const AdminPermission = Object.freeze({
	Admins: 'admins',
	Any: 'any',
	AutomatedMetadata: 'automated_metadata',
	ContentIdClaims: 'contentid_claims',
	CustomPages: 'custom_pages',
	Feature: 'feature',
	FileDelivery: 'file_delivery',
	Licensees: 'buyers',
	Licensing: 'licensing',
	Metadata: 'metadata',
	MusicSuppliers: 'music_providers',
	Pando: 'pando',
	Settings: 'settings',
	Sharing: 'sharing',
	Statistics: 'statistics',
	SuperAdmin: 'super_admin',
	WorksRegistration: 'works_registration',
	Users: 'users'
});
(function() {
	const notice = `$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
$    ,--.       ,---.                                                                                  $
$    /    '.    /     \\                                                                                $
$           \\  ;                                                                                       $
$            \\-|                                                                                       $
$           (o o)      (/                                                                              $
$           /'v'     ,-'                                                                               $
$   ,------/ >< \\---'                                                                                  $
$  /)     ;  --  :                                                                                     $
$     ,---| ---- |--.                            Did you find a bug? Let us know!                      $
$    ;    | ---- |   :      Read about our bug bounty program at https://docs.sourceaudio.com/security $
$   (|  ,-| ---- |-. |)                      And report it to security@sourceaudio.com                 $
$      | /| ---- |\\ |                                                                                  $
$      |/ | ---- | \\|                                                                                  $
$      \\  : ---- ;  |                                                                                  $
$       \\  \\ -- /  /                                                                                   $
$       ;   \\  /  :                                                                                    $
$      /   / \\/ \\  \\                                                                                   $
$     /)           (\\                                                                                  $
$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$`;
	console.log(`%c${notice}`, 'font-family: monospace;');
})();/**
 * Debounce a function call
 * @param callback
 * @param wait
 * @returns {(function(...[*]): void)|*}
 */
const debounce = (callback, wait) => {
	let timeoutId = null;
	return (...args) => {
		window.clearTimeout(timeoutId);
		timeoutId = window.setTimeout(() => {
			callback(...args);
		}, wait);
	};
};

/**
 * Throttle a function call
 * @param callback
 * @param delay
 * @returns {(function(...[*]): void)|*}
 */
const throttle = (callback, delay) => {
	let timeout = false;
	return (...args) => {
		if (!timeout) {
			timeout = true;
			callback(...args);
			setTimeout(() => {
				timeout = false;
			}, delay);
		}
	};
};
/**
 * Utility class for domain validation and cleaning
 */
class DomainUtils {
	/**
	 * Validates and cleans a comma-separated list of domains
	 * @param {string} input - Comma-separated list of domains/URLs
	 * @returns {Object} Object containing arrays of valid and invalid domains
	 */
	static validateDomains(input) {
		// Handle empty or non-string input
		if (!input || typeof input !== 'string') {
			return { valid: [], invalid: [] };
		}

		const domains = input.split(',').map(d => d.trim()).filter(Boolean);
		const result = { valid: [], invalid: [] };

		for (const domain of domains) {
			const cleaned = this.cleanDomain(domain);
			if (cleaned && this.isValidDomain(cleaned)) {
				result.valid.push(cleaned);
			} else {
				// Need to html entity encode this domain
				const sanitizedDomain = domain.replace(/</g, '&lt;').replace(/>/g, '&gt;');
				result.invalid.push(sanitizedDomain);
			}
		}

		return result;
	}

	/**
	 * Cleans and normalizes a domain string
	 * @param {string} domain - Domain string to clean
	 * @returns {string|null} Cleaned domain or null if invalid
	 */
	static cleanDomain(domain) {
		try {
			// Remove leading/trailing whitespace
			let cleaned = domain.trim();
			
			// Strip any tags/html
			cleaned = cleaned.replace(/<[^>]+>/g, '');

			// Handle email-style domains (e.g., @google.com)
			if (cleaned.startsWith('@')) {
				cleaned = cleaned.substring(1);
			}

			// Try to extract domain from full URLs
			try {
				const url = new URL(cleaned.startsWith('http') ? cleaned : `https://${cleaned}`);
				cleaned = url.hostname;
			} catch (e) {
				// If URL parsing fails, assume it's a bare domain
			}

			// Remove www. prefix if present
			cleaned = cleaned.replace(/^www\./i, '');

			return cleaned.toLowerCase();
		} catch (e) {
			return null;
		}
	}

	/**
	 * Validates a domain string
	 * @param {string} domain - Domain to validate
	 * @returns {boolean} Whether the domain is valid
	 */
	static isValidDomain(domain) {
		// Basic domain validation regex
		const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](\.[a-zA-Z]{2,})+$/;

		if (!domain || domain.length > 255) {
			return false;
		}

		// Check basic format
		if (!domainRegex.test(domain)) {
			return false;
		}

		// Additional validation for each part
		const parts = domain.split('.');

		// Must have at least two parts
		if (parts.length < 2) {
			return false;
		}

		// Each part must be valid
		return parts.every(part => {
			// Parts must not start or end with hyphens
			if (part.startsWith('-') || part.endsWith('-')) {
				return false;
			}

			return true;
		});
	}
}
var	expandedTrackLists = [],
	firstCheck = false,
	ios = false,
	android = false,
	sa = {
		initialized : false,
		components : {},
		pages : {},
		objectTypes : {},
		currentPage : null,
		getCurrentPageName : function() {
			return sa.currentPage ? sa.currentPage.name : '';
		},
		useHovers : true,
		disableDownloading : false,
		disableUploading : false,
		objectOnly : false,
		lastCommit : '',
		breakingChangeVersion : window['breakingChangeVersion'] || '',
		getSiteOwner : function(callback) {
			sa.api.request({
				handler : 'settings',
				action : 'get-site-owner'
			}).then(callback).catch(e => { callback(null); });
		},
		getLoginConfig : function(callback) {
			if (window.loginConfig) {
				sa.cookies.setAgreedToCookies(window.loginConfig.cookiePreferences.agreed);
				sa.cookies.setAllowCookieType(sa.cookieTypes.preference, window.loginConfig.cookiePreferences.allowPreferenceCookies);
				sa.cookies.setAllowCookieType(sa.cookieTypes.statistical, window.loginConfig.cookiePreferences.allowStatisticalCookies);
				sa.cookies.setAllowCookieType(sa.cookieTypes.marketing, window.loginConfig.cookiePreferences.allowMarketingCookies);
				sa.cookies.setAllowCookieType(sa.cookieTypes.login, window.loginConfig.cookiePreferences.allowLoginCookies);
				callback(window.loginConfig);
			} else {
				ajax({
					p : 'signup',
					action : 'getLoginConfig'
				}, function (loginConfig) {
					window.loginConfig = loginConfig;
					sa.getLoginConfig(callback);
				});
			}
		}
	},
	nocache = false;

const DefaultLogo = '/images/logos/sourceaudio-with-text-no-padding-2023-200x41.png'; // flat logo
const DefaultLogoWhite = '/images/logos/sourceaudio-with-text-no-padding-white-2023-200x41.png'; // flat all-white logo
// 'https://dm09pscvq9wc9.cloudfront.net/user_data/74/1490821236-74-200.png' // white logo
// 'https://dm09pscvq9wc9.cloudfront.net/user_data/72/1502810650.9763-72.png' // black logo

const PasswordLength = 8;

/**
 * @global
 * @type {JQueryStatic}
 */
const $j = jQuery.noConflict();
var lockdown = false;
// any functions in here will be called when the route unloads (NOT the window)
// if the function returns true, the route won't change
// you're responsible for manually removing these
var unloadFunctions = [];

/**
 * Creates a hash-table object with hasOwnProperty for iteration but without other prototype methods or properties
 * that are vulnerable to prototype pollution, like constructor or prototype
 * @returns {Object}
 */
function createSafeObject() {
	const safe = Object.create(null);
	// add hasOwnProperty so it can be used in for-in loops and use Object.defineProperty so we can make it non-enumerable (hasOwnProperty won't appear in those loops or in $j.param(createSafeObject()))
	Object.defineProperty(safe, 'hasOwnProperty', { enumerable: false, value: function(key) {
		if (key === 'hasOwnProperty') return false;
		return Object.prototype.hasOwnProperty.call(this, key);
	}});
	// toString is also used in comparisons
	Object.defineProperty(safe, 'toString', { enumerable: false, value: function() {
		return Object.prototype.toString.call(this);
	}});
	return safe;
}

if (!window['loginConfig']) {
	var loginConfig = null;
}

if (window['config'] === undefined) {
	window['config'] = {};
	console.log('config is undefined');
}

const ImportDomain = 'import.sourceaudio.com'+ (config.dev ? '/' + (config.dev.endsWith('-r') ? config.dev.substr(0, config.dev.length - 2) : config.dev) : '');

// make sure the analytics object exists even if it's being blocked
if (!window.recordAnalytics) {
	window.recordAnalytics = function() {};
}

/**
 * SourceAudio events need to be accessible from the beginning. Can't wait for the real sa object
 * 	Adds functions "on", "off", and "trigger"
 * @mixin
 * @param {Object} object
 */
sa.eventify = function(object) {

	let events = {};
	let continuousEvents = {};

	/**
	 * Wrapper function to create events so browsers that don't support document.createEvent (facebook crawler)
	 * don't throw constant Illegal Invocation errors
	 */
	function createEvent(eventType) {
		try {
			let event = document.createEvent('Event');
			event.initEvent(eventType, true, true);
			return event;
		} catch (e) {
			return {
				bubbles: true,
				cancelBubble: false,
				cancelable: true,
				composed: false,
				currentTarget: null,
				defaultPrevented: false,
				eventPhase: 0,
				isTrusted: false,
				path: [],
				returnValue: true,
				srcElement: null,
				target: null,
				type: eventType,
				preventDefault : function() {},
				stopPropagation : function() {},
				stopImmediatePropagation : function() {}
			};
		}
	}

	/**
	 * Adds a function to fire on the next trigger()
	 * @param {string} eventType
	 * @param {function} callback - the first parameter will be a relevant Event object and other parameters vary based on the trigger
	 */
	object.on = function(eventType, callback) {
		if (callback === null || callback === undefined) return;
		let dotParts = eventType.split('.');
		eventType = dotParts[0];
		if (continuousEvents.hasOwnProperty(eventType)) {
			callback.apply(object, continuousEvents[eventType]);
		} else {
			if (dotParts.length > 1) {
				callback.eventClass = dotParts[1];
			}
			if (!events.hasOwnProperty(eventType)) {
				events[eventType] = [];
			}
			events[eventType].push(callback);
		}
	};

	/**
	 * Removes a callback that was previously added with on()
	 * If the callback wasn't added already, nothing happens
	 * @param {string} eventType
	 * @param {function} callback - must be the actual function added previously. sending in a new copy will not work
	 */
	object.off = function(eventType, callback) {
		if (eventType.indexOf('.') === 0) {
			let eventClass = eventType.substring(1);
			for (let eventType in events) {
				if (!events.hasOwnProperty(eventType)) continue;
				events[eventType] = events[eventType].filter(function(callback) {
					return callback.eventClass !== eventClass;
				});
			}
		} else if (events.hasOwnProperty(eventType)) {
			if (callback) {
				let i = events[eventType].indexOf(callback);
				if (i !== -1) {
					events[eventType].splice(i, 1);
				}
			} else {
				events[eventType] = [];
			}
		}
	};

	/**
	 * Events added this way will fire any callbacks that were previously added with on()
	 * @param {string} eventType
	 */
	object.trigger = function(eventType) {
		if (!events.hasOwnProperty(eventType)) return;
		let args = [ createEvent(eventType) ];
		for (let a = 1, aLen = arguments.length; a < aLen; a++) {
			args.push(arguments[a]);
		}
		fireCallbacks(args, events[eventType]);
	};

	/**
	 * Events added this way will fire their callbacks even if the callback is added later.
	 * For example, the login overlay triggers an event when it's shown but it might have shown before it returns its event emitter so calling code will call on() and it might be too late.
	 * By using triggerContinuously for its shown event, those callbacks will still fire
	 * @param {string} eventType
	 */
	object.triggerContinuously = function(eventType) {
		let args = [ createEvent(eventType) ];
		for (let a = 1, aLen = arguments.length; a < aLen; a++) {
			args.push(arguments[a]);
		}
		continuousEvents[eventType] = args;
		if (events.hasOwnProperty(eventType)) {
			fireCallbacks(args, events[eventType]);
			delete events[eventType];
		}
	};

	/**
	 * Fires a set of callbacks
	 * @param {Array} args
	 * @param {function[]} callbacks
	 */
	function fireCallbacks(args, callbacks) {
		for (let callback of callbacks.slice()) { // slice in case the callback includes a call to "off". it can mess up iteration
			callback.apply(object, args);
		}
	}

};
sa.eventify(sa);

window['responseIndex'] = 0;
if (window['console'] === undefined) {
	window.console = { log : function () {}, error : function () {}, warn : function () {} };
}

// sometimes while admining, it's useful to be able to see the white label id. you can view source but it's easier to hit shift + alt + i which will now alert the id
$j(window).on('keydown', function(e) {
	if (window.event) e = window.event;
	if (e.altKey && e.shiftKey) {
		let keyCode = e.keyCode;
		if (keyCode === 73) { // I
			console.log('- white id:', config.id);
			alert(config.id);
			return false;
		} else if (keyCode === 76) { // L
			// open lookup
			if (user && user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				let devPathFragment = sa.router.getDevPathFragment();
				let base = 'https://music.sourceaudio.com' + devPathFragment + '/superadmin/lookup.php?';
				if (sa.isCurrentPage(sa.pages.details)) {
					window.open(base + 'searchType=track&trackId=' + sa.pages.details.getTrackId());
				} else if (sa.router.getCurrentPath().indexOf(devPathFragment + '/album/') === 0) {
					window.open(base + 'searchType=album&albumId=' + sa.router.getCurrentPath().match(/\/album\/(\d+)/)[1]);
				} else if (sa.isCurrentPage(sa.pages.projectItemList)) {
					window.open(base + 'searchType=project&projectId=' + sa.pages.projectItemList.getProjectId());
				} else if (sa.isCurrentPage(sa.pages.label)) {
					window.open(base + 'searchType=label&labelId=' + sa.pages.label.getLabelId());
				} else if (sa.isCurrentPage(sa.pages.catalog)) {
					window.open(base + 'searchType=catalog&catalogId=' + sa.pages.catalog.getCatalogId());
				} else if (sa.router.getCurrentPath() === devPathFragment + '/admin') {
					let matches = sa.router.getFullUrl().match(/[&\?]user=(\d+)/);
					if (matches) {
						window.open(base + 'searchType=user&userId=' + matches[1]);
					}
				}
			}
			return false;
		} else if (keyCode === 82 || keyCode === 84) { // R (or T since Firefox (at least in Windows) doesn't like R)
			// restat it
			let lb = new FocusBox($j('<a href="https://' + config.domain.replace(/\/git-[-_a-zA-Z0-9]+/, '') + '/superadmin/scripts/restater.php?whiteId=' + config.id + '&now=1" class="restat_link">Restat</a>'));
			lb.show();
			$j('.restat_link').on('click', function () {
				lb.hide();
				return true;
			});
			return false;
		} else if (keyCode === 84) {
			ajax.toggleTiming();
			return false;
		} else if (keyCode !== 16 && keyCode !== 18) { // shift and alt
			console.log('detected alt+shift+key press. key code is ' + keyCode);
		}
	}
});

function generateJavascriptDoc(object, name, recurse) {
	let ret = '/**\n * @typedef {Object} ' + name + '\n';
	let subs = [];
	for (let key in object) {
		if (!object.hasOwnProperty(key)) continue;
		let type = (typeof object[key]).toString();
		if (type === 'object') {
			if (object[key] === null) {
				type = 'Object';
			} else if (object[key]['isArray']) {
				type = 'Array';
			} else if (recurse) {
				let subtype = key.ucfirst();
				subs.push(generateJavascriptDoc(object[key], subtype, true));
				type = subtype;
			} else {
				type = 'Object';
			}
		} else if (type === 'number' && Number.isInteger(object[key])) {
			type = 'int';
		}
		ret += ' * @property {' + type + '} ' + key + '\n';
	}
	ret += ' */\n\n' + subs.join();
	return ret;
}

/**
 * @typedef {Object} Config
 * @property {int} id
 * @property {string} dev
 * @property {string} sub
 * @property {string} domain
 * @property {string} cookieDomain
 * @property {string} siteType
 * @property {boolean} grayLabel
 * @property {boolean} selfServe
 * @property {boolean} watermarked
 * @property {string} name
 * @property {int} singleCatalog
 * @property {Array} catalogs
 * @property {boolean} showLabels
 * @property {boolean} showLicensing
 * @property {boolean} showAdrev
 * @property {boolean} showBrowse
 * @property {boolean} showTrackCount
 * @property {boolean} showLabelsInCatalogColumns
 * @property {boolean} showAllCounts
 * @property {boolean} showCueSheets
 * @property {boolean} showSonicSearch
 * @property {boolean} showEmbeds
 * @property {boolean} showMusicSupplierContacts
 * @property {boolean} showSubscriptionOptions
 * @property {boolean} showAltDownloads
 * @property {boolean} showExternalCatalogData
 * @property {boolean} showUnloggedHome
 * @property {boolean} showSyncFlags
 * @property {boolean} showNestedCounts
 * @property {boolean} showMCPS
 * @property {boolean} showRequestEmailOptions
 * @property {boolean} showUserTrackDLIndicator
 * @property {string} currency
 * @property {Object} contentid
 * @property {int} dateFormat
 * @property {string} dateFormatString
 * @property {string} dateTimeFormatString
 * @property {string} datePickerDateFormatString
 * @property {int} defaultResultsPerPage
 * @property {boolean} defaultNesting
 * @property {string} defaultCatalogSelect
 * @property {string} defaultViews
 * @property {string} defaultAlbumSort
 * @property {string} defaultTrackSort
 * @property {string} defaultCatalogTab
 * @property {string} defaultLabelTab
 * @property {string} catalogTabs
 * @property {string} labelTabs
 * @property {string} footerAdditional
 * @property {string} downloadPermissionRequestText
 * @property {Object} theme
 * @property {string} logo
 * @property {Object} downloadFormats
 * @property {string} facebookAppId
 * @property {boolean} hasJwt
 * @property {string} olark
 * @property {boolean} enableLicenseId
 * @property {string} analytics
 * @property {Array} googleAdWords
 * @property {string} googleAdWordsUseExplanation
 * @property {{ tags : string, settings : { alias : { pattern : string, result : string }[], meta : { title : string, description : string, keywords : string, set : string }}}} seo
 * @property {string} licenseUrl
 * @property {string} home
 * @property {string} escapedFragmentHash
 * @property {Array} hiddenFields
 * @property {{ wave : { normal : ListColumn[], alternate : ListColumn[] }, simple : { normal : ListColumn[], alternate : ListColumn[] }}} trackColumnLists
 * @property {Object} dictionary
 * @property {Object} customFields
 * @property {Array} pandos
 * @property {boolean} hasRatingSort
 * @property {string} siteMode
 * @property {Array} trackingCodes
 * @property {boolean} visible
 * @property {boolean} hideStats
 * @property {Object} licensingConfig
 * @property {boolean} licensing
 * @property {Array} clouds
 * @property {Array} tabs
 * @property {Array} registrationFields
 * @property {function} getDictionaryEntry
 * @property {function} getReverseDictionaryEntry
 * @property {string[]} cookieUses
 * @property {{ id : int, name : string, url : string, order : int, version : int }[]} userAgreements
 * @property {Array.<string>} syncFlags
 * @property {bool} disableEmailLogins
 * @property {int} showDownloadStudio
 */

/**
 * @typedef {Object} LoginConfig
 * @property {boolean} requiresRegistration
 * @property {Array} idps
 * @property {boolean} ssoButton
 * @property {Object} ssoButtonVars
 * @property {Object} ssoVars
 * @property {Object} jwtButtonVars
 * @property {Array} oAuthButtons
 * @property {string} confirmation
 * @property {string} verb
 * @property {boolean} showFacebook
 * @property {string} facebookCommunicationKey
 * @property {string} facebookIframeSrc
 * @property {string} googleCommunicationKey
 * @property {string} googleIframeSrc
 * @property {string} forward
 * @property {string} loginPage
 * @property {boolean} usernameLogins
 * @property {boolean} showNewMessage
 * @property {string} signupMessage
 * @property {Array} registrationFields
 * @property {string} recaptchaCacheCommunicationKey
 * @property {string} recaptchaIframeSrc
 * @property {string} loginPath
 * @property {string} signupPath
 * @property {CookiePreferences} cookiePreferences
 * @property {bool} disableEmailLogins
 * @property {bool} disableSignups
 * @property {bool} foxSignupForm
 */

/**
 * @typedef {Object} CookiePreferences
 * @property {int} agreed
 * @property {boolean} allowPreferenceCookies
 * @property {boolean} allowStatisticalCookies
 * @property {boolean} allowMarketingCookies
 * @property {boolean} allowLoginCookies
 */

/**
 * Track object type reference
 * @typedef {Object} Track
 * @property {int} id
 * @property {string} title
 * @property {string} date in local time format, eg mm/dd/yyyy
 * @property {int} dateAdded as unix timestamp
 * @property {User} addedBy null if not found or not a drop site
 * @property {string} length in mm:ss format
 * @property {Number} actualLength in seconds
 * @property {int} plays
 * @property {int} downloads
 * @property {Array} comments
 * @property {Array.<Genre>} genres
 * @property {Array.<Tempo>} tempos
 * @property {Array.<CueType>} cueTypes
 * @property {MusicSupplier} musicSupplier
 * @property {Array.<Genre>} musicSupplierGenres
 * @property {Array.<Tempo>} musicSupplierTempos
 * @property {Array.<CueType>} musicSupplierCueTypes
 * @property {int} bpm
 * @property {Catalog} catalog
 * @property {Label} label
 * @property {Artist} artist
 * @property {Array.<Writer>} writers
 * @property {Array.<Publisher>} publishers
 * @property {Album} album
 * @property {Key} key
 * @property {int} has_vocal 0 means no, 1 means yes, 2 means maybe
 * @property {int} explicit 0 means no, 1 means yes, 2 means maybe
 * @property {string} isrc
 * @property {string} iswc
 * @property {Array.<WorkNumber>} workNumbers
 * @property {boolean} featured
 * @property {boolean} private
 * @property {string} price
 * @property {Array.<string>} styles
 * @property {Array.<string>} moods
 * @property {string} description
 * @property {string} keywords
 * @property {string} instruments
 * @property {string} version
 * @property {FormatList} formats
 * @property {File} file
 * @property {Array.<CustomField>} custom_fields
 * @property {boolean} can_download
 * @property {boolean} tagged
 * @property {boolean} rated
 * @property {Array.<Project>} user_projects
 * @property {Array.<CueSheet>} user_cue_sheets
 * @property {int} masterId
 * @property {Array.<Track>} alternates
 * @property {int} alternateCount
 * @property {Object} alternateDownloadFormats
 * @property {boolean} editable
 * @property {boolean} outOfDate
 * @property {string} lyrics
 * @property {string} style_of
 * @property {boolean} watermarked
 * @property {string} externalId
 * @property {Array.<Object>} metadataEmbedderProfiles
 * @property {Array.<Object>} fullCustomFields
 * @property {int} dateAddedToBank
 * @property {int} userDownloaded
 * @property {int} userLastDLdate
 * @property {Object} worksRegistrationData
 * @property {Array.<string>} syncFlags
 * @property {Array.<Object>} datasets
 */

/**
 * Genre object type reference
 * @typedef {Object} Genre
 * @property {int} id
 * @property {string} name
 */

/**
 * Tempo object type reference
 * @typedef {Object} Tempo
 * @property {int} id
 * @property {string} name
 */

/**
 * CueType object type reference
 * @typedef {Object} CueType
 * @property {int} id
 * @property {string} name
 */

/**
 * Key object type reference
 * @typedef {Object} Key
 * @property {int} id
 * @property {string} name
 */

/**
 * WorkNumber object type reference
 * @typedef {Object} WorkNumber
 * @property {int} id
 * @property {string} workNumber
 * @property {Affiliation} affiliation
 * @property {int} affiliationId
 * @property {int} trackId
 * @property {int} registrationDate
 */

/**
 * FormatList object type reference
 * @typedef {Object} FormatList
 * @property {int} mp3 size
 * @property {int} wav size
 * @property {int} aiff size
 * @property {Array} extras
 * @property {boolean} disableMp3
 * @property {boolean} disableWav
 * @property {boolean} disableAiff
 * @property {Array.<string>} transcodeFormats
 */

/**
 * File object type reference
 * @typedef {Object} File
 * @property {string} waveform full path
 * @property {string} play deprecated
 * @property {string} playHtml5 full path but can't be loaded without calling ajax
 * @property {int} waveformCallbackId
 * @property {string} filename
 */

/**
 * CustomField object type reference
 * @typedef {Object} CustomField
 * @property {int} id
 * @property {string} name
 * @property {value} name
 * @property {boolean} hidden
 */

/**
 * ProjectPublishSetting object type reference
 * @typedef {Object} ProjectPublishSetting
 * @property {int} local
 * @property {int} licensee
 */

/**
 * @typedef {Object} ProjectFolder
 * @property {int} id
 * @property {string} name
 * @property {string} description
 * @property {Array.<ProjectFolder>} subfolders
 * @property {int} parentFolderId
 */

/**
 * CueSheet object type reference
 * @typedef {Object} CueSheet
 * @property {int} id
 * @property {string} name
 * @property {boolean} created
 * @property {int} trackCount
 * @property {int} dateCreated unix timestamp
 * @property {int} dateAltered unix timestamp
 */

/**
 * MusicSupplierLicensing object type reference
 * @typedef {Object} MusicSupplierLicensing
 * @property {string} phone
 * @property {string} name
 * @property {string} email
 */

/**
 * PublisherCollectionShare object type reference
 * @typedef {Object} PublisherCollectionShare
 * @property {PublisherCollectionShareTerritory} territory
 * @property {Number} collectionShare
 */

/**
 * PublisherCollectionShareTerritory object type reference
 * @typedef {Object} PublisherCollectionShareTerritory
 * @property {int} id
 * @property {string} name
 * @property {string} code
 */

/**
 * Affiliation object type reference
 * @typedef {Object} Affiliation
 * @property {int} id
 * @property {string} name
 * @property {string} code
 * @property {string} country
 */

/**
 * Role object type reference
 * @typedef {Object} Role
 * @property {int} id
 * @property {string} name
 * @property {string} code
 * @property {string} type
 */

/**
 * ListMetaData object type reference
 * @typedef {Object} ListMetaData
 * @property {int} count the number of master tracks in this result
 * @property {int} trackCount the number of tracks in this result, including nested tracks
 * @property {int} page the page we're on now, 0 indexed
 * @property {int} perPage results showing per page
 * @property {string} pageVars a string to send back in that will recreate this search. ends in page number var so you just append a new page
 * @property {int} req passed back from the request so js can determine the most recently requested data
 * @property {Object} filters any applied filters
 * @property {{ original : string, suggestion : string, automaticallyApplied : boolean, rawSuggestions : Object }} spellcheckResult - rawSuggestions are formatted as { originalTerm : [ newTerm1, newTerm2 ], originalTerm2 : ... }
 * @property {int} showTrackNumbers true for albums
 * @property {Array.<string>} hideColumns any columns irrelevant to the current view, e.g., don't show album name on album page
 * @property {string} headingName to show in the black bar
 * @property {string} headingValue
 * @property {string} headingImage
 * @property {Object} headingExtra
 * @property {int} headingAll
 * @property {Album} album if it's an album list
 * @property {Project} project if it's a project list
 * @property {CueSheet} cueSheet if it's a cue sheet list
 * @property {int} trackOffset used by project and cue sheet lists
 * @property {boolean} profileError set for some list types if there was a MAP issue
 * @property {Object} facets as key : count
 */

/**
 * CatalogThemeData object type reference
 * @typedef {Object} CatalogThemeData
 * @property {int} id
 * @property {string} catalogName
 * @property {string} labelName
 * @property {Array.<CatalogThemeSection>} sections
 * @property {Array.<ListColumn>} columns
 * @property {Array.<ListColumn>} altColumns
 */

/**
 * CatalogThemeSection object type reference
 * @typedef {Object} CatalogThemeSection
 * @property {string} value
 * @property {string} display
 */

/**
 * SADBillingStatus object type reference
 * @typedef {Object} SADBillingStatus
 * @property {boolean} owned
 * @property {boolean} newOwner
 * @property {int} billingNextDate
 * @property {int} amount
 * @property {int} subscriptionId
 * @property {Array.<SADUnpaidMonth>} unpaidMonths
 * @property {Array.<SADHistory>} history
 */

/**
 * SADUnpaidMonth object type reference
 * @typedef {Object} SADUnpaidMonth
 * @property {int} startDate
 * @property {int} endDate
 * @property {int} amount
 * @property {int} detections
 */

/**
 * SADHistory object type reference
 * @typedef {Object} SADHistory
 * @property {string} name
 * @property {string} link
 * @property {boolean} paid
 */

/**
 * EdadDropZoneOptions object type reference
 * @typedef {Object} EdadDropZoneOptions
 * @property {Array.<string>} allowedExtensions Extensions the zone will accept
 * @property {string} anchorSelector The drop zone will look for and position itself on top of and filling this anchor. If the selector isn't on the page, the drop zone won't appear
 * @property {string} templateSelector The name of a template in the edad.html template file
 * @property {string} uniqueKey If you the zone to be unique (in case the page loads multiple times), when you add a zone, any zones that share this key will be removed (if set)
 * @property {function} dropCallback Accepts a list of files that were dropped
 * @property {function} prepareTemplate if set, will be sent the template for applying in custom changes before it's rendered. should return the template
 * @property {string} zoneClass zones can be removed en masse by this string (optional)
 */

/**
 * @typedef {Object} Request
 * @property {int} id
 * @property {string} title
 * @property {string} description
 * @property {int} closed
 * @property {int} datePosted
 * @property {string} budgetPerCue
 * @property {string} email
 * @property {string} whiteName
 * @property {boolean} editable
 * @property {Array.<RequestFile>} briefs
 * @property {Array.<RequestFile>} references
 * @property {Array.<RequestResponse>} responses
 */

/**
 * @typedef {Object} RequestFile
 * @property {int} id
 * @property {string} filename
 * @property {int} filesize
 */

/**
 * @typedef {Object} RequestResponse
 * @property {int} id
 * @property {int} trackId
 * @property {int} albumId
 * @property {int} projectId
 * @property {int} trackCount
 * @property {string} comments
 * @property {int} date
 * @property {string} username
 * @property {Object} supplier
 * 	@property {int} id
 * 	@property {string} name
 */

/**
 * @typedef {Object} UserManagementRequestContainer
 * @property {string} result - if it has this, it won't have the other elements
 * @property {int} page
 * @property {int} perPage
 * @property {int} total
 * @property {string} o
 * @property {string} status
 * @property {Array.<UserManagementRequest>} requests
 */

/**
 * @typedef {Object} UserManagementRequest
 * @property {int} id
 * @property {string} code
 * @property {RegistrationRequest} registration - will only have one of these two
 * @property {DownloadRequest} download_request - will only have one of these two
 */

/**
 * @typedef {Object} RegistrationRequest
 * @property {int} id
 * @property {string} username
 * @property {string} email
 * @property {string} avatar
 * @property {string} date
 * @property {string} status
 * @property {string} responseDate
 * @property {string} ip
 * @property {string} location
 * @property {Array} extraFields
 */

/**
 * @typedef {Object} DownloadRequest
 * @property {int} id
 * @property {Object} requestor
 * @property {Track} track - note, not a full track
 * @property {string} date
 * @property {string} status
 * @property {Object} approver
 * @property {string} response_date
 */

/**
 * @typedef {Object} FAQ
 * @property {int} id
 * @property {string} title
 * @property {Array.<string>} hashes
 */
if (!Element.prototype.matches) {
	Element.prototype.matches =
		Element.prototype.msMatchesSelector ||
		Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
		var el = this;

		do {
			if (Element.prototype.matches.call(el, s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}
// document.querySelectorAll returns a NodeList, which is a collection, not an array, so we need a way to be able to use
// .forEach against the collection
if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}
(function(t){var e=function(){try{return!!Symbol.iterator}catch(e){return false}};var r=e();var n=function(t){var e={next:function(){var e=t.shift();return{done:e===void 0,value:e}}};if(r){e[Symbol.iterator]=function(){return e}}return e};var i=function(e){return encodeURIComponent(e).replace(/%20/g,"+")};var o=function(e){return decodeURIComponent(String(e).replace(/\+/g," "))};var a=function(){var a=function(e){Object.defineProperty(this,"_entries",{writable:true,value:{}});var t=typeof e;if(t==="undefined"){}else if(t==="string"){if(e!==""){this._fromString(e)}}else if(e instanceof a){var r=this;e.forEach(function(e,t){r.append(t,e)})}else if(e!==null&&t==="object"){if(Object.prototype.toString.call(e)==="[object Array]"){for(var n=0;n<e.length;n++){var i=e[n];if(Object.prototype.toString.call(i)==="[object Array]"||i.length!==2){this.append(i[0],i[1])}else{throw new TypeError("Expected [string, any] as entry at index "+n+" of URLSearchParams's input")}}}else{for(var o in e){if(e.hasOwnProperty(o)){this.append(o,e[o])}}}}else{throw new TypeError("Unsupported input's type for URLSearchParams")}};var e=a.prototype;e.append=function(e,t){if(e in this._entries){this._entries[e].push(String(t))}else{this._entries[e]=[String(t)]}};e.delete=function(e){delete this._entries[e]};e.get=function(e){return e in this._entries?this._entries[e][0]:null};e.getAll=function(e){return e in this._entries?this._entries[e].slice(0):[]};e.has=function(e){return e in this._entries};e.set=function(e,t){this._entries[e]=[String(t)]};e.forEach=function(e,t){var r;for(var n in this._entries){if(this._entries.hasOwnProperty(n)){r=this._entries[n];for(var i=0;i<r.length;i++){e.call(t,r[i],n,this)}}}};e.keys=function(){var r=[];this.forEach(function(e,t){r.push(t)});return n(r)};e.values=function(){var t=[];this.forEach(function(e){t.push(e)});return n(t)};e.entries=function(){var r=[];this.forEach(function(e,t){r.push([t,e])});return n(r)};if(r){e[Symbol.iterator]=e.entries}e.toString=function(){var r=[];this.forEach(function(e,t){r.push(i(t)+"="+i(e))});return r.join("&")};t.URLSearchParams=a};var s=function(){try{var e=t.URLSearchParams;return new e("?a=1").toString()==="a=1"&&typeof e.prototype.set==="function"&&typeof e.prototype.entries==="function"}catch(e){return false}};if(!s()){a()}var f=t.URLSearchParams.prototype;if(typeof f.sort!=="function"){f.sort=function(){var r=this;var n=[];this.forEach(function(e,t){n.push([t,e]);if(!r._entries){r.delete(t)}});n.sort(function(e,t){if(e[0]<t[0]){return-1}else if(e[0]>t[0]){return+1}else{return 0}});if(r._entries){r._entries={}}for(var e=0;e<n.length;e++){this.append(n[e][0],n[e][1])}}}if(typeof f._fromString!=="function"){Object.defineProperty(f,"_fromString",{enumerable:false,configurable:false,writable:false,value:function(e){if(this._entries){this._entries={}}else{var r=[];this.forEach(function(e,t){r.push(t)});for(var t=0;t<r.length;t++){this.delete(r[t])}}e=e.replace(/^\?/,"");var n=e.split("&");var i;for(var t=0;t<n.length;t++){i=n[t].split("=");this.append(o(i[0]),i.length>1?o(i[1]):"")}}})}})(typeof global!=="undefined"?global:typeof window!=="undefined"?window:typeof self!=="undefined"?self:this);(function(u){var e=function(){try{var e=new u.URL("b","http://a");e.pathname="c d";return e.href==="http://a/c%20d"&&e.searchParams}catch(e){return false}};var t=function(){var t=u.URL;var e=function(e,t){if(typeof e!=="string")e=String(e);if(t&&typeof t!=="string")t=String(t);var r=document,n;if(t&&(u.location===void 0||t!==u.location.href)){t=t.toLowerCase();r=document.implementation.createHTMLDocument("");n=r.createElement("base");n.href=t;r.head.appendChild(n);try{if(n.href.indexOf(t)!==0)throw new Error(n.href)}catch(e){throw new Error("URL unable to set base "+t+" due to "+e)}}var i=r.createElement("a");i.href=e;if(n){r.body.appendChild(i);i.href=i.href}var o=r.createElement("input");o.type="url";o.value=e;if(i.protocol===":"||!/:/.test(i.href)||!o.checkValidity()&&!t){throw new TypeError("Invalid URL")}Object.defineProperty(this,"_anchorElement",{value:i});var a=new u.URLSearchParams(this.search);var s=true;var f=true;var c=this;["append","delete","set"].forEach(function(e){var t=a[e];a[e]=function(){t.apply(a,arguments);if(s){f=false;c.search=a.toString();f=true}}});Object.defineProperty(this,"searchParams",{value:a,enumerable:true});var h=void 0;Object.defineProperty(this,"_updateSearchParams",{enumerable:false,configurable:false,writable:false,value:function(){if(this.search!==h){h=this.search;if(f){s=false;this.searchParams._fromString(this.search);s=true}}}})};var r=e.prototype;var n=function(t){Object.defineProperty(r,t,{get:function(){return this._anchorElement[t]},set:function(e){this._anchorElement[t]=e},enumerable:true})};["hash","host","hostname","port","protocol"].forEach(function(e){n(e)});Object.defineProperty(r,"search",{get:function(){return this._anchorElement["search"]},set:function(e){this._anchorElement["search"]=e;this._updateSearchParams()},enumerable:true});Object.defineProperties(r,{toString:{get:function(){var e=this;return function(){return e.href}}},href:{get:function(){return this._anchorElement.href.replace(/\?$/,"")},set:function(e){this._anchorElement.href=e;this._updateSearchParams()},enumerable:true},pathname:{get:function(){return this._anchorElement.pathname.replace(/(^\/?)/,"/")},set:function(e){this._anchorElement.pathname=e},enumerable:true},origin:{get:function(){var e={"http:":80,"https:":443,"ftp:":21}[this._anchorElement.protocol];var t=this._anchorElement.port!=e&&this._anchorElement.port!=="";return this._anchorElement.protocol+"//"+this._anchorElement.hostname+(t?":"+this._anchorElement.port:"")},enumerable:true},password:{get:function(){return""},set:function(e){},enumerable:true},username:{get:function(){return""},set:function(e){},enumerable:true}});e.createObjectURL=function(e){return t.createObjectURL.apply(t,arguments)};e.revokeObjectURL=function(e){return t.revokeObjectURL.apply(t,arguments)};u.URL=e};if(!e()){t()}if(u.location!==void 0&&!("origin"in u.location)){var r=function(){return u.location.protocol+"//"+u.location.hostname+(u.location.port?":"+u.location.port:"")};try{Object.defineProperty(u.location,"origin",{get:r,enumerable:true})}catch(e){setInterval(function(){u.location.origin=r()},100)}}})(typeof global!=="undefined"?global:typeof window!=="undefined"?window:typeof self!=="undefined"?self:this);
/**!
 * url-search-params-polyfill
 *
 * @author Jerry Bendy (https://github.com/jerrybendy)
 * @licence MIT
 */
(function(self) {
	'use strict';

	var nativeURLSearchParams = (function() {
			// #41 Fix issue in RN
			try {
				if (self.URLSearchParams && (new self.URLSearchParams('foo=bar')).get('foo') === 'bar') {
					return self.URLSearchParams;
				}
			} catch (e) {}
			return null;
		})(),
		isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
		// There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
		decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
		__URLSearchParams__ = "__URLSearchParams__",
		// Fix bug in Edge which cannot encode ' &' correctly
		encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
			var ampersandTest = new nativeURLSearchParams();
			ampersandTest.append('s', ' &');
			return ampersandTest.toString() === 's=+%26';
		})() : true,
		prototype = URLSearchParamsPolyfill.prototype,
		iterable = !!(self.Symbol && self.Symbol.iterator);

	if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
		return;
	}


	/**
	 * Make a URLSearchParams instance
	 *
	 * @param {object|string|URLSearchParams} search
	 * @constructor
	 */
	function URLSearchParamsPolyfill(search) {
		search = search || "";

		// support construct object with another URLSearchParams instance
		if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
			search = search.toString();
		}
		this [__URLSearchParams__] = parseToDict(search);
	}


	/**
	 * Appends a specified key/value pair as a new search parameter.
	 *
	 * @param {string} name
	 * @param {string} value
	 */
	prototype.append = function(name, value) {
		appendTo(this [__URLSearchParams__], name, value);
	};

	/**
	 * Deletes the given search parameter, and its associated value,
	 * from the list of all search parameters.
	 *
	 * @param {string} name
	 */
	prototype['delete'] = function(name) {
		delete this [__URLSearchParams__] [name];
	};

	/**
	 * Returns the first value associated to the given search parameter.
	 *
	 * @param {string} name
	 * @returns {string|null}
	 */
	prototype.get = function(name) {
		var dict = this [__URLSearchParams__];
		return this.has(name) ? dict[name][0] : null;
	};

	/**
	 * Returns all the values association with a given search parameter.
	 *
	 * @param {string} name
	 * @returns {Array}
	 */
	prototype.getAll = function(name) {
		var dict = this [__URLSearchParams__];
		return this.has(name) ? dict [name].slice(0) : [];
	};

	/**
	 * Returns a Boolean indicating if such a search parameter exists.
	 *
	 * @param {string} name
	 * @returns {boolean}
	 */
	prototype.has = function(name) {
		return hasOwnProperty(this [__URLSearchParams__], name);
	};

	/**
	 * Sets the value associated to a given search parameter to
	 * the given value. If there were several values, delete the
	 * others.
	 *
	 * @param {string} name
	 * @param {string} value
	 */
	prototype.set = function set(name, value) {
		this [__URLSearchParams__][name] = ['' + value];
	};

	/**
	 * Returns a string containg a query string suitable for use in a URL.
	 *
	 * @returns {string}
	 */
	prototype.toString = function() {
		var dict = this[__URLSearchParams__], query = [], i, key, name, value;
		for (key in dict) {
			name = encode(key);
			for (i = 0, value = dict[key]; i < value.length; i++) {
				query.push(name + '=' + encode(value[i]));
			}
		}
		return query.join('&');
	};

	// There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
	var forSureUsePolyfill = !decodesPlusesCorrectly;
	var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy);
	var propValue;
	if (useProxy) {
		// Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
		propValue = new Proxy(nativeURLSearchParams, {
			construct: function (target, args) {
				return new target((new URLSearchParamsPolyfill(args[0]).toString()));
			}
		})
		// Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
		propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
	} else {
		propValue = URLSearchParamsPolyfill;
	}
	/*
	 * Apply polifill to global object and append other prototype into it
	 */
	Object.defineProperty(self, 'URLSearchParams', {
		value: propValue
	});

	var USPProto = self.URLSearchParams.prototype;

	USPProto.polyfill = true;

	/**
	 *
	 * @param {function} callback
	 * @param {object} thisArg
	 */
	USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
		var dict = parseToDict(this.toString());
		Object.getOwnPropertyNames(dict).forEach(function(name) {
			dict[name].forEach(function(value) {
				callback.call(thisArg, value, name, this);
			}, this);
		}, this);
	};

	/**
	 * Sort all name-value pairs
	 */
	USPProto.sort = USPProto.sort || function() {
		var dict = parseToDict(this.toString()), keys = [], k, i, j;
		for (k in dict) {
			keys.push(k);
		}
		keys.sort();

		for (i = 0; i < keys.length; i++) {
			this['delete'](keys[i]);
		}
		for (i = 0; i < keys.length; i++) {
			var key = keys[i], values = dict[key];
			for (j = 0; j < values.length; j++) {
				this.append(key, values[j]);
			}
		}
	};

	/**
	 * Returns an iterator allowing to go through all keys of
	 * the key/value pairs contained in this object.
	 *
	 * @returns {function}
	 */
	USPProto.keys = USPProto.keys || function() {
		var items = [];
		this.forEach(function(item, name) {
			items.push(name);
		});
		return makeIterator(items);
	};

	/**
	 * Returns an iterator allowing to go through all values of
	 * the key/value pairs contained in this object.
	 *
	 * @returns {function}
	 */
	USPProto.values = USPProto.values || function() {
		var items = [];
		this.forEach(function(item) {
			items.push(item);
		});
		return makeIterator(items);
	};

	/**
	 * Returns an iterator allowing to go through all key/value
	 * pairs contained in this object.
	 *
	 * @returns {function}
	 */
	USPProto.entries = USPProto.entries || function() {
		var items = [];
		this.forEach(function(item, name) {
			items.push([name, item]);
		});
		return makeIterator(items);
	};


	if (iterable) {
		USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
	}


	function encode(str) {
		var replace = {
			'!': '%21',
			"'": '%27',
			'(': '%28',
			')': '%29',
			'~': '%7E',
			'%20': '+',
			'%00': '\x00'
		};
		return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
			return replace[match];
		});
	}

	function decode(str) {
		return str
			.replace(/[ +]/g, '%20')
			.replace(/(%[a-f0-9]{2})+/ig, function(match) {
				return decodeURIComponent(match);
			});
	}

	function makeIterator(arr) {
		var iterator = {
			next: function() {
				var value = arr.shift();
				return {done: value === undefined, value: value};
			}
		};

		if (iterable) {
			iterator[self.Symbol.iterator] = function() {
				return iterator;
			};
		}

		return iterator;
	}

	function parseToDict(search) {
		var dict = {};

		if (typeof search === "object") {
			// if `search` is an array, treat it as a sequence
			if (isArray(search)) {
				for (var i = 0; i < search.length; i++) {
					var item = search[i];
					if (isArray(item) && item.length === 2) {
						appendTo(dict, item[0], item[1]);
					} else {
						throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
					}
				}

			} else {
				for (var key in search) {
					if (search.hasOwnProperty(key)) {
						appendTo(dict, key, search[key]);
					}
				}
			}

		} else {
			// remove first '?'
			if (search.indexOf("?") === 0) {
				search = search.slice(1);
			}

			var pairs = search.split("&");
			for (var j = 0; j < pairs.length; j++) {
				var value = pairs [j],
					index = value.indexOf('=');

				if (-1 < index) {
					appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

				} else {
					if (value) {
						appendTo(dict, decode(value), '');
					}
				}
			}
		}

		return dict;
	}

	function appendTo(dict, name, value) {
		var val = typeof value === 'string' ? value : (
			value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
		);

		// #47 Prevent using `hasOwnProperty` as a property name
		if (hasOwnProperty(dict, name)) {
			dict[name].push(val);
		} else {
			dict[name] = [val];
		}
	}

	function isArray(val) {
		return !!val && '[object Array]' === Object.prototype.toString.call(val);
	}

	function hasOwnProperty(obj, prop) {
		return Object.prototype.hasOwnProperty.call(obj, prop);
	}

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));
/* global define */

(function (root, pluralize) {
	/* istanbul ignore else */
	if (typeof require === 'function' && typeof exports === 'object' && typeof module === 'object') {
		// Node.
		module.exports = pluralize();
	} else if (typeof define === 'function' && define.amd) {
		// AMD, registers as an anonymous module.
		define(function () {
			return pluralize();
		});
	} else {
		// Browser global.
		root.pluralize = pluralize();
	}
})(this, function () {
	// Rule storage - pluralize and singularize need to be run sequentially,
	// while other rules can be optimized using an object for instant lookups.
	var pluralRules = [];
	var singularRules = [];
	var uncountables = {};
	var irregularPlurals = {};
	var irregularSingles = {};

	/**
	 * Sanitize a pluralization rule to a usable regular expression.
	 *
	 * @param  {(RegExp|string)} rule
	 * @return {RegExp}
	 */
	function sanitizeRule (rule) {
		if (typeof rule === 'string') {
			return new RegExp('^' + rule + '$', 'i');
		}

		return rule;
	}

	/**
	 * Pass in a word token to produce a function that can replicate the case on
	 * another word.
	 *
	 * @param  {string}   word
	 * @param  {string}   token
	 * @return {Function}
	 */
	function restoreCase (word, token) {
		// Tokens are an exact match.
		if (word === token) return token;

		// Lower cased words. E.g. "hello".
		if (word === word.toLowerCase()) return token.toLowerCase();

		// Upper cased words. E.g. "WHISKY".
		if (word === word.toUpperCase()) return token.toUpperCase();

		// Title cased words. E.g. "Title".
		if (word[0] === word[0].toUpperCase()) {
			return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
		}

		// Lower cased words. E.g. "test".
		return token.toLowerCase();
	}

	/**
	 * Interpolate a regexp string.
	 *
	 * @param  {string} str
	 * @param  {Array}  args
	 * @return {string}
	 */
	function interpolate (str, args) {
		return str.replace(/\$(\d{1,2})/g, function (match, index) {
			return args[index] || '';
		});
	}

	/**
	 * Replace a word using a rule.
	 *
	 * @param  {string} word
	 * @param  {Array}  rule
	 * @return {string}
	 */
	function replace (word, rule) {
		return word.replace(rule[0], function (match, index) {
			var result = interpolate(rule[1], arguments);

			if (match === '') {
				return restoreCase(word[index - 1], result);
			}

			return restoreCase(match, result);
		});
	}

	/**
	 * Sanitize a word by passing in the word and sanitization rules.
	 *
	 * @param  {string}   token
	 * @param  {string}   word
	 * @param  {Array}    rules
	 * @return {string}
	 */
	function sanitizeWord (token, word, rules) {
		// Empty string or doesn't need fixing.
		if (!token.length || uncountables.hasOwnProperty(token)) {
			return word;
		}

		var len = rules.length;

		// Iterate over the sanitization rules and use the first one to match.
		while (len--) {
			var rule = rules[len];

			if (rule[0].test(word)) return replace(word, rule);
		}

		return word;
	}

	/**
	 * Replace a word with the updated word.
	 *
	 * @param  {Object}   replaceMap
	 * @param  {Object}   keepMap
	 * @param  {Array}    rules
	 * @return {Function}
	 */
	function replaceWord (replaceMap, keepMap, rules) {
		return function (word) {
			// Get the correct token and case restoration functions.
			var token = word.toLowerCase();

			// Check against the keep object map.
			if (keepMap.hasOwnProperty(token)) {
				return restoreCase(word, token);
			}

			// Check against the replacement map for a direct word replacement.
			if (replaceMap.hasOwnProperty(token)) {
				return restoreCase(word, replaceMap[token]);
			}

			// Run all the rules against the word.
			return sanitizeWord(token, word, rules);
		};
	}

	/**
	 * Check if a word is part of the map.
	 */
	function checkWord (replaceMap, keepMap, rules, bool) {
		return function (word) {
			var token = word.toLowerCase();

			if (keepMap.hasOwnProperty(token)) return true;
			if (replaceMap.hasOwnProperty(token)) return false;

			return sanitizeWord(token, token, rules) === token;
		};
	}

	/**
	 * Pluralize or singularize a word based on the passed in count.
	 *
	 * @param  {string}  word      The word to pluralize
	 * @param  {number}  count     How many of the word exist
	 * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
	 * @return {string}
	 */
	function pluralize (word, count, inclusive) {
		var pluralized = count === 1
			? pluralize.singular(word) : pluralize.plural(word);

		return (inclusive ? count + ' ' : '') + pluralized;
	}

	/**
	 * Pluralize a word.
	 *
	 * @type {Function}
	 */
	pluralize.plural = replaceWord(
		irregularSingles, irregularPlurals, pluralRules
	);

	/**
	 * Check if a word is plural.
	 *
	 * @type {Function}
	 */
	pluralize.isPlural = checkWord(
		irregularSingles, irregularPlurals, pluralRules
	);

	/**
	 * Singularize a word.
	 *
	 * @type {Function}
	 */
	pluralize.singular = replaceWord(
		irregularPlurals, irregularSingles, singularRules
	);

	/**
	 * Check if a word is singular.
	 *
	 * @type {Function}
	 */
	pluralize.isSingular = checkWord(
		irregularPlurals, irregularSingles, singularRules
	);

	/**
	 * Add a pluralization rule to the collection.
	 *
	 * @param {(string|RegExp)} rule
	 * @param {string}          replacement
	 */
	pluralize.addPluralRule = function (rule, replacement) {
		pluralRules.push([sanitizeRule(rule), replacement]);
	};

	/**
	 * Add a singularization rule to the collection.
	 *
	 * @param {(string|RegExp)} rule
	 * @param {string}          replacement
	 */
	pluralize.addSingularRule = function (rule, replacement) {
		singularRules.push([sanitizeRule(rule), replacement]);
	};

	/**
	 * Add an uncountable word rule.
	 *
	 * @param {(string|RegExp)} word
	 */
	pluralize.addUncountableRule = function (word) {
		if (typeof word === 'string') {
			uncountables[word.toLowerCase()] = true;
			return;
		}

		// Set singular and plural references for the word.
		pluralize.addPluralRule(word, '$0');
		pluralize.addSingularRule(word, '$0');
	};

	/**
	 * Add an irregular word definition.
	 *
	 * @param {string} single
	 * @param {string} plural
	 */
	pluralize.addIrregularRule = function (single, plural) {
		plural = plural.toLowerCase();
		single = single.toLowerCase();

		irregularSingles[single] = plural;
		irregularPlurals[plural] = single;
	};

	/**
	 * Irregular rules.
	 */
	[
		// Pronouns.
		['I', 'we'],
		['me', 'us'],
		['he', 'they'],
		['she', 'they'],
		['them', 'them'],
		['myself', 'ourselves'],
		['yourself', 'yourselves'],
		['itself', 'themselves'],
		['herself', 'themselves'],
		['himself', 'themselves'],
		['themself', 'themselves'],
		['is', 'are'],
		['was', 'were'],
		['has', 'have'],
		['this', 'these'],
		['that', 'those'],
		['my', 'our'],
		['its', 'their'],
		['his', 'their'],
		['her', 'their'],
		// Words ending in with a consonant and `o`.
		['echo', 'echoes'],
		['dingo', 'dingoes'],
		['volcano', 'volcanoes'],
		['tornado', 'tornadoes'],
		['torpedo', 'torpedoes'],
		// Ends with `us`.
		['genus', 'genera'],
		['viscus', 'viscera'],
		// Ends with `ma`.
		['stigma', 'stigmata'],
		['stoma', 'stomata'],
		['dogma', 'dogmata'],
		['lemma', 'lemmata'],
		['schema', 'schemata'],
		['anathema', 'anathemata'],
		// Other irregular rules.
		['ox', 'oxen'],
		['axe', 'axes'],
		['die', 'dice'],
		['yes', 'yeses'],
		['foot', 'feet'],
		['eave', 'eaves'],
		['goose', 'geese'],
		['tooth', 'teeth'],
		['quiz', 'quizzes'],
		['human', 'humans'],
		['proof', 'proofs'],
		['carve', 'carves'],
		['valve', 'valves'],
		['looey', 'looies'],
		['thief', 'thieves'],
		['groove', 'grooves'],
		['pickaxe', 'pickaxes'],
		['passerby', 'passersby'],
		['canvas', 'canvases']
	].forEach(function (rule) {
		return pluralize.addIrregularRule(rule[0], rule[1]);
	});

	/**
	 * Pluralization rules.
	 */
	[
		[/s?$/i, 's'],
		[/[^\u0000-\u007F]$/i, '$0'],
		[/([^aeiou]ese)$/i, '$1'],
		[/(ax|test)is$/i, '$1es'],
		[/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
		[/(e[mn]u)s?$/i, '$1s'],
		[/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
		[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
		[/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
		[/(seraph|cherub)(?:im)?$/i, '$1im'],
		[/(her|at|gr)o$/i, '$1oes'],
		[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
		[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
		[/sis$/i, 'ses'],
		[/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
		[/([^aeiouy]|qu)y$/i, '$1ies'],
		[/([^ch][ieo][ln])ey$/i, '$1ies'],
		[/(x|ch|ss|sh|zz)$/i, '$1es'],
		[/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
		[/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
		[/(pe)(?:rson|ople)$/i, '$1ople'],
		[/(child)(?:ren)?$/i, '$1ren'],
		[/eaux$/i, '$0'],
		[/m[ae]n$/i, 'men'],
		['thou', 'you']
	].forEach(function (rule) {
		return pluralize.addPluralRule(rule[0], rule[1]);
	});

	/**
	 * Singularization rules.
	 */
	[
		[/s$/i, ''],
		[/(ss)$/i, '$1'],
		[/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
		[/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
		[/ies$/i, 'y'],
		[/(dg|ss|ois|lk|ok|wn|mb|th|ch|ec|oal|is|ck|ix|sser|ts|wb)ies$/i, '$1ie'],
		[/\b(l|(?:neck|cross|hog|aun)?t|coll|faer|food|gen|goon|group|hipp|junk|vegg|(?:pork)?p|charl|calor|cut)ies$/i, '$1ie'],
		[/\b(mon|smil)ies$/i, '$1ey'],
		[/\b((?:tit)?m|l)ice$/i, '$1ouse'],
		[/(seraph|cherub)im$/i, '$1'],
		[/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
		[/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
		[/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
		[/(test)(?:is|es)$/i, '$1is'],
		[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
		[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
		[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
		[/(alumn|alg|vertebr)ae$/i, '$1a'],
		[/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
		[/(matr|append)ices$/i, '$1ix'],
		[/(pe)(rson|ople)$/i, '$1rson'],
		[/(child)ren$/i, '$1'],
		[/(eau)x?$/i, '$1'],
		[/men$/i, 'man']
	].forEach(function (rule) {
		return pluralize.addSingularRule(rule[0], rule[1]);
	});

	/**
	 * Uncountable rules.
	 */
	[
		// Singular words with no plurals.
		'adulthood',
		'advice',
		'agenda',
		'aid',
		'aircraft',
		'alcohol',
		'ammo',
		'analytics',
		'anime',
		'athletics',
		'audio',
		'bison',
		'blood',
		'bream',
		'buffalo',
		'butter',
		'carp',
		'cash',
		'chassis',
		'chess',
		'clothing',
		'cod',
		'commerce',
		'cooperation',
		'corps',
		'debris',
		'diabetes',
		'digestion',
		'elk',
		'energy',
		'equipment',
		'excretion',
		'expertise',
		'firmware',
		'flounder',
		'fun',
		'gallows',
		'garbage',
		'graffiti',
		'hardware',
		'headquarters',
		'health',
		'herpes',
		'highjinks',
		'homework',
		'housework',
		'information',
		'jeans',
		'justice',
		'kudos',
		'labour',
		'literature',
		'machinery',
		'mackerel',
		'mail',
		'media',
		'mews',
		'moose',
		'music',
		'mud',
		'manga',
		'news',
		'only',
		'personnel',
		'pike',
		'plankton',
		'pliers',
		'police',
		'pollution',
		'premises',
		'rain',
		'research',
		'rice',
		'salmon',
		'scissors',
		'series',
		'sewage',
		'shambles',
		'shrimp',
		'software',
		'staff',
		'swine',
		'tennis',
		'traffic',
		'transportation',
		'trout',
		'tuna',
		'wealth',
		'welfare',
		'whiting',
		'wildebeest',
		'wildlife',
		'you',
		/pok[eé]mon$/i,
		// Regexes.
		/[^aeiou]ese$/i, // "chinese", "japanese"
		/deer$/i, // "deer", "reindeer"
		/fish$/i, // "fish", "blowfish", "angelfish"
		/measles$/i,
		/o[iu]s$/i, // "carnivorous"
		/pox$/i, // "chickpox", "smallpox"
		/sheep$/i
	].forEach(pluralize.addUncountableRule);

	return pluralize;
});
class Router {
	constructor() {
		// All the registered routes
		this.routes = [];

		// Current Route (the page you're on)
		this.currentRoute = null;

		// Current URL (the page you're on)
		this.currentUrl = null;

		// The Current Alias's URL Object
		this.currentAliasUrl = null;

		// If this is a dev site, this gets added as a prefix
		this.devPathFragment = null;

		// The Base URL for the site (protocol + host + dev fragment [if applicable])
		this.siteBaseUrl = '';

		// Route History
		this.routeHistory = [];

		// Router Status
		this.isStarted = false;

		// First time loading
		this.firstLoad = true;
		
		// Previous URL
		this.previousUrls = [];
	}

	/**
	 * Start up the router and attach event listeners
	 */
	start() {
		// Check for referrer URL
		this.previousUrls.push(window.location.href);
		
		// Anytime there is a popstate, route to that page using router
		window.addEventListener('popstate', (e) => {
			let lastLocation = this.previousUrls[this.previousUrls.length - 1];
			lastLocation = new URL(lastLocation);
			const currentUrl = new URL(window.location.href);
			
			// If the last location and the new location are both React routes, don't route
			const lastLocationWasReactRoute = this.isReactRoute(lastLocation);
			if (lastLocationWasReactRoute && this.isReactRoute(new URL(window.location.href))) return;
			
			// Only route if the URL has changed
			this.routeTo(window.location.href, true, !this.isSameUrl(currentUrl, lastLocation));
		});

		// Intercept and handle all site click events
		document.addEventListener('click', (e) => {
			// Get the link that is being clicked and make sure it has a URL
			let link = e.target.closest('a') || '';
			if (!link || !link.href) return;

			// Check if a modifier key is being used (to open in new tab, new window, etc)
			const isUsingModifierKey = e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
			if (isUsingModifierKey) return;

			// Check if it's a link that should be ignored
			const ignoredLink = link.dataset.routerIgnore && link.dataset.routerIgnore === 'true';

			// Check if it's target is a new window
			const targetIsNewWindow = link.hasAttribute('target') && link.getAttribute('target') === '_blank';

			// Check if the href is just a single hash '#'
			const isAnchorLink = link.href.match(/\/?#$/);

			// Build a full URL object to work with
			link = sa.router.buildFullUrl(link.href);

			// Check to see if it's the same origin
			const isSameOrigin = window.location.hostname === link.hostname;
			const isPHPLink = link.pathname.includes('.php');

			// Check if this URL or Hash is in the banned list
			const isBlacklisted = this.urlIsBlacklisted(link, false);
			
			// Check if this URL is for a React Component that uses its own router
			const isReactRoute = this.isReactRoute(link);

			// Ignore the link if it's not the same origin or is a link to a PHP file
			if (
				!isSameOrigin
				|| isPHPLink
				|| ignoredLink
				|| targetIsNewWindow
				|| isAnchorLink
			) {
				return;
			}

			e.preventDefault();

			if (isBlacklisted || isReactRoute) return;

			// Use the router to go to the SPA link
			sa.router.routeTo(link.href);
		});

		// Set the base url for the site
		this.siteBaseUrl = this.getSiteBaseUrl();

		// Set status to "started"
		this.isStarted = true;

		this.routeTo(window.location.href, true);
	}

	/**
	 * Check that the router is started
	 *
	 * @returns {boolean}
	 */
	started() {
		return this.isStarted;
	}

	/**
	 * Add/Register a new route with the router
	 *
	 * @param routeName
	 * @param options
	 * @param cb
	 */
	addRoute(routeName, options, cb) {
		const pattern = this.convertRouteToRegex(options.pattern);

		const navigable = options.hasOwnProperty('navigable') ? options.navigable : true;

		this.routes.push({
			pattern,
			name: routeName,
			hash: options.hash,
			id: options.id,
			appendParams: options.appendParams,
			redirect: options.redirect,
			navigable,
			cb: options.cb || cb,
		});
	}

	/**
	 * Routes to a provided link, path, path fragment, etc.
	 *
	 * @param path Can be a full URL `https://example.com`, a fragment `/tracks`, a hashbang `#!explorer`, or a query parameter string `id=1&pg=0`
	 * @param isPopState Is this route action happening due to a popstate event
	 * @param overrideHardStop Skip the page check in order to force the page to reload the content
	 * @param skipSameUrlCheck Skip the same url check (used for special cases)
	 * @returns {*}
	 */
	routeTo(path, isPopState = null, overrideHardStop = false, skipSameUrlCheck = false) {
		// Build working URL from path
		let parsedPathUrl = this.buildFullUrl(path);

		parsedPathUrl = this.stripParamsFromUrl(parsedPathUrl);
		parsedPathUrl = this.updateOldUrls(parsedPathUrl);
		parsedPathUrl = this.checkForMalformedUrls(parsedPathUrl);

		// Check if the url is a custom hash
		const [isCustomHashUrl, convertedHashUrl] = this.checkCustomHash(parsedPathUrl);
		if (isCustomHashUrl) {
			parsedPathUrl = convertedHashUrl;
		}

		parsedPathUrl = this.homePathLookup(parsedPathUrl);

		parsedPathUrl = this.splitParamsFromHash(parsedPathUrl);

		// If the base site url has a dev path and this path does not, add one.
		parsedPathUrl = this.checkForDevFragment(parsedPathUrl);

		// Check for hardcoded redirects
		parsedPathUrl = this.checkHardCodedRedirects(parsedPathUrl);

		// Check if current path is the same the new incoming path
		if (!skipSameUrlCheck && this.isSameUrl(parsedPathUrl, this.currentUrl) && !overrideHardStop) {
			console.log('Hard Stop. Same URL.');
			return;
		}

		// Check for an alias for this path
		// The pathUrl is the original URL to be used for query params and other data extraction
		// The aliasUrl is the new alias URL object (if it exists) that is used to set the url history state
		let { aliasUrl, pathUrl } = this.findAlias(parsedPathUrl);
		
		// Convert Hash Paths to the new clean URL structure
		// Example: #!explorer -> /tracks
		const originalUrl = new URL(pathUrl.href);
		aliasUrl = this.convertPathToGoodLinks(aliasUrl, true);

		if (!isCustomHashUrl) {
			pathUrl = this.convertPathToGoodLinks(pathUrl);
		} else {
			pathUrl.hash = '';
		}

		// Check and see if there is an alias, and if so, make it the url that will be pushed to the history api
		const pushUrl = !aliasUrl ? pathUrl : aliasUrl;

		// Set the current page to be the previous page
		this.storePreviousUrl(pushUrl);

		// Check if this URL or Hash is in the banned list
		if (this.urlIsBlacklisted(pushUrl, isPopState)) return;

		// Check if the current user or site has the proper permissions to view this page
		if (!this.checkRoutePermissions(pushUrl)) return;

		// If there isn't an available route to use to build this path, go to 404 page
		if (!pathUrl) {
			console.warn('No route available for url: %s.', originalUrl.href);
			this.goTo404Page(pushUrl);
			return;
		}

		// For route comparison, we need to remove the dev fragment.
		// The route pattern might be /tracks, but the current url may be /dev-prefixed-1234/tracks, so we need to remove it.
		let pathname = this.removeDevPathFragment(pathUrl.pathname);

		/*
			If the current route/path is the root or home page, we override the pathname with what the user has set
			as their home page path (in the config). One user may have '/' -> '/tracks', while another might
			have '/' -> '/albums', so we need to check for that.
	 	*/
		let overridePath = false;
		if (pathname === '/' || pathname === '') {
			pathname = this.pathConversionLookup(config.home);
			pathUrl = this.buildFullUrl(pathname);
			pathname = this.removeDevPathFragment(pathUrl.pathname);
			overridePath = true;
		}

		// Find the route based on the current pathname matching the route path pattern
		let route = this.routes.find(currentRoute => pathname.match(currentRoute.pattern));
		if (!route || this.pageNotAllowed(route)) {
			console.warn('No route available for url: %s.', pathUrl.href);
			this.goTo404Page(pushUrl);
			return;
		}
		
		// Check if the route has a redirect URL
		if (route.redirect) {
			// Get the current route name. We need to replace it with the new route name
			const originalRouteName = route.name;
			const newRoutePathname = route.redirect.replace(/^\//, '');
			const tempPathName = pathname.replace(originalRouteName, newRoutePathname);
			
			// Find the new route based on the new pathname
			route = this.routes.find(currentRoute => tempPathName.match(currentRoute.pattern));

			// Update the pathURL and the pushUrl with the new route information.
			// Essentially, we're doing something like /my-url/1234 -> /my-new-url/1234
			pathUrl.href = pathUrl.href.replace(originalRouteName, newRoutePathname);
			
			// Check if there is an alias and keep the alias pathname if it exists, otherwise use our new pathUrl pathname
			pushUrl.pathname = aliasUrl ? pushUrl.pathname : pathUrl.pathname;
			
			// If the route isn't available or not allowed, 404
			if (!route || this.pageNotAllowed(route)) {
				console.warn('No route available for url: %s.', pathUrl.href);
				this.goTo404Page(pushUrl);
				return;
			}
		}

		sa.trigger('beforeRouteChange');

		// If the route isn't navigable (feedback popup, etc), push it to the routeHistory, run the callback and return
		if (!route.navigable) {
			this.routeHistory.push({
				route,
				path: pathUrl.href,
			});

			route.cb();

			return;
		}

		// Add the dev fragment back to the path, if necessary, so that the history state will have the prefix if it needs it
		pushUrl.pathname = this.addDevFragment(overridePath ? pathname : pushUrl.pathname);

		// Check if there are any registered unloadFunctions that need to execute
		if (unloadFunctions.length) {
			for (let i = 0, len = unloadFunctions.length; i < len; i++) {
				if (unloadFunctions[i]()) {
					this.setHistory(url);
					return;
				}
			}
		}

		// Check for affiliate for e-commerce tracking
		this.setAffiliate(pushUrl);

		// Check for NOCACHE param in the URL query params
		if (pushUrl.searchParams.has('nocache')) nocache = true;

		// Check if this is the download route and redirect
		if (route.name === 'download') {
			const uri = this.pathConversionLookup(config.home);
			sa.router.routeTo(uri);
			return;
		}

		// Check if this is a custom page and redirect accordingly
		if (route.name === 'custom' && typeof showCustomPage !== 'function') {
			sa.router.routeTo(this.pathConversionLookup(config.home));
			return;
		}

		// Update the history via the History API
		this.setHistory(pushUrl, isPopState);

		// Update the route history array
		this.updateRouteHistory(route, pushUrl);

		// Set the current route, current alias url, and current actual url
		this.currentRoute = route;
		this.currentAliasUrl = aliasUrl;
		this.currentUrl = pathUrl;

		// Since many pages need specific parameters passed to them to run/load the correct data
		// this will pull that parameter from a clean url structure if it can.
		// For example, to load a specific album, we need to pass the parameter `b=12345`, but the
		// clean path will be `/album/12345`. This method extracts the query key: `b` and value: `12345` and 
		// builds the query param `b=12345` we need to pass along.
		const params = this.parseParamsFromRoute(route, pathUrl);

		// Passes any and all query parameters to the callback function for the route. AKA, "the main event"
		route.cb(params);

		// Analytics
		recordAnalytics(pushUrl.href);

		// Trigger `routeChange` event
		sa.trigger('routeChange', {
			route: this.currentRoute,
		});
	}

	/**
	 * Store the previous URL in the stack
	 * @param pushUrl
	 */
	storePreviousUrl(pushUrl = '') {
		// Store the previous URL
		this.previousUrls.push(pushUrl.href);
	}

	/**
	 * Get the last page visited's URL
	 * @returns {*|null}
	 */
	getPreviousUrl() {
		if (this.previousUrls.length === 0) {
			return null;
		}
		
		// If the last URL is the same as the current URL, remove it from the stack
		while (this.previousUrls.length > 1 && this.previousUrls[this.previousUrls.length - 1] === this.currentUrl.href) {
			this.previousUrls.pop();
		}
		
		if (this.previousUrls.at(-1) === this.currentUrl.href) {
			return null;
		}
		
		return this.previousUrls.pop();
	}
	
	/**
	 * Check if a specific page is allowed to be loaded
	 *
	 * @param route
	 * @returns {boolean}
	 */
	pageNotAllowed(route) {
		const { siteType } = config;

		if (route.name === 'requests' && siteType === 'seller') {
			return true;
		}

		return false;
	}

	/**
	 * Strip params from a URL object
	 * @param url The URL Object being worked on
	 * @param params An array of param names to remove (optional)
	 * @returns {URL} The modified URL Object
	 */
	stripParamsFromUrl(url, params = []) {
		let unneededParamList = [...params, 'ajaxNonce', 'ajaxNonceKey'];
		unneededParamList.forEach(paramName => {
			if (url.searchParams.has(paramName)) {
				url.searchParams.delete(paramName);
			}
		});

		return url;
	}

	/**
	 * Update the current url by replacing old patterns with new
	 *
	 * @param url
	 */
	updateOldUrls(url) {
		const urlConversions = new Map();
		urlConversions.set('music_providers', 'music-providers');

		urlConversions.forEach((v, k) => {
			url.pathname = url.pathname.replace(k, v);
		});

		return url;
	}

	/**
	 * Checks if a url might have a known malformed url pattern and replaces it with a good one
	 *
	 * @param url
	 * @returns {*}
	 */
	checkForMalformedUrls(url) {
		const possibleBadUrlPatterns = {
			'tracks/tracks': 'tracks'
		};

		for (const badPattern in possibleBadUrlPatterns) {
			const urlWithoutDevPrefix = this.removeDevPathFragment(url.pathname);
			if (urlWithoutDevPrefix.includes(badPattern)) {
				url.href = url.href.replace(badPattern, possibleBadUrlPatterns[badPattern]);
				break;
			}
		}

		return url;
	}

	/**
	 * Get unique ids from url path
	 *
	 * @param path
	 * @returns {string|*}
	 */
	extractUniqueIdFromPath(path) {
		// Ex. - /playlist/12345
		let pathWithoutDev = this.removeDevPathFragment(path);
		let url = this.buildFullUrl(pathWithoutDev);
		let route = this.routes.find(route => url.pathname.match(route.pattern));
		if (!route) return path;
		return this.parseParamsFromRoute(route, url);
	}

	/**
	 * Append new route information to the routeHistory array
	 *
	 * @param route Route object
	 * @param url Route URL object
	 */
	updateRouteHistory(route, url) {
		this.routeHistory.push({
			route,
			path: url.href,
		});
	}

	/**
	 * Checks the current URL for an affiliate parameter and set's it to the global `sa` instance
	 *
	 * @param url
	 */
	setAffiliate(url) {
		const hasAffiliateParam = url.searchParams.has('_aff');
		if (hasAffiliateParam) {
			sa._aff = url.searchParams.get('_aff');
		}
	}

	/**
	 * Pushes a URL to the site's URL history
	 *
	 * @param url
	 * @param {boolean} isPopState
	 *
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/History/pushState} for further information.
	 */
	setHistory(url, isPopState = false) {
		if (isPopState || this.firstLoad) {
			window.history.replaceState(null, null, url);
		} else {
			window.history.pushState(null, null, url);
		}

		this.firstLoad = false;
	}

	/**
	 * If a route cannot be found, this will get the `page-not-found` route and return it.
	 *
	 * @param failedUrl
	 */
	goTo404Page(failedUrl) {
		const pageNotFoundRoute = this.routes.find(route => route.name === 'page-not-found');
		if (!pageNotFoundRoute) {
			sa.router.routeTo('404.php');
			return;
		}

		// Update the URL to reflect the 404
		const pageNotFoundUrl = `${this.getSiteBaseUrl()}/page-not-found`;
		this.currentUrl = this.buildFullUrl(pageNotFoundUrl);
		window.history.pushState(null, null, pageNotFoundUrl);
		pageNotFoundRoute.cb(failedUrl);
	}

	/**
	 * Check if the current URL has a dev fragment and adds on if necessary
	 *
	 * @param {URL} url Original URL object
	 * @returns {URL} Modified URL object
	 */
	checkForDevFragment(url) {
		const { pathname } = url;
		url.pathname = this.addDevFragment(pathname);
		return url;
	}

	/**
	 * Get and set the sites base url
	 *
	 * @returns {string}
	 */
	getSiteBaseUrl() {
		const currentUrl = new URL(window.location.href);
		const port = currentUrl.port ? ':' + currentUrl.port : '';
		return `${currentUrl.protocol}//${currentUrl.hostname}${port}${this.getDevPathFragment()}`;
	}

	/**
	 * Get the current URL pathname (optionally, with query params)
	 *
	 * Example: `/tracks` or `/tracks?pg=1`
	 *
	 * @param {boolean} withQueryParams
	 * @returns {string|*}
	 */
	getCurrentPath(withQueryParams = false) {
		const currentUrl = this.currentUrl || new URL(window.location.href);
		return currentUrl.pathname + (withQueryParams ? currentUrl.search : '');
	}

	/**
	 * Checks if the current URL is an unrecognized (possibly custom) hash route
	 *
	 * @param url URL object
	 * @returns {(boolean|{hash}|*)[]} Returns an array with two values: is it a custom hash (bool) AND a new URL built from that hash
	 */
	checkCustomHash(url) {
		let tempUrl = url;
		let path = tempUrl.pathname;
		let pathWithoutDevPath = this.removeDevPathFragment(path);

		// Check if the url contains a hash
		if ((!tempUrl.hash || !tempUrl.hash.includes('#!')) && (pathWithoutDevPath !== '' || pathWithoutDevPath !== '/')) {
			return [false, tempUrl];
		}

		// Check if there is a matching hash in our register routes
		let [hash, params] = tempUrl.hash.split('?');
		const routeMatch = this.routes.find(route => route.hash === hash);

		// If there are params attached to the hash, add them into the query string
		tempUrl.search = params || tempUrl.search;

		if (!routeMatch) {
			tempUrl.hash = '';
			tempUrl.pathname = hash.replace('#!', '');
			return [true, tempUrl];
		}

		return [false, tempUrl];
	}

	/**
	 * Get the current alias URL object (or as a string)
	 *
	 * @param asString Return just the Href as a string
	 * @returns {null|string|URL}
	 */
	getCurrentAlias(asString = false) {
		if (!this.currentAliasUrl) return null;

		if (!asString) return this.currentAliasUrl;

		return this.currentAliasUrl.href;
	}

	currentRouteIsAlias() {
		return !!this.currentAliasUrl;
	}

	/**
	 * Get the current query parameters as an object
	 *
	 * @returns {{}}
	 */
	getCurrentParamsAsObject() {
		return this.paramsToVars(this.getCurrentQueryParams());
	}

	/**
	 * Get the current query parameters as a string (with optional leading '?')
	 *
	 * @param withLeadingQuestionMark
	 * @returns {string|*}
	 */
	getCurrentQueryParams(withLeadingQuestionMark = false) {
		if (!this.currentUrl) return '';

		if (withLeadingQuestionMark) {
			return this.currentUrl.search;
		}

		return this.currentUrl.search.replace(/^\?/, '');
	}

	/**
	 * Convert a query string into a URLSearchParams object
	 *
	 * @param {string} queryString
	 * @returns {URLSearchParams}
	 */
	convertQueryStringToUrlSearchObj(queryString) {
		return new URLSearchParams(queryString);
	}

	/**
	 * Get the dev fragment from the current URL (if one is available)
	 *
	 * @returns {string}
	 */
	getDevPathFragment() {
		if (this.devPathFragment === null) {
			const currentUrl = new URL(window.location.href);
			const pattern = /git-[a-zA-Z0-9_-]+/;
			const match = currentUrl.pathname.match(pattern);
			if (match) {
				this.devPathFragment = '/' + match[0];
			} else {
				this.devPathFragment = '';
			}
		}
		return this.devPathFragment;
	}

	/**
	 * Add the currently set dev fragment to a string path
	 *
	 * @param path
	 * @returns {string|*}
	 */
	addDevFragment(path) {
		const devPathFragment = this.getDevPathFragment();
		if (!devPathFragment) return path;

		const pattern = /git-[a-zA-Z0-9_-]+/;
		if (!path.match(pattern)) {
			path = (devPathFragment.startsWith('/') ? '' : '/') + devPathFragment + (devPathFragment.endsWith('/') ? '' : '/') + path;
			return path.replace(/\/{2,}/, '/');
		}

		return path.replace(/\/{2,}/, '/');
	}

	/**
	 * Remove the dev fragment from a string path
	 *
	 * @param path
	 * @returns {*}
	 */
	removeDevPathFragment(path) {
		const pattern = /git-[a-zA-Z0-9_-]+/;
		if (path.match(pattern)) {
			path = path
				.replace(pattern, '')
				.replace(/\/{2,}/, '/');
			return path;
		}

		return path;
	}

	/**
	 * Get the full Href for the currently set URL
	 *
	 * @returns {string|*}
	 */
	getFullUrl() {
		return this.currentUrl.href;
	}

	/**
	 * Do a lookup on a path to see if it needs adjusting
	 *
	 * @param path
	 * @returns {string|*}
	 */
	pathConversionLookup(path) {
		path = decodeURIComponent(path);
		const [pathFragment, paramFragment] = path.split('?');

		// Build param object
		const params = new URLSearchParams(paramFragment || '');

		// Get the possible routes based on the path
		let possibleRoutes = this.routes.filter(route => route.hash.replace('#!', '') === pathFragment);

		// Narrow down the list if there can't be unique id's present in params
		if (!paramFragment) {
			possibleRoutes = possibleRoutes.filter(route => !route.id);
		}

		// Remove any routes that are missing their unique ids in the param string
		possibleRoutes = possibleRoutes.filter(route => {
			return !(route.id && !params.has(route.id));
		});

		if (!possibleRoutes) {
			return path;
		}

		const route = possibleRoutes[0];

		// If there isn't a route, return the path that was passed in.
		if (!route) return path;

		// Start building the new path
		const basePath = route.name;

		// If there aren't any query params, send back just the base path
		if (!paramFragment) return basePath;

		// If the route doesn't have a unique id, return the path with the params
		if (!route.id) return `${basePath}?${paramFragment}`;

		// Check if unique id is in params		
		// If the query params don't have a unique id, send back a url anyway
		if (!params.has(route.id)) return `${basePath}?${paramFragment}`;

		// Query Params have the unique ID
		const uniqueIdValue = params.get(route.id);
		params.delete(route.id);

		let remainingParams = params.toString();
		remainingParams = (remainingParams ? `?${params.toString()}` : '');

		return `${basePath}/${uniqueIdValue}${remainingParams}`;
	}

	/**
	 * Reloads the current page
	 */
	reloadPage() {
		sa.currentPage = null;
		console.log("**** reloading page")
		this.routeTo(window.location.href, true, true);
	}

	/**
	 * Figure out which type of explorer page to build a link for
	 *
	 * @param params
	 * @returns {{ path: null|string, params: URLSearchParams }}
	 */
	explorerParamConverter(params) {
		// Convert the query params to query param object
		const queryParams = new URLSearchParams(params);

		const fullUrl = queryParams.toString().startsWith('?') ? this.buildFullUrl(params) : this.buildFullUrl(`?${params}`);
		const pathname = this.removeDevPathFragment(fullUrl.pathname);
		const route = sa.router.routes.find(route => pathname.match(route.pattern) && route.id);

		if (route) {
			queryParams.delete(route.id);
			return {
				path: pathname.startsWith('/') ? pathname.replace('/', '') : pathname,
				params: queryParams,
			};
		}

		// Get a possible list of routes to match against
		const explorerRoutes = sa.router.routes.filter(route => route.hash === '#!explorer' && route.id);

		let path;

		// Loop through each route and see if the params have a matching unique ID in their query params
		for (let i = 0; i < explorerRoutes.length; i++) {
			const uniqueId = explorerRoutes[i].id;
			const routeName = explorerRoutes[i].name;
			const appendParams = explorerRoutes[i].appendParams;
			if (queryParams.has(uniqueId)) {
				const val = queryParams.get(uniqueId);

				// If we are just appending the query params (ex. tracks?sim=123456) instead of building a new url (ex. track/12345)
				if (appendParams) {
					path = `${routeName}`;
					break;
				} else {
					path = `${routeName}/${val}`;
					queryParams.delete(uniqueId);
					break;
				}
			}
		}

		return {
			path,
			params: queryParams,
		};
	}

	/**
	 * Check if two urls have the same host/origin
	 *
	 * @param url1
	 * @param url2
	 * @returns {boolean}
	 */
	urlsHaveSameHost(url1, url2) {
		const firstUrl = this.buildFullUrl(url1);
		const secondUrl = this.buildFullUrl(url2);

		return firstUrl.host === secondUrl.host;
	}

	/**
	 * Split a hashbang to extract query parameters, if available
	 * `https://example.sourceaudio.com/#!explorer?b=1234` => `https://example.sourceaudio.com?b=1234#!explorer`
	 * This is for dealing with the URL object values, not for the actual URL format
	 *
	 * @param {URL} url
	 * @returns {URL|*}
	 */
	splitParamsFromHash(url) {
		if (url.hash && url.hash.includes('#!')) {
			const [hashFragment, paramFragment] = url.hash.split('?');
			url.hash = hashFragment;
			url.search = !paramFragment ? url.search : paramFragment;
			return url;
		}

		return url;
	}

	/**
	 * Extract query parameters from a URL path
	 *
	 *  Since many pages need specific parameters passed to them to run/load the correct data
	 *	this will pull that parameter from a clean url structure if it can.
	 *	For example, to load a specific album, we need to pass the parameter `b=12345`, but the
	 *	clean path will be `/album/12345`. This method extracts the query key: `b` and value: `12345` and
	 *	builds the query param `b=12345` we need to pass along.
	 *
	 * @param route
	 * @param url
	 * @returns {string|*}
	 */
	parseParamsFromRoute(route, url) {
		let searchQuery;

		// Building a temporary URL, since URLs are passed by reference
		// and changing them here changes the original, which we don't want.
		const tempUrl = new URL(url);

		// Remove the dev fragment, so we can check the page against the route pattern
		const pathname = this.removeDevPathFragment(url.pathname);
		const routePathMatch = pathname.match(route.pattern);

		// Checking if the route has a unique id and that the URL has it set as a query param
		const urlHasUniqueId = route.id && url.searchParams.has(route.id);
		if (urlHasUniqueId) {
			const uniqueIdValue = url.searchParams.get(route.id);
			tempUrl.searchParams.append(route.id, uniqueIdValue);
			searchQuery = tempUrl.search;
		} else if (route.id && routePathMatch) {
			const uniqueIdValue = routePathMatch[1];
			tempUrl.searchParams.append(route.id, uniqueIdValue);
			searchQuery = tempUrl.search;
		}

		// If we found a match and built a new search query, return it
		if (searchQuery) {
			return searchQuery.replace(/^\?/, '');
		}

		// Return the original URLs search (minus the leading '?')
		return url.search.replace(/^\?/, '');
	}

	isReactRoute(url) {
		const reactRoutes = [
			'/admin?p=inbox',
			'/dashboard?p=inbox'
		];
		
		// Allow links to work when the links in question are for the inbox page, but the site type doesn't match
		if (
			window.location.href.includes('/admin?p=inbox') && config.siteType !== 'seller'
			|| window.location.href.includes('/dashboard?p=inbox') && config.siteType === 'seller'
		) {
			return false;
		}

		const hasReactRoute = reactRoutes.some(reactRoute => url.href.includes(reactRoute));
		const currentlyInReactRoute = reactRoutes.some(reactRoute => window.location.href.includes(reactRoute));

		// The one exception is that if we're inside the react route, but want to go to a root route, we should allow that
		// For instance, if we are in the inbox like `/admin?p=inbox#/briefs/123/responses`, we should be able to go to
		// `/admin?p=inbox` without issue.
		const routeEndsInbox = ['/admin?p=inbox', '/dashboard?p=inbox'];
		const routeEndsWithInbox = routeEndsInbox.some(reactRoute => url.href.endsWith(reactRoute));
		if (currentlyInReactRoute && routeEndsWithInbox) {
			this.routeTo(url);
		}
		
		return hasReactRoute && currentlyInReactRoute;
	}

	urlIsBlacklisted(url, newWindowOrTab) {
		const blackListedHashes = ['#0'];
		const blackListedPaths = [];
		const blacklistedUrls = [];

		const hasBlockedHash = blackListedHashes.includes(url.hash);
		const hasBlockedPath = blackListedPaths.includes(url.pathname);
		const hasBlockedUrl = blacklistedUrls.includes(url.href);

		// If the URL was navigated to via a new tab or window, it won't be caught by
		// the click handler, so we can check for that here
		if (newWindowOrTab) {
			if (hasBlockedHash || hasBlockedPath || hasBlockedUrl) {
				this.goTo404Page(url);
				return true;
			}
		} else {
			return (hasBlockedUrl || hasBlockedHash || hasBlockedPath);
		}

		return false;
	}

	checkRoutePermissions(url) {
		// Check if the site is allowed to go to Sonic Search pages/results
		const isSonicSearch = url.pathname.match(/\/sonicsearch/);
		if (isSonicSearch && config.grayLabel) {
			sa.alert({
				text: 'Your workspace is a free grey label, upload and music management only workspace. To use these features, please contact us (sales@sourceaudio.com) and upgrade your workspace.',
				onClose: () => {
					this.routeTo('/');
					return false;
				}
			});

			return false;
		}

		return true;
	}

	/**
	 * Convert hash URLs to "clean" URls
	 * Example: `https://example.sourceaudio.com/#!explorer?b=1234` -> `https://example.sourceaudio.com/album/1234`
	 *
	 * @param url
	 * @param {boolean} isAlias
	 * @returns {URL|boolean|*}
	 */
	convertPathToGoodLinks(url, isAlias = false) {
		if (!url) return false;

		// Check if it's a Hash URL
		const isHashUrl = url.hash && url.hash.includes('#!');

		// Assign it to a temporary variable, as to not mess up the original URL
		const tempUrl = new URL(url.href);

		if (isHashUrl) {
			// Check if there is a route that matches the hash and the unique identifier ('b', 'ct', etc)
			const routeWithId = this.routes.find(route => route.hash === url.hash && url.searchParams.has(route.id));

			// This would, for example, convert `/#!details?id=1234` to `/track/1234`
			if (routeWithId) {
				const uniqueIdValue = url.searchParams.get(routeWithId.id);
				const newPath = `${routeWithId.name}/${uniqueIdValue}`;
				tempUrl.hash = '';
				tempUrl.searchParams.delete(routeWithId.id);
				tempUrl.pathname = newPath;

				return tempUrl;
			}

			// There wasn't a route that matches with a unique id, so see if there is a route that matches just the hash
			const route = this.routes.find(checkedRoute => checkedRoute.hash === url.hash && !checkedRoute.id);

			// This is used in the rare occasion that it's an alias to an alias and we need to display the original hash as a path
			if (!route && isAlias) {
				tempUrl.hash = '';
				tempUrl.pathname = url.hash.replace('#!', '').replace('_', '-');
				return tempUrl;
			}

			if (!route) return false;

			// This should cover routes with no specific params to worry about (#!subscriptions -> /subscriptions, etc)
			const newPath = `${route.name}`;
			tempUrl.hash = '';
			tempUrl.pathname = newPath;
			return tempUrl;
		}

		return url;
	}

	checkHardCodedRedirects(url) {
		const hardCodedPathRedirects = {
			support: {
				redirectTo: 'feedback',
				isNavTab: true,
				siteType: 'buyer'
			}
		};
		
		// Remove dev fragment
		let pathname = this.removeDevPathFragment(url.pathname);
		
		// Split the url to get the path
		pathname = pathname.split('/').at(-1);
		
		// Make sure a pathname exists
		if (!pathname) {
			return url;
		}

		// Check that a redirect exists
		if (!hardCodedPathRedirects[pathname]) {
			return url;
		}
		
		// Check that the redirect is for the current site type
		if (hardCodedPathRedirects[pathname].siteType && hardCodedPathRedirects[pathname].siteType !== config.siteType) {
			return url;
		}
		
		// Check if the redirect is for a nav tab
		if (hardCodedPathRedirects[pathname].isNavTab) {
			const isNavTab = config.tabs.find(tab => tab.path === pathname);
			if (!isNavTab) {
				return url;
			}
		}
		
		// Check if this is an alias for the current site. We aren't overriding aliases
		if (config.seo.settings && config.seo.settings.alias) {
			const alias = config.seo.settings.alias.find(currentAlias => {
				const { pattern } = currentAlias;
				return pathname.includes(pattern.replace(/^\//, '').replace(/\/$/, ''));
			});

			if (alias) {
				return url;
			}
		}
		
		// Update pathname with the new path
		pathname = hardCodedPathRedirects[pathname].redirectTo;
		
		// Add back the dev fragment
		url.pathname = this.addDevFragment(pathname);
		
		return url;
	}

	homePathLookup(url) {
		const tempUrl = new URL(url);
		const pathname = this.removeDevPathFragment(tempUrl.pathname);

		const isRootUrlWithHash = (pathname === '/' || pathname === '') && (tempUrl.hash && tempUrl.hash.includes('#!'));
		const isNotRootUrl = (pathname !== '/' && pathname !== '');

		if (isRootUrlWithHash || isNotRootUrl) return tempUrl;

		const convertedPathname = this.pathConversionLookup(config.home);
		if (pathname !== convertedPathname) {
			const [path, params] = convertedPathname.split('?');
			tempUrl.pathname = path;
			tempUrl.search = !params ? tempUrl.search : params;
			return tempUrl;
		}

		return url;
	}

	/**
	 * Finds an alias for the passed in URL
	 *
	 * @param url
	 * @returns {{aliasUrl: undefined, pathUrl}|{aliasUrl: URL, pathUrl: URL}}
	 */
	findAlias(url) {
		const tempUrl = new URL(url);
		// Remove dev fragment
		tempUrl.pathname = this.removeDevPathFragment(tempUrl.pathname);

		// Does the user have any aliases
		const hasAliases = config.seo.settings && config.seo.settings.alias && config.seo.settings.alias.length;
		if (!hasAliases) {
			return {
				aliasUrl: undefined,
				pathUrl: url,
			};
		}

		// Look for an alias in the alias array
		const alias = config.seo.settings.alias.find(currentAlias => {
			const pathname = tempUrl.pathname.replace(/^\//, '');
			const { pattern } = currentAlias;
			// Check if the pattern is a regex
			if (pattern.startsWith('/') && pattern.endsWith('/')) {
				const regex = new RegExp(pattern.substr(1, pattern.length - 2), 'i');
				const match = pathname.match(regex);

				return !!match;
			}

			// If it isn't a regex, does the url have an exact match with the alias pattern
			return pathname.includes(pattern.replace(/^\//, '').replace(/\/$/, ''))
				|| tempUrl.hash === pattern
				|| '#!' + pathname === pattern;
		});

		// If no alias was found, return the original url and an undefined alias
		if (!alias) {
			return {
				aliasUrl: undefined,
				pathUrl: url,
			};
		}
		
		let aliasPattern = null;
		let aliasResult = null;

		// Check if the alias includes query parameters
		if (alias.result.includes('?')) {
			const aliasUrl = new URLSearchParams(alias.result.split('?')[1]);
			const pathParams = tempUrl.searchParams;

			// Merge in any new query params that weren't there - specifically, pg/show params to keep pagination working
			pathParams.forEach((value, key) => {
				if (!aliasUrl.has(key) || aliasUrl.get(key) !== value) {
					aliasUrl.set(key, value);
				}
			});

			// Update the result with the new query params
			aliasResult = `${alias.result.split('?')[0]}?${aliasUrl.toString()}`;

			// When going to the alias, we need to make sure the pagination is correct
			const resultCountChanged = aliasResult.includes('pg=') && aliasResult !== url;
			const pageIsNotZero = pathParams.has('pg') && Number(pathParams.get('pg')) > 0;
			if (pageIsNotZero || resultCountChanged) {
				aliasPattern = aliasResult;
			} else {
				aliasPattern = alias.pattern;
				aliasUrl.delete('pg');
				aliasResult = `${alias.result.split('?')[0]}?${aliasUrl.toString()}`;
			}
		} else {
			aliasPattern = alias.pattern;
			aliasResult = alias.result;
		}
		
		// Return the alias and the original urls as full URL objects
		return {
			aliasUrl: this.buildFullUrl(aliasPattern),
			pathUrl: this.buildFullUrl(aliasResult),
		};
	}

	// ============= HELPER METHODS ============= //

	/**
	 * Build a full URL object from a link, link fragment, or hash
	 *
	 * @param path
	 * @returns {URL}
	 */
	buildFullUrl(path) {
		// Check if it's a fully qualified URL and return the new URL object
		// If it wasn't able to create the new URL, that means the path is a fragment
		try {
			return new URL(path);
		} catch (e) {
			// Create a new URL as a starting point to build upon 
			const currentUrl = new URL(window.location.href);

			// Check if the passed in fragment is just a query param string
			const isParamString = path.match(/^\?/);
			if (isParamString) {
				const [_, paramString] = path.split('?');
				currentUrl.search = paramString;
				return currentUrl;
			}

			// Remove params if new path fragment doesn't have them
			// For example, our `currentURL` is our current page, which may have params set already
			if (!isParamString && currentUrl.search) {
				currentUrl.search = '';
			}

			// Check if the path is a hashbang path and split it into the hash and query parameter pieces
			if (path.startsWith('#!')) {
				const [hash, params] = path.split('?');
				currentUrl.hash = hash;
				currentUrl.search = !params ? currentUrl.search : params;
				return currentUrl;
			}

			// Check if it's a path with or without params
			const [pathFragment, paramFragment] = path.split('?');
			currentUrl.pathname = !pathFragment ? currentUrl.pathname : pathFragment;
			currentUrl.search = !paramFragment ? currentUrl.search : paramFragment;

			return currentUrl;
		}
	}

	/**
	 * Convert a url/path pattern into a corresponding regex pattern
	 *
	 * Example: /track/:int/:any? would become `^\/?track\/(\d+)\/?([\w\-\_\.?=&\[\]]+)?\/?$` - a regex matching a track with an int ID, followed by anything (or nothing)
	 *
	 * @param routePattern
	 * @returns {RegExp|*}
	 */
	convertRouteToRegex(routePattern) {
		// If the routePattern is already a regex, return it
		if (routePattern instanceof RegExp) {
			return routePattern;
		}

		// Remove leading and trailing forward slash
		const uri = routePattern.toString().replace(/\/$/, '').replace(/^\//, '');

		let rule = uri
			.replace(/([\\/\-_.])/g, '\\$1')
			.replace(/\{[a-zA-Z]+}/g, '(:any)')
			.replace(/:any\?/g, '?([\\w\\-\\_\\.?=&\\[\\]]+)?')
			.replace(/:any/g, '([\\w\\-\\_\\.?=&\\[\\]]+)')
			.replace(/:word\?/g, '?([a-zA-Z]+)?')
			.replace(/:word/g, '([a-zA-Z]+)')
			.replace(/:int\?/g, '?(\\d+)?')
			.replace(/:int/g, '(\\d+)')
			.replace(/\?\\\//g, '?\\/?');

		if (routePattern === '/') {
			rule = '\\/';
		}

		return new RegExp('^/?' + rule + '/?$', 'i');
	}

	/**
	 * Get the currently set Route Object
	 *
	 * @param {boolean} justName If this is set, just return the route name
	 * @returns {null|*}
	 */
	getCurrentRoute(justName = false) {
		if (justName) return this.currentRoute.name;

		return this.currentRoute;
	}

	/**
	 * Check if the passed in route name is the currently active route
	 *
	 * @param {string} routeName
	 * @returns {boolean}
	 */
	isCurrentRoute(routeName) {
		if (!this.currentRoute) return false;

		return routeName === this.currentRoute.name;
	}

	/**
	 * Check if two URLs are the same
	 *
	 * @param url1
	 * @param url2
	 * @returns {boolean}
	 */
	isSameUrl(url1, url2) {
		// Missing one of the urls
		if (!url1 || !url2) return false;

		// Convert both urls into full URL objects to aid with comparison
		const tempUrl1 = this.buildFullUrl(url1);
		const tempUrl2 = this.buildFullUrl(url2);

		// The urls are exactly the same
		// This would be enough in many cases, but sometimes the parameters aren't in the same order, so it 
		// returns a false positive.
		if (tempUrl1.href === tempUrl2.href) return true;

		// Maybe this is a React component with hash based routing.
		if (tempUrl1.hash.length !== tempUrl2.hash.length) return false;
		
		// If the path names aren't the same, the urls aren't the same
		const pathNamesAreSame = tempUrl1.pathname === tempUrl2.pathname;
		if (!pathNamesAreSame) return false;
		
		// Check if the query parameters in both URLs are the same (if they exist)
		if (tempUrl1.search && tempUrl2.search) {
			const url1Params = tempUrl1.search.replace(/^\?/, '').split('&');
			const url2Params = tempUrl2.search.replace(/^\?/, '').split('&');

			// They don't have the same amount of query params
			if (url1Params.length !== url2Params.length) return false;

			// Hack to compare the two query string arrays
			// Sort, then compare strings
			url1Params.sort();
			url2Params.sort();
			return url1Params.toString() === url2Params.toString();
		}

		return false;
	}

	buildLocalUrl(path, asString = false) {
		if (path.startsWith('http')) return path;

		let url = this.buildFullUrl(path);
		url.pathname = this.addDevFragment(url.pathname);

		if (asString) {
			return url.href;
		}

		return url;
	}

	// DEALING WITH QUERY PARAMS //

	/**
	 * Extract query param string from path string
	 *
	 * @param {string} path
	 * @returns {string|*}
	 */
	pullParamsFromString(path) {
		const [_, params] = path.split('?');
		if (!params) return '';

		return params.replace('+', '%20');
	}

	// HISTORY
	/**
	 * Get the currently set route history
	 *
	 * @returns {[]} Route History or empty array
	 */
	getHistory() {
		return this.routeHistory || [];
	}

	/**
	 * Go back In route history
	 *
	 * @param fallback
	 */
	goBack(fallback) {
		if (this.routeHistory.length > 1 && this.routeHistory[1].route !== '') {
			this.routeTo(this.routeHistory[1].path);
		} else {
			this.routeTo(fallback);
		}
	}

	addQueryParamToURL(key, value) {
		const url = new URL(window.location.href);

		if (url.searchParams.has(key) && url.searchParams.get(key) === value) return;

		url.searchParams.append(key, value);

		window.history.replaceState(null, null, url);
		this.currentUrl = url;
	}

	// OLD METHODS DIRECT FROM HASH MANAGER
	cleanParams(params) {
		if (!params) return '';
		return (params ? '?' + params.replace(/^&/, '') : '');
	}

	paramsToVars(params) {
		let vars = createSafeObject(); // create an object with no prototype to prevent potential prototype pollution
		if (params == null || params.length === 0) return vars;
		params = params.split('&');
		for (let i = 0; i < params.length; i++) {
			let p = params[i].split('=');
			if (p[0]) {
				const key = decodeURIComponent(p[0]);
				const val = decodeURIComponent(p[1]).replace(/\+/g, ' ');
				const subs = key.match(/\[(.+)\]/);

				if (subs) {
					// it's something more complex like 'tempo[2][val]=123' and we need to turn it into vars = { tempo : { 2 : { val : 123 } } };
					// bad values like 'tempo[2]asdf[3] or even stuff like tempo[asdf][]=2 are going to produce bad results
					const keys = [key.substring(0, key.indexOf('['))].concat(subs[1].split('][')); // keys will now contain a hierarchy of the keys, [tempo, 2, val]
					let tempVars = vars; // the vars we're assigning into. points to the object in which the current key needs to go
					for (let j = 0, jLen = keys.length; j < jLen; j++) {
						// we go through each of the keys. if it's the last one, we just need to assign the value into the tempVars
						const singleKey = keys[j];
						if (j === jLen - 1) {
							tempVars[singleKey] = val;
						} else {
							// if it's not the last key, we need to go one object deeper for the next key
							if (tempVars[singleKey] == null) tempVars[singleKey] = createSafeObject();
							tempVars = tempVars[singleKey];
						}
					}
				} else if (vars[key] != null) { // if we've already found one element of name key
					if (vars[key].isArray) {
						vars[key][vars[key].length] = val;
					} else { // the value in vars isn't an array already so let's make it one
						vars[key] = [vars[key], val];
					}
				} else {
					vars[key] = val;
				}
			}
		}
		return vars;
	}

	queryParamsToString(vars) {
		let queryParamString = '';

		for (let name in vars) {
			if (!vars.hasOwnProperty(name)) continue;
			if (vars[name] !== '' && vars[name] !== undefined && vars[name] !== null && typeof vars[name] !== 'function') {
				if (vars[name].isArray) {
					for (var i = 0; i < vars[name].length; i++) {
						queryParamString += '&' + encodeURIComponent(name) + '=' + encodeURIComponent(vars[name][i]);
					}
				} else if (typeof(vars[name]) == 'object') {
					var recurse = function(key, vars) {
						var rets = [];
						for (var name in vars) {
							if (!vars.hasOwnProperty(name)) continue;
							if (typeof(vars[name]) == 'object') {
								rets = rets.concat(recurse(name, vars[name]));
							} else {
								rets.push('[' + encodeURIComponent(name) + ']=' + encodeURIComponent(vars[name]));
							}
						}
						for (var i = 0, len = rets.length; i < len; i++) rets[i] = '[' + encodeURIComponent(key) + ']' + rets[i];
						return rets;
					};
					queryParamString += ('&' + recurse(name, vars[name]).join('&')).replace(new RegExp('&\\[' + name + '\\]', 'g'), '&' + name).replace(/\[/g, encodeURIComponent('[')).replace(/\]/g, encodeURIComponent(']'));
				} else {
					queryParamString += '&' + encodeURIComponent(name) + '=' + encodeURIComponent(vars[name]);
				}
			}
		}
		return queryParamString.length ? '?' + queryParamString.substring(1) : '';
	}

	varsToParams(vars) {
		const hash = sa.router.queryParamsToString(vars);
		return hash.length ? hash.substring(1) : '';
	}

	// HELPERS FOR CHECKING ROUTES
	isHomePage() {
		return this.currentRoute.name === 'home';
	}
}

sa.router = new Router();

const siteBaseUrl = () => sa.router.getSiteBaseUrl();
/**
 * Wrapper for localStorage to prevent errors in clients that block it
 * @type {{removeItem: Window.safeLocalStorage.removeItem, getItem: Window.safeLocalStorage.getItem, setItem: Window.safeLocalStorage.setItem}}
 */
window['safeLocalStorage'] = (function() {

	let storage = {};
	
	return {
		setItem : function(key, value) {
			try {
				if (window['localStorage'] && window['localStorage']['setItem']) {
					localStorage.setItem(key, value);
				} else {
					storage[key] = value || '';
				}
			} catch (e) {
				console.error('Unable to set in localStorage', e);
			}
		},
		getItem : function(key) {
			try {
				if (window['localStorage'] && window['localStorage']['getItem']) {
					return localStorage.getItem(key);
				}
				if (storage[key] !== undefined) {
					return storage[key];
				}
				return null;
			} catch (e) {
				console.error('Unable to get from localStorage', e);
				return null;
			}
		},
		removeItem : function(key) {
			try {
				if (window['localStorage'] && window['localStorage']['removeItem']) {
					localStorage.removeItem(key);
				} else if (storage[key] !== undefined) {
					delete storage[key];
				}
			} catch (e) {
				console.error('Unable to remove from localStorage', e);
			}
		}
	}
	
})();/**
 * Array_functions.js has functions that deal with arrays
 */

/**
 * Implodes an array into a string, just like PHP's implode
 * @param {string} glue the string to place between elements of the array
 * @param {array} array the array to implode
 * @return {string} the imploded array
 */
function implode(glue, array) {
	var str = '';
	for (var i = 0; i < array.length; i++) {
		str += array[i];
		if (i + 1 < array.length) str += glue;
	}
	return str;
}

if (!Array.prototype.at) {
	/**
	 * Returns element "at" an index, including a negative index
	 * 
	 * const items = ['a', 'b', 'c', 1, 2, 3];
	 * items.at(0) === 'a' // true
	 * items.at(-1) === 3 // true
	 * 
	 * @param index
	 * @returns {Array|undefined|*}
	 */
	Array.prototype.at = function(index) {
		if (this.length === 0) return this;

		if (this.length < Math.abs(index)) {
			return undefined;
		}

		if (index < 0) {
			return this[this.length + index];
		}

		return this[index];
	}
}


/**
 * Removes all duplicates from an array
 * @return {Array} the updated array object for chaining
 */
Array.prototype.removeDuplicates = function() {
	for (var i = 0; i < this.length; i++) {
		while ((ind = this.lastIndexOf(this[i])) != i) {
			this.splice(ind, 1);
		}
	}
	return this;
};

/**
 * Finds and returns the first index of an element in the array
 * http://www.htmlgoodies.com/primers/jsp/print.php/3624446
 *	Firefox has its own internal version of this function but it doesn't cast between types, which I need it to do for consistency's sake
 *	In Firefox, ['1', '2'].indexOf(2) is -1 but in this function (which is used by chrome, ie, etc.) it's 1
 *	Since we overwrite the default function, it's now 1 in Firefox as well.
 *	That being, said, testing shows that doing this comparison with casting is slower than without so you should avoid needing to cast if you can
 * @param {object} obj the object to search for
 * @return {int} the index of obj in the array
 */
Array.prototype.indexOf = function(obj) {
	for (var i = 0; i < this.length; i++) {
		if (this[i] == obj) {
			return i;
		}
	}
	return -1;
};

/**
 * Finds and returns the last index of an element in the array
 * http://www.htmlgoodies.com/primers/jsp/print.php/3624446
 * @param {object} obj the object to search for
 * @return {int} the index of obj in the array
 */
Array.prototype.lastIndexOf = function(obj) {
	for (var i = this.length - 1; i >= 0; i--) {
		if (this[i] == obj) {
			return i;
		}
	}
	return -1;
};

/**
 * This enables easy detection of arrays by a single var.isArray
 */
Array.prototype.isArray = true;

// https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/filter
if (!Array.prototype.filter) {
	Array.prototype.filter = function(fun /*, thisp */) {
		"use strict";
		if (this == null)
			throw new TypeError();
 
		var t = Object(this);
		var len = t.length >>> 0;
		if (typeof fun != "function")
			throw new TypeError();
 
		var res = [];
		var thisp = arguments[1];
		for (var i = 0; i < len; i++) {
			if (i in t) {
				var val = t[i]; // in case fun mutates this
				if (fun.call(thisp, val, i, t))
					res.push(val);
			}
		}
 
		return res;
	};
}

// https://stackoverflow.com/questions/1394020/jquery-each-backwards
jQuery.fn.reverse = Array.prototype.reverse;

if (!Array.prototype.each) {
	Array.prototype.each = function(callback) {
		for (var i = 0, len = this.length; i < len; i++) {
			callback.call(this[i], i, this[i]);
		}
	};
}

if (!NodeList.prototype.each) {
	NodeList.prototype.each = function(callback) {
		for (var i = 0, len = this.length; i < len; i++) {
			callback.call(this[i], i, this[i]);
		}
	};
}

if (!Array.prototype.trim) {
	Array.prototype.trim = function() {
		var newArray = [];
		this.each(function(i, val) {
			newArray[i] = val.trim();
		});
		return newArray;
	};
}

/**
 * Wraps the elements of a string array in an html tag and returns it
 * e.g., if you have an array of messages to display, like arr=["Fix username", "Fix email"] and want to add them to a <ul>, 
 * you could call arr.wrapTags('li') and get back '<li>Fix username</li><li>Fix email</li>'
 * @param {string=} tag - the tag to wrap with. defaults to 'li' 
 * @param {boolean=} htmlEncodeValues - should the values be html encoded to prevent code injection? defaults to true
 * @returns {string}
 */
Array.prototype.wrapTags = function(tag, htmlEncodeValues) {
	if (tag === undefined) tag = 'li';
	if (htmlEncodeValues === undefined) htmlEncodeValues = true;
	let list = this;
	if (htmlEncodeValues) {
		list = list.map(htmlEncode);
	}
	return '<' + tag + '>' + list.join('</' + tag + '><' + tag + '>') + '</' + tag + '>';
};
/**
 * StringFunctions.js has string manipulation and form validation functions
 */

/**
 * Is the string a valid email address?
 * Copied from http://developer.apple.com/internet/webcontent/validation.html
 * @return {boolean} well, is it?
 */
String.prototype.isEmail = function() {
	var emailFilter = /^.+@.+(\..+)+$/;
	if (!(emailFilter.test(this))) {
		return false;
	}
	var illegalChars= /[\(\)\<\>\,\;\:\\\/\"\[\] ]/;
	return !this.match(illegalChars);
};

String.prototype.isValidUrl = function () {
	let url;
	try {
		url = new URL(this);
	}
	catch(e){
		return false;
	}

	return url.protocol === "http:" || url.protocol === "https:";
}

/**
 * Decodes an html entity encoded string
 *	For example, turns 'Midtown Caf&#142;<br/>test&amp;' into 'Midtown Caf�test&'
 *	http://stackoverflow.com/questions/5796718/html-entity-decode
 * @returns {string} an altered string
 */
String.prototype.entityDecode = (function() {
	// this prevents any overhead from creating the object each time
	var element = document.createElement('div');

	function decodeHTMLEntities () {
		// strip script/html tags
		var str = this;
		str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
		str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
		element.innerHTML = str;
		str = element.textContent;
		element.textContent = '';

		return str;
	}

	return decodeHTMLEntities;
})();

function checkIfHTMLEncoded(str) {
	const possibleEncodedSequences = ['&amp;', '&lt;', '&gt;', '&quot;', '&apos;', '\x3C'];

	// Check if the string contains one of the sequences in the array
	for (let i = 0; i < possibleEncodedSequences.length; i++) {
		if (str.indexOf(possibleEncodedSequences[i]) !== -1) {
			return true;
		}
	}

	return false;
}

function sanitizeHtml(str) {
	return str.replace(/[^\w. ]/gi, (c) => {
		return `&#${c.charCodeAt(0)};`;
	});
}

/**
 * Replaces a char at a particular index since you can't str[1] = 'a'
 * http://stackoverflow.com/questions/1431094/how-do-i-replace-a-character-at-a-particular-index-in-javascript
 * @param {int} index the index of the char to replace
 * @param {string} character the new char to put there
 * @returns {string} the altered string
 */
String.prototype.replaceAt = function(index, character) {
	return this.substr(0, index) + character + this.substr(index + character.length);
};

/**
 * Returns a version of the string with the first letter capitalized
 * @returns {string}
 */
String.prototype.ucfirst = function() {
	return this.charAt(0).toUpperCase() + this.slice(1);
};

/**
 * Makes a copy of the string
 * @returns {string}
 */
String.prototype.clone = function() {
	return this + '';
};

/**
 * Is the string a non-negative integer?
 * @param {string} str the string to check
 * @return {boolean} well, is it?
 */
function isInt(str) {
	return !!str.match(/^[0-9]+$/);
}

/**
 * Adds html encoding to any necessary characters. i.e., & -> &amp;
 *	http://stackoverflow.com/questions/1219860/javascript-jquery-html-encoding
 * @param {string} value the string to encode
 * @returns {string} the encoded result
 */
function htmlEncode(value) {
	let a = document.createElement('a');
	a.appendChild(document.createTextNode(value));
	return a.innerHTML;
}

/**
 * Removes html encoding from any necessary characters. i.e., &amp; -> &
 *	http://stackoverflow.com/questions/1219860/javascript-jquery-html-encoding
 * @param {string|array|Object} value the string to decode
 * @returns {string|array|Object} the decoded result
 */
function htmlDecode(value) {
	if (typeof value === 'object') {
		for (let k in value) {
			if (value.hasOwnProperty(k)) {
				value[k] = htmlDecode(value[k]);
			}
		}
		return value;
	}
	let a = document.createElement('a');
	a.innerHTML = value;
	return a.textContent;
}

/**
 * Clean text saved by ckeditor so it's safe to display
 * @param html
 * @param {boolean=} decodeLtGt if true, will convert &gt; and &lt;
 * @returns {string}
 */
function cleanCkeditorOutput(html, decodeLtGt) {
	if (decodeLtGt) {
		html = html.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
	}
	// the second replace prevents onload events from firing when jquery creates the elements. it preserves the "on" so we don't change its case if it's legit
	let cleaned = $j('<div class="cleaned_container">' + html.replace(/&quot;/g, '"').replace(/([^a-z])(on)/ig, '$1saremovemeclean$2') + '</div>');
	// remove any CDATA elements. do this after making it a jQuery element bc it'll account for encoded lt/gt symbols
	cleaned.html(cleaned.html().replace(/<!\[CDATA\[.*?]]>/gi, ''));
	// remove any obvious script or link tags
	cleaned.find('script, link, meta, svg, base').remove();
	// remove any events
	cleaned.find('*').each(function() {
		// uses an iterator instead of `for (let attr of this.attributes)` because the latter doesn't adjust the pointer when you remove attributes inside the loop. it starts skipping
		for (let i = 0; i < this.attributes.length; i++) {
			let attr = this.attributes[i];
			if (attr.name.startsWith('saremovemeclean')) {
				this.removeAttribute(attr.name);
				i--;
			}
		}
	});
	// put ok on values back
	cleaned.html(cleaned.html().replace(/saremovemeclean(on)/gi, '$1'));
	// remove any srcdoc, javascript, or vbscript protocols. the &#x0A is a newline and &x0D is a carriage return
	cleaned.html(cleaned.html().replace(/&#x0A;/gi, '\n').replace(/&#x0D;/gi, '\r').replace(/s\s*r\s*c\s*d\s*o\s*c/gi, 'srcdoc-disabled').replace(/j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|v\s*b\s*s\s*c\s*r\s*i\s*p\s*t\s*:/gi, ''));
	// clean any base64 encoded strings
	let cleanHtml = cleaned.html();
	let matches = cleanHtml.match(/base64, *([a-z0-9=+/]+)/ig);
	if (matches) {
		for (let match of matches) {
			try {
				let decoded = atob(match.replace(/base64, */, ''));
				cleanHtml = cleanHtml.replace(match, 'base64,' + btoa(cleanCkeditorOutput(decoded)));
			} catch (exception) {
				cleanHtml = cleanHtml.replace(match, '');
			}
		}
	}
	// clean any iframe src's
	cleaned.html(cleanHtml);
	for (let iframe of cleaned.find('iframe')) {
		if (iframe.src) {
			iframe.src = cleanCkeditorOutput(iframe.src);
			let src = iframe.src.toLowerCase();
			if (src.indexOf('http:') !== 0 && src.indexOf('https:') !== 0) {
				iframe.sandbox = ''; // if they're not embedding a website, assume it's malicious and block javascript
			}
		}
	}
	// convert any password form elements that may trigger autofill
	cleaned.find('input[type=password]').prop('type', 'text');
	cleanHtml = cleaned.html();
	return cleanHtml;
}

/**
 * Gets a message to show what's changed between two param strings
 * @param {string} oldString the previous param string
 * @param {string} newString the new param string
 * @param {string} def the default string to show if changes cannot be determined or haven't been made
 * @return {string} the message
 */
function getLoadingMessage(oldString, newString, def) {
	if (oldString && newString) {
		// check pages
		var last = oldString.match(/show=([0-9]+)/);
		var now = newString.match(/show=([0-9]+)/);
		if (last && now && last[1] != now[1]) {
			if (Number(last[1]) > Number(now[1])) {
				return 'Showing fewer results...';
			} else {
				return 'Showing more results...';
			}
		}
		var oldGenreCount, newGenreCount, genreChange, oldCueCount, newCueCount, cueChange, oldTempoCount, newTempoCount, tempoChange, oldLength, newLength, lengthChange, m;
		// check filters, starting with genre
		oldGenreCount = (m = oldString.match(/genre(?:\[|%5B)(?:\]|%5D)=/g)) ? m.length : 0;
		newGenreCount = (m = newString.match(/genre(?:\[|%5B)(?:\]|%5D)=/g)) ? m.length : 0;
		genreChange = oldGenreCount != newGenreCount;
		// check cue types
		oldCueCount = (m = oldString.match(/cue=/)) ? m.length : 0;
		newCueCount = (m = newString.match(/cue=/)) ? m.length : 0;
		cueChange = oldCueCount != newCueCount;
		// check tempos
		oldTempoCount = (m = oldString.match(/tempo(?:\[|%5B)(?:\]|%5D)=/g)) ? m.length : 0;
		newTempoCount = (m = newString.match(/tempo(?:\[|%5B)(?:\]|%5D)=/g)) ? m.length : 0;
		tempoChange = oldTempoCount != newTempoCount;
		// check lengths
		oldLength = oldString.match(/length(?:\[|%5B)(?:min|max)(?:\]|%5D)=([0-9]+)/g);
		newLength = newString.match(/length(?:\[|%5B)(?:min|max)(?:\]|%5D)=([0-9]+)/g);
		// to whomever needs to find a bug in this if statement: i'm sorry
		// we first check if length is set in one and not the other
		// if that fails, see if the values are the same. they might not be in the same order but still be equal
		lengthChange = (oldLength && !newLength) || (newLength && !oldLength) ||
			(oldLength && newLength && ((oldLength[0] != newLength[0] && oldLength[0] != newLength[1])
				|| (oldLength[1] != newLength[1] && oldLength[1] != newLength[0])));
		// if more than one filter changed, they adjusted all the filters by disabling or clearing
		if ((genreChange && cueChange) || (genreChange && tempoChange) || (genreChange && lengthChange)
			|| (cueChange && tempoChange) || (cueChange && lengthChange) || (tempoChange && lengthChange)) {
			return 'Removing filters...';
		}
		if (genreChange) {
			if (oldGenreCount < newGenreCount) {
				return 'Adding '+ gde('genre', { plural : false, 'case' : 'lower' }) +' filter...';
			} else {
				return 'Removing '+ gde('genre', { plural : false, 'case' : 'lower' }) +' filter...';
			}
		}
		if (cueChange) {
			if (oldCueCount < newCueCount) {
				return 'Adding '+ gde('cue type', { plural : false, 'case' : 'lower' }) +' filter...';
			} else {
				return 'Removing '+ gde('cue type', { plural : false, 'case' : 'lower' }) +' filter...';
			}
		}
		if (tempoChange) {
			if (oldTempoCount < newTempoCount) {
				return 'Adding '+ gde('tempo', { plural : false, 'case' : 'lower' }) +' filter...';
			} else {
				return 'Removing '+ gde('tempo', { plural : false, 'case' : 'lower' }) +' filter...';
			}
		}
		if (lengthChange) {
			return 'Adjusting length filter...';
		}
		// it wasn't a filter change. see if it's sorting
		now = newString.match(/no=([a-z ]+)/);
		if (now) {
			return 'Sorting...';
		}
		// nope. check page. we check page after sorting because a change to sorting also changes page
		last = oldString.match(/pg=([0-9]+)/);
		now = newString.match(/pg=([0-9]+)/);
		if (now && (!last || last[1] != now[1])) {
			return 'Loading page ' + (Number(now[1]) + 1);
		}
	}
	return def;
}

////////////////////
// Date Functions
////////////////////

/**
 * Formats a date ala PHP's date function
 * Only supports djYymnFgiaT
 * @param {string} format see http://us2.php.net/manual/en/function.date.php
 * @param {int=} unixTime the time you want the date to represent in seconds (NOT millisends) (optional - defaults to now)
 * @param {boolean=} utc should the timestamp be considered utc?
 * @return {string} the formatted date
 */
function formatDate(format, unixTime, utc) {
	var date = new Date();
	if (undefined !== unixTime)
		date.setTime(unixTime * 1000);
	if (utc) {
		date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
	}
	var s = '';
	for (var i = 0; i < format.length; i++) {
		var formatChar = format.substring(i, i + 1);
		switch (formatChar) {
			case 'd':
				if (date.getDate() < 10)
					s += '0';
				s += date.getDate();
				break;
			case 'j':
				s += date.getDate();
				break;
			case 'Y':
				s += date.getFullYear();
				break;
			case 'y':
				s += (date.getFullYear() + '').substring(2);
				break;
			case 'm':
				if (date.getMonth() + 1 < 10)
					s += '0';
				s+= (date.getMonth() + 1);
				break;
			case 'n':
				s+= (date.getMonth() + 1);
				break;
			case 'F':
				switch (date.getMonth()) {
					case 0:
						s += 'January';
						break;
					case 1:
						s += 'February';
						break;
					case 2:
						s += 'March';
						break;
					case 3:
						s += 'April';
						break;
					case 4:
						s += 'May';
						break;
					case 5:
						s += 'June';
						break;
					case 6:
						s += 'July';
						break;
					case 7:
						s += 'August';
						break;
					case 8:
						s += 'September';
						break;
					case 9:
						s += 'October';
						break;
					case 10:
						s += 'November';
						break;
					case 11:
						s += 'December';
						break;
				}
				break;
			case 'g':
			case 'h':
				let hours = date.getHours();
				let formattedHours = (hours <= 12 ? (hours == 0 ? 12 : hours) : hours - 12);
				s += (formatChar === 'h' && formattedHours < 10 ? '0' : '') + formattedHours;
				break;
			case 'i':
				var minutes = date.getMinutes();
				s += (minutes < 10 ? '0' : '') + minutes;
				break;
			case 's':
				let seconds = date.getSeconds();
				s += (seconds < 10 ? '0' : '') + seconds;
				break;
			case 'a':
				s += (date.getHours() < 12 ? 'am' : 'pm');
				break;
			case 'T':
				s += date.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
				break;
			default:
				s += formatChar;
				break;
		}
	}
	return s;
}

/**
 * Converts a human friendly string, like "02/18/1983", into an <input type="date" /> friendly string, like "1983-02-18"
 * @param {string} dateString
 * @returns {string}
 */
function formatDateForInput(dateString) {
	var parts = dateString.split('/');
	var partTypes = config.dateFormatString.split('/');
	var indexedParts = {};
	for (var i = 0; i < 3; i++) {
		indexedParts[partTypes[i]] = parts[i];
	}
	return indexedParts['Y'] + '-' + indexedParts['m'] + '-' + indexedParts['d'];
}

/**
 * Converts a number of seconds to a string like 13m 12s
 * @param {int} seconds the seconds to convert
 * @param {boolean} decimals should we include decimals? Changes output to something like 0.03s
 * @return {string} a string time period like 13m 12s
 */
function secondsToString(seconds, decimals) {
	if (decimals) {
		return (Math.round(seconds * 100) / 100) + 's';
	}
	var string = '';
	var minutes = Math.floor(seconds / 60);
	if (minutes > 60) {
		var hours = Math.floor(minutes / 60);
		minutes -= hours * 60;
		string += hours + 'h ';
	}
	if (minutes > 0) {
		string += minutes + 'm ';
	}
	string += (seconds % 60) + 's';
	return string;
}

/**
 * Converts a number of seconds to a string like 13:12 (meaning 13m 12s)
 * @param {int} totalSeconds the seconds to convert
 * @param {boolean=} noHours if set, the time will always be in minutes, max
 * @return {string} a string like 13:12
 */
function secondsToClockTime(totalSeconds, noHours) {
	var hours = noHours ? 0 : Math.floor(totalSeconds / (60 * 60));
	var minutes = Math.floor(totalSeconds / 60) - hours * 60;
	var seconds = Math.round(totalSeconds % 60);
	return (hours ? (hours < 10 ? '0' : '') + hours + ':' : '') + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}

/**
 * Reverses secondsToClockTime. e.g. clockTimeToSeconds('1:12:40') === 4360
 * @param {string} clockTime
 * @return {int|NaN}
 */
function clockTimeToSeconds(clockTime) {
	var times = clockTime.split(':');
	var seconds = 0;
	for (var i = times.length - 1; i >= 0; i--) {
		seconds += parseInt(times[i] * Math.pow(60, times.length - 1 - i));
	}
	return seconds;
}

/**
 * Groups the digits of a number by ,
 * @param {string/int} number the number to format
 */
function numberFormat(number) {
	var decimal, integer;
	number = ('' + number).replace(',', '');
	decimal = number.match(/\.[0-9]+$/);
	integer = number.match(/^[0-9]+/);
	if (!decimal && !integer) return number;
	if (!integer) return decimal;
	integer = integer + ',';
	while (integer.match(/[0-9]{4}/)) {
		integer = integer.replace(/([0-9]{3}),/, ',$1,');
	}
	return integer.substring(0, integer.length - 1) + (decimal ? decimal : '');
}

String.prototype.numberFormat = Number.prototype.numberFormat = function(decimalsToShow) {
	var number = this, decimal, integer;
	number = ('' + number).replace(',', '');
	decimal = number.match(/\.[0-9]+$/);
	integer = number.match(/^[0-9]+/);
	if (!decimal && !integer) return number;
	if (!integer) return decimal;
	integer = integer + ',';
	while (integer.match(/[0-9]{4}/)) {
		integer = integer.replace(/([0-9]{3}),/, ',$1,');
	}
	if (decimalsToShow !== undefined && decimalsToShow > 0) {
		if (!decimal) {
			decimal = ['.'];
		} else if (decimal[0].length > decimalsToShow + 1) {
			decimal[0] = decimal[0].substring(0, decimalsToShow + 1);
		}
		while (decimal[0].length < decimalsToShow + 1) {
			decimal[0] += '0';
		}
	}
	return integer.substring(0, integer.length - 1) + (decimal ? decimal[0] : '');
};

/**
 * Money formatting made easy - assumes the number is the number of cents
 * @param {int} requestedDecimalCount is the number of decimals to include. defaults to 2 and will include a preceding 0 for < 1
 * @param {boolean} excludeDescription if set to true, the description of the currency (i.e., 'USD') will NOT be appended to the end of the generated string
 * @param {boolean} excludeCurrency if set to true, the currency symbol (i.e., '$') will NOT be prepended to the generated string
 * @param {boolean=} accountingFormat if set to true and the number is negative, it'll appear in parenthesis instead of with a negative sign
 * @return {string} a version of the number that looks like money
 */
String.prototype.moneyFormat = Number.prototype.moneyFormat = function(requestedDecimalCount, excludeDescription, excludeCurrency, accountingFormat){
	var n = this / 100,
		decimalCount = isNaN(Math.abs(requestedDecimalCount)) ? 2 : Math.abs(requestedDecimalCount),
		decimalCharacter = '.',
		thousandSeparator = ',',
		currencyCharacter = '$',
		negLead = n < 0 ? (accountingFormat ? '(' : "-") : "",
		negTail = n < 0 && accountingFormat ? ')' : "",
		i = parseInt(n = Math.abs(+n || 0).toFixed(decimalCount)) + "",
		j = i.length > 3 ? i.length % 3 : 0;
	if (window['config'] === undefined || config.currency == 'USD') {
		decimalCharacter = '.';
		thousandSeparator = ',';
		currencyCharacter = '$';
	} else {
		alert('Config has unknown currency - ' + config.currency);
	}
	return negLead + (!excludeCurrency ? currencyCharacter : '') + (j ? i.substr(0, j) + thousandSeparator : "")
		+ i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandSeparator)
		+ (decimalCount ? decimalCharacter + Math.abs(n - i).toFixed(decimalCount).slice(2) : "")
		+ (excludeDescription ? '' : ' ' + config.currency)
		+ negTail;
};

/**
 * Money formatting based on the licenseConfig currency string to support localization of currencies
 * @param {string} the currency string in format "CODE - Name - SYMBOL - flags"
 * Flags: f = flip commas and decimels, h = hide trailing CODE, e = put SYMBOL after number
 * ex. 'EUR - Euro - € - f'
 */

String.prototype.currencyFormat = Number.prototype.currencyFormat = function(curr_string, returnParts) {
	var n = this;

	if (!curr_string) curr_string = (config.licensingConfig ? config.licensingConfig['currency'] : false) || 'USD - United States Dollar - $ - h';
	var c = curr_string.split('-').map(function(s) { return s.trim(); });
	var code = '<span class="code">' + c[0] + '</span>';
	var symbol = c[2] ? '<span class="symbol">' + c[2] + '</span>' : '';
	var flags = c[3] || '';
	var joiner = '.';

	n = parseFloat(n).toFixed(2);
	var parts = n.split('.');
	var ce = parseFloat(parts[1]);
	if (ce < 10) ce = '0' + ce;
	n = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
	if (flags.indexOf('f') != -1) {
		n = n.replace(/\,/g, '.');
		joiner = ',';
	}
	if (flags.indexOf('h') != -1) {
		code = '';
	}
	var e = flags.indexOf('e') != -1;

	if (returnParts) {
		return {
			pre: (e ? '' : c[2] || ''),
			dollars: n,
			joiner: joiner,
			cents: ce,
			post: (e ? c[2] || '' : ''),
			code: code
		};
	}

	return ((e ? '' : symbol || '') + n + joiner + ce + (e ? symbol || '' : '') + ' ' +  code).trim();

};

/**
 * Formats a size as a string with MB or KB
 * @param {int} size the size to start with
 * @param {int} decimals the number of decimals to show (default to 2)
 * @return {string} the size as a string
 */
function sizeFormat(size, decimals) {
	if (decimals === undefined) decimals = 2;
	var units = ['B', 'KB', 'MB', 'GB', 'TB'];
	for (var unit = 0, len = units.length; unit < len && size > 1024; unit++) {
		size /= 1024;
	}
	if (unit >= units.length) {
		unit = units.length - 1;
		size *= 1024;
	}
	var mult = Math.pow(10, decimals);
	size = Math.floor(size * mult) / mult;
	return size + ' ' + units[unit];
}
String.prototype.sizeFormat = Number.prototype.sizeFormat = function(decimals) {
	return sizeFormat(this, decimals);
};

/**
 * Places <em> tags around $search in $fullString while preserving $fullString's capitalization
 * For example, caselessBold('Big, Bad & Badder', 'ba') would return 'Big, <em>Ba</em>d & <em>Ba</em>dder'
 *
 * Here's the easy regex solution
 * fullString.replace(/(' + search + ')/gi, '<em>$1</em>');
 * but data shows that it's slower in chrome and firefox (faster in ie though! :P)
 *
 * @param {string} fullString the unformatted string
 * @param {string} search the string to place <em> tags around in fullString
 * @return {string} the newly formatted string
 */
function caselessBold(fullString, search) {
	search = search.toLowerCase();
	var b = fullString.toLowerCase();
	var splits = b.split(search);
	var index = 0;
	var newString = '';
	for (var i = 0; i < splits.length - 1; i++) {
		newString += fullString.substring(index, index + splits[i].length);
		index += splits[i].length;
		newString += '<em>' + fullString.substring(index, index + search.length) + '</em>';
		index += search.length;
	}
	newString += fullString.substring(index, fullString.length);
	return newString;
}

/**
 * Removes all white space characters from the beginning and end of a string
 * thanks to http://blog.stevenlevithan.com/archives/faster-trim-javascript
 * @return {string} string - whitespace (at the beginning and end)
 */
String.prototype.trim = function() {
	return this.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
};

/**
 * Resizes displayed text so it fits within a certain width
 * It's questionable whether this belongs in string_functions
 * @param {HTMLElement} text some wrapper around the text like a <span>
 * @param {int} width the max width the text can take up
 * @param {int} maxSize the max font size the text can be
 */
function resizeText(text, width, maxSize) {
	for (var size = maxSize; text.offsetWidth > width && size > 0; size--) {
		text.style.fontSize = size + 'px';
	}
}

/**
 * Rounds a number to a certain number of digits
 * ex: round(1.2345, 2) == 1.23
 * @param {number} num the number to round
 * @param {int} digits the number of digits to round to
 * @return {number} the rounded number
 */
function round(num, digits) {
	return (Math.round(num * Math.pow(10, digits)) / Math.pow(10, digits));
}

/**
 * Capitalizes the first letter of a string
 * ex: ucfirst('artist') == 'Artist'
 * @param {string} string the string to alter
 * @return {string} the altered string
 */
function ucfirst(string) {
	if (!string || !string.length) return '';
	return string.substring(0, 1).toUpperCase() + string.substring(1);
}

/**
 * Capitalizes the first letter of every word in a string
 * ex: ucwords('release date') == 'Release Date'
 * @param {string} string the string to alter
 * @return {string} the altered string
 */
function ucwords(string) {
	return ucwords_d(ucwords_d(string, '/'), ' ');
}

/**
 * Capitalizes the first letter of every word in a string, separating 'words' by a specific character
 *	A helper function for ucwords
 *	ex: ucwords('release date', ' ') == 'Release Date'
 * @param {string} string the string to alter
 * @param {string} delimiter the string to split on
 * @return {string} the altered string
 */
function ucwords_d(string, delimiter) {
	if (!string || !string.length) return '';
	var words = string.split(delimiter);
	for (var i = 0, len = words.length; i < len; i++) {
		words[i] = ucfirst(words[i]);
	}
	return words.join(delimiter);
}

/**
 * Adds the ordinal suffix to a number
 * https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
 * @param {int} i
 * @returns {string}
 */
function addOrdinal(i) {
	var j = i % 10,
		k = i % 100;
	if (j == 1 && k != 11) {
		return i + "st";
	}
	if (j == 2 && k != 12) {
		return i + "nd";
	}
	if (j == 3 && k != 13) {
		return i + "rd";
	}
	return i + "th";
}

// repeat function not supported in ie
if (!String.prototype.repeat) {
	String.prototype.repeat = function(count) {
		'use strict';
		if (this == null) {
			throw new TypeError('can\'t convert ' + this + ' to object');
		}
		var str = '' + this;
		count = +count;
		if (count != count) {
			count = 0;
		}
		if (count < 0) {
			throw new RangeError('repeat count must be non-negative');
		}
		if (count == Infinity) {
			throw new RangeError('repeat count must be less than infinity');
		}
		count = Math.floor(count);
		if (str.length == 0 || count == 0) {
			return '';
		}
		// Ensuring count is a 31-bit integer allows us to heavily optimize the
		// main part. But anyway, most current (August 2014) browsers can't handle
		// strings 1 << 28 chars or longer, so:
		if (str.length * count >= 1 << 28) {
			throw new RangeError('repeat count must not overflow maximum string size');
		}
		var rpt = '';
		for (;;) {
			if ((count & 1) == 1) {
				rpt += str;
			}
			count >>>= 1;
			if (count == 0) {
				break;
			}
			str += str;
		}
		// Could we try:
		// return Array(count + 1).join(this);
		return rpt;
	}
}

/**
 * Converts text into tag links if it's detected as CSV
 * Call addTagListeners after this function to add onclick listeners
 * @param {string} text the text to convert
 * @param {boolean=} force whether or not to force tag conversion
 * @param {boolean=} includeTitle whether to show the shift-click title message
 * @return {string|boolean} the resulting text
 */

function detectTags(text, force, includeTitle) {
	if (!text) return false;

	var tags = text.split(',');

	// semicolon separated tags, skip html entities
	let semiTags = [];
	let semiTag = '';
	let inSpecial = false; // keep track of whether we're in a special character
	for(let char of text){

		if (char == '&') { // start of special character
			inSpecial = true;
		} else if ((inSpecial && (char == ';' || char == ' '))){ // end of special character
			inSpecial = false;
		} else if (char == ';'){
			semiTags.push(semiTag);
			semiTag = '';
			continue;
		}

		semiTag += char;
	}
	if (semiTag.length) semiTags.push(semiTag); // push the last tag

	let char = ',';
	if (semiTags.length > tags.length) {
		tags = semiTags;
		char = ';';
	}

	if (tags.length < 2) {
		if (force) {
			return convertTextToTags(text);
		} else {
			return false;
		}
	}

	var links = [];
	//get word counts within tag, it might just be a long paragraph
	for (var i = 0, tagCount = tags.length; i < tagCount; i++) {
		var words = tags[i].split(' ');
		var wordCount = words.length;
		if (wordCount > 4 && wordCount < 8) {
			if (force || tagCount > 10) {
				return convertTextToTags(text, includeTitle);
			} else {
				return false;
			}
		}
		links.push('<a href="' + getExplorerLink('s=' + encodeURIComponent(tags[i].trim()), true) + '"' + (includeTitle ? ' title="Shift-Click to add this term to your search bar."' : '') + ' data-search_tag="' + StringSanitize.encodeIfNotEncoded(tags[i].trim()) + '">' + tags[i] + '</a>');
	}

	//we're probably tags
	return links.join(char + ' ');
}

/**
 * Converts text to tags, assuming it is not a simple CSV
 * and strips punctuation so it's not included in tags
 * @param {string} text the text to transform
 * @param {boolean=} includeTitle whether to show the shift-click title message
 * @return {string} the resulting text
 */
function convertTextToTags(text, includeTitle) {
	var joinChars = ['&', '/']; //characters that denote compound words (R & B)
	var ignoreWords = ['with', 'and', 'in', 'the']; //word that have no meaning, so we won't tag them. not exhaustive, just most common
	var punct = '\\['+ '\\!'+ '\\"'+ '\\#'+ '\\$'+
		'\\%'+ '\\&'+ '\\\''+ '\\('+ '\\)'+
		'\\*'+ '\\+'+ '\\,'+ '\\\\'+ '\\-'+
		'\\.'+ '\\/'+ '\\:'+ '\\;'+ '\\<'+
		'\\='+ '\\>'+ '\\?'+ '\\@'+ '\\['+
		'\\]'+ '\\^'+ '\\_'+ '\\`'+ '\\{'+
		'\\|'+ '\\}'+ '\\~'+ '\\]';

	var re=new RegExp(
		'('+               // start capture group
		'\\w+\\-\\w+'+       // hyphenated words
		'|'+               // alternator
		'\\w+\'(?:\\w+)?'+   // compound words
		'|'+               // alternator
		'\\w+'+              // other words
		'|'+               // alternator
		'['+punct+']'+        // punct
		')'                // end capture group
	);

	//unescape all html entities and kill any html
	var etext = $j('<div />').html(text.replace('<br/>', ' ')).text();
	//console.log('pre', text, etext);

	var textTokens = etext.split(re);
	//console.log('tokens:', textTokens);

	//clean up the tokens by removing blank entries and joining compound words
	var cleanTokens = [];
	var compounding = '';

	var token;
	for (var i = 0; i < textTokens.length; i++) {
		token = textTokens[i];
		if (!token) continue;

		if (compounding) {
			if (token == ' ') {
				compounding += ' ';
				continue;
			} else {
				cleanTokens.push( compounding + token );
				compounding = '';
				continue;
			}
		}

		if (joinChars.indexOf(token) != -1) { //these characters compound words into ideas, so we want to keep them together
			if (!cleanTokens.length) { //we are the first token, so just return it. this is weird.
				cleanTokens.push(token);
				continue;
			}

			if (compounding) { //&& or // etc. rare, but... whatever
				compounding += token;
				continue;
			} else {
				compounding = token;
				var k = i - 1; // index of previous token in textTokens
				var kk = cleanTokens.length - 1; // index of previous token in cleanTokens
				// go back through previous tokens until we find one that's not empty or a space and add them all to this new, compound token
				while (textTokens[k] == ' ' || textTokens[k] == '') {
					compounding = textTokens[k] + compounding;
					delete cleanTokens[kk];
					kk--;
					k--;
				}
				// once we've reached a non-empty token, add it the compound also
				compounding = textTokens[k] + compounding;
				if (cleanTokens[kk] != ' ') delete cleanTokens[kk]; // commented this out because 'funky r&b' would become 'funkyr&b' -- check that case if you put this back for some other reason
				continue;
			}
		}

		cleanTokens.push(token);
	}
	//console.log('cleanTokens:', cleanTokens);

	var tagged = [];
	for (i = 0; i < cleanTokens.length; i++) {
		token = cleanTokens[i];
		if (!token) continue;

		if (token.length > 1 && ignoreWords.indexOf(token) == -1) {
			tagged.push('<a href="' + getExplorerLink('s=' + encodeURIComponent(token.trim()), true) + '"' + (includeTitle ? ' title="Shift-Click to add this term to your search bar."' : '') + ' data-search_tag="' + StringSanitize.encodeIfNotEncoded(token.trim()) + '">' + token + '</a>');
		} else {
			tagged.push(token);
		}
	}

	return tagged.join('');
}

// rgb to hex conversion from https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
function componentToHex(c) {
	var hex = c.toString(16);
	return hex.length == 1 ? "0" + hex : hex;
}

function rgbToHex(r, g, b) {
	return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

/**
 * Checks if the string passed in is a valid IP address
 * From https://stackoverflow.com/a/27434991/19696
 * @param {string} ipaddress
 * @returns {boolean}
 */
function isIpAddress(ipaddress) {
	return !!(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress));
}

/**
 * https://stackoverflow.com/questions/10726909/random-alpha-numeric-string-in-javascript
 * @param length
 * @returns {string}
 */
function generateRandomString(length) {
	let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	let result = '';
	let hasNumber = false;
	let hasLetter = false;
	for (let i = length; i > 0; --i) {
		let charIndex = Math.floor(Math.random() * chars.length);
		if (charIndex < 10) {
			hasNumber = true;
		} else {
			hasLetter = true;
		}
		result += chars[charIndex];
	}
	if (length > 1 && (!hasNumber || !hasLetter)) {
		let newChar = '';
		if (!hasNumber) {
			newChar = chars[Math.floor(Math.random() * 10)];
		} else {
			newChar = chars[Math.floor(Math.random() * 52) + 10];
		}
		let newIndex = Math.floor(Math.random() * length);
		result = result.substring(0, newIndex) + newChar + result.substring(newIndex + 1);
	}
	return result;
}

function titleCase(str) {
	return str.toLowerCase().split(' ').map(function(word) {
		return word.length ? word.replace(word[0], word[0].toUpperCase()) : '';
	}).join(' ');
}

function isAcronym(str) {
	let possibleAcronym = str.toUpperCase();
	let knownAcronyms = [
		'BPM',
		'RPM',
		'ISRC',
		'ISWC'
	];

	return knownAcronyms.indexOf(possibleAcronym) > -1;
}

/**
 * Combines an array of strings into a single string, separated with commas and an "and", as appropriate
 * For example => joinWithCommas(['one', 'two']) === 'one and two'; joinWithCommas(['one', 'two', 'three']) === 'one, two, and three';
 * @param {string[]} arr
 * @returns {string}
 */
function joinWithCommas(arr) {
	let str = '';
	for (let i = 0, len = arr.length; i < len; i++) {
		let join = ', '; // if they have multiple agreements, connect them with oxford comma syntax
		if (i === 0) {
			join = ''; // first agreement needs no joining comma
		} else if (i === len - 1) {
			join = (len === 2 ? '' : ',') + ' and '; // the last agreement is joined with "and" (plus a comma if there's more than two)
		}
		str += join + arr[i];
	}
	return str;
}

/**
 * Format search term tags for display in the search bar
 *
 * @param tag
 * @returns {string}
 */
function searchTermTagFormatter(tag) {
	const isMultiWordTag = tag.split(' ').length > 1;

	if (isMultiWordTag) {
		tag = tag.replace(/"/g, '');
		// Wrap the tag with double quotes
		tag = '"' + tag + '"';
	} else {
		tag = tag.replace(/^'|"/g, '');
	}

	// Remove any doubled up quotes
	tag = tag.replace(/""/, '"').replace(/''/, "'");

	return tag;
}

class StringSanitize {
	/**
	 * Simple sanitization of a string to prevent XSS attacks
	 * @param str
	 * @returns {string}
	 * @constructor
	 */
	static sanitize(str) {
		// Create a textarea element
		const textarea = document.createElement('textarea');
		// Set the string as its value
		textarea.textContent = str;
		// Get the sanitized value back
		return textarea.value;
	}
	
	/**
	 * Some basic string HTML entity encoding
	 *
	 * @param str
	 * @param additionalEntities
	 * @param removeEntries
	 * @returns {*}
	 */
	static encode(str, additionalEntities = {}, removeEntries = []) {
		if (!str) return str;
		
		let entityList = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			"'": '&#39;',
			'"': '&quot;'
		};
		
		// Add any additional mappings
		entityList = Object.assign(entityList, additionalEntities);
		
		// Remove any entries from the entity list that are specified
		for (let i = 0; i < removeEntries.length; i++) {
			delete entityList[removeEntries[i]];
		}
		
		return str.replace(/[&<>'"]/g, tag => (entityList[tag]));
	}

	/**
	 * Specifically replace the greater than, less than, and line break HTML entities
	 * @param str
	 * @returns {*}
	 */
	static encodeGtLt(str) {
		return str.replace(/[\u003C\u003E]/g, match => {
			const replacements = {
				'\u003C': '&lt;',
				'\u003E': '&gt;',
			};
			return replacements[match];
		});
	}

	/**
	 * Encode the string if it's not already encoded. Avoid double encoding.
	 *
	 * @param str
	 * @param additionalEntities
	 * @param removeEntries
	 * @returns {*}
	 */
	static encodeIfNotEncoded(str, additionalEntities = {}, removeEntries = []) {
		if (!str) return str;

		if (!this.isEncoded(str)) {
			return this.encode(str, additionalEntities, removeEntries);
		}
		return str;
	}

	/**
	 * Decode the string if it's already encoded.
	 *
	 * @param str
	 * @returns {*}
	 */
	static ifEncodedDecode(str) {
		if (!str) return str;

		if (this.isEncoded(str)) {
			return this.decodeString(str);
		}
		return str;
	}

	/**
	 * Check if the string has already been encoded with the HTML entities we're looking for.
	 *
	 * @param str
	 * @returns {boolean}
	 */
	static isEncoded(str) {
		if (!str) return false;

		// Check for named entities (e.g., &lt; &gt; &amp; &quot; &apos;)
		const namedEntityPattern = /&[a-zA-Z]+;/;

		// Check for decimal entities (e.g., &#39;)
		const decimalEntityPattern = /&#\d+;/;

		// Check for hexadecimal entities (e.g., &#x27;)
		const hexEntityPattern = /&#x[0-9a-fA-F]+;/;

		return (
			namedEntityPattern.test(str)
			|| decimalEntityPattern.test(str)
			|| hexEntityPattern.test(str)
		);
	}

	/**
	 * Helper method to decode a string so we can show it correctly in an input field.
	 * We know the string isn't being run as a HTML tag when in an input field, so it's okay to decode.
	 *
	 * @param str
	 * @returns {*}
	 */
	static forInputField(str) {
		if (!str) return str;

		return this.ifEncodedDecode(str);
	}

	/**
	 * Decode a string that's been encoded with the HTML entities we're using.
	 *
	 * @param str
	 * @param extraEntityDecode
	 * @returns {*}
	 */
	static decodeString(str, extraEntityDecode = false) {
		if (!str) return str;

		const replacements = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			"'": '&#039;',
			'"': '&quot;'
		};

		const replacementValues = Object.values(replacements);
		const replacementKeys = Object.keys(replacements);

		for (let i = 0; i < replacementValues.length; i++) {
			const encodedStr = replacementValues[i];
			if (str.includes(encodedStr)) {
				str = str.replace(new RegExp(encodedStr, "ig"), replacementKeys[i]);
			}
		}

		if (extraEntityDecode) {
			str = StringSanitize.entityDecode(str);
		}

		return str;
	}

	static entityDecode(str) {
		return str.replace(/&([^;]+);/g, match => {
			const textarea = document.createElement('textarea');
			textarea.innerHTML = match;
			return textarea.value;
		});
	}

	/**
	 * Strip all HTML tags from a string
	 * @param str
	 * @param allowedTags
	 * @returns {*|string}
	 * @constructor
	 */
	static stripTags(str, allowedTags = []) {
		// If no string is provided, return empty string
		if (!str) return '';

		// Convert allowed tags array to lowercase for case-insensitive matching
		allowedTags = allowedTags.map(tag => tag.toLowerCase());

		// Create a regular expression that matches all HTML tags
		const regex = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;

		// Replace tags based on whether they're allowed or not
		return str.replace(regex, (match, tag) => {
			// If the tag is in the allowed list, keep it
			if (allowedTags.includes(tag.toLowerCase())) {
				return match;
			}
			// Otherwise, remove it
			return '';
		});
	}
}
function Track(details) {
	const track = this;

	details = $j.extend({
		id: 0,
		name: '',
		description: '',
		image: '',
		number: '',
		count: 0,
		plays: 0,
		downloads: 0,
		code: '',
		catalog: null,
		label: null,
		artist: null,
		featured: 0,
		date: '',
		genres: [],
		user_projects: [],
		editable: false
	}, details);

	for (const i in details) {
		if (!details.hasOwnProperty(i)) continue;
		track[i] = details[i];
	}

	track.generateArtElement = function (options) {
		options = $j.extend({
			listType: 'track',
			hovers: true,
			showCatalog: true,
			showArtist: true,
			showAlbum: false,
			showDetailLabels: false,
			showCode: true,
			showReleaseDate: true,
			showing: false,
			size: 'normal',
			showPlayBtn: false,
		}, options);

		const classes = ['list_block', options.listType + '_block', 'selector_track'];
		if (track.featured) classes.push('featured');
		if (options.size !== 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');

		// Build the various strings for the div here for a little clarity
		const showArtistLink = options.showArtist && track.artist && track.artist.id;
		const artistLink = `
			<span>
				<a href="${getArtistLink(track.artist.id)}" class="normal">
					<span class="item-detail track-item-detail">${options.showDetailLabels ? '<span class="emphasis">Artist:</span>' : ''} ${track.artist.name}</span>
				</a>
			</span>`.trim();

		const showAlbumLink = track.album && track.album.id;
		const albumLink = `
			<span>
				<a href="${getAlbumLink(track.album.id)}" class="normal">
					<span class="item-detail track-item-detail">${options.showDetailLabels ? '<span class="emphasis">Album:</span>' : ''} ${track.album.name}</span>
				</a>
			</span>`.trim();
		
		const showReleaseDate = options.showReleaseDate && config.id !== 382 && config.id !== 1494 && track.date && track.date !== formatDate(config.dateFormatString, 0);
		const releaseDate = `<span class="item-detail track-item-detail release_date"><span class="emphasis">Released:</span> ${track.date}</span>`;

		const playBtn = sa.components.player.generatePlayButton(track.id);
		
		// convert seconds into minutes and seconds
		const time = track.length || '';
		
		const div = $j(`
			<div id="item_${track.id}" class="${classes.join(' ')}">
				<a href="${getTrackLink(track.id)}" class="art_image">
					<img src="${track.album.image}" />
					<div class="buttons"></div>
					${track.featured ? '<div class="featured"></div>' : ''}
					<div class="hover-bg"></div>
				</a>
				<div class="info">
					<a href="${getTrackLink(track.id)}" title="${track.title.replace(/"/g, '&quot;')}">${track.title}</a>
					${showArtistLink ? `${artistLink}` : ''}
					${showAlbumLink ? `${albumLink}` : ''}
					${showReleaseDate ? `${releaseDate}` : ''}
				</div>
			</div>
		`);
		
		if (options.showPlayBtn) {
			div.find('.art_image').append(playBtn);
		}

		// store the track
		div.data('track', track);

		if (track.album.image === '') {
			div.find('.art_image img').remove();
			div.find('.art_image').prepend(getDefaultArtElement('track'));
		}

		if (options.hovers && sa.useHovers) {
			// what follows has to do with setting up the hover interaction layer
			const buttonContainer = div.find('.buttons');
			// add the download button
			const downloadAnchor = sa.components.downloadFormatSelector.generateDownloadButton({ 
				type: 'track', 
				item: track 
			});
			
			let hovers = 0;
			buttonContainer.append(downloadAnchor);
			div.find('.art_image').add(downloadAnchor.getContainer()).on('mouseenter.hovers', function() {
				div.addClass('hovering');
				hovers++;
			})
				.on('mouseleave.hovers', function() {
					hovers--;
					setTimeout(() => {
						if (hovers < 1) {
							div.removeClass('hovering');
							hovers = 0;
						}
					}, 50);
				});
			
			// add the email button
			buttonContainer.append(sa.components.emailer.generateEmailButton({ 
				type: 'track', 
				item: track 
			}));
			
			// if edit is on, we need to add those options
			if (user.hasAdminPermission(AdminPermission.Feature)) {
				buttonContainer.append(sa.components.buttons.generateFeatureButton({ 
					id: track.id, 
					type: 'track', 
					featured: track.featured
				}));
			}
			
			if (track.editable) {
				buttonContainer.append(sa.components.buttons.generateEditButton({ 
					type: 'track', 
					item: track 
				}));
				
				buttonContainer.append($j('<a class="faux_button"><span class="icon fa fa-times"></span></a>').on('click', () => { 
					track.delete(options.deleteCallback); 
					return false; 
				}));
				
				div.find('.buttons').addClass('tall');
			}
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};
}

/**
 * AlbumData object type reference
 * @typedef {object} AlbumData
 * 	@property {int} id
 * 	@property {string} name
 * 	@property {string} description
 * 	@property {string} image full path
 * 	@property {string} number track number - note: not an int on purpose
 * 	@property {int} count number of tracks in the album
 * 	@property {int} nestedCount number of tracks including ones included by nesting that aren't in the album (used by project includeNested)
 * 	@property {int} plays
 * 	@property {int} downloads
 * 	@property {string} code
 * 	@property {Catalog} catalog
 * 	@property {Label} label
 * 	@property {Artist} artist
 * 	@property {int} featured
 * 	@property {string} date
 * 	@property {Array.<Genre>} genres
 * 	@property {Array.<Project>} user_projects
 * 	@property {boolean} editable
 */

/**
 * Album object type reference
 * @class
 * @augments AlbumData
 * @param {AlbumData|Album|Object} details
 */
function Album(details) {
	
	var album = this;
	
	details = $j.extend({
		id : 0,
		name : '',
		description : '',
		image : '',
		number : '',
		count : 0,
		plays : 0,
		downloads : 0,
		code : '',
		catalog : null,
		label : null,
		artist : null,
		featured : 0,
		date : '',
		genres : [],
		user_projects : [],
		editable : false
	}, details);
	
	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		album[i] = details[i];
	}

	/**
	 * Shows a binary box asking if the user wants to delete an album
	 * @param {function=} callback a function to call when delete is complete (if it is) (optional)
	 */
	album.delete = function(callback) {
		sa.confirm({
			text : 'Delete ' + gde('album', { c : 'lower', p : false }) + ' "' + album.name + '" and ALL ITS TRACKS? This is not undoable.',
			yesFunction : function() {
				ajax({ id : album.id, action : 'delete' }, function(response) {
					sa.notify({ text : response[0].result });
					if (callback) {
						callback();
					}
				}, 'POST', 'p=album_details');
				sa.showCover('Deleting ' + album.name + '. Please be patient. Depending on your track count, this may take a minute...,');
			},
			yesText : 'Delete'
		})
	};

	album.generateArtElement = function(options) {

		options = $j.extend({
			listType : 'album',
			hovers : true,
			showCatalog : true,
			showArtist : true,
			showCode : true,
			showReleaseDate : true,
			deleteCallback : function() {},
			showing : false,
			size : 'normal'
		}, options);


		var classes = [ 'list_block', options.listType + '_block', 'selector_album' ];
		if (album.featured) classes.push('featured');
		if (options.size != 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');
		
		// Build the various strings for the div here for a little clarity
		const showCatalogLink = options.showCatalog 
			&& sa.getCurrentPageName() !== 'catalog' 
			&& sa.getCurrentPageName() !== 'label' 
			&& (config.siteType === 'radio' || config.siteType === 'network');
		
		const catalogLink = `<span class="item-detail album-item-detail"><span class="emphasis">${gde('catalog')}:</span> <a href="${getCatalogLink(album.catalog.id)}" title="${album.catalog.name}" class="normal">${album.catalog.name}</a></span><br/>`;
		
		const showArtistLink = options.showArtist && album.artist && album.artist.id;
		const artistLink = `<span class="item-detail album-item-detail"><span class="emphasis">${config.getDictionaryEntry('artist')}:</span> <a href="${getArtistLink(album.artist.id)}" class="normal">${album.artist.name}</a></span><br/>`;
		
		const idsToCheck = [172, 286, 7301];
		const showCode = options.showCode && (idsToCheck.includes(config.id)) && album.code;
		const codeSpan = `<span class="code item-detail album-item-detail"><span class="emphasis">${gde('album', { case: 'upper', plural: false })} Code:</span> ${album.code}</span><br/>`;
		
		const showReleaseDate = options.showReleaseDate && config.id !== 382 && config.id !== 1494 && album.date && album.date !== formatDate(config.dateFormatString, 0);
		const releaseDate = `<span class="release_date item-detail album-item-detail"><span class="emphasis">Released</span> ${album.date}</span>`;
		
		const div = $j(`
			<div id="item_${album.id}" class="${classes.join(' ')}">
				<a href="${getAlbumLink(album.id)}" class="art_image">
					<img src="${album.image}" />
					<div class="buttons"></div>
					${album.featured ? `<div class="featured"></div>` : ``}
				</a>
				<div class="info">
					<a href="${getAlbumLink(album.id)}" title="${album.name.replace(/"/g, '&quot;')}">${album.name}</a>
					${showCatalogLink ? catalogLink : ''}
					${showArtistLink ? artistLink : ''}
					<span class="item-detail album-item-detail"><span class="emphasis">Tracks${(config.id === 752 ? ' and Stems' : '')}:</span> ${numberFormat(album.count)}</span><br/>
					${showCode ? codeSpan : ''}
					${showReleaseDate ? releaseDate : ''}
				</div>
			</div>
		`);
		
		// store the album
		div.data('album', album);

		if (album.image == '') {
			div.find('.art_image img').remove()
			div.find('.art_image').prepend(getDefaultArtElement('album'))
		}
		
		if (options.hovers && sa.useHovers) {
			// what follows has to do with setting up the hover interaction layer
			var buttonContainer = div.find('.buttons');
			// add the download button
			var downloadAnchor = sa.components.downloadFormatSelector.generateDownloadButton({ type : 'album', item : album });
			var hovers = 0;
			buttonContainer.append(downloadAnchor);
			div.find('.art_image').add(downloadAnchor.getContainer()).on('mouseenter.hovers', function() {
				div.addClass('hovering');
				hovers++;
			})
			.on('mouseleave.hovers', function() {
				hovers--;
				setTimeout(function() {
					if (hovers < 1) {
						div.removeClass('hovering');
						hovers = 0;
					}
				}, 50);
			});
			// add the email button
			buttonContainer.append(sa.components.emailer.generateEmailButton({ type : 'album', item : album }));
			// if edit is on, we need to add those options
			if (user.hasAdminPermission(AdminPermission.Feature)) {
				buttonContainer.append(sa.components.buttons.generateFeatureButton({ id : album.id, type : 'album', featured : album.featured }));
			}
			if (album.editable) {
				buttonContainer.append(sa.components.buttons.generateEditButton({ type : 'album', item : album }));
				buttonContainer.append($j('<a class="faux_button"><span class="icon fa fa-times"></span></a>').on('click', function() { album.delete(options.deleteCallback); return false; }));
				div.find('.buttons').addClass('tall');
			}
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};
}

/**
 * ArtistData object type reference
 * @typedef {Object} ArtistData
 * @property {int} id
 * @property {string} name
 * @property {string} image full path
 * @property {string} description
 * @property {int} count - not always set
 * @property {int} album_count - not always set
 * @property {boolean} editable
 * @property {boolean} featured
 */

/**
 * @class
 * @augments ArtistData
 * @param  {ArtistData|Artist} details
 */
function Artist(details) {
	
	var artist = this;
	
	details = $j.extend({
		id : 0,
		name : '',
		image : '',
		description : '',
		count : 0,
		album_count : 0,
		editable : false,
		featured : false
	}, details);

	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		artist[i] = details[i];
	}

	artist.generateArtElement = function(options) {

		options = $j.extend({
			listType : 'artist',
			hovers : true,
			showing : false,
			size : 'normal'
		}, options);

		var classes = [ 'list_block', options.listType + '_block' ];
		if (artist.featured) classes.push('featured');
		if (options.size != 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');

		const div = $j(`
			<div id="item_${artist.id}" class="${classes.join(' ')}">
				<a href="${getArtistLink(artist.id)}" class="art_image">
					<img src="${artist.image}" alt=""/>
					<div class="buttons"></div>
					${artist.featured ? '<div class="featured"></div>' : ''}
				</a>
				<div class="info">
					<a href="${getArtistLink(artist.id)}" title="${artist.name.replace(/"/g, '&quot;')}">${artist.name}</a>
					<span class="item-detail artist-item-detail">${[72, 87, 114].includes(config.id) ? '<span class="emphasis">Sound Effects: ' : '<span class="emphasis">Tracks' + (config.id === 752 ? ' and Stems' : '') + ':</span> '} ${numberFormat(artist.count)}</span>
					<span class="item-detail artist-item-detail">${(artist.album_count ? '<br>' + config.getDictionaryEntry('album', true) + ': ' + numberFormat(artist.album_count) : '')}</span>
				</div>
			</div>
		`);
		
		// store the artist
		div.data('artist', artist);

		if (artist.image == '') {
			div.find('.art_image img').remove()
			div.find('.art_image').prepend(getDefaultArtElement('person'))
		}

		if (options.hovers && sa.useHovers && (user.hasAdminPermission(AdminPermission.Feature) || artist.editable)) {
			// what follows has to do with setting up the hover interaction layer
			var buttonContainer = div.find('.buttons');
			if (user.hasAdminPermission(AdminPermission.Feature)) {
				buttonContainer.append(sa.components.buttons.generateFeatureButton({ id : artist.id, type : 'artist', featured : artist.featured }));
			}
			if (artist.editable) {
				buttonContainer.append(sa.components.buttons.generateEditButton({ type : 'artist', item : artist }));
			}
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};
	
}

/**
 * CatalogData object type reference
 * @typedef {Object} CatalogData
 * @property {int} id
 * @property {string} name
 * @property {string} description
 * @property {string} image full path
 * @property {int} label_count
 * @property {int} album_count
 * @property {int} artist_count
 * @property {int} track_count
 * @property {int} featured
 * @property {string} external
 * @property {boolean} editable
 */

/**
 * @class
 * @augments CatalogData
 * @param  {CatalogData|Catalog|Object=} details
 */
function Catalog(details) {

	var catalog = this;
	details = $j.extend({
		id : 0,
		name : '',
		description : '',
		image : '',
		catalog : null,
		label_count : 0,
		album_count : 0,
		artist_count : 0,
		track_count : 0,
		featured : 0,
		external : '',
		editable : false
	}, details);

	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		catalog[i] = details[i];
	}

	catalog.generateArtElement = function(options) {

		options = $j.extend({
			listType : 'catalog',
			hovers : true,
			showing : false,
			size : 'normal'
		}, options);

		var classes = [ 'list_block', options.listType + '_block' ];
		if (catalog.featured) classes.push('featured');
		if (options.size != 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');

		const div = $j(`
			<div id="item_${catalog.id}" class="${classes.join(' ')}">
				<a href="${getCatalogLink(catalog.id)}" class="art_image">
					<img src="${catalog.image}"/>
					<div class="buttons"></div>
					${catalog.featured ? '<div class="featured"></div>' : ''}
				</a>
				<div class="info">
					<a href="${getCatalogLink(catalog.id)}" title="${catalog.name.replace(/"/g, '&quot;')}">${catalog.name}</a>
					<span class="item-detail catalog-item-detail">${([72, 87, 114].includes(config.if) ? '<span class="emphasis">Sound Effects: ' : '<span class="emphasis">Tracks' + (config.id === 752 ? ' and Stems' : '') + ':</span> ') + numberFormat(catalog.track_count)}</span>
					<span class="item-detail catalog-item-detail">${catalog.label_count ? '<br>' + ([72, 87, 114].includes(config.if) ? '' : '<span class="emphasis">' + config.getDictionaryEntry('label', true)) + ':</span> ' + numberFormat(catalog.label_count) : ''}</span>
					<span class="item-detail catalog-item-detail">${catalog.album_count ? '<br>' + '<span class="emphasis">' + config.getDictionaryEntry('album', true) + ':</span> ' + numberFormat(catalog.album_count) : ''}</span>
				</div>
			</div>
		`);
		
		// store the catalog
		div.data('catalog', catalog);

		if (catalog.image == '') {
			div.find('.art_image img').remove()
			div.find('.art_image').prepend(getDefaultArtElement('catalog'))
		}

		if (options.hovers && sa.useHovers && (user.hasAdminPermission(AdminPermission.Feature) || catalog.editable)) {
			// what follows has to do with setting up the hover interaction layer
			var buttonContainer = div.find('.buttons');
			if (user.hasAdminPermission(AdminPermission.Feature)) {
				buttonContainer.append(sa.components.buttons.generateFeatureButton({ id : catalog.id, type : 'catalog', featured : catalog.featured }));
			}
			if (catalog.editable) {
				buttonContainer.append(sa.components.buttons.generateEditButton({ type : 'catalog', item : catalog }));
			}
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};

}
/**
 * ImportTrackData object type reference
 * @typedef {Object} ImportTrackData
 * @property {int} id
 * @property {int} jobId
 * @property {string} status
 * @property {int} finalTrackId
 * @property {Catalog} catalog
 * @property {Label} label
 * @property {string} labelName
 * @property {string} albumName
 * @property {string} albumDescription
 * @property {string} albumCode
 * @property {string} albumGenre
 * @property {string} albumReleaseDate
 * @property {string} trackNumber
 * @property {string} artistName
 * @property {string} composerName
 * @property {string} publisherName
 * @property {string} tempos
 * @property {int} bpm
 * @property {Key} key
 * @property {string} genres
 * @property {string} cueTypes
 * @property {string} title
 * @property {string} filename
 * @property {string} date
 * @property {string} releaseDate
 * @property {float} length
 * @property {string} description
 * @property {string} mood
 * @property {string} style
 * @property {string} styleOf
 * @property {string} lyrics
 * @property {int} has_vocal
 * @property {int} explicit
 * @property {string} isrc
 * @property {string} iswc
 * @property {Array.<Writer>} writers
 * @property {Array.<Publisher>} publishers
 * @property {Array.<CustomField>} custom_fields
 */

/**
 * @class
 * @augments ImportTrackData
 * @param {ImportTrackData|sa.objectTypes.ImportTrack|Object=} details
 */
sa.objectTypes.ImportTrack = function(details) {

	var importTrack = this;

	details = $j.extend({
		id : 0,
		jobId : 0,
		status : '',
		finalTrackId : 0,
		catalog : null,
		label : null,
		labelName : '',
		albumName : '',
		albumDescription : '',
		albumCode : '',
		albumGenre : '',
		albumReleaseDate : '',
		trackNumber : '',
		artistName : '',
		composerName : '',
		publisherName : '',
		tempos : '',
		bpm : 0,
		key : null,
		genres : '',
		cueTypes : '',
		title : '',
		filename : '',
		date : '',
		releaseDate : '',
		length : 0,
		description : '',
		mood : '',
		style : '',
		styleOf : '',
		lyrics : '',
		has_vocal : 2,
		explicit : 0,
		isrc : '',
		iswc : '',
		writers : [],
		publishers : [],
		custom_fields : [],
		projectId : 0
	}, details);

	/**
	 * Sets the status of the import, updating the row's display
	 * @param {string} newStatus
	 */
	importTrack.setStatus = function(newStatus) {
		if (row) {
			row.removeClass('status_' + importTrack.status);
			row.addClass('status_' + newStatus);
		}
		importTrack.status = newStatus;
	};

	function setInternalFields(details) {
		importTrack.setStatus(details.status);
		for (var i in details) {
			if (!details.hasOwnProperty(i)) continue;
			importTrack[i] = details[i];
		}
	}
	setInternalFields(details);

	var row;
	var progressBar;
	var progressDescription;
	var progressDescriptionText = '';

	function checkProgress(shouldStop) {

		sa.importTrackManager.checkProgress(importTrack.id, function(newImportTrackData) {

			if (!newImportTrackData) {
				return console.error('Stopping progress checks for', importTrack.id, 'because of null response');
			}

			setInternalFields(newImportTrackData);

			if (importTrack.status === 'd' && importTrack.finalTrackId) {

				ajax({ p : 'track_info', id : importTrack.finalTrackId }, function(response) {

					if (response.length !== 2) {
						return console.error('Unable to load', importTrack.finalTrackId, 'server said', response);
					}

					/** @var {Track} */
					var trackData = response[1];
					/** @var {List} */
					var trackList = row.parents('.track_list').data('list-object');
					if (!trackList) {
						console.error('Unable to find track list object for import track row');
						row.remove();
					} else {
						trackBank.add(trackData, trackList.conf.bankKey);
						let trackListRow = trackList.addListItem(trackData, 'track', true);
						trackListRow.detach();
						row.after(trackListRow);
						row.remove();
						trackList.reinitializeInteractions();

						// if you're uploading multiple tracks, they might appear in any order. just save whatever it's currently displaying
						if (importTrack.projectId && sa.currentPage && sa.currentPage.name === sa.pages.projectItemList.name && sa.currentPage.project.id == importTrack.projectId) {
							sa.pages.projectItemList.getList().saveSort();
						}
					}

				});
				return;

			}

			if (!shouldStop()) {
				checkProgress(shouldStop);
			}

		});

	}

	function showUploadError(message) {
		importTrack.setStatus('e');
		if (row) {
			row.find('.error_description').html('Error uploading "' + importTrack.filename + '"');
		}
		sa.importTrackManager.removeUploadingImportTrack(importTrack);
		sa.alert({ text : message, extraClasses : 'import_track_error_alert' });

	}

	/** @var {Uploader} uploader */
	let uploader;
	importTrack.uploadFile = function(file, context, extraUploadParameters) {
		if (lockdown) return;

		importTrack.generateListElement();
		sa.importTrackManager.addUploadingImportTrack(importTrack, context);

		uploader = new Uploader({
			button : $j(),
			browseCallback : function() { },
			fileType : UploaderConstants.AUDIO
		});
		uploader.addFilesToUpload([ file ]);

		// rate limiter
		sa.importTrackManager.addImportTrackToUploadQueue(importTrack, function() {

			uploader.upload({
				params : 't=track&publish=1' + (extraUploadParameters ? '&' + $j.param(extraUploadParameters, false) : ''),
				complete : function (e, serverResponse) {
					if (serverResponse.length && serverResponse[0] == '{') {
						try {
							var parsedResponse = JSON.parse(serverResponse);
							if (!parsedResponse) {
								return showUploadError('');
							}
							if (parsedResponse.error) {
								return showUploadError('Unable to upload ' + file.name + ' to your workspace. ' + parsedResponse.message);
							}
							if (parsedResponse.success) {
								sa.importTrackManager.removeUploadingImportTrack(importTrack);
								importTrack.jobId = parsedResponse['jobId'];
								importTrack.id = parsedResponse['importTrackId'];
								importTrack.setStatus('q');
								updateRowState();
							}
						} catch (e) {
							return showUploadError('');
						}
					} else {
						return showUploadError('');
					}
				},
				progress : function (e, bytesLoaded, bytesTotal) {

					if (!progressBar) {
						progressBar = row.find('.import_track_uploading .progress_bar');
						progressDescription = row.find('.import_track_uploading .description');
					}

					let statusText = 'Uploading "' + importTrack.filename + '"';
					let percentage = bytesLoaded / bytesTotal;

					progressBar.css({ right : (100 - (100 * percentage)) + '%' });
					if (statusText !== progressDescriptionText) {
						progressDescription.html(statusText);
						progressDescriptionText = statusText;
					}

				},
				abort : function() {
					abortUpload(true);
				},
				error : function () {
					importTrack.setStatus('ie');
					updateRowState();
					console.error('error during upload', file);
				}
			});

		});

		updateRowState();
	};

	function abortUpload(notify) {
		if (importTrack.status === 'ic') {
			return; // already cancelled, probably manually
		}
		importTrack.setStatus('ic');
		uploader.abort();
		sa.importTrackManager.removeImportTrackFromUploadQueue(importTrack);
		sa.importTrackManager.removeUploadingImportTrack(importTrack, true);
		updateRowState();
		if (notify) {
			sa.notify({ text : 'Your upload of "' + importTrack.filename + '" was interrupted. Please try again.' });
		}
	}

	function updateRowState(options) {
		if (importTrack.id > 0) {
			row.find('.import_track_processing .description').html('Processing "' + importTrack.filename + '"');

			checkProgress(function () {
				return row.parents('body').length === 0;
			});
		} else {
			if (importTrack.status === 'iq') {
				row.find('.import_track_upload_queued .queue_description').html('Queued "' + importTrack.filename + '" for uploading');
			} else if (importTrack.status === 'ic') {
				row.find('.import_track_upload_cancelled .cancel_description').html('Upload of "' + importTrack.filename + '" cancelled');
			} else {
				row.find('.import_track_uploading .description').html('Uploading "' + importTrack.filename + '"');
			}
			row.find('.cancel_button').off('click').on('click', function() {
				abortUpload();
			});
			row.find('.remove_button').off('click').on('click', function() {
				sa.importTrackManager.removeUploadingImportTrack(importTrack, false);
				sa.router.reloadPage();
			});
		}

		if (options) {
			if (options.waveform) {
				row.addClass('with_waveform');
			} else {
				row.removeClass('with_waveform');
			}
		}
	}

	importTrack.generateListElement = function(options) {

		options = $j.extend({
			waveform : false
		}, options);

		if (!row || !row.length || !row[0].childNodes.length) {
			let templates = sa.importTrackManager.getTemplates();
			row = templates.get('row').children().first();
			importTrack.setStatus(importTrack.status);
			// reset vars so they're grabbed again in this new context
			progressBar = null;
			progressDescription = null;
			progressDescriptionText = '';
		}

		updateRowState(options);

		return row;

	};

};

sa.importTrackManager = (function() {

	var importTrackManager = {};
	var templates;

	// context-related import tracking
	var uploadingImportTracks = {};
	var importTrackIndex = 0;
	const baseContext = 'tracks';

	// queue-related import tracking
	/** @var {Array.<sa.objectTypes.ImportTrack>} */
	var currentUploads = [];
	var uploadQueue = [];
	const maxSimultaneousUploads = 3;

	importTrackManager.getTemplates = function () {
		if (!templates) {
			templates = sa.templates.get('object.import_track');
		}
		return templates;
	};

	/**
	 * Gets the hash contexts to which the current context should apply
	 * @param {string} context
	 * @returns {Array.<string>}
	 */
	function getCleanContexts(context) {
		let contextMatches = context.match(/(playlist\/[0-9]+)/);
		let contexts = [ baseContext ];
		if (contextMatches) {
			contexts.push(contextMatches[1]);
		}
		return contexts;
	}

	/**
	 * Adds an import track that's uploading to the list
	 * @param {sa.objectTypes.ImportTrack} importTrack
	 * @param {string} context
	 */
	importTrackManager.addUploadingImportTrack = function(importTrack, context) {
		importTrack.id = 0 - importTrackIndex++;
		getCleanContexts(context).each(function(i, context) {
			if (!uploadingImportTracks[context]) {
				uploadingImportTracks[context] = [ importTrack ];
			} else {
				uploadingImportTracks[context].push(importTrack);
			}
		});
	};

	/**
	 * Removes an import track from the list of those that are currently uploading
	 * @param {sa.objectTypes.ImportTrack} importTrack
	 * @param {boolean=} leaveInContext if true, the import track will still be returned in its context(s)
	 */
	importTrackManager.removeUploadingImportTrack = function(importTrack, leaveInContext) {
		if (!leaveInContext) {
			// remove the track from the context list
			for (let context in uploadingImportTracks) {
				if (!uploadingImportTracks.hasOwnProperty(context)) continue;
				let importTracksInContext = uploadingImportTracks[context];
				for (let i = 0, len = importTracksInContext.length; i < len; i++) {
					if (importTracksInContext[i].id === importTrack.id) {
						importTracksInContext.splice(i, 1);
						if (!importTracksInContext.length) {
							delete uploadingImportTracks[context];
						}
						break;
					}
				}
			}
		}

		// remove the track from the current uploads
		for (let i = 0, len = currentUploads.length; i < len; i++) {
			let queuedImportTrack = currentUploads[i];
			if (queuedImportTrack.id === importTrack.id) {
				currentUploads.splice(i, 1);
				processUploadQueue();
				break;
			}
		}
	};

	/**
	 * Gets the import tracks that are currently being uploaded in the current context
	 * @param {string} context
	 * @returns {Array}
	 */
	importTrackManager.getUploadingImportTracks = function(context) {
		if (config.siteType !== 'drop') return []; // skip the regex if possible
		context = getCleanContexts(context).pop();
		if (uploadingImportTracks.hasOwnProperty(context)) {
			return uploadingImportTracks[context].slice();
		} else {
			return [];
		}
	};

	/**
	 *
	 * @param {string} context information about the page we're on (probably the hash)
	 * @param {ImportTrackData} itemInfo information about the track to return
	 * @return {sa.objectTypes.ImportTrack}
	 */
	importTrackManager.getImportTrack = function(context, itemInfo) {
		if (itemInfo.id > 0) {
			return new sa.objectTypes.ImportTrack(itemInfo);
		}

		var uploadingImportTracks = importTrackManager.getUploadingImportTracks(context).reverse();
		var importTrack = uploadingImportTracks[Math.abs(itemInfo.id)];
		if (importTrack === undefined) {
			console.warn('import track not found for id', itemInfo.id);
			importTrack = null;
		}

		return importTrack;
	};

	/**
	 * Sets up an edad drop zone on the given selector
	 * @param {string} anchorSelector
	 * @param {object=} extraUploadParameters
	 */
	importTrackManager.createDropZone = function(anchorSelector, extraUploadParameters) {
		sa.components.edad.addGenericDropZone({
			allowedExtensions : Uploader.GetExtensions(UploaderConstants.AUDIO),
			anchorSelector : anchorSelector,
			templateSelector : 'track_list_drop_zone',
			uniqueKey : 'explorer_drop_zone',
			dropCallback : function(files) {
				if (config.siteType === 'seller' || config.siteType === 'network') {
					AdminUploadUpload.files = files;
					sa.router.routeTo('/admin?p=upload');
				} else if (config.siteType === 'drop') {
					files.each(function(i, file) {
						var it = new sa.objectTypes.ImportTrack();
						it.filename = file.name;
						it.uploadFile(file, sa.router.getFullUrl(), extraUploadParameters);
					});
					sa.router.reloadPage();
				}
			}
		});
	};

	/**
	 * Gets a button to let the user select files for upload
	 * @param {object=} extraUploadParameters
	 * @returns {*}
	 */
	importTrackManager.getUploadButton = function(extraUploadParameters) {
		let button = importTrackManager.getTemplates().get('upload_button');
		let uploader = new Uploader({
			button : button,
			allowMultiple : true,
			browseCallback : function() {
				uploader.getFileDetails().each(function(i, file) {
					var it = new sa.objectTypes.ImportTrack();
					it.filename = file.name;
					it.uploadFile(file, sa.router.getFullUrl(), extraUploadParameters);
				});
				uploader.removeAllFiles();
				sa.router.reloadPage();
			},
			fileType : UploaderConstants.AUDIO
		});
		return button;
	};

	/**
	 * Adds an import track to the queue, starting it if there's room
	 * @param {sa.objectTypes.ImportTrack} importTrack
	 * @param {function} startUploading
	 */
	importTrackManager.addImportTrackToUploadQueue = function(importTrack, startUploading) {
		importTrack.setStatus('iq');
		uploadQueue.push({ importTrack : importTrack, startUploading : startUploading });
		processUploadQueue();
	};

	/**
	 * Removes an import track from the queue, if it's in there
	 * @param {sa.objectTypes.ImportTrack} importTrack
	 */
	importTrackManager.removeImportTrackFromUploadQueue = function(importTrack) {
		for (let n = 0, nLen = uploadQueue.length; n < nLen; n++) {
			let upload = uploadQueue[n];
			if (upload.importTrack.id === importTrack.id) {
				uploadQueue.splice(n, 1);
				break;
			}
		}
	};

	/**
	 * Advances the upload queue, moving tracks into the current uploads if there's space
	 */
	function processUploadQueue() {
		if (currentUploads.length >= maxSimultaneousUploads) return; // we're already at max

		let nextUpload = uploadQueue.shift();
		if (nextUpload === undefined) return; // nothing in queue

		currentUploads.push(nextUpload.importTrack);
		nextUpload.importTrack.setStatus('iu');
		nextUpload.startUploading();
	}

	// variables and functions used when checking for progress updates on import track publishing
	var progressCheckTimeout;
	var importTracksToProgressCheck = [{}]; // uses this structure to prevent concurrency issues. new import tracks are always added to 0 and we're going to use them, we create a new 0 and use the old one

	/**
	 * Checks the publishing progress of the given import track
	 * @param {int} importTrackId the id of the import track to check
	 * @param {function} callback called with the new data for the import track
	 */
	importTrackManager.checkProgress = function(importTrackId, callback) {
		importTracksToProgressCheck[0][importTrackId] = callback;

		startProgressCheck();
	};

	/**
	 * Internal function that actually performs the ajax call to check for import track publishing progress
	 * Uses a setTimeout loop and merges all the progress check requests into one so we don't spam the server
	 */
	function startProgressCheck() {
		if (progressCheckTimeout) return;
		progressCheckTimeout = setTimeout(function() {
			progressCheckTimeout = null;
			importTracksToProgressCheck.unshift({});
			let importTrackCallbacks = importTracksToProgressCheck.pop();
			let importTrackIds = Object.keys(importTrackCallbacks);

			if (!importTrackIds.length) return;

			ajax({ p : 'import_tracks', action : 'tracksStatus', importTrackIds : importTrackIds, cacheBreak : new Date().getTime() }, function(importTrackUpdates) {

				if (!importTrackUpdates || importTrackUpdates.error) {
					return console.error(importTrackUpdates);
				}

				for (let importTrackId in importTrackCallbacks) {
					if (!importTrackCallbacks.hasOwnProperty(importTrackId)) continue;

					importTrackCallbacks[importTrackId](importTrackUpdates[importTrackId]);
				}

				startProgressCheck();

			});

		}, 1000);
	}

	// variables and functions used to handle ajax requests getting new publishing times
	// this lets us update your project counts, etc. without you having to reload the page
	let publishedToProjectTime = -1;
	let publishedTrackTime = -1;

	/**
	 * Updates the locally cached times tracking import progress and takes appropriate action
	 * @param {int} newPublishedToProjectTime
	 * @param {int} newPublishedTrackTime
	 */
	importTrackManager.updatePublishingTimes = function(newPublishedToProjectTime, newPublishedTrackTime) {
		if (publishedToProjectTime === -1) { // just means it's the first ajax call
			publishedToProjectTime = newPublishedToProjectTime;
			publishedTrackTime = newPublishedTrackTime;
			return;
		}

		if (newPublishedTrackTime === 0 && publishedTrackTime !== 0) { // cache expired. go back to 0
			publishedTrackTime = 0;
		} else if (newPublishedTrackTime > publishedTrackTime) { // this is an actual update
			publishedTrackTime = newPublishedTrackTime;
			sa.requestCache.clear(); // make sure the new tracks show up as the user navigates around
		}

		if (newPublishedToProjectTime === 0 && publishedToProjectTime !== 0) { // cache expired. go back to 0
			publishedToProjectTime = 0;
		} else if (newPublishedToProjectTime > publishedToProjectTime) { // this is an actual update
			// the user has new tracks in their projects. update the projects and the page if they're on a project item list
			publishedToProjectTime = newPublishedToProjectTime;
			user.reloadProjects(function() {
				if (sa.isCurrentPage(sa.pages.projectItemList)) {
					sa.pages.projectItemList.updateItemCount();
				}
			});
		}

	};

	return importTrackManager;

})();

/**
 * LabelData object type reference
 * @typedef {Object} LabelData
 * @property {int} id
 * @property {string} name
 * @property {string} description
 * @property {string} image full path
 * @property {Catalog} catalog
 * @property {int} album_count
 * @property {int} artist_count
 * @property {int} count - track count
 * @property {int} featured
 * @property {boolean} editable
 */

/**
 * @class
 * @augments LabelData
 * @param  {LabelData|Label|Object} details
 */
function Label(details) {

	var label = this;

	details = $j.extend({
		id : 0,
		name : '',
		description : '',
		image : '',
		catalog : null,
		album_count : 0,
		artist_count : 0,
		count : 0,
		featured : false
	}, details);

	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		label[i] = details[i];
	}

	label.generateArtElement = function(options) {

		options = $j.extend({
			listType : 'label',
			hovers : true,
			showing : false,
			size : 'normal'
		}, options);

		var classes = [ 'list_block', options.listType + '_block' ];
		if (label.featured) classes.push('featured');
		if (options.size != 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');

		const div = $j(`
			<div id="item_${label.id}" class="${classes.join(' ')}">
				<a href="${getLabelLink(label.id)}" class="art_image">
					<img src="${label.image}"/>
					<div class="buttons"></div>
					${label.featured ? '<div class="featured"></div>' : ''}
				</a>
				<div class="info">
					<a href="${getLabelLink(label.id)}" title="${label.name.replace(/"/g, '&quot;')}">${label.name}</a>
					<span class="item-detail label-item-detail">${([72, 87, 114].includes(config.id) ? '<span class="emphasis">Sound Effects: ' : '<span class="emphasis">Tracks' + (config.id == 752 ? ' and Stems' : '') + ':</span> ') + numberFormat(label.count)}</span>
					<span class="item-detail label-item-detail"><span class="emphasis">${label.album_count ? '<br>' + config.getDictionaryEntry('album', true) + ':</span> ' + numberFormat(label.album_count) : ''}</span>
				</div>
			</div>
		`);
		
		// store the label
		div.data('label', label);
		
		if (label.image == '') {
			div.find('.art_image img').remove()
			div.find('.art_image').prepend(getDefaultArtElement('label'))
		}

		if (options.hovers && sa.useHovers && (user.hasAdminPermission(AdminPermission.Feature) || label.editable)) {
			// what follows has to do with setting up the hover interaction layer
			var buttonContainer = div.find('.buttons');
			if (user.hasAdminPermission(AdminPermission.Feature)) {
				buttonContainer.append(sa.components.buttons.generateFeatureButton({ id : label.id, type : 'label', featured : label.featured }));
			}
			if (label.editable) {
				buttonContainer.append(sa.components.buttons.generateEditButton({ type : 'label', item : label }));
			}
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};

}

/**
 * MusicSupplierData object type reference
 * @typedef {object} MusicSupplierData
 * @property {int} id
 * @property {int} supplierId - converts to id on MusicSupplier creation
 * @property {string} name
 * @property {string} image full page
 * @property {int} label_count
 * @property {int} album_count
 * @property {int} artist_count
 * @property {int} track_count
 * @property {boolean} featured
 * @property {MusicSupplierLicensing} licensing
 */

/**
 * MusicSupplier object type reference
 * @class
 * @augments MusicSupplierData
 * @param {MusicSupplierData|MusicSupplier|Object} details
 */
function MusicSupplier(details) {

	var musicSupplier = this;
	
	if (details.supplierId) {
		details.id = details.supplierId;
		delete details.supplierId;
	}

	details = $j.extend({
		id : 0,
		name : '',
		image : '',
		label_count : 0,
		album_count : 0,
		artist_count : 0,
		track_count : 0,
		featured : 0,
		licensing : null
	}, details);

	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		musicSupplier[i] = details[i];
	}

}

/**
 * ProjectData object type reference
 * @typedef {Object} ProjectData
 * @property {int} id
 * @property {string} name
 * @property {string} description
 * @property {string} image
 * @property {boolean} created
 * @property {boolean} shared
 * @property {boolean} featured
 * @property {int} trackCount
 * @property {int} albumCount
 * @property {int} totalTrackCount
 * @property {int} unfilteredTrackCount
 * @property {int} dateCreated unix timestamp
 * @property {int} dateAltered unix timestamp
 * @property {ProjectPublishSetting} publish
 * @property {boolean} includeNested
 * @property {int} userId
 * @property {int} whiteId
 * @property {int} folderId
 * @property {boolean} canEdit
 * @property {MusicSupplier} musicSupplier
 */

/**
 * @class
 * @augments ProjectData
 * @param  {ProjectData|Project} details
 */
function Project(details) {

	var project = this;
	const isHomePage = sa.router.isHomePage();

	details = $j.extend({
		id : 0,
		name : '',
		description : '',
		image : '',
		created : true,
		shared : false,
		featured : false,
		trackCount : 0,
		albumCount : 0,
		totalTrackCount : 0,
		unfilteredTrackCount : 0,
		dateCreated : 0,
		dateAltered : 0,
		publish : null,
		includeNested : false,
		userId : 0,
		whiteId : 0,
		folderId : 0,
		canEdit : false,
		musicSupplier : null
	}, details);

	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		project[i] = details[i];
	}

	project.generateArtElement = function(options) {

		options = $j.extend({
			listType : 'project',
			hovers : true,
			showing : false,
			size : 'normal'
		}, options);

		var classes = [ 'list_block', options.listType + '_block' ];
		if (project.featured) classes.push('featured');
		if (options.size != 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');

		const div = $j(`
			<div id="item_${project.id}" class="${classes.join(' ')}">
				<a href="${getProjectLink(project.id, project.name)}" class="art_image">
					<img src="${project.image}"/>
					<div class="buttons"></div>
					${project.featured ? '<div class="featured"></div>' : ''}
				</a>
				<div class="info">
					<a href="${getProjectLink(project.id, project.name)}" title="${project.name.replace(/"/g, '&quot;')}">${project.name}</a>
					<span class="item-detail playlist-item-detail"><span class="emphasis">Total ${[72, 87, 114].includes(config.id) ? 'Sound Effects' : 'Tracks'}:</span> ${numberFormat(project.totalTrackCount)}
				</div>
			</div>
		`);
		
		// store the project
		div.data('project', project);

		if (project.image == '') {
			div.find('.art_image img').remove()
			div.find('.art_image').prepend(getDefaultArtElement('project'))
		}

		if (options.hovers && sa.useHovers && (user.hasAdminPermission(AdminPermission.Feature) || project.editable)) {
			// what follows has to do with setting up the hover interaction layer
			var buttonContainer = div.find('.buttons');
			var downloadAnchor = sa.components.downloadFormatSelector.generateDownloadButton({ type : 'project', item : project });
			var hovers = 0;
			buttonContainer.append(downloadAnchor);
			div.find('.art_image').add(downloadAnchor.getContainer()).on('mouseenter.hovers', function() {
				div.addClass('hovering');
				hovers++;
			})
			.on('mouseleave.hovers', function() {
				hovers--;
				setTimeout(function() {
					if (hovers < 1) {
						div.removeClass('hovering');
						hovers = 0;
					}
				}, 50);
			});
			buttonContainer.append(sa.components.emailer.generateEmailButton({ type : 'project', item : project }));
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};

}

/**
 * PublisherData object type reference
 * @typedef {Object} PublisherData
 * @property {int} id
 * @property {string} name
 * @property {string} image full path
 * @property {Number} ownershipShare
 * @property {Affiliation} affiliation
 * @property {string} ipi
 * @property {string} affiliationNumber
 * @property {Role} role
 * @property {Array.<PublisherCollectionShare>} collectionShares
 * @property {int} featured
 */

/**
 * Publisher object type reference
 * @class
 * @augments PublisherData
 * @param {PublisherData|Publisher|Object} details
 */
function Publisher(details) {

	var publisher = this;

	details = $j.extend({
		id : 0,
		name : '',
		image : '',
		ownershipShare : 0,
		affiliation : null,
		publisherId : 0,
		ipi : '',
		affiliationNumber : 0,
		role : null,
		collectionShares : [],
		featured : 0
	}, details);

	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		publisher[i] = details[i];
	}

	publisher.generateArtElement = function(options) {
		options = $j.extend({
			listType : 'publisher',
			hovers : true,
			showing : false,
			size : 'normal'
		}, options);

		var classes = [ 'list_block', options.listType + '_block' ];
		if (publisher.featured) classes.push('featured');
		if (options.size != 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');
		
		const div = $j(`
			<div id="item_${publisher.id}" class="${classes.join(' ')}">
				<a href="${getPublisherLink(publisher.id)}" class="art_image">
					<img src="${publisher.image}"/>
					<div class="buttons"></div>
					${publisher.featured ? '<div class="featured"></div>' : ''}
				</a>
				<div class="info">
					<a href="${getPublisherLink(publisher.id)}" title="${publisher.name.replace(/"/g, '&quot;')}">${publisher.name}</a>
					<span class="item-detail publisher-item-detail">${[72, 87, 114].includes(config.id) ? '<span class="emphasis">Sound Effects: ' : '<span class="emphasis">Tracks' + (config.id === 752 ? ' and Stems' : '') + ':</span> '} ${numberFormat(publisher.track_count)}</span>
					<span class="item-detail publisher-item-detail">${publisher.album_count ? '<br><span class="emphasis">' + config.getDictionaryEntry('album', true) + ':</span> ' + numberFormat(publisher.album_count) : ''}</span>
				</div>
			</div>
		`);
		
		// store the publisher
		div.data('publisher', publisher);


		if (publisher.image == '') {
			div.find('.art_image img').remove()
			div.find('.art_image').prepend(getDefaultArtElement('publisher'))
		}

		if (options.hovers && sa.useHovers && (user.hasAdminPermission(AdminPermission.Feature) || publisher.editable)) {
			// what follows has to do with setting up the hover interaction layer
			var buttonContainer = div.find('.buttons');

			// featuring
			if (user.hasAdminPermission(AdminPermission.Feature)) {
				buttonContainer.append(sa.components.buttons.generateFeatureButton({ id : publisher.id, type : 'publisher', featured : publisher.featured }));
			}
			if (publisher.editable) {
				buttonContainer.append(sa.components.buttons.generateEditButton({ type : 'publisher', item : publisher }));
			}
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};

}

/**
 * WriterData object type reference
 * @typedef {Object} WriterData
 * @property {int} id
 * @property {string} name
 * @property {string} lastName
 * @property {string} image
 * @property {Number} ownershipShare
 * @property {Affiliation} affiliation
 * @property {string} affiliationNumber
 * @property {int} publisherId
 * @property {string} ipi
 * @property {Role} role
 * @property {int} featured
 */

/**
 * Writer object type reference
 * @class
 * @augments WriterData
 * @param {WriterData|Writer|Object} details
 */
function Writer(details) {

	var writer = this;

	details = $j.extend({
		id : 0,
		name : '',
		lastName : '',
		image : '',
		ownershipShare : 0,
		affiliation : null,
		publisherId : 0,
		ipi : '',
		affiliationNumber : 0,
		role : null,
		featured : 0
	}, details);

	for (var i in details) {
		if (!details.hasOwnProperty(i)) continue;
		writer[i] = details[i];
	}

	writer.generateArtElement = function(options) {
		options = $j.extend({
			listType : 'writer',
			hovers : true,
			showing : false,
			size : 'normal'
		}, options);

		var classes = [ 'list_block', options.listType + '_block' ];
		if (writer.featured) classes.push('featured');
		if (options.size != 'normal') classes.push(options.size);
		if (options.showing) classes.push('showing');

		const div = $j(`
			<div id="item_${writer.id}" class="${classes.join(' ')}">
				<a href="${getWriterLink(writer.id)}" class="art_image">
					<img src="${writer.image}"/>
					<div class="buttons"></div>
					${writer.featured ? '<div class="featured"></div>' : ''}
				</a>
				<div class="info">
					<a href="${getWriterLink(writer.id)}" title="${writer.name.replace(/"/g, '&quot;')}">${writer.name}</a>
					<span class="item-detail writer-item-detail">${([72, 87, 114].includes(config.id) ? '<span class="emphasis">Sound Effects: ' : '<span class="emphasis">Tracks' + (config.id == 752 ? ' and Stems' : '') + ':</span> ') + numberFormat(writer.track_count)}</span>
					<span class="item-detail writer-item-detail">${writer.album_count ? '<br/>' + config.getDictionaryEntry('album', true) + ': ' + numberFormat(writer.album_count) : ''}</span>
				</div>
			</div>
		`);
		
		// store the writer
		div.data('writer', writer);

		if (writer.image == '') {
			div.find('.art_image img').remove()
			div.find('.art_image').prepend(getDefaultArtElement('person'))
		}

		if (options.hovers && sa.useHovers && (user.hasAdminPermission(AdminPermission.Feature) || writer.editable)) {
			// what follows has to do with setting up the hover interaction layer
			var buttonContainer = div.find('.buttons');
			// featuring
			if (user.hasAdminPermission(AdminPermission.Feature)) {
				buttonContainer.append(sa.components.buttons.generateFeatureButton({ id : writer.id, type : 'writer', featured : writer.featured }));
			}
			if (writer.editable) {
				buttonContainer.append(sa.components.buttons.generateEditButton({ type : 'writer', item : writer }));
			}
		} else {
			div.find('.buttons').remove();
		}

		return div;
	};

}

/**
 * A Focus Box object that gently borders content
 * @param {JQuery|HTMLElement} child the object to put on the interior of the focus box
 * @param {Object=} options
 * 	@property {boolean} allowReuse when the box hides, should it do so without destroying? def: false
 * 	@property {boolean} showClose should the box show its own close button? if you need a close button, please use this. def: false
 * 	@property {function} onClose function to call on hide. def: null
 *	@property {boolean} lightbox should the focus box be lightboxed? def: true
 *  @property {string} title any title that should appear at the heading at the top
 *  @property {int} verticalIndent if set, the focus box will make sure it has that many px above when max sizing
 *  @property {boolean} preventRemoval if set, this box will not close when removeFocusBoxes() is called
 *  @property {boolean} preventClose if set, clicking the background will not close the fb. be very careful
 *  @property {int} fillScreenAtLowResolution if set, the focus box will be almost full screen on small widths (leaves a little space for aesthetics)
 *  @property {int} fillWidthAtLowResolution if set, the focus box will be full width on small widths (smaller than this number)
 */
function FocusBox(child, options) {
	var fb = this;

	var templates = sa.templates.get('focus_box');

	/** @var {JQuery} */
	var cover;

	var centerInterval;
	var focusedContent;

	child = $j(child);

	options = $j.extend({
		additionalClasses: [],
		showClose : false,
		onClose : null,
		lightbox : true,
		allowReuse : false,
		title : '',
		verticalIndent : 0,
		preventRemoval : false,
		preventClose : false,
		fillScreenAtLowResolution : 0,
		fillWidthAtLowResolution : 0
	}, options);

	/** @var {JQuery} */
	this.div = null;
	this.preventRemoval = options.preventRemoval;

	child[0].fb = this;

	/**
	 * @returns {JQuery}
	 */
	this.getFocusedContainer = function() {
		return this.div;
	};

	/**
	 * Shows the focus box
	 */
	this.show = function() {
		var body = $j('body');
		if (cover) {
			body.append(cover);
		}
		
		if (options.additionalClasses) {
			fb.div.addClass(options.additionalClasses.join(' '));
		}
		
		body.append(fb.div);
		setTimeout(function() {
			fb.div.removeClass('closing');
			if (cover) {
				cover.removeClass('closing');
			}
			setTimeout(function () {
				// if (BrowserDetect.isChrome) {
				// 	fb.div.css({ transform : 'scale(1)' });
				// }
				fb.center();
				centerInterval = setInterval(function () {
					fb.center();
				}, 200);
				sa.forms.update(fb.div);
			}, 250);
		}, 10);

		stopCenterCheck();
		this.div.on('destroyed', function() {
			stopCenterCheck();
		});
		return this;
	};

	function stopCenterCheck() {
		if (centerInterval) {
			clearInterval(centerInterval);
			centerInterval = null;
		}
	}

	/**
	 * Hides the focus box
	 * @param {function=} callback called on close
	 */
	this.hide = function(callback) {
		stopCenterCheck();
		this.div.css({ marginTop : '', marginLeft : '', transform : '' });
		this.div.addClass('closing');
		if (cover) {
			cover.addClass('closing');
		}
		
		setTimeout(function() {
			if (options.additionalClasses) {
				fb.div.removeClass(options.additionalClasses.join(' '));
			}
			
			if (options.allowReuse) {
				fb.div.detach();
				if (cover) {
					cover.detach();
				}
			} else {
				fb.div.remove();
				if (cover) {
					cover.remove();
				}
			}
			if (callback) {
				callback();
			}
		}, 250);
		if (options.onClose != null) {
			options.onClose();
		}
		return this;
	};

	var lastWindowHeight = 0;
	var lastFocusedContainerHeight = 0;
	var lastFocusedContainerWidth = 0;
	var lowResolution = false; // used by options.fillScreenAtLowResolution
	var lowWidth = false; // used by options.fillWidthAtLowResolution
	this.center = function() {
		const minimumVerticalDistance = 20; // between top and bottom of focus box and top and bottom of window
		const padToEvenPixels = BrowserDetect.isChrome; // at odd pixel heights, translateY(50%) causes Chrome to render at fractional pixels and blur the focus box. we pad an extra pixel to prevent this
		var focusedContainer = this.div;
		var focusedContentActual = child;

		var isMobile = sa.isMobile();

		if (isMobile) {
			focusedContainer.addClass('fill_screen');
			return;
		} else {
			focusedContainer.removeClass('fill_screen');
		}
		
		if (window.innerWidth < options.fillScreenAtLowResolution) {
			if (!lowResolution) {
				lowResolution = true;
				if (padToEvenPixels) {
					focusedContainer.css({ paddingBottom : '', paddingRight : '' });
				}
				focusedContentActual.css({ maxHeight : '', paddingRight : '' });
				focusedContainer.addClass('fill_screen');
				focusedContainer.find('#focus_close').show();
			}
			return;
		} else if (lowResolution) {
			focusedContainer.removeClass('fill_screen');
			lowResolution = false;
			if (!options.showClose) {
				focusedContainer.find('#focus_close').hide();
			}
		}

		if (window.innerWidth < options.fillWidthAtLowResolution) {
			if (!lowWidth) {
				lowWidth = true;
				if (padToEvenPixels) {
					focusedContainer.css({ paddingRight : '' });
				}
				focusedContentActual.css({ paddingRight : '' });
				focusedContainer.addClass('fill_width');
			}
			return;
		} else if (lowWidth) {
			focusedContainer.removeClass('fill_width');
			lowWidth = false;
		}

		var windowInnerHeight = window.innerHeight; // - verticalIndent;
		// 2020-07-03 RAC - we're using getBoundingClientRect because it returns float values and I found an issue on the site manager where focusedContainer.outerWidth() and focusedContentActual.outerWidth() were both X.5 but
		// the former would round down and the latter would round up, causing focusedContainerHeight to never equal lastFocusedContainerHeight on subsequent calls to center and the focus box would constantly recenter
		let focusedContainerBoundingClientRect = focusedContainer[0].getBoundingClientRect();
		var focusedContainerHeight = focusedContainerBoundingClientRect.height;
		var focusedContainerWidth = focusedContainerBoundingClientRect.width;
		var maxFocusedContainerHeight;
		var maxFocusedContentActualHeight;
		var initialScrollTop;

		if (lastWindowHeight != windowInnerHeight || Math.abs(focusedContainerHeight - lastFocusedContainerHeight) > 1 || Math.abs(focusedContainerWidth - lastFocusedContainerWidth) > 1) {
			focusedContainer[0].style.transition = 'initial';//.css({ transition : 'initial' });
			initialScrollTop = focusedContentActual[0].scrollTop;
			focusedContentActual.css({ maxHeight : '', paddingRight : '' });
			if (padToEvenPixels) {
				focusedContainer.css({ paddingBottom : '', paddingRight : '' });
			}
			focusedContainerBoundingClientRect = focusedContainer[0].getBoundingClientRect()
			focusedContainerHeight = focusedContainerBoundingClientRect.height;
			focusedContainerWidth = focusedContainerBoundingClientRect.width;
			maxFocusedContainerHeight = windowInnerHeight - minimumVerticalDistance * 2;
			if (focusedContainerHeight > maxFocusedContainerHeight) {
				maxFocusedContentActualHeight = maxFocusedContainerHeight - (focusedContainerHeight - focusedContentActual[0].getBoundingClientRect().height);
				focusedContentActual.css({ maxHeight : maxFocusedContentActualHeight });
				focusedContentActual.css({ paddingRight : 40 - (focusedContentActual[0].offsetWidth - focusedContentActual[0].clientWidth) });
				focusedContainerHeight = maxFocusedContainerHeight;
				focusedContentActual[0].scrollTop = initialScrollTop;
			}

			if (padToEvenPixels) {
				if (focusedContainerHeight % 2) {
					focusedContainerHeight += 1;
					focusedContainer.css({ paddingBottom : '1px' });
				} else {
					focusedContainer.css({ paddingBottom : '' });
				}
				if (focusedContainerWidth % 2) {
					focusedContainerWidth += 1;
					focusedContainer.css({ paddingRight : '1px' });
				} else {
					focusedContainer.css({ paddingRight : '' });
				}
			}

			focusedContainer[0].style.transition = '';//.css({ transition : '' });
		}
		lastWindowHeight= windowInnerHeight;
		lastFocusedContainerHeight = focusedContainerHeight;
		lastFocusedContainerWidth = focusedContainerWidth;
	};

	/**
	 * Resizes the FocusBox to fit its content
	 */
	this.resize = function() {
	};

	this.showFormValidationErrors = function(validationResult) {
		var errors = [];
		validationResult.errors.each(function (i, error) {
			errors.push(error.errorDetail);
		});
		this.showErrorMessage(templates.get('form_validation_errors', { errors : errors.join('</li><li>') }));
	};

	this.showErrorMessage = function(message) {
		showMessage('error', message.clone(true));
	};
	this.hideErrorMessage = function() {
		hideMessage();
	};

	this.showSuccessMessage = function(message) {
		showMessage('success', message.clone(true));
	};
	this.hideSuccessMessage = function() {
		hideMessage();
	};

	var lastMessage = '';

	function showMessage(type, message) {
		var template = templates.get('message', { type : type });
		template.find('.focus_box_message_contents').append(message);

		var messageHtml = template[0].outerHTML;
		if (messageHtml == lastMessage) return;
		hideMessage();
		lastMessage = messageHtml;

		template.css({ width : child.outerWidth() });
		child.before(template);

		var height = template.height();
		template.css({ height : 0 });
		setTimeout(function() {
			template.css({ height : height });
			// Move the content down below the message on mobile
			let $contentActual = fb.div.find('.focused_content_actual')
			if (sa.isMobile() && $contentActual.length) {
				$contentActual.css('top', parseInt($contentActual.css('top')) + height )
			}
			setTimeout(function() {
				resizeLoader();
			}, 150);
		}, 150);
		fb.div.addClass('showing_message');
	}

	function hideMessage() {
		var messageDiv = fb.div.find('.focus_box_message');
		messageDiv.css({ height : 0 });
		setTimeout(function() {
			messageDiv.remove();
			resizeLoader();
		}, 150);
		lastMessage = '';
		fb.div.removeClass('showing_message');
	}

	this.showLoader = function(message) {
		var loader = templates.get('focus_box_loader', { text : message });
		this.div.append(loader);
		setTimeout(function() {
			loader.addClass('showing');
		}, 50);
	};

	this.hideLoader = function() {
		var focusBoxLoader = this.div.find('.focus_box_loader').removeClass('showing');
		setTimeout(function() {
			focusBoxLoader.remove();
		}, 150);
	};

	/**
	 * The browser (chrome) doesn't always resize an absolute, top, bottom, left, right: 0 element when the parent resizes
	 * This function forces it
	 */
	function resizeLoader() {
		var loader = fb.div.find('.focus_box_loader');
		loader.removeAttr('style');
		setTimeout(function() {
			loader.css({ height : '100%' });
		}, 25);
		setTimeout(function() {
			loader.removeAttr('style');
		}, 50);
	}

	/**
	 * Hides the content of the focus box, like if it's job is over and you've displaying a success message
	 * IMPORTANT NOTE: display the success message first. it bases its width on the content width
	 */
	this.hideContent = function() {
		child.animate({ height : 0, paddingTop : 0, paddingBottom : 0 }, 150, function() {
			child.remove();
		});
		fb.div.addClass('hiding_content');
	};

	/**
	 * Sets the title to something else, creating the title element if it doesn't exist
	 * @param {string} newTitle
	 */
	this.setTitle = function(newTitle) {
		var titleContainer = this.div.find('.focus_box_title');
		if (!titleContainer.length) {
			child.before(templates.get('title', { title : newTitle }));
		} else {
			titleContainer.empty().append(newTitle);
		}
	};

	/**
	 * Creates a new focus box using the parameters in the original FocusBox call
	 */
	this.init = function() {
		var div = templates.get('focus_box');
		child.addClass('focused_content_actual');
		focusedContent = div.find('.focused_content').append(child);
		div.data('focusBox', this);
		this.div = div;

		if (options.title) {
			child.before(templates.get('title', { title : options.title }));
			div.addClass('with_title');
		}

		// always enable the close button and just hide it if we're not showing it in case we want to show it again at low resolution
		div.find('#focus_close').on('click', function() {
			fb.hide();
		});
		if (!options.showClose) {
			div.find('#focus_close').hide();
		}

		sa.on('view_mobile', function() {
			div.find('#focus_close').show();
		});

		if (options.lightbox) {
			cover = templates.get('focus_box_cover');
			if (!options.preventClose) {
				cover.on('click', function () {
					fb.hide();
				});
			}
		}
	};

	this.init();
}

/**
 * Removes all currently visible focus boxes
 */
function removeFocusBoxes() {
	$j('.focused_container').each(function() {
		var box = $j(this).data('focusBox');
		// theoretically, you could just call box.hide(). You could skip the whole var box = thing altogether. But that doesn't work
		// for all focus boxes (track list expanded containers). So we do this instead
		if (!box || !box.preventRemoval) {
			if (box) {
				box.hide();
			} else {
				$j(this).remove();
			}
		}
	});
}

sa.on('beforeRouteChange', function() {
	removeFocusBoxes();
});

/**
 * @param {JQuery} template
 * @param {Object} options
 * @returns {FocusBox}
 */
sa.showFocusBox = function(template, options) {
	let fb = new FocusBox(template, options);
	fb.show();
	return fb;
};
function FlyoutMenu(child, options = {}) {
	var flyout = this;
	var alignment = options.alignment || 'right'; // default
	var showClose = options.showClose || true; // default
	var closeHtml = options.closeHtml || 'X';
	var showCover = options.showCover || true;
	var extraClasses = options.classes || [];
	var cover = false;

	extraClasses.push(alignment);
	this.div = $j('<div class="flyout_menu ' + extraClasses.join(' ') +'"></div>')
	if (showClose) {
		var $close = $j('<a class="close-flyout">' + closeHtml + '</a>');
		$close.on('click', function() { 
			console.log("clicking close flyout");
			flyout.hide() 
		})
		this.div.append($close);
	}
	if (showCover) {
		cover = sa.templates.get('focus_box').get('focus_box_cover');
	}
	this.div.append($j(child));
	this.showing = false;
	this.rendered = false;

	this.show = function () {
		this.showing = this.div.hasClass('show');

		if (!this.showing) {
			this.div.addClass('show');
			if (cover) cover.show()
		}

		this.showing = true;
	
	
		return this;
	}

	this.hide = function() {
		this.showing = this.div.hasClass('show');

		if (this.showing) {
			this.div.removeClass('show');
			if (cover) cover.hide()
		}

		this.showing = false;
	}

	this.attach = function() {
		if (!this.rendered) {
			var body = $j('body');
			if (cover) {
				cover.on('click', function() {
					flyout.hide();
				})
				body.append(cover);
				cover.hide()
			}
			body.append(flyout.div);
			this.rendered = true;
		}
	}
}class TabBrowseButtons {
	/**
	 * Given a root element which wraps inner tabs that have the selector `tabSelector`,
	 * this will cause the container to stay on one line and allow a user to scroll 
	 * through the tabs with little buttons on either side of the container rather than
	 * with a scroll bar.
	 * 
	 * 
	 * @param {HTMLElement} root The container to make a tab browser container
	 * @param {string} tabSelector the selector for the tabs
	 */
	constructor(root, tabSelector) {
		this.$tabs = root.find(tabSelector);
		this.tabSelector = tabSelector;
		this.$el = root;
		this.el = root[0];
		this.$tabLeft = $j('<a class="tab_browse_left"><i class="fa fa-angle-double-left"></i></a>');
		this.$tabRight = $j('<a class="tab_browse_right"><i class="fa fa-angle-double-right"></i></a>');
		this.$tabBrowse = $j('<div class="tab_browse_buttons"></div>');
		this.$farthestRightTab = this.$tabs.filter(':last-of-type');


		// set tab colors
		this.setTabColors();
		this.initialPosition = root.css('position');

		// whether it's on or not
		this.enabled = false;

		// Generate HTML
		this.$tabBrowse.append(this.$tabLeft).append(this.$tabRight);
		root.append(this.$tabBrowse);

		// bind events on render
		this.debounceTime = 150;
		this.disableScroll = false;

		const renderInt = setInterval(() => {
			if (document.contains(root[0])) {
				clearInterval(renderInt);
				this.onRender();
			}
		}, this.debounceTime)
	}

	onRender() {
		if ("ResizeObserver" in window) {
			this.resizeObserver = new ResizeObserver(this.onResize.bind(this));
			this.resizeObserver.observe(this.el);
		} else {
			sa.on('left_nav_resize', this.onResize.bind(this));
		}

		// scroll left when click the left arrow
		this.$tabLeft.on('click', () => {
			requestAnimationFrame(this.scrollLeft.bind(this));
		});

		// scroll right when click the right arrow
		this.$tabRight.on('click', () => {
			requestAnimationFrame(this.scrollRight.bind(this));
		});
	}

	run() {
		if (!this.enabled) return;
		// won't run unless enabled
		this.fixOversizeScrollArea();
		this.scrollToSelectedTab();
		this.showHideTabs();
	}


	enable() {
		// 
		//console.log("enabling tab browse buttons", document.contains(this.el));
		// make container position relative so we can position the browse buttons
		// within it
		this.$el.addClass("tab_browse_container");
		if (this.$el.css('position') == 'static') {
			this.$el.css({ position: 'relative' });
		}

		this.$tabs.addClass('tab_browse');

		// hide tabs on start scroll
		this.$el.on('scroll.tabs', _.debounce(() => {
			if (this.disableScroll) return;
			// console.log("calling on scroll")
			this.hideTabs();
		}, this.debounceTime - 50, {leading: true, trailing: false}));

		// show tabs on end scroll
		this.$el.on('scroll.tabs', _.debounce(() => {
			if (this.disableScroll) return;
			// console.log("calling end scroll")

			this.showHideTabs();
		}, this.debounceTime, {leading: false, trailing: true}));

		this.enabled = true;
		$j(window).on('orientationchange.tabs', this.scrollToSelectedTab.bind(this));
		sa.on('routeChange', this.onRouteChange.bind(this));
		sa.on('start', this.scrollToSelectedTab.bind(this));
	}

	async scrollToSelectedTab() {
		if (!this.enabled) return;
		const selectedTab = this.$tabs.filter('.selected');
		if (selectedTab.length == 0) return;
		await this.waitForScroll().catch(e => {});
		// scroll our selected element into view
		selectedTab.first()[0].scrollIntoView(false);
	}

	async fixOversizeScrollArea() {
		if (!this.enabled) return;
		await this.waitForScroll().catch(e => {});
		
		const fudgePx = 5 + parseInt(this.$farthestRightTab.css('marginRight'));
		const scrollWidth = this.el.scrollWidth;
		const farthestRightOffsetRight = Math.ceil(this.$farthestRightTab[0].offsetLeft + this.$farthestRightTab[0].clientWidth);
		if (farthestRightOffsetRight + fudgePx < scrollWidth) {
			this.el.scrollLeft = farthestRightOffsetRight - this.el.clientWidth;
		}
	}

	/**
	 * Enables or disables this functionality
	 * 
	 * @param {ResizeObserverEntry} resizeEntry Optional entry from a ResizeObserver
	 * 
	 * @returns Boolean
	 */
	checkEnable(resizeEntry) {
		const self = this;

		const scrollWidth = this.el.scrollWidth;
		const childElSelectors = ['.nav_item', '.tab'].join(', ');
		const childrenWidth = this.$el.children(childElSelectors).toArray().reduce((acc, item) => acc + item.clientWidth, 0);
		const clientWidth = (resizeEntry ? resizeEntry.contentRect.width : self.el.clientWidth);
		const widerScrollThanElement = (scrollWidth > clientWidth) || (childrenWidth > clientWidth);
		
		if (scrollWidth === 0) return;

		let enable = false;
		if (!this.enabled) {
			let $tabsWrapped = this.$tabs.filter(function () {
				return $j(this).position().top > 0;
			});

			enable = ($tabsWrapped.length > 0 || widerScrollThanElement);
		} else {
			// already enabled
			enable = widerScrollThanElement;
		}

		if (enable && !this.enabled) {
			this.enable();
		} else if (!enable && this.enabled) {
			this.disable();
		}
	}

	onResize(entries = []) {
		if (!entries) return;
		const entry = Array.isArray(entries) ? entries.shift() : null;
		this.checkEnable(entry);
		this.run();
	}
	onRouteChange() {
		this.checkEnable();
		this.run();
	}
	disable() {
		console.log("disabling tab browse");
		this.enabled = false;
		this.hideTabs();
		this.$el.off('scroll.tabs');
		this.$el.css('position', '');
		sa.off('routeChange', this.onRouteChange.bind(this));
		$j(window).off('orientationchange.tabs');
		this.$tabs.removeClass('tab_browse');
		this.$el.removeClass("tab_browse_container");
	}

	disableScrollHandlers() {
		this.disableScroll = true;
	}

	enableScrollHandlers() {
		setTimeout(() => {
			this.disableScroll = false;
		}, this.debounceTime + 50);
	}
	async scrollLeft() {
		if (!this.enabled) return;

		this.disableScrollHandlers();
		let scrollLeft = this.el.scrollLeft - document.documentElement.clientWidth;
		this.el.scrollLeft = scrollLeft;
		this.hideTabs();
		this.showHideTabs();

		this.enableScrollHandlers();
	}

	/**
	 * Because of browser scroll events not happening instantly--i.e. using some 
	 * easing function via CSS 'scroll-behavior'--when you query for a scroll position, 
	 * the browser may not actually be done scrolling.
	 * 
	 * There's no 'scrollend' event, so this is a way to check that the
	 * browser scrolling has actually finished
	 * 
	 * @returns {Promise}
	 */
	async waitForScroll() {
		const self = this;
		const maxRun = 30;
		let runs = 0;
		return new Promise((resolve, reject) => {
			let same = 0;
			let lastScrollLeft = null;
			// if we get the same scroll left value more than 2 times in a row, we are done scrolling
			const checkDoneScrolling = () => {
				const newScrollLeft = self.el.scrollLeft;

				if (newScrollLeft == lastScrollLeft) {
					same++;
					if (same > 2) {
						return resolve();
					}
				} else {
					// scroll value wasn't the same, start over
					same = 0;
				}
				lastScrollLeft = newScrollLeft;
				// check again next painting frame
				requestAnimationFrame(checkDoneScrolling);
				runs++;

				if (runs >= maxRun) {
					console.error("waited forever to finish scrolling, can't stop, won't stop");
					return reject();
				}
			};

			requestAnimationFrame(checkDoneScrolling);
		});

	}

	async scrollRight() {
		if (!this.enabled) return;
		this.disableScrollHandlers();
		let scrollLeft = this.el.scrollLeft + document.documentElement.clientWidth;
		this.el.scrollLeft = scrollLeft;

		this.hideTabs();
		this.showHideTabs();

		this.enableScrollHandlers();
	}

	hideTabs() {
		this.$tabRight.removeClass('show');
		this.$tabLeft.removeClass('show');
	}

	/**
	 * This is what checks whether to show the left/right buttons and then places them in the right position
	 */
	async showHideTabs() {
		if (!this.enabled) return;
		await this.waitForScroll().catch(e => {});
		// check one more time in case we got disabled while we were waiting to stop scrolling
		if (!this.enabled) return;
		const scrollWidth = this.el.scrollWidth;
		const childrenWidth = this.$el.children('.nav_item').toArray().reduce((acc, item) => acc + item.clientWidth, 0);
		const scrollLeft = this.el.scrollLeft;
		const scrollRight = scrollLeft + this.el.clientWidth;
		const fudgePx = 10;
		const isOnLeft = scrollLeft <= fudgePx;
		const isOnRight = scrollRight >= (scrollWidth - fudgePx);

		// position the browse buttons
		if (scrollLeft == 0) {
			this.$tabBrowse[0].style.left = '';
		} else {
			this.$tabBrowse[0].style.left = scrollLeft + 'px';
		}

		// show or hide the buttons
		if (isOnRight) {
			this.$tabRight.removeClass('show');
		} else {
			this.$tabRight.addClass('show');
		}
		if (isOnLeft) {
			this.$tabLeft.removeClass('show');
		} else {
			this.$tabLeft.addClass('show');
		}

		if (isOnRight && isOnLeft) {
			if (childrenWidth > scrollWidth) {
				this.$tabLeft.addClass('show');
				this.$tabRight.addClass('show');
			} else {
				this.$tabLeft.removeClass('show');
				this.$tabRight.removeClass('show');
			}
		}
	}

	setTabColors() {
		const $tab = this.$tabs.first();
		const css = {
			color: $tab.css('color'),
			backgroundColor: $tab.css('background-color'),
		};
		this.$tabLeft.css(css);
		this.$tabRight.css(css);
	}
}

function get(id, element) {
	if(!element) {
		return document.getElementById(id);
	} else {
		for (var i = 0; i < element.childNodes.length; i++) {
			if (element.childNodes[i].id == id) {
				return element.childNodes[i];
			}
			if (element.childNodes[i].childNodes.length) {
				var ret = get(id, element.childNodes[i]);
				if (ret != null) {
					return ret;
				}
			}
		}
		return null;
	}
}

function getDimensions(elem) {
	return {'width':elem.offsetWidth,'height':elem.offsetHeight};
}

function getPosition(elem) {
	var l = 0;
	var t = 0;
	do {
		l += elem.offsetLeft;
		t += elem.offsetTop;
	} while (elem = elem.offsetParent);
	return {'x':l,'y':t};
}

function lowest(num1, num2) {
	num1 = num1 ? num1 : 0;
	num2 = num2 ? num2 : 0;
	if (!num1)
		return num2;
	if (!num2)
		return num1;
	return num1 < num2 ? num1 : num2;
}

function getDisplayWidth() {
	return window.innerWidth;
	//return $j(window).width();
}

function getDisplayHeight() {
	return window.innerHeight;
	//return $j(window).height();
}

function getScrollX() {
	var w = 0;
	w = lowest(w, window.pageXOffset);
	w = document.documentElement ? lowest(w, document.documentElement.scrollLeft) : w;
	return document.body ? lowest(w, document.body.scrollLeft) : w;
}

function getScrollY() {
	var w = 0;
	w = lowest(w, window.pageYOffset);
	w = document.documentElement ? lowest(w, document.documentElement.scrollTop) : w;
	return document.body ? lowest(w, document.body.scrollTop) : w;
}

/**
 * Removes all the children from the #body element.
 * You'd think you could do that with $j('#body').html('') or .empty() BUT DON'T DO THAT
 *  If you use jQuery to clear the body, it destroys elements and interactions that might be reused later, like left nav sections
 *  Removing the objects by iterating through the dom's child nodes avoids that issue
 *  Note that this isn't a problem in all browsers but IE in particular loves to forget objects removed by jQuery
 * @param {boolean=} dontHideLeft
 */
function clearBody(dontHideLeft) {
	var body = $j('#body');
	removeChildren(body[0]);
	if (!dontHideLeft && sa.components.leftNav) {
		sa.components.leftNav.hide();
	}
}

/**
 * Removes all children from a node. Like calling node.innerHTML = '' but faster
 * Seriously, I've profiled this 18 different ways and this one seems to the fastest
 * It's still expensive but it's the fastest
 * @param {HTMLElement} elem the element to remove all children from
 */
function removeChildren(elem) {
	if (!elem) return;
	while (elem.childNodes.length)
		elem.removeChild(elem.childNodes[0]);
}

function createElement(name, id, className, child) {
	var e = document.createElement(name);
	if (id != '' && id != undefined)
		e.id = id;
	if (className != '' && className != undefined)
		e.className = className;
	if (child != '' && child != undefined)
		e.appendChild(child);
	return e;
}

function createDiv(id, className, child) {
	var d = createElement('div', id, className);
	if (child != '' && child != undefined)
		d.appendChild(child);
	return d;
}

function createA(id, className, href, onclick, name, text) {
	var a = createElement('a', id, className);
	if (href != '')
		a.href = href;
	if (onclick != '' && onclick != undefined)
		a.addEventListener('click', onclick);
	if (name != '' && name != undefined)
		a.name = name;
	if (text != '' && text != undefined)
		a.innerHTML = text;
	a.addEventListener('focus', function() {this.blur();});
	return a;
}

function createSpan(id, className, child) {
	var d = createElement('span', id, className);
	if (child != '' && child != undefined)
		d.appendChild(child);
	return d;
}

function createTh(id, className, content) {
	var th = document.createElement('th');
	if (id != '' && id != undefined)
		th.id = id;
	if (className != '' && className != undefined)
		th.className = className;
	if (content != '' && content != undefined)
		th.appendChild(content);
	return th;
}

function createP(id, className, text) {
	var p = createElement('p', id, className);
	p.appendChild(createText(text));
	return p;
}

function createH2(text, onclick, className, id) {
	var h2 = createElement('h2', id, className);
	h2.innerHTML = text;
	if (onclick != '' && onclick)
		h2.addEventListener('click', onclick);
	return h2;
}

function createImg(id, className, src) {
	var img = createElement('img', id, className);
	img.src = src;
	return img;
}

function createInput(type, id, className, child) {
	var input = createElement('input', id, className);
	input.type = type;
	if (child) input.appendChild(child);
	return input;
}

function createText(t) {
	return document.createTextNode(t);
}

function createButton(text, id, className, href, onclick) {
	return createA(id, 'button faux_button ' + className, (href ? href : getDefaultLink()), onclick, '', text);
}

window.lastError = null;
window.lastResponse = null;

window['ajax'] = (function() {

	let baseParameters = '';
	let requestTiming = window.location.href.indexOf('ajaxTiming=1') !== -1;

	/**
	 * SourceAudio ajax
	 * 	Replicated in sa.requestCache.ajax so change that if you change these parameters
	 * @param {object|string} vars the variables to be sent, in url format. e.g., var1=asfd&var2=qwer or object format like { var1 : 'asfd', var2 : 'qwer' }
	 * @param {callback=} callback a function to call with a response. will be passed the response object (optional)
	 * @param {string=} method /^GET|POST$/ (optional - defaults to GET)
	 * @param {object|string=} getVars the url formatted vars to pass in via GET if method == 'POST' (optional)
	 * @param {object=} customHeaders any extra headers to be sent with this request (optional)
	 * @return {XMLHttpRequest|ActiveXObject} the request object in case you need to abort() it
	 */
	function ajax(vars, callback, method, getVars, customHeaders) {
		if (method == undefined || (method != 'GET' && method != 'POST')) {
			method = 'GET';
		}
		// parse vars
		if (typeof vars == 'object') {
			vars = createVarStringFromObject(vars);
		}
		var o;
		if (window.XMLHttpRequest) {
			o = new XMLHttpRequest();
		} else if (window.ActiveXObject) {
			o = new ActiveXObject('Microsoft.XMLHTTP');
		}
		
		let addCustomHeaders = function(o) {
			if (customHeaders) {
				for (let headerName in customHeaders) {
					if (!customHeaders.hasOwnProperty(headerName)) continue;
					o.setRequestHeader(headerName, customHeaders[headerName]);
				}
			}
		};

		if (o != null) {
			let activePermissionProfileVar = window['user'] && user.userData.id ? ('&activePermissionProfileId_' + user.userData.id + '=' + user.getActivePermissionProfileId()) : '';
			if (method == 'GET') {
				vars += activePermissionProfileVar;
				if (nocache) vars += '&nocache=1';
				if (requestTiming) vars += '&timing=1&ajaxTiming=1';
				o.open('GET', siteBaseUrl() + '/ajax.php?' + vars + baseParameters, true);
				addCustomHeaders(o);
				o.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						handleAjaxResponse(callback, this.responseText, vars);
					}
				};
				o.send(null);
			} else {
				if (getVars != undefined && typeof getVars == 'object') {
					getVars = createVarStringFromObject(getVars);
				}
				if (getVars == undefined) {
					getVars = siteBaseUrl() + '/ajax.php?' + baseParameters;
				} else {
					getVars = siteBaseUrl() + '/ajax.php?' + getVars + baseParameters;
				}
				getVars += activePermissionProfileVar;
				if (nocache) getVars += '&nocache=1';
				if (requestTiming) getVars += '&timing=1&ajaxTiming=1';
				o.open('POST', getVars, true);
				addCustomHeaders(o);
				o.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
				o.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						handleAjaxResponse(callback, this.responseText, vars);
					}
				};
				o.send(vars);
			}
		}
		
		return o;
	}

	ajax.addBaseParameter = function(name, value) {
		baseParameters += '&' + encodeURIComponent(name) + '=' + encodeURIComponent(value);
		// the sa.api object needs these base parameters too
		if (window['sa'] && window['sa']['api']) {
			// if the sa.api object is already loaded, set now
			sa.api.addBaseParameter(name, value);
		} else {
			// if not, set when it does
			window['sa-api-base-parameters'] = window['sa-api-base-parameters'] || {};
			window['sa-api-base-parameters'][name] = value;
		}
	};
	// used for testing
	ajax.resetBaseParameters = function() {
		baseParameters = '';
	};
	ajax.getBaseParameters = function() {
		return baseParameters;
	};
	ajax.getBasePath = function() {
		return 'ajax.php?' + baseParameters + '&';
	};
	ajax.toggleTiming = function() {
		requestTiming = !requestTiming;
		console.log('ajax request timing ' + (requestTiming ? 'on' : 'off'));
	};

	ajax.promise = function(vars, method, getVars, customHeaders) {
		return new Promise((resolve, reject) => {
			ajax(vars, function(response) {
				// lots of ways to get errors and often we want to handle
				// those as a valid response so no reject logic
				resolve(response);
			}, method, getVars, customHeaders)
		})
	}

	return ajax;

})();



/**
 * Handles one response from the server
 * @param {callback} callback the function to call with the response. Required but can be ''
 * @param {string} response the response from the server. Should be valid json
 * @param {string} vars the information sent to the server. Just used for error sending
 * @param {callback=} errorCallback called if an error occurred
 * @param {boolean=} disableRecursion used internally to denote that recursion has already occurred. don't send this in
 */
function handleAjaxResponse(callback, response, vars, errorCallback, disableRecursion) {
	if (!response) return;
	var parseSuccess = false;
	try {
		var resp = JSON.parse(response);

		if (resp['nonceError']) {
			document.location.reload();
			return;
		}
		if (resp['timings'] !== undefined && Object.keys(resp['timings']).length) {
			console.log('Got timings for request', vars, resp['timings']);
		}
		if (resp['sumTimings'] !== undefined && Object.keys(resp['sumTimings']).length) {
			console.log('Got sum timings for request', vars, resp['sumTimings']);
		}
		if (resp['resetCookiePreferences']) {
			sa.cookies.setAgreedToCookies(0);
			sa.components.cookieManager.show();
		}
		if (resp.error) {
			switch (resp.error) {
				case 'solr_error':
					sa.error('We appear to be having a problem with our search server. Our tech team has been notified and is currently working on it. Please wait a couple minutes and try again. Sorry for the inconvenience!');
					return;
				case 'database_error':
					sa.error('We appear to be having a problem with our database. Our tech team has been notified and is currently working on it. Please wait a couple minutes and try again. Sorry for the inconvenience!');
					return;
				case 'login_error':
					//alert('got ' + resp.errorDetails + ' from server');
					if (lockdown) {
						sa.showLockdownMessage();
					} else {
						document.location.href = 'login.php';
					}
					return;
				case 'json_error':
				case 'logged_error':
					if (window['user'] && user.hasAdminPermission(AdminPermission.SuperAdmin)) {
						resp.errorId = '<a target="_blank" href="https://september.sourceaudio.com/errors?id=' + resp.errorId + '">' + resp.errorId + '</a>';
					}
					sa.notify({ text : $j('<div>Our server had a problem processing your request.<br/>If you report this issue, reference error <b><a>' + resp.errorId + '</a></b></div>') });
					return;
				case 'auth_error':
					sa.showAuthForm();
					// see if the user is correct
					if (window['user'] && user['verifyUser']) user.verifyUser(resp.userId);
					return;
				case 'ignore_result':
					console.log('ignore response because ignore_result was set', resp);
					return;
				default:
					sa.notify({ text : 'An unknown error has occurred. Please try again later.' });
					return;
			}
		}
		parseSuccess = true;
		// see if there's a new breaking change version
		if (sa.breakingChangeVersion !== resp.breakingChangeVersion) {
			if (sa.breakingChangeVersion) {
				sa.alert({
					text : 'We released an update since you loaded the workspace and you need to reload to get the latest and greatest. Please do so now or click below. Thanks!',
					buttonText : 'Reload',
					onClose : function() { window.location.reload(); }
				});
			}
			sa.breakingChangeVersion = resp.breakingChangeVersion; // only show the notice once
		}
		// see if there's a forward in this response and we're not actually there already
		if (resp.forward && resp.forward !== sa.router.getCurrentPath(true)) {
			// Check if there is a malformed url being passed through the forward
			if (resp.forward && resp.forward.includes('tracks/tracks')) {
				resp.forward = resp.forward.replace('tracks/tracks', 'tracks');
			}

			// rerouting the forward url
			if (resp.forward.indexOf('http') === 0) {
				document.location.href = resp.forward;
			} else {
				sa.router.routeTo(resp.forward);
			}
			return;
		}
		// see if the user is correct
		if (window['user'] && user['verifyUser']) user.verifyUser(resp.userId);
		// update import tracks
		if (resp['publishedToProjectTime'] !== undefined && sa.importTrackManager) {
			sa.importTrackManager.updatePublishingTimes(resp['publishedToProjectTime'], resp['publishedTrackTime']);
		}
		// actually parse the response
		if (resp.success && callback) {
			// save the secureToken if there was one
			if (resp.secureToken) {
				user.secureToken = resp.secureToken;
			}
			/**
			 * We need to pass the response from the server into the callback function
			 * The callback function is a string to be eval'd but the response is an object
			 *  - the response used to be a string also but now we have to pre-parse out the container info
			 * The eval needs a string parameter so we have to store the response as a variable somewhere that can
			 * be accessed as a string. We set that in window so it can be accessed globally
			 * We make sure to get a unique responseIndex so we don't overwrite the responses from other
			 * calls to handleAjaxResponse.
			 *  - since it's called asynchronously, multiple threads could assign into the variable name
			 *    if we don't make sure it's unique
			 *  - thought about using Math.random() but that won't guarantee no collisions
			 * After we're done, we delete the window var so we're not wasting that memory
			 */
			var responseIndex = window['responseIndex'] = window['responseIndex'] + 1;
			if (window['responseIndex'] > 15) {
				window['responseIndex'] = 0;
			}
			if (resp['apiError']) {
				errorCallback(resp['apiError']);
			} else {
				callback(resp.content);
			}
			// delete window[key]; // this threw errors in IE because you can't delete global windows vars
		}
	} catch (error) {
		var authResultPos = response.indexOf('Auth Result: ');
		if (authResultPos != -1) {
			var specificErrorMessage = response.substring(authResultPos + 13);
			specificErrorMessage = specificErrorMessage.substring(0, specificErrorMessage.indexOf('<'));
			let msg = '<b>Server communication failure</b><br/>Your network connection said: '+specificErrorMessage+'<br/>Please consult your local network admin for help.';
			sa.notify({ text : $j('<span>' + msg + '</span>') });
			error.message = 'Handled quietly';
		} else if (parseSuccess) {
			if (vars == 'p=checkin') {
				console.log('eval response parsing failed for checkin. not logging. response was', response);
				return;
			}
			console.log('parsing response succeeded but callback threw an error. response was', response, 'from vars', vars);
		} else if (!disableRecursion && error && error.message.indexOf('Unexpected token \' in JSON') !== -1) {
			console.log('Caught "Unexpected token \' in JSON" message. Trying to strip escaped single quotes.', error);
			return handleAjaxResponse(callback, response.replace(/\\'/g, ''), vars, errorCallback, true);
		}

		// google bot doesn't like our templates for some reason and keeps throwing and recording these errors the first time they're accessed
		// if you wanted to actually solve the issue, maybe you could log a LOT more but it would be a slow process. i'd rather suppress for now
		if (BrowserDetect.isBot || (BrowserDetect.OS == 'Linux' && vars.indexOf('p=user') !== -1 && error.stack.indexOf("TypeError: Cannot read property 'get' of null") !== -1 && error.stack.indexOf("at Object.b.build") !== -1)) {
			console.error('Not logging error thrown by googlebot');
			return;
		}
		
		// Brent generates a ton of errors in inactive tabs when we do a code update
		if (error.message.indexOf('play method is not allowed by the user agent') !== -1 
			|| error.stack.indexOf('play method is not allowed by the user agent') !== -1
			|| error.stack.indexOf('request is not allowed by the user agent') !== -1) {
			console.error('Not logging error about "play method/request is not allowed by the user agent"');
			return;
		}

		// We started getting a lot of these 2025-09-23. Some kind of Safari extension issue?
		if (error.message.indexOf('Invalid call to runtime.sendMessage') !== -1 || error.message === 'Load failed') {
			console.error('Not logging error about "Invalid call to runtime.sendMessage"');
			return;
		}

		// We started getting a lot of these 2025-10-06. It's some school web filter spitting out errors
		if (error.message.indexOf('RPC request timed out') !== -1 || error.stack.indexOf('deledao') !== -1) {
			console.error('Not logging error about "RPC request timed out"');
			return;
		}
		
		// we've recorded tons of these errors in 2023. i think they're coming from a plugin? we can't do anything about them and logging them just makes it harder to find useful errors
		if (error.stack.match(/@[[<](native|anonymous) code[\]>]/)) {
			console.error('Not logging error from native/anonymous code', error);
			return;
		}
		if (error.stack.indexOf('wallet must has at least one account') !== -1) { // this is a browser plugin error
			console.error('Not logging error about "wallet must has at least one account"', error);
			return;
		}

		// record this in september
		if (!window['user']) {
			// site manager doesn't have a user object
			window['user'] = { logged : false, userData : { id : -1, username : 'Site Manager' }, hasAdminPermission : function () { return false; } };
			window['jsRelease'] = 0;
		}
		var sepError = {
			message : error.message,
			type : error.name,
			stack : error.stack,
			url : window.location.href,
			whiteId : config.id,
			whiteName : config.name,
			userId : user.logged ? user.userData.id : 'temp-' + user.userData.id,
			userName : user.userData.username,
			userEmail : user.logged ? user.userData.email : '',
			request : vars,
			response : response,
			jsRelease : jsRelease,
			browser : BrowserDetect.OS + ' ' + BrowserDetect.browser + ' ' + BrowserDetect.version
		};
		if (config.dev) {
			console.error(error.stack);
		}
		console.log('sending error (also stored in window.lastError with response in window.lastResponse):', sepError);
		window.lastError = sepError;
		window.lastResponse = response;
		$j.post('https://september.sourceaudio.com/api/monitor/error', sepError, function (r) {
			console.log('september error response:', r);
			if (window['user'] && user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				r.id = '<a target="_blank" href="https://september.sourceaudio.com/errors?id=' + r.id + '">' + r.id + '</a>';
			}
			sa.notify({ text : $j(`<div>The client had a problem processing your request.<br/>If you report this issue, reference error <b>${r.id}</b></div>`) });
		}, 'json');
	}
}

/**
 * Turns an object like { a : 1, b : 'dance time' } into a string suitable for sending via ajax, like a=1&b=dance+time
 * @param {object} vars the vars object
 * @returns {String} the encoded string
 */
function createVarStringFromObject(vars) {
	let cleanedVars = {};
	if (vars !== null && vars !== undefined) {
		for (let k in vars) {
			if (vars.hasOwnProperty(k) && typeof vars[k] !== 'function') {
				cleanedVars[k] = vars[k];
			}
		}
	}
	return $j.param(cleanedVars, false);
}

if (window['ajaxNonceKey']) {
	window['ajax'].addBaseParameter('ajaxNonceKey', window['ajaxNonceKey']);
	delete window['ajaxNonceKey'];
}
if (window['ajaxNonce']) {
	window['ajax'].addBaseParameter('ajaxNonce', window['ajaxNonce']);
	delete window['ajaxNonce'];
}

class SaAPI {

	//_baseParameters; // closure doens't like this

	constructor() {
		this._baseParameters = createSafeObject();
	}

	/**
	 * Makes a request to the onsite API, the newer PHP request handling system, mostly in includes/classes/SourceAudio/API/
	 * @param options
	 * @param {string} options.handler The PHP API handler you're requesting. For example, to call class.mailtrackinghandler.php, you'd put "mail-tracking"
	 * @param {string} options.action The PHP function to call within the handler class. For example, to call the getTracking function, you'd put "get-tracking"
	 * @param {Object} [options.postData] An object with keys/values to be sent as POST. Optional
	 * @param {Object} [options.getData] An object with keys/values to be sent as GET. Optional
	 * @returns {Promise} A promise that resolves with the server's response or rejects with an error message
	 * @throws {Error}
	 */
	request(options) {
		const self = this;

		return new Promise((resolve, reject) => {
			options = $j.extend({
				handler: '',
				action: '',
				postData: {},
				getData: {},
				jsonData: {},
				formData: null,
				timeout: Infinity,
			}, options);
			for (let baseParameterKey in self._baseParameters) {
				if (self._baseParameters.hasOwnProperty(baseParameterKey)) {
					options.getData[baseParameterKey] = self._baseParameters[baseParameterKey];
				}
			}
			if (options['success'] || options['error']) {
				console.error('Success and Error should no longer be set on calls to sa.api.request calls', options);
				if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
					sa.alert({ text: 'Success and Error should no longer be set on calls to sa.api.request calls. Check the console.' });
				}
			}

			let o;
			if (window.XMLHttpRequest) {
				o = new XMLHttpRequest();
			} else if (window.ActiveXObject) {
				o = new ActiveXObject('Microsoft.XMLHTTP');
			}

			if (o === null) {
				reject('Unable to create XMLHttpRequest object');
				return;
			}

			if (nocache) {
				options.getData['nocache'] = 1;
			}
			let requestBody = '';
			let requestPath = 'sa/' + options.handler + '/' + options.action + '/';

			// add get params to request
			if (Object.keys(options.getData).length) {
				requestPath += '?' + (typeof options.getData !== 'string' ? createVarStringFromObject(options.getData) : options.getData);
			}

			if (options.formData instanceof FormData) {
				// handle direct form data
				o.open('POST', requestPath, true);
				// o.setRequestHeader('Content-type', 'multipart/form-data');
				requestBody = options.formData;
			} else if (Object.keys(options.jsonData).length) {
				requestBody = JSON.stringify(options.jsonData);
				o.open('POST', requestPath, true);
				o.setRequestHeader('Content-type', 'application/json');
			} else if (!Object.keys(options.postData).length) {
				o.open('GET', requestPath, true);
			} else {
				requestBody = typeof options.postData !== 'string' ? createVarStringFromObject(options.postData) : options.postData;
				o.open('POST', requestPath, true);
				o.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			}

			o.onreadystatechange = function() {
				if (this.readyState == 4) {
					if (this.status == 200) {
						handleAjaxResponse(resolve, this.responseText, requestBody, function(apiError) {
							reject(new SaAPIError(apiError.message, apiError.details));
						});
					}
				}
			};
			
			o.ontimeout = function() {
				// Request timed out
				const statusText = o?.statusText;
				let errorMessage = 'Request timed out.  Please try again and let us know if you see this message repeatedly.';
				console.error(errorMessage, statusText)
				reject(errorMessage);
			};

			o.onerror = function() {
				// Request encountered an error
				const statusText = o?.statusText;
				let errorMessage = 'Request encountered an unknown error.  Please try again and let us know if you see this message repeatedly.';
				console.error(errorMessage, statusText)
				reject(errorMessage);

			};

			o.onabort = function() {
				// Request was aborted
				const statusText = o?.statusText;
				let errorMessage = 'Request was aborted.  Please try again and let us know if you see this message repeatedly.';
				console.error(errorMessage, statusText)
				reject(errorMessage);
			};

			if (options.timeout !== Infinity) {
				o.timeout = options.timeout;
			}
			o.send(requestBody);

		});

	};

	/**
	 * Adds a parameter to be sent with every API request. Primarily used for nonce security.
	 * @param {string} key The key to send with the request
	 * @param {string} value The value to send with the request
	 */
	addBaseParameter(name, value) {
		this._baseParameters[name] = value;
	};
}

class SaAPIError extends Error {
	constructor(message, details) {
		super(message);
		this.details = details;
		this.name = 'SaAPIError';
	}
}

sa.api = new SaAPI();

if (window['sa-api-base-parameters']) {
	for (let name in window['sa-api-base-parameters']) {
		if (window['sa-api-base-parameters'].hasOwnProperty(name)) {
			sa.api.addBaseParameter(name, window['sa-api-base-parameters'][name]);
		}
	}
	delete window['sa-api-base-parameters'];
}

function getMarginPixels(element, direction) {
	var style = element.currentStyle || window.getComputedStyle(element);
	if (!style) return 0;
	var margin = style['margin'] + ucfirst(direction);
	if (!margin) return 0;
	return parseInt(margin);
}
/**
 * Data.js holds objects (primarily) that are used to store data
 */

/**
 * The Track Back is a singleton that stores track objects in TrackInfo "accounts".
 * Pages/objects that load tracks create an account in the bank and store their tracks in that account.
 * When they load new tracks, they replace what's in the account.
 * It has various utility functions to find/add/update/remove tracks.
 * Accounts are loaded with string keys
 */
var trackBank = (function () {

	let trackBank = {};

	let trackInfos = {};
	let trackUpdates = {};

	/**
	 * Clears all tracks from one accounts
	 * @param {string} key the account key
	 */
	trackBank.clear = function (key) {
		trackInfos[key] = null;
	};

	/**
	 * Adds a track to an account
	 * @param {Track} track the track to add
	 * @param {string} key the account key
	 */
	trackBank.add = function (track, key) {
		trackBank.addKey(key);

		if (trackUpdates[track.id]) {
			trackUpdates[track.id].each(function (i, update) {
				update.applyTo(track);
			});
		}

		trackInfos[key].add(track);
	};

	/**
	 * Creates a new account in the bank
	 * @param {string} key the account's key
	 */
	trackBank.addKey = function (key) {
		if (trackInfos[key] == null) {
			trackInfos[key] = new TrackInfo();
		}
	};

	/**
	 * Gets a track from a specific account
	 * @param {int} trackId the track's id
	 * @param {string} key the account's key
	 * @return {Track|null} the track of null if not found
	 */
	trackBank.get = function (trackId, key) {
		if (trackInfos[key] == null) return null;
		return trackInfos[key].get(trackId);
	};

	/**
	 * Gets a track from the bank, regardless of account
	 * @param {int} trackId the track's id
	 * @return {Track} the track or null if not found
	 */
	trackBank.find = function (trackId) {
		let latestTrack = null;
		for (let key in trackInfos) {
			if (!trackInfos.hasOwnProperty(key)) continue;
			let t = trackBank.get(trackId, key);
			if (t && (!latestTrack || t.dateAddedToBank > latestTrack.dateAddedToBank)) {
				latestTrack = t;
			}
		}
		return latestTrack;
	};

	/**
	 * Gets a track from the bank, regardless of account
	 * @param {int} trackId the track's id
	 * @param {string} setKey if the track is not found, it will be loaded and stored with key setKey
	 * @param {function} callback will be passed the track's data or null if it couldn't be loaded
	 */
	trackBank.load = function (trackId, setKey, callback) {
		var trackData = trackBank.find(trackId);
		if (trackData) {
			callback(trackData);
		} else {
			ajax({
				p: 'track_info',
				id: trackId
			}, function (trackResponse) {
				if (trackResponse.length > 1) {
					trackData = trackResponse[1];
					trackBank.add(trackData, setKey);
				}
				callback(trackData);
			});
		}
	};

	/**
	 * Updates the information about a track for all instances of the track in all accounts
	 * @param {int} trackId the track's id
	 * @param {string} name the name of the field to change
	 * @param {object} value the field's new value
	 */
	trackBank.updateAll = function (trackId, name, value) {
		for (let key in trackInfos) {
			if (!trackInfos.hasOwnProperty(key)) continue;
			trackBank.update(trackId, name, value, key);
		}
		if (!trackUpdates[trackId]) {
			trackUpdates[trackId] = [];
		}
		trackUpdates[trackId].push(new TrackUpdate(name, value));
	};

	/**
	 * Updates the information about a track in a single account
	 * @param {int} trackId the track's id
	 * @param {string} name the name of the field to change
	 * @param {object} value the field's new value
	 * @param {string} key the account's key  
	 */
	trackBank.update = function (trackId, name, value, key) {
		if (trackBank.get(trackId, key)) {
			trackInfos[key].update(trackId, name, value);
		}
	};

	/**
	 * Removes a track from an account
	 * @param {int} trackId the track's id
	 * @param {string} key the account's key
	 */
	trackBank.remove = function (trackId, key) {
		if (trackBank.get(trackId, key)) {
			trackInfos[key].remove(trackId);
		}
	};

	/**
	 * Gets the number of tracks in an account
	 * @param {string} key the account's key
	 * @return {int} the number of tracks
	 */
	trackBank.count = function (key) {
		if (trackInfos[key] != null) {
			return trackInfos[key].length;
		}
		return 0;
	};


	function TrackUpdate(field, value) {
		let dateUpdated = new Date().getTime();

		/**
		 * Applies the update to the track if the update is more recent than the track
		 * @param {Track} track
		 */
		this.applyTo = function (track) {
			if (track.dateAddedToBank && track.dateAddedToBank < dateUpdated) {
				track[field] = value;
			}
		};
	}

	/**
	 * Stores a list of tracks and allows easy manipulation of that list
	 * An "account" in the track bank
	 */
	function TrackInfo() {
		this.info = {};
		this.length = 0;

		/**
		 * Removes all tracks
		 */
		this.clear = function () {
			this.info = {};
		};

		/**
		 * Adds one track
		 * @param {Track} track the track to add
		 */
		this.add = function (track) {
			if (this.info[track.id] == null)
				this.length++;
			track.dateAddedToBank = new Date().getTime(); // used in find to make sure we're returning the most recent
			this.info[track.id] = track;
			if (track.alternates && track.alternates.length) {
				for (var i = 0; i < track.alternates.length; i++) {
					this.add(track.alternates[i]);
				}
			}
		};

		/**
		 * Updates one field in a specific track
		 * @param {int} trackId the track's id
		 * @param {string} name the name of the field to update
		 * @param {object} value the value of the field
		 */
		this.update = function (trackId, name, value) {
			this.info[trackId][name] = value;
		};

		/**
		 * Gets one track
		 * @param {int} trackId the track's id
		 * @return {Track} the track or null if not found
		 */
		this.get = function (trackId) {
			return this.info[trackId];
		};

		/**
		 * Removes one track
		 * @param {int} trackId the track's id
		 */
		this.remove = function (trackId) {
			if (this.info[trackId] != null)
				this.length--;
			this.info[trackId] = null;
		};

	}

	return trackBank;

})();

/**
 * Gets information about a track if it exists
 * Shortcut for trackBank.find()
 * @param {int} trackId the track's id
 * @return {Track} the track or null if not found
 */
function getTrack(trackId) {
	return trackBank.find(trackId);
}

/**
 * The RequestCache is a singleton used to cache ajax requests client-side
 */
sa.requestCache = (function () {

	var requestCache = {};
	var cache = {};
	var ttl = 600000;

	/**
	 * Makes ajax requests but uses the request cache first to avoid duplicate requests
	 * @param {object|string} vars the variables to be sent, in url format. e.g., var1=asfd&var2=qwer or object format like { var1 : 'asfd', var2 : 'qwer' }
	 * @param {function|string=} callback a function to call with a response or the string name of the function. will be passed the response object (optional)
	 * @param {string=} method /^GET|POST$/ (optional - defaults to GET)
	 * @param {object|string=} getVars the url formatted vars to pass in via GET if method == 'POST' (optional)
	 */
	requestCache.ajax = function (vars, callback, method, getVars) {
		if (callback == undefined) return;
		if (method == undefined) {
			method = 'GET';
		}
		if (getVars == undefined) {
			getVars = '';
		}
		var key = 'requestCache.ajax(' + JSON.stringify({
			vars: vars,
			method: method,
			getVars: getVars
		}) + ')';
		var result = requestCache.get(key);
		if (result) {
			callback(result);
		} else {
			ajax(vars, function (response) {
				requestCache.set(key, response);
				callback(response);
			}, method, getVars);
		}
	};

	/**
	 * Sets something in the cache
	 * @param {string} requestString the key
	 * @param {JSON|Array<JSON>} result the result of a query for the request
	 */
	requestCache.set = function (requestString, result) {
		if (!cache[requestString]) {
			cache[requestString] = {
				'bod': (new Date()).getTime(),
				'result': result
			};
		}
	};

	/**
	 * Gets something out of the cache
	 * @param {string} requestString the key
	 * @return {JSON|Array<JSON>} the stored data associated with the key
	 */
	requestCache.get = function (requestString) {
		requestCache.cleanup();
		return (cache[requestString] ? cache[requestString].result : null);
	};

	/**
	 * Removes everything from the cache older than ttl
	 */
	requestCache.cleanup = function () {
		var delTime = (new Date()).getTime() - ttl;
		for (var i in cache) {
			if (!cache.hasOwnProperty(i)) continue;
			if (cache[i].bod < delTime) {
				//console.log('deleting ' + i + ' because of time');
				delete cache[i];
			}
		}
	};

	/**
	 * Clears the cache
	 */
	requestCache.clear = function () {
		var originalTtl = ttl;
		ttl = 0;
		requestCache.cleanup();
		ttl = originalTtl;
	};

	return requestCache;
	//return 0;

})();
class EditInterfaceBannerFields {
	constructor(container, item) {
		this.container = container
		this.objectType = item.type == 'project' ? 'playlist' : item.type;
		const state = {
			src: _.get(item, 'bannerImage.image', ''),
			focusX: _.get(item, 'bannerImage.focusX', ''),
			focusY: _.get(item, 'bannerImage.focusY', ''),
			artOverBanner: _.get(item, 'bannerImage.artOverBanner', false),
			textColorLocal: _.get(item, "bannerImage.textColor", undefined),
			textColorGlobal: _.get(config, 'theme.colors.textOverBannerImageColor', '#FFFFFF'),
			typeGlobal: _.get(config, `theme.bannerTypes.${this.objectType}`, false),
			typeLocal: _.get(item, 'bannerImage.type', _.get(item, 'bannerImage.bannerType', false)), // bannerType key is backwards compatibility
		}

		Object.assign(this, state);

		this.rendered = false;
		this.templates = sa.templates.get('components.item_edit_interface');
		this.render();

		// return the elements
		return {
			$bannerImageUploader: this.$bannerImageUploader,
			$bannerTextColor: this.$bannerTextColor,
			$bannerImageFields: this.$bannerImageFields,
			$bannerTypeSelector: this.$bannerTypeSelector,
			$artOverBanner: this.$artOverBanner,
		}
	}

	render() {
		if (this.rendered) return;
		const self = this;
		this.$bannerTypeSelector = this.templates.get("banner_type_field", {
			heading: "Banner Type",
			type: this.objectType,
		})


		this.setDefaultText();


		this.$bannerTypeSelector.find("input").on('change', function (e) {
			self.changeBannerType(e.target.value)
		})


		this.$bannerImageFields = this.templates.get("banner_image_fields");

		this.$bannerImageUploader = this.$bannerImageFields.find(".banner_image_uploader");
		this.$artOverBanner = this.$bannerImageFields.find(".art_over_banner");
		this.$bannerTextColor = this.$bannerImageFields.find(".banner_text_color");


		this.container.append(this.$bannerTypeSelector)
		this.container.append(this.$bannerImageFields)

		this.initializeSettings();
		this.rendered = true;
	}

	initializeSettings() {
		if (!this.typeLocal || (this.typeLocal === 'image' && this.src === '')) {
			// global value
			this.$bannerTypeSelector.find('input').data('value', '');
			this.changeBannerType(false)
		} else {
			// local saved value
			this.$bannerTypeSelector.find('input').data('value', this.typeLocal);
			this.changeBannerType(this.typeLocal)
		}
		
	
		// set saved banner text color
		this.$bannerTextColor.find('input').data({
			value: this.textColorLocal || this.textColorGlobal,
			default: this.textColorGlobal,
			saved: this.textColorLocal
		})
	
		// set saved banner image
		this.$bannerImageUploader.find('input').data('value', this.src);
		this.$bannerImageUploader.data('value', {
			percX: this.focusX || '50%',
			percY: this.focusY || '50%',
		});


		this.$artOverBanner.find('input').data('value', this.artOverBanner);
	}

	/**
	 * Show or hide option sets in the form based on which banner type is selected
	 * @param {string} type 
	 */
	changeBannerType(type) {
		// key is which banner type, value is which element to show/hide, enable/disable inputs
		const templateMap = {
			'image': '.banner_image_fields'
		}
		
		// hide the others
		for (let [key, val] of Object.entries(templateMap)) {
			if (type != key) {
				this.hideDisable(this.container.find(val));
			} else {
				this.showEnable(this.container.find(val))
			}
		}
	}
	setDefaultText() {
		// Set default text : Use Global Default (Solid Color)
		if (this.typeGlobal) {
			let globalStr = this.typeGlobal;
			if (globalStr == 'color') {
				globalStr = 'Solid Color';
			} else {
				globalStr = this.typeGlobal.charAt(0).toUpperCase() + this.typeGlobal.slice(1);
			}

			this.$bannerTypeSelector.find('.default label').append(`<span>(${globalStr.toLowerCase()})</span>`)
		}
	}
	hideDisable($el) {
		$el.addClass('hidden')
		$el.find('input, textarea, select').attr('disabled', true)
	}
	showEnable($el) {
		$el.removeClass('hidden')
		$el.find('input, textarea, select').attr('disabled', false)
	}
}class PersonEditForm {
	/**
	 * Edit fields for a person for use in the item_edit_interface
	 * 
	 * @param {jQuery} container Container to put the edit fields in
	 * @param {object} person The person to be edited
	 */
	constructor(container, person) {

		this.container = container;
		this.person = person;
		this.person.isCompany = person.type === 'publisher';
		this.templates = sa.templates.get('components.item_edit_interface');

		this.render();
		this.populateListCustomFields().then(a => {
			this.setFormValues();
		});

	}

	/**
	 * Set form values once all the inputs are ready
	 */
	setFormValues() {
		// set all the values of the field values, easy way first by just finding matching inputs
		let skipKeys = ['editable', 'role', 'ownershipShare', 'publisherId', 'writerId', 'isCompany'];
		// person fields to input names
		let keyMap = {
			'addresses': 'address[]',
			'emails': 'email[]',
			'phones': 'phone[]',
			'groups': 'group',
		};

		// set all the fields on the inputs from the person
		// go through each formatting values to set on the form 
		for (let [inputName, value] of Object.entries(this.person)) {
			if (skipKeys.includes(inputName)) continue;
			if (value === '') continue;

			// map fields to input names if necessary
			if (keyMap[inputName]) {
				inputName = keyMap[inputName];
			}
			// init values to set for this field
			let valuesToSet = [{
				value,
				input: inputName
			}];

			if (inputName == 'group') {
				if (value.length == 0) continue;

				// these are in the format [{id: 'id', name: 'group name'}, {id: 'id2', name: 'group name 2'}]
				// so we need to map them to what selectize expects for setting the values, which is {id: 'id', value: 'group name'}
				valuesToSet = [
					{ input: inputName, value: value.map(a => this.formatSelectizeOption(a.id, a.name)) }
				];

			}

			if (inputName == 'affiliationNumber') {
				if (this.person.hasOwnProperty('affiliation') && this.person.affiliation.hasOwnProperty('id') && this.person.affiliation.id == 0) {
					continue;
				}
				if (value == 0) {
					// don't show affiliation number 0
					continue;
				}
			}
			if (inputName == 'affiliation') {
				if (value.id == 0) {
					continue;
				}
				valuesToSet = [{
					value: value.id,
					input: inputName,
				}];
			}
			if (inputName == 'phone[]') {
				// phone numbers	
				// TODO: do we need the IDs
				if (value.length == 0) continue;
				valuesToSet = [
					{ input: 'phone[]', value: value.map(p => p.number) },
					{ input: 'phoneType[]', value: value.map(p => p.type) }
				];
			}
			if (inputName == 'address[]') {
				// addresses
				// TODO: do we need the IDs
				if (value.length == 0) continue;

				valuesToSet = [
					{ input: 'address[]', value: value.map(a => a.address) },
					{ input: 'city[]', value: value.map(a => a.city) },
					{ input: 'state[]', value: value.map(a => a.state) },
					{ input: 'zip[]', value: value.map(a => a.zip) },
					{ input: 'country[]', value: value.map(a => a.country) },
					{ input: 'addressType[]', value: value.map(a => a.type) },
				];
			}
			if (inputName == 'email[]') {
				// addresses
				// TODO: do we need the IDs
				if (value.length == 0) continue;

				valuesToSet = [
					{ input: 'email[]', value: value.map(a => a.email) },
					{ input: 'emailPreferred[]', value: value.map(a => a.preferred == true ? 1 : 0) },
					{ input: 'emailType[]', value: value.map(a => a.type) },
				];
			}

			if (inputName == 'customFields') {
				valuesToSet = [];
				for (const f of value) {
					valuesToSet.push({
						value: f.value,
						input: `customField[${f.id}]`
					});
				}
			}

			for (const v of valuesToSet) {
				const { value, input: inputName } = v;
				const $matchingInput = this.container.find(`input[name="${inputName}"], select[name="${inputName}"], textarea[name="${inputName}"]`).first();
				if ($matchingInput.length) {
					// now that we have a matching input, check if it is a special prompted input
					const $promptedInput = $matchingInput.closest('.prompted_input').first();
					if ($promptedInput.length) {
						// set value using the PromptedInput class
						$promptedInput[0].promptedInput.setVal(value, inputName, true);
					} else {
						console.log("wanting to set val on a non prompted input", inputName, value);
						$matchingInput.val(value);
						$matchingInput.closest('.input_container').addClass('with_value');
					}
				}

			}

			continue;
		}
	}

	/**
	 * Set up all the prompted inputs and special logic
	 */
	render() {
		this.container.find('.prompted_input').each(function() {
			const options = {
				repeatable: $j(this).hasClass('repeatable')
			};
			if ($j(this).hasClass('email_group')) {
				options.onAddAnother = function($el) {
					$el.find('.not_preferred').removeClass('hide');
					$el.find('.preferred').addClass('hide');
				}
			}
			$j(this).initPromptedInput(options);
		});



		/**
		 * SPECIAL EMAIL INPUT HANDLING
		 */
		// bind email preferred / not preferred clicks to change the input value
		this.container.find('.email_group').on('click', '.not_preferred, .preferred', function() {
			let value = 0;
			if ($j(this).hasClass('not_preferred')) {
				value = 1;
			} 

			const $thisPreferredInput = $j(this).siblings('input[name^=emailPreferred]');
			$thisPreferredInput.val(value);
			$thisPreferredInput.trigger('change');

		});

		// on input value changes, update the UI state
		this.container.find('.email_group').on('change', 'input[name^=emailPreferred]', function(e) {
			// reflect state of input
			if ($j(this).val() == 1) {
				$j(this).siblings(".preferred").removeClass('hide');
				$j(this).siblings(".not_preferred").addClass('hide');

				$j(this).closest('.inputs_wrapper').find('input[name^=emailPreferred]').not($j(this)).each(function() {
					if ($j(this).val() == 1) {
						$j(this).val(false);
						$j(this).siblings(".not_preferred").removeClass('hide');
						$j(this).siblings(".preferred").addClass('hide');
					}
				});
			} else {
				$j(this).siblings(".preferred").addClass('hide');
				$j(this).siblings(".not_preferred").removeClass('hide');
			}
		});
	}

	addCustomField(name, id, $beforeEl = false) {
		if (!id) {
			sa.alert('Unable to create custom field with that name. Please try again.');
			return;
		}
		if (!$beforeEl) {
			$beforeEl = this.container.find('a.add_custom_field');
		}

		const $input = this.templates.get('prompted_input');
		const decodedName = StringSanitize.ifEncodedDecode(name);
		$input.find('.heading').text(decodedName);
		$input.find('.prompt').text(`Add ${decodedName}`);
		$input.find('input').attr('name', 'customField[' + id + ']').attr('placeholder', decodedName);

		/**
		 * since we made an API call before generating these, the PromptedInputs for the rest of the form
		 * have already been bound, so we need to initialize PromptedInput capabilities manually
		 */
		$input.initPromptedInput();
		$beforeEl.before($input);
	}

	/**
	 * Populate the custom fields
	 */
	async populateListCustomFields() {
		const self = this;
		const responses = await Promise.all([
			ajax.promise({ p: 'people', action: 'loadListFieldValues' }),
			ajax.promise({ p: 'people', action: 'list_custom_fields' }),
		]);

		this.listFields = responses[0];
		this.customFields = responses[1];
		const select = this.container.find('select[name=affiliation]');
		let optionString = select.html();
		for (let a = 0, aLen = this.listFields.affiliations.length; a < aLen; a++) {
			let affiliation = this.listFields.affiliations[a];
			optionString += '<option value="' + affiliation.id + '">' + affiliation.name + '</option>';
		}
		select.html(optionString);


		// custom fields
		let $addCustomFieldLink = this.container.find('a.add_custom_field');
		for (var c = 0, cLen = this.customFields.length; c < cLen; c++) {
			const field = this.customFields[c];
			this.addCustomField(field.name, field.id)
		}


		$addCustomFieldLink.on('click', function(e) {
			e.preventDefault();

			sa.prompt({
				text: 'Create a new custom field',
				placeholder : 'New custom field name',
				yesFunction : function(newField, interactionOptions) {
					if (!newField) {
						interactionOptions.showError('Please enter a name for the new custom field');
						return true;
					}

					ajax({ name : newField }, function(response) {
				
						if (response[0].success) {
							sa.notify({ text : StringSanitize.encodeIfNotEncoded(`Successfully created custom field: ${newField}`) });
							self.addCustomField(newField, response[0].customFieldId)
						} else {
							sa.alert({ text : response[0].message });
						}
						
					}, 'POST', { p : 'people', action : 'add_custom_field' });
	
					return false;
				},
				yesText : 'Create'
			});
		});


		let $manageCustomFieldsLink = this.container.find('a.manage_customs');
		$manageCustomFieldsLink.on('click', function(e) {
			e.preventDefault();

			sa.confirm({
				text: 'You will lose any unsaved changes. Are you sure?',
				yesFunction: function() {
					// you have to double encode the source because parseHash decodes it
					let currentPath = sa.router.getCurrentPath(true);
					sa.router.routeTo('/admin?p=metadata&tab=people&action=manage_custom_fields&source=' + encodeURIComponent(currentPath));
				},
				yesText: 'Manage Custom Fields'
			});
		});

		
	}
	/**
	 * Selectize requires options in this format
	 */
	formatSelectizeOption(id, text, extraProps = {}) {
		return { id, value: text, ...extraProps };
	}
}
class PromptedInput {
	/**
	 * An input where you first have to click a prompt to show the inputs.  Requires an HTML format, see the template for examples.
	 * 
	 * @param {jQuery} $el Element to make a prompted input, see the template for what these look like
	 * @param {object} options Options like "repeatable," which signifies whether the inputs are repeatable
	 * @returns 
	 */
	constructor($el, options = {}) {
		const self = this;
		// Add options and defaults to this
		Object.assign(this, {
			repeatable: false,
			onAddAnother: function() {}
		}, options);

		this.$el = $el;
		this.$prompt = this.$el.find('.prompt');
		this.$prompt.on('click', function(e) {
			self.showInputs();
		});
		// don't save disabled
		this.$el.find('input, textarea, select').attr('disabled', true);

		if (this.repeatable) {

			// bind remove buttons
			this.$el.find('.inputs_wrapper').on('click', '.input_repeatable .remove', function(e) {
				let numRepeaters = $j(this).closest('.inputs_wrapper').find('.input_repeatable').length;
				const $thisRow = $j(this).closest('.input_repeatable');
				if (numRepeaters == 1) {
					// unset the values if this is the last row
					$thisRow.find('input, textarea, select').val('');
					self.hideInputs();
				} else if (numRepeaters > 1) {
					// remove it if it's not the last one
					$thisRow.remove();
				}
			});

			// add an "add another" button
			this.$addAnother = $j('<a href="#" class="add-another">Add another</a>');
			this.$addAnother.on('click', function(e) {
				e.preventDefault();
				const $added = self.addAnother();
				self.onAddAnother($added);

			});
			this.$el.find('.inputs_wrapper').append(this.$addAnother);
		}



		this.hideInputs();

		return this;
	}

	/**
	 * If this is a repeatable input, add another
	 */
	addAnother() {
		if (!this.$addAnother || !this.$addAnother.length) {
			console.error("No 'Add Another' button found for repeating prompted input.");
			return;
		}
		
		const $initialRepeatable = this.$el.find('.inputs_wrapper .input_repeatable').first();

		if (!$initialRepeatable || !$initialRepeatable.length) {
			console.error('No `.input_repeatable` inputs to copy for adding another input.', this);
			return;
		}
		const $item = $initialRepeatable.clone(true);
		$item.find('input, textarea, select').val('').attr('disabled', false);

		this.$addAnother.before($item);
		return $item;
	}

	/**
	 * Set the value of the input, handling different cases like selectizes or
	 * if there are multiple inputs with the same name, `val` will be an array
	 * where the values will be set on each input of that name in the order
	 * the values are placed inside of the array
	 * 
	 * @param {array|any} val single val or array of values if there are multiple inputs with the same name
	 * @param {string} inputName Input name
	 * @param {boolean} triggerChange should we trigger the 'change' event
	 * @returns 
	 */
	setVal(val, inputName = false, triggerChange = false) {
		if (!val) return;
		const self = this;
		let $selector;
		if (inputName === false) {
			$selector = this.$el.find('input, textarea, select');
		} else {
			$selector = this.$el.find(`input[name="${inputName}"], select[name="${inputName}"], textarea[name="${inputName}"]`);
		}

		if (!$selector.length) {
			console.error(`Input name ${inputName} did not exist for PromptedInput`, this.$el);
			return;
		}
		if (Array.isArray(val)) {
			// set the value
			if ($selector[0].selectize && $selector[0].multiple) {
				// handle selectize that accepts multiple values
				val.forEach(v => $selector[0].selectize.addOption(v))
				$selector[0].selectize.setValue(val.map(v => v.id));
				if (triggerChange) {
					$selector.trigger('change');
				}
			} else {
				// handle multiple inputs with the same name.  go through them
				// in the order jQuery finds them
				for (let i = 0; i < val.length; i++) {
					let $elem = $selector.eq(i);

					if (i > 0 && (!$elem || !$elem.length)) {
						$elem = this.addAnother();
						if (!$elem) {
							// should never happen but if somebody sends an array to set value for a non-repeatable
							// field, adding another field will fail
							continue;
						}
						$elem = $elem.find(`input[name="${inputName}"], select[name="${inputName}"], textarea[name="${inputName}"]`);
					}
					// set the value
					if ($elem[0].selectize) {
						// for repeatable selectizes
						$elem[0].selectize.addOption(val[i]);
						$elem[0].selectize.setValue(val[i].id);
					} else {
						$elem.val(val[i]);
					}
					if (triggerChange) {
						$elem.trigger('change');
					}
				}
			}

		} else {
			// single value
			let $elem = $selector.first();
			if ($elem[0].selectize) {
				$elem[0].selectize.addOption(val);
				$elem[0].selectize.setValue(val.id);
			} else {
				$elem.val(val);
			}

			if (triggerChange) {
				$elem.trigger('change');
			}
		}

		this.showInputs();
	}

	/**
	 * Hide inputs, showing the prompt, i.e. "Add An SSN"
	 */
	hideInputs() {
		this.$el.find('.inputs_wrapper').slideUp();
		this.showPrompt();
	}

	/**
	 * Show the inputs, hiding the prompt
	 * 
	 * @param {boolean} focus 
	 */
	showInputs(focus = false) {
		this.hidePrompt();
		// enable the inputs
		this.$el.find('input, textarea, select').attr('disabled', false);
		// enable for selectize
		this.$el.find('input, textarea, select').each(function() {
			if (this.selectize) {
				this.selectize.enable();
			}
		});
		this.$el.find('.inputs_wrapper').slideDown();

		// focus on the first element
		if (focus !== false) {
			this.$el.find('.inputs_wrapper').find('input, textarea').first().focus();
		} else {
			this.$el.find('.inputs_wrapper').find('input, textarea').first().blur();
		}
	}
	/**
	 * Hide the prompt, i.e. "Add An SSN"
	 */
	hidePrompt() {
		this.$prompt.slideUp();
	}
	/**
	 * Show the prompt, i.e. "Add An SSN"
	 */
	showPrompt() {
		this.$prompt.slideDown();
	}
}

/**
 * Make available via jQuery
 */
if (!$j.fn.promptedInput) {
	$j.fn.initPromptedInput = function(options) {
		return this.each(function() {
			if (this.promptedInput) return;
			this.promptedInput = new PromptedInput($j(this), options);
		});
	};
}


sa.components.addToDrop = (function() {

	let addToDrop = {
		attachOnReceiveLoad : true
	};
	let templates;

	/**
	 * Shows the add to drop window
	 * @param {Object} options
	 *  @property {string} itemType the type of item you're adding (track, project, etc.) (required)
	 *  @property {int} itemId the id of the itemType (required)
	 *  @property {int} selectSite if you want a site auto-selected, pass this in with the site id (optional)
	 */
	addToDrop.show = function(options) {

		options = $j.extend({
			itemType : '',
			itemId : 0,
			selectSite : 0
		}, options);

		if (!options.itemType) {
			return console.error('itemType is required for addToDrop.show');
		} else if (!options.itemId) {
			return console.error('itemId is required for addToDrop.show');
		}

		console.log('adding', options.itemType, options.itemId);

		sa.api.request({
			handler : 'site-manager',
			action : 'listSites',
			getData : {
				siteType : 'drop',
				excludeCurrent :  1
			}
		}).then(function(sites) {
			if (sites.length) {
				showSiteList(sites, options);
			} else {
				sa.components.siteCreator.show({
					siteType : 'drop',
					callback : function(newSite) {
						if (newSite) {
							options.selectSite = newSite.id;
							addToDrop.show(options);
						}
					}
				});
			}
		}).catch(() => {
			sa.components.signup.show({
				whiteLabelAccount : false,
				callback : function() {
					try {
						safeLocalStorage.setItem('addToDrop', JSON.stringify(options));
					} catch (e) {
						console.error('Caught exception while setting addToDrop option string to localStorage', e);
					}
				},
				source : 'add_to_drop component',
				loginAction : 'reload',
				cancelAction : 'login',
				signupAction : 'show'
			});
		});
	};

	function showSiteList(sites, options) {
		let template = templates.get('site_list');

		let selector = template.find('#site_selector');
		sites.each(function(i, site) {
			selector.append(new Option(site.name, site.id));
		});
		if (options.selectSite) {
			selector.val(options.selectSite);
		}
		selector.append(new Option('Create New Drop Workspace', -1));
		selector.on('change', function() {
			if (selector.val() == -1) {
				sa.components.siteCreator.show({
					siteType : 'drop',
					callback : function(newSite) {
						if (newSite) {
							options.selectSite = newSite.id;
							addToDrop.show(options);
						} else {
							addToDrop.show(options);
						}
					}
				});
				fb.hide();
			}
		});

		let postData = {
			itemId : options.itemId,
			itemType : options.itemType
		};

		// set up formats
		let availableFormats = { mp3 : 1, wav : 1, aiff : 1 };
		if (options.itemType === 'track') {
			let track = trackBank.find(options.itemId);
			if (track) {
				for (let format in availableFormats) {
					if (availableFormats.hasOwnProperty(format) && !track.formats[format]) {
						delete availableFormats[format];
					}
				}
			}
		}
		let formatCount = Object.keys(availableFormats).length;
		if (formatCount === 0) {
			sa.alert('Sorry, the track(s) you selected have no downloadable formats and cannot be added to a Drop workspace.');
			return;
		}
		if (formatCount === 1) {
			postData.copyFormat = Object.keys(availableFormats)[0];
			template.find('#formats_container').remove();
		} else {
			let downloadFormatButtons = template.find('.single_format_download_button');
			downloadFormatButtons.on('click', function () {
				downloadFormatButtons.removeClass('selected');
				$j(this).addClass('selected');
				template.find('#copyFormat').val(this.dataset.format);
			});
			if (formatCount < downloadFormatButtons.length) {
				downloadFormatButtons.each(function(i, button) {
					if (!availableFormats[button.dataset.format]) {
						$j(button).remove();
					}
				});
			}
			downloadFormatButtons = template.find('.single_format_download_button');
			$j(downloadFormatButtons[0]).trigger('click');
		}

		template.find('#add_to_drop_site').on('click', function() {
			sa.api.request({
				handler : 'drop',
				action : 'add-to-site',
				postData : $j.extend(postData, sa.forms.validate(template).values)
			}).then(function(data) {
				fb.hideLoader();
				fb.hide();
				sa.notify({
					text : data.trackCount + ' track(s) copied to ' + data.siteName,
					type : sa.notify.notificationTypes.success
				});
			}).catch(function() {
				fb.hideLoader();
				sa.alert(data.error);
			});
			fb.showLoader('Adding tracks...');
		});

		template.find('#cancel_button').on('click', function() {
			fb.hide();
		});

		sa.forms.init(template);

		let fb = new FocusBox(template, { title : 'Add ' + options.itemType + ' to your drop workspace' });
		fb.show();
	}

	addToDrop.attach = function() {
		try {
			let optionsString = safeLocalStorage.getItem('addToDrop');
			if (optionsString) {
				safeLocalStorage.removeItem('addToDrop');
				let options = JSON.parse(optionsString);
				if (options) {
					addToDrop.show(options);
				}
			}
		} catch (e) {
			console.error('Caught exception while getting addToDrop option string from localStorage', e);
		}
	};

	addToDrop.build = function() {
		templates = sa.templates.get('components.add_to_drop');
	};

	return addToDrop;

})();

sa.components.buttons = (function() {

	var buttons = {};
	/** @var TemplateSet */
	var templates;

	/**
	 * Creates a button to feature something
	 * @param {Object} options
	 * 	@property {int} id the item
	 * 	@property {string} type artist, album, label, etc.
	 * 	@property {int} featured is the item already featured
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon (optional)
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable) (optional)
	 * 		if this text contains the word 'Feature', it will be replaced by 'Unfeature' when appropriate
	 * @return {JQuery} the button
	 */
	buttons.generateFeatureButton = function(options) {
		if (config.siteType === 'drop' || config.grayLabel) return $j();
		options = $j.extend({
			id : 0,
			type : '',
			featured : 0,
			wide : false,
			text : 'Feature'
		}, options);
		options.text = htmlEncode(options.text);
		var a;
		if (options.wide) {
			if (options.featured) {
				options.text = options.text.replace('Feature', 'Unfeature');
			}
			a = templates.get('generate_feature_button_wide', { text : options.text });
		} else {
			a = templates.get('generate_feature_button');
		}
		a.attr('title', options.featured ? 'Click here to unfeature this ' + options.type : 'Click here to feature this ' + options.type);
		if (options.featured) {
			a.addClass('featured');
		}
		a.on('click', function() {
			// swap status so we know what it is
			options.featured = options.featured ? 0 : 1;
			// update the title so the user gets a new message
			a.attr('title', options.featured ? 'Click here to unfeature this ' + options.type : 'Click here to feature this ' + options.type);
			// swap the icon
			if (options.featured) {
				a.addClass('featured');
			} else {
				a.removeClass('featured');
			}
			// swap the text
			if (options.wide) {
				if (options.featured) {
					options.text = options.text.replace('Feature', 'Unfeature');
				} else {
					options.text = options.text.replace('Unfeature', 'Feature');
				}
				// make sure we can change text even when this button has been moved
				var button = $j(this);
				var textContainer = button.find('.text');
				if (textContainer.length) {
					textContainer.html(options.text);
				} else {
					button.html(options.text);
					sa.notify({ text : gde(options.type, { c : 'upper' }) + ' ' + (options.featured ? 'featured' : 'unfeatured') });
				}
			}
			// tell the server to update
			sa.api.request({
				handler : 'features',
				action : (options.featured ? 'feature' : 'unfeature'),
				postData : {
					type : options.type + 's',
					id : options.id
				}
			});
			// swap the featured class on the item being featured
			if (options.type == 'track') trackBank.updateAll(options.id, 'featured', options.featured);
			var item = $j('#lr_' + options.id + ', #item_' + options.id);
			options.featured ? item.addClass('featured') : item.removeClass('featured');
			// don't do anything with the click
			if (this.blur) this.blur();
			return false;
		});
		return a;
	};

	/**
	 * Not really a button but fakes one with the same styling as a feature button
	 * @return {JQuery}
	 */
	buttons.generateFeatureBadge = function() {
		return templates.get('generate_feature_badge');
	};

	/**
	 * A button that shows the edit options. If you want to just show them directly, call sa.components.itemEditInterface.show
	 * @param {Object} options
	 * 	@property {string} type
	 * 	@property {Album|Catalog|Label|Artist|Project|ProjectFolder|Writer|Publisher} item
	 * 	@property {boolean} wide
	 * 	@property {string} text
	 * 	@property {function} callback - sends 1 param, did the user hit save? we're not guaranteeing anything good happened.
	 * @return {JQuery}
	 */
	buttons.generateEditButton = function(options) {

		options = $j.extend({
			type : '',
			item : null,
			wide : false,
			text : '',
			callback : null
		}, options);
		var displayType = (options.type == 'project' ? 'playlist' : gde(options.type, { c : 'lower', p : false }));

		if (!options.text) {
			options.text = 'Edit this ' + displayType;
		}
		options.text = htmlEncode(options.text);

		var a = templates.get('generate_edit_button' + (options.wide ? '_wide' : ''), { tooltip : options.text });

		a.on('click', function (e) {
			sa.components.itemEditInterface.show(options);
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
		});

		return a;
	};

	/**
	 * Shows an option to delete an album
	 * @param {Object} options
	 * 	@property {Album} album
	 * 	@property {boolean} wide
	 * 	@property {string} text
	 * 	@property {function} callback - sends 1 param, did the user hit save? we're not guaranteeing anything good happened.
	 * 	@property {function} processingCallback - called when (if) the user clicks Delete so you can show a cover. it might take awhile
	 * @return {JQuery}
	 */
	buttons.generateAlbumDeleteButton = function(options) {

		options = $j.extend({
			album : null,
			wide : false,
			text : '',
			callback : null,
			processingCallback : null
		}, options);

		if (!options.text) {
			options.text = 'Delete this ' + gde('album', { p : false, c : 'lower' });
		}
		options.text = htmlEncode(options.text);

		var a = templates.get('generate_album_delete_button' + (options.wide ? '_wide' : ''), { tooltip : options.text });

		a.on('click', function() {
			sa.confirm({
				text : templates.get('album_delete_button_confirm_text', { name : options.album.name }).html(),
				yesFunction : function () {
					ajax('id=' + options.album.id + '&action=delete', function (response) {
						sa.notify({ text : response[0].result });
						if (options.callback) {
							options.callback();
						}
					}, 'POST', 'p=album_details');
					if (options.processingCallback) {
						options.processingCallback();
					}
				},
				yesText : 'Delete'
			});
		});

		return a;
	};

	/**
	 * Shows a button-like indicator of what someone downloaded or played
	 * @param {Object} options
	 * 	@property {string} type
	 * @return {JQuery}
	 */
	buttons.generateInteractionHistoryButton = function(options) {

		options = $j.extend({
			type : 'item'
		}, options);

		var iconClass = 'fa fa-music';
		var name = 'Item';
		if (options.type == 'project-new' || options.type == 'project' || options.type == 'playlist') {
			iconClass = 'fa fa-folder-o';
			name = 'Playlist';
		} else if (options.type == 'track') {
			name = 'Track';
		} else if (options.type == 'album') {
			iconClass = 'fal fa-compact-disc';
			name = 'Album';
		} else if (options.type == 'cue_sheet') {
			iconClass = 'fa fa-list';
			name = 'Cue Sheet';
		} else {
			return $j('<span/>');
		}

		return templates.get('generate_interaction_history_button', {
			iconClass : iconClass,
			name : htmlEncode(name)
		});

	};

	/**
	 * @param {object} options
	 * 	@property {boolean} small
	 * 	@property {function} onClick fires when the button is clicked
	 * 	@property {Array.<OptionsMenuItem>} optionsMenuItems instead of firing callback, if you specify menu items, an options menu will expand out of the button when clicked
	 * @return {JQuery}
	 */
	buttons.generateAddButton = function(options) {

		options = $j.extend({
			small : false,
			onClick : function() {},
			optionsMenuItems : []
		}, options);

		var template = templates.get('add_button');

		if (options.small) {
			template.addClass('small');
		}

		if (options.optionsMenuItems.length) {

			new sa.components.OptionsMenu({
				items : options.optionsMenuItems,
				iconClass : 'fa-plus',
				customAnchor : template
			});

			console.warn('This functionality is unfinished');

		} else {

			template.on('click', function () {
				options.onClick();
			});

		}

		return template;

	};

	/**
	 * Creates a button that prompts users to add things to their drop site
	 * @param {object} options
	 *  @property {string} type (album|track|project)
	 *  @property {int} itemId id of the $type
	 * 	@property {boolean} small
	 * 	@property {string} text to show in the button
	 * @return {JQuery}
	 */
	buttons.generateAddToDropButton = function(options) {

		options = $j.extend({
			addClass: false,
			small: false,
			type : '',
			itemId : 0,
			text : 'Add to New workspace'
		}, options);

		var template = templates.get('add_to_drop_button');
		if (options.addClass){
			template.removeClass('wide').addClass(options.addClass);
		}
		if (options.small) {
			template.addClass('small');
		}
		options.text = htmlEncode(options.text);
		template.find('.text').html(options.text);

		template.on('click', function() {
			sa.components.addToDrop.show({ itemType : options.type, itemId : options.itemId });
		});

		return template;

	};

	buttons.generateAIArtButton = function({entityObj, entityType, buttonClasses = '', buttonText = '', zOrder = 5, overrideSaveFunc = undefined, onRequestGetOverrides = () => {}}) {
		if (entityType == 'project_item_list') {
			entityType = 'playlist';
		}
		const entityDisplayName = config.getDictionaryEntry(entityType);
		if (!entityDisplayName) {
			console.error("tried to call generateAIArtButon with an invalid entityType", entityType);
			return;
		}

		const entityId = entityObj?.id;
		
		let template = $j("<div class='ai-art-button'></div>");
		window.mountReactComponent(template[0], 'ai-art-generate-button', {
			entityId, 
			entityDisplayName, // passing so we don't have to call config.getDictionaryEntry in React, keep React independent of the other JS
			entityType, 
			buttonClasses,
			buttonText: buttonText || '',
			overrideSaveFunc, // if passed, this function will be called instead of saving the return url
			onRequestGetOverrides,
			zOrder,
		});
		return template
	}

	buttons.generateAIButton = function(options) {
		let {title = "AI Button", tooltip} = options;

		let template = templates.get('ai_button', {tooltip: tooltip || title, title: title });
		return template;
	}

	buttons.build = function() {
		templates = sa.templates.get('components.buttons');
	};

	return buttons;

})();

sa.components.bottomBar = (function() {

	var bottomBar = {
		attachOnLoad : true,
		attachOnReceiveLoad : true
	};
	var container;
	var templates;
	
	bottomBar.showTrack = function(trackId) {
		container.addClass('player_has_track');
		sa.getDomBody().addClass('showing_playbar')
		// player calls this when the track changes. just copied here to remove it from old component
	};

	bottomBar.hideTrack = function(trackId) {
		container.removeClass('player_has_track');
		sa.getDomBody().removeClass('showing_playbar');

	};
	
	bottomBar.enableQuickProjects = function() {
		// projector calls this. a stub for now to remove old component
	};

	bottomBar.enableQuickCueSheets = function() {
		// cue sheeter calls this. a stub for now to remove old component
	};

	bottomBar.disableQuickProjects = function() {
		// projector and others calls this. a stub for now to remove old component
	};

	bottomBar.addComponent = function(component) {
		container.append(component);
	};

	bottomBar.attach = function() {
		$j('body').append(container);
	};

	bottomBar.build = function() {
		templates = sa.templates.get('bottom_bar');
		container = templates.get('bottom_bar');
	};

	return bottomBar;

})();/**
 * Confirms and processes cloning of tracks
 */

sa.showTrackCloner = function(track) {
	//private vars
	var me = this;
	/** @var {FocusBox} box */
	var box = null;
	var content;
	var templates = sa.templates.get('components.clone_track_confirm');
	var newValues = {};

	function submit(track) {

		box.showLoader('Processing...');

		//let's find out which values to use
		var input = sa.forms.validate(content);

		if (input.error) {
			box.showErrorMessage(input.errors[0].errorDetail);
			return;
		}

		var values = input.values;

		['album', 'catalog', 'label'].each(function (i, type) {
			if (values[type] < 0) {
				values[type] = { name : newValues[values[type]] };
			} else {
				values[type] = { id : values[type] };
			}
		});

		values.trackId = track.id;
		if (config.siteType == 'drop') {
			values.catalog.id = track.catalog.id;
			values.label.id = track.label.id;
		}

		ajax(values, function(response) {
			response = response[0];
			console.log('submit response:', response);
			box.hideLoader();

			if (response.error) {
				box.showErrorMessage('There was a problem cloning your track. ' + response.error);
			} else {
				box.showSuccessMessage(templates.get('success_message'));
				content.addClass('cloned');
			}
		}, 'POST', { p : 'clone_track', action : 'clone' });

	}

	this.hide = function() {
		box.hide();
	};

	function setUpSelect(name, current, container) {

		var select = container.find('select');
		var fieldValueContainer = container.find('.value');
		var currentValue = current.id;
		var currentDisplayValue = current.name;
		var newValueIndex = 0;

		var selectizeOptions = {
			delimiter : '\n',
			placeholder : 'Click to specify ' + name,
			labelField : 'value',
			searchField : 'value',
			sortField : 'value',
			valueField : 'id',
			onChange : function(newValue) {
				var changed = false;
				if (newValue != currentValue) {
					changed = true;
					fieldValueContainer.html(container.find('div[data-value=' + newValue + ']').html());
				}
				if (changed) {
					container.addClass('changed');
				} else {
					container.removeClass('changed');
					fieldValueContainer.html(currentDisplayValue);
				}
			},
			load : function (query, callback) {
				if (!query.length) return callback([]);
				ajax({ p : 'list', type : name, ids : 1, part : query, excludeSyncs : 1 }, function (response) {
					var items = [];
					if (response && response.length && response[0].items) {
						response[0].items.each(function() {
							items.push({ id : this.id, value : this.value.replace(/&quot;/g, '"') });
						});
					}
					callback(items);
				});
			},
			create : function(input) {
				newValueIndex--;
				newValues[newValueIndex] = input;
				return { id : newValueIndex, value : input };
			}
		};

		if (name == 'catalog') {
			delete selectizeOptions.create;
		}

		select.find('.initial_value').attr('value', currentValue).html(currentDisplayValue);
		select.selectize(selectizeOptions);
		fieldValueContainer.html(currentDisplayValue);
		container.addClass('select_editable_field');
	}

	// show the confirmer
	(function() {

		content = templates.get('cloner');
		content.find('#clone_title').val(track.title);

		sa.forms.init(content);
		if (config.siteType !== 'drop') {
			setUpSelect('catalog', track.catalog, content.find('#catalog_row'));
			setUpSelect('label', track.label, content.find('#label_row'));
		} else {
			content.find('#catalog_row').remove();
			content.find('#label_row').remove();
		}
		setUpSelect('album', track.album, content.find('#album_row'));

		box = new FocusBox(content, { title : 'Clone a track' });
		box.show();

		//handlers
		content.find('.submit').on('click', function() { submit(track); });
		content.find('.cancel, .done').on('click', function() { me.hide(); });

		box.show();

	})();

};
///////////////////////
// Sharer
///////////////////////

sa.components.collaborationManager = (function() {

	var collaborationManager = {};
	var templates;

	/** @var FocusBox */
	var currentFocusBox;
	var cont;

	/**
	 *
	 * @param response
	 * 	@property {string} result
	 * 	@property {boolean} owner
	 * 	@property {Array} sharedWith
	 * 	@property {string} sharedWithHash
	 * @param {string} type
	 * @param {Project} item
	 */
	function showSharedWithList(response, type, item) {
		var list = cont.find('.shared_with_list');
		if (response.result != 'Success') {
			if (response.result == 'viewers-cannot-see-shared') {
				sa.components.emailer.show({ type : type, item : item });
				currentFocusBox.hide();
			} else {
				list.html(response.result);
			}
			return;
		}
		var sharedWith = response.sharedWith;
		var owner = response.owner;
		list.empty();
		for (var i = 0, len = sharedWith.length; i < len; i++) {
			var share = sharedWith[i];
			var swTemplate = templates.get('shared_with', {
				username : share.user.username,
				email : share.user.email,
				userId : share.user.id
			});
			if (share.user.avatar && share.user.avatar.indexOf('default_editor') === -1) {
				swTemplate.find('.user_image').removeClass('fas fa-user-circle').find('img').attr('src', share.user.avatar);
			}
			if (share.user.id != user.id) {
				swTemplate.find('.you').remove();
			}
			if (share.type == 'owner') {
				swTemplate.find('.share_type_editor').remove();
			} else {
				swTemplate.find('.share_type_owner').remove();
			}
			if (!owner) {
				swTemplate.find('.is_owner').remove();
			}
			swTemplate.find('.share_type_editor').val(share.type);
			list.append(swTemplate);
		}
		// make the delete buttons work
		list.find('a.delete').on('click', function() {
			$j(this).parent().remove();
		});
		// form it up
		sa.forms.init(list);
		// make the apply button work
		cont.find('#sharer_send_button').on('click', function() {

			const validationResult = sa.forms.validate(cont);

			if (validationResult.error) {
				return;
			}

			const ajaxParams = validationResult.values;
			ajaxParams.sharedWithHash = response.sharedWithHash;

			// validate the email addresses and remove any of the special formatting so we just get addresses
			const emails = ajaxParams.addPeople.split(',');
			const validEmails = [];
			emails.each((i, email) => {
				email = email.trim().replace(/(?:"[^"]*")? *?<([^>]+)>/, '$1');
				if (email.isEmail()) {
					validEmails.push(email);
				}
			});
			ajaxParams.addPeople = validEmails;

			currentFocusBox.showLoader('Sharing...');
			currentFocusBox.hideErrorMessage();
			ajax(ajaxParams, (responseArray) => {
				/**
				 * @var {Object} response
				 * 	@property {Array.<string>} notUsers
				 * 	@property {Array.<Project>} projects
				 * 	@property {string} result
				 */
				const response = responseArray[0];
				if (response.result == 'Success') {
					currentFocusBox.hide();
					sa.notify({ text : $j('<div>Changes saved!' + (response.notUsers && response.notUsers.length ? '<br/>The following emails weren\'t added because they weren\'t associated with users: ' + response.notUsers.join(', ') : '') + '</div>') });
					// if we were on the project page for this project, start a concurrency check
					const projectItemPage = sa.pages.projectItemList;
					const newProject = response.projects[0];
					if (newProject.shared && !item.shared && projectItemPage && projectItemPage.project.id === item.id) {
						// reload the user's project list
						user.reloadProjects();
						// check the project's concurrency
						sa.components.projector.checkConcurrency(newProject);
					} else if (!newProject.shared && item.shared && projectItemPage && projectItemPage.project.id === item.id) {
						// reload the user's project list
						user.reloadProjects();
						// check the project's concurrency
						sa.components.projector.checkConcurrency(newProject);
					}
				} else {
					currentFocusBox.hideLoader();
					currentFocusBox.showErrorMessage(response.result);
				}
			}, 'POST', 'p=' + type + 's&action=set_shared_with&' + type + 'Id=' + item.id);
		});
	}

	/**
	 * Shows the collaborationManager so the user can share something or modify its sharing settings
	 * @param options
	 * 	@propery {string} type - object type (only projects currently)
	 * 	@propery {Project} item
	 */
	collaborationManager.show = function(options) {

		options = $j.extend({
			type : '',
			item : null
		}, options);

		if (!options.type || !options.item) {
			console.error('Trying to show collaborationManager without required attributes (type, item)', options);
			return;
		}

		if (config.grayLabel) {
			sa.showGrayLabelNotice();
			return;
		}

		cont = templates.get('sharer');

		var personalMessageContainer = cont.find('.personal_message_container');
		var newOptions = cont.find('.new_options');
		sa.forms.init(cont, {
			realTimeValidationCallback : function (validationResult) {
				if (validationResult.name == 'addPeople') {
					if (validationResult.value) {
						newOptions.addClass('showing');
					} else {
						newOptions.removeClass('showing');
					}
				} else if (validationResult.name == 'notifyByEmail') {
					if (validationResult.value) {
						personalMessageContainer.addClass('showing');
					} else {
						personalMessageContainer.removeClass('showing');
					}
				}
			}
		});

		var ajaxParams = { p : options.type + 's', action : 'load_shared_with_list' };
		ajaxParams[options.type + 'Id'] = options.item.id;
		ajax(ajaxParams, function(response) {
			showSharedWithList(response[0], options.type, options.item);
		});

		currentFocusBox = new FocusBox(cont, {
			title : 'Collaboration settings'
		});
		currentFocusBox.show();

		cont.find('.confirm_no').on('click', function() {
			currentFocusBox.hide();
			currentFocusBox = null;
		});

	};

	/**
	 * Creates a button that will spawn the collaborationManager when clicked
	 * @param {Object} options - these options are also passed to the emailer
	 * 	@property {string} type - object type
	 * 	@property {Project} item
	 * 	@property {boolean} wide - defaults to false
	 * 	@property {string} text - the text on button, if wide
	 * 	@property {string} tooltip - defaults to something reasonable
	 * @returns {JQuery}
	 */
	collaborationManager.generateShareButton = function(options) {

		options = $j.extend({
			type : '',
			item : null,
			wide : false,
			text : 'Collaborate',
			tooltip : 'Click to collaborate on this ' + (options.type != 'project' ? options.type : 'playlist') + ' with people'
		}, options);

		if (!options.type || !options.item) {
			console.error('Trying to generate collaboration button without required attributes (type, item)', options);
			return $j();
		}

		var img = templates.get('generate_share_button' + (options.wide ? '_wide' : ''), { text : options.text });

		img.on('click', function() {
			if (!lockdown) {
				collaborationManager.show(options);
			} else {
				sa.showLockdownMessage();
			}
			this.blur();
		});

		img.attr('title', options.tooltip);

		return img;
	};

	collaborationManager.build = function() {
		templates = sa.templates.get('components.collaboration_manager');
	};

	return collaborationManager;

})();
/**
 * The cookie manager allows the user to manage their cookie settings, showing the initial overlay and the expanded popup, if requested
 */
sa.components.cookieManager = (function() {

	var cookieManager = {
		attachOnLoad : true,
		attachOnLoginLoad : true
	};
	var container;
	var templates;
	let showingTimeout;
	
	cookieManager.hide = function() {
		if (showingTimeout) {
			clearTimeout(showingTimeout);
			showingTimeout = null;
		}
		if (container) {
			container.on('transitionend', function () {
				container.remove();
			});
			container.removeClass('showing');
		}
	};

	/**
	 * Save the user's new cookie preferences
	 * @param {boolean} preference true/false for this cookie type
	 * @param {boolean} statistical true/false for this cookie type
	 * @param {boolean} marketing true/false for this cookie type
	 * @param {boolean} login true/false for this cookie type
	 * @param {string} source
	 */
	function saveSettings(preference, statistical, marketing, login, source) {
		// did the user revoke permission for something they allowed previously?
		let restrictedCurrentCookies = ((!preference && sa.cookies.allowCookieType(sa.cookieTypes.preference)) || (!statistical && sa.cookies.allowCookieType(sa.cookieTypes.statistical)) || (!marketing && sa.cookies.allowCookieType(sa.cookieTypes.marketing)) || (!login && sa.cookies.allowCookieType(sa.cookieTypes.login)));
		
		// change the settings locally
		sa.cookies.setAllowCookieType(sa.cookieTypes.preference, preference);
		sa.cookies.setAllowCookieType(sa.cookieTypes.statistical, statistical);
		sa.cookies.setAllowCookieType(sa.cookieTypes.marketing, marketing);
		sa.cookies.setAllowCookieType(sa.cookieTypes.login, login);
		sa.cookies.setAgreedToCookies(Math.floor(new Date().getTime() / 1000));
		
		// change the settings on the server
		sa.api.request({
			handler : 'privacy',
			action : 'saveCookiePreferences',
			postData : {
				preference : preference,
				statistical : statistical,
				marketing : marketing,
				login : login,
				source : source
			}
		}).then(function() {
			if (restrictedCurrentCookies) {
				// if the user revoked permission to something they allowed previously, we really need to reload the page to make sure we stop everything
				sa.alert({
					text : 'Please reload the page to ensure your new cookie preferences are applied going forward.',
					onClose : function() { window.location.reload(); }
				});
				// to make sure that already loaded libraries don't track the user as the page reloads, we block all unload-type event listeners
				window.addEventListener('visibilitychange', function(e) { e.stopImmediatePropagation(); }, true);
				window.addEventListener('pagehide', function(e) { e.stopImmediatePropagation(); }, true);
			}
		});
		
	}
	
	cookieManager.showCustomizer = function() {
		config.cookieUses = config.cookieUses.map(u => {
			return StringSanitize.stripTags(StringSanitize.sanitize(u));
		});
		
		const customizer = templates.get('customize_cookies', {
			siteName: config.name,
			marketing_cookie_explanation: '<ul><li>' + config.cookieUses.join('</li><li>') + '</li></ul>'
		});

		// not every site will have custom cookie uses. these are set in Add-Ons->Tracking/Analytics
		if (!config.cookieUses.length) {
			customizer.find('.marketing_cookie_preference').remove();
		}

		let fb = new FocusBox(customizer, { title : 'Customize Cookies' });

		// update checkboxes to match user settings
		if (sa.cookies.allowCookieType(sa.cookieTypes.preference)) {
			customizer.find('input[name=preference]').prop('checked', true);
		}
		if (sa.cookies.allowCookieType(sa.cookieTypes.statistical)) {
			customizer.find('input[name=statistical]').prop('checked', true);
		}
		if (sa.cookies.allowCookieType(sa.cookieTypes.marketing)) {
			customizer.find('input[name=marketing]').prop('checked', true);
		}
		if (sa.cookies.allowCookieType(sa.cookieTypes.login)) {
			customizer.find('input[name=login]').prop('checked', true);
		}

		// give them another chance to accept all
		customizer.find('#accept_all_cookies').on('click', function() {
			fb.hide();
			cookieManager.hide();
			saveSettings(true, true, config.cookieUses.length > 0, true, 'customizer accept all');
		});

		// the descriptions of the cookie types are initially collapsed for space but users can expand them
		customizer.find('.expander').on('click', function() {
			let expander = $j(this);
			let content = expander.next();

			if (content.hasClass('closed')) {
				content.slideDown();
				content.removeClass('closed');
				expander.removeClass('fa-angle-down').addClass('fa-angle-up');
			} else {
				content.slideUp();
				content.addClass('closed');
				expander.addClass('fa-angle-down').removeClass('fa-angle-up');
			}
		});

		// cookie setting save button
		customizer.find('#accept_limited_cookies').on('click', function() {
			fb.hide();
			cookieManager.hide();
			saveSettings(!!customizer.find('input[name=preference]:checked').length, !!customizer.find('input[name=statistical]:checked').length, !!customizer.find('input[name=marketing]:checked').length, !!customizer.find('input[name=login]:checked').length, 'customizer');
		});

		// if they cancel out, we hide the customizer but not the bottom bar. they still need to agree
		customizer.find('.confirm_no').on('click', function() {
			fb.hide();
		});

		fb.show();
	};
	
	cookieManager.show = function() {
		let body = sa.getDomBody();

		sa.components.documentViewer.enableButtons(container);

		// if the user clicks the big "accept all" button, mark that they accepted everything
		container.find('#accept_everything').on('click', function() {
			cookieManager.hide();
			saveSettings(true, true, config.cookieUses.length > 0, true, 'cookie bar accept all');
		});

		// if the user clicks the "decline all" button, mark that they declined everything
		container.find('#decline_everything').on('click', function() {
			cookieManager.hide();
			saveSettings(false, false, false, false, 'cookie bar decline all');
		});

		// if they want to customize cookies, show them the big window with all the information
		container.find('#customize_cookies').on('click', function() {
			cookieManager.showCustomizer();
		});

		body.append(container);

		// animate in (store the timeout so we can cancel if necessary)
		showingTimeout = setTimeout(function() {
			container.addClass('showing');
		}, 250);
	};

	cookieManager.attach = function() {
		sa.on('start', function() {
			if (!sa.cookies.hasAgreedToCookies()) {
				cookieManager.show();
			}
		});
	};

	cookieManager.build = function() {
		templates = sa.templates.get('components.cookie_manager');
		container = templates.get('cookie_manager', { siteName : htmlEncode(config.name) });
		if (config.id < 1 || (!config.cookieUses.length && window['gaCodes'] && window['gaCodes'].length === 1)) {
			container.find('.site_specific_notice').remove();
		}
	};

	return cookieManager;

})();
/**
 * Lets users view "documents" (HTML pages from the documents folder) in a popup window.
 * The easiest way to use it is to add a link with the class "document_viewer_button" and a data-document attribute
 * and then run sa.components.documentViewer.enableButtons($container) to enable the click event.
 * e.g., <a href="#0" class="document_viewer_button" data-document="terms">Terms and Conditions</a>
 * @type {{}}
 */
sa.components.documentViewer = (function() {
	
	var documentViewer = {};
	var templates;
	
	documentViewer.build = function() {
		sa.router.addRoute('document', {
			hash: '#!document',
			pattern: '/document'
		}, (params) => {
			let documentName = sa.router.paramsToVars(params).name;
			documentViewer.show(documentName);
			return true;
		});
		
		templates = sa.templates.get('document_viewer');
	};

	documentViewer.show = function(type) {
		ajax('p=document&d=' + type, function(newData) {

			var div = templates.get('document_display');
			div.addClass(type + '_document_container');
			div.find('#dc_body').html(newData[0].body);
			div.find('#close').on('click', function() {
				fb.hide();
			});
			
			documentViewer.enableButtons(div);

			var fb = new FocusBox(div, {
				title : newData[0].title,
				showClose : true,
				fillScreenAtLowResolution : 1000
			});
			fb.getFocusedContainer().addClass('document_viewer');
			fb.show();
			
		});
	};
	
	documentViewer.enableButtons = function(container) {
		if (!container) {
			container = $j('body');
		}
		container.find('.document_viewer_button').on('click', function(e) {
			documentViewer.show($j(this).data('document'));
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
	};
	
	return documentViewer;
	
})();
/**
 * Manages the download format selector
 */
sa.components.downloadFormatSelector = (function() {
	
	var selector = {};
	var templates;

	/**
	 * Creates a button that, when clicked, will show the download format selector
	 * @param {Object} options parameters that control how the selector appears and functions
	 *  @property {string} type what type of item is this? (album|track|project)
	 *  @property {Object} item the item you're trying to download
	 *  @property {int} itemId the item's id if it's a track
	 *  @property {boolean} wide should it be a full button?
	 *  @property {function} getItemForAjax used by the selector
	 *  @property {boolean} load
	 *  @property {boolean} useMetaPermissionProfile
	 * @return {JQuery} the
	 */
	selector.generateDownloadButton = function(options) {

		options = $j.extend({
			type : '',
			item : null,
			wide : false,
			getItemForAjax : undefined,
			useMetaPermissionProfile : false
		}, options);

		var itemId = 0;
		var loadedAdditionalOptions = false; // makes sure we don't double load any additional options
		let userDownloaded = false;

		// determine the item id and data
		if (options.item.id) {
			itemId = options.item.id;
		} else if (options.type == 'track' && options.itemId) {
			options.item = trackBank.find(options.itemId);
			if (!options.item) {
				console.log('Unable to find requested track in download format selector', options);
				return $j();
			}
			itemId = options.item.id;
		} else if (options.type == 'code') {
			itemId = options.item;
		} else if (options.type != 'selected') {
			console.log('Bad id passed into download format selector', options);
			return $j();
		}

		// figure out which options to show
		var downloadTypes = {};
		var types = [ 'mp3', 'aiff', 'wav' ];
		var t, tLen = types.length;
		var displayTitle = 'Download ';
		var downloadItems = [];

		for (t = 0; t < tLen; t++) {
			downloadTypes[types[t]] = { show : config.downloadFormats[types[t]], disable : false, size : '' };
		}

		if (options.type == 'track') {
			if (options.item.formats === undefined) {
				console.warn('Track item passed into download format selector without formats specified', options);
				return $j();
			}
			if (options.item.userDownloaded === 1) {
				userDownloaded = true;
			}
			for (t = 0; t < tLen; t++) {
				downloadTypes[types[t]].show &= !!options.item.formats[types[t]];
				downloadTypes[types[t]].size = options.item.formats[types[t]];
				downloadTypes[types[t]].disable = !!options.item.formats['disable' + types[t].ucfirst()];
			}
			if (options.item.title !== undefined) {
				displayTitle += options.item.title;
			}
			if (options.item.formats.extras.length) {
				var extras = options.item.formats.extras;
				for (var e = 0, eLen = extras.length; e < eLen; e++) {
					var extra = extras[e];
					var extension = extra.extension == 'aif' ? 'aiff' : extra.extension;
					downloadItems.push({
						custom : generateDownloadFormatTemplate(extension, 'Download ' + extra.type, extra.size),
						format : extension,
						type : 'extra',
						extra : extra
					});
				}
			}
			if (config.showDownloadStudio === 1 || (config.showDownloadStudio === 2 && user.hasAdminPermission(AdminPermission.Any))) {
				downloadItems.push({
					custom : generateDownloadFormatTemplate('download_studio', sa.pages.downloadStudio.buttonText),
					format : 'download_studio',
					type : 'download_studio'
				});
			}
			if (options.item.id == options.item.masterId) {
				for (var adf = 0, adfLen = types.length; adf < adfLen; adf++) {
					var adfType = types[adf];
					if (options.item.alternateDownloadFormats[adfType]) {
						downloadItems.push({
							custom : generateDownloadFormatTemplate(adfType, 'Download with alternates as ' + adfType + 's', options.item.alternateDownloadFormats[adfType].size),
							format : adfType,
							type : 'nested'
						});
					}
				}
			}
		} else if (options.type == 'album') {
			displayTitle += options.item.name;
			downloadTypes.aiff.show = downloadTypes.wav.show = false;
		} else if (options.type == 'project') {
			displayTitle += options.item.name;
			downloadTypes.aiff.show = downloadTypes.wav.show = false;
		} else if (options.type == 'cue_sheet') {
			displayTitle += options.item.name;
			downloadTypes.aiff.show = downloadTypes.wav.show = false;
		} else if (options.type == 'selected') {
			displayTitle += 'these tracks';
			downloadTypes.aiff.show = downloadTypes.wav.show = false;
		} else if (options.type == 'code') {
			displayTitle += 'these tracks';
		} else if (options.type == 'request_response') {
			displayTitle += 'this response';
			downloadTypes.aiff.show = downloadTypes.wav.show = false;
		}

		// add in the regular formats. iterate in reverse order because we're going to prepend them
		for (t = tLen - 1; t >= 0; t--) {
			var typeName = types[t];
			var type = downloadTypes[typeName];
			if (type.show) {
				var option = generateDownloadFormatTemplate(typeName, 'Download ' + typeName, type.size, options.type);
				if (type.disable) {
					option.addClass('disabled');
					option.prop('title', 'File will be available for download shortly');
				}
				downloadItems.unshift({
					custom : option,
					format : typeName,
					type : 'single',
					disabled : type.disable
				});
			}
		}

		// make them all clickable.
		for (var di = 0, diLen = downloadItems.length; di < diLen; di++) {
			let downloadItem = downloadItems[di];
			if (!downloadItem.disabled) {
				downloadItem.onClick = function (downloadItem) {
					download(downloadItem, options);
				};
			}
		}

		// title goes on top. unshift it on last
		downloadItems.unshift({ name : displayTitle, heading : true });

		var optionsMenu = new sa.components.OptionsMenu({
			itemId: options.item.id,
			items : downloadItems,
			hideOnOutsideClick: true,
			hideOnMouseLeave: true,
			entityType: 'dl_formats_' + options.type,
			iconClass: userDownloaded ? 'fa-download downloaded-fa-check' : 'fa-download',
			buttonAnchor: options.wide ? 'Download ' + (options.type == 'track' ? 'Track' : 'All') : false,
			tooltip: userDownloaded ? 'Previously downloaded' : 'Download',
			onShow : function() {
				if (loadedAdditionalOptions) return;
				loadedAdditionalOptions = true;
				if (options.type == 'album' || options.type == 'project' || options.type == 'cue_sheet' || options.type == 'request_response') {
					ajax('p=download_formats&type=' + options.type + '&id=' + itemId + (options.type == 'request_response' ? '&responseId=' + item.responseId : ''), function(response) {
						addAdditionalFormats(response, optionsMenu, options, downloadTypes);
					});
				} else if (options.type == 'selected') {
					ajax(options.getItemForAjax(), function(response) {
						addAdditionalFormats(response, optionsMenu, options, downloadTypes);
					}, 'POST', 'p=download_formats&type=' + options.type);
				}
			}
		});
		
		let anchor = optionsMenu.getAnchor();

		if (config.siteType === 'drop') {
			
			anchor.off('click');
			anchor.on('click', function() {
				sa.components.downloader.show({
					type : options.type,
					item : options.item,
					format : 'wav', // doesn't matter - each file only has one format
					getItemForAjax : options.getItemForAjax
				});
			});
			
		}

		anchor.addClass('download_anchor')

		return anchor;

	};

	/**
	 * Creates a line item for the download format selector
	 * @param {string} type used for icon generation. images/icons/[type].png should exist
	 * @param {string} displayMessage shown so the user gets some more details
	 * @param {int=} size the size to display in bytes (optional)
	 * @returns {JQuery} the line item
	 */
	function generateDownloadFormatTemplate(type, displayMessage, size, entityType = 'default') {
		var template = templates.get('download_format', { type : type, displayMessage : displayMessage, size : size ? sizeFormat(size) : '', entityType: entityType });
		if (!size) {
			template.addClass('unknown_size');
		}

		if (type == 'aif') type = 'aiff';
		if (type == 'mp3' || type == 'aiff' || type == 'wav') {
			return template;
		} else if (type == 'xls' || type == 'xlsx' || type == 'csv') {
			template.find('.image').addClass('fa fa-file-excel-o');
		} else if (type == 'pdf') {
			template.find('.image').addClass('fa fa-file-pdf-o');
		} else if (type == 'doc' || type == 'docx') {
			template.find('.image').addClass('fa fa-file-word-o');
		} else if (type == 'txt') {
			template.find('.image').addClass('fa fa-file-text-o');
		} else if (type == 'zip') {
			template.find('.image').addClass('fa fa-file-zip-o');
		} else if (type === 'download_studio') {
			template.find('.image').addClass('fa fa-display-arrow-down');
		} else {
			template.find('.image').addClass('fa fa-file-o');
		}
		
		return template;
	}

	/**
	 * Creates a single format download button (used on drop sites)
	 * @param {int} trackId
	 * @param {string} type
	 * @param {int} size
	 * @returns {JQuery}
	 */
	selector.generateSingleFormatTrackDownloadButton = function(trackId, type, size) {
		return templates.get('single_download_format', {
			type : type,
			size : sizeFormat(size),
			link : siteBaseUrl() + '/download.php?track_id=' + trackId + '&type=' + type + '&source=explorer'
		});
	};

	/**
	 * Creates a single format download button (used on drop sites)
	 * @param {int} albumId
	 * @returns {JQuery}
	 */
	selector.generateSingleFormatAlbumDownloadButton = function(albumId) {
		let button = templates.get('single_download_format', {
			type : 'zip',
			size : 'All files',
			link : siteBaseUrl() + '/download.php?album_id=' + albumId + '&source=explorer'
		});
		
		button.on('click', function() {
			sa.components.downloader.show({ type : 'album', item : { id : albumId }, format : 'wav' });
			return false;
		});
		
		return button;
	};

	/**
	 * Sets the user's default download format and starts a download
	 * @param {Object} downloadItem details about the item clicked
	 * @param {Object} options parameters that control how the selector appears and functions
	 */
	function download(downloadItem, options) {
		var option;
		var nested = 0;
		if (downloadItem.type == 'extra') {
			option = 'extra&extraType=' + encodeURIComponent(downloadItem.extra.type);
		} else if (downloadItem.type == 'download_studio' && options.type == 'track') {
			option = 'download_studio';
		} else if (config.downloadFormats.mp3 && downloadItem.format == 'mp3') {
			setTimeout(function() { user.setOption('default_download_format', 'mp3'); }, 100);
			option = 'mp3';
		} else if (config.downloadFormats.wav && downloadItem.format == 'wav') {
			setTimeout(function() { user.setOption('default_download_format', 'wav'); }, 100);
			option = 'wav';
		} else if (config.downloadFormats.aiff && downloadItem.format == 'aiff') {
			setTimeout(function() { user.setOption('default_download_format', 'aiff'); }, 100);
			option = 'aiff';
		} else {
			// if the config has disabled the type of download the user has as their default, they'll get an mp3
			option = 'mp3';
		}
		if (downloadItem.type == 'nested' || downloadItem.nested) {
			nested = 1;
		}
		if ((config.licensing.show_cart || config.licensing.coupons) && !options.item.can_download && options.type == 'track') {
			if(config.licensing.coupons) { // && user.credit) { //let's give them the ability to use credit here

				console.log('click of nondl/credit with type:', option);

				var box = new DownloadCreditConfirm(item, option);
				box.afterSuccess = function() {
					options.item.can_download = true;
				};
				box.show();

			}
		} else if (options.type == 'track' && downloadItem.can_download) {
			document.location.href = siteBaseUrl() + '/download.php?track_id=' + options.item.id + '&type=' + option + '&source=list&includeNested=' + nested;
		} else {
			sa.components.downloader.show({ type: options.type, item: options.item, format: option, getItemForAjax: options.getItemForAjax, nested: nested, useMetaPermissionProfile : options.useMetaPermissionProfile });
		}
	}


	/**
	 * Adds format specific download buttons based on a list of available formats from the server
	 * @param {{ mp3 : int, aiff : int, wav : int, nestedFormats : { mp3 : int, aiff : int, wav : int } }} formats the formats list
	 * @param {sa.components.OptionsMenu} optionsMenu
	 * @param {Object} options the selector show options
	 * @param {Object} downloadTypes
	 */
	function addAdditionalFormats(formats, optionsMenu, options, downloadTypes) {
		if (formats.mp3 && config.downloadFormats.mp3 && !downloadTypes.mp3.show) {
			addFormat('mp3', optionsMenu, options);
		}
		if (formats.aiff && config.downloadFormats.aiff && !downloadTypes.aiff.show) {
			addFormat('aiff', optionsMenu, options);
		}
		if (formats.wav && config.downloadFormats.wav && !downloadTypes.wav.show) {
			addFormat('wav', optionsMenu, options);
		}
		if (formats.nestedFormats) {
			if (formats.nestedFormats.mp3 && config.downloadFormats.mp3) {
				addNestedFormat('mp3', formats.nestedFormats.mp3, optionsMenu, options);
			}
			if (formats.nestedFormats.aiff && config.downloadFormats.aiff) {
				addNestedFormat('aiff', formats.nestedFormats.aiff, optionsMenu, options);
			}
			if (formats.nestedFormats.wav && config.downloadFormats.wav) {
				addNestedFormat('wav', formats.nestedFormats.wav, optionsMenu, options);
			}
		}
	}

	/**
	 * Helper function to actually add the additional formats so it doesn't have a ton of repeated code
	 * @param {string} format the format to add
	 * @param {sa.components.OptionsMenu} optionsMenu
	 * @param {Object} options the selector show options
	 */
	function addFormat(format, optionsMenu, options) {
		var template = generateDownloadFormatTemplate(format, 'Download ' + format);
		optionsMenu.addItem({
			custom : template,
			format : format,
			type : 'single',
			onClick : function(downloadItem) {
				download(downloadItem, options);
			}
		});
	}

	/**
	 * Helper function to actually add the additional nested formats so it doesn't have a ton of repeated code
	 * @param {string} format the format to add
	 * @param {int} size
	 * @param {sa.components.OptionsMenu} optionsMenu
	 * @param {Object} options the selector show options
	 */
	function addNestedFormat(format, size, optionsMenu, options) {
		var template = generateDownloadFormatTemplate(format, 'Download with alternates as ' + format + 's', size);
		optionsMenu.addItem({
			custom : template,
			format : format,
			onClick : function(downloadItem) {
				download($j.extend({ nested : 1 }, downloadItem), options);
			}
		});
	}

	selector.build = function() {
		templates = sa.templates.get('download_format_selector');
	};

	return selector;

})();

sa.components.downloader = (function() {

	var downloader = {};
	var templates;

	/**
	 * Calling this function creates a new focus boxed download widget and shows it
	 * @param {object} options the parameters that affect how the downloader displays
	 *  @property {string} type the type of item to download
	 *  @property {object} item the object to download
	 *  @property {string} format mp3|aiff|wav
	 *  @property {int} nested 1 or 0 should we include nested tracks?
	 *  @property {function} getItemForAjax gets a description of the item (required for selected type)
	 *  @property {boolean} test should we do a test run? if so, set a testCallback and it'll be passed the result. no ui is displayed if you're doing a test
	 *  @property {function} testCallback a function to call when test has completed with result. function will be passed one boolean param, true if downloading is allowed
	 *  @property {boolean} useMetaPermissionProfile if set, will be passed into ajax calls
	 */
	downloader.show = function(options) {

		options = $j.extend({
			type : '',
			item : null,
			format : 'mp3',
			nested : 0,
			getItemForAjax : function() {
				var itemDetails = {
					nested : options.nested
				};
				if (options.type == 'code') {
					itemDetails.code = options.item;
				} else if (options.type == 'tag') {
					itemDetails.tagId = options.item.id;
					itemDetails.userId = options.item.userId;
				} else if (options.type == 'project') {
					itemDetails.projectId = options.item.id;
				} else if (options.type == 'cue_sheet') {
					itemDetails.cueSheetId = options.item.id;
				} else if (options.type == 'album') {
					itemDetails.albumId = options.item.id;
				} else if (options.type == 'track') {
					itemDetails.trackId = options.item.id;
				} else if (options.type == 'request_response') {
					itemDetails.responseId = options.item.responseId;
				}
				return itemDetails;
			},
			test : false,
			testCallback : function() {},
			useMetaPermissionProfile : false
		}, options);
		if (options.test) options.format = 'mp3';

		var container = templates.get('downloader_frame');
		var focusBox = new FocusBox(container);
		focusBox.setTitle('Download');
		focusBox.show();
		focusBox.showLoader('Checking permissions...');
		
		var getVars = {
			p : 'download',
			format : options.format,
			agreed : user.getOption('agreed'),
			test : options.test ? 1 : 0
		};
		if (getVars.format.indexOf('extra&extraType=') === 0) {
			getVars.extraType = getVars.format.substring(16);
			getVars.format = 'extra';
		}

		let itemForAjax = options.getItemForAjax();
		if (options.useMetaPermissionProfile) {
			if (typeof itemForAjax === 'string') {
				itemForAjax += '&useMetaPermissionProfile=1';
			} else {
				itemForAjax.useMetaPermissionProfile = 1;
			}
		}
		ajax(itemForAjax, function(response) { setData(options, container, focusBox, response); }, 'POST', getVars);

	};

	downloader.startDownload = function(path, dlInfo = {}) {
		document.location.href = path;
	}

	/**
	 * Updates the ui after data's received from the server
	 * @param {Object} options
	 * @param {JQuery} container
	 * @param {FocusBox} focusBox
	 * @param {Array} newData the server's response
	 */
	function setData(options, container, focusBox, newData) {
		var response = newData[0];
		if (options.test) {
			options.testCallback(response.result == 'Download allowed' || response.result == 'Agreement required');
			return;
		}
		var dlInfo = _.pick(options, 'format', 'item', 'type', 'nested');
		var approved = response['auths'] && response['auths']['approved'] ? response['auths']['approved'] : [];
		var unapproved = response['auths'] && response['auths']['unapproved'] ? response['auths']['unapproved'] : [];
		container.empty();

		switch (response.result) {
			case 'Agreement required':
				focusBox.setTitle('Download - Agreement Required');
				container.append(templates.get('agreement_required'));
				container.find('.confirm_yes').on('click', function() {
					focusBox.showLoader('Processing request...');
					user.setOption('agreed', 1);
					ajax($j.extend({
						p : 'download',
						format : options.format,
						agreed : 1,
						ignore : response.ignore
					}, options.getItemForAjax()), function(response) {
						setData(options, container, focusBox, response);
					});
				});
				container.find('#details_downloading_conditions').append(newData[0].agreement);
				container.find('.confirm_no').on('click', function() {
					focusBox.hide();
				});
				break;
			case 'Permission requested':
				focusBox.setTitle('Download - Request Pending');
				container.append(templates.get('permission_requested', {
					email : user.userData.email,
					siteName : config.name
				}));
				if (approved.length) {
					addBatchApproved(options, container, focusBox, approved);
				}
				break;
			case 'Permission denied':
				focusBox.setTitle('Download - Not Available');
				if (!approved.length) {
					container.append(templates.get('permission_denied', {
						siteName : config.name
					}));
				} else {
					container.append(templates.get('partial_permission_denied', {
						siteName : config.name
					}));
					addBatchApproved(options, container, focusBox, approved);
				}
				break;
			case 'Permission required':
				// if we're a licensing site, let's show them a different message
				if (config.licensingConfig.show) {
					if (unapproved.length > 1) {
						sa.notify({ text : 'You do not have permission to download all the selected tracks. Please make sure you purchase them!' });
						focusBox.hide();
						return;
					} else if (unapproved.length && unapproved[0] && config.licensingConfig.coupons_active || config.licensingConfig.subscriptions_active) {
						var t = trackBank.find(unapproved[0]);
						licensingModal.getProfile( t || {id: unapproved[0]}, function(profile) {
							if (profile.oneprice) {
								console.log('click of nondl/credit with type:', t, options);
								AutoCreditPurchase.attempt(t, user.getOption('default_download_format'), profile, function() {
									//init();
								});
							} else { // this is not one-price and requires the licensing

								/* leaving this here, because i don't know if some client will demand that it opens up the license modal
								 // we've lost the mouse event by now, let's make a fake one from the middle (presumeably starting under the modal)
								 var e = {
								 pageX: $j(window).width(),
								 pageY: $j(window).height()
								 };

								 licensingModal.show(profile, item, e, function(r) {
								 console.log('- lm cb:', r);
								 if (r) {
								 var t = $j('#add_to_cart_' + item.id + ' img');
								 t.attr('src', 'images/shoppingcart/button-added-to-cart.png');
								 t.off();
								 }
								 selector.hide();
								 });*/

								sa.notify({ text : 'You do not have a license for this track. Add it to your cart!' });

							}
						});
					} else { // licensing is on, but we don't have an opportunity for credit.
						sa.notify({ text : 'You do not have a license for this track. Add it to your cart!' });
					}
					focusBox.hide();
					return;
				}
				if (config.licensing['show_cart'] || config.licensing['coupons']) {
					focusBox.setTitle('Download - Multi-Download Request');
					container.append(templates.get('permission_required_licensing'));
				} else if (config.downloadPermissionRequestText) {
					focusBox.setTitle('Download - Contact Us');
					container.append(templates.get('permission_required_contact', { text : config.downloadPermissionRequestText }));
					if (approved.length) {
						addBatchApproved(options, container, focusBox, approved);
					}
				} else {
					focusBox.setTitle('Download - Request Permission');
					container.append(templates.get('permission_required', { siteName : config.name }));
					var info = response.info || {};
					info.email = user.userData.email;
					if (response.info) {
						for (var infoKey in response.info) {
							if (response.info.hasOwnProperty(infoKey)) {
								container.find('input[name=' + infoKey + ']').val(response.info[infoKey]);
							}
						}
					}
					sa.forms.init(container);
					container.find('.confirm_yes').on('click', function() {
						submitDownloadRequest(options, container, focusBox);
					});
					if (approved.length) {
						addBatchApproved(options, container, focusBox, approved);
					}
				}
				break;
			case 'Download authorized':
				var files = response.files;
				focusBox.hide();
				if (response['allFilesHaveFiles'] === 0) {
					sa.confirm({
						text : templates.get('not_all_files_have_files', { fileType : options.format == 'wav' ? 'a WAV' : ('an ' + options.format.toUpperCase()) }).html(),
						yesText : 'Download',
						noText : 'Cancel',
						yesFunction : function () {
							downloader.startDownload(files[0].url, dlInfo);
						}
					});
				} else if (response['allFilesHaveType'] === 0 && config.siteType !== 'drop') {
					sa.confirm({
						text : templates.get('not_all_files_have_type', { fileType : options.format == 'wav' ? 'a WAV' : ('an ' + options.format.toUpperCase()) }).html(),
						yesText : 'Download',
						noText : 'Cancel',
						yesFunction : function () {
							downloader.startDownload(files[0].url, dlInfo);
						}
					});
				} else {
					if (config.showUserTrackDLIndicator) {
						try {
							updateUserTrackDLstates(options, response.auths.approved);
						} catch (e) {
							console.log(e.name, e.message);
						}
					}
					if (options.format === 'download_studio') {
						sa.router.routeTo(sa.pages.downloadStudio.generateRoute(options.item.id));
					} else {
						downloader.startDownload(files[0].url, dlInfo);
					}
				}
				return;
			default:
				container.append(templates.get('default_message', { message : response.result }));
		}
		container.find('.confirm_close').on('click', function() {
			focusBox.hide();
		});
		focusBox.hideLoader();
	}


	function updateUserTrackDLstates(options, dlTrackIds) {

		if (_.isEmpty(dlTrackIds)) {
			throw (new Error('No trackIds to process, trackIds = ' + dlTrackIds));
		}
		
		var knownTypes = ['project', 'cue_sheet', 'single', 'track', 'album'];
		var isKnownType = (knownTypes.find(x => x == options.type)) ? true : false;
		if (!isKnownType) {
			throw (new Error('Unknown option type, options.type = ' + options.type));
		}

		//update trackBank, download button class, and hover text
		for (var trackId of dlTrackIds) {
			trackBank.updateAll(trackId, 'userDownloaded', 1);
			trackBank.updateAll(trackId, 'userLastDLdate', Math.floor(Date.now() / 1000));
			$j('#dlBtn_' + trackId).addClass('downloaded-fa-check').prop('title', 'Previously downloaded');
		}
		console.log('Processed user track download state for these tracks: ' + dlTrackIds);
	}
	

	function submitDownloadRequest(options, container, focusBox) {
		var validationResult = sa.forms.validate(container);
		if (!validationResult.error) {
			focusBox.showLoader('Processing...');
			ajax(validationResult.values, function(response) {
				setData(options, container, focusBox, response);
			}, 'POST', $j.extend({
				p : 'download',
				permRequest : 1
			}, options.getItemForAjax()));
		}
	}

	function addBatchApproved(options, container, focusBox, approved) {
		var conf;
		var trackList;
		container.append(templates.get('batch_approved', { number : approved.length }));

		function setTracks(data) {
			trackList.setData(data, function() { return '#0'; }, function(page) { loadTracks(page); return false; });
		}

		function loadTracks(page) {
			trackList.loadPage('ids[]=' + approved.join('&ids[]=') + '&pg=' + page);
		}

		conf = new TrackListConfig();
		conf.allowList = true;
		conf.allowMiniBlock = false;
		conf.bankKey = 'batches';
		conf.addColumnList([
			new ListColumn('play', ['play']),
			new ListColumn('title', ['title']),
			new ListColumn('music rep', ['avatar', 'rep'])
		]);
		conf.callback = function(response) { setTracks(response); };
		conf.callbackActual = function(response) { setTracks(response); };
		conf.defaultResultsPerPage = 5;
		conf.headerBackground = true;
		conf.getDefaultView = function() { return ListViewType.List; };
		conf.pagination = true;
		conf.resultCountChanging = false;
		conf.resultsPerPageCookie = false;
		conf.sortable = false;
		conf.viewCookie = false;
		trackList = createTrackList(conf);
		trackList.generatePage(container.find('#partial_download_list'));
		loadTracks(0);

		container.find('#batch_downloading_alternative').on('click', function() {
			ajax($j.extend({
				p : 'download',
				format : options.format,
				ignore : 1
			}, options.getItemForAjax()), function (response) {
				setData(options, container, focusBox, response);
			});
		});
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
	/*function receiveMessage(event) {
		console.log('received a message!', event);
		if (event.origin != 'https://download.sourceaudio.com') return;
		if (event.data.multiFileDownload && event.data.downloadFrameId) {
			console.log('iframe loaded a multifile download');
			$j('iframe#' + event.data.downloadFrameId).addClass('showing');
			window['receivedEvent'] = event;
		} else {
			console.log('not a multifile download')
		}
	}

	window.addEventListener('message', function(event) { receiveMessage(event); }, true);*/

	downloader.build = function() {
		templates = sa.templates.get('components.downloader');
	};

	return downloader;

})();
/* eslint-disable */
// needs a rebuild into a class
sa.components.EDLImporter = (function() {

	var edl = {};
	var templates;
	var reviewFocusBox;

	edl.build = function() {
		templates = sa.templates.get('components.edl_importer');
	};

	edl.generateButton = function(button, cueSheetId) {
		var edl = this;
		edl.cueSheetId = cueSheetId;

		return new Uploader({
			button : button,
			browseCallback : function(uploader) {
				if (lockdown) {
					return sa.showLockdownMessage();
				}

				var file = uploader.getFileDetails()[0];
				console.log('- edl file:', file);

				var buttonTitle = $j('#cue_sheet_edl_button').html();
				$j('#cue_sheet_edl_button').html('Loading...');

				console.log('file info:', file);
				uploader.upload({
					params : 't=edl&cueSheetId=' + cueSheetId,
					complete : function(e, jsonData) {
						var r = JSON.parse(jsonData);
						
						if (r.content.length && r.content[0].result) {
							if (r.content[0].result === 'File format is not supported.') {
								$j('#cue_sheet_edl_button').html(buttonTitle);
								return sa.alert('File format is not supported.');
							}
						}
						
						var data = r.content[0].data;
						console.log('- upload complete:', data);
						$j('#cue_sheet_edl_button').html(buttonTitle);
						showReview(data);
					},
					progress : function(e, bytesLoaded, bytesTotal) {
						console.log('- edl progress:', bytesLoaded / bytesTotal);
					},
					error : function() { console.log('error during upload'); },
					fileId : file.id
				});
			},
			fileType : UploaderConstants.EDL
		});
	};

	function showReview(data) {
		console.log('edl data:', data);
		edl.data = data;

		if (reviewFocusBox) {
			reviewFocusBox.hide();
		}

		if (data.error) return sa.error(data.error);

		var template = templates.get('review');

		//is there anything to map?
		if (Array.isArray(data.fields) && !data.fields.length) {

			template.find('.mapping-title').html('');
			template.find('.mapping').html('');

		} else {

			//add mapping
			var ms = template.find('.mapping').html('');
			const fieldMap = {};
			for (var k in data.fields) {
				if (!data.fields.hasOwnProperty(k) || typeof data.fields[k] == 'function') continue;
				fieldMap[data.fields[k]] = k;
				ms.append('<div class="mapping-block">' + data.fields[k] + ': <select id="mapping-select-' + k + '" class="mapping-select"><option value=0>-- Leave Empty --</option><option value="src_in">Src In</option><option value="src_out">Src Out</option><option value="rec_in">Rec In</option><option value="rec_out">Rec Out</option><option value="duration_code">Duration (timecode)</option><option value="duration">Duration (secs)</option><option value="filename">Filename</option><option value="num">Edit Number</option></select></div>');
			}
			ms.append('<div class="clr"></div>');

			// set defaults: 
			// * Timing: Duration(timecode)
			// * TC IN: Rec IN
			// * TC OUT: Rec OUT
			ms.find('select#mapping-select-' + fieldMap['Timing']).val('duration_code');
			ms.find('select#mapping-select-' + fieldMap['TC In']).val('rec_in');
			ms.find('select#mapping-select-' + fieldMap['TC Out']).val('rec_out');
		}

		template.find('.save').on('click', function() { save(); });
		template.find('.cancel').on('click', function() { reviewFocusBox.hide(); });

		var c = template.find('.track_matches');

		for (var i in data.edits) {
			if (!data.edits.hasOwnProperty(i)) continue;

			var cut = data.edits[i];
			if (!cut.filename) continue;

			var t = templates.get('track_match', {
				id : 'cut-' + i,
				num : cut.num,
				trackCount : cut.tracks.length == 1 ? '1 track' : cut.tracks.length + ' tracks',
				filename : cut.filename,
				srcIn : cut['rec_in'],
				srcOut : cut['rec_out'],
				duration : secondsToClockTime(cut.duration)
			});

			for (var ii = 0; ii < cut.tracks.length; ii++) {
				try {
					var track = cut.tracks[ii] = JSON.parse('[' + cut.tracks[ii] + ']');
					track = track[0];
				} catch(e) {
					console.log('json error', cut);
					window.lastCut = cut;
					continue;
				}

				var tt = templates.get('single_track_match', {
					id : 'track-' + i + '-' + track.id,
					artist : (track.artist ? track.artist.name : 'None'),
					title : track.title,
					length : track.length
				});
				if (ii > 0) {
					tt.find('.action').html('');
				} else {
					tt.addClass('selected');
				}
				tt.data({
					track : track,
					cut : i
				});
				tt.on('click', function(e) {
					var track = $j(this).data('track');
					var cut = $j(this).data('cut');
					edl.data.edits[cut].chosen = {id: track.id};
					$j('#cut-' + cut + ' .track').removeClass('selected');
					$j('#cut-' + cut + ' .track .action').html('');
					$j('#track-' + cut + '-' + track.id).addClass('selected');
					$j('#track-' + cut + '-' + track.id + ' .action').html('Chosen');
				});
				t.find('.tracks').append( tt );
			}

			c.append( t );
		}

		reviewFocusBox = new FocusBox(template, {
			title : 'EDL Import Review',
			onClose : function() {
				reviewFocusBox = null;
			}
		});
		reviewFocusBox.show();
	}

	function save() {

		//get the chosen
		var chosen = [];
		for (var i in edl.data.edits) {
			if (!edl.data.edits.hasOwnProperty(i)) continue;
			if (edl.data.edits[i].chosen) chosen.push( 'chosen[' + i + ']=' + edl.data.edits[i].chosen.id );
			if (edl.data.edits[i].tracks && edl.data.edits[i].tracks.length) {
				edl.data.edits[i].tracks = _.map(edl.data.edits[i].tracks, function(t) {
					if (t.hasOwnProperty('id')) {
						return { id: t.id };
					} else if (t.length && t[0].hasOwnProperty('id')) {
						return { id: t[0].id };
					}
				});
			}
		}
		console.log('save data:', edl.data);

		var chosenVars = chosen.length ? '&' + chosen.join('&') : '';

		//get fields
		var selects = [];
		$j('#edl_review .mapping select').each(function(i) {
			var idA = $j(this).attr('id').split('-');
			var id = idA.pop();
			selects.push( 'maps[' + id + ']=' + $j(this).val() );
		});
		var mapVars = selects.length ? '&' + selects.join('&') : '';

		$j('#edl_review .actions .save').html('<i class="fa fa-spin fa-refresh"></i>');

		console.log('- edits', JSON.parse( JSON.stringify( edl.data.edits) ) );

		ajax('cueSheetId=' + edl.cueSheetId + '&edl=' + edl.data.id + chosenVars + mapVars + '&data=' + escape( JSON.stringify( edl.data.edits ) ), function(r) {
			console.log('response:', r);
			const result = r.result ? r.result : r[0].result;
			if (result !== 'Success') {
				sa.notify({ text: 'There was an error with your EDL. Was it really big?' });
			} else {
				sa.router.reloadPage();
			}
			if (reviewFocusBox) reviewFocusBox.hide();
		}, 'POST', 'p=cue_sheets&action=edl_import');
	}

	return edl;

})();
////////////////
// Emailer
////////////////

sa.components.emailer = (function() {

	var emailer = {};
	var templates;

	/** @var {FocusBox} currentFocusBox */
	var currentFocusBox;
	var code;

	function reset() {
		currentFocusBox = null;
		code = '';
	}

	/**
	 * Shows the emailer so the user can send an email
	 * @param {Object} options
	 * 	@property {string} type - object type
	 * 	@property {Album|Track|Project|CueSheet} item
	 */
	emailer.show = function(options) {

		options = $j.extend({
			type : '',
			item : null
		}, options);

		if (!options.type || !options.item) {
			console.error('Trying to show emailer without required attributes (type, item)', options);
			return;
		}

		if (config.grayLabel) {
			sa.showGrayLabelNotice();
			return;
		}

		if (currentFocusBox) {
			currentFocusBox.hide(function() {
				reset(); // this should have happened onClose for the FB but just in case to prevent loop
				emailer.show(options);
			});
			return;
		}

		var subject = user.userData.username + ' sent you "';
		var emailerTitle;

		switch (options.type) {
			case 'track':
				if (config.id == 72 || config.id == 87 || config.id == 114) {
					emailerTitle = 'Send this sound effect';
				} else {
					emailerTitle = 'Send this Track';
				}
				subject += options.item.title;
				break;
			case 'album':
				emailerTitle = 'Send this ' + gde('album', { p : false, c : 'upper' });
				subject += options.item.name;
				break;
			case 'project':
				emailerTitle = 'Send this Playlist';
				subject += options.item.name;
				break;
			case 'cue_sheet':
				emailerTitle = 'Send this Cue Sheet';
				subject += options.item.name;
				break;
			case 'request':
				emailerTitle = 'Send this Request';
				subject += options.item.title;
				break;
		}

		subject += '" from ' + config.name;

		var div = templates.get('emailer');

		div.find('#email_subject').val(subject);

		sa.forms.init(div);

		currentFocusBox = new FocusBox(div, {
			onClose : function() {
				reset();
			},
			title : emailerTitle
		});
		currentFocusBox.show();

		let getData = {};
		getData[options.type] = options.item.id;
		sa.api.request({
			handler : 'mail-tracking',
			action : 'get-link',
			getData : getData
		}).then(function(response) {
			setLink(response, div);
		}).catch(function (e) {
			if (currentFocusBox) currentFocusBox.hide();
			sa.notify({ text : e.message });
		});

		div.find('#email_send_button').on('click', function() {
			send(options, div);
		});

		div.find('.confirm_no').on('click', function() {
			currentFocusBox.hide();
		});

		if (config.siteType == 'drop') {
			div.find('.notes').remove();
			div.find('#download_settings').remove();
		}

	};

	/**
	 * Sets the link and the code that will be used for mail tracking
	 * 	Also handles whether or not to show the admin sent options
	 * @param {{ code : string, adminSent : boolean, recipientSites : Array, link : string }} data the data from the server
	 * @param {JQuery} div the container for the emailer
	 */
	function setLink(data, div) {

		code = data.code;

		if (!code) {
			sa.notify({ text : 'You do not have permission to send these tracks. Please contact an admin for assistance.' });
			return;
		}

		// if these tracks are admin sent, we need to show the admin sent module
		if (data.adminSent) {
			var adminSent = div.find('.admin_sent');
			var userAdminSent = user.getOption('admin_sent');

			adminSent.find('input[name=adminSent][value=' + (userAdminSent > 0 ? 1 : userAdminSent) + ']').prop('checked', true);
			if (userAdminSent != -1 && userAdminSent != 0 && userAdminSent != 7) {
				adminSent.find('#logged_out_span').val(userAdminSent);
			}
			if (user.getOption('direct_downloading')) {
				adminSent.find('input[name=directDownloading]').prop('checked', true);
			}

			adminSent.find('input[name=adminSent]').on('click', function () {
				if (adminSent.find('input[name=adminSent]:checked').val() == '-1') {
					adminSent.find('input[name=directDownloading]').prop('disabled', true).prop('checked', false);
				} else {
					adminSent.find('input[name=directDownloading]').prop('disabled', false);
				}
			}).filter(':checked').trigger('click');

			if (data.recipientSites.length) {
				var recipientSiteOptions = '';
				for (var rs = 0, rsLen = data.recipientSites.length; rs < rsLen; rs++) {
					recipientSiteOptions += '<option value="' + data.recipientSites[rs].id + '">' + data.recipientSites[rs].name + '</option>';
				}
				adminSent.find('#recipient_site').html(recipientSiteOptions);
				adminSent.find('#recipient_site').on('change', function() {
					adminSent.find('#send_external').prop('checked', true);
				});
			} else {
				adminSent.find('#send_external_options').remove();
			}

			adminSent.addClass('showing');

			// other sending options (unrestricted access url)
			div.find('#copy_text').val(data.link);

			loadScript(ExtraScripts.clipboard, function () {
				var cp = new Clipboard('.send_directly .button', {
					target : function () {
						return div.find('#copy_text')[0];
					}
				});
				cp.on('success', function () {
					sa.notify({ text : 'Copied to clipboard!' });
					if (currentFocusBox) {
						currentFocusBox.hide();
					}
				});
				cp.on('error', function () {
					sa.notify({ text : 'Press Cmd+C to copy' });
				});
			});
		}
	}

	/**
	 * Performs form validation before sending the entered data to the server for actual sending
	 * @param options
	 * 	@property {string} type - object type
	 * 	@property {Album|Track|Project|CueSheet} item
	 * @param {JQuery} div
	 */
	function send(options, div) {
		var validEmails = [];

		var vals = sa.forms.validate(div);

		if (vals.error) {
			return;
		}

		var emails = vals.values.emails.split(',');

		// validate emails
		for (var i = 0; i < emails.length; i++) {
			var email = emails[i].trim();
			if (!email) continue;
			email = email.replace(/(?:"[^"]*")? *?<([^>]+)>/, '$1');
			if (email.isEmail() || email.indexOf(' (Group)') !== -1) {
				validEmails[validEmails.length] = email;
			} else {
				vals.fields.emails.showError('Invalid email: ' + email, true);
				return;
			}
		}
		if (!validEmails.length) {
			vals.fields.emails.showError('Please enter at least one recipient email address', true);
			return;
		}
		vals.values.emails = validEmails.join(',');

		if (vals.values['sendExternal'] === undefined) {
			vals.values.recipientSite = config.id;
		}

		if (vals.values['adminSent'] !== undefined || config.siteType == 'drop') {
			if (config.siteType == 'drop') {
				vals.values.directDownloading = '1';
				vals.values.adminSent = '1';
			}
			if (vals.values.adminSent == '1') {
				vals.values.adminSent = vals.values.loggedOutSpan;
			}
			if (vals.values.adminSent == '-1') {
				// if playback only, don't send in direct downloading
				vals.values.directDownloading = 0;
			}
			user.setOption('admin_sent', vals.values.adminSent);
			user.setOption('direct_downloading', vals.values.directDownloading);
			delete vals.values.loggedOutSpan;
		}

		var sendParameters = $j.extend({
			t : options.item.id,
			code : code
		}, vals.values);

		currentFocusBox.hideErrorMessage();
		currentFocusBox.showLoader('Sending...');

		sendApiRequest({ type : 'send_' + options.type }, sendParameters);

	}

	function sendApiRequest(getData, postData) {

		sa.api.request({
			handler : 'mail',
			action : 'send',
			getData : getData,
			postData : postData
		}).then(function () {
			if (currentFocusBox) currentFocusBox.hide();
			sa.notify({ text : 'Email sent!' });
		}).catch(function (e) {
			let message = e.message;
			let details = e.details;
			
			if (details && details.type === 'permissionWarning') {
				if (user.hasAdminPermission(AdminPermission.Sharing)) {
					sa.confirm({
						text : templates.get('permission_warning', { recipients : details.badUsers.join('</li><li>') }).html(),
						yesFunction : function() {
							postData.permissionConfirm = 1;
							sendApiRequest(getData, postData);
						},
						noFunction : function() { enableSendButton(); },
						closeFunction : function() { enableSendButton(); },
						yesText : 'Grant and send'
					});
				} else {
					sa.alert({
						text : templates.get('permission_denied', { recipients : details.badUsers.join('</li><li>') }).html(),
						buttonText : 'Ok',
						onClose : function() { enableSendButton(); }
					});
				}
			} else if (details && details.type === 'licenseeSiteLoggedOut') {
				sa.alert({
					text : templates.get('permission_denied_licensee', { recipients : details.badUsers.join('</li><li>') }).html(),
					buttonText : 'Ok',
					onClose : function() { enableSendButton(); }
				});
			} else if (details && details.type === 'crossSiteNonUser') {
				sa.alert({
					text : templates.get('cross_site_non_user', { recipients : details.badUsers.join('</li><li>') }).html(),
					buttonText : 'Ok',
					onClose : function () {
						enableSendButton();
					}
				});
			} else if (details && details.type === 'emptyCueSheetWarning') {
				sa.confirm({
					text : templates.get('empty_cue_sheet_warning').html(),
					yesFunction : function() {
						postData.sendEmptyCueSheet = 1;
						sendApiRequest(getData, postData);
					},
					noFunction : function() { enableSendButton(); },
					closeFunction : function() { enableSendButton(); },
					yesText : 'Send'
				});
			} else {
				sa.alert({
					text : StringSanitize.encodeIfNotEncoded(message),
					buttonText : 'Ok',
					onClose : function() { enableSendButton(); }
				});
			}
		});

	}

	function enableSendButton() {
		if (currentFocusBox) currentFocusBox.hideLoader();
	}

	/**
	 * Creates a button that will spawn the emailer when clicked
	 * @param {Object} options - these options are also passed to the emailer
	 * 	@property {string} type - object type
	 * 	@property {Album|Track|Project|CueSheet} item
	 * 	@property {boolean} wide - defaults to false
	 * 	@property {string} text - the text on button, if wide
	 * 	@property {string} tooltip - defaults to something reasonable
	 * @returns {JQuery}
	 */
	emailer.generateEmailButton = function(options) {

		options = $j.extend({
			type : '',
			item : null,
			wide : false,
			text : 'Email',
			tooltip : 'Click to send this ' + (options.type != 'project' ? options.type : 'playlist') + ' to someone'
		}, options);

		if (!options.type || !options.item) {
			console.error('Trying to generate email button without required attributes (type, item)', options);
			return $j();
		}

		var img = templates.get('generate_email_button' + (options.wide ? '_wide' : ''), { text : options.text });

		img.on('click', function (e) {
			e.preventDefault();
			if (!lockdown) {
				emailer.show(options);
			} else {
				sa.showLockdownMessage();
			}
			this.blur();
			return false;
		});

		img.attr('title', options.tooltip);

		return img;
	};

	emailer.build = function() {
		templates = sa.templates.get('components.emailer');
	};

	return emailer;

})();
/**
 *
 */
sa.components.embedder = (function() {
	var embedder = {};
	var templates;
	var lastCode = { type : '', id : 0, code : '', downloads : 0, sharing : 0 }; // used for code caching
	var lightBox;

	embedder.build = function() {
		templates = sa.templates.get('components.embedder');
	};

	embedder.show = function(type, datum) {
		var embedWidth = parseInt($j('.embed_options input[name=width]').val());
		var embedOptions = {
				sharing : 1,
				art : 1,
				downloads : 0,
				width : embedWidth ? embedWidth : 640,
				backgroundColor : '5698C8',
				textColor : '5698C8',
				borderColor : '000000'
			},
			frame;
		$j.extend(embedOptions, user.getOption('embed_options'));
		frame = templates.get('embedder', embedOptions);
		if (embedOptions.sharing) {
			frame.find('input[name=sharing]').prop('checked', true);
		}
		if (embedOptions.art) {
			frame.find('input[name=art]').prop('checked', true);
		}
		if (!user.hasAdminPermission(AdminPermission.Users)) {
			frame.find('input[name=downloads]').parent().remove();
		} else if (embedOptions.downloads) {
			frame.find('input[name=downloads]').prop('checked', true);
		}
		// create the lightbox
		lightBox = new FocusBox(frame, { title : 'Create your embedded player' });
		// show it!
		lightBox.show();
		// set the defaults
		updateEmbedCode(type, datum);
		// copy button
		loadScript(ExtraScripts.clipboard, function() {
			var cp = new Clipboard('.copy_button', {
				target : function() { return $j('.embed_options .code')[0]; }
			});
			cp.on('success', function(e) {
				sa.notify({ text : 'Copied to clipboard!' });
			});
			cp.on('error', function(e) {
				sa.notify({ text : 'Press Cmd+C to copy' });
			});
		});
		// checkboxes
		$j('.embed_options input[type=checkbox]').on('click', function() {
			updateEmbedCode(type, datum);
		});

		// Embed Width Change
		$j('.embed_options input[name="width"]').on('change blur', function() {
			console.log($j(this).val());
			if ($j(this).val() < 538) {
				$j(this).val(538);
				$j('.body_embed input.width').val(538);
			}
			updateEmbedCode(type, datum);
		});

		// color pickers
		loadScript(ExtraScripts.colorPicker, function() {
			$j('.embed_options .color').each(function() {
				var input = $j(this);
				input.jPicker(
					{
						window : {
							title : 'Pick a color',
							effects : {
								type : 'fade',
								speed : {
									show : 'slow',
									hide : 'fast'
								}
							},
							position : {
								x : 'screenCenter',
								y : 'center'
							},
							positionFunctions : {
								top : function() {
									return input.offset().top - 150;
								},
								left : function() {
									var pickerWidth = 545 + 5,
										left = input.offset().left + input.outerWidth() + 50,
										maxLeft = $j('#body').width() - pickerWidth;
									return Math.min(left, maxLeft);
								}
							}
						},
						images : {
							clientPath : 'images/jpicker/'
						}
					},
					function () {
						updateEmbedCode(type, datum);
					},
					function () {
						//updateEmbedCode(type, datum);
					},
					function () {
						//updateEmbedCode(type, datum);
					}
				);
			});
		});
	};

	embedder.hide = function() {
		lightBox.hide();
	};

	function updateEmbedCode(type, datum) {
		var embedOptions = {
				width : Math.max(538, $j('.embed_options input[name=width]').val()), // no max, min is 538
				backgroundColor : $j('.embed_options input[name=background_color]').val(),
				borderColor : $j('.embed_options input[name=border_color]').val(),
				textColor : $j('.embed_options input[name=text_color]').val(),
				sharing : $j('.embed_options input[name=sharing]:checked').length,
				art : $j('.embed_options input[name=art]:checked').length,
				downloads : $j('.embed_options input[name=downloads]:checked').length
			},
			height = 112,
			embedPath,
			embedStyles;
		if (isNaN(embedOptions.width)) {
			embedOptions.width = 640;
		}

		// save into the user options
		user.setOption('embed_options', embedOptions);
		var setCode = function(code) {
			embedPath = 'https://' + config.domain
				+ '/embed.php?code=' + code
				+ '&art=' + embedOptions.art
				+ '&backgroundColor=' + embedOptions.backgroundColor
				+ '&borderColor=' + embedOptions.borderColor
				+ '&textColor=' + embedOptions.textColor
				+ '&width=' + embedOptions.width;

			embedStyles = 'style="width:' + embedOptions.width
				+ 'px;height:' + height
				+ 'px;border:2px solid #'
				+ embedOptions.borderColor + ';overflow:hidden;"';

			// set the code on the page
			$j('.embed_options .code').html('&lt;iframe ' + embedStyles + ' src="' + embedPath + '" scrolling="no" marginwidth="0" marginheight="0" frameborder="0"&gt;&lt;/iframe&gt;');
			$j('.embed_options iframe').attr('src', embedPath).css({
				width : embedOptions.width,
				height : height,
				borderColor : '#' + embedOptions.borderColor,
				overflow: 'hidden'
			});
		};
		// get code
		// we cache the last code we received so we don't reload it unnecessarily
		if (lastCode.type == type && lastCode.id == datum.id && lastCode.downloads == embedOptions.downloads && lastCode.sharing == embedOptions.sharing && lastCode.code) {
			setCode(lastCode.code);
		} else {
			ajax('p=embed&action=getCode&type=' + encodeURIComponent(type) + '&id=' + datum.id + '&downloads=' + embedOptions.downloads + '&sharing=' + embedOptions.sharing, function(response) {
				if (response[0].code == '0') {
					embedder.hide();
					return sa.notify({ text : 'This track is not available for embedding' });
				}
				setCode(response[0].code);
				lastCode = { type : type, id : datum.id, code : response[0].code, downloads : embedOptions.downloads, sharing : embedOptions.sharing };
			});
		}
	}

	/**
	 * Creates a button that will spawn the embedder when clicked
	 * @param {Object} options - these options are also passed to the emailer
	 * 	@property {string} type - object type
	 * 	@property {Track} item
	 * 	@property {boolean} wide - defaults to false
	 * 	@property {string} text - the text on button, if wide
	 * 	@property {string} tooltip - defaults to something reasonable
	 * @returns {JQuery}
	 */
	embedder.generateEmbedButton = function(options) {

		options = $j.extend({
			type : 'track',
			item : null,
			wide : false,
			text : 'Embed',
			tooltip : ''
		}, options);

		if (!options.type || !options.item) {
			console.error('Trying to generate embed button without required attributes (type, item)', options);
			return $j();
		}

		var img = templates.get('generate_embed_button' + (options.wide ? '_wide' : ''), { text : options.text });

		img.on('click', function() {
			if (!lockdown) {
				embedder.show(options.type, options.item);
			} else {
				sa.showLockdownMessage();
			}
			this.blur();
		});

		if (!options.tooltip) {
			options.tooltip = 'Click to embed this ' + (options.type != 'project' ? options.type : 'playlist') + ' on your workspace';
		}

		img.attr('title', options.tooltip);

		return img;

	};

	return embedder;
})();

sa.components.exitSurvey = (function() {
	
	var survey = {};
	var templates;
	
	survey.build = function() {
		templates = sa.templates.get('components.exit_survey');
	};
	
	function advanceToQuestion(container, question) {
		container.find('.question.current').removeClass('current').addClass('answered');
		question.removeClass('unanswered').addClass('current');
	}

	function reverseToQuestion(container, question) {
		container.find('.question.current').removeClass('current').addClass('unanswered');
		question.removeClass('answered').addClass('current');
	}

	/**
	 * @param {Object} options
	 * 	@property {function} onClose
	 */
	survey.show = function(options) {
		var container = templates.get('survey');
		var state = 0;
		var nextButton = container.find('.confirm_yes');
		var previousButton = container.find('.confirm_no');
		
		options = $j.extend({
			onClose : function() {}
		}, options);

		nextButton.on('click', function() {
			var validationResult = sa.forms.validate(container);
			
			// it's possible that the site's domain will become disassociated while it's being deleted
			// we use jquery's ajax instead of normal ajax so we can bypass ajax.php in favor of survey.php, which
			// doesn't validate the domain.
			// we save every next button click because we want the data even if the user cancels out before finishing
			$j.ajax({
				url : 'survey.php',
				dataType : 'json',
				type : 'POST',
				data : {
					results : validationResult.values,
					whiteId : config.id,
					userId : user.userData.id
				}
			});
			
			if (state === 0) {
				if (!validationResult.values.reason) {
					sa.alert('Please select a reason. Your feedback really helps!');
					return;
				}
				previousButton.show();
				advanceToQuestion(container, container.find('#' + container.find('input[name=reason]:checked').data('next')));
				state = 1;
			} else if (state === 1) {
				advanceToQuestion(container, container.find('#question_final'));
				state = 2;
				nextButton.html('Done');
				previousButton.remove();
			} else {
				fb.hide();
			}
		});

		previousButton.on('click', function() {
			if (state === 1) {
				reverseToQuestion(container, container.find('#question_0'));
				previousButton.hide();
				state = 0;
			}
		});
		
		sa.forms.init(container);
		
		var fb = new FocusBox(container, { title : 'SourceAudio Exit Survey', onClose : options.onClose });
		fb.show();
	};
	
	return survey;
	
})();

sa.components.facebookLogin = (function() {

	var facebookLogin = {};
	var templates;

	var tryFacebookLoginFunction = function() {};

	/** @var {LoginConfig} loginConfig */
	let loginConfig;

	/**
	 * @param {Object} options
	 *  @property {JQuery} container
	 *  @property {function} statusCallback
	 *  @property {function} loginCallback
	 *  @property {LoginConfig} loginConfig
	 */
	facebookLogin.show = function(options) {

		options = $j.extend({
			container : $j(),
			statusCallback : function(status, email, name, accounts) {
				if (status == 'matched_accounts') {
					facebookLogin.showAccountChooser(accounts);
				} else if (status == 'need_match') {
					showExternalAccountLinker('facebook', email);
				} else if (status == 'external') {
					ajax({ key : loginConfig.facebookCommunicationKey }, function(response) {
						if (response['logged']) {
							options.loginCallback();
						} else if (response['result']) {
							sa.alert(response['result']);
						}
					}, 'POST', { p : 'login', action : 'facebook' });
				}
			},
			loginConfig : null,
			loginCallback : function() {
				document.location.href = decodeURIComponent(loginConfig.forward);
			}
		}, options);

		if (options.loginConfig) {
			loginConfig = options.loginConfig;
		} else {
			sa.getLoginConfig(function(currentLoginConfig) {
				options.loginConfig = currentLoginConfig;
				facebookLogin.show(options);
			});
			return;
		}

		let iframe = $j('<iframe class="facebook_login_iframe" src="' + loginConfig.facebookIframeSrc + '"></iframe>');
		options.container.append(iframe);
		iframe.on('load', function () {
			$j.getJSON('facebook.php?loginCheck=1&key=' + loginConfig.facebookCommunicationKey, function(response) {
				let email = '';
				let name = '';
				if (response['facebookData']) {
					email = response['facebookData'].email;
					name = response['facebookData'].name;
				}
				console.log('checked facebook cache and got', response);
				options.statusCallback(response.status, email, name, response['accounts']);
			});
		});
		tryFacebookLoginFunction = function(userId) {
			iframe.attr('src', loginConfig.facebookIframeSrc + '&facebookLogin=1' + (userId ? '&userId=' + userId : ''));
		};
	};

	/**
	 * Shows and handles the logic for linking an external account to a SourceAudio account
	 * @param {string} type the type of external account we're linking - facebook
	 * @param {string} email the email address to fill the box with by default
	 */
	function showExternalAccountLinker(type, email) {
		var template = templates.get('external_account_linker');

		template.find('#linker_email').val(email);

		if (config.siteType == 'buyer' || !config.id) {
			template.find('.signup_option').remove();
		} else if (config.id == -1) {
			template.find('.signup_option a').attr('href', '?p=signup');
		}

		sa.forms.init(template);

		var button = template.find('.button').on('click', function() {
			var data = sa.forms.validate(template).values;

			fb.hideErrorMessage();
			if (!data.password || !data.email) {
				fb.showErrorMessage('Please fill out all required fields');
			} else {
				data.password = btoa(data.password);
				var originalButtonHeight = button.height();
				button.css({ height : 0 });
				ajax(data, function (response) {
					var result = response.result;
					if (result == 'success') {
						fb.hide();
						sa.notify({ text : 'Account Linked Successfully!<br/><br/>Click the Log In With Facebook button to log in.' });
					} else {
						button.css({ height: originalButtonHeight });
						fb.showErrorMessage(result);
					}
				}, 'POST', 'p=link_account&type=facebook');
			}
		});

		var fb = new FocusBox(template, { title : 'Link Facebook Account' });
		fb.show();
	}

	facebookLogin.showAccountChooser = function(accounts) {
		var template = templates.get('external_account_selector');
		accounts.each(function(i, account) {
			var accountTemplate = templates.get('external_account', {
				username : account.username,
				email : account.email,
				id : account.id
			});
			if (account.avatar && account.avatar.indexOf('default_editor') === -1) {
				accountTemplate.find('.user_image').removeClass('fas fa-user-circle').html('<img src="' + account.avatar + '" alt="user image"/>');
			}

			accountTemplate.find('.button').on('click', function() {
				tryFacebookLoginFunction(account.id);
			});
			template.find('.accounts').append(accountTemplate);
		});

		var fb = new FocusBox(template);
		fb.show();
	};

	facebookLogin.build = function() {
		templates = sa.templates.get('components.facebook_login');
	};

	return facebookLogin;

})();
/**
 * Shows a support widget so the user can ask for help
 */
sa.components.feedback = (function() {
	
	var feedback = {};

	var templates;
	
	feedback.show = function(name, email) {
		let user = window['user'] !== undefined ? window['user'] : null;
		var isAdmin = user && user.hasAdminPermission(AdminPermission.Any);
		if (!name && user && user.userData.username) {
			name = user.userData.username;
		}
		name = name ? name : '';
		if (!email && user && user.userData.email) {
			email = user.userData.email;
		}
		email = email ? email : '';

		// create a new interface
		var cont = templates.get((isAdmin ? 'admin_' : '') + 'contact_form');
		cont.find('#support_name, #admin_support_name').val(name);
		cont.find('#support_email, #admin_support_email').val(email);
		cont.find('#support_email, #admin_support_email').val(email);

		if (isAdmin) {
			let supportUrl = location.href;
			let routeHistory = sa.router.getHistory();
			
			if (routeHistory.length >= 3 && routeHistory[1].route.name === 'feedback') {
				supportUrl = siteBaseUrl() + '/' + routeHistory[2].route.name;
			} else if (routeHistory.length >= 2 && routeHistory[0].route.name === 'feedback') {
				supportUrl = siteBaseUrl() + '/' + routeHistory[1].route.name;
			}
			
			cont.find('#support_url').val(supportUrl);
		}

		// make the button work
		cont.find('.confirm_yes').on('click', function() {
			submitForm(cont, fb);
		});

		cont.find('.confirm_no').on('click', function() {
			fb.hide();
		});

		sa.forms.init(cont);

		// show the new box
		var fb = new FocusBox(cont, {
			title : 'Contact <span class="feedback_site_title">' + (isAdmin ? 'SourceAudio' : config.name) + '</span> Support',
			preventRemoval : true,
			fillWidthAtLowResolution : 500
		});
		fb.show();
	};
	
	function submitForm(cont, fb) {

		var validationResult = sa.forms.validate(cont);

		if (validationResult.error) return;

		var vals = validationResult.values;
		vals.browser = BrowserDetect.browser + ' ' + BrowserDetect.version + ' on ' + BrowserDetect.OS;

		// send it in!
		fb.showLoader('Sending');
		ajax(vals, function(response) {
			if (response[0].result == 'success') {
				fb.hide();
				sa.notify({ text : 'Contact request sent! You should receive an email response from us shortly.' });
			} else {
				fb.hideLoader();
				sa.notify({ text : response[0].result });
			}
		}, 'POST', 'p=contact');

	}

	feedback.build = function() {
		templates = sa.templates.get('feedback');

		sa.router.addRoute('feedback', {
			hash: '#!feedback',
			pattern: '/feedback',
			cb: () => {
				feedback.show();
			},
			navigable: false
		});
	};
	
	return feedback;
})();

sa.components.forgotPassword = (function() {

	var forgotPassword = {};
	var templates;

	forgotPassword.show = function(options) {
		var template = templates.get('forgot_password');

		options = $j.extend({
			emailAddress : ''
		}, options);

		sa.forms.init(template);

		if (options.emailAddress) {
			template.find('input').val(options.emailAddress).trigger('change').prop('disabled', true);
		} else {
			template.find('input').val($j('#login_email_input').val()).trigger('change');
		}
		template.find('.confirm_yes').on('click', function() {
			fb.hideErrorMessage();
			var email = template.find('#forgot_email').val();
			if (!email.isEmail())  {
				fb.showErrorMessage('Please enter a valid email address.');
			} else {
				fb.showLoader('Processing');
				sa.api.request({
					handler : 'email-check',
					action : 'check-email-address',
					postData : {
						email : email
					}
				}).then(function() {
					fb.hideLoader();
					submitRequest(email, fb);
				}).catch(function(e) {
					/** @var { { email: string, loginLink : string, sites : string[], account : boolean, sitesString : string, noticeRequired : boolean } } errorDetails */
					let errorDetails = e.details;
					if (errorDetails.account && errorDetails.noticeRequired) {
						sa.confirm({
							text : templates.get('shared_password').html(),
							yesText : 'Ok',
							yesFunction : function() {
								fb.hideLoader();
								submitRequest(email, fb);
							},
							noText : 'Cancel',
							noFunction : function() {
								fb.hideLoader();
							},
							closeFunction : function() {
								fb.hideLoader();
							}
						});
						$j('.send_site_list').on('click', function() {
							sa.api.request({
								handler : 'email-check',
								action : 'send-site-list',
								postData : {
									'email' : email
								}
							}).then(function() {
								sa.alert('We sent a list of workspaces to your provided email address. Please check it for more information.');
							});
						});
					} else {
						fb.hideLoader();
						submitRequest(email, fb);
					}
				});

			}
		});
		template.find('.confirm_no').on('click', function() {
			fb.hide();
		});

		var fb = new FocusBox(template, {
			title : 'Forgot Password',
			showClose : true
		});
		fb.show();
	};

	function submitRequest(email, fb) {
		fb.showLoader('Processing your request...');
		sa.api.request({
			handler : 'reset-password',
			action : 'request-new-password',
			postData : {
				emailAddress : email
			}
		}).then(function() {
			fb.hideLoader();
			fb.showSuccessMessage('Request processed! Please check your email for a reset link and be sure to check your spam folder.');
			fb.hideContent();
		}).catch(function(e) {
			fb.hideLoader();
			fb.showErrorMessage(e.message);
		});
	}

	forgotPassword.build = function() {
		templates = sa.templates.get('components.forgot_password');
	};

	return forgotPassword;

})();
/**
 * This object represents the black bar on the top of track lists.
 * Technically, it can be displayed on any page with a right_content
 * Singleton - var heading
 */
/* eslint-disable no-inner-declarations */
/* eslint-disable wrap-iife */
sa.components.heading = (function () {

	const heading = {};
	let templates;
	let headingContainer;

	heading.LocationTop = 0;
	heading.LocationBottom = 1;
	heading.LocationLeft = 2;

	let headingOptions = [[], [], []];
	let hideNextTabCounts = false;
	let extraTabs = {};
	let currentType = '';
	let quickProjectModeEnabled = false;

	let showingHeadingText;
	let showingOptions;

	// Helps us figure out how to render the heading
	heading.listType = undefined;

	/**
	 * Hides the tab counts the next time they're displayed
	 */
	heading.hideTabCounts = function () {
		hideNextTabCounts = true;
	};

	/**
	 * Removes any previously added options
	 */
	heading.resetOptions = function () {
		headingOptions = [[], [], []];
	};

	heading.enableQuickProjects = function () {
		quickProjectModeEnabled = true;
		console.log('heading enable quick projects');
		if (headingContainer) headingContainer.addClass('quick_project_mode');
		console.log('heading container', headingContainer);
		if (currentType == 'album') {
			console.log('quick project enabled for album');
		}
	};

	heading.disableQuickProjects = function () {
		quickProjectModeEnabled = false;
		if (headingContainer) headingContainer.removeClass('quick_project_mode');
	};

	/**
	 * Adds a new option that will be displayed when heading.show() is called. Does not affect any currently shown heading
	 * @param {HTMLElement|JQuery} button the button to display. should be an a.button with an image inside and an href or an onclick
	 * @param {int} location either heading.LocationTop or heading.LocationBottom
	 * @param {boolean=} immediately should we add the button to the currently displayed header instead of just the queue?
	 */
	heading.addOption = function (button, location, immediately) {
		headingOptions[location].push($j(button));
		if (immediately) {
			reshow();
		}
	};

	/**
	 * Removes an option that's already been added
	 * @param {string} selector a string selector to find the button that's to be removed
	 * @param {int} location the location from which to remove the button
	 * @param {boolean=} immediately remove it from teh current header or just from the list? (only currently works for LocationLeft)
	 */
	heading.removeOption = function (selector, location, immediately) {
		for (let i = 0, len = headingOptions[location].length; i < len; i++) {
			const option = headingOptions[location][i];
			if (option.filter(selector).length) {
				headingOptions[location].splice(i, 1);
			}
		}
		if (immediately) {
			reshow();
		}
	};

	/**
	 * Shows the heading on top of the right content section
	 * @param {string} headingText the main, big white text to display
	 * @param {object=} options any extra things that may be displayed
	 * 	@property {string} preamble text that appears above the main text
	 * 	@property {string} subtext text that appears below the main text
	 * 	@property {int} count a number to parenthized and placed after the main text
	 * 	@property {int} releaseDate a timestamp (currently disabled)
	 * 	@property {string} image path to an image if there is one
	 * 	@property {Array} tabs
	 */
	heading.show = function (headingText, options) {
		if (get('heading') || !get('right_content')) return;

		showingHeadingText = headingText;
		showingOptions = options;

		options = $j.extend({
			preamble: '',
			subtext: '',
			count: 0,
			releaseDate: 0,
			item: {},
			image: '',
			tabs: []
		}, options);

		// remove breaks and use newlines
		options.subtext = br2nl(options.subtext);

		/**
		 * AI SEARCH
		 * 
		 * If we have the key aiIWantResponse in the options, then things are gonna change around here
		 */
		if (options.aiIWantResponse) {
			// first off check for errors
			if (options.aiIWantResponse.error) {
				const error = _.get(options, 'aiIWantResponse.error', '')
				const wasGPTError = _.get(options, 'aiIWantResponse.error_from_gpt', false);

				if (wasGPTError) {
					// error thrown from OpenAI
					console.error("AI Error:", error);
					const username = _.get(user, 'userData.username', 'Dave') || "Dave";
					const halMessage = `I'm afraid I can't do that, ${username}`;
					return sa.error({
						text: `${halMessage}.  Our AI isn't cooperating right now.  Please try your search again or modify it in order to get better results.`, 
						onClose() {
							sa.router.routeTo('/tracks');
						}
					});
				}

				return sa.error({
					text: 'An unknown error occured. Please try your search again or modify it in order to get better results.',
					onClose() {
						sa.router.routeTo('/tracks');
					}
				});
			}

			options.preamble = '';
			headingText = '"' + options.aiIWantResponse.prompt + '"';
			const $subtext = $j('<div class="ai_search_subtext"></div>');
			const $explanationContainer = templates.get('ai_search');
			const sharedTemplates = sa.templates.get('shared');
			const $artemis = sharedTemplates.get('artemis');
			$explanationContainer.find('.ai_search_graphic').prepend($artemis);
			const $keywords = $explanationContainer.find('.ai_search_keywords');
			const $genres = $explanationContainer.find('.ai_search_genres');
			// explanation
			if (options.aiIWantResponse.explanation) {
				$explanationContainer.find('.ai_search_your_search blockquote').text('"' + options.aiIWantResponse.prompt + '"');
				$explanationContainer.find('.ai_search_ai_explanation blockquote').text('"' + options.aiIWantResponse.explanation + '"');
			}
			// keywords
			if (options.aiIWantResponse.keywords && Array.isArray(options.aiIWantResponse.keywords) && options.aiIWantResponse.keywords.length) {
				for (const keyword of options.aiIWantResponse.keywords) {
					const $keyword = $j('<div class="ai_search_keyword ai_search_pill pill"></div>').text(keyword);
					$keywords.append($keyword);
				}
			} else {
				$keywords.remove();
			}

			// genres
			if (options.aiIWantResponse.matching_genres && Array.isArray(options.aiIWantResponse.matching_genres) && options.aiIWantResponse.matching_genres.length) {
				for (const genre of options.aiIWantResponse.matching_genres) {
					const $genre = $j('<div class="ai_search_genre ai_search_pill pill"></div>').text(genre);
					$genres.append($genre);
				}
			} else {
				$genres.remove();
			}

			$subtext.append($explanationContainer);
			options.subtext = $subtext;
		}

		// get the initial container
		headingContainer = templates.get('heading', { headingText: headingText + (options.count ? ' (' + options.count.numberFormat() + ')' : '') });

		/**
		 * Hero image options for heading redesign
		 */

		// should show AI art generation
		const shouldShowAIArtGeneration = (options.type == 'album' || options.type == 'project_item_list') && options.item.editable ;
		let heroOptions = {
			title: headingText,
			item: options.item,
			imgSrc: options.image || '',
			subtext: options.subtext || '',
			preamble: options.preamble || '',
			imgIsDefault: _.get(options, 'item.imageIsDefault', false),
			fullHeightImage: true,
			aiGenerateArtButtonOverImage: shouldShowAIArtGeneration,
		};

		// Boolean that tells us whether to render the hero header
		const shouldRenderHero = options.type === 'hero' || config.typesWithBanner.includes(options.type);

		if (options.type) {
			/**
			 * Add classes and type-specific options (catalog/label/artist/album, etc.)
			 */
			currentType = options.type;
			headingContainer.addClass('type_' + options.type);
			heroOptions.type = options.type;
		}

		// add the image, if we have one
		if (options.image) {
			headingContainer.addClass('with_image');
			headingContainer.find('.art_image img').attr('src', options.image);
		} else {
			headingContainer.find('.art_image').remove();
		}

		// add the preamble, if we have one
		if (options.preamble && options.preamble != headingText) {
			headingContainer.addClass('with_preamble');
			headingContainer.find('#preamble').html(options.preamble);
		} else {
			headingContainer.find('#preamble').remove();
		}

		// add the subtext, if we have any
		if (!shouldRenderHero && options.releaseDate && parseInt(options.releaseDate)) {
			if (options.subtext) {
				options.subtext += '<br/>';
			}
			options.subtext += 'Released ' + formatDate(config.dateFormatString, options.releaseDate);
		}

		if (options.subtext) {
			headingContainer.addClass('with_subtext');
			headingContainer.find('#subtext').html(options.subtext);
		} else {
			headingContainer.find('#subtext').remove();
		}
		
		if (options.readonly) {
			headingContainer.find('h1#text').append(`
				<span class="pill ${options.pillType}-pill">Read Only</span>
			`.trim());
			
			headingContainer.find('.titles').append(`
				<span class="read-only-pill-explainer">This cue sheet is not currently editable. Disable read only mode by clicking <button class="faux-link">here</buton></span>
			`.trim());
		}

		// If in quick project mode, add class 
		if (quickProjectModeEnabled) {
			headingContainer.addClass('quick_project_mode');
		}

		/**
		 * add tabs
		 */
		const tabContainer = headingContainer.find('.tab_container');
		const showingTabs = (options.tabs && options.tabs.length);
		let topCollapse = '';

		if (showingTabs) {

			for (let e = options.tabs.length - 1; e >= 0; e--) {
				const tab = options.tabs[e];
				const countDisplay = !tab.count || (hideNextTabCounts && !tab.selected) ? '' : ' (' + tab.count.numberFormat() + ')';
				const $tab = $j('<a class="tab' + (tab.selected ? ' selected' : '') + '" href="' + tab.href + '">' + tab.title + countDisplay + '</a>');
				$tab.data('ind', e);
				tabContainer.append($tab);
			}

			if (headingOptions[heading.LocationBottom].length) {
				headingOptions[heading.LocationTop] = headingOptions[heading.LocationTop].concat(headingOptions[heading.LocationBottom]);
				headingOptions[heading.LocationBottom] = [];
				topCollapse = 'always';
			}
			if (headingOptions[heading.LocationTop].length) {
				headingContainer.addClass('with_tabs_and_buttons');
			}

			headingContainer.addClass('with_tabs');

			// Add tab browsing on mobile
			new TabBrowseButtons(tabContainer, '.tab');

		} else {
			tabContainer.remove();
		}

		hideNextTabCounts = false;
		extraTabs = {};

		// add all the option buttons
		const headingRight = headingContainer.find('.heading_right');
		const alwaysCollapseBottomOptions = config.siteType !== 'drop' || config.siteMode !== 'receive';

		if (headingOptions[heading.LocationTop].length && headingOptions[heading.LocationBottom].length) {
			headingContainer.addClass('with_top_and_bottom_buttons');
			if (!alwaysCollapseBottomOptions && headingOptions[heading.LocationBottom].length === 1) {
				headingContainer.addClass('with_top_and_bottom_actual_buttons');
			}
		}
		if (headingOptions[heading.LocationTop].length) {
			if (headingOptions[heading.LocationLeft].length) {
				headingContainer.addClass('with_top_and_left_buttons');
			} else {
				headingContainer.addClass('with_top_button');
			}
		}
		if (headingOptions[heading.LocationBottom].length) {
			headingContainer.addClass('with_bottom_button');
		}

		/**
		 * ACTUAL RENDERING OF THE HEADER
		 */
		const rc = $j('#right_content');
		const filterControl = rc.find('#filter_control');
		if (filterControl.length) {
			filterControl.after(headingContainer);
		} else {
			if (shouldRenderHero) {
				// if we are rendering the hero container, empty the header first
				headingContainer.empty();
			}
			rc.prepend(headingContainer);
		}

		/**
		 * adjust tabs after render
		 */
		if (showingTabs) {
			const tabWidth = tabContainer.width();
			headingContainer.addClass('with_buttons');
			// the #text might have a right margin it no longer needs with this padding
			const textContainer = headingContainer.find('#text');
			const marginRight = parseInt(textContainer.css('marginRight'));
			if (!Number.isNaN(marginRight) && marginRight > 0) {
				textContainer.css('marginRight', Math.max(0, marginRight - tabWidth));
			}
		}

		// one time mobile things
		$j('#heading .mobile_buttons .mobile_filter').on('click', (e) => {
			e.stopPropagation();
			sa.components.leftNav.toggleExpand();

		});

		// Hide mobile filter on non explorer, album page
		const pageName = _.get(sa, 'currentPage.name', '');
		const hideMobileButtons = ['album'].includes(options.type) || !['explorer', 'album', 'albums'].includes(pageName) || window.location.href.includes('b=');
		if (hideMobileButtons) {
			$j('#heading .mobile_buttons').remove();
		}

		/** 
		 * RENDERING THE HERO IMAGE
		 */

		if (shouldRenderHero) {

			// combine all options into menu
			let allOptions = [];
			for (const a of headingOptions) {
				for (const b of a) {
					allOptions.push(b);

				}
			}
			allOptions = allOptions.flat();

			// banner image options
			const bannerType = options.type === 'project_item_list' ? 'playlist' : options.type;
			const bannerTypeGlobal = _.get(config, `theme.bannerTypes.${bannerType}`, false);
			const bannerTypeLocal = _.get(options, 'item.bannerImage.type', _.get(options, 'item.bannerImage.bannerType', false)); // bannerType key is backwards compatibility
			const bannerImage = options.bannerImage || _.get(options, 'item.bannerImage', false);
			const currentBannerType = bannerTypeLocal || bannerTypeGlobal;
			const handlers = []; // callables to fire to attach event listeners once the hero is created. functions in here will be passed the hero jQuery element

			// set whether to show a gradient
			let useDynamicColor = currentBannerType === 'gradient';

			if ((_.get(options, 'imageIsDefault', false) || _.get(options.item, 'imageIsDefault', false)) && bannerTypeLocal !== 'color') {
				useDynamicColor = false;
			}

			heroOptions.dynamicColor = useDynamicColor;

			/**
			 * other banner image settings
			 */
			if (bannerImage) {
				const artOverBannerSetting = _.get(bannerImage, 'artOverBanner', false);
				let extraOptions = {};
				if (currentBannerType === 'image') {
					extraOptions = _.extend(extraOptions, {
						textColor: _.get(bannerImage, 'textColor', ''),
						artOverBanner: artOverBannerSetting,
						bgImgSrc: _.get(bannerImage, 'image', ''),
						bgFocusX: _.get(bannerImage, 'focusX', '50%'),
						bgFocusY: _.get(bannerImage, 'focusY', '50%'),
					});
				}

				heroOptions = Object.assign(heroOptions, extraOptions);
			}

			/**
			 * writer, publisher specific rendering
			 */
			if (['writer', 'publisher'].includes(options.type)) {
				const person = options.item;
				const affiliationNumber = person.affiliationNumber && parseInt(person.affiliationNumber) != 0 ? parseInt(person.affiliationNumber) : false;
				if (person.affiliation.name !== '') {
					const $details = `<div class="affiliation"><em>${person.affiliation.name}` + (affiliationNumber ? ':' : '') + '</em>' + (affiliationNumber || '') + '</div>';
					heroOptions.subtext = $details + heroOptions.subtext;
				}

				// add title at company for writer
				if (options.type === 'writer') {
					const title = person.title ? '<strong>' + person.title + '</strong>' : '';
					const company = person.company ? '<i>' + person.company + '</i>' : '';
					const titleAt = [title, company].filter(a => !!a).join(' at ');

					if (titleAt) {
						heroOptions.subtext = `<div class="writer_company">${titleAt}</div>` + heroOptions.subtext;
					}
				}
			}

			/**
			 * album-specific rendering
			 */
			if (options.type === 'album') {

				// if there's a download link, change the text to Download all album tracks
				for (const option of allOptions) {
					if (option.text() === 'Download All') {
						option.text('Download all album tracks');
						break;
					}
				}

				// Add album details to header
				let nestedText = '';
				if (options.item.nestedCount && options.item.nestedCount > options.item.count) {
					nestedText = ' + <span class="alternate_notice" title="Some of the tracks in this album have alternates outside of the album which will appear here and when it is downloaded.">' + numberFormat(itemInfo.nestedCount - itemInfo.count) + ' alternate tracks</span>';
				}
				if (options.item) {
					const genreStr = (genres) => {
						const maxLen = 10;
						let genreStr = genres.slice(0, maxLen).map(a => {
							if (!a.name) return '';
							const quoteEscaped = a.name.replace(/"/g, '&quot;').replace(/'/g, "\\'");
							return `<a href="${getExplorerLink('s=' + encodeURIComponent(a.name))}" data-search_tag="${quoteEscaped}">${a.name}</a>`;
						}).join(', ');
						const numDiff = genres.length - maxLen;
						if (genres.length > maxLen) {
							genreStr = genreStr + ', and ' + (numDiff) + ' other genre' + (numDiff > 1 ? 's.' : '.');
						}
						return genreStr;
					};
					const showGenres = options.item.genres && options.item.genres.length && !config.hiddenFields.includes('genre');
					if (showGenres) {
						// clicking the genres should add them to search
						handlers.push(($hero) => {
							sa.search.addSearchTagListeners($hero);
						});
					}
					heroOptions.details = (options.item.code ? '<div class="code"><em>' + gde('album', { case: 'upper', plural: false }) + ' Code:</em> ' + options.item.code + '</div>' : '')
						+ (config.catalogs.length > 1 && !config.hiddenFields.includes('catalog') ? '<div class="catalog"><em>' + gde('catalog', { case: 'upper', plural: false }) + ':</em> <a href="' + getCatalogLink(options.item.catalog.id) + '">' + options.item.catalog.name + '</a></div>' : '')
						+ (config.showLabels && !config.hiddenFields.includes('label') ? '<div class="label"><em>' + gde('label', { case: 'upper', plural: false }) + ':</em> <a href="' + getLabelLink(options.item.label.id) + '">' + options.item.label.name + '</a></div>' : '')
						+ (showGenres ? '<div class="genre"><em>' + gde('genre', { p: false, c: 'upper' }) + ':</em> ' + genreStr(options.item.genres) + '</div>' : '')
						+ (options.item.artist && options.item.artist.id && !config.hiddenFields.includes('artist') ? '<div class="artist"><em>' + gde('artist', { case: 'upper', plural: false }) + ':</em> <a href="' + getArtistLink(options.item.artist.id) + '">' + options.item.artist.name + '</a></div>' : '')
						+ (config.id != 382 && config.id != 1494 && options.item.date && options.item.date != formatDate(config.dateFormatString, 0) && !config.hiddenFields.includes('release date') ? '<div class="release_date"><em>Released:</em> ' + options.item.date + '</div>' : '')
						+ '<div class="stats">'
						+ (config.showTrackCount && options.count ? '<em>Tracks' + (config.id == 752 ? ' and Stems' : '') + ':</em> ' + numberFormat(options.count) + nestedText : '')
						+ '</div>';

				}

			}

			/**
			 * EDIT BUTTONS FOR LABELS, CATALOGS, WRITERS, ETC.
			 * 
			 * This editCallback updates the header with new data after a save
			 */
			function editCallback(type, id) {
				if (['writer', 'publisher'].includes(type)) {
					type = 'person';
				}

				const updateOptions = (entity) => {
					// get the keys that could have changed
					let lastOptions = JSON.stringify(showingOptions);
					const harvestKeys = ['image', 'bannerImage', 'subtext', 'name'];
					const harvestValues = _.pick(entity, harvestKeys);
					options = Object.assign(options, harvestValues);

					// assign keys from the item to the options based on this map,
					// i.e., for catalogs, set the catalog description to options.subtext
					const harvestMap = {
						catalog: {
							description: 'subtext',
						},
						person: {
							description: 'subtext',
						},
						label: {
							description: 'subtext',
						},
					};
					const harvestMapType = harvestMap[type];
					if (harvestMapType) {
						for (const [itemKey, optionKey] of Object.entries(harvestMapType)) options[optionKey] = entity[itemKey];
					}

					if (options.subtext) {
						options.subtext = br2nl(options.subtext, true);
					}

					options.item = entity;
					// update header options and heading text
					showingOptions = options;
					showingHeadingText = entity.name;
					const newOptions = JSON.stringify(showingOptions);
					if (lastOptions != newOptions) {
						reshow();
						lastOptions = newOptions;
						sa.pages.grouping.overrideTabData(entity);
					}
				};

				return function (response) {
					if (response === false) {
						// cancel was clicked on the edit interface.  ignore
						return;
					}
					if (['person'].includes(type) && response.length && response[1]) {
						// response[1] is the saved person data
						updateOptions(response[1]);
						return;
					}
					const ajaxUrl = `p=${type}_info&id=${id}`;
					ajax(ajaxUrl, (response) => {
						if (response.length === 0) return;
						const entity = response[1];
						if (entity) {
							updateOptions(entity);
						}
					});
				};
			}

			if (['catalog', 'label', 'writer', 'publisher'].includes(options.type) && options.item.editable) {
				
				allOptions.unshift(sa.components.buttons.generateEditButton({
					type: options.type,
					item: options.item,
					wide: true,
					callback: editCallback(options.type, options.item.id),
				}));
			}

			const hero = new HeroImage(heroOptions);
			const $heroTitle = hero.$el;
			
			// run any event attachment handlers
			for (const handler of handlers) {
				handler(hero.$el);
			}

			// move tabs into hero
			// move mobile filters into hero
			if (!hideMobileButtons) {
				hero.$heroOptions.append(headingContainer.find('.mobile_buttons'));
			}
			headingContainer.empty().append($heroTitle).addClass('with_hero');
			if (showingTabs) {
				hero.$el.after(tabContainer);
			}

			// option added for ai playlisting, but usable by whatever, adds regular site buttons under the main header text instead of to the right
			if (options.bigButtons) {
				console.log('- heading adding big buttons:', options.bigButtons);
				const $buttonHolder = $j('<div class="big_buttons"></div>');
				for (const button of options.bigButtons) {
					const $button = $j('<a id="' + button.id + '" class="button" href="#0"><i class="' + button.icon + '"></i>' + button.text + '</a>');
					$button.on('click', button.action);
					$buttonHolder.append($button);
				}
				hero.$el.find('.subtext').append($buttonHolder);
			}

			if (allOptions.length > 0) {
				/**
				 * EXTRACT DOWNLOAD LINKS FROM HEADING OPTIONS, put them next to the options menu
				 */
				let dlButton = false;
				for (let i = allOptions.length - 1; i > -1; i--) {
					const option = allOptions[i];
					if (option.is('.download_anchor')) {
						dlButton = option;
						allOptions.splice(i, 1);
						break;
					}

				}
				if (dlButton) {
					dlButton.text('').addClass('fa fa-download').removeClass('wide');
					hero.$heroOptions.append(dlButton);
				}

				/**
				 * EXTRACT PLAYLIST ADD/REMOVE BUTTONS FOR PLAYLISTS
				 */
				if (options.type === 'project_item_list') {
					let addRemoveButton = false;
					for (let i = allOptions.length - 1; i > -1; i--) {
						const option = allOptions[i];
						if (option.is('.quick_project_button')) {
							addRemoveButton = option;
							allOptions.splice(i, 1);
							break;
						}

					}

					if (addRemoveButton) {
						addRemoveButton.text('').addClass('fas fa-plus-square').removeClass('wide');
						hero.$heroOptions.prepend(addRemoveButton);
					}
				}

				/**
				 * ACTUALLY ADD THE OPTIONS BUTTON
				 */
				const anchor = sa.components.OptionsMenu.GenerateFromButtons({ buttons: allOptions });
				hero.$heroOptions.append(anchor);

				// Add quick project buttons for album
				if (options.type === 'album') {
					const addAlbumButton = sa.components.projector.generateQuickProjectAlbumButton(options.item);
					hero.$heroOptions.prepend(addAlbumButton);
				}
			}


			// add ai generate art buttons
			if (shouldShowAIArtGeneration) {
				const aiGenerateArtButton = sa.components.buttons.generateAIArtButton({entityObj: options.item, entityType: options.type, buttonClasses: 'icon_button'});
				hero.$heroOptions.prepend(aiGenerateArtButton);
			}

			// move mobile filter to the end and bind click
			if (hideMobileButtons) {
				hero.$heroOptions.find('.mobile_buttons').remove();
			} else {
				hero.$heroOptions.find('.mobile_buttons').appendTo(hero.$heroContentRight);
				hero.$heroOptions.find('.mobile_buttons .mobile_filter').on('click', (e) => {
					console.log('clicking mobile buttons');
					e.stopPropagation();
					sa.components.leftNav.toggleExpand();

				});
			}

			if (showingTabs) {
				hero.$el.after(tabContainer);
			}
		} else { // shouldRenderHero check
			addOptionButtons(headingOptions[heading.LocationTop], headingRight, 'top_options', topCollapse);
			addOptionButtons(headingOptions[heading.LocationBottom], headingRight, 'bottom_options', alwaysCollapseBottomOptions ? 'always' : '');
			addOptionButtons(headingOptions[heading.LocationLeft], headingRight, 'left_options', 'never');
		}
	};

	function addOptionButtons(optionButtons, container, className, collapse) {
		if (!optionButtons.length) return;
		className += ' options_buttons';
		if (optionButtons.length == 1 && collapse != 'always') {
			// if there's only one button, we can just add it directly
			optionButtons[0].addClass(className);
			container.append(optionButtons[0]);
		} else if (collapse == 'never') {
			// no menu
			for (let ob = 0, obLen = optionButtons.length; ob < obLen; ob++) {
				optionButtons[ob].addClass(className + ' ' + className + '_' + ob);
				container.append(optionButtons[ob]);
			}
		} else {
			// if there's more than one, we have to build a menu
			const anchor = sa.components.OptionsMenu.GenerateFromButtons({ buttons: optionButtons });

			if (anchor) {
				anchor.addClass(className);
				container.append(anchor);
			}

		}
	}

	/**
	 * Adds a single heading tab if the tabs are being shown already
	 * @param {Object} tab
	 * @param {string} key a unique identifer you can later pass into removeTab
	 */
	heading.addTab = function (tab, key) {
		const tabContainer = $j('#heading .tab_container');
		if (!tabContainer.length) {
			return; // we can't add a tab if there are no tabs already
		}
		if (tab.selected) {
			tabContainer.find('.selected').removeClass('selected');
		}
		const tagElement = $j('<a class="tab' + (tab.selected ? ' selected' : '') + '" href="' + tab.href + '">' + tab.title + (!tab.count ? '' : ' (' + tab.count.numberFormat() + ')') + '</a>');
		heading.removeTab(key);
		extraTabs[key] = tagElement;
		tabContainer.prepend(tagElement);
	};

	/**
	 * Removes a tab that was previously added with addTab
	 * @param {string} key the unique identifier previously passed into addTab
	 * @return {boolean} was a tab removed?
	 */
	heading.removeTab = function (key) {
		if (extraTabs[key]) {
			extraTabs[key].remove();
			delete extraTabs[key];
			return true;
		}

		return false;
	};

	/**
	 * Adds facet data to an object to be passed in as options into heading.show
	 * @param {Object} facets keys are types and values are counts
	 * @param {Object} extra the object to which the facets will be added
	 * @param {string} current a facet will be selected if this string matches a key in the facets parameter
	 * @param {string} searchTerm a search term to insert in place of $s in the url href's
	 * @param {string} [hrefBase] the base of the url for the tabs (optional)
	 */
	heading.buildFacetTabs = function (facets, extra, current, searchTerm, hrefBase) {
		extra.tabs = [];
		const facetOrder = ['tracks', 'albums', 'artists', 'catalogs', 'labels', 'writers', 'publishers', 'lyrics'];
		const tracksTitle = 'Tracks';

		const baseUrl = siteBaseUrl();
		const currentPath = sa.router.removeDevPathFragment(sa.router.getCurrentPath());

		for (let i = 0, len = facetOrder.length; i < len; i++) {
			const facetType = facetOrder[i];
			const count = facets[facetType];
			if (!count && facetType != current) continue;
			if (!user.hasAdminPermission(AdminPermission.Any) && config.hiddenFields.indexOf(facetType.substring(0, facetType.length - 1)) !== -1) continue;

			const title = facetType === 'tracks' ? tracksTitle : gde(facetType.substring(0, facetType.length - 1), { plural: true, case: 'upper' });

			let href;
			if (hrefBase) {
				href = hrefBase.replace('$t', facetType).replace('$s', encodeURIComponent(searchTerm));
			} else {
				href = (facetType === 'tracks' || facetType === 'lyrics') ? 'tracks' : facetType;
				href += '?' + (facetType === 'lyrics' ? 'lyrics' : 's') + '=' + encodeURIComponent(searchTerm);
			}

			extra.tabs.push({
				title,
				href,
				count,
				selected: facetType === current
			});
		}
	};

	/**
	 * Hides the heading, removing it from the right content
	 */
	heading.hide = function () {
		$j('#right_content #heading').remove();
		heading.resetOptions();
	};

	function reshow() {
		$j('#right_content #heading').detach();
		heading.show(showingHeadingText, showingOptions);
	}

	heading.build = function () {
		templates = sa.templates.get('components.heading');
	};

	return heading;

})();
/**
 * Adds alerts to any elements with the class "help_explanation"
 */
sa.components.helpExplanation = (function() {

	var helpExplanation = {};

	helpExplanation.show = function(element, message, iconClass) {
		if (!iconClass) {
			iconClass = 'far fa-question-circle'
		}
		element.attr('title', message.replace(/<a .*?<\/a>/gm, '').trim()); // tries to strip <a> tags from the text but it's pretty clunky. if you update this, make sure MAF help (in top_bar) still works
		element.addClass('help_explanation_container');
		element.append($j('<a class="help_explanation ' + iconClass + '"></a>').on('click', function() { sa.alert({ text : message }); }));
	};
	
	helpExplanation.build = function() {};

	return helpExplanation;
	
})();
sa.components.itemEditInterface = (function() {

	const itemEditInterface = {};
	let templates;
	let editInterfaceContainer;
	let options = {};
	let $mainImage;
	let $bannerImageUploader;
	let mainUploader = false;
	let uploadFiles = {};
	let aiImageGenerationId = null;

	/**
	* Shows the edit options
	* @param {Object} options
	* 	@property {string} type
	* 	@property {Album|Catalog|Label|Artist|Project|ProjectFolder|Person} item
	* 	@property {function} callback - sends 1 param, did the user hit save? we're not guaranteeing anything good happened.
	*/
	itemEditInterface.show = function(opts) {

		options = $j.extend({
			type: '',
			item: {},
			id: '',
			title: null,
			saveText: 'Saving',
			callback: null,
			ajaxPage: '',
			ajaxAction: '',
			ajaxExtraVars: {},
			reloadAfterSave: true, // stop reloading the page after saving
		}, opts);

		if (options.type === 'composer') {
			sa.alert('Composers are being upgraded to "writers". Please convert your existing composers in the admin panel.');
			return;
		}

		if (options.title === null) {
			options.title = 'Edit ' + (options.type == 'project' ? 'playlist' : gde(options.type));
		}

		let focusBox;
		const displayType = (options.type == 'project' ? 'playlist' : options.type);

		// close down any old edit boxes
		const oldEditBoxCloseButton = $j('#name_thumb_box #close');
		if (oldEditBoxCloseButton.length) {
			oldEditBoxCloseButton.trigger('click');
		}

		editInterfaceContainer = templates.get('edit_interface', { displayType, type: options.type });

		/**
		 * COMPLETE THE RENDERING
		 */

		/**
		* Banner type radio selector
		*/
		if (config.typesWithBanner.includes(options.type) || options.type == 'project') {
			options.item.type = options.type == 'project' ? 'playlist' : options.type;
			// renders the banner fields in the edit interface
			const bannerFields = new EditInterfaceBannerFields(editInterfaceContainer.find('.banner_image_fields'), options.item);
			$bannerImageUploader = bannerFields.$bannerImageUploader;
		}

		if (['writer', 'publisher'].includes(options.type)) {
			// publisher, writer only fields
			const removeClass = `.remove_${options.item.type}`;
			editInterfaceContainer.find(removeClass).each(function() {
				$j(this).remove();
			});

			// extract writer business logic to a different class
			const peopleFields = new PersonEditForm(editInterfaceContainer.find(`.${options.type}_editing_options`), options.item);
		}

		console.log('edit interface showing with item', options.item);

		editInterfaceContainer.find('.type_editing_options:not(.' + options.type + '_editing_options)').remove();

		// add additional components for different objects
		if (options.type == 'album') {
			if (config.siteType === 'drop') {
				editInterfaceContainer.find('.album_editing_options').remove();
			} else {
				if (options.item.artist.id != 0) {
					editInterfaceContainer.find('*[name=albumArtist]').html('<option value="' + options.item.artist.id + '" selected="selected">' + options.item.artist.name + '</option>');
				}
				editInterfaceContainer.find('*[name=albumCode]').val(options.item.code);
				if (options.item.date != formatDate(config.dateFormatString, 0)) {
					editInterfaceContainer.find('*[name=releaseDate]').val(formatDateForInput(options.item.date));
				}
				const genreSelect = editInterfaceContainer.find('*[name=albumGenre]');
				options.item.genres.each((i, genre) => {
					genreSelect.append('<option value="' + genre.id + '" selected="selected">' + genre.name + '</option>');
				});
			}
		}

		// folder handling
		if (options.type === 'folder') {
			editInterfaceContainer.find('#thumb_upload_input').parent().remove();
			let optionsHtml = '';
			// to enable recursion
			function addProjects(folders, nesting) {
				for (let i = 0, len = folders.length; i < len; i++) {
					const projectFolder = folders[i];
					if (options.item.id == projectFolder.id) continue;
					optionsHtml += '<option value="' + projectFolder.id + '"' + (options.item.parentFolderId == projectFolder.id ? ' selected="selected"' : '') + '>'
						+ (nesting ? new Array(nesting + 1).join('-') + ' ' : '') + projectFolder.name + '</option>';
					if (projectFolder.subfolders.length) {
						addProjects(projectFolder.subfolders, nesting + 1);
					}
				}

			}

			addProjects(user.projectFolders, 0);
			editInterfaceContainer.find('select[name=folderId]').append(optionsHtml);
		} else if (options.type === 'project') {
			const folderSelector = editInterfaceContainer.find('select[name=folderId]');
			// add the folders
			const baseFolders = folderSelector.html();
			folderSelector.prepend(sa.components.projector.getNestedFolderOptions());
			if (options.item.folderId) {
				folderSelector.val(options.item.folderId);
			} else {
				folderSelector.val(0);
			}
			// new folder in playlist
			folderSelector.on('change', function () {
				if (this.value == -1) {
					sa.components.projector.showNewFolderBox((newFolder) => {
						if (newFolder) {
							folderSelector.html(baseFolders + sa.components.projector.getNestedFolderOptions());
							folderSelector.val(newFolder.id);
						} else if (options.item.folderId) {
							folderSelector.val(options.item.folderId);
						}
					});
				}
			});
			// set the include nested option. use the current value or the user's default
			const $includeAlternates = editInterfaceContainer.find('#ei_include_nested');
			$includeAlternates.val(options.item.includeNested ?? user.getPlaylistAlternates());

			$includeAlternates.on('change', function() {
				user.setPlaylistAlternates(this.value);
			});
		}

		if (config.siteType === 'drop') {
			editInterfaceContainer.find('.' + options.type + '_hide_on_drop').remove();
		}

		// save button
		editInterfaceContainer.find('#input_box_success').on('click', () => {
			saveItem(options, focusBox);
		});

		// cancel or close buttons
		editInterfaceContainer.find('#input_box_cancel').on('click', () => { focusBox.hide(); if (options.callback) options.callback(false); });

		/**
		 * SET THE SAVED SETTINGS that have not been set yet
		 */
		initializeSettings();

		// init the form
		sa.forms.init(editInterfaceContainer, { realTimeValidationCallback });

		// now set up the focus box!
		focusBox = new FocusBox(editInterfaceContainer, {
			title: options.title,
		});
		focusBox.show();

	};

	function hideDisable($el) {
		$el.addClass('hidden');
		$el.find('input, textarea, select').attr('disabled', true);
	}
	function showEnable($el) {
		$el.removeClass('hidden');
		$el.find('input, textarea, select').attr('disabled', false);
	}

	/**
	 * Show or hide option sets in the form based on which banner type is selected
	 * @param {string} type 
	 */
	function showBannerOptions(type) {
		// key is which banner type, value is which element to show/hide, enable/disable inputs
		const templateMap = {
			image: '.banner_image_options'
		};

		// hide the others
		for (const [key, val] of Object.entries(templateMap)) {
			if (type !== key) {
				hideDisable(editInterfaceContainer.find(val));
			} else {
				showEnable(editInterfaceContainer.find(val));
			}
		}
	}

	/**
	* Prepare initial values of edit interface
	*/
	function initializeSettings() {
		// name

		if (options.item.name) {
			const nameInput = editInterfaceContainer.find('*[name=name]');
			nameInput.val(htmlDecode(options.item.name));
			checkForEnter(nameInput, () => {
				editInterfaceContainer.find('#input_box_success').trigger('click');
			});
		}

		// set description
		if (options.item.description) {
			let descriptionText = options.item.description;
			const hasNewLines = descriptionText.match(/\n/g);
			const hasBreaks = descriptionText.match(/<br\s?\/?>/g);
			if (hasNewLines && hasBreaks) {
				descriptionText = descriptionText.replace(/<br\s?\/?>/g, '');
			} else if (hasBreaks && !hasNewLines) {
				descriptionText = br2nl(descriptionText, true);
			}
			descriptionText.replace(/&quot;/g, '"');
			editInterfaceContainer.find('*[name=description]').val(descriptionText);
		}

		// set main image
		$mainImage = editInterfaceContainer.find('.main_image_uploader');

		const getPathname = (url) => {
			try {
				return new URL(url).pathname;
			} catch {
				return url;
			}
		};

		let imgSrc = _.get(options, 'item.image', '');
		if (imgSrc) imgSrc = getPathname(imgSrc);
		let labelImgSrc = _.get(options, 'item.label.image', false);
		if (labelImgSrc) labelImgSrc = getPathname(labelImgSrc);
		let catalogImgSrc = _.get(options, 'item.catalog.image', false);
		if (catalogImgSrc) catalogImgSrc = getPathname(catalogImgSrc);

		const imgIsDefault = _.get(options, 'item.imageIsDefault', false);
		let imgIsLabel = (imgSrc || labelImgSrc) && labelImgSrc == imgSrc;
		const imgIsCatalog = (imgSrc || catalogImgSrc) && catalogImgSrc == imgSrc;
		// case where label images are inherited from catalogs
		if (catalogImgSrc === labelImgSrc && imgIsCatalog) {
			imgIsLabel = false;
		}
		imgSrc = imgSrc && !imgIsDefault && !imgIsLabel && !imgIsCatalog ? imgSrc : '';
		$mainImage.find('input').data('value', imgSrc);

		if (imgIsLabel) {
			$mainImage.find('.notes').append('<p class="fallback">The current image is a fallback from the label.</p>');
		} else if (imgIsCatalog) {
			$mainImage.find('.notes').append('<p class="fallback">The current image is a fallback from the catalog.</p>');
		}

		// update text in edit interface to reference specific type "album", "artist", "catalog", etc.
		if (options.type) {
			const bannerType = options.type == 'project' ? 'playlist' : options.type;
			const dictTypeUpper = gde(bannerType);
			const dictTypeLower = gde(bannerType, { case: 'lower' });
			if (dictTypeUpper) {
				$mainImage.find('label').text(dictTypeUpper + ' Art');
				const newNotes = editInterfaceContainer.find('.match_image_colors .notes').text().replace('this page', 'this ' + dictTypeLower);
				editInterfaceContainer.find('.match_image_colors .notes').text(newNotes);
				editInterfaceContainer.find('.art_over_banner label').text(`Show ${dictTypeUpper} Art Over Banner`);
			}


			// add AI generate buttons
			if (['album', 'project'].includes(options.type)) {
				$mainImage.find(".browse_button").remove();

				// choose folder button
				const slidingFolderEl = $j('<div class="browse_button"></div>');
				$mainImage.find('.image_choose_buttons').append(slidingFolderEl);
				window.mountReactComponent(slidingFolderEl[0], 'icon-link', {
					text: 'Choose new file',
					fontAwesomeClasses: 'fa fa-solid fa-folder-open',
				});

				// AI art button
				const aiArtButton = sa.components.buttons.generateAIArtButton({
					entityObj: options.item,
					entityType: bannerType,
					buttonText: 'Generate AI Art',
					zOrder: 11,
					onRequestGetOverrides: () => {
						const formValues = serialize();
						// console.log("edit interface form values", formValues)
						return formValues || {};
					},
					overrideSaveFunc: async ({url, generationId}) => {
						if (generationId) aiImageGenerationId = generationId;
						// this needs to set the image in the interface using URL from file
						// assume that the type of the file is image/webp
						const urlFile = await urlToFile(url, Date.now() + '.webp', 'image/webp');
						const uploader = $mainImage.data('uploader');
						uploader.removeAllFiles();
						uploader.addFiles([urlFile]);
					}
				});
				$mainImage.find('.image_choose_buttons').append(aiArtButton);
			}
		}

	}

	function realTimeValidationCallback(validationResult) {
		/**
		* TODO: move this to the uploader class
		*/
		if (validationResult.inputContainer.data('uploader')) {
			// file input
			validationResult.hideError();

			const uploader = validationResult.inputContainer.data('uploader');
			for (const file of uploader.getFileDetails()) {
				if (!uploader.isMimeTypeAllowed(file.type)) {
					console.log("file type wasn't allowed", uploader.fileTypes);
					const type = gde(_.findKey(UploaderConstants, o => o === uploader.fileTypes), { case: 'lower' });
					let joiner = 'an';
					if (['csv', 'doc'].indexOf(type) !== -1) {
						joiner = 'a';
					}
					validationResult.showError(`That file type isn't allowed.  Please select ${joiner} ` + gde(_.findKey(UploaderConstants, o => o === uploader.fileTypes), { case: 'lower' }) + ' file.');
					uploader.removeFile(file.id);
					if (uploader.getFileDetails().length === 0) {
						// if we already had a file, go back to that
						if (validationResult.inputContainer.data('initialVal')) {
							validationResult.inputContainer.data('value', validationResult.inputContainer.data('initialVal'));
							// if (validationResult.inputContainer.parent('.image_focus_selector_wrapper').length) {}
						} else {
							validationResult.inputContainer.removeClass('with_value');
							// TODO: this should just be handled by the with_value class and CSS to show/hide remove button
							validationResult.inputContainer.find('.remove_button').removeClass('showing');
						}
					}
				} else {
					// file changed
					validationResult.inputContainer.trigger('focusposition', [50, 50]);
				}
			}
		}

		// Main image changed
		if (validationResult.name === 'image' && validationResult.value !== '') {
			$mainImage.find('.notes p.fallback').hide();
		}

	}
	function serialize(ignoreErrors = false) {
		const validationResults = sa.forms.validate(editInterfaceContainer);
		if (validationResults.error && !ignoreErrors) {
			throw new Error('Validation errors', validationResults);
		}
		// remove disabled since it does not happen in sa.forms.validate
		for (const field of Object.keys(validationResults.fields)) {
			if (validationResults.fields[field].input.attr('disabled')) {
				delete validationResults.fields[field];
				delete validationResults.values[field];
			}
		}

		for (const [fieldName, field] of Object.entries(validationResults.fields)) {
			// get if images were removed or changed
			if (field.uploader
				&& field.inputContainer.data('initialVal')
				&& field.inputContainer.data('value') === ''
				&& !Object.keys(validationResults.values).includes(fieldName)) {

				validationResults.values[fieldName] = '';
				console.log('got uploader where file was removed, saving', field);
			}
		}

		const obj = validationResults.values;
		if (options?.item?.id) {
			obj.id = options.item.id;
		}
		return obj;
	}
	function saveItem(options, focusBox) {
		const validationResults = sa.forms.validate(editInterfaceContainer);
		if (validationResults.error) {
			console.error('validation errors', validationResults);
			return;
		}

		// remove disabled since it does not happen in sa.forms.validate
		for (const field of Object.keys(validationResults.fields)) {
			if (validationResults.fields[field].input.attr('disabled')) {
				delete validationResults.fields[field];
				delete validationResults.values[field];
			}
		}

		for (const [fieldName, field] of Object.entries(validationResults.fields)) {
			// get if images were removed or changed
			if (field.uploader
				&& field.inputContainer.data('initialVal')
				&& field.inputContainer.data('value') === ''
				&& !Object.keys(validationResults.values).includes(fieldName)) {

				validationResults.values[fieldName] = '';
				console.log('got uploader where file was removed, saving', field);
			}
		}

		// console.log("validation results", validationResults)
		// console.log("valiiation values", validationResults.values)

		if (options.type === 'project') {
			// make sure it's not a duplicate name
			for (const project of user.getProjectArray()) {
				// if they entered the name of an existing project, don't let them change the name
				if (project.name === validationResults.values.name && project.id != options.item.id) {
					validationResults.fields.name.showError('There\'s already a playlist with this name. Please choose another');
					return;
				}
			}

		} else if (options.type === 'folder') {
			// make sure it's not a duplicate name
			for (const folder of user.projectFolders) {
				// if they entered the name of an existing project, don't let them change the name
				if (folder.name === validationResults.values.name && folder.id != options.item.id) {
					validationResults.fields.name.showError('There\'s already a folder with this name. Please choose another');
					return;
				}
			}
		}

		let getVars = {};
		if (options.type === 'project') {
			getVars.p = 'projects';
			getVars.action = 'change_details';
			getVars.projectId = options.item.id;
		} else if (options.type === 'folder') {
			getVars.p = 'projects';
			getVars.action = 'edit_folder';
			getVars.id = options.item.id;
		} else if (['publisher', 'writer'].includes(options.type)) {
			getVars.p = 'people';
			getVars.action = 'save';
			getVars.id = options.item.id;
			// save person to Solr immediately
			getVars.immediate = true;

		} else {
			getVars.p = options.type + '_details';
			getVars.id = options.item.id;
		}

		// override ajax params if requested
		if (options.ajaxPage && options.ajaxAction !== '') {
			getVars = {};
			getVars.p = options.ajaxPage;
			getVars.action = options.ajaxAction;
			if (options.ajaxExtraVars && Object.keys(options.ajaxExtraVars).length > 0) {
				getVars = _.extend(getVars, options.ajaxExtraVars);
			}
		}

		uploadFiles = {};
		for (const [key, val] of Object.entries(validationResults.fields)) {
			if (val.uploader && val.uploader.getFileDetails().length > 0) {
				for (const file of val.uploader.getFileDetails()) {
					if (!(file instanceof File)) {
						continue;
					}
					if (!mainUploader) {
						mainUploader = val.uploader;
					}
					if (key === 'bannerImage[image]') {
						uploadFiles.banner = file;
					} else if (key === 'image') {
						uploadFiles.file = file;
					}
				}
			}
		}

		// the uploader was really only built for one file at a time, so what we do now is grab the files from all the uploaders
		// attached to the form elements and then add the files to the first one to upload

		if (Object.keys(uploadFiles).length > 0 && mainUploader) {
			focusBox.showLoader(options.saveText);

			mainUploader.addFiles(Object.values(uploadFiles));
			const uploaderParams = $j.extend(validationResults.values, {
				t: options.type
			});
			if (getVars.id) {
				uploaderParams.id = getVars.id;
			} else {
				uploaderParams.projectId = getVars.projectId;
			}
			if (aiImageGenerationId) uploaderParams.aiImageGenerationId = aiImageGenerationId;

			mainUploader.upload({
				fileOverride: uploadFiles,
				params: createVarStringFromObject(uploaderParams),
				complete(e, response) { // success function
					// simulate an edit response from ajax so the user knows everything went ok
					handleEditResponse(options, focusBox, response);
				},
				parseComplete: true,
				error() { // error function
					focusBox.hideLoader();
					focusBox.showError('Unable to save. Please try again later');
				}
			});
			return;
		}
		focusBox.showLoader(options.saveText);
		const submitValues = validationResults.values;
		if (aiImageGenerationId) submitValues.aiImageGenerationId = aiImageGenerationId;
		ajax(submitValues, (response) => {
			focusBox.hideLoader();
			handleEditResponse(options, focusBox, response);
		}, 'POST', getVars);

	}

	// function to call after we get a response to an edit save from the server
	function handleEditResponse(options, focusBox, response) {
		let message = 'Unknown error ocurred. Please try again later';
		console.log('handle edit response', options);
		if (response && response.length && response[0].personId && response[0].success) {
			// person responses
			if (!options.item || (options.item && !options.item.id)) {
				message = gde(options.type) + ' created!';
			} else {
				message = 'Changes saved successfully!';
			}
		}
		if (response && response.length && response[0].result) {
			/**
				 * handle image upload failures via a special response in the form
				 * {
				 * 	result: 'image:Error for the main image;banner_image: Error for the banner;'
				 * }
				 * 
				 */
			const haveSpecialResponse = response[0].result.indexOf(':') > 0 && response[0].result.indexOf(';') > 0;
			if (haveSpecialResponse) {
				// in case there are image errors, we return which image was the issue
				const respObj = response[0].result.split(';').filter(a => a != '').reduce((prev, cur) => {
					const parts = cur.split(':');
					prev[parts[0]] = parts[1];
					return prev;
				}, {});

				let imageFailure = false;
				for (const [key, value] of Object.entries(respObj)) {
					// check for image failures
					if (['image', 'banner_image'].includes(key)) {
						let validationResult;
						let uploadFileToBeRemoved = false;
						if (key == 'image') {
							validationResult = new sa.forms.validationResult($mainImage.find('input').first());
							uploadFileToBeRemoved = uploadFiles.file ? uploadFiles.file.id : false;
						} else if (key == 'banner_image') {
							validationResult = new sa.forms.validationResult($bannerImageUploader.find('input').first());
							uploadFileToBeRemoved = uploadFiles.banner ? uploadFiles.banner.id : false;
						}
						validationResult.showError(value, false);

						/**
							 * since we have multiple file uploads that get combined into the first uploader
							 * for multiple file uploads, make sure to remove the errored file from all of them
							 */
						const uploader = validationResult.inputContainer.data('uploader');

						if (mainUploader && uploadFileToBeRemoved) {
							mainUploader.removeFile(uploadFileToBeRemoved);
						}
						if (uploader && uploadFileToBeRemoved) {
							uploader.removeAllFiles(uploadFileToBeRemoved);
						}

						// now reset the errored input to what the image was BEFORE the bad upload
						if (validationResult.inputContainer.data('initialVal')) {
							validationResult.inputContainer.find('img').attr('src', validationResult.inputContainer.data('initialVal'));
							validationResult.input.data('value', validationResult.inputContainer.data('initialVal'));
							validationResult.inputContainer.addClass('with_value');
							validationResult.inputContainer.find('.remove_button').addClass('showing');
						} else {
							// remove the image if there was none before the upload
							validationResult.input.data('value', '');
							validationResult.inputContainer.removeClass('with_value');
							validationResult.inputContainer.find('.remove_button').removeClass('showing');
						}

						if (key === 'banner_image') {
							const { percX, percY } = $bannerImageUploader.data('value');
							validationResult.inputContainer.trigger('focusposition', [percX, percY]);
						}
						imageFailure = true;
					}
				}
				if (imageFailure) {
					// display errors if image failure
					focusBox.showErrorMessage('Image upload failed, see below.');
					editInterfaceContainer.find('input').one('change.afterError input.afterError focus.afterError', () => {
						// hide the error after the user interacts with the form
						editInterfaceContainer.find('input').off('.afterError');
						focusBox.hideErrorMessage();
					});
				} else {
					message = response[0].result;

				}
				focusBox.hideLoader();
				return;
			}
			// success
			message = response[0].result;

			if (['changes saved!', 'success', 'success!', 'folders'].includes(message.toLowerCase())) {
				message = 'Changes saved successfully!';
			} else {
				focusBox.showErrorMessage(message);
				focusBox.hideLoader();
				return;
			}
		}
		if ((options.type == 'project' && !(options.ajaxAction == 'new' && options.ajaxPage == 'projects')) || options.type == 'folder') {
			user.reloadProjects();
		}
		sa.notify({ text: message });
		focusBox.hide();
		sa.requestCache.clear();
		if (options.type === 'artist' && sa.currentPage && sa.currentPage.name === sa.pages.artist.name && response[0].newArtistId && response[0].newArtistId != sa.pages.artist.artistId) {
			sa.router.routeTo('/artist/' + response[0].newArtistId);
		} else if (options.ajaxPage == 'projects' && options.ajaxAction == 'new') {
			// do nothing, just call the callback
		} else if (options.reloadAfterSave) {
			sa.router.reloadPage();
		}
		if (options.callback) options.callback(response);
	}

	itemEditInterface.build = function() {
		templates = sa.templates.get('components.item_edit_interface');
	};

	return itemEditInterface;

}());
sa.components.leftNav = (function () {

	var leftNav = {
		attachOnLoad : true,
		templates : null
	};

	var dataCache = {}; // used for catalog-specific filters
	var lastRequestedCatalogId;
	/** @var {JQuery} */
	var container;
	var contentContainer;
	var loaded = false;
	var trackFiltersDisabled = false;
	var albumFiltersDisabled = false;
	/** @var {Array.<LeftNavSection>} */
	var sections = [];
	var hiddenFilters = [];
	var lastLoadedCatalogId = 0;
	var smartInterval;
	var mobileHidLeftNav = false;
	var expanded = false;

	leftNav.isLoaded = function() {
		return loaded;
	};

	leftNav.isExpanded = function() {
		return loaded && expanded;
	};

	/**
	 * Checks if the Left Nav is showing the genre or label parent sections (indicating filters are available to use)
	 * If these sections are hidden, it indicates that expanded out track alternates/sub-sections shouldn't be using those filters.
	 * 
	 * @returns {boolean}
	 */
	leftNav.trackFiltersAreActive = function() {
		return !trackFiltersDisabled;
	};

	leftNav.hasGenreFilter = function () {
		var filters = getSection(getSectionTitle('tracks')).components;
		for (var i = 0, len = filters.length; i < len; i++) {
			if (filters[i].varName == 'genre') {
				return true;
			}
		}
		return false;
	};

	/**
	 * @return {Array.<LeftNavSection>}
	 */
	leftNav.getSections = function() {
		return sections;
	};

	leftNav.setMaxComponentHeight = function(titleEl, contentEl) {
		const leftNav = $j('#left_nav');
		const leftNavHeight = leftNav[0].clientHeight;
		const titleHeight = titleEl.first()[0].clientHeight;

		let maxHeight = leftNavHeight - titleHeight;
		let shouldScroll = sa.components.leftNav.isExpanded();
	
		contentEl.css({
			maxHeight,
			transition: '',
		})

		if (shouldScroll) {
			// this settimeout seems to be required for some reason
			setTimeout(() => {
				leftNav.overlayScrollbars().scroll(titleEl, 200, 'linear');
			}, 1);
		}

		
		sa.components.leftNav.resize();
	}
	
	function isAlbumPage() {
		return window.location.href.indexOf('b=');
	}

	/**
	 * Loads the parameters for the left nav
	 */
	function load(catalogId) {
		// add 'loading' to the tracks section, if there is one
		let cacheKey = user.getActivePermissionProfileId() + '-' + catalogId;
		if (dataCache[cacheKey]) {
			loadResponse(dataCache[cacheKey]);
		} else {
			contentContainer.find('#loader_element').remove();
			
			if (!isAlbumPage()) {
				showLoader(contentContainer[0], 'Loading filters');
			}
			
			lastRequestedCatalogId = catalogId;
			ajax('p=left_nav&c=' + catalogId, function(response) {
				dataCache[cacheKey] = response;
				if (catalogId == lastRequestedCatalogId) {
					loadResponse(response);
				}
			});
		}
	}

	/**
	 * Triggers a reload, which can be useful if something affecting state has changed, like a permission profile switch
	 */
	leftNav.reload = function() {
		let loadCatalogId = lastLoadedCatalogId;
		lastLoadedCatalogId = 0;
		loaded = false;
		load(loadCatalogId)
	};

	/**
	 * Processes the left nav parameters, which contains the details for the Filter Tracks section
	 */
	function loadResponse(newData) {
		var sec;
		loaded = true;
		$j('#left_nav #loader_element').remove();
		sa.components.selector.showOptions();
		if (newData.length) {

			// remove the filter sections if there are any
			for (var i = 0; i < sections.length; i++) {
				if (sections[i].title.indexOf('Filter') != -1) {
					sections[i].container.remove();
					sections.splice(i, 1);
					i--;
				}
			}

			// add a new filter tracks section
			sec = new LeftNavSection(getSectionTitle('tracks'));
			if (trackFiltersDisabled) {
				sec.hide();
			}
			sections[sections.length] = sec;
			contentContainer.append(sec.container);
			sec.trigger('attach');

			// go through all the sections specified by the server and make components for them
			function setUpComponents(sec, data, uniqueInputKey) {
				for (var i = 0; i < data.length; i++) {

					var item = data[i],
						comp = new LeftNavComponent(item.title, undefined, uniqueInputKey);

					comp.type = item.type;
					if (item.items) {
						comp.list = item.items;
					}
					comp.varName = item.varName;
					if (item.nestedVarName) {
						comp.nestedVarName = item.nestedVarName;
					}
					if (item.subTitle) {
						comp.subTitle = item.subTitle;
					}
					comp.generate(item);
					sec.addComponent(comp);

				}

				if (sec.isEmpty()) {
					sec.hide();
				}
			}
			setUpComponents(sec, newData[0].tracks, 'tracks_');

			// the filters should already be shown if they're going to be but we need to check if anything should be hidden because that won't be taken into account
			if (!trackFiltersDisabled && hiddenFilters && hiddenFilters.length) {
				leftNav.enableTrackFilters(hiddenFilters, lastLoadedCatalogId);
			} else if (config.id == 225 || config.id == 268 || config.id == 118 || config.id == 104 || config.id == 365) {
				// show categories filter for spot me radio http://bugs.sourceaudio.com/show_bug.cgi?id=1047
				sec.components[0].show();
				if (config.id == 225 || config.id == 104) { // show sub-filters http://bugs.sourceaudio.com/show_bug.cgi?id=1082
					$j(sec.components[0].container).addClass('expanded_sub_container');
				}
			}

			// add a new filter albums section
			sec = new LeftNavSection('Filter ' + gde('album', { p : true, c : 'upper' }));
			if (albumFiltersDisabled) {
				sec.hide();
			}
			sections[sections.length] = sec;
			contentContainer.append(sec.container);
			sec.trigger('attach');

			// go through all the sections specified by the server and make components for them
			setUpComponents(sec, newData[0].albums, 'albums_');

			// the filters should already be shown if they're going to be but we need to check if anything should be hidden because that won't be taken into account
			if (!albumFiltersDisabled && hiddenFilters && hiddenFilters.length) {
				leftNav.enableAlbumFilters(hiddenFilters, lastLoadedCatalogId);
			}

		}
		sa.components.projector.show();
		if (config.showCueSheets) {
			sa.components.cueSheeter.show();
		}
		return this;
	}

	function getSection(title) {
		for (var i = 0; i < sections.length; i++) {
			if (sections[i].title == title) {
				return sections[i];
			}
		}
		return null;
	}


	function getSectionTitle(type) {
		if (type == 'albums') {
			return 'Filter ' + gde('album', { p : true, c : 'upper' });
		} else if (type == 'tracks') {
			if (config.id == 72 || config.id == 87 || config.id == 114) {
				return 'Filter Sound FX';
			}
			if (config.id == 752) {
				return 'Filter Tracks and Stems';
			}
			return 'Filter Tracks';
		}
		return '';
	}

	/**
	 * Gets all the currently active parameters in the left nav in a format suitable for appending to a hash or query. Includes unselected parameters but doesn't give them values
	 * @param {boolean} ignoreEnabled should we include params even when filters are disabled?
	 * @param {string} leftNavType if 'tracks' or 'albums', will restrict results to that filter section
	 * @return {string} for example, custom_1[]=high&length[min]=&length[max]=&cue[]=
	 */
	leftNav.getParams = function(ignoreEnabled, leftNavType) {
		if (!get('left_nav')) return '';
		var params = [],
			sectionTitle = getSectionTitle(leftNavType);
		for (var i = 0, len = sections.length; i < len; i++) {
			if (sectionTitle && sections[i].title != sectionTitle) continue;
			var param = sections[i].getParams(ignoreEnabled);
			if (param) {
				params[params.length] = param;
			}
		}
		return params.join('&');
	};

	leftNav.setParams = function(params, leftNavType) {
		if (!get('left_nav')) return false;
		var sectionTitle = getSectionTitle(leftNavType);
		for (var i = 0, len = sections.length; i < len; i++) {
			if (sectionTitle && sections[i].title != sectionTitle) continue;
			sections[i].setParams(params);
		}
		return true;
	};

	/**
	 * Gets a list of all the active elements in the left nav
	 * @param {string} leftNavType if 'tracks' or 'albums', will restrict results to that filter section
	 * @return {Array} of objects with { name : name, value : value, reset : function that resets element }
	 */
	leftNav.getItemizedParams = function(leftNavType) {
		if (!get('left_nav')) return [];
		var params = [],
			sectionTitle = getSectionTitle(leftNavType);
		for (var i = 0, len = sections.length; i < len; i++) {
			if (sectionTitle && sections[i].title != sectionTitle) continue;
			params = params.concat(sections[i].getItemizedParams());
		}
		return params;
	};

	/**
	 * Resets all the left nav filters
	 */
	leftNav.reset = function() {
		if (!get('left_nav')) return [];
		for (var i = 0, len = sections.length; i < len; i++) {
			sections[i].reset();
		}
	};

	/**
	 * If there's a special override=1 in the hash, this function will
	 * change the left nav filter state to match what's in the full hash
	 * 	Note that it only overrides values that are specified.
	 * 	For example, if you have genre set but not tempo, only genre will change
	 */
	leftNav.applyOverride = function() {
		// get the current vars in the hash
		let vars = sa.router.getCurrentParamsAsObject();
		if (vars.override) delete vars.override;
		// see what else is there
		for (var i = 0; i < sections.length; i++) {
			sections[i].applyOverride(vars);
		}
		return leftNav;
	};

	leftNav.disableAll = function() {
		leftNav.disableTrackFilters();
		leftNav.disableAlbumFilters();
		return leftNav;
	};

	leftNav.disableTrackFilters = function() {
		var s = getSection(getSectionTitle('tracks'));
		if (s) {
			s.hide();
		}
		// these next var is set in case this function is called before the filter data is loaded
		// the load handler will check for it and take approprate action
		trackFiltersDisabled = true;
		return leftNav;
	};

	leftNav.disableAlbumFilters = function() {
		var s;
		if ((s = getSection('Filter ' + gde('album', { p : true, c : 'upper' })))) s.hide();
		// these next var is set in case this function is called before the filter data is loaded
		// the load handler will check for it and take approprate action
		albumFiltersDisabled = true;
		return leftNav;
	};

	/**
	 * Shows the filters in the left nav
	 * @param {Array=} newHiddenFilters of string names of filters that shouldn't be shown on this page
	 * @param {int=} catalogId the id of the catalog whose filters we should enable
	 * @returns {sa.components.leftNav}
	 */
	leftNav.enableTrackFilters = function(newHiddenFilters, catalogId) {
		if (!catalogId) catalogId = 0;
		// console.log('enabling catalog filters with', catalogId);
		if (lastLoadedCatalogId != catalogId) {
			lastLoadedCatalogId = catalogId;
			trackFiltersDisabled = false;
			albumFiltersDisabled = true;
			hiddenFilters = newHiddenFilters;
			load(catalogId);
			return;
		}
		lastLoadedCatalogId = catalogId;
		var s, i, len;
		if (s = getSection(getSectionTitle('tracks'))) s.show();
		if (s && newHiddenFilters && newHiddenFilters.length) {
			// hide anything that's in the hidden filters
			for (i = 0, len = s.components.length; i < len; i++) {
				var comp = s.components[i];
				if (newHiddenFilters.indexOf(comp.varName) != -1 || newHiddenFilters.indexOf(comp.nestedVarName) != -1) {
					$j(comp.container).hide();
				} else {
					$j(comp.container).show();
				}
			}
		} else if (s) {
			// show everything
			for (i = 0, len = s.components.length; i < len; i++) {
				$j(s.components[i].container).show();
			}
		}
		if (s && (config.id == 225 || config.id == 268 || config.id == 118 || config.id == 104 || config.id == 365)) { // show categories filter for spot me radio http://bugs.sourceaudio.com/show_bug.cgi?id=1047
			s.components[0].show();
			if (config.id == 225 || config.id == 104) { // show sub-filters http://bugs.sourceaudio.com/show_bug.cgi?id=1082
				$j(s.components[0].container).addClass('expanded_sub_container');
			}
		}
		// these next vars are set in case this function is called before the filter data is loaded
		// the load handler will check for them and take approprate action
		trackFiltersDisabled = false;
		hiddenFilters = newHiddenFilters;
		return leftNav;
	};

	/**
	 * Shows the filters in the left nav
	 * @param {Array=} newHiddenFilters of string names of filters that shouldn't be shown on this page
	 * @param {int=} catalogId the id of the catalog whose filters we should enable
	 */
	leftNav.enableAlbumFilters = function(newHiddenFilters, catalogId) {
		if (!catalogId) catalogId = 0;
		// console.log('enabling catalog album filters with', catalogId, newHiddenFilters);
		if (lastLoadedCatalogId != catalogId) {
			lastLoadedCatalogId = catalogId;
			albumFiltersDisabled = false;
			trackFiltersDisabled = true;
			hiddenFilters = newHiddenFilters;
			load(catalogId);
			return;
		}
		lastLoadedCatalogId = catalogId;
		var s, i, len;
		if ((s = getSection('Filter ' + gde('album', { p : true, c : 'upper' })))) s.show();
		if (s && newHiddenFilters && newHiddenFilters.length) {
			// hide anything that's in the hidden filters
			for (i = 0, len = s.components.length; i < len; i++) {
				var comp = s.components[i];
				if (newHiddenFilters.indexOf(comp.varName) != -1 || newHiddenFilters.indexOf(comp.nestedVarName) != -1) {
					$j(comp.container).hide();
				} else {
					$j(comp.container).show();
				}
			}
		} else if (s) {
			// show everything
			for (i = 0, len = s.components.length; i < len; i++) {
				$j(s.components[i].container).show();
			}
		}
		// these next vars are set in case this function is called before the filter data is loaded
		// the load handler will check for them and take approprate action
		albumFiltersDisabled = false;
		hiddenFilters = newHiddenFilters;
	};

	leftNav.addComponent = function(component) {
		contentContainer.append(component);
	};

	leftNav.showSmartFilters = function(filters) {
		if (!loaded) {
			if (smartInterval) clearInterval(smartInterval);
			smartInterval = setInterval(function() {
				if (loaded) {
					leftNav.showSmartFilters(filters);
					clearInterval(smartInterval);
					smartInterval = null;
				}
			}, 250);
			return;
		}
		if (!trackFiltersDisabled && (s = getSection(getSectionTitle('tracks')))) {
			s.showSmartFilters(filters);
		} else if (!albumFiltersDisabled && (s = getSection('Filter ' + gde('album', { c : 'upper', p : true })))) {
			s.showSmartFilters(filters);
		}
	};

	leftNav.show = function () {
		const body = $j('body');
		body.addClass('with_left_nav');
		mobileHidLeftNav = false;

		if (body.hasClass('branding_header_full_width')) {
			const minTop = $j('#top_bar').height();
			const maxTop = $j('#branding_header').height() + minTop;
			const containerStyle = container[0].style;
			let topped = maxTop - getScrollY() <= minTop;
			$j(window).off('.left_nav').on('scroll.left_nav', function () {
				const newTop = maxTop - getScrollY();
				if (newTop <= minTop) {
					if (!topped) {
						topped = true;
						containerStyle.top = `${minTop}px`;
					}
				} else {
					topped = false;
					containerStyle.top = `${newTop}px`;
				}
			}).trigger('scroll');
		}
		container.overlayScrollbars().scroll({ y: 0 });
		
		leftNav.resize();
	};

	leftNav.hide = function() {
		$j('body').removeClass('with_left_nav');
		$j(window).off('.left_nav');
		mobileHidLeftNav = false;
	};

	leftNav.resize = function () {
		const body = sa.getDomBody();
		let midWidth = false;
		if ($j(window).width() >= 1200) {
			body.removeClass('with_collapsed_left_nav');
			container.removeClass('collapsible');
			if (mobileHidLeftNav) {
				body.addClass('with_left_nav');
				mobileHidLeftNav = false;
			}
			container.addClass('expanded');
			expanded = true;

			container.overlayScrollbars({
				overflowBehavior: {
					y: 'scroll'
				},
			});

		} else if ($j(window).width() < 1200 && $j(window).width() >= 768) {
			body.addClass('with_collapsed_left_nav');
			container.addClass('collapsible');
			if (mobileHidLeftNav) {
				body.addClass('with_left_nav');
				mobileHidLeftNav = false;
			}

			container.removeClass('expanded');

			expanded = false;
			midWidth = true;

		} else {
			if (body.hasClass('with_left_nav')) mobileHidLeftNav = true;
			body.removeClass('with_collapsed_left_nav with_left_nav');
			container.removeClass('collapsible');
			expanded = true;
		}

		if (
			body.hasClass('with_left_nav') 
			&& body.hasClass('with_collapsed_left_nav')
		) {
			if (container.hasClass('expanded')) {
				expanded = true;

				container.overlayScrollbars({
					overflowBehavior: {
						y: 'scroll'
					},
				});
			} else {
				expanded = false;

				container.overlayScrollbars({
					overflowBehavior: {
						y: 'hidden'
					},
				});
				container.overlayScrollbars().scroll({ y: 0 });
			}
		}
		
		// Check and make sure the left nav is not taller than the main area
		container.css('top', '');
		const topOfLeftNav = container.offset().top;
		const leftNavTopSelector = (!midWidth && sa.getDomBody().hasClass('branding_header_full_width')) || !sa.getDomBody().hasClass('with_branding_header') ? '#nav_container' : '#branding_header';
		const topOfMainMenu = $j(leftNavTopSelector).offset().top;
		if (topOfLeftNav < topOfMainMenu) {
			container.css('top', `${topOfMainMenu}px`);
		}
		
		sa.trigger('left_nav_resize');
	};

	leftNav.build = function() {
		leftNav.templates = sa.templates.get('left_nav');

		container = leftNav.templates.get('left_nav');
		contentContainer = container.find('#left_nav_content');

		this.disableAll();

		contentContainer.find('#ltp_nav').remove();

		if (BrowserDetect.isWin) {

			container.on('mouseenter', function () {
				//container.nanoScroller();
				container.addClass('moused_over');
			})
			.on('mouseleave', function () {
				container.removeClass('moused_over');
			});

		} else {
			//container['nanoScroller'] = function() {};
		}

		container.find('#left_nav_handle').on('click', function() {
			leftNav.toggleExpand();
		});
	};

	leftNav.toggleExpand = function() {
		var handleClosingClickTarget = $j('html');
		container.toggleClass('expanded');
		if (container.hasClass('expanded')) {
			handleClosingClickTarget.on('click.expanded_left_nav', function(e) {
				var parents = $j(e.target).parents().add(e.target);
				if (!parents.filter('#left_nav, .focused_container').length || parents.filter('.project_list_project').length || $j(e.target).is('#left_nav_close')) {
					container.removeClass('expanded');
					handleClosingClickTarget.off('.expanded_left_nav');
					container.overlayScrollbars({
						overflowBehavior : {
							y : "hidden"
						},
					});
					container.overlayScrollbars().scroll({y: 0});
				}
			});

			container.overlayScrollbars({
				overflowBehavior : {
					y : "scroll"
				},
			});

			expanded = true;
			
		} else {
		
			handleClosingClickTarget.off('.expanded_left_nav');
			container.overlayScrollbars({
				overflowBehavior : {
					y : "hidden"
				},
			});

			container.overlayScrollbars().scroll({y: 0});

			expanded = false;
		}

	}

	leftNav.attach = function() {
		$j('body').append(container);

		if (!loaded) {
			load(0);
		}

		sa.components.selector.showOptions();
		sa.components.projector.show();
		if (config.showCueSheets) {
			sa.components.cueSheeter.show();
		}

		//if (BrowserDetect.isWin && container['overlayScrollbars']) {
			container.overlayScrollbars({
				scrollbars : {
					autoHide : 'leave'
				}
			});
		//}
		if (ios || android) {
			sa.getDomBody().addClass('with_collapsed_left_nav');
			container.addClass('collapsible');
		}

		sa.on('resize', function() {
			leftNav.resize();
		});

	};

	return leftNav;
}());

function LeftNavSection(title) {
	let section = this;

	this.title = title;
	this.enabled = true;
	/** @var {Array.<LeftNavComponent>} this.components */
	this.components = [];
	this.container = null;

	/**
	 * @return {boolean}
	 */
	this.isEmpty = function() {
		for (let i = 0, len = this.components.length; i < len; i++) {
			if (!this.components[i].isEmpty()) {
				return false;
			}
		}
		return true;
	};

	this.showSmartFilters = function(filters) {
		var components = this.components;
		for (var i = 0, len = components.length; i < len; i++) {
			components[i].showSmartFilters(filters);
		}
	};

	this.getComponent = function(title) {
		if ((i = this.getComponentIndex(title)) != -1) {
			return this.components[i];
		}
		return null;
	};

	this.getComponentIndex = function(title) {
		var components = this.components;
		for (var i = 0, len = components.length; i < len; i++) {
			if (components[i].title == title) return i;
		}
		return -1;
	};

	this.addComponent = function(component, before) {
		if (before && (i = this.getComponentIndex(before)) != -1) {
			this.components.splice(i, 0, component);
			return;
		}
		this.components[this.components.length] = component;
		this.refresh();
	};

	this.removeComponent = function(title) {
		var i = this.getComponentIndex(title);
		if (i == -1) return;
		this.container.find('#left_nav_components')[0].removeChild(this.components[i].container[0]);
		this.components.splice(i, 1);
	};

	this.showAll = function() {
		var components = this.components;
		for (var i = 0, len = components.length; i < len; i++) {
			components[i].show();
		}
	};

	this.refresh = function() {
		var div = this.container.find('#left_nav_components'),
			components = this.components;
		var i, len;
		for (i = 0, len = components.length; i < len; i++) {
			components[i].container.detach();
		}
		div.empty();
		for (i = 0, len = components.length; i < len; i++) {
			div.append(components[i].container);
		}
	};

	this.reset = function() {
		var components = this.components;
		for (var i = 0, len = components.length; i < len; i++) {
			components[i].reset();
		}
	};

	this.getParams = function(ignoreEnabled) {
		var params = [],
			components = this.components;
		for (var i = 0, len = components.length; i < len; i++) {
			var param = components[i].getParams(this.enabled || (ignoreEnabled && ignoreEnabled != undefined));
			if (param) {
				params[params.length] = param;
			}
		}
		return params.join('&');
	};

	this.setParams = function(params) {
		for (var i = 0; i < this.components.length; i++) {
			this.components[i].setParams(params);
		}
	};

	/**
	 * Gets a list of all the active elements in this left nav section
	 * @return {Array} of objects with { name : name, value : value, reset : function that resets element }
	 */
	this.getItemizedParams = function() {
		var params = [],
			components = this.components;
		for (var i = 0, len = components.length; i < len; i++) {
			params = params.concat(components[i].getItemizedParams());
		}
		return params;
	};

	/**
	 * Passes the override buck down the chain to the components
	 */
	this.applyOverride = function(vars) {
		for (var i = 0; i < this.components.length; i++) {
			this.components[i].applyOverride(vars);
		}
	};

	this.setEnabled = function(enabled) {
		this.enabled = enabled;
	};

	this.hide = function() {
		this.container.hide();
		this.trigger('hide');
	};

	this.show = function() {
		if (!this.isEmpty()) {
			this.container.show();
			this.trigger('show');
		}
	};

	this.init = function() {
		this.container = sa.components.leftNav.templates.get('section', { title : this.title });

		sa.eventify(this);

		this.on('attach', function() {
			let lastWidth = 0;
			let lastHeight = 0;
			let resizeIframe = this.container.find('.resize_detector iframe')[0];
			(resizeIframe.contentWindow || resizeIframe).addEventListener('resize', function () {
				let newWidth = Math.round(resizeIframe.clientWidth);
				let newHeight = Math.round(resizeIframe.clientHeight);
				if (lastWidth != newWidth || lastHeight != newHeight) { // without this check, the resize trigger can cause an iframe resize and it loops forever
					lastWidth = newWidth;
					lastHeight = newHeight;
					section.trigger('resize');
				}
			});
		});
	};

	this.init();
}

function LeftNavComponent(title, showing, uniqueInputKey) {
	var component = this;

	this.container = null;
	this.list = [];
	this.name = title.toLowerCase().replace(' ', '_');
	this.range = null;
	this.nestedVarName = '';
	this.showing = showing;
	this.subTitle = title;
	this.title = title;
	this.type = '';
	this.varName = '';

	this.clickedExpand = false;

	var empty = false;

	/**
	 * @returns {boolean}
	 */
	this.isEmpty = function() {
		return empty;
	};

	this.setMaxHeight = function() {
		const leftNav = $j('#left_nav');
		const leftNavHeight = leftNav[0].clientHeight;
		const componentContainer = this.container;
		const contentContainer = componentContainer.find('#content');
		const titleHeight = componentContainer.find("#title").first()[0].clientHeight;

		let maxHeight = leftNavHeight - titleHeight;
		let shouldScroll = this.clickedExpand && sa.components.leftNav.isExpanded() ;
	
		contentContainer.css({
			maxHeight,
			transition: '',
		}).one('transitionend', function () {
			// only scroll if clicked to open
			if (!shouldScroll) {
				return;
			}

			// this settimeout seems to be required for some reason
			setTimeout(() => {
				leftNav.overlayScrollbars().scroll(componentContainer, 200, 'linear');
			}, 1);
		});
	}

	this.show = function() {
		this.container.addClass('expanded');
		this.showing = true;
		this.setMaxHeight();
		sa.components.leftNav.resize();
	};

	this.hide = function() {
		this.container.removeClass('expanded');
		this.showing = false;
		this.container.find('#content').css({ maxHeight: '' });
		sa.components.leftNav.resize();
	};

	this.swap = function() {
		if (this.showing) {
			this.hide();
		} else {
			this.show();
		}
		user.leftNavChange(this.title, this.showing);
	};

	this.showSmartFilters = function(filters) {
		if (config.id == 225 || config.id == 104 || config.id == 1246 || config.id == 1843 || config.id == 2235) return; // no smart filters for spot me http://bugs.sourceaudio.com/show_bug.cgi?id=1082

		// remove filters that don't support smart filtering
		var noFilters = ['catalog', 'label', 'network'];
		if (config.id == 299) noFilters.push('tempo');

		// make sure this is one we're going to show
		var isSmartFilter = filters[this.varName] && noFilters.indexOf(this.varName) == -1;
		if (filters[this.varName] && (isSmartFilter || (component.nestedVarName && noFilters.indexOf(component.nestedVarName) == -1))) {

			// we iterate over the list of items that are displayed on the page and determine whether or not to show each one
			var items = this.container.find('#content > .left_item_container');
			if (items.length) {
				this.container.show();

				// the new count data for this filter
				var filterCounts = filters[this.varName];

				items.each(function() {
					var item = $j(this);
					var itemId = item.find('.left_nav_checkbox:first').data('value');
					var subItems = item.find('.sub_container > .left_item_container');
					
					if (!filterCounts[itemId] && typeof itemId === 'string') {
						itemId = htmlEncode(itemId);
					}

					if (filterCounts[itemId]) {

						var filterData = filterCounts[itemId];

						// filter is ok. show the count
						if (isSmartFilter) {
							item.removeClass('disabled');
							item.find('label:first').find('span').remove().end().append('<span class="count"> (' + filterData.count.numberFormat() + ')</span>');
						}

						// show sub items, if there are any
						if (component.nestedVarName && noFilters.indexOf(component.nestedVarName) == -1) {
							if (filterData['nestedFields'] && filterData['nestedFields'][component.nestedVarName]) {
								var subCounts = filterData['nestedFields'][component.nestedVarName];
								subItems.each(function() {
									var subItem = $j(this);
									var subItemId = subItem.find('.left_nav_checkbox:first').data('value');
									if (subCounts[subItemId]) {
										// filter is ok. show the count
										subItem.removeClass('disabled');
										subItem.find('label:first').find('span').remove().end().append('<span class="count"> (' + subCounts[subItemId].count.numberFormat() + ')</span>');
									} else {
										// no tracks were available for the filter
										subItem.addClass('disabled');
										subItem.find('label:first').find('span').remove().end().append('<span class="count"> (0)</span>');
									}
								});
							} else {
								subItems.each(function() {
									var subItem = $j(this);
									subItem.addClass('disabled');
									subItem.find('label:first').find('span').remove().end().append('<span class="count"> (0)</span>');
								});
							}
						}

					} else {
						// no tracks were available for the filter
						if (isSmartFilter) {
							item.addClass('disabled');
							item.find('label:first').find('span').remove().end().append('<span class="count"> (0)</span>');
						}
						subItems.each(function() {
							var subItem = $j(this);
							subItem.addClass('disabled');
							subItem.find('label:first').find('span').remove().end().append('<span class="count"> (0)</span>');
						});
					}
				});
			} else {
				this.container.hide();
			}
		}
	};


	this.generate = function(params) {
		var content = this.container.find('#content');
		this.container.addClass(this.type);
		switch (this.type) {
			case 'list-multiple':
			case 'list-nested':
				this.showMultiple(content, this.list, this.type, false);
				break;
			case 'range-select':
				this.range = new LeftNavRangeComponent(content, params, this, 'length', uniqueInputKey);
				break;
			case 'date-range':
				this.range = new LeftNavRangeComponent(content, params, this, 'date', uniqueInputKey);
				break;
			case 'int-range':
				this.range = new LeftNavRangeComponent(content, params, this, 'int', uniqueInputKey);
				break;
			default:
				console.log('not a recognized type');
		}
	};

	this.showMultiple = function(container, list, type, nestingKey) {
		empty = !list.length;
		for (var i = 0, len = list.length; i < len; i++) {
			var item = list[i],
				itemText = item.text ? item.text : item,
				itemValue = item.value ? item.value : item,
				div = $j('<div class="left_item_container"></div>'),
				input = $j('<span class="left_nav_checkbox fa fa-square-o" data-value="' + itemValue + '" id="' + uniqueInputKey + 'left_item_' + this.name + '_' + i + '_' + nestingKey + '"/>').on('click', function() { this.clickFunc(); });
			input[0].val = itemValue;
			input[0].useNestedVarName = nestingKey !== false;
			input[0].itemText = itemText;
			(function(input) {
				input[0].checkMe = function() {
					input[0].className = 'left_nav_checkbox fa fa-check-square-o';
					input[0].dataset.ignoreReset = "true";
				};
				input[0].uncheckMe = function() {
					input[0].className = 'left_nav_checkbox fa fa-square-o';
					delete input[0].dataset.ignoreReset;
				};
				input[0].isChecked = function() {
					return input.hasClass('fa-check-square-o');
				};
			})(input);
			input[0].clickFunc = function() {
				var parent = $j(this).parent(),
					grandParent = parent.parent();

				// have we been disabled?
				if (parent.hasClass('disabled')) {
					this.uncheckMe();
					return;
				}

				if (this.isChecked()) {
					this.uncheckMe();
				} else {
					this.checkMe();
				}

				if (grandParent.hasClass('sub_container')) {
					// see if the top most check needs to be checked or not
					var checks = grandParent.find('.fa-check-square-o').length,
						unchecks = grandParent.find('.left_nav_checkbox').length - checks;
					if (checks && !unchecks) {
						grandParent.parent().find('.left_nav_checkbox:first')[0].checkMe();
					} else {
						grandParent.parent().find('.left_nav_checkbox:first')[0].uncheckMe();
					}
				}
				
				// Check children
				let hasChildren = !!$j(this).parent().find('.sub_container').length;
				let hasCheckedChildren = !!$j(this).parent().find('.sub_container .fa-check-square-o').length;
				
				if (hasChildren && hasCheckedChildren) {
					$j(this).parent().find('.sub_container .fa-check-square-o').each(function() {
						this.uncheckMe();
					});
				}
				
				component.changed();
			};
			if (nestingKey !== false) {
				input.addClass('nested');
			}
			div.append(input).append('<label for="' + uniqueInputKey + 'left_item_' + this.name + '_' + i + '_' + nestingKey + '">' + itemText + '</label><div class="clr"></div>');
			if (type == 'list-nested' && item.subValues && item.subValues.length > 1) {

				var subContainer = $j('<div class="sub_container"></div>');
				var expand = $j('<span class="faux_button expander" title="Click to show/hide detailed options"><span class="expand_button">+</span><span class="collapse_button">-</span></span>');

				expand.on('click', function(div) { return function() {
					div.toggleClass('expanded_sub_container');
				};}(div));

				this.showMultiple(subContainer, item.subValues, 'list-multiple', i);

				input.after(expand);
				div.append(subContainer);
			}
			container.append(div);
		}
		container.find('label').off('click').on('click', function() {
			$j(this).siblings('.left_nav_checkbox').trigger('click');
		});
		container.append('<div class="clr"></div>');

		// prevent overscrolling from scrolling the whole page
		// https://stackoverflow.com/questions/7600454/how-to-prevent-page-scrolling-when-scrolling-a-div-element
		// container.on( 'mousewheel DOMMouseScroll', function ( e ) {
		// 	var d = e.originalEvent.wheelDelta || -e.originalEvent.detail,
		// 		dir = d > 0 ? 'up' : 'down',
		// 		stop = (dir == 'up' && this.scrollTop == 0) ||
		// 			(dir == 'down' && this.scrollTop == this.scrollHeight-this.offsetHeight);
		// 	stop && e.preventDefault();
		// 	e.stopPropagation();
		// });
	};

	/**
	 * Resets the component to its default state. Everything unchecked, etc.
	 */
	this.reset = function() {

		switch (this.type) {
			case 'list-multiple':
			case 'list-nested':
				this.container.find('.left_nav_checkbox').each(function() {
					let skipUncheck = this.dataset.hasOwnProperty('ignoreReset') && this.dataset.ignoreRest === 'true';
					if (!skipUncheck) {
						this.uncheckMe();
					}
				});
				break;
			case 'range-select':
			case 'int-range':
			case 'date-range':
				this.range.reset();
				break;
		}
	};

	/**
	 * Gets any url parameters specified by this component's state
	 * NOTE: this function must return at least 'this.varName=' if there is a varName. It's used for disabling and clearing filters
	 * @return {string} url parameter form of the component's state
	 */
	this.getParams = function(enabled) {
		if (this.type == 'range-select' || this.type == 'date-range' || this.type == 'int-range') {
			// range selects handle this differently
			return this.range.getParams(enabled);
		}
		var values = '';
		if (enabled) {
			var items = this.container.find('.left_nav_checkbox'),
				lastUnnestedChecked = false;
			for (var i = 0, len = items.length; i < len; i++) {
				var item = items[i];
				// if a parent item is checked, we don't want to send in all the sub items. this lets us skip that
				if (!item.useNestedVarName) lastUnnestedChecked = item.isChecked();
				else if (lastUnnestedChecked) continue;
				if (item.isChecked()) {
					item.val = $j('<div/>').html(item.val).text();
					var escapedVal = encodeURIComponent(item.val);

					if (item.useNestedVarName) {
						var parentVal = encodeURIComponent($j(item).parent().parent().parent().find('.left_nav_checkbox:first').data('value')),
							key = (parentVal + '-' + escapedVal).replace(/%[0-9A-F]{2}/g, '');
						values += this.nestedVarName + '[' + key + '][val]=' + escapedVal
							+ '&' + this.nestedVarName + '[' + key + '][under_var]=' + encodeURIComponent(this.varName) + '&'
							+ '&' + this.nestedVarName + '[' + key + '][under_val]=' + parentVal + '&';
					} else {
						values += this.varName + '[]=' + encodeURIComponent(item.val) + '&';
					}
				}
			}
		}
		if (values) {
			values = values.substring(0, values.length - 1);
			// we need to include an empty param for any vars that can be set by this component but aren't. Otherwise, those items will be left in the vars if they weren't
			// the vars will be stored as a hash and only values that are present in this return will be overwritten
			if (this.nestedVarName && values.indexOf(this.nestedVarName) == -1) {
				values += '&' + this.nestedVarName + '[]=';
			}
			if (values.indexOf(this.varName + '[]') == -1) {
				values += '&' + this.varName + '[]=';
			}
			return values;
		} else if (this.varName) {
			if (this.nestedVarName) {
				return this.varName + '[]=&' + this.nestedVarName + '[]=';
			}
			return this.varName + '[]=';
		} else {
			return '';
		}
	};

	/**
	 * Sets the state of the component to match values specified in params
	 * @param {string} params url parameter form of the state this component should be in
	 */
	this.setParams = function(params) {
		// if you're trying to figure out why a new item isn't being populated in and expanded, it's probably because you didn't add it to the pagevars, dumbass
		window['params'] = params;
		if (this.varName) {
			let testVarNames = [ this.varName + '[]', this.varName + encodeURIComponent('[]'), this.varName + '[min]', this.varName + encodeURIComponent('[min]') ];
			for (let i = 0, len = testVarNames.length; i < len; i++) {
				let testVarName = testVarNames[i];
				if (params.indexOf(testVarName) != -1) {
					if (this.type == 'range-select' || this.type == 'date-range' || this.type == 'int-range') {
						// range selects handle this differently
						return this.range.setParams(params);
					}
					let myVar = sa.router.paramsToVars(params)[testVarNames[0]];
					if (myVar) { // var name might appear in a search term, etc. in which case myVar will be undefined
						this.applyVars(myVar);
						this.show();
					}
				}
			}
		}
		if (this.nestedVarName && params.indexOf(this.nestedVarName) != -1) {
			let myVar = sa.router.paramsToVars(params)[this.nestedVarName];
			if (myVar) { // var name might appear in a search term, etc. in which case myVar will be undefined
				this.applyVars(myVar, true);
				this.show();
			}
		}
	};

	/**
	 * Gets a list of all the active elements in this left nav component
	 * @return {Array} of objects with { name : name, value : value, reset : function that resets element }
	 */
	this.getItemizedParams = function() {
		if (this.type == 'range-select' || this.type == 'date-range' || this.type == 'int-range') {
			return this.range.getItemizedParams();
		}
		var params = [],
			items = this.container.find('.left_nav_checkbox'),
			lastUnnestedChecked = false;
		for (var i = 0, len = items.length; i < len; i++) {
			var item = items[i];
			// if a parent item is checked, we don't want to send in all the sub items. this lets us skip that
			if (!item.useNestedVarName) lastUnnestedChecked = item.isChecked();
			else if (lastUnnestedChecked) continue;
			if (item.isChecked()) {
				var value = item.itemText;
				if (item.useNestedVarName) {
					value += ' ' + 'and' + ' ' + this.title + ': ' + $j(item).parent().parent().parent().find('label:first').html().replace(/<span class="count">[^<]+<\/span>/g, '');
				}
				params.push({ name : (item.useNestedVarName ? this.subTitle : this.title), value : value, reset : function(item) { return function() {
					//item.uncheckMe();
					item.clickFunc();
					if ($j(item).parents('.left_item_container.disabled').length) {
						component.changed();
					}
				}; }(item) });
			}
		}
		return params;
	};

	/**
	 * Goes through every value sent in and checked="checked" it
	 * @param {Array|string} vars either a single value to check or a list of values
	 * @param {boolean=} nested should we be considering nested inputs?
	 */
	this.applyVars = function(vars, nested) {
		if (!vars.isArray && typeof(vars) == 'object') {
			for (var ind in vars) {
				if (!vars.hasOwnProperty(ind)) continue;
				var details = vars[ind],
					val = details.val,
					underVal = details.under_val,
					input = this.container.find('#content > .left_item_container .left_nav_checkbox[data-value="' + underVal.replace(/"/g, '\\\\"') + '"]').parent().find('.sub_container .left_nav_checkbox[data-value="' + val.replace(/"/g, '\\\\"') + '"]');
				if (input.length) {
					input.parents('.left_item_container').addClass('expanded_sub_container');
					input[0].checkMe();
				}
			}
			return;
		}
		var inputs = this.container.find('.left_nav_checkbox' + (nested ? '.nested' : ':not(.nested)'));
		if (!vars.isArray) vars = [vars];
		for (var i = 0; i < vars.length; i++) {
			for (var j = 0, jLen = inputs.length; j < jLen; j++) {
				if (inputs[j].val == vars[i]) {
					inputs[j].checkMe();
					$j(inputs[j]).parents('.left_item_container').addClass('expanded_sub_container');
					/*continue;
					// for nested, we want to also check sub boxes
					$j(inputs[j]).parent().find('.sub_container input').prop('checked', true);
					// for actual nested items, we should expand them if this is happening
					if (nested) {
						$j(inputs[j]).parent().parent().parent().find('span:contains(+)').trigger('click');
					}*/
				}
			}
		}
	};

	/**
	 * If this is a filter component, looks for its name in the vars and if it's there, updates its state to match
	 */
	this.applyOverride = function(vars) {
		// doesn't work for range-select types right now. feel free to add that....me
		if (this.type != 'list-multiple' && this.type != 'list-nested') return;
		// reset before we start applying new values
		this.reset();
		// if we're not specified in the vars, that's all we have to do
		if (!vars[this.varName]) return;
		// apply!
		this.applyVars(vars[this.varName]);
		// show us since we changed
		this.show();
	};

	this.changed = function() {
		reloadTrackList(true);
		reloadAlbumList();
		console.log('calling reload track list');
	};

	this.init = function() {
		const self = this
		this.container = sa.components.leftNav.templates.get('component', { name : this.name, title : this.title });
		this.container.find('h1').on('click', function() { 
			self.clickedExpand = true;
			component.swap(); 
			self.clickedExpand = false;

		});
		if (this.showing || ((config.id == 72 || config.id == 87 || config.id == 114 || config.id == 104) && this.title == 'Category') || (config.id == 365 && this.title == 'Genre')) {
			this.show();
		} else {
			this.hide();
		}
	};

	this.init();
}

/**
 * A range select component where the user can input a min and a max value
 * Unlike the other components that are updated in realtime, this component requires users to apply changes
 * @param {HTMLElement} container the container this component will sit in
 * @param {Object} params some information about the component. Expects min, max, and varName
 * @param {LeftNavComponent} component the component that's holding this one
 * @param {string} type (length|date|int)
 * @param {string} uniqueInputKey (tracks_|albums_)
 */
function LeftNavRangeComponent(container, params, component, type, uniqueInputKey) {
	this.component = component;
	this.container = $j(container);
	this.max = Math.floor(params.max);
	this.min = Math.floor(params.min);
	if (type == 'date') {
		// set the times to the first second in the day. when you use the datepicker to pick a date, this is what it'll set min and max to
		// and we need that to be == this.max and this.min so we can determine if the filter is active
		this.max = new Date(formatDate('m/d/Y', this.max)).getTime() / 1000;
		this.min = new Date(formatDate('m/d/Y', this.min)).getTime() / 1000;
	}
	this.type = type;
	this.varName = params.varName;

	/**
	 * Gets any url parameters specified by this component's state
	 * @param {boolean} enabled is the component enabled?
	 * @return {string} url parameter form of the component's state
	 */
	this.getParams = function(enabled) {
		if (enabled) {
			var min = this.getMin();
			var max = this.getMax();
			if ((min != this.min || max != this.max) && max !== false && min !== false) {
				// for dates, we need max to be the last second in the day. if the user filters from 01/01/2011 to 01/07/2011, they'll expect to get all times on the 7th
				return this.varName + '[min]=' + min + '&' + this.varName + '[max]=' + (max + (this.type == 'date' ? 86399 : 0));
			}
		}
		return this.varName + '[min]=&' + this.varName + '[max]=';
	};

	/**
	 * Sets the state of the component to match values specified in params
	 * @param {string} params url parameter form of the state this component should be in
	 */
	this.setParams = function(params) {
		let openBracket = '(?:\\[|' + encodeURIComponent('[') + ')';
		let closeBracket = '(?:\\]|' + encodeURIComponent(']') + ')';
		var min = params.match(new RegExp(this.varName + openBracket + 'min' + closeBracket + '=(-?[0-9]+)'));
		if (min) {
			this.setMin(min[1]);
			this.component.show();
		}
		var max = params.match(new RegExp(this.varName + openBracket + 'max' + closeBracket + '=(-?[0-9]+)'));
		if (max) {
			this.setMax(max[1]);
			this.component.show();
		}
	};

	/**
	 * Gets a list of all the active elements in this left nav component
	 * @return {Array} of objects with { name : name, value : value, reset : function that resets element }
	 */
	this.getItemizedParams = function() {
		var min = this.getMin(),
			max = this.getMax(),
			t = this;
		if ((min != this.min || max != this.max) && max !== false && min !== false) {
			return [{ name : this.component.title, value : 'Between ' + this.serverToDisplay(min) + ' & ' + this.serverToDisplay(max), reset : function() { t.reset(); t.component.changed(); } }];
		}
		return [];
	};

	if (type == 'length') {
		/**
		 * Converts seconds into mm:ss format
		 * @param {int} sec seconds
		 * @return {string} mm:ss
		 */
		this.serverToDisplay = function(sec) {
			var s = sec % 60;
			return Math.floor(sec / 60) + ':' + (s < 10 ? '0' : '') + Math.floor(s);
		};

		/**
		 * Converts mm:ss into seconds
		 * @param {string} mmss a time in mm:ss or ss format
		 * @return {int|boolean} seconds
		 */
		this.displayToServer = function(mmss) {
			var match = mmss.match(/^([0-9]+)?:?(\b[0-9]+)$/);
			if (!match) return false;
			return Number(match[1] ? match[1] * 60 : 0) + Number(match[2]);
		};
	} else if (type == 'date') {
		/**
		 * Converts a timestamp into m/d/y format
		 * @param {int} sec timestamp
		 * @return {string} formatted date
		 */
		this.serverToDisplay = function(sec) {
			return formatDate(config.dateFormatString, sec);
		};

		/**
		 * Converts m/d/y into a timestamp
		 * @param {string} display a date in m/d/y format
		 * @return {int} unix timestamp
		 */
		this.displayToServer = function(display) {
			var parts, date;
			if (1 === config.dateFormat) {
				parts = display.split('/');
				date = new Date(parts[2] + "/" + parts[1] + "/" + parts[0]);
			} else {
				date = new Date(display);
			}

			return date.getTime() / 1000;
		};
	} else {
		/**
		 * Stub. Does no conversion
		 * @param {int} serverValue
		 * @return {string} formattedValue
		 */
		this.serverToDisplay = function(serverValue) {
			return '' + serverValue;
		};

		/**
		 * Stub. Does no conversion
		 * @param {string} formattedValue
		 * @return {int} serverValue
		 */
		this.displayToServer = function(formattedValue) {
			return parseInt(formattedValue);
		};
	}

	/**
	 * Gets the current min or the default min if the current is invalid
	 * @return {int|boolean} the min or false if the input was bad
	 */
	this.getMin = function() {
		var min = this.container.find('#min-' + uniqueInputKey + this.varName);
		if (!min.length) return false;
		return this.displayToServer(min.val());
	};

	/**
	 * Gets the current max or the default max if the current is invalid
	 * @return {int|boolean} the max
	 */
	this.getMax = function() {
		var max = this.container.find('#max-' + uniqueInputKey + this.varName);
		if (!max.length) return false;
		return this.displayToServer(max.val());
	};

	/**
	 * Sets the current min that's being displayed
	 * @param {int} min the min
	 */
	this.setMin = function(min) {
		$j('#min-' + uniqueInputKey + this.varName, this.container).val(this.serverToDisplay(min));
	};

	/**
	 * Sets the current max that's being displayed
	 * @param {int} max the max
	 */
	this.setMax = function(max) {
		$j('#max-' + uniqueInputKey + this.varName, this.container).val(this.serverToDisplay(max));
	};

	/**
	 * Tries to apply any changes to the min and max
	 * Does form validation to make sure they're both numbers
	 */
	this.applyChanges = function() {
		var min = this.getMin();
		var max = this.getMax();
		// do some validation
		$j('.error', this.container).html('');
		var error = false;
		if (min === false) {
			$j('.current_min span.error', this.container).html('Bad Value');
			error = true;
		}
		if (max === false) {
			$j('.current_max span.error', this.container).html('Bad Value');
			error = true;
		}
		if (max < min) {
			this.setMin(max);
			this.setMax(min);
		}
		if (!error) {
			reloadTrackList(true);
			reloadAlbumList();
		}
	};

	/**
	 * Resets the min and max to whatever was sent in with params
	 */
	this.reset = function() {
		$j('.error', this.container).html('');
		this.setMin(this.min);
		this.setMax(this.max);
	};

	/**
	 * Creates the elements within the component and adds their events
	 */
	this.show = function() {
		var t = this;
		var template = sa.components.leftNav.templates.get('range_component', { varName : uniqueInputKey + this.varName, minName : this.type == 'length' ? 'Min' : 'From', maxName : this.type == 'length' ? 'Max' : 'To' });
		var minInput = template.find('#min-' + uniqueInputKey + t.varName);
		var maxInput = template.find('#max-' + uniqueInputKey + t.varName);

		minInput.val(this.serverToDisplay(this.min));
		maxInput.val(this.serverToDisplay(this.max));

		template.find('.button').on('click', function() {
			t.applyChanges();
		});

		if (this.type == 'date') {
			minInput.datepicker({ dateFormat: config.datePickerDateFormatString });
			maxInput.datepicker({ dateFormat: config.datePickerDateFormatString });
		}

		sa.forms.init(template);

		this.container.append(template);
	};

	/**
	 * Initializes the component
	 */
	this.init = function() {
		this.show();
	};

	this.init();
}
/* eslint-disable */
sa.components.login = (function() {

	let login = {};
	let templates;
	const superadminLoginPath = location.href.includes('git-simplesamlphp2') ? 'https://music.sourceaudio.com/git-simplesamlphp2/superadmin_login.php' : 'https://music.sourceaudio.com/superadmin_login.php';

	let loginFocusBox;

	/** @var {LoginConfig} loginConfig */
	let loginConfig;

	// returned from login.show
	let eventEmitter = {};
	sa.eventify(eventEmitter);

	login.show = function(options) {

		options = $j.extend({
			whiteLabelAccount : false,
			callback : null,
			lightbox : true,
			loginAction : 'forward', // forwards the user on login to loginConfig.forward or 'reload' to just reload the current page
			cancelAction : 'forward', // forwards the user to loginConfig.forward or ('close' || 'login') to just close the box
			signupAction : 'forward', // forwards the user to loginConfig.signupPath or 'show' to just show the signup box here
			focusBoxOptions : {},
			showTitle : true
		}, options);

		sa.getLoginConfig(function(currentLoginConfig) {
			options.loginConfig = currentLoginConfig;
			showLoginForm(options);
		});

		return eventEmitter;
	};

	function showLoginForm(options) {

		var template = templates.get('login_page' + (options.loginConfig.disableEmailLogins ? '_without_email' : ''), {
			siteName : config.name,
			forward : ''
		});

		if (config.userAgreements.length) {
			template.find('#site_login_agreement_container .site_agreement_list').html(joinWithCommas(config.userAgreements.map(agreement => '<a target="_blank" href="' + agreement.url + '">' + htmlEncode(agreement.name) + '</a>')));
		} else {
			template.find('#site_login_agreement_container').remove();
		}

		loginConfig = options.loginConfig;

		// forgot password
		template.find('.forgot_password_link').on('click', function() {
			sa.components.forgotPassword.show();
		});

		// you can't sign up on licensee sites
		if (config.siteType == 'buyer' || !config.id || loginConfig.disableSignups) {
			template.find('.signup_button').remove();
		} else {
			let signupButton = template.find('.signup_button');
			if (options.signupAction === 'forward') {
				signupButton.prop('href', loginConfig.signupPath);
			} else {
				signupButton.on('click', function () {
					loginFocusBox.hide();
					sa.components.signup.show(options);
					return false;
				});
			}
		}

		// you can't skip login if the site requires registration
		let cancelButton = template.find('.cancel_button');
		if (loginConfig.requiresRegistration) {
			cancelButton.remove();
		} else if (options.cancelAction === 'forward') {
			cancelButton.prop('href', decodeURIComponent(loginConfig.forward));
		} else {
			cancelButton.on('click', function() {
				loginFocusBox.hide();
			});
		}

		// make the form work
		if (loginConfig.usernameLogins) {
			template.find('#login_email_input').prop('type', 'text');
		}
		sa.forms.init(template);
		checkForEnter(template.find('#login_email_input'), function() { setTimeout(function() { submitLoginForm(options); }, 100); });
		checkForEnter(template.find('#login_password_input'), function() { setTimeout(function() { submitLoginForm(options); }, 100); });
		template.find('.button.login').on('click', function() { submitLoginForm(options); });
		
		// superadmin check
		let showingSuperAdminButton = false;
		template.find('#login_email_input').on('input keyup change', function() {
			if (this.value.match(/^[a-z.]+@sourceaudio.com *$/i)) {
				if (!showingSuperAdminButton) {
					const forwardUrl = getForwardUrl();
					template.find('.button.login').before(templates.get('superadmin_login_button', {
						forwardWhiteId: config.id,
						forward: forwardUrl
					}));
					showingSuperAdminButton = true;
				}
			} else if (showingSuperAdminButton) {
				template.find('.superadmin_login').remove();
				showingSuperAdminButton = false;
			}
		});

		// customization
		if (options.whiteLabelAccount && (config['isPremiere'] || config.id == 469)) {
			template.find('label[for=login_email_input]').html('Email Address or Username');
		}

		// add the extra buttons
		addExternalLoginButtons(options, template.find('.external_login_options'), loginConfig.verb, template);

		// terms agreement
		sa.components.documentViewer.enableButtons(template);

		// show the logo, if they have one
		if (!options.whiteLabelAccount) {
			template.find('.logo_container').attr('href', 'https://www.sourceaudio.com/');
			template.find('.logo_image').attr('src', DefaultLogo);
		} else {
			let logo = config.theme.loginLogo.path;
			if (logo) {
				template.find('.logo_container').attr('href', 'https://' + config.domain + '/');
				template.find('.logo_image').attr('src', logo);
			} else {
				template.find('.logo_container').remove();
				template.find('#login_options').addClass('without_logo');
			}
		}
		
		if (config.id == 2570) {
			template.find('.logo_container').after('<div class="netflix_notice">This is NOT the Netflix streaming service site. To watch unlimited movies, TV shows, and more, visit <a href="https://netflix.com">Netflix.com</a></div>');
		}

		// show the background, if they have one
		if (options.whiteLabelAccount) {
			let background = config.theme.loginBackground.path;
			if (background) {
				$j('body').css({
					backgroundImage : "url('" + background + "')"
				});
			}
		}

		// display everything
		loginFocusBox = new FocusBox(template, $j.extend({
			lightbox : options.lightbox,
			title : options.showTitle ? (config.id == 2570 ? 'Log In To Netflix Internal Music' : 'Log In') : ''
		}, options.focusBoxOptions));
		loginFocusBox.show();
		loginFocusBox.getFocusedContainer().addClass('landing_page_container');

		// autofill isn't triggering input changes correctly
		setTimeout(function() {
			template.find('input').trigger('change');
		}, 1000);

		if (options.whiteLabelAccount) {
			trySsoLogin();
		}

		eventEmitter.triggerContinuously('show');

	}

	function submitLoginForm(options) {
		var fields = sa.forms.validate($j('.landing_page')).values;
		fields.forward = loginConfig.forward;
		fields.password = btoa(fields.password);
		sendLoginRequest(options, fields);
	}
	
	function getForwardUrl() {
		const currentUrl = document.location.href;
		
		// If we're on the login.php or signup.php pages, we want to check for an existing forward
		if (currentUrl.includes('login.php') || currentUrl.includes('signup.php')) {
			if (loginConfig.forward) {
				return loginConfig.forward;
			}
			
			const urlParams = new URLSearchParams(window.location.search);
			const forwardUrl = urlParams.get('forward');
			if (forwardUrl) {
				return encodeURIComponent(forwardUrl);
			}
		}
		
		return encodeURIComponent(currentUrl);
	}

	function handleLogin(options) {
		if (options.callback) {
			options.callback();
		}
		if (options.loginAction === 'forward') {
			document.location.href = decodeURIComponent(loginConfig.forward);
		} else {
			document.location.reload();
		}
	}

	function sendLoginRequest(options, fields) {
		hideLoginError();
		loginFocusBox.showLoader('Processing your login');
		if (window['user'] && user['disableVerification']) {
			user.disableVerification();
		}
		ajax(fields, function(response) {
			if (window['user'] && user['enableVerification']) {
				user.enableVerification();
			}
			if (response['logged']) {
				handleLogin(options);
				return;
			} else if (response['passwordResetRequired']) {
				showLoginError(options, 'password_reset_required');
			} else if (response['loginFailed']) {
				showLoginError(options, 'password_recovery_message');
			} else if (response['tooManyFailed']) {
				showLoginError(options, 'too_many_failed_logins_message');
			} else if (response['headerMissing']) {
				showLoginError(options, 'header_missing');
			} else if (response['unverifiedEmail']) {
				showLoginError(options, 'unverified_user_message', { message : response['message'] }, fields);
			} else if (response['pendingDelete']) {
				showLoginError(options, 'pending_delete_message', { message : response['message'] }, fields);
			} else if (response['employee']) {
				showLoginError(options, 'employee_message', {}, fields);
				document.location.href = superadminLoginPath + '?forward=' + loginConfig.forward + '&forwardWhiteId=' + config.id;
			} else if (response['result']) {
				sa.alert(response['result']);
			}
			if (response['showDocument']) {
				sa.components.documentViewer.show(response['showDocument']);
			}
			loginFocusBox.hideLoader();
		}, 'POST', { p : 'login', action : 'login' }, { 'X-SA-Login' : sa.cookies.get('sa_user_temp') });

	}

	function showLoginError(options, templateName, templateVars, fields) {
		var errorTemplate = templates.get(templateName, templateVars);

		errorTemplate.find('.password_recovery').on('click', function() {
			sa.components.forgotPassword.show();
		});

		errorTemplate.find('.resend_verification').on('click', function() {
			fields.resendVerification = 1;
			sendLoginRequest(options, fields);
		});

		if (templateVars) {
			for (var f in templateVars) {
				if (!templateVars.hasOwnProperty(f)) continue;
				errorTemplate.find(f).html(templateVars[f]);
			}
		}

		loginFocusBox.showErrorMessage(errorTemplate);
	}

	function hideLoginError() {
		loginFocusBox.hideErrorMessage();
	}

	function trySsoLogin() {
		if (!loginConfig.ssoVars) return;

		var vars = $j.extend({}, loginConfig.ssoVars);
		if (!vars.returning && document.location.href.indexOf('idp=11&returning=1') !== -1) {
			vars.returning = 1;
		}
		ajax(vars, function(response) {
			// this should respond with an ajax forward to either log them in immediately or send them to signup
			if (response['result']) {
				sa.alert(response['result']);
			}
		}, 'POST', { p : 'login', action : 'ssoLogin', source : 'login' });

	}

	function addExternalLoginButtons(options, externalButtons, verb, fullContainer) {
		
		let cookieButton = externalButtons.find('.cookie_button, .cookie_button_instructions');
		cookieButton.on('click', function(e) {
			e.preventDefault();
			sa.components.cookieManager.showCustomizer();
			return false;
		});
		
		sa.cookies.on(sa.cookieTypes.login, function f() {
			sa.cookies.off(sa.cookieTypes.login, f);
			cookieButton.remove();
			externalButtons.find('.cookie_button_instructions').remove();

			if (loginConfig.idps && loginConfig.idps.length) {
				loginConfig.idps.each(function (i, idpData) {
					var buttonTemplate;
					if (idpData['buttonUrl']) {
						buttonTemplate = templates.get('saml_idp_button_' + idpData.id, {
							url : idpData['buttonUrl'],
							verb : verb
						});
					} else {
						buttonTemplate = templates.get('saml_idp_button_' + idpData.id, {
							url : 'https://' + config.domain,
							verb : verb
						});
						buttonTemplate.on('click', function () {
							ajax({
								idp : idpData.id,
								forward : loginConfig.forward,
								ssoType : 'idp',
								returning : (idpData.id == 11 && document.location.href.indexOf('returning=1')) ? 1 : ''
							}, function (response) {
								if (response['logged']) {
									document.location.href = decodeURIComponent(loginConfig.forward);
								} else if (response['result']) {
									sa.alert(response['result']);
								}
							}, 'POST', { p : 'login', action : 'ssoLogin', 'ajax' : 1, source : 'login' });
							return false;
						});
					}
					externalButtons.append(buttonTemplate);
				});
			}
			if (loginConfig.jwtButtonVars) {
				loginConfig.jwtButtonVars.verb = loginConfig.verb;
				loginConfig.jwtButtonVars.page = 'login.php';
				if (loginConfig.jwtButtonVars.letter) {
					loginConfig.jwtButtonVars.letter = htmlDecode(loginConfig.jwtButtonVars.letter);
				}
				externalButtons.append(templates.get('jwt_button', loginConfig.jwtButtonVars));
			} else if (loginConfig.ssoButton) {
				loginConfig.ssoButtonVars.verb = verb;
				loginConfig.ssoButtonVars.page = 'login.php';
				externalButtons.append(templates.get('sso_button_' + config.id, loginConfig.ssoButtonVars));
			}
			if (loginConfig.oAuthButtons.length) {
				loginConfig.oAuthButtons.each(function (i, oAuthButton) {
					externalButtons.append(templates.get('oauth_button', {
						verb : loginConfig.verb,
						href : oAuthButton.href,
						name : oAuthButton.theme.name.text,
						nameBackgroundColor : '#' + oAuthButton.theme.name.backgroundColor,
						nameTextColor : '#' + oAuthButton.theme.name.textColor,
						char : oAuthButton.theme.char.text,
						charBackgroundColor : '#' + oAuthButton.theme.char.backgroundColor,
						charTextColor : '#' + oAuthButton.theme.char.textColor
					}))
				});
			}

			// generic sso button for the adobe panel
			if (BrowserDetect.isAdobePanel) {
				externalButtons.append(templates.get('sso_button_adobe').on('click', function (e) {
					e.preventDefault();
					let ssoTemplate = templates.get('adobe_sso_entry');
					ssoTemplate.find('#adobe_normal_browser').on('click', function() {
						window.cep.util.openURLInDefaultBrowser('https://account.sourceaudio.com/blanker.php');
					});
					sa.forms.init(ssoTemplate);
					ssoTemplate.find('#adobe_example_toggle').on('click', function () {
						let img = ssoTemplate.find('#adobe_example_image');
						if (img.hasClass('hidden')) {
							img.removeClass('hidden');
						} else {
							img.addClass('hidden');
						}
					});
					ssoTemplate.find('#adobe_sso_login_button').on('click', function () {
						sa.api.request({
							handler : 'account',
							action : 'useAdobeLoginCode',
							postData : {
								code : ssoTemplate.find('#adobe_sso_input').val()
							}
						}).then(function () {
							document.location.reload();
						}).catch(function (e) {
							sa.alert({ text : e.message });
						});
					});
					let fb = new FocusBox(ssoTemplate, { title : 'Adobe Panel Login' });
					fb.show();
					return false;
				}));
			}

			if (!BrowserDetect.isAdobePanel && loginConfig.showFacebook && config.id != 0) {
				sa.components.facebookLogin.show({
					container : externalButtons,
					loginConfig : loginConfig,
					loginCallback : function () {
						handleLogin(options);
					}
				});
			}

			var childNodes = externalButtons[0].childNodes;
			if (!childNodes.length) {
				// calling hide and remove makes sure the buttons won't be visible no matter whether or externalButtons has been attached
				externalButtons.hide().remove();
			}
			
		});

		if (config.id == 0) {
			fullContainer.find('.button.login, .or_container, .login_form').remove();
		} else {
			fullContainer.find('.sa_name').on('dblclick', () => {
				// get the current page url
				const forwardingUrl = getForwardUrl();
				document.location.href = superadminLoginPath + '?forward=' + forwardingUrl + '&forwardWhiteId=' + config.id;
			});
		}
	}

	login.build = function() {
		templates = sa.templates.get('pages.login');
	};

	return login;

})();
sa.components.mobile_menu = (function () {
	// Clone the music access profile button
	const menu = {
		attachOnLoad: true,
	};

	let container;
	let $foldersDiv; let 
		$cueSheetsDiv;

	let attached = false;

	let rerenderNextMobile = false;

	// Render playlists into menu
	function renderPlaylists(filter = false) {
		// console.time("- mobilemenu render playlists")
		$foldersDiv.find('.folder').remove();

		user.projectFolders.forEach((folder) => {
			folderAppender(folder, $foldersDiv, filter);
		});
		// console.timeEnd("- mobilemenu render playlists")

	}
	const folderAppender = function (folder, $parent, filter = false) {
		let folderStr = folder.name;
		let projects = _.filter(sa.components.projector.sortedProjects, { folderId: folder.id });

		if (filter) {
			projects = projects.filter(p => {
				return p.name.toLowerCase().indexOf(filter.toLowerCase()) != -1;
			});
		}
		if (!projects.length && !(folder.subfolders && folder.subfolders.length)) {
			return;
		}

		if (projects && projects.length) {
			folderStr += ' (' + projects.length + ')';
		}
		const $folderDiv = $j('<li class="folder"><a href="#"><i class="fa fa-folder"></i>' + folderStr + '</a></li>');
		$parent.append($folderDiv);
		// Render subfolders
		if (folder.subfolders && folder.subfolders.length) {
			const $newListWrapper = $j('<ul></ul>');
			folder.subfolders.forEach((f) => {
				folderAppender(f, $newListWrapper);
			});
			$folderDiv.append($newListWrapper);
		}
		// Render projects
		// Get projects for folder
		if (projects && projects.length) {
			const $projects = $j('<ul class="projects"></ul>');
			const baseUrl = siteBaseUrl();
			projects.forEach((proj) => {
				$projects.append('<li class="project"><a href="' + baseUrl + '/playlist/' + proj.id + '"><i class="fa fa-th-list"></i>' + proj.name + ' (' + proj.totalTrackCount + ')</a></li>');
			});
			$folderDiv.append($projects);
		}

	};

	// Render cue sheets into menu
	function renderCueSheets() {
		// console.time("- mobilemenu render cuesheets")
		if (!config.showCueSheets) {
			container.find('.cue_sheets').remove();
			return;
		}

		$cueSheetsDiv.find('.cue_sheet').remove();
		const baseUrl = siteBaseUrl();
		user.cueSheets.forEach((cue) => {
			// https://ryaudio.sourceaudio.com/git-mrj-r/cue-sheet/53057
			$cueSheetsDiv.append('<li class="cue_sheet"><a href="' + baseUrl + '/cue-sheet/' + cue.id + '"><i class="fa fa-file-text-o"></i>' + cue.name + ' (' + cue.trackCount + ')</a></li>');
		});
		// console.timeEnd("- mobilemenu render cuesheets")

	}

	function renderMusicAccessProfiles() {
		// console.time("- mobilemenu render music access profiles")

		// Music access profile selector
		const $profileSelector = sa.components.permissionProfileSelector.generateProfileSelectorDropdown();
		if ($profileSelector) {
			container.find('.music_access_profiles .profiles').remove();

			// Convert selector to list
			const $options = $profileSelector.find('option');
			const $profileList = $j('<ul class="profiles"></ul>');
			$options.each(function () {
				const $option = $j(this);
				if ($option.attr('selected')) {
					$option.text($option.text() + ' (Current)');
				}
				var $profile = $j('<li ' + ($option.attr('selected') ? 'data-nav-active' : '') + '><a href="#" data-value="' + $option.attr('value') + '">' + $option.text() + '</a></li>');
				if ($option.attr('selected')) {
					$profile.find('a').attr('data-selected', true);
				}
				var $profile = $j('<li ' + ($option.attr('selected') ? 'data-nav-active' : '') + '><a href="#" data-selected="' + ($option.attr('selected') ? 'true' : 'false') + '" data-value="' + $option.attr('value') + '">' + $option.text() + '</a></li>');
				$profile.find('a').on('click', function (e) {
					console.log('target', e.target);
					const val = $j(this).data('value');
					console.log('**** setting user profile to', val);
					const currentSelected = $profileList.find('a[data-selected="true"]');
					currentSelected.attr('data-selected', false).text(currentSelected.text().slice(0, -10));
					const toBeSelected = $profileList.find('a[data-value="' + val + '"]');
					console.log('current selected', currentSelected, 'to be selected', toBeSelected);
					toBeSelected.attr('data-selected', true).text(toBeSelected.text() + ' (Current)');
					console.log('set current', toBeSelected, toBeSelected.text(), toBeSelected.attr('data-selected'));
					menu.nav.update(true);
					menu.setStyle();
					user.setActivePermissionProfile($j(this).data('value'));

				});
				$profileList.append($profile);
			});

			container.find('.music_access_profiles').append($profileList);
		} else {
			container.find('.music_access_profiles').remove();
		}
		// console.timeEnd("- mobilemenu render music access profiles")

	}

	menu.build = function () {
		templates = sa.templates.get('components.mobile_menu');
		container = templates.get('mobile_menu', {
			baseUrl: siteBaseUrl(),
			inboxType: config.siteType !== 'buyer' ? 'admin?p=inbox' : 'dashboard?p=inbox',
		});
		$foldersDiv = container.find('.playlists .folders');
		$cueSheetsDiv = container.find('.cue_sheets ul');
		
		menu.buildInbox();
	};
	
	menu.buildInbox = function () {
		if (!BrowserDetect.isMobile()) return;
		
		if (!user.logged) {
			container.find('#inbox_link').remove();
			return;
		}

		if (config.siteType === 'seller') {
			if (!user.hasAdminPermission(AdminPermission.Any)) {
				container.find('#inbox_link').remove();
				return;
			}
		} else if (config.siteType !== 'buyer' && config.siteType !== 'network') {
			container.find('#inbox_link').remove();
			return;
		}

		let pollDelay = 60000; // Start with 1 minute
		let maxDelay = 600000; // Max out at 10 minutes
		let currentTimeout = null;

		function pollUnreadCount() {
			// Get the unread count
			sa.api.request({
				handler: 'Inbox/Inbox',
				action: 'getUnreadCount'
			}).then(function (r) {
				if (r && r.unreadCount >= 0) {
					pollDelay = 60000; // Reset to 1 minute on success
					if (r.unreadCount > 99) r.unreadCount = '99+';

					// Add the count to the inbox link
					// Check if message element is still in the DOM 
					let inboxLink = container.find('#inbox_link');

					if (r.unreadCount <= 0) {
						inboxLink.find('.message-count').remove();
						return;
					}

					if (!container.find('#inbox_link .message-count').length) {
						inboxLink.append(`<span class="message-count">${r.unreadCount}</span>`);
					} else {
						inboxLink.find('.message-count').text(r.unreadCount);
					}
				} else {
					console.warn('Polling for inbox count failed', r);
					pollDelay = Math.min(pollDelay * 2, maxDelay); // Exponential backoff
				}
				// Check if this timeout already exists, and if not, create it
				if (currentTimeout) clearTimeout(currentTimeout);
				currentTimeout = setTimeout(pollUnreadCount, pollDelay);
			});
		}
		pollUnreadCount();

		window.eventBus.on('inbox-updated', () => pollUnreadCount());
	};

	menu.attach = function () {
		if (attached) return;

		// Respond to app changes
		sa.on('routeChange', () => { menu.hide(); });
		sa.on('start', () => {
			rerenderDebounced('first load');
		});
		
		sa.on('view_mobile', () => {
			$j('#top_bar #user_image_container').off('click.mobile_menu').on('click.mobile_menu', (e) => {
				e.stopPropagation();
				menu.showOrHide();
				return false;
			});

			if (rerenderNextMobile) {
				rerenderNextMobile = false;
				rerenderDebounced('desktop changes');
			}
		});

		sa.on('view_desktop', () => {
			$j('#top_bar #user_image_container').off('click.mobile_menu');
		});

		sa.on('permissionprofiles_reload', () => {
			rerenderDebounced('permission profiles reload');
		});
		sa.on('cuesheets_reload', () => {
			rerenderDebounced('cuesheets reload');
		});
		sa.on('projects_reload', () => {
			rerenderDebounced('playlists reload');
		});

		user.onLoad(() => {
			if (!user || !user.logged) return;

			// Remove admin link if necessary
			if (!user.hasAdminPermission(AdminPermission.Any)) {
				container.find('#admin_link').closest('li').remove();
			}

			// Logout link
			container.find('#logout_link').attr('href', sa.components.topBar.getLogoutPath());

			// Bind new playlist click
			$foldersDiv.find('.new_playlist').on('click', (e) => {
				e.preventDefault();

				if (!user.logged) {
					return sa.notify({ text: 'You must be logged in to use this feature.' });
				}
				menu.nav.close();
				sa.components.projector.showNewProjectBox(false, () => {
					menu.rerender();
				});
			});

			// Bind new playlist folder click
			$foldersDiv.find('.new_folder').on('click', (e) => {
				e.preventDefault();

				if (!user.logged) {
					return sa.notify({ text: 'You must be logged in to use this feature.' });
				}
				sa.components.projector.showNewProjectBox(true, () => {
					menu.rerender();
				});
			});

			// bind new ai playlist click
			if (!config.showAIPlaylists) {
				$foldersDiv.find('.new_ai_playlist').hide();
			} else {
				$foldersDiv.find('.new_ai_playlist').on('click', (e) => {
					e.preventDefault();
					if (lockdown) {
						return sa.showLockdownMessage();
					}
					if (!user.logged) {
						return sa.notify({ text: 'You must be logged in to use this feature.' });
					}
					const aiModal = new AIPlaylistModal();
					aiModal.init();
				});
			}

			// Bind playlist search
			$foldersDiv.find('.search').on('input', _.debounce((e) => {
				renderPlaylists(e.target.value);
				menu.nav.update(true);
				menu.setStyle();
				$j('nav.mobile_menu .folders .search').focus().val(e.target.value);
			}, 250));

			// bind new cue sheet click

			$cueSheetsDiv.find('.new_cuesheet').on('click', (e) => {
				e.preventDefault();
				if (lockdown) {
					return sa.showLockdownMessage();
				}
				if (!user.logged) {
					return sa.notify({ text: 'You must be logged in to use this feature.' });
				}
				sa.components.cueSheeter.showNewCueSheetBox(() => {
					menu.rerender();
				});
			});

			// Generate the menu
			container.hcOffcanvasNav({
				disableAt: 1024,
				// navTitle: 'Main Menu',
				levelTitles: true,
				position: 'right',
				swipeGestures: false,
				navClass: 'mobile_menu'
				// levelOpen: 'expand',
				// levelTitleAsBack: true
			});
			menu.nav = container.data('hcOffcanvasNav');
			rerenderDebounced('load');
		});

		attached = true;
	};

	menu.setStyle = function () {
		// console.time("- mobilemenu render styles")
		const topBarBackground = $j('#top_bar').css('background');
		const borderColor = pSBC(0.2, topBarBackground);
		// darkened background
		const topMenuBackground = pSBC(-0.2, topBarBackground);
		const topBarTextColor = $j('#top_bar').css('color');
		// Colors

		$j('nav.mobile_menu .nav-item, nav.mobile_menu .nav-item-link').css({
			color: topBarTextColor
		});
		$j('nav.mobile_menu .nav-container, nav.mobile_menu .nav-wrapper, nav.mobile_menu ul').css({
			background: topBarBackground,
			color: topBarTextColor,
		});

		// Top bar
		$j('nav.mobile_menu .nav-content>.nav-close:first-child a, nav.mobile_menu .nav-title+.nav-close a.has-label, nav.mobile_menu li.nav-close a, nav.mobile_menu .nav-back a').css({
			background: topMenuBackground
		});

		// Borders of links
		$j('nav.mobile_menu .nav-wrapper>.nav-content>ul:first-of-type>li:first-child:not(.nav-back):not(.nav-close)>.nav-item-wrapper>.nav-item-link').css({
			borderTop: '1px solid ' + borderColor
		});

		$j('nav.mobile_menu .nav-back a').css({
			borderTop: '1px solid ' + borderColor,
			borderBottom: '1px solid ' + borderColor,
		});

		$j('nav.mobile_menu .nav-item-link, nav.mobile_menu li.nav-close a, nav.mobile_menu .nav-back a').css({
			borderBottom: '1px solid ' + borderColor,
		});

		// text color
		$j('nav.mobile_menu .nav-content>h2, nav.mobile_menu .nav-content>h3, nav.mobile_menu .nav-content>h4, nav.mobile_menu .nav-content>h5, nav.mobile_menu .nav-content>h6').css({
			color: topBarTextColor
		});

		$j('nav.mobile_menu:not(.touch-device) li:not(.nav-item-custom) a:not([disabled]):hover').off('mouseover.mobilemenu').off('mouseout.mobilemenu').on('mouseover.mobilemenu', function () { // using "on" for optimization
			this.style.background = borderColor; // native JS application
		})
			.on('mouseout.mobilemenu', function () { // chain to avoid second selector call
				this.style.background = topBarBackground; // native JS application
			});

		// $j('nav.mobile_menu .nav-content .nav-close').append('<div class="user_image fas fa-user-circle"><img src="//secure.sourceaudio.com/images/shared/default_editor6.jpg" alt="user image" /></div>')
		$j('nav.mobile_menu .nav-content .nav-close').prepend(templates.get('top_bar', {
			username: _.get(user, 'userData.username', ''),
		}));

		if (user.userData.image && user.userData.image.indexOf('default_editor') === -1) {
			$j('nav.mobile_menu .user_image').removeClass('fas fa-user-circle').append('<img src="' + user.userData.image + '" alt="user image" />');
		}

		// console.timeEnd("- mobilemenu render styles")

	};

	menu.detach = function () {
		if (!attached) return;
		console.log('detached mobile_menu');

		attached = false;

	};
	menu.rerender = function (reason = '') {
		if (!menu.nav) return;
		if (!sa.isMobile()) {
			// if we aren't mobile, then don't render now, but do
			// note that we need to rerender because of changes
			// when we *are* mobile
			rerenderNextMobile = true;

			return;
		}
		// if (reason) console.log("rerendering mobile menu because of", reason)

		// console.time('- mobilemenu rerender')
		renderPlaylists();
		renderCueSheets();
		renderMusicAccessProfiles();
		menu.nav.update(true);
		menu.setStyle();
		// console.timeEnd('- mobilemenu rerender')

	};

	// Rerender when playlists, cuesheets or permission profiles change.  
	// Debounce so it only gets called once on load or when these things happen close together
	const rerenderDebounced = _.debounce((reason) => {
		menu.rerender(reason);
	}, 1000);

	menu.showOrHide = function () {
		if (menu.nav.isOpen()) {
			menu.hide();
		} else {
			menu.show();
		}
	};
	menu.show = function () {
		if (menu.nav) {
			// menu.rerender(); // just to make sure playlists and cuesheets have the right numbers
			menu.nav.open();
		}
	};

	menu.hide = function () {
		if (menu.nav) {
			menu.nav.close();
		}
	};

	// Color darkener/lightener, etc.
	// https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
	// Version 4.0
	const pSBC = (p, c0, c1, l) => {
		let r; let g; let b; let P; let f; let t; let h; const i = parseInt; const m = Math.round; let 
			a = typeof (c1) === 'string';
		if (typeof (p) !== 'number' || p < -1 || p > 1 || typeof (c0) !== 'string' || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
		if (!this.pSBCr) {
			this.pSBCr = (d) => {
				let n = d.length; const 
					x = {};
				if (n > 9) {
					[r, g, b, a] = d = d.split(','), n = d.length;
					if (n < 3 || n > 4) return null;
					x.r = i(r[3] == 'a' ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1;
				} else {
					if (n == 8 || n == 6 || n < 4) return null;
					if (n < 6) d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : '');
					d = i(d.slice(1), 16);
					if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
					else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
				} return x;
			}; 
		}
		h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == 'c' ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != 'c' ? this.pSBCr(c1) : P ? {
			r: 0, g: 0, b: 0, a: -1 
		} : {
			r: 255, g: 255, b: 255, a: -1 
		}, p = P ? p * -1 : p, P = 1 - p;
		if (!f || !t) return null;
		if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
		else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
		a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
		if (h) return 'rgb' + (f ? 'a(' : '(') + r + ',' + g + ',' + b + (f ? ',' + m(a * 1000) / 1000 : '') + ')';
		return '#' + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
	};

	return menu;
}());

sa.components.nav = (function() {

	var nav = {
		attachOnLoad : true
	};
	var navContainer;
	var hidden = false;

	nav.tabs = [];

	nav.reset = function() {
		navContainer.find('a').removeClass('selected');
	};

	/**
	 * Updates the nav to highlight the passed in page
	 * @param {Array} pages the pages you want to highlight. This parameter may also be a string, only highlighting that page
	 * 	IMPORTANT: the most specific page should be sent in first to avoid duplicate highlights
	 */
	nav.focusPage = function(pages) {
		if (!pages.isArray) {
			pages = [pages];
		}
		
		nav.setActiveTab(pages);
	};
	
	nav.setActiveTab = function(pages) {
		if (!pages.length) return;
		
		// Get the current page's URL
		let currentUrl = new URL(window.location.href);
		currentUrl.pathname = sa.router.removeDevPathFragment(currentUrl.pathname);
		
		// Filter through tabs, looking for exact matches
		let tabExactMatch = nav.tabs.find(tab => {
			return sa.router.isSameUrl(tab.path, currentUrl.href);
		});

		let tabParamMatch = nav.tabs.find(tab => {
			let tabUrl = sa.router.buildFullUrl(tab.path);

			let samePathname = tabUrl.pathname === currentUrl.pathname;
			let bothHaveTabParam = tabUrl.searchParams.has('tab') && currentUrl.searchParams.has('tab');
			let haveMatchingTabIds = bothHaveTabParam ? tabUrl.searchParams.get('tab') === currentUrl.searchParams.get('tab') : false;

			return samePathname && haveMatchingTabIds;
		});
		
		let tab = nav.tabs.find(tab => {
			// Split tab path into path and params
			let [path, _] = tab.path.split('?');
			
			// Paths Match
			let cleanTabPath = path.replace(/^\//, '').replace(/\/$/, '');
			let cleanPathname = currentUrl.pathname.replace(/^\//, '').replace(/\/$/, '');
			if (cleanTabPath === cleanPathname) return true;
			
			// Finally, check if the tab includes, even in part, the path
			return tab.path.includes(currentUrl.pathname.replace(/^\//, ''));
		});

		// Check if the tab url is an exact match or a param match
		// Otherwise, just use the regular tab info
		if (tabExactMatch) {
			tab = tabExactMatch;
		} else if (tabParamMatch) {
			tab = tabParamMatch;
		}
		
		if (tab) {
			//console.log(tab);
			navContainer.find('.selected').removeClass('selected');
			navContainer.find('#' + tab.id).addClass('selected');
		//} else {
			//console.log('No tab found. None set to active.');
		}
		
	};

	/**
	 * Sets a new alignment for the tabs in the nav. Persists for session but doesn't save to server
	 * @param {string} alignment
	 */
	nav.alignNav = function (alignment) {
		config.theme.navAlignment = alignment;
		nav.build();
		nav.attach();
		nav.resize();
	};

	nav.show = function() {
		if (hidden) {
			navContainer.removeClass('hidden');
			$j('body').removeClass('without_nav');
			hidden = false;
		}
	};

	nav.hide = function() {
		navContainer.addClass('hidden');
		$j('body').addClass('without_nav');
		hidden = true;
	};

	nav.calculateTabWidths = function () {
		let tabsWidth = 0;
		navContainer.find('a.nav_item').each(function () {
			tabsWidth += $j(this).outerWidth();
		});

		if (!navContainer.hasClass('center-aligned')) return;

		if ((navContainer.width() < tabsWidth) || Math.ceil(tabsWidth) > 1600) {
			navContainer.css('display', 'flex');
			navContainer.find('.narrow-nav a').unwrap();
			navContainer.removeClass('alignment-override');
			return;
		}

		if ($j('.narrow-nav').length) return;
		navContainer.children().wrapAll('<div class="narrow-nav"></div>');

		$j('.narrow-nav').css({
			display: 'flex',
			justifyContent: 'space-evenly',
			width: '1600px'
		});
	};

	nav.attach = function() {
		$j('#' + navContainer.attr('id')).remove();
		
		$j('body').append(navContainer);

		nav.calculateTabWidths();

		sa.on('resize', function() {
			nav.resize();
			nav.calculateTabWidths();
		});

		sa.on('beforeRouteChange', function() {
			nav.reset();
			nav.show();
		});

		sa.on('routeChange', function(e, data) {
			nav.focusPage([data.route.name, sa.getCurrentPageName()]);
		});
	};
	
	nav.build = function() {
		let templates = sa.templates.get('nav');
		navContainer = templates.get('nav');
		nav.tabs = config.tabs.slice();
		nav.tabs = nav.tabs.map(tab => {
			const isSameDomain = sa.router.urlsHaveSameHost(tab.hash, window.location.href);
			
			if (!isSameDomain) {
				tab.path = tab.hash;
				return tab;
			}
			
			let path;
			let params;

			let tabSplit = tab.hash.split('?');
			path = tabSplit[0];
			params = tabSplit.length > 1 ? tabSplit[1] : path;
			
			tab.hash = sa.router.pathConversionLookup(tab.hash);
			tab.path = tab.hash;
			
			tab.uniqueId = tab.path;

			const replacementRegex = /[^a-zA-Z\d+_-]/g;
			
			tab.uniqueId = tab.uniqueId.replace(replacementRegex, '');
			
			return tab;
		});
		
		navContainer.removeClass(['left-aligned', 'center-aligned', 'right-aligned']);
		if (!config.theme.navAlignment) {
			navContainer.addClass('left-aligned');
		} else {
			navContainer.addClass(`${config.theme.navAlignment}-aligned`);
		}

		for (let n = nav.tabs.length - 1; n >= 0; n--) {
			let tab = nav.tabs[n];
			let href = tab.path;
			// href = sa.router.getPathTo(href).href;
			
			let target = '_self';
			if (href.indexOf('http') === 0) {
				tab.id = 'nav_extenal';
				target = '_blank';
			} else {
				const replacementRegex = /[^a-zA-Z\d+_-]/g;
				
				tab.id = 'nav_' + tab.path.replace(replacementRegex, '');
			}
			
			const baseUrl = siteBaseUrl();
			
			if (!href.includes('http')) {
				href = baseUrl + ('/' + href).replace(/[\/]{2,}/g, '/');
			}
			
			// Make sure the href (and more importantly, the search query params, are properly formatted/encoded)
			href = (new URL(href)).toString();
			
			navContainer.prepend(templates.get('nav_tab', {
				href: href,
				target: target,
				text: tab.text,
				id: tab.id
			}));
		}

		// Add tab browsing on mobile
		new TabBrowseButtons(navContainer, '.nav_item');
	};

	/**
	 * Nav items shrink font and padding depending on the screen width
	 */
	nav.resize = debounce(function () {
		const navItems = navContainer.find('.nav_item');
		if (!navItems.length) return;
		
		const lastNavItem = $j(navItems[navItems.length - 1]);
		// we don't want to resize when the left nav shows and hides so we just pad to make it effectively there even when it's not
		// sometimes this function is called mid-animation so we need to know the actual size at this moment to determine the right padding
		const leftNavWidth = $j('#left_nav').width();
		const currentLeftPosition = parseInt(window.getComputedStyle(navContainer[0]).left);
		if (currentLeftPosition < leftNavWidth) {
			navContainer.css('padding-right', leftNavWidth - currentLeftPosition);
		}

		// mathing the float falloff of the last item would be complicated, if not impossible, bc of the effect of font size
		// so instead we shrink one font size and one padding px at a time until the last item's top is 0 or we hit certain usability mins
		navItems.css({ fontSize : '', paddingLeft : '', paddingRight : '' });
		// the tab_browse class interferes with the above-mentioned float falloff so we have to temporarily remove it for this to work
		const tabBrowse = navItems.hasClass('tab_browse');
		if (tabBrowse) {
			navItems.removeClass('tab_browse');
			navContainer.removeClass('tab_browse_container');
		}

		// this is checking that items are wrapping around onto another line
		let lastNavItemTop = lastNavItem.position().top;
		if (lastNavItemTop > 0) {
			const computedStyles = window.getComputedStyle(lastNavItem[0]);
			const minFontSize = 14;
			const minPadding = 10;
			let currentFontSize = parseInt(computedStyles.fontSize);
			let currentPadding = parseInt(computedStyles.paddingLeft);
			for (let i = 0; lastNavItemTop > 0 && (currentFontSize > minFontSize || currentPadding > minPadding); i++) {
				if (currentFontSize > minFontSize && i % 2) { // the i % 2 creates an alternation between font and padding reduction
					currentFontSize--;
				} else {
					currentPadding--;
				}
				
				navItems.css({ fontSize : currentFontSize + 'px', paddingLeft : currentPadding + 'px', paddingRight : currentPadding + 'px' });
				lastNavItemTop = lastNavItem.position().top;
			}
		}
		navContainer.css('padding-right', '');
		if (tabBrowse) {
			navItems.addClass('tab_browse');
			navContainer.addClass('tab_browse_container');
			navContainer.addClass('alignment-override');
		} else {
			navContainer.removeClass('alignment-override');
		}
	}, 500);

	return nav;
})();

sa.components.nester = (function() {
	
	var nester = {
		attachOnLoad : true
	};
	
	var templates;
	/** @var {JQuery} */
	var container;
	/** @var {Track|null} */
	var track = null;
	
	/**
	 * Are we in nesting mode?
	 * @return {boolean} are we?
	 */
	nester.inNestingMode = function() {
		return !!track;
	};
	
	/**
	 * Turns the nester on if it's off and off it's own
	 * @param {Track} newTrack the track to nest under if we're turning on
	 */
	nester.swap = function(newTrack) {
		if (track && track.id == newTrack.id) {
			nester.disable();
		} else {
			enable(newTrack);
		}
	};
	
	/**
	 * Turns the nester off, hiding all the buttons
	 */
	nester.disable = function() {
		if (track !== null) {
			track = null;
			handleNesterChange();
			sa.requestCache.clear();
			sa.router.reloadPage();
		}
	};
	
	/**
	 * Turns the nester on, showing buttons everywhere
	 * @param {Track} newTrack the track to nest under
	 */
	function enable(newTrack) {
		if (sa.components.projector.inQuickProjectMode()) {
			sa.components.projector.disableQuickProjectMode();
		}
		if (sa.components.cueSheeter.inQuickCueSheetMode()) {
			sa.components.cueSheeter.disableQuickCueSheetMode();
		}
		if (track) {
			nester.disable();
		}
		track = newTrack;
		handleNesterChange();
	}
	
	/**
	 * Does everything you need to do once you've enabled or disabled nester
	 */
	function handleNesterChange() {
		// enable the buttons on the track lists
		getTrackList().disableNesters();
		if (track) {
			getTrackList().enableNesters();
		}
		// enable the button on the details page
		if (sa.getCurrentPageName() == 'details') {
			if (track) {
				sa.pages.details.enableNesters();
			} else {
				sa.pages.details.disableNesters();
			}
		}
		// set up the quick project bar
		if (track) {
			sa.components.quickProjectBar.startMoving(container);
			container.find('.project_name').attr('href', getTrackLink(track.id)).html(track.title);
			container.addClass('showing');
			$j('body').addClass('with_quick_project_bar');
		} else {
			$j('body').removeClass('with_quick_project_bar');
			container.removeClass('showing');
			sa.components.quickProjectBar.stopMoving(container);
		}
	}
	
	/**
	 * Actually calls the server to update nested status
	 * @param {int} toNestId the id of the track to be nested under this.track
	 * @param {boolean} nest should the toNestId be nested under track or not?
	 */
	function nest(toNestId, nest) {
		ajax({ master : (nest ? track.id : toNestId) }, function(response) {
			sa.notify({ text : response[0].result });
		}, 'POST', { p : 'track_details', t : toNestId });
		// we should change the button they clicked so they get some instant feedback
		if (nest) {
			$j('.quick_project_track_button_' + toNestId).addClass('has_projects');
		} else {
			$j('.quick_project_track_button_' + toNestId).removeClass('has_projects');
		}
	}
	
	/**
	 * Creates a button that will show the nested status and do the nesting
	 * @param {int} toNestId the id of the track to be nested under this.track
	 * @return {JQuery} the button
	 */
	nester.generateButton = function(toNestId) {
		var toNest = trackBank.find(toNestId);
		if (!toNest) return $j(); // this can happen if you go into add more with an empty project open
		var nested = toNest.masterId == track.id;
		// we don't want a button for the track itself
		if (toNest.id == track.id) return $j();
		// also, nesting rules require the tracks be in the same album and label
		if (toNest.catalog.id != track.catalog.id) return $j();
		
		var button = templates.get('quick_nesting_button', { trackId : toNestId });
		button.on('click', function(e) {
			nest(toNestId, !nested);
			nested = !nested;
			e.preventDefault();
			e.stopPropagation();
			console.log('button clicked');
		});
		if (nested) {
			button.addClass('has_projects');
		}
		return button;
	};
	
	nester.build = function() {
		templates = sa.templates.get('components.quick_project_bar');
		container = templates.get('quick_nesting_bar');
		container.find('.done_button').on('click', function() {
			nester.disable();
		});
	};

	nester.attach = function() {
		$j('body').append(container);
	};
	
	return nester;
	
})();
/**
 * A vertical list of options, which are either links or callbacks
 * To use, instantiate with an item list and then call getAnchor() and attach the returned anchor JQuery element
 *
 * @param {Object} params
 * 	@property {Array.<OptionsMenuItem>} items please see definition of OptionsMenuItem below. just include headings in the regular list
 * 	@property {boolean} hideOnMouseLeave what it sounds like. defaults to false
 * 	@property {boolean} hideOnOutsideClick what it sounds like. defaults to false
 * 	@property {string} iconClass defaults to fa-bars
 * 	@property {string} entityType defaults to 'default', distinguishes what kind of options we are showing by adding a class to the root HTML element, i.e. "dl_formats_track" for example, will add class "options_type_dl_formats_track"
 * 	@property {string} anchorText if set, the anchor will be a pseudo button with text instead of just an icon
 * 	@property {string} buttonAnchor if set, the anchor will be a regular button with text instead of just an icon
 * 	@property {JQuery} customAnchor if set, the anchor will be this exact element
 * 	@property {function} onShow will be called whenever the options menu is shown. note that it might not have its final position or dimensions yet. passed the options menu
 *
 * @typedef {Object} OptionsMenuItem
 * 	@property {string} name
 * 	@property {boolean} heading if true, the following will be ignored
 *	@property {string} href set this if you want the item to just link somewhere
 * 	@property {function} onClick the item will fire this on click (even if you set an href). function is sent the OptionsMenuItem as a parameter, the clicked element, and the click event
 * 	@property {JQuery} custom if set, this element will be used as the option element. it has the class "option" added to it
 *
 * @constructor
 */
sa.components.OptionsMenu = function(params) {

	var optionsMenu = this;
	var templates;
	var container;
	var anchor;
	var showing = false;
	let clickClass = 'options_menu_' + (new Date().getTime());
	var mouseEntered = false;

	params = $j.extend({
		items : [],
		hideOnMouseLeave : false,
		hideOnOutsideClick : false,
		anchorText : null,
		buttonAnchor : false,
		customAnchor: null,
		itemId: null,
		entityType: 'default', // what kind of options are these?  List of track download links, list of album download links?
		iconClass: 'fa-bars',
		tooltip: '',
		onShow : null,
	}, params);

	if (!params.items.length) {
		console.warn('Attempt to create an options menu with no items', params);
	}

	templates = sa.templates.get('options_menu');
	container = templates.get('options_menu', { itemId : params.itemId, iconClass : params.iconClass, tooltip: params.tooltip, entityType: params.entityType });
	container.addClass(clickClass);

	if (params.buttonAnchor) {
		anchor = templates.get('anchor_as_button', {itemId : params.itemId, text : params.buttonAnchor, iconClass : params.iconClass, tooltip: params.tooltip});
	} else if (params.anchorText) {
		anchor = templates.get('anchor_with_text', {itemId : params.itemId, text : params.anchorText, iconClass : params.iconClass, tooltip: params.tooltip});
	} else if (params.customAnchor) {
		anchor = params.customAnchor;
	} else {
		anchor = templates.get('anchor', { itemId : params.itemId, iconClass : params.iconClass, tooltip: params.tooltip});
	}

	/**
	 * Adds a single item to the options menu. Try to avoid calling this directly and just pass in a static list of items to the OptionsMenu on instantiation
	 * Can be used later if you have to load in items dynamically but don't want to spam the server for every button created
	 * For instance, the download format selector loads additional formats only on show
	 * @param {OptionsMenuItem|Object} item
	 */
	optionsMenu.addItem = function(item) {
		var itemElement;
		if (item.heading) {
			itemElement = templates.get('heading');
			itemElement.html(item.name);
		} else {
			if (item.custom) {
				if (!item.custom.length) {
					return; // if custom is set but the jQuery element is empty, don't render a blank area
				}
				itemElement = item.custom;
				itemElement.addClass('option');
			} else {
				itemElement = templates.get('option');
				itemElement.html(item.name);
			}
			itemElement.on('click', function(e) {
				if (item.onClick) {
					item.onClick(item, itemElement[0], e);
				}
				if (item.href) {
					if (item.href.match(/^[-_a-zA-Z0-9]+\.php/) || item.target == '_blank') {
						if (item.target == '_blank') {
							window.open(item.href, '_blank');
						} else {
							document.location.href = item.href;
						}
					} else {
						sa.router.routeTo(item.href);
					}
				}
				hideContainer();
			});
		}
		// Useful to get the URLs of option items
		if (item.href) {
			itemElement.data('href', item.href)
		}

		if (item.data) {
			itemElement.data(item.data);
		}
		container.append(itemElement);

		if (showing) {
			updateContainerPosition();
		}
	};

	// add the items to the container
	for (var i = 0, len = params.items.length; i < len; i++) {
		optionsMenu.addItem(params.items[i]);
	}

	function showContainer() {
		showing = true;
		container.removeClass('showing'); // in case it was left on for some reason
		anchor.addClass('menu_showing');
		$j('body').append(container);
		updateContainerPosition();
		setTimeout(function() {
			if (showing) {
				container.addClass('showing');
				setTimeout(function() {
					updateContainerPosition();
				}, 200);
			}
		}, 100);
		if (params.onShow != null) {
			params.onShow(optionsMenu);
		}
		// hide if you click elsewhere
		if (params.hideOnOutsideClick || sa.isMobile()) { // hide by default on mobile
			$j(window).off('.' + clickClass).on('click.' + clickClass, function(e) {
				if (!$j(e.target).parents('.' + clickClass).length) {
					hideContainer();
					$j(window).off('.' + clickClass);
				}
			});
		}
	}

	function updateContainerPosition() {
		let rect = anchor[0].getBoundingClientRect();
		
		// the adobe panel uses zoom, which affects absolute positioning math. we need to account for it or the options menu will be in the wrong place
		let zoom = $j('body').css('zoom');
		zoom = zoom ? parseFloat(zoom) : 1;
	
		container.css({
			top : Math.min(rect.top, $j(window).height() / zoom - container.height()) + getScrollY() / zoom,
			left : Math.max(0, rect.left + anchor.outerWidth() - container.outerWidth()) + getScrollX() / zoom
		});
	}

	function hideContainer() {
		showing = false;
		container.removeClass('showing');
		setTimeout(function() {
			if (!showing) {
				container.detach();
				anchor.removeClass('menu_showing');
			}
		}, 250);
	}
	
	anchor.show = showContainer;
	anchor.hide = hideContainer;

	// clicking the icon inside the menu should close it
	anchor.add(container.find('.options_menu_close')).on('click', function(e) {
		// Hide the advanced search
		sa.components.topBar?.hideAdvancedSearch();
		
		if (!showing) { // now it's supposed to show
			showContainer();
		} else {
			hideContainer();
		}
		
		e.preventDefault();
		e.stopPropagation();
	});

	// clicking the first item should hide the menu if it's a heading
	if (params.items.length && params.items[0].heading) {
		container.find('.heading:first').on('click', function() {
			hideContainer();
		});
	}

	// hide when you mouse out
	if (params.hideOnMouseLeave) {
		container.on('mouseenter mouseover', function() {
			mouseEntered = true;
		})
		container.on('mouseleave', function() {
			if (mouseEntered) {
				hideContainer();
				mouseEntered = false
			}
		});
	}

	/**
	 * @returns {JQuery}
	 */
	optionsMenu.getAnchor = function() {
		anchor.getContainer = function() {
			return container;
		};
		return anchor;
	};

};

/**
 *
 * @param {Object} options
 * 	@property {string} name defaults to More Options
 * 	@property {JQuery[]} buttons
 * @returns {JQuery} the anchor
 */
sa.components.OptionsMenu.GenerateFromButtons = function(options) {

	options = $j.extend({
		name : 'More Options',
		buttons : []
	}, options);

	if (!options.buttons.length) {
		return null;
	}

	// if there's more than one, we have to build a menu
	var menu;
	var anchor;
	var menuItems = [
		{
			name : options.name,
			heading : true
		}
	];

	// since the options.buttons are full jQuery button elements, we need to convert them into OptionsMenuItem objects
	for (var o = 0, oLen = options.buttons.length; o < oLen; o++) {
		var optionButton = $j(options.buttons[o]);
		if (!optionButton.length) {
			continue; // don't add empty buttons
		}

		/**
		 * Handle download buttons inside options menus by pulling out an invisible download menu,
		 * adding it before the main options menu, and binding clicks on the download option 
		 * within the main options mennu to open the invisible download menu
		 */
		if (optionButton.is('[id^="dlBtn"]')) {
			let $downloadMenu = optionButton;
			$downloadMenu.addClass('options_download_hidden')
			optionButton = $j('<div class="option download">' + optionButton.text() + '</div>');
			optionButton.on('click', function(e) {
				e.stopPropagation();
				anchor.before($downloadMenu)
				$downloadMenu.click();
			});
		}
		var option = {
			name : optionButton.text(),
			optionButton : optionButton
		};
		// most of those buttons work by using onclicks. here we strip those off and attach them to the new buttons instead
		option.onClick = function (optionData, optionElement, event) {
			var events = jQuery._data(optionData.optionButton[0], 'events');
			if (events && events['click'] && events['click'].length > 0) {
				events['click'][0].handler.call(optionElement, event);
			}
		};

		// some will also use href. those are easier to deal with
		var href = optionButton.attr('href');
		if ( (href && href !== 'javascript:' && href !== 'javascript:;') || (optionButton.data('href'))) {
			option.href = href;
		}

		option.data = optionButton.data();

		menuItems.push(option);
	}

	if (menuItems.length) {
		menu = new sa.components.OptionsMenu({
			hideOnMouseLeave : true,
			items : menuItems,
			anchorText : options.name
		});
		anchor = menu.getAnchor();
	}

	return anchor;
};
/**
 * Class with some helper functions for sa.component.permissionProfileSelector(s)
 * Don't call this directly. Instead instantiate a selector with 
 * let selector = new sa.components.permissionProfileSelector();
 * @type {{object}}
 */
sa.components.permissionProfileSelectorController = (function() {
	
	let permissionProfileSelectorController = {};
	let templates;
	
	// cache of permission profiles { id : int, name : string }
	let permissionProfiles = [];
	// tracks callbacks for when the server finishes loading the permission profile list. prevents rapid calls to getPermissionProfiles from making multiple requests
	let getPermissionProfileCallbacks = [];
	let gettingPermissionProfiles = false;
	
	permissionProfileSelectorController.resetPermissionProfileList = function() {
		permissionProfiles = [];
		// for the mobile menu
		sa.trigger('permissionprofiles_reload')
	};

	/**
	 * @constructor
	 */
	sa.components.permissionProfileSelector = function() {

		let permissionProfileSelector = this;
		let selectedPermissionProfileIds;
		let selectedDefaultId = -1;
		let listElement = $j();
		let hidingNewAndView = false;

		/**
		 * @function
		 * @memberOf sa.components.permissionProfileSelector#
		 * @param {int[]} ids
		 * @param {int} defaultId
		 */
		this.setSelectedPermissionProfileIds = function(ids, defaultId) {
			// if the profile data HASN'T loaded, this will make sure selected profiles are saved for when it is
			selectedPermissionProfileIds = ids;
			selectedDefaultId = defaultId;
			// if the profile data HAS loaded, this will update the currently selected values
			if (listElement.length) {
				listElement.find('.permission_profile_checkbox').prop('checked', false);
				for (let id of selectedPermissionProfileIds) {
					listElement.find('.permission_profile_checkbox[value=' + id + ']').prop('checked', true).trigger('change');
					if (id == defaultId) {
						listElement.find('.permission_profile_default_checkbox').prop('checked', true);
					}
				}
			}
		};


		/**
		 * @function
		 * @memberOf sa.components.permissionProfileSelector#
		 */
		this.hideNewAndView = function() {
			hidingNewAndView = true;
			listElement.find('.new_profile_container, .perm_view').hide();
		};

		/**
		 * @function
		 * @memberOf sa.components.permissionProfileSelector#
		 * @param {JQuery} container
		 * @param {string} inputName
		 */
		this.show = function(container, inputName) {
			listElement = templates.get('selector');
			if (hidingNewAndView) {
				this.hideNewAndView();
			} else {
				listElement.find('.new_profile').on('click', () => {
					AdminPermissionProfiles.CreateNewProfileOnLoad = true;
				});
				listElement.find('.perm_view').on('click', function () {
					let values = permissionProfileSelector.getValues();
					if (values.length < 1) {
						sa.notify({ text : 'Please select a profile to view.' });
						return false;
					} else if (values.length > 1) {
						sa.notify({ text : 'Please select only one profile to view it.' });
						return false;
					} else {
						AdminPermissionProfiles.LoadProfileOnLoad = values[0];
						return true;
					}
				});
			}
			
			let profileContainer = listElement.find('.permission_profile_list');

			getPermissionProfiles(permissionProfiles => {
				if (config.siteType === 'drop') {
					// drop sites don't get to choose
					let profileElement = templates.get('permission_profile', { inputName : inputName, id : permissionProfiles[0].id, name : permissionProfiles[0].name });
					profileElement.find('.permission_profile_checkbox').prop('checked', true);
					profileContainer.append(profileElement);
					listElement.addClass('hidden');
				} else {
					// other sites get options!
					profileContainer.empty();

					// show all button (needs to be first so we can apply styles to last-child)
					if (permissionProfiles.length > 5) {
						let showAll = templates.get('show_all');
						showAll.on('click', () => {
							profileContainer.addClass('showing_all');
							profileContainer.removeClass('with_show_all_button');
							showAll.remove();
						});
						profileContainer.on('scroll', () => {
							showAll.css({ bottom : 0 - profileContainer.scrollTop() });
						});
						profileContainer.append(showAll);
						profileContainer.addClass('with_show_all_button');
					}
					
					for (let permissionProfile of permissionProfiles) {
						let profileElement = templates.get('permission_profile', { inputName : inputName, id : permissionProfile.id, name : permissionProfile.name });
						let defaultContainer = profileElement.find('.default_container');
						if (selectedPermissionProfileIds && selectedPermissionProfileIds.indexOf(permissionProfile.id) !== -1) {
							profileElement.find('.permission_profile_checkbox').prop('checked', true);
							defaultContainer.removeClass('disabled');
							if (permissionProfile.id == selectedDefaultId) {
								defaultContainer.find('.permission_profile_default_checkbox').prop('checked', true);
							}
						}
						profileElement.find('.permission_profile_checkbox').on('change', function() {
							if (this.checked) {
								defaultContainer.removeClass('disabled');
							} else {
								defaultContainer.addClass('disabled');
							}
							fixDefaults();
						});
						profileContainer.append(profileElement);
					}
				}
			});
			
			function fixDefaults() {
				listElement.find('.disabled.default_container input').prop('checked', false);
				let enabledDefaults = listElement.find('.default_container:not(.disabled) input');
				if (enabledDefaults.length && !enabledDefaults.filter(':checked').length) {
					$j(enabledDefaults[0]).prop('checked', true);
				}
			}

			container.empty().append(listElement);
		};

		/**
		 * @function 
		 * @memberOf sa.components.permissionProfileSelector#
		 * @returns {[{Number}]}
		 */
		this.getValues = function() {
			let values = [];
			for (let element of listElement.find('.permission_profile_checkbox:checked')) {
				values.push(parseInt(element.value));
			}
			return values;
		};

		/**
		 * @function
		 * @memberOf sa.components.permissionProfileSelector#
		 * @returns {Number}
		 */
		this.getDefaultValue = function() {
			let checked = listElement.find('.permission_profile_default_checkbox:checked');
			if (checked.length) {
				return checked.parents('.permission_profile_in_selector').find('.permission_profile_checkbox').val();
			}
			return -1;
		};

	};

	sa.components.permissionProfileSelector.generateProfileSelectorDropdown = function() {
		let permissionProfiles = user.userData.permissionProfiles;
		var templates = sa.templates.get('top_bar');
		if (!permissionProfiles || permissionProfiles.length < 2) {
			return;
		}
		let ppsc = $j('<div class="permission_profile_wrapper"><label></label><select class="permission_profile_select_dropdown"></select></div>')
		let selector = ppsc.find('select');
		for (let profile of permissionProfiles) {
			selector.append(new Option(profile.name, profile.id, profile.active, profile.active));
		}
		selector.on('change', function() {
			user.setActivePermissionProfile(this.value);
		});
		if (user.hasAdminPermission(AdminPermission.Any)) {
			sa.components.helpExplanation.show(ppsc.find('label'), templates.get('maf_explanation').html());
		}
		

		return ppsc;
	}

	/**
	 * Loads the permission profiles for this white label
	 * @param {function} callback
	 */
	function getPermissionProfiles(callback) {
		if (permissionProfiles.length) {
			setTimeout(function() { callback(permissionProfiles); }, 10);
			return;
		}

		// the first time you call this function, it requests the list from the server. if you call it again before that first call returns, store the 
		// second callback in the getPermissionProfileCallbacks array and don't make a repeat request. when the server responds, both (or more) callbacks will fire
		getPermissionProfileCallbacks.push(callback);
		if (!gettingPermissionProfiles) {
			gettingPermissionProfiles = true;
			sa.api.request({
				handler : 'permission-profiles',
				action : 'getList',
			}).then(newProfiles => {
				permissionProfiles = newProfiles;
				gettingPermissionProfiles = false;
				for (let callback of getPermissionProfileCallbacks) {
					callback(permissionProfiles);
				}
				getPermissionProfileCallbacks = []; // don't hang onto those references
			}).catch(err => {
				sa.alert(err.message);
			});
		}
	}

	permissionProfileSelectorController.build = function() {
		templates = sa.templates.get('components.permission_profile_selector');
	};
	
	return permissionProfileSelectorController;
	
})();

sa.components.privacyManager = (function() {
	
	var privacyManager = {};
	var templates;
	
	privacyManager.exportData = function() {
		document.location.href = 'export.php?type=userDataExport'
	};
	
	privacyManager.deleteAccount = function(stage) {
		if (!stage) {
			sa.confirm({
				text : 'This will delete your account and all your data across all SourceAudio workspaces. Are you sure that\'s what you want?',
				yesText : 'Delete My Data',
				yesFunction : function () {
					privacyManager.deleteAccount('typing')
				},
				noText : 'Cancel'
			});
		} else if (stage === 'typing') {
			sa.prompt({
				text : 'Please type the word "delete" in this box to confirm you want us to delete your account and all your data across all SourceAudio workspaces.',
				yesText : 'Delete My Data',
				yesFunction : function(enteredValue, interactionOptions) {
					if (enteredValue === 'delete') {
						privacyManager.deleteAccount('sites');
						return false;
					} else {
						interactionOptions.showError('Please type the word exactly as shown');
						return true;
					}
				},
				noText : 'Cancel'
			})
		} else if (stage === 'sites') {
			sa.api.request({
				handler : 'privacy',
				action : 'listSites'
			}).then(sites => {
				if (!sites.length) {
					privacyManager.deleteAccount('final');
				} else {
					var container = templates.get('site_list');
					var siteList = container.find('.privacy_site_list');
					var focusBox = new FocusBox(container);
					sites.each(function(i, site) {
						siteList.append(templates.get('site_list_checkbox', { siteId : site.id, siteName : site.name }));
					});
					sa.forms.init(siteList);

					container.find('.confirm_no').on('click', function() {
						focusBox.hide();
					});
					container.find('.confirm_yes').on('click', function() {
						var result = sa.forms.validate(container);
						if (result.error) {
							focusBox.showErrorMessage('You must agree to delete each workspace you own to delete your account.');
						} else {
							sa.api.request({
								handler : 'privacy',
								action : 'saveSiteConsent',
								postData : result.values
							}).then(() => {
								focusBox.hide();
								privacyManager.deleteAccount('final');
							}).catch(err => {
								focusBox.showErrorMessage(err.message);
							});
						}
					});

					focusBox.show();
				}
			});
		} else if (stage === 'final')  {
			sa.api.request({
				handler : 'privacy',
				action : 'deleteAccount'
			}).then(() => {
				sa.alert({
					text : 'Your account has been queued for deleting and we will email you to confirm once the process has finished.',
					onClose : function() { document.location.href = 'logout.php'; }
				});
			});
		}
	};

	privacyManager.build = function() {
		templates = sa.templates.get('components.privacy_manager');
	};
	
	return privacyManager;
	
})();

sa.components.quickProjectBar = (function() {

	var quickProjectBar = {
		attachOnLoad : true
	};

	/** @var {JQuery} */
	var container;
	var listContainer;
	var changeSummaryDisplay;

	var templates;

	var changes = { tracks : 0, albums : 0 };

	/**
	 *
	 * @param {Object} contents
	 * 	@property {Array.<Project|CueSheet>} items projects or cue sheets
	 * 	@property {function} removeFunction called on removal of item with the item as a parameter
	 * 	@property {function} countFunction passed an item, returns the number of tracks in the item
	 * 	@property {function} getButton passed an item, returns a button to disable that item
	 * 	@property {function} linkFunction passed an item, returns a link to that item's page
	 */
	quickProjectBar.setContents = function(contents) {
		listContainer.empty();
		changeSummaryDisplay.empty();
		var baseHeight = container.height();

		changes = { tracks : 0, albums : 0 };

		$j.each(contents.items, function(index) {
			var item = contents.items[index];
			var quickItem = templates.get('quick_item', { id : item.id, name : item.name, trackCount : contents.countFunction(item), link : contents.linkFunction(item.id) });
			quickItem.append(contents.getButton(item));
			quickItem.find('.quick_project_button').off().on('click', function() { contents.removeFunction(item); });
			listContainer.append(quickItem);
		});
		
		var actualHeight = container.outerHeight();
		var bodyElement = sa.body[0];
		if (baseHeight != actualHeight) {
			bodyElement.style.paddingTop = (actualHeight - baseHeight) + 'px';
		} else {
			bodyElement.style.paddingTop = '';
		}
	};

	quickProjectBar.setProjects = function(projects) {
		quickProjectBar.setContents({
			items : projects,
			removeFunction : function(project) { sa.components.projector.removeQuickProject(project); },
			countFunction : function(project) { return project.totalTrackCount },
			getButton : function(project) { return sa.components.projector.generateQuickProjectModeButton(project); },
			linkFunction : getProjectLink
		});
	};

	quickProjectBar.setCueSheets = function(cueSheets) {
		quickProjectBar.setContents({
			items : cueSheets,
			removeFunction : function(cueSheet) { sa.components.cueSheeter.removeQuickCueSheet(cueSheet); },
			countFunction : function(cueSheet) { return cueSheet.trackCount },
			getButton : function(cueSheet) { return sa.components.cueSheeter.generateQuickCueSheetModeButton(cueSheet); },
			linkFunction : getCueSheetLink
		});
	};

	/**
	 * @param {int} trackChange
	 * @param {int} albumChange
	 */
	quickProjectBar.updateChangeSummary = function(trackChange, albumChange) {
		var changeStrings = [];
		changes.tracks += trackChange;
		changes.albums += albumChange;
		var tracksWord = 'track' + (changes.tracks > 1 || changes.tracks < -1 ? 's' : '');
		var albumsWord = gde('album', { p : changes.albums > 1 || changes.albums < -1, c : 'lower' });
		if (changes.tracks > 0) {
			changeStrings.push('Added ' + changes.tracks + ' ' + tracksWord);
		} else if (changes.tracks < 0) {
			changeStrings.push('Removed ' + Math.abs(changes.tracks) + ' ' + tracksWord);
		}
		if (changes.albums > 0) {
			changeStrings.push('Added ' + changes.albums + ' ' + albumsWord);
		} else if (changes.albums < 0) {
			changeStrings.push('Removed ' + Math.abs(changes.albums) + ' ' + albumsWord);
		}
		changeSummaryDisplay.html(changeStrings.length ? changeStrings.join(', ') : '');
	};

	/**
	 * Shows the bar
	 * @param {string} type
	 * @param {function} onClose
	 */
	quickProjectBar.show = function(type, onClose) {
		quickProjectBar.startMoving(container);
		container.find('.optional_text').hide();
		container.find('.' + type + '_text').show();
		container.addClass('showing');
		$j('body').addClass('with_quick_project_bar');
		container.find('.button').off().on('click', function() {
			quickProjectBar.hide();
			if (onClose) {
				onClose();
			}
		});
	};

	quickProjectBar.hide = function() {
		$j('body').removeClass('with_quick_project_bar');
		container.removeClass('showing');
		quickProjectBar.stopMoving(container);
		sa.body[0].style.paddingTop = '';
	};
	
	quickProjectBar.isShowing = function() {
		return $j('body').hasClass('with_quick_project_bar');
	};

	quickProjectBar.startMoving = function(container) {
		var topBarHeight = $j('#top_bar').height();
		var containerStyle = container[0].style;
		var initTop = container.offset().top;
		$j(window).off('.quick_project_bar').on('scroll.quick_project_bar', function() {
			var topBarBottom = $j('#top_bar').offset().top + topBarHeight;
			if (topBarBottom > initTop) {
				containerStyle.top = topBarHeight + 'px';
				containerStyle.position = 'fixed';
			} else {
				containerStyle.top = initTop + 'px'
				containerStyle.position = '';
			}
		})
		.trigger('scroll');
	};
	
	quickProjectBar.stopMoving = function(container) {
		setTimeout(function() {
			if (container.hasClass('showing')) return;
			$j(window).off('.quick_project_bar');
			container.css({ top: '', position: '' })
		}, 250);
	};

	quickProjectBar.build = function() {
		templates = sa.templates.get('components.quick_project_bar');
		container = templates.get('quick_project_bar');
		listContainer = container.find('.project_list');
		changeSummaryDisplay = container.find('.change_summary');
	};

	quickProjectBar.attach = function() {
		$j('body').append(container);
	};

	return quickProjectBar;

})();
sa.components.selector = (function() {
	var selector = {},
		selectedClass = 'selected_selected',
		subSelectedClass = 'sub_selected_selected',
		hoverClass = 'hover',
		baseConfig = {
			change : false, // should be a function that will received getSelected() as its parameter
			action : function() {}, // should be a function that will be called with getSelected() when the action button is clicked. return true if you want selection to continue. otherwise, everything will be deselected
			cancel : function() {}, // should be called when the cancel button is clicked
			showContainerWhenEmpty : false,
			dragging : true,
			key : 'general',
			selectAlbums : true,
			selectProjectItems : true,
			selectTracks : true,
			selectCatalogs : false,
			selectLabels : false,
			selectArtists : false,
			buttonSection : 'download_buttons',
			persistent : false
		},
		selectorConfig = $j.extend({}, baseConfig),
		container;

	// sends show and hide events
	sa.eventify(selector);

	function SelectionType(name) {

		var selectionType = this;
		var rowSelectors = [];
		var singular = name.substring(0, name.length - 1);
		var plural = name;
		var selected = {};

		this.handleTypes = [];
		this.listBlockTypes = [];

		if (name == 'tracks') {
			this.handleTypes = ['.track_row'];
			rowSelectors = [ '.lr_track#lr_', '.track_row#lr_' ];
		} else {
			this.handleTypes = ['.' + singular + '_detailed', '.' + singular + '_row'];
			this.listBlockTypes = ['.' + singular + '_block'];
			rowSelectors = [ '.' + singular + '_row#lr_', '.' + singular + '_detailed#item_', '.' + singular + '_block#item_' ];
			if (name == 'albums') {
				rowSelectors.push('.project_item_detailed#item_');
			}
		}

		/**
		 * @return {Number}
		 */
		this.updateContainerSection = function() {
			var section = container.find('.' + plural + '_selected');
			var configSelected = this.getSelected();
			var selectedCount = configSelected.length;
			if (selectedCount) {
				section.show();
				section.find('.selected_count').html(selectedCount);
				if (selectedCount > 1) {
					section.find('.singular').hide();
					section.find('.plural').show();
				} else {
					section.find('.singular').show();
					section.find('.plural').hide();
				}
			} else {
				section.hide();
			}
			return selectedCount;
		};

		/**
		 * @return {Array.<int>}
		 */
		this.getSelected = function() {
			if (!selected[selectorConfig.key]) {
				selected[selectorConfig.key] = [];
			}
			return selected[selectorConfig.key];
		};

		/**
		 * Safely gets rid of all the selected for the current config
		 */
		this.clearSelected = function() {
			var configSelected = this.getSelected();
			configSelected.splice(0, configSelected.length);
		};

		/**
		 * @return {boolean}
		 */
		this.isEnabled = function() {
			return selectorConfig['select' + ucfirst(plural)];
		};

		/**
		 * @param {int} id
		 * @return {string}
		 */
		this.getRowSelector = function(id) {
			return rowSelectors.join(id + ', ') + id;
		};

		/**
		 * Adds any selected ids of the current type to the passed in object
		 * @param {Object} items
		 */
		this.addAjaxVars = function(items) {
			var configSelected = this.getSelected();
			if (configSelected.length) {
				items[singular + 'Ids'] = configSelected;
			}
		};

		/**
		 * Adds a copy of the current selected ids in format for selector.getSelected
		 * @param items
		 */
		this.addSelectedCopy = function(items) {
			items[plural] = this.getSelected().slice(0);
		};

		/**
		 * Overwrites the currently selected with a new list
		 * @param data should have an array of ints at { $myPlural : array }
		 */
		this.importSelected = function(data) {

			// the list's contents will change during this object but the object won't so one ref is ok
			var configSelected = selectionType.getSelected();

			// unhighlight everything
			configSelected.each(function(j, id) {
				unhighlightRow($j(selectionType.getRowSelector(id)));
			});

			// remove anything currently selected
			this.clearSelected();

			// do the overwrite
			var myData = data[plural];
			if (myData && myData.length) {
				myData.each(function(i, id) {
					configSelected.push(id);
				});
			}

			// apply new highlight
			configSelected.each(function(i, id) {
				highlightRow($j(selectionType.getRowSelector(id)));
			});

		};

		/**
		 * @return {string}
		 */
		this.getSelectedDescription = function() {
			var len = this.getSelected().length;
			if (!len) return '';
			return len + ' ' + (len > 1 ? plural : singular);
		};
	}

	var selections = {
		types : ['tracks', 'albums', 'artists', 'catalogs', 'labels'],
		each : function(callback) {
			selections.types.each(function(i, type) {
				callback(i, selections[type]);
			})
		}
	};
	selections.types.each(function(i, type) {
		selections[type] = new SelectionType(type);
	});

	var templates;

	function deselectAll() {
		unhighlightRow($j('.' + selectedClass));
		unhighlightRow($j('.' + subSelectedClass));
		selections.each(function(i, selectionType) {
			selectionType.clearSelected();
		});
		hideContainer();
	}

	selector.deselectAll = deselectAll;

	/**
	 * Adds the selector options to the left nav
	 * @param {boolean=} forceAttachment if set, the selector will attach regardless of whether or not #left_nav exists
	 */
	selector.showOptions = function(forceAttachment) {
		if (!container) {
			if (!android && !ios) {
				container = templates.get('container');
			} else {
				container = $j("");
				$j('#left_nav').removeClass('with_selector')
					.removeClass('with_zero_selector');
			}

			// downloading
			container.find(".download_buttons").prepend(sa.components.downloadFormatSelector.generateDownloadButton({
				type : 'selected',
				wide : true,
				wideText : 'Download',
				item : { can_download : true },
				getItemForAjax : function() {
					var items = {};
					selections.each(function(i, selectionType) {
						selectionType.addAjaxVars(items);
					});
					return items;
				} }));

			// clear
			container.find('.cancel_button').on('click', function() {
				selectorConfig.cancel();
				selector.cancelPersistentSelection();
			});

			// other actions
			container.find('.action_button').on('click', function() {
				if (!selectorConfig.action(selector.getSelected())) {
					selector.cancelPersistentSelection();
				}
			});

			// set up interactions
			$j('#top_bar').on('click', function() {
				deselectAll();
			});
			$j('#logo, .search_browse, #nav_container, .player_controls_container, #login_container, .mode_options').on('click', function(e) { e.stopPropagation(); });
		}
		// need to add it after the nav if there is one
		if (forceAttachment || $j("#left_nav").length > 0) {
			$j('body').append(container);
		}
		selector.updateCount();
	};

	// Register path event listener to hide container if we are not
	// on the explorer page
	sa.on('routeChange', function() {
		let disallowedRoutes = ['admin', 'dashboard', 'home', 'track'];
		let updateSelector = !disallowedRoutes.includes(sa.router.getCurrentRoute(true));
		if (updateSelector) {
			//showContainer();
			selector.updateCount();
		} else {
			hideContainer();
			$j('#left_nav').removeClass('with_selector')
				.removeClass('with_zero_selector');
		}
	});

	function hideContainer() {
		if (!android && !ios) {
			$j('#left_nav').removeClass('with_selector');
			$j('#left_nav').addClass('with_zero_selector');
		}
		if (container.hasClass('showing')) {
			container.removeClass('showing');
			selector.trigger('hide');
		}
	}

	function showContainer() {
		if (!android && !ios) {
			$j('#left_nav').addClass('with_selector');
			$j('#left_nav').removeClass('with_zero_selector');
		}
		if (!container.hasClass('showing')) {
			container.addClass('showing');
			selector.trigger('show');
		}
	}

	selector.updateCount = function() {
		if (!container) return;
		var selectedCount = 0;
		selections.each(function(i, selectionType) {
			selectedCount += selectionType.updateContainerSection();
		});
		if (selectorConfig.buttonSection && (selectorConfig.showContainerWhenEmpty || selectedCount)) {
			if (selectedCount) {
				container.find('.nothing_selected').hide();
			} else {
				container.find('.nothing_selected').show();
			}
			showContainer();
		} else {
			hideContainer();
		}
	};

	/**
	 * Highlights one row, altering any subelements as necessary
	 * @param row the row to highlight
	 */
	function highlightRow(row) {
		row.addClass(selectedClass).find('td:first').addClass(subSelectedClass);
		var wave = row.find('.wave_row').data('waveform');
		if (wave) wave.resize();
		row.find('.track_selector').prop('checked', 'checked');
	}

	/**
	 * Unhighlights one row, altering any subelements as necessary
	 * @param row the row to unhighlight
	 */
	function unhighlightRow(row) {
		row.removeClass(selectedClass).find('.' + subSelectedClass).removeClass(subSelectedClass);
		var wave = row.find('.wave_row').data('waveform');
		if (wave) wave.resize();
		row.find('.track_selector').removeProp('checked');
	}

	/**
	 * Gets the "id" of the track/album/etc. from the row
	 * @param row
	 * @return {Number}
	 */
	function getId(row) {
		var id = row.attr('id');
		if (!id) {
			id = row.find('.project_item_detailed').attr('id');
		}
		return parseInt(id.match(/_([0-9]+)/)[1]);
	}

	/**
	 * Gets the array in which ids should be stored for the given row
	 * @param row
	 * @return {Array}
	 */
	function getSelectedArray(row) {
		var classes = row.prop('class');
		var selectionType;
		if (classes.indexOf('album') != -1) {
			selectionType = selections.albums;
		} else if (classes.indexOf('artist') != -1) {
			selectionType = selections.artists;
		} else if (classes.indexOf('label') != -1) {
			selectionType = selections.labels;
		} else if (classes.indexOf('catalog') != -1) {
			selectionType = selections.catalogs;
		} else {
			selectionType = selections.tracks;
		}
		return selectionType.getSelected();
	}

	/**
	 * Returns a copy of all the currently selected elements of the array
	 * @return {{ tracks : Array.<int>, albums : Array.<int>, artists : Array.<int>, labels : Array.<int>, catalogs : Array.<int> }}
	 */
	selector.getSelected = function() {
		var selected = {};
		selections.each(function(i, selectionType) {
			selectionType.addSelectedCopy(selected);
		});
		return selected;
	};

	/**
	 * Sets the current selection
	 * @param {{ tracks : Array.<int>, albums : Array.<int>, artists : Array.<int>, labels : Array.<int>, catalogs : Array.<int> }} selected
	 */
	selector.setSelected = function(selected) {

		selections.each(function(i, selectionType) {

			// overwrite the current selections
			selectionType.importSelected(selected);

		});

		selector.updateCount();
		if (selectorConfig.change) {
			selectorConfig.change(selector.getSelected());
		}
	};

	/**
	 * Returns selector behavior to normal if you previously had an persistent-flagged selector config
	 */
	selector.cancelPersistentSelection = function() {
		deselectAll();
		selectorConfig = $j.extend({}, baseConfig, {});
	};

	/**
	 * Set up a track list's handles so they're selectable
	 * @param itemContainer the object to search within for tracks
	 * @param {Object} newConfig
	 */
	selector.initializeItems = function(itemContainer, newConfig) {

		// if you have a persistent selector set, don't override it whenever you go to a new item list page
		if (selectorConfig.persistent) {
			console.log('Overriding call to selector.initializeItems because another selector is persistent');
		} else {
			selectorConfig = $j.extend({}, baseConfig, newConfig);
			container.find('.button_set').hide();
			if (selectorConfig.buttonSection) {
				container.find('.' + selectorConfig.buttonSection).show();
			}
		}

		var handleTypes = [ '.track_selector' ]; // all the handles that'll be clickable
		var listBlockTypes = []; // all the list block classes to which we should add checkboxes

		// the selection types know what should be selectable if they're enabled
		selections.each(function(i, selectionType) {
			if (selectionType.isEnabled()) {
				handleTypes = handleTypes.concat(selectionType.handleTypes);
				listBlockTypes = listBlockTypes.concat(selectionType.listBlockTypes);
			}
		});
		if (selectorConfig.selectProjectItems) {
			handleTypes.push('.project_item_detailed[id^=item]');
		}

		// add some checkboxes
		if (listBlockTypes.length) {
			var listBlocks = itemContainer.find(listBlockTypes.join(', '));
			if (listBlocks.length) {
				listBlocks.append('<input type="checkbox" class="track_selector"/>').addClass('with_track_selector');
				listBlocks.on('mouseenter', function () {
					$j(this).addClass('ts_hover');
				}).on('mouseleave', function () {
					$j(this).removeClass('ts_hover');
				});
			}
		}
		
		

		var handleSelector = handleTypes.join(', ');
		var handles = itemContainer.find(handleSelector).filter(':not(.import_track_row)');
		handles.off('.selector');
		// add to them a function that'll do the selecting
		handles.on('click.selector', function(e) {
			
			// The advanced search has an event listener that is being intercepted by this file
			// Added a method to check the current state so that we can correctly handle it
			let advancedSearchIsActive = sa.components.topBar.showingAdvancedSearch();
			
			if ((e.target.nodeName === 'A' && e.target.href) || e.target.nodeName === 'IMG' || advancedSearchIsActive) {
				if (e.target.classList.contains('songbird-btn')) return;
				e.preventDefault();
				return;
			}
			
			var clickedRow = $j(this);
			if (clickedRow.hasClass('track_selector')) {
				clickedRow = clickedRow.parent();
			}
			var id = getId(clickedRow);
			var selectedArray = getSelectedArray(clickedRow);
			var index = selectedArray.indexOf(id);
			// don't let clicking on active waveforms do selection
			if (clickedRow.find('.wave_row.faux_button, .wave_container.faux_button').length && e.target.tagName == 'CANVAS') return;
			// if ctrl is down, we add or remove track
			// if shift is down, we select everything up or down to that item from the lowest/highest displayed
			// if no special keys are down, we unselect everything and just select this one
			if (e.shiftKey) {
				// basing this off how google play's selection algorithm appears to work (sorta. you can break theirs, actually)
				// find the highest track currently displayed. if we're above that one, find the lowset track currently displayed and select all in the middle
				// if we're below the highest track currently displayed, select from it to this one and deselect any others that are visible
				var topSelectedItem = -1;
				var bottomSelectedItem = -1;
				var thisItem = -1;
				var rows = $j(handleSelector);

				var i, len, row, rowArray, rowId, rowIndex;

				for (i = 0, len = rows.length; i < len; i++) {
					row = $j(rows[i]);
					rowArray = getSelectedArray(row);
					rowId = getId(row);
					if (rowArray.indexOf(rowId) != -1) {
						if (topSelectedItem == -1) {
							topSelectedItem = i;
						}
						bottomSelectedItem = i;
					}
					if (rowId == id) {
						thisItem = i;
					}
				}
				if (topSelectedItem == -1 && bottomSelectedItem == -1) {
					// nothing was selected on this page. just ignore
					return;
				} else if (thisItem <= topSelectedItem) {
					// select all between bottom and this
					for (i = thisItem; i < bottomSelectedItem; i++) {
						row = $j(rows[i]);
						rowArray = getSelectedArray(row);
						rowId = getId(row);
						if (rowArray.indexOf(rowId) == -1) {
							rowArray.push(rowId);
							highlightRow(row);
						}
					}
				} else {
					// select all between top and this
					for (i = topSelectedItem; i <= thisItem; i++) {
						row = $j(rows[i]);
						rowArray = getSelectedArray(row);
						rowId = getId(row);
						if (rowArray.indexOf(rowId) == -1) {
							rowArray.push(rowId);
							highlightRow(row);
						}
					}
					// unselect any others below this
					for (i = thisItem + 1; i < len; i++) {
						row = $j(rows[i]);
						rowArray = getSelectedArray(row);
						rowId = getId(row);
						rowIndex = rowArray.indexOf(rowId);
						if (rowIndex != -1) {
							rowArray.splice(rowIndex, 1);
							unhighlightRow(row);
						}
					}
				}

			} else {
				if (index != -1) {
					selectedArray.splice(index, 1);
					unhighlightRow(clickedRow);
				} else {
					selectedArray.push(id);
					highlightRow(clickedRow);
				}
			}
			
			if (e.target.nodeName !== 'A' && !advancedSearchIsActive) {
				selector.updateCount();
				if (selectorConfig.change) {
					selectorConfig.change(selector.getSelected());
				}
				
				e.stopPropagation(); // if they click on a track inside a block album, don't bubble up to the album
			}
		}).on('dblclick', function() { // play on double click
			$j(this).find('.play_button').trigger('click');
		}).find('a, .lc_reorder').not('#songbird-btn').on('click', (e) => { 
			if (e.target.nodeName === 'A' || e.target.nodeName === 'IMG') {				
				// Check if a modifier key is being used (to open in new tab, new window, etc)
				const isUsingModifierKey = e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
				if (!isUsingModifierKey) {
					e.preventDefault();
					return;
				}
			}
			
			if (e.target.nodeName !== 'IMG') {
				e.stopPropagation(); 
			}
		}); // if you click an a tag or the play button, don't select

		// unhighlight everything in case this was called earlier
		itemContainer.find('.' + selectedClass).removeClass(selectedClass);

		// highlight any that are in the selected list
		selections.each(function(i, selectionType) {
			selectionType.getSelected().each(function(j, id) {
				highlightRow(itemContainer.find(selectionType.getRowSelector(id)));
			});
		});

		// disable selection
		itemContainer.find('*').disableSelection();

		// make them draggable
		var removeDraggingClasses = function() {
			$j('body').removeClass('dragging');
		};
		var bodyScrollTop = 0;
		if (selectorConfig.dragging) {
			handles.draggable({
				appendTo : $j('body'),
				cancel : '.lc_reorder',
				containment : $j('body'),
				//cursor : 'none',
				cursorAt : { bottom : 5, left : -2 },
				distance : 5,
				drag : function(event, ui) {
					//ui.position.top -= bodyScrollTop;
				},
				helper : function() {
					return $j('<div class="dragging_tracks"><span class="icon fa fa-plus-sign"></span><span class="track_count"></span></div>');
				},
				refreshPositions : true,
				start : function(event, ui) {
					//console.log('drag start', event, ui);
					// make sure the clicked track is selected. if it is, don't do anything. if it isn't, act like it was clicked normally
					var clickedRow = $j(this),
						id = getId(clickedRow),
						selectedArray = getSelectedArray(clickedRow),
						index = selectedArray.indexOf(id),
						selectedDescriptions = [];
					if (index == -1) {
						clickedRow.trigger('click');
					}
					if ((BrowserDetect.isChrome || BrowserDetect.isSafari) && !ios && !android) {
						bodyScrollTop = $j('body').scrollTop();
						$j('body').on('scroll.selector', function() {
							bodyScrollTop = $j('body').scrollTop();
						});
					}
					$j('body').addClass('dragging');
					// set the selected track in the selector
					selections.each(function(i, selectionType) {
						var description = selectionType.getSelectedDescription();
						if (description !== '') {
							selectedDescriptions.push(description);
						}
					});
					ui.helper.find('.track_count').html(selectedDescriptions.join('; '));
					// set up the droppable projects
					// we used to just use all projects and cue sheets as the selector (what's not visibleProjects) but there are performance problems when you have 1k+ projects
					// so now we filter by which ones are actually visible given the scroll of the project widget
					var visibleProjects = $j('#cue_sheet_list a.created'), // no one has a comparable number of cue sheets so we're going to take the easy way out on those
						projectList = $j('#project_list'),
						minTop = projectList.scrollTop(),
						maxTop = minTop + projectList.height(),
						projects = $j('#projector #project_list a.created'); // all the ones that are potentially eligible for dropping
					for (var i = 0, len = projects.length; i < len; i++) {
						var project = $j(projects[i]),
							projectTop = project.position().top;
						if (projectTop < maxTop) { // is it high enough?
							if (projectTop + project.outerHeight() > minTop) { // is it low enough?
								visibleProjects = visibleProjects.add(project);
							}
						} else {
							// if the element is off the bottom, all subsequent elements will be too
							break;
						}
					}
					visibleProjects.addClass('while_dragging').droppable({
						drop : function(event, ui) {
							//removeDraggingClasses();
							console.log('drop detected!', event, ui);

							var droppedOnItem = $j(event.target);
							var isProject = droppedOnItem.attr('id').indexOf('project') === 0;
							var itemId = droppedOnItem.attr('id').substring(isProject ? 8 : 10);
							var selectedTracks = selections.tracks.getSelected();
							var selectedAlbums = selections.albums.getSelected();

							if (isProject) {
								sa.components.projector.addItemsToProject(itemId, selectedTracks, selectedAlbums);
							} else {
								sa.components.cueSheeter.addTracksToCueSheet(itemId, selectedTracks);
							}
						},
						hoverClass : 'dragging_over',
						out : function(event, ui) {
							//ui.helper.find('.icon').addClass('fa-move').removeClass('fa-plus-sign');
							ui.helper.removeClass('hovering');
						},
						over : function(event, ui) {
							//ui.helper.find('.icon').removeClass('fa-move').addClass('fa-plus-sign');
							ui.helper.addClass('hovering');
						}
					});
				}, stop : function() {
					removeDraggingClasses();
					$j('#projector #project_list a.created.while_dragging, #cue_sheet_list a.created.while_dragging').removeClass('while_dragging').droppable('destroy');
					$j('body').off('.selector');
				}
			});
		}
		// put a subtle highlight on the handles
		handles.on('mouseenter.selector', function() {
			$j(this).addClass(hoverClass);
			$j(this).find('.lc_interaction img').attr('src', 'images/explorer/action-layer-hover.png');
		});
		handles.on('mouseleave.selector', function() {
			$j(this).removeClass(hoverClass);
			$j(this).find('.lc_interaction img').attr('src', 'images/explorer/action-layer-rest.png');
		});
	};

	selector.build = function() {
		templates = sa.templates.get('components.selector');

		// make the delete button remove selected items from playlists
		$j(window).on('keyup', function(e) {
			if (!e.target || e.keyCode != 46) return;
			var nodeName = e.target.nodeName;
			if (nodeName == 'INPUT' || nodeName == 'TEXTAREA') return;
			var selectedTracks = selections.tracks.getSelected();
			var selectedAlbums = selections.albums.getSelected();
			if (sa.getCurrentPageName() == 'project_item_list' && (selectedTracks.length || selectedAlbums.length)) {
				sa.components.projector.removeItemsFromProject(sa.pages.projectItemList.project.id, selectedTracks, selectedAlbums);
			}
		});
	};

	return selector;
})();

sa.components.signup = (function() {

	let signup = {};
	let templates;

	/** @var FocusBox */
	let signupFocusBox;
	let ssoErrorMessage = '';
	let ssoSuccessMessage = '';
	let ssoParams = {};

	// returned from signup.show
	let eventEmitter = {};
	sa.eventify(eventEmitter);

	signup.show = function(options) {

		options = $j.extend({
			whiteLabelAccount : false,
			callback : null,
			lightbox : true,
			source : 'signup component',
			fullPage : false,
			loginAction : 'forward', // passed to log in box
			cancelAction : 'forward', // forwards the user to loginConfig.loginPath, 'close' to just close the box, or 'login' to show the login box here
			signupAction : 'forward', // passed to log in box
			confirmation : '',
			emailConfirmation : null,
			showTitle : true
		}, options);

		sa.getLoginConfig(function(currentLoginConfig) {
			options.loginConfig = currentLoginConfig;
			showSignupForm(options);
		});

		return eventEmitter;
	};

	function showSignupForm(options) {
		let template = templates.get('signup_page' + (options.loginConfig.foxSignupForm ? '_fox' : (options.loginConfig.disableEmailLogins ? '_without_email' : '')), {
			siteName : options.whiteLabelAccount ? config.name : 'SourceAudio',
			forward : '',
			signupMessage : options.whiteLabelAccount ? options.loginConfig.signupMessage : ''
		});
		/** @var {LoginConfig} loginConfig */
		let loginConfig = options.loginConfig;

		if (!options.whiteLabelAccount) {
			template.find('.signup_message').remove();
		}

		if (config.id != 8616) { //FoxSound
			template.find('.login_footer').remove();
		}

		if (config.userAgreements.length) {
			if (config.id == 8616) { // FoxSound
				template.find('#site_signup_agreement_container .site_agreement_text').html('I consent to the disclosure of my personal information to FoxSound as described in the FoxSound');
			}
			template.find('#site_signup_agreement_container .site_agreement_list').html(joinWithCommas(config.userAgreements.map(agreement => '<a target="_blank" href="' + agreement.url + '">' + htmlEncode(agreement.name) + '</a>')));
		} else {
			template.find('#site_signup_agreement_container').remove();
		}

		// coupon codes
		if (!options.whiteLabelAccount || !config.licensingConfig || !config.licensingConfig.coupons_active || !config.licensingConfig.options.signupCoupons || !config.licensingConfig.active) {
			template.find('.coupon_input_container').remove();
		}

		// add all the extra fields
		if (options.whiteLabelAccount) {
			let extraFieldContainer = template.find('.extra_fields');
			loginConfig.registrationFields.each(function (i, registrationField) {
				var fieldTemplate = templates.get('signup_page_extra_field_' + registrationField.type.replace(/ /g, '_'), {
					extraId : registrationField.id,
					name : registrationField.name
				});
				if (registrationField.type === 'contact selector') {
					let select = fieldTemplate.find('select');
					if (registrationField.contactSelectorOptions && registrationField.contactSelectorOptions.isArray) {
						select.html('<option disabled selected value=""></option><option>' + registrationField.contactSelectorOptions.join('</option><option>') + '</option>');
					}
				} else if (registrationField.type === 'option selector') {
					let select = fieldTemplate.find('select');
					if (registrationField.optionSelectorOptions && registrationField.optionSelectorOptions.isArray) {
						select.html('<option disabled selected value=""></option><option>' + registrationField.optionSelectorOptions.join('</option><option>') + '</option>');
					}
				}
				if (registrationField.defaultValue) {
					fieldTemplate.find('input,textarea,select').val(registrationField.defaultValue);
				}
				if (registrationField.required === '1') {
					fieldTemplate.find('input,textarea,select').attr('required', '1');
				}
				extraFieldContainer.append(fieldTemplate);
			});
			if (config.id == 2570) { // Netflix #3796
				let contentField = extraFieldContainer.find('#extra_40464');
				let contentFieldContainer = contentField.parent().hide();
				extraFieldContainer.find('#extra_textarea_22085').on('change', function() {
					if (this.value.indexOf('Content') === 0) {
						contentFieldContainer.show();
						contentField.attr('required', '1')
					} else {
						contentFieldContainer.hide();
						contentField.removeAttr('required');
					}
				});
			}
		}

		// make the form work
		var lastErrorMessage = '';
		var lastEmailChecked = '';
		sa.forms.init(template, {
			realTimeValidation : true,
			realTimeValidationCallback : function(validationResult) {
				// console.log('got validationResult', validationResult);
				if (validationResult.errorDetail && lastErrorMessage == validationResult.errorDetail) return;
				if (validationResult.errorDetail) {
					signupFocusBox.showErrorMessage(validationResult.errorDetail);
				} else if (validationResult.name == 'email') {
					// check if the email is in use already
					lastEmailChecked = validationResult.value;
					sa.api.request({
						handler : 'email-check',
						action : 'check-email-address',
						postData : {
							'email' : lastEmailChecked
						}
					}).then(
					/**
					 * @param {{ email : string }} result
					 */
					function(result) {
						if (result.email === lastEmailChecked) {
							hideErrorMessage();
						}
					}).catch(function(e) {
						/** @var {string} errorMessage */
						let errorMessage = e.message;

						/** @var {{ email : string, loginLink : string, sites : string[], account : boolean, noticeRequired : boolean, rateLimited : float }} errorDetails */
						let errorDetails = e.details;

						if (errorDetails && errorDetails.rateLimited) {
							// email check requests are rate limited. if we exceed the limit, wait and try again
							setTimeout(function() {
								// only try again if the value hasn't changed
								if (lastEmailChecked === validationResult.value) {
									$j('input[name=email]').trigger('input');
								}
							}, Math.floor(errorDetails.rateLimited * 1000));
						} else if (errorDetails.email === lastEmailChecked) {
							if (errorDetails.account && errorDetails.noticeRequired) {
								errorMessage = templates.get('account_exists_error', { errorMessage : errorMessage }).html();
								validationResult.showError(errorMessage);
								signupFocusBox.showErrorMessage(errorMessage);
								$j('.send_site_list').on('click', function() {
									sa.api.request({
										handler : 'email-check',
										action : 'send-site-list',
										postData : {
											'email' : lastEmailChecked
										}
									}).then(function() {
										sa.alert('We sent a list of workspaces to your provided email address. Please check it for more information.');
									});
								});
							} else {
								validationResult.showError(errorMessage);
								signupFocusBox.showErrorMessage(errorMessage);
							}
						}
					});
				} else if (validationResult.name == 'password_again') {
					if (validationResult.value && validationResult.value != $j('input[name=password]').val()) {
						validationResult.showError('Passwords do not match');
						signupFocusBox.showErrorMessage('Passwords do not match');
					} else {
						hideErrorMessage();
						validationResult.hideError();
					}
				} else if (validationResult.name == 'password') {
					if (validationResult.value && !validationResult.value.match(/[a-z].+[0-9]|[0-9].+[a-z]/i)) {
						validationResult.showError('Password must contain a letter and a number.');
						signupFocusBox.showErrorMessage('Password must contain a letter and a number.');
					} else {
						hideErrorMessage();
						validationResult.hideError();
					}
				} else {
					hideErrorMessage();
				}
				lastErrorMessage = validationResult.errorDetail;
			}
		});
		template.find('.button.signup').on('click', function() {
			submitSignupForm(template, options);
		});

		// add the extra buttons
		addExternalLoginButtons(loginConfig, template.find('.external_login_options'));

		// terms agreement
		sa.components.documentViewer.enableButtons(template);

		// show the logo
		if (!options.whiteLabelAccount) {
			template.find('.logo_link').attr('href', 'https://www.sourceaudio.com/');
			template.find('.logo_image').attr('src', DefaultLogo);
		} else {
			let logo = config.theme.loginLogo.path;
			if (logo) {
				template.find('.logo_link').attr('href', 'https://' + config.domain + '/');
				template.find('.logo_image').attr('src', logo);
			} else {
				template.find('.logo_container').remove();
			}
		}

		if (config.id == 2570) {
			template.find('.logo_container').after('<div class="netflix_notice">This is NOT the Netflix streaming service site. To watch unlimited movies, TV shows, and more, visit <a href="https://netflix.com">Netflix.com</a></div>');
		}

		// set the background
		if (options.whiteLabelAccount) {
			let background = config.theme.loginBackground.path;
			if (background) {
				$j('body').css({
					backgroundImage : "url('" + background + "')"
				});
			}
		}

		// log in button needs to be adjusted
		let actionSwitcher = template.find('.action_switcher').removeClass('hidden');
		if (options.cancelAction === 'forward') {
			actionSwitcher.prop('href', loginConfig.loginPath);
		} else {
			actionSwitcher.on('click', function() {
				signupFocusBox.hide();
				if (options.cancelAction !== 'close') {
					sa.components.login.show(options);
				}
				return false;
			});
		}

		// display everything
		signupFocusBox = new FocusBox(template, {
			lightbox : options.lightbox,
			title : options.showTitle ? (config.id == 2570 ? 'Sign Up For Netflix Internal Music' : 'Sign Up') : ''
		});
		signupFocusBox.getFocusedContainer().addClass('landing_page_container');
		signupFocusBox.show();

		if (options.emailConfirmation) {
			signupFocusBox.show();
			processEmailConfirmation(options.emailConfirmation);

		} else if (options.confirmation) {

			processConfirmation(options.confirmation);

		} else if (loginConfig.confirmation) {

			processConfirmation(loginConfig.confirmation);

		} else {
			// autofill isn't triggering input changes correctly
			setTimeout(function () {
				template.find('input[type=text][value!=""], input[type=email][value!=""], textarea[value!=""]').trigger('change');
			}, 1000);

			// make recaptcha work
			template.find('.recaptcha_iframe').attr('src', loginConfig['recaptchaIframeSrc']).iFrameResize({
				log : false,
				checkOrigin : false
			});

			if (options.whiteLabelAccount) {
				trySsoLogin(loginConfig);
			}

		}

		eventEmitter.triggerContinuously('show');
	}

	function trySsoLogin(loginConfig) {
		if (!loginConfig.ssoVars) return;

		var vars = $j.extend({}, loginConfig.ssoVars);
		/** @var {{ email : string, fullName : string, title : string, market : string, usingSso : boolean }} response */
		ajax(vars, function(response) {
			// this might just log them in. if it does, it'll auto-forward them
			if (!response.usingSso) return;

			ssoParams = vars;
			ssoParams.email = response.email;

			if (response.email) {
				$j('.email_input').val(response.email).prop('disabled', true);
				sa.forms.update($j('.email_input'));
			}
			if (response.fullName) {
				$j('.name_input').val(response.fullName);
				sa.forms.update($j('.name_input'));
			}
			if (response.title || response.market) {
				loginConfig.registrationFields.each(function(i, registrationField) {
					let value = '';
					if ((registrationField.name === 'Title' || registrationField.name === 'Job Title') && response.title) {
						value = response.title;
					} else if ((registrationField.name === 'Entercom Market' || registrationField.name === 'Audacy Market') && response.market) {
						value = response.market;
					}
					if (value) {
						sa.forms.update($j('#extra_' + registrationField.id).val(value));
					}
				});
			}
			if (response['registrationFieldValues'] && Object.keys(response['registrationFieldValues']).length) {
				for (let fieldId in response['registrationFieldValues']) {
					if (response['registrationFieldValues'].hasOwnProperty(fieldId)) {
						sa.forms.update($j('#' + fieldId).val(response['registrationFieldValues'][fieldId]));
					}
				}
			}
			$j('.sso_hidden_field').remove();
			signupFocusBox.showSuccessMessage(templates.get('signup_sso'));
		}, 'POST', { p : 'login', action : 'ssoLogin', source : 'signup' });

	}

	function hideErrorMessage() {
		if (ssoErrorMessage) {
			signupFocusBox.showErrorMessage(ssoErrorMessage);
		} else if (ssoSuccessMessage) {
			signupFocusBox.showSuccessMessage(ssoSuccessMessage);
		} else {
			signupFocusBox.hideErrorMessage();
		}
	}

	function submitSignupForm(container, options) {
		let validationResult = sa.forms.validate(container);
		let loginConfig = options.loginConfig;
		console.log('validationResult is', validationResult);
		if (validationResult.error) {
			signupFocusBox.showFormValidationErrors(validationResult);
		} else if (!validationResult.values.terms) {
			signupFocusBox.showErrorMessage('You must agree to the terms and conditions to sign up');
		} else if (config.userAgreements.length && !validationResult.values.siteTerms) {
			signupFocusBox.showErrorMessage('You must agree to all terms and conditions to sign up');
		} else {
			var fields = validationResult.values;
			fields.source = options.source;
			fields.forward = loginConfig.forward;
			fields.password = btoa(fields.password);
			fields.recaptchaKey = loginConfig.recaptchaCacheCommunicationKey;
			fields.whiteLabelAccount = options.whiteLabelAccount ? 1 : 0;
			hideErrorMessage();

			fields = $j.extend(fields, ssoParams);

			signupFocusBox.showLoader('Processing your sign up');

			/** @var {{ success : boolean, canLogin : boolean, loggedIn : boolean, errors : Array.<string> }} response */
			ajax(fields, function(response) {
				signupFocusBox.hideLoader();
				if (response.success) {
					signupFocusBox.showSuccessMessage(response.success);
					if (response.loggedIn) {
						if (options.callback) {
							options.callback();
						}
						$j('#login_options, .external_login_options').animate({ height : 0, paddingTop : 0, paddingBottom : 0 }, 500, function () { $j(this).remove(); });
						$j('.access.button').removeClass('hidden');
						$j('.login.action_switcher').addClass('hidden');
					} else if (response.canLogin) {
						$j('#login_options, .external_login_options').animate({ height : 0, paddingTop : 0, paddingBottom : 0 }, 500, function() { $j(this).remove(); });
						$j('.login.action_switcher').removeClass('hidden');
					} else {
						$j('.landing_page, .external_login_options').animate({ height : 0, paddingTop : 0, paddingBottom : 0 }, 500, function() { $j(this).remove(); });
					}
					sa.trigger('registration');
				} else if (response.errors && response.errors.length) {
					signupFocusBox.showErrorMessage(response.errors.length > 1 ? '<ol><li>' + response.errors.join('</li><li>') + '</li></ol>' : response.errors[0]);
					$j('.recaptcha_iframe').attr('src', $j('.recaptcha_iframe').attr('src'));
				}
			}, 'POST', { p : 'signup', action : 'signup' });
		}
	}

	function addExternalLoginButtons(loginConfig, externalButtons) {
		if (!externalButtons.length) return; // not all versions of the form have external buttons
		// used to determine if we added anything
		let initialChildNodes = externalButtons[0].childNodes;

		let cookieButton = externalButtons.find('.cookie_button, .cookie_button_instructions');
		cookieButton.on('click', function(e) {
			e.preventDefault();
			sa.components.cookieManager.showCustomizer();
			return false;
		});

		sa.cookies.on(sa.cookieTypes.login, function f() {
			sa.cookies.off(sa.cookieTypes.login, f);
			cookieButton.remove();
			externalButtons.find('.cookie_button_instructions').remove();

			if (loginConfig.idps && loginConfig.idps.length) {
				loginConfig.idps.each(function (i, idpData) {
					var buttonTemplate;
					if (idpData['buttonUrl']) {
						buttonTemplate = templates.get('saml_idp_button_' + idpData.id, {
							url : idpData['buttonUrl'],
							verb : loginConfig.verb
						});
					} else {
						buttonTemplate = templates.get('saml_idp_button_' + idpData.id, {
							url : 'https://' + config.domain,
							verb : loginConfig.verb
						});
						buttonTemplate.on('click', function () {
							ajax({
								idp : idpData.id,
								forward : loginConfig.forward,
								ssoType : 'idp'
							}, function (response) {
								if (response['logged']) {
									document.location.href = decodeURIComponent(loginConfig.forward);
								} else if (response['result']) {
									sa.alert(response['result']);
								} else if (response['usingSso']) {
									loginConfig.ssoVars = { ssoType : 'idp', idp : idpData.id };
									trySsoLogin(loginConfig);
								}
							}, 'POST', { p : 'login', action : 'ssoLogin', 'ajax' : 1, source : 'signup' });
							return false;
						});
					}
					externalButtons.append(buttonTemplate);
				});
			}
			if (loginConfig.jwtButtonVars) {
				loginConfig.jwtButtonVars.verb = loginConfig.verb;
				loginConfig.jwtButtonVars.page = 'signup.php';
				if (loginConfig.jwtButtonVars.letter) {
					loginConfig.jwtButtonVars.letter = htmlDecode(loginConfig.jwtButtonVars.letter);
				}
				externalButtons.append(templates.get('jwt_button', loginConfig.jwtButtonVars));
			} else if (loginConfig.ssoButton) {
				loginConfig.ssoButtonVars.verb = loginConfig.verb;
				loginConfig.ssoButtonVars.page = 'signup.php';
				externalButtons.append(templates.get('sso_button_' + config.id, loginConfig.ssoButtonVars));
			}
			if (loginConfig.oAuthButtons.length) {
				loginConfig.oAuthButtons.each(function (i, oAuthButton) {
					/** @var {{ href : string, theme : { name : { text : string, backgroundColor string, textColor : string }, char : { textColor : string } } }} oAuthButton */
					externalButtons.append(templates.get('oauth_button', {
						verb : loginConfig.verb,
						href : oAuthButton.href,
						name : oAuthButton.theme.name.text,
						nameBackgroundColor : '#' + oAuthButton.theme.name.backgroundColor,
						nameTextColor : '#' + oAuthButton.theme.name.textColor,
						char : oAuthButton.theme.char.text,
						charBackgroundColor : '#' + oAuthButton.theme.char.backgroundColor,
						charTextColor : '#' + oAuthButton.theme.char.textColor
					}))
				});
			}

			if (loginConfig.showFacebook && !BrowserDetect.isAdobePanel) {
				sa.components.facebookLogin.show({
					container : externalButtons,
					loginConfig : loginConfig,
					statusCallback : function (status, email, name) {
						if (status == 'matched_accounts' || status == 'external') {
							ssoErrorMessage = templates.get('signup_already_facebook', { loginLink : config.id > 0 ? 'login.php' : '?p=login' });
							hideErrorMessage();
						} else if (status == 'need_match') {
							ssoSuccessMessage = templates.get('signup_facebook');
							hideErrorMessage();
							ssoParams = { hasFacebook : true, externalKey : loginConfig.facebookCommunicationKey };
							if (email) {
								$j('#email_input').val(email).trigger('change').trigger('input').prop('disabled', 'disabled');
							}
							if (name) {
								$j('#name_input').val(name).trigger('change').trigger('input');
							}
							$j('.sso_hidden_field').remove();
						}
					}
				});
			}

			if (externalButtons[0].childNodes.length === initialChildNodes) { // if we increased the number of nodes, show the buttons
				// calling hide and remove makes sure the buttons won't be visible no matter whether or externalButtons has been attached
				externalButtons.hide().remove();
			}
		});
	}

	function processConfirmation(confirmationCode) {
		if (!confirmationCode) return;

		// The confirmation codes are prefixed with a 0 if they are for email confirmation cancellations
		const isCancellation = confirmationCode[0] === '0';

		// If we're canceling the registration email confirmation
		if (isCancellation) {
			signupFocusBox.hide();
			$j('.external_login_options, #login_options').remove();

			// Get the confirmation template
			const template = templates.get('confirmation_cancellation');

			const cancellationBox = new FocusBox(template, {
				title: 'Account Registration Cancellation',
				lightbox: false
			});

			cancellationBox.div.addClass('cancellation-box');

			cancellationBox.show();
			cancellationBox.showLoader('Checking confirmation information...');

			// Check if the cancellation has already happened
			confirmEmailForCancellation(confirmationCode, cancellationBox, true);

			template.find('#confirmation-cancellation-btn').on('click', () => {
				cancellationBox.showLoader('Processing your confirmation');
				confirmEmailForCancellation(confirmationCode, cancellationBox);
			});

			return;
		}

		$j('.external_login_options, #login_options').remove();
		signupFocusBox.showLoader('Processing your confirmation');

		confirmEmailForSignup(confirmationCode, signupFocusBox);
	}

	function confirmEmailForCancellation(confirmationCode, focusBox, isCheck = false) {
		sa.api.request({
			handler: 'account',
			action: 'confirmEmail',
			postData: {
				confirmation: confirmationCode,
				isCheck: isCheck
			}
		}).then((result) => {
			/** @var {{ canLogin : boolean, success : string, errors : string[] }} result */

			if (result?.success) {
				focusBox.showSuccessMessage(htmlDecode(result.success));
				focusBox.hideContent();
			}

			focusBox.hideLoader();
			if (result.canLogin) {
				$j('.login.action_switcher').removeClass('hidden');
			}
			if (result.errors && result.errors.length) {
				sa.alert({ text: result.errors[0] });
			}
		}).catch((e) => {
			focusBox.showErrorMessage(e.message);
			focusBox.hideContent();
			focusBox.hideLoader();
		});
	}

	function confirmEmailForSignup(confirmationCode, focusBox) {
		sa.api.request({
			handler: 'account',
			action: 'confirmEmail',
			postData: {
				confirmation: confirmationCode
			}
		}).then((result) => {
			/** @var {{ canLogin : boolean, success : string, errors : string[] }} result */
			focusBox.showSuccessMessage(htmlDecode(result.success));
			focusBox.hideLoader();
			if (result.canLogin) {
				$j('.login.action_switcher').removeClass('hidden');
			}
			focusBox.hideContent();
			if (result.errors && result.errors.length) {
				sa.alert({ text: result.errors[0] });
			}
		}).catch((e) => {
			focusBox.showErrorMessage(e.message);
			focusBox.hideContent();
			focusBox.hideLoader();
		});
	}

	function processEmailConfirmation(emailConfirmation) {
		if (!emailConfirmation) return;

		$j('.external_login_options, #login_options').remove();
		signupFocusBox.showLoader('Processing your confirmation');

		sa.api.request({
			handler : 'account',
			action : 'confirmEmailChange',
			postData : emailConfirmation
		}).then(function(result) {
			/** @var {{ accepted : boolean, success : boolean }} result */
			signupFocusBox.showSuccessMessage(result.accepted ? 'Email address updated!' : 'Email address change cancelled.' );
			signupFocusBox.hideLoader();
			$j('.normal_login_button').removeClass('hidden');
			$j('.login.action_switcher').addClass('hidden');
		}).catch(function(e) {
			signupFocusBox.showErrorMessage(e.message);
			signupFocusBox.hideLoader();
			$j('.normal_login_button').removeClass('hidden');
			$j('.login.action_switcher').addClass('hidden');
		});
	}

	signup.build = function() {
		templates = sa.templates.get('pages.login');
	};

	return signup;

})();

sa.components.siteCreator = (function() {
	
	let siteCreator = {
		attachOnReceiveLoad : true,
		attachOnLoad : true
	};
	let templates;

	/**
	 * Shows the site creator site type selection page before showing the regular site creation interface
	 * @param {Object} options
	 * 	@propery {function} callback will be passed the new site or null if one wasn't created
	 */
	siteCreator.showSiteTypeSelector = function(options) {

		options = $j.extend({
			callback : null
		}, options);
		
		if (config.dev !== 'git-drop') {
			siteCreator.show({
				siteType : 'seller',
				callback : options.callback
			});
			return;
		}
		
		let template = templates.get('site_type_selector');

		template.find('.site_type').on('click', function() {
			fb.hide();
			siteCreator.show({
				siteType : this.dataset.type,
				callback : options.callback
			});
		});

		template.find('#cancel_button').on('click', function() {
			fb.hide();
			return false;
		});

		let fb = new FocusBox(template, {
			title : 'Create a workspace',
			fillWidthAtLowResolution : true
		});
		focusBox.getFocusedContainer().addClass('site_creator_container');
		fb.show();
		
	};

	/**
	 * Shows the site creator interface
	 * @param {Object} options
	 * 	@property {string} siteType the type of site the user should be able to create
	 * 	@propery {function} callback will be passed the new site or null if one wasn't created
	 */
	siteCreator.show = function(options) {
		
		options = $j.extend({
			siteType : 'seller',
			callback : null
		}, options);
		
		// this page doesn't actually need a site list but it makes this request to test if the user is logged in, which the site manager page doesn't innately know
		sa.api.request({
			handler : 'site-manager',
			action : 'listSites'
		}).catch(function() {
			// throws an error if the user is logged out.
			sa.components.signup.show({
				whiteLabelAccount : false,
				callback : function() {
					try {
						safeLocalStorage.setItem('siteCreator', JSON.stringify(options));
					} catch (e) {
						console.error('Caught exception while setting siteCreator option string to localStorage', e);
					}
				},
				source : 'add_to_drop component'
			});
		}).then(function() {
			// we don't care about the site list. the point is that the user is logged in!
			
			let template = templates.get('site_creator', { type : (options.siteType === 'drop' ? options.siteType.ucfirst() : '') });
			let checkedDomains = {};

			sa.forms.init(template, {
				realTimeValidation : true,
				realTimeValidationCallback : function(validationResult) {
					fb.hideErrorMessage();
					if (validationResult.name === 'subdomain') {
						let subdomain = validationResult.value;
						let domain = template.find('select[name=domain], input[name=domain]').val();
						let fullDomain = subdomain + domain;
						let cachedResult = checkedDomains[fullDomain];
						if (cachedResult !== undefined) {
							updateDomainCheck(cachedResult.available, cachedResult.reason, validationResult);
						} else {
							sa.api.request({
								handler : 'site-manager',
								action : 'checkDomainAvailability',
								getData : {
									subdomain : subdomain,
									domain : domain
								}
							}).then(function(response) {
								/** @var {{ available : boolean, reason : string, domain : string }} response */
								checkedDomains[response.domain] = response;
								updateDomainCheck(response.available, response.reason, validationResult);
							});
						}
					}
				}
			});

			template.find('#create_site_button').on('click', function() {
				let validationResult = sa.forms.validate(template);

				if (validationResult.error) {
					fb.showFormValidationErrors(validationResult);
				} else {
					fb.hideErrorMessage();
					fb.showLoader('Creating your workspace');

					sa.api.request({
						handler : 'site-manager',
						action : 'createSite',
						postData : $j.extend({ siteType : options.siteType }, validationResult.values)
					}).catch(function(e) {
						fb.hideLoader();
						fb.showErrorMessage(e.message);
					}).then(function(siteData) {
						/** @var {{ id : int, name : string, path : string }} siteData */
						fb.hide();

						let createdTemplate = templates.get('site_created', { sitePath : siteData.path });

						let createdFocusBox = new FocusBox(createdTemplate, {
							title : 'Congratulations!',
							onClose : function() {

								if (options.callback) {
									options.callback(siteData);
								}

							},
							fillScreenAtLowResolution : 400
						});
						createdFocusBox.show();

						createdTemplate.find('#ok_button').on('click', function() {
							createdFocusBox.hide();
						});
					});
				}
			});

			template.find('#cancel_button').on('click', function() {
				fb.hide();
				return false;
			});

			let fb = new FocusBox(template, {
				title : 'Create a workspace',
				fillScreenAtLowResolution : 400,
			});
			fb.show();
		});
		
	};
	
	function updateDomainCheck(available, reason, validationResult) {
		if (available) {
			validationResult.showSuccess('Domain available!');
		} else {
			validationResult.showError(reason);
		}
	}

	siteCreator.attach = function() {
		try {
			let optionsString = safeLocalStorage.getItem('siteCreator');
			if (optionsString) {
				safeLocalStorage.removeItem('siteCreator');
				let options = JSON.parse(optionsString);
				if (options) {
					siteCreator.show(options);
				}
			}
		} catch (e) {
			console.error('Caught exception while getting siteCreator option string from localStorage', e);
		}
	};
	
	siteCreator.build = function() {
		templates = sa.templates.get('components.site_creator');
	};
	
	return siteCreator;
	
})();
sa.components.topBar = (function () {

	var topBar = {
		attachOnLoad: true,
		attachOnReceiveLoad: true
	};
	var container;
	var templates;
	var dotInterval;
	var backToTop;
	
	let advancedSearchActive = false;

	/**
	 * Updates the number of displayed items in your cart
	 * @param {int} newAmount the amount to show
	 */
	topBar.updateCartContents = function (newAmount) {
		var amt = container.find('#shopping_cart_count').html(newAmount);
		if (newAmount == 0) {
			amt.addClass('empty');
			container.find('#shopping_cart').removeClass('has_items')
		} else {
			amt.removeClass('empty');
			container.find('#shopping_cart').addClass('has_items')
		}

		
	};

	topBar.attach = function () {
		$j('body').append(container).append(backToTop);

		sa.on('beforeRouteChange', function () {
			topBar?.hideAdvancedSearch();
		});

		sa.on('updateUserData', function () {
			topBar.updateUserData()
		});

		sa.on('resize', function() {
			topBar.sizeSearchBox();
		})

	};

	topBar.build = function () {
		templates = sa.templates.get('top_bar');
		container = templates.get('top_bar', { 
			baseUrl: siteBaseUrl() ,
			siteType: config.siteType !== 'buyer' ? 'admin?p=inbox': 'dashboard?p=inbox'
		});

		// set up the logo
		buildLogo();

		// user info
		buildUser();
		
		// Inbox Info
		buildInbox();

		// shopping cart
		buildEcommerce();

		// search
		buildSearch();

		// browse
		buildBrowse();

		// permission profile selector
		buildPermissionProfileSelector();

		// unpaid notice
		buildUnpaidNotice();

		// back to top
		buildBackToTop();

		// Mobile click
		container.find('#mobile_toggle').on('touchstart mousedown', function(e) {
			e.preventDefault()
			sa.components.mobile_menu.showOrHide();
			return false;
		});
	};

	function buildBackToTop() {
		backToTop = templates.get('back_to_top');
		backToTop.on('click', function (e) {
			sa.scrollToPosition(0);
			e.preventDefault();
			return false;
		});
		var jWindow = $j(window);
		jWindow.on('scroll', function () {
			if (jWindow.scrollTop() > 40) {
				backToTop.addClass('showing');
			} else {
				backToTop.removeClass('showing');
			}
		});
	}

	function buildPermissionProfileSelector() {
		let ppsc = container.find('#permission_profile_selector_container');
		let permissionProfiles = user.userData.permissionProfiles;

		if (!permissionProfiles || permissionProfiles.length < 2) {
			ppsc.remove();
			return;
		}

		let selector = ppsc.find('#permission_profile_selector');
		for (let profile of permissionProfiles) {
			selector.append(new Option(profile.name, profile.id, profile.active, profile.active));
		}
		
		const prevVal = selector.val();
		selector.on('change', function (e) {
			// check if the home page editor is active and if it is, ask user to confirm
			const homepageEditorOn = !!$j('#body.homepage-editing-mode-on').length;
			
			if (homepageEditorOn) {
				sa.confirm({
					text: 'Are you sure you want to change permission profiles? Unsaved changes will be lost.',
					yesFunction: function () {
						user.setActivePermissionProfile(this.value);
					},
					noFunction: function () {
						selector.val(prevVal);
					}
				});
			} else {
				user.setActivePermissionProfile(this.value);
			}
		});
		if (user.hasAdminPermission(AdminPermission.Any)) {
			sa.components.helpExplanation.show(ppsc.find('label'), templates.get('maf_explanation').html());
		}
	}

	function buildEcommerce() {
		var shoppingCartButton = container.find('#shopping_cart');

		if (config.licensing['show_cart'] || config.licensingConfig.show) {
			let baseUrl = siteBaseUrl();
			shoppingCartButton.attr('href', baseUrl + '/shopping-cart');
		} else {
			shoppingCartButton.remove();
		}

		// sa.components.shoppingCart.count()
		if (!user.logged || (!config.licensingConfig.coupons_active && !config.licensingConfig.subscriptions_active)) {
			container.find('#download_credit').remove();
		} else {
			container.find('#download_credit #header-credit-amount').html(user.userData.licensing_uo ? (parseInt(user.userData.licensing_uo.coupon_credit) + parseInt(user.userData.licensing_uo.download_credit) >= 99999) ? '<span class="inf">∞</span>' : parseInt(user.userData.licensing_uo.coupon_credit) + parseInt(user.userData.licensing_uo.download_credit) : '0');
			var altText = '';
			if (user.userData.licensing_uo && parseInt(user.userData.licensing_uo.coupon_credit)) altText = user.userData.licensing_uo.coupon_credit + ' coupon downloads';
			if (altText) altText += ' and ';
			if (user.userData.licensing_uo && parseInt(user.userData.licensing_uo.download_credit)) altText += user.userData.licensing_uo.download_credit + ' subscription downloads';
			if (user.userData.licensing_uo && parseInt(user.userData.licensing_uo.coupon_credit) + parseInt(user.userData.licensing_uo.download_credit) >= 99999) altText = '∞ downloads';
			if (!altText) altText = '0 download credits';
			container.find('#download_credit').prop('alt', altText);
			container.find('#download_credit').prop('title', altText);
			container.find('#download_credit').on('click', function () {
				let baseUrl = siteBaseUrl();
				if (config.licensingConfig.subscriptions_active) {
					sa.router.routeTo(baseUrl + '/subscriptions');
				} else {
					sa.router.routeTo(baseUrl + '/coupon-entry');
				}
			});
		}
		//+ ((config.id == 48) ? //elias concierge
		//	'<div class="elias_concierge"><img src="images/custom_skins/elias/concierge_icon_35height.png"/></div>' : '')
	}

	function buildLogo() {
		topBar.setLogo(config.theme.topBarLogo);
	}

	topBar.setLogo = function (logoData) {
		var logoContainer = container.find('#logo');
		if (logoData.path) {
			$j('body').addClass('with_topbar_logo')
			var img = container.find('#logo_image').show();
			logoContainer.removeAttr('style');
			img.off('load');
			let loadFunction = function (retries) {
				let width = img.width();
				if (!width) {
					setTimeout(function () {
						loadFunction(retries ? retries + 1 : 1);
					}, 20);
				} else {
					logoContainer.css({ width: width + 20 });
					if (retries > 0) {
						console.log('Took ' + retries + ' to load image width');
					}
				}
			};
			img.on('load', function () { loadFunction(); });
			img.attr('src', logoData.path);
			let baseUrl = siteBaseUrl();
			let homePath = sa.router.pathConversionLookup(config.home);
			logoContainer.attr('href', baseUrl + '/' + homePath).show();
		} else {
			$j('body').removeClass('with_topbar_logo')
			logoContainer.find('#logo_image').hide();
		}
	};


	topBar.getLogoutPath = function () {
		let logoutForwardPath = 'https://' + config.domain;
		if (config.siteType === 'drop' && config.siteMode === 'receive') {
			logoutForwardPath = 'https://' + document.location.host + document.location.pathname;
		}
		return 'https://' + config.domain + '/logout.php?forward=' + encodeURIComponent(logoutForwardPath);

	}
	
	function buildInbox() {
		if (!user.logged) {
			container.find('#inbox_link').remove();
			return;
		}
		
		if (config.siteType === 'seller') {
			if (!user.hasAdminPermission(AdminPermission.Pando) && !user.hasAdminPermission(AdminPermission.Licensees)) {
				container.find('#inbox_link').remove();
				return;
			}
		} else if (config.siteType !== 'buyer' && config.siteType !== 'network') {
			container.find('#inbox_link').remove();
			return;
		}
		
		// Adjust the URL of the Inbox Link
		let link = config.siteType === 'buyer' || config.siteType === 'network' ? '/dashboard?p=inbox' : '/admin?p=inbox';
		let baseUrl = siteBaseUrl();
		container.find('#inbox_link').attr('href', baseUrl + link);
		
		let pollDelay = 60000; // Start with 1 minute
		let maxDelay = 600000; // Max out at 10 minutes
		let currentTimeout = null;
		
		function pollUnreadCount() {
			// Get the unread count
			sa.api.request({
				handler: 'Inbox/Inbox',
				action: 'getUnreadCount'
			}).then(function (r) {
				if (r && r.unreadCount >= 0) {
					pollDelay = 60000; // Reset to 1 minute on success
					if (r.unreadCount > 99) r.unreadCount = '99+';
					
					// Add the count to the inbox link
					// Check if message element is still in the DOM 
					let inboxLink = container.find('#inbox_link');

					if (r.unreadCount <= 0) {
						inboxLink.find('.message-count').remove();
						return;
					}
					
					if (!container.find('#inbox_link .message-count').length) {
						inboxLink.append(`<span class="message-count">${r.unreadCount}</span>`);
					} else {
						inboxLink.find('.message-count').text(r.unreadCount);
					}
				} else {
					console.warn('Polling for inbox count failed', r);
					pollDelay = Math.min(pollDelay * 2, maxDelay); // Exponential backoff
				}
				// Check if this timeout already exists, and if not, create it
				if (currentTimeout) clearTimeout(currentTimeout);
				currentTimeout = setTimeout(pollUnreadCount, pollDelay);
			});
		}
		pollUnreadCount();
		
		window.eventBus.on('inbox-updated', () => pollUnreadCount());
	}

	function buildUser() {
		if (user.logged) {
			if (!user.hasAdminPermission(AdminPermission.Any)) {
				container.find('#admin_link').remove();
			}
			// Set log out path
			container.find('#logout').attr('href', topBar.getLogoutPath())

			var userOptions = container.find('#user_options');
			var body = $j('body');

			userOptions.find('a').off().on('click', function () {
				userOptions.removeClass('showing');
				body.off('.top_bar_user_options');
			});

			if (!user.isSiteOwner()) {
				container.find('#get_started_link').remove();
			} else {
				container.find('#get_started_link').on('click', function () {
					sa.api.request({
						handler: 'settings',
						action: 'showGettingStarted'
					}).then(function () {
						let currentPath = sa.router.getCurrentPath(true);
						if (currentPath === 'admin' || currentPath === '/admin?p=users&tab=notifications') {
							sa.router.reloadPage();
						} else {
							sa.router.routeTo('/admin?p=users&tab=notifications');
						}
					});
				});
			}

			topBar.updateUserData();

			// expander
			container.find('#user_image_container').off('click').on('click', function () {
				userOptions.toggleClass('showing');
				if (config.siteType === 'drop') {
					container.find('#get_started_link').remove();
					container.find('#faq_link').remove();
				}
				if (userOptions.hasClass('showing')) {
					setTimeout(function () {
						body.on('click.top_bar_user_options', function (e) {
							if (e.target.id !== 'user_options' && $j(e.target).parents('#user_options').length === 0) {
								userOptions.removeClass('showing');
								body.off('.top_bar_user_options');
							}
						});
					}, 100);
				} else {
					body.off('.top_bar_user_options');
				}
			});
		} else {
			container.find('.login_button').on('click', function () {
				sa.components.login.show({
					whiteLabelAccount: config.siteType !== 'drop',
					lightbox: true,
					loginAction: 'reload',
					cancelAction: 'login',
					signupAction: 'show'
				});
				return false;
			});
			if (config.siteType !== 'drop') {
				container.find('.register_button').on('click', function () {
					sa.components.signup.show({
						whiteLabelAccount: config.siteType !== 'drop',
						lightbox: true,
						source: 'top bar',
						loginAction: 'reload',
						cancelAction: 'login',
						signupAction: 'show'
					});
					return false;
				});
			} else {
				container.find('.register_button').remove();
			}
		}
		
		
	}

	/**
	 * Updates the user display in the top bar so it shows the current data based on what's in the user object
	 */

	topBar.updateUserData = function () {
		if (user.userData.image && user.userData.image.indexOf('default_editor') === -1) {
			container.find('.user_image').removeClass('fas fa-user-circle').find('img').attr('src', user.userData.image);
		}

		container.find('#username').html(StringSanitize.encodeIfNotEncoded(user.userData.username));
		container.find('#user_email').html(StringSanitize.encodeIfNotEncoded(user.userData.email));

		container.find('.user_option_link').each(function() {
			let href = $j(this).attr('href');
			if (!href) return;
			
			let url = sa.router.buildFullUrl(href);
			url.pathname = sa.router.addDevFragment(url.pathname);
			url.hash = '';
			
			let skipBuildingLink = $j(this).attr('data-router-ignore') === 'true';
			let isSameOrigin = sa.router.urlsHaveSameHost(url, new URL(window.location.href));
			
			if (skipBuildingLink || !isSameOrigin) {
				return;
			}
			
			$j(this).attr('href', url.href);
		});
	};

	function buildBrowse() {

		var browseContainer = container.find('#browse_container');

		if (config.showBrowse && config.clouds.length) {

			var browseColumn = $j('<div class="column"></div>');
			config.clouds.each(function (i, cloud) {
				browseColumn.append(templates.get('cloud_button', { cloudName: cloud.name }).on('click', function (e) {
					sa.components.cloudBrowser.showCloud(cloud);
					e.preventDefault();
					return false;
				}));
				if (i % 2 == 1) {
					browseContainer.append(browseColumn);
					browseColumn = $j('<div class="column"></div>');
				}
			});
			if (browseColumn.html()) {
				browseContainer.append(browseColumn);
			}
			browseContainer.append('<div class="clr"></div>');

		} else {

			browseContainer.remove();

		}
	}

	function buildSearch() {
		var searchContainer = container.find('#search_container');
		if (sa.search) {
			sa.search.build(container);
			container.find('#search_box').on('focus', function () {
				searchContainer.addClass('focused');
			}).on('blur', function () {
				searchContainer.removeClass('focused');
			});
			if (!config.showSonicSearch || config.grayLabel) {
				searchContainer.find('.sonic_search').remove();
			}
		} else {
			searchContainer.remove();
		}

		// Check if clicked outside search area and close the advanced search
		window.addEventListener('mousedown', (e) => {
			const advancedSearchActive = $j('#search_container').hasClass('asearch_expanded');
			if (advancedSearchActive) {
				const clickedOutsideSearch = !document.querySelector('.asearch_expanded').contains(e.target);
				
				if (clickedOutsideSearch) {
					topBar?.hideAdvancedSearch();
				}
			}
		});
	}

	function buildUnpaidNotice() {
		if (!config.billingState) {
			container.find('#unpaid_notice').remove();
		}
	}

	function clearDotInterval() {
		if (dotInterval) {
			clearInterval(dotInterval);
			dotInterval = null;
		}
	}

	topBar.setSonicSearchStatus = function (buttonEnabled, text) {
		clearDotInterval();
		if (buttonEnabled) {
			container.find('#sonic_search_button').removeClass('hidden');
			container.find('#sonic_search_text').addClass('hidden');
		} else {
			container.find('#sonic_search_button').addClass('hidden');
			container.find('#sonic_search_text').html('SonicSearch Status: ' + text + '<span class="dots"></span>').removeClass('hidden');
			var dotContainer = container.find('#sonic_search_text .dots');
			var dotString = '...';
			var dotCount = 1;
			dotInterval = setInterval(function () {
				dotContainer.html(dotString.substring(0, dotCount));
				dotCount++;
				if (dotCount > 3) dotCount = 0;
			}, 500);
		}
	};

	topBar.setSearchProgress = function (progress) {
		container.find('#progress_bar').css({ width: Math.min(progress * 100, 100) + '%' });
	};

	topBar.toggleAdvancedSearch = function () {
		if (container.find('#search_container').hasClass('asearch_expanded')) {
			topBar?.hideAdvancedSearch();
		} else {
			topBar?.showAdvancedSearch();
		}
	};
	
	topBar.showingAdvancedSearch = function() {
		return advancedSearchActive;
	}

	topBar.hideAdvancedSearch = function () {
		container.find('#search_container').removeClass('asearch_expanded');
		advancedSearchActive = false;
	};

	topBar.showAdvancedSearch = function () {
		container.find('#search_container').addClass('asearch_expanded');
		advancedSearchActive = true;
	};

	topBar.showCurrentSearch = function (displayValue, inputValue) {
		let searchCurrent = container.find('#search_current');
		const $searchContainer = container.find('#search_container');
		searchCurrent.addClass('visible');
		searchCurrent.find('.type').html(displayValue);
		searchCurrent.find('input[name=search_current]').val(inputValue);
		$searchContainer.addClass('small_placeholder')

		topBar.sizeSearchBox();
	};

	topBar.sizeSearchBox = function() {
		const $searchCurrent = container.find('#search_current:visible');
		const $searchContainer = container.find('#search_container');
		var isMobile = sa.isMobile();
		if (!isMobile) {
			const searchCurrentWidth = $searchCurrent.length ? $searchCurrent.innerWidth() : 0;
			let topBarButtonsWidth = searchCurrentWidth;
			$searchContainer.find(".top_bar_button:visible").each(function() {
				if ($j(this).is('#search_button')) return;
				topBarButtonsWidth += $j(this).innerWidth();
			})
			container.find('#search_box').css({ paddingRight: topBarButtonsWidth + 'px' });
		} else {
			container.find('#search_box').css({ paddingRight: ''});
		}
	}

	topBar.hideCurrentSearch = function () {
		const $searchContainer = container.find('#search_container');
		container.find('#search_current').removeClass('visible');
		$searchContainer.removeClass('small_placeholder');

		topBar.sizeSearchBox();
	};

	return topBar;

})();

/**
 * Handles access to and the framerate for all waveforms
 * Singleton
 */
sa.components.waveformManager = (function() {
	
	var waveformManager = {};

	/** @var {TemplateSet} waveformManager.templates  */
	waveformManager.templates = null;
	
	var colors = {
		lightBarColor : '',
		lightBarShadowColor : '',
		darkBarColor : '',
		darkBarShadowColor : '',
		playheadColor : '',
		hoverBarColor : ''
	};

	/**
	 * Adds color data to the waveform object's local cache
	 * Caches the color info so each waveform doesn't have to load it independently
	 * @param {Waveform} waveform
	 */
	waveformManager.addColors = function(waveform) {
		if (waveform.lightBarColor) return; // it's already set
		if (!colors.lightBarColor) {
			// i wanted to set the colors in css but you can't use a css selector to specify a canvas color
			// so we create a temp div that has the appropriate class and use jquery to figure out what the css color is
			// it's really just a hack to read info from the css file into js
			colors.lightBarColor = getCSSColor('waveform_light_bar');
			colors.lightBarShadowColor = getCSSColor('waveform_light_bar_shadow');
			colors.darkBarColor = getCSSColor('waveform_dark_bar');
			colors.darkBarShadowColor = getCSSColor('waveform_dark_bar_shadow');
			colors.playheadColor = getCSSColor('waveform_playhead_color');
			colors.hoverBarColor = getCSSColor('waveform_hover_bar_color');
		}
		waveform.lightBarColor = colors.lightBarColor;
		waveform.lightBarShadowColor = colors.lightBarShadowColor;
		waveform.darkBarColor = colors.darkBarColor;
		waveform.darkBarShadowColor = colors.darkBarShadowColor;
		waveform.playheadColor = colors.playheadColor;
		waveform.hoverBarColor = colors.hoverBarColor;
	};

	/**
	 * Resizes all the waveforms
	 */
	waveformManager.resizeWaveforms = function() {
		var waveforms = $j('.waveform_container');
		for (var i = 0; i < waveforms.length; i++) {
			var waveform = $j(waveforms[i]).data('waveform');
			waveform.resize();
		}

		//resize clippers for sonic search results
		if (sa.getCurrentPageName() == 'sonicsearch' && $j('#ss_clipper_left').length) {
			sa.pages.sonicsearch.clipperResize();
		}
	};

	/**
	 * Updates the state of a single waveform
	 * 	Called by this.updatePlayTime and each waveform after it's initially created
	 * @param {Waveform} waveform the waveform to update
	 */
	waveformManager.updateWaveform = function(waveform) {
		if (sa.components.player.isPlayingTrack(Math.abs(waveform.trackId))) {
			waveform.updateProgress(sa.components.player.getProgress(), sa.components.player.getLoadProgress());
		} else {
			waveform.disable();
		}
	};

	/**
	 * Updates state on all the waveforms
	 */
	waveformManager.updatePlayTime = function() {
		var waveforms = $j('.waveform_container');
		for (var len = waveforms.length, i = 0; i < len; i++) {
			waveformManager.updateWaveform($j(waveforms[i]).data('waveform'));
		}
	};

	waveformManager.removeHovers = function() {
		$j('.waveform_hover').remove();
	};

	waveformManager.build = function() {
		waveformManager.templates = sa.templates.get('components.waveform_manager');
		
		setInterval(function() { waveformManager.updatePlayTime(); }, 50);
		// make sure waveforms are resized as the window is
		// we don't want to reload constantly as the user drags around (if they're free-form resizing) so we wait for stability
		var win = $j(window),
			windowWidth = win.width(),
			windowResizeTimer = null;
		win.on('resize', function() {
			var newWidth = win.width();
			if (newWidth == windowWidth) return;
			windowWidth = newWidth;
			if (windowResizeTimer) {
				clearTimeout(windowResizeTimer);
			}
			windowResizeTimer = setTimeout(function() {
				waveformManager.resizeWaveforms();
			}, 500);
		});

		sa.on('beforeRouteChange', function() {
			waveformManager.removeHovers();
		});
	};
	
	return waveformManager;
	
})();
sa.components.yt_channel_search = (function() {

	let yt_channel_search = {};
	let templates;
	let currentFocusBox;
	let cont;

	yt_channel_search.show = function (cb = function(r) { }, showConfirm = true) {
		cont = templates.get('yt_search_cont');
		cont.find('a.search-channel').on('click', function () {
			var searchQuery = cont.find('#yt-search').val();
			currentFocusBox.showLoader('Searching YouTube Channels...');
			sa.api.request({
				handler: 'content-id/UserWhitelist',
				action: 'SearchChannels',
				postData: { query: searchQuery }
			}).then(showResultList).catch(function (e) {
				currentFocusBox.hideLoader();
				console.log('Error:', e);
				sa.alert(e.message);
			});
		});

		cont.find('.search-results').on('click', 'a.get-page', function () {
			var searchQuery = cont.find('#yt-search').val();
			var ytPg = $j(this).attr("data-page");
			currentFocusBox.showLoader('Searching YouTube Channels...');
			sa.api.request({
				handler: 'content-id/UserWhitelist',
				action: 'SearchChannels',
				postData: { query: searchQuery, page: ytPg ? ytPg : ''}
			}).then(showResultList).catch(function (e) {
				currentFocusBox.hideLoader();
				console.log('Error: ' + e.message);
				sa.alert(e.message);
			});
		});

		currentFocusBox = new FocusBox(cont);
		currentFocusBox.show();

		function showResultList(r) {

			currentFocusBox.hideLoader();

			let list = cont.find('#yt-searchList');
			let paginationCont = cont.find('#yt-paging');

			list.empty();
			paginationCont.empty();
			sa.scrollToElement(list);

			console.log('youtube search results:', r);

			let results = r.items;
			for (var i = 0, len = results.length; i < len; i++) {
				var ch = results[i].snippet;
				var img = '<img height="88" width="88" src="' + (ch.thumbnails.default.url || 'images/shared/default_artist6.jpg') + '" />';
				var chParams = {
					thumbnail: img,
					channelId: ch.channelId,
					channelTitle: ch.channelTitle,
					channelDescription: ch.description
				};
				var chTemplate = templates.get('yt_channel_item', chParams);
				list.append(chTemplate);
			}

			if (r) {
				let paging = {
					showing: r.items.length || 0,
					totalResults: r.pageVars.totalResults || 0,
					prev: r.prevPageToken || '',
					next: r.nextPageToken || ''
				};

				cont.find('.result_desc').html('<h5>Showing ' + paging.showing + ' of about ' + paging.totalResults + ' results.</h5>');

				var pagingtpl = templates.get('yt_paging_cont', paging);
				paginationCont.append(pagingtpl);

				if (!paging.prev) paginationCont.find('#list_page_prev').remove();
				if (!paging.next) paginationCont.find('#list_page_next').remove();
			}

			list.find('a.yt-add-channel').on('click', function () {
				let selectedChannelId = $j(this).attr("data-channelId") || '';
				let selectedChannelName = $j(this).attr("data-channelName") || '';
				if (showConfirm) {
					sa.confirm({
						text: 'Are you sure you want to add <b>' + selectedChannelName + '</b> to your whitelist?',
						yesFunction: function () {
							if (currentFocusBox) currentFocusBox.hide();
							return cb(selectedChannelId);
						},
						yesText: 'Add Channel'
					});	
				} else {
					if (currentFocusBox) currentFocusBox.hide();
					return cb(selectedChannelId);
				}
			});
		}

	};


	yt_channel_search.build = function() {
		templates = sa.templates.get('components.yt_channel_search');
	};

	return yt_channel_search;

})();/**
 * The player!
 */

sa.components.player = (function() {

	var player = {
		parent : 'bottomBar',
		attachOnLoad : true,
		attachOnReceiveLoad : true
	};

	var templates;
	var container,
		savedPlaylistData = null,
		nexting = false; // used to make sure we finish one next press before trying to handle the next one. spam clicking the next button is bad

	var playingTrackId = 0;
	var currentSource = '';
	var playingTrackData = {
		id : 0,
		actualLength : 0
	};
	var playerObject = null;
	var playerType = '';
	var playing = false;
	var quickProjectModeEnabled = false;


	var progressBarDragDot;
	var progressBarDisplay;
	var loadProgressBarDisplay;
	var currentTimeDisplay;
	var totalTimeDisplay;
	var lastTotalTime = -1; // cache so we don't have to update the value every tick
	var continuousPlayDisplay;
	var titleDisplay;
	var downloadContainer;
	var sonicSearchContainer;
	let optionsContainer;
	var artDisplay;
	var volumeDisplay;
	var volumeBarDisplay;
	var infoContainer;

	const playEventHandler = (data) => {
		const { track, resourceData } = data;

		// If it's already playing, do nothing
		if (player.isPlaying() && track.id === player.getPlayingTrackId()) {
			return;
		}

		// If it isn't playing and is the current track, just play
		if (!player.isPlaying() && track.id === player.getPlayingTrackId()) {
			player.playPause();
			return;
		}

		// If it's playing and not the current track, switch to the new track
		if (player.isPlaying() && track.id !== player.getPlayingTrackId()) {
			player.playTrack(track.id, resourceData, resourceData.items.indexOf(track.id));
			return;
		}

		// If nothing is playing, play the requested track
		if (!player.isPlaying()) {
			player.playTrack(track.id, resourceData, resourceData.items.indexOf(track.id));
		}
	};
	
	window.eventBus.on(AUDIO_EVENTS.COMMANDS.PLAY_TRACK, playEventHandler);
	window.eventBus.on(AUDIO_EVENTS.COMMANDS.PLAY, playEventHandler);
	
	window.eventBus.on(AUDIO_EVENTS.COMMANDS.PAUSE, () => {
		if (player.isPlaying()) player.playPause();
	});
	
	window.eventBus.on(AUDIO_EVENTS.COMMANDS.SKIP_NEXT, () => {
		player.next(1);
	});

	window.eventBus.on(AUDIO_EVENTS.COMMANDS.SKIP_PREVIOUS, () => {
		player.next(-1);
	});

	/**
	 * Function used to generate a play button image with the appropriate onclick to actually play
	 * @param {int} trackId the track's id
	 * @param {object=} params
	 * 	@property {string} location a unique name for where on the page the image is. i.e. explorer or history. used to create the image's id (used to do more. might not be necessary)
	 * 	@property {boolean} large should the play button be one of the large, detail page buttons (defaults to no)
	 * 	@property {object} importTrack data for the import track if it is one (defaults to null)
	 * @return {JQuery} the button
	 */
	player.generatePlayButton = function(trackId, params) {

		params = $j.extend({
			location : 'null_location',
			large : false,
			importTrack : null
		}, params);

		if (params.importTrack) trackId = 0 - params.importTrack.id;

		var button = templates.get('play_button', { trackId : trackId, location : params.location });
		button.data({ trackId : trackId });

		if (player.isPlayingTrack(trackId) && playing) {
			button.addClass('playing');
		}
		if (params.large) {
			button.addClass('large');
		}

		button.on('click touchend', function(e) {
			// Close the search bar if it's open
			sa.components.topBar?.hideAdvancedSearch();

			if (player.isPlayingTrack(trackId)) {
				// same track
				// console.log("pause/playing same track")
				sa.components.bottomBar.showTrack(trackId);
				player.playPause();
			} else {
				// track changed
				currentSource = params.location;
				// console.log("playing different track")
				if (!params.importTrack) {
					// figure out the request string for the track list in which this button sits
					var trackList = button.parents('.track_list:first'),
						playlistData = {};
					let playIndex = false;
					// which button is this in case we have multiple tracks in the same playlist
					trackList.find('.play_button').each(function(index) {
						if (this === button[0]) {
							playIndex = index;
							return false;
						}
					})
					if (trackList.length) {
						playlistData = trackList.data('listObject').playlistData;
					} else {
						playlistData.items = [trackId];
						playlistData.itemOffset = 0;
						playlistData.totalItems = 1;
					}
					player.playTrack(trackId, playlistData, playIndex);
					sa.components.bottomBar.showTrack(trackId);
					getTrackList().highlightTrack(trackId);
				} else if (params.importTrack.type == 'sonicsearch') {
					player.playSonicSearchTrack(params.importTrack);
					sa.components.bottomBar.showTrack(params.importTrack.id);
					$j('.player_controls_container .play').removeClass('disabled')
				} else {
					player.playImportTrack(params.importTrack);
				}
			}
			e.preventDefault();
			e.stopPropagation();
		});

		return button;
	};

	/**
	 * Updates the state of all the play/pause buttons for a given track
	 * @param {int} trackId the id of the track to update state for
	 */
	player.updatePlayButtons = function(trackId) {
		if (player.isPlayingTrack(trackId) && playing) {
			$j(`.track_list .play_button:not(.play_button_${trackId})`).removeClass('playing');
			$j('.play_button_' + trackId).addClass('playing');
		} else {
			$j('.playing.play_button_' + trackId).removeClass('playing');
		}
	};

	/**
	 * Shows a loading spinner when a track is loading
	 *
	 * @param {int} trackId loading track ID
	 * @param {boolean} loading is it loading or not
	 */
	player.setLoadingTrack = function(trackId, loading) {
		const loadingClass = 'track_loading';
		$j(`.play_button`).removeClass(loadingClass);
		if (loading) {
			$j('.play_button_' + trackId).addClass(loadingClass);
		}

	}

	/**
	 * Checks if the player is playing the specific track
	 * @param {int} trackId
	 * @returns {boolean}
	 */
	player.isPlayingTrack = function(trackId) {
		return trackId == playingTrackId;
	};

	/**
	 * Returns the id of the currently playing track
	 * @returns {int} 0 if not playing anything. if the number you get is negative, it's an import track
	 */
	player.getPlayingTrackId = function() {
		return playingTrackId;
	};

	/**
	 * Gets the actual player object, be it a flash <object> or an html5 <audio> element
	 * @return {HTMLElement} the player
	 */
	player.getPlayer = function () {
		return playerObject;
	};

	/**
	 * Plays a specific track
	 * @param {int} id the id of the track to play
	 * @param {object} playlistData with items:array, totalItems:int, itemOffset:int, requestString:string
	 */
	let prevPlayId;
	player.playTrack = function (id, playlistData, playlistIndex = false) {
		trackBank.clear('player');
		
		if (player.getPlayingTrackId() !== id) {
			player.sendEvent(AUDIO_EVENTS.STATE.BUFFERING, { isBuffering: true, trackId: id });
		}
		
		if (playingTrackId) {
			player.updatePlaying(playingTrackId, false);
		}
		playlistData = $j.extend(true, {}, playlistData); // clone the object so when the track list updates, we don't lose it
		console.log('playing ' + id + ' with play list data: ', playlistData);
		savedPlaylistData = playlistData;
		if (prevPlayId) {
			player.setLoadingTrack(prevPlayId, false)
		}
		player.setLoadingTrack(id, true)
		prevPlayId = id;

		var fl = player.getPlayer();

		// this function actually plays the track once playingTrackData is set and the file has the correct url
		// abstracted into a function because there are multiple places it can be called
		var playFunc = function() {
			fl.playTrack();
			playingTrackId = id;
			
			// Send global playing event
			player.sendEvent(AUDIO_EVENTS.STATE.PLAYING, { trackId: id });

			sa.components.bottomBar.showTrack(id);
			
			updateTrackDisplay();
			player.setVolume(player.getVolume());
			container.find('.play').removeClass('disabled');

			// play list stuff
			// figure out what track out of X we're playing and enable/disable the next/prev buttons
			const noPlaylistIndex = playlistIndex !== false;
			const backupIndex = playlistData.items.indexOf(id) + playlistData.itemOffset + 1;
			let currentIndex = (playlistIndex !== false ? playlistIndex : playlistData.items.indexOf(id)) + playlistData.itemOffset + 1;
			playlistData.currentIndex = currentIndex;

			// enable or disable next and prev buttons
			if (currentIndex != 1) {
				$j('.player_controls_container .previous').removeClass('disabled');
			} else {
				$j('.player_controls_container .previous').addClass('disabled');
			}
			if (currentIndex < playlistData.totalItems) {
				$j('.player_controls_container .next').removeClass('disabled');
			} else {
				$j('.player_controls_container .next').addClass('disabled');
			}

			if (quickProjectModeEnabled) {
				player.addQuickProjectButtonForTrack(playingTrackId)
			}
		};

		if (!(BrowserDetect.isSafari && BrowserDetect.ua.indexOf('version/11') !== -1)) {
			ajax('p=download_auth&trackId=' + id + '&source=' + encodeURIComponent(currentSource) + '&type=' + playerType + (window['code'] ? '&embedCode=' + code : ''), function(response) {
				console.log("got download auth response");
				if (response[0].params) {
					trackBank.load(id, 'player', function(newTrackData) {
						playingTrackData = newTrackData;
						if (!playingTrackData) {
							sa.alert('Track could not be loaded for playback.');
							return;
						}
						playingTrackData.file.playHtml5 = playingTrackData.file.playHtml5.replace(/\?.*/, '') + '?' + response[0].params;
						playFunc();
					});
				} else {
					sa.notify({ text : 'Permission denied trying to play track' });
				}
			});
		} else {
			/**
			 * PROBABLY DEPRECATED: the following is probably not true
			 */
			// in ios, playing an audio element has to happen directly from a user's interaction. if you wait for an ajax callback to get the correct file url, that won't count
			// and the track won't play. to get around this restriction, we bake a 24 hour valid html5 playback path into the track data on the server side when we know we've got ios
			// so it can play without having to do an ajax call first. we still do the ajax so we get the metrics but we typically ignore the result.
			// shortcomings:
			//  this is less secure but it's still only going to work for users who have access to those tracks so i'm hoping it's not a big deal. we could miss metrics if you're smart
			//  if you leave your browser on the page for more than a day and then come back, it won't play anymore until you reload. i decided that was acceptable
			playingTrackData = getTrack(id);
			//console.log('ios playing track with url: ' + playingTrackData.file.playHtml5);
			ajax('p=download_auth&trackId=' + id + '&source=' + encodeURIComponent(currentSource) + '&type=' + playerType + (window['downloadCode'] ? '&code=' + window['downloadCode'] : ''), function(response) {
				if (!response[0].params) {
					sa.notify({ text : 'Permission denied trying to play track' });
				}
			});
			playFunc();
		}
	};

	function updateTrackDisplay() {
		if (!playingTrackData) return;
		titleDisplay.html( playingTrackData.title );
		if (playingTrackData.album && playingTrackData.album.id !== 0 && playingTrackData.album.image.indexOf('user_data') !== -1) {
			artDisplay.html('<img src="' + playingTrackData.album.image + '"/>');
			infoContainer.addClass('showing_art');
		} else {
			infoContainer.addClass('showing_art');
			artDisplay.html(getDefaultArtElement()[0].outerHTML);
		}
		downloadContainer.empty();
		sonicSearchContainer.empty();
		optionsContainer.empty();

		// Show waveform
		if (sa.isMobile()) {
			new Waveform(playingTrackId, container.find('.waveform'), false);
		}

		let showDownloadButton = !sa.embedded && (ecommerceDownloadAvailable || playingTrackData.can_download);
		let showOptionsButton = !sa.embedded;

		let optionsDownloadButton;

		if (config.siteType === 'drop') {
			// the drop download button
			let format;
			if (playingTrackData.formats.wav) {
				format = 'wav';
			}  else if (playingTrackData.formats.aiff) {
				format = 'aiff';
			} else {
				format = 'mp3';
			}

			if (showDownloadButton) {
				optionsDownloadButton = sa.components.downloadFormatSelector.generateSingleFormatTrackDownloadButton(playingTrackData.id, format, playingTrackData.formats[format]);
				downloadContainer.append(sa.components.downloadFormatSelector.generateSingleFormatTrackDownloadButton(playingTrackData.id, format, playingTrackData.formats[format]));
			}
		} else {
			if (showDownloadButton) {
				optionsDownloadButton = sa.components.downloadFormatSelector.generateDownloadButton({ type : 'track', item : playingTrackData });
				downloadContainer.append(sa.components.downloadFormatSelector.generateDownloadButton({ type : 'track', item : playingTrackData }));
			}
			if (config.showSonicSearch) {
				sonicSearchContainer.append($j('<div class="options_menu_anchor hiding_overflow fa fa-bolt" title="Find Similar"></div>'));
				sonicSearchContainer.find('.fa-bolt').on('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					sa.router.routeTo(siteBaseUrl() + '/sonicsearch?track_search=' + playingTrackId);
				});
			}
		}

		if (showOptionsButton && showDownloadButton) {
			let optionsDropDown = getOptionsDropDown(playingTrackData.id, 'track', playingTrackData, false);
			// optionsDropDown = attachDownloadOptionToOptionsMenu(optionsDropDown, optionsDownloadButton);
			let $options = $j('<div class="options">').append(optionsDropDown);
			// $options.append(optionsDownloadButton);
			optionsContainer.append($options);
		} else if (showOptionsButton) {
			let optionsDropDown = getOptionsDropDown(playingTrackData.id, 'track', playingTrackData, true);
			let $options = $j('<div class="options">').append(optionsDropDown);
			optionsContainer.append($options);
		}
	}

	/**
	 * Advances playback in one direction
	 * @param {int} direction should be -1 for previous or 1 for next
	 * @param {boolean} showTrackChangeNotification should we show a notification when the track changes?
	 */
	player.next = function(direction, showTrackChangeNotification = true) {
		if (nexting) return;
		
		// Handle Player Events
		player.sendEvent(AUDIO_EVENTS.STATE.PAUSED, { trackId: player.getPlayingTrackData().id });
		// player.pause();
		
		nexting = true;
		var playlistData = savedPlaylistData,
		newIndex = playlistData.currentIndex + direction;
		if (newIndex < 1 || newIndex > playlistData.totalItems) return; // out of bounds check
		
		// see if we have the track id
		const currentPlaylistItemIndex = playlistData.currentIndex - 1;
		const currentTrackId = playlistData.items[currentPlaylistItemIndex];
		var oldItemIndex = currentTrackId && currentTrackId == playingTrackId ? currentPlaylistItemIndex : playlistData.items.indexOf(playingTrackId),
		newItemIndex = oldItemIndex + direction;
		
		// Send buffering state
		player.sendEvent(AUDIO_EVENTS.STATE.BUFFERING, { isBuffering: true, trackId: playlistData.items[newItemIndex] });
		
		if (newItemIndex < 0 || newItemIndex >= playlistData.items.length) {
			// out of what we've got. we'll have to request data from the track list
			console.log('not in item list. going to have to request');
			// figure out what page the last request was on
			var requestString = playlistData.requestString,
				matches;
			if (matches = requestString.match(/pg=([0-9]+)/)) {
				requestString = requestString.replace(matches[0], 'pg=' + (parseInt(matches[1]) + direction));
			} else {
				// no page. must be 0?
				requestString += '&pg=1';
			}
			ajax(requestString, function(response) {
				// now we store the new tracks ids in the savedPlaylistData items array, store the tracks in the track bank, and call this function again
				trackBank.clear('player-pagination');
				var newItems = [];
				for (var i = 1, len = response.length; i < len; i++) {
					var track = response[i];
					if (response[0].project || response[0].cueSheet) {// projects and cue sheets have their tracks nested in type objects
						if (track.track) {
							trackBank.add(track.track, 'player-pagination');
							newItems.push(track.track.id);
						} // else it's an album
					} else {
						trackBank.add(track, 'player-pagination');
						newItems.push(track.id);
					}
				}
				console.log('loaded ' + newItems.length + ' new items', newItems);
				if (!newItems.length) {
					// we couldn't load any tracks?
					if (!response[0].project && !response[0].cueSheet) {
						sa.notify({ text: 'Unable to load next tracks in playlist. Sorry. Please reload and try again.' });
					} // this isn't actually an error for projects or cue sheets because the next page may have contained all albums
				}
				// now add the new items to play list data items
				if (direction == 1) {
					playlistData.items = playlistData.items.concat(newItems);
				} else {
					playlistData.items = newItems.concat(playlistData.items);
					// since we added new items to the beginning of the array, our offset is off
					playlistData.itemOffset -= newItems.length;
					playlistData.currentIndex += newItems.length;
				}
				// save our updated request string
				playlistData.requestString = requestString;
				// update the saved array
				savedPlaylistData = playlistData;
				// and the next call to next() should have the items it needs!
				nexting = false;
				player.next(direction);
			});
		} else {
			// we have the id of the track to play! before we can do that, we need the track's data. see if it's in the bank
			const trackId = playlistData.items[newItemIndex];
			trackBank.load(trackId, 'player', function(trackData) {
				if (!trackData) {
					sa.alert('Track could not be loaded for playback.');
					return;
				}
				// we have everything! play it!
				player.playTrack(trackId, playlistData, newItemIndex);
				getTrackList().highlightTrack(trackId);
				player.showTrackData(trackData, showTrackChangeNotification);
				nexting = false;
				
				// Handle Player Events
				player.sendEvent(AUDIO_EVENTS.STATE.PLAYING, { trackId });
			});
		}
	};

	player.showTrackData = function (trackData, showNotification = true) {
		if (!showNotification) return;

		sa.notify({
			cancelPreviousOfType: true,
			text: '<a href="' + getTrackLink(trackData.id) + '">' + trackData.title + '</a>',
			type: sa.notify.notificationTypes.track
		});
	};

	/**
	 * Plays an import track on the upload metadata page
	 * @param {object} trackData all the data for the track
	 */
	player.playImportTrack = function(trackData) {
		if (!trackData.playHtml5File) {
			sa.alert({ text : 'Playback file not ready. Please try again later.' });
			return;
		}
		trackBank.clear('player');
		if (playingTrackId) {
			player.updatePlaying(playingTrackId, false);
		}
		var fl = player.getPlayer();
		// we create a faux track data object the player can load so it'll be able to play
		negativeId = 0 - trackData.id;
		playingTrackData = {
			importTrack : 1,
			id: negativeId,
			file : {
				play : trackData['playFile'],
				playHtml5 : trackData.playHtml5File
			},
			title : trackData.title,
			artist : { name : trackData.artist },
			actualLength : trackData.length,
			length : trackData.length
		};
		fl.playTrack();
		playingTrackId = negativeId;
		updateTrackDisplay();
		$j('#progress_display span').html('Track pending import');
		player.setVolume(player.getVolume());
	};

	/**
	 * Plays a sonic search track on the sonic search results page
	 * @param {object} trackData all the data for the track
	 */
	player.playSonicSearchTrack = function(trackData) {
		if (!trackData.playHtml5File) {
			sa.alert({ text : 'Playback file not ready. Please try again later.' });
			return;
		}
		trackBank.clear('player');
		if (playingTrackId) {
			player.updatePlaying(playingTrackId, false);
		}
		var fl = player.getPlayer();

		// we create a faux track data object the player can load so it'll be able to play
		playingTrackData = {
			sonicsearch : 1,
			importTrack : 1,
			id : 0 - trackData.id,
			file : {
				play : trackData['playFile'],
				playHtml5 : trackData.playHtml5File
			},
			title : trackData.title,
			artist : { name : trackData.artist },
			actualLength : trackData.length,
			length : trackData.length
		};
		fl.playTrack();
		playingTrackId = 0 - trackData.id;
		updateTrackDisplay();
		player.setVolume(player.getVolume());
	};

	/**
	 * Checks if the player is currently playing (as opposed to being paused or stopped)
	 * @returns {boolean}
	 */
	player.isPlaying = function() {
		return playing;
	};

	/**
	 * Updates the stored and displayed track and it's playing state
	 * @param {int} id the id of the playing track
	 * @param {boolean} isPlaying is it playing? as opposed to paused
	 */
	player.updatePlaying = function (id, isPlaying) {
		if (isPlaying) {
			container.find('.play_button').addClass('playing');
			player.sendEvent(AUDIO_EVENTS.STATE.PLAYING, { trackId: id });
		} else {
			container.find('.play_button').removeClass('playing');
			player.sendEvent(AUDIO_EVENTS.STATE.PAUSED, { trackId: id });
		}
		playingTrackId = id;
		playing = isPlaying;
		player.setLoadingTrack(id, false);
		player.updatePlayButtons(id);
	};

	/**
	 * If the player is paused, plays it. If it's playing, pauses it
	 */
	player.playPause = function () {
		var fl = player.getPlayer();
		fl.playPause();
		if (playing) {
			player.sendEvent(AUDIO_EVENTS.STATE.PAUSED, { trackId: player.getPlayingTrackData().id });
		} else {
			player.sendEvent(AUDIO_EVENTS.STATE.PLAYING, { trackId: player.getPlayingTrackData().id });
		}
	};
	
	player.pause = function () {
		const fl = player.getPlayer();
		player.sendEvent(AUDIO_EVENTS.STATE.PAUSED, { trackId: player.getPlayingTrackData().id });
		fl.pause();
	}

	/**
	 * Requests that the html5 player object send us a new updatePlaying() status
	 */
	player.manualPlayingUpdate = function() {
		var fl = player.getPlayer();
		try {
			fl.updatePlaying();
		} catch (e) {
			setTimeout(function () {
				player.manualPlayingUpdate();
			}, 100);
			console.log('unable to updatePlaying because of error', e);
		}

	};

	/**
	 * Gets the data about what track is playing
	 *  Used by flash
	 * @return {object} track data
	 */
	player.getPlayingTrackData = function() {
		return {
			currentSource : currentSource,
			id : playingTrackData.id,
			length : playingTrackData.length,
			file : $j.extend(true, {}, playingTrackData.file)
		};
	};

	/**
	 * Gets the current playingTrackData. You probably don't want this function. Use player.getPlayingTrackData instead
	 * @returns {{}}
	 */
	player.getRawPlayingTrackData = function() {
		return playingTrackData;
	};

	/**
	 * Gets the volume in the player object
	 * @return {number} volume between 0 and 1, inclusive
	 */
	player.getVolume = function() {
		return user.getVolume();
	};

	/**
	 * Sets the volume in the player
	 * @param {number} volume between 0 and 1, inclusive
	 */
	player.setVolume = function(volume) {
		volume = Math.min(1, Math.max(0, volume));
		var pl = player.getPlayer();
		if (pl.setVolume) {
			// when the site is loading, if you try to set volume, it won't be there yet and this throws an error if you don't do this check
			pl.setVolume(volume);
		}
		user.setVolume(volume);

		volumeBarDisplay.css({ top : ((1 - volume) * 100) + '%' });
		volumeDisplay.removeClass('fa-volume-up fa-volume-down fa-volume-off');
		if (volume == 0) {
			volumeDisplay.addClass('fa-volume-off');
		} else if (volume < .6) {
			volumeDisplay.addClass('fa-volume-down');
		} else {
			volumeDisplay.addClass('fa-volume-up');
		}
	};

	/**
	 * Gets the progress through the currently playing track
	 * @return {number} the progress as a percentage (0 if no playing track)
	 */
	player.getProgress = function() {
		return player.getPlayer().getProgress();
	};

	function toggleVolumeBar() {
		volumeDisplay.toggleClass('volume_bar_showing');
	}

	function hideVolumeBar() {
		volumeDisplay.removeClass('volume_bar_showing');
	}

	/**
	 * Sets the progress of the currently playing track in the player
	 * @param {number} progress the progress of the playing track as a percentage
	 */
	player.setProgress = function(progress) {
		player.getPlayer().setProgress(progress);
	};

	/**
	 * Gets the buffering progress of the currently playing track
	 * @return {number} the load progress as a percentage (0 if no playing track)
	 */
	player.getLoadProgress = function() {
		return player.getPlayer().getLoadProgress();
	};

	/**
	 * Updates the play bar
	 *  Called by html5 as the play time updates
	 * @param {int} current time in ms
	 * @param {int} total time in ms
	 */
	player.updatePlayProgress = function(current, total) {
		current /= 1000;
		total /= 1000;

		progressBarDisplay.css('right', (100 - 100 * current / total) + '%');
		progressBarDragDot.css('right', (100 - 100 * current / total) + '%');
		currentTimeDisplay.html(secondsToClockTime(Math.floor(current)));
		if (total != lastTotalTime) {
			totalTimeDisplay.html(secondsToClockTime(Math.floor(total)));
			lastTotalTime = total;
		}

	};

	/**
	 * Updates the load bar progress
	 *  Called by html5 as load happens
	 * @param {number} percentLoaded the amount that's loaded
	 */
	player.updateLoadProgress = function(percentLoaded) {
		loadProgressBarDisplay.css('right', (100 - 100 * percentLoaded) + '%');
	};

	/**
	 * Gets the total time for the currently playing track
	 * @return {number} the total time in seconds
	 */
	player.getTotalTime = function() {
		return player.getPlayer().getTotalTime();
	};

	/**
	 * Fires when the player completes a track
	 */
	player.complete = function() {
		const $body = $j(sa.getBody());
		if ($body.hasClass('tablet') || $body.hasClass('mobile') || user.getOption('continuous_play') == 1) {
			player.next(1);
		}
	};

	player.enableQuickProjects = function() {
		quickProjectModeEnabled = true;
		player.addQuickProjectButtonForTrack(playingTrackId);
	};

	player.disableQuickProjects = function() {
		quickProjectModeEnabled = false;
		container.find('.quick_project_container').empty()
	};

	player.addQuickProjectButtonForTrack = function(trackId) {
		if (!quickProjectModeEnabled) return;
		let button = sa.components.projector.generateQuickProjectTrackButton(trackId);
		container.find('.quick_project_container').empty().append(button)
	};
	
	player.changeOrientation = function (e) {
		if (e.target.type === 'landscape-primary' || e.target.type === 'landscape-secondary') {
			$j('body').addClass('mobile-landscape');
		} else {
			$j('body').removeClass('mobile-landscape');
		}
	};
	
	player.checkOrientation = function () {
		// Check if the window width is larger than the height, if so, we're in landscape mode
		if (window.innerWidth > window.innerHeight) {
			$j('body').addClass('mobile-landscape');
		} else {
			$j('body').removeClass('mobile-landscape');
		}
	};

	/**
	 * sets up the player
	 */
	player.build = function () {
		// set up the interface
		templates = sa.templates.get('player');

		const isMobileOrTablet = $j('body').hasClass('tablet') || $j('body').hasClass('mobile');
		container = !isMobileOrTablet ? templates.get('player') : templates.get('playerMobile');
		
		// Check orientation and setup event listener for changes
		player.checkOrientation();
		screen.orientation.addEventListener('change', player.changeOrientation);
		window.addEventListener('resize', debounce(player.checkOrientation, 100));
		
		progressBarDragDot = container.find('.progress_bar .progress_dragdot');
		progressBarDisplay = container.find('.progress_bar .progress');
		loadProgressBarDisplay = container.find('.load');
		currentTimeDisplay = container.find('.current_time');
		totalTimeDisplay = container.find('.total_time');
		continuousPlayDisplay = container.find('.continuous_play');
		titleDisplay = container.find('.title_bar');
		downloadContainer = container.find('.download_container');
		sonicSearchContainer = container.find('.sonic_search_container');
		optionsContainer = container.find('.options_container');
		artDisplay = container.find('.album_art');
		volumeDisplay = container.find('.mute_button');
		volumeBarDisplay = container.find('.volume_bar .progress');
		infoContainer = container.find('.info');

		container.find('.progress_bar .fill').css('background-color', $j('.button').css('background-color') );
		container.find('.play').on('click', function() {
			player.playPause();
		});
		container.find('.next').on('click', function() {
			if (!$j(this).hasClass('disabled')) {
				player.next(1, false);
				// window.eventBus.emit(AUDIO_EVENTS.COMMANDS.SKIP_NEXT);
			}
		});
		container.find('.previous').on('click', function() {
			if (!$j(this).hasClass('disabled')) {
				player.next(-1, false);
				// window.eventBus.emit(AUDIO_EVENTS.COMMANDS.SKIP_PREVIOUS);
			}
		});
		container.filter('.hide_player').on('click', function() {
			console.log("clicking hide player");
			if (player.isPlaying()) player.playPause()
			sa.components.bottomBar.hideTrack();
		});

		$j(titleDisplay).add(artDisplay).on('click', function() {
			if (player.isPlayingTrack(0)) return;
			sa.router.routeTo(getTrackLink(playingTrackData.id));
		});
		container.find('.progress_bar').on('mousedown touchstart', function(e) {
			if (player.isPlayingTrack(0)) return;
			e.preventDefault ? e.preventDefault() : event.returnValue = false;


			var wasPlaying = playing;
			if (wasPlaying) player.playPause();

			var progressLeft = container.find('.progress_bar').offset().left;
			var progressWidth = container.find('.progress_bar').width();

			var playHeadDrag = function(e) {
				container.find('.info').addClass('dragging');
				var touch = undefined
				if (e.originalEvent.touches) {
					touch = e.originalEvent.touches[0]
					pos_x = touch.pageX
				} else {
					pos_x = e.pageX;
				}
				var progress = Math.max(0, pos_x - progressLeft) / progressWidth;
				player.setProgress(progress);
			};


			container.find('.info').off().on('mousemove touchmove', playHeadDrag);

			container.find('.info').on('mouseup mouseleave touchend touchcancel', function(e) {
				console.log('mouse out or up');
				container.find('.info').removeClass('dragging');
				container.find('.info').off();
				if (wasPlaying) player.playPause();
			});

			playHeadDrag(e); //trigger it once so the progress updates
		});
		
		function updateContinuousPlayTitle(active) {
			continuousPlayDisplay.attr('title', continuousPlayDisplay.data(active ? 'activetitle' : 'inactivetitle'));
		}
		
		continuousPlayDisplay.on('click', function() {
			continuousPlayDisplay.toggleClass('active');
			let isActive = continuousPlayDisplay.hasClass('active') ? 1 : 0;
			user.setOption('continuous_play', isActive);
			updateContinuousPlayTitle(isActive);
		});
		
		if (user.getOption('continuous_play') == 1) {
			continuousPlayDisplay.addClass('active');
			updateContinuousPlayTitle(1);
		} else {
			updateContinuousPlayTitle(0);
		}
		
		volumeDisplay.on('mouseleave', function() {
			hideVolumeBar();
		});
		
		volumeDisplay.on('click', function(e) {
			if ($j(e.target).hasClass('volume_bar')) {
				return;
			}
			toggleVolumeBar();
		});
		
		var volumeBar = container.find('.volume_bar');
		volumeBar.on('mousedown', function(e) {
			e.preventDefault ? e.preventDefault() : event.returnValue = false;

			var fillContainer = volumeBar.find('.fill');
			var progressTop = fillContainer.offset().top;
			var progressWidth = fillContainer.height();

			var playHeadDrag = function(e) {
				var progress = Math.max(0, e.pageY - progressTop) / progressWidth;
				player.setVolume(1 - progress);
			};

			volumeBar.on('mousemove.vbar', playHeadDrag);

			volumeBar.on('mouseup.vbar mouseleave.vbar', function(e) {
				volumeBar.off('.vbar');
				e.preventDefault ? e.preventDefault() : event.returnValue = false;
			});

			playHeadDrag(e); //trigger it once so the progress updates
		});

		initHtmlPlayer(container);
	};

	function initHtmlPlayer(container) {
		player.player = playerObject = new Html5Player(container);
		player.playerType = 'mp3';

		player.setVolume(user.getVolume());
	}

	player.attach = function() {
		sa.components.bottomBar.addComponent(container);
	};
	
	player.sendEvent = function (eventName, eventData = null) {
		console.log('Sending event from player.js:', eventName, eventData);
		window.eventBus.emit(eventName, eventData);
	};

	return player;
}());

/**
 * The player expects the html5 audio container, Html5Player, to support the following interface:
 * playTrack() -> asks player for current track and plays it
 * playPause()
 * updatePlaying() -> calls player.updatePlaying(id, isPlaying)
 * getVolume():float
 * setVolume(float)
 * getProgress():percentage
 * setProgress(float)
 * getLoadProgress():float
 * getTotalTime():float
 *
 * additionally, it should periodically call
 * updatePlayProgress(int current in ms, int total in ms)
 * updateLoadProgress(float percentLoaded)
 * complete() when done with a track
 */

// good reference on html audio events: https://developer.mozilla.org/En/Using_audio_and_video_in_Firefox
function Html5Player(container) {

	var volume = 1,
		audio = null,
		isPlaying = false,
		progressTimer = null;

	var player = sa.components.player;

	// BEGIN INTERFACE - these functions are required by the player

	/**
	 * Plays the current track in the player object
	 * Creates a new <audio> element because Safari doesn't seem to notice changes to <source> unless you create a new player
	 */
	this.playTrack = async function () {
		const rawData = player.getRawPlayingTrackData();
		if (rawData && rawData.file && rawData.file.playHtml5) {
			// $j('#audio_container audio').attr('src', rawData.file.playHtml5);
			audio.src = rawData.file.playHtml5;
			audio.volume = volume;
			audio.playsInline = true;

			try {
				await audio.load();
				await audio.play();
			} catch (e) {
				console.warn(e);
			}
		}
	};

	/**
	 * Plays the player if it's paused or pauses it if it's playing
	 */
	this.playPause = function() {
		if (isPlaying) {
			audio.pause();
		} else {
			let promise = audio.play();
			if (promise) {
				promise.catch(() => {});
			}
		}
	};
	
	this.pause = function () {
		if (isPlaying) audio.pause();
	}

	/**
	 * Tells the player whether or not the audio element is playing
	 */
	this.updatePlaying = function(newIsPlaying) {
		if (newIsPlaying === undefined) newIsPlaying = isPlaying;
		isPlaying = newIsPlaying;
		player.updatePlaying(player.getRawPlayingTrackData().id, isPlaying);
	};

	/**
	 * Gets the current volume of the audio element
	 * @return {float} volume between 0 and 1
	 */
	this.getVolume = function() {
		return audio.volume;
	};

	/**
	 * Sets the volume of the player
	 * @param {number} volume the volume level between 0 and 1, inclusive
	 */
	this.setVolume = function(volume) {
		if (volume < 0) volume = 0;
		else if (volume > 1) volume = 1;
		audio.volume = volume;
	};

	/**
	 * Gets how far along in the playback we are
	 * @return {number} progress between 0 and 1, inclusive
	 */
	this.getProgress = function() {
		return audio.currentTime / player.getRawPlayingTrackData().actualLength;
	};

	/**
	 * Sets how far along we are in the playback
	 * @param {float} progress how far we should be between 0 and 1, inclusive
	 */
	this.setProgress = function(progress) {
		var newTime = progress * player.getRawPlayingTrackData().actualLength;
		if (Math.floor(audio.currentTime * 100) != Math.floor(newTime * 100)) {
			audio.currentTime = newTime;
		}
	};

	/**
	 * Gets how loaded the currently playing file is
	 * @return {number} load progress between 0 and 1, inclusive
	 */
	this.getLoadProgress = function() {
		if (audio.buffered.length) {
			// get largest end point of audio buffer time ranges
			let maxBuff = 0;
			for (let ind = 0; ind < audio.buffered.length; ind++) {
				let rangeEnd = audio.buffered.end(ind);
				if (rangeEnd > maxBuff) {
					maxBuff = rangeEnd
				}
			}
			return maxBuff / player.getRawPlayingTrackData().actualLength;
		}
		return 0;
	};

	/**
	 * Gets the total play time for the track in seconds
	 */
	this.getTotalTime = function() {
		return player.getRawPlayingTrackData().actualLength;
	};

	// END INTERFACE

	/**
	 * Tells the player about the current play progress
	 * Called by play events
	 */
	this.updatePlayProgress = function() {
		player.updatePlayProgress(audio.currentTime * 1000, player.getRawPlayingTrackData().actualLength * 1000);
	};

	/**
	 * Tells the player about the current load progress
	 * Called by play events
	 * @return {number} progress straight out of this.getLoadProgress() - used to determine whether loading is complete, in which case, you don't need to do this anymore
	 */
	this.updateLoadingProgress = function() {
		var progress = this.getLoadProgress();
		player.updateLoadProgress(progress);
		return progress;
	};

	/**
	 * Puts event listeners on the player so we get notified when it plays, pauses, and time updates
	 * Should be called every time you create a new <audio> element to play
	 */
	this.addEventListeners = function() {
		let p = this;

		audio.addEventListener('loadeddata', function(e) {
			console.log('got event loadeddata', e);
		});
		audio.addEventListener('error', function(e) {
			console.log('got event error', e);
		});
		audio.addEventListener('playing', function() {
			console.log('got event playing');
			p.updatePlaying(true);
		});
		audio.addEventListener('pause', function() {
			console.log('got event pause');
			p.updatePlaying(false);
		});
		audio.addEventListener('timeupdate', function() {
			//console.log('got event timeupdate');
			p.updatePlayProgress();
		});
		audio.addEventListener('ended', function() {
			console.log('playback ended');
			player.complete();
		});
		// there's a 'progress' event but it doesn't actually work
		progressTimer = setInterval(function() {
			if (p.updateLoadingProgress() == 1) {
				clearInterval(progressTimer);
			}
		}, 100);
	};

	/**
	 * Sets up the basic player elements and events
	 */
	this.init = function() {
		// set up the player
		container.append(
			'<div id="audio_container"><audio id="SourceAudioPlayer"></audio></div>'
		);
		audio = container.find('audio').get(0);
		this.addEventListeners();
	};

	this.init();
}

$j(window).on('keydown', function(e) {
	if (!e) e = window.event;
	if (e.altKey || e.shiftKey || e.ctrlKey || e.metaKey) return;
	var nodeName = document.activeElement.nodeName;
	if (nodeName != 'INPUT' && nodeName != 'TEXTAREA') {
		switch (e.keyCode) {
			// Space
			case 32:
				sa.components.player.playPause();
				break;
			// Left Arrow
			case 37:
				if (!($j('.player_controls_container .previous').hasClass('disabled'))) {
					sa.components.player.next(-1, false);
				}
				break;
			// Right Arrow
			case 39:
				if (!($j('.player_controls_container .next').hasClass('disabled'))) {
					sa.components.player.next(1, false);
				}
				break;
			default:
				return true;
		}
		return false;
	}
});
var uploaderId = 0,
	UploaderConstants = { ANY : 0, AUDIO : 1, IMAGES : 2, MP3 : 3, AIFF : 4, WAV : 5, CSV : 6, DOCS : 7, AV : 8, ICONS : 9, EDL: 10, ALL : 11, NOTES : 12, LPROFILE: 13 };

sa.components.uploader = (function() {

	var uploader = {};

	uploader.getFileType = function(fileTypeString) {
		switch (fileTypeString) {
			case 'images':
				return UploaderConstants.IMAGES;
			case 'icons':
				return UploaderConstants.ICONS;
		}
		return UploaderConstants.ANY;
	};

	uploader.attachUploader = function(options) {
		return new Uploader(options);
	};

	return uploader;

})();

/**
 * Creates a file uploader
 * @param {object} vars parameters that control how the uploader functions
 *  @property {JQuery|HTMLElement} button the container for the uploader. it will take this object's dimensions
 *  @property {boolean} allowMultiple should multiple files be uploaded? (optional - defaults to false)
 *  @property {boolean} allowFolder if we're allowing multiple, should we allow folder selection? (optional - defaults to true)
 *  @property {function|string} browseCallback something to call once once the user has browsed. If func, will pass this
 *  @property {UploaderConstants} fileType from the object above. determines what file types to allow uploaded
 * @returns {Uploader}
 */
function Uploader(vars) {

	var uploader = this;
	var button = $j(vars.button);
	var allowMultiple = vars.allowMultiple;
	var allowFolder = allowMultiple && (vars.allowFolder === undefined || vars.allowFolder);
	var browseCallback = vars.browseCallback;
	var fileType = vars.fileType; // should be one of the UploaderConstants so we know what types of files to accept
	this.fileTypes = vars.fileType
	var myId = 0; //  The id of the uploader object on the page
	var fileIds = [];
	var selectedFiles = [];
	var removedFiles = [];
	/** @var {XMLHttpRequest} xhr */
	var xhr;

	/**
	 * The function to call once things happen (browse|error|complete|progress)
	 */
	this.callbacks = { browse : browseCallback };

	function getNewId() {
		myId = 'FileUploader_' + uploaderId++;
		return myId;
	}

	function processChosenFiles(newFiles) {
		var fileArray = [];
		// set an id for all the files
		for (var i = 0, len = newFiles.length; i < len; i++) {
			var file = newFiles[i],
				fileId = new Date(file.lastModifiedDate).getTime() + '-' + file.name.replace(/[^a-z0-9\-]/ig, '') + '-' + file.size; // generate as unique an id as possible for this file
			// if it's in the file id list already, we treat it differently
			if (fileIds.indexOf(fileId) != -1) {
				// if it hasn't been removed, don't add it again
				var removedIndex = removedFiles.indexOf(fileId);
				if (removedIndex == -1) {
					console.log('skipping ' + fileId);
				} else {
					// if it has been removed, unremove it
					removedFiles.splice(removedIndex, 1);
				}
				continue;
			}
			if (fileIds.indexOf(fileId) == -1) fileIds.push(fileId);
			file.id = fileId;
			fileArray.push(file);
		}
		selectedFiles = selectedFiles.concat(fileArray);
		// do callback
		browseCallback(uploader);
		// if they added files, we should get another input object so we can keep adding on
		if (newFiles.length) {
			createInput();
		}
	}

	function createInput() {
		var mimeType = getMimeTypes().join(',');
		var fileInput = $j('<input type="file" id="' + getNewId() + '" class="file_uploader no_validate"/>');
		fileInput.on('change', function(e) {
			var target = e.originalEvent.target || e.originalEvent.srcElement,
				newFiles = target.files,
				fileArray = [];
			// remove any currently selected files, if we're not allowing multiple
			if (!allowMultiple) {
				uploader.removeAllFiles();
			}
			// set an id for all the files
			for (var i = 0, len = newFiles.length; i < len; i++) {
				var file = newFiles[i],
					fileId = new Date(file.lastModifiedDate).getTime() + '-' + file.name.replace(/[^a-z0-9\-]/ig, '') + '-' + file.size; // generate as unique an id as possible for this file
				// if it's in the file id list already, we treat it differently
				if (fileIds.indexOf(fileId) != -1) {
					// if it hasn't been removed, don't add it again
					var removedIndex = removedFiles.indexOf(fileId);
					if (removedIndex == -1) {
						console.log('skipping ' + fileId);
					} else {
						// if it has been removed, unremove it
						removedFiles.splice(removedIndex, 1);
					}
					continue;
				}
				if (fileIds.indexOf(fileId) == -1) fileIds.push(fileId);
				file.id = fileId;
				fileArray.push(file);
			}
			selectedFiles = selectedFiles.concat(fileArray);
			// do callback
			browseCallback(uploader);
			// if they added files, we should get another input object so we can keep adding on
			if (newFiles.length) {
				createInput();
			}
		});

		fileInput.attr('accept', mimeType);
		if (allowMultiple) {
			fileInput.attr('multiple', 'multiple');
		}
		button.parent().append(fileInput); // can't just append to button because then the input.trigger('click') bubbles down and it loops
		button.off('click').on('click', function(e) {
			fileInput.trigger('click');
			e.preventDefault();
			return false;
		});
	}

	/**
	 * Manually adds some files to the uploader's list. Useful if you have files specified in some other way, like through drag and drop
	 * @param {Array} newFiles
	 */
	this.addFiles = function(newFiles) {
		var fileArray = [];
		// set an id for all the files
		for (var i = 0, len = newFiles.length; i < len; i++) {
			var file = newFiles[i],
				fileId = file.lastModifiedDate + '\t' + file.name + '\t' + file.size; // generate as unique an id as possible for this file
			// if it's in the file id list already, we treat it differently
			if (fileIds.indexOf(fileId) != -1) {
				// if it hasn't been removed, don't add it again
				var removedIndex = removedFiles.indexOf(fileId);
				if (removedIndex == -1) {
					console.log('skipping ' + fileId);
				} else {
					// if it has been removed, unremove it
					removedFiles.splice(removedIndex, 1);
				}
				continue;
			}
			if (fileIds.indexOf(fileId) == -1) fileIds.push(fileId);
			file.id = fileId;
			fileArray.push(file);
		}
		selectedFiles = selectedFiles.concat(fileArray);
		// do callback
		browseCallback(uploader);
	};

	this.isMimeTypeAllowed = function(type) {
		return getMimeTypes().indexOf(type) !== -1;
	}

	function getMimeTypes() {
		switch (fileType) {
			case UploaderConstants.AUDIO:
				return ['audio/aiff', 'audio/mp3', 'audio/mpeg', 'audio/wav', 'audio/x-aiff'];
			case UploaderConstants.MP3:
				return ['audio/mp3', 'audio/mpeg'];
			case UploaderConstants.AIFF:
				return ['audio/aiff', 'audio/x-aiff'];
			case UploaderConstants.WAV:
				return ['audio/wav'];
			case UploaderConstants.IMAGES:
				return ['image/gif', 'image/jpeg', 'image/png', 'image/webp'];
			case UploaderConstants.CSV:
				return ['.csv', 'text/csv']; // should be text/csv but it doesn't work. .csv does though
			case UploaderConstants.DOCS:
				return ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'text/plain', 'application/vnd.oasis.opendocument.text'];
			case UploaderConstants.EDL:
			case UploaderConstants.LPROFILE:
				return [];
			case UploaderConstants.AV:
				return ['audio/aiff', 'audio/x-aiff', 'audio/mp3', 'audio/mpeg', 'audio/wav', 'audio/ogg', 'video/quicktime', 'video/mp4'];
			case UploaderConstants.ICONS:
				return ['image/x-icon', 'image/png'];
			case UploaderConstants.NOTES:
				return ['audio/aiff', 'audio/mp3', 'audio/mpeg', 'audio/wav', 'audio/x-aiff',
					'.csv', 'text/csv', 'application/zip', 'multipart/x-zip', 'application/octet-stream', 'application/x-zip-compressed',
					'application/msexcel', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'text/plain', 'application/vnd.oasis.opendocument.text'];
			case UploaderConstants.ALL:
				return ['audio/aiff', 'audio/x-aiff', 'audio/mp3', 'audio/mpeg', 'audio/wav', 'audio/ogg', 'image/gif', 'image/jpeg', 'image/png', ''
					+ 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'text/plain', 'application/zip', 'application/x-zip-compressed'];
			case UploaderConstants.ANY:
			default:
				return [];
		}
	}

	function createFolderInput() {
		var allowFolders = true;
		// test to see if folder uploading is allowed
		var i = createElement('input');
		if (i['directory'] === undefined && i['webkitdirectory'] === undefined) {
			allowFolders = false;
		}
		// add the folders button
		var folderButton = $j('<a class="button" id="folder_button">Choose Folder</a>');
		if (allowFolders) {
			// create an input
			var input = $j('<input type="file" id="' + getNewId() + '" class="file_uploader no_validate"/>'),
				mimeTypes = getMimeTypes();
			input.on('change', function(e) {
				var newFiles = e.originalEvent.target.files,
					fileArray = [];
				// set an id for all the files
				for (var i = 0, len = newFiles.length; i < len; i++) {
					var file = newFiles[i],
						fileId = file.lastModifiedDate + '\t' + file.name + '\t' + file.size; // generate as unique an id as possible for this file
					if (mimeTypes.indexOf(file.type) === -1) continue; // it's the wrong type
					if (file.name[0] == '.') continue; // don't allow files that start with .
					// if it's in the file id list already, we treat it differently
					if (fileIds.indexOf(fileId) != -1) {
						// if it hasn't been removed, don't add it again
						var removedIndex = removedFiles.indexOf(fileId);
						if (removedIndex == -1) {
							console.log('skipping ' + fileId);
						} else {
							// if it has been removed, unremove it
							removedFiles.splice(removedIndex, 1);
						}
						continue;
					}
					if (fileIds.indexOf(fileId) == -1) fileIds.push(fileId);
					file.id = fileId;
					fileArray.push(file);
				}
				selectedFiles = selectedFiles.concat(fileArray);
				// do callback
				browseCallback(uploader);
				// if they added files, we should get another input object so we can keep adding on
				if (newFiles.length) {
					folderButton.remove();
					createFolderInput();
				}
			});

			input.attr('multiple', 'multiple');
			input.attr('directory', '');
			input.attr('webkitdirectory', '');
			button.parent().append(input); // can't just append to button because then the input.trigger('click') bubbles down and it loops
			folderButton.on('click', function(e) { input.trigger('click'); e.preventDefault(); return false; });
		} else {
			folderButton.addClass('disabled').on('click', function(e) {
				sa.notify({ text : $j('<div>' + 'Folder uploading is only available in Chrome. To take advantage of this feature, please download <a href="https://www.google.com/chrome" target="_blank">Chrome</a></div>') });
				e.preventDefault();
				return false;
			});
		}
		button.after(folderButton);
	}

	/**
	 * Creates the uploader
	 */
	this.init = function() {
		createInput();

		if (allowFolder) {
			createFolderInput();
		}

	};
	this.init();

	/**
	 * Called once the user has completed an action and calls a function to notify the creating object
	 * @param {string} type what kind of callback is this?
	 * @param {int} bytesLoaded the current number of bytes uploaded (if a progress callback)
	 * @param {int} bytesTotal the total number of bytes to be uploaded (if a progress callback)
	 */
	this.doCallback = function(type, bytesLoaded, bytesTotal) {
		var callback = this.callbacks[type];
		if (callback) {
			callback(this, bytesLoaded, bytesTotal);
		}
	};

	/**
	 * Gets a list of all the names of the files the user has selected
	 * 	DON'T USE THIS FUNCTION - IT DOESN'T TAKE INTO ACCOUNT REMOVEDFILES
	 * @return {Array} of string selected files
	 */
	this.getFiles = function() {
		var filenames = [], i, len;
		for (i = 0, len = selectedFiles.length; i < len; i++) {
			filenames.push(selectedFiles[i].name);
		}
		return filenames;
	};

	/**
	 * Gets the details for currently chosen files
	 * @return {Array} of file objects, each with an id, name, size, type (extension including .), modificationDate (timestamp), and creationDate (timestamp)
	 */
	this.getFileDetails = function() {
		var files = [];
		for (var i = 0, len = selectedFiles.length; i < len; i++) {
			if (removedFiles.indexOf(selectedFiles[i].id) == -1) {
				files.push(selectedFiles[i]);
			}
		}
		return files;
	};

	/**
	 * Removes a file from the list of files to upload
	 * @param {int} id the id of the file to remove (comes from one of the objects in this.getFileDetails();
	 * @return {Array} this.getFileDetails()
	 */
	this.removeFile = function(id) {
		console.log('trying to remove ' + id);
		removedFiles.push(id);
		return this.getFileDetails();
	};

	/**
	 * Removes all files from the upload queue.
	 */
	this.removeAllFiles = function() {
		for (var i = 0, len = selectedFiles.length; i < len; i++) {
			if (removedFiles.indexOf(selectedFiles[i].id) == -1) {
				removedFiles.push(selectedFiles[i].id);
			}
		}
	};

	/**
	 * Actually begins the upload process
	 * @param {object} options parameters that control the upload
	 *  @property {string} params - any additional url parameters to send to the server during upload. used to specify what type of thing is being uploaded, etc. - sent as GET vars
	 *  @property {function} complete - a func to call when the upload finishes (sends an event)
	 *  @property {function} process - a func to call when progress in the upload is made (sends event, bytesLoaded, bytesTotal)
	 *  @property {function} error - a func to call if an error occurs during upload (sends an event)
	 *  @property {function} abort - a func to call if an abort occurs during upload (sends an event)
	 *  @property {int} fileId - the id of the file to upload if there's more than one available
	 *  @property {boolean} forceSourceAudioServer - if true, the file will always upload to the regular sa server and not the import server. otherwise, will try to determine server based on type
	 *  @property {boolean} forceImportServer - if true, the file will always upload to the import server and not the sa server. otherwise, will try to determine server based on type
	 *  @property {boolean} useImportIndex - if true, the file will be uploaded to index_import.php instead of the default
	 *  @property {boolean} parseComplete - should we parse the response from the server before sending to the complete function? (defaults to false)
	 *  @property {string} p - uploads usually go to p=upload. use this var to override that behavior
	 *
	 * Note that the file will be sent as 'file'
	 */
	this.upload = function(options) {
		
		options = $j.extend({
			params : '',
			complete : null,
			progress : null,
			error : null,
			abort : null,
			fileId : 0,
			forceSourceAudioServer : false,
			forceImportServer : false,
			useImportIndex : false,
			parseComplete : null,
			fileOverride: {}, // override the default upload behavior to use key, value relationship: { "filekey": File(), "filekey2": File() }
			p : 'upload'
		}, options);
		
		this.off('complete');
		this.on('complete', options.complete);
		this.off('progress');
		this.on('progress', options.progress);
		this.off('error');
		this.on('error', options.error);
		this.off('abort');
		this.on('abort', options.abort);
		
		// determine our upload path based on the options
		let path = '';
		let addCredentials = false;
		if (options.forceImportServer || (!options.forceSourceAudioServer && (fileType == UploaderConstants.AUDIO || fileType == UploaderConstants.AIFF || fileType == UploaderConstants.WAV || fileType == UploaderConstants.MP3))) {
			path = '//' + ImportDomain + '/index_import.php?whiteId=' + config.id;
			addCredentials = true;
		} else {
			path = '//' + config.domain + '/' + ajax.getBasePath() + 'sub=' + config.sub + '&p=' + options.p + (options.useImportIndex ? '&useImportIndex=1' : '');
		}
		if (addCredentials) {
			path += '&l=' + sa.cookies.get(window['normalUserCookieName']) + '&ua=' + encodeURIComponent(navigator.userAgent.replace(/(Trident\/[5-9]\.[0-9.]+);.*/, '$1)'))
				// see http://secularcoding.com/2012/06/ie9-user-agent-in-http-requests-vs-navigator-useragent/ for why we replace
				+ '&s=' + sa.cookies.get(window['secureUserCookieName']) + '&authType=upload';
		}
		if (options.params) {
			path += '&' + options.params;
		}
		
		let file;
		// get the right file
		if (options.fileId) {
			for (let i = 0, len = selectedFiles.length; i < len && !file; i++) {
				let currentFile = selectedFiles[i];
				if (currentFile.id == options.fileId && removedFiles.indexOf(currentFile.id) == -1) {
					file = currentFile;
				}
			}
		} else {
			// just get the first non-removed file
			for (let i = 0, len = selectedFiles.length; i < len && !file; i++) {
				let currentFile = selectedFiles[i];
				if (removedFiles.indexOf(currentFile.id) == -1) {
					file = currentFile;
				}
			}
		}
		if (!file) return;
		var f = new FormData();
		xhr = new XMLHttpRequest();
		
		/**
		 * Append files to the request
		 */
			// check if we have a file override to send multiple files
		const haveOverrideFiles = Object.values(options.fileOverride).filter(a => a instanceof File).length > 0
		if (Object.keys(options.fileOverride).length > 0 && haveOverrideFiles) {
			for (const [key, file] of Object.entries(options.fileOverride)) {
				if (file instanceof File) {
					f.append(key, file);
				}
			}
		} else {
			// normal behavior is to just append 1 file with with the key "file"
			f.append('file', file);
		}
		
		// make our request
		if (options.parseComplete) {
			path += '&parsingResponse=1';
		}
		xhr.open('POST', path);
		
		xhr.upload.addEventListener('progress', function(e) {
			if (e['lengthComputable']) {
				uploader.trigger('progress', e['loaded'], e['total']);
			} else {
				uploader.trigger('progress', 0, 1);
			}
		});
		
		xhr.addEventListener('load', function() {
			// get all the data we need out of the xhr object so we can clear it and future calls to abort, etc. don't do anything
			const status = xhr.status;
			let responseText = '';
			try {
				responseText = xhr.responseText; // docs say this can throw an exception if the response hasn't loaded properly
			} catch (e) {}
			xhr = null;
			
			if (status == 200) {
				console.log('upload complete');
				if (options.parseComplete) {
					handleAjaxResponse(function(content) { uploader.trigger('complete', content); }, responseText, 'upload&' + options.params);
				} else {
					uploader.trigger('complete', responseText);
				}
			} else {
				console.log('uploader xhr load event error', status);
				uploader.trigger('error', status);
			}
			
		});
		
		xhr.addEventListener('abort', function() {
			console.log('uploader xhr.abort detected', xhr);
			xhr = null; // any future calls to abort, etc. don't do anything
			uploader.trigger('abort');
		});
		
		xhr.addEventListener('error', function(e) {
			console.log('uploader xhr.error detected', xhr, e);
			const status = xhr.status;
			xhr = null; // any future calls to abort, etc. don't do anything
			uploader.trigger('error', status);
		});
		
		xhr.addEventListener('timeout', function() {
			console.log('uploader xhr.timeout detected', xhr);
			xhr = null; // any future calls to abort, etc. don't do anything
			uploader.trigger('error', 'timeout');
		});
		
		xhr.send(f);
	};

	/**
	 * Stops the XHR request
	 */
	this.abort = function() {
		if (xhr) {
			try {
				xhr.abort();
			} catch (e) {
				console.log('Caught error while trying to abort xhr request', e);
			}
		}
	};

	this.addFilesToUpload = function (files) {
		if (!files.isArray) {
			throw "Argument to addFilesToUpload must be an array.";
		}
		processChosenFiles(files);
	};

	sa.eventify(this);
}

/**
 * Turns an UploaderType into an array of extensions, like useable in GenericDropZone.allowedExtensions
 * @param {int} fileType
 * @return {Array.<string>}
 */
Uploader.GetExtensions = function(fileType) {
	switch (fileType) {
		case UploaderConstants.AUDIO:
			return [ 'aiff', 'aif', 'mp3', 'wav' ];
		case UploaderConstants.MP3:
			return [ 'mp3' ];
		case UploaderConstants.AIFF:
			return [ 'aiff', 'aif' ];
		case UploaderConstants.WAV:
			return [ 'wav' ];
		case UploaderConstants.IMAGES:
			return [ 'gif', 'jpg', 'jpeg', 'png' ];
		case UploaderConstants.CSV:
			return [ 'csv' ];
		case UploaderConstants.DOCS:
			return [ 'doc', 'docx', 'pdf', 'txt' ];
		case UploaderConstants.EDL:
			return [ 'edl', 'txt' ];
		case UploaderConstants.ALL:
			return [ 'aiff', 'aif', 'mp3', 'wav', 'ogg', 'gif', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf', 'txt' ];
		case UploaderConstants.ANY:
		default:
			return [];
	}
};
/**
 * Abstracts out the loading of templates so we don't have to do it with jquery everywhere 
 */
sa.templates = (function() {
	
	var templates = {},
		templateContainer;
	
	function cleanName(name) {
		return name.replace(/\./g, '-');
	}
	
	templates.init = function() {
		if (!templateContainer) {
			templateContainer = $j('#sourceaudio_templates').detach();
			window['templateContainer'] = templateContainer;
		}
	};

	/**
	 * @param templateSetName
	 * @returns {TemplateSet}
	 */
	templates.get = function(templateSetName) {
		
		var set = templateContainer.find('.template_set#' + cleanName(templateSetName));
		
		if (!set.length) {
			console.error('Request for unknown template set', templateSetName);
			return new TemplateSet(templateSetName, $j());
		}
		
		return new TemplateSet(templateSetName, set);
		
	};
	
	function TemplateSet(templateSetName, set) {

		/**
		 * @param {string} templateName
		 * @param {Object=} substitutions { find => replace }. in the template, the find should have curlies but no $
		 * 	for example, if your template has <a href="/admin?page=whatever&id={itemId}">{itemName}</a>, you could call templates.get('name', { itemId : 123, itemName : 'Dance Hits' });
		 * 	and it would be more performant than doing all the replaces with jQuery DOM functions.
		 * 	It also prevents you from having to doing nasty stuff like $j(cont).find('a').attr('href', $j(cont).find('a').attr('href') + 123); or just storing all the hrefs in js
		 * @returns {JQuery}
		 */
		this.get = function(templateName, substitutions) {
			
			var template = set.find('.template#' + cleanName(templateSetName + '-' + templateName)),
				templateHTML;

			if (undefined === substitutions) {
				substitutions = {};
			}
			
			if (!template.length) {
				console.error('Request for unknown template', templateName);
				return $j();
			}
			
			templateHTML = template.html();
			
			templateHTML = templateHTML.replace(/\{\$([a-zA-Z ]+)\}/g, function(whole, val, index) {
				var upperCase = val.charCodeAt(0) < 96,
					plural = val.charAt(val.length - 1) == 's';
				
				if (upperCase) {
					val = val.toLowerCase();
				}
				
				if (plural) {
					val = val.substring(0, val.length - 1);
				}
				val = val.trim();
				
				return gde(val, { p : plural, c : upperCase ? 'upper' : 'lower' });
			});
			
			// if you try to $j.each an object that has an attribute named length, the each fails and nothing fires
			if (substitutions.length != undefined) {
				substitutions.lengthBUTNOTLENGTHITSBAD = substitutions.length;
				delete substitutions.length;
			}

			$j.each(substitutions, function (pattern, replacement) {
				if (pattern == 'lengthBUTNOTLENGTHITSBAD') {
					pattern = 'length';
				}
				// pattern could contain regex unsafe characters, hence the goofy replace to escape them
				var regExp = new RegExp("\{" + pattern.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + "\}", "g");
                templateHTML = templateHTML.replace(regExp, replacement);
			});

			return $j(templateHTML);
			
		};
		
	}
	
	return templates;
	
})();
// used for triggering adwords events and for generating the drop down in the admin panel
(function() {
	
	sa.googleAdWordsEvents = { 'visit' : 'Visit', 'signup' : 'Sign Up' };
	sa.recordGoogleAdWordsEvent = function() {};
	
	let initAdwords = function() {
		if (config.googleAdWords.length) {
			sa.recordGoogleAdWordsEvent = function(eventName) {
				
				if (sa.googleAdWordsEvents[eventName] === undefined) return;
				
				config.googleAdWords.each(function(i, details) {
					
					if (details['event'] == eventName) {
						
						$j('body').append('<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/' + encodeURIComponent(details['id']) + '/?label=' + encodeURIComponent(details['label']) + '&amp;guid=ON"/>');
						
					}
					
				});
				
			};
		}
		initAdwords = function() {}; // only run once
	};
	
	sa.on('start', function() {
		initAdwords();
		sa.cookies.on(sa.cookieTypes.marketing, function f() {
			sa.cookies.off(sa.cookieTypes.marketing, f);
			sa.recordGoogleAdWordsEvent('visit');
		});
	});
	sa.on('registration', function() {
		initAdwords();
		sa.cookies.on(sa.cookieTypes.marketing, function f() {
			sa.cookies.off(sa.cookieTypes.marketing, f);
			sa.recordGoogleAdWordsEvent('signup');
		});
	});
	
})();
/**
 * LinkFunctions.js has functions that generate links to pages
 */

function buildExactLink(name, id, paramString) {
	if (!paramString) return name;
	const params = sa.router.cleanParams(paramString.replace('type', 'page'));
	
	const paramsObj = new URLSearchParams(params);

	let path;
	if (paramsObj.has(id)) {
		const linkId = paramsObj.get(id);
		paramsObj.delete(id);
		path = `/${name}/` + linkId;
	} else {
		path = `/${name}`;
	}

	return siteBaseUrl() + path + (paramsObj.toString() ? '?' + paramsObj.toString() : '');
}
 
function getDefaultLink() {
	return '#0';
}

function getExplorerLink(vars, isSiteWideSearch = false) {
	const { path, params } = sa.router.explorerParamConverter(vars);
	
	// If we have an orphaned search query, do it on the tracks page
	if ((!path && params.has('s')) || isSiteWideSearch) {
		return siteBaseUrl() + '/tracks?' + params.toString();
	}

	if (!path) {
		const currentUrl = new URL(window.location.href);
		const port = currentUrl.port ? ':' + currentUrl.port : '';

		return currentUrl.protocol + '//' + currentUrl.hostname + port + currentUrl.pathname + (params.toString().length ? '?' + params.toString() : '');
	}

	return siteBaseUrl() + '/' + path + (params.toString().length ? '?' + params.toString() : '');
}

function getArtistsLink(vars) {
	return siteBaseUrl() + '/artists' + sa.router.cleanParams(vars);
}

function getComposersLink(vars) {
	return siteBaseUrl() + '/composers' + sa.router.cleanParams(vars);
}

function getWritersLink(vars) {
	return siteBaseUrl() + '/writers' + sa.router.cleanParams(vars);
}
function getPublishersLink(vars) {
	return siteBaseUrl() + '/publishers' + sa.router.cleanParams(vars);
}

function getAlbumsLink(vars) {
	return siteBaseUrl() + '/albums' + sa.router.cleanParams(vars);
}

function getLabelsLink(vars) {
	return siteBaseUrl() + '/labels' + sa.router.cleanParams(vars);
}

function getCatalogListLink(vars) {
	return siteBaseUrl() + '/catalogs' + sa.router.cleanParams(vars);
}

function getMusicSupplierListLink(vars) {
	return siteBaseUrl() + '/music-suppliers' + sa.router.cleanParams(vars);
}

function getArtistLink(id) {
	if (id === 0) return '';
	return siteBaseUrl() + '/artist/' + id;
}

function getAlbumLink(id) {
	if (id === 0) return '';
	return siteBaseUrl() + '/album/' + id;
}

function getLabelLink(id) {
	if (id === 0) return '';
	let page;
	if (config.defaultLabelTab === 'a') {
		page = 'artists';
	} else if (config.defaultLabelTab === 't') {
		page = 'tracks';
	} else {
		page = 'albums';
	}
	return siteBaseUrl() + '/label/' + id + '?page=' + page;
}

function getLabelLinkExact(str) {	
	return buildExactLink('label', 'l', str);
}

function getLabelLinkArbitrary(id, page, vars) {
	if (!vars) vars = {};
	vars.l = id;
	vars.page = page;
	return siteBaseUrl() + '/label' + sa.router.queryParamsToString(vars);
}

function getPublisherLink(id) {
	if (id === 0) return '';
	return siteBaseUrl() + '/publisher/' + id;
}

function getPublisherLinkExact(str) {
	return buildExactLink('publisher', 'publisher', str);
}

function getWriterLink(id) {
	if (id === 0) return '';
	return siteBaseUrl() + '/writer/' + id;
}
function getWriterLinkExact(str) {
	return buildExactLink('writer', 'writer', str);
}


function getComposerLink(id) {
	if (id === 0) return '';
	return siteBaseUrl() + '/composer/' + id;
}

function getGenreLink(id) {
	return siteBaseUrl() + '/genre/' + id;
}

function getTempoLink(id) {
	return siteBaseUrl() + '/tempo/' + id;
}

function getCueTypeLink(id) {
	return siteBaseUrl() + '/cue-type/' + id;
}

function getSearchLink(term) {
	return siteBaseUrl() + '/tracks?s=' + encodeURIComponent(term);
}

function getCustomLink(fieldId, value) {
	return getExplorerLink() + sa.router.queryParamsToString({ custom: fieldId, value: value });
}

function getMusicSupplierLink(id, page) {
	if (id === page) page = '';
	
	let v = {};
	
	if (config.siteType === 'buyer' && !page) page = 'labels';
	
	if (page && !isInt(page)) v.page = page;
	
	return siteBaseUrl() + '/music-supplier/' + id + sa.router.queryParamsToString(v);
}

function getMusicSupplierLinkExact(str) {
	return buildExactLink('music-supplier', 'supplierId', str);
}

function getCatalogLink(id, page) {
	if (id === page) page = '';
	let v = {};
	
	if (!page) {
		if (config.defaultCatalogTab === 'l') {
			page = 'labels';
		} else if (config.defaultCatalogTab === 'a') {
			page = 'artists';
		} else if (config.defaultCatalogTab === 't') {
			page = 'tracks';
		} else {
			page = 'albums';
		}
	}
	
	if (page && !isInt(page)) v.page = page;
	
	return siteBaseUrl() + '/catalog/' + id + sa.router.queryParamsToString(v);
}

function getCatalogLinkExact(str) {
	return buildExactLink('catalog', 'c', str);
}

function getNewDashboardLink(page) {
	return siteBaseUrl() + '/dashboard' + sa.router.queryParamsToString({ p : page });
}

function getTrackLink(trackId, page) {
	if (page === 'license' && config.licenseUrl) {
		return decodeURIComponent(config.licenseUrl) + '" target="_blank';
	}
	return siteBaseUrl() + '/track/'+ trackId + sa.router.queryParamsToString({ page:page });
}

function getProjectLink(id, name) {
	return siteBaseUrl() + '/playlist/' + id;
}

function getProjectLinkExact(vars) {
	return buildExactLink('playlist', 'projectId', vars);
	// return siteBaseUrl() + '/playlist' + sa.router.cleanParams(vars);
}

function getCueSheetLink(id) {
	return siteBaseUrl() + '/cue-sheet/' + id;
}

function getCueSheetLinkExact(vars) {
	return buildExactLink('cue-sheet', 'cueSheetId', vars);
	// return siteBaseUrl() + '/cue_sheet' + sa.router.cleanParams(vars);
}

function getSecureLink(path) {
	return 'https://' + config.domain + '/' + path;
}

/**
 * Gets the url of the login page based on the current config and location
 * @return {string} url of the login page
 */
function getLoginLink() {
	return 'https://' + config.domain + '/login.php?forward=' + encodeURIComponent(document.location);
}

/**
 * Gets the url of the login page based on the current config and location taht ends up being secure
 * @return {string} url of the login page
 */
function getSecureLoginLink() {
	return 'https://' + config.domain + '/login.php?forward=' + encodeURIComponent('https://' + config.domain + sa.router.getCurrentPath(true));
}

/**
 * Gets the url of the signup page based on the current config and location
 * @return {string} url of the signup page
 */
function getSignupLink() {
	return 'https://' + config.domain + '/signup.php';
}
/**
 * ██╗  ██╗ ██████╗ ██╗    ██╗    ████████╗██╗  ██╗██╗███████╗     █████╗ ██╗     ██╗         ██╗    ██╗ ██████╗ ██████╗ ██╗  ██╗███████╗
 * ██║  ██║██╔═══██╗██║    ██║    ╚══██╔══╝██║  ██║██║██╔════╝    ██╔══██╗██║     ██║         ██║    ██║██╔═══██╗██╔══██╗██║ ██╔╝██╔════╝
 * ███████║██║   ██║██║ █╗ ██║       ██║   ███████║██║███████╗    ███████║██║     ██║         ██║ █╗ ██║██║   ██║██████╔╝█████╔╝ ███████╗
 * ██╔══██║██║   ██║██║███╗██║       ██║   ██╔══██║██║╚════██║    ██╔══██║██║     ██║         ██║███╗██║██║   ██║██╔══██╗██╔═██╗ ╚════██║
 * ██║  ██║╚██████╔╝╚███╔███╔╝       ██║   ██║  ██║██║███████║    ██║  ██║███████╗███████╗    ╚███╔███╔╝╚██████╔╝██║  ██║██║  ██╗███████║
 * ╚═╝  ╚═╝ ╚═════╝  ╚══╝╚══╝        ╚═╝   ╚═╝  ╚═╝╚═╝╚══════╝    ╚═╝  ╚═╝╚══════╝╚══════╝     ╚══╝╚══╝  ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝
 *
 *
 * This is a master class which generates lists of elements you might want displayed: "Albums, Tracks, Project Items, Cue Sheets".
 *
 * Generally, for each type of element, there is a function like createTrackList, createAlbumList, etc. which generates a List which can be
 * used to render the list on to the page via List.generatePage($('#containerYouWantTheListIn')).
 *
 * As things are on Jun 01, 2021, there are generally two ways the elements are rendered: as a table, as in listType === 'track',
 * and as amorphous "blocks" as in listType === 'albums'.  See List::generatePage for how this is working.
 *
 * Once the container is declared as a block or a table, List::addItem is used to actually add things to it.  In the case of blocks,
 * a function is passed whose output generates a block of HTML.
 * In the case of tables, and in the case of tracklists for example, the columns for track lists are declared in PHP,
 * in class.config.php::getTrackListColumns.  Then the code here accesses those configs, translates them into
 * columns and rows: see generateListItemRow and addItem.
 *
 * The Lists can have different Views as well, which sit at the top of the rendered List, allowing you to change the look of the
 * resulting List.  A combination of the view, the listType (track, album, etc.), is used to generate the final output.
 *
 * Check in the functions listed above to get an idea of the general flow.
 * explorer.js is an example where a tracklist is rendered via createTrackList (but is not yet rendered to the page),
 *
 *
 */

/**
 * Objects that list stuff, like tracks, artists, albums, reps
 */

function ListColumn(name, columns, sortable) {
	let listColumn = this;

	listColumn.name = name;
	listColumn.sortable = sortable;

	/** @type {Array.<ListDisplayColumn>} */
	listColumn.displayColumns = [];
	for (let column of columns) {
		if (column instanceof ListDisplayColumn) {
			listColumn.displayColumns.push(column);
		} else {
			listColumn.displayColumns.push(new ListDisplayColumn(column));
		}
	}

	/**
	 * @returns {boolean}
	 */
	listColumn.isHidden = function () {
		for (let displayColumn of this.displayColumns) {
			if (!displayColumn.hidden) {
				return false;
			}
		}
		return true;
	};

	/**
	 * Sets all hidden columns as visible again
	 */
	listColumn.showHidden = function () {
		for (let displayColumn of this.displayColumns) {
			displayColumn.hidden = false;
		}
	};

	/**
	 * @param {string} name
	 * @returns {boolean}
	 */
	listColumn.hasDisplayColumn = function (name) {
		for (let displayColumn of this.displayColumns) {
			if (displayColumn.name === name) {
				return true;
			}
		}
		return false;
	};

	/**
	 * @param {string} name
	 * @returns {ListDisplayColumn|null}
	 */
	listColumn.getDisplayColumn = function (name) {
		for (let displayColumn of this.displayColumns) {
			if (displayColumn.name === name) {
				return displayColumn;
			}
		}
		return null;
	};

	/**
	 * @returns {Array.<ListDisplayColumn>}
	 */
	listColumn.getVisibleDisplayColumns = function () {
		let cols = [];
		for (let displayColumn of this.displayColumns) {
			if (!displayColumn.hidden) {
				cols.push(displayColumn);
			}
		}
		return cols;
	};

	/**
	 * @param {ListDisplayColumn|string} column
	 * @param {int} [index]
	 */
	listColumn.addDisplayColumn = function (column, index) {
		if (!(column instanceof ListDisplayColumn)) {
			column = new ListDisplayColumn(column);
		}
		if (index !== undefined) {
			listColumn.displayColumns.splice(index, 0, column);
		} else {
			listColumn.displayColumns.push(column);
		}
	};

	/**
	 * @param {ListDisplayColumn|string} columnName
	 * @return {boolean} was anything removed?
	 */
	listColumn.removeDisplayColumn = function (columnName) {
		if (columnName instanceof ListDisplayColumn) {
			columnName = columnName.name;
		}
		for (let i = 0, len = this.displayColumns.length; i < len; i++) {
			if (this.displayColumns[i].name === columnName) {
				this.displayColumns.splice(i, 1);
				return true;
			}
		}
		return false;
	};

	/**
	 * @param {ListDisplayColumn|string} columnName
	 * @return {boolean} was anything hidden?
	 */
	listColumn.hideDisplayColumn = function (columnName) {
		if (columnName instanceof ListDisplayColumn) {
			columnName = columnName.name;
		}
		for (let i = 0, len = this.displayColumns.length; i < len; i++) {
			if (this.displayColumns[i].name === columnName) {
				this.displayColumns[i].hidden = true;
				return true;
			}
		}
		return false;
	};
}

function ListDisplayColumn(name) {
	this.name = name;
	this.hidden = false;
}


function ListConfig(initialData) {
	this.allowMobileView = true;
	this.allowBlock = true;
	this.allowEditing = true; // won't override user's permissions but can be used to disable admin features, like featuring, editing, and deleting
	this.allowList = true;
	this.allowMiniBlock = true;
	this.affectFilters = true;
	this.bankKey = 'default';
	this.callback = function () { };
	/** @type {function} */
	this.callbackActual = null;
	this.columnLists = {};
	this.defaultResultsPerPage = 100;
	this.defaultViewType = 't';
	this.disableEmptyMessage = false;
	this.disableLinks = false;
	this.extraLoadVars = ''; // string vars that should be appended to any load requests (these vars are copied down to expanded tracks)
	this.emptyMessage = '';
	this.filterNoResultMessage = '';
	this.activeFilters = new Set();
	this.headerBackground = true;
	this.linkFunc = function () {
	};
	this.listType = '';
	this.loadingTextOverride = '';
	this.pagination = true;
	this.resultCountChanging = true;
	this.resultsPerPageCookie = true;
	this.selectable = true;
	this.selectorConfig = {};
	this.sortable = true;
	this.stripe = true;
	this.useFilters = false;
	this.viewCookie = true;
	this.suppressFeature = false;

	this.columnLists[ListViewType.List] = [];
	this.columnLists[ListViewType.MiniBlock] = [];
	this.columnLists[ListViewType.Block] = [];
	this.columnLists[ListViewType.Mobile] = [];

	for (let i in initialData) {
		if (!initialData.hasOwnProperty(i) || i == 'defaultViewType' || i == 'getDefaultView') continue;
		this[i] = initialData[i];
	}
}

/**
 * If you want to force a view, turn viewCookie off and change this function. conf.getDefaultView = function() { return ListViewType.List; }; for example
 * @return {string}
 */
ListConfig.prototype.getDefaultView = function () {
	return user.getView(this.defaultViewType);
};

/**
 * Adds a column list to this List for certain view types
 * @param {Array.<ListColumn>} columnList
 * @param {string|Array.<string>} [viewTypes] one of the ListViewType constants as a string, an array of those constants, or defaults to all
 */
ListConfig.prototype.addColumnList = function (columnList, viewTypes) {
	if (!viewTypes) {
		viewTypes = [ListViewType.List, ListViewType.Block, ListViewType.MiniBlock];
	} else if (!viewTypes.isArray) {
		viewTypes = [viewTypes];
	}
	for (let viewType of viewTypes) {
		this.columnLists[viewType] = columnList;
	}
};

/**
 * Gets the column list associated with a specific view type
 * @param {string} viewType one of the ListViewType constants
 * @returns {Array.<ListColumn>|null}
 */
ListConfig.prototype.getColumnList = function (viewType) {
	return getCustomColumnList(this.columnLists[viewType]);
};

/**
 * @returns {Array.<ListViewType>}
 */
ListConfig.prototype.getAllowedViewTypes = function () {
	let viewTypes = [];
	if (this.allowList) {
		viewTypes.push(new ListViewType('Simple', ListViewType.List));
	}
	if (this.listType === 'track' || this.listType === 'project_item') {
		if (this.allowBlock) {
			viewTypes.push(new ListViewType('Wave', ListViewType.Block));
		}
		// if (this.allowMiniBlock) {
		// 	viewTypes.push(new ListViewType('Wave', ListViewType.MiniBlock));
		// }
	} else {
		if (this.allowMiniBlock) {
			viewTypes.push(new ListViewType('Art', ListViewType.MiniBlock));
		}
		if (this.allowBlock) {
			viewTypes.push(new ListViewType('Detailed', ListViewType.Block));
		}
	}
	return viewTypes;
};

/**
 * Checks if the view type is allowed by this config
 * @param {string} type
 * @returns {boolean}
 */
ListConfig.prototype.isViewTypeAllowed = function (type) {
	if (type === ListViewType.Block) {
		return this.allowBlock;
	} else if (type === ListViewType.List) {
		return this.allowList;
	} else if (type === ListViewType.MiniBlock) {
		return this.allowMiniBlock;
	} else if (type === ListViewType.Mobile) {
		return this.allowMobileView;
	}
	return false;
};

ListConfig.prototype.getMobileView = function () {
	var isMobile = sa.isMobile();
	// Handle mobile
	if (isMobile) {
		if (this.bankKey == 'publish_component' || this.bankKey == 'users' || this.bankKey == "sad_detections_page") {
			return this.getDefaultView();
		}
		if (this.listType === 'track' || this.listType === 'project_item') {
			return ListViewType.Mobile;
		} else if (this.listType == 'license' || this.listType == 'multiformat') {
			return this.getDefaultView();
		} else if (this.isViewTypeAllowed(ListViewType.MiniBlock)) {
			return ListViewType.MiniBlock;
		} else {
			return this.getDefaultView()
		}
	} else {
		return false;
	}
}

function ListViewType(name, type) {
	this.name = name;
	this.type = type;
}

// ListViewType names for List.setView
ListViewType.Block = 'block';
ListViewType.MiniBlock = 'mini-block';
ListViewType.List = 'list';
ListViewType.CueSheetBlock = 'cue-sheet-block';
ListViewType.Mobile = 'mobile';

/**
 *
 * @param initialData
 * @constructor
 * @augments ListConfig
 */
function TrackListConfig(initialData) {
	this.addDetailsRows = false;
	this.commentLoadVars = null;
	this.commentSaveVars = null;
	this.disableLinksToLists = lockdown || config.siteMode === 'receive';
	this.skipWaveforms = false;
	this.sourceOverride = '';
	this.topBar = false;
	this.useCache = false;
	this.useMusicSupplierData = false;

	initialData = $j.extend(true, {
		allowBlock: false,
		allowMiniBlock: false,
		defaultResultsPerPage: config.defaultResultsPerPage
	}, initialData);

	if (initialData.allowMiniBlock) {
		initialData.allowBlock = true;
		initialData.allowMiniBlock = false;
	}

	ListConfig.call(this, initialData);

	this.listType = 'track';
}
TrackListConfig.prototype = Object.create(ListConfig.prototype);


/**
 * This is where one defines the mappings between the column lists that come through in the JS config and the ListViewTypes
 *
 **/
TrackListConfig.prototype.useStandardColumnList = function () {
	this.addColumnList(getCustomColumnList(config.trackColumnLists.simple.normal), [ListViewType.List, ListViewType.MiniBlock]);
	this.addColumnList(getCustomColumnList(config.trackColumnLists.wave.normal), ListViewType.Block);
	this.addColumnList(getCustomColumnList(config.trackColumnLists.mobile.normal), ListViewType.Mobile);
};
TrackListConfig.prototype.isViewTypeAllowed = function (type) {
	if (type === ListViewType.MiniBlock) {
		return false;
	}
	return ListConfig.prototype.isViewTypeAllowed.call(this, type);
};
TrackListConfig.prototype.getAllowedViewTypes = function () {
	this.allowMiniBlock = false;
	return ListConfig.prototype.getAllowedViewTypes.call(this);
};
Object.defineProperty(TrackListConfig.prototype, 'constructor', {
	value: TrackListConfig,
	enumerable: false,
	writable: true
});

function getTrackList() {
	var tls = [],
		lists = $j('.track_list');
	for (var i = 0, len = lists.length; i < len; i++) {
		var list = $j(lists[i]),
			listObject = list.data('list-object');
		if (listObject) {
			tls.push(listObject);
		}
	}
	if (!tls.length) {
		tls[0] = {
			highlightTrack: function () { },
			stopExpandedTimer: function () { },
			hideExpandedActual: function () { },
			setResultsPerPage: function () { },
			enableQuickProjects: function () { },
			disableQuickProjects: function () { },
			enableQuickCueSheets: function () { },
		};
	}
	return new MetaTrackList(tls);
}

function getAlbumList() {
	var cp = sa.getCurrentPageName();
	if (cp == sa.pages.albumList.name) {
		return sa.pages.albumList;
	} else if (cp == 'catalog') {
		return sa.pages.catalog.getAlbumList();
	} else if (cp == 'label') {
		return sa.pages.label.getAlbumList();
	} else {
		// functions calling this assume they're going to get an album list and may immediately call
		// the below specified functions. rather than make them all check to see if the return was valid,
		// we can just return an object that'll do what they expect
		return { enableQuickProjects: function () { }, disableQuickProjects: function () { } };
	}
}

function reloadTrackList(removePage) {
	let currentPage = sa.router.getCurrentRoute(true);

	if (
		currentPage === 'tracks'
		|| (currentPage === 'catalog' && sa.pages.catalog.isShowingTrackList())
		|| (currentPage === 'label' && sa.pages.label.isShowingTrackList())
		|| (currentPage === 'music-supplier' && sa.pages.musicSupplier.isShowingTrackList())
		|| currentPage === 'sonicsearch'
	) {
		console.log('Reloading Track List');

		let newPath = reloadTrackListRoute(removePage, 'tracks');
		console.log(newPath);
		sa.router.routeTo(newPath);
	}
}

function reloadAlbumList() {
	let currentPage = sa.router.getCurrentRoute(true);

	if (
		currentPage === 'albums'
		|| (currentPage === 'catalog' && sa.pages.catalog.isShowingAlbumList())
		|| (currentPage === 'label' && sa.pages.label.isShowingAlbumList())
		|| (currentPage === 'music-supplier' && sa.pages.musicSupplier.isShowingAlbumList())
	) {
		let newPath = reloadTrackListRoute(true, 'albums');
		console.log(newPath);
		sa.router.routeTo(newPath);
	}
}

function reloadList(listType) {
	if (listType == 'track') {
		return reloadTrackList();
	} else if (listType == 'album') {
		return reloadAlbumList();
	} else {
		console.warn('Not sure how to reload lists of type', listType);
	}
}

/**
 * Generates a new hash based on the current hash and the left nav state
 * 	The left nav overrides the current hash in the event of conflict
 * 	Note that left nav returning an empty string as a value counts as a value (which it does for each of its unset values)
 * 	Used to apply left nav filters to pages that should have them.
 * 	ie, when you go to #explorer and you have left nav filters but they're not in the url. this adds them
 * @param {boolean=} applyLeftNav if set, will apply the left nav filters to the track list hash
 * @param {string=} leftNavType if 'tracks' or 'albums', will restrict results to that filter section
 * @return {string} hash
 */
function reloadTrackListRoute(applyLeftNav, leftNavType) {
	// grab the vars according to the current hash
	let currentVars = sa.router.paramsToVars(sa.router.getCurrentQueryParams());
	if (applyLeftNav) {
		// grab the vars according to the left nav
		var newVars = sa.router.paramsToVars(sa.components.leftNav.getParams(false, leftNavType));
		// go through each left nav var and if it's empty, delete it from the current hash vars
		// if it's not empty, let it in the current vars
		for (var i in newVars) {
			if (!newVars.hasOwnProperty(i)) continue;
			var curr = newVars[i];
			if (!curr.isArray && typeof (curr) == 'object') {
				var del = true;
				for (var j in curr) {
					if (!curr.hasOwnProperty(j)) continue;
					if (curr[j] != '') del = false;
				}
				if (del) {
					delete currentVars[i];
					delete currentVars[i.replace('[]', '')];
				}
				else currentVars[i] = curr;
			} else if (curr == '') {
				delete currentVars[i];
				delete currentVars[i.replace('[]', '')];
			} else {
				currentVars[i] = curr;
			}
		}
		// here's where we pull out pg if specified in the parameter
		if (currentVars['pg']) {
			delete currentVars['pg'];
		}
	}
	// also remove override
	if (currentVars['override']) {
		delete currentVars['override'];
	}

	// Build the new route path
	let currentPath = sa.router.currentUrl.pathname;
	let queryString = sa.router.queryParamsToString(currentVars);
	queryString = (queryString && queryString.startsWith('?')) ? queryString : '';
	return currentPath + queryString;

	// make the altered current hash vars a hash again and return
	// return sa.getCurrentPageName() + (sa.router.queryParamsToString(currentVars));
}

/**
 * Returns a standardized track list column list, adjusted based on the current config
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardColumnList() {
	return getCustomColumnList(config.trackColumnLists.simple.normal);
}

/**
 * Creates a deep copy of the cols so you can change it later (if necessary) without overwriting the default
 * @param {Array.<ListColumn>} cols
 * @return {Array.<ListColumn>}
 */
function getCustomColumnList(cols) {
	let list = [];
	if (!cols) {
		return list;
	}
	for (let len = cols.length, i = 0; i < len; i++) {
		let c = cols[i];
		list.push(new ListColumn(c.name, c.displayColumns.slice(0), c.sortable));
	}
	if (config.siteMode === 'receive') {
		list.each(function (i, listColumn) {
			let emailColumn = listColumn.getDisplayColumn('email');
			if (emailColumn !== null) {
				emailColumn.hidden = true;
			}
		});
	}
	return list;
}

/**
 * Creates a new alternate track list config
 * @param {string} viewType
 * @return {TrackListConfig} the config
 */
function getAlternateTrackListConfig(viewType) {
	let conf = new TrackListConfig();
	let columnList = [];

	if (viewType === ListViewType.Block) {
		columnList = getCustomColumnList(config.trackColumnLists.wave.alternate);
	} else {
		columnList = getCustomColumnList(config.trackColumnLists.simple.alternate);
	}
	conf.addColumnList(columnList);
	conf.affectFilters = false;
	conf.allowBlock = true;
	conf.bankKey = 'alternate_track_list_';
	conf.defaultResultsPerPage = 50;
	//conf.headerBackground = false;
	conf.emptyMessage = 'No tracks found.';
	conf.pagination = false;
	conf.resultCountChanging = false;
	conf.resultsPerPageCookie = false;
	conf.stripe = true;
	conf.sortable = false;
	conf.useCache = false;
	conf.useFilters = false;
	return conf;
}

/**
 * Returns a standardized album list column list, adjusted based on the current config
 * @param {boolean} [singleCatalog] list will be different if it's only for a single catalog's albums
 * @param {boolean} [singleLabel] list will be different if it's only for a single label's albums
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardAlbumColumnList(singleCatalog, singleLabel) {
	var ret;
	if (config.siteType === 'drop') {
		ret = [
			new ListColumn('name', ['album avatar', 'name', 'expand-album', 'download', 'email'], true)
		];
	} else if (config.singleCatalog || singleCatalog) {
		if (config.showLabels && !singleLabel) {
			ret = [
				new ListColumn('name', ['album avatar', 'name', 'expand-album', 'download', 'email'], true),
				new ListColumn(config.getDictionaryEntry('label', false, true), ['label'], true),
				new ListColumn('Release Date', ['added'], true)
			];
		} else {
			ret = [
				new ListColumn('name', ['album avatar', 'name', 'expand-album', 'download', 'email'], true),
				new ListColumn('Release Date', ['added'], true)
			];
		}
	} else {
		ret = [
			new ListColumn('name', ['album avatar', 'name', 'expand-album', 'download', 'email'], true),
			new ListColumn(config.getDictionaryEntry('catalog', false, true), ['rep'], true),
			new ListColumn('Release Date', ['added'], true)
		];
	}
	if (!user.hasAdminPermission(AdminPermission.Statistics) && (config.id == 4 || config.id == 12 || config.id == 105)) { // beyond doesn't want some of their info
		ret.splice(ret.length - 1, 1); //play counts, track count, release date
	}
	if (config.id == 628) {
		ret.splice(1, 0, new ListColumn('artist', ['artist']));
	}
	if (config.id == 382 || config.id == 1494) { //beatbox doesn't want release dates
		ret.pop();
	}
	return ret;
}

/**
 * Returns a standardized artist list column list, adjusted based on the current config
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardArtistColumnList() {
	return [
		new ListColumn('name', ['name'], true),
		new ListColumn('track count', ['count'], true)
	];
}

/**
 * Returns a standardized composer list column list, adjusted based on the current config
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardComposerColumnList() {
	return [
		new ListColumn('name', ['name'], true),
		new ListColumn('track count', ['count'], true)
	];
}

/**
 * Returns a standardized writer list column list, adjusted based on the current config
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardWriterColumnList() {
	return [
		new ListColumn('name', ['name'], true),
		new ListColumn('track count', ['track_count'], true)
	];
}

/**
 * Returns a standardized writer list column list, adjusted based on the current config
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardPublisherColumnList() {
	return [
		new ListColumn('name', ['name'], true),
		new ListColumn('track count', ['track_count'], true)
	];
}
/**
 * Returns a standardized label list column list, adjusted based on the current config
 * @param {boolean} [singleCatalog] list will be different if it's only for a single catalog's albums
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardLabelColumnList(singleCatalog) {
	var ret;
	if (config.singleCatalog || singleCatalog) {
		ret = [
			new ListColumn('name', ['name'], true),
			new ListColumn('track count', ['count'], true),
			new ListColumn(config.getDictionaryEntry('album') + ' count', ['album count'], true),
			new ListColumn('artist count', ['artist count'], true)
		];
	} else {
		ret = [
			new ListColumn('name', ['name'], true),
			new ListColumn('catalog', ['rep'], true),
			new ListColumn('track count', ['count'], true),
			new ListColumn(config.getDictionaryEntry('album') + ' count', ['album count'], true),
			new ListColumn('artist count', ['artist count'], true)
		];
	}
	if (config.id == 4 || config.id == 12 || config.id == 105) { // beyond doesn't want play counts for non admins for artist counts for anyone
		ret.splice(ret.length - 2, 1);
		if (!user.hasAdminPermission(AdminPermission.Statistics)) {
			console.log('user is not admin', user.userData, window['user'].userData);
			ret.splice(ret.length - 1, 1);
		}
	}
	return ret;
}

/**
 * Returns a standardized catalog list column list, adjusted based on the current config
 * @return {Array} an array of ListColumns, suitable for passing into ListConfig.addColumnList
 */
function getStandardCatalogColumnList() {
	return [
		new ListColumn('name', ['name'], true),
		new ListColumn('track count', ['track count'], true)
	];
}

/**
 * For the XxxList objects, there are a couple things you need to know if you're adding a new one
 * this.conf.listType should match the name of the _info.php file. So if you want to load 'foo_bar_info.php', your listType should be 'foo_bar';
 * this.conf.defaultViewType is the key for the view type cookie used to store this list's view setting. it should match one of the shortTypes in user.setView()
 */

/**
 * Lists albums
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createAlbumList(conf) {
	conf.defaultViewType = 'b';
	conf.linkFunc = getAlbumLink;
	conf.listType = 'album';
	conf.selectable = true;

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists artists
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createArtistList(conf) {
	conf.defaultViewType = 'a';
	conf.linkFunc = getArtistLink;
	conf.listType = 'artist';
	if (config.siteType === 'drop') {
		conf.allowBlock = false;
		conf.allowMiniBlock = false;
		conf.allowList = true;
		conf.getDefaultView = function () { return ListViewType.List; };
	}

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists catalogs
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createCatalogList(conf) {
	conf.defaultViewType = 'c';
	conf.linkFunc = getCatalogLink;
	conf.listType = 'catalog';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists composers
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createComposerList(conf) {
	conf.defaultViewType = 'o';
	conf.linkFunc = getComposerLink;
	conf.listType = 'composer';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists writers
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createWriterList(conf) {
	// defaultViewType should be the same as what you set in user::setView for writers
	conf.defaultViewType = 'w';
	conf.linkFunc = getWriterLink;
	conf.listType = 'writer';
	conf.sourceOverride = 'person_info';
	conf.extraLoadVars = 't=writer';
	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists publishers
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createPublisherList(conf) {
	// defaultViewType should be the same as what you set in user::setView for writers

	conf.defaultViewType = 'u';
	conf.linkFunc = getPublisherLink;
	conf.listType = 'publisher';
	conf.sourceOverride = 'person_info';
	conf.extraLoadVars = 't=publisher';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists cue sheets
 * @param {TrackListConfig} conf the conf params for the list
 * @return {List}
 */
function createCueSheetList(conf) {
	conf.getDefaultView = function () { return ListViewType.CueSheetBlock; };
	conf.linkFunc = getCueSheetLink;
	conf.listType = 'cue_sheet';
	conf.resultCountChanging = false;
	conf.sortable = false;

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;
	list.playlistData = {}; // make sure each track list has a unique play list data

	return list;
}

/**
 * Lists labels
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createLabelList(conf) {
	conf.defaultViewType = 'l';
	conf.linkFunc = getLabelLink;
	conf.listType = 'label';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists music suppliers
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createMusicSupplierList(conf) {
	conf.defaultViewType = 'm';
	conf.linkFunc = getMusicSupplierLink;
	conf.listType = 'music_supplier';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists project items
 * @param {TrackListConfig} conf the conf params for the list
 * @return {List}
 */
function createProjectItemList(conf) {
	conf.defaultViewType = 'p';
	conf.linkFunc = getProjectLink;
	conf.listType = 'project_item';
	conf.sortable = false;

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;
	list.playlistData = {}; // make sure each track list has a unique play list data

	return list;
}

/**
 * Lists projects. A subclass of List
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createProjectList(conf) {
	conf.allowMiniBlock = config.siteType !== 'drop';
	conf.defaultViewType = 'r';
	conf.linkFunc = getProjectLink;
	conf.listType = 'project';
	conf.sortable = false;

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;
	list.playlistData = {}; // make sure each track list has a unique play list data

	return list;
}

/**
 * Lists tracks
 * @param {TrackListConfig} conf the conf params for the list
 * @return {List}
 */
function createTrackList(conf) {
	conf.defaultViewType = 't';
	conf.linkFunc = getTrackLink;
	conf.listType = 'track';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;
	list.playlistData = {}; // make sure each track list has a unique play list data

	return list;
}

/**
 * Lists the license history of a white label or user with offers
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createLicenseHistoryList(conf) {
	let baseUrl = siteBaseUrl();
	conf.allowBlock = false;
	conf.getDefaultView = function () { return ListViewType.List; };
	conf.linkFunc = function () { return baseUrl + '/admin?p=licenses'; };
	conf.listType = 'license';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists the license history of a white label or user with offers
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createLicensingActivityList(conf) {
	conf.allowBlock = false;
	conf.getDefaultView = function () { return ListViewType.List; };
	conf.sortable = false;
	conf.suppressFeature = true;
	let baseUrl = siteBaseUrl();
	conf.linkFunc = function (id) {
		return baseUrl + '/track/' + id;
	};
	conf.listType = 'license';
	// conf.linkFunc = getTrackLink;
	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists the sa detection
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createSADetectionList(conf) {
	conf.allowBlock = false;
	conf.getDefaultView = function () { return ListViewType.List; };
	conf.linkFunc = getTrackLink;
	conf.listType = 'sad';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists the confirmed sa detections
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createConfirmedSADetectionList(conf) {
	conf.allowBlock = false;
	conf.getDefaultView = function () { return ListViewType.List; };
	conf.linkFunc = getTrackLink;
	conf.listType = 'confirmedSad';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists SonicSearch results
 * @param {TrackListConfig} conf the conf params for the list
 * @return {List}
 */
function createSonicSearchResultsList(conf) {
	conf.allowMiniBlock = true;
	conf.allowBlock = true;
	conf.linkFunc = getTrackLink;
	conf.listType = 'track';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists users
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createUserList(conf) {
	let baseUrl = siteBaseUrl();
	conf.allowBlock = false;
	conf.getDefaultView = function () { return ListViewType.List; };
	conf.linkFunc = function (userId) { return baseUrl + '/admin?page=stats&tab=user&user=' + userId; };
	conf.listType = 'user';

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists a variety of formatted objects together in one list. Designed for activity lists
 * @param {ListConfig} conf the conf params for the list
 * @return {List}
 */
function createMultiFormatList(conf) {
	let baseUrl = siteBaseUrl();
	conf.allowBlock = false;
	conf.getDefaultView = function () { return ListViewType.List; };
	conf.linkFunc = function (userId) { return baseUrl + '/admin?page=stats&tab=user&user=' + userId; };
	conf.listType = 'multiformat';
	conf.headerBackground = false;

	var list = new List(conf);
	list.resultsPerPage = conf.defaultResultsPerPage;

	return list;
}

/**
 * Lists requests
 * @param {ListConfig} conf
 * @returns {List}
 */
// function createRequestList(conf) {
// 	conf.allowList = true;
// 	conf.allowMiniBlock = false;
// 	conf.allowBlock = true;
// 	conf.getDefaultView = function() { return 'list'; };
// 	conf.linkFunc = function(requestId) { return '/requests?p=details&requestId=' + requestId; };
// 	conf.listType = 'request';
//
// 	let list = new List(conf);
// 	list.resultsPerPage = conf.defaultResultsPerPage;
//
// 	return list;
// }

/**
 * Lists objects on the page, like tracks, composers, etc.
 * @param {ListConfig|TrackListConfig} conf
 * @property {JQuery} blocks
 * @property {JQuery} container
 * @property {JQuery} table
 * @constructor
 */
function List(conf) {
	var list = this;
	var templating;
	this.blocks = null;
	this.conf = conf;
	this.container = null;
	this.lastRequest = 0;
	this.lastRequestString = '';
	this.pageVars = '';
	this.playlistData = {};
	this.resultsPerPage = 15; // placeholder for highlighting. set by subclasses
	this.sourceLinkFunction = null;
	this.table = null;
	this.useMetaPermissionProfile = false;
	this.view = ListViewType.List; // placeholder for highlighting. set by subclasses

	var rowTimeout = 0;
	var rowTimeoutIncrement = 100;

	/** @type {Array.<ListColumn>} */
	let columnList = [];

	// eventify stubs
	this.on = function () { };
	this.off = function () { };
	this.trigger = function () { };
	sa.eventify(this);

	let licenseNowText = config.id === 7494 ? 'Request License' : 'License Now'; // change for Netflix #4293

	sa.on('resize', _.debounce(function () {
		list.sizeForMobile();
	}, 50));

	/**
	 * @returns {TemplateSet}
	 */
	function getTemplates() {
		if (!List.Templates) {
			List.Templates = sa.templates.get('list_objects');
		}
		return List.Templates;
	}

	/**
	 * Shows a transparent cover with loader gif on top of the track list
	 * @param {string} vars the new vars for the page so we can determine the message to show in the loader
	 * @param {string=} message if specified, this will be the message instead of trying to parse vars (optional)
	 */
	this.showCover = function (vars, message) {
		// special handling for AI searches
		const varParams = sa.router.convertQueryStringToUrlSearchObj(vars);
		let aiSearch = false;
		if (varParams && varParams.has('ai')) {
			aiSearch = true;
			// make message a jQuery object
			const artemisMessage = 'Artemis is thinking...';
			const sharedTemplates = sa.templates.get('shared');
			const $artemis = sharedTemplates.get('artemis');
			message = $j(`<div class="ai_loader"><div class="artemis_graphic animate-beat"></div>${artemisMessage}</div>`);
			message.find('.artemis_graphic').prepend($artemis);
		}
		this.hideCover();
		var container = aiSearch ? $j('#right_content') : this.container,
			coverLoader = $j('<div id="track_list_cover_loader"><div class="background"></div></div>'),
			loadingName = 'Loading',
			dictEntry = config.getDictionaryEntry(this.conf.listType, true, true);

		container.addClass('covered').append('<div id="track_list_cover"></div>');
		if (dictEntry == 'projects') {
			dictEntry = 'playlists';
		} else if (dictEntry == 'project_items') {
			dictEntry = 'playlist_items';
		}
		if (this.conf.listType != 'multiformat') {
			loadingName += ' ' + dictEntry.replace('_', ' ');
		}

		if (this.conf.loadingTextOverride) {
			loadingName = this.conf.loadingTextOverride
		}
		showLoader(coverLoader[0], message ? message : getLoadingMessage(this.lastRequestString, vars, loadingName + '...'));
		container.append(coverLoader);
		// hide any existing
		if (this.conf.listType != 'track' && this.view == ListViewType.MiniBlock) {
			this.blocks.find('.list_block').addClass('hiding');
		}
	};

	/**
	 * Hides the cover if it's visible
	 */
	this.hideCover = function () {
		// special handling for AI searches
		const vars = sa.router.getCurrentQueryParams();
		const varParams = sa.router.convertQueryStringToUrlSearchObj(vars);
		let aiSearch = false;
		if (varParams && varParams.has('ai')) {
			aiSearch = true;
		}
		const container = aiSearch ? $j('#right_content') : this.container;
		container.removeClass('covered').find('#track_list_cover, #track_list_cover_loader').remove();
	};

	/**
	 * Commences the loading process, formatting the request to the server and then making it
	 * @param {string} vars variables passed to the server so it knows how to filter/sort/etc.
	 */
	this.loadPage = function (vars) {
		var listType = conf.listType,
			source = conf.sourceOverride ? conf.sourceOverride : listType + '_info',
			newRoutePath,
			parsedVars = sa.router.paramsToVars(vars);

		vars = typeof vars !== 'string' ? vars.toString() : vars;

		this.loadResultsPerPage();
		let lastRequest = ++this.lastRequest;
		newRoutePath = reloadTrackListRoute();
		// the left nav state to match the override value
		if (sa.components.leftNav && conf.affectFilters && (listType === 'track' || listType === 'album')) {
			sa.components.leftNav.applyOverride();
		}

		if (conf.useFilters && newRoutePath && !newRoutePath.includes(sa.router.getCurrentRoute(true))) {
			reloadList(conf.listType);
			let varsFromString = sa.router.pullParamsFromString(newRoutePath);

			if (varsFromString && vars && !varsFromString.includes(vars)) {
				vars = varsFromString + '&' + vars;
			} else {
				vars = varsFromString ? varsFromString : vars;
			}
		}
		// removed this.conf.resultsPerPageCookie && from this statement because it wasn't minding defaultResultsPerPage
		if (!vars || !vars.match(/show=[0-9]+/)) {
			vars = (vars ? vars : '') + '&show=' + this.resultsPerPage;
		}
		if (conf.extraLoadVars) {
			if (vars.indexOf(conf.extraLoadVars) === -1) { // this won't work well if you have multiple vars. sorry
				vars += '&' + conf.extraLoadVars;
			}
		}
		if (parsedVars && parsedVars['reqOverride']) {
			lastRequest = this.lastRequest = parsedVars['reqOverride'];
		}

		// validate search terms
		if (parsedVars && parsedVars.s) {
			// check for odd number of quotes and notify users that this is a bad idea
			if ((parsedVars.s.match(/"/g) || []).length % 2 != 0) {
				sa.alert('Your search has an odd number of quotation marks, which might produce bad results. If you don\'t find what you\'re looking for, please consult our <a href="https://docs.sourceaudio.com/search/advanced_search.html">Advanced Search Documentation</a> for help.');
			}
		}

		this.showCover(vars);
		this.lastRequestString = 'p=' + source + (vars != undefined ? '&' + vars.replace('p=' + source + '&', '') : '');

		let uploadingImportTrackCount = 0;
		if (conf.listType === 'track' || conf.listType === 'project_item') {
			let currentPath = sa.router.getCurrentPath();
			uploadingImportTrackCount = sa.importTrackManager.getUploadingImportTracks(currentPath).length;
			if (uploadingImportTrackCount !== 0) {
				this.lastRequestString += '&uploadingImportTrackCount=' + uploadingImportTrackCount;
			}
		}
		let cachedRequestResult;
		this.playlistData.requestString = this.lastRequestString;
		if (uploadingImportTrackCount || !conf.useCache || !(cachedRequestResult = sa.requestCache.get(this.lastRequestString))) {
			loadLastRequest();
		} else if (config.siteType === 'drop' && (conf.listType === 'track' || conf.listType === 'project_item') && user.hasAdminPermission(AdminPermission.Metadata)) {
			ajax({ p: 'import_tracks', action: 'checkForUnfinished', cacheBreak: new Date().getTime() }, function (e) {
				if (response['unfinished']) {
					loadLastRequest();
				} else {
					loadCachedRequest(cachedRequestResult, lastRequest);
				}
			});
		} else {
			loadCachedRequest(cachedRequestResult, lastRequest);
		}
	};

	/**
	 * Loads data using the sa.api method instead of the ajax function
	 * @param {Object} options passed directly into sa.api.request
	 * @return {Promise} the promise returned by sa.api.request
	 */
	this.loadApiPage = function (options) {
		let req = ++this.lastRequest;
		if (!options.getData) {
			options.getData = { req: req };
		} else if (!options.getData.req) {
			options.getData.req = req;
		}
		this.showCover('', 'Loading...');
		return sa.api.request(options); // returns the promise
	};

	function loadCachedRequest(requestData, lastRequestNumber) {
		requestData[0].req = lastRequestNumber;
		conf.callbackActual(requestData);
	}

	function loadLastRequest() {
		ajax(list.lastRequestString + '&req=' + list.lastRequest, conf.callback);
	}

	/**
	 * Determines if the response received was the most recent one asked for
	 */
	this.isLastRequest = function (newData) {
		if (newData) {
			return !(this.lastRequest && this.lastRequest != newData[0].req);
		}
	};

	/**
	 * Adds quick project buttons to the items
	 */
	this.enableNesters = function () {
		if (this.conf.listType == 'project') return;
		if (this.view === ListViewType.Block && (this.conf.listType === 'track' || this.conf.listType === 'project_item')) {
			// if there are already quick project buttons, don't do anything
			if (this.table.find('.quick-project_button_container').length) return;
			this.table.find('.track_row').each(function () {
				let trackId = parseInt(this.id.substring(3));
				let $this = $j(this);
				$this.find('.lc_interaction').last().after($j('<div class="quick-project_button_container"></div>').append(sa.components.nester.generateButton(trackId)));
				$this.addClass('has_add_remove_button');
			});
		} else if (this.view === ListViewType.Mobile && (this.conf.listType === 'track' || this.conf.listType == 'project_item')) {
			// mobile view
			this.blocks.find('.track_row, .project_item_row').each(function () {
				let trackId = parseInt(this.id.substring(5));
				let $this = $j(this);
				$this.find('.options').before($j('<div class="quick-project_button_container"></div>').append(sa.components.nester.generateButton(trackId)));
				$this.addClass('has_add_remove_button');
			});

		} else if (this.view == ListViewType.Block || (this.view == ListViewType.MiniBlock && this.conf.listType != 'track' && this.conf.listType != 'project_item') || this.view == ListViewType.CueSheetBlock) {
			// if there are already buttons, we don't need to do anything
			if ($j('.track_list_block .track_list_fast_tag_column').length) return;
			// find the email buttons and add add a quick project button after them
			$j('.track_list_block').each(
				function () {
					let trackId = parseInt(this.id.substring(6, this.id.length - 4));
					$j(this).find('#tag_container').append($j('<span class="button_container track_list_fast_tag_column"></span>').append(sa.components.nester.generateButton(trackId)));
				}
			);
		} else if (this.table) { // sometimes this is called before the table has loaded. just ignore in that case. it'll load with the elements
			// if there are already quick project buttons, don't do anything
			if (this.table.find('.lc_quick-project').length) {
				// Even if the tracks in a track list already have quick project buttons when enable quick projects is called, it doesn't mean it's been sized correctly. Force a resize
				//  - this happens if the track list is a nested track list. the parent's enable quick projects adds buttons to the child so when the child's version of this func runs, the buttons are there
				//    and we have to forcibly run resize
				this.addSubColumn(0, 'quick-projects');
				this.resizeTrackList();
				return;
			}
			// make sure there are actually tracks in this list
			if (this.table.find('#no_row').length) return;
			// add the column to the list of the displayed columns if it's not already there (so when we resize, the first col knows how many subcols it has)
			this.addSubColumn(0, 'quick-projects');
			// where are we adding the button
			var lastFirstColIndex = columnList[0].getVisibleDisplayColumns().length - 2;
			// now go through each row and add a button
			var lrs = this.table.find('.lr');
			for (var i = 0, len = lrs.length; i < len; i++) {
				var lr = $j(lrs[i]),
					trackId = lr.data('trackId'),
					album = lr.data('album');
				lr.find('.lc_quick-project').remove();
				lr.find('td:eq(' + lastFirstColIndex + ')').after($j('<td class="lc_quick-project"/>').append(
					album ? '' : sa.components.nester.generateButton(trackId)));
			}
			this.resizeTrackList();
		}
	};

	/**
	 * Adds quick project buttons to the items
	 */
	this.enableQuickCueSheets = function () {
		if (this.conf.listType == 'project') return;
		if (this.view === ListViewType.Block && (this.conf.listType === 'track' || this.conf.listType === 'project_item')) {
			// if there are already quick project buttons, don't do anything
			if (this.table.find('.quick-project_button_container').length) return;
			this.table.find('.track_row').each(function () {
				let trackId = parseInt(this.id.substring(3));
				let $this = $j(this);
				$this.find('.lc_interaction').last().after($j('<div class="quick-project_button_container"></div>').append(sa.components.cueSheeter.generateQuickCueSheetTrackButton(trackId)));
				$this.addClass('has_add_remove_button');
			});
		} else if (this.view === ListViewType.Mobile && (this.conf.listType === 'track' || this.conf.listType == 'project_item')) {
			// mobile view
			this.blocks.find('.track_row, .project_item_row').each(function () {
				let trackId = parseInt(this.id.substring(5));
				let $this = $j(this);
				$this.find('.options').before($j('<div class="quick-project_button_container"></div>').append(sa.components.cueSheeter.generateQuickCueSheetTrackButton(trackId)));
				$this.addClass('has_add_remove_button');
			});

		} else if (this.view == ListViewType.Block || (this.view == ListViewType.MiniBlock && this.conf.listType != 'track' && this.conf.listType != 'project_item') || this.view == ListViewType.CueSheetBlock) {

			// if there are already buttons, we don't need to do anything
			if ($j('.track_list_block .track_list_fast_tag_column').length) return;

			// find the email buttons and add add a quick project button after them
			$j('.track_list_block').each(function () {
				let trackId = parseInt(this.id.substring(6, this.id.length - 4));
				$j(this).find('#tag_container').append($j('<span class="button_container track_list_fast_tag_column"></span>').append(sa.components.cueSheeter.generateQuickCueSheetTrackButton(trackId)));
			});

			// add to track rows on the cue sheet page
			$j('.cue_sheet_block:not(.cue_sheet_custom_block)').each(function () {
				var row = $j(this);
				row.find('#tag_container').append($j('<span class="button_container track_list_fast_tag_column"></span>').append(sa.components.cueSheeter.generateQuickCueSheetTrackButton(row.data('trackId'))));
			});

			// add to custom rows on the cue sheet page
			$j('.cue_sheet_custom_block').each(function () {
				var block = $j(this);
				if (sa.components.cueSheeter.isQuickCueSheet(block.data('cueSheetId'))) {
					block.find('#tag_container').append($j('<span class="button_container track_list_fast_tag_column"></span>').append(sa.components.cueSheeter.generateQuickCueSheetTrackButton(block.data('customId'), true)));
				}
			});

		} else if (this.table) { // sometimes this is called before the table has loaded. just ignore in that case. it'll load with the elements
			// if there are already quick project buttons, don't do anything
			if (this.table.find('.lc_quick-project').length) {
				// Even if the tracks in a track list already have quick project buttons when enable quick projects is called, it doesn't mean it's been sized correctly. Force a resize
				//  - this happens if the track list is a nested track list. the parent's enable quick projects adds buttons to the child so when the child's version of this func runs, the buttons are there
				//    and we have to forcibly run resize
				this.addSubColumn(0, 'quick-projects');
				this.resizeTrackList();
				return;
			}
			// make sure there are actually tracks in this list
			if (this.table.find('#no_row').length) return;
			// add the column to the list of the displayed columns if it's not already there (so when we resize, the first col knows how many subcols it has)
			this.addSubColumn(0, 'quick-projects');
			// where are we adding the button
			var lastFirstColIndex = columnList[0].getVisibleDisplayColumns().length - 2;
			// now go through each row and add a button
			var lrs = this.table.find('.lr');
			for (var i = 0, len = lrs.length; i < len; i++) {
				var lr = $j(lrs[i]),
					trackId = lr.data('trackId'),
					album = lr.data('album');
				lr.find('.lc_quick-project').remove();
				lr.find('td:eq(' + lastFirstColIndex + ')').after($j('<td class="lc_quick-project"/>').append(
					album ? '' : sa.components.cueSheeter.generateQuickCueSheetTrackButton(trackId)));
			}
			this.resizeTrackList();
		}
	};

	/**
	 * Adds quick project buttons to the items
	 */
	this.enableQuickProjects = function () {
		if (this.conf.listType == 'project') return;
		// add to albums
		$j('.album_detailed, .project_detailed, .project_item_detailed').each(function () {
			var block = $j(this),
				album = block.data('album');
			block.find('.button_container').find('.quick_project_button').remove().end().append(sa.components.projector.generateQuickProjectAlbumButton(album));
		});
		$j('.album_block').each(function () {
			var block = $j(this),
				album = block.data('album');
			block.find('.art_image').find('.quick_project_button').remove().end().append(sa.components.projector.generateQuickProjectAlbumButton(album));//.addClass('');
		});


		// add to tracks
		if (this.view === ListViewType.Block && (this.conf.listType === 'track' || this.conf.listType === 'project_item')) {
			// if there are already quick project buttons, don't do anything
			if (this.table.find('.quick-project_button_container').length) return;
			this.table.find('.track_row').each(function () {
				let trackId = parseInt(this.id.substring(3));
				let $this = $j(this);
				$this.find('.lc_interaction').last().after($j('<div class="quick-project_button_container"></div>').append(sa.components.projector.generateQuickProjectTrackButton(trackId)));
				$this.addClass('has_add_remove_button');
			});
		} else if (this.view === ListViewType.Mobile && (this.conf.listType === 'track' || this.conf.listType == 'project_item')) {
			// mobile view
			this.blocks.find('.track_row, .project_item_row').each(function () {
				let trackId = parseInt(this.id.substring(5));
				let $this = $j(this);
				$this.find('.options').before($j('<div class="quick-project_button_container"></div>').append(sa.components.projector.generateQuickProjectTrackButton(trackId)));
				$this.addClass('has_add_remove_button');
			});

		} else if (this.view == ListViewType.Block || (this.view == ListViewType.MiniBlock && this.conf.listType != 'track' && this.conf.listType != 'project_item') || this.view == ListViewType.CueSheetBlock) {
			// if there are already buttons, we don't need to do anything
			if ($j('.track_list_block .track_list_fast_tag_column').length) return;
			// find the email buttons and add add a quick project button after them
			$j('.track_list_block').each(function () {
				let trackId = parseInt(this.id.substring(6, this.id.length - 4));
				$j(this).find('#tag_container').append($j('<span class="button_container track_list_fast_tag_column"></span>').append(sa.components.projector.generateQuickProjectTrackButton(trackId)));
			});
		} else if (this.table) { // sometimes this is called before the table has loaded. just ignore in that case. it'll load with the elements
			// if there are already quick project buttons, don't do anything
			if (this.table.find('.lc_quick-project').length) {
				// Even if the tracks in a track list already have quick project buttons when enable quick projects is called, it doesn't mean it's been sized correctly. Force a resize
				//  - this happens if the track list is a nested track list. the parent's enable quick projects adds buttons to the child so when the child's version of this func runs, the buttons are there
				//    and we have to forcibly run resize
				this.addSubColumn(0, 'quick-projects');
				this.resizeTrackList();
				return;
			}
			// make sure there are actually tracks in this list
			if (this.table.find('#no_row:visible').length) return;
			// add the column to the list of the displayed columns if it's not already there (so when we resize, the first col knows how many subcols it has)
			this.addSubColumn(0, 'quick-projects');
			// where are we adding the button
			var lastFirstColIndex = columnList[0].getVisibleDisplayColumns().length - 2;
			// now go through each row and add a button
			var lrs = this.table.find('.lr');
			for (var i = 0, len = lrs.length; i < len; i++) {
				var lr = $j(lrs[i]),
					trackId = lr.data('trackId'),
					album = lr.data('album');
				lr.find('.lc_quick-project').remove();
				lr.find('td:eq(' + lastFirstColIndex + ')').after($j('<td class="lc_quick-project"/>').append(
					album ? sa.components.projector.generateQuickProjectAlbumButton(album) : sa.components.projector.generateQuickProjectTrackButton(trackId)));
			}
			this.resizeTrackList();
		}
	};

	/**
	 * Removes quick project buttons from the track lists
	 */
	this.disableQuickProjects = this.disableNesters = function () {
		if (this.conf.listType == 'project') return;
		$j('.album_detailed .quick_project_button, .project_detailed .quick_project_button, .project_item_detailed .quick_project_button, .album_block .quick_project_button, .quick-project_button_container').remove();
		$j('.track_list_fast_tag_column, .lc_quick-project').remove();
		if ((this.view != ListViewType.Block && (this.view != ListViewType.MiniBlock || this.conf.listType == 'track' || this.conf.listType == 'project_item') && this.view != ListViewType.CueSheetBlock) && this.table) {
			// remove the column to the list of the displayed columns if it's there (so when we resize, the first col knows how many subcols it has)
			this.table.find('.interaction_container').removeClass('tight');
			this.removeSubColumn(0, 'quick-projects');
			this.resizeTrackList();
		} else if (this.view === ListViewType.Block && (this.conf.listType === 'track' || this.conf.listType === 'project_item')) {
			this.table.find('.track_row').removeClass('has_add_remove_button');
		} else if (this.view === ListViewType.Mobile && (this.conf.listType === 'track' || this.conf.listType === 'project_item')) {
			this.blocks.find('.track_row').removeClass('has_add_remove_button');
		} else {
			$j('.list_block .button_container.tight').removeClass('tight');
			$j('.list_block .button_container .quick_project_button').remove();
		}
	};

	/**
	 * Adds a named subcol from a specific column, if it's not there already
	 * @param {int} addTo the index number of the column to add the subcol to
	 * @param {string} name the name of the new subcol (only used to refer back to later if removing. and must be unique)
	 * @param {int=} displayColumnIndex the index at which to add the new column (if ommitted, col will be pushed)
	 */
	this.addSubColumn = function (addTo, name, displayColumnIndex) {
		let listColumn = columnList[addTo];
		if (!listColumn.hasDisplayColumn(name)) {
			listColumn.addDisplayColumn(name, displayColumnIndex);
		}
	};

	/**
	 * Removes a named subcol from a specific column, if it's there in the first place
	 * @param {int} addTo the index number of the column to remove the subcol from
	 * @param {string} name the name of the new subcol
	 */
	this.removeSubColumn = function (addTo, name) {
		if (columnList[addTo].removeDisplayColumn(name)) {
			this.resizeTrackList();
		}
	};

	/**
	 * Determines if the track list has a particular column
	 * @param {string} name
	 * @returns {boolean}
	 */
	this.hasSubColumn = function (name) {
		for (var c = 0, cLen = columnList.length; c < cLen; c++) {
			if (columnList[c].hasDisplayColumn(name)) {
				return true;
			}
		}
		return false;
	};

	// /**
	//  * Adds a column to the list's table, if it's not there already
	//  * @param {int} columnIndex - the index number in columnList where you want the column added
	//  * @param {ListColumn} listColumn - the information for the column to add - name must be unique
	//  */
	// this.addColumn = function(columnIndex, listColumn) {
	// 	if (columnList[columnIndex] && columnList[columnIndex].name === listColumn.name) return; // column already there
	// 	columnList.splice(columnIndex, 0, listColumn);
	// };
	//
	// /**
	//  * Removes a column from the list's table, if it's found at the given index
	//  * @param {int} columnIndex - the index number in columnList from where you want the column removed
	//  * @param {ListColumn} listColumn - the information for the column to remove
	//  */
	// this.removeColumn = function(columnIndex, listColumn) {
	// 	if (columnList[columnIndex] && columnList[columnIndex].name === listColumn.name) {
	// 		columnList.splice(columnIndex, 1);
	// 		this.resizeTrackList();
	// 	}
	// };

	/**
	 * Adds a track to the current display
	 * @param {JSON|Track|Album} itemInfo the information for the track
	 * @param {string=} type the type of item to add (optional - default to this.conf.listType)
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @param {boolean=} hiddenByActivePermissionProfile is this item hidden by the active permission profile? it's still visible but we gray it out
	 */
	this.addItem = function (itemInfo, type, addToTop, hiddenByActivePermissionProfile) {
		const skipWaveform = this.parentViewType === 'list'
			|| (this.conf.hasOwnProperty('skipWaveforms') && this.conf.skipWaveforms)
			|| (itemInfo.hasOwnProperty('skipWaveForm') && itemInfo.skipWaveForm);

		let addedElement;
		// console.log("add item", this.view, type, itemInfo)

		if (!type) type = this.conf.listType;
		if (type === 'track') {
			trackBank.add(itemInfo, this.conf.bankKey);
		}
		// console.log('adding item', type, itemInfo, this.view)
		/**
		 * Render page in general by either a table (this.table) or blocks (this.blocks)
		 */
		if (type === 'music_provider' || type === 'music_supplier') type = 'musicSupplier';
		if (type === 'track' && this.view === ListViewType.Block) {
			if (!this.table) return;
			addedElement = this.addArtTrack(itemInfo, addToTop, skipWaveform);
		} else if (
			this.view === ListViewType.Block
			|| (this.view === ListViewType.Mobile && (type === 'track' || type === 'album' || type === 'project_item'))
			|| (this.view === ListViewType.MiniBlock && type === 'album' && this.conf.listType === 'project_item')
		) {
			if (!this.blocks) return;
			let blockFunction;
			if (type === 'musicSupplier') blockFunction = this.addBlockMusicSupplier;
			else if (type === 'album') blockFunction = this.addBlockAlbum;
			else if (type === 'artist') blockFunction = this.addBlockArtist;
			else if (type === 'writer') blockFunction = this.addBlockWriter;
			else if (type === 'publisher') blockFunction = this.addBlockPublisher;
			else if (type === 'catalog') blockFunction = this.addBlockCatalog;
			else if (type === 'label') blockFunction = this.addBlockLabel;
			else if (type === 'project' && this.view === ListViewType.Mobile) blockFunction = this.addBlockMobileTrack.bind(this);
			else if (type === 'project') blockFunction = this.addBlockProject;
			else if (type === 'track' && this.view === ListViewType.Mobile) blockFunction = this.addBlockMobileTrack.bind(this);
			if (blockFunction) {
				addedElement = blockFunction(itemInfo, addToTop);

				if (itemInfo.image === '' && addedElement.find('.art_image img').length) {
					addedElement.find('.art_image img').remove()
					const artEl = getDefaultArtElement(type)
					addedElement.find('.art_image').append(artEl)
				}
			}
		} else if (type !== 'track' && type !== 'importTrack' && this.view === ListViewType.MiniBlock) {
			if (!this.blocks) return;
			let artFunction;
			if (type === 'musicSupplier') artFunction = this.addArtMusicSupplier;
			else if (type === 'album') artFunction = this.addArtAlbum;
			else if (type === 'artist') artFunction = this.addArtArtist;
			else if (type === 'writer') artFunction = this.addArtWriter;
			else if (type === 'publisher') artFunction = this.addArtPublisher;
			else if (type === 'catalog') artFunction = this.addArtCatalog;
			else if (type === 'label') artFunction = this.addArtLabel;
			else if (type === 'project') artFunction = this.addArtProject;
			if (artFunction) {
				addedElement = artFunction(itemInfo, addToTop);
			}
		} else {
			if (!this.table) return;
			addedElement = this.addListItem(itemInfo, type, addToTop, skipWaveform);
		}

		if (addedElement && hiddenByActivePermissionProfile) {
			addedElement.addClass('hidden_by_active_permission_profile');
			//addedElement.append('<div class="hidden_by_active_permission_profile_notice">')
			sa.components.helpExplanation.show(addedElement.find('.large_track_art, .project_item_detailed, .no_wave .left'),
				'This ' + gde(type, { p: false, c: 'lower' }) + ' is grayed out because it is inaccessible to your current Music Access Filter. You can still see it in playlists but it won\'t appear elsewhere unless you change your filter to the right of the search bar.', 'fas fa-ban');
		}
	};

	/**
	 * Adds a track to the current display and the local cache, since it was called internally
	 * @param {JSON} itemInfo the information for the track
	 * @param {string} type the type of item to add (optional - default to this.conf.listType)
	 * @param {boolean} addToTop should we put the item on top instead of the default bottom?
	 */
	this.addExternalItem = function (itemInfo, type, addToTop) {
		list.addItem(itemInfo, type, addToTop);

		//add to lastNewData cache
		if (addToTop) {
			list.lastNewData.splice(1, 0, itemInfo);
		} else {
			list.lastNewData.push(itemInfo);
		}

		//adjust index 0 vars
		list.lastNewData[0].count++;

		updateMaxCols();
	};

	/**
	 * Adds an art version of an musicSupplier to the block display
	 * @param {MusicSupplier} itemInfo the musicSupplier's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtMusicSupplier = function (itemInfo, addToTop) {
		var div = $j(
			'<div id="item_' + itemInfo.id + '" class="list_block ' + list.conf.listType + '_block' + (itemInfo.featured ? ' featured' : '') + '">'
			+ '<a href="' + getMusicSupplierLink(itemInfo.id) + '" class="art_image">'
			+ '<img src="' + itemInfo.image + '" alt=""/>'
			+ '</a>'
			+ '<div class="info">'
			+ '<a href="' + getMusicSupplierLink(itemInfo.id) + '" title="' + itemInfo.name.replace(/"/g, '&quot;') + '">' + itemInfo.name + '</a>'
			+ (config.id == 72 || config.id == 87 || config.id == 114 ? 'Sound Effects: ' : 'Tracks' + ': ') + numberFormat(itemInfo.track_count)
			+ (itemInfo.label_count ? '<br/>' + (config.id == 72 || config.id == 87 || config.id == 114 ? '' : config.getDictionaryEntry('label', true)) + ': ' + numberFormat(itemInfo.label_count) : '')
			+ (itemInfo.album_count ? '<br/>' + config.getDictionaryEntry('album', true) + ': ' + numberFormat(itemInfo.album_count) : '')
			+ '</div>'
			+ '</div>');
		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}
		return div;
	};

	this.getAlbumArtDiv = function (itemInfo, type) {
		var albumId = itemInfo.id;
		image = '';
		if (albumId && albumId != 0) {
			if (itemInfo['av']) {
				image = itemInfo['av'];
			} else if (itemInfo['image']) {
				image = itemInfo['image'];
			}
		}
		if (type != 'album') {
			albumId = itemInfo.album.id;
			if (albumId != 0) {
				image = itemInfo.album.image;
			}
		}
		var noImage = false;
		var href = getAlbumLink(albumId);
		var isValidImage = function (image) {
			return image && image.indexOf('default_editor') === -1;
		};
		if (!isValidImage(image)) {
			image = itemInfo.label.image;
			if (!isValidImage(image)) {
				image = itemInfo.catalog.image;
			} else {
				href = getLabelLink(itemInfo.label.id);
			}
			if (!isValidImage(image)) {
				href = 'track/' + itemInfo.id;
				noImage = true;
			} else {
				href = getCatalogLink(itemInfo.catalog.id);
			}
		}

		var $html = '';
		if (noImage) {
			$html = $j('<a href="' + href + '">' + getDefaultArtElement()[0].outerHTML + '</a>')
			// $html = $j('<a href="' + href + '"><div class="art_image default_album_art"><div class="fa fa-music art_symbol"></div></div></a>');
		} else {
			$html = $j('<a href="' + href + '"><div class="art_image"><img src="' + image + '" alt=""></div></a>');
		}
		$html = $html.wrap('<div class="album_art"></div>');

		return $html
	}

	/**
		 * Adds a detailed version of an item
		 * @param {object} options display options
		 * @return {JQuery} the added element
		 */
	this.addDetailedListItem = ({
		id = null,
		title = '',
		description = '',
		image = '',
		hideImage = false,
		link = '',
		external = false,
		stats = [
			/*
			{
				name: '',
				value: '',
				hide: false
			}
			*/
		],
		append = '',
		buttons = [
			/*jquery elements*/
		],
		featured = false,
		data = {},
		addToTop = false
	} = {}) => {

		let $item = $j(`<div id="item_${id}" class="list_detailed ${list.conf.listType}_detailed"/>`);

		// store data
		$item.data(list.conf.listType, data);

		// add to array
		if (addToTop) {
			list.blocks.prepend($item);
		} else {
			list.blocks.append($item);
		}

		// featured
		if (featured) {
			$item.addClass('featured');
		}

		// image
		if (!hideImage) {
			let $image = $j(`
				<div class="art_section">
					<a href="${link}" class="art_image">
						<img src="${image}" alt=""/>
					</a>
				</div>
			`);
			if (external) $image.attr('target', '_blank');

			let $featuredText = $j(`
				<div class="block_feature_notice">
					<span class="fa fa-star-o"></span>
					Featured
				</div>
			`);
			$image.append($featuredText);
			$item.append($image);
		}

		// info
		let $info = $j(`<div class="info" id="item_info"></div>`);
		$item.append($info);

		//title
		$title = $j(`<a class="title" href="${link}">${title}</a>`);
		if (external) $title.attr('target', '_blank');
		$info.append($title);

		//description
		let $description = $j(`<div class="description">${description}</div>`);
		$info.append($description);

		/** show hide button */
		let $showButton = $j('<div class="show_button"></div>');

		// show/hide
		let showMore = '<i class="fas fa-angle-double-down"></i> Show More <i class="fas fa-angle-double-down"></i>';
		let showLess = '<i class="fas fa-angle-double-up"></i> Show Less <i class="fas fa-angle-double-up"></i>';

		// default to show more
		$showButton.html(showMore);
		// only use the button when we need
		$showButton.hide();

		// toggle on click
		$showButton.on('click', (e) => {
			e.stopPropagation();
			// swap the button text
			$showButton.html($showButton.html() == showMore ? showLess : showMore);
			$description.toggleClass('show-overflow', 200);
		});

		// add the buttons under the description
		$description.after($showButton);

		// if the description overflows, add show/hide buttons
		let defaultHeight = $description.height();

		let condense = () => {
			if ($description.prop('scrollHeight') > defaultHeight) {
				$description.removeClass('condense');
				$showButton.show();
			} else {
				$description.addClass('condense');
				$showButton.hide();
			}
		}

		condense();

		new ResizeObserver(condense).observe($description[0]);

		//stats
		let $stats = $j(`<div class="stats "/>`);
		for (let i = 0; i < stats.length; i++) {
			if (stats[i].hide) continue;
			if(!user.hasAdminPermission(AdminPermission.Any) && config.hiddenFields.includes(stats[i].name.toLowerCase())) continue;
			$stats.append(`
				<div class="stat">
					<em class="stat-name">${stats[i].name}:</em>
					<span class="stat-value">${stats[i].value}</span>
				</div>
			`);
		}
		$info.append($stats);

		// anything extra we wish to append
		$info.append(append);

		//buttons
		let $buttons = $j('<div class="button_container" id="button_container">');
		for (button of buttons) {
			$buttons.append(button);
		}
		$item.append($buttons);

		return $item;
	}
	/**
	 * Mobile track block with condensed info, art with play button, alternates
	 */
	this.addBlockMobileTrack = function (itemInfo, addToTop) {
		const trackId = itemInfo.id;
		const type = 'track';
		const div = $j(
			'<div id="item_' + trackId + '" class="list_block ' + list.conf.listType + '_row ' + list.conf.listType + '_block' + (itemInfo.featured ? ' featured' : '') + ' ' + (itemInfo.is_alternate ? 'alternate' : '') + '">'
		);
		// Play button is the whole track
		const playPlusArt = $j('<div class="track_art">');
		const albumArt = this.getAlbumArtDiv(itemInfo, type);
		const playButton = sa.components.player.generatePlayButton(trackId, { location: 'track_list_' + conf.bankKey });
		playPlusArt.append(albumArt).append(playButton);
		div.append(playPlusArt)

		// Track info
		const $trackInfo = $j('<div class="track_info"></div>');
		const $title = $j('<div class="title"><a href="' + getTrackLink(trackId) + '">' + itemInfo.title + '</a></div>');
		let $album = $j('');
		if (config.siteType === 'network' || config.siteType === 'buyer') {
			$album = $j('<div class="artist"><a href="' + getCatalogLink(itemInfo.catalog.id) + '">' + itemInfo.catalog.name + '</a></div>');
		} else if (itemInfo.album) {
			$album = $j('<div class="album"><a href="' + getAlbumLink(itemInfo.album.id) + '">' + itemInfo.album.name + '</a></div>');
		} else if (itemInfo.artist) {
			$album = $j('<div class="artist"><a href="' + getArtistLink(itemInfo.artist.id) + '">' + itemInfo.artist.name + '</a></div>');
		}

		// Duration/release date, append to track info
		const $durationDate = $j('<div class="duration_date"></div>');
		const $duration = $j('<span class="length">' + itemInfo.length + '</span>');

		// Append the duration
		$durationDate.append($duration.html());

		$trackInfo.append($title).append($album).append($durationDate);
		div.append($trackInfo);

		// Alternates
		// the alternates button
		if ((itemInfo.alternates && itemInfo.alternates.length) || itemInfo.alternateCount) {
			const $alternates = $j('<div class="alternates"><a class="lc_alternates button small" href="' + getTrackLink(itemInfo.id) + '" '
				+ 'title="Click to see alternate versions of this track">+' + (itemInfo.alternateCount ? itemInfo.alternateCount : itemInfo.alternates.length) + '</a></td>')
				.find('a').on('click', function () {
					list.showAlternates(itemInfo, this);
					this.blur();
					return false;
				}).end();

			div.append($alternates)
		}

		// Options
		const $optionsDropdown = getOptionsDropDown(trackId, type, itemInfo, true);

		const $options = $j('<div class="options">').append($optionsDropdown);
		$options.find('.options_menu_anchor').removeClass('fa-bars').addClass('fa-ellipsis-v')
		const $downloadMenu = sa.components.downloadFormatSelector.generateDownloadButton({ type: type, item: itemInfo, useMetaPermissionProfile: conf.listType === 'project_item' });
		$downloadMenu.addClass('options_download')
		$optionsDropdown.getContainer().find('.option.download').click((e) => {
			e.stopPropagation();
			$downloadMenu.show();
			$downloadMenu.on('mouseleave', () => {
				$downloadMenu.hide();
			})
			$j('body').on('click', (e) => {
				if ($j(e.target).closest($downloadMenu).length == 0) {
					$downloadMenu.hide();
				}
			})
		});
		$options.append($downloadMenu);
		div.append($options);

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}
	}

	/**
	 * Adds a block version of a musicSupplier to the block display
	 * @param {MusicSupplier} itemInfo the musicSupplier's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockMusicSupplier = (itemInfo, addToTop) => {
		return this.addDetailedListItem({
			id: itemInfo.id,
			title: itemInfo.name,
			description: (()=>{
				let description = '';
				if (user.hasAdminPermission(AdminPermission.MusicSuppliers) && config.showMusicSupplierContacts) {
					description = `<em> Name:</em> ${itemInfo.licensing.name}<br/>`;
					if (itemInfo.licensing.phone) description += `<em> Phone:</em> ${itemInfo.licensing.phone}<br/>`;
					description += `<em>Email:</em> ${itemInfo.licensing.email}<br/>`;
				}
				return description;
			})(),
			image: itemInfo.image,
			link: getMusicSupplierLink(itemInfo.id),
			stats: [
				{
					name: 'Tracks',
					value: numberFormat(itemInfo.track_count)
				},
				{
					name: gde('label', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.label_count)
				},
				{
					name: gde('album', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.album_count)
				},
				{
					name: gde('artist', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.artist_count)
				}

			],
			data: itemInfo,
			addToTop: addToTop
		});
	};

	/**
	 * Adds an art version of an catalog to the block display
	 * @param {Catalog} itemInfo the catalog's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtCatalog = function (itemInfo, addToTop) {

		var div = (new Catalog(itemInfo)).generateArtElement({
			listType: list.conf.listType,
			showing: true
		});

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}

		return div;
	};

	/**
	 * Adds a block version of a catalog to the block display
	 * @param {Catalog} itemInfo the catalog's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockCatalog = (itemInfo, addToTop) => {
		// whites with customizations
		let isCustom1 = (config.id == 72 || config.id == 87);
		let isCustom2 = (config.id == 752
			);

		return this.addDetailedListItem({
			id: itemInfo.id,
			title: itemInfo.name,
			description: itemInfo.description,
			image: itemInfo.image,
			link: (itemInfo.external ? itemInfo.external : getCatalogLink(itemInfo.id)),
			external: (itemInfo.external ? true : false),
			stats: [
				{
					name: (() => {
						// custom track label
						if (isCustom1) return 'Sound Effects';
						if (isCustom2) return 'Tracks and Stems';
						return gde('track', { plural: true, 'case': 'upper' });
					})(),
					value: numberFormat(itemInfo.track_count),
				},
				{
					name: gde('label', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.label_count),
					hide: isCustom1
				},
				{
					name: gde('album', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.album_count),
					hide: isCustom1
				},
				{
					name: gde('artist', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.artist_count),
					hide: (isCustom1 || config.siteType == 'network')
				}
			],
			buttons: (()=>{
				let buttons = [];
				if (user.hasAdminPermission(AdminPermission.Feature)) {
					buttons.push(
						sa.components.buttons.generateFeatureButton({
							id: itemInfo.id,
							type: list.conf.listType,
							featured: itemInfo.featured
						}),
					);
				}
				if (itemInfo.editable) {
					buttons.push(
						sa.components.buttons.generateEditButton({
							type: list.conf.listType,
							item: itemInfo
						})
					);
				}
				return buttons;
			})(),
			featured: itemInfo.featured,
			data: itemInfo,
			addToTop: addToTop
		});
	};

	/**
	 * Adds an art version of an label to the block display
	 * @param {Label} itemInfo the label's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtLabel = function (itemInfo, addToTop) {

		var div = (new Label(itemInfo)).generateArtElement({
			listType: list.conf.listType,
			showing: true
		});

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}

		return div;
	};

	/**
	 * Adds a block version of a label to the block display
	 * @param {Label} itemInfo the label's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockLabel = (itemInfo, addToTop) => {

		return this.addDetailedListItem({
			id: itemInfo.id,
			title: itemInfo.name,
			description: itemInfo.description,
			image: itemInfo.image,
			link: getLabelLink(itemInfo.id),
			stats: [
				{
					name: (config.id == 752 ? 'Tracks and Stems' : 'Tracks'),
					value: numberFormat(itemInfo.count)
				},
				{
					name: gde('album', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.album_count)
				},
				{
					name: gde('artist', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.artist_count),
					hide: (config.siteType == 'network')
				}

			],
			buttons: (()=>{
				let buttons = [];
				if (user.hasAdminPermission(AdminPermission.Feature)) {
					buttons.push(
						sa.components.buttons.generateFeatureButton({
							id: itemInfo.id,
							type: list.conf.listType,
							featured: itemInfo.featured
						}),
					);
				}
				if (itemInfo.editable) {
					buttons.push(
						sa.components.buttons.generateEditButton({
							type: list.conf.listType,
							item: itemInfo
						})
					);
				}
				return buttons;
			})(),
			featured: itemInfo.featured,
			data: itemInfo,
			addToTop: addToTop
		});
	};

	/**
	 * Adds an art version of an album to the block display
	 * @param {Album} itemInfo the album's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtAlbum = function (itemInfo, addToTop) {

		var div = (new Album(itemInfo)).generateArtElement({
			listType: list.conf.listType,
			deleteCallback: function () {
				list.loadPage(list.lastRequestString);
			},
			showing: true
		});

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}
		return div;
	};

	/**
	 * Adds a block version of an album to the block display
	 * @param {Album} itemInfo the album's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockAlbum = (itemInfo, addToTop) => {
		// create the block
		const $detailedListItem = this.addDetailedListItem({
			id: itemInfo.id,
			title: (list.conf.listType == 'project_item' ? gde('album') + ': ' : '') + itemInfo.name,
			description: itemInfo.description,
			image: itemInfo.image,
			link: getAlbumLink(itemInfo.id),
			stats: [
				{
					name: gde('album', { 'case': 'upper', plural: false }) + ' Code',
					value: itemInfo.code,
					hide: (!itemInfo.code)
				},
				{
					name: gde('catalog', { 'case': 'upper', plural: false }),
					value: `<a href=" ${getCatalogLink(itemInfo.catalog.id)}">${itemInfo.catalog.name}</a>`,
					hide: (config.catalogs.length < 1)
				},
				{
					name: gde('label', { 'case': 'upper', plural: false }),
					value: `<a href="${getLabelLink(itemInfo.label.id)}">${itemInfo.label.name}</a>`,
					hide: (!config.showLabels)
				},
				{
					name: gde('artist', { 'case': 'upper', plural: false }),
					value: `<a href="${getArtistLink(itemInfo.artist.id)}">${itemInfo.artist.name}</a>`,
					hide: (!itemInfo.artist || !itemInfo.artist.id)
				},
				{
					name: 'Released',
					value: itemInfo.date,
					hide: (config.id == 382 || config.id == 1494 || !itemInfo.date || itemInfo.date == formatDate(config.dateFormatString, 0))
				},
				{
					name: gde('genre', { p: false, c: 'upper' }),
					value: (()=>{
						let genreList = [];
						for (genre of itemInfo.genres) {
							genreList.push(genre.name);
						}
						return genreList.join(', '); // comma separate

					})(),
					hide: (!itemInfo.genres || !itemInfo.genres.length)
				},
				{
					name: (config.id == 752 ? 'Tracks and Stems' : gde('track', { plural: true, 'case': 'upper' })),
					value: numberFormat(itemInfo.count) + (itemInfo.nestedCount && itemInfo.nestedCount > itemInfo.count ? ` + <span class="alternate_notice" title="Some of the tracks in this album have alternates outside of the album which will appear here and when it is downloaded.">${numberFormat(itemInfo.nestedCount - itemInfo.count)} alternate tracks</span>` : '')
				}
			],
			buttons: (()=>{
				let buttons = [];
				if (ecommerceDownloadAvailable) {
					buttons.push(sa.components.downloadFormatSelector.generateDownloadButton({ type: 'album', item: itemInfo, useMetaPermissionProfile: conf.listType === 'project_item' }));
				}
				// if this is in a project, add the reorder buttons
				if (list.conf.listType == 'project_item' && (columnList[0].hasDisplayColumn('reorder') || columnList[1].hasDisplayColumn('reorder'))) {
					buttons.push($j('<div class="lc lc_reorder faux_button"><span class="icon fa fa-grip-vertical"></span></div>'));
				}
				// if edit is on, we need to add those options
				var dropButtons = [];
				// add the email button
				dropButtons.push(sa.components.emailer.generateEmailButton({ type: 'album', item: itemInfo, wide: true }));
				if (conf.listType != 'project_item' && user.hasAdminPermission(AdminPermission.Feature)) {
					dropButtons.push(sa.components.buttons.generateFeatureButton({ id: itemInfo.id, type: 'album', featured: itemInfo.featured, wide: true }));
				}
				if (itemInfo.editable) {
					dropButtons.push(sa.components.buttons.generateEditButton({ type: 'album', item: itemInfo, wide: true, text: 'Edit' }));
					dropButtons.push(sa.components.buttons.generateAlbumDeleteButton({
						album: itemInfo,
						wide: true,
						text: 'Delete',
						callback: function () {
							list.loadPage(list.lastRequestString);
						},
						processingCallback: function () {
							list.showCover('', 'Deleting ' + gde('album', { c: 'lower', p: false }) + '. Please be patient. Depending on your track count, this may take a minute...');
						}
					}));
				}
				if (dropButtons.length) {
					var anchor = sa.components.OptionsMenu.GenerateFromButtons({ buttons: dropButtons });

					if (anchor) {
						anchor.addClass('more_options');
						anchor.find('.anchor_text').remove()
						buttons.push(anchor);
					}
				}
				return buttons;
			})(),
			featured: itemInfo.featured,
			data: itemInfo,
			addToTop: addToTop
		});

		if (lockdown) {
			sa.lockdownLinks($detailedListItem.find('a'));
		}

		// album expand button
		$detailedListItem.find('.info').append(createButton('Show Tracks', '', 'expand-album', getDefaultLink(),
			function (e) {
				e.preventDefault();
				var t = $j(this);
				if ($j('#expanded_' + itemInfo.id).length) {
					// it's already open. close it
					t.html('Show Tracks');
					list.hideTracks(itemInfo.id);
				} else {
					// it's closed. open it!
					t.html('Hide Tracks');
					list.expandTracks(itemInfo.id, { name: 'album', id: itemInfo.id, parent: $detailedListItem, stripe: false });
				}
				this.blur();
				return false;
			})
		);
		$detailedListItem.find('.info').addClass('with_buttons');

		// needed for playlist mode to work properly on playlists with albums
		$detailedListItem.data('album', itemInfo);

		// if this is in a playlist, we need to wrap it in a table row
		if (list.conf.listType == 'project_item' && list.view != ListViewType.Mobile) {
			$detailedListItem.wrap('<tbody class="lr_album"><tr><td colspan="' + list.table.find('colgroup:first col').length + '" class="max_cols"></td></tr></tbody>');
		}

		return $detailedListItem;
	};

	/**
	 * Adds an art version of an artist to the block display
	 * @param {Artist} itemInfo the artist's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtArtist = function (itemInfo, addToTop) {

		var div = (new Artist(itemInfo)).generateArtElement({
			listType: list.conf.listType,
			showing: true
		});

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}

		return div;
	};

	/**
	 * Adds a block version of an artist to the block display
	 * @param {Artist} itemInfo the artist's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockArtist = (itemInfo, addToTop) => {
		// return the block
		return this.addDetailedListItem({
			id: itemInfo.id,
			title: itemInfo.name,
			description: itemInfo.description,
			image: itemInfo.image,
			link: getArtistLink(itemInfo.id),
			stats: [
				{
					name: (config.id == 752 ? 'Tracks and Stems' : gde('track', { plural: true, 'case': 'upper' })),
					value: numberFormat(itemInfo.count)
				}
			],
			buttons: (()=>{
				let buttons = [];
				if (user.hasAdminPermission(AdminPermission.Feature)) {
					buttons.push(
						sa.components.buttons.generateFeatureButton({
							id: itemInfo.id,
							type: list.conf.listType,
							featured: itemInfo.featured
						}),
					);
				}
				if (itemInfo.editable) {
					buttons.push(
						sa.components.buttons.generateEditButton({
							type: list.conf.listType,
							item: itemInfo
						})
					);
				}
				return buttons;
			})(),
			featured: itemInfo.featured,
			data: itemInfo,
			addToTop: addToTop
		});
	};

	/**
	 * Adds an art version of an writer to the block display
	 * @param {Writer} itemInfo the composer's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtWriter = function (itemInfo, addToTop) {

		var div = (new Writer(itemInfo)).generateArtElement({
			listType: list.conf.listType,
			showing: true
		});

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}
		return div;
	};

	/**
	 * Adds a block version of an writer to the block display
	 * @param {Writer} itemInfo the writer's information
	 * @param {boolean} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockWriter = (itemInfo, addToTop) => {
		return this.addDetailedListItem({
			id: itemInfo.id,
			title: itemInfo.name,
			description: itemInfo.description,
			image: itemInfo.image,
			link: getWriterLink(itemInfo.id),
			stats: [
				{
					name: (config.id == 752 ? 'Tracks and Stems' : gde('track', { plural: true, 'case': 'upper' })),
					value: numberFormat(itemInfo.track_count)
				}
			],
			buttons: (()=>{
				let buttons = [];
				if (user.hasAdminPermission(AdminPermission.Feature)) {
					buttons.push(
						sa.components.buttons.generateFeatureButton({
							id: itemInfo.id,
							type: list.conf.listType,
							featured: itemInfo.featured,
						}),
					);
				}
				if (itemInfo.editable) {
					buttons.push(
						sa.components.buttons.generateEditButton({
							type: list.conf.listType,
							item: itemInfo
						})
					);
				}
				return buttons;
			})(),
			featured: itemInfo.featured,
			data: itemInfo,
			addToTop: addToTop
		});
	};

	/**
	 * Adds an art version of an publisher to the block display
	 * @param {Publisher} itemInfo the composer's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtPublisher = function (itemInfo, addToTop) {

		var div = (new Publisher(itemInfo)).generateArtElement({
			listType: list.conf.listType,
			showing: true
		});

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}
		return div;
	};

	/**
	 * Adds a block version of an publisher to the block display
	 * @param {Composer} itemInfo the composer's information
	 * @param {boolean} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockPublisher = (itemInfo, addToTop) => {
		return this.addDetailedListItem({
			id: itemInfo.id,
			title: itemInfo.name,
			description: itemInfo.description,
			image: itemInfo.image,
			link: getPublisherLink(itemInfo.id),
			stats: [
				{
					name: (config.id == 752 ? 'Tracks and Stems' : gde('track', { plural: true, 'case': 'upper' })),
					value: numberFormat(itemInfo.track_count)
				}
			],
			buttons: (()=>{
				let buttons = [];
				if (user.hasAdminPermission(AdminPermission.Feature)) {
					buttons.push(
						sa.components.buttons.generateFeatureButton({
							id: itemInfo.id,
							type: list.conf.listType,
							featured: itemInfo.featured,
						}),
					);
				}
				if (itemInfo.editable) {
					buttons.push(
						sa.components.buttons.generateEditButton({
							type: list.conf.listType,
							item: itemInfo
						})
					);
				}
				return buttons;
			})(),
			featured: itemInfo.featured,
			data: itemInfo,
			addToTop: addToTop
		});
	};

	/**
	 * Adds a block version of a project to the block display
	 * @param {Project} itemInfo the project's information
	 * @param {boolean} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addBlockProject = (itemInfo, addToTop) => {
		return this.addDetailedListItem({
			id: itemInfo.id,
			title: itemInfo.name,
			description: (()=>{
				let description = itemInfo.description;
				// add the music supplier if it's not the current site
				if (config.id != itemInfo.whiteId && itemInfo.musicSupplier) {
					description += `
						<div class="music_supplier">
							<em>Music Supplier:</em>
							<a href="${getMusicSupplierLink(itemInfo.musicSupplier.id)}">
								${itemInfo.musicSupplier.name}
							</a>
						</div>
					`;
				}
				return description;
			})(),
			image: itemInfo.image,
			link: getProjectLink(itemInfo.id),
			hideImage: (config.siteType == 'drop'),
			stats: [
				{
					name: gde('total track', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.totalTrackCount)
				},
				{
					name: gde('individual track', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.trackCount)
				},
				{
					name: gde('individual album', { plural: true, 'case': 'upper' }),
					value: numberFormat(itemInfo.albumCount)
				}
			],
			buttons: (()=>{
				// buttons
				let buttons = [];

				// add the interaction buttons
				var dropButtons = [];
				var actionButtons = generateProjectActionsList(itemInfo, true);

				// download button
				// remove wide and button classes from the download button
				let dlButton = actionButtons.shift().getButton();
				dlButton.removeClass('wide icon_button button');
				dlButton.find('.anchor_text').remove();
				buttons.push(dlButton);

				// other buttons
				actionButtons.each(function () {
					dropButtons.push(this.getButton());
				});

				// reordering
				if (config.siteType != 'buyer' && user.hasAdminPermission(AdminPermission.Feature)) {
					$up = $j(`<a class="up" href="${getDefaultLink()}" class="reorder_button"><span class="icon fa fa-arrow-up faux_button"></span></a>`);
					$down = $j(`<a class="down" href="${getDefaultLink()}" class="reorder_button"><span class="icon fa fa-arrow-down faux_button"></span></a>`);

					$up.on('click', (e) => {
						list.reorder(itemInfo.id, 'project', -1);
						e.preventDefault();
						return false;
					});
					$down.on('click', (e) => {
						list.reorder(itemInfo.id, 'project', 1);
						e.preventDefault();
						return false;
					});
					buttons.push($up);
					buttons.push($down);
				}
				if (dropButtons.length) {
					var anchor = sa.components.OptionsMenu.GenerateFromButtons({ buttons: dropButtons });

					if (anchor) {
						anchor.addClass('more_options');
						anchor.find('.anchor_text').remove()
						buttons.push(anchor);
					}
				}
				return buttons;
			})(),
			featured: itemInfo.featured,
			data: itemInfo,
			addToTop: addToTop
		});
	};

	/**
	 * Adds an art version of an artist to the block display
	 * @param {Project} itemInfo the project's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @return {JQuery} the added element
	 */
	this.addArtProject = function (itemInfo, addToTop) {

		const div = (new Project(itemInfo)).generateArtElement({
			listType: list.conf.listType,
			showing: true
		});

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}

		return div;

	};

	/**
	 * Adds an art version of a track to the table display
	 * @param {Track} itemInfo the track's information
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 * @param {boolean=} skipWaveform Whether to generate a waveform for this item.
	 * @return {JQuery} the added element
	 */
	this.addArtTrack = function (itemInfo, addToTop, skipWaveform) {
		if (undefined === skipWaveform) {
			skipWaveform = false;
		}

		// generate the row
		const ShowBigArtPlayButton = true;
		const type = 'track';
		const rowContainer = generateListItemRow(itemInfo, type);
		const row = rowContainer.children().first();
		const id = itemInfo.id;

		// add the waveform
		if (!skipWaveform) {
			const largeTrackArt = rowContainer.find('.large_track_art');
			const showingArt = !!largeTrackArt.length;
			row.addClass('with_wave with_track_art' + (showingArt ? ' showing_art' : ' not_showing_art'));
			rowContainer.append('<tr><td colspan="" class="wave_row wave_view' + getExtraClassesForItem(itemInfo) + ' max_cols' + (showingArt ? '_minus_one showing_art' : ' not_showing_art') + ' track_art_wave_row" id="wave_row_' + id + '"><div class="track_art_wave_row_inner"></div></td></tr>');
			if (showingArt) {
				list.table.find('.l_header').addClass('showing_art').removeClass('not_showing_art');
			} else {
				list.table.find('.l_header').removeClass('showing_art').addClass('not_showing_art');
			}

			// make the art a big play button (if we're showing art)
			if (ShowBigArtPlayButton && showingArt) {
				const artPlayButton = sa.components.player.generatePlayButton(id, { location: 'track_list_' + conf.bankKey });
				artPlayButton.addClass('art_play_button');
				largeTrackArt.append(artPlayButton);
			}

			waveRow = rowContainer.find('.track_art_wave_row_inner');
			if (!ShowBigArtPlayButton || !showingArt || ios || android) {
				// show a separate play button if there is no large art or if you're on mobile
				waveRow.append($j('<div class="play_button_container"></div>').append(sa.components.player.generatePlayButton(id, { location: 'track_list_' + conf.bankKey })));
			}
			if (config.id === 72) {
				waveRow.append($j('<div class="lc_interaction lc_single_interaction_option"></div>').append(sa.components.emailer.generateEmailButton({ type: type, item: itemInfo })));
			} else {
				if (ecommerceDownloadAvailable || itemInfo.can_download === 1) {
					waveRow.append($j('<div class="download_button_container"></div>').append(sa.components.downloadFormatSelector.generateDownloadButton({ type: type, item: itemInfo, useMetaPermissionProfile: conf.listType === 'project_item' })));
				}
				if (config.showSonicSearch) {
					waveRow.append($j('<div class="lc_interaction"><div class="options_menu_anchor hiding_overflow fa fa-bolt" title="Find Similar"></div></div>'));
					waveRow.find('.fa-bolt').on('click', (e) => {
						e.preventDefault();
						e.stopPropagation();
						sa.router.routeTo(siteBaseUrl() + '/sonicsearch?track_search=' + id);
					});
				}
				waveRow.append($j('<div class="lc_interaction"></div>').append(getOptionsDropDown(id, type, itemInfo)));
			}
			waveRow.append($j('<div class="wave_container"></div>'));
			waveRow.append($j('<div class="length_container">' + itemInfo.length + '</div>'));

			const waveform = new Waveform(id, rowContainer.find('#wave_row_' + id + ' .wave_container'), false, itemInfo.comments, 0);
			if (conf.commentSaveVars) {
				waveform.enableCommenting(conf.commentSaveVars);
			}
		} else {
			row.addClass('no_wave');
		}

		// apply lockdown if necessary
		if (lockdown) {
			sa.lockdownLinks(row.find('a:not(.lc_alternates,.download_button)'));
		}

		if (conf.hasOwnProperty('addDetailsRows') && conf.addDetailsRows) {
			const extraRow = $j('<tr class="lr_detail_row" data-item-id="' + id + '"><td class="max_cols"></td></tr>');
			extraRow.hide();
			rowContainer.append(extraRow);
		}

		// var div = (new Album(itemInfo)).generateArtElement({
		// 	listType : this.conf.listType,
		// 	deleteCallback : function() {
		// 		list.loadPage(list.lastRequestString);
		// 	},
		// 	showing : true
		// });
		//
		// if (addToTop) {
		// 	this.blocks.prepend(div);
		// } else {
		// 	this.blocks.append(div);
		// }

		// add the container to the table
		if (addToTop) {
			list.table.find('.l_header').after(rowContainer);
		} else {
			list.table.append(rowContainer);
		}

		// expanding of tag overflows
		enableTagOverflows();

		return rowContainer;
	};

	/**
	 * Adds cue numbers to the cuesheet block
	 */
	this.numberCueBlocks = function () {
		let meta = list.lastNewData[0];
		let startNumber = meta.page * meta.perPage + 1;
		$j('.cue_sheet_block').each(function () {
			$j(this).find('.num-index span').html($j(this).index() + startNumber);
		});
	};

	/**
	 * Adds a cue sheet block for a non-SA track
	 * @param {Object} info information to display
	 * @param {boolean} addToTop should we put the item on top?
	 * @return {JQuery} the added element
	 */
	this.addCueSheetCustomBlock = function (info, addToTop) {
		var cueSheetPage = sa.pages.cueSheet;
		var trackFields = cueSheetPage.trackFields;

		// actually create the html
		var div = $j('<div id="custom_' + info.custom + '_row" class="cue_sheet_block cue_sheet_custom_block cue_sheet_' + cueSheetPage.cueSheet.id + '_custom_block"></div>'),
			html =
				'<div class="controls">'
				+ '<div class="custom_message">' + 'Audio not hosted in system.' + '</div>'
				+ '<div class="other_controls"><span id="tag_container"></span></div>'
				+ '</div>'
				+ '<div class="num-index">Cue <span></span></div>'
				+ '<div class="relocate">'
				+ '<div class="arrow up faux_button"><i class="fa fa-arrow-up"></i></div>'
				+ '<div class="arrow down faux_button"><i class="fa fa-arrow-down"></i></div>'
				+ '</div>'
				+ '<div class="data">';

		if (info['field_edl_src']) {
			html += '<div><div class="title"><b>EDL Filename:</b></div><div class="value">' + info['field_edl_src'].filename + ' (for reference only, not exported)</div><div class="clr"></div></div>';
		}

		for (let i = 0, len = trackFields.length; i < len; i++) {
			const trackField = trackFields[i];
			let title = trackField.name ? trackField.name : config.getDictionaryEntry(trackField.type);

			if (title === 'Title') title = 'Track Name';

			if (trackField.type === 'user_entered') {
				if (trackField.values) {
					html += '<div><div class="title"><b>' + trackField.name + ':</b></div><div class="value user_entered"><select name="field_' + trackField.id + '"><option value="custom">'
						+ 'Custom' + '</option>';
					const vals = trackField.values.split(';');

					for (let j = 0, valLen = vals.length; j < valLen; j++) {
						const val = vals[j].trim();
						html += '<option value="' + val + '"' + (val == info['field_' + trackField.id] ? ' selected="selected"' : '') + '>' + val + '</option>';
					}

					html += '</select> <input type="text" name="field_' + trackField.id + '" value="'
						+ (info['field_' + trackField.id] ? StringSanitize.encodeIfNotEncoded(info['field_' + trackField.id]) : '') + '"/></div><div class="clr"></div></div>';
				} else {
					html += '<div><div class="title"><b>' + trackField.name + ':</b></div><div class="value"><input type="text" name="field_' + trackField.id + '" value="'
						+ (info['field_' + trackField.id] ? StringSanitize.encodeIfNotEncoded(info['field_' + trackField.id]) : '') + '"/></div><div class="clr"></div></div>';
				}
			} else {
				html += `
					<div>
						<div class="title">
							<b>${title}:</b>
						</div>
						<div class="value">
							<input name="field_${trackField.id}" type="text" value="${(info['field_' + trackField.id] ? StringSanitize.encodeIfNotEncoded(info['field_' + trackField.id]) : '')}" />
						</div>
						<div class="clear"></div>
					</div>
				`.trim();
			}
		}

		html += '</div><div class="clr"></div>';
		div.html(html);
		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}

		enableCueSheetInteraction(info, div);

		div.data('customId', info.custom);
		div.data('cueSheetId', cueSheetPage.cueSheet.id);

		return div;
	};

	function enableCueSheetInteraction(info, div) {

		// set up auto-saving of fields
		div.find('input').each(function () {
			// we set up a timeout so this doesn't fire on every keystroke if you're typing quickly. only once you've stopped typing for a half second does it save
			// we do it in an each() like this so every input can have its own timeout in case you're switching quickly
			var timeout = null;
			$j(this).on('keyup', function () {
				if (lockdown) {
					return sa.showLockdownMessage();
				}
				var input = this,
					select = $j(this).parent().find('select');
				if (timeout) clearTimeout(timeout);
				timeout = setTimeout(function () {
					ajax('cueSheetId=' + sa.pages.cueSheet.cueSheet.id + (info.custom ? '&customId=' + info.custom : '&rowId=' + info.id + '&trackId=' + info.track.id) + '&fieldId=' + input.name.substring(6) + '&fieldValue=' + encodeURIComponent(input.value),
						function () {
							var s = $j('<span style="margin-left: 5px">Saved!</span>');
							$j(input).parent().find('span').remove().end().append(s);
							s.fadeOut(1000, function () { s.remove(); });
						}, 'POST', 'p=cue_sheets&action=update_track_field');
					timeout = null;
				}, 500);
				if (select.length && select.val() != input.value) {
					var found = false;
					for (var i = 0, len = select[0].options.length; i < len; i++) {
						var option = select[0].options[i];
						if (option.value == input.value) {
							option.selected = true;
							found = true;
						}
					}
					if (!found) {
						select[0].options[0].selected = true;
					}
				}
			});
		});

		// set up the drop downs
		div.find('select').on('change', function () {
			var t = $j(this),
				val = t.val();
			if (val == 'custom') {
				val = '';
			}
			t.parent().find('input').val(val).trigger('keyup');
		});

		// set up the relocation function
		var moveCueTrack = function (dir) {

			//let's figure out what track we're switching places with
			let data = list.lastNewData;
			let currentRowId = info.id;
			let prev = 0;

			console.log('move track', currentRowId, dir);

			for (let ii = 1, dataLength = data.length; ii < dataLength; ii++) {
				let t = data[ii];
				if (currentRowId == t.id) { // this is our track
					let currentRow = $j((info.custom ? '#custom_' : '#track_') + currentRowId + '_row');

					// determine if the move is legal based on the number of tracks in the sheet and the position of the moving track
					let outOfSheet = false;
					let movingOffPage = false;
					let listMeta = data[0];

					if (!prev && dir == -1) {
						if (listMeta.page === 0) {
							outOfSheet = true;
						} else {
							movingOffPage = true;
						}
					} else if (ii + 1 >= dataLength && dir == 1) {
						if ((listMeta.page + 1) * listMeta.perPage >= listMeta.count) {
							outOfSheet = true;
						} else {
							movingOffPage = true;
						}
					}
					console.log('outOfSheet', outOfSheet, 'movingOffPage', movingOffPage);
					if (outOfSheet) { // can't move to less than 0 or more than the max. jiggle the row
						currentRow.transition({ y: dir * 5 }, 100, function () {
							currentRow.transition({ y: -5 * dir }, 100);
						});
						return;
					}

					// actually do a move
					if (!movingOffPage) {
						let swap = data[ii + dir];
						let swapRow = $j(swap.custom ? '#custom_' + swap.custom + '_row' : '#track_' + swap.id + '_row');
						currentRow.transition({ y: (swapRow.outerHeight() + parseInt(swapRow.css('margin-top'))) * dir });
						swapRow.transition({
							delay: 100,
							y: (currentRow.outerHeight() + parseInt(currentRow.css('margin-top'))) * -1 * dir
						}, function () {
							// swap the dom elements and remove transformations when done
							if (dir == 1) {
								swapRow.insertBefore(currentRow.css({ y: 0 })).css({ y: 0 });
							} else {
								currentRow.insertBefore(swapRow.css({ y: 0 })).css({ y: 0 });
							}
							list.numberCueBlocks();
						});

						// swap the data
						data[ii + dir] = t;
						data[ii] = swap;
					} else {
						// make it disappear so the user gets some feedback
						currentRow.fadeOut();
					}

					// save it
					ajax('cueSheetId=' + sa.pages.cueSheet.cueSheet.id + '&rowId=' + currentRowId + '&dir=' + dir,
						function () {
							if (movingOffPage) {
								loadLastRequest();
							}
							console.log('-- move saved');
						}, 'POST', 'p=cue_sheets&action=move_item');

					return;
				}
				prev = ii;
			}
			console.log('ERROR: did not find row, big problem');
		};

		//set up the relocation arrows
		div.find('.arrow.up').on('click', function (e) {
			moveCueTrack(-1);
			e.preventDefault();
			return false;
		});
		div.find('.arrow.down').on('click', function (e) {
			moveCueTrack(1);
			e.preventDefault();
			return false;
		});
	}

	// loads license contact name info from the server, making sure it all goes through one request
	let licenseContactNameContainers = $j(); // a list of containers to which we'll add the name once it's loaded
	let licenseContactName = null; // the name, after it finishes loading
	async function addLicenseContactName(container) {
		// if it's null, we haven't made a server request yet for the info
		if (licenseContactName === null) {
			licenseContactName = ''; // mark that we've now made the request
			licenseContactNameContainers = licenseContactNameContainers.add(container); // mark that we need to add the name to this container
			const r = await sa.api.request({
				handler: 'contact',
				action: 'getLicenseContact'
			});
			licenseContactName = r.name;
			licenseContactNameContainers.html(licenseContactName);
			licenseContactNameContainers = $j();
		} else if (licenseContactName === '') {
			// if the licenseContactName is an empty string, the request is still pending so add our container to the queue
			// it's also possible they don't have one set and then we'll never set it anyway
			licenseContactNameContainers = licenseContactNameContainers.add(container);
		} else {
			// if there is a name, set it immediately. the request already finished and processed its list
			container.html(licenseContactName);
		}
	}

	/**
	 * Adds a cue sheet block track
	 * @param {Object} info information to display in the block plus the track's info in info.track
	 * @param {boolean=} addToTop should we put the item on top instead of the default bottom?
	 */
	this.addCueSheetBlock = function (info, addToTop) {
		var trackInfo = info.track,
			cueSheetPage = sa.pages.cueSheet,
			trackFields = cueSheetPage.trackFields;

		//if we're a custom item, we need to override
		if (info.custom) {
			return list.addCueSheetCustomBlock(info, addToTop);
		}

		// since we bypassed addItem, we have to bank the track ourselves
		trackBank.add(trackInfo, list.conf.bankKey);

		// make sure we have some track fields
		if (!trackFields.length) {
			trackFields = [{ type: 'title' }];
		}

		// actually create the html
		var div = $j('<div id="track_' + info.id + '_row" class="cue_sheet_block"></div>'),
			html =
				'<div class="controls">'
				+ (info['permissionDenied'] ? '<div class="custom_message">Your Music Access Filter does not allow access to this track.</div>' : '<div class="play_container"></div>')
				+ '<div class="other_controls"><span id="tag_container"></span></div>'
				+ '</div>'
				+ '<div class="num-index">Cue <span></span></div>'
				+ '<div class="relocate">'
				+ '<div class="arrow up faux_button"><i class="fa fa-arrow-up"></i></div>'
				+ '<div class="arrow down faux_button"><i class="fa fa-arrow-down"></i></div>'
				+ '</div>'
				+ '<div class="data">';
		for (var i = 0, len = trackFields.length; i < len; i++) {
			var trackField = trackFields[i];
			switch (trackField.type) {
				case 'album':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('album', false) + ':</b></div><div class="value"><a href="' + getAlbumLink(trackInfo.album.id) + '">' + trackInfo.album.name + '</a></div><div class="clr"></div></div>';
					break;
				case 'artist':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('artist') + ':</b></div><div class="value"> <a href="' + getArtistLink(trackInfo.artist.id) + '">' + trackInfo.artist.name + '</a></div><div class="clr"></div></div>';
					break;
				case 'catalog':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('catalog') + ':</b></div><div class="value"><a href="' + getCatalogLink(trackInfo.catalog.id) + '">' + trackInfo.catalog.name + '</a></div><div class="clr"></div></div>';
					break;
				case 'cue-type':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('cue type') + ':</b></div><div class="value">';
					for (var c = 0, cLen = trackInfo.cueTypes.length; c < cLen; c++) {
						html += (c ? ', ' : '') + '<a href="' + getCueTypeLink(trackInfo.cueTypes[c].id) + '">' + trackInfo.cueTypes[c].name + '</a>';
					}
					html += '</div><div class="clr"></div></div>';
					break;
				case 'added':
					html += '<div><div class="title"><b>' + 'Date Added' + ':</b></div><div class="value">'
						+ trackInfo['date'].substring(0, 6) + trackInfo['date'].substring(8, 10) + '</div><div class="clr"></div></div>';
					break;
				case 'description':
				case 'keywords':
				case 'instruments':
				case 'version':
					html += '<div><div class="title"><b>' + trackField.type.ucfirst() + ':</b></div><div class="value">' + trackInfo[trackField.type] + '</div><div class="clr"></div></div>';
					break;
				case 'filename':
					var filename = trackInfo['filename'] ? trackInfo['filename'] : trackInfo.file.filename;
					html += '<div><div class="title"><b>Filename:</b></div><div class="value">' + filename + '</div><div class="clr"></div></div>';
					break;
				case 'genre':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('genre') + ':</b></div><div class="value">';
					for (var g = 0, gLen = trackInfo.genres.length; g < gLen; g++) {
						html += (g ? ', ' : '') + '<a href="' + getGenreLink(trackInfo.genres[g].id) + '">' + trackInfo.genres[g].name + '</a>';
					}
					html += '</div><div class="clr"></div></div>';
					break;
				case 'isrc':
				case 'iswc':
				case 'bpm':
					html += '<div><div class="title"><b>' + trackField.type.toUpperCase() + ':</b></div><div class="value">' + trackInfo[trackField.type] + '</div><div class="clr"></div></div>';
					break;
				case 'key':
					html += '<div><div class="title"><b>' + 'Key' + ':</b></div><div class="value">' + trackInfo.key + '</div><div class="clr"></div></div>';
					break;
				case 'label':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('label') + ':</b></div><div class="value"><a href="'
						+ getLabelLink(trackInfo['label'].id) + '">' + trackInfo['label'].name + '</a></div><div class="clr"></div></div>';
					break;
				case 'length':
					html += '<div><div class="title"><b>' + 'Length' + ':</b></div><div class="value">' + trackInfo.length + '</div><div class="clr"></div></div>';
					break;
				case 'mood':
					let moods = trackInfo.moods;
					if (!moods) {
						moods = '';
					} else {
						moods.map(mood => StringSanitize.ifEncodedDecode(mood));
						moods = moods.join(', ');
					}

					html += '<div><div class="title"><b>' + gde('mood', { plural: true, case: 'upper' }) + ':</b></div><div class="value">' + moods + '</div><div class="clr"></div></div>';
					break;
				case 'publishing':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('publishing') + ':</b></div><div class="value"><a href="'
						+ getPublisherLink(trackInfo.publisher.id) + '">' + trackInfo.publisher.name + '</a></div><div class="clr"></div></div>';
					break;
				case 'style':
					let styles = trackInfo.styles;
					if (!styles) {
						styles = '';
					} else {
						styles.map(style => StringSanitize.ifEncodedDecode(style));
						styles = styles.join(', ');
					}

					html += '<div><div class="title"><b>' + gde('style', { plural: true, case: 'upper' }) + ':</b></div><div class="value">' + styles + '</div><div class="clr"></div></div>';
					break;
				case 'tempo':
					html += '<div><div class="title"><b>' + config.getDictionaryEntry('tempo') + ':</b> ';
					for (var t = 0, tLen = trackInfo.tempos.length; t < tLen; t++) {
						html += (t ? ', ' : '') + '<a href="' + getTempoLink(trackInfo.tempos[t].id) + '">' + trackInfo.tempos[t].name + '</a>';
					}
					html += '</div><div class="clr"></div></div>';
					break;
				case 'title':
					html += '<div><div class="title"><b>' + 'Track Name' + ':</b></div><div class="value"><a id="title" href="' + getTrackLink(trackInfo.id) + '">'
						+ trackInfo.title + '</a></div><div class="clr"></div></div>';
					break;
				case 'track_number':
					html += '<div><div class="title"><b>' + 'Track Number' + ':</b></div><div class="value">'
						+ (trackInfo.album.number && trackInfo.album.number != '0' ? trackInfo.album.number : '') + '</div><div class="clr"></div></div>';
					break;
				case 'writer':
				case 'publisher':
					var addedWriter = false;
					var index = trackField.type + 's';
					html += '<div><div class="title"><b>' + gde(trackField.type, { plural: true, 'case': 'upper' }) + ':</b></div><div class="value">';
					for (var w = 0, wLen = trackInfo[index].length; w < wLen; w++) {
						var person = trackInfo[index][w];
						html += (addedWriter ? ', ' : '') + person.name + (person.affiliation.id ? ' (' + person.affiliation.name + ')' : '') + (person.ownershipShare ? ' ' + person.ownershipShare + '%' : '')
							+ (person.ipi && person.ipi !== '0' ? ' [' + person.ipi + ']' : '');
						addedWriter = true;
					}
					html += '</div><div class="clr"></div></div>';
					break;
				case 'user_entered':
					if (trackField.values) {
						html += '<div><div class="title"><b>' + trackField.name + ':</b></div><div class="value user_entered"><select name="field_' + trackField.id + '"><option value="custom">'
							+ 'Custom' + '</option>';
						var vals = trackField.values.split(';');
						for (var j = 0, valLen = vals.length; j < valLen; j++) {
							var val = vals[j].trim();
							html += '<option value="' + val + '"' + (val == info['field_' + trackField.id] ? ' selected="selected"' : '') + '>' + val + '</option>';
						}
						html += '</select> <input type="text" name="field_' + trackField.id + '" value="'
							+ (info['field_' + trackField.id] ? StringSanitize.encodeIfNotEncoded(info['field_' + trackField.id]) : '') + '"/></div><div class="clr"></div></div>';
					} else {
						html += '<div><div class="title"><b>' + trackField.name + ':</b></div><div class="value"><input type="text" name="field_' + trackField.id + '" value="'
							+ (info['field_' + trackField.id] ? StringSanitize.encodeIfNotEncoded(info['field_' + trackField.id]) : '') + '"/></div><div class="clr"></div></div>';
					}
					break;
				case 'contact':
					html += '<div><div class="title"><b>' + 'Contact' + ':</b></div><div class="value"><span class="license_contact_name"></span> ' + htmlEncode(config.name) + '</div><div class="clr"></div></div>';
					break;
				default:
					// custom fields
					var colId = trackField.type.match(/^custom_([0-9]+)$/);
					if (colId) {
						// it's a custom column!
						colId = colId[1];
						var customValue = ''; // this default is what will show up if they didn't set this custom field for this track
						// we don't have a good way to find these so we'll have to loop through and track it down
						for (var cf = 0; cf < trackInfo.custom_fields.length; cf++) {
							var cust = trackInfo.custom_fields[cf];
							if (cust.id == colId) {
								// we found it!
								customValue = cust.value;
								break;
							}
						}
						html += '<div><div class="title"><b>' + trackField.name + ':</b></div><div class="value"><a href="' + getCustomLink(colId, customValue) + '">' + customValue + '</a></div><div class="clr"></div></div>';
					} else {
						// it's not a custom column. something bad is happening
						console.log('Unknown column: ' + trackField.type);
					}
			}
		}
		html += '</div><div class="clr"></div>';
		div.html(html);

		let licenseContactName = div.find('.license_contact_name');
		if (licenseContactName.length) {
			addLicenseContactName(licenseContactName);
		}

		if (addToTop) {
			list.blocks.prepend(div);
		} else {
			list.blocks.append(div);
		}
		if (!info['permissionDenied']) {
			// add the play button
			div.find('.play_container').append(sa.components.player.generatePlayButton(trackInfo.id, { location: 'track_list_' + list.conf.bankKey }));

			// add the download buttons
			if (ecommerceDownloadAvailable || trackInfo.can_download === 1) {
				div.find('#tag_container').before(sa.components.downloadFormatSelector.generateDownloadButton({
					type: 'track',
					item: trackInfo,
					useMetaPermissionProfile: true
				}));
			}

			// add the email button
			div.find('#tag_container').before(sa.components.emailer.generateEmailButton({
				type: 'track',
				item: trackInfo
			}));
			//copy button
			div.find('#tag_container').before('<a class="fa fa-copy copy-button faux_button"></a>');
			div.find('.copy-button').on('click', function (e) {
				if (!cueSheetPage.cueSheet.created) {
					e.preventDefault();

					sa.alert({
						text: 'Copy is disabled for "Read Only" Cue Sheets'
					});

					return;
				}

				if (lockdown) {
					return sa.showLockdownMessage();
				}
				console.log('copy track:', trackInfo.id);
				div.find('.copy-button i').removeClass('fa-copy').addClass('fa-refresh fa-spin');

				ajax('cueSheetId=' + cueSheetPage.cueSheet.id + '&rowId=' + info.id,
					function () {
						console.log('-- item copied');
						sa.router.reloadPage();
						let path = siteBaseUrl() + '/cue-sheet/' + cueSheetPage.cueSheet.id + '?focus=1'
						sa.router.routeTo(path);

					}, 'POST', 'p=cue_sheets&action=copy_item');
				return false;
			});
		} else {
			div.find('.data .value a').each(function () {
				$j(this).parent().html(this.innerHTML);
			});
		}

		enableCueSheetInteraction(info, div);

		div.data('trackId', trackInfo.id);

	};

	function addSearchableTags(dataContainer, tags) {
		let tagStrings = [];

		if (conf.disableLinksToLists) {
			tagStrings = tags;
		} else {
			for (let t = 0, tLen = tags.length; t < tLen; t++) {
				const currentTag = searchTermTagFormatter(StringSanitize.ifEncodedDecode(tags[t]));
				tagStrings.push('<a href="' + getExplorerLink('s=' + currentTag) + '">' + tags[t] + '</a>');
			}
		}

		const tagElement = $j('<td><span class="tags"><div>' + tagStrings.join(', ') + '</div></span></td>');
		tagElement.attr('title', tags.join(', '));
		tagElement.find('a').on('click', function (e) {
			if (!e.shiftKey) return;
			e.preventDefault();
			e.stopPropagation();
			sa.search.searchTagHandler(e, $j(this).html().entityDecode().trim());
		});

		dataContainer.append(tagElement);
	}

	function getOptionsDropDown(id, type, itemInfo, download = false) {
		const baseUrl = siteBaseUrl();

		let optionsMenuItems = [{ name: 'Track Options', heading: true }];

		// download option
		if (download) {
			optionsMenuItems.push({
				name: "Download",
				custom: $j('<div class="option download">Download</div>')
			});
		}

		// add to cart option
		if (config.licensingConfig.show) {
			licensingModal.getProfile(itemInfo, function (profile) {
				if (profile && profile.oneprice && profile.oneprice >= 0) {
					optionsMenuItems.push({
						name: `Add To Cart (${Number(profile.oneprice).currencyFormat()})`,
						onClick: function (e) {
							licensingModal.show(profile, itemInfo, e);
						}
					});
				}
			});
		}

		// general options
		optionsMenuItems = [
			...optionsMenuItems,
			{ name: 'Details', href: baseUrl + '/track/' + id },
			{ name: 'Email', onClick: function () { if (lockdown) { return sa.showLockdownMessage(); } sa.components.emailer.show({ type: type, item: itemInfo }); } },
		];

		var loadLicensingProfile = false;
		if (config.showSonicSearch) {
			optionsMenuItems.push({ name: '<i class="fa fa-bolt"></i> Similar Tracks', href: baseUrl + '/sonicsearch?track_search=' + id });
		} else {
			optionsMenuItems.push({ name: 'Similar Tracks', href: baseUrl + '/tracks?sim=' + id });
		}
		if (config.showLicensing && (config.id != 49 && config.id != 118 && config.id != 104 && config.id != 225 && config.id != 162)) {
			if (config.licensingConfig && config.licensingConfig.show) {
				loadLicensingProfile = true;
			} else if (!config.licensing['full_licensing']) {
				optionsMenuItems.push({
					name: licenseNowText,
					onClick: function () {
						var modal = new LicenseNowModal();
						modal.trackId = id;
						modal.init();
					}
				});
			} else {
				optionsMenuItems.push({
					name: licenseNowText,
					href: 'license-now/' + id
				});
			}
		}
		if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			optionsMenuItems.push({ name: 'Preview AMG Tags', href: baseUrl + '/sa/amg/amg/generateForTrack?debug=1&track_id=' + id, target: '_blank' });
			optionsMenuItems.push({
				name: 'Preview Lyrics',
				onClick: function () {
					const modal = new LyricsModal();
					modal.trackId = id;
					modal.init();
				}
			});
		}

		// Check if Netflix Songbird link allowed
		const [allowSongbird, grammyTrackId] = allowSongbirdOption(itemInfo);

		if (allowSongbird) {
			optionsMenuItems.push({ name: 'Songbird', href: 'https://songbird.prod.netflixstudios.com/track/' + grammyTrackId, target: '_blank' });
		}

		var optionsMenu = new sa.components.OptionsMenu({
			items: optionsMenuItems,
			hideOnMouseLeave: true,
			hideOnOutsideClick: sa.isMobile() ? true : false,
		});

		if (loadLicensingProfile) {
			licensingModal.getProfile(itemInfo, function (profile) {
				if (!profile || profile.notfound) {
					return;
				}
				optionsMenu.addItem({
					name: licenseNowText,
					onClick: function (e) {
						licensingModal.show(profile, itemInfo, e);
					}
				});
			});
		}

		return optionsMenu.getAnchor();
	}

	/**
	 * Return information about showing/using Songbird
	 * @param itemInfo
	 * @returns array [boolean, string|null] - [allowSongbird, grammyTrackId]
	 */
	function allowSongbirdOption(itemInfo) {
		// If this isn't the right domain
		const isMusicHub = config.id === 7494;
		if (!isMusicHub) return [false, null];

		// Check if there is an email
		const email = user.userData?.email;
		if (!email) return [false, null];

		// Check if the email is a Netflix email
		const emailSuffix = email.split('@')[1];
		if (!emailSuffix) return [false, null];

		const isNetflixEmail = ['netflix.com', 'netflixanimation.com', 'netflixcontractors.com'].includes(emailSuffix);
		if (!isNetflixEmail && !user.hasAdminPermission(AdminPermission.SuperAdmin)) return [false, null];

		// Check if the track has the `grammy_track_id` field
		const hasGrammyTrackId = itemInfo.custom_fields?.some(field => field.name === 'grammy_track_id');
		if (!hasGrammyTrackId) return [false, null];

		const grammyTrackId = itemInfo.custom_fields?.find(field => field.name === 'grammy_track_id')?.value;

		return [true, grammyTrackId];
	}

	function addArtToList(container, image, href, blank) {
		let col;
		if (!image && !href) {
			// default art
			col = $j('<td class="lc_art"><div class="art_image"></div></td>');
			col.find('.art_image').append(getDefaultArtElement(list.conf.listType))
		} else if (image && (!href || conf.disableLinksToLists)) {
			col = $j('<td class="lc_art"><div class="art_image non_link"><img src="' + image + '" alt=""/></div></td>');
		} else if (!image && href) {
			col = $j('<td class="lc_art"><a href="' + href + '"' + (blank ? ' target="_blank"' : '') + '><div class="art_image"></div></a></td>');
			col.find('.art_image').append(getDefaultArtElement(list.conf.listType))
		} else {
			col = $j('<td class="lc_art"><a href="' + href + '"' + (blank ? ' target="_blank"' : '') + '><div class="art_image"><img src="' + image + '" alt=""/></div></a></td>');
		}
		container.append(col);
		return col;
	}

	function getExtraClassesForItem(itemInfo) {
		return (itemInfo.featured ? ' featured' : '') + (itemInfo.outOfDate ? ' out_of_date' : '');
	}

	function generateListItemRow(itemInfo, type) {
		var id = itemInfo.id;
		var tbody = $j('<tbody id="lr_' + id + '" class="item_row ' + type + '_row"></tbody>');
		var row = $j('<tr class="lr lr_' + type + getExtraClassesForItem(itemInfo) + '"></tr>').data('trackId', id);
		tbody.append(row);

		// rep/label/album lists format their data a little differently so we're going to replicate the structure used everywhere else
		if (type == 'catalog') {
			itemInfo.catalog = new Catalog({ id: itemInfo.id, image: itemInfo.image, name: itemInfo.name });
		} else if (type == 'label') {
			itemInfo['label'] = new Label({ id: itemInfo.id, image: itemInfo.image, name: itemInfo.name });
		} else if (type == 'album') {
			row.data('album', itemInfo);
			if (conf.listType == 'project_item') {
				itemInfo.album = new Album({ id: itemInfo.id, name: itemInfo.name, image: itemInfo.image });
			}
		}

		// console.log('rendering row', itemInfo, type);
		// console.log('column list', columnList);
		columnList.each(function (j, column) {
			column.getVisibleDisplayColumns().each(function (h, displayColumn) {
				var name, elem, closeElem, tags, link, userId, image, g, gLen, item, tl, col;
				let colType = displayColumn.name;
				// a bunch of special handling for albums in project lists
				if (type == 'album' && conf.listType == 'project_item') {
					// project lists override the play colum for albums
					if (colType == 'play') {
						colType = 'expand-album';
					} else if (['artist', 'composer', 'description', 'publishing'].indexOf(colType) != -1) {
						colType = 'empty';
					} else if (['artist-avatar', 'artist avatar', 'genre', 'length', 'cue-type', 'added', 'key', 'tempo', 'bpm', 'expand', 'plays', 'downloads', 'favorites', 'license_now'].indexOf(colType) != -1) {
						colType = 'empty';
					}
				}
				// track lists show labels instead of catalogs
				if ((type == 'track' || (type == 'album' && conf.listType == 'project_item')) && (colType == 'rep' || colType == 'catalog') && config.showLabelsInCatalogColumns) colType = 'label';

				let baseUrl = siteBaseUrl();

				switch (colType) {
					case 'detection-video':
						row.append($j('<td class="detection-video-wrapper">' + itemInfo['detection-video'] + '</td>'));
						break;
					case 'play':
						// the play button
						if (id == 0) {
							row.append($j('<td></td>'));
						} else {
							row.append($j('<td></td>').append(sa.components.player.generatePlayButton(id, { location: 'track_list_' + conf.bankKey })));
						}
						break;
					case 'play_with_art':
						row.addClass('with_track_art');

						var albumId = itemInfo.id;
						image = '';
						if (albumId != 0) {
							if (itemInfo['av']) {
								image = itemInfo['av'];
							} else if (itemInfo['image']) {
								image = itemInfo['image'];
							}
						}
						if (type != 'album') {
							albumId = itemInfo.album.id;
							if (albumId != 0) {
								image = itemInfo.album.image;
							}
						}
						var noImage = false;
						var href = getAlbumLink(albumId);
						var isValidImage = function (image) {
							return image && image.indexOf('default_editor') === -1;
						};
						if (!isValidImage(image)) {
							image = itemInfo.label.image;
							if (!isValidImage(image)) {
								image = itemInfo.catalog.image;
							} else {
								href = getLabelLink(itemInfo.label.id);
							}
							if (!isValidImage(image)) {
								href = 'track/' + itemInfo.id;
								noImage = true;
							} else {
								href = getCatalogLink(itemInfo.catalog.id);
							}
						}
						col = addArtToList(row, image);
						if (noImage) {
							col.find('a').append(getDefaultArtElement())
						}
						col.attr('rowspan', '2');
						col.addClass('large_track_art');

						let artPlayButton = sa.components.player.generatePlayButton(id, { location: 'track_list_' + conf.bankKey });
						artPlayButton.addClass('art_play_button');
						col.append(artPlayButton);
						break;
					case 'play for publish':
						row.append($j('<td><div class="play-button-for-publish"></div></td>').find("div").append(sa.components.player.generatePlayButton(id, { location: 'upload', importTrack: itemInfo })).end());
						break;
					case 'download':
						// the download button
						row.append($j('<td class="lc_interaction"></td>').append(sa.components.downloadFormatSelector.generateDownloadButton({ type: type, item: itemInfo, useMetaPermissionProfile: conf.listType === 'project_item' })));
						break;
					case 'download_single_format':
						// the drop download button
						let button;
						if (type === 'album') {
							button = sa.components.downloadFormatSelector.generateSingleFormatAlbumDownloadButton(id);
						} else {
							let format;
							if (itemInfo.formats.wav) {
								format = 'wav';
							} else if (itemInfo.formats.aiff) {
								format = 'aiff';
							} else {
								format = 'mp3';
							}
							button = sa.components.downloadFormatSelector.generateSingleFormatTrackDownloadButton(id, format, itemInfo.formats[format])
						}
						row.append($j('<td class="lc_interaction"></td>').append(button));
						break;
					case 'sonic_search_bolt':
						row.append($j('<td class="lc_interaction"><div id="ss_bolt_' + id + '" class="options_menu_anchor hiding_overflow fa fa-bolt" title="Find Similar"></div></td>'));
						row.find('.fa-bolt').on('click', (e) => {
							e.preventDefault();
							e.stopPropagation();
							sa.router.routeTo(siteBaseUrl() + '/sonicsearch?track_search=' + id);
						});
						break;
					case 'email':
						// the email button
						row.append($j('<td></td>').append(sa.components.emailer.generateEmailButton({ type: type, item: itemInfo })));
						break;
					case 'options':
						// drop down so you can see options for the item
						if (type != 'track') {
							row.append($j('<td></td>'));
							break;
						}
						row.append($j('<td class="lc_interaction"></td>').append(getOptionsDropDown(id, type, itemInfo)));
						break;
					case 'reorder':
						// the reording buttons for projects
						row.append($j('<td class="lc_reorder"><span class="icon fa fa-grip-vertical"></span></td>'));
						//row.find('img.up, img.down').on('click', function(itemId) { return function() { list.reorder(itemId, type, $j(this).hasClass('up') ? -1 : 1); }; }(itemInfo.id));
						break;
					case 'alternates':
						// the alternates button
						if ((itemInfo.alternates && itemInfo.alternates.length) || itemInfo.alternateCount) {
							row.append(
								$j('<td class="col_numeric"><a class="lc_alternates button small" '
									+ 'title="Click to see alternate versions of this track">+' + (itemInfo.alternateCount ? itemInfo.alternateCount : itemInfo.alternates.length) + '</a></td>')
									.find('a').on('click', function () {
										list.showAlternates(itemInfo, this);
										this.blur();
										return false;
									}).end());

						} else {
							row.append($j('<td></td>'));
						}
						break;
					// name/title columns
					case 'title':
						if (id == 0) {
							row.append($j('<td>' + itemInfo.title + '</td>'));
						} else if (conf.listType == 'project_item' && type == 'album') {
							if (list.hasAlbum) {
								row.append($j('<td></td>'));
							} else {
								row.append($j('<td class="col_single_link"><a href="' + getAlbumLink(id) + '">' + itemInfo.name + '</a></td>').attr('title', itemInfo.name.entityDecode()));
							}
						} else {
							var linkFunc = conf.linkFunc;
							if (conf.listType == 'project_item') linkFunc = getTrackLink;
							if (ios || android) {
								row.append($j('<td class="col_single_link"><a href="' + linkFunc(id) + '">' + itemInfo.title + '</a></td>').attr('title', itemInfo.title.entityDecode()));
							} else {
								row.append($j('<td class="col_multi_link"><div>'
									+ '<a href="' + linkFunc(id) + '" class="list_item_title">' + itemInfo.title + '</a></div></td>').attr('title', itemInfo.title.entityDecode()));
								//row.append($j('<td class="select_handle">' + itemInfo.title + '</td>').attr('title', itemInfo.title));
							}
						}
						break;
					case 'name':
						if (conf.listType == 'project_item' && list.hasAlbum) {
							row.append($j('<td></td>'));
						} else if (itemInfo.external) {
							row.append($j('<td class="col_single_link"><a href="' + itemInfo.external + '" target="_blank">' + itemInfo.name + '</a></td>').attr('title', itemInfo.name.entityDecode()));
						} else {
							row.append($j('<td class="col_multi_link"><div><a href="' + conf.linkFunc(id, (itemInfo.catalog ? itemInfo.catalog.id : 0)) + '">'
								+ itemInfo.name + '</a></div></td>').attr('title', itemInfo.name.entityDecode()));
						}
						break;
					case 'multi_name':
						link = '';
						if (itemInfo.link) {
							link = itemInfo.link;
						} else if (itemInfo.type.name == 'album') {
							link = getAlbumLink(itemInfo.type.id);
						} else if (itemInfo.type.name == 'project' || itemInfo.type.name == 'project_item') {
							link = getProjectLink(itemInfo.type.id);
						} else if (itemInfo.type.name == 'cue_sheet') {
							link = getCueSheetLink(itemInfo.type.id);
						} else if (itemInfo.type.name == 'tag') {
							link = getExplorerLink('type=tag&t=' + itemInfo.type.id + '&u=' + itemInfo.type['user_id']);
						} else if (itemInfo.type.name == 'track') {
							link = getTrackLink(itemInfo.type.id);
						}
						row.append($j('<td class="col_single_link"><a href="' + link + '">' + itemInfo.name + '</a></td>'));
						break;
					case 'username':
					case 'edit_user':
						userId = parseInt(itemInfo['user_id'] ? itemInfo['user_id'] : itemInfo.id);
						if (!userId) {
							if (!itemInfo.username) itemInfo.username = 'User has been removed from workspace';
							row.append($j('<td>' + itemInfo.username + (itemInfo.location ? ' ' + '(probably in ' + itemInfo.location +')' : '') + '</td>'));
						} else {
							row.append($j('<td class="col_single_link"><a href="' + baseUrl + '/admin?p=' + (colType === 'edit_user' ? 'users&tab=edit&user=' : 'stats&tab=users&user=') + userId + '">'
								+ itemInfo.username + '</a></td>').attr('title', itemInfo.username));
						}
						break;
					case 'watermarked':
						if (itemInfo.watermarked) {
							row.append($j('<td class="watermarked"><span class="watermark_notice" title="This download was watermarked">W</span></td>'));
						} else {
							row.append($j('<td></td>'));
						}
						break;
					case 'added_by':
						if (!itemInfo.addedBy || itemInfo.addedBy.userId) {
							row.append('<td></td>');
						} else {
							row.append($j('<td>' + itemInfo.addedBy.username + '</td>').attr('title', itemInfo.addedBy.username.entityDecode()));
						}
						break;
					// thumb columns
					case 'avatar':
					case 'catalog_avatar':
					case 'large_catalog_art':
						col = addArtToList(row, itemInfo.catalog.image, itemInfo.external ? itemInfo.external : getCatalogLink(itemInfo.catalog.id), !!itemInfo.external);
						if (colType === 'large_catalog_art') {
							col.attr('rowspan', '2');
							col.addClass('large_track_art');
						}
						break;
					case 'label_avatar':
					case 'label avatar':
					case 'large_label_art':
						col = addArtToList(row, itemInfo['label'].image, getLabelLink(itemInfo['label'].id));
						if (colType === 'large_label_art') {
							col.attr('rowspan', '2');
							col.addClass('large_track_art');
						}
						break;
					case 'album_avatar':
					case 'album avatar':
					case 'forced album avatar':
					case 'large_album_art':
						var albumId = itemInfo.id;
						image = '';
						if (albumId != 0) {
							if (itemInfo['av']) {
								image = itemInfo['av'];
							} else if (itemInfo['image']) {
								image = itemInfo['image'];
							}
						}
						if (type != 'album') {
							albumId = itemInfo.album.id;
							if (albumId != 0) {
								image = itemInfo.album.image;
							}
						}
						var href = getAlbumLink(albumId);
						var isValidImage = function (image) {
							return image && image.indexOf('default_editor') === -1;
						};
						if (!isValidImage(image) && colType === 'large_album_art') {
							image = itemInfo.label.image;
							if (!isValidImage(image)) {
								image = itemInfo.catalog.image;
							} else {
								href = getLabelLink(itemInfo.label.id);
							}
							if (!isValidImage(image)) {
								let $artEl = getDefaultArtElement();
								$artEl.addClass('art_image');
								let artHtml = $artEl[0].outerHTML;
								row.append(`<td class="lc_art large_track_art left" rowspan="2"><a href="track/${itemInfo.id}">${artHtml}</a></td>`)
								// row.append('<td class="lc_art large_track_art left" rowspan="2"><a class="default_album_art" href="track/' + itemInfo.id + '"><div class="art_image"><div class="fa fa-music art_symbol"></div></div></a></td>');
								break;
							} else {
								href = getCatalogLink(itemInfo.catalog.id);
							}
						}
						col = addArtToList(row, image, href);
						if (colType === 'large_album_art') {
							col.attr('rowspan', '2');
							col.addClass('large_track_art');
						}
						break;
					case 'artist avatar':
					case 'artist_avatar':
					case 'large_artist_art':
						var artistId = itemInfo.id;
						image = itemInfo['av']; // brackets won't throw undefined
						if (type != 'artist') {
							if (!itemInfo.artist) {
								row.append($j('<td></td>'));
								console.log('tried to create an artist avatar without an artist set');
								break;
							}
							artistId = itemInfo.artist.id;
							image = itemInfo.artist.image;
						}
						col = addArtToList(row, image, getArtistLink(artistId));
						if (colType === 'large_artist_art') {
							col.attr('rowspan', '2');
							col.addClass('large_track_art');
						}
						break;
					case 'user avatar':
						userId = itemInfo['user_id'] ? itemInfo['user_id'] : itemInfo.id;
						row.append('<td class="col_single_link">' + sa.generateUserAvatarHtml(itemInfo, userId ? baseUrl + '/admin?p=stats&tab=users&user=' + userId : '#0') + '</td>');
						break;
					case 'image':
						addArtToList(row, itemInfo.image, itemInfo.external ? itemInfo.external : getCatalogLink(id), !!itemInfo.external);
						break;
					case 'music_supplier_avatar':
					case 'large_music_supplier_art':
					case 'music_provider_avatar':
					case 'large_music_provider_art':
						if (itemInfo.musicSupplier) {
							col = addArtToList(row, itemInfo.musicSupplier.image, getMusicSupplierLink(itemInfo.musicSupplier.id));
							if (colType === 'large_music_provider_art' || colType === 'large_music_supplier_art') {
								col.attr('rowspan', '2');
								col.addClass('large_track_art');
							}
						} else {
							row.append($j('<td></td>'));
						}
						break;
					// linked flexible text columns
					case 'rep':
					case 'catalog':
						name = itemInfo['catalog'].name;
						elem = (!conf.disableLinksToLists && (tl = getCatalogLink(itemInfo['catalog'].id))) ? '<a href="' + tl + '" data-search_tag="catalog:&quot;' + name.trim().replace(/'/g, '&apos;').replace(/"/g, '') +'&quot;">' : '';
						closeElem = elem ? '</a>' : '';
						row.append($j('<td class="col_single_link">' + (itemInfo['label'].id ? elem + name + closeElem : '') + '</td>').attr('title', name.entityDecode()));
						break;
					case 'label':
						name = itemInfo['label'].name;
						elem = (!conf.disableLinksToLists && (tl = getLabelLink(itemInfo['label'].id))) ? '<a href="' + tl + '" data-search_tag="label:&quot;' + name.trim().replace(/'/g, '&apos;').replace(/"/g, '') +'&quot;">' : '';
						closeElem = elem ? '</a>' : '';
						row.append($j('<td class="col_single_link">' + (itemInfo['label'].id ? elem + name + closeElem : '') + '</td>').attr('title', name.entityDecode()));
						break;
					case 'music provider':
					case 'music_provider':
					case 'music supplier':
					case 'music_supplier':
						if (itemInfo.musicSupplier) {
							row.append($j('<td class="col_single_link"><a href="' + getMusicSupplierLink(itemInfo.musicSupplier.id) + '">' + itemInfo.musicSupplier.name + '</a></td>')
								.attr('title', htmlDecode(itemInfo.musicSupplier.name.entityDecode())));
						} else {
							row.append($j('<td></td>'));
						}
						break;
					case 'artist':
						name = itemInfo.artist.name;
						elem = (!conf.disableLinksToLists && (tl = getArtistLink(itemInfo.artist.id))) ? '<a href="' + tl + '" data-search_tag="artist:&quot;' + name.trim().replace(/'/g, '&apos;').replace(/"/g, '') +'&quot;">' : '';
						closeElem = elem ? '</a>' : '';
						row.append($j('<td class="col_single_link">' + elem + name + closeElem + '</td>').attr('title', itemInfo.artist.name.entityDecode()));
						break;
					case 'album':
						name = itemInfo.album.name;
						elem = (!conf.disableLinksToLists && (tl = getAlbumLink(itemInfo.album.id))) ? '<a href="' + tl + '" data-search_tag="album:&quot;' + name.trim().replace(/'/g, '&apos;').replace(/"/g, '') +'&quot;">' : '';
						closeElem = elem ? '</a>' : '';
						row.append($j('<td class="col_single_link">' + (itemInfo.album.id ? elem + name + closeElem : '') + '</td>').attr('title', name.entityDecode()));
						break;
					// basic data columns
					case 'description':
						tags = detectTags(itemInfo.description, true);
						if (tags) {
							if (conf.disableLinksToLists) {
								tags = itemInfo.description
							}
							row.append($j('<td class="list_item_description"><span class="tags"><div>' + tags + '</div></span></td>').attr('title', (config.id != 225 ? itemInfo.description.entityDecode() : '')));
							sa.search.addSearchTagListeners(row);
						} else {
							row.append($j('<td class="col_single_link"><a href="' + getTrackLink(id) + '" class="list_item_description">' + itemInfo.description + '</a></td>')
								.attr('title', (config.id != 225 ? itemInfo.description.entityDecode() : '')));
						}
						break;
					case 'instruments':
					case 'keywords':
						let val = itemInfo[colType];
						if (val) {
							// Remove extra commas from the list of tags
							val = val.replace(/,{2,}/g, ',');

							tags = detectTags(val, true);
							if (tags) {
								if (conf.disableLinksToLists) {
									tags = val;
								}
								row.append($j(`<td class="list_item_${colType}"><span class="tags"><div>${tags}</div></span></td>`).attr('title', val.entityDecode()));
								sa.search.addSearchTagListeners(row);
							} else {
								row.append($j(`<td class="list_item_${colType}">${val}</td>`).attr('title', val.entityDecode() ));
							}
						} else {
							row.append($j('<td></td>'));
						}
						break;
					case 'filename':
						var filename = '';
						if (itemInfo['filename']) {
							filename = itemInfo['filename'];
						} else if (itemInfo['file'] && itemInfo['file']['filename']) {
							filename = itemInfo['file']['filename'];
						}
						row.append($j('<td><span class="tags">' + filename + '</span></td>').attr('title', filename.entityDecode()));
						break;
					case 'style':
						addSearchableTags(row, itemInfo.styles || []);
						break;
					case 'mood':
						addSearchableTags(row, itemInfo.moods || []);
						break;
					case 'genre':
						var genres = (conf.useMusicSupplierData && itemInfo.musicSupplierGenres) ? itemInfo.musicSupplierGenres : itemInfo.genres;
						var genreStrings = [];
						for (g = 0, gLen = genres.length; g < gLen; g++) {
							genreStrings.push(genres[g].name);
						}
						addSearchableTags(row, genreStrings);
						break;
					case 'tempo':
						var tempos = (conf.useMusicSupplierData && itemInfo.musicSupplierTempos) ? itemInfo.musicSupplierTempos : itemInfo.tempos;
						var tempoStrings = [];
						for (g = 0, gLen = tempos.length; g < gLen; g++) {
							tempoStrings.push(tempos[g].name);
						}
						addSearchableTags(row, tempoStrings);
						break;
					case 'cue-type':
						var cueTypes = (conf.useMusicSupplierData && itemInfo.musicSupplierCueTypes) ? itemInfo.musicSupplierCueTypes : itemInfo.cueTypes;
						var cueTypeStrings = [];
						for (g = 0, gLen = cueTypes.length; g < gLen; g++) {
							cueTypeStrings.push(cueTypes[g].name);
						}
						addSearchableTags(row, cueTypeStrings);
						break;
					case 'writer':
					case 'publisher':
						var personLinks = [];
						let personType = colType + 's';
						if (itemInfo[personType]) {
							for (var w = 0, wLen = itemInfo[personType].length; w < wLen; w++) {
								var person = itemInfo[personType][w];
								personLinks.push('<a href="' + siteBaseUrl() + '/' + colType + '/' + person.id + '" data-search_tag="' + personType.substring(0, personType.length - 1) + ':&quot;' + person.name.trim().replace(/'/g, "&apos;").replace(/"/g, '') +'&quot;">' + person.name + (person.affiliation.id ? ' (' + person.affiliation.name + ')' : '') + '</a>');
							}
						}
						row.append('<td><span class="tags">' + personLinks.join(', ') + '</span></td>');
						break;
					case 'added':
						if (itemInfo.date && itemInfo.date != formatDate(config.dateFormatString, 0)) {
							if (config.id == 382 || config.id == 1494) {
								row.append('<td>' + itemInfo.date.match(/[0-9]{4}/)[0] + '</td>');
							} else if (config.dateFormatString === 'Y/m/d') {
								row.append('<td>' + itemInfo['date'] + '</td>');
							} else {
								row.append('<td>' + itemInfo['date'].substring(0, 6) + itemInfo['date'].substring(8, 10) + '</td>');
							}
						} else {
							row.append('<td></td>');
						}
						break;
					case 'date':
						if (itemInfo.dateAdded) {
							row.append('<td>' + itemInfo.dateAdded + '</td>');
						} else if (itemInfo.date) {
							row.append('<td>' + formatDate(config.dateTimeFormatString, itemInfo.date) + '</td>');
						} else {
							row.append('<td></td>');
						}
						break;
					case 'date_string':
						row.append('<td>' + itemInfo.date_string + '</td>');
						break;
					case 'key':
						row.append('<td>' + itemInfo.key.name + '</td>');
						break;
					case 'isrc':
					case 'iswc':
					case 'version':
						row.append('<td>' + (itemInfo[colType] || '') + '</td>');
						break;
					case 'bpm':
						row.append('<td class="col_numeric">' + (itemInfo.bpm != '0' ? itemInfo.bpm : '') + '</td>');
						break;
					// multi format and type specific columns
					case 'type':
						row.append($j('<td title="Show/Hide Tracks"></td>').append($j(sa.components.buttons.generateInteractionHistoryButton({ type: itemInfo.type.name }))
							.on('click', function () {
								var t = $j(this);
								if ($j('#expanded_' + itemInfo.id).length) {
									// it's already open. close it
									list.hideTracks(itemInfo.id);
									t.parents('.lr').find('.lc_expand').html('+' + itemInfo.track_count);
								} else {
									// it's closed. open it!
									list.expandTracks(itemInfo.id, itemInfo.type);
									t.parents('.lr').find('.lc_expand').html('-' + itemInfo.track_count);
								}
								this.blur();
								return false;
							})));
						break;
					case 'expand':
						// expands tracks under a download
						row.append($j('<td class="col_numeric"><a class="lc_expand button small" href="' + getDefaultLink() + '" title="Click to show/hide tracks">+' + itemInfo.track_count + '</a></td>')
							.find('a').on('click', function () {
								var t = $j(this);
								if ($j('#expanded_' + itemInfo.id).length) {
									// it's already open. close it
									list.hideTracks(itemInfo.id);
									t.html('+' + itemInfo.track_count);
								} else {
									// it's closed. open it!
									list.expandTracks(itemInfo.id, itemInfo.type);
									t.html('-' + itemInfo.track_count);
								}
								this.blur();
								return false;
							}).end());
						break;
					case 'expand-album':
						// expands an album's tracks
						row.append($j('<td class="col_numeric"><a class="lc_alternates lc_expand-album button small" title="Click to show/hide tracks">+' + itemInfo.count + '</a></td>')
							.find('a').on('click', function () {
								var t = $j(this);
								if ($j('#expanded_' + itemInfo.id).length) {
									// it's already open. close it
									t.html('+' + itemInfo.count);
									list.hideTracks(itemInfo.id);
								} else {
									// it's closed. open it!
									t.html('-' + itemInfo.count);
									list.expandTracks(itemInfo.id, {
										name: 'album',
										id: itemInfo.id
									});
								}
								this.blur();
								return false;
							}).end());
						break;
					case 'status':
						// shows on a download list the status of the bundle
						var status = '';
						var statusText = '';
						if (itemInfo['downloaded']) {
							statusText = 'Downloaded';
							status = 'downloaded';
						} else if (itemInfo.status == 'cached') {
							statusText = 'Ready!';
							status = 'cached';
						} else if (itemInfo.status == 'processing') {
							statusText = 'Currently bundling';
							status = 'processing';
						} else {
							statusText = 'Queued for bundling';
							status = 'queued';
						}
						var dot = $j('<td class="dot ' + status + '"></td>');
						dot.attr('title', itemInfo.type.name + ': ' + itemInfo.name);
						if (status == 'downloaded' || status == 'cached') {
							dot.on('click', function () {
								sa.components.downloader.show({
									type: itemInfo.type.name,
									item: { id: itemInfo.type.id, userId: itemInfo.type['user_id'] },
									format: itemInfo.format
								});
							});
						}
						row.addClass(status).append($j('<td>' + statusText + '</td>').prepend(dot));
						break;
					case 'format':
						// indicates what format an item was interacted with in a history list
						if (itemInfo.format == 'flv' || itemInfo.format == 'extr') {
							// it's a play and we need to show a download widget. we also show it for extra format downloads because we're not recording enough info to do it properly
							item = {
								id: itemInfo.type.id,
								userId: itemInfo.type['user_id'],
								tag: itemInfo.name,
								name: itemInfo.name,
								formats: itemInfo.formats
							};
							row.append($j('<td class="lc_interaction"></td>').append(sa.components.downloadFormatSelector.generateDownloadButton({ type: 'track', item: item })));
						} else {
							if (sa.disableDownloading) {
								row.append($j('<td class="col_numeric"><div id="nondl_' + itemInfo.format + '" class="non_download download_button download_' + itemInfo.format + ' image_only"><div class="image"></div></td>')
									.on('click', function () {
										sa.alert('Downloading this file type is disabled by administrators.');
									}));
							} else {
								row.append($j('<td class="col_numeric"><div id="dl_' + itemInfo.format + '" class="download_button download_' + itemInfo.format + ' download_button_icon_container image_only"><div class="image"></div></td>')
									.on('click', function () {
										sa.components.downloader.show({ type: itemInfo.type.name, item: { id: itemInfo.type.id, userId: itemInfo.type['user_id'] }, format: itemInfo.format });
									}));
							}
						}
						break;
					case 'multi_download':
						// download button that supports multiformats
						item = {
							id: itemInfo.type.id,
							userId: itemInfo.type['user_id'],
							tag: itemInfo.name,
							name: itemInfo.name,
							formats: itemInfo.formats
						};
						row.append($j('<td class="lc_interaction"></td>').append(sa.components.downloadFormatSelector.generateDownloadButton({ type: itemInfo.type.name, item: item })));
						break;
					// super basic text columns
					case 'length':
						row.append($j('<td class="col_numeric">' + itemInfo[colType] + '</td>'));
						break;
					case 'history_type':
						row.append($j('<td>' + itemInfo[colType] + '</td>'));
						break;
					case 'plays':
					case 'downloads':
					case 'source_download':
					case 'price':
					case 'favorites':
					case 'licenses':
					case 'track count':
					case 'label count':
					case 'artist count':
					case 'album count':
					case 'comments':
					case 'count':
						colType = colType.replace(/ /g, '_');
						row.append($j('<td class="col_numeric">' + (itemInfo.external ? '&nbsp;' : numberFormat(itemInfo[colType])) + '</td>'));
						break;
					case 'project album count':
						row.append($j('<td class="col_numeric">' + (itemInfo.external ? '&nbsp;' : numberFormat(itemInfo.albumCount)) + '</td>'));
						break;
					case 'project track count':
						row.append($j('<td class="col_numeric">' + (itemInfo.external ? '&nbsp;' : numberFormat(itemInfo.trackCount)) + '</td>'));
						break;
					case 'project total track count':
						row.append($j('<td class="col_numeric">' + (itemInfo.external ? '&nbsp;' : numberFormat(itemInfo.totalTrackCount)) + '</td>'));
						break;
					case 'project date published':
						row.append($j('<td>' + formatDate(config.dateFormatString, config.siteType == 'buyer' ? itemInfo.publish.licensee : itemInfo.publish.local) + '</td>'));
						break;
					case 'licensee':
						colType = colType.replace(/ /g, '_');
						row.append($j('<td>' + (itemInfo.userId ? '<a href="' + baseUrl + '/admin?p=users&tab=edit&user=' + itemInfo.userId + '">' : '')
							+ (itemInfo.external ? '&nbsp;' : itemInfo[colType]) + (itemInfo.userId ? '</a>' : '') + '</td>'));
						break;
					case 'license_price':
						colType = colType.replace(/ /g, '_');
						row.append($j('<td>' + (itemInfo.external ? '&nbsp;' : itemInfo[colType]) + '</td>'));
						break;
					case 'license_status':
					case 'license_view':
						colType = colType.replace(/ /g, '_');
						row.append($j('<td>' + numberFormat(itemInfo[colType]) + '</td>'));
						break;
					case 'wang_score':
						colType = colType.replace(/ /g, '_');
						row.append($j('<td class="col_numeric">' + (itemInfo.external ? '&nbsp;' : itemInfo[colType]) + '</td>'));
						break;
					case 'add_to_cart':
						colType = colType.replace(/ /g, '_');
						if (config.licensingConfig.show) {

							licensingModal.getProfile(itemInfo, function (profile) {
								if (!profile) {
									row.append($j('<td id="add_to_cart_' + itemInfo.id + '" class="add_to_cart no-profile"></td>'));
								} else {

									let hasPrice = profile.oneprice && profile.oneprice >= 0;

									if (profile.oneprice && profile.oneprice == -1) {
										var contactOverrideUrl = profile.data.hasOwnProperty('overrideUrl') && profile.data.overrideUrl ? profile.data.overrideUrl : '';
										var contactFormCell;
										if (contactOverrideUrl) {
											contactFormCell = $j(`
												<td id="add_to_cart_${itemInfo.id}" class="add_to_cart${hasPrice ? ' with_price' : ''}">
													<div class="cart_container" class="contact-us-line-item">
														<a href="${contactOverrideUrl}" target="_blank">
															Contact Us
														</a>
													</div>
												</td>`
											);
										} else {
											contactFormCell = $j(`
												<td id="add_to_cart_${itemInfo.id}" class="add_to_cart${hasPrice ? ' with_price' : ''}">
													<div class="cart_container" class="contact-us-line-item">
														<a href="#0">
															Contact Us
														</a>
													</div>
												</td>`
											);
											contactFormCell.find('a').on('click', function() {
												contactUsLicenseModal(itemInfo.id);
												return false;
											});
										}
										row.append(contactFormCell);

										return;
									} else {

										row.append($j(`
												<td id="add_to_cart_${itemInfo.id}" class="add_to_cart${hasPrice ? ' with_price' : ''}">
													<div class="cart_container">${hasPrice ? Number(profile.oneprice).currencyFormat() + ' ' : ''}
													<div class="cart fa fa-shopping-cart"><div class="addremove fa fa-plus"></div></div>
												</td>`));
									}

									if (sa.components.shoppingCart.hasItem({ track_id: itemInfo.id, type: 'licensing' })) {
										row.find('#add_to_cart_' + itemInfo.id + ' .addremove').removeClass('fa-plus').addClass('fa-check');
									} else {
										row.find('#add_to_cart_' + itemInfo.id + ' .cart_container').on('click', function (e) {
											var t = $j(this);

											licensingModal.show(profile, itemInfo, e, function (r) {
												console.log('- lm cb:', r);
												if (r) {
													t.find('.addremove').removeClass('fa-plus').addClass('fa-check');
													t.off();
												}
											});

											e.stopPropagation(); // don't select the row
										});
									}

								}
							});

						} else {
							row.append($j('<td id="add_to_cart_' + itemInfo.id + '"></td>'));
						}
						break;
					case 'track_number':
						row.append($j('<td>' + (itemInfo.album.number && itemInfo.album.number != '0' ? itemInfo.album.number : '') + '</td>'));
						break;
					case 'license_now':
						const [allowSongbird, grammyTrackId] = allowSongbirdOption(itemInfo);
						const songbirdLink = allowSongbird ? `
							<a href="https://songbird.prod.netflixstudios.com/track/${grammyTrackId}" id="songbird-btn" style="margin-top: 4px;" target="_blank" class="songbird-btn button">
								Songbird
							</a>
						` : '';
						const licenseNowRow = `
							<td>
								<a id="list-lnow-${id}" href="${config.licensing['full_licensing'] ? '/license-now/' + id : getTrackLink(id, 'license')}" ${allowSongbird ? 'style="margin-top: 10px;"' : ''} class="button license_now_button">
									${licenseNowText}
								</a>
								${songbirdLink}
							</td>
						`;

						row.append($j(licenseNowRow));

						if (!config.licensing.full_licensing) {
							row.find('#list-lnow-' + id).on('click', function () {
								$j(this).removeAttr('href');
								var modal = new LicenseNowModal();
								modal.trackId = id;
								modal.init();
							});
						}
						break;
					case 'available formats':
						var formatContainer;

						if (undefined === templating) {
							templating = sa.templates.get('publish_component');
						}

						formatContainer = $j('<td class="lc_available_formats"></td>').append(templating.get("available_formats_row"));

						_.each(itemInfo.formats, function (val, format) {
							var img = formatContainer.find('img[data-format="' + format + '"]');

							if (val == 'i') {
								img.attr('src', 'images/icons/' + format + '-faded.png')
									.attr('title', 'Not yet uploaded');
							} else if ('g' == val) {
								img.attr('title', 'Will be generated on publish');
							}
						});

						row.append(formatContainer);
						break;
					// catches times when we need a column to take up space but don't want anything in it
					case 'empty':
						row.append($j('<td></td>'));
						break;
					// don't need to do anything. we'll take care of this later
					case 'quick-projects':
					case 'edit':
					case 'delete':
					case 'feature':
						break;
					default:
						var colId = colType.match(/^custom_([0-9]+)$/);
						if (colId) {
							// it's a custom column!
							if (type == 'track') {
								colId = colId[1];
								var customValue = ''; // this default is what will show up if they didn't set this custom field for this track
								// we don't have a good way to find these so we'll have to loop through and track it down
								for (var c = 0; c < itemInfo.custom_fields.length; c++) {
									var cust = itemInfo.custom_fields[c];
									if (cust.id == colId) {
										// we found it!
										customValue = cust.value;

										break;
									}
								}
								tags = detectTags(customValue);
								if (tags) {
									if (conf.disableLinksToLists) {
										tags = customValue
									}
									row.append($j('<td class="flexible"><span class="tags"><div>' + tags + '</div></span></td>').attr('title', customValue));
									sa.search.addSearchTagListeners(row);
								} else {
									if (conf.disableLinksToLists) {
										row.append($j('<td>' + customValue + '</td>').attr('title', customValue));
									} else {
										row.append($j('<td class="col_single_link"><a class="lc_' + colType + ' lc_custom flexible" href="' + getCustomLink(colId, customValue) + '">' + customValue + '</a></td>').attr('title', customValue));
									}
								}
							} else {
								// it's probably an album in a project list on a white label that has custom fields in their columns
								row.append($j('<td></td>'));
							}

						} else
							if (itemInfo && itemInfo[colType]) { // just default property fallback
								row.append($j('<td class="lc_' + colType + '">' + itemInfo[colType] + '</td>'));
							} else {
								// it's not a custom column. something bad is happening
								console.log('Unknown column: ' + colType, itemInfo);
							}
				}

			});
		});

		if (list.view === ListViewType.Mobile) {
			columnList.each(function (n, column) {
				console.log('mobile column', j, column);
				row.find('td:nth-child(' + (n + 1) + ')').attr('rowspan', 2);
				if (column.name == 'Track Info') {
					var visibleColumns = column.getVisibleDisplayColumns();
					var visibleColumnsCount = visibleColumns.length;
					var infoCol = row.find('td:nth-child(' + (n + 1) + ')');
					var removeCols = []
					for (var j = 0; j < visibleColumnsCount - 1; j++) {
						var visCol = visibleColumns[j];
						console.log("visCol", visCol.name)
						var dataCol = row.find('td:nth-child(' + (j + n + 2) + ')').first();
						if (!dataCol.length) continue;
						removeCols.push(dataCol);
						if (dataCol.children().length) {
							console.log("had children", dataCol.children())
							infoCol.append(dataCol.children().detach().wrap('<div class="' + visCol.name + '"></div>'));
						} else {
							infoCol.append('<div class="' + visCol.name + '">' + dataCol.html() + '</div>')
						}
					}
					removeCols.forEach(function (a) { a.remove() });
					console.log('table', list.table, 'header', list.table.find('.l_header'), '.l_header th:nth-child(' + (n + 1) + ')', list.table.find('.l_header th:nth-child(' + (n + 1) + ')').attr('colspan'))
					list.table.find('.l_header th:nth-child(' + (n + 1) + ')').attr('colspan', 1);

				}
			})
		}

		if (conf.listType != 'project_item' && !conf.suppressFeature) {
			// let featurePosition = (list.view === ListViewType.Block && conf.listType === 'track' ? 'last' : 'first');
			const featurePosition = 'last';
			if (conf.allowEditing && user.hasAdminPermission(AdminPermission.Feature)) {
				row.find('td:' + featurePosition).addClass('featured-button-parent').append(sa.components.buttons.generateFeatureButton({
					id: itemInfo.id,
					type: type,
					featured: itemInfo.featured
				}).addClass('line_listing_feature_button'));
			} else {
				row.find('td:' + featurePosition).addClass('featured-button-parent').append(sa.components.buttons.generateFeatureBadge());
			}
		}

		if (itemInfo.outOfDate) {
			row.find('td:last').addClass('last').append('<div class="out_of_date_notice" title="' + 'This track has updates pending and may appear out of place until those updates have finished processing.' + '">i</div>');
		}

		// designate first and last for indentation
		row.find('td:first').addClass('left');
		row.find('td:last').addClass('right');

		sa.search.addSearchTagListeners(row);

		return tbody;
	}

	/**
	 * Adds a table tr track
	 * @param {Track|Catalog|Label|Artist|Composer|sa.objectTypes.ImportTrack|ImportTrackData} itemInfo see this.addTrack
	 * @param {string} type the type of item to add (optional - default to this.conf.listType)
	 * @param {boolean} addToTop should we put the item on top instead of the default bottom?
	 * @param {boolean} [skipWaveform=false] Whether to generate a waveform for this item.
	 * @return the row element
	 */
	this.addListItem = function (itemInfo, type, addToTop, skipWaveform) {
		if (undefined === skipWaveform) {
			skipWaveform = false;
		}
		type = type ? type : conf.listType;

		var id = itemInfo.id;
		var showWaveform = this.view == ListViewType.MiniBlock && (type === 'track' || type === 'importTrack') && !skipWaveform;
		var rowContainer;

		if (type === 'importTrack') {

			var importTrack = sa.importTrackManager.getImportTrack(sa.router.getFullUrl(), itemInfo);
			if (importTrack === null) return $j();
			rowContainer = importTrack.generateListElement({ waveform: showWaveform });

		} else {

			// generate the row
			rowContainer = generateListItemRow(itemInfo, type);
			var row = rowContainer.children().first();

			// add the waveform
			if (showWaveform) {
				row.addClass('with_wave');
				rowContainer.append('<tr><td colspan="' + row.find('td').length + '" class="wave_row wave_view' + getExtraClassesForItem(itemInfo) + ' max_cols" id="wave_row_' + id + '"></td></tr>');
				var waveform = new Waveform(id, rowContainer.find('#wave_row_' + id), false, itemInfo.comments);
				if (conf.commentSaveVars) {
					waveform.enableCommenting(conf.commentSaveVars);
				}
			} else {
				row.addClass('no_wave');
			}

			// apply lockdown if necessary
			if (lockdown) {
				sa.lockdownLinks(row.find('a:not(.lc_alternates,.download_button)'));
			}

			if (conf.hasOwnProperty("addDetailsRows") && conf.addDetailsRows) {
				var extraRow = $j('<tr class="lr_detail_row" data-item-id="' + id + '"><td class="max_cols"></td></tr>');
				extraRow.hide();
				rowContainer.append(extraRow);
			}

		}

		// add the container to the table
		if (addToTop) {
			if (type != 'license') {
				this.table.find('.l_header').after(rowContainer);
			} else {
				this.table.find('tbody:first').after(rowContainer);
			}
		} else {
			this.table.append(rowContainer);
		}

		// expanding of tag overflows
		enableTagOverflows();

		return rowContainer;

	};

	this.removeItemByRowId = function (itemId) {
		this.table.find('#' + itemId).remove();
	};

	var tagOverflowTimeout = null;
	function enableTagOverflows() {
		if (tagOverflowTimeout) {
			clearTimeout(tagOverflowTimeout);
		}
		tagOverflowTimeout = setTimeout(function () {
			tagOverflowTimeout = null;
			if (!list.table) return;
			list.table.find('span.tags').each(function (i, el) {
				let $el = $j(el);
				if ($el.find('.expander').length) {
					return; // already has an expander
				}

				// should we add an expander?
				let lineHeight = parseInt($el.css('line-height').replace('px', ''));
				const fontSize = parseInt($el.css('font-size').replace('px', ''));
				lineHeight = !Number.isNaN(lineHeight) ? lineHeight : Math.ceil(fontSize * 1.2);
				const moreThanTwoLinesOfTags = (lineHeight * 2) + 5 < el.scrollHeight;
				if (moreThanTwoLinesOfTags) {
					$el.find('div').append('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'); //spacer so final line doesn't extend into the expander
					$el.append('<div class="expander"><i class="down fa fa-chevron-down"></i><i class="up fa fa-chevron-up"></i></div>');
					$el.find('.expander').on('click', function (e) {
						if ($el.hasClass('full')) {
							$el.removeClass('full');
						} else {
							$el.addClass('full');
						}
						e.stopPropagation();
						e.stopImmediatePropagation();
					});
				}
			});
		}, 500);
	}

	function resetRowTimeout() {
		rowTimeout = 0;
	}

	/**
	 * Populates the list after data has been loaded from the server
	 * @param {Array<ListMetaData|JSON>} newData the data from the server
	 * @param {function} sourceLinkFunction the function to use to generate pagination/sort/rpp links
	 * @param {function=} sourceOnClickFunction a function to call onclick when pagination/sort/rpp are clicked (optional)
	 */
	this.setData = function (newData, sourceLinkFunction, sourceOnClickFunction, parentViewType) {
		this.parentViewType = parentViewType;
		if (!get(this.container.attr('id'))) {
			// console.log("could not set data on container with no HTML id attribute")
			return false;
		}
		const { listType } = conf;
		const { container } = this;
		/** @type {ListMetaData} */
		const listMeta = newData ? newData[0] : [];
		const vars = sa.router.paramsToVars(listMeta.pageVars);
		const topBar = container.find('#list_top_bar');
		const { pageVars } = listMeta;
		const templates = getTemplates();
		if (!this.isLastRequest(newData)) {
			return false;
		} else if (conf.useCache) {
			sa.requestCache.set(this.lastRequestString, newData);
		}
		resetRowTimeout();
		this.lastNewData = newData;
		this.lastSourceLinkFunction = sourceLinkFunction;
		this.lastSourceOnClickFunction = sourceOnClickFunction;
		this.useMetaPermissionProfile = !!listMeta['useMetaPermissionProfile'];
		if (listType == 'track') {
			trackBank.clear(conf.bankKey);
		}

		// set up the top-of-page filters
		if (conf.affectFilters) {
			$j('#filter_control').remove();
			$j('#save_search').remove();
		}
		if ((listType == 'track' || listType == 'album') && conf.useFilters && conf.affectFilters && sa.components.leftNav) {
			// note that this is based on pagevars so if you forgot to add your new filter to the pagevars, it won't work
			let affectLeftNav = function () {
				sa.components.leftNav.setParams(listMeta.pageVars, listType + 's');
				let params = sa.components.leftNav.getItemizedParams(listType + 's');
				/**
				 * add below here if you want to add a filter to the filter bar
				 *
				 * passing this if means we want to show filters in the filters bar above the tracklist
				 *
				 * the logic within this if statment creates the filters and adds them to the filter bar
				 */
				if (params.length || vars.showSaveSearchOnly || vars.s || vars.ssurl || vars.ss || vars.ts || vars.lyrics || vars.ai || vars['ai[]']) {
					var filterControl = $j('<div id="filter_control"><div class="filter_title"><em>' + 'Filters' + '</em></div></div>');
					$j(list.container).parent().prepend(filterControl);

					// hide the tabs (if they exist and you're using filters)
					if (params.length) {
						sa.components.heading.hideTabCounts();
					}

					/**
					 * add search filters which show up in #filter_control above a track list
					 */

					if (vars.showSaveSearchOnly) {
						// hide "Filters text"
						filterControl.find('.filter_title').hide()
					}

					if (vars.s) {
						params = [{
							name: 'Search',
							value: vars.s.replace('+', ' '),
							reset: function () {
								sa.search.reset();

								const currentParams = sa.router.getCurrentParamsAsObject();
								delete currentParams['s'];

								return sa.router.routeTo(sa.router.getCurrentPath() + '?' + new URLSearchParams(currentParams).toString());
							}
						}].concat(params);
					}

					if (vars.lyrics) {
						params = [{
							name: 'Lyrics', value: vars.lyrics.replace('+', ' '), reset: function () {
								sa.search.reset();
								let currentUrl = sa.router.getFullUrl();
								let path = currentUrl
									.replace(/\blyrics=[^&]+/, '')
									.replace('&&', '&')
									.replace('?&', '?')
									.replace(/[?&]$/, '');

								sa.router.routeTo(path);
							}
						}].concat(params);
					}
					if (vars.id3) {
						let id3s = vars.id3.split('|');
						for (let kk = 0, len = id3s.length; kk < len; kk++) {
							let id3tag = id3s[kk];
							(function (id3tag) {
								params = [{
									name: 'ID3 Tag',
									value: decodeURIComponent(id3tag).substr(0, 50),
									reset: function () {
										let path = sa.route.getCurrentPath() + '&si[]=' + id3tag;
										sa.router.routeTo(path);
									}
								}].concat(params);
							})(id3tag);
						}
					}
					if (vars['ai[]'] || vars['ai']) { // ai search filter
						let aiKey = vars['ai[]'] ? 'ai[]' : 'ai';
						let val = decodeURIComponent(vars[aiKey]);
						if (val.length > 50) {
							val = val.substr(0, 50) + '...';
						}
						params.push({
							name: 'Artemis AI',
							value: decodeURIComponent(vars[aiKey]),
							reset: function () {
								let url = new URL(sa.router.currentUrl.toString());
								// for some reason the aiKey doesn't match what's in the params
								// so just delete both
								if (url.searchParams.has('ai[]')) {
									url.searchParams.delete('ai[]');
								}
								if (url.searchParams.has('ai')) {
									url.searchParams.delete('ai');
								}
								sa.router.routeTo(url.toString());
							}
						});
					}
					if (vars.ssurl) { // url search
						console.log("URL filter search", vars)
						const urlMap = {
							'nonspecific': 'Sonic Search URL',
							'spotify': 'Spotify Track',
							'tiktok' : 'TikTok Video',
							'soundcloud': 'SoundCloud Track',
							'youtube': 'YouTube Video',
						}
						let name = urlMap['nonspecific'];
						let value = decodeURIComponent(vars.sstitle || vars.ssurl).substr(0, 50);
						try {
							const url = new URL(vars.ssurl)
							if (url.hostname.indexOf("spotify.com") >= 0) {
								name = urlMap['spotify'];
							} else if (url.hostname.indexOf('youtube.com') >= 0 || url.hostname.indexOf('youtu.be') >= 0 || url.hostname.indexOf("youtube-nocookie.com") >= 0) {
								name = urlMap['youtube'];
							} else if (url.hostname.indexOf("soundcloud.com") >= 0) {
								name = urlMap['soundcloud'];
							} else if (url.hostname.indexOf("tiktok.com") >= 0) {
								name = urlMap['tiktok'];
							} else {
								value = decodeURIComponent(vars.ssurl).substr(0, 50);
							}
						}
						catch (e) {
							console.error("could not parse ssurl", vars.ssurl, e)
						}

						params.unshift({
							name: name,
							value: value,
							href: decodeURIComponent(vars.ssurl),
							reset: function () {
								let path = sa.router.getCurrentPath(true);
								path = path.replace(/sonicsearch\?id=[0-9]*/, 'tracks?');
								sa.router.routeTo(path);
							}
						});

						params.push({
							name: 'Clear All',
							emphasized: true,
							reset: function () {
								sa.router.routeTo('/tracks');
							}
						});
					} else if (vars.ts) { //track search
						params = [{
							name: 'Track', value: decodeURIComponent(vars.tstitle).replace('+', ' '),
							reset: function () {
								let path = sa.router.getCurrentPath(true);
								path = path.replace(/sonicsearch\?track_search=[0-9]*/, 'tracks?');
								path = path.replace('?&', '?');
								sa.router.routeTo(path);
							}
						}].concat(params);
						params.push({
							name: 'Clear All',
							emphasized: true,
							reset: function () {
								sa.router.routeTo('/tracks');
							}
						});
					} else if (vars.ss) { //sonic search
						params = [{
							name: 'Sonic Search File', 
							value: decodeURIComponent(vars.ss).replace('+', ' '),
							reset: function () {
								sa.router.routeTo('/tracks');
							}
						}].concat(params);
						params.push({
							name: 'Clear All',
							emphasized: true,
							reset: function () {
								sa.router.routeTo('/tracks');
							}
						});
					} else if (params.length > 1) {
						params.push({
							name: 'Clear All', emphasized: true, reset: function () {
								sa.components.leftNav.reset();
								sa.search.reset();


								let currentRoute = sa.router.getCurrentRoute(true);
								let currentUrl = sa.router.buildFullUrl(sa.router.getCurrentPath());
								if (currentRoute === null) {
									currentUrl.search = '';
									sa.router.routeTo(currentUrl.href);
								}

								let pages = ['catalog', 'label', 'music-supplier'];

								if (pages.includes(currentRoute)) {
									currentUrl.searchParams.set('page', 'tracks');
									sa.router.routeTo(currentUrl.href);
								} else {
									currentUrl.search = '';
									sa.router.routeTo(currentUrl.href);
								}
							}
						});
					}
					for (let i = 0, len = params.length; i < len; i++) {
						let param = params[i];
						let filterText = htmlEncode(param.name) + (param.value ? ': ' + htmlEncode(param.value) : '');
						if (param.emphasized) {
							filterText = '<b>' + filterText + '</b>';
						}
						if (param.href) {
							filterText = '<a href="' + param.href + '" target="_blank">' + filterText + '</a>';
						}
						let filter = $j('<span class="filter_item"><span class="fa fa-times"></span> ' + filterText + '</span>');
						filter.on('click', function (param) {
							return function () {
								param.reset();
								$j(this).remove();
							};
						}(param));
						filterControl.append(filter);
					}
					filterControl.append('<div class="clr"></div>');

					// anything with filters gets search saving
					$j(list.container).parent().prepend('<a id="save_search"><span class="icon fa fa-star-o"></span> ' + 'Save this search' + '</a>');
					$j('#save_search').off().on('click', function () { user.saveSearch(); });
					//new SaveSearchClippy().init();
				}
			};
			if (sa.components.leftNav.isLoaded()) {
				affectLeftNav();
			} else {
				console.log('setting interval to check for left nav load so we can apply track list filters');
				var initialUrl = sa.router.getFullUrl(),
					navInterval = setInterval(function () {
						if (sa.components.leftNav.isLoaded()) {
							console.log('finally setting left nav');
							clearInterval(navInterval);
							affectLeftNav();
						} else if (sa.router.getFullUrl() !== initialUrl) {
							clearInterval(navInterval);
							console.log('clearing track list left nav check because hash changed from', initialUrl, 'to', sa.router.getFullUrl());
						} else {
							console.log('still waiting on left nav load');
						}
					}, 250);
			}
		}

		// make sure we understand our source linkers
		this.pageVars = listMeta.pageVars;
		if (!this.sourceLinkFunction) {
			this.sourceLinkFunction = sourceLinkFunction;
		} else if (!sourceLinkFunction && this.sourceLinkFunction) {
			// 2020-07-08 RAC - I'm not sure why this block exists at all but if the old sourceLinkFunction is different than the new one,
			// it overwrites the new one. I added the condition above where before it was just an "else".
			// It was issue if you start on a catalog-album list, go to a catalog-label list, click on a label, and
			// then view the albums for that label. It reuses the albumList object from the catalog-album list on the label-album list
			// and this block would overwrite the label page's sourceLinkFunction with the catalog page's.
			sourceLinkFunction = this.sourceLinkFunction;
		}

		// set up sorting, if applicable
		if ((this.view === ListViewType.Mobile && (listType === 'track' || listType === 'album' || listType === 'project_item')) || ((this.view == ListViewType.Block || this.view == ListViewType.MiniBlock) && listType != 'track' && listType != 'project_item') || this.view == ListViewType.CueSheetBlock) {
			this.blocks.html('');
		} else {
			let showTrackNumbers = listMeta.showTrackNumbers,
				table = this.table;
			// determine if track numbers were already going to be shown by config
			for (let i = 0, len = columnList.length; i < len; i++) {
				if (columnList[i].title == '#' || columnList[i].name == '&num;') showTrackNumbers = false;
			}
			this.table.find('tr:not(.l_header), tbody:not(:first)').remove();
			// do we need to add the track number column?
			let trackNumberColumnIndex = this.view === ListViewType.Block ? 2 : 1;
			if (showTrackNumbers) {
				// has it already been automatically added?
				for (let i = 0, len = columnList.length; i < len; i++) {
					if (columnList[i].name == '#') {
						showTrackNumbers = false;
						break;
					}
				}
				if (showTrackNumbers) {
					columnList.splice(trackNumberColumnIndex, 0, new ListColumn('#', ['track_number'], true));
				}
			} else if (columnList.length > trackNumberColumnIndex && columnList[trackNumberColumnIndex].name == '#') {
				columnList.splice(trackNumberColumnIndex, 1);
			}
			// hide any unnecessary columns
			for (let c = 0, cLen = columnList.length; c < cLen; c++) {
				columnList[c].showHidden();
			}
			if (listMeta.hideColumns) {
				for (let hideColumn of listMeta.hideColumns) {
					for (let c = 0, cLen = columnList.length; c < cLen; c++) {
						if (columnList[c].hideDisplayColumn(hideColumn)) {
							break;
						}
					}
				}
			}
			// set up sorting header
			for (let i = 0, len = columnList.length; i < len; i++) {
				let col = columnList[i];
				if (col.isHidden()) {
					continue; // all its display columns are hidden
				}
				let name = col.name.replace(/ /g, '_').replace(/\//g, '-');
				let colDisplay = name;
				let displayColumns = col.getVisibleDisplayColumns();
				if (displayColumns[0].name.match(/^custom_/)) {
					name = displayColumns[0].name;
				} else if (name == '#') {
					name = 'track_number';
				} else if ((config.id == 72 || config.id == 87 || config.id == 114) && colDisplay == 'Title') {
					colDisplay = 'Filename';
				} else if ((config.id == 72 || config.id == 87 || config.id == 114) && colDisplay == 'Length') {
					colDisplay = 'Duration';
				} else if (config.id == 7494 && colDisplay == 'License_now') {
					colDisplay = 'Request License';
				}
				// find the col header by checking the "name" data attribute
				let colHeader = [];
				table.find('th').each(function(){
					if (this.dataset.name == col.name) {
						colHeader = $j(this)
					}
				});
				// let colHeader = table.find('th:eq(' + i + ')');
				if (!colHeader.length) {
					table.find('th.right').removeClass('right');
					table.find('th:last').after('<th colspan="' + displayColumns.length + '" class="right"></th>');
					colHeader = table.find('th:eq(' + i + ')');
				}
				if (conf.sortable && col.sortable == '1') {
					colHeader.html('<a href="' + sourceLinkFunction(pageVars + '0&no=' + name) + '"></a>');
					colHeader = colHeader.find('a');
					colHeader.on('focus', function () { this.blur(); });
					if (sourceOnClickFunction) {
						colHeader.on('click', function (sort) { return function () { return sourceOnClickFunction(pageVars + '0&no=' + sort); }; }(name));
					}
				}
				colHeader.html(ucwords(colDisplay.replace(/_/g, ' ').replace('Music rep', 'catalog')));
			}
			// remove any extra col headers
			while (columnList.length < this.table.find('th').length) {
				this.table.find('th:last').remove();
			}
		}
		// top bar sorting
		if (conf.topBar && conf.sortable) {
			//let sorter = topBar.find('#list_sorter').html('<em>Sort</em><select></select>');
			let options = [];
			let currentSort = (vars.o ? vars.o.toLowerCase() : '');
			let currentDirection = (vars.d ? vars.d.toLowerCase() : 'd');
			let foundCurrent = false;

			// top bar gets an option for each sortable column heading and one for the current sort if it's not one of those options
			for (let i = 0, len = columnList.length; i < len; i++) {
				let col = columnList[i];
				let name = col.name.toLowerCase();
				if (col.sortable != '1') continue;
				options.push(name);
				if (name == currentSort || name.replace(' ', '_') == currentSort) foundCurrent = true;
				if (currentSort == 'track_number' && (name == '#' || name == '&num;')) foundCurrent = true;
			}
			// if this site has rating sort, show it
			if (config.hasRatingSort && conf instanceof TrackListConfig) {
				options.push('rating');
				if (currentSort === 'rating' || currentSort === 'ranking') {
					foundCurrent = true;
					currentSort = 'rating';
				}
			}
			// if we're searching, we need to add the relevance sort
			// except that it's not implemented for anything but tracks and people, so only add if it's one of those
			const listTypesSupportRelevance = ['track', 'writer', 'publisher'];
			if ((vars["ai[]"] || vars['ai'] || vars.s) && listTypesSupportRelevance.includes(listType) && config.id != 382 && config.id != 1494) {
				options.push('relevance');
				foundCurrent = foundCurrent || currentSort === 'relevance';
			}
			// if it's a track list, we need to add length as a sorting option (if it's not there)
			if (conf instanceof TrackListConfig && options.indexOf('length') === -1) {
				options.push('length');
				foundCurrent = foundCurrent || currentSort === 'length';
			}
			// add the current sort as an option
			if (!foundCurrent && currentSort) {
				options.push(currentSort);
			}
			if (config.siteType === 'drop') {
				if (options.indexOf('date_added') == -1 && options.indexOf('date added') == -1 && (conf.listType == 'track')) {
					options.push('date_added');
				}
				if (options.indexOf('release_date') == -1 && options.indexOf('release date') == -1 && (conf.listType == 'album')) {
					options.push('release_date');
				}
			} else if (conf.listType === 'track' || conf.listType === 'album') {
				let releaseIndex = options.indexOf('release date');
				if (releaseIndex === -1 && options.indexOf('release_date') === -1) {
					options.push('release_date');
				} else if (releaseIndex !== -1) {
					options[releaseIndex] = 'release_date'; // release date with spaces causes problems. let's replace it
				}
			}
			options.sort();
			// the list we're going to pass to the OptionsMenu
			let menuOptions = [{
				name: 'Sorting Options',
				heading: true
			}];
			/** @var {JQuery} */
			let sortAnchor;
			let sortAnchorText = 'Select a field';
			let sortAnchorIcon = 'fa-sort-amount-desc';
			// the function called when the user clicks on a sorting option
			let menuChangeHandler = function (menuItem, element, clickEvent) {
				// set the new value in the "vars" object, which was created from the current list's pageVars, and use it to create a new pageVars
				if (menuItem.sort === '#' || menuItem.sort === '&num;') {
					vars.o = 'track_number';
				} else {
					vars.o = menuItem.sort; // the sort option we're using
				}

				// determine the direction based on the element the user actually clicked
				// we have to do this because OptionsMenus don't natively support multiple options within the same "option"
				if (clickEvent.target && clickEvent.target.className.indexOf('reverse_option') !== -1) {
					vars.d = menuItem.reverseDirection;
					sortAnchorIcon = menuItem.reverseIcon;
				} else {
					vars.d = menuItem.primaryDirection;
					sortAnchorIcon = menuItem.primaryIcon;
				}
				vars.pg = 0;
				delete vars.no; // this shouldn't be there anyway but just in case
				let newPageVars = sa.router.varsToParams(vars);
				if (sourceOnClickFunction) {
					sourceOnClickFunction(newPageVars);
				} else {
					let link = sourceLinkFunction(newPageVars);
					link = decodeURIComponent(link);
					sa.router.routeTo(link);
				}
				sortAnchor.find('#field_name').html(menuItem.optionName);
				sortAnchor.find('.anchor_icon').attr('class', 'fa anchor_icon ' + sortAnchorIcon);
			};
			// go through all the options and convert them into menu options for the OptionsMenu
			for (let i = 0, len = options.length; i < len; i++) {
				let option = options[i];
				let templateOptions = {
					optionName: ucwords(option.replace('_', ' ')),
					primaryIcon: 'fa-sort-alpha-down',
					primaryTitle: 'Alphabetically',
					primaryDirection: 'a',
					primarySelected: '',
					reverseIcon: 'fa-sort-alpha-down-alt',
					reverseTitle: 'Reverse alphabetically',
					reverseDirection: 'd',
					reverseSelected: ''
				};
				if (option === 'bpm') {
					templateOptions.primaryIcon = 'fa-sort-numeric-down';
					templateOptions.primaryTitle = 'Slowest first';
					templateOptions.reverseIcon = 'fa-sort-numeric-down-alt';
					templateOptions.reverseTitle = 'Fastest first';
					templateOptions.optionName = 'BPM';
				} else if (option === 'track count') {
					templateOptions.primaryIcon = 'fa-sort-numeric-down';
					templateOptions.primaryTitle = 'Least tracks first';
					templateOptions.reverseIcon = 'fa-sort-numeric-down-alt';
					templateOptions.reverseTitle = 'Most tracks first';
				} else if (option === 'length') {
					templateOptions.primaryIcon = 'fa-sort-amount-down-alt';
					templateOptions.primaryTitle = 'Shortest first';
					templateOptions.reverseIcon = 'fa-sort-amount-down';
					templateOptions.reverseTitle = 'Longest first';
				} else if (option === 'release_date') {
					templateOptions.primaryDirection = 'd';
					templateOptions.primaryIcon = 'fa-sort-numeric-down-alt';
					templateOptions.primaryTitle = 'Newest first';
					templateOptions.reverseDirection = 'a';
					templateOptions.reverseIcon = 'fa-sort-numeric-down';
					templateOptions.reverseTitle = 'Oldest first';
				} else if (option == '#' || option == '&num;') {
					templateOptions.primaryDirection = 'a';
					templateOptions.primaryIcon = 'fa-sort-numeric-down';
					templateOptions.primaryTitle = 'Track order';
					templateOptions.reverseDirection = 'd';
					templateOptions.reverseIcon = 'fa-sort-numeric-down-alt';
					templateOptions.reverseTitle = 'Reverse track order';
				} else if ((config.id == 72 || config.id == 87 || config.id == 114) && templateOptions.optionName === 'Title') {
					templateOptions.optionName = 'Filename';
				} else if (option === 'relevance') {
					templateOptions.primaryDirection = 'd';
					templateOptions.primaryIcon = 'fa-sort-amount-down';
					templateOptions.primaryTitle = 'Most relevant first';
					templateOptions.reverseDirection = 'a';
					templateOptions.reverseIcon = 'fa-sort-amount-down-alt';
					templateOptions.reverseTitle = 'Least relevant first';
				}
				// determine if the current option is selected
				if (option === currentSort || option.replace(' ', '_') === currentSort || (currentSort === 'track_number' && (option === '#' || option === '&num;'))) {
					sortAnchorText = templateOptions.optionName;
					if (templateOptions.primaryDirection === currentDirection) {
						templateOptions.primarySelected = 'selected';
						sortAnchorIcon = templateOptions.primaryIcon;
					} else {
						templateOptions.reverseSelected = 'selected';
						sortAnchorIcon = templateOptions.reverseIcon;
					}
				}
				menuOptions.push({
					onClick: menuChangeHandler,
					custom: templates.get('sort_option', templateOptions),
					// the following options aren't used by the OptionsMenu but this whole object is passed to the onClick and it uses them to actually perform the sort
					sort: option,
					primaryDirection: templateOptions.primaryDirection,
					reverseDirection: templateOptions.reverseDirection,
					optionName: templateOptions.optionName,
					primaryIcon: templateOptions.primaryIcon,
					reverseIcon: templateOptions.reverseIcon
				});
			}
			let sortOptionsMenu = new sa.components.OptionsMenu({
				items: menuOptions,
				customAnchor: templates.get('sort_anchor', { icon: sortAnchorIcon, fieldName: sortAnchorText }),
				hideOnOutsideClick: true
			});
			sortAnchor = sortOptionsMenu.getAnchor();
			topBar.find('#list_sorter').empty().append(sortAnchor);
		}

		// set up album image columns
		// for project lists, we either display the album name under the "Album" column if there is one or under the "Title" column if there isn't
		// there's always a title column but we need to check for an album one
		if (conf.listType == 'project_item' && this.view == ListViewType.List) {
			this.hasAlbum = false;
			let hasAlbumAvatar = false;
			let forceAlbumAvatar = false;
			for (let j = 1, len = columnList.length; j < len && !this.hasAlbum; j++) {
				let col = columnList[j];
				let displayColumns = col.getVisibleDisplayColumns();
				for (let h = 0, dispLen = displayColumns.length; h < dispLen && !this.hasAlbum; h++) {
					let colType = displayColumns[h].name;
					if (colType == 'album') {
						this.hasAlbum = true;
						if (!hasAlbumAvatar) {
							columnList[j].addDisplayColumn('forced album avatar', h);
							forceAlbumAvatar = true;
						}
					} else if (colType == 'album_avatar') {
						hasAlbumAvatar = true;
					} else if (colType == 'forced album avatar') {
						hasAlbumAvatar = true;
						forceAlbumAvatar = true;
					}
				}
			}
		}

		// figure out how many total items we have for next/prev playing
		if (conf.listType == 'project_item') {
			this.playlistData.totalItems = listMeta.project.trackCount;
			this.playlistData.itemOffset = listMeta.trackOffset;
		} else if (conf.listType == 'cue_sheet') {
			this.playlistData.totalItems = listMeta.cueSheet.trackCount;
			this.playlistData.itemOffset = listMeta.trackOffset;
		} else {
			this.playlistData.totalItems = listMeta.count;
			this.playlistData.itemOffset = listMeta.page * listMeta.perPage;
		}
		this.playlistData.items = [];

		// actually add the items
		if (newData.length < 2) {
			let emptyMessage = this.conf.emptyMessage;
			
			if (this.conf.activeFilters.size > 0) {
				emptyMessage = this.conf.filterNoResultMessage;
			} else if (!emptyMessage && listMeta.profileError) {
				if (conf.listType == 'multiformat') {
					emptyMessage = 'You do not have permission to view these items';
				} else {
					emptyMessage = `You do not have permission to view these ${gde(conf.listType, { 'case': 'lower', plural: true })}`;
				}
			} else if (!emptyMessage) {
				switch (conf.listType) {
					case 'multiformat':
						emptyMessage = 'No items to show here yet.';
						break;
					case 'project_item':
						emptyMessage = 'No tracks or albums added to playlist.';
						break;
					case 'cue_sheet':
						emptyMessage = 'No tracks added to cue sheet.';
						break;
					case 'project':
						if (config.siteType === 'drop') {
							emptyMessage = 'Make a playlist public to add it to this page';
						} else {
							emptyMessage = 'No playlists currently published.';
						}
						break;
					default:
						emptyMessage = `No ${gde(listType, { plural: true })} found.`;
						// if you're spell checking, this will be an object like { firstOriginalTerm : suggestion, secondOriginalTerm : suggestion, ... }
						// this array will be just the original terms
						// let spellcheckSuggestionKeys = Object.keys(listMeta.spellcheckSuggestions);
						// if (spellcheckSuggestionKeys.length) {
						// 	// get the string that the user searched for
						// 	let originalSearchString = sa.router.paramsToVars(listMeta.pageVars)['s'];
						// 	if (originalSearchString) {
						// 		// we're going to replace into this string to add our suggestions into a new pageVars s= string
						// 		let spellcheckedSearchStrings = [];
						// 		// we're going to replace into this string to display the suggestions to the end user
						// 		let spellcheckedDisplayStrings = [];
						// 		// we need to replace in order of longest word first
						// 		spellcheckSuggestionKeys.sort(function(a, b) { return b.length - a.length; });
						//
						// 		let originSearchStringSplits = originalSearchString.split(' ');
						// 		for (let i = 0, len = originSearchStringSplits.length; i < len; i++) {
						// 			let originalSearchStringTerm = originSearchStringSplits[i];
						// 			let found = false;
						// 			for (let i = 0, len = spellcheckSuggestionKeys.length; i < len; i++) {
						// 				let originalTerm = spellcheckSuggestionKeys[i];
						// 				if (originalSearchStringTerm.indexOf(originalTerm) !== -1) {
						// 					spellcheckedSearchStrings.push(originalSearchStringTerm.replace(originalTerm, listMeta.spellcheckSuggestions[originalTerm]));
						// 					spellcheckedDisplayStrings.push(originalSearchStringTerm.replace(originalTerm, '<i>' + htmlEncode(listMeta.spellcheckSuggestions[originalTerm]) + '</i>'));
						// 					found = true;
						// 					break;
						// 				}
						// 			}
						// 			if (!found) {
						// 				spellcheckedSearchStrings.push(originalSearchStringTerm);
						// 				spellcheckedDisplayStrings.push(originalSearchStringTerm);
						// 			}
						// 		}
						//
						// 		let href = sourceLinkFunction(listMeta.pageVars.replace('s=' + encodeURIComponent(originalSearchString), 's=' + encodeURIComponent(spellcheckedSearchStrings.join(' '))).replace('&pg=', ''));
						// 		let suggestion = spellcheckedDisplayStrings.join(' ');
						// 		emptyMessage += ` <span class="did_you_mean">Did you mean: <a href="${href}">${suggestion}</a></span>`;
						// 	}
						// }
						if ((conf.listType === 'track' || config.listType === 'album') && $j('#filter_control').length) {
							if (config.id == 72 || config.id == 87 || config.id == 114) {
								emptyMessage += ' <br/><div class="empty_notice"><b>Your filters might be hiding results.</b> Disable them in the Filter Sound Effects widget or using the list above.</div>';
							} else {
								emptyMessage += ' <br/><div class="empty_notice"><b>Your filters might be hiding results.</b> Disable them in the Filter Tracks widget or using the list above.</div>';
							}
						}
						if (config.siteType == 'buyer' && user.hasAdminPermission(AdminPermission.MusicSuppliers) && (conf.listType == 'track' || conf.listType == 'music_supplier')) {
							showEmptyLicenseeSiteNotice();
						}
				}
			}
			if (!conf.disableEmptyMessage) {
				// check to see if you're getting an empty list
				if ((!listMeta.headingName || listMeta.headingName.indexOf('All') === 0) && (!listMeta.pageVars || listMeta.pageVars.indexOf('siteId') == -1)) {
					// make sure there's actually no filtering
					var filtering = false;
					if (listMeta.pageVars) {
						var varTest = sa.router.paramsToVars(listMeta.pageVars);
						delete varTest.o;
						delete varTest.no;
						delete varTest.pg;
						delete varTest.show;
						delete varTest.d;
						filtering = (Object.keys(varTest).length > 0);
					}
					if (user.siteOwner && !filtering && !conf.emptyMessage) {
						// you're the site owner so let's tell you what to do about it
						if (conf.listType == 'track') {
							emptyMessage = sa.templates.get('get_started').get('get_started')[0].outerHTML;
						} else if (conf.listType == 'catalog') {
							emptyMessage = '<div class="guide_no_tracks">To add some ' + config.getDictionaryEntry('catalog', true, true) + ', go to the admin panel (accessible by clicking the <span class="fas fa-tools"></span> in the upper right) and go to the Manage Metadata &raquo; Catalogs section.</div>';
						} else if (conf.listType == 'label' || conf.listType == 'album' || conf.listType == 'artist') {
							emptyMessage = '<div class="guide_no_tracks">To add some ' + config.getDictionaryEntry(conf.listType, true, true) + ", edit your tracks' metadata and set their " + config.getDictionaryEntry(conf.listType, false, true) + ' fields.</div>';
						} else if (conf.listType == 'composer') {
							emptyMessage = `<div class="guide_no_tracks">${config.getDictionaryEntry(conf.listType, true, false)} can no longer be added and will soon be removed.</div>`;
						}
					} else if (!filtering) {
						// you're not the site owner. show a message that looks better than an empty track list
						if (conf.listType == 'track' || conf.listType == 'catalog' || conf.listType == 'label') {
							emptyMessage = !emptyMessage ? '<div class="nonowner_empty_message">Hello' + (user.userData.username ? ', ' + user.userData.username : '') + '!<br/><br/>'
								+ 'Your account doesn\'t currently have access to any music on this workspace.<br/><br/>'
								+ 'To enable your account and access the music, please <em>reach out to your main contact at ' + config.name + '</em> and ask them to update your access.<br/><br/>'
								+ 'Thank you!</div>' : emptyMessage;
						}
					}
				}
				if (getItemContainerType() === 'blocks') {
					if (this.blocks) this.blocks.append('<div class="list_block empty"><h2>' + emptyMessage + '</h2></div>');
				} else {
					var colSpan = 0;
					for (let j = 0; j < columnList.length; j++) {
						colSpan += columnList[j].getVisibleDisplayColumns().length;
					}
					this.table.append('<tr id="no_row"><td colspan="' + this.table.find('col').length + '" class="max_cols">' + emptyMessage + '</td></tr>');
					console.log('added no_row');
					this.resizeTrackList();
				}
			}
		} else {
			// add the tracks
			for (let i = 1, len = newData.length; i < len; i++) {
				var itemData = newData[i];
				// add to the playlist
				if (!itemData.importTrack && (conf.listType == 'track' || conf.listType == 'sad')) {
					this.playlistData.items.push(itemData.id);
				} else if ((conf.listType == 'cue_sheet' || conf.listType == 'project_item') && !itemData.importTrack && itemData.track) {
					this.playlistData.items.push(itemData.track.id);
				}
				// actually add it
				if (conf.listType == 'cue_sheet') {
					this.addCueSheetBlock(itemData);
				} else if (itemData.importTrack) {
					this.addItem(itemData, 'importTrack');
				} else if (conf.listType != 'project_item') {
					this.addItem(itemData);
				} else if (itemData.album) {
					this.addItem(itemData.album, 'album', false, !itemData['activePermissionProfile']);
				} else {
					this.addItem(itemData.track, 'track', false, !itemData['activePermissionProfile']);
				}
			}

			if (conf.listType == 'cue_sheet') {
				list.numberCueBlocks();
			}
			if (listType == 'track' || listType == 'project_item' || (this.view != ListViewType.Block && this.view != ListViewType.CueSheetBlock)) {
				this.resizeTrackList();
			}
			if (this.view == ListViewType.MiniBlock && listType != 'track' && listType != 'project_item') {
				/*
				 * If you find this block, I owe you an apology. I'm so sorry.
				 * Using display: flex; solves a lot of spacing issues with art view because it lets the elements resize
				 * easy to fill the available space in a way floats don't without a lot of javascript.
				 * Unfortunately, the last row of art objects, if it doesn't have the same number as the other rows,
				 * which is purely random, also flexes horizontally and doesn't align with the grid like the other
				 * items. The simplest fix is to add some stub elements that are incorporated into the flex calculation
				 * but aren't displayed. These stub elements pad out the last row. Since we don't know how many items
				 * are in the last row, we just add 40 of them, which should be enough even for a full rez 8k monitor.
				 * They all have 0 height and no content so hopefully there's no real cost to having them here.
				 * Now, if you'll excuse me, I need to take a shower. I can't stop feeling dirty.
				 */
				this.blocks.append('<div class="list_block showing stub"></div>'.repeat(40));
			}
			// reordering
			enableReordering();
			// disable links
			disableLinks();
			// make the tracks selectable
			enableSelection();
			// join the album art columns (if necessary)
			joinAlbumTracks();
		}

		// top bar view type control
		if (conf.topBar) {
			//console.log('view is ' + this.view);
			let listViewControl = topBar.find('#list_view_control');
			let allowedViewTypes = conf.getAllowedViewTypes();
			if (allowedViewTypes.length < 2) {
				listViewControl.hide();
			} else {

				listViewControl.show().html(templates.get('view_control').html());

				// add all the available view types in order based on the config
				let viewTypeContainer = listViewControl.find('#view_types');
				allowedViewTypes.each(
					/**
					 * @param {int} i
					 * @param {ListViewType} viewType
					 */
					function (i, viewType) {
						let viewTypeTemplate = templates.get('view_type', { type: viewType.type, name: viewType.name });
						viewTypeTemplate.on('click', function (e) {
							list.setView(viewType.type);
							e.stopPropagation();
							return false;
						});
						if (list.view === viewType.type) {
							viewTypeTemplate.addClass('selected');
						}
						viewTypeContainer.append(viewTypeTemplate);
					}
				);
			}
		}

		if (conf.pagination) {
			// set up pages
			let totalPages = Math.ceil(listMeta.count / listMeta.perPage),
				p = parseIntIfNecessary(listMeta.page),
				topBarDiv = topBar.find('#list_page_numbers').html('<em>Page</em>');
			let div = container.find('div[id=list_page_numbers]:last').html('');
			if (topBarDiv.length) {
				div = div.add(topBarDiv);
			}

			div.removeClass('showing_all');
			if (totalPages < 2) {
				div.html('Showing all results').addClass('showing_all');
			} else {
				if (p > 0) {
					div.html('<a id="list_page_prev"  href="' + sourceLinkFunction(pageVars + (p - 1)) + '"><span class="pagination_icon">&laquo;</span><span class="pagination_identifier">Prev</span></a>'
						+ '<a href="' + sourceLinkFunction(pageVars + 0) + '" id="list_page_first" >1</a>'
						+ '<span>...</span>');
					if (sourceOnClickFunction) {
						$j('#list_page_prev', div).on('click', function (page) { return function () { return sourceOnClickFunction(pageVars + page); }; }(p - 1));
						$j('#list_page_first', div).on('click', function (page) { return function () { return sourceOnClickFunction(pageVars + page); }; }(0));
					}
				}
				div.append('<input type="text" class="list_page_selection" value="' + (p + 1) + '"/>');
				// you have to do this after appending or it won't work when applying to multiple elements (top bar + bottom bar)
				div.find('input:last')
					.on('keydown', function (e) {
						var code;
						if (e) {
							code = e.keyCode;
						} else {
							code = window['event']['keyCode']; // written with array syntax to avoid deprecation notices
						}
						if ((code != 8 && code != 46 && code != 37 && code != 39 && code != 16)
							&& (code < 48 || (code > 57 && code < 96) || code > 105)) {
							return false;
						}
					})
					.on('keyup', function (e) {
						var code;
						if (e) {
							code = e.keyCode;
						} else {
							code = window['event']['keyCode']; // written with array syntax to avoid deprecation notices
						}
						if (code == 13 && this.value.match(/^[0-9]+$/)) {
							var vars = pageVars + ($j(this).val() - 1);
							if (!sourceOnClickFunction || (sourceOnClickFunction && sourceOnClickFunction(vars))) {
								let path = sourceLinkFunction(vars);
								sa.router.routeTo(path);
								window.scrollTo(window.scrollX, container.offset().top - 10);
							}
						} else {
							var t = $j(this);
							var baseWidth = t.data('base-width');
							if (!baseWidth) {
								baseWidth = t.width();
								t.data('base-width', baseWidth);
							}
							var test = $j('<span>' + t.val() + '</span>');
							$j('body').append(test);
							t.width(Math.max(baseWidth, test.width() + 8) + 'px');
							test.remove();
						}
					}).trigger('keyup');
				if (p < totalPages - 1) {
					div.append('<span>...</span>'
						+ '<a href="' + sourceLinkFunction(pageVars + (totalPages - 1)) + '" id="list_page_last">' + totalPages + '</a>'
						+ '<a id="list_page_next" href="' + sourceLinkFunction(pageVars + (p + 1)) + '"><span class="pagination_identifier">Next</span><span class="pagination_icon">&raquo;</span></a>');
					if (sourceOnClickFunction) {
						$j('#list_page_next', div).on('click', function (page) { return function () { return sourceOnClickFunction(pageVars + page); }; }(p + 1));
						$j('#list_page_last', div).on('click', function (page) { return function () { return sourceOnClickFunction(pageVars + page); }; }(totalPages - 1));
					}
				}
				div.filter('.bottom_numbers').find('a').on('click', function () {
					sa.scrollToElement(container);
					//window.scrollTo(window.scrollX, container.offset().top - 10);
				});
			}
		}
		// set up the rpp changing if it's allowed
		if (conf.resultCountChanging) {

			let resultsCountsCheck = !ios ?
				(conf.listType == 'track' || conf.listType == 'project_item' || conf.listType == 'cue_sheet') ? [5, 10, 25, 50] : [5, 10, 25, 50, 100, 250] // desktop counts
				: (conf.listType == 'track' || conf.listType == 'project_item' || conf.listType == 'cue_sheet') ? [5, 10, 15, 25, 50] : [8, 12, 20, 50]; // ios counts
			if (conf.listType === 'confirmedSad') {
				resultsCountsCheck = [5, 10, 15, 20, 25];
			}

			sa.pagination.addResultsPerPage({
				callback: function (resultCount) {
					if (!sourceOnClickFunction || (sourceOnClickFunction && sourceOnClickFunction(listMeta.pageVars.replace(/^show=([0-9]+)?&?|&show=([0-9]+)?/ig, '') + '0&show=' + resultCount))) {
						let path = sourceLinkFunction(listMeta.pageVars.replace(/^show=([0-9]+)?&?|&show=([0-9]+)?/ig, '') + '0&show=' + resultCount);
						sa.router.routeTo(path);
						list.setResultsPerPage(resultCount);
					}
				},
				container: container.find('#list_bottom_bar'),
				resultCounts: resultsCountsCheck,
				resultsPerPage: this.resultsPerPage = listMeta.perPage
			});
		}

		if (listType == 'track') {
			this.highlightTrack(sa.components.player.getPlayingTrackId());
			sa.components.player.manualPlayingUpdate();
		}

		if ((this.view != ListViewType.MiniBlock || listType == 'track' || listType == 'project_item') && this.view != ListViewType.CueSheetBlock && conf.stripe) {
			stripe(container.get(0));
		}

		this.hideCover();

		if (sa.components.projector && sa.components.projector.inQuickProjectMode()) {
			this.enableQuickProjects();
		} else if (sa.components.nester && sa.components.nester.inNestingMode()) {
			this.enableNesters();
		} else if (sa.components.cueSheeter && sa.components.cueSheeter.inQuickCueSheetMode()) {
			this.enableQuickCueSheets();
		}

		if (window['initializePlugAndPlayExplorer'] && typeof initializePlugAndPlayExplorer == 'function') {
			initializePlugAndPlayExplorer();
		}

		return true;
	};

	/**
	 * Call after manually adding a new item to the list to make sure it's properly interactive
	 */
	this.reinitializeInteractions = function () {
		updateAddRemoveButtons();
		enableSelection();
		disableLinks();
		enableReordering();
		joinAlbumTracks();
	};

	/**
	 * Disables and then re-enables the add/remove buttons if they're on
	 */
	function updateAddRemoveButtons() {
		if (sa.components.projector && sa.components.projector.inQuickProjectMode()) {
			list.disableQuickProjects();
			list.enableQuickProjects();
		} else if (sa.components.nester && sa.components.nester.inNestingMode()) {
			list.disableNesters();
			list.enableNesters();
		} else if (sa.components.cueSheeter && sa.components.cueSheeter.inQuickCueSheetMode()) {
			list.disableQuickProjects();
			list.enableQuickCueSheets();
		}
	}

	function getItemContainerType() {
		if (((list.view === ListViewType.Block || list.view === ListViewType.MiniBlock) && conf.listType != 'track' && conf.listType != 'project_item') || list.view == ListViewType.CueSheetBlock || list.view == ListViewType.Mobile) {
			return 'blocks';
		} else {
			return 'table';
		}
	}

	/**
	 * Gets the currently displayed item container, be it list.blocks or list.table
	 * @returns {JQuery} if neither container is initialized, returns an empty jQuery list so it's always safe to use
	 */
	function getItemContainer() {
		let container = getItemContainerType() === 'blocks' ? list.blocks : list.table;
		if (!container) {
			container = $j();
		}
		return container;
	}

	/**
	 * Makes the rows selectable
	 */
	function enableSelection() {
		if (!ios && !android && conf.selectable) {
			sa.components.selector.initializeItems(getItemContainer(), conf.selectorConfig);
		}
	}

	/**
	 * Disables all the links in the rows
	 */
	function disableLinks() {
		if (conf.disableLinks) {
			getItemContainer().find('a:not(.lc_alternates, .feature_button)').replaceWith(function () { return '<span class="removed_a">' + $j(this).html() + '</span>'; });
		}
	}

	/**
	 * Lets the user drag to reorder items in the list
	 */
	function enableReordering() {
		var needReorder = false;
		for (let i = 0, len = columnList.length; !needReorder && i < len; i++) {
			needReorder = columnList[i].hasDisplayColumn('reorder');
		}
		if (needReorder) {
			var draggedToPage = false;
			/** @type {JQuery} */
			var container = list.container;
			let lastTop = -9999;
			let needsSortFix = false;
			window['sortfix'] = function (event, ui) {
				if ((BrowserDetect.isChrome || BrowserDetect.isFirefox)) { // && container.hasClass('needs-sort-fix')
					let newTop = ui.item.position().top;
					if (needsSortFix) {
						ui.item.css('top', newTop + $j(window).scrollTop());
					} else if (lastTop === -9999 || Math.abs(newTop - lastTop) < 100) {
						lastTop = newTop;
					} else {
						needsSortFix = true;
					}
				}
			};
			// for a reason which eludes me, if you set up a sortable with a containment but the containment doesn't have forced dimensions, you can't drag all the way to the bottom
			//  - only true in wave view
			// mousedown fires before sortable's events so we use mousedown to set dimensions on the containment element and we remove them when sorting stops
			container.find('.lc_reorder');
			container.off('.list_reordering');
			container.on('mousedown.list_reordering', function () {
				console.log('mousedown.list_reordering');
				needsSortFix = false;
				lastTop = -9999;
				// force containment dimensions
				let containment = container.parent();
				let originalContainmentStyles = containment.attr('style');
				containment.height(containment.height());
				containment.width(containment.width());
				//container.find('.track_list_table').sortable('option', 'containment', containment);
				// hide any expanded albums
				$j(this).parents('table').find('.lc_expand-album:contains("-"), .expand-album:contains(Hide)').trigger('click');
				// remove containment restrictions when the user releases the button
				$j(document).on('mouseup.list_reordering', function () {
					container.addClass('needs-sort-fix');
					$j(document).off('.list_reordering');
					if (originalContainmentStyles) {
						containment.attr('style', originalContainmentStyles);
					} else {
						containment.removeAttr('style');
					}
				})
			});
			container.on('click', function () { });
			container.on('click.test', function () { });
			// make sure it's draggable
			/** @type {JQuery} */
			let trackListTable = container.find('.track_list_table');
			trackListTable.sortable({
				placeholder: 'ui-state-highlight-' + list.view,
				items: '.lr[id^=lr_], .lr_album, .track_row, .album_row',
				axis: 'y',
				containment: container.parent(),
				handle: '.lc_reorder',
				tolerance: 'pointer'
			});
			trackListTable.disableSelection();
			trackListTable.off('.list_reordering');
			trackListTable.on('sortstop.list_reordering', function () {
				console.log('sortstop.list_reordering');
				// remove forced containment dimensions
				var containment = container.parent();
				containment.css('width', '').css('height', '');
				// other stuff
				if (draggedToPage) return false;
				$j('.forced-width').removeClass('forced-width').removeAttr('style');
				stripe(container.get(0));
				list.saveSort();
				$j('.drop_container').remove();
			});
			trackListTable.on('sortstart.list_reordering', function (event, ui) {
				console.log('sortstart.list_reordering');
				// size the helper
				var placeholder = ui.placeholder;
				if (placeholder.is('tbody')) {
					placeholder.html('<tr><td></td></tr>');
				} else if (placeholder.is('tr')) {
					placeholder.html('<td></td>');
				}
				placeholder.find('td').attr('colspan', list.table.find('colgroup:first col').length).height($j(ui.item).outerHeight());
				// make sure the tds in the item are the right size
				if (ui.item.is('tr') && !ui.item.attr('id')) {
					// block albums are easy. there's only one td and we just set it to the width of the full-width placeholder
					ui.helper.find('td').width(ui.placeholder.width()).addClass('forced-width');
				} else {
					// for tracks, we copy the track, append the copy to the table (which should give it the right td widths), copy the widths over, and then delete the copy
					// we also need to do the waveform (if exists) which we do like the album
					var tempDrag = ui.helper.clone().removeAttr('style'), // remove style because the helper has already been absolutely positioned and won't get col widths
						trs = ui.helper.is('tbody') ? ui.helper.find('tr') : ui.helper,
						firstTrTds = $j(trs[0]).find('td');
					list.table.append(tempDrag);
					tempDrag.find('td').each(function (i) {
						$j(firstTrTds[i]).width($j(this).width()).addClass('forced-width');
					});
					tempDrag.remove();
					// now do the waveform
					if (trs.length > 1) {
						$j(trs[1]).find('td').width(ui.placeholder.width()).addClass('forced-width');
					}
					// hide the trs
					//trs.hide();
				}
				// other stuff
				draggedToPage = false;
				var pageData = list.lastNewData[0];
				if (pageData.page != 0) {
					// add a drop container at the top
					container.append('<div class="drop_container" id="previous_container">' + 'Drop items here to move to the previous page.' + '</div>');
				}
				if (pageData.count > (pageData.page + 1) * pageData.perPage) {
					// add a drop container at the bottom
					container.append('<div class="drop_container" id="next_container">' + 'Drop items here to move to the next page.' + '</div>');
				}
				/** @type {JQuery} */
				let dropContainer = $j('.drop_container');
				dropContainer.droppable({
					accept: '.lr[id^=lr_], .lr_album, .track_row, .album_row',
					hoverClass: 'ui-state-hover',
					tolerance: 'touch',
					greedy: true
				});
				dropContainer.on('drop', function (event, ui) {
					draggedToPage = true;
					var droppedRow = ui.draggable;
					let droppedRowId = droppedRow.attr('id');
					list.sortToPage(
						droppedRow.hasClass('lr_album') || droppedRow.hasClass('list_detailed') ? 'album' : 'track',
						parseInt((droppedRowId ? droppedRowId : droppedRow.find('.list_detailed').attr('id')).match(/(?:lr_|item_)([0-9]+)/)[1]),
						$j(this).attr('id').substring(0, 4));
					$j('.drop_container').remove();
				});
				dropContainer.on('dropover', function (event, ui) {
					ui.draggable.addClass('over_drop_container');
				});
				dropContainer.on('dropout', function (event, ui) {
					ui.draggable.removeClass('over_drop_container');
				});
				window['sortfix'](event, ui);
			});
			trackListTable.on('sort.list_reordering', function (event, ui) {
				console.log('sort.list_reordering');
				window['sortfix'](event, ui);
			});
		}
	}

	function joinAlbumTracks() {
		// if (list.conf.listType !== 'track' || list.view !== ListViewType.Block) return;
		//
		// let albumArtColumns = list.table.find('.large_album_art');
		// if (!albumArtColumns.length) return;
		//
		// let foundArt = false; // if there isn't any art, we need to hide the art column
		// let lastArtPath = ''; // if the art is the same as the last art, hide it
		//
		// for (let i = 0, len = albumArtColumns.length; i < len; i++) {
		// 	let currentAlbumArtColumn = $j(albumArtColumns[i]);
		// 	let currentAlbumArtPath = currentAlbumArtColumn.find('img').attr('src');
		//
		// 	if (currentAlbumArtPath !== undefined) {
		// 		// we found some art! the art column will still be displayed
		// 		foundArt = true;
		// 	}
		//
		// 	if (currentAlbumArtPath !== lastArtPath) {
		// 		currentAlbumArtColumn.removeClass('repeated_album');
		// 	} else {
		// 		currentAlbumArtColumn.addClass('repeated_album');
		// 	}
		// 	lastArtPath = currentAlbumArtPath;
		// }
		//
		// // if we didn't find any art at all, hide the art column altogether
		// console.log('joinAlbumTracks foundArt status is', foundArt);
	}

	/**
	 * Forces the List to reload its column list from its config
	 */
	this.updateColumnList = function () {
		columnList = conf.getColumnList(this.view);
	};

	/**
	 * Generates the basic container for the list that will be populated once data's been loaded
	 * @param {HTMLElement|JQuery} container the container to generate in
	 */
	this.generatePage = function (container, forceMobileView = false) {
		let listType = conf.listType;
		let templates = getTemplates();

		this.container = container = $j(container).addClass(listType + '_list').addClass('track_list');

		if (conf.topBar) {
			container.append(templates.get('top_bar'));
			setTimeout(function () {
				container.find('.list_control_bar.loading').removeClass('loading');
			}, rowTimeoutIncrement);
		}

		if (this.hasSubColumn('quick-projects') && !sa.components.quickProjectBar.isShowing()) {
			this.removeSubColumn(0, 'quick-projects');
		}

		// determine the view type based on conf and default view settings
		if (listType == 'track') {
			this.view = conf.defaultView = conf.getDefaultView();
			if (!conf.isViewTypeAllowed(this.view)) {
				this.view = ListViewType.Block;
			}
		} else if (listType == 'project_item') {
			this.view = conf.getDefaultView();
			if (!conf.isViewTypeAllowed(this.view)) {
				this.view = ListViewType.List;
			}
		} else if (listType == 'cue_sheet') {
			this.view = ListViewType.CueSheetBlock;
		} else {
			this.view = conf.defaultView = conf.getDefaultView();
			if (!conf.isViewTypeAllowed(this.view)) {
				if (conf.isViewTypeAllowed(ListViewType.Block)) {
					this.view = ListViewType.Block;
				} else if (conf.isViewTypeAllowed(ListViewType.List)) {
					this.view = ListViewType.List;
				} else {
					this.view = ListViewType.MiniBlock;
				}
			}
		}

		// Handle mobile
		var mobileView = this.conf.getMobileView();
		if (mobileView || forceMobileView) {
			this.view = mobileView;
		}

		/**
		 * Initialize the container that will hold all the listed items:
		 * Determine whether to use blocks or tables to render the listed items
		 */
		columnList = conf.getColumnList(this.view);
		if ((this.view === ListViewType.Mobile && (listType === 'track' || listType === 'project_item')) || ((this.view == ListViewType.Block || this.view == ListViewType.MiniBlock) && listType != 'track' && listType != 'project_item') || this.view == ListViewType.CueSheetBlock) {
			this.blocks = templates.get('block_container', { view: this.view });
			container.append(this.blocks);
		} else {
			this.table = templates.get('table_container', { bankKey: list.conf.bankKey });
			if (listType == 'project_item' && (this.view === ListViewType.MiniBlock || this.view === ListViewType.Block)) this.blocks = this.table;

			// set up the table's header row
			let headerRow = this.table.find('.l_header');
			if (!conf.headerBackground) {
				headerRow.addClass('tl_no_bg');
			}
			columnList.each(
				/**
				 * @param {int} i
				 * @param {ListColumn} col
				 */
				function (i, col) {
					let visibleColumns = col.getVisibleDisplayColumns();
					if (!visibleColumns.length) return;
					let name = (visibleColumns[0].name.match(/^custom_/) ? visibleColumns[0].name + ' lc_custom' : col.name.replace(/ /g, '_').replace(/\//g, '-')).toLowerCase();
					if (name === '#') name = 'track_number';
					let headerColumn = document.createElement('th');
					headerColumn.dataset.name = name;
					headerColumn.appendChild(document.createTextNode(name.replace(/_/g, ' ')));
					headerColumn.colSpan = visibleColumns.length;
					headerRow.append(headerColumn);
				}
			);

			if ((listType === 'track' || listType === 'project_item') && this.view === ListViewType.Block) {
				this.table.addClass('large_art_table');
			} else {
				this.table.removeClass('large_art_table');
			}

			container.append(this.table);
		}

		if (conf.resultCountChanging || conf.pagination) {
			var listBottomBar = templates.get('bottom_bar');
			if (conf.resultCountChanging) {
				listBottomBar.append(createDiv('list_result_count', ''));
			}
			if (conf.pagination) {
				listBottomBar.append(createDiv('list_page_numbers', 'bottom_numbers'));
			}
			container.append(listBottomBar);
		}
		container.append(createDiv('', 'clr'));
		container.data('list-object', this);
	};

	/**
	 * TODO: mobile task, make sure this is handled correctly
	 *
	 * we need to adjust the widths of the flexible columns to make sure the table fills the available width
	 * we also need to do this for vertical centering but don't get me started
	 */
	this.resizeTrackList = function () {
		if (!this.table) return;
		if (this.view === ListViewType.Mobile) {
			return;
		}
		var table = this.table,
			colspans = [],
			totalFixedWidth = 0,
			flexibleIndexes = [],
			currentCol = 0;
		// first pass sets widths for fixed columns and sums those widths up so we know how much we've got for flexibles
		for (let i = 0, len = columnList.length; i < len; i++) {
			let col = columnList[i];
			let displayColumns = col.getVisibleDisplayColumns();
			for (var j = 0, jLen = displayColumns.length; j < jLen; j++) {
				var colName = displayColumns[j].name,
					width = 0;
				currentCol++;
				//console.log(colName);
				switch (colName.replace(/_/g, ' ')) {
					case 'play':
					case 'play for publish':
						width = 45;
						break;
					case 'expand-album':
						if (this.view == ListViewType.MiniBlock) {
							width = 67;
						} else {
							width = 55;
						}
						break;
					case 'expand':
						if (this.view == ListViewType.MiniBlock) {
							width = 67;
						} else {
							width = 37;
						}
						break;
					case 'download':
					case 'email':
					case 'multi-download':
					case 'edit':
					case 'delete':
					case 'feature':
					case 'quick-projects':
					case 'reorder':
					case 'sonic search bolt':
					case 'options':
						width = 26;
						break;
					case 'download single format':
						width = 60;
						break;
					case 'alternates':
						width = 32;
						break;
					case 'length':
						width = 60;
						break;
					case 'bpm':
						width = 36;
						break;
					case 'key':
						width = 76;
						break;
					case 'plays':
						width = 50;
						break;
					case 'custom 1': // this is where content id earnings are stored right now, don't have a good override method
					case 'downloads':
					case 'multi download':
						width = 85;
						break;
					case 'isrc':
					case 'iswc':
						width = 120;
						break;
					case 'favorites':
						width = 70;
						break;
					case 'format':
						width = 60;//46;
						break;
					case 'added':
						width = 94;
						break;
					case 'track number':
						width = 30;
						break;
					case 'track count':
					case 'artist count':
					case 'label count':
					case 'project track count':
					case 'count':
						width = 85;
						break;
					case 'project total track count':
						width = 90;
						break;
					case 'project album count':
					case 'album count':
						width = 91;
						break;
					case 'album avatar':
					case 'artist avatar':
					case 'avatar':
					case 'catalog avatar':
					case 'composer avatar':
					case 'forced album avatar':
					case 'image':
					case 'label avatar':
					case 'music provider avatar':
					case 'music supplier avatar':
					case 'watermarked':
						width = 46;
						break;
					case 'large album art':
					case 'large music provider art':
					case 'large music supplier art':
						width = 100; // bc it's the first column, below code will add 20
						break;
					case 'user avatar':
						width = 36;
						break;
					case 'add to cart':
						width = 100;
						break;
					case 'date':
						width = 145;
						break;
					case 'project date published':
						width = 110;
						break;
					case 'type':
						width = 110;
						break;
					case 'clip':
					case 'history type':
						width = 70;
						break;
					case 'wang score':
						width = 60;
						break;
					case 'license now':
						width = 130;
						break;
					case 'runtime':
					case 'tracks':
						width = 50;
						break;
					case 'lastdetection':
					case 'detections':
					case 'progtype':
					case 'episodes':
					case 'channel':
						width = 100;
						break;
					case 'license price':
					case 'license view':
					case 'license date':
						width = 100;
						break;
					case 'see all':
					case 'more':
						width = 50;
						break;

				}
				if (!width) {
					if (colName == 'title' || colName == 'name' || colName == 'username' || colName == 'edit_user' || colName == 'multi_name' || colName == 'added_by') {
						colspans[currentCol - 1] = '<col />';
					}
					flexibleIndexes.push(currentCol - 1);
					continue;
				}
				// first and last get extra padding (enforced by css)
				if ((i == 0 && j == 0) || (i == len - 1 && j == jLen - 1)) {
					width += 20;
				}
				totalFixedWidth += width;
				colspans[currentCol - 1] = '<col style="width:' + width + 'px" class="lc_' + colName.replace(/ /g, '-') + '" />';
			}
		}
		// now we can figure out how much flex width we have
		var totalWidth = table.width(),
			widthLeft = totalWidth - totalFixedWidth,
			leftPercent = widthLeft / totalWidth * 100,
			percentPerFlexible = Math.floor(leftPercent / flexibleIndexes.length);
		// now apply them to those columns except the <col></col> one which will flex more
		for (let i = 0, len = flexibleIndexes.length; i < len; i++) {
			if (colspans[flexibleIndexes[i]]) continue;
			colspans[flexibleIndexes[i]] = '<col style="width:' + percentPerFlexible + '%" />';
		}
		if (!table.find('colgroup').length) table.prepend('<colgroup></colgroup>');
		table.find('colgroup').html(colspans.join(''));
		updateMaxCols();

		// update the header items so they have the right colspans
		var headerCols = table.find('.l_header th');
		for (let i = 0, len = Math.min(headerCols.length, columnList.length); i < len; i++) {
			let displayColumnCount = columnList[i].getVisibleDisplayColumns().length;
			if (displayColumnCount) {
				headerCols[i].colSpan = displayColumnCount;
			} else {
				$j(headerCols[i]).remove();
			}
		}
		table.find('.l_header th:first').addClass('left');
		table.find('.l_header th:last').addClass('right');
	};

	// update any columns that are supposed to span the whole width
	function updateMaxCols() {
		let table = list.table;
		if (table) {
			table.find('.max_cols').attr('colspan', table.find('colgroup:first col').length);
			table.find('.max_cols_minus_one').attr('colspan', table.find('colgroup:first col').length - 1);
		}
	}

	/**
	 * Highlights a track when it's playing
	 * @param {int} num the track's id
	 */
	this.highlightTrack = function (num) {
		if (this.view === 'mobile') {
			this.container
				.find('.list_block.selected')
				.removeClass('selected')
				.end()
				.find('#item_' + num)
				.addClass('selected');

			return;
		}

		if (!this.table) return;
		this.table.find('.lr.selected, .track_row.selected').removeClass('selected').end().find('#lr_' + num).addClass('selected');
	};

	/**
	 * Changes the response per page
	 * @param {int} r the new rpp
	 */
	this.setResultsPerPage = function (r) {
		this.resultsPerPage = r;
		if (this.conf.resultsPerPageCookie) {
			this.saveResultsPerPage();
		}
	};

	/**
	 * Saves the rpp into the cookie if cookie rpp is set in the config
	 */
	this.saveResultsPerPage = function () {
		if (!this.conf.resultsPerPageCookie) return;
		sa.cookies.setIfAllowed(sa.cookieTypes.preference, 'sa_rpp' + this.conf.listType + '_' + (ios ? 'ios_' : '') + (user.logged ? user.userData.id : 0), this.resultsPerPage, 86400 * 7);
	};

	/**
	 * Loads the rpp to use out of the cookie
	 */
	this.loadResultsPerPage = function () {
		if (!this.conf.resultsPerPageCookie) return;
		this.resultsPerPage = sa.cookies.get('sa_rpp' + this.conf.listType + '_' + (ios ? 'ios_' : '') + (user.logged ? user.userData.id : 0));
		if (!this.resultsPerPage) {
			if (ios && (this.conf.listType == 'track' || this.conf.listType == 'project_item' || this.conf.listType == 'cue_sheet')) {
				this.resultsPerPage = 10;
			} else if (ios) {
				this.resultsPerPage = 20;
			} else {
				this.resultsPerPage = this.conf.defaultResultsPerPage;
			}
		} else {
			this.saveResultsPerPage();
		}
	};

	/**
	 * Updates the view type for the track list
	 * @param {string} newView (block|list|wave)
	 */
	this.setView = function (newView, forceMobileView = false) {
		if (newView === this.view) return;

		const isMobile = sa.isMobile() || forceMobileView;
		if (
			newView === 'mobile'
			|| (newView === ListViewType.Block && this.conf.isViewTypeAllowed(ListViewType.Block))
			|| (newView === ListViewType.List && this.conf.isViewTypeAllowed(ListViewType.List))
			|| (newView === ListViewType.MiniBlock && this.conf.isViewTypeAllowed(ListViewType.MiniBlock))
		) {
			this.view = newView;
			if (!isMobile) {
				user.setView(this.conf.listType, newView);
			}

			// preserve the drop bar
			let dropBar = [];
			if (this.container) {
				dropBar = this.container.find('#drop_bar');
			}
			let dropBarPrevId = '';
			if (dropBar.length) {
				dropBarPrevId = dropBar.prev().prop('id');
				dropBar.detach();
			}


			// regenerate the page with the new data
			columnList = this.conf.getColumnList(newView);
			this.generatePage($j(this.container).html(''));
			this.setData(this.lastNewData, this.lastSourceLinkFunction, this.lastSourceOnClickFunction);

			// reattach the drop bar
			if (dropBar.length) {
				this.container.find('#' + dropBarPrevId).after(dropBar);
			}

			updateAlternatesHeight();
		}
	};

	/**
	 * Shows a track list under a row of this track list
	 * @param {function} listCreationFunction like createTrackList
	 * @param {JQuery} row one of the rows of this table. either a tbody or a tr
	 * @param {string} id a unique id for this sub list
	 * @param {TrackListConfig|ListConfig} config the config for the sub list
	 * @param {function} loadTracks a function that when called will load the tracks for this list
	 * 	the function will take two parameters - a function to which it'll pass the tracks once they're loaded and the sub track list
	 * @returns {List}
	 */
	this.showSubTrackList = function (listCreationFunction, row, id, config, loadTracks) {
		var trackList;
		var isMobile = sa.isMobile();

		var subListRow;
		if (isMobile) {
			subListRow = $j('<div id="alternates_' + id + '" class="alternates alternates_mobile loading"></div>')
		} else {
			subListRow = $j('<tr id="alternates_' + id + '" class="alternates_container_row"><td colspan="' + this.table.find('colgroup:first col').length + '" class="max_cols alternates_wave_fix">'
				+ '<div id="track_list_' + config.bankKey + id + '" class="track_list loading"></div></td></tr>');
			if (row.is('tbody')) {
				subListRow = $j('<tbody id="alternates_' + id + '" class="alternates_container_row"></tbody>').append(subListRow.removeAttr('id'));
			}

		}

		config.selectorConfig = this.conf.selectorConfig;

		trackList = listCreationFunction(config);
		if (isMobile) {
			trackList.generatePage(subListRow);
		} else {
			trackList.generatePage(subListRow.find('.track_list').get(0));
		}
		expandedTrackLists[expandedTrackLists.length] = trackList;

		// insert the container row. make sure it goes under waveform row if there is one
		row.after(subListRow);

		loadTracks(function (tracks, sourceLinkFunction, sourceOnClickFunction, parentViewType) {
			if (!sourceLinkFunction) {
				sourceLinkFunction = list.lastSourceLinkFunction;
			}
			if (!sourceOnClickFunction) {
				sourceOnClickFunction = list.lastSourceOnClickFunction;
			}

			if (tracks && Array.isArray(tracks)) tracks = tracks.map(t => {
				t.is_alternate = true
				return t
			})
			trackList.setData(tracks, sourceLinkFunction, sourceOnClickFunction, parentViewType);
			updateAlternatesHeight();
		}, trackList);

		updateAlternatesHeight();

		return trackList;
	};


	/**
	 * Shows a track list under a row of this track list (for mobile)
	 * @param {function} listCreationFunction like createTrackList
	 * @param {JQuery} row one of the rows of this table. either a tbody or a tr
	 * @param {string} id a unique id for this sub list
	 * @param {TrackListConfig|ListConfig} config the config for the sub list
	 * @param {function} loadTracks a function that when called will load the tracks for this list
	 * 	the function will take two parameters - a function to which it'll pass the tracks once they're loaded and the sub track list
	 * @returns {List}
	 */
	this.showSubTrackListMobile = function (listCreationFunction, row, id, config, loadTracks) {
		var trackList;

		console.log("creating track alternates list mobile")
		var subListRow = $j('<div id="alternates_' + id + '" class="alternates alternates_mobile loading"></div>')

		config.selectorConfig = this.conf.selectorConfig;

		trackList = listCreationFunction(config);
		trackList.generatePage(subListRow);
		expandedTrackLists[expandedTrackLists.length] = trackList;

		// insert the container row. make sure it goes under waveform row if there is one
		row.after(subListRow);

		loadTracks(function (tracks, sourceLinkFunction, sourceOnClickFunction) {
			if (!sourceLinkFunction) {
				sourceLinkFunction = list.lastSourceLinkFunction;
			}
			if (!sourceOnClickFunction) {
				sourceOnClickFunction = list.lastSourceOnClickFunction;
			}
			trackList.setData(tracks, sourceLinkFunction, sourceOnClickFunction);
			updateAlternatesHeight();
		}, trackList);

		updateAlternatesHeight();

		return trackList;
	};

	/**
	 * Hides the an open sub track list
	 * @param {int} id the unique id of the source row
	 * @param {function=} onClose function call after closing
	 */
	this.hideSubTrackList = function (id, onClose) {
		var altContainer = $j('#alternates_' + id);
		altContainer.find('.track_list:first').addClass('loading').css({ height: 0 });
		setTimeout(function () {
			altContainer.remove();
			cleanExpandedTrackLists();
			updateAlternatesHeight();
			if (onClose) {
				onClose();
			}
		}, 200);
	};

	/**
	 * Shows the alternate versions of a track
	 * @param {object} track the track to show versions for
	 * @param {HTMLElement} a the button the user clicked
	 */
	this.showAlternates = function (track, a) {
		var config = getAlternateTrackListConfig(this.view);

		config.bankKey += track.id;
		config.disableLinks = this.conf.disableLinks;
		config.extraLoadVars = this.conf.extraLoadVars;
		config.selectorConfig = this.conf.selectorConfig;
		config.commentLoadVars = this.conf.commentLoadVars;
		config.commentSaveVars = this.conf.commentSaveVars;

		if (this.conf.commentLoadVars) {
			config.extraLoadVars = (config.extraLoadVars ? config.extraLoadVars + '&' : '')
				+ 'commentLoadParameters=' + JSON.stringify(this.conf.commentLoadVars);
		}

		var container;
		if (this.view == ListViewType.Mobile && this.blocks) {
			container = this.blocks.find('#item_' + track.id);
		} else {
			container = this.table.find('#lr_' + track.id);
		}

		list.showSubTrackList(createTrackList, container, track.id, config, (setData) => {
			if (!sa.components.leftNav.trackFiltersAreActive()) {
				sa.components.leftNav.reset();
			}

			const reloadedTrackListRoute = reloadTrackListRoute(true, 'tracks');

			let uniqueIdSearchQuery = sa.router.extractUniqueIdFromPath(reloadedTrackListRoute);
			uniqueIdSearchQuery = uniqueIdSearchQuery ? '&' + uniqueIdSearchQuery : '';

			['sonicsearch', 'details'].forEach(pageName => {
				if (sa.getCurrentPageName() === pageName) {
					uniqueIdSearchQuery = '';
				}
			});

			const parentViewType = list.view;

			let query = 'p=track_info&showAll=1&'
			+ (config.extraLoadVars ? config.extraLoadVars + '&' : '')
			+ (list.pageVars.indexOf('useMetaPermissionProfile') !== -1 ? '&useMetaPermissionProfile=1' : '')
			+ uniqueIdSearchQuery
			+ '&alt=' + track.id;

			query = query.replace(/&{2,}/, '&');

			ajax(query, data => {
				setData(data, undefined, undefined, parentViewType);
			});
		});

		$j(a).off('click').on('click', function () {
			list.hideAlternates(track, a);
			this.blur();
			return false;
		}).html('-' + (track.alternateCount ? track.alternateCount : track.alternates.length));
	};

	function updateAlternatesHeight(recursed) {
		$j('.alternates_container_row .track_list, .alternates_mobile').reverse().each(function (i, alternatesRow) {
			var a = $j(alternatesRow);
			if (a.hasClass('loading') && a.find('.track_row').length > 0) {
				a.removeClass('loading');
			}
			var totalHeight = 0;
			a.find('> *').each(function () {
				var id = this.id;
				if (id == '' || id == 'track_list_cover' || id == 'track_list_cover_loader') return;
				totalHeight += $j(this).outerHeight();
			});
			alternatesRow.style.height = totalHeight + 'px';
			if (!recursed) {
				// sometimes the elements haven't finished css transitioning by the time this function is called
				setTimeout(function () {
					updateAlternatesHeight(true);
				}, 150); // 150 is the movement transition time @movementTransition
			}
		});
	}

	this.updateAlternatesHeight = updateAlternatesHeight;

	/**
	 * Hides the alternate versions of a track
	 * @param {object} track the track to hide versions for
	 * @param {HTMLElement} a the button the user clicked
	 */
	this.hideAlternates = function (track, a) {
		list.hideSubTrackList(track.id, function () {
			$j(a).off('click').on('click', function () {
				list.showAlternates(track, this);
				this.blur();
				return false;
			}).html('+' + (track.alternateCount ? track.alternateCount : track.alternates.length));
		});
	};

	/**
	 * Shows the tracks associated with an album (or download?)
	 * @param {int} itemId the id of the item
	 * @param {Object} type extra information used to format the expanded track list
	 *  Currently features these params:
	 *   - parent - the parent of the new expanded container (if not specified, looks for #lr_{itemId}
	 *   - name - the type of item that's being expanded (project|cue_sheet|tag|track|album)
	 *   - stripe - should we preserve the stipe color of the parent? (undefined same as true)
	 *   - id - same as itemId
	 */
	this.expandTracks = function (itemId, type) {
		var row = type.parent ? type.parent : $j('#lr_' + itemId);
		let expandedConf = new TrackListConfig();
		let len = expandedTrackLists.length;
		let container;
		let trackList;
		let view = '';
		let useMetaPermissionProfile = (this.conf.listType === 'project_item' || this.useMetaPermissionProfile) ? '&useMetaPermissionProfile=1' : ''; // needed with multi-mafs so you can see the tracks that are outside your current MAF
		if (type.name == 'project') {
			type.name = 'project_item';
		}
		expandedConf.affectFilters = false;
		expandedConf.bankKey = 'profile_downloads_' + itemId;
		expandedConf.callback = function (data) {
			let playListIsDeleted = Array.isArray(data) && data[0].project === null;
			if (playListIsDeleted) {
				$j('#expanded_container_' + itemId).remove();
				sa.alert('This playlist has been deleted.');
				return;
			}
			if (expandedTrackLists.length <= len) {
				expandedTrackLists[len] = { manager: { setTracks: function () { expandedTrackLists.splice(len, 1); } } };
			}
			expandedTrackLists[len].manager.setTracks(data);
		};
		expandedConf.commentLoadVars = this.conf.commentLoadVars;
		expandedConf.commentSaveVars = this.conf.commentSaveVars;
		expandedConf.useStandardColumnList();
		expandedConf.defaultResultsPerPage = 5;
		expandedConf.disableLinks = this.conf.disableLinks;
		expandedConf.extraLoadVars = this.conf.extraLoadVars;
		expandedConf.pagination = true;
		expandedConf.resultCountChanging = false;
		expandedConf.resultsPerPageCookie = false;
		expandedConf.selectorConfig = this.conf.selectorConfig;
		expandedConf.sortable = false;
		expandedConf.topBar = true;
		expandedConf.viewCookie = false;
		if (this.conf.listType == 'project_item') {
			view = expandedConf.defaultView = this.view;
			if (this.view == ListViewType.List) {
				expandedConf.allowList = true;
				expandedConf.allowBlock = true;
				expandedConf.allowMiniBlock = true;
				expandedConf.viewCookie = true;
			} else {
				expandedConf.allowList = true;
				expandedConf.allowBlock = true;
				expandedConf.allowMiniBlock = true;
				expandedConf.viewCookie = true;
			}
		} else {
			expandedConf.allowList = true;
			expandedConf.allowBlock = true;
			expandedConf.allowMiniBlock = true;
			expandedConf.viewCookie = true;
		}

		if (this.conf.commentLoadVars) {
			expandedConf.extraLoadVars = (expandedConf.extraLoadVars ? expandedConf.extraLoadVars + '&' : '')
				+ 'commentLoadParameters=' + JSON.stringify(this.conf.commentLoadVars);
		}

		trackList = (type.name == 'project_item') ? createProjectItemList(expandedConf) : (type.name == 'cue_sheet') ? createCueSheetList(expandedConf) : createTrackList(expandedConf);
		if (view) trackList.view = view;
		expandedTrackLists[expandedTrackLists.length] = trackList;
		container = $j('<div id="expanded_' + itemId + '" class="expanded_container' + (!(type.stripe == false) && row.hasClass('stripe') ? ' stripe' : '') + '"><div id="'
			+ (type.name == 'project_item' ? 'project' : (type.name == 'cue_sheet' ? 'cue_sheet' : 'track')) + '_list_' + expandedConf.bankKey + '" class="track_list loading"></div></div>');
		console.log('view is ' + this.view + ' and type is ' + type.name);
		if (this.view == ListViewType.List || (this.conf.listType == 'project_item' && type.name == 'track')) {
			container = $j('<tr id="expanded_container_' + itemId + '" class="alternates_container_row"></tr>').append($j('<td class="max_cols" colspan="' + this.table.find('colgroup:first col').length + '"></td>').append(container));
		} else {
			container.addClass('alternates_container_row');
		}
		if ((this.view == ListViewType.Block && type.name == 'album') || (this.view == ListViewType.MiniBlock && type.name == 'album')) {
			// expand inside instead of after
			$j('#item_' + itemId).append(container);
		} else {
			row.after(container);
		}
		trackList.generatePage(container.find('.track_list').get(0));

		/**
		 * We're creating a new, anonymous object to manage this track list
		 * We have to do this because when the user clicks the next button on a track list, we need to know which
		 * track list to advance. The TrackList accepts a function to call on page change but that function won't
		 * know which list it's supposed to be operating on. So what we do, is create a function with its own scope
		 * and that scope contains a variable that has the track list. It's all about anonymous functions
		 * being able to access some variables
		 *
		 * This code is all stolen and modified from the project page
		 */
		trackList.manager = {
			type: type, trackList: trackList, rpp: expandedConf.defaultResultsPerPage, first: true,
			/**
			 * Sets the tracks of the project after they're loaded on the server
			 * @param {Array.<ListMetaData|JSON>} newData the track data
			 */
			setTracks: function (newData) {
				/**
				 * We create the "next page" function, func, within its own scope so it can get to the manager
				 * By passing "this" into the unnamed anonymous function, js creates an internal scope around
				 * func and when "next page" is clicked, func still has that scope that includes the manager, o
				 */
				(function (o) {
					function func(vars) {
						o.loadPage(vars);
						return false;
					}
					o.trackList.setData(newData, function () { return getDefaultLink(); }, func);
					if (o.first) {
						o.first = false;
					}
					updateAlternatesHeight();
				})(this);
			},
			/**
			 * Calls the load to actually commence loading the next page's data
			 * @param {int} page the page to load
			 */
			loadPage: function (page) {
				if (this.type.name == 'album') {
					this.trackList.loadPage('b=' + this.type.id + '&show=' + this.rpp + '&pg=' + page + useMetaPermissionProfile);
				} else if (this.type.name == 'project_item') {
					this.trackList.loadPage('projectId=' + this.type.id + '&show=' + this.rpp + '&pg=' + page + '&forwardOverride=1' + useMetaPermissionProfile);
				} else if (this.type.name == 'cue_sheet') {
					this.trackList.loadPage('cueSheetId=' + this.type.id + '&show=' + this.rpp + '&pg=' + page + '&forwardOverride=1' + useMetaPermissionProfile);
				} else if (this.type.name == 'track') {
					this.trackList.loadPage('ids[]=' + this.type.id + '&show=' + this.rpp + '&pg=' + page + useMetaPermissionProfile);
				} else if (this.type.name == 'alt') {
					this.trackList.loadPage('alt=' + this.type.id + '&includeMaster=1&show=' + this.rpp + '&pg=' + page + useMetaPermissionProfile);
				}
			}
		};
		trackList.manager.loadPage(0);
		updateAlternatesHeight();
	};

	/**
	 * Hides the alternate versions of a track
	 * @param {int} itemId the id of the item
	 */
	this.hideTracks = function (itemId) {
		var altContainer = $j('#expanded_' + itemId + ', #expanded_container_' + itemId);
		altContainer.find('.track_list:first').addClass('loading').css({ height: 0 });
		setTimeout(function () {
			altContainer.remove();
			cleanExpandedTrackLists();
			updateAlternatesHeight();
		}, 200);
	};

	/**
	 * Moves an item up or down in the list
	 * @param {int} itemId the id of the item to move
	 * @param {string} itemType is it a Track or an Album?
	 * @param {int} direction -1 to move up, 1 to move down
	 */
	this.reorder = function (itemId, itemType, direction) {

		// visually reorder
		var row = $j('.lr_' + itemType + '#lr_' + itemId + (itemType == 'album' || itemType == 'project' ? ', #item_' + itemId : ''));
		// if we're moving the item over a page boundary, we need to reload to get the replacement item
		var meta = (this.lastNewData && this.lastNewData.length) ? this.lastNewData[0] : null;
		var reloadRequired = false;
		var rowToSwap;
		var swapRow;
		if (direction == 1) { // down
			rowToSwap = row.nextAll('.lr, .project_item_detailed, .project_detailed').filter(':first');
			reloadRequired = (!rowToSwap.length && meta && (meta.page + 1) * meta.perPage < meta.count);
			swapRow = function () { rowToSwap.after(row); }
		} else { // up
			rowToSwap = row.prevAll('.lr, .project_item_detailed, .project_detailed').filter(':first');
			reloadRequired = (!rowToSwap.length && meta && meta.page > 0);
			swapRow = function () { rowToSwap.before(row); }
		}
		stripe(this.container.get(0));

		// animate reorder
		if (!reloadRequired && rowToSwap.length) {
			var marginTop = getMarginPixels(row[0], 'top'); // position doesn't account for margins
			var rowToSwapPosition = rowToSwap.position().top;
			var rowPosition = row.position().top;
			var rows = $j(row).add(rowToSwap);
			// to animate, we move them into the right position in the list and then offset them back to where they were previously, animating to their new position
			rows.addClass('transitions_disabled'); // don't animate the offset back
			// move them into the right position
			swapRow();
			// offset back
			if (rowPosition < rowToSwapPosition) {
				row.css({ top: (0 - rowToSwap.outerHeight(true) + marginTop) + 'px' });
				rowToSwap.css({ top: (row.outerHeight(true) - marginTop) + 'px' });
			} else {
				row.css({ top: (rowToSwap.outerHeight(true) - marginTop) + 'px' });
				rowToSwap.css({ top: (0 - row.outerHeight(true) + marginTop) + 'px' });
			}
			// without set timeout, transitions_disabled doesn't work right. you see a pop
			setTimeout(function () {
				rows.removeClass('transitions_disabled');
				// move to new position
				rows.css({ top: 0 });
			}, 100);
		}

		// reorder on backend
		function handleReorder() {
			console.log('handle reorder with', reloadRequired, 'as reload required');
			if (reloadRequired) {
				sa.router.reloadPage();
			}
		}
		if (this.conf.listType == 'project_item') {
			ajax('projectId=' + sa.pages.projectItemList.project.id + '&' + itemType + 'Id=' + itemId + '&direction=' + direction, handleReorder, 'POST', 'p=projects&action=reorder');
		} else if (this.conf.listType == 'cue_sheet') {
			ajax('cueSheetId=' + sa.pages.cueSheet.cueSheet.id + '&' + itemType + 'Id=' + itemId + '&direction=' + direction, handleReorder, 'POST', 'p=cue_sheets&action=reorder');
		} else if (this.conf.listType == 'project') {
			ajax('projectId=' + itemId + '&direction=' + direction, handleReorder, 'POST', 'p=projects&action=reorder_published');
		} else {
			console.log('not sure how to reorder ' + itemType);
		}

	};

	/**
	 * Saves the order of the current page
	 */
	this.saveSort = function () {
		var order = [],
			items = this.container.find('.lr[id^=lr_]:not(.lr_import_track), .lr_album, .track_row:not(.import_track_row), .album_row'),
			pageVars = this.lastNewData[0];
		for (var i = 0, len = items.length; i < len; i++) {
			var item = $j(items[i]),
				itemType = (item.hasClass('lr_album') || item.hasClass('list_detailed')) ? 'album' : 'track',
				itemId = (itemType == 'album' && !item.attr('id') ? item.find('.list_detailed') : item).attr('id').match(/(?:lr_|item_)([0-9]+)/)[1];
			order.push({ type: itemType, id: itemId });
		}
		this.trigger('reorder', order, pageVars.page, pageVars.perPage);
	};

	var enableSortToPage = true;

	/**
	 * Moves an item to another page
	 * @param {string} itemType (track|album)
	 * @param {int} itemId the id of the item we're moving
	 * @param {string} direction "next" for next page, "prev" for prev
	 */
	this.sortToPage = function (itemType, itemId, direction) {
		if (!enableSortToPage) return;
		var dataString,
			pageVars = this.lastNewData[0];
		dataString = '&itemId=' + itemId + '&itemType=' + itemType + '&direction=' + (direction == 'next' ? 1 : -1) + '&page=' + pageVars.page + '&perPage=' + pageVars.perPage;
		if (this.conf.listType == 'project_item') {
			enableSortToPage = false;
			ajax('projectId=' + sa.pages.projectItemList.project.id + dataString, function () { enableSortToPage = true; sa.router.reloadPage(); }, 'POST', 'p=projects&action=reorder_to_page');
		} else {
			console.log('not sure how to sort to page');
		}
	};


	this.sizeForMobile = function () {
		var mobileView = this.conf.getMobileView()
		if (mobileView) {
			this.setView(mobileView)
		} else {
			var newView = this.conf.getDefaultView();
			if (!this.conf.isViewTypeAllowed(newView)) {
				newView = ListViewType.Block;
			}
			this.setView(newView);
		}
	}

}

function cleanExpandedTrackLists() {
	for (var i = 0; i < expandedTrackLists.length; i++) {
		if (!$j('#track_list_' + expandedTrackLists[i].conf.bankKey + ', #project_list_' + expandedTrackLists[i].conf.bankKey + ', #cue_sheet_list_' + expandedTrackLists[i].conf.bankKey).length) {
			expandedTrackLists.splice(i, 1);
			i--;
		}
	}
}

function MetaTrackList(trackLists) {
	this.trackLists = trackLists;

	this.highlightTrack = function (id) {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].highlightTrack(id);
		}
	};

	this.hideExpanded = function () {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].hideExpandedActual();
		}
	};

	this.stopExpandedTimer = function () {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].stopExpandedTimer();
		}
	};

	this.hideExpandedActual = function () {
		this.hideExpanded();
	};

	this.setResultsPerPage = function (a) {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].setResultsPerPage(a);
		}
	};

	this.enableNesters = function () {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].enableNesters();
		}
	};

	this.enableQuickProjects = function () {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].enableQuickProjects();
		}
	};

	this.enableQuickCueSheets = function () {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].enableQuickCueSheets();
		}
	};

	this.disableQuickProjects = this.disableNesters = function () {
		for (var i = 0; i < this.trackLists.length; i++) {
			this.trackLists[i].disableQuickProjects();
		}
	};
}

/**
 * Stripes a list
 * @param {HTMLElement|JQuery} elem a container of the tr's to stripe
 */
function stripe(elem) {
	var e = $j(elem);
	e.find('.lr, .wave_row, .list_detailed').removeClass('stripe');
	e.find('.list_detailed').addClass('lr');
	e.find('.lr:not(:first):not(.wave_row):even').addClass('stripe');
	e.find('.list_detailed').removeClass('lr');
	//$j('.list_detailed:odd', $j(elem)).addClass('stripe');
}
/**
 * sa.forms provides some utility functions to make forms prettier and and easier to use/code
 * 	Note: Does not interact with or require a <form> element. Just works with input, select, and textareas
 *
 * Let's say you have a container with some form elements
 * <div>
 *     <div class="input_container">
 *         <label for="name_input_id">Enter your name*</label>
 *         <input type="text" id="name_input_id" name="name" required="required" minlength="2" maxlength="20" />
 *         <sub>Between 2 and 20 characters</sub>
 *     </div>
 *     <div class="input_container">
 *         <label for="email_input_id">Enter your email*</label>
 *         <input type="email" id="email_input_id" name="email" required="required" />
 *     </div>
 * </div>
 *
 * To show an email search drop down, give a textarea class smart_email_input
 * To show a toggle instead of a checkbox, give an input[type=checkbox] class toggle
 * To control the filetypes selectable by an input[type=file], add data-filetype="images"
 * To create a selectize, create a select with data-selectize="selectize"
 * 	Specify the source data list with data-list="artist"
 * 	To allow creation of new items, use data-create="create"
 *	To allow multiple item selection, use multiple="multiple"
 */
sa.forms = (function () {

	var forms = {
		validationErrors: {
			required: 1,
			matches: 2,
			minlength: 3,
			maxlength: 4,
			email: 5
		}
	};

	/**
	 * Class returned from validateInput
	 * @param {JQuery} input
	 */
	forms.validationResult = function (input) {

		var result = this;

		/** @var {JQuery} */
		result.input = input;

		/** @var {string|array} */
		result.value = input.val();

		/** @var {string} */
		result.name = input.attr('name');

		/** @var {string} */
		result.error = '';

		/** @var {string} */
		result.errorDetail = '';

		/** @var {JQuery} */
		result.inputContainer = input.closest('.input_container');

		/** @var {string} */
		result.labelName = result.inputContainer.find('label').html();
		if (result.labelName === undefined) {
			result.labelName = '';
		}

		/** @var {Uploader} */
		result.uploader = null;

		/**
		 * Shows an error message in the input container
		 * @param {string} errorMessage
		 * @param {boolean=} scrollTo
		 */
		result.showError = function (errorMessage, scrollTo) {
			showMessage(errorMessage, scrollTo, 'failed_validation');
		};

		/**
		 * Shows a success message in the input container
		 * @param {string} successMesage
		 * @param {boolean=} scrollTo
		 */
		result.showSuccess = function (successMesage, scrollTo) {
			showMessage(successMesage, scrollTo, 'passed_validation');
		};

		function showMessage(message, scrollTo, validationClass) {
			var instructionsElement = result.inputContainer.find('sub');
			var originalValue = instructionsElement.data('originalValue');
			var currentValue = instructionsElement.html();
			result.inputContainer.addClass(validationClass);
			if (message && message != currentValue) {
				if (originalValue === undefined) {
					instructionsElement.data('originalValue', currentValue);
				}
				setInstructionsElementContent(instructionsElement, message, currentValue);
			}

			if (scrollTo) {
				result.scrollTo();
			}
		}

		/**
		 * Scrolls the window or focus box to the field
		 */
		result.scrollTo = function () {
			var topErrorInputParent = result.inputContainer;
			var containerFocusBox = topErrorInputParent.parents('.focused_content_actual');
			if (containerFocusBox.length) {
				var relativeOffset = parseInt(getComputedStyle(containerFocusBox[0]).getPropertyValue('padding-top'));
				relativeOffset += topErrorInputParent.offset().top;
				for (var currentElement = topErrorInputParent, foundElement = currentElement.hasClass('focused_content_actual'), parentElement; !foundElement; currentElement = parentElement) {
					parentElement = currentElement.parent();
					if (parentElement.hasClass('focused_content_actual')) {
						relativeOffset -= currentElement.offset().top;
						foundElement = true;
					} else if (!parentElement.length) {
						foundElement = true; // this should never happen but prevent infinite loop
					}
				}
				containerFocusBox.animate({ scrollTop: relativeOffset }, 500);
			} else {
				sa.scrollToElement(topErrorInputParent);
			}
		};

		/**
		 * Removes the error state from the field
		 */
		result.hideError = function () {
			hideMessage('failed_validation');
		};

		/**
		 * Removes the success state from the field
		 */
		result.hideSuccess = function () {
			hideMessage('passed_validation');
		};

		function hideMessage(validationClass) {
			var instructionsElement = result.inputContainer.find('sub');
			var originalValue = instructionsElement.data('originalValue');
			var currentValue = instructionsElement.html();
			result.inputContainer.removeClass(validationClass);
			if (originalValue === undefined) {
				originalValue = '';
			}
			if (currentValue != originalValue) {
				setInstructionsElementContent(instructionsElement, originalValue, currentValue);
			}
		}

		(function () {

			var required = input.attr('required');
			var matches = input.attr('matches');
			var minLength = input.attr('minlength');
			var maxLength = input.attr('maxlength');
			var notrim = input.attr('notrim');
			var inputType = input.attr('type');

			if (inputType == 'checkbox') {
				result.value = input.filter(':checked').length ? result.value : '';

				if (!notrim) {
					result.value = result.value.trim();
				}
			} else if (inputType == 'file') {
				result.uploader = result.inputContainer.data('uploader');
				result.name = result.inputContainer.data('inputName');
				return;
			} else if (input.data('selectize') && input[0]['getSelectizeVal']) {
				result.value = input[0].getSelectizeVal(!notrim);
			}

			if (input.data('defaultClass')) {
				result.value = input.data('defaultClass').valToSave
				// console.log("val to save for default", result.name, result.value)
			}

			if (!result.name) {
				return;
			}

			function validateValue(testValue) {
				var errorFieldName = (result.labelName.length < 20 ? result.labelName : 'This field');
				if (required && !testValue) {
					result.error = forms.validationErrors.required;
					result.errorDetail = errorFieldName + ' is required.';
				} else if (matches && testValue && !testValue.match(new RegExp(matches))) {
					result.error = forms.validationErrors.matches;
				} else if (minLength !== undefined && (testValue === undefined || testValue.length < minLength)) {
					result.error = forms.validationErrors.minlength;
					result.errorDetail = errorFieldName + ' must be at least ' + minLength + ' characters.';
				} else if (maxLength !== undefined && testValue.length > maxLength) {
					result.error = forms.validationErrors.maxlength;
					result.errorDetail = errorFieldName + ' must be at most ' + maxLength + ' characters.';
				} else if (inputType == 'email' && testValue && !testValue.isEmail()) {
					result.error = forms.validationErrors.email;
					result.errorDetail = errorFieldName + ' is not a valid email address.';
				}
			}

			var testValue = result.value;

			if (testValue !== null && testValue.isArray) {

				if (required && !testValue.length) {
					result.error = forms.validationErrors.required;
					result.errorDetail = result.labelName + ' is required.';
				} else {
					for (var t = 0, tLen = testValue.length; !result.error && t < tLen; t++) {
						var singleValue = testValue[t];
						if (typeof singleValue == 'object' && singleValue.name !== undefined) {
							validateValue(singleValue.name);
						} else if (typeof singleValue != 'object') {
							validateValue(singleValue);
						}
					}
				}

			} else if (testValue !== null && typeof testValue == 'object') {

				if (testValue['name']) {
					validateValue(testValue['name']);
				}

			} else {

				validateValue(testValue);

			}

			if (result.error) {
				result.showError(result.errorDetail, false);
			} else {
				result.hideError();
			}

		})();
	};

	function setInstructionsElementContent(instructionsElement, content, currentValue) {
		if (content == currentValue) return;
		let contentTimeout = instructionsElement.data('content-timeout');
		if (contentTimeout) {
			// since the content is cleared on a timeout, subsequent calls to this function need to disable the clear
			clearTimeout(contentTimeout);
			instructionsElement.data('content-timeout', 0);
		}
		if (content == '') {
			instructionsElement.addClass('empty');
			instructionsElement.removeAttr('style');
			instructionsElement.data('content-timeout', setTimeout(function () {
				instructionsElement.html(content);
			}, 150));
		} else {
			instructionsElement.addClass('for_measuring');
			instructionsElement.html(content);
			var newHeight = instructionsElement.outerHeight();
			instructionsElement.addClass('disabled_transitions').removeClass('for_measuring');
			setTimeout(function () {
				instructionsElement.removeClass('disabled_transitions');
				setTimeout(function () {
					instructionsElement.removeClass('empty');
					instructionsElement.css({ height: newHeight });
				}, 10);
			}, 10);
		}
	}

	forms.update = function (element) {
		if (!element || !element.length) return;
		var type = element[0].tagName;
		if (type == 'TEXTAREA') {
			element.trigger('input');
			element.trigger('change');
		} else if (type == 'INPUT') {
			element.trigger('change');
		}
	};

	/**
	 * Sets up dynamic form elements within an element
	 * @param {JQuery} container
	 * @param {Object=} options
	 * 	@property {boolean} realTimeValidation should we validate as the user types? (default true)
	 * 	@property {function} realTimeValidationCallback function passed real time validation results
	 * 	@property {function} submitCallback function that's called if the form is submitted. triggers on an "enter" press in a text input or on clicks for any elements with class "button submit"
	 */
	forms.init = function (container, options) {

		options = $j.extend({
			realTimeValidation: true,
			realTimeValidationCallback: function () { },
			submitCallback: function () { }
		}, options);

		container.find('.input_container').each(function (index, inputContainer) {
			inputContainer = $j(inputContainer);
			var input = inputContainer.find('input, textarea, select');
			if (!input.length) {
				console.warn('sa.forms.init found an input_container without an input');
				return;
			}
			var type = input[0].tagName;
			inputContainer.off('.forms');


			// dont save default logic
			if (inputContainer.hasClass('dont_save_default')) {
				const inputDefaultClass = new InputWithDefault(input, inputContainer, input.data('default'), input.data('saved'))
				input.data('defaultClass', inputDefaultClass)
				console.log("input", input, input.data('defaultClass'))

			}

			if (type == 'TEXTAREA' || type == 'INPUT') {
				var inputType = 'textarea';
				if (type == 'TEXTAREA') {
					let inputElement = input[0];
					let setHeight = function () {
						inputElement.style.height = '0px';
						inputElement.style.height = (inputElement.scrollHeight) + 'px';
					};
					// RAC 2020-07-29 while working on the contact form for the site manager, the textarea wouldn't size right on initial load.
					// it was always too big. using the input event's function to set the initial height instead of just setting it to scrollHeight worked
					// I'm leaving this note here in case it breaks other things
					// input.css({ height : input[0].scrollHeight });
					setHeight();
					input.on('input', setHeight);
					if (input.hasClass('smart_email_input')) {
						initSmartEmailInput(input);
					}
					inputContainer.on('formsVisibilityChange.forms', function () {
						setHeight();
					});
				} else {
					inputType = input.attr('type');
					if (inputType == 'checkbox' && input.hasClass('toggle')) {
						initCheckbox(input, inputContainer);
					} else if (inputType == 'radio') {
						initRadio(input, inputContainer);
					} else if (inputContainer.hasClass('color_input_container')) {
						initColorPicker(input, inputContainer)
					} else if (inputType == 'file') {
						initFile(input, inputContainer);

						// Image focus selectors are both a file and the focus selector
						if (inputContainer.hasClass('image_focus_selector_container')) {
							initImageFocusSelector(input, inputContainer.parent('.image_focus_selector_wrapper'))
						}
					} else if (inputType == 'date') {
						inputContainer.addClass('with_value');
					} else if (input.hasClass('percent')) {
						initPercent(input, inputContainer)
					} else if (options.submitCallback) {
						input.on('keypress', function (e) {
							if (!e || !e['keyCode'] || e.keyCode !== 13) {
								return true;
							}
							options.submitCallback();
							return false;
						});
					}
				}
				if (inputType != 'radio') {
					input.on('focus', function () {
						inputContainer.addClass('focused');
					});
					input.on('blur', function () {
						inputContainer.removeClass('focused');
					});
					if (inputType != 'date' && inputType != 'file') {
						input.on('change', function () {
							if (this.value || input.css('transitionDelay') == '9999s') {
								inputContainer.addClass('with_value');
							} else {
								inputContainer.removeClass('with_value');
							}
						});
						input.trigger('change');
					}
				}
			} else if (type == 'SELECT') {
				initSelect(input, inputContainer);
			}

			if (input[0].required) {
				inputContainer.addClass('input_required');
			}

			var sub = inputContainer.find('sub');
			if (sub.length) {
				var subContent = sub.html();
				if (subContent) {
					sub.data('originalValue', subContent);
					addAttachmentEventListener(container, function () {
						setInstructionsElementContent(sub, subContent, '');
					});
					inputContainer.on('formsVisibilityChange.forms', function () {
						setInstructionsElementContent(sub, sub.html(), '');
					});
				} else {
					sub.addClass('empty');
				}
			} else {
				inputContainer.append('<sub class="empty"></sub>');
			}

			if (options.realTimeValidation) {
				initRealTimeValidation(input, inputContainer, options);
			}
		});

		if (options.submitCallback) {
			container.find('.button.submit').on('click', options.submitCallback);
		}

		addAttachmentEventListener(container, function (alreadyAttached) {
			if (!alreadyAttached) {
				container.find('textarea').data('attachCheckerTriggered', 1).trigger('input');
			}
		});

	};

	/**
	 * Creates a listener that will fire once the container has been attached to the page
	 * @param {JQuery} container
	 * @param {function} callback receives a boolean parameter indicating if the container was already attached
	 */
	function addAttachmentEventListener(container, callback) {
		if (!isAttached(container)) {
			var attachChecker = function () {
				if (!isAttached(container)) {
					return setTimeout(function () {
						attachChecker();
					}, 100);
				}

				callback(false);
			};

			attachChecker();
		} else {
			callback(true);
		}
	}

	/**
	 * Checks if an element is attached and visible (not display hidden)
	 * @param {JQuery} element
	 * @returns {boolean}
	 */
	function isAttached(element) {
		return !!(element.length && element[0].offsetParent !== null && element.parents('body').length);
	}

	function initImageFocusSelector(input, inputContainer) {
		// bind the setFocusPosition with the inputContainer variable so we can set it
		// on the actual HTML element
		const setFocusPosition = (function(inputContainer) {
			var $selector = inputContainer.find(".image_focus_selector")
			return function(percX, percY) {
				if (!$selector.hasClass('show')) {
					$selector.addClass('show')
				}
				// make sure percent
				percX = parseInt(percX) + '%'
				percY = parseInt(percY) + '%'
	
				$selector.css({
					top: percY,
					left: percX,
				})
				inputContainer.find('input[name="bannerImage[focusX]"]').val(percX)
				inputContainer.find('input[name="bannerImage[focusY]"]').val(percY)
			}
		})(inputContainer);

		inputContainer.on('click', '.valid_image', function (e) {
			var rect = e.currentTarget.getBoundingClientRect();
			var x = e.clientX - rect.left; //x position within the element.
			var y = e.clientY - rect.top;  //y position within the element.
			var percX = Math.floor((x / e.currentTarget.clientWidth) * 100) + '%'
			var percY = Math.floor((y / e.currentTarget.clientHeight) * 100) + '%'
			setFocusPosition(percX, percY)
		})

		// this is triggered when image changes
		inputContainer.on('focusposition', function(e, x, y) {
			setFocusPosition(x, y)
		})


		if (inputContainer.data('value')) {
			const {percX, percY} = inputContainer.data('value');
			if (percX || percY) {
				setFocusPosition(percX, percY)
			}
		}

	}
	function initPercent(input, inputContainer) {
		//Get human input: 
		input.on('input', function (e) {
			//Separate the percent sign from the number:
			let int = e.target.value.slice(0, e.target.value.length - 1);

			/* If there is no number (just the percent sign), rewrite
			   it so it persists and move the cursor just before it.*/
			if (int.includes('%')) {
				e.target.value = '%';
			}
			/* If the whole has been written and we are starting the
			   fraction rewrite to include the decimal point and percent 
			   sign. The fraction is a sigle digit. Cursor is moved to 
			   just ahead of this digit.*/
			else if (int.length >= 3 && int.length <= 4 && !int.includes('.')) {
				e.target.value = int.slice(0, 2) + '.' + int.slice(2, 3) + '%';
				e.target.setSelectionRange(4, 4);
			}
			/* If the we have a double digit fraction we split up, format it
			   and print that. Cursor is already in the right place.*/
			else if (int.length >= 5 & int.length <= 6) {
				let whole = int.slice(0, 2);
				let fraction = int.slice(3, 5);
				e.target.value = whole + '.' + fraction + '%';
			}
			/* If we're still just writing the whole (first 2 digits), just 
			   print that with the percent sign. Also if the element has just
			   been clicked on we want the cursor before the percent sign.*/
			else {
				e.target.value = int + '%';
				e.target.setSelectionRange(e.target.value.length - 1, e.target.value.length - 1);
			}
			console.log(getInt(e.target.value));
		});

		/* For consuption by robots, the number is best written as an 
		   interger, so we do that remembering it contains 2 or less
		   decimal places*/
		function getInt(val) {
			//So as not to breakup a potential fraction
			let v = parseFloat(val);
			//If we only have the whole:
			if (v % 1 === 0) {
				return v;
				//If the numberis a fraction  
			} else {
				let n = v.toString().split('.').join('');
				return parseInt(n);
			}
		}
	}

	function initColorPicker(input, inputContainer) {
		var data = input.data();
		if (data['value']) {
			input.val(data['value'])
		}
		loadScript(ExtraScripts.colorPicker, function () {
			// TODO: support color-changing of the input when alphaSupport is true
			input.jPicker({
				window: {
					// title : displayName + ' Color',
					effects: {
						type: 'fade',
						speed: {
							show: 'slow',
							hide: 'fast'
						}
					},
					position: {
						x: 'screenCenter',
						y: 'center',
					},
					positionFunctions : {
						top : function() {
							return input.offset().top - 150;
						},
						left: function() {},
					},
				},
				images: {
					clientPath: 'images/jpicker/'
				}
			},
				function (color, context) {
					input.trigger('change')
				})
		})
	}
	function initFile(input, inputContainer) {
		var uploader;
		var data = input.data();
		const fileType = sa.components.uploader.getFileType(input.data('filetype'));
		const isImage = fileType && fileType == UploaderConstants.IMAGES && inputContainer.hasClass('image_input_container')
		const imgSrc = inputContainer.find('img').attr('src') || data['value'] || ''
		inputContainer.addClass('file_input_container');

		console.log("adding file to inputContainer", inputContainer)
		console.log("has img", imgSrc)
		if (!isImage) {
			input.after('<input type="text" id="filename" disabled="disabled" class="no_validate" /><a class="button browse_button">Browse</a><a class="remove_button fa fa-times"></a>');
		} else if (isImage && imgSrc) {
			console.log("setting img src")
			inputContainer.find('img').attr('src', imgSrc)
		}


		var removeButton = inputContainer.find('.remove_button');
		removeButton.on('click', function () {
			uploader.removeAllFiles();
			inputContainer.removeClass('with_value');
			inputContainer.data('value', '')
			inputContainer.find('#filename').val('');
			removeButton.removeClass('showing');
			inputContainer.trigger('realtime');
		});

		if (data['value']) {
			console.log("data", data)
			removeButton.addClass('showing');
			setTimeout(function () {
				inputContainer.addClass('with_value');
			}, 100);
			// save the initial and current values in order to validate the input
			inputContainer.data('value', data['value'])
			inputContainer.data('initialVal', data['value'])
			inputContainer.find('#filename').val('Saved image');
		}

		uploader = sa.components.uploader.attachUploader({
			button: inputContainer.find('.browse_button'),
			browseCallback: function (uploader) { // after selecting an image
				var fileList = uploader.getFileDetails();
				var newMessage = '';
				if (fileList && fileList.length >= 1) {
					newMessage = fileList[0].name;
					inputContainer.addClass('with_value');
					removeButton.addClass('showing');
					// update the current val for validation against initial value
					inputContainer.data('value', fileList[0].name)
					
					// TODO: shouldn't this validate that the file type matches the expected?
					const isFileAllowed = uploader.isMimeTypeAllowed(fileList[0].type)
					
					if (isImage && isFileAllowed) {
						var fr = new FileReader();
						var imgFile = fileList[0];
						fr.addEventListener('load', function (event) {
							inputContainer.find('img').attr('src', event.target.result)
						});
						fr.readAsDataURL(imgFile)
					}
				} else {
					inputContainer.removeClass('with_value');
					removeButton.removeClass('showing');
				}
				inputContainer.find('#filename').val(newMessage).attr('title', newMessage);
				inputContainer.trigger('realtime');
			},
			fileType,
		});

		inputContainer.data({ uploader: uploader, inputName: input.attr('name'), filetype: fileType });

		input.remove();
	}

	function initCheckbox(input, inputContainer) {
		inputContainer.find('.toggle_label').remove();
		input.after('<label for="' + input.attr('id') + '" class="toggle_label"></label>');
		input.addClass('hidden');
		inputContainer.find('.toggle_label').on('mouseenter', function () {
			input.trigger('focus');
		}).on('mouseleave', function () {
			input.trigger('blur');
		});
		inputContainer.addClass('checkbox_input_container');


		if (input.data('value')) {
			input.prop('checked', input.data('value'))
		}
	}


	/**
	 * For this to work correctly the radio buttons need to be in this format:
	 * 
	 * 	<div class="input_container">
	 * 		<div>
	 * 			<input type="radio" id="banners_dynamic_background_default" checked name="banners_dynamic_background"> 
	 * 			<label for="banners_dynamic_background_default">Use Global Default</label>
	 * 		</div>
	 * 		<div>
	 * 			<input type="radio" id="banners_dynamic_background_on" name="banners_dynamic_background"> 
	 * 			<label for="banners_dynamic_background_on">Match Image Colors</label>
	 * 		</div>
	 * 		<div>
	 * 			<input type="radio" id="banners_dynamic_background_off" name="banners_dynamic_background"> 
	 * 			<label for="banners_dynamic_background_off">Don't Match Image Colors</label>
	 * 		</div>
	 * 	</div>
	 * 
	 * - Each input has to have a label with a for="{id}" matching an id on the input
	 * - The input and label need to be in their own container without other inputs/labels
	 * - The input needs to come BEFORE the label 
	 * 
	 * 
	 * @param {*} inputs 
	 * @param {*} inputContainer 
	 */
	function initRadio(inputs, inputContainer) {
		inputs.each(function () {
			var input = $j(this);
			var inputId = input.attr('id');
			if (!inputId) {
				console.warn('Unable to initialize forms for radio button - has no id', input, inputContainer);
				return;
			}
			var label = inputContainer.find('label[for=' + inputId + ']');
			if (!label.length) {
				console.warn('Unable to initialize forms for radio button - has no label', input, inputContainer);
			}

			let inputVal = input.val();

			if (inputVal == 'true') inputVal = true;
			if (inputVal == 'false') inputVal = false;
			console.log("input data value radio", input.data('value'), input.val())
			if (input.data('value') == inputVal) {
				input.prop('checked', true)
				inputContainer.addClass('with_value')
			}

		});
		inputContainer.addClass('radio_input_container');
	}

	function initSelect(input, inputContainer) {
		input.on('focus', function () {
			inputContainer.addClass('focused');
		});
		input.on('blur', function () {
			inputContainer.removeClass('focused');
		});
		inputContainer.append('<span class="fa fa-caret-down faux_select"></span>');
		inputContainer.find('.faux_select').on('click', function () {
			input.trigger('click');
		});
		if (input.data('selectize')) {
			selectize(input, inputContainer);
		} else if (input.find('option:selected:not(:disabled)').length) {
			inputContainer.addClass('with_value');
		} else {
			input.on('change', function () {
				if (input.find('option:selected:not(:disabled)').length) {
					inputContainer.addClass('with_value');
				} else {
					inputContainer.removeClass('with_value');
				}
			});
		}
	}

	/**
	 * Selectize's a select box
	 * @param {JQuery} select
	 * @param {JQuery} inputContainer
	 */
	function selectize(select, inputContainer) {
		var newValues = createSafeObject();
		var newValueIndex = 0;
		var options = select.data();

		// camelcased selectize options must be passed as data attributes with underscores
		// so that they can be parsed here, i.e. data-create_on_blur
		for (let [key, val] of Object.entries(options)) {
			let spacesKey = key.split('_');
			if (spacesKey.length > 1) {
				let newKey = spacesKey.reduce((prev, cur, ind) => {
					if (ind > 0) cur = cur[0].toUpperCase() + cur.slice(1)
					return prev += cur
				}, '')

				options[newKey] = val;
				delete options[key]
			}
		}

		var selectizeOptions = {
			delimiter: '\n',
			dropdownParent: 'body',
			labelField: 'value',
			maxOptions: 3000,
			searchField: 'value',
			sortField: 'value',
			valueField: 'id'
		};

		options = $j.extend({
			list: '',
			create: false,
			multiple: false
		}, options);

		if (select.attr('multiple')) {
			options.multiple = true;
		} else if (options.multiple) {
			select.attr('multiple', 'multiple');
		}

		if (options.create) {
			selectizeOptions.create = function (input) {
				newValueIndex--;
				newValues[newValueIndex] = input;
				return { id: newValueIndex, value: input, text: input };
			};
		}

		selectizeOptions.load = function (query, callback) {
			if (!query.length) return callback([]);
			if (['writers', 'publishers', 'groups'].includes(options.list)) {
				ajax({ p: 'people', action: 'search', type: options.list, s: query }, function (response) {
					var items = [];
					if (response && response.length) {
						response.each(function () {
							items.push({ id: this.id, value: this['display'].replace(/&quot;/g, '"') });
						});
					}
					callback(items);
				});
			} else {
				ajax({ p: 'list', type: options.list, ids: 1, part: query, excludeSyncs: 1 }, function (response) {
					var items = [];
					if (response && response.length && response[0].items) {
						response[0].items.each(function () {
							items.push({ id: this.id, value: this['value'].replace(/&quot;/g, '"') });
						});
					}
					callback(items);
				});
			}
		};

		if (select.val()) {
			inputContainer.addClass('with_value');
		}
		selectizeOptions.onChange = function (newValue) {
			if (!newValue) {
				inputContainer.removeClass('with_value');
			} else {
				inputContainer.addClass('with_value');
			}
		};

		selectizeOptions.onFocus = selectizeOptions.onClick = function () {
			inputContainer.addClass('focused');
		};
		selectizeOptions.onBlur = function () {
			inputContainer.removeClass('focused');
		};
		selectizeOptions.onDropdownOpen = function (dropdown) {
			dropdown.addClass('forms_dropdown');
		};
		if (select.prop('placeholder')) {
			selectizeOptions.placeholder = select.prop('placeholder');
		}

		$j(select).selectize(selectizeOptions);

		var realInput = inputContainer.find('.selectize-input input');
		realInput.on('focus', function () {
			inputContainer.addClass('focused');
		});
		realInput.on('blur', function () {
			inputContainer.removeClass('focused');
		});
		realInput.addClass('no_validate');

		select[0].getSelectizeVal = function (trim) {
			var vals = [];
			this.childNodes.each(function (i, node) {
				if (node.value === undefined || node.value === '') return;
				if (node.value >= 0) {
					vals.push({ id: node.value });
				} else if (newValues[node.value] !== undefined) {
					var valueName = newValues[node.value];
					if (trim) {
						valueName = valueName.trim();
					}
					vals.push({ name: valueName });
				}
			});
			if (!options.multiple) {
				if (vals.length) {
					return vals[0];
				} else {
					return '';
				}
			}
			return vals;
		};
	}

	function initSmartEmailInput(input) {
		if (ios) return;
		input.data({
			searchCache: {},
			lastAutoCompleteRequest: 0,
			lastValue: ''
		});
		input.on('keydown', function (e) {
			var code;
			if (e) {
				code = e.keyCode;
			} else {
				code = window.event.keyCode;
			}
			if ((code == 38 /* up arrow */ || code == 40 /* down arrow */)) {
				// navigate through the list
				var suggestions = $j('.email_suggestions .email_suggestion');
				// find the one that's selected and select the one in the arrow direction
				for (var i = 0, len = suggestions.length; i < len; i++) {
					var suggestion = $j(suggestions[i]);
					if (suggestion.hasClass('selected')) {
						if (code == 38) { // up
							if (!i) return; // on the first element already
							$j(suggestions[i - 1]).addClass('selected');
						} else { // down
							if (i == len - 1) return; // on the last element already
							$j(suggestions[i + 1]).addClass('selected');
						}
						suggestion.removeClass('selected');
						storeSmartEmailSelection(input);
						return false;
					}
				}
			} else if (code == 13 /* enter */ || code == 9 /* tab */ || code == 188 /* comma */) {
				// select current
				if (input.data('lastSelected')) {
					chooseSmartEmailOption(input);
					return false;
				}
				if (code == 13) return false; // no enters
			} else {
				clearTimeout(input.data('autocompleteTimeout'));
				input.data('autocompleteTimeout', setTimeout(function () { showSmartEmailSuggestions(input); }, 500));
				hideSmartEmailSuggestions();
			}
		});
		input.on('blur', function () {
			setTimeout(function () { hideSmartEmailSuggestions(); }, 50);
		});
	}

	function chooseSmartEmailOption(input) {
		// remove everything from the input box's value after the last comma
		var val = input.val().replace(/[^,]*$/, ' ' + input.data('lastSelected'));
		input.val(val.trim() + ', ');
		hideSmartEmailSuggestions();
		// can't hide on blur. focus still changes to other elements because of the mouseup. add mouse up to false?
		input.data('lastSelected', '');
		forms.update(input);
	}

	function storeSmartEmailSelection(input) {
		var selected = $j('.email_suggestions .email_suggestion.selected');
		var lastSelected = '';
		if (selected.length) {
			lastSelected = selected.html().replace(/<\/?b>/ig, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
		}
		input.data('lastSelected', lastSelected);
	}

	function hideSmartEmailSuggestions() {
		var suggestions = $j('.email_suggestions');
		suggestions.removeClass('showing');
		setTimeout(function () {
			suggestions.remove();
		}, 150);
	}

	/**
	 * Shows the autocomplete box based on the value of the input box
	 * @param {JQuery} input the input box whose value we're searching for
	 */
	function showSmartEmailSuggestions(input) {
		var value = input.val().trim();
		// if the user didn't change the value (hitting arrow keys or spaces) don't refresh anything
		if (value == input.data('lastValue')) return;
		input.data('lastSelected', '');

		var commaVals = value.split(','); // we only want to search for the last item in the comma-seperated recipients
		var searchVal = commaVals.pop().trim();

		// we cache results locally (reloaded for every new emailer) so see if we already have the result in cache
		var cachedVal = input.data('searchCache')[searchVal];
		if (cachedVal) {
			populateSmartEmailSuggestions(input, cachedVal, searchVal);
		} else {
			// if we're going to hit the server, make sure we only show data from the last request response
			var autoCompleteRequest = input.data('lastAutoCompleteRequest') + 1;
			input.data('lastAutoCompleteRequest', autoCompleteRequest);
			ajax({ p: 'email_search', includeGroups: 1, partial: searchVal }, function (matches) {
				var searchCache = input.data('searchCache');
				if (searchCache) {
					searchCache[searchVal] = matches;
					input.data('searchCache', searchCache);
				}
				if (autoCompleteRequest == input.data('lastAutoCompleteRequest')) {
					populateSmartEmailSuggestions(input, matches, searchVal);
				}
			});
		}
		// save the value as the last searched for the first if
		input.data('lastValue', value);
	}

	function populateSmartEmailSuggestions(input, matches, searchVal) {
		if (!matches.length) return;

		var suggestionDiv = $j('<div class="email_suggestions"></div>');
		searchVal = searchVal.replace(/([[\]+()-*$^])/g, '\\$1');
		for (var i = 0, len = Math.min(5, matches.length); i < len; i++) {
			var match = matches[i];
			var display = match.email.replace(new RegExp('(' + searchVal + ')', 'ig'), '<b>$1</b>');
			if (match.email != match.username) {
				display = ('"' + match.username.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(new RegExp('(' + searchVal + ')', 'ig'), '<b>$1</b>') + '" &lt;' + display + '&gt;');
			}
			suggestionDiv.append('<div class="email_suggestion' + (!i ? ' selected' : '') + '">' + display + '</div>');
		}
		input.after(suggestionDiv);

		suggestionDiv.css({ top: input.outerHeight() + 1, width: input.width() });
		suggestionDiv.find('.email_suggestion').mouseover(function () {
			suggestionDiv.find('.email_suggestion').removeClass('selected');
			$j(this).addClass('selected');
			storeSmartEmailSelection(input);
		}).on('mousedown', function () {
			chooseSmartEmailOption(input);
			$j(window).on('mouseup', function () { $j(window).off('mouseup'); input.trigger('focus'); return false; });
		});
		setTimeout(function () {
			suggestionDiv.addClass('showing');
		}, 20);
		storeSmartEmailSelection(input);
	}

	function initRealTimeValidation(input, inputContainer, options) {
		var timeout; // use a timeout so we don't fire constantly while they're typing. only after they pause
		var event = '';
		var fileInput = false;
		if (input.filter('input[type=text], input[type=email], input[type=password], textarea, select').length) {
			event = 'input';
		} else if (input.filter('input[type=checkbox], input[type=radio]').length) {
			event = 'change'; // checkboxes don't fire 'input' events
		} else if (input.filter('input[type=file]').length) {
			event = 'realtime'; // we want to fire this manually
			fileInput = true;
		}
		if (event) {
			(fileInput ? inputContainer : input).on(event, function () {
				// console.log('firing', event, 'for', input.attr('name'));
				clearTimeout(timeout);
				timeout = setTimeout(function () {
					if (fileInput) {
						input = inputContainer.find('input[type=file]');
					}
					var validationResult = new sa.forms.validationResult(input);
					if (input.data('attachCheckerTriggered')) {
						input.data('attachCheckerTriggered', 0);
						if (input.attr('required') && !validationResult.value) {
							validationResult.hideError();
						}
						return;
					}
					if (options.realTimeValidationCallback) {
						options.realTimeValidationCallback(validationResult);
					} else {
						inputContainer.addClass('failed_validation');
					}
				}, 500);
			});
		}
	}

	/**
	 * Validates a form* and returns all its elements in a form that's suitable for sending to ajax
	 * 	*Doesn't need to actually be a form. Will search any container for elements to send
	 * 	Finds all input elements, selects, and textareas
	 * 	Validation is based off attributes on the elements. Accepted attributes are:
	 * 		required - if set to 1, will not allow form submission if no value
	 * 		matches - a regex to match to the value. will block submission if the value doesn't match. useful for forcing integers with "^[0-9]+$". don't include beginning and end /
	 * 		minlength - an integer, inclusive
	 * 		maxlength - an integer, inclusive
	 * 		formnovalidate - if set to formnovalidate, the input will not be evaluated or included in results
	 * 	Note: no validation attributes are required
	 * 	If an element fails validation, the form will look for an element with class "error" in the parent div and show it
	 *
	 * 	Returns an object with the following attributes
	 * 		{boolean} error - were there validation errors?
	 * 		{Object} values - the successfully validated values, indexed by input name
	 * 		{Array} errors - any values that failed validation. uses sa.forms.validationResult return format
	 *
	 * 	Example:
	 * 		<div class="input_container">
	 * 			<input type="text" name="zip" required="1" matches="^[0-9]{5}$"/>
	 * 			<div class="error">Please enter a five digit zip code</div>
	 * 		</div>
	 * 	If the user enters nothing, "asdf", or "123", function will return { error : true, values : {}, errors : [{sa.forms.validationResult}] } and the .error div will be shown
	 *  If the user enters "12345", function will return { error : true, values : { zip : "12345" }, errors : [] } and the .error div will be hidden
	 *
	 * @param {JQuery} container where to search for the input elements
	 * @returns {{ error : boolean, values : Object, errors : Array, fields : Object }} an object, as described above
	 */
	forms.validate = function (container) {
		/**
		 * TODO: this should remove disabled inputs
		 */
		var inputs = container.find('input[type!=radio][type!=checkbox]:not(.no_validate), input[type=radio]:checked, input[type=checkbox]:checked, input[type=checkbox].toggle, select, textarea');
		var topValidationError = null;
		var returnObject = {
			error: true,
			errors: [],
			values: {},
			fields: {}
		};

		inputs = inputs.filter(':not([formnovalidate=formnovalidate])');

		function addToVars(vars, inputName, val) {
			var openBracketPosition = inputName.indexOf('[');
			var closeBracketPosition = inputName.indexOf(']');

			if (openBracketPosition == -1 || closeBracketPosition == -1 || closeBracketPosition < openBracketPosition) {
				vars[inputName] = val;
			} else if (openBracketPosition == closeBracketPosition - 1) {
				inputName = inputName.replace('[]', '');
				if (vars[inputName] && vars[inputName].isArray) {
					vars[inputName].push(val);
				} else if (vars[inputName]) {
					console.error('Unable to parse form input names into vars object. Make sure all references to', inputName, 'are an array');
				} else {
					vars[inputName] = [val];
				}
			} else {
				var key = inputName.substring(0, openBracketPosition);
				if (!vars[key]) {
					vars[key] = createSafeObject();
				}
				addToVars(vars[key], inputName.substring(openBracketPosition + 1, inputName.length).replace(']', ''), val);
			}
		}

		for (var i = 0, len = inputs.length; i < len; i++) {
			var validationResult = new sa.forms.validationResult($j(inputs[i]));

			if (!validationResult.name) {
				console.warn('not adding element to forms because it has no name', validationResult);
			} else if (!validationResult.error) {
				validationResult.input.parent().find('.error').hide();
				addToVars(returnObject.values, validationResult.name, validationResult.value);
			} else {
				returnObject.errors.push(validationResult);
				if (!topValidationError) {
					topValidationError = validationResult;
				}
			}
			returnObject.fields[validationResult.name] = validationResult;
		}

		// add any files
		container.find('.file_input_container').each(function (i, fileInputContainer) {
			var validationResult = new sa.forms.validationResult($j(fileInputContainer).find('input[type=file]'));
			returnObject.fields[validationResult.name] = validationResult;
		});

		if (topValidationError) {
			topValidationError.scrollTo();
		} else {
			returnObject.error = false;
		}
		return returnObject;
	};


	class InputWithDefault {
			constructor(input, inputContainer, defaultVal, savedVal) {
			const self = this
			this.input = input
			this.inputContainer = inputContainer
			this.interacted = false

			// pass in a function for defaultVal to use as a getter
			if (typeof defaultVal == 'function') {
				this.defaultFunc = defaultVal
			} else {
				this.defaultFunc = () => defaultVal
			}


			// pass in a function for defaultVal to use as a getter
			if (typeof savedVal == 'function') {
				this.savedFunc = savedVal
			} else {
				this.savedFunc = () => savedVal
			}

			this.reset = this.saved === undefined;

		
			this.initGlobalText()
			this.initResetButton()
			this.initInput()
			// this.logVals()

			return this
		}

		get default() {
			return this.defaultFunc()
		}

		get saved() {
			return this.savedFunc()
		}
		get val() {
			const {input, inputContainer} = this
			var tagType = input.attr('type')
			let val = input.val()
			if (tagType == 'checkbox') val = input.prop('checked')

			return val
		}

		get valToSave() {
			const {input, inputContainer} = this
			if (this.reset) return ''

			if (this.interacted) {
				return this.val
			}
			if (this.saved !== undefined) {
				return this.saved
			}
		}

		initGlobalText() {
			const {input, inputContainer} = this
			const self = this

			this.globalText = inputContainer.find('.default_text')
			if (!this.globalText.length && this.default !== undefined) {
				this.defaultText = this.default == true ? 'On' : (this.default == false ? 'Off' : this.default)
				this.globalText = $j(`<p class="default_text">Global Setting: ${this.defaultText}</p>`)
				inputContainer.find('label').after(this.globalText)
			}

		}

		initInput() {
			const {input, inputContainer} = this
			const self = this

			
			if (this.saved === undefined) {
				inputContainer.addClass('is_default')
				input.addClass('is_default')
			}

			let val = self.val
			var tagType = input.attr('type')
			if (tagType == 'checkbox') {
				input.prop('checked', val)
			} else {
				input.val(val)
			}
			
			// respond after first call because we trigger 'change' when initially setting the value for the input
			let times = 0;
			input.on('change input', function (e) {
				if (times == 0) {
					times++
					return
				}
				// console.log("dont_save_default input changing or inputting")
				self.interacted = true
				self.reset = false

				inputContainer.addClass('interacted')

				let val = self.val;

				// console.log("input val", val, 'dfeault', input.data('default'))
				if (val == self.default) {
					input.addClass('is_default')
					inputContainer.addClass('is_default')
					console.log("val is default")

				} else {
					input.removeClass('is_default')
					inputContainer.removeClass('is_default')
					console.log("val is NOT default")
				}

				input.data('value', val)

				self.logVals()


			});
		}

		initResetButton() {
			const self = this
			const { inputContainer, input } = this

			this.resetButton = inputContainer.find('.reset_button')

			if (!this.resetButton.length) {
				this.resetButton = $j('<a href="#" class="reset_button">Reset To Default</a>');
				this.input.parent().append(this.resetButton)
			}

			this.resetButton.on('click', function (e) {
				inputContainer.removeClass('interacted')
				const isColorPicker = inputContainer.hasClass('color_input_container')

				self.interacted = false
				self.reset = true

				// If is color picker have to set jPicker's active color
				if (isColorPicker) {
					input[0].color.active.val('hex', self.default)
				}

				var tagType = input.attr('type')
				if (tagType == 'checkbox') {
					input.prop('checked', self.default)
				} else {
					input.val(self.default)
				}

				inputContainer.addClass('is_default')
				input.addClass('is_default')


				self.logVals()


				return false
			})
		}
		logVals() {
			console.log(this.input)
			console.log('current input val', this.val)
			console.log('default val', this.default)
			console.log('saved val', this.saved)
			console.log("val to save", this.valToSave)
		}

	
	}

	return forms;

})();

sa.search = (function() {

	var search = {};

	/** @var {JQuery} */
	var searchBox;
	/** @var {JQuery} */
	var searchButton;
	/** @var {JQuery} */
	let $searchContainer;
	/** @var {JQuery} */
	let $aiMode;
	/** @var {JQuery} */
	let $artemis;

	var requests = {};
	var searchCounts = {};

	var placeholderBackup = '';
	let aiModeEnabled = false;


	/**
	 * Gets the current value of the search box, accounting for the variable not being initialized
	 * @returns {string}
	 */
	function getSearchBoxValue() {
		let value = '';
		if (searchBox && searchBox.length) {
			value = searchBox.val();
			if (value === undefined) {
				value = '';
			} else {
				value = value.trim();
			}
		}
		return value;
	}


	/**
	 * AI MODE FUNCTIONS
	 */
	function enterAIMode(focus = true) {
		if (aiModeEnabled) return;
		aiModeEnabled = true;

		// rotate placeholders
		const placeholders = [
			'ex. a song like the one at the end of Beverly Hills Cop',
			'ex. a song to use in a Western',
			'ex. a song that sounds like Snoop Dogg',
			'ex. a song that makes me happy',
			'ex. a song like you\'d hear at Coachella',
			'ex. a song for a sword fight on a volcano',
			'ex. a song for long walks on the beach',
		];
		
		const placeholder = placeholders[Math.floor(Math.random()*placeholders.length)];
		animatePlaceholder(searchBox, placeholder, function($input){
			// add 'ai_mode' class to the search container so we can style it differently
			if (focus) searchBox.focus();
			searchButton.removeClass('fa fa-search');
			$searchContainer.addClass('ai_mode');
			$aiMode.removeClass('fa-light').addClass('fa-solid')
		})
	}
	function exitAIMode() {
		if (!aiModeEnabled) return;

		aiModeEnabled = false;
		
		animatePlaceholder(searchBox, '', function($input) {
			$searchContainer.removeClass("ai_mode");
			searchButton.addClass('fa fa-search');
			$aiMode.addClass('fa-light').removeClass('fa-solid')
		})
	}

	/**
	 * Animate changes to an input's placeholder
	 * 
	 * @param {jQuery} $input The input to animate changes in the placeholder
	 * @param {string} placeholder New placeholder text.  Empty resets to original
	 * @param {function} callback Function to run after the animation is complete
	 */
	const animatePlaceholder = ($input, placeholder, hideCallback = function() {}, showCallback= function() {}) => {
		$input.animate({width: 0}, 150, function() {
			// this kinda makes this function only useful in this context, but it's fine
			if (placeholder === '') {
				removeTemporaryPlaceholder();
			} else {
				showTemporaryPlaceholder(placeholder);
			}
			hideCallback($input);
			// delay the length of time the width transition is set to on the I Want ai_prompt
			$input.delay(150).animate({width: '100%'}, 100, function() {
				showCallback($input);
			});
		})
	}

	/**
	 * Sets the value of the search field to match what's in the hash (if anything)
	 */
	const debouncedEnterExitAIMode = _.debounce(function(aiMode) {
		if (aiMode)	{
			enterAIMode(false);
		} else {
			exitAIMode();
		}
	}, 100);
	search.updateSearchFromPath = function() {
		let m = sa.router.getCurrentQueryParams();
    	let vars = sa.router.convertQueryStringToUrlSearchObj(m);
		m = m ? vars.get('s') : '';

		let aiMode = false;
		if (vars.has('ai') || vars.has('ai[]')) {
			aiMode = true;
			m = vars.get('ai') || vars.get('ai[]')
		}
		
		let v = getSearchBoxValue();
		window['m'] = m;
		window['v'] = v;
		if (m) {
			searchBox.val(m.toString());
		} else {
			searchBox.val('');
		}

		// this gets called a bunch of times on route changes so don't call it till after the change is done,
		// or else it goes in and out of AI mode quickly
		debouncedEnterExitAIMode(aiMode);
		searchBox.trigger('input');
		
	};

	function setPlaceholder(text) {
		if (placeholderBackup) {
			placeholderBackup = text;
		} else {
			searchBox.attr('placeholder', text);
		}
	}

	function showTemporaryPlaceholder(text) {
		if (!placeholderBackup) {
			placeholderBackup = searchBox.attr('placeholder');
		}
		searchBox.attr('placeholder', text);
	}

	function removeTemporaryPlaceholder() {
		if (placeholderBackup) {
			searchBox.attr('placeholder', placeholderBackup);
		}
		placeholderBackup = '';
	}

	/**
	 * Updates the displayed number of tracks the user can search, loading it from the server if necessary
	 * Also updates the catalog selector display
	 */
	search.updateSearchCount = function() {
		// get the parameters we'll use to determine count. add the permission profile id so we have a separate cache if you're changing profiles
		var selectedParameters = search.getSelectedCatalogData().parameters + '&permissionProfileId=' + user.getActivePermissionProfileId();

		// see if we have the parameteres in the cache
		// check vs undefined because 0 could be an answer
		if (searchCounts[selectedParameters] == undefined) {
			setPlaceholder('');
			if (!requests[selectedParameters]) {
				ajax('p=search_counts&' + selectedParameters, function(response) {
					searchCounts[selectedParameters] = response[0].count;
					search.updateSearchCount();
				});
				// set something here so we know this is loading and don't make lots of dupe calls if they click faster than we can ajax
				requests[selectedParameters] = 1;
			}
		} else {
			// we only want to update the text if the user doesn't have custom search text entered. if they do, we need to save this value for when they delete
			var title = 'tracks';
			if (config.id == 72 || config.id == 87 || config.id == 114) {
				title = 'sound effects';
			} else if (config.id == 752) {
				title = 'tracks and stems';
			}
			var isMobile = sa.isMobile();
			var placeholder = 'Search ' + searchCounts[selectedParameters] + ' ' + title;
			const joiners = [
				'by keywords',
				'audio file',
				'or URL',
			];
			if (isMobile) {
				joiners.splice(1, 1)
			}
			if (config.showSonicSearch) {
				if (joiners.length > 2) {
					placeholder += ' ' + joiners.join(', ')
				} else {
					placeholder += ' ' + joiners.join(' ')
				}
			}
			setPlaceholder(placeholder);
		}
		// search.updateSearchFromPath();
	};

	/**
	 * Resets the current search terms
	 */
	search.reset = function() {
		searchBox.val('');
	};

	/**
	 * Gets data about the state of catalog selection
	 * @return {object} ret.parameters = 'cs[]=123&ls[]=456', ret.catalogCount = 1, ret.labelCount = 1, ret.all = false, ret.currentCatalog = false, ret.currentLabel = false
	 */
	search.getSelectedCatalogData = function() {
		var ret = {
			parameters : '',
			catalogCount : 0,
			labelCount : 0,
			all : false,
			currentCatalog : false,
			currentLabel : false,
			currentMusicSupplier : false
		};
		switch ($j('#search_current.visible input[name=search_current]:checked').val()) {
			case undefined:
				ret.all = true;
				break;
			case 'label':
				var label = sa.pages.label.getLabel();
				if (label) {
					ret.currentLabel = true;
					ret.parameters = '&ls' + encodeURIComponent('[]') + '=' + label.id;
				}
				break;
			case 'catalog':
				var catalog = sa.pages.catalog.getCatalog();
				if (catalog) {
					ret.currentCatalog = true;
					ret.parameters = '&cs' + encodeURIComponent('[]') + '=' + catalog.id;
				}
				break;
			case 'music provider':
			case 'music supplier':
				let musicSupplier = sa.pages.musicSupplier.getMusicSupplier();
				if (musicSupplier) {
					ret.currentMusicSupplier = true;
					ret.parameters = '&network' + encodeURIComponent('[]') + '=' + musicSupplier.id;
				}
				break;
		}
		return ret;
	};

	search.getFilterVars = function() {
		var filterVars = sa.router.paramsToVars(sa.components.leftNav.getParams(false, 'tracks')), // grab the vars according to the left nav
			deleteEmpty = function(filterVars) {
				for (var i in filterVars) {
					if (!filterVars.hasOwnProperty(i)) continue;
					var filterVar = filterVars[i];
					if (filterVar == '') {
						delete filterVars[i];
					} else if (filterVar.isArray) {
						if (!filterVar.length) {
							delete filterVars[i];
						}
					} else if (typeof filterVar == 'object') {
						deleteEmpty(filterVar);
						// see if there are any attributes left
						var varCount = 0;
						for (var j in filterVar) {
							if (filterVar.hasOwnProperty(j)) {
								varCount++;
							}
						}
						if (!varCount) {
							delete filterVars[i];
						}
					}
				}
			};
		deleteEmpty(filterVars);
		return sa.router.varsToParams(filterVars).replace('?', '&');
	};

	/**
	 * Searches!
	 * @param {string=} searchTerms the currently entered terms
	 */
	search.doSearch = function(searchTerms) {
		if (lockdown) {
			return sa.showLockdownMessage();
		}

		// check for odd number of quotes and notify users that this is a bad idea
		if ((searchTerms.match(/"/g) || []).length % 2 != 0) {
			sa.alert('Your search has an odd number of quotation marks, which might produce bad results. If you don\'t find what you\'re looking for, please consult our <a href="https://docs.sourceaudio.com/search/advanced_search.html">Advanced Search Documentation</a> for help.');
		}

		if (!searchTerms) { //no terms sent, let's use current
			searchTerms = getSearchBoxValue();
		}

		//is there a URL in the search box, cause if so, let's override and do a sonic search
		if (searchTerms.isValidUrl()) {
			if (!config.showSonicSearch) {
				return sa.alert('Sorry, this workspace has performing Sonic Searches by video disabled.');
			}
			// if this is a sourceaudio site, we can't search
			// check if the search is for the same site
			const url = new URL(searchTerms);
			if (url.hostname == window.location.hostname) {
				sa.router.routeTo(url.toString());
				return;
			}
			if (/sourceaudio\.com$/.test(url.hostname)) {
				sa.alert({ text: 'Sorry, we can\'t Sonic Search on tracks from other SourceAudio workspaces. Please try another URL.' });
				search.reset()
				return;
			}
			sonicSearchProcessUrl(searchTerms);
			return;
		}
		
		if (searchTerms === 'spiders' && window['SpiderController']) {
			new SpiderController({ minBugs: 2, maxBugs: 16, imageSprite: 'js/lib/bug/spider-sprite.png'});
		}

		// grab the data so we know state
		var selectedData = search.getSelectedCatalogData(),
			filterParams = search.getFilterVars(),
			encodedSearchTerms = encodeURIComponent(searchTerms).replace(/&/g, '%26'),
			pageType;

		if (aiModeEnabled) {
			// run AI search
			// exitAIMode();
			searchBox.trigger('blur');
			const searchLabelCatalog = search.getSelectedCatalogData();
			sa.router.routeTo(`/tracks?ai=${encodedSearchTerms}${searchLabelCatalog.parameters}`);
			// searchBox.val(searchTerms);
			return;
		}

		// all we have to do is update the hash and the current page will take it from there
		if (sa.currentPage && sa.currentPage.name == 'sonicsearch') {
			var ssVars = sa.pages.sonicsearch.vars;
			ssVars.s = searchTerms;
			console.log('ss filter search:', ssVars);
			
			if (ssVars.hasOwnProperty('id')) {
				let id = ssVars.id;
				delete ssVars.id;
				sa.router.routeTo('/sonicsearch/' + id + '?' + sa.router.varsToParams(ssVars));
			} else {
				sa.router.routeTo('/sonicsearch' + '?' + sa.router.varsToParams(ssVars));
			}
		} else if (selectedData.currentCatalog) {
			pageType = 'tracks';
			if (sa.pages.catalog.isShowingAlbumList()) {
				pageType = 'albums';
			}
			var catalog = sa.pages.catalog.getCatalog();
			if (catalog) {
				sa.router.routeTo('/catalog/' + catalog.id + '?page=' + pageType + (searchTerms ? '&s=' + encodedSearchTerms : '') + filterParams);
			} else {
				sa.router.routeTo('/tracks?s=' + encodedSearchTerms + selectedData.parameters);
			}
		} else if (selectedData.currentLabel) {
			pageType = 'tracks';
			if (sa.pages.label.isShowingAlbumList()) {
				pageType = 'albums';
			}
			var label = sa.pages.label.getLabel();
			if (label) {
				sa.router.routeTo('/label/' + label.id + '?page=' + pageType + (searchTerms ? '&s=' + encodedSearchTerms : '') + filterParams);
			} else {
				sa.router.routeTo('/tracks?s=' + encodedSearchTerms + selectedData.parameters);
			}
		} else if (selectedData.currentMusicSupplier) {
			pageType = 'tracks';
			if (sa.pages.musicSupplier.isShowingAlbumList()) {
				pageType = 'albums';
			}
			let musicSupplier = sa.pages.musicSupplier.getMusicSupplier();
			if (musicSupplier) {
				sa.router.routeTo('music-supplier/' + musicSupplier.id + '?page=' + pageType + (searchTerms ? '&s=' + encodedSearchTerms : '') + filterParams);
			} else {
				sa.router.routeTo('/tracks?s=' + encodedSearchTerms + selectedData.parameters);
			}
		} else {
			if (sa.currentPage && (sa.currentPage.name == 'catalog' || sa.currentPage.name == 'label' || sa.currentPage.name == 'music_supplier')) {
				filterParams = '';
			}
			
			let paramString = 's=' + encodedSearchTerms;
			paramString += selectedData.parameters ? '&' + selectedData.parameters : '';
			paramString += filterParams ? '&' + filterParams : '';
			paramString = paramString.replace(/&{2,}/, '&');
			
			sa.router.routeTo(siteBaseUrl() + '/tracks?' + paramString);
		}

		// hide advanced search
		sa.components.topBar?.hideAdvancedSearch();

		// deselect the search box
		searchBox.trigger('blur');
		// hide the clouds
		hideClouds();
		search.searchFlashCount = 100;

		sa.scrollToPosition(0);
	};

	/**
	 * Shows the current label option in the options and selects it
	 */
	search.showCurrentLabel = function() {
		sa.components.topBar.showCurrentSearch(gde('label', { 'case' : 'lower', plural : false }), 'label');
		search.updateSearchCount();
	};

	/**
	 * Shows the current catalog option in the options and selects it
	 */
	search.showCurrentCatalog = function() {
		sa.components.topBar.showCurrentSearch(gde('catalog', { 'case' : 'lower', plural : false }), 'catalog');
		search.updateSearchCount();
	};

	/**
	 * Shows the current music supplier option in the options and selects it
	 */
	search.showCurrentMusicSupplier = function() {
		sa.components.topBar.showCurrentSearch('music supplier', 'music supplier');
		search.updateSearchCount();
	};

	/**
	 * Hides the current option from the catalog/label/music supplier drop down options
	 */
	search.hideCurrentGrouping = function() {
		sa.components.topBar.hideCurrentSearch();
		search.updateSearchCount();
	};

	/**
	 * Handler for when search tags are clicked while holding shift
	 * @param {PointerEvent} e - the mouse event
	 * @param {string} tag - the tag text that was clicked and should be added to search
	 */
	search.searchTagHandler = function (e, tag) {
		if (!e.shiftKey) return; // only do this if shift is pressed 
		e.preventDefault();
		
		// Remove existing quotes around the tag if they exist
		tag = tag.replace(/^"/g, '');
		tag = tag.replace(/"$/g, '');

		const href = $j(e.srcElement).attr('href');
		$j(e.srcElement).attr('href', '#0'); // turn off the link

		// should we put quotes around it?
		if (tag.includes(' ') && !tag.includes(':')) { // if it has spaces, but no prefix (prefixes will already do this)
			tag = tag.replace(/"/g, ''); // remove any existing quotes
			tag = '"' + tag + '"';
		}

		sa.search.addSearchTerm(tag);

		setTimeout(function () {
			$j(e.srcElement).attr('href', href); // turn it back on
		}, 500);
	};

	/**
	 * Finds any sub elements with a data-search_tag attribute and adds a click handler to add that tag to the search box
	 * @param {JQuery} $element
	 */
	search.addSearchTagListeners = function($element) {
		$element.find('a[data-search_tag]').on('click', function(e) {
			// e.preventDefault();
			// e.stopPropagation();
			search.searchTagHandler(e, this.dataset.search_tag);
			// return true;
		});
	};

	search.addSearchTerm = function (term) {
		const terms = getSearchBoxValue().split(' ');
		let newVal = '';
		searchBox.val('');
		
		for (let i = 0; i < terms.length; i++) {
			if (terms[i] !== term) {
				newVal += terms[i] + ' ';
			}
		}
		
		let cleanTerm;
		
		try {
			cleanTerm = $j('<textarea/>').html(term).text().trim();
		} catch (e) {
			console.log('- cleanterm failed', e, term);
			cleanTerm = term.trim();
		}
		
		cleanTerm = searchTermTagFormatter(cleanTerm);
		
		newVal += cleanTerm;
		searchBox.val(newVal);
		searchBox.trigger('input');
		searchBox.focus();
	};

	search.addTermAndSearch = function(term) {
		search.addSearchTerm(decodeURIComponent(term).trim());
		search.doSearch( getSearchBoxValue() );
	};

	search.searchForValue = function(value) {
		searchBox.val(value);
		searchButton.trigger('click');
	};

	/**
	 * Sets up the search container in the header and its basic contents and interactions
	 */
	search.build = function(container) {
		sa.on('beforeRouteChange', function() {
			search.hideCurrentGrouping();
		});
		sa.on('routeChange', function() {
			if (firstCheck) firstCheck = false;
			search.updateSearchFromPath();

			if (sa.isMobile()) {
				container.removeClass('search_bar_open');
			}
		});

		sa.on('resize', _.debounce(function() {
			// to set the placeholder correctly (we can't search by audio file on mobile)
			search.updateSearchCount();
		}, 500))

		searchBox = container.find('#search_box');
		searchButton = container.find('#search_button');
		$searchContainer = container.find("#search_container");
		const sharedTemplates = sa.templates.get('shared');
		$artemis = sharedTemplates.get('artemis');
		searchButton.append($artemis);

		searchBox.attr('autocapitalize', 'off').attr('autocorrect', 'off');

		// advanced search button
		if (config.id != 72 && config.id != 87 && config.id != 82) {
			container.find('#search_options').on('click', function(e) {
				e.preventDefault();
				sa.components.topBar.toggleAdvancedSearch();
			});
		} else {
			container.find('#search_options').remove();
		}
		
		/**
		 * AI Mode stuff
		 */
		$aiMode = container.find('#search_ai_mode');
		if (config.showAISearch) {
			$aiMode.on('click', function(e) {
				if (aiModeEnabled) {
					exitAIMode();
				} else {
					enterAIMode();
				}
			})
	
			searchBox.on('keyup', function (e) {
				// exit AI mode on escape key
				if (e.which == 27) {
					exitAIMode();
				}
			});
		} else {
			container.find('#search_ai_mode').remove();
		}
	

		// search clear button
		container.find('#search_clear').on('click', function(e) {
			e.preventDefault();
			search.reset();
			searchBox.focus();
			// container.find('#search_clear').hide();
			$searchContainer.removeClass('has_input');
		});

		searchBox.on('input blur', function(e) {
			const val = searchBox.val();
			if (!val) {
				$searchContainer.removeClass('has_input');
			} else {
				$searchContainer.addClass('has_input');
			}
		});
		searchBox.trigger('input');

		// make the call to load the number of search results
		search.updateSearchCount();

		// set up the button that will actually run searches when pressed
		searchButton.on('click', function() { 
			if (sa.isMobile()) {
				container.toggleClass('search_bar_open');
			} else {
				search.doSearch(getSearchBoxValue()); 
			}
		});
		searchButton.on('focus', function() { searchButton.trigger('blur'); });
		checkForEnter(searchBox, function() { search.doSearch(getSearchBoxValue()); });
		setPlaceholder((config.id == 72 || config.id == 87 || config.id == 114 ? 'Search lots of sound effects' : 'Search lots of tracks'));

		// sonic search file uploading
		if (config.showSonicSearch) {
			sa.components.edad.addGenericDropZone({
				allowedExtensions : Uploader.GetExtensions(UploaderConstants.AUDIO),
				anchorSelector : '#search_box_container',
				templateSelector : 'wang_drop_zone',
				uniqueKey : 'wang_drop_zone',
				dropCallback : function (files) {
					if (config.grayLabel) {
						sa.alert({ text : 'To add this feature to your workspace, please contact SourceAudio at sales@sourceaudio.com.' });
						return;
					}
					var file = files[0];
					var randId = new Date().getTime() + '-' + user.userData.id;
					var fu = new FileUploader();
					fu.onProgress = function (loaded, total) {
						sonicSearchUploadProgress(loaded / total);
					};
					fu.onComplete = function () {
						sonicSearchUploadComplete(file, randId);
					};
					fu.onError = function () {
						sonicSearchUploadReset();
					};
					fu.uploadFromDrop(file, 't=track&soundShapeExact=1&useImportIndex=1&id=' + encodeURIComponent(randId), 'TRACK_SERVER');
					sonicSearchUploadStart();
				}
			});

			new Uploader({
				button : container.find('#sonic_search_button')[0], browseCallback : function (uploader) {
					var file = uploader.getFileDetails()[0];
					var randId = new Date().getTime() + '-' + user.userData.id;
					sonicSearchUploadStart();
					uploader.upload({
						forceSourceAudioServer: 1,
						useImportIndex : 1,
						params : 't=track&soundShapeExact=1&id=' + encodeURIComponent(randId),
						complete : function () {
							sonicSearchUploadComplete(file, randId);
						},
						progress : function (e, bytesLoaded, bytesTotal) {
							sonicSearchUploadProgress(bytesLoaded / bytesTotal);
						},
						error : function () {
							console.log('error during upload');
						},
						fileId : file.id
					});
				}, fileType : UploaderConstants.AUDIO
			});
		}

		// advanced search
		var advancedSearch = container.find('#asearch');
		let options = [ 'Title', 'BPM', 'Lyrics', 'Description' ];
		$j.each(config.dictionary, function(key, dic) {
			if (key == 'composer' || key == 'publishing' || config.hiddenFields.indexOf(key) != -1) return true;
			options.push(dic['singular']);
		});
		for (let key in config.customFields) {
			if (!config.customFields.hasOwnProperty(key)) continue;
			let cf = config.customFields[key];
			if (!parseInt(cf.hidden)) {
				options.push(cf.name);
			}
		}
		options.sort(function(a, b) { return a.localeCompare(b, 'en', { sensitivity : 'base' })});
		let select = advancedSearch.find('.asearch_row select');
		for (let option of new Set(options)) {
			let optionText = !isAcronym(option) ? titleCase(option) : option.toUpperCase();
			select.append(new Option(optionText, option.toLowerCase()));
		}

		// and/or buttons
		var andorPress = function() {
			$j(this).parent().find('span').removeClass('selected');
			$j(this).addClass('selected');
		};
		advancedSearch.find('.asearch_andor span').on('click', andorPress);

		// add row button
		advancedSearch.find('.asearch_actions .addfield').on('click', function() {
			const andor = $j(advancedSearch.find('.asearch_andor')[0]).clone();
			const row = $j(advancedSearch.find('.asearch_row')[0]).clone();
			row.find('.asearch-row-close').show();
			row.addClass('includes-close-btn');
			row.find('.remove-search-row').on('click', function () {
				$j(this).closest('.asearch_row').prev().remove();
				$j(this).closest('.asearch_row').remove();
			});
			row.find('select').val(0);
			row.find('input').val('');
			andor.find('span').removeClass('selected');
			andor.find('span.and').addClass('selected');
			andor.find('span').on('click',  andorPress );

			advancedSearch.find('.asearch_rows').append(andor);
			advancedSearch.find('.asearch_rows').append(row);
		});

		// form submit
		advancedSearch.find('form').on('submit', function(e) {
			e.preventDefault();
			$j('#asearch .asearch_actions .submit').trigger('click');
		});

		// submit button
		advancedSearch.find('.asearch_actions .submit').on('click', function() {

			//get terms
			var terms = [];
			$j('#asearch .asearch_row').each(function(key, row) {
				var field = $j(row).find('select').val();
				var term = $j(row).find('input').val();
				if (field != '0') {
					if (field.indexOf(' ') != -1) {
						field = '"' + field + '"';
					}
					if (term.indexOf(' ') != -1) {
						term = '"' + term + '"';
					}
					term = field + ':' + term;
				}

				terms.push(term);
			});

			//get joiners
			var joiners = [];
			$j('#asearch .asearch_andor').each(function(key, andor) {
				joiners.push( $j(andor).find('.and').hasClass('selected') ? 'and' : 'or' );
			});

			//console.log('terms:', terms, joiners);

			var query = '';
			var inor = false;

			for (var ii = 0; ii < terms.length; ii++) {
				var term = terms[ii];
				if (!term) continue;

				if (ii > 0) {
					var joiner = joiners[ii - 1];

					if (inor && joiner != 'or') {
						query += ')';
					}

					query += ' ' + joiner.toUpperCase() + ' ';

					inor = (joiner == 'or');

				}

				if (joiners[ii] == 'or' && !inor) {
					query += '(';
				}

				query += term;
			}
			if (inor) query += ')';

			console.log('query', query);

			//remove a fully parened query, cause it doens't need it, and it looks dumb
			if (query[0] == '(' && query[query.length - 1] == ')' && query.substr(1, query.length - 2).indexOf('(') == -1) {
				query = query.substr(1, query.length - 2);
			}

			search.searchForValue(query);
			sa.components.topBar?.hideAdvancedSearch();
		});

		// current search
		var currentSearchInput = container.find('input[name=search_current]');
		var searchCurrent = container.find('#search_current');
		searchCurrent.on('click', function(e) {
			if (currentSearchInput.filter(':checked').length) {
				currentSearchInput.prop('checked', false);
				searchCurrent.removeClass('checked');
			} else {
				currentSearchInput.prop('checked', true);
				searchCurrent.addClass('checked');
			}
			e.preventDefault();
			e.stopPropagation();
		});

	};

	function sonicSearchUploadStart() {
		showTemporaryPlaceholder('SonicSearch Status: Uploading file...');
		sa.components.topBar.setSonicSearchStatus(false, 'Uploading file');
	}

	function sonicSearchUploadProgress(percentage) {
		sa.components.topBar.setSearchProgress(percentage);
	}

	async function sonicSearchUploadComplete(file, randId) {
		console.log('complete');
		sa.components.topBar.setSearchProgress(0);
		showTemporaryPlaceholder('SonicSearch Status: Processing file...');
		sa.components.topBar.setSonicSearchStatus(false, 'Processing file');

		const r = await sa.api.request({
			handler: 'sonicsearch',
			action: 'processFile',
			getData: {
				id: randId,
				name: file.name,
				format: file.name.split('.').pop()
			}
		}).catch(err => {
			sa.alert({ text: err.message });
		});

		sonicSearchUploadReset();
		if (r.search_id) {
			var saved_filters = $j('#sonic_search_search').data('saved_filters');
			if (!saved_filters) saved_filters = '';

			sa.router.routeTo('/sonicsearch/' + r.search_id + saved_filters);
			console.log('would now take you to search:', r.search_id);
		} else {
			sa.notify({ text: 'Sorry, there was a problem processing that track. Please try another one.' });
		}
			
	}

	function sonicSearchUploadReset() {
		sa.components.topBar.setSonicSearchStatus(true);
		sa.components.topBar.setSearchProgress(0);
		removeTemporaryPlaceholder();
	}

	async function sonicSearchProcessUrl(url) {

		if (!url) return;

		searchBox.val('');

		showTemporaryPlaceholder('SonicSearch Status: Processing. This could take a few mins depending on length...');
		sa.components.topBar.setSonicSearchStatus(false, 'Processing URL');

		const r = await sa.api.request({
			handler: 'sonicsearch',
			action: 'processURL',
			getData: {video_url: url}
		}).catch(e => {
			console.log('SA-API Error:', e);
			sa.alert({ text: e.message });
		});

		if (r.error) {
			console.log('error:', r.error);
			sa.alert({ text: r.error });

			// reset state
			sonicSearchUploadReset();
			return;
		}

		if (r['search_id']) {
			sa.router.routeTo('/sonicsearch/' + r['search_id']);
			sonicSearchUploadReset();
			return;
		}

		console.log('Unknown state', r);
		sonicSearchUploadReset();
		sa.notify({ text: 'An unknown error occurred. Most often, this is a result of a very long video, or one not available for download.' });
			

	}

	return search;

})();

sa.components.cloudBrowser = (function() {
	var cloudBrowser = {};
	/** @var {FocusBox} cloudBrowserContainer */
	var cloudBrowserContainer;
	var cloudBrowserContent;
	var showing = false;
	
	sa.eventify(cloudBrowser);

	cloudBrowser.hide = function() {
		if (!showing) return;
		cloudBrowserContainer.hide();
		showing = false;
	};

	/**
	 * @param {CloudDetails} cloudData
	 */
	cloudBrowser.showCloud = function(cloudData) {

		cloudBrowserContainer.setTitle('Add ' + cloudData.name + ' to search');

		// select the tab
		cloudBrowserContent.find('.selected').removeClass('selected');
		cloudBrowserContent.find('#' + cloudData.optionId).addClass('selected');

		// set the actual cloud
		var cloud = new Cloud(cloudData);
		cloudBrowserContent.find('#cloud').remove();
		cloudBrowserContent.append(cloud.div);
		cloud.show();

		// show it!
		if (!showing) {
			cloudBrowserContainer.show();
		}

		setTimeout(function() {
			cloudBrowser.trigger('resize');
		}, 300);

		showing = true;

	};

	/**
	 * Makes sure if the window is too small that the appropriate overflow is applied to the cloud
	 */
	cloudBrowser.on('resize', function() {
		if (!showing) return;

		var height = 0;
		let div = cloudBrowserContent.find('#cloud');
		height += div[0].offsetHeight;

		var maxHeight = $j(window).height() - 40 - $j('#top_bar').height() * 2;
		if (height > maxHeight) {
			cloudBrowserContent.css('max-height', maxHeight + 'px');
		} else {
			cloudBrowserContent.css('max-height', '');
		}
	});

	cloudBrowser.build = function() {

		var templates = sa.templates.get('clouds');

		cloudBrowserContent = templates.get('cloud_browser');

		cloudBrowserContainer = new FocusBox(cloudBrowserContent, { additionalClasses: ['cloud-browser-focusbox'], allowReuse : true, onClose : function() { showing = false; } });

	};

	return cloudBrowser;

})();


function hideClouds() {
	sa.components.cloudBrowser.hide();
}

/**
 * @typedef {Object} CloudDetails
 * @property {string} name
 * @property {string} type
 * @property {int} customFieldId
 * @property {string} optionId
 */

/**
 * @param {CloudDetails} cloudDetails
 * @constructor
 * @extends sa.eventify
 */
function Cloud(cloudDetails) {
	var cloud = this;
	var cloudData;
	this.div = null;
	
	sa.eventify(this);

	this.show = function() {
		if (!cloudData) {
			var cloud = this,
				f = function(response) { cloud.setData(response); };
			showLoader(get('cloud_tags', this.div), cloudDetails.name + ' List');
			if (cloudDetails.type == 'm') {
				ajax('p=list&type=moods', f);
			} else if (cloudDetails.type == 's') {
				ajax('p=list&type=styles', f);
			} else {
				ajax('p=list&type=custom_cloud&customFieldId=' + cloudDetails.customFieldId, f);
			}
		} else {
			this.setData(cloudData);
		}
		this.trigger('resize');
		this.hideCover();
	};

	this.setData = function(newData) {
		var div = get('cloud_tags', this.div);
		if (div) {
			if (cloudData == newData) {
				this.trigger('resize');
				return;
			}
			cloudData = newData;
			removeChildren(div);
			const items = cloudData[0].items;
			
			for (let i = 0; i < items.length; i++) {
				const item = items[i];
				if (item.tag.trim !== undefined && item.tag.trim() === '') continue;
				const a = document.createElement('a');
				a.href = getDefaultLink();
				a.textContent = StringSanitize.ifEncodedDecode(item.tag);
				const adjustedWeight = Math.floor(item.weight / items.length * 25 + 10);
				a.style.fontSize = adjustedWeight + 'px';
				a.addEventListener('click', function () {
					cloud.addSearchTerm(this.innerHTML);
					return false;
				});
				div.appendChild(a);
			}
			
			div.appendChild(createDiv('', 'clr'));
		}
		this.trigger('resize');
	};

	this.addSearchTerm = function (term) {
		const termToAdd = term.entityDecode();
		const cloud = this;
		
		sa.search.addSearchTerm(termToAdd);
		const cover = createDiv('cover');
		let h2;
		cover.appendChild(createDiv('back'));
		cover.appendChild(h2 = createH2('Adding "'+ term +'" to search'));
		cover.style.width = this.div.offsetWidth + 'px';
		cover.style.height = this.div.offsetHeight + 'px';
		
		let parentBgColor = $j('#cloud_browser').css('background-color');
		parentBgColor = ColorUtils.addAlpha(parentBgColor, 0.7);
		cover.style.backgroundColor = parentBgColor.hex();
		$j(cover).find('h2').css('color', ColorUtils.contrast(parentBgColor.hex()).hex());
		
		this.div.appendChild(cover);
		h2.style.left = Math.floor((this.div.offsetWidth - h2.offsetWidth) / 2) + 'px';
		setTimeout(() => { cloud.hideCover(); }, 1000);
	};

	this.hideCover = function() {
		$j('#cloud #cover').remove();
	};

	this.on('resize', function() {
		sa.components.cloudBrowser.trigger('resize');
	});

	this.init = function() {
		this.div = createDiv('cloud', 'cloud_container');
		//nameDiv.style.width = (a.offsetWidth + 20) + 'px';
		var containerDiv = createDiv('cloud_main', 'cloud_main');
		containerDiv.appendChild(createDiv('cloud_tags'));
		this.div.appendChild(containerDiv);
	};

	this.init();
}
/**
 * Represents the user, logged in or not. A singleton in the current design
 */
function User() {
	this.logged = false;

	/** @var {Array.<ProjectFolder>} */
	this.projectFolders = [];
	/** @var {Array.<CueSheet>} */
	this.cueSheets = [];
	/**
	 * @var {{
	 * 		id : int,
	 * 		image : string,
	 * 		username : string,
	 * 		email : string,
	 * 		adminPermissions : Array.<string>,
	 * 		setName : int,
	 * 		facebook : int,
	 * 		lastLogin : int,
	 * 		siteOwner : int,
	 * 		options : Object,
	 * 		emailPreferences : Object,
	 * 		authorizedByIP : true,
	 * 		permissionProfiles : Array.<{ id : int, name : string, active : boolean }>
	 * }}
	 */
	this.userData = {};
	this.secureToken = '';
	this.views = {};
	this.siteOwner = false;

	var firstLog = false;
	var loaded = false;
	var fullyAuthorized = false; // if the user is logged but not fully authorized (let in by email code) a number of features are unavailable
	var verificationEnabled = true; // should the verifyUser function work? used during login attempts, which handle their own verification
	var currentMusicAccessProfileId = -1;
	var indexedProjects = {};

	// Volume settings
	let currentVolume = null;

	var onLoadCallbacks = [];
	this.onLoad = function(callback) {
		if (loaded) {
			callback();
		} else {
			//console.log('user onLoad queueing callback');
			onLoadCallbacks.push(callback);
		}
	};

	/**
	 * Is this a logged in user who has normal access levels?
	 * @return {boolean}
	 */
	this.isFullyAuthorized = function() {
		return !this.logged || fullyAuthorized;
	};

	/**
	 * User data will be verified on ajax responses (default)
	 */
	this.enableVerification = function() {
		verificationEnabled = true;
	};

	/**
	 * User data will not be verified on ajax responses (not default)
	 */
	this.disableVerification = function() {
		verificationEnabled = false;
	};

	/**
	 * Makes sure the given user id is the same user id the user is currently logged in with and if not, corrects the local state
	 * @param {int} userId the user to check against (usually comes from ajax response)
	 */
	this.verifyUser = function(userId) {
		if (!verificationEnabled) {
			console.log('skipping verifyUser because verificationEnabled is false');
			return;
		}
		if (firstLog) {
			//console.log('skipping verifyUser because of firstLog state');
			return;
		}
		if (userId && !this.logged) {
			// user is logged in on server but not on client
			$j('.lightbox_container').remove();
			this.loadUser();
		} else if (userId && userId != this.userData.id) {
			// user is logged in on server with different login from client
			$j('.lightbox_container').remove();
			this.loadUser();
		} else if (!userId && this.logged) {
			// user isn't logged in on server but is on client
			$j('.lightbox_container').remove();
			this.logout();
		}
	};

	/**
	 * Checks if the current user is an admin
	 * @return {boolean} is the user an admin?
	 */
	this.hasAdminPermission = function (permission) {
		if (config.siteMode === 'receive') return false;
		if (permission === AdminPermission.Users && this.hasAdminPermission(AdminPermission.Admins)) return true;
		if (permission === AdminPermission.WorksRegistration) return false;
		return this.logged && this.userData.adminPermissions && this.userData.adminPermissions.length > 0
			&& (permission === AdminPermission.Any || this.userData.adminPermissions.indexOf(permission) !== -1);
	};

	/**
	 * Returns a brief description of what an admin permission does.
	 * Useful if you want to say if (!user.hasAdminPermission(X)) { sa.alert('You must have the ' + getAdminPermissionDescription(X) + 'permission'); }
	 * @param {string} permission
	 * @returns {string}
	 */
	this.getAdminPermissionDescription = function(permission) {
		switch (permission) {
			case AdminPermission.Settings:
				return 'Change Settings';
			case AdminPermission.CustomPages:
				return 'Edit Home Page/Custom Pages';
			case AdminPermission.Feature:
				return 'Feature Content/Publish Playlists';
			case AdminPermission.FileDelivery:
				return 'Use the File Delivery Tool';
			case AdminPermission.Users:
				return 'Manage Users';
			case AdminPermission.Admins:
				return 'Manage Admins';
			case AdminPermission.Statistics:
				return 'View Statistics';
			case AdminPermission.Licensees:
				return 'Manage Licensees, Sync Settings, &amp; Briefs';
			case AdminPermission.Metadata:
				return 'Edit Metadata and Add/Delete Tracks';
			case AdminPermission.Licensing:
				return 'Manage Licensing';
			case AdminPermission.Pando:
				return 'View Add-Ons and Programs';
			case AdminPermission.MusicSuppliers:
				return 'Manage Music Suppliers';
			case AdminPermission.Sharing:
				return 'Send and Embed Tracks &amp; Manage Comments';
			default:
				console.error('Unknown permission requested', permission);
				return '';
		}
	};

	/**
	 * Is this the user that owns the site?
	 * @return {boolean} are they?
	 */
	this.isSiteOwner = function() {
		return this.siteOwner;
	};

	/**
	 * Sets the user's currently active permission profile and calls all the functions necessary to reload site state based on the change
	 * @param {int} permissionProfileId
	 */
	this.setActivePermissionProfile = function(permissionProfileId) {
		if (!this.logged) return;
		for (let i = 0, len = user.userData.permissionProfiles.length; i < len; i++) {
			user.userData.permissionProfiles[i].active = (user.userData.permissionProfiles[i].id == permissionProfileId);
		}
		currentMusicAccessProfileId = permissionProfileId;
		sa.cookies.setIfAllowed(sa.cookieTypes.necessary, 'activePermissionProfileId_' + this.userData.id, permissionProfileId, 0, true);
		sa.requestCache.clear();
		//user.reloadProjects();
		//user.reloadCueSheets();
		sa.search.updateSearchCount();
		sa.components.leftNav.reload();
		sa.pages.details.resetTrackData();
		sa.router.reloadPage();
	};

	/**
	 * Gets the ID of the currently active permission profile
	 * @returns {int|number}
	 */
	this.getActivePermissionProfileId = function() {
		if (currentMusicAccessProfileId === -1 && user.userData.permissionProfiles && user.userData.permissionProfiles.length) {
			for (let i = 0, len = user.userData.permissionProfiles.length; i < len; i++) {
				if (user.userData.permissionProfiles[i].active) {
					currentMusicAccessProfileId = user.userData.permissionProfiles[i].id;
					break;
				}
			}
		}
		return currentMusicAccessProfileId;
	};

	/**
	 * Changes the username that appears across the site
	 * DOES NOT change the user's username in the database. Meant to be called after a database update
	 * @param {string} username the new username
	 */
	this.setUsername = function(username) {
		this.userData.username = username;
		sa.trigger('updateUserData');
		sa.requestCache.clear();
	};

	/**
	 * Changes the user's email as it's displayed on the site
	 * DOES NOT change the user's email in the database. Meant to be called after a database update
	 * @param {string} email the user's new email
	 */
	this.setEmail = function(email) {
		this.userData.email = email;
		sa.trigger('updateUserData');
	};

	/**
	 * Updates the user's avatar as it's displayed on the site
	 * @param {string} avatar url to the new avatar
	 */
	this.setAvatar = function(avatar) {
		this.userData.image = avatar;
		sa.trigger('updateUserData');
	};

	/**
	 * Saves the current volume level into the user cookies
	 * @param {number} volume the volume to store
	 */
	this.setVolume = function(volume) {
		currentVolume = volume;
		sa.cookies.setIfAllowed(sa.cookieTypes.preference, 'volume_' + this.userData.id, volume);
	};

	/**
	 * Gets the current volume from the user cookies
	 * @return {number} the stored volume or 1 if it wasn't stored
	 */
	this.getVolume = function() {
		let storedVolume = sa.cookies.get('volume_' + this.userData.id);

		const noStoredVolume = storedVolume === null || storedVolume === undefined || Number.isNaN(parseFloat(storedVolume));

		if (noStoredVolume && currentVolume !== null) {
			storedVolume = currentVolume;
		} else if (noStoredVolume && currentVolume === null) {
			storedVolume = 1;
			currentVolume = 1;
			this.setVolume(1);
		} else if ((!noStoredVolume && currentVolume === null) || (!noStoredVolume && currentVolume)) {
			currentVolume = parseFloat(storedVolume);
		}

		if (storedVolume > 1) storedVolume = 1;
		if (storedVolume < 0) storedVolume = 0;

		return storedVolume;
	};

	/**
	 * Sets the user's data based on data from the server
	 * Calls all the disparate functions required to log someone new in
	 * @param {object} newUserData the data for the user. Will become user.userData
	 */
	this.setUser = function(newUserData) {
		this.userData = newUserData;
		this.logged = true;
		this.siteOwner = newUserData['siteOwner'];
		fullyAuthorized = !newUserData['authorizedByCode'];
		if (config.siteMode !== 'receive' && !fullyAuthorized) {
			lockdown = true;
		}
		sa.cookies.setAgreedToCookies(newUserData.cookiePreferences.agreed);
		sa.cookies.setAllowCookieType(sa.cookieTypes.preference, newUserData.cookiePreferences.allowPreferenceCookies);
		sa.cookies.setAllowCookieType(sa.cookieTypes.statistical, newUserData.cookiePreferences.allowStatisticalCookies);
		sa.cookies.setAllowCookieType(sa.cookieTypes.marketing, newUserData.cookiePreferences.allowMarketingCookies);
		sa.cookies.setAllowCookieType(sa.cookieTypes.login, newUserData.cookiePreferences.allowLoginCookies);
		sa.requestCache.clear();
		if (!firstLog) {
			sa.router.reloadPage();
		}
	};

	/**
	 * Makes the ajax call to log the user out
	 */
	this.logout = function() {
		ajax('p=logout', function() {
			// clear volume cookie on logout
			sa.cookies.remove('volume_' + user.userData.id);
			sa.cookies.remove('playlist_alternates_' + user.userData.id);
			sa.cookies.remove('activePermissionProfileId_' + user.userData.id);
			sa.requestCache.clear();
			user.resetUserData();
			user.logged = false;
			indexedProjects = {};
			user.cueSheets = [];
			user.views = {};
			sa.router.reloadPage();
			$j('body').addClass('not_logged').removeClass('logged');
		});
	};

	/**
	 * Loads the user, assuming they're already logged in server-side
	 * @param {function=} callback
	 */
	this.loadUser = async function (callback) {
		const newData = await sa.api.request({
			handler: 'user',
			action: 'me',
			uncache: new Date().getTime()
		});
		let data = newData[0];
		if (data.result === 'success') {
			data = newData[1];
			user.setUser(data);
			var loadsComplete = loaded ? 10 : 0;
			var loadsRequired = 1 + (config.showCueSheets ? 1 : 0);
			var loadComplete = function() {
				loadsComplete++;
				if (loadsComplete == loadsRequired) {
					// console.log('user loadUser firing ' + onLoadCallbacks.length + ' callbacks after ' + loadsRequired);
					completeLoad();
				}
			};
			if (!sa.embedded && fullyAuthorized) {
				user.reloadProjects(loadComplete);
				user.reloadCueSheets(loadComplete);
				$j('body').removeClass('not_logged');
			} else {
				completeLoad();
			}
		} else {
			// not logged in user
			if (data.options) {
				user.userData.options = data.options;
			}
			// load cookies for logged out
			if (data.cookiePreferences) {
				if (data.cookiePreferences.hasOwnProperty("agreed")) sa.cookies.setAgreedToCookies(data.cookiePreferences.agreed);
				if (data.cookiePreferences.hasOwnProperty("allowPreferenceCookies")) sa.cookies.setAllowCookieType(sa.cookieTypes.preference, data.cookiePreferences.allowPreferenceCookies);
				if (data.cookiePreferences.hasOwnProperty("allowStatisticalCookies")) sa.cookies.setAllowCookieType(sa.cookieTypes.statistical, data.cookiePreferences.allowStatisticalCookies);
				if (data.cookiePreferences.hasOwnProperty("allowMarketingCookies")) sa.cookies.setAllowCookieType(sa.cookieTypes.marketing, data.cookiePreferences.allowMarketingCookies);
				if (data.cookiePreferences.hasOwnProperty("allowLoginCookies")) sa.cookies.setAllowCookieType(sa.cookieTypes.login, data.cookiePreferences.allowLoginCookies);
			}
			completeLoad();
		}

		firstLog = false;
		if (callback) {
			callback();
		}
	};

	function completeLoad() {
		loaded = true;
		onLoadCallbacks.each(function() {
			this();
		});
		onLoadCallbacks = [];
	}

	/**
	 * Saves a particular path for later retreival
	 */
	this.saveSearch = function() {
		if (!user.logged) {
			return sa.notify({ text: 'You must be logged in to use this feature.' });
		}
		if (!fullyAuthorized) {
			return sa.showAuthForm();
		}

		path = sa.router.getCurrentPath(true);
		path = path.replace(/&pg=[0-9]+/, '');

		sa.prompt({
			placeholder : 'Search name',
			yesFunction : function(name) {
				ajax({ path : path, name : name }, function(response) {
					if (response[0].success) {
						sa.notify({ text: 'Access your saved searches in your user dashboard.', type : sa.notify.notificationTypes.success });
					} else {
						sa.notify({ text: response[0].error });
					}
				}, 'POST', 'p=saved_search&action=save');
			},
			yesText : 'Save'
		});
	};

	/**
	 * Gets an array version of the user's projects
	 * @returns {Project[]}
	 */
	this.getProjectArray = function() {
		return Object.values(indexedProjects);
	};

	/**
	 * 
	 * @param sortFn
	 * @param includeEmpty
	 * @returns {Playlist[]|*[]}
	 */
	this.getAllPlaylists = function (sortFn = null, includeEmpty = false) {
		let playlists = this.getProjectArray();
		if (playlists.length === 0) {
			return [];
		}

		// filter out empty playlists if needed
		if (!includeEmpty) {
			playlists = playlists.filter(playlist => playlist.totalTrackCount > 0);
		}
		
		if (sortFn) {
			playlists.sort(sortFn);
		}
		
		return playlists;
	};

	/**
	 * Gets the latest modified playlists
	 * 
	 * @param limit
	 * @param includeEmpty
	 * @returns {Playlist[]|*[]}
	 */
	this.getLatestPlaylists = function(limit = 10, includeEmpty = false) {
		let playlists = this.getProjectArray();
		if (playlists.length === 0) {
			return [];
		}
		
		// filter out empty playlists if needed
		if (!includeEmpty) {
			playlists = playlists.filter(playlist => playlist.totalTrackCount > 0);
		}
		
		// sort by last altered date, descending
		playlists.sort((a, b) => b.dateAltered - a.dateAltered);
		
		if (limit === -1) {
			return playlists;
		}
		
		return playlists.slice(0, limit);
	};

	/**
	 * Gets the data for a project based on its id
	 * @param {int} projectId the project's id
	 * @return {Project|null} the project or null if not found
	 */
	this.getProject = function(projectId) {
		if (indexedProjects[projectId]) {
			return indexedProjects[projectId];
		}
		return null;
	};

	/**
	 * Makes sure a project is part of the user's project (once they're loaded, if they're not)
	 * @param {Project} newProject
	 */
	this.ensureProject = function(newProject) {
		this.onLoad(function() {
			// we need to add it to the user's project list and the projector
			user.updateProject(newProject);
			sa.components.projector.setProjects(user.getProjectArray());
		});
	};

	/**
	 * Removes a project from the JS user list. Has no effect on the server
	 * @param {Project} oldProject
	 */
	this.removeProject = function(oldProject) {
		if (indexedProjects[oldProject.id]) {
			delete indexedProjects[oldProject.id];
		}
	};

	/**
	 * Adds a project to the JS user list. Has no effect on the server
	 * @param {Project} newProject
	 */
	this.addProject = function(newProject) {
		indexedProjects[newProject.id] = newProject;
	};

	/**
	 * Updates the user's information about a project, replacing whatever we have currently
	 * @param {Project} updatedProject
	 */
	this.updateProject = function(updatedProject) {
		this.addProject(updatedProject);
	};

	/**
	 * Gets the data for a project folder based on its id
	 * @param {int} folderId the folder's id
	 * @return {ProjectFolder} the folder or null if not found
	 */
	this.getProjectFolder = function(folderId) {
		function findFolder(folders) {
			for (var i = 0, len = folders.length; i < len; i++) {
				var folder = folders[i];
				if (folder.id == folderId) {
					return folder;
				}
				var foundFolder = findFolder(folder.subfolders);
				if (foundFolder) return foundFolder;
			}
			return null;
		}
		return findFolder(user.projectFolders);
	};

	/**
	 * Reloads the user's projects and causes a page reload if you're on the project list page
	 */
	this.reloadProjects = async function (callback) {
		if (!fullyAuthorized) {
			return;
		}
		sa.requestCache.clear();
		const response = await sa.api.request({
			handler: 'projects',
			action: 'getForUser',
			uid: this.userData.id,
			cache: new Date().getTime()
		});
		const { projects, folders } = response[0];
		user.projectFolders = folders;
		indexedProjects = {};
		for (const project of projects) {
			// add currently uploading tracks
			project.totalTrackCount += sa.importTrackManager.getUploadingImportTracks(getProjectLink(project.id)).length;
			// put it in the list
			indexedProjects[project.id] = project;
		}
		
		sa.components.projector.setProjects(user.getProjectArray());

		if (typeof callback === 'function') {
			callback();
		}
	};

	/**
	 * Reloads the user's cueSheets and causes a page reload if you're on the cueSheet list page
	 */
	this.reloadCueSheets = function(callback) {
		if (!fullyAuthorized || !config.showCueSheets) {
			return;
		}
		sa.requestCache.clear();
		ajax('p=cue_sheets&action=get&uid=' + this.userData.id + '&cache=' + Math.random(), function(newData) {
			user.cueSheets = newData;
			sa.components.cueSheeter.setCueSheets(user.cueSheets);

			if (undefined !== callback && 'function' === typeof callback) {
				callback();
			}
		});

	};

	/**
	 * Updates a user's preference about whether or not a left nav section is showing
	 * {deprecated} - these sections no longer exist
	 * @param {string} section the name of the section
	 * @param {boolean} showing the new state indicating whether the section is showing or not
	 */
	this.leftNavChange = function(section, showing) {
		if (!this.logged) return;
		if (section == 'Favorites') {
			this.setOption('left_favorites', (showing ? 1 : 0));
		}
	};

	/**
	 * Checks the value a user chose for a particular option
	 * @param {string} option the name of the option
	 * @return {string|null} the value
	 */
	this.getOption = function(option) {
		if (firstLog) {
			return null;
		}
		if (this.userData.options[option] !== undefined) {
			return this.userData.options[option];
		}
		return null;
	};

	/**
	 * Updates an option for a user, locally and on the server
	 * @param {string} option the name of the option
	 * @param {string|object} value the new value (if an object, will be stringified)
	 * @param {callback=} callback the function to callback after the option is set
	 */
	this.setOption = function(option, value, callback) {
		if (lockdown) return;
		if (!callback) callback = function() {};
		var stringValue = value;
		if (typeof value === 'object') {
			stringValue = JSON.stringify(value);
		}
		if (this.logged || option !== 'default_download_format') {
			ajax('action=set&option=' + encodeURIComponent(option) + '&value=' + encodeURIComponent(stringValue), callback, 'POST', 'p=user_options');
		}
		this.userData.options[option] = value;
	};

	/**
	 * Gets the current view setting for a specific object type
	 * @param {string} type (t|c|l|a|b|o|m|r)
	 * @returns {string} (block|mini-block|list)
	 */
	this.getView = function(type) {
		var views = this.views;
		// see if we've already loaded this view
		if (views[type]) return views[type];
		// if not, check the user's cookies
		var cookieView = sa.cookies.get('user_view_' + this.userData.id + '_' + config.id),
			parseViews = function(viewString) {
				if (!viewString) return;
				var viewSplit = viewString.split('|');
				for (var i = 0, len = viewSplit.length; i < len; i++) {
					var view = viewSplit[i];
					if (view.length != 2) continue;
					if (views[view[0]]) continue; // don't overwrite one that's already set
					views[view[0]] = view[1] == 'b' ? ListViewType.Block : (view[1] == 'l' ? ListViewType.List : ListViewType.MiniBlock);
				}
			};
		parseViews(cookieView ? cookieView : '');
		if (views[type]) return views[type];
		// if it wasn't in the cookies, use the site default
		parseViews(config.defaultViews);
		if (views[type]) return views[type];
		// if it wasn't there either, something's gone wrong. just return block
		return ListViewType.Block;
	};

	/**
	 * Sets a view in the global list and in the user's cookie
	 * @param {string} type the type of item whose view is being set (track|artist|album|catalog|label|composer). Other values will be ignored
	 * @param {string} newView the new view type (mini-block|block|list). Other values will be ignored
	 */
	this.setView = function(type, newView) {
		var shortType = '',
			shortView = '',
			views = this.views;
		if (type == 'track') shortType = 't';
		else if (type == 'artist') shortType = 'a';
		else if (type == 'album') shortType = 'b';
		else if (type == 'catalog') shortType = 'c';
		else if (type == 'writer') shortType = 'w';
		else if (type == 'publisher') shortType = 'u';
		else if (type == 'label') shortType = 'l';
		else if (type == 'composer') shortType = 'o';
		else if (type == 'project_item') shortType = 'p';
		else if (type == 'project') shortType = 'r';
		else if (type == 'music_provider' || type == 'music_supplier') shortType = 'm';
		else return console.log('unable to determine short type for ' + type);
		if (newView == ListViewType.MiniBlock) shortView = 'm';
		else if (newView == ListViewType.Block) shortView = 'b';
		else if (newView == ListViewType.List) shortView = 'l';
		else return console.log('unable to determine short view for ' + newView);
		views[shortType] = newView;
		var cookieView = sa.cookies.get('user_view_' + this.userData.id + '_' + config.id),
			viewSplit = (cookieView ? cookieView : '').split('|'),
			found = false;
		for (var i = 0, len = viewSplit.length; i < len; i++) {
			var view = viewSplit[i];
			if (view == '') {
				len--;
				viewSplit.splice(i, 1);
			}
			if (view[0] == shortType) {
				found = true;
				viewSplit[i] = shortType + shortView;
			}
		}
		if (!found) {
			viewSplit.push(shortType + shortView);
		}
		sa.cookies.setIfAllowed(sa.cookieTypes.preference, 'user_view_' + this.userData.id + '_' + config.id, viewSplit.join('|'), 86400 * 30);
	};

	this.getPlaylistAlternates = function () {
		var storedAlternates = sa.cookies.get('playlist_alternates_' + this.userData.id);
		if (storedAlternates == null || isNaN(storedAlternates = parseInt(storedAlternates))) {
			storedAlternates = 1; // default is yes
			this.setPlaylistAlternates(storedAlternates);
		}
		return storedAlternates;
	};

	/**
	 * Saves the default for "include alternates" when creating playlists
	 * @param {number} val
	 */
	this.setPlaylistAlternates = function (val) {
		sa.cookies.setIfAllowed(sa.cookieTypes.preference, 'playlist_alternates_' + this.userData.id, val);
	};

	/**
	 * Sets up the user data object with default values
	 */
	this.resetUserData = function() {
		this.userData = {options:{},username:''};
		currentMusicAccessProfileId = -1;
	};

	/**
	 * Loads the initial user details from the server
	 * @param {function} callback
	 */
	this.loadInitialUser = function(callback) {
		firstLog = true;
		this.resetUserData();
		[ 'mousedown', 'keydown', 'contextmenu' ].forEach(function(eventType) {
			window.addEventListener(eventType, function() {
				if (user.logged) {
					sa.cookies.setIfAllowed(sa.cookieTypes.necessary, 'activePermissionProfileId_' + user.userData.id, currentMusicAccessProfileId, 0, true);
				}
			});
		})
		this.loadUser(callback);
	};

	/**
	 * Disables the user in the embed
	 */
	this.disableUser = function() {
		firstLog = true;
	};

}

var user = new User();

sa.cookieTypes = {
	necessary : 'necessary',
	preference : 'preference',
	statistical : 'statistical',
	marketing : 'marketing',
	login : 'login'
};

/**
 * A singleton used to add/edit/remove cookies
 * Some of this code came from http://www.quirksmode.org/js/cookies.html
 */
sa.cookies = (function() {

	let cookies = {};
	
	let allowedCookies = {};
	allowedCookies[sa.cookieTypes.necessary] = true;
	allowedCookies[sa.cookieTypes.preference] = false;
	allowedCookies[sa.cookieTypes.statistical] = false;
	allowedCookies[sa.cookieTypes.marketing] = false;
	allowedCookies[sa.cookieTypes.login] = false;
	
	let agreedToCookies = 0;

	/**
	 * Sets the agreement status of the current user
	 * @param {int} value
	 */
	cookies.setAgreedToCookies = function(value) {
		agreedToCookies = value;
		if (value && sa.components.cookieManager) { // if they agreed, make sure we aren't showing the manager (happens bc of load ordering issues on site manager)
			sa.components.cookieManager.hide();
		}
	};

	/**
	 * Gets the agreement status of the current user
	 * @return {boolean}
	 */
	cookies.hasAgreedToCookies = function() {
		return !!agreedToCookies;
	};

	/**
	 * Should we be allowed to set this type of cookie?
	 * @param {string} cookieType
	 * @returns {boolean}
	 */
	cookies.allowCookieType = function(cookieType) {
		return allowedCookies[cookieType];
	};

	/**
	 * Updates on-page cookie types allowed
	 * @param {string} cookieType
	 * @param {boolean} value
	 */
	cookies.setAllowCookieType = function(cookieType, value) {
		if (cookieType === sa.cookieTypes.preference || cookieType === sa.cookieTypes.statistical || cookieType === sa.cookieTypes.marketing || cookieType === sa.cookieTypes.login) {
			allowedCookies[cookieType] = value;
			if (value) {
				cookies.triggerContinuously(cookieType);
			}
		}
	}
	
	/**
	 * Creates or edits a cookie
	 * @param {string} cookieType
	 * @param {string} name the name of the cookie
	 * @param {string} value the cookie's value
	 * @param {int=} expiration the number of seconds in the future that the cookie should expire
	 * @param {boolean=} thisDomain by default, the cookie's domain is .sourceaudio.com. if thisDomain, the cookie is only set on
	 * 	the current domain
	 */
	cookies.setIfAllowed = function(cookieType, name, value, expiration, thisDomain) {
		if (cookies.allowCookieType(cookieType)) {
			let expires = '';
			let domain;
			if (!thisDomain) {
				domain = '; domain=' + config.cookieDomain;
			} else {
				domain = '';
			}
			if (expiration) {
				let date = new Date();
				date.setTime(date.getTime()+(expiration * 1000));
				expires = "; expires=" + date.toUTCString();
			}

			document.cookie = name + "=" + value + expires + "; path=/" + domain;
		}
	};

	/**
	 * Gets the value of a cookie by its name
	 * @param {string} name the name of the cookie
	 * @return {string|null} the cookies value or null if it wasn't set
	 */
	cookies.get = function(name) {
		let nameEQ = name + "=";
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	};

	/**
	 * Removes a cookie, both from this domain and all sourceaudio domains
	 * @param {string} name the cookie's name
	 */
	cookies.remove = function(name) {
		cookies.setIfAllowed(sa.cookieTypes.necessary, name, "", -1, false);
		cookies.setIfAllowed(sa.cookieTypes.necessary, name, "", -1, true);
	};

	let storedCookieSetting = cookies.get('allow_cookies');
	if (storedCookieSetting) {
		let parsedSettings = JSON.parse(storedCookieSetting);
		if (parsedSettings) {
			cookies.setAgreedToCookies(parsedSettings.allow);
			cookies.setAllowCookieType(sa.cookieTypes.statistical, parsedSettings.allowStatisticalCookies);
			cookies.setAllowCookieType(sa.cookieTypes.preference, parsedSettings.allowPreferenceCookies);
			cookies.setAllowCookieType(sa.cookieTypes.marketing, parsedSettings.allowMarketingCookies);
			cookies.setAllowCookieType(sa.cookieTypes.login, parsedSettings.allowLoginCookies);
		}
	}
	
	sa.eventify(cookies);

	return cookies;
	
})();
/**
 * Honestly, this is a catch all
 */

$j.event.special.destroyed = {
	remove: function (o) {
		if (o.handler && o.type !== 'destroyed') {
			o.handler();
		}
	}
};

/**
 * Utility function to serialize objects with data on them to URL vars
 * This only works one level deep, because browsers freak out if you go deeper
 * @return string
 */

function objToVars(varName, obj) {
	var s = '';
	$j.each(obj, function (ii, v) {
		if (s.length) s += '&';
		s += varName + '[' + ii + ']=' + encodeURIComponent(v);
	});

	return s;
}

/**
 * This function is same as PHP's nl2br() with default parameters.
 *
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @param {boolean} isXhtml Use XHTML 
 * @return {string} Filtered text
 */
 function nl2br (str, replaceMode, isXhtml) {

	var breakTag = (isXhtml) ? '<br />' : '<br>';
	var replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}


/**
 * This function inverses text from PHP's nl2br() with default parameters.
 *
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @return {string} Filtered text
 */
function br2nl (str, replaceMode) {   

	var replaceStr = (replaceMode) ? "\n" : '';
	// Includes <br>, <BR>, <br />, </br>
	return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
}

/**
 * backwards compatibility for non ES5 browsers
 */
if (!Object.keys) {
	Object.keys = function (obj) {
		var keys = [],
			k;
		for (k in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, k)) {
				keys.push(k);
			}
		}
		return keys;
	};
}

/**
 * A version of parseInt that formally accepts an int parameter so you don't have to type check before calling parseInt on something that might already be one
 * @param {String|int} val
 * @returns {int}
 */
function parseIntIfNecessary(val) {
	if (typeof val === 'string' || val instanceof String) {
		return parseInt(val);
	} else {
		return val;
	}
}

/**
 * Shows a wysiwyg editor on the page
 * @param {string} selector
 * @param {?object} options - see tinymce options
 * @param {?callable} autosave - if a function, will automatically save the editor contents to the selector's value on change and will pass the output to this function
 */
function showWysiwygEditor(selector, options, autosave) {
	options = $j.extend({
		automatic_uploads: true,
		custom_elements: 'style',
		extended_valid_elements: 'style',
		file_picker_types: 'image',
		height: 400,
		images_upload_url: ajax.getBasePath() + 'p=upload&t=custom_image&source=tinymce',
		invalid_elements: 'script',
		menu: {
			edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
			view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments' },
			insert: { title: 'Insert', items: 'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime' },
			format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat' },
			table: { title: 'Table', items: 'inserttable | cell row column | advtablesort | tableprops deletetable' },
			tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount' },
			help: { title: 'Help', items: 'help' }
		},
		plugins: 'link image code table',
		promotion: false,
		selector: selector,
		toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | image link | code',
	}, options);
	
	if (autosave) {
		options.init_instance_callback = function (editor) {
			// editor.on('blur', window.tinymce.triggerSave);
			// editor.on('input', window.tinymce.triggerSave);
			// editor.on('keyup', window.tinymce.triggerSave);
			editor.on('Change', function() { autosave(editor.getContent()); });
		};
	}

	loadScript(ExtraScripts.tinyMCE, function() {
		window.tinymce.remove();
		window.tinymce.init(options);
	});
}

/**
 * Gets the HTML content of a wysiwyg editor
 * @param selector
 * @returns {string|number|string[]|string}
 */
function getWysiwygEditorContent(selector) {
	if (!window['tinymce']) return '';
	window.tinymce.triggerSave();
	return $j(selector).val();
}

/**
 * Loads an external js file - keeps track of what files we've already loaded so we don't load the same script multiple times
 * @param {string} name the name of the file, loaded from the js folder or an absolute path to the file
 * @param {function} callback a function to call when the load is complete (optional)
 */
function loadScript(name, callback, cache=false) {
	if (name === 'ffmpeg') {
		// requires several scripts to work properly
		loadScript(`../node_modules/@ffmpeg/ffmpeg/dist/umd/ffmpeg.js`, () => {
			loadScript(`../node_modules/@ffmpeg/util/dist/umd/index.js`, () => {
				
				if (callback) callback();
			});
		});
		return;
	}
	var winName = name.replace(/\./g, '').replace(/\//g, '');
	if (!window[winName]) {
		
		// generate a new script tag and add it to the head
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = name.indexOf('http') == -1 ? (config.dev ? `/${config.dev}/`: '/') + 'js/' + name : name;
		script.addEventListener('load', function () {
			window[winName] = true;
			if (callback) callback();
		});
		document.head.appendChild(script);
		
		// $j.ajax({
		// 	type: "GET",
		// 	url: name.indexOf('http') == -1 ? (config.dev ? `/${config.dev}/`: '/') + 'js/' + name : name,
		// 	success: function() {
		// 		if (callback) callback();
		// 		window[winName] = true;
		// 	},
		// 	dataType: "script",
		// 	cache: cache
		// });
		
		if (name == ExtraScripts.colorPicker) {
			let jPickerCss = `/css/jPicker-1.1.6.css`;
			$j('head').append('<link rel="stylesheet" type="text/css" href="'+ jPickerCss  +'"/>');
		} else if (name == ExtraScripts.nivoSlider) {
			let nivoSliderCss = `/css/lib/jquery.nivo.slider/nivo-slider.css`;
			let nivoSliderCss2 = `/css/lib/jquery.nivo.slider/themes/default/default.css`;
			$j('head').append('<link rel="stylesheet" type="text/css" href="'+ nivoSliderCss  +'"/><link rel="stylesheet" type="text/css" href="'+ nivoSliderCss2  +'"/>');
		} else if (name == ExtraScripts.timePicker) {
			let jqueryTimePickerCss = `/css/jquery.timepicker.css`;
			$j('head').append('<link rel="stylesheet" type="text/css" href="'+ jqueryTimePickerCss +'"/>');
		} else if (name == ExtraScripts.mediaElement) {
			let mediaElementCss = `/js/lib/mediaelement/mediaelementplayer.css`;
			$j('head').append('<link rel="stylesheet" type="text/css" href="'+ mediaElementCss +'"/>');
		} else if (name == ExtraScripts.videoJs) {
			let videoJsCss = `/css/lib/video-js.css?v=${videoVersion}`;
			$j('head').append(`<link rel="stylesheet" type="text/css" href="${videoJsCss}"/>`);
		} else if (name == ExtraScripts.ios) {
			$j('head').append(`<link rel="stylesheet" type="text/css" href="/css/ios-min.css"/>`);
			$j('head').append('<meta name="apple-mobile-web-app-capable" content="yes"/>');
			$j('head').append('<link rel="apple-touch-startup-image" href="images/appleTouchStartupImage.php"/>');
		}
	} else if (callback) {
		callback();
	}
}

function loadScriptPromise(name, cache = false) {
	return new Promise((resolve, reject) => loadScript(name, resolve, cache));
}

/**
 * Some of the extra scripts you might load with loadScript so we can update their versions easily in one place
 */

/**
 * If you want to cache these, be sure to add a cache-busting version string just in case
 * We are also sending Last-Modified so if you don't it should probably be fine, but just in case
 */
const videoVersion = 1;
const vibrantVersion = '3.1.6'
var ExtraScripts = {
	charts : 'https://www.gstatic.com/charts/loader.js',
	clipboard : 'lib/clipboard.min.js',
	colorPicker : 'jpicker-1.1.6.js',
	ffmpeg: `ffmpeg`,
	flvJs: `lib/video/flv.min.js?v=${videoVersion}`,
	less : 'lib/less/less.min.js',
	ios: 'ios.js',
	mediaElement : 'lib/mediaelement/mediaelement-and-player.min.js',
	nestedSortable : 'lib/jquery.mjs.nestedSortable/jquery.mjs.nestedSortable.js',
	nivoSlider : 'lib/jquery.nivo.slider/jquery.nivo.slider-3.2.min.js',
	slickSlider: 'lib/slick.min.js',
	timePicker : 'jquery.timepicker.js',
	tinyMCE : '../node_modules/tinymce/tinymce.js',
	tinyScrollbar : 'jquery.tinyscrollbar.js',
	vibrant: `lib/vibrant-3.1.6/vibrant.min.js?v=${vibrantVersion}`,
	videoFlvJs: `lib/video/videojs-flvjs.min.js?v=${videoVersion}`,
	videoJs: `lib/video/video.min.js?v=${videoVersion}`,
};

function setTitle(pageDetail, pageType) {
	// do we have specific seo settings for page title?
	let route = sa.router.getCurrentRoute();
	let currentPath = sa.router.getCurrentPath(true);
	if (!route) {
		route = sa.router.routes.find(route => route.name === 'page-not-found');
	}

	if (config.seo.settings.meta && config.seo.settings.meta.set) {
		var template = config.seo.settings.meta.title || '{pageDetail}|{pageType}|{siteName}';
		var description = config.seo.settings.meta.description || '';
		var keywords = config.seo.settings.meta.keywords || '';
		var lastMatch = false;
		if (config.seo.settings.meta.rules) {
			_.each(config.seo.settings.meta.rules, function (rule) {
				let match = null;
				if (rule.pattern.charAt(0) === '/' && rule.pattern.charAt( rule.pattern.length - 1 ) === '/') {
					try {
						let pattern = rule.pattern.substring(1, rule.pattern.length - 1).replace(/\\/g, '');
						let p = new RegExp(pattern,'i');

						match = (route.hash).match(p) || currentPath.match(p);
					} catch(e) {
						console.log('- seo regex error:', e);
						return; // skip it
					}
				} else {
					let hashMatch = route.hash.startsWith(rule.pattern);
					let pathMatch = currentPath.includes(rule.pattern);
					if (rule.pattern && (hashMatch || pathMatch)) {
						match = [true];
					}
				}

				if (match) {
					lastMatch = match;
					if (rule.title) template = rule.title;
					description = rule.description;
					keywords = rule.keywords;
				}
			});
		}

		//console.log('- template clean:', template);

		if (lastMatch && lastMatch.length > 1) {
			//parts replacement
			var ii = 1;
			_.each(lastMatch.slice(1), function (m) {
				template = template.replace('$' + ii, m);
				description = description.replace('$' + ii, m);
				keywords = keywords.replace('$' + ii, m);
				ii++;
			});
		}

		//console.log('- template after match replace:', template, lastMatch);


		// page vars
		template = template.replace('{pageDetail}', pageDetail || '');
		description = description.replace('{pageDetail}', pageDetail || '');
		keywords = keywords.replace('{pageDetail}', pageDetail || '');
		template = template.replace('{pageType}', pageType || '');
		description = description.replace('{pageType}', pageType || '');
		keywords = keywords.replace('{pageType}', pageType || '');
		template = template.replace('{siteName}', htmlEncode(config.name || ''));
		description = description.replace('{siteName}', htmlEncode(config.name || ''));
		keywords = keywords.replace('{siteName}', htmlEncode(config.name || ''));

		//console.log('- template after page vars:', template);

		// transforms
		let transform = (template) => {
			template = template.replace(/{{uppercase (.*?)}}/g, function(m, p1) {
				return p1.toUpperCase();
			});
			template = template.replace(/{{lowercase (.*?)}}/g, function (m, p1) {
				return p1.toLowerCase();
			});
			template = template.replace(/{{ucfirst (.*?)}}/g, function (m, p1) {
				return ucfirst(p1);
			});
			template = template.replace(/{{ucall (.*?)}}/g, function (m, p1) {
				return _.map(p1.split(' '), function (word) { return ucfirst(word); }).join(' ');
			});
			return template;
		};

		template = transform(template);
		description = transform(description);
		keywords = transform(keywords);

		//console.log('- template after transforms:', template);
		
		var parts = template.split('|');
		parts = _.filter(parts, function (p) { return p.trim(); });
		document.title = _.map(parts, function (p) { return htmlDecode(p).trim(); }).join(' | ');

		// description
		$j('meta[name=description]').remove();
		if (description) {
			$j('head').append( '<meta name="description" content="' + htmlEncode(description) + '">' );
		}

		// keywords
		$j('meta[name=keywords]').remove();
		if (keywords) {
			$j('head').append( '<meta name="keywords" content="' + htmlEncode(keywords) + '">' );
		}

	} else {
		document.title = htmlDecode((pageDetail ? pageDetail + ' | ' : '') + (pageType ? pageType + ' | ' : '') + htmlEncode(config.name));
	}

}

/**
 * Shows a spinning loader gif in a container
 * @param {HTMLElement|JQuery} container the container for the loader
 * @param {string|JQuery} message the message to display beneath the spinner or JQuery object
 * @param {boolean=} contain if true, the container element will automatically get a css class to help formatting 
 * @return {JQuery} the loader so you can remove it later
 */
function showLoader(container, message, contain) {
	let loader = $j('<div id="loader_element"><div class="message"></div><div class="img"><div class="tint"></div></div></div>');
	if (typeof message === 'string') { 
		loader.find('.message').text(message);
	} else if (message instanceof jQuery) {
		loader.find('.message').append(message);
	}
	container = $j(container);
	container.append(loader);

	if (contain) {
		container.addClass('loader_container');
		let observer = new MutationObserver(function (mutations) {
			if (!container[0].contains(loader[0])) {
				container.removeClass('loader_container');
				observer.disconnect();
			}
		});
		observer.observe(container[0], { childList: true, subtree: true });
	}


	let loaderDim = getDimensions(loader[0]);
	let containerDim = getDimensions(loader[0]);
	if (!loaderDim.width || !containerDim.width) return $j();
	loader.css({
		'margin-left': Math.floor((containerDim.width - loaderDim.width) / 2),
		'margin-top': Math.floor((containerDim.height - loaderDim.height) / 2)
	});
	return loader;
}

/**
 * Get default art element for catalogs/labels/track lists etc.
 * 
 * @returns jQuery 
 */
function getDefaultArtElement(type) {
	var globalTemplates = sa.templates.get('shared');
	let templateKey = 'default_art';
	
	if (['composer', 'artist', 'writer', 'person'].includes(type)) {
		templateKey = 'default_person_art';
		type = 'person'
	} else if (type === 'publisher') {
		templateKey = 'default_publisher_art';
	} else if (['project', 'playlist'].includes(type)) {
		templateKey = 'default_project_art';
	} else if (type === 'album') {
		templateKey = 'default_album_art';
	} else if (type === 'track') {
		templateKey = 'default_album_art';
	}
	
	let $defaultArt = globalTemplates.get(templateKey)

	// random user art
	// if (false && type == 'person') {
	// 	let userTypes = ["user-alt","user-alt-slash","user-astronaut","user-chart","user-check","user-circle","user-clock","user-cog","user-cowboy","user-crown","user-edit","user-friends","user-graduate","user-hard-hat","user-headset","user-injured","user-lock","user-md","user-md-chat","user-minus","user-music","user-ninja","user-nurse","user-plus","user-secret","user-shield","user-slash","user-tag","user-tie","user-times"]
	// 	$defaultArt.find('.fa').removeClass('fa-user-music').addClass('fa-' + userTypes[Math.floor(Math.random() * userTypes.length)])
	// }
	
	return $defaultArt
}

function hasTouchScreen() {
	let hasTouchScreen = false;
	if ("maxTouchPoints" in navigator) {
		hasTouchScreen = navigator.maxTouchPoints > 0;
	} else if ("msMaxTouchPoints" in navigator) {
		hasTouchScreen = navigator.msMaxTouchPoints > 0;
	} else {
		const mQ = matchMedia?.("(pointer:coarse)");
		if (mQ?.media === "(pointer:coarse)") {
			hasTouchScreen = !!mQ.matches;
		} else if ("orientation" in window) {
			hasTouchScreen = true; // deprecated, but good fallback
		} else {
			// Only as a last resort, fall back to user agent sniffing
			const UA = navigator.userAgent;
			hasTouchScreen =
				/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
				/\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
		}
	}
	
	return hasTouchScreen;
}

async function urlToFile(url, filename = null, mimeType = null) {
	if (!mimeType) {
		const response = await fetch(url, { method: 'HEAD' });
		mimeType = mimeType || response.headers.get('Content-Type');
	}
	if (!mimeType) {
		throw new Error('Unable to determine MIME type');
	}

	let extension = mimeType.split('/').pop();
	const timestamp = Date.now();
	
	if (!filename) {
	  filename = `${timestamp}.${extension}`;
	}

	const dataResponse = await fetch(url);
	const buffer = await dataResponse.arrayBuffer();
	return new File([buffer], filename, { type: mimeType });
}

var BrowserDetect = {
	init: function () {
		var ua = navigator.userAgent.toLowerCase();
		this.ua = ua;

		this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
		this.version = this.searchVersion(navigator.userAgent)
			|| this.searchVersion(navigator.appVersion)
			|| "an unknown version";
		this.OS = this.searchString(this.dataOS) || "an unknown OS";
		this.isMobile = function() {
			// Modern approach (supported in newer browsers)
			if (navigator.userAgentData) {
				return navigator.userAgentData.mobile;
			}

			// Fallback for older browsers
			const userAgent = navigator.userAgent.toLowerCase();
			const mobileKeywords = [
				'android', 'webos', 'iphone', 'ipad', 'ipod',
				'blackberry', 'windows phone', 'mobile'
			];

			return mobileKeywords.some(keyword => userAgent.includes(keyword));
		};
		this.isIpad = navigator.platform.match(/iPad/i) || navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)
		this.isTouchDevice = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
		// browser name
		this.isIE        = ( (ua.indexOf("msie") != -1 || ua.indexOf('trident') != -1) && (ua.indexOf("opera") == -1) && (ua.indexOf("webtv") == -1) );
		this.isIE11		 = !!window.MSInputMethodContext && !!document.documentMode;
		this.isSafari    = ua.indexOf('applewebkit') != -1 && ua.indexOf('safari') != -1;
		this.isChrome    = this.isSafari && ua.indexOf('chrome') != -1;
		this.isCrawler   = ua.indexOf('googlebot') != -1;
		this.isEdge      = ua.indexOf(' edge/') != -1;
		this.isFirefox   = ua.indexOf('firefox') != -1;
		this.isAdobePanel = ua === 'adobepanel';

		if (this.isChrome) {
			this.isSafari = false;
		}

		if (this.isEdge) {
			this.isChrome = false;
		}

		var browserString = 'browser_';
		if (this.isIE) {
			browserString += 'ie';
		} else if (this.isChrome) {
			browserString += 'chrome';
		} else if (this.isSafari) {
			browserString += 'safari';
		} else if (this.isEdge) {
			browserString += 'edge';
		} else if (this.isFirefox) {
			browserString += 'firefox';
		}
		$j('html').addClass(browserString);

		// browser version
		this.versionMinor = parseFloat(navigator.appVersion);

		// correct version number for IE4+
		if (this.isIE && this.versionMinor >= 4) {
			var msieIndex = ua.indexOf('msie ');
			if (msieIndex !== -1) {
				this.versionMinor = parseFloat(ua.substring(msieIndex + 5));
			} else {
				this.versionMinor = parseFloat(ua.substring(ua.indexOf('rv:') + 3));
			}
		}

		this.versionMajor = parseInt(this.versionMinor);

		// platform
		this.isWin = (ua.indexOf('win') != -1);
		// this.isWin32 = (this.isWin && ( ua.indexOf('95') != -1 || ua.indexOf('98') != -1 || ua.indexOf('nt') != -1 || ua.indexOf('win32') != -1 || ua.indexOf('32bit') != -1) );
		this.isWindowsXP = ua.indexOf('nt 5.') != -1;
		this.isMac = this.OS === 'Mac';

		// this.isIE4x = (this.isIE && this.versionMajor == 4);
		// this.isIE4up = (this.isIE && this.versionMajor >= 4);
		// this.isIE5x = (this.isIE && this.versionMajor == 5);
		// this.isIE55 = (this.isIE && this.versionMinor == 5.5);
		// this.isIE5up = (this.isIE && this.versionMajor >= 5);
		// this.isIE6down = (this.isIE && this.versionMajor <= 6);
		// this.isIE6x = (this.isIE && this.versionMajor == 6);
		// this.isIE6up = (this.isIE && this.versionMajor >= 6);
		// this.isIE7x = (this.isIE && this.versionMajor == 7);
		// this.isIE7up = (this.isIE && this.versionMajor >= 7);
		// this.isIE7down = (this.isIE && this.versionMajor <= 7);
		// this.isIE8x = (this.isIE && this.versionMajor == 8);
		// this.isIE8up = (this.isIE && this.versionMajor >= 8);
		this.isIE8down = (this.isIE && this.versionMajor <= 8);
		// this.isIE9up = (this.isIE && this.versionMajor >= 9);
		//this.isIE9down = (this.isIE && this.versionMajor <= 9);
		this.isIE10down = (this.isIE && this.versionMajor <= 10);

		// this.isIE4xMac = (this.isIE4x && this.isMac);

		this.isBot = ua.match(/bot|crawler|spider|crawling/i);
	},
	searchString: function (data) {
		for (var i = 0; i < data.length; i++) {
			var dataString = data[i].string;
			var dataProp = data[i].prop;
			this.versionSearchString = data[i].versionSearch || data[i].identity;
			if (dataString) {
				if (dataString.indexOf(data[i].subString) != -1)
					return data[i].identity;
			}
			else if (dataProp)
				return data[i].identity;
		}
	},
	searchVersion: function (dataString) {
		var index = dataString.indexOf(this.versionSearchString);
		if (index == -1) return;
		return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
	},
	dataBrowser: [
		{
			string: navigator.userAgent,
			subString: "Chrome",
			identity: "Chrome"
		},
		{
			string: navigator.userAgent,
			subString: "OmniWeb",
			versionSearch: "OmniWeb/",
			identity: "OmniWeb"
		},
		{
			string: navigator['vendor'],
			subString: "Apple",
			identity: "Safari"
		},
		{
			prop: window.opera,
			identity: "Opera"
		},
		{
			string: navigator['vendor'],
			subString: "iCab",
			identity: "iCab"
		},
		{
			string: navigator['vendor'],
			subString: "KDE",
			identity: "Konqueror"
		},
		{
			string: navigator.userAgent,
			subString: "Firefox",
			identity: "Firefox"
		},
		{
			string: navigator['vendor'],
			subString: "Camino",
			identity: "Camino"
		},
		{		// for newer Netscapes (6+)
			string: navigator.userAgent,
			subString: "Netscape",
			identity: "Netscape"
		},
		{
			string: navigator.userAgent,
			subString: "MSIE",
			identity: "Explorer",
			versionSearch: "MSIE"
		},
		{
			string: navigator.userAgent,
			subString: "Gecko",
			identity: "Mozilla",
			versionSearch: "rv"
		},
		{ 		// for older Netscapes (4-)
			string: navigator.userAgent,
			subString: "Mozilla",
			identity: "Netscape",
			versionSearch: "Mozilla"
		}
	],
	dataOS: [
		{
			string: navigator.platform,
			subString: "Win",
			identity: "Windows"
		},
		{
			string: navigator.platform,
			subString: "Mac",
			identity: "Mac"
		},
		{
			string: navigator.platform,
			subString: "Linux",
			identity: "Linux"
		}
	]

};
BrowserDetect.init();

/**
 * Gets a color out of the css
 * @param {string} className the name of the class to get the color from. Gets the value of the background-color. If it starts with #, assumes an id instead
 * @param {boolean} [forceConcise=false] if true, will force the returned string into #FFFFFF format even if the browser returns rgb(...)
 * @param {string} [style=background-color] which style to load
 * @return {string} the color, ready to be used. Formatted like rgb(255, 255, 255) or #FFFFFF, depending on your browser
 */
function getCSSColor(className, forceConcise, style) {
	var index = 'colors_' + className;
	// we cache these so we don't have to do this over and over again (each waveform makes 4 requests)
	if (window[index]) {
		return forceConcise ? convertCSSColor(window[index]) : window[index];
	}
	// in firefox, you can get the color without adding to body. chrome just returns '' though
	var ref = $j('<div id="' + (className.indexOf('#') === 0 ? className.substring(1) : 'css_ref') + '" class="' + className + '"></div>');
	$j('body').append(ref);
	if (!style) {
		style = 'background-color';
	}
	window[index] = ref.css(style);
	ref.remove();
	return forceConcise ? convertCSSColor(window[index]) : window[index];
}

/**
 * Converts a color string from whatever format it's in into #FFFFFF format
 * @param {string} color the color string to convert
 * @param {boolean=} returnOpacity
 * @returns {string} converted string
 */
function convertCSSColor(color, returnOpacity) {
	var matches = color.match(/rgba?\(([0-9]+), *([0-9]+), *([0-9]+)(?:, ([0-9]+))?\)/);
	if (matches) {
		var r = parseInt(matches[1]).toString(16),
			g = parseInt(matches[2]).toString(16),
			b = parseInt(matches[3]).toString(16),
			a = matches[4];
		color = '#' + (r.length < 2 ? '0' : '') + r + (g.length < 2 ? '0' : '') + g + (b.length < 2 ? '0' : '') + b;
	}
	return returnOpacity ? (a ? parseInt(a) : 1) : color;
}

/**
 * Use this function to get an entry out of the config's dictionary
 * 	It provides a number of helper parameters to name dealing with dictionary entries easier
 *  If an item isn't found in the dictionary, it is returned as sent in with the appropriate pluralization and case
 * @param {string} name the name of the entry to load. For example, label or album
 * @param {boolean} [plural=false] should the entry be pluralized? Defaults to no
 * @param {boolean} [lowercase=false] should the entry be all lowercase? Defaults to first letter capitalized on word boundaries
 * @return {string} the dictionary entry, formatted as specified
 */
config.getDictionaryEntry = function (name, plural, lowercase) {
	var dict = config.dictionary[name],
		entry = '';
	if (typeof plural == 'object') {
		plural = plural['plural'] === true;
		lowercase = plural['lowercase'] === true;
	}
	if (dict) {
		if (plural) entry = dict['plural'];
		else entry = dict['singular'];
	} else {
		if (name == 'writers') {
			entry = 'Writer';
		} else if (name == 'publishers') {
			entry = 'Publisher';
		} else if (name == 'isrc' || name == 'iswc' || name == 'bpm') {
			entry = name.toUpperCase();
		} else if (name.toLowerCase() == 'images') {
			entry = 'Image';
		} else if (name.toLowerCase() == 'docs') {
			entry = 'Doc'
		} else if (name.toLowerCase() == 'icons') {
			entry = 'Icon'
		} else if (name.toLowerCase() == 'notes') {
			entry = 'Note'
		} else {
			entry = name;
		}
		if (plural) entry += 's';
	}
	if (lowercase) entry = entry.toLowerCase();
	else entry = ucwords(entry);
	return entry;
};

/**
 * Use this function to reverse a dictionary lookup, getting the standard SA term for a customized term
 * @param {string} name the name of the entry to look for. can be any case and singular or plural
 * @return {string} the dictionary entry, lowercase and singular, or just the name var if it wasn't found in the dictionary
 */
config.getReverseDictionaryEntry = function (name) {
	var dict = config.dictionary,
		lookup = name.toLowerCase();
	for (var entry in dict) {
		if (!dict.hasOwnProperty(entry)) continue;
		if (dict[entry]['singular'].toLowerCase() == lookup || dict[entry]['plural'].toLowerCase() == lookup) {
			return entry;
		}
	}
	return lookup;
};

/**
 * Shortcut for the config.getDictionaryEntry function because I can <i>never</i> remember the order of parameters
 * @param {string} name the name of the entry to lookup
 * @param {object=} options supports plural : (boolean} and 'case' : (upper|lower)
 * @returns {string} the dictionary entry
 */
function gde(name, options) {
	if (!options) options = {};
	if (options.c) options['case'] = options.c;
	if (options.p) options.plural = options.p;
	options = $j.extend({ plural: false, 'case': 'upper' }, options);
	return config.getDictionaryEntry(name, options.plural, options['case'] == 'lower');
}

function dateStringToTimestamp(dateString) {
	var parts, date;

	if (1 === config.dateFormat) {
		parts = dateString.split('/');
		date = new Date(parts[2] + "/" + parts[1] + "/" + parts[0]);
	} else {
		date = new Date(dateString);
	}

	return date.getTime() / 1000;
}

/**
 * Performs an action when export.php has finished processing and has begun
 * sending a file to the user.
 *
 * @param {Function} onDownloadCallback A function to be executed when the
 *     download has begun. This function is called with zero arguments.
 * @param {int=} nonce A unique number associated with this event. Optional;
 *     defaults to the current UNIX timestamp.
 * @return {int} The nonce to pass to export.php. If the nonce argument is
 *     provided, the same value is returned.
 */
function attachOnExportDownloadEventHandler(onDownloadCallback, nonce) {
	if (undefined === nonce) {
		nonce = new Date().getTime();
	}

	(function (timestamp, callback) {
		var cookieName = 'download_' + timestamp,
			regexp = new RegExp(cookieName),
			interval, intervalClear;

		intervalClear = function () {
			clearInterval(interval);
			$j(window).off("hashchange", intervalClear);
		};

		interval = setInterval(function () {
			if (regexp.test(document.cookie)) {
				intervalClear();
				document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
				callback();
			}
		}, 1000);

		$j(window).on("hashchange", intervalClear);
	}(nonce, onDownloadCallback));

	return nonce;
}

/*
  jQuery deparam is an extraction of the deparam method from Ben Alman's jQuery BBQ
  http://benalman.com/projects/jquery-bbq-plugin/
  https://github.com/chrissrogers/jquery-deparam/blob/master/jquery-deparam.js
*/
(function ($) {
	$.deparam = function (params, coerce) {
		var obj = {},
			coerce_types = { 'true': !0, 'false': !1, 'null': null };

		// Iterate over all name=value pairs.
		$.each(params.replace(/\+/g, ' ').split('&'), function (j, v) {
			var param = v.split('='),
				key = decodeURIComponent(param[0]),
				val,
				cur = obj,
				i = 0,

				// If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
				// into its component parts.
				keys = key.split(']['),
				keys_last = keys.length - 1;

			// If the first keys part contains [ and the last ends with ], then []
			// are correctly balanced.
			if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
				// Remove the trailing ] from the last keys part.
				keys[keys_last] = keys[keys_last].replace(/\]$/, '');

				// Split first keys part into two parts on the [ and add them back onto
				// the beginning of the keys array.
				keys = keys.shift().split('[').concat(keys);

				keys_last = keys.length - 1;
			} else {
				// Basic 'foo' style key.
				keys_last = 0;
			}

			// Are we dealing with a name=value pair, or just a name?
			if (param.length === 2) {
				val = decodeURIComponent(param[1]);

				// Coerce values.
				if (coerce) {
					val = val && !isNaN(val) ? +val              // number
						: val === 'undefined' ? undefined         // undefined
							: coerce_types[val] !== undefined ? coerce_types[val] // true, false, null
								: val;                                                // string
				}

				if (keys_last) {
					// Complex key, build deep object structure based on a few rules:
					// * The 'cur' pointer starts at the object top-level.
					// * [] = array push (n is set to array length), [n] = array if n is
					//   numeric, otherwise object.
					// * If at the last keys part, set the value.
					// * For each keys part, if the current level is undefined create an
					//   object or array based on the type of the next keys part.
					// * Move the 'cur' pointer to the next level.
					// * Rinse & repeat.
					for (; i <= keys_last; i++) {
						key = keys[i] === '' ? cur.length : keys[i];
						cur = cur[key] = i < keys_last
							? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : [])
							: val;
					}

				} else {
					// Simple key, even simpler rules, since only scalars and shallow
					// arrays are allowed.

					if (obj[key] && obj[key].isArray) {
						// val is already an array, so push on the next value.
						obj[key].push(val);

					} else if (obj[key] !== undefined) {
						// val isn't an array, but since a second value has been specified,
						// convert val into an array.
						obj[key] = [obj[key], val];

					} else {
						// val is a scalar.
						obj[key] = val;
					}
				}

			} else if (key) {
				// No value was defined, so set something meaningful.
				obj[key] = coerce
					? undefined
					: '';
			}
		});

		return obj;
	};
})(jQuery);

/**
 * Gets some html that will display the user's avatar. The html tag is an <a> so you pass in the href link
 * @param {object} userData
 * @param {string} link
 * @returns {string}
 */
sa.generateUserAvatarHtml = function (userData, link) {
	if (userData.image && userData.image.indexOf('default_editor') === -1) {
		return '<a class="user_avatar" href="' + link + '"><img src="' + userData.image + '" alt="user image"/></a>';
	} else {
		return '<a class="user_avatar fas fa-user-circle" href="' + link + '"></a>';
	}
};

/**
 * Attaches a click listener to the element and alternates between calling two functions
 * @param {function} firstClick
 * @param {function} secondClick
 */
jQuery.fn.toggleClick = function (firstClick, secondClick) {
	let clicked = false;
	return jQuery(this).on('click', function () {
		if (clicked) {
			secondClick();
		} else {
			firstClick();
		}
		clicked = !clicked;
	});
};

/**
 * Takes the config object and checks for a currency property
 * @param {Object} config
 * @return {Object} currency data object
 */
function getCurrencyInfo(config) {
	let currencyString = (config.licensingConfig ? config.licensingConfig.currency : false) || 'USD - United States Dollar - $ - h';
	let currencyData = currencyString.split('-').map(piece => {
		return piece.trim();
	});

	return {
		code: currencyData[0].toLowerCase(),
		name: currencyData[1]
	}
}

function formatCurrency(config, price) {
	var currency = getCurrencyInfo(config);
	return (new Currency(currency.code, parseFloat(price), false)).getResult();

}

/**
 * Adding support/polyfill for String.includes
 */
if (!String.prototype.includes) {
	String.prototype.includes = function (search, start) {
		'use strict';

		if (search instanceof RegExp) {
			throw TypeError('first argument must not be a RegExp');
		}
		if (start === undefined) { start = 0; }
		return this.indexOf(search, start) !== -1;
	};
}

/**
 * Adding support/polyfill for String.endsWith
 */
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function(search, this_len) {
		if (this_len === undefined || this_len > this.length) {
			this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	};
}

// Is there e-commerce?
var hasEcommerce = config.licensingConfig && config.licensingConfig.show;
// Is downloading available?
var ecommerceDownloadAvailable = hasEcommerce ? config.licensingConfig.options.downloadAvailable : true;

// Get current user id
function getCurrentUserId() {
	return (window.user && window.user.hasOwnProperty('userData')) ? window.user.userData.id : null;
}

let safeFunctionEval = (fnStr) => Function('"use strict;";return ' + fnStr)();


function classFromType(type, data) {
	console.log("dictionary type", gde(type))
	switch (type) {
		case 'catalog':
			return new Catalog(data)
		case 'label':
			return new Label(data)
		case 'writer':
			return new Writer(data)
		case 'publisher':
			return new Publisher(data)
		case 'artist':
			return new Artist(data)
		case 'album':
			return new Album(data)
	}
	return false;
}
const extractImageColors = (imgSrcOrEl, opts = {}) => {
	return loadScriptPromise(ExtraScripts.vibrant, true).then(() => new Promise((resolve, reject) => {
		try {
			console.log("extracting image colors from", imgSrcOrEl)
			console.time('extract image colors')
			/**
			 * NOTE: tried to use WebWorker from the docs https://github.com/Vibrant-Colors/node-vibrant
			 * but it wouldn't work on any version up to and including 3.2.1 alpha
			 */
			const vibrant = new Vibrant(imgSrcOrEl, opts)
			vibrant.getPalette(function (err, palette) {
				// vibrant.getPalette(function (err, palette) {
				if (err) {
					console.error("[extractimagecolors] error getting palette from", imgSrcOrEl, err)
					return reject(err)
				} 
				// sort the colors by how often the colors exist in the image "population"
				const sortByPopulation = Object.keys(palette).filter(k => palette[k] && palette[k].getPopulation).map(k => {
					return {
						key: k,
						population: palette[k].getPopulation(),
						hex: palette[k].getHex()
					}
				})
				sortByPopulation.sort((a,b) => b.population - a.population)
				console.log('extract image colors', sortByPopulation)
				console.timeEnd('extract image colors')

				resolve(sortByPopulation)
			});
		} catch (e) {
			console.error("[extractimagecolors] could not get dominant colors from image", imgSrcOrEl, e)
			resolve([])
		}
	}))

}



// Background videos and background image
(function ($) {
	$.fn.addBackgroundImage = function (url, options = {}) {
		const self = this;
		const defaults = {
			attachment: 'scroll',
			size: 'cover',
			repeat: 'no-repeat',
			position: 'center center',
			fixedScrollSpeed: 0.5,
			fixedExtraHeightPercent: 25,
			fixedStartScrollPxAbove: false, // default
			direction: 'down',
		}

		options = _.extend(defaults, options);
		
		this.addClass('bg-img');

		const isMobile = android || ios || options.fixedScrollSpeed == 1;

		if (options.attachment == 'fixed') {
			// add bg element
			this.bgImageFixed = $j(`<div class="bg-img-fixed"><img src="${url}" /></div>`);
			this.bgImageFixed.find('img').first()[0].addEventListener('load', function() {
				self.naturalHeight = this.naturalHeight;
				self.naturalWidth = this.naturalWidth;
				onRendered.bind(self)();
			})
			this.prepend(this.bgImageFixed)
	
		} else {
			this.css({
				backgroundImage: `url(${url})`,
				backgroundAttachment: options.attachment == 'fixed' ? 'scroll' : options.attachment,
				backgroundSize: options.size,
				backgroundRepeat: options.repeat,
				backgroundPosition: options.position,
			})
		}

		/**
		 * FIXED POSITION PARALLAX SCROLLING LOGIC
		 */
		const getFocusPosition = (width, height) => {
			const focusXPerc = options.position ? parseInt(options.position.split(' ').shift()) : 50;
			const focusYPerc = options.position ? parseInt(options.position.split(' ').pop()) : 50;
			return {
				x: {
					px: (focusXPerc / 100) * width,
					perc: focusXPerc
				},
				y: {
					px: (focusYPerc / 100) * height,
					perc: focusYPerc
				},
			}
		}


		const requestFrame = window.requestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					window.msRequestAnimationFrame ||
					window.oRequestAnimationFrame ||
					function(callback){ return setTimeout(callback, 1000 / 60); };

		/**
		 * Set the image size on resize and orientation change
		 */
		const setFixedImageSize = () => {
			self.wrapperWidth = this[0].clientWidth;
			self.wrapperHeight = this[0].clientHeight;
			self.wrapperLeft = this.offset().left;
			self.wrapperRight = self.wrapperLeft + self.wrapperWidth;
			self.wrapperTop = this.offset().top;
			self.wrapperBottom = self.wrapperTop + self.wrapperHeight;
			const wrapperMiddle = self.wrapperBottom - (self.wrapperHeight / 2);
			const wrapperMiddleX = (self.wrapperWidth / 2) + self.wrapperLeft;
			
			const startMultiplier = 2;
			let regionTop = self.wrapperTop - (startMultiplier * self.wrapperHeight);
			regionTop = regionTop < 0 ? 0 : regionTop;
			self.scrollRegionTop = regionTop;


			let bgWidth = self.wrapperWidth;
			let bgHeight = bgWidth * (self.naturalHeight / self.naturalWidth);
			const extraHeightMultiplier = 1 + (options.fixedExtraHeightPercent / 100);
			const aspectRatio = bgWidth / bgHeight;

			if (isMobile) {
				// height needs to be nav container + branding header + the size of the actual heading
				// for the position: fixed fallback
				const fixedBgHeight = ($j('#nav_container').length ? $j('#nav_container').height() : 0) +
							($j('#branding_header').length ? $j('#branding_header').height() : 0) +
							($j('#heading').length ? $j('#heading').height() : 0);

				if (bgHeight < fixedBgHeight) {
					bgHeight = fixedBgHeight;
					bgWidth = aspectRatio * bgHeight;
				}

			} else if (bgHeight / self.wrapperHeight < extraHeightMultiplier) {
				// set width to something bigger
				bgHeight = extraHeightMultiplier * self.wrapperHeight;
				bgWidth = aspectRatio * bgHeight;
				self.bgImageFixed[0].style.width = `${bgWidth}px`;

			} else if (self.bgImageFixed[0].style.width) {
				self.bgImageFixed[0].style.width = '';
			}
			// now check where the focus position is in relation to the edges of the viewport
			const bgLeft = self.wrapperLeft;
			const bgRight = bgLeft + bgWidth;
			const bgBottom = self.wrapperTop + bgHeight;
			const bgTop = self.wrapperTop;
			const bgMiddleX = (bgWidth / 2) + bgLeft;
			const bgMiddleY = (bgHeight / 2) + bgTop;
			
			const focusPos = getFocusPosition(bgWidth, bgHeight);
			const bgFocusX = focusPos.x.px + bgLeft;
			const bgFocusY = focusPos.y.px + bgTop;
			
			const moveRight = bgFocusX <= wrapperMiddleX;
			const moveUp = bgFocusY >= wrapperMiddle;
			// offset X
			let offsetX = 0;
			if (moveRight) {
				offsetX = Math.min(Math.abs(wrapperMiddleX - bgFocusX), Math.abs(bgLeft - self.wrapperLeft));
			} else {
				offsetX = Math.min(Math.abs(wrapperMiddleX - bgFocusX), Math.abs(bgRight - self.wrapperRight)) * -1;
			}

			let offsetY = 0;
			if (moveUp) {
				offsetY = Math.min(Math.abs(wrapperMiddle - bgFocusY), Math.abs(bgBottom - self.wrapperBottom)) * -1;
			} else {
				offsetY = Math.min(Math.abs(wrapperMiddle - bgFocusY), Math.abs(bgTop - self.wrapperTop))
				// if no offset give it a little space to scroll
				if (offsetY == 0) {
					offsetY = -25;
				}
			}

			self.initialYOffset = Math.floor(offsetY);
			self.initialXOffset = Math.floor(offsetX);

			if (isMobile) {
				// position fixed fallback
				const topBarOffset = $j('#top_bar').length ? $j('#top_bar').height() : 0;
				let fixedTop = self.wrapperTop + offsetY;
				fixedTop =  fixedTop > topBarOffset ? topBarOffset : fixedTop;
				self[0].style.clipPath = 'inset(0 0 0 0)';
				self.bgImageFixed.css({
					position: 'fixed',
					top: fixedTop,
					width: bgWidth,
					left: self.wrapperLeft + offsetX,
				})
			} else {
				self.bgImageFixed[0].style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0`;
			}
	
			requestingResize = false;

		}

		/**
		 * Update focus positioning on scroll
		 */
		const updateFocus = () => {
			let speed = options.fixedScrollSpeed;
			speed = (options.direction == 'down' ? 1 : -1) * speed;
			
			// distance in frame is y = mx + b where m is speed, x is position in frame and b is offset
			let newOffset = (speed * (window.scrollY - self.scrollRegionTop)) + self.initialYOffset;
			const maxDiff = Math.abs(self.wrapperHeight - self.bgImageFixed.find('img').first()[0].clientHeight);

			if (Math.abs(newOffset) > maxDiff) {
				newOffset = newOffset < 0 ? -1 * maxDiff : maxDiff;
			}
			newOffset = Math.floor(newOffset);

			if (options.direction == 'down' && newOffset > 0) {
				newOffset = 0;
			} else if (options.direction == 'up' && (Math.abs(newOffset) > maxDiff)) {
				newOffset = maxDiff * (newOffset < 0 ? -1 : 1);
			}
			self.bgImageFixed[0].style.transform = `translate3d(${self.initialXOffset}px, ${newOffset}px, 0)`;
			requestingScroll = false;
		}
		let preventResize = false;
		let requestingResize = false;
		const resizeImageHeight = () => {
			if (!requestingResize && !preventResize) {
				requestingResize = true;
				requestFrame(setFixedImageSize);
			}
		}

		let requestingScroll = false;
		const disablePreventResize = _.debounce(function() {
			preventResize = false;
		}, 250);
		const scrollHandler = () => {
			preventResize = true;
			if (!requestingScroll) {
				requestingScroll = true;
				requestFrame(updateFocus)
			}

			// stops resizing from happening while scrolling, will only actually run after 250 ms after scroll has stopped
			disablePreventResize();
		}

	
		function onRendered() {

			if (options.attachment == 'fixed') {
				resizeImageHeight();
				$j(window).on("resize", _.debounce(resizeImageHeight, 50));
				$j(window).on("orientationchange",  _.debounce(resizeImageHeight, 50));
				$j(document).off('scroll.bgimg')
				
				if (!isMobile) {
					$j(document).on('scroll.bgimg', scrollHandler);
				}
			}
		}

		return this;
	}


	$.fn.addBackgroundVideo = function (srcs, options) {
		options = _.assign({
			autoplay: true,
			loop: true,
			muted: true,
			controls: false,
			preload: 'auto',
			playsinline: true,
			poster: '',
			position: 'center',
		}, options)


		const $wrapper = $('<div class="bg-video"></div>');

		const $root = $j('<video>Your browser does not support the video tag.</video>');

		for (let obj of srcs) {
			$root.append(`<source src="${obj.src}" type="${obj.type}"></source>`);
		}

		let html5Opts = _.pick(options, ['autoplay', 'muted', 'loop', 'controls', 'playsinline', 'poster', 'preload']);

		for (const [key, val] of Object.entries(html5Opts)) {
			$root[0][key] = val;
		}
		
		// Append the video
		$wrapper.append($root);

		// Add position class (top, bottom, center)
		$wrapper.addClass('bg-' + options.position);
		this.prepend($wrapper);
		this.bgVideo = $root;

		const video = $root[0];
		video.addEventListener("loadedmetadata", function (e) {
			var vidWidth = this.videoWidth,
				vidHeight = this.videoHeight;
			// $root.css({
			// 	paddingTop: (vidHeight / vidWidth) * 100 + '%'
			// })
		}, false);

		if (this.css('position') == 'static') {
			this.css('position', 'relative');
		}
		this.addClass('bg-img-vid-wrapper');
		// TODO: add other options
		return this;
	}
})(jQuery)

// Helper
function getOptionsDropDown(id, type, itemInfo, download = false) {
	let baseUrl = siteBaseUrl();

	let licenseNowText = config.id === 7494 ? 'Request License' : 'License Now'; // change for Netflix #4293
	let optionsMenuItems = [
		{ name: 'Track Options', heading: true },
		{ name: 'Details', href: 'track/' + id },
		{ name: 'Email', onClick: function () { if (lockdown) { return sa.showLockdownMessage(); } sa.components.emailer.show({ type: type, item: itemInfo }); } },
	];
	if (config.showSonicSearch) {
		optionsMenuItems.push({ name: 'Similar Tracks', href: baseUrl + '/sonicsearch?track_search=' + id });
	} else {
		optionsMenuItems.push({ name: 'Similar Tracks', href: baseUrl + '/tracks?sim=' + id });
	}
	
	if (download) {
		// let downloader = 
		let downloadOption = {
			name: "Download",
			custom: $j('<div class="option download">Download</div>')
		}
		optionsMenuItems.splice(1, 0, downloadOption);
	}
	
	let loadLicensingProfile = false;
	if (config.showLicensing && (config.id != 49 && config.id != 118 && config.id != 104 && config.id != 225 && config.id != 162)) {
		if (config.licensingConfig && config.licensingConfig.show) {
			loadLicensingProfile = true;
		} else if (!config.licensing['full_licensing']) {
			optionsMenuItems.push({
				name: licenseNowText,
				onClick: function () {
					var modal = new LicenseNowModal();
					modal.trackId = id;
					modal.init();
				}
			});
		} else {
			optionsMenuItems.push({
				name: licenseNowText,
				href: 'license_now?id=' + id
			});
		}
	}

	let optionsMenu = new sa.components.OptionsMenu({
		items: optionsMenuItems,
		hideOnMouseLeave: true,
		hideOnOutsideClick: !!sa.isMobile(),
	});

	if (loadLicensingProfile) {
		licensingModal.getProfile(itemInfo, function (profile) {
			if (!profile || profile.notfound) {
				return;
			}
			optionsMenu.addItem({
				name: licenseNowText,
				onClick: function (e) {
					licensingModal.show(profile, itemInfo, e);
				}
			});
		});
	}

	return optionsMenu.getAnchor();
}

function attachDownloadOptionToOptionsMenu(optionsDropdown, downloadMenu) {
	downloadMenu.addClass('options_download');

	optionsDropdown.getContainer().find('.option.download').click(function (e) {
		e.stopPropagation();
		downloadMenu.show();
		downloadMenu.on('mouseleave', function () {
			downloadMenu.hide();
		})
		$j('body').on('click', function (e) {
			if ($j(e.target).closest(downloadMenu).length === 0) {
				downloadMenu.hide();
			}
		})
	});
	
	return optionsDropdown;
}

// Color Functions
const rgba2Hex = (rgba) => `#${rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/).slice(1).map((n, i) => (i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n)).toString(16).padStart(2, '0').replace('NaN', '')).join('')}`
const rgb2hex = (rgb) => `#${rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/).slice(1).map(n => parseInt(n, 10).toString(16).padStart(2, '0')).join('')}`
const invertHex = (hex) => (Number(`0x1${hex}`) ^ 0xFFFFFF).toString(16).substr(1).toUpperCase();
function luminance(r, g, b) {
    var a = [r, g, b].map(function (v) {
        v /= 255;
        return v <= 0.03928
            ? v / 12.92
            : Math.pow( (v + 0.055) / 1.055, 2.4 );
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

/**
 * Gets text contrast ratios between colors as described here:
 * https://webaim.org/resources/contrastchecker/
 * 
 * WCAG 2.0 level AA requires a contrast ratio of at least 4.5:1 for normal text and 3:1 for large text. 
 * WCAG 2.1 requires a contrast ratio of at least 3:1 for graphics and user interface components (such as form input borders). 
 * WCAG Level AAA requires a contrast ratio of at least 7:1 for normal text and 4.5:1 for large text.
 * 
 * @param {array} rgb1 Array where first element is R, second is G, third is B
 * @param {array} rgb2 
 * @returns 
 */
function colorContrastRatio(rgb1, rgb2) {
    var lum1 = luminance(rgb1[0], rgb1[1], rgb1[2]);
    var lum2 = luminance(rgb2[0], rgb2[1], rgb2[2]);
    var brightest = Math.max(lum1, lum2);
    var darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}

function hexToRgb(hex) {
	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
	return result ? {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16)
	} : null;
}

function getGlobalDynamicHeaderBgColorSetting() {
	// this allows us to set the default for all calls (false)
	return _.get(config, 'theme.bannersDynamicBackground', false);
}

/**
 * This function checks if an element is within the same X/Y bounding box area as a secondary element
 * It does not check if the elements have a parent->child relationship.
 * 
 * @param {HTMLElement} el1 The element that is being checked as inside the other element
 * @param {HTMLElement} el2 The element that the previous element is inside
 * @param {function} insideFn
 * @param {function} outsideFn
 * @returns {boolean} If the first element is inside the other element
 */
const elementInsideElement = (
	el1, 
	el2, 
	insideFn = () => {}, 
	outsideFn = () => {}
) => {
	const el1BoundingInfo = el1.getBoundingClientRect();
	const el2BoundingInfo = el2.getBoundingClientRect();

	const top = el1BoundingInfo.top >= el2BoundingInfo.top;
	const right = el1BoundingInfo.right <= el2BoundingInfo.right;
	const bottom = el1BoundingInfo.bottom <= el2BoundingInfo.bottom;
	const left = el1BoundingInfo.left >= el2BoundingInfo.left;
	
	const isInside = top && right && bottom && left;
	
	if (isInside) {
		insideFn();
	} else {
		outsideFn();
	}
	
	return isInside;
};

/**
 * Check if an element in the viewport
 * 
 * @param el
 * @param {object} leewayOverrides
 * @returns {boolean}
 */
function isElementInViewport (el, leewayOverrides = {}) {
	const leeway = {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...leewayOverrides
	};
	
	// Special bonus for those using jQuery
	if (typeof $j === "function" && el instanceof $j) {
		el = el[0];
	}

	let rect = el.getBoundingClientRect();

	return (
		(rect.top + leeway.top) >= 0 &&
		(rect.left + leeway.left) >= 0 &&
		(rect.bottom + leeway.bottom) <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
		(rect.right + leeway.right) <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
	);
}

function getElementDimensionInfo(el) {
	// Special bonus for those using jQuery
	if (typeof $j === "function" && el instanceof $j) {
		el = el[0];
	}

	return el.getBoundingClientRect();
}

function uuidv4() {
	return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
		(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	);
}

/**
 * Create an abort controller for removing an event listener or multiple listeners
 * @see https://css-tricks.com/using-abortcontroller-as-an-alternative-for-removing-event-listeners/
 * @param {string} key A key to group the events by
 * @param forceNew
 * @returns {any}
 */
function registerEventAbortController(key, forceNew = false) {
	if (!window.eventRegistry) {
		window.eventRegistry = new Map();
	}
	
	if (!window.eventRegistry.has(key) && !forceNew) {
		window.eventRegistry.set(key, new AbortController());
	} else {
		window.eventRegistry.set(key, new AbortController());
	}
	
	return window.eventRegistry.get(key);
}

/**
 * Get an abort controller for removing an event listener or listeners
 * 
 * @param key
 * @returns {any|boolean}
 */
function getEventAbortController(key) {
	if (!window.eventRegistry) return false;
	
	if (!window.eventRegistry.has(key)) return false;
	
	return window.eventRegistry.get(key);
}

/**
* Check if var is numeric
* Since jQuery.isNumeric was deprecated, we needed an alternative.
* Stolen from here: https://github.com/jquery/jquery/blob/bf48c21d225c31f0f9b5441d95f73615ca3dcfdb/src/core.js#L206
* @param number
* @returns {boolean}
*/
function isNumeric(number) {
	return !Array.isArray(number) && (number - parseFloat(number) + 1) >= 0;
}
class Currency {
    /**
     *
     * @param {string} currencyCode 3-digit currency code (USD, ILS, etc)
     * @param {number} amount The currency amount
     * @param {boolean} showISOCode Boolean to set option for 3-digit ISO Code instead of currency symbol
     */
    constructor(currencyCode, amount, showISOCode) {
        this.currencyCode = currencyCode;
        this.amount = amount;
        this.showISOCode = showISOCode;
    }

    /**
     *
     * @returns {string} Returns the user's locale ("en", "es", "in", etc)
     */
    detectLocale() {
        let locale;
        if ("language" in navigator) {
            locale = navigator.language;
        } else if ("userLanguage" in navigator) {
            locale = navigator.userLanauge;
        } else if ("browerLanguage" in navigator) {
            locale = navigator.userLanauge;
        }

        return locale.split("-")[0];
    }

    /**
     *
     * @returns {string} Returns composite locale string ("en-US", "ca-FR", etc) for Intl.NumberFormat
     */
    buildLocaleString() {
        let locale = this.detectLocale();
        let currenciesMap = this.countryCurrencyMap();
        if (!currenciesMap.hasOwnProperty(this.currencyCode.toLowerCase())) {
            return locale + '-' + locale.toUpperCase();
        }

        let localeData = currenciesMap[this.currencyCode.toLowerCase()];
        if (Array.isArray(localeData.locale)) {
            let localeIndx = localeData.locale.indexOf(locale.toUpperCase());
            if (localeIndx > -1) {
                return locale + "-" + localeData.locale[localeIndx].toUpperCase();
            }
        } else if (localeData.hasOwnProperty('locale') && typeof localeData.locale === 'string') {
            return locale + "-" + localeData.locale;
        } else {
            return locale + "-US";
        }
    }

    /**
     * Builds and returns custom Intl.NumberFormat currency string
     * @returns {string} Returns formatted currency
     */
    getResult() {
        let localeString = this.buildLocaleString();
        let options = {
            style: "currency",
            currency: this.currencyCode,
        };

        if (this.showISOCode) {
            options['currencyDisplay'] = 'code';
        }

        let result = new Intl.NumberFormat(localeString, options).format(this.amount);
        return this.parseResult(result);
    }

    /**
     * Parses out the currency symbol or 3-digit code and wraps with styled span
     * @param result
     * @returns {string} Returns parsed currency string
     */
    parseResult(result) {
        let pattern = /([^\d,.`’\s'\u200f\u202f])/g;
        let parsedResult = result.match(pattern).join('');
        return result.replace(parsedResult, "<span class='code'>$&</span>")
    }

    /**
     * Currency / Locale Map Object
     * @returns {object} Returns object/map of currencies with their locales and names
     */
    countryCurrencyMap() {
        return {
            'dzd': { locale: "DZ", name: "Algerian Dinar" },
            'aoa': { locale: "AO", name: "Angolan Kwanza" },
            'ars': { locale: "AR", name: "Argentine Peso" },
            'amd': { locale: "AM", name: "Armenian Dram" },
            'awg': { locale: "AW", name: "Aruban Florin" },
            'aud': { locale: "AU", name: "Australian Dollar" },
            'azn': { locale: "AZ", name: "Azerbaijani Manat" },
            'bsd': { locale: "BS", name: "Bahamian Dollar" },
            'bdt': { locale: "BD", name: "Bangladeshi Taka" },
            'bbd': { locale: "BB", name: "Barbadian Dollar" },
            'byn': { locale: "BY", name: "Belarusian Ruble" },
            'bzd': { locale: "BZ", name: "Belize Dollar" },
            'bmd': { locale: "BM", name: "Bermudian Dollar" },
            'ves': { locale: "VE", name: "Bolívar Soberano" },
            'bob': { locale: "BO", name: "Bolivian Boliviano" },
            'bam': { locale: "BA", name: "Bosnia and Herzegovina Convertible Mark" },
            'bwp': { locale: "BW", name: "Botswana Pula" },
            'brl': { locale: "BR", name: "Brazilian Real" },
            'gbp': { locale: "GB", name: "British Pound" },
            'bnd': { locale: "BN", name: "Brunei Dollar" },
            'bgn': { locale: "BG", name: "Bulgarian Lev" },
            'bif': { locale: "BI", name: "Burundian Franc" },
            'khr': { locale: "KH", name: "Cambodian Riel" },
            'cad': { locale: "CA", name: "Canadian Dollar" },
            'cve': { locale: "CV", name: "Cape Verdean Escudo" },
            'kyd': { locale: "KY", name: "Cayman Islands Dollar" },
            'xaf': { locale: "CM", name: "Central African Cfa Franc"}, // "CM", "CF", "TD", "CD", "GQ", "GA"
            'xpf': { locale: "PF", name: "Cfp Franc"}, // "PF", "NC", "WF"
            'clp': { locale: "CL", name: "Chilean Peso" },
            'cny': { locale: "CN", name: "Chinese Renminbi Yuan" },
            'cop': { locale: "CO", name: "Colombian Peso" },
            'kmf': { locale: "KM", name: "Comorian Franc" },
            'crc': { locale: "CR", name: "Costa Rican Colón" },
            'hrk': { locale: "HR", name: "Croatian Kuna" },
            'czk': { locale: "CZ", name: "Czech Koruna" },
            'dkk': { locale: "DK", name: "Danish Krone" },
            'djf': { locale: "DJ", name: "Djiboutian Franc" },
            'dop': { locale: "DO", name: "Dominican Peso" },
            'xcd': { locale: "AG", name: "East Caribbean Dollar"}, // "AG", "DM", "GD", "KN", "LC", "VC", "AI", "MS"
            'egp': { locale: "EG", name: "Egyptian Pound" },
            'etb': { locale: "ET", name: "Ethiopian Birr" },
            'eur': {
                locale: ["AT", "BE", "CY", "EE", "FR", "FI", "DE", "GR", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PT", "SK", "SI", "ES"],
                name: "Euro"
            },
            'fkp': { locale: "FK", name: "Falkland Pound" },
            'fjd': { locale: "FJ", name: "Fijian Dollar" },
            'gmd': { locale: "GM", name: "Gambian Dalasi" },
            'gel': { locale: "GE", name: "Georgian Lari" },
            'ghs': { locale: "GH", name: "Ghanaian Cedi" },
            'gip': { locale: "GI", name: "Gibraltar Pound" },
            'gtq': { locale: "GT", name: "Guatemalan Quetzal" },
            'gnf': { locale: "GN", name: "Guinean Franc" },
            'gyd': { locale: "GY", name: "Guyanese Dollar" },
            'htg': { locale: "HT", name: "Haitian Gourde" },
            'hnl': { locale: "HN", name: "Honduran Lempira" },
            'hkd': { locale: "HK", name: "Hong Kong Dollar" },
            'huf': { locale: "HU", name: "Hungarian Forint" },
            'isk': { locale: "IS", name: "Icelandic Króna" },
            'inr': { locale: "IN", name: "Indian Rupee" },
            'idr': { locale: "ID", name: "Indonesian Rupiah" },
            'ils': { locale: "IL", name: "Israeli New Sheqel" },
            'jmd': { locale: "JM", name: "Jamaican Dollar" },
            'jpy': { locale: "JP", name: "Japanese Yen" },
            'kzt': { locale: "KZ", name: "Kazakhstani Tenge" },
            'kes': { locale: "KE", name: "Kenyan Shilling" },
            'kgs': { locale: "KG", name: "Kyrgyzstani Som" },
            'lak': { locale: "LA", name: "Lao Kip" },
            'lbp': { locale: "LB", name: "Lebanese Lira" },
            'lsl': { locale: "LS", name: "Lesotho Loti" },
            'lrd': { locale: "LR", name: "Liberian Dollar" },
            'ltl': { locale: "LT", name: "Lithuanian Litas" },
            'mop': { locale: "MO", name: "Macanese Pataca" },
            'mkd': { locale: "MK", name: "Macedonian Denar" },
            'mwk': { locale: "MW", name: "Malawian Kwacha" },
            'myr': { locale: "MY", name: "Malaysian Ringgit" },
            'mvr': { locale: "MV", name: "Maldivian Rufiyaa" },
            'mur': { locale: "MU", name: "Mauritian Rupee" },
            'mxn': { locale: "MX", name: "Mexican Peso" },
            'mdl': { locale: "MD", name: "Moldovan Leu" },
            'mnt': { locale: "MN", name: "Mongolian Tögrög" },
            'mad': { locale: "MA", name: "Moroccan Dirham" },
            'mzn': { locale: "MZ", name: "Mozambican Metical" },
            'nad': { locale: "NA", name: "Namibian Dollar" },
            'npr': { locale: "NP", name: "Nepalese Rupee" },
            'twd': { locale: "TW", name: "New Taiwan Dollar" },
            'nzd': { locale: "NZ", name: "New Zealand Dollar" },
            'nio': { locale: "NI", name: "Nicaraguan Córdoba" },
            'ngn': { locale: "NG", name: "Nigerian Naira" },
            'nok': { locale: "NO", name: "Norwegian Krone" },
            'pkr': { locale: "PK", name: "Pakistani Rupee" },
            'pab': { locale: "PA", name: "Panamanian Balboa" },
            'pgk': { locale: "PG", name: "Papua New Guinean Kina" },
            'pyg': { locale: "PY", name: "Paraguayan Guaraní" },
            'pen': { locale: "PE", name: "Peruvian Nuevo Sol" },
            'php': { locale: "PH", name: "Philippine Peso" },
            'pln': { locale: "PL", name: "Polish Złoty" },
            'qar': { locale: "QA", name: "Qatari Riyal" },
            'ron': { locale: "RO", name: "Romanian Leu" },
            'rub': { locale: "RU", name: "Russian Ruble" },
            'rwf': { locale: "RW", name: "Rwandan Franc" },
            'shp': { locale: "SH", name: "Saint Helenian Pound" },
            'svc': { locale: "SV", name: "Salvadoran Colón" },
            'wst': { locale: "WS", name: "Samoan Tala" },
            'std': { locale: "ST", name: "São Tomé and Príncipe Dobra" },
            'sar': { locale: "SA", name: "Saudi Riyal" },
            'rsd': { locale: "RS", name: "Serbian Dinar" },
            'scr': { locale: "SC", name: "Seychellois Rupee" },
            'sll': { locale: "SL", name: "Sierra Leonean Leone" },
            'sgd': { locale: "SG", name: "Singapore Dollar" },
            'sbd': { locale: "SB", name: "Solomon Islands Dollar" },
            'sos': { locale: "SO", name: "Somali Shilling" },
            'zar': { locale: "ZA", name: "South African Rand" },
            'krw': { locale: "KR", name: "South Korean Won" },
            'lkr': { locale: "LK", name: "Sri Lankan Rupee" },
            'srd': { locale: "SR", name: "Surinamese Dollar" },
            'szl': { locale: "SZ", name: "Swazi Lilangeni" },
            'sek': { locale: "SE", name: "Swedish Krona" },
            'chf': { locale: "CH", name: "Swiss Franc" },
            'syp': { locale: "SY", name: "Syrian Pound" },
            'tjs': { locale: "TJ", name: "Tajikistani Somoni" },
            'tzs': { locale: "TZ", name: "Tanzanian Shilling" },
            'thb': { locale: "TH", name: "Thai Baht" },
            'top': { locale: "TO", name: "Tongan Paʻanga" },
            'ttd': { locale: "TT", name: "Trinidad and Tobago Dollar" },
            'try': { locale: "TR", name: "Turkish Lira" },
            'ugx': { locale: "UG", name: "Ugandan Shilling" },
            'uah': { locale: "UA", name: "Ukrainian Hryvnia" },
            'aed': { locale: "AE", name: "United Arab Emirates Dirham" },
            'usd': { locale: "US", name: "United States Dollar" },
            'uyu': { locale: "UY", name: "Uruguayan Peso" },
            'uzs': { locale: "UZ", name: "Uzbekistani Som" },
            'vuv': { locale: "VU", name: "Vanuatu Vatu" },
            'vnd': { locale: "VN", name: "Vietnamese Đồng" },
            'xof': { locale: "BJ", name: "West African Cfa Franc"}, // "BJ", "BF", "GW", "ML", "NG", "SN", "TG", "CI"
            'yer': { locale: "YE", name: "Yemeni Rial" },
            'zmk': { locale: "ZM", name: "Zambian Kwacha" },
            'zwd': { locale: "ZW", name: "Zimbabwean Dollar" }
        }
    }
}
/**
 * A stylized alert that displays some text/html and one button
 *
 * @param {object|string} options
 * 	@property {string} text - what the box should say
 * 	@property {string} buttonText - what the button should say
 * 	@property {string} extraClasses - any extra classes the alert box should have
 * 	@property {function} onClose - a function to call when the user clicks the close button in the corner
 * 	@property {boolean} error
 */
sa.alert = function (options) {
	// key for events this alert instance attaches so we can remove them when it closes
	const eventKey = `.alert_${sa.alert.alertNumber++}`;

	if (typeof options === 'string') {
		options = { text: options };
	}

	options = $j.extend({
		text: 'Alert!',
		buttonText: 'Ok',
		extraClasses: ''
	}, options);

	// override the onClose so we can make sure to remove our keypress event
	let originalOnClose;
	if (options.onClose) {
		originalOnClose = options.onClose;
	}
	// make sure this only fires once
	options.onClose = _.once(() => {
		$j(window).off(eventKey);
		if (originalOnClose) {
			originalOnClose();
			originalOnClose = null; // prevent duplicate firings
		}
	});

	if (!sa.alert.templates) {
		sa.alert.templates = sa.templates.get('alert');
	}

	if (options.text === 'Alert!') {
		console.warn('Did you mean to set alert text?');
	}

	const div = sa.alert.templates.get('alert', { text: options.text, buttonText: options.buttonText });
	let fb;

	div.find('.button, #close').on('click', () => {
		fb.hide();
		options.onClose();
	});

	if (options.extraClasses !== '') {
		div.addClass(options.extraClasses);
	}

	fb = new FocusBox(div, { onClose: options.onClose });
	fb.show();
	
	$j(window).on(`keypress${eventKey}`, (e) => {
		if (e.keyCode === 13) {
			fb.hide();
			options.onClose();
			$j(window).off(eventKey);
		}
	});
};
sa.alert.alertNumber = 0;

sa.error = function (options) {
	options.error = true;
	sa.alert(options);
};

sa.alert.templates = null;

/**
 * Shows an overlay with text and two options, like a js confirm box
 * @param {Object} options
 * 	@param {string} options.text the text to prompt the user with at the top of the box
 * 	@param {string|function} options.yesFunction a function to call on [yes]. If this function returns true, the box will not close when the user clicks the [yes] button.
 * 	@param {string|function} options.noFunction a function to call on [no]. If this function returns true, the box will not close when the user clicks the [no] button.
 *	@param {string} options.yesText what to display on the [yes] button
 * 	@param {string} options.noText what to display on the [no] button
 * 	@param {string} options.closeFunction a function to call on clicking the close button
 * @return {FocusBox} the focus box that was created
 */
sa.confirm = function(options) {

	options = $j.extend({
		text : 'You should enter some text here',
		yesFunction : function() { return false; },
		noFunction : function() { return false; },
		yesText : 'Ok',
		noText : 'Cancel',
		closeFunction : function() {}
	}, options);

	if (!sa.confirm.templates) {
		sa.confirm.templates = sa.templates.get('confirm');
	}

	var div = sa.confirm.templates.get('confirm', { text : options.text, yesText : options.yesText, noText : options.noText });
	var fb;

	div.find('.confirm_yes').on('click', async function() {
		let yesFunctionResult = await options.yesFunction(div);
		if (!yesFunctionResult) {
			fb.hide();
		}
	});

	div.find('.confirm_no').on('click', function() {
		if (!options.noFunction()) {
			fb.hide();
		}
	});

	fb = new FocusBox(div, { onClose : function() { options.closeFunction(); }});
	fb.show();

	/**
	 * Shows an error message inside the input box (not the input[type=text])
	 * @param {html} errorMessage. The message to show. If empty, the error text will hide completely
	 */
	this.showError = function(errorMessage) {
		this.div.div.find('.error').remove();
		if (errorMessage) {
			this.div.div.find('#text_container').after('<div class="error">' + errorMessage + '</div>');
		}
	};
	
	// return the focus box so we can close it if necessary
	return fb;

};

sa.confirm.templates = null;

/**
 * Shows a notification window in the bottom right that sits for a few seconds and then disappears
 * @param {Object} options
 * 	@property {string|JQuery|HTMLElement} text - what you want the notification to say
 * 	@property {string} type - one of the sa.notify.notificationTypes (optional)
 */
sa.notify = function(options) {

	options = $j.extend({
		text : 'Enter something for your notification',
		type : sa.notify.notificationTypes.basic,
		cancelPreviousOfType: false,
	}, options);

	if (!sa.notify.templates) {
		sa.notify.templates = sa.templates.get('notify');
	}

	var notificationContents = sa.notify.templates.get(options.type);
	notificationContents.find('.contents').append(options.text);

	sa.alertManager.alert({
		html: notificationContents,
		type: options.type,
		cancelPreviousOfType: options.cancelPreviousOfType,
	});

};

sa.notify.notificationTypes = {
	basic : 'basic_notification',
	success : 'success_notification',
	download : 'download_notification',
	track : 'track_notification'
};

sa.notify.templates = null;

/**
 * Do not invoke this directly anymore. Use sa.notify
 */
sa.alertManager = (function() {

	var alertManager = {};
	var currentAlert = null;
	var alertQueue = [];
	var waitTimer = null;
	var waitTime = 5000;
	var animationSpeed = 500;

	/**
	 * Creates a new alert
	 * @param {JQuery} contents the content to display in the alert container
	 */
	alertManager.alert = function(contents) {
		if (contents.cancelPreviousOfType) {
			alertQueue = alertQueue.filter(a => {
				return a.type !== contents.type;
			})
		}
		alertQueue.push(contents);
		showAlert();
	};

	/**
	 * Shows the next notification, if there isn't one showing already
	 */
	function showAlert() {
		// if there's something showing or there's no notifications, we don't have to do anything right now
		if (currentAlert || !alertQueue.length) return;
		// grab the top note and set its contents in the container
		currentAlert = alertQueue.shift().html;
		// make it hideable
		var clickPos = { x : 0, y : 0 };
		currentAlert.on('mousedown', function(e) {
			if (e.target.nodeName !== 'A') {
				clickPos.x = e.pageX;
				clickPos.y = e.pageY;
			}
		});
		currentAlert.on('mouseup', function(e) {
			if (Math.abs(clickPos.x - e.pageX) < 3 && Math.abs(clickPos.y - e.pageY) < 3) {
				clearTimeout(waitTimer);
				hideAlert();
			}
		});
		// add the container to the body
		$j('body').append(currentAlert);
		// put the container so it's just covered by shadowfax
		setTimeout(function() {
			currentAlert.addClass('showing');
		}, 50);
		// make the notices auto-hide
		waitTimer = setTimeout(function() { hideAlert(); }, waitTime + animationSpeed);
	}

	/**
	 * Hides the current notification
	 */
	function hideAlert() {
		// this can be called in a couple ways. if it was called by something other than the timer, clear it so we're not called twice
		if (waitTimer) clearTimeout(waitTimer);
		// start the hiding animation
		currentAlert.removeClass('showing');
		setTimeout(function() {
			// remove the current notification
			currentAlert.remove();
			currentAlert = null;
			// start the next one (if there is one)
			showAlert();
		}, animationSpeed);
	}

	return alertManager;

})();

/**
 * An input box object that displays an input[type=text] and an ok and a cancel button
 *  Upon clicking one of the buttons, the box calls one of two functions that you specify and hides (probably. see params)
 *  If the user clicks the X button, neither function is called
 *  Shows immediately on creation
 * @param {Object} options
 * 	@property {string} text the text to prompt the user with at the top of the box
 * 	@property {string} subtext - if set, appears below the input box in a lighter color. provides clarifying information
 *	@property {function} yesFunction a function to call on [yes]. Passed params - {string} inputValue, {Object} interactionOptions.
 *		The interactionOptions has the function showError({string} message). If you pass in a message, it will be displayed below the input
 *		If this function returns true, the box will not close when the user clicks the [yes] button.
 * 	@property {function} noFunction a function to call on [no]. If this function returns true, the box will not close when the user clicks the [no] button
 * 	@property {string} yesText what to display on the [yes] button
 * 	@property {string} noText what to display on the [no] button
 * 	@property {string} value the default value of the input[type=text]. this value is not a placeholder and will actually be returned if the user clicks [yes]
 * 	@property {string} placeholder the value to use as an input placeholder
 * 	@property {function} closeFunction a function to call if the user closes the box without hitting a real button
 * 	@property {string} inputType - the input box's type attribute. defaults to "text" but changeable to "password", "date", etc.
 */
sa.prompt = function(options) {

	options = $j.extend({
		text : '',
		subtext : '',
		yesFunction : function(enteredValue) { console.error('Uncaught prompt return value', enteredValue); },
		yesText : 'Save',
		noFunction : function() {},
		noText : 'Cancel',
		value : '',
		placeholder : '',
		inputType : 'text',
		closeFunction : function() {}
	}, options);

	if (!sa.prompt.templates) {
		sa.prompt.templates = sa.templates.get('prompt');
	}

	var div = sa.prompt.templates.get('prompt', { text : options.text, yesText : options.yesText, noText : options.noText, inputType : options.inputType, placeholder : options.placeholder });
	if (options.subtext) {
		div.find('#subtext').html(options.subtext);
	} else {
		div.find('#subtext').remove();
	}
	var input = div.find('#prompt_input');
	var errorContainer = div.find('.error_message');
	var fb;
	var interactionOptions = {
		showError : function(errorMessage) {
			errorContainer.html(errorMessage).addClass('showing');
		}
	};

	if (!options.text) {
		div.find('.input_box_text').remove();
	}

	if (options.value) {
		input.val(options.value);
	}
	checkForEnter(input, function() {
		div.find('#prompt_yes').trigger('click');
	});

	div.find('#prompt_yes').on('click', function() {
		var enteredValue = input.val().trim();
		errorContainer.removeClass('showing');
		if (!options.yesFunction(enteredValue, interactionOptions)) {
			options.onClose = function() {};
			fb.hide();
		}
	});

	div.find('#prompt_no').on('click', function() {
		if (!options.noFunction()) {
			options.onClose = function() {};
			fb.hide();
		}
	});

	sa.forms.init(div);

	function checkForEscape(e) {
		if (window.event) e = window.event;
		if (e.keyCode == 27) {
			fb.hide();
		}
	}

	$j(window).on('keydown', checkForEscape);

	fb = new FocusBox(div, { onClose : function() {
		options.closeFunction();
		$j(window).off('keydown', checkForEscape);
	}});
	fb.show();

};

sa.prompt.templates = null;

/**
 * Creates an auth form, letting the user fill out their information
 */
sa.showAuthForm = function() {

	if ($j('#auth_form').length || sa.showAuthForm.pendingShow) return;

	/** @var {FocusBox} */
	var focusBox;

	var signupTemplate = sa.templates.get('pages.login');
	var templates = sa.templates.get('auth_form');

	var container = templates.get('page');

	if (config.registrationFields.length) {
		container = templates.get('page_with_extra_fields');
		var extraFieldsContainer = container.find('#extra_fields');
		for (var i = 0; i < config.registrationFields.length; i++) {
			var field = config.registrationFields[i];
			var fieldTemplate = signupTemplate.get('signup_page_extra_field_' + field.type.replace(/ /g, '_'), {
				extraId : field.id,
				name : field.name
			});
			if (field.type === 'contact selector') {
				let select = fieldTemplate.find('select');
				if (field.contactSelectorOptions && field.contactSelectorOptions.isArray) {
					select.html('<option>' + field.contactSelectorOptions.join('</option><option>') + '</option>');
				}
			} else if (field.type === 'option selector') {
				let select = fieldTemplate.find('select');
				if (field.optionSelectorOptions && field.optionSelectorOptions.isArray) {
					select.html('<option>' + field.optionSelectorOptions.join('</option><option>') + '</option>');
				}
			}
			if (field.defaultValue) {
				fieldTemplate.find('input,textarea').val(field.defaultValue);
			}
			if (field.required) {
				fieldTemplate.find('input,textarea').attr('required', '1');
			}
			extraFieldsContainer.append(fieldTemplate);
		}
		sa.forms.init(container);
	} else {
		container = templates.get('page');
	}

	container.find('.confirm_yes').on('click', function() {
		// now check the extra fields
		var fields;
		if (config.registrationFields.length) {
			var validationResult = sa.forms.validate(focusBox.div);
			if (validationResult.error) {
				var errorMessages = [];
				validationResult.errors.each(function(i, errorDetails) {
					errorMessages.push(errorDetails.errorDetail);
				});
				focusBox.showErrorMessage(signupTemplate.get('signup_errors', { errors : errorMessages.join('</li><li>')}));
				return;
			} else {
				fields = validationResult.values;
			}
		} else {
			fields = {};
		}
		focusBox.hideErrorMessage();
		focusBox.showLoader('Processing your request');
		ajax(fields, function(response) {
			focusBox.hideLoader();
			if (response[0].result == 'success') {
				focusBox.showSuccessMessage(templates.get('request_sent_message'));
				$j('#auth_form').remove();
				sa.showAuthForm.pendingShow = true; // so they won't keep getting this box
				sa.trigger('registration');
			} else if (response[0].result == 'refresh') {
				const messageTemplate = templates.get('request_approved_message');
				messageTemplate.find('a').on('click', function() { window.location.reload(true); return false; });
				focusBox.showSuccessMessage(messageTemplate);
				$j('#auth_form').remove();
				sa.trigger('registration');
			} else {
				focusBox.showErrorMessage(response[0].result);
			}
		}, 'POST', 'p=authorization');
	});
	container.find('.confirm_no').attr('href', 'logout.php');

	// disable closing to prevent white hat confusion - if you're not paying attention, it looks like password changes, etc. work but they don't
	focusBox = new FocusBox(container, { title : 'Authorization Required', showClose: false, preventClose: true});
	sa.showAuthForm.pendingShow = true;

	setTimeout(function() {
		sa.showAuthForm.pendingShow = false;
		focusBox.show();
	}, 500);

};
/**
 * The suggestion box on a details page when you edit a smart field
 *  Displays possible completions below a text box while the user types
 *  
 * RAC 2013-07-08 - Updated this object into a wrapper for the jQuery UI autocomplete function. It was bug-tastic before and was proving hard to fix.
 * http://jqueryui.com/autocomplete/#default
 * 
 * @param {string} type a key passed into the server (p=list&type=type) so it know what to match against
 * @returns {DomElement} the input box
 */
function SuggestionBox(type) {
	var input = $j('<input type="text"/>');
	input.autocomplete({
		source : function(request, response) {
			ajax('p=list&type=' + type + '&part=' + encodeURIComponent(request.term) + '&limit=5', 
			function(data) {
				response($j.map(data[0].items, function(item) {
					return {
						label : caselessBold(item, request.term),
						value : item
					};
				}));
			});
		},
		minLength : 1,
		select : function(event, ui) {
			if (ui.item) {
				console.log('autocomplete returned', ui.item.label);
			}
		}
	}).data('ui-autocomplete')._renderItem = function(ul, item) {
		return $j('<li><a>' + item.label + '</a></li>').appendTo(ul);
	};
	return input[0];
}/**
 * Widgets.js holds non-page display widgets that are occassionally used on the site.
 * These widgets can be anything from small tag buttons to large objects like the document viewer
 * It also contains utility functions related to their use
 */

////////////////////////
// PDF Button
////////////////////////

/**
 * A button that will create a pdf of a cue sheet
 * @param {string} parameters anything that needs to be sent to pdf.php to generate the approprate pdf
 * @param {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
 * @param {string} text the text to display inside the button if wide (defaults to something reasonable)
 */
function generatePdfButton(parameters, wide, text) {
	var a = $j('<a class="' + (wide ? 'button ' : 'faux_button') + '" title="Click to save a pdf"><i class="fa fa-file-pdf-o"></i>' + (wide ? ' ' + (text ? text : 'Download PDF') : '') + '</a>');
	const url = 'https://' + config.domain + '/pdf.php?' + parameters
	
	if (BrowserDetect.isAdobePanel) {
		a.attr('href', '')
		a.data('href', url)
	} else {
		a.on('click', function() {
			document.location.href = url;
			return false;
		});
	}
	return a;
}

////////////////////////
// CSV Button
////////////////////////

/**
* A button that will create a csv of a cue sheet
* @param {string} parameters anything that needs to be sent to csv.php to generate the approprate csv
* @param {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
* @param {string} text the text to display inside the button if wide (defaults to something reasonable)
*/
function generateCsvButton(parameters, wide, text) {
	var a = $j('<a class="' + (wide ? 'button ' : 'faux_button') + '" title="Click to save a csv"><i class="fa fa-file-code-o"></i> ' + (wide ? ' ' + (text ? text : 'Download CSV') : '') + '</a>');
	const url = 'https://' + config.domain + '/csv.php?' + parameters;

	if (BrowserDetect.isAdobePanel) {
		a.attr('href', '')
		a.data('href', url)
	} else {
		a.on('click', function() {
			document.location.href = url;
			return false;
		});
	}

	return a;
}

////////////////////////
// Excel Button
////////////////////////

/**
* A button that will create a csv of a cue sheet
* @param {string} parameters anything that needs to be sent to csv.php to generate the approprate csv
* @param {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
* @param {string} text the text to display inside the button if wide (defaults to something reasonable)
*/
function generateExcelButton(parameters, wide, text) {
	var a = $j('<a class="' + (wide ? 'button ' : 'faux_button') + '" title="Click to save a csv"><i class="fa fa-file-excel-o"></i> ' + (wide ? ' ' + (text ? text : 'Download Excel') : '') + '</a>');
	const url = 'https://' + config.domain + '/excel.php?' + parameters;

	if (BrowserDetect.isAdobePanel) {
		a.attr('href', '')
		a.data('href', url)
	} else {
		a.on('click', function() {
			document.location.href = url;
			return false;
		});
	}
	return a;
}

///////////////////////////
// Other Project Buttons
///////////////////////////

/**
 * Creates a button that lets a user change a project to make it created
 * @param {Project} project the project to make created
 * @param {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
 * @param {string} text the text to display inside the button if wide (defaults to something reasonable)
 */
function generateProjectMakeCreatedButton(project, wide, text) {
	var img;
	if (wide) {
		img = $j('<a class="button" title="Click to save this received playlist to your personal playlist list"><img src="images/shared/copy.png"/> '
				+ (text ? text : 'Enable Editing') + '</a>');
	} else {
		img = $j('<a class="faux_button" title="Click to save this received playlist to your personal playlist list"><img src="images/shared/copy.png"/></a>');
	}
	img.on('click', function() {
		if (lockdown) {
			return sa.showLockdownMessage();
		}
		sa.components.projector.makeCreated(project);
		return false;
	});
	return img;
}

/**
 * Creates a button that lets a user remove a project
 * @param {Project} project the project to remove
 * @param {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
 * @param {string} text the text to display inside the button if wide (defaults to something reasonable)
 */
function generateProjectRemoveButton(project, wide, text) {
	var img;
	if (wide) {
		img = $j('<a class="delete_button button" title="Click to permanently delete this playlist"><span class="fa fa-times icon"></span>' + (text ? text : 'Delete') + '</a>');
	} else {
		img = $j('<a class="faux_button" title="Click to permanently delete this playlist"><span class="fa fa-times icon"></span></a>');
	}
	img.on('click', function() {
		sa.confirm({
			text: 'Are you sure you want to delete playlist "' + project.name + '"?',
			yesFunction: function() { return sa.components.projector.removeProject(project); },
			yesText: 'Delete'
		});
		return false;
	});
	return img;
}

/**
 * Creates a cue sheet from a project
 * @param {Project} project the project to copy
 * @param {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
 * @param {string} text the text to display inside the button if wide (defaults to something reasonable)
 * @return {HTMLElement}
 */
function generateProjectToCueSheetButton(project, wide, text) {
	var img;
	if (wide) {
		img = $j('<a class="copy_button button" title="Click to copy this playlist to a cue sheet"><span class="fa fa-random icon"></span>' + (text ? text : 'Copy to Cue Sheet') + '</a>');
	} else {
		img = $j('<a class="faux_button" title="Click to copy this playlist to a cue sheet"><span class="fa fa-random icon"></span></a>');
	}
	img.on('click', function() {
		if (lockdown) {
			return sa.showLockdownMessage();
		}
		ajax('projectId=' + project.id, function(response) { sa.components.cueSheeter.projectCopyResponse(response); }, 'POST', 'p=cue_sheets&action=create_from_project');
		return false;
	});
	return img;
}

/**
 * Creates a project from a cue sheet
 * @param {CueSheet} cueSheet the project to copy
 * @param {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
 * @param {string} text the text to display inside the button if wide (defaults to something reasonable)
 */
function generateCueSheetToProjectButton(cueSheet, wide, text) {
	var img = $j('<a class="faux_button" title="Click to copy this cue sheet to a playlist"><span class="fa fa-random icon"></span></a>')
		.on('click', function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			ajax('cueSheetId=' + cueSheet.id, function(response) { sa.components.projector.cueSheetCopyResponse(response); }, 'POST', 'p=projects&action=create_from_cue_sheet');
			return false;
		});
	if (wide) {
		img.addClass('button');
		img.append(' ' + (text ? text : 'Convert to playlist'));
	}
	return img;
}

/////////////////////////
// Check For Enter Box
/////////////////////////

/**
 * Adds a check for the enter key to an input[type=text], textarea and if the user presses it, callback is evaled
 * @param {HTMLElement|JQuery} element the input box or text area
 * @param {function} callback called if enter is pressed
 */
function checkForEnter(element, callback) {
	$j(element).on('keypress', function(e) {
		if (e) {
			code = e.keyCode;
		} else {
			code = window.event.keyCode;
		}
		if (code == 13) {
			callback();
			return false;
		}
		return true;
	});
}

/**
 * Displays a focus box with a loading spinner and a short message
 * @param {string} message the message to display
 * @returns {Waiter} the waiter. You might want it to call hide() at some point
 */
function Waiter(message) {
	this.hide = function() {
		this.fb.hide();
	};

	var div = createDiv('', 'waiter');
	showLoader(div, message);
	this.fb = new FocusBox(div);
	this.fb.show();
}

/**
 * Pops a focus box in the middle of the screen that tells admins to add music to their sites
 */
function showEmptyLicenseeSiteNotice() {
	if (config.siteType != 'buyer' || !user.hasAdminPermission(AdminPermission.MusicSuppliers) || config.catalogs.length) return;
	var oldCont = $j('.empty_licensee_site_notice');
	if (oldCont.length) {
		oldCont[0].fb.hide();
	}
	var cont = $j(
		'<div class="empty_licensee_site_notice">'
			+ '<a id="close" class="fa fa-times"></a>'
			+ '<h2>Welcome to your new sync licensing music search workspace!</h2>'
			+ '<h3>Getting Started:</h3>'
			+ '<hr/>'
			+ '<ol>'
				+ '<li>Begin by reviewing available publishers, labels, and libraries on the network</li>'
				+ '<li>Request access to the ones you want to be included on your workspace</li>'
				+ '<li>As your requests are approved, your workspace will automatically populate itself with the music &amp; corresponding metadata</li>'
			+ '</ol>'
			+ '<h4>Enjoy!</h4>'
			+ '<hr/>'
			+ '<a class="button" href="' + getSecureLink('admin?p=music_suppliers') + '">Make My Music Selections &raquo;</a>'
		+ '</div>'
	);
	var fb = new FocusBox(cont);
	fb.show();
	cont.find('#close').on('click', function() { fb.hide(); });
}

function generateProjectActionsList(project, wide = true) {
	function ProjectAction(button, location) {
		this.getButton = function () {
			return button;
		};
		this.getLocation = function () {
			return location;
		};
	}

	var actionList = [],
		owned = project.userId == user.userData.id,
		published = project.publish.local || project.publish.licensee, // need to know if it's published because we get different buttons
		local = project.whiteId == config.id; // need to know if it's based on this while label because it affects the owner's options

	// download button
	actionList.push(new ProjectAction(sa.components.downloadFormatSelector.generateDownloadButton({ type: 'project', item: project, wide: wide, useMetaPermissionProfile: true }), sa.components.heading.LocationTop));

	// drop receive mode only shows download and add button
	if (config.siteType === 'drop' && config.siteMode === 'receive') {
		actionList.push(new ProjectAction(sa.components.buttons.generateAddToDropButton({
			type: 'project',
			itemId: project.id
		}), sa.components.heading.LocationBottom));
		return actionList;
	}

	// email button
	actionList.push(new ProjectAction(sa.components.emailer.generateEmailButton({
		type: 'project',
		item: project,
		wide: wide,
		text: 'Email Link',
	}), sa.components.heading.LocationBottom));
	// sharing buttons
	if (owned && local && project.created) {
		actionList.push(new ProjectAction(sa.components.collaborationManager.generateShareButton({ type: 'project', item: project, wide: wide }), sa.components.heading.LocationBottom));
		// publishing button
		if (user.hasAdminPermission(AdminPermission.Feature) && config.siteType != 'buyer') {
			actionList.push(new ProjectAction(sa.components.projector.generatePublishButton({
				project: project,
				wide: wide,
			}), sa.components.heading.LocationBottom));
		}
	}

	// exporting
	if (user.hasAdminPermission(AdminPermission.Metadata)) {
		actionList.push(new ProjectAction($j('<a class="button" href="export.php?type=tracks&format=csv&projectId=' + project.id + '">Export as CSV</a>'), sa.components.heading.LocationBottom));
	}
	// upload button for drop sites
	if (owned && local && config.siteType === 'drop' && user.hasAdminPermission(AdminPermission.Metadata)) {
		actionList.push(new ProjectAction(sa.importTrackManager.getUploadButton({ projectId: project.id }), sa.components.heading.LocationBottom));
	}
	// publish button for other admins
	if (local && published && user.hasAdminPermission(AdminPermission.Feature) && config.siteType != 'buyer' && !owned) {
		actionList.push(new ProjectAction(sa.components.projector.generatePublishButton({
			project: project,
			wide: wide,
		}), sa.components.heading.LocationBottom));
	}
	// cue sheet button
	if (config.showCueSheets) {
		actionList.push(new ProjectAction(generateProjectToCueSheetButton(project, wide, 'Copy to Cue Sheet'), sa.components.heading.LocationBottom));
	}
	if (project.created && local && (owned || project.shared)) {
		// add/remove button
		actionList.push(new ProjectAction(sa.components.projector.generateQuickProjectModeButton(project, {
			wide: wide,
			text: 'Add/Remove'
		}), sa.components.heading.LocationLeft));
	}
	if (local) {
		if (owned) {
			// edit
			actionList.push(new ProjectAction(sa.components.buttons.generateEditButton({
				type: 'project',
				item: project,
				wide: wide,
			}), sa.components.heading.LocationBottom));
			// copy
			actionList.push(new ProjectAction(sa.components.projector.generateProjectCopyButton({
				project: project,
				wide: wide,
				text: 'Copy/Make New'
			}), sa.components.heading.LocationBottom));
		} else if (user.logged) {
			// edit if shared with edit perms
			if (project.created && project.shared) {
				actionList.push(new ProjectAction(sa.components.buttons.generateEditButton({
					type: 'project',
					item: project,
					wide: wide,
				}), sa.components.heading.LocationBottom));
			}
			// copy to your projects
			actionList.push(new ProjectAction(sa.components.projector.generateProjectCopyButton({
				project: project,
				wide: wide,
				text: (config.id != 162 ? 'Add to My Playlists' : 'Make a Copy')
			}), sa.components.heading.LocationBottom));
		}
	}
	if (local && user.getProject(project.id) != null) {
		// remove
	actionList.push(new ProjectAction(generateProjectRemoveButton(project, wide, 'Delete'), sa.components.heading.LocationBottom));
	}

	return actionList;
}

function generateArtDownloadButton(album, wide, text) {
	var img;
	if (wide) {
		img = $j('<a class="button" title="Click to download cover art"><span class="fa fa-file-image-o icon"></span>' + (text ? text : 'Download Cover Art') + '</a>');
	} else {
		img = $j('<a class="faux_button" title="Click to download cover art"><span class="fa fa-file-image-o icon"></span></a>');
	}

	let imageUrl = "album_image.php?albumId=" + encodeURIComponent(album.id)
	
	img.on('click', function () {
		window.location.href = imageUrl;
		return false;
	});

	// Used by Adobe Panel for downloading album art`
	if (window.adobe_panel) {
		img.off('click')
		img.attr('href', imageUrl);
		img.data('href', imageUrl )
	}

	return img.get(0);
}

sa.pagination = (function() {

	let pagination = {};

	function safeParseInt(str) {
		return parseInt(str);
	}

	/**
	 * Adds pagination to a container, in the style you see it on the explorer
	 * @param {object} options
	 * 	@property {int} currentPage - the current page (0 indexed)
	 * 	@property {boolean} showTitle - should we show the text "Page" next to input on page one?
	 * 	@property {function} callback - func to call when the user uses the pagination. it's passed the page number
	 * 	@property {JQuery} container - where to append the pagination
	 *
	 * 	@property {int} totalItems - total number of items
	 * 	@property {int} perPage - how many items to display per page
	 * 		OR
	 * 	@property {int} totalPages - how many pages there are total
	 */
	pagination.addPagination = function(options) {
		options = $j.extend({
			currentPage : 0,
			totalItems : 0,
			perPage : 0,
			totalPages : 0,
			callback : function(page) {
				console.error('Please set a callback in sa.pagination.addPagination options', page);
			},
			container : null,
			showTitle : false
		}, options);
		if (!options.container) {
			console.error('Please supply a container to addResultsPerPage options');
			return;
		}
		options.currentPage = safeParseInt(options.currentPage);
		options.totalItems = safeParseInt(options.totalItems);
		options.perPage = safeParseInt(options.perPage);
		options.totalPages = safeParseInt(options.totalPages);

		// set up pages
		if (!options.totalPages || isNaN(options.totalPages)) {
			options.totalPages = Math.ceil(options.totalItems / options.perPage);
		}

		var div = $j('<div id="list_page_numbers"></div>');
		if (options.totalPages < 2) {
			div.html('Showing all results');
		} else {
			if (options.currentPage > 0) {
				div.append($j('<a id="list_page_prev" class="faux_button">&laquo; Prev</a>').on('click', function(pg) { return function() { options.callback(pg); return false; }; }(options.currentPage - 1)));
				div.append($j('<a id="list_page_first" class="faux_button">1</a>').on('click', function() { options.callback(0); return false; })).append('<span>...</span>');
			} else if (options.showTitle) {
				div.append('<em>Page</em>');
			}
			div.append($j('<input type="text" class="list_page_selection" value="' + (options.currentPage + 1) + '"/>').on('keydown',
				function(e) {
					if (e) {
						code = e.keyCode;
					} else {
						code = window.event.keyCode;
					}
					//console.log('code is ' + code);
					if ((code != 8 && code != 46 && code != 37 && code != 39 && code != 16)
						&& (code < 48 || (code > 57 && code < 96) || code > 105)) {
						return false;
					}
				})
				.on('keyup',
					function(e) {
						if (e) {
							code = e.keyCode;
						} else {
							code = window.event.keyCode;
						}
						var t = $j(this);
						if (code == 13 && t.val().match(/^[0-9]+$/)) {
							options.callback(t.val() - 1);
						} else {
							var baseWidth = t.data('base-width');
							if (!baseWidth) {
								baseWidth = t.width();
								t.data('base-width', baseWidth);
							}
							var test = $j('<span>' + t.val() + '</span>');
							$j('body').append(test);
							t.width(Math.max(baseWidth, test.width() + 8) + 'px');
							test.remove();
						}

					}
				)).trigger('keyup');
			if (options.currentPage < options.totalPages - 1) {
				div.append('<span>...</span>').append($j('<a id="list_page_last" class="faux_button">' + options.totalPages + '</a>').on('click', function(pg) { return function() { options.callback(pg); return false; }; }(options.totalPages - 1)));
				div.append($j('<a id="list_page_next" class="faux_button">Next &raquo;</a>').on('click', function(pg) { return function() { options.callback(pg); return false; }; }(options.currentPage + 1)));
			}
		}

		options.container.append(div);

	};

	/**
	 * Adds a results per page changing form to a container, like you see on the bottom of the track list
	 * @param {Object} options
	 * 	@property {function} callback - called when the user chooses something and passed the new result count
	 * 	@property container - jQuery container for the rpp widget
	 * 	@property {Array.<int>} resultCounts - the options to show
	 * 	@property {int} resultsPerPage - the current results per page
	 */
	pagination.addResultsPerPage = function(options) {
		options = $j.extend({
			callback : function(resultCount) { console.log('new result count is', resultCount); },
			container : null,
			resultCounts : [ 5, 10, 15 ],
			resultsPerPage : 10
		}, options);
		if (!options.container) {
			console.error('Please supply a container to addResultsPerPage options');
			return;
		}
		options.resultCounts.push(-1);
		let op = false;
		var isMobile = sa.isMobile();
		let div;
		if (isMobile) {
			div = $j('<div id="list_result_count"><span>Per page:</span></div>');
		} else {
			div = $j('<div id="list_result_count"><span>Results per page:</span></div>');
		}
		options.resultCounts.each(function(i, count) {
			if (!op && (count >= options.resultsPerPage || count == -1)) {
				op = true;
				let countInput = $j('<input type="text" value="' + options.resultsPerPage + '" id="result_count_selection"/>');
				countInput.on('keydown', function(e) {
					// Allow: backspace, delete, tab, escape, enter and .
					if ($j.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
						// Allow: Ctrl/cmd+A
						(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
						// Allow: Ctrl/cmd+C
						(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
						// Allow: Ctrl/cmd+X
						(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
						// Allow: home, end, left, right
						(e.keyCode >= 35 && e.keyCode <= 39)) {
						// let it happen, don't do anything
						return;
					}
					// Ensure that it is a number and stop the keypress
					if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
						e.preventDefault();
					}
				});
				countInput.on('keyup', function(e) {
					let val = this.value;
					if (e) {
						code = e.keyCode;
					} else {
						code = window.event.keyCode;
					}
					if (code == 13 && val.match(/^[0-9]+$/)) {
						options.callback(val);
					}
				});
				div.append(countInput);
			}
			if (options.resultsPerPage != count && count != -1) {
				let countDisplay = $j('<a  href="#0">' + count + '</a>');
				countDisplay.on('click', function() {
					options.callback(count);
					// Scroll to top of page
					sa.scrollToElement($j(this).closest('.track_list'));
					return false;
				});
				div.append(countDisplay);
			}
		});
		options.container.find('#' + div.prop('id')).remove();
		options.container.append(div);

	};

	return pagination;

})();
/**
 * Represents and controls a waveform display for a track
 * @param {int} trackId the id of the track the waveform is fow
 * @param {JQuery} container the element that will hold the waveform
 * @param {boolean} timeline should we show a timeline under the waveform?
 * @param {Array=} comments
 * @param {int=} heightPadding waveforms default to padding down their height. you can change this behavior by overriding that padding here
 */
function Waveform(trackId, container, timeline, comments, heightPadding) {
	var waveform = this;

	/** @var {object} */
	var commentSaveVars = null;
	var newCommentMarker = null; // used during resize to detach/reattach the marker for a new comment (if exists)

	this.trackId = trackId;
	this.track = trackBank.find(this.trackId) ?? trackBank.find(0 - trackId);
	/** @var {JQuery} this.container */
	this.container = container;
	this.timeline = timeline;
	this.commentsEnabled = false;

	/**
	 * Colors for the various elements
	 */
	this.lightBarColor = '';
	this.lightBarShadowColor = '';
	this.darkBarColor = '';
	this.darkBarShadowColor = '';
	this.playheadColor = '';
	this.hoverBarColor = '';

	/**
	 * The main canvas object we draw to plus its context so we don't have to re-get it each time
	 */
	this.canvas = null;
	this.context = null;

	/**
	 * Caches so we don't have to redraw the waveform each frame (6-14ms to draw from data, 0ms to draw from cache)
	 */
	this.waveCanvasLight = null;
	this.waveCanvasDark = null;

	/**
	 * Is this the currently playing track?
	 */
	this.enabled = false;
	/**
	 * Have we loaded data?
	 */
	this.loaded = false;
	/**
	 * Additional console.log messages?
	 */
	this.logging = false;

	/**
	 * Because it can't draw canvases on other canvases, IE requires we keep the data so we can redraw each frame
	 */
	this.ieMode = false;
	this.data = [];

	/**
	 * The position of the mouse while dragging { x : int, y : int }
	 */
	this.dragPos = null;
	/**
	 * Was the player playing when drag started?
	 */
	this.dragPlaying = false;
	/**
	 * The position of the mouse while hovering { x : int, y : int }
	 */
	this.hoverPos = null;
	/**
	 * Tracking the last play and load percentages sent into setProgress so we don't redraw if nothing's different
	 */
	this.lastPlayPercentage = -1;
	this.lastLoadPercentage = -1;

	/**
	 * Loads the waveform data from the server
	 */
	this.load = function() {
		if (this.loaded) return;
		var waveform = this;
		$j.getJSON(this.track.file.waveform + '?callback=?', function(waveData) {
			waveform.setData(waveData);
		});
	};

	/**
	 * Handles parsing the waveform data after it's been loaded
	 * 	Also draws the waveform on the background
	 * @param {string} waveData the data
	 */
	this.setData = function(waveData) {
		if (this.loaded) return;
		if (!waveData) {
			console.log('no data for ' + this.trackId);
			return;
		}
		this.resize(); // sometimes initCanvas creates a canvas that's 8px too wide. by this point, it should have the real size and resize fixes it. if it was already right, this call is free
		var resolution = 1;
		var start = (new Date()).getTime();
		var boundary = this.canvas.width - Math.max(0, resolution - 1); // no reason to calc this every time
		var data = [];
		var maxHeight = 0;
		var i;
		for (i = 0; i < boundary; i += resolution) {
			var waveIndex = Math.floor(i * waveData.length / this.canvas.width);
			var waveValue = Math.abs(waveData[waveIndex]);
			var height = Math.floor(waveValue * this.canvas.height);
			data.push(height);
			if (waveValue > maxHeight) maxHeight = waveValue;
		}
		if (maxHeight < 1) {
			for (i = 0; i < data.length; i++) {
				data[i] = Math.floor(data[i] / maxHeight);
			}
		}
		// sometimes the waveform generator pulls an anomalous non-zero value for the first data point
		// if the first value is greater than 0.3 and the second is less than 0.01, we'll just set the first to 0
		if (data.length > 1 && data[0] > 0.3 && data[1] < 0.01) {
			data[0] = 0;
		}
		if (this.ieMode) {
			// flash canvas doesn't support drawing canvases on other canvases so we can't cache the wave images. we have to draw them each time
			this.data = data;
		} else {
			var waveContextLight = this.waveCanvasLight.getContext('2d');
			var waveContextDark = this.waveCanvasDark.getContext('2d');
			for (i = 0; i < data.length; i++) {
				var waveHeight = data[i];
				// draw the light version
				this.drawLightBar(waveContextLight, i, waveHeight);
				// draw the dark version
				this.drawDarkBar(waveContextDark, i, waveHeight);
			}
		}
		this.drawDisabled();
		var drawTime = (new Date()).getTime();
		if (this.logging)
			console.log('drawTime - ' + (drawTime - start));
		// set up the interactions
		this.initInteractions();

		this.loaded = true;
		sa.components.waveformManager.updateWaveform(this);
	};

	this.enableCommenting = function(newCommentSaveVars) {
		const self = this
		this.commentsEnabled = true;
		commentSaveVars = newCommentSaveVars;
		var newCommentButton = sa.components.waveformManager.templates.get('new_comment_button');

		newCommentButton.on('click', function (e) {
			e.stopPropagation();

			var trackTime = waveform.track.actualLength;
			var commentTime = trackTime / 2;
			// if this is the playing track, get current playing time
			if (self.enabled) {
				commentTime = sa.components.player.getProgress() * trackTime;
			}
			var newComment = { id : 0, time : commentTime, comment : '', newComment : true };
			var newCommentMarker = sa.components.waveformManager.templates.get('new_comment_marker');
			var commentContainer = waveform.container.find('.comment_handle_container');
			var showDelay = 0; // how long to wait before showing the new comment window (used to avoid duplicates)

			// if the user tries to open a second new comment window, we close the first
			// using a custom event, making it easy to access this new comment's variables
			newCommentMarker.on('new_comment_creation', function() {
				hideComment(newComment, newCommentMarker);
			});

			var oldMarker = $j('.new_comment_marker');
			if (oldMarker.length) { // they already have a new comment window open
				oldMarker.trigger('new_comment_creation');
				showDelay = 250; // slightly more than the hiding delay
			}

			setTimeout(function() {
				commentContainer.append(newCommentMarker);
				newCommentMarker.css({
					left : Math.floor(newComment.time / trackTime * commentContainer.width()) - newCommentMarker.width() / 2
				});

				showComment(newComment, newCommentMarker);
			}, showDelay);

		});

		this.container.append(newCommentButton);
		this.container.append(sa.components.waveformManager.templates.get('new_comment_button_cover'));

	};

	/**
	 * Sets up interactions so you can do stuff with the waveform (like click on it)
	 */
	this.initInteractions = function() {
		var w = this;
		$j(this.canvas).on('mousedown', function(e) {
			return w.startDrag(e);
		});
		if (ios) {
			$j(this.container).on('click', function(e) {
				var clickPos = w.windowToLocal(e.pageX, e.pageY);
				sa.components.player.setProgress(clickPos.x / w.canvas.width);
			});
		}
	};

	/**
	 * Starts the drag, pausing the player and adding the drag listeners to movement and mouse up
	 * @param {Event} e the click event
	 */
	this.startDrag = function(e) {
		if (!this.enabled || ios) return;
		var windowX = e.pageX,
			windowY = e.pageY,
			w = this,
			dragStopped = false; // if jquery ui loading finishes after drag has stopped, don't disable selection

		if (!window.adobe_panel) e.stopPropagation();
		
		// we need to store whether or not we were playing before drag started and if we were, pause for duration of drag
		if (!ios && !android && (this.dragPlaying = sa.components.player.isPlaying())) {
			sa.components.player.playPause();
		}
		// set the current drag pos
		this.dragPos = this.windowToLocal(windowX, windowY);
		// disable selection so dragging out of the waveform doesn't select everything on the page
		if (!dragStopped) {
			$j('body').disableSelection();
		}
		var dragFunc = function(e) {
			w.drag(e.pageX, e.pageY);
		};
		var upFunc = function(e) {
			w.stopDrag(e.pageX, e.pageY, dragFunc, upFunc);
			$j('body').enableSelection();
			dragStopped = true;
		};
		// add the move and up listeners
		$j(document).on('mousemove', dragFunc)
			.on('mouseup', upFunc)
			.data('waveform', this);
		if (autoShowingComment) {
			hideComment(autoShowingComment);
			autoShowingComment = null;
		}
	};

	/**
	 * Updates the stored position of the user's mouse
	 * @param {int} windowX the x position relative to the browser window where the user's mouse currently is
	 * @param {int} windowY the y position relative to the browser window where the user's mouse currently is
	 */
	this.drag = function(windowX, windowY) {
		this.dragPos = this.windowToLocal(windowX, windowY);
	};

	/**
	 * Stops the drag, restarting the player and removing listeners
	 * @param {int} windowX the x position relative to the browser window where the user's mouse was at mouse up
	 * @param {int} windowY the y position relative to the browser window where the user's mouse was at mouse up
	 * @param {function} dragFunc a listener that was previously build to mouse move
	 * @param {function} upFunc a listener that was previously bound to mouse up
	 */
	this.stopDrag = function(windowX, windowY, dragFunc, upFunc) {
		// update the player to the new position
		sa.components.player.setProgress(this.dragPos.x / this.canvas.width);
		// clear the dragPos object so draw knows to start following play head again
		this.dragPos = null;
		// remove listeners and the waveform ref so we're not storing it forever when the user leaves the page
		$j(document).off('mouseup', upFunc).off('mousemove', dragFunc);
		// if the play was playing when we started, start it again!
		if (!ios && !android && this.dragPlaying) {
			if (!sa.components.player.isPlaying()) {
				sa.components.player.playPause();
			} else {
				// on safari, if you click quickly, the pause doesn't have time to fire before trying to unpause and they don't stack - it just ends up paused
				setTimeout(function() {
					sa.components.player.playPause();
				}, 150);
			}
		}

	};

	/**
	 * Updates the position of the hover tracker
	 * @param {Event} e event that led to this function being called
	 * @return {boolean} should this waveform stay in the update list?
	 */
	this.setHover = function(e) {
		// if this waveform was disabled, stop sending it updates
		if (!this.enabled || ios || android) return false;
		// if it's no longer visible, stop sending it updates
		if (!$j('.waveform_' + this.track.file.waveformCallbackId).length) return false;
		var windowX = e.pageX, // the x position relative to the browser window where the user's mouse currently is
			windowY = e.pageY, // the y position relative to the browser window where the user's mouse currently is
			hoverPos = this.windowToLocal(windowX, windowY),
			target = e.target || e.srcElement;
		if (!target || !target.nodeName) {
			target = { nodeName : '' };
		}
		// remove any old hover widgets
		$j('#waveform_hover_' + this.container.attr('id')).remove();
		// make sure they're actually mousing over the canvas
		if (target.nodeName != 'CANVAS' || hoverPos.y < 0 || hoverPos.y >= this.canvas.height || hoverPos.x < 0 || hoverPos.x >= this.canvas.width) {
			// they're not, so get rid of the hover pos
			if (this.hoverPos) {
				// if hoverPos is set, that means they were moused on last frame and we need it to redraw
				// one more time to get rid of the bar. the -1,-1 is a special value telling draw to do that
				this.hoverPos = { x : -1, y : -1 };
			}
		} else {
			// save the hover pos so it'll be drawn in the draw function
			this.hoverPos = hoverPos;
			// determine the time text to display
			var totalTime = sa.components.player.getTotalTime();
			var currentTime = '';
			if (totalTime) {
				currentTime = secondsToClockTime((hoverPos.x / this.canvas.width) * totalTime) + '/' + secondsToClockTime(totalTime);
			} else {
				currentTime = 'time loading...';
			}
			// create a new hover widget
			var hover = $j('<div id="waveform_hover_' + this.container.attr('id') + '" class="waveform_hover">' + currentTime + '</div>');
			// add it and put it in the right position
			$j('body').append(hover);
			var hoverWidth = hover.outerWidth();
			var hoverLeft = Math.max(0, Math.min(windowX - hoverWidth / 2, $j(window).width() - hoverWidth));
			hover.css({
				top : ($j(this.canvas).offset().top - hover.outerHeight()) + 'px',
				left : hoverLeft + 'px'
			});
			if (!this.ieMode) {
				// ie mode flips out when you try to redraw this often
				sa.components.waveformManager.updateWaveform(this);
			}
		}
		// keep it showing
		return true;
	};

	/**
	 * Translates a browser window x and y position to x and y inside the waveform canvas
	 * @param {int} windowX the x position in the window
	 * @param {int} windowY the y position in the window
	 * @return {object} the local position { x : int, y : int } (x and y can be negative)
	 */
	this.windowToLocal = function(windowX, windowY) {
		var offset = $j(this.canvas).offset();
		return { x : windowX - offset.left, y : windowY - offset.top };
	};

	/**
	 * Draws a disabled version of the waveform, showing the waveform and then covering it with a faded transparency
	 */
	this.drawDisabled = function() {
		if (!this.context) return;
		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
		if (this.ieMode) {
			for (var i = 0; i < this.data.length; i++) {
				this.drawLightBar(this.context, i, this.data[i]);
			}
		} else if (this.canvas.width && this.canvas.height) {
			this.context.drawImage(this.waveCanvasLight, 0, 0);
		// } else {
		// 	console.log('skipping draw because of canvas dimensions', this.canvas.width, this.canvas.height);
		}
		//this.context.fillStyle = 'rgba(255, 255, 255, 0.7)';
		//this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
	};

	/**
	 * Draws one light colored bar with shadow on a canvas context
	 * @param {CanvasRenderingContext2D} context the canvas context on which to draw the bar
	 * @param {int} x the x coordinate on the canvas to draw the bar
	 * @param {int} height the height of the bar
	 */
	this.drawLightBar = function(context, x, height) {
		try {
			if (height > 0) {
				context.fillStyle = this.lightBarShadowColor;
				context.fillRect(x, Math.floor((this.canvas.height - height) / 2) + height, 1, 1);
			}
			context.fillStyle = this.lightBarColor;
			context.fillRect(x, Math.floor((this.canvas.height - height) / 2), 1, height ? height : 1);
		} catch (e) {
			console.log('error drawing light bar at ' + x + ' with height ' + height);
		}
	};

	/**
	 * Draws one dark colored bar with shadow on a canvas context
	 * @param {CanvasRenderingContext2D} context the canvas context on which to draw the bar
	 * @param {int} x the x coordinate on the canvas to draw the bar
	 * @param {int} height the height of the bar
	 */
	this.drawDarkBar = function(context, x, height) {
		try {
			if (height > 0) {
				context.fillStyle = this.darkBarShadowColor;
				context.fillRect(x, Math.floor((this.canvas.height - height) / 2) + height, 1, 1);
			}
			context.fillStyle = this.darkBarColor;
			context.fillRect(x, Math.floor((this.canvas.height - height) / 2), 1, height ? height : 1);
		} catch (e) {
			console.log('error drawing dark bar at ' + x + ' with height ' + height);
		}
	};

	this.updateProgress = function(playPercentage, loadPercentage) {
		this.drawProgress(playPercentage, loadPercentage);
		updateComments(playPercentage);
	};

	/**
	 * Draws the waveform as enabled with a certain amount filled in
	 * @param {float} playPercentage the percentage of the track that's played
	 * @param {float} loadPercentage the percentage of the track that's loaded
	 */
	this.drawProgress = function(playPercentage, loadPercentage) {
		if (!this.loaded || !this.context) return;
		if (!this.enabled) {
			this.container.addClass('faux_button');
			this.enabled = true;
			this.hoverPos = null;
			/**
			 * What we're doing here is creating a window mousemove function that alerts
			 * all currently enabled waveforms of a move so they can see if it's in their boundaries.
			 * The list of enabled waveforms is stored in window['hoverWaveforms'];
			 * Since we can't count on the waveforms to be able to remove themselves from the list (user might change page, for example)
			 * the setHover functions of the waveforms returns false if they're no longer visible and the waveform is removed from the list.
			 * If the list is empty, the function removes itself from mousemove
			 */
			if (!window['hoverWaveforms']) {
				window['hoverWaveforms'] = [this];
			} else {
				window['hoverWaveforms'].push(this);
			}
			if (!ios) {
				$j(document).off('mousemove')
					.on('mousemove', function(e) {
						for (var i = 0; i < window['hoverWaveforms'].length; i++) {
							var waveform = window['hoverWaveforms'][i];
							if (typeof waveform.setHover != 'function' || !waveform.setHover(e)) {
								// remove it from the list
								window['hoverWaveforms'].splice(i, 1);
								i--;
							}
						}
						if (!window['hoverWaveforms'].length) {
							$j(document).off('mousemove');
						}
					});
			}
		}
		// if nothing's changed, we don't have to do anything
		if (playPercentage == this.lastPlayPercentage && loadPercentage == this.lastLoadPercentage && !this.dragPos && !this.hoverPos) return;
		this.lastPlayPercentage = playPercentage;
		this.lastLoadPercentage = loadPercentage;
		var t = (new Date()).getTime();
		// clear before we redraw
		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
		if (this.ieMode) {
			// ie doesn't support drawing from other canvases so we have to do a complete redraw each time
			for (var i = 0; i < this.data.length; i++) {
				var height = this.data[i];
				if (i / this.data.length < loadPercentage) {
					this.drawDarkBar(this.context, i, height);
				} else {
					this.drawLightBar(this.context, i, height);
				}
			}
		} else {
			// browsers that support canvas can draw from other canvases
			if (loadPercentage < 1) {
				// if it's not loaded completely, we draw the full light wave first
				this.context.drawImage(this.waveCanvasLight, 0, 0);
				if (loadPercentage > 0) {
					// then we draw the dark image as wide as we've loaded
					this.context.drawImage(this.waveCanvasDark, 0, 0, this.waveCanvasDark.width * loadPercentage, this.waveCanvasDark.height, 0, 0, this.waveCanvasDark.width * loadPercentage, this.waveCanvasDark.height);
				}
			} else {
				// if it's completely loaded, we just have to draw the full dark image
				this.context.drawImage(this.waveCanvasDark, 0, 0);
			}
		}
		// now we draw the hover line
		if (this.hoverPos) {
			if (this.hoverPos.x == -1) {
				// if hoverPos.x is -1, it's a signal that we needed to do a redraw and then remove hoverPos
				// if the mouse tracking function just unsets hoverPos and the track isn't playing, draw doesn't execute again
				// and the bar just sits there
				this.hoverPos = null;
			} else {
				this.context.fillStyle = this.hoverBarColor;
				this.context.fillRect(this.hoverPos.x - 1, 0, 1, this.canvas.height);
			}
		}
		// now we draw the progress line
		try {
			this.context.fillStyle = this.playheadColor;
			// if we're dragging, we draw the line at the drag position instead of the play position
			var playPos;
			if (this.dragPos) {
				playPos = this.dragPos.x;
				if (playPos > this.canvas.width) playPos = this.canvas.width;
				else if (playPos < 0) playPos = 0;
				sa.components.player.setProgress(playPos / this.canvas.width);
			} else {
				playPos = this.canvas.width * playPercentage;
			}
			this.context.fillRect(playPos - 1, 0, 3, this.canvas.height);
		} catch (e) {
			console.log('bad percentage: ' + playPercentage);
		}
		// some time logging
		if (this.logging) console.log((new Date()).getTime() - t);
	};

	/**
	 * Disables the waveform, drawing the disabled version
	 */
	this.disable = function() {
		if (this.enabled) {
			this.enabled = false;
			this.drawDisabled();
			this.container.removeClass('faux_button');
		}
	};

	/**
	 * Resizes the waveform if its container has changed dimensions
	 */
	this.resize = function() {
		var newWidth = this.getCanvasWidth();
		var canvas = this.canvas;
		if (newWidth == canvas.width) return;
		newCommentMarker = container.find('.new_comment_marker').detach();
		this.container.html('').data('waveform', '');
		this.loaded = false;
		this.init();
		this.lastPlayPercentage = -1;
	};

	/**
	 * Sets up the timeline, if there is one
	 */
	this.initTimeline = function() {
		if (this.timeline) {
			var timeline = this.container.find('.timeline');
			var totalTime = config.id == 90 || config.id == 92 ? 30 : this.track.actualLength; // priddis only plays 30s samples
			var getReadableTime = function(time) {
				if (totalTime < 5) {
					return secondsToString(time, true);
				} else {
					return secondsToClockTime(time);
				}
			};
			timeline.html(sa.components.waveformManager.templates.get('timeline', {
				time0 : getReadableTime(0),
				time25 : getReadableTime(totalTime * 0.25),
				time50 : getReadableTime(totalTime * 0.5),
				time75 : getReadableTime(totalTime * 0.75),
				time100 : getReadableTime(totalTime)
			}).html());
		}
		// comments
		this.container.find('.comment_handle_container').remove();
		var commentContainer = sa.components.waveformManager.templates.get('comment_handle_container');
		this.container.prepend(commentContainer);
		if (comments && comments.length) {
			var trackTime = this.track.actualLength,
				commentContainerWidth = commentContainer.outerWidth();
			for (var i = 0, len = comments.length; i < len; i++) {
				(function(comment) {
					var commentMarker = sa.components.waveformManager.templates.get('comment_marker', { id : comment.id });
					commentMarker.on('mouseenter', function() {
						if ($j('.comment_container.editing').length) return;
						manuallyShowingComment = comment;
						autoShowingComment = null;
						showComment(comment, commentMarker);
					});
					commentMarker.on('mouseleave', function() {
						if ($j('.comment_container.editing').length) return;
						manuallyShowingComment = null;
						hideComment(comment, commentMarker);
					});
					commentMarker.css({
						left : Math.floor(comment.time / trackTime * commentContainerWidth) - 6
						//borderBottomColor : markerColor
					});
					commentContainer.append(commentMarker);
				})(comments[i]);
			}
		}
		if (newCommentMarker && newCommentMarker.length) {
			// the waveform has been resized and we have a cached new comment marker
			commentContainer.append(newCommentMarker);
			newCommentMarker = null;
			$j('.edit_comment_time').trigger('input');
		}
	};

	var autoShowingComment = null,
		manuallyShowingComment = null,
		lastPlayPercentage = -1,
		removeCheckInterval;
	function showComment(comment, handle) {

		handle.addClass('showing');

		// if the current comment is already showing, we don't really have to do anything. just stop the hide timer
		var commentContainer = $j('.comment_container#comment_' + comment.id);
		if (commentContainer.length) {
			if (hideCommentTimer) clearTimeout(hideCommentTimer);
			commentContainer.addClass('showing');
			return;
		}

		// hide any currently showing comments (can happen easily if one is auto-opened by play timer and the user mouses over another)
		$j('.comment_container').each(function(index, commentContainer) {
			var commentData = $j(commentContainer).data();
			hideComment(commentData.comment, commentData.handle);
		});

		// only the currently open comment should be remove checked at a time (see below)
		if (removeCheckInterval) {
			clearInterval(removeCheckInterval);
			removeCheckInterval = null;
		}

		// now just set up the comment!
		commentContainer = sa.components.waveformManager.templates.get('comment_container', {
			commentId : comment.id,
			time : secondsToClockTime(comment.time),
			body : comment.comment.replace(/(http[s]?[^\s]+)/g, '<a href="$1" target="_blank">$1</a>')
		});
		var handleOffset = handle.offset(),
			handleOuterWidth = handle.outerWidth(),
			left = Math.min(handleOffset.left - 200 + handleOuterWidth / 2, $j('body').width() - 405); // comments should be centered under handles but not off the side of the page
		commentContainer.css({
			top : handleOffset.top + handle.outerHeight(),
			left : left,
			'transform-origin' : (handleOffset.left - left + handleOuterWidth / 2) + 'px top 0px' // the showing animation looks bad if it's not centered under the handle
		});
		commentContainer.find('.fa-times').on('click', function() {
			if (commentContainer.hasClass('editing')) {
				moveCommentToTime(comment.time);
			}
			hideComment(comment, handle);
		});
		commentContainer.on('mouseenter', function() {
			showComment(comment, handle);
			if (autoShowingComment && autoShowingComment.id == comment.id) return;
			manuallyShowingComment = comment;
			autoShowingComment = null;
		});
		commentContainer.on('mouseleave', function() {
			manuallyShowingComment = null;
			if (autoShowingComment && autoShowingComment.id == comment.id) return;
			hideComment(comment, handle);
		});
		if (comment.newComment) {
			manuallyShowingComment = comment;
			if (autoShowingComment) {
				hideComment(autoShowingComment);
				autoShowingComment = null;
			}
		}

		function moveCommentToTime(time) {
			var newHandleLeft = Math.floor(Math.min(time / waveform.track.actualLength, 1) * handle.parent().width()) - handle.width() / 2;
			handle.css({
				left : newHandleLeft
			});
			updateContainerLeft(newHandleLeft);
		}

		function updateContainerLeft(handleLeft) {
			var newContainerLeft = Math.min(handle.parent().offset().left + handleLeft - 200 + handleOuterWidth / 2, $j('body').width() - 405);
			commentContainer.css({
				top : handleOffset.top + handle.outerHeight(),
				left : newContainerLeft
			});
		}

		if (comment['editingParameters'] || comment.newComment) {
			commentContainer.addClass('editable');

			function editComment() {

				container.addClass('showing_comment_editor');

				commentContainer.addClass('editing');
				commentContainer.find('.time').html(sa.components.waveformManager.templates.get('comment_time_editing', { time : secondsToClockTime(comment.time) }).html());
				commentContainer.find('.comment_body').html(sa.components.waveformManager.templates.get('comment_body_editing').html()).find('textarea').val(comment.comment);
				commentContainer.off('mouseenter');
				commentContainer.off('mouseleave');
				$j(this).off('click');

				var timeInput = commentContainer.find('.edit_comment_time');
				timeInput.on('input', function() {

					var time = clockTimeToSeconds(timeInput.val());
					if (isNaN(time)) return;

					moveCommentToTime(time);
				});

				function updateTimeInput(handleLeft) {
					timeInput.val(secondsToClockTime(handleLeft / handle.parent().width() * waveform.track.actualLength, true));
				}

				handle.draggable({
					axis : 'x',
					containment : 'parent',
					drag : function(event, ui) {
						updateContainerLeft(ui.position.left);
						updateTimeInput(ui.position.left);
					},
					start : function() {
						commentContainer.addClass('no_transitions');
						$j('body').append('<div class="drag_cover"></div>');
					},
					stop : function() {
						commentContainer.removeClass('no_transitions');
						timeInput.trigger('input');
						setTimeout(function() {
							$j('.drag_cover').remove();
						}, 50);
					}
				});

				if (comment.newComment) {
					commentContainer.append(sa.components.waveformManager.templates.get('new_comment_options'));
					if (sa.getCurrentPageName() != 'project_item_list') {
						commentContainer.find(".new_comment_options .description").remove();
					}
				} else {
					commentContainer.find('.admin_options').append(sa.components.waveformManager.templates.get('comment_save_button'));
				}
				commentContainer.find('.save_comment').on('click', function() {

					var commentText = commentContainer.find('.edit_comment_body').val();
					var seconds = clockTimeToSeconds(timeInput.val());

					if (!commentText) {
						return sa.notify({ text: 'Please enter a comment' });
					} else if (isNaN(seconds)) {
						return sa.notify({ text: 'Please enter a time as either a number of seconds or in a mm:ss format' });
					}

					var postVars;
					if (comment.newComment) {
						postVars = $j.extend({
							trackId : waveform.trackId,
							commentId : comment.id,
							time : seconds,
							comment : commentText
						}, commentSaveVars ? commentSaveVars : {});
					} else {
						postVars = $j.extend({
							time : seconds,
							comment : commentText
						}, comment['editingParameters']);
					}

					ajax(postVars,
						function(response) {
							if (response[0].success) {
								sa.notify({ text : 'Comment ' + (comment.newComment ? 'created' : 'updated'), type : sa.notify.notificationTypes.success });
								sa.pages.details.resetTrackData();
								sa.requestCache.clear();
								sa.router.reloadPage();
							} else {
								sa.notify({ text : response[0].message });
							}
						}, 'POST', { p : 'comments', action : comment.newComment ? 'add' : 'edit' });
				});
			}

			if (comment.newComment) {
				editComment();
			} else {
				commentContainer.append(sa.components.waveformManager.templates.get('comment_editing_options',
					{ description : comment['description'] }));
				commentContainer.find('.edit_comment').on('click', function() {
					editComment();
				});

				commentContainer.find('.delete_comment').on('click', function() {

					var postVars = $j.extend({
						trackId : waveform.trackId,
						commentId : comment.id
					}, commentSaveVars ? commentSaveVars : {});

					ajax(postVars, function(response) {
						if (response[0].error) {
							sa.notify({ text : response[0].message });
						} else {
							sa.notify({ text: 'Comment deleted' });
							//hideComment(comment);
							sa.pages.details.resetTrackData();
							sa.requestCache.clear();
							sa.router.reloadPage();
						}
					}, 'POST', 'p=comments&action=delete');

				});
			}
		}

		// now actually add the comment to the page
		commentContainer.data({ handle : handle, comment: comment }); // so we can remove using hideComment when all we have is the comment container itself
		$j('body').append(commentContainer);
		setTimeout(function() {
			commentContainer.addClass('showing'); // if you don't use a timeout, the container will appear in the showing state with no transition (tested Chrome on Win 10)
		}, 10);

		// comments were getting stuck on sometimes if the page transitioned before they were removed. this check kills them if the parent waveform is no longer on the page
		removeCheckInterval = setInterval(function() {
			if (!$j(waveform.canvas).filter(':visible').length) {
				commentContainer.remove();
				clearInterval(removeCheckInterval);
				removeCheckInterval = null;
			}
		}, 250);
	}

	var hideCommentTimer;
	function hideComment(comment, handle) {
		var commentContainer = $j('.comment_container#comment_' + comment.id);
		if (!handle) {
			handle = container.find('#comment_' + comment.id);
		}

		// starts the visible hiding process
		handle.removeClass('showing');
		commentContainer.removeClass('showing');
		container.removeClass('showing_comment_editor');

		if (comment.newComment) {
			$j('.comment_handle_container .new_comment_marker').remove();
			manuallyShowingComment = null;
		}

		// we use a timeout so the user can mouse from handle to comment and back without instantly hiding. also facilitates animation completion
		if (hideCommentTimer) clearTimeout(hideCommentTimer);
		hideCommentTimer = setTimeout(function() {
			commentContainer.remove();
			hideCommentTimer = null;
			if (removeCheckInterval) {
				clearInterval(removeCheckInterval);
				removeCheckInterval = null;
			}
		}, 200); // timer amount set to coincide with the timing of the hide animation
	}

	// shows/hides comments based on the play head. as play moves, comments will be automatically shown
	function updateComments(playPercentage) {
		if (!comments || !comments.length || playPercentage == lastPlayPercentage) return;
		var time = playPercentage * waveform.track.actualLength,
			lastTime = lastPlayPercentage * waveform.track.actualLength;
		lastPlayPercentage = playPercentage;
		for (var i = comments.length - 1; i >= 0; i--) {
			var comment = comments[i];
			if (comment.time < time && comment.time + 5 > time && !(comment.time < lastTime && comment.time + 5 > lastTime) && !manuallyShowingComment) {
				autoShowingComment = comment;
				showComment(comment, $j('.comment_marker#comment_' + comment.id));
				return;
			} else if (autoShowingComment && autoShowingComment.id == comment.id && comment.time + 5 < time && comment.time + 5 >= lastTime) {
				autoShowingComment = null;
				hideComment(comment, $j('.comment_marker#comment_' + comment.id));
			}
		}
	}

	/**
	 * Sets up the basic canvas inside this.container and initializes this.canvas
	 */
	this.initCanvas = function() {
		this.container.html('<canvas width="' + this.getCanvasWidth() + '" height="' + this.getCanvasHeight() + '" id="canvas_'
				+ Math.floor(Math.random() * 100000) + '"></canvas>'
			+ (this.timeline ? '<div class="timeline"></div>' : ''));
		// canvas
		this.canvas = this.container.find('canvas').get(0);
	};

	/**
	 * Gets how wide the canvas should be
	 * @return {int} width in pixels
	 */
	this.getCanvasWidth = function() {
		return this.container.width();
	};

	/**
	 * Gets how tall the canvas should be based on whether we're in timeline mode
	 * @return {int} height in pixels
	 */
	this.getCanvasHeight = function() {
		return (this.container.height() - (heightPadding !== undefined ? heightPadding : (this.timeline ? 20 : 15)));
	};

	/**
	 * Sets up the basic frame for the waveform and calls load
	 */
	this.init = function() {
		// figure out our colors
		sa.components.waveformManager.addColors(this);
		// set up the canvas object to hold the view the user sees
		this.container.addClass('waveform_container waveform_' + this.track.file.waveformCallbackId).data('waveform', this);
		this.initCanvas();
		// set up the canvas objects to hold the background waveform
		this.waveCanvasLight = createElement('canvas');
		this.waveCanvasLight.width = this.getCanvasWidth();
		this.waveCanvasLight.height = this.getCanvasHeight();
		this.waveCanvasDark = createElement('canvas');
		this.waveCanvasDark.width = this.waveCanvasLight.width;
		this.waveCanvasDark.height = this.waveCanvasLight.height;
		if (!this.canvas) {
			console.log('canvas does not or no longer exists');
			return;
		}
		if (!this.canvas.getContext) {
			console.log('browser doesn\'t support canvas');
			return;
		}
		this.context = this.canvas.getContext('2d');
		// time line, if we have one
		this.initTimeline();
		// draw the basic, disabled waveform (since no data yet, will just be blank)
		//this.backgroundContext.fillStyle = '#DDDDDD';
		//this.backgroundContext.fillRect(0, 0, this.backgroundCanvas.width, this.backgroundCanvas.height);
		this.drawDisabled();
		// if we're allowing comments, show the button
		if (commentSaveVars || this.commentsEnabled) {
			this.enableCommenting(commentSaveVars);
		}
		// load the data
		this.load();
	};

	this.init();
}

/**
 * Callback for loading waveform data
 * @param {int} waveformCallbackId the id of the file the data belongs to
 * @param {Array.<float>} data the data
 */
function wfcb(waveformCallbackId, data) {
	var wf = $j('.waveform_' + waveformCallbackId);
	for (var i = 0; i < wf.length; i++) {
		$j(wf[i]).data('waveform').setData(data);
	}
}

/**
 * Tracks all the waveforms that have been created when we're in ie mode
 */
var waveformPool = {
	/**
	 * All the waveforms that have been created
	 */
	pool : [],

	/**
	 * Gets a waveform object that's not currently being displayed
	 * @return {HTMLCanvasElement/Boolean} a canvas element or false if there isn't one free
	 */
	getFree : function() {
		for (var i = 0; i < this.pool.length; i++) {
			// all waveform canvases have unique (hopefully) random ids so we can just see if it's in the dom
			if (!$j('#' + this.pool[i].id).length)
				return this.pool[i];
		}
		return false;
	},

	/**
	 * Adds another waveform to the pool
	 * @param {HTMLCanvasElement} waveform the element to add
	 */
	add : function(waveform) {
		this.pool.push(waveform);
	}
};


sa.components.billing = (function() {

	var billing = {};
	var templates;
	var focusBox;

	billing.build = function() {
		templates = sa.templates.get('components.billing');
	};

	/**
	 * Adds an addon to this site (if the user has the correct information and approves it)
	 * @param {string} addonType should match the type passed in to BillingAddon::RegisterType
	 * @param {function} callback passed true or false if the user subscribed or not, respectively
	 * @param {boolean} noProrate whether to use the template without prorating
	 */
	billing.addAddon = function(addonType, callback, noProrate = false) {

		var loader = templates.get('loader');
		showLoader(loader, 'Loading details...');
		var loaderFocusBox = new FocusBox(loader);
		loaderFocusBox.show();

		ajax({ p : 'billing', action : 'getAddonInformation', addonType : addonType }, function(addonInformation) {
			console.log('- billing info:', addonInformation);

			loaderFocusBox.hide();

			/**
			 * @var {Object} addonInformation
			 *  @property {string} error
			 *  @property {boolean} billingRequired if you haven't entered billing information, you can't add addons
			 *  @property {boolean} isSiteInvoicing if the site is invoicing and has no billing info, they get a different message
			 *  @property {boolean} isSiteUnpaid if the site is unpaid and has no billing info, they get a different message
			 *  @property {boolean} isSiteTrial if the site is a trial, they get a different message
			 *  @property {string} addonName
			 *  @property {string} addonDescription
			 *  @property {int} totalAmountInCents
			 *  @property {string} tacDocument (optional)
			 *  @property {string} billingExplanation
			 *  @property {string} cardDescription
			 *  @property {string} nextBillingDate
			 *  @property {string} nonce
			 *  @property {boolean} free
			 */

			if (addonInformation.error) {
				sa.notify({ text : addonInformation.error });
				callback(false);
				return;
			}

			if (addonInformation.billingRequired) {

				sa.confirm({
					text : templates.get('billingRequiredMessage' + (addonInformation.isSiteInvoicing ? 'Invoicing' : (addonInformation.isSiteUnpaid ? 'Unpaid' : (addonInformation.isSiteTrial ? 'Trial' : '')))).html(),
					yesText : 'Enable Billing',
					noText : 'Cancel',
					yesFunction : function() {
						var currentPath = sa.router.getCurrentPath();
						sa.router.routeTo('/admin?p=billing');
						AdminBilling.onCardUpdate = function() {
							sa.router.routeTo(currentPath);
							billing.addAddon(addonType, callback);
							return true;
						};
					},
					noFunction : function() {
						callback(false);
					},
					closeFunction : function() {
						callback(false);
					}
				});

			} else {
				const promptTemplate = addonInformation.free ? 'billingAddonPromptFree' : (noProrate ? 'billingAddonPromptNoProrate' : 'billingAddonPrompt');
				var template = templates.get(promptTemplate, {
					addonName : addonInformation.addonName,
					addonDescription : addonInformation.addonDescription,
					amount : addonInformation.totalAmountInCents.moneyFormat(2, true),
					cardDescription : addonInformation.cardDescription,
					nextBillingDate : addonInformation.nextBillingDate,
					billingExplanation : addonInformation.billingExplanation
				});

				if (addonInformation.tacDocument) {
					template.find('.tac_link').on('click', function() {
						sa.components.documentViewer.show(addonInformation.tacDocument);
					});
				} else {
					template.find('.tac').remove();
				}

				template.find('.subscribe_button').on('click', function() {

					template.find('.loading_button').addClass('showing');
					template.find('.subscribe_button').removeClass('showing');

					ajax({ nonce : addonInformation.nonce }, function(response) {

						if (response.error) {

							sa.notify({ text : response.error });
							callback(false);

						} else if (response.success) {

							focusBox.hide();
							focusBox = null;

							const subscribedTemplate = noProrate ? 'subscribedMessageNoProrate' : 'subscribedMessage';

							sa.alert({
								text : templates.get(subscribedTemplate, { addonName : addonInformation.addonName }).html(),
								onClose : function() { callback(true); }
							});

						} else {
							billing.addAddon(addonType, callback);
						}

					}, 'POST', { p : 'billing', action : 'addAddon', addonType : addonType });

				});

				template.find('.cancel_button').on('click', function() {
					focusBox.hide();
					focusBox = null;
				});

				if (focusBox) {
					focusBox.hide();
				}

				focusBox = new FocusBox(template, { title : addonInformation.addonName + ' Subscription' });
				focusBox.show();

			}

		});
	};

	/**
	 * Removes an addon from this site (if the user has the correct information and approves it)
	 * @param {string} addonType should match the type passed in to BillingAddon::RegisterType
	 * @param {function} callback passed true or false if the user subscribed or not, respectively
	 */
	billing.removeAddon = function(addonType, callback) {

		var loader = templates.get('loader');
		showLoader(loader, 'Loading details...');
		var loaderFocusBox = new FocusBox(loader);
		loaderFocusBox.show();

		ajax({ p : 'billing', action : 'getAddonInformation', addonType : addonType, remove : 1 }, function(addonInformation) {

			loaderFocusBox.hide();

			/**
			 * @var {Object} addonInformation
			 *  @property {string} error
			 *  @property {string} addonName
			 *  @property {string} addonUnsubscribeDescription
			 *  @property {string} nonce
			 */

			if (addonInformation.error) {
				sa.notify({ text : addonInformation.error });
				callback(false);
				return;
			}

			var template = templates.get('billingAddonRemovalPrompt', {
				addonUnsubscribeDescription : addonInformation.addonUnsubscribeDescription
			});

			template.find('.subscribe_button').on('click', function() {

				template.find('.loading_button').addClass('showing');
				template.find('.subscribe_button').removeClass('showing');

				ajax({ nonce : addonInformation.nonce }, function(response) {

					if (response.error) {

						sa.notify({ text : response.error });
						callback(false);

					} else if (response.success) {

						focusBox.hide();
						focusBox = null;

						sa.alert({
							text : templates.get('unsubscribedMessage', { addonName : addonInformation.addonName }).html(),
							onClose : function() { callback(true); }
						});

					} else {
						billing.removeAddon(addonType, callback);
					}

				}, 'POST', { p : 'billing', action : 'removeAddon', addonType : addonType });

			});

			if (focusBox) {
				focusBox.hide();
			}

			focusBox = new FocusBox(template, { title : addonInformation.addonName + ' Subscription' });
			focusBox.show();

		});
	};

	return billing;

})();

sa.components.brandingHeader = (function() {

	var brandingHeader = {
		attachOnLoad : true
	};
	var container;
	var hidden = false; // flag to reduce jquery calls on url changes
	var hasLogo = false;
	var hasBackground = false;
	var attached = false;
	var fullWidth = !!$j('body').addClass('branding_header_full_width').length;
	var temporarilyPartialWidth = false; // used if we're in fullWidth mode but the browser has resized to mid-size

	brandingHeader.build = function() {
		container = sa.templates.get('branding_header').get('branding_header');
		
		let baseUrl = siteBaseUrl();
		
		container.find('#logo').attr('href', baseUrl + '/' + sa.router.pathConversionLookup(config.home));

		hasLogo = !!config.theme.brandingHeaderLogo.path;
		hasBackground = !!config.theme.brandingHeaderBackground.path;
		
		if (hasLogo) {
			brandingHeader.setLogo(config.theme.brandingHeaderLogo, true);
		}
		if (hasBackground) {
			brandingHeader.setBackground(config.theme.brandingHeaderBackground, true);
		}
		if (hasLogo || hasBackground) {
			brandingHeader.setFullWidth(config.theme.brandingHeaderFullWidth);
		}
		if (config.theme.brandingHeaderLogo.options && config.theme.brandingHeaderLogo.options.position) {
			brandingHeader.setLogoPosition(config.theme.brandingHeaderLogo.options.position);
		}
	};

	brandingHeader.attach = function() {
		if (!attached && (hasLogo || hasBackground)) {
			sa.getDomBody().append(container).addClass('with_branding_header');
			attached = true;
			sa.on('beforeRouteChange', function() {
				brandingHeader.show();
			});
			sa.on('resize', function() {
				brandingHeader.resize();
			});
			brandingHeader.resize();
		}
	};
	
	brandingHeader.detach = function() {
		if (attached) {
			container.detach();
			attached = false;
			$j('body').removeClass('with_branding_header');
		}
	};
	
	brandingHeader.show = function() {
		if (attached && hidden) {
			container.removeClass('hidden');
			$j('body').addClass('with_branding_header');
			hidden = false;
			brandingHeader.resize();
		}
	};
	
	brandingHeader.hide = function() {
		if (attached) {
			container.addClass('hidden');
			$j('body').removeClass('with_branding_header');
			hidden = true;
		}
	};
	
	brandingHeader.setLogo = function(logoData, skipAttach) {
		hasLogo = !!logoData.path;
		if (hasLogo) {
			container.find('#logo_image').attr('src', logoData.path);
			if (!skipAttach) brandingHeader.attach();
		} else {
			container.find('#logo_image').removeAttr('src');
			if (!hasBackground && !skipAttach) {
				brandingHeader.detach();
			}
		}
	};
	// brandingHeader.setLogo = function(logoData, skipAttach) {
	// 	hasLogo = true;
	// 	container.find('#logo').html('<video id="logo_image" autoplay="autoplay" src="https://s3.amazonaws.com/sourceaudio-images/motus.mp4"></video>');
	// 	if (!skipAttach) brandingHeader.attach();
	// };

	brandingHeader.setBackground = function(imageData, skipAttach) {
		hasBackground = !!imageData.path;
		if (hasBackground) {
			container.css({
				backgroundImage : 'url(' + imageData.path + ')',
				backgroundRepeat : imageData.options && imageData.options.repeat ? 'repeat-x' : 'no-repeat'
			});
			if (!skipAttach) brandingHeader.attach();
		} else {
			container.css({ backgroundImage : '' });
			if (!hasLogo && !skipAttach) {
				brandingHeader.detach();
			}
		}
	};
	
	brandingHeader.setLogoPosition = function(position) {
		container.find('#logo').removeClass('left_aligned center_aligned right_aligned').addClass(position + '_aligned');
	};
	
	brandingHeader.resize = function() {
		if (hidden) return;
		if ($j(window).width() < 1200 && $j(window).width() >= 768) {
			if (fullWidth) {
				container.addClass('indents_with_left_nav');
				sa.getDomBody().removeClass('branding_header_full_width');
				temporarilyPartialWidth = true;
			}
		} else if (temporarilyPartialWidth) {
			temporarilyPartialWidth = false;
			if (fullWidth) {
				container.removeClass('indents_with_left_nav');
				sa.getDomBody().addClass('branding_header_full_width');
			}
		}
	};
	
	brandingHeader.setFullWidth = function(newFullWidth) {
		if (newFullWidth) {
			container.removeClass('indents_with_left_nav');
			sa.getDomBody().addClass('branding_header_full_width');
		} else {
			container.addClass('indents_with_left_nav');
			sa.getDomBody().removeClass('branding_header_full_width');
		}
		fullWidth = !!newFullWidth;
	};
	
	return brandingHeader;

})();
/**
 * Confirms and processes using download credit to purchase download-only tracks
 */

/**
 * TODO: is this used?
 * @param track
 * @param type
 * @constructor
 */

function DownloadCreditConfirm(track, type) {
	//private vars
	var dcc = this;
	var box = null;
	var made = false;
	var isProcessing = false;

	this.make = function() {
		//which make should we use?
		if(!user.credit) {
			if(config.licensing.show_cart) {
				dcc.makeAddToCart();
			} else {
				dcc.makeNoCredit();
			}

			return;
		}
		
		let baseUrl = siteBaseUrl();

		var box_content = ''
		+ '<div class="dl_credit_confirm">'
		+	'<div class="title">Download With Credit</div>'
		+	'<div class="desc">You are about to download the following track with credit:</div>'
		+	'<div class="track">'+track.title+'</div>'
		+	'<div class="remaining">If you accept, you will have <span class="amt">'+(user.credit - 1)+'</span> download credits left. To get more download credits, please <a href="'+baseUrl+'/feedback">contact us</a> for another code.</div>'
		+	'<div class="buttons">'
		+		'<div class="button faux_button cancel">Cancel</div>'
		+		'<div class="button faux_button submit">Download</div>'
		+	'</div>'
		+ '<div class="clr"></div>'
		+ '</div>';
		box = new FocusBox(box_content);

		made = true;
	};

	this.makeNoCredit = function() {
		let baseUrl = siteBaseUrl();
		var box_content = ''
		+ '<div class="dl_credit_confirm">'
		+	'<div class="title">You Have No Credit</div>'
		+	'<div class="desc">You don\'t have enough credit to download:</div>'
		+	'<div class="track">'+track.title+'</div>'
		+	'<div class="remaining">To get more download credits, please <a href="'+baseUrl+'/feedback">contact us</a> for another code.</div>'
		+	'<div class="buttons">'
		+		'<div class="button faux_button cancel" style="margin-left: 55px;">Close</div>'
		+	'</div>'
		+ '<div class="clr"></div>'
		+ '</div>';
		box = new FocusBox(box_content);

		made = true;
	};

	this.makeAddToCart = function() {
		let baseUrl = siteBaseUrl();
		var box_content = ''
		+ '<div class="dl_credit_confirm">'
		+	'<div class="title">Add To Cart</div>'
		+	'<div class="desc">You don\'t have enough credit to download:</div>'
		+	'<div class="track">'+track.title+'</div>'
		+	'<div class="remaining">Either click below to add the track to your cart or to get more download credits, please <a href="'+baseUrl+'/feedback">contact us</a> for a code.</div>'
		+	'<div class="buttons">'
		+		'<div class="button faux_button cancel">Cancel</div>'
		+		'<div class="button faux_button addtocart">Add To Cart</div>'
		+	'</div>'
		+ '<div class="clr"></div>'
		+ '</div>';
		box = new FocusBox(box_content);

		made = true;
	};

	this.show = function() {
		if(!made) dcc.make();
		box.show();

		//assign click functions
		$j('.dl_credit_confirm .cancel').off().on('click', function() {
			dcc.hide();
		});

		$j('.dl_credit_confirm .submit').off().on('click', function() {
			dcc.submit();
		});

		$j('.dl_credit_confirm .addtocart').off().on('click', function() {
			dcc.addToCart();
		});
	};

	this.hide = function() {
		box.hide();
	};

	this.setProcessing = function(newProcessing) {
		isProcessing = newProcessing;

		if(isProcessing) {
			$j('.dl_credit_confirm .submit').html('Processing...');
		} else {
			$j('.dl_credit_confirm .submit').html('Download');
		}
	};

	/**
	 * Actually do the license behind the scenes, and barring any complications, start the download
	 */

	this.submit = function() {
		if(isProcessing) {
			console.log('fail submit because we are processing');
			return;
		}

		dcc.setProcessing(true);


		console.log('triggering download purchase for', track, 'and then downloading', type);

		var license_type = (config.licensing.paid_downloads) ? 'Paid Download' : 'Royalty Free';
		var license = [license_type, license_type, license_type, 0, config.licensing.currency_marker];
		var license_string = objToVars('full_license', license);

		//split the name up into 2 parts, cause that's how we store stuff here
		var nameA = user.userData.username.split(" ");
		if(nameA.length > 1) {
			var first_name = nameA.shift();
			var last_name = nameA.join(" ");
		} else {
			first_name = user.userData.username;
			last_name = user.userData.username;
		}

		var shipping = new Object();
		shipping.company = user.company;
		shipping.firstName = first_name;
		shipping.lastName = last_name;
		shipping.streetAddress = '';
		shipping.extendedAddress = '';
		shipping.locality = '';
		shipping.region = '';
		shipping.postalCode = '';
		shipping.countryCodeAlpha2 = '';

		var shipping_string = objToVars('shipping', shipping);

		ajax(shipping_string +'&'+ license_string +'&project_title='+ 'in-line purchase' +'&project_note='+ '' +'&project_po='+ '' +'&track_id='+track.id, function(response) { dcc.braintreeChargeHandler(response); }, 'POST', 'p=braintree&action=payWithCredit');
	};

	/**
	 * the handler for braintree charges
	 * - final step of payment, sends to next page
	 */
	this.braintreeChargeHandler = function(response) {

		response = response[0];
		console.log('braintree charge response:', response);
		if (response.success) {
			console.log('success!');

			user.credit--;
			$j('#download_credit .amount').html(user.credit);


			dcc.hide();

			window.location.href = siteBaseUrl() + '/download.php?track_id=' + track.id + '&type=' + type + '&source=download_credit';

			dcc.afterSuccess();
		} else {
			sa.notify({ text : 'There was a problem processing your credit. Please check the details and try again.' });
			dcc.setProcessing(false);
			return;
		}
	};

	this.addToCart = function() {
		var item = { type : 'royalty_free', track_id : track.id, price : track.price };

		let baseUrl = siteBaseUrl();
		
		if(sa.components.shoppingCart.addItem(item)) {
			sa.notify({ 
				text: $j('<div>Added to cart!<br/><a href="'+baseUrl+'/shopping_cart">Click to go to cart.</a></div>') 
			});
		}

		dcc.hide();
	};

	this.isExtraType = function() {
		return (type != 'mp3' && type != 'wav' && type != 'aiff');
	};

	/**
	 * Placeholder for an "after success" function to be passed in by the calling location
	 * default is a reload
	 */
	 this.afterSuccess = function() {
	 	console.log('after succes default, reloading...');
	 	setTimeout(function() { window.location.reload(); }, 2000);
	 };


}


function AutoCreditPurchaseFunc() {
    var acp = this;
    this.credit = null;
    this.track = null;
    this.type = null;
    this.cb = function(){};


    this.attempt = function(track, type, profile, cb) {
        acp.cb = cb || console.log;
        acp.track = track;
        acp.type = type;

        if (!profile.oneprice) return {error: 'Not one-click purchasable.'};

        // does this user have any credit?
        sa.api.request({
            handler: 'licensing/licensingCheckout',
            action: 'getUserOptions'
        }).then(function (r) {
            if (r.error) {
                console.log('- error loading options:', r.error);
                return cb();
            }

            acp.credit = r;
            console.log('- loaded user options', r);

            var total = r ? r.coupon_credit + r.download_credit : 0;

            // no credit
            if (!total) {
                sa.notify({ text: 'You do not have a license for this track or any credit to use. Add it to your cart!' });
                return cb({ error: 'No credit.' });
            }

            

            const purchase = function() {
                profile.data.children[0].agreement = profile.data.agreement;

                // create the cart item
                var cart = [{
                    type: 'licensing',
                    item_id: track.id + '-' + profile.id + '-0',
                    track_id: track.id,
                    track: track,
                    license: [profile.data.children[0]],
                    project: [],
                    price: profile.oneprice
                }];

                sa.notify({ text: 'Purchasing with credit...' });

                sa.api.request({
                    handler: 'licensing/licensingCheckout',
                    action: 'creditCheckout',
                    postData: {
                        cartItems: JSON.stringify(cart)
                    }
                }).then(acp.handlePurchase);
            }

            if (total == 99999) { // unlimited, skip the confirm
                return purchase();
            }

            sa.confirm({
                text: 'You currently have <b>' + total + '</b> credit. Do you want to use one and download this track?',
                yesFunction: function () {

                    return purchase();
                },
                yesText: 'Use Credit'
            });

        });
    };

    this.handlePurchase = function(r) {
        window.location.href = siteBaseUrl() + '/download.php?track_id=' + acp.track.id + '&type=' + acp.type + '&source=download_credit';
    };


}
var AutoCreditPurchase = new AutoCreditPurchaseFunc();
/* eslint-disable */
/**
 * The project manager that lives in the left nav
 */
sa.components.projector = (function() {

	/** @var TemplateSet */
	var templates;

	var projector = {};

	// if true, projector will attach
	var autoShow = false;

	/**
	 * Some globals used to start an applyFrom chain. See projector.applyFrom for details
	 */
	projector.SORT = 'sort';
	projector.FILTER = 'filter';

	/**
	 * {JQuery} the container for the whole left nav element the projector lives in
	 */
	projector.container = null;

	/**
	 * All the projects, sorted
	 */
	projector.sortedProjects = [];

	/**
	 * The projects filtered by the current search
	 */
	projector.filteredProjects = [];

	/**
	 * The id of the project that's currently highlighted
	 */
	projector.highlightedProject = 0;

	/**
	 * The focus box the project options are displayed in
	 */
	projector.projectOptionsBox = null;

	/**
	 * The projects we're in quick project mode for
	 */
	projector.quickProjects = [];

	/**
	 * Should we show the splash page when the projector is added to a page?
	 */
	projector.splashWaiting = false;

	/**
	 * The project for which we're checking concurrency
	 */
	var concurrentProjectId = 0;
	/**
	 * The setTimeout that we called as a wait between concurrency checks
	 */
	var concurrentProjectTimer = null;
	/**
	 * Appears at the top of the projector widget in the left nav
	 */
	var playlistText = config.id == 162 ? 'Project' : 'Playlist',
		playlistsText = config.id == 162 ? 'Projects' : 'Playlists';

	/**
	 * Used to track between reloads which projects are open
	 */
	var savedOpenStates = {};

	projector.resize = debounce(function() {
		const isExpanded = projector.container.hasClass('expanded');
		if (isExpanded) return;
		
		const leftNavHeight = $j('#left_nav').height();
		let visibleLeftNavSectionsHeight = 0;
		$j('.left_nav_section:visible:not(.project_section), .cue_sheet_section').each(function(i, section) { visibleLeftNavSectionsHeight += $j(section).outerHeight(); });
		const projectList = projector.container.find('.project_list');
		projectList.css({ maxHeight : '' });
		const projectListDefaultHeight = parseInt(window.getComputedStyle(projectList[0]).maxHeight);
		const availableProjectListHeight = leftNavHeight - visibleLeftNavSectionsHeight - projector.container.outerHeight() + projectList.outerHeight();

		if (availableProjectListHeight > projectListDefaultHeight) {
			projectList.css({ maxHeight : availableProjectListHeight + 'px' });
		}

		// show/hide expander
		if (projectList[0].scrollHeight > projectList[0].clientHeight) {
			projector.container.find('.expand_state').removeClass('hide');
		} else {
			projector.container.find('.expand_state').addClass('hide');
		}
	}, 250);

	/**
	 * Checks for an update to the concurrency for this project
	 * @param {Project} project the project to check
	 */
	projector.checkConcurrency = function(project) {
		//console.log('doing concurrency check');
		if ((project.shared || project.id == concurrentProjectId) && concurrentProjectTimer && (project.id != concurrentProjectId || !project.shared)) {
			// we were previously checking a different project
			clearTimeout(concurrentProjectTimer);
			concurrentProjectTimer = null;
			sa.pages.projectItemList.displayConcurrentUsersList([], project);
			//console.log(' clearing because different project');
		}
		if (!project.shared) {
			//console.log(' returning because project is not shared');
			return;
		}
		var pageProjectId = null;

		if (sa.currentPage && sa.currentPage.name == 'project_item_list') {
			pageProjectId = sa.pages.projectItemList.project.id;
		} else if ("playlists" === sa.router.getCurrentRoute(true)) {
			pageProjectId = sa.getPage("playlistManager").getSelectedPlaylistId();
		}
		// make sure we're still on a page where we care
		if (!projector.isQuickProject(project.id) && (null === pageProjectId || pageProjectId !== project.id)) {
			//console.log(' returning because we are not on a page we care about');
			return;
		}
		// we are!
		concurrentProjectId = project.id;
		ajax('p=projects&projectId=' + project.id + '&action=concurrency&created=' + project.created, function(response) {
			//console.log(' got response', response);
			var result = response[0].result,
				changed,
				users;
			if (result == 'change') {
				changed = true;
			} else if (result == 'no-change'){
				changed = false;
			} else if (result == 'reload-change') {
				// the user's permissions on the project changed
				// reload the project list so it gets the appropriate + button
				user.reloadProjects();
				// if the user was editing the project, stop them
				projector.removeQuickProject(project);
				// reload the page so it has the reordering arrows
				sa.router.reloadPage();
				return;
			} else {
				//console.log(' returning from response because of response');
				// take us to the home page and reload projects
				clearTimeout(concurrentProjectTimer);
				concurrentProjectTimer = null;
				return; // we didn't have access to this project or something
			}
			users = response[0].users;
			sa.pages.projectItemList.displayConcurrentUsersList(users, project);
			if (changed) {
				// freak out
				var items = response[0].items,
					onProjectPage = false;

				sa.getPage('playlistManager').receiveConcurrencyNotification(project, response);

				// if we're on the project's page, reload it
				if (sa.currentPage && sa.currentPage.name == 'project_item_list' && sa.pages.projectItemList.project.id == project.id) {
					sa.pages.projectItemList.reload(items);
					onProjectPage = true;
				} else if (projector.isQuickProject(project.id)) {
					// update any + or - icons (we can only do this if they're editing a single project. if they're doing multiples, we can't tell if they've changed the button state)
					sa.requestCache.clear();
					if (projector.quickProjects.length == 1) {
						// unselect anything that's selected
						$j('.quick_project_button img[src="images/buttons/project_remove.png"]').attr('src', 'images/buttons/project_add.png');
						// grab all the buttons
						var buttons = $j('.quick_project_button img');
						// go through all the items and add
						for (var i = 0, len = items.length; i < len; i++) {
							var item = items[i];
							buttons.filter('.quick_project_' + item.type + '_image_' + item.id).attr('src', 'images/buttons/project_remove.png');
						}

					} else {
						// just reload, I guess
						sa.router.reloadPage();
					}
				}
				// see if the details changed
				var details = response[0].details;
				if (details.name != project.name || details.description != project.description || details.image != project.image) {
					if (details.name != project.name) {
						// name changed
						project.name = details.name;
						if (onProjectPage) {
							$j('#heading #text span:first').html(project.name + '(' + project.totalTrackCount + ')');
						}
					}
					if (details.description != project.description) {
						// description changed
						project.description = details.description;
					}
					if (details.image != project.image) {
						// image changed
						project.image = details.image;
						if (onProjectPage) {
							$j('#heading .avatar').remove();
							if (project.image) {
								$j('#heading').prepend('<div class="avatar"><img src="' + project.image + '"/></div>');
							}
						}
					}
					user.reloadProjects();
				}
			}
			// set a timeout so we reload the list
			// if we're the only one viewing, we check every 5s for other viewers. if others are viewing, we're on the lookout for changes so we check every 1s
			concurrentProjectTimer = setTimeout(function() {
				if (projector.concurrentProjectTimer) clearTimeout(projector.concurrentProjectTimer);
				projector.concurrentProjectTimer = null;
				projector.checkConcurrency(project);
			}, users.length > 1 ? 1000 : 5000);
		});
	};

	/**
	 * Updates the list of all projects and then applies the current applyFrom chain and displays them
	 * @param {Array} projects the projects to display
	 */
	projector.setProjects = function(projects) {
		if (!projector.container) {
			console.error('Projector container is null when calling setProjects');
			return;
		}
		projector.sortedProjects = projects;
		projector.applyFrom(projector.SORT);
		// for the mobile menu
		sa.trigger('projects_reload');
	};

	/**
	 * Projects come in as a list of all projects and then go through a chain of filters and sorts before
	 * they're ready to display. This function manages going through those stages in order
	 * @param {string} from one of the projector.STAGE vars defined at top. Determines what step in the chain to begin with
	 */
	projector.applyFrom = function(from) {
		//noinspection FallThroughInSwitchStatementJS - the fallthrough is intentional
		switch (from) {
			case projector.SORT:
				projector.applySort();
			case projector.FILTER:
				projector.applyFilter();
		}
		projector.populate();
	};

	/**
	 * Adds the projector to the left nav
	 */
	projector.show = function() {
		if (!projector.container) {
			autoShow = true;
			return;
		}
		sa.components.leftNav.addComponent(projector.container);
		if (projector.splashWaiting) {
			setTimeout(function() { projector.showSplash(); }, 250);
			projector.splashWaiting = false;
		}
		projector.container.find('#sort select').trigger('change');

		// resizing
		// console.log('calling projector.resize because of projector.show');
		projector.resize();
		sa.components.selector.off('.projector_resize');
		sa.components.selector.on('show.projector_resize', function() { projector.resize(); });
		sa.components.selector.on('hide.projector_resize', function() { projector.resize(); });
		sa.components.leftNav.getSections().each(function(i, section) {
			section.off('.projector_resize');
			section.on('resize.projector_resize', function() { projector.resize(); });
			section.on('show.projector_resize', function() { projector.resize(); });
			section.on('hide.projector_resize', function() { projector.resize(); });
		});
		sa.components.cueSheeter.off('.projector_resize');
		sa.components.cueSheeter.on('resize.projector_resize', function() { projector.resize(); });
		$j(window).off('.projector_resize');
		$j(window).on('resize.projector_resize', function() { projector.resize(); });
	};

	/**
	 * Creates a button that activates quick project mode for a specific project
	 *  Some of this code is replicated in projector.populate
	 * @param {Project} project the project to activate mode for
	 * @param {Object=} options
	 * 	@property {boolean} small should we use a small button? defaults to false
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery}
	 */
	projector.generateQuickProjectModeButton = function(project, options) {
		options = $j.extend({
			small : false,
			wide : false,
			text : 'Add/Remove'
		}, options);
		var img = templates.get('quick_project_mode_button' + (options.wide ? '_wide' : ''), { projectId : project.id, text : options.text, extraClasses : (options.small ? 'small ' : '') + (projector.isQuickProject(project.id) ? 'active' : '') });
		img.on('click', function() {
			projector.toggleQuickProjectMode(project);
			this.blur();
			return false;
		}).data('project', project);
		return img;
	};

	/**
	 * Creates a button that adds/removes a track to the current quick project
	 * @param {int} trackId the track to add/remove from the current quick project
	 * @return {JQuery} the button
	 */
	projector.generateQuickProjectTrackButton = function(trackId) {
		var track = trackBank.find(trackId);
		if (!track) return null; // this can happen if you go into add more with an empty project open
		var img = templates.get('quick_project_track_button', { trackId : trackId });
		if (projector.hasAllQuickProjects(track.user_projects)) {
			img.addClass('has_projects');
		}
		img.on('click', function(e) {
			if (window.event) e = window.event;
			projector.addQuickProjectTrack(trackId, !img.hasClass('has_projects'), e.ctrlKey || e.shiftKey);
			return false;
		});
		return img;
	};

	/**
	 * Sets the state for all the currently displayed quick project buttons for a single track
	 * @param {int} trackId
	 * @param {boolean} hasProject
	 */
	function updateQuickProjectTrackButtons(trackId, hasProject) {
		if (hasProject) {
			$j('.quick_project_track_button_' + trackId).addClass('has_projects');
		} else {
			$j('.quick_project_track_button_' + trackId).removeClass('has_projects');
		}
	}

	/**
	 * Creates a button that adds/removes an album to the current quick project
	 * @param {Album} album the album to add/remove from the current quick project
	 * @param {Object=} options
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery}
	 */
	projector.generateQuickProjectAlbumButton = function(album, options) {
		options = $j.extend({
			wide : false,
			text : 'Add/Remove Album'
		}, options);
		var img = templates.get('quick_project_album_button' + (options.wide ? '_wide' : ''), { albumId : album.id, text : options.text });
		if (projector.hasAllQuickProjects(album.user_projects)) {
			img.addClass('has_projects');
		}
		img.on('click', function(e) {
			if (window.event) e = window.event;
			projector.addQuickProjectAlbum(album, !img.hasClass('has_projects'), e.ctrlKey || e.shiftKey);
			return false;
		});
		return img;
	};

	/**
	 * Sets the state for all the currently displayed quick project buttons for a single album
	 * @param {int} albumId
	 * @param {boolean} hasProject
	 */
	function updateQuickProjectAlbumButtons(albumId, hasProject) {
		if (hasProject) {
			$j('.quick_project_album_button_' + albumId).addClass('has_projects');
		} else {
			$j('.quick_project_album_button_' + albumId).removeClass('has_projects');
		}
	}

	/**
	 * Lets you know whether or not quick project mode is active
	 * @return {boolean} is it?
	 */
	projector.inQuickProjectMode = function() {
		return !!projector.quickProjects.length;
	};

	/**
	 * Determines if a given project is in the quick projects
	 * @param {int} projectId the id of the project to check
	 * @return {boolean} is it?
	 */
	projector.isQuickProject = function(projectId) {
		for (var i = 0; i < projector.quickProjects.length; i++) {
			if (projector.quickProjects[i].id == projectId) return true;
		}
		return false;
	};

	/**
	 * Checks if the passed in projects is a superset of the quick projects
	 * 	ex: project.quickProjects = [1,2]; projector.hasAllQuickProjects([1,2,3]) === true
	 * 	despite that example, these things are projects and NOT ints
	 * @param {Array} projects array of project objects
	 * @return {boolean} is it?
	 */
	projector.hasAllQuickProjects = function(projects) {
		if (!projects || !projects.length || !projector.quickProjects.length || projects.length < projector.quickProjects.length) return false;
		for (var i = 0; i < projector.quickProjects.length; i++) {
			var found = false;
			for (var j = 0; j < projects.length; j++) {
				if (projects[j].id == projector.quickProjects[i].id) {
					found = true;
					break;
				}
			}
			if (!found) return false;
		}
		return true;
	};

	/**
	 * Turns quick project mode on or off
	 * @param {Project} project the project to activate/deactive mode for
	 */
	projector.toggleQuickProjectMode = function(project) {
		if (sa.components.nester.inNestingMode()) {
			sa.components.nester.disable();
		}
		if (sa.components.cueSheeter.inQuickCueSheetMode()) {
			sa.components.cueSheeter.disableQuickCueSheetMode();
		}
		if (projector.isQuickProject(project.id)) {
			// quick project mode is already on for this track. kill it
			projector.removeQuickProject(project);
			// in this case, we don't want to activate the new one
			return;
		}
		projector.quickProjects.push(project);
		projector.handleQuickProjectsChange();
		if (project.shared) {
			projector.checkConcurrency(project);
		}
	};

	/**
	 * Does everything you need to do once you've changed the quick project list
	 */
	projector.handleQuickProjectsChange = function() {
		// enable the buttons on the track lists
		getTrackList().disableQuickProjects();
		getAlbumList().disableQuickProjects();
		if (projector.quickProjects.length) {
			getTrackList().enableQuickProjects();
			getAlbumList().enableQuickProjects();
			sa.components.bottomBar.enableQuickProjects();
			sa.components.player.enableQuickProjects();
			sa.components.heading.enableQuickProjects();
		} else {
			sa.components.bottomBar.disableQuickProjects();
			sa.components.player.disableQuickProjects();
			sa.components.heading.disableQuickProjects();


		}
		var currentPageName = sa.getCurrentPageName();
		// enable the button on the details page
		if (currentPageName == 'details') {
			if (projector.quickProjects.length) {
				sa.pages.details.enableQuickProjects();
			} else {
				sa.pages.details.disableQuickProjects();
			}
		}
		// // enable the button on the album track lists
		// if (currentPageName == 'explorer') {
		// 	if (projector.quickProjects.length) {
		// 		sa.currentPage.enableQuickProjects();
		// 	} else {
		// 		sa.currentPage.disableQuickProjects();
		// 	}
		// }
		// set up the quick project bar
		var quickProjectBar = sa.components.quickProjectBar;
		if (projector.quickProjects.length) {
			quickProjectBar.setProjects(projector.quickProjects);
			quickProjectBar.show('project', function() { projector.disableQuickProjectMode(); });
		} else {
			quickProjectBar.hide();
		}
		sa.trigger('scroll');
		// swap the buttons
		$j('.quick_project_button.active').removeClass('active');
		for (var qp = 0, qpLen = projector.quickProjects.length; qp < qpLen; qp++) {
			$j('.quick_project_' + projector.quickProjects[qp].id).addClass('active');
		}
		// show/hide the batch delete button
		// projector.container.find('.batch_delete_button').remove();
		// if (projector.quickProjects.length) {
		// 	let button = templates.get('batch_delete_button');
		// 	button.on('click', function(){
		// 		projector.deleteQuickProjects();
		// 	});
		// 	projector.container.find('#project_list').append(button);
		// }
	};

	/**
	 * Removes a project from the quick projects
	 * @param {Project} project the project to remove
	 */
	projector.removeQuickProject = function(project) {
		// remove the project from the list
		for (var i = 0; i < projector.quickProjects.length; i++) {
			if (projector.quickProjects[i].id == project.id) {
				projector.quickProjects.splice(i, 1);
			}
		}
		if (projector.quickProjects.length) {
			// if there are more projects, we need to regenerate the header
			projector.handleQuickProjectsChange();
		} else {
			// that was it. just disable
			projector.disableQuickProjectMode();
		}
	};

	/**
	 * Turns quick project mode off
	 */
	projector.disableQuickProjectMode = function() {
		projector.quickProjects = [];
		projector.handleQuickProjectsChange();
	};

	/**
	 * Confirms with the user and then deletes all the currently selector projects
	 */
	projector.deleteQuickProjects = function() {
		let projectCount = projector.quickProjects.length;
		if (!projectCount) return;
		sa.confirm({
			text : 'Are you sure you want to delete ' + (projectCount > 1 ? 'these ' + projectCount + ' playlists' : 'this playlist') + '? Deleted playlists <b>are gone forever</b>.',
			yesText : 'Delete',
			noText : 'Cancel',
			yesFunction : function() {
				let projectIds = projector.quickProjects.map(function(project) { return project.id; });
				let removedProjectIds = [];
				projector.disableQuickProjectMode();
				// recursive function to move through and delete each project sequentially
				let deleteNextProject = function() {
					let projectId = projectIds.pop();
					if (projectId === undefined) {
						// done!
						sa.notify({ text : projectCount + ' playlist(s) removed!' });
						let matches = sa.router.getCurrentPath(true).match(/project\/([0-9]+)/);
						if (matches && removedProjectIds.indexOf(matches[1]) !== -1) {
							// they're on the page of one of the deleted projects. need to take them to another page
							let projectArray = user.getProjectArray();
							if (projectArray.length) {
								// if they have another project, take them to that
								sa.router.routeTo(getProjectLink(projectArray[0].id));
							} else {
								sa.router.routeTo('/tracks');
							}
						}
						return;
					}
					// remove from the local list
					let project = user.getProject(projectId);
					if (project) {
						user.removeProject(project);
					}
					projector.setProjects(user.getProjectArray());
					ajax({
						projectId : projectId
					}, function() {
						removedProjectIds.push(projectId);
						deleteNextProject();
					}, 'POST', 'p=projects&action=remove_project');
				};
				deleteNextProject();

			}
		})
	};

	/**
	 * Adds or removes a track from a quick project
	 * @param {int} trackId the id of the track to add/remove
	 * @param {boolean} add should we add the track or remove it
	 * @param {boolean} addToTop
	 */
	projector.addQuickProjectTrack = function(trackId, add, addToTop) {
		// you should also always have a quick project but again, jic
		if (!projector.quickProjects.length) return console.log('Add track called without quick playlist ' + trackId);
		// figure out if the current quick project is one of the track's projects
		var addTrack = add ? 1 : 0;
		// now either send the command to remove the track or add it
		var projectIds = [];
		for (var i = 0; i < projector.quickProjects.length; i++) {
			projectIds.push(projector.quickProjects[i].id);
		}
		ajax('p=projects&action=quick_track&add=' + addTrack + '&trackId=' + trackId + '&projectIds[]=' + projectIds.join('&projectIds[]=') + (addToTop ? '&addToTop=1' : ''),
			function(response) { projector.addQuickProjectItemResponse(response, function() { projector.addQuickProjectTrack(trackId, !add); }); });
		// we should change the button they clicked so they get some instant feedback
		updateQuickProjectTrackButtons(trackId, addTrack);
		// now we want to update project track counts. could let the server do this but it's a lot faster to do it ourselves
		// we also need to update the track bank so all copies of the track have the correct projects
		// you could do this with a page reload but we want you to be able to add/remove tracks without the page constantly refreshing
		if (!addTrack) addTrack = -1;
		sa.components.quickProjectBar.updateChangeSummary(addTrack, 0);
		var track = trackBank.find(trackId);
		for (let project of user.getProjectArray()) {
			if (projector.isQuickProject(project.id)) {
				// need to see if track already has project
				var notInProject = true;
				if (track) {
					for (var j = 0; j < track.user_projects.length; j++) {
						if (track.user_projects[j].id == project.id) {
							notInProject = false;
							// need to update the local cache of the track
							if (addTrack < 0) {
								track.user_projects.splice(j, 1);
							}
							break;
						}
					}
				}
				// need to update the local cache of the track
				if (addTrack > 0 && track) {
					track.user_projects.push(project);
				}
				// if the track is not in the project and we're adding it, or the track is in the project and we're removing it
				if (!project.includeNested && ((notInProject && addTrack > 0) || (!notInProject && addTrack < 0))) {
					project.trackCount += addTrack;
					project.totalTrackCount += addTrack;
					$j('#total_track_count_' + project.id).html(project.totalTrackCount);
				}
			}
		}
		if (track) {
			// need to update all instances of the track in the track bank so they show up correctly everywhere
			trackBank.updateAll(track.id, 'user_projects', track.user_projects);
		}
		projector.setProjects(user.getProjectArray());
		// clear the cache so if we go back to a project page, we get a new one
		sa.requestCache.clear();
	};

	/**
	 * Handles the response from the server after adding/removing a track or album from the quick project
	 *  Typically doesn't actually do anything with the response but potentially causes a reload
	 *  Handles server failure response, currently generated if you try to add a track that's not on your site (requests)
	 * @param {object} newData server response
	 * @param {function} failureCallback if the server response isn't "success", call this function
	 */
	projector.addQuickProjectItemResponse = function(newData, failureCallback) {
		if (newData.length && newData[0].result != 'Success') {
			failureCallback();
			return sa.notify({ text : newData[0].result });
		}
		// see if they're on the project list page, in which case we want to refresh
		for (var i = 0; i < projector.quickProjects.length; i++) {
			if ((sa.router.getCurrentPath(true)).indexOf(getProjectLink(projector.quickProjects[i].id)) === 0) {
				sa.requestCache.clear();
				sa.router.reloadPage();
				return;
			}
		}
		updateProjectCounts(newData[0].projects);
	};

	/**
	 * @param {Array.<Project>} projects
	 */
	function updateProjectCounts(projects) {
		var changed = false;
		projects.each(function(i, newProject) {
			var currentProject = user.getProject(newProject.id);
			if (currentProject && currentProject.includeNested && newProject.dateAltered > currentProject.dateAltered) {
				currentProject.trackCount = newProject.trackCount;
				currentProject.albumCount = newProject.albumCount;
				currentProject.totalTrackCount = newProject.totalTrackCount;
				$j('#total_track_count_' + newProject.id).html(newProject.totalTrackCount);
				currentProject.dateAltered = newProject.dateAltered;
				console.log('Updated project stats for', newProject, currentProject);
				changed = true;
			} else {
				console.log("Skipping project stats update", newProject, currentProject);
			}
		});
		if (changed) {
			projector.setProjects(user.getProjectArray());
		}
	}

	/**
	 * Adds or removes an album from a quick project
	 * @param {Object} album the album to add/remove
	 * @param {boolean} add should we add the album or remove it
	 * @param {boolean} addToTop 
	 */
	projector.addQuickProjectAlbum = function(album, add, addToTop) {
		// you should also always have a quick project but jic
		if (!projector.quickProjects.length) return console.log('Add album called without quick playlist ' + album.id);
		// figure out if the current quick project is one of the track's projects
		var addAlbum = add ? 1 : 0;
		// now either send the command to remove the album or add it
		var projectIds = [];
		for (var i = 0; i < projector.quickProjects.length; i++) {
			projectIds.push(projector.quickProjects[i].id);
		}
		ajax('p=projects&action=quick_album&add=' + addAlbum + '&albumId=' + album.id + '&projectIds[]=' + projectIds.join('&projectIds[]=') + (addToTop ? '&addToTop=1' : ''),
			function(response) { projector.addQuickProjectItemResponse(response, function() { projector.addQuickProjectAlbum(album, !add); }); });
		// we should change the button they clicked so they get some instant feedback
		updateQuickProjectAlbumButtons(album.id, addAlbum);
		// now we want to update project track counts. could let the server do this but it's a lot faster to do it ourselves
		// we also need to update the local cache of the album so subsequent views out of cache will have the right state
		if (!addAlbum) addAlbum = -1;
		sa.components.quickProjectBar.updateChangeSummary(0, addAlbum);
		for (let project of user.getProjectArray()) {
			if (projector.isQuickProject(project.id)) {
				// need to see if album already has project
				var notInProject = true;
				for (var j = 0; j < album.user_projects.length; j++) {
					if (album.user_projects[j].id == project.id) {
						notInProject = false;
						if (addAlbum < 0) {
							// need to update the local cache of the album
							album.user_projects.splice(j, 1);
						}
						break;
					}
				}
				if (addAlbum > 0) {
					// need to update the local cache of the album
					album.user_projects.push(project);
				}
				// if the track is not in the project and we're adding it, or the track is in the project and we're removing it
				if (!project.includeNested && ((notInProject && addAlbum > 0) || (!notInProject && addAlbum < 0))) {
					project.albumCount += addAlbum;
					project.totalTrackCount += album.count * addAlbum;
					$j('#total_track_count_' + project.id).html(project.totalTrackCount);
				}
			}
		}
		projector.setProjects(user.getProjectArray());
		// clear the cache so if we go back to a project page, we get a new one
		sa.requestCache.clear();
	};

	/**
	 * Adds a set of tracks to a project
	 * @param {int} projectId the id of the project to add to
	 * @param {Array} trackIds int ids of the tracks to add
	 * @param {Array} albumIds int ids of the albums to add
	 */
	projector.addItemsToProject = function(projectId, trackIds, albumIds) {
		// now either send the command to remove the track or add it
		var projectIds = [];
		for (var i = 0; i < projector.quickProjects.length; i++) {
			projectIds.push(projector.quickProjects[i].id);
		}
		ajax((trackIds.length ? 'trackIds[]=' + trackIds.join('&trackIds[]=') : '') + (albumIds.length ? '&albumIds[]=' + albumIds.join('&albumIds[]=') : '') + '&projectId=' + projectId,
			function(response) {
				if (response[0].result != 'Success') {
					sa.notify({ text : response[0].result });
					return;
				}
				var newProject = response[0].projects[0];
				for (var i = 0, len = trackIds.length; i < len; i++) {
					var trackId = trackIds[i];
					// update the track bank so all copies of the track have the correct projects
					var track = trackBank.find(trackId);
					if (track) {
						// need to see if track already has project
						for (var j = 0; j < track.user_projects.length; j++) {
							if (track.user_projects[j].id == projectId) {
								// need to update the local cache of the track
								track.user_projects.splice(j, 1);
								break;
							}
						}
						track.user_projects.push(newProject);
						trackBank.updateAll(track.id, 'user_projects', track.user_projects);
						// change any quick buttons so they get some instant feedback
						// need to know if the track is in all quick projects
						var inProject = projector.hasAllQuickProjects(track.user_projects);
						updateQuickProjectTrackButtons(trackId, inProject);
					}
				}
				// update the user object's version of this project 
				user.updateProject(newProject);
				projector.setProjects(user.getProjectArray());
				$j('#total_track_count_' + newProject.id).html(newProject.totalTrackCount);
				// clear the cache so if we go back to a project page, we get a new one
				sa.requestCache.clear();
				if (sa.currentPage && sa.currentPage.name == 'project_item_list' && sa.pages.projectItemList.project.id == projectId) {
					sa.router.reloadPage();
				}
			}, 'POST', 'p=projects&action=add_items');
	};

	/**
	 * Adds a set of tracks to a project
	 * @param {int} projectId the id of the project to add to
	 * @param {Array} trackIds int ids of the tracks to add
	 * @param {Array} albumIds int ids of the albums to add
	 */
	projector.removeItemsFromProject = function(projectId, trackIds, albumIds) {
		// now either send the command to remove the track or add it
		var projectIds = [];
		for (var i = 0; i < projector.quickProjects.length; i++) {
			projectIds.push(projector.quickProjects[i].id);
		}
		ajax((trackIds.length ? 'trackIds[]=' + trackIds.join('&trackIds[]=') : '') + (albumIds.length ? '&albumIds[]=' + albumIds.join('&albumIds[]=') : '') + '&projectId=' + projectId,
			function(response) {
				if (response[0].result != 'Success') {
					sa.notify({ text : response[0].result });
					return;
				}
				var newProject = response[0].projects[0];
				for (var i = 0, len = trackIds.length; i < len; i++) {
					var trackId = trackIds[i];
					// now we want to update project track counts. could let the server do this but it's a lot faster to do it ourselves
					// we also need to update the track bank so all copies of the track have the correct projects
					// you could do this with a page reload but we want you to be able to add/remove tracks without the page constantly refreshing
					var track = trackBank.find(trackId);
					if (track) {
						// need to see if track already has project
						for (var j = 0; j < track.user_projects.length; j++) {
							if (track.user_projects[j].id == projectId) {
								// need to update the local cache of the track
								track.user_projects.splice(j, 1);
								break;
							}
						}
						trackBank.updateAll(track.id, 'user_projects', track.user_projects);
						// change any quick buttons so they get some instant feedback
						// need to know if the track is in all quick projects
						var inProject = projector.hasAllQuickProjects(track.user_projects);
						updateQuickProjectTrackButtons(trackId, inProject);
					}
				}
				// update the user object's version of this project
				user.updateProject(newProject);
				projector.setProjects(user.getProjectArray());
				// clear the cache so if we go back to a project page, we get a new one
				sa.requestCache.clear();
				if (sa.currentPage && sa.currentPage.name == 'project_item_list' && sa.pages.projectItemList.project.id == projectId) {
					sa.router.reloadPage();
				}
			}, 'POST', 'p=projects&action=remove_items');
	};

	/**
	 * Deletes a project
	 * @param {project} project the project to remove
	 */
	projector.removeProject = function(project) {
		// remove the project on the server
		ajax('projectId=' + project.id, function(response) { projector.removeProjectResponse(response); }, 'POST', 'p=projects&action=remove_project');
		// remove from the local list
		user.removeProject(project);
		projector.setProjects(user.getProjectArray());
		return false;
	};

	/**
	 * Handles the response from the server after you delete a project
	 */
	projector.removeProjectResponse = function(newData) {
		sa.requestCache.clear();
		// need to take them to another page
		let projects = user.getProjectArray();
		if (projects.length) {
			// if they have another project, take them to that
			sa.router.routeTo(getProjectLink(projects[0].id));
		} else {
			sa.router.routeTo('/tracks');
		}
		sa.notify({ text : createText(playlistText + ' removed') });
	};

	/**
	 * Creates a button that lets a user copy a project
	 * @param {Object} options
	 * 	@property {Project} project the project to copy
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery} the button
	 */
	projector.generateProjectCopyButton = function(options) {//project, wide, text) {

		options = $j.extend({
			project : null,
			wide : false,
			text : 'Copy'
		}, options);

		if (!options.project) {
			console.error('generateProjectCopyButton called but not passed a project');
			return $j();
		}

		var img = templates.get('project_copy_button' + (options.wide ? '_wide' : ''), { text : options.text });

		img.on('click', function () {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			sa.prompt({
				value : options.project.name + ' copy',
				placeholder : 'Name of playlist copy',
				yesFunction : function (val, interactionOptions) {
					return projector.copyProject(options.project, val, interactionOptions);
				},
				yesText : 'Copy'
			});
		});

		return img;
	};

	/**
	 * Validates and saves a copy of a project
	 * @param {Project} project the project being copied
	 * @param {string} newName the name for the copy
	 * @param {Object} interactionOptions the inputBox the user was entering information into
	 * @return {boolean} true of failure, false on success
	 */
	projector.copyProject = function(project, newName, interactionOptions) {
		// if they didn't change the name, make them
		if (newName == project.name && project.userId == user.userData.id) {
			interactionOptions.showError('There\'s already a '+ playlistText +' with this name. Please choose another.');
			return true;
		}
		// validate new name
		if (!newName.trim()) {
			interactionOptions.showError('Please enter a name for the ' + playlistText);
			return true;
		}
		// make sure it's not a duplicate name
		for (let testProject of user.getProjectArray()) {
			// if they entered the name of an existing project, don't let them change the name
			if (testProject.name == newName && testProject.id != project.id) {
				interactionOptions.showError('There\'s already a '+ playlistText + ' with this name. Please choose another.');
				return true;
			}
		}
		// notify the server of the name change
		ajax('name=' + encodeURIComponent(newName) + '&projectId=' + project.id, function(response) { projector.copyProjectResponse(response); }, 'POST', 'p=projects&action=copy');
		// can't do a local update. need to get the new project from the server
		return false;
	};

	/**
	 * Handles the response from the server after a copy
	 * @param {json} newData
	 */
	projector.copyProjectResponse = function(newData) {
		var projects = newData[0].projects;
		if (projects.length) {
			user.addProject(projects[0]);
			projector.setProjects(user.getProjectArray());
			sa.router.routeTo(getProjectLink(projects[0].id));
		} else {
			sa.notify({ text : 'An unknown error has occurred. Please try again later.' });
		}
	};

	/**
	 * Changes a project so it's created instead of received
	 * @param {Project} project the project to send
	 * @param {boolean} sendConfirmation should we force copy in case of viewing permission errors?
	 */
	projector.makeCreated = function(project, sendConfirmation) {
		ajax('projectId=' + project.id + (sendConfirmation ? '&conf=1' : ''), function(response) {
			if (response[0].result == 'viewing_error') {
				sa.confirm({
					text : 'If you change this playlist, you will lose access to some of its tracks. Continue?',
					yesFunction : function() { projector.makeCreated(project, true); },
					yesText : 'Continue'
				});
			} else {
				var newProject = response[0].projects[0];
				// Moves this project to your created list
				let existingProject = user.getProject(project.id);
				if (existingProject) {
					existingProject.created = 1;
					existingProject.trackCount = newProject.trackCount;
					existingProject.albumCount = newProject.albumCount;
					existingProject.totalTrackCount = newProject.totalTrackCount;
				}
				projector.setProjects(user.getProjectArray());
				// reload the page so they have all the options
				sa.requestCache.clear();
				sa.router.reloadPage();
			}
		}, 'POST', 'p=projects&action=make_created');
	};

	/**
	 * Creates a button to manage publishing settings for a project
	 * @param {Object} options
	 * 	@property {Project} project
	 * 	@property {boolean} wide
	 * 	@property {string} text
	 * @returns {JQuery}
	 */
	projector.generatePublishButton = function(options) {

		if (config.siteType === 'drop') {
			return projector.generateDropPublishButton(options);
		}

		options = $j.extend({
			project : null,
			wide : false,
			text : 'Publish Settings'
		}, options);

		if (!user.hasAdminPermission(AdminPermission.Feature)) {
			return $j();
		}

		var button = templates.get('project_publish_button' + (options.wide ? '_wide' : ''), { tooltip : options.text });

		button.on('click', function() {
			// find an updated version of the project in case it changed since this button was created
			let updatedProject = user.getProject(options.project.id);
			if (updatedProject) {
				options.project = updatedProject;
			}

			var fb;
			var div = templates.get('project_publish_options', { name : options.project.name });

			if (options.project.publish.licensee) {
				div.find('#publish_licensee').prop('checked', true);
			}

			var publishLocal = div.find('.publish_local');
			var publishLicensee = div.find('.publish_licensee');

			// toggle the licensee enabling checkbox when the local is swapped
			publishLocal.find('select').on('change', function() {
				if (this.value == '0') {
					publishLicensee.addClass('disabled');
					publishLicensee.find('input').prop('disabled', true).prop('checked', false);
				} else {
					publishLicensee.removeClass('disabled');
					publishLicensee.find('input').prop('disabled', false);
				}
				if (this.value == -1) {
					projector.generateProjectTabForm({
						onSave(tab) {
							publishLocal.find('select').append('<option value="' + tab.id + '">' + $j('<div/>').text(tab.name).html() + '</option>').val(tab.id);
						},
						onClose() {
							publishLocal.find('select').val(1);
						}
					});
				}
			});
			if (!options.project.publish.local) {
				publishLicensee.addClass('disabled');
				publishLicensee.find('input').prop('disabled', true).prop('checked', false);
			}

			// get a list of the local publishing options
			sa.api.request({
				handler: 'projectTabs',
				action: 'list'
			}).then((response) => {
				const tabs = response.items ?? [];
				console.log('tabs', tabs);
				var publishSelect = div.find('#publish_local').html('<option value="0">Unpublished</option>');
				for (var i = 0, len = tabs.length; i < len; i++) {
					var tab = tabs[i];
					publishSelect.append('<option value="' + tab.id + '"' + (options.project.publish.local == tab.id ? ' selected="selected"' : '') + '>' + tab.name + '</option>');
				}
				publishSelect.append('<option value="-1">+ New Collection</option>');

			})

			// make the buttons work
			div.find('#cancel_button').on('click', function() {
				fb.hide();
			});

			div.find('#save_button').on('click', function() {
				var local = div.find('#publish_local').val();
				var licensee = div.find('#publish_licensee:checked').length;
				ajax('publishLocal=' + local + '&publishLicensee=' + licensee + '&projectId=' + options.project.id, function(response) {
					if (response[0].result != 'Success') {
						sa.notify({ text : response[0].result });
						fb.hide();
						return;
					}
					sa.notify({ text : 'Publish settings for ' + options.project.name + ' saved!' });
					fb.hide();

					user.reloadProjects();
					// see if they want to add a tab
					if (local) {
						// see if they've got one already
						var foundProjectTab = false;
						for (var i = 0, len = config.tabs.length; !foundProjectTab && i < len; i++) {
							if (config.tabs[i].hash === 'playlists') {
								foundProjectTab = true;
							}
						}
						if (!foundProjectTab && user.hasAdminPermission(AdminPermission.Settings)) {
							sa.confirm({
								text: 'Do you want to add a playlist tab so users can find your playlist?',
								yesFunction: function () {
									// yes function
									ajax('p=projects&action=add_tab', function () {
										sa.notify({ text : $j('<div>Tab added!<br/>You can manage your tabs in your admin panel.</div>') });
										// add it to the current tabs
										config.tabs.push({ text: 'Playlists', hash: 'playlists', color: 'blue' });
										const baseUrl = siteBaseUrl();
										const playlistTab = `<a href="${baseUrl}/playlists" id="nav_projects" class="nav_item"><span class="nav_item_text">Playlists</span></a>`;
										$j('#nav_container').prepend(playlistTab);
									});
								},
								yesText: 'Add'
							});
						}
					} else if (user.userData.id != options.project.userId) {
						// user just unpublished the project they were looking at
						sa.router.routeTo(sa.router.pathConversionLookup(config.home));
					} else if (sa.currentPage && sa.currentPage.name == 'projects') {
						// if you unpublish something from the projects page, reload
						sa.router.reloadPage();
					}

					if (sa.currentPage && sa.currentPage.name == 'projects') {
						// if you unpublish something from the projects page, reload
						sa.router.reloadPage();
					}
				}, 'POST', 'p=projects&action=publish');
			});

			sa.forms.init(div);

			// now actually show it
			fb = new FocusBox(div, {
				title : 'Publish Settings'
			});
			fb.show();

		});

		return button;
	};

	projector.generateDropPublishButton = function(options) {

		options = $j.extend({
			project : null,
			wide : false,
			text : 'Make Public'
		}, options);

		var button = templates.get('project_publish_button' + (options.wide ? '_wide' : ''), { tooltip : options.text });

		button.on('click', function() {
			// find an updated version of the project in case it changed since this button was created
			let updatedProject = user.getProject(options.project.id);
			if (updatedProject) {
				options.project = updatedProject;
			}

			var fb;
			var div = templates.get('project_publish_options_drop', { name : options.project.name });

			if (options.project.publish.local) {
				div.find('#publish').prop('checked', 'checked');
			}

			// make the buttons work
			div.find('#cancel_button').on('click', function() {
				fb.hide();
			});

			div.find('#save_button').on('click', function() {
				ajax({
					publishLocal : div.find('#publish:checked').length,
					projectId : options.project.id
				}, function(response) {
					if (response[0].result != 'Success') {
						sa.notify({ text : response[0].result });
						fb.hide();
						return;
					}
					sa.notify({ text : 'Public settings for ' + options.project.name + ' saved!' });
					fb.hide();

					user.reloadProjects();
					// see if they want to add a tab
					if (user.userData.id != options.project.userId) {
						// user just unpublished the project they were looking at
						sa.router.routeTo(sa.router.pathConversionLookup(config.home));
					} else if (sa.currentPage && sa.currentPage.name == 'projects') {
						// if you unpublish something from the projects page, reload
						sa.router.reloadPage();
					}

					if (sa.currentPage && sa.currentPage.name == 'projects') {
						// if you unpublish something from the projects page, reload
						sa.router.reloadPage();
					}
				}, 'POST', 'p=projects&action=publish');
			});

			sa.forms.init(div);

			// now actually show it
			fb = new FocusBox(div, {
				title : 'Make Playlist Public'
			});
			fb.show();

		});

		return button;

	};

	/**
	 * Generates a modal form that lets a user create or edit a playlist collection
	 * @param {Object} options
	 * @param {Object} options.tab The tab we're editing. if empty we're creating a new one.
	 * @param {Number} options.tab.id The id of the tab we're editing. if empty we creat a new one.
	 * @param {String} options.tab.name The name of the tab
	 * @param {String} options.tab.description The description of the tab
	 * @param {Function} options.onSave Callback when the user saves the tab
	 * @param {Function} options.onClose Callback when the user closes the tab
	 */
	projector.generateProjectTabForm = function ({
		tab = { id: null, name : '', description : '' },
		onSave = (tab) => {},
		onClose = () => {}
	} = {}) {
		var div = templates.get('playlist_tab_edit', { name: tab.name, description: tab.description ?? '' });
		sa.forms.init(div);

		// display it in a focus box
		fb = new FocusBox(div, {title : 'Playlist Collection'});
		fb.show();

		// make the buttons work
		div.find('#cancel_button').on('click', () => {
			onClose();
			fb.hide();
		});

		div.find('#save_button').on('click', async () => {
			let fields = sa.forms.validate(div);

			if (fields.error) return;

			if (tab.id) {
				// update existing tab
				const data = {
					id: tab.id,
					...fields.values
				};
				try {
					await sa.api.request({
						handler: 'projectTabs',
						action: 'update',
						postData: data
					});

					onSave(data);
					fb.hide();
				} catch (e) {
					fb.showErrorMessage(e.message);
				}
				return;
			}

			// otherwise create a new tab
			try {
				const result = await sa.api.request({
					handler: 'projectTabs',
					action: 'create',
					postData: fields.values
				});
				// add the id to the tab
				const tab = {...fields.values, id: result.id};
				sa.notify({
					text: `New Playlist Collection created!
						<br/><br/>
						If you want to add this Collection to your workspace's navigation tabs above, you may do so from the
						<a href = "${siteBaseUrl()}/admin?p=settings&tab=tabs"> Edit Workspace Settings &gt; Tabs page</a>.`
				});
				onSave(tab);
				fb.hide();
			} catch (e) {
				fb.showErrorMessage(e.message);
			}
		});
	}

	var maxProjectsToShowInterval = 200;
	var maxProjectsToShow = maxProjectsToShowInterval;

	/**
	 * Whenever the projects to display changes, this function will repopulate the projects in the list
	 */
	projector.populate = function() {
		if (!user.logged) return;
		var projects = projector.filteredProjects;
		var projectCount = projects.length;
		if (projectCount > maxProjectsToShow) {
			projects = projects.slice(0, maxProjectsToShow);
		}
		// set the title so it includes the project count
		let titleContainer = projector.container.find('.left_nav_heading_title');
		titleContainer.html('My ' + playlistText + 's (' + projects.length + (projector.sortedProjects.length == projects.length ? '' : '/' + projector.sortedProjects.length) + ')');
		if (projector.sortedProjects.length != projects.length && projector.sortedProjects.length > 999) {
			titleContainer.addClass('long');
		} else {
			titleContainer.removeClass('long');
		}
		// grab the list body we'll add elements to
		var list = projector.container.find('#project_list'); 
		var sort = projector.container.find('#sort').val();
		list[0].innerHTML = '';
		if (lockdown) {
			list.append('<span class="none"><a class="request_authorization" href="#0">Request authorization</a> to access playlists.</span>');
			list.find('.request_authorization').on('click', function() {
				sa.showAuthForm();
				return false;
			});
			return;
		}
		if (sort == 'Folder Name' || sort == playlistText + ' Count') {

			// get all the folders for our projects
			var folders = [],
				foldersById = {};
			if (savedOpenStates[0] === undefined) {
				savedOpenStates[0] = true; // open the general folder by default
			}
			function processFolders(folderList, subFolder) {
				for (var i = 0, len = folderList.length; i < len; i++) {
					var folder = folderList[i];
					folder.projects = [];
					foldersById[folder.id] = folder;
					if (!subFolder) {
						folders.push(folder);
					}
					if (savedOpenStates[folder.id]) {
						folder.open = true;
					}
					processFolders(folder.subfolders, true);
				}
			}
			processFolders(user.projectFolders);

			// what projects go in what folders?
			for (var i = 0, len = projects.length; i < len; i++) {
				var project = projects[i];
				if (!foldersById[project.folderId]) { // make sure the folder wasn't lost somehow
					project.folderId = 0;
				}
				foldersById[project.folderId].projects.push(project);
			}

			// sort folders
			function countProjects(folder) {
				var count = folder.projects.length;
				for (var i = 0, len = folder.subfolders.length; i < len; i++) {
					count += countProjects(folder.subfolders[i]);
				}
				return count;
			}
			function sortFolders(folders) {
				if (sort == 'Folder Name') {
					folders.sort(function(a, b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; });
				} else {
					folders.sort(function(a, b) { return countProjects(a) > countProjects(b) ? -1 : 1; });
				}
				for (var f = 0, fLen = folders.length; f < fLen; f++) {
					if (folders[f].subfolders.length) {
						sortFolders(folders[f].subfolders);
					}
				}
			}
			sortFolders(folders);

			// go through all folders and add them with their projects
			function addFolder(folder, list) {
				var projects = folder.projects,
					projectCount = projects.length,
					folderCont = templates.get('folder', { folderId : folder.id, folderName : folder.name, projectCount : projectCount }),
					playlistCont = folderCont.find('.projects');

				if (folder.open) {
					folderCont.addClass('open');
				}

				folderCont.find('a').attr('title', folder.description);

				// make the folder link work
				folderCont.find('.folder_link').on('click', function(folderCont, folder) { return function() {
					folder.open = !folderCont.hasClass('open');
					savedOpenStates[folder.id] = folder.open;
					folderCont.toggleClass('open');
				}; }(folderCont, folder));

				// go through and add all subfolders
				for (var i = 0, len = folder.subfolders.length; i < len; i++) {
					projectCount += addFolder(folder.subfolders[i], playlistCont);
				}
				folderCont.find('.project_count:first').html(projectCount);

				// remove any old drop zones
				sa.components.edad.removeZonesByZoneClass('projector_project_folder_' + folder.id + '_drop_zone');

				// go through all the projects and add them as links
				let projectString = '';
				for (let project of projects) {
					// this code is replicated from projector.generateQuickProjectModeButton for performance
					let quickButton = project.created ? `<span title="Click to add or remove tracks or albums from this playlist" class="quick_project_button quick_project_${project.id} small${projector.isQuickProject(project.id) ? ' active' : ''}"><span class="fa fa-plus-square-o inactive quick_project_icon"></span><span class="fa fa-plus-square active quick_project_icon"></span></span>` : '';
					projectString += `<a id="project_${project.id}" href="${getProjectLink(project.id)}" class="project_list_project${(project.id == projector.highlightedProject ? ' selected' : '') + (project.created ? ' created' : '') }">${project.name} (${project.totalTrackCount})${quickButton}</a>`;
					// if it's a drop site, you can upload by dragging in
					// if (config.siteType === 'drop' && project.userId == user.userData.id && project.whiteId == config.id && user.hasAdminPermission(AdminPermission.Metadata)) {
					// 	sa.components.edad.addGenericDropZone({
					// 		allowedExtensions : Uploader.GetExtensions(UploaderConstants.AUDIO),
					// 		anchorSelector : a,
					// 		templateSelector : 'projector_project_drop_zone',
					// 		zoneClass : 'projector_project_folder_' + folder.id + '_drop_zone',
					// 		prepareTemplate : function(template) {
					// 			template.find('.project_name').html(project.name + ' (' + project.totalTrackCount + ')');
					// 			if (a.hasClass('created')) {
					// 				template.addClass('created');
					// 			}
					// 			if (a.hasClass('selected')) {
					// 				template.addClass('selected');
					// 			}
					// 			return template;
					// 		},
					// 		uniqueKey : 'projector_project_' + project.id + '_drop_zone',
					// 		dropCallback : function(files) {
					// 			let projectHash = getProjectLink(project.id);
					// 			files.each(function(i, file) {
					// 				var it = new sa.objectTypes.ImportTrack();
					// 				it.filename = file.name;
					// 				it.uploadFile(file, projectHash, { projectId : project.id });
					// 			});
					// 			project.totalTrackCount += files.length;
					// 			projector.applyFrom(projector.SORT);
					// 			if (sa.hashManager.getHash().indexOf(projectHash.substring(2)) === 0) {
					// 				sa.hashManager.reloadPage();
					// 			} else {
					// 				sa.hashManager.setHash(projectHash);
					// 			}
					// 		}
					// 	});
					// }
				}
				let projectListObjects = $j(projectString);
				projectListObjects.find('.quick_project_button').on('click', function(e) {
					// this code is derivative of projector.generateQuickProjectModeButton
					e.stopPropagation();
					e.preventDefault();
					projector.toggleQuickProjectMode(user.getProject(this.className.match(/quick_project_([0-9]+)/)[1]));
				});
				playlistCont.append(projectListObjects);
				if (!folder.subfolders.length && !projects.length) {
					playlistCont.append('<span class="none">' + 'No '+ playlistsText +' in this folder.</a>');
				}

				// folder edit/delete buttons
				if (folder.id) { // can't edit 0
					playlistCont.append(
						'<div class="folder_buttons">'
							+ '<a class="folder_edit_button faux_button"><span class="icon fa fa-edit"></span>Edit</a>'
							+ '<a class="folder_delete_button faux_button"><span class="icon fa fa-times"></span>' + 'Delete' + '</a>'
							+ '<div class="clr"></div>'
						+ '</div>');
					(function(folder) {
						playlistCont.find('.folder_edit_button:last').on('click', function() {
							sa.components.itemEditInterface.show({ type : 'folder', item : folder });
							return false;
						});
						// delete
						playlistCont.find('.folder_delete_button:last').on('click', function() {
							// show a confirmation
							sa.confirm({
								text : 'Are you sure you want to delete this folder? All its playlists will move to General.',
								yesFunction : function() {
									ajax('folderId=' + folder.id, function() {
										user.reloadProjects();
									}, 'POST', 'p=projects&action=delete_folder');
								},
								yesText : 'Delete'
							});
							return false;
						});
					})(folder);
				}

				// show folders
				list.append(folderCont);

				return projectCount;
			}
			for (var f = 0, fLen = folders.length; f < fLen; f++) {
				addFolder(folders[f], list);
			}

			// allow dropping onto new playlist button
			if (config.siteType === 'drop' && user.hasAdminPermission(AdminPermission.Metadata)) {
				sa.components.edad.removeZonesByZoneClass('projector_new_project_drop_zone');
				sa.components.edad.addGenericDropZone({
					allowedExtensions : Uploader.GetExtensions(UploaderConstants.AUDIO),
					anchorSelector : projector.container.find('.button_container'),
					templateSelector : 'projector_new_project_drop_zone',
					zoneClass : 'projector_new_project_drop_zone',
					uniqueKey : 'projector_new_project_drop_zone',
					dropCallback : function (files) {
						projector.showNewProjectBox(false, function(newProject) {
							if (newProject === null) return;
							sa.components.projector.toggleQuickProjectMode(newProject);

							files.each(function (i, file) {
								var it = new sa.objectTypes.ImportTrack();
								it.filename = file.name;
								it.uploadFile(file, 'project?projectId=' + newProject.id, { projectId : newProject.id });
							});
							newProject.totalTrackCount += files.length;
							projector.applyFrom(projector.SORT);
							sa.router.reloadPage();
						});
					}
				});
			}

			if (!folders.length) {
				list.append('<span class="none">No folders matched.</a>');
			} else {
				var fauxHandle, // see the documentation in helper, below
					fauxHandleOffset = { x : -20, y : -10 }; // where in the fake dragging element to put the cursor. you could determine cursor pos on start drag and adjust this but it's not worth it
				// project and folder dragging
				list.find('.projects > a').draggable({
					axis : 'y',
					containment : '#projector',
					distance : 3,
					helper : function(e) {
						// we want the handle you're dragging to look like a folder but without any of the projects (if it's open)
						// unfortunately, jquery ui gets buggy dragging objects around inside a container with overflow: scroll or auto. The handle gets disconnected from the cursor after scrolling
						// so we let it use an invisible handle (var handle) and we make a separate faux handle (var fauxHandle) that's what's visible and we use the drag event to have it follow the cursor
						// you lose containment but you could implement that if you really wanted to. sounds like too much work to me
						var handle = $j(e.target);
						// if they click on the + button, you're not on the right element and we get the wrong handle
						if (handle.hasClass('quick_project_button')) {
							handle = handle.parent();
						} else if (handle[0].tagName == 'IMG') {
							handle = handle.parent().parent();
						}
						handle = handle.clone();
						if (fauxHandle) fauxHandle.remove();
						fauxHandle = handle.clone();
						fauxHandle.addClass('faux_handle');
						fauxHandle.css({ top : e.clientY + fauxHandleOffset.y, left : e.clientX + fauxHandleOffset.x });
						handle.hide();
						$j('body').append(fauxHandle);
						return handle;
					},
					stop : function() {
						// in some instances, folders get stuck with a hover state. clear them out
						$j('.ui-state-hover').removeClass('ui-state-hover');
						// kill the faux handle. the if should always be true, but just in case
						if (fauxHandle) {
							fauxHandle.remove();
							fauxHandle = null;
						}
					},
					drag : function(event) {
						// need to move the fake handle around so it follows the mouse
						fauxHandle.css({ top : event.clientY + fauxHandleOffset.y, left : event.clientX + fauxHandleOffset.x });
					}
				});
				list.find('.folder:not(#folder_0)').draggable({
					axis : 'y',
					containment : '#projector',
					distance : 3,
					helper : function(e) {
						// we want the handle you're dragging to look like a folder but without any of the projects (if it's open)
						// unfortunately, jquery ui gets buggy dragging objects around inside a container with overflow: scroll or auto. The handle gets disconnected from the cursor after scrolling
						// so we let it use an invisible handle (var handle) and we make a separate faux handle (var fauxHandle) that's what's visible and we use the drag event to have it follow the cursor
						// you lose containment but you could implement that if you really wanted to. sounds like too much work to me
						var handle = $j(e.target).parents('.folder:first').clone();
						handle.find('.projects').remove(); // have to remove from the handle because, even though it's invisible, draggable uses its height for calculations
						if (fauxHandle) fauxHandle.remove();
						fauxHandle = handle.clone();
						fauxHandle.addClass('faux_handle');
						fauxHandle.css({ top : e.clientY + fauxHandleOffset.y, left : e.clientX + fauxHandleOffset.x });
						handle.hide();
						$j('body').append(fauxHandle);
						return handle;
					},
					start : function() {
						// folders have to be draggable to the "not in any folder" position so we have a normally-invisible "Top Level" drag recipient that we made visible while dragging folders
						$j('#project_list .top_drop_target').show();
					},
					stop : function() {
						// hide the Top Level drag recipient (see start)
						$j('#project_list .top_drop_target').hide();
						// in some instances, folders get stuck with a hover state. clear them out
						$j('.ui-state-hover').removeClass('ui-state-hover');
						// kill the faux handle. the if should always be true, but just in case
						if (fauxHandle) {
							fauxHandle.remove();
							fauxHandle = null;
						}
					},
					drag : function(event) {
						// need to move the fake handle around so it follows the mouse
						fauxHandle.css({ top : event.clientY + fauxHandleOffset.y, left : event.clientX + fauxHandleOffset.x });
					}
				});
				list.append('<div class="folder top_drop_target" id="folder_-1"><a class="folder_link"><span class="fa fa-level-up icon"></span>Top Level</a></div>');
				list.find('.folder').droppable({
					accept : '#projector .projects > a, #projector .folder',
					hoverClass : 'ui-state-hover',
					tolerance : 'pointer',
					greedy : true,
					drop : function(event, ui) {
						var droppedObject = ui.draggable,
							receivingFolderId = $j(this).attr('id').substring(7);
						if (droppedObject.hasClass('folder')) {
							var folderId = droppedObject.attr('id').substring(7),
								folder = user.getProjectFolder(folderId);
							console.log('folder', folderId, 'dropped on', receivingFolderId);
							ajax({
									id : folderId,
									name : folder.name,
									description : folder.description,
									folderId : receivingFolderId
								},
								function() {
									user.reloadProjects();
								},
								'POST', 'p=projects&action=edit_folder');
						} else {
							var projectId = droppedObject.attr('id').substring(8),
								project = user.getProject(projectId);
							if (!project) return;
							console.log('project', projectId, 'dropped on', receivingFolderId);
							ajax({
									projectId : projectId,
									name : project.name,
									description : project.description,
									folderId : receivingFolderId
								},
								function() {
									project.folderId = receivingFolderId;
									projector.applyFrom(projector.SORT);
								},
								'POST', 'p=projects&action=change_details');
						}
					}
				});
			}

		} else {
			// go through all the projects and add them as links
			projects.each(function(i, project) {
				var a = $j('<a id="project_' + project.id + '" href="' + getProjectLink(project.id) + '" class="project_list_project">'+ project.name + ' (' + project.totalTrackCount + ')' + '</a>');
				if (project.id == projector.highlightedProject) {
					a.addClass('selected');
				}
				list.append(a);
				if (project.created) {
					a.append(projector.generateQuickProjectModeButton(project, { small : true })).addClass('created');
				}
				if (sa.currentPage && sa.currentPage.name == 'project_item_list' && sa.pages.projectItemList.project.id == project.id) {
					a.on('click', function() { projector.hideSplash(); });
				}
			});
			if (!projects.length) {
				list.append('<span class="none">' + 'No '+ playlistsText +' matched.</a>');
			}
		}

		if (projectCount > maxProjectsToShow) {
			if (projectCount > maxProjectsToShow + maxProjectsToShowInterval) {
				list.append('<a class="button" id="more_projects">Show More</a>');
				list.find('#more_projects').on('click', function () {
					if (maxProjectsToShow == maxProjectsToShowInterval) {
						sa.confirm({
							text : 'Showing more playlists can significantly impact workspace performance. Have you tried searching?',
							noText : 'Cancel',
							yesText : 'Show More',
							yesFunction : function () {
								maxProjectsToShow += maxProjectsToShowInterval;
								projector.populate();
							}
						});
					} else {
						maxProjectsToShow += maxProjectsToShowInterval;
						projector.populate();
					}
				});
			}
			list.append('<a class="button" id="all_projects">Show All</a>');
			list.find('#all_projects').on('click', function() {
				sa.confirm({
					text : 'Showing all playlists can significantly impact workspace performance. Have you tried searching?',
					noText : 'Cancel',
					yesText : 'Show All',
					yesFunction : function() {
						maxProjectsToShow = projectCount;
						projector.populate();
					}
				});
			});
		}


		// show/hide expander
		if (list[0].scrollHeight > list[0].clientHeight) {
			projector.container.find('.expand_state').removeClass('hide')
		} else {
			projector.container.find('.expand_state').addClass('hide')
		}
	};

	/**
	 * Sorts the projects in sortedProjects by the current sort value and puts the result back in sortedProjects
	 */
	projector.applySort = function() {
		var projects = projector.sortedProjects;
		// grab the currently selected sort
		var sort = projector.container.find('#sort').val();
		// we need to create a comparison function depending on which sort is selected
		var c = function(a, b) {
			if (a == b) {
				return 0;
			}
			return a < b ? 1 : -1;
		};
		var compareNames = function(a, b) {
			return c(b.name.toLowerCase(), a.name.toLowerCase()); // reverse order for ascending
		};
		var compareTrackCounts = function(a, b) {
			return c(a.totalTrackCount, b.totalTrackCount);
		};
		var compareAlbumCounts = function(a, b) {
			return c(a.albumCount, b.albumCount);
		};
		var compareDateCreated = function(a, b) {
			return c(a.dateCreated, b.dateCreated);
		};
		var compareDateAdded = function(a, b) {
			return c(a.dateAltered, b.dateAltered);
		};
		var preferredCompare;
		var masterCompare = function(a, b) {
			var comp = preferredCompare(a, b);
			if (comp != 0) return comp;
			comp = compareNames(a, b);
			if (comp != 0) return comp;
			comp = compareTrackCounts(a, b);
			if (comp != 0) return comp;
			comp = compareDateCreated(a, b);
			if (comp != 0) return comp;
			comp = compareDateAdded(a, b);
			if (comp != 0) return comp;
			comp = compareAlbumCounts(a, b);
			if (comp != 0) return comp;
			return c(a.id, b.id);
		};
		switch (sort) {
			case gde('album', { plural : false, 'case' : 'upper' }) + ' Count':
				preferredCompare = compareAlbumCounts;
				break;
			case playlistText + ' Name':
				preferredCompare = compareNames;
				break;
			case 'Date Created':
				preferredCompare = compareDateCreated;
				break;
			case 'Date Added To':
				preferredCompare = compareDateAdded;
				break;
			case 'Track Count':
			default:
				preferredCompare = compareTrackCounts;
				break;
		}
		// now do the sort!
		projects.sort(masterCompare);
		// and that's all there is to it. Save the result in the global var
		projector.sortedProjects = projects;
	};

	/**
	 * Filters the projects by the current search term and puts the result in filteredProjects
	 */
	projector.applyFilter = function() {
		var projects = projector.sortedProjects;
		// grab the current filter value from the input box
		var filter = projector.container.find('#search input').val().toLowerCase();
		// if they didn't set a filter, we don't have to do anything
		if (!filter) {
			projector.filteredProjects = projects;
			return;
		}
		filter = filter.toLowerCase();
		// now we need to go through each of the projects and see if they match the filter
		// make a new var to hold the matches
		var matchedProjects = [];
		for (var i = 0; i < projects.length; i++) {
			if (projects[i].name.toLowerCase().indexOf(filter) != -1) {
				matchedProjects.push(projects[i]);
			}
		}
		// all done! set it in the storage var
		projector.filteredProjects = matchedProjects;
	};

	projector.getNestedFolderOptions = function() {
		var options = '';
		// folders can be nested so we build this list recursively
		function addFolder(folders, depth) {
			folders.each(function (i, folder) {
				options += '<option value="' + folder.id + '">' + new Array(depth).join('&mdash;') + folder.name + '</option>';
				if (folder.subfolders.length) {
					addFolder(folder.subfolders, depth + 1);
				}
			});

		}
		addFolder(user.projectFolders, 1);
		return options;
	};

	projector.showNewFolderBox = function(callback) {
		if (!callback) callback = function() {};

		var template = templates.get('new_project_folder');

		sa.forms.init(template);

		// populate the folder nesting selector
		template.find('#folder_folder').html('<option value="-1">None</option>' + projector.getNestedFolderOptions());

		// make sure the callback only fires once
		function fireCallback(param) {
			if (callback) {
				callback(param);
				callback = null;
			}
		}

		template.find('.submit').on('click', function() {
			var formValidation = sa.forms.validate(template);
			if (formValidation.error) {
				return;
			}
			for (var i = 0; i < user.projectFolders.length; i++) {
				if (user.projectFolders[i].name == formValidation.values.name) {
					fb.showErrorMessage('You already have a folder with this name. Please choose another.');
					return;
				}
			}
			fb.showLoader('Creating folder');
			ajax(formValidation.values, function(response) {
				fb.hideLoader();
				if (response[0].result != 'folders') {
					fb.showErrorMessage(response[0].result);
				} else {
					// it worked! add the folder to our list and resort
					var newFolder = response[0]['folders'][0];
					if (newFolder.parentFolderId == -1) {
						user.projectFolders.push(newFolder);
					} else {
						function searchFolders(folders) {
							for (var i = 0, len = folders.length; i < len; i++) {
								var folder = folders[i];
								if (folder.id == newFolder.parentFolderId) {
									return folder.subfolders.push(newFolder);
								}
								searchFolders(folder.subfolders);
							}
						}
						searchFolders(user.projectFolders);
					}
					projector.applyFrom(projector.SORT);
					fireCallback(newFolder);
					fb.hide();
				}
			}, 'POST', 'p=projects&action=new_folder');
		});
		template.find('.cancel').on('click', function() {
			fireCallback(null);
			fb.hide();
		});

		var fb = new FocusBox(template, { title : 'Create new folder', onClose : function() { fireCallback(null); } });
		fb.show();
	};

	/**
	 * Shows an overlay, allowing the user to enter a name for a new project
	 * @param {boolean=} showFolder if true, will show the Create New Folder dialog instead
	 * @param {function=} callback func to call when a new project is created if one is. will be passed project details (optional)
	 */
	projector.showNewProjectBox = function(showFolder, callback) {
		if (showFolder) {
			projector.showNewFolderBox(callback);
			return;
		}
		if (!callback) callback = function() {};

		sa.components.itemEditInterface.show({
			title: 'Create New Playlist',
			saveText: 'Creating playlist',
			type: 'project',
			ajaxPage: 'projects',
			ajaxAction: 'new',
			ajaxExtraVars: {projectId: 'new'},
			callback: function(response) {
				if (response[0].result.includes('Success')) {
					// it worked! add the project to our list, resort, and go into add mode
					var project = response[0].projects[0];
					user.addProject(project);
					projector.setProjects(user.getProjectArray());
					projector.toggleQuickProjectMode(project);
					for (var i = 0, len = projector.newProjectCallbacks.length; i < len; i++) {
						if (!projector.newProjectCallbacks(project)) {
							projector.newProjectCallbacks.splice(i, 1);
							i--;
							len--;
						}
					}
					callback(project);
				}
			}
		})
	};

	projector.newProjectCallbacks = [];
	/**
	 * Adds a func to the list of funcs to call when creating a new project
	 * @param {function} func the func to add. Should accept one parameter - project - and return whether or not to keep the func in the list
	 */
	projector.addNewProjectCallback = function(func) {
		projector.newProjectCallbacks.push(func);
	};

	/**
	 * Handles the response after a user converts a cue sheet into a project
	 * @param {json} newData the server's response
	 */
	projector.cueSheetCopyResponse = function(newData) {
		if (newData[0].result != 'Success') {
			sa.notify({ text : createText(newData[0].result) });
		} else {
			// it worked! add the project to our list, resort, and display it
			var project = newData[0].projects[0];
			user.addProject(project);
			projector.setProjects(user.getProjectArray());
			console.log('project cue sheet copy response');
			sa.router.routeTo(getProjectLink(project.id));
		}
	};

	/**
	 * Shows a small splash page, letting the user see a little bit about projects
	 */
	projector.showSplash = function() {
		// remove any old covers (in case you double clicked on the project link?)
		$j('#splash_container').remove();
		// create the container
		var splashContainer = $j('<div id="splash_container"></div>');
		// hide the splash if someone clicks it
		splashContainer.on('click', function() {
			projector.hideSplash();
		});
		// add it to the page
		$j('#right_content').append(splashContainer).addClass('splash');
		// add the info focus box
		var splashInfo = $j('<div id="splash_info"><div class="highlight"><h2>' + playlistsText + '</h2><a id="close" href="' + getDefaultLink() + '" class="fa fa-times"></a></div>'
			+ '<div class="unhighlight">'
				+ (user.getProjectArray().length 
					? `Select a ${playlistText} on the left to see its tracks, download it, send it to someone, edit it, and more!<br/><br/>You can also search for a specific ${playlistText} or sort them to find the ${playlistText} you're looking for.<br/><br/>To make a new ${playlistText}, use the button at the bottom of the left My ${playlistsText} widget.` 
					: `Select a ${playlistText} on the left to see its tracks, download it, send it to someone, edit it, and more!<br/><br/>You can also search for a specific ${playlistText} or sort them to find the ${playlistText} you're looking for.<br/><br/>To make a new {$playlist}, use the button at the bottom of the left My ${playlistsText} widget.`)
				+ '</div></div>');
		// make the close button work
		splashInfo.find('#close').on('click', function() {
			projector.hideSplash();
		});
		// add it to a focus box
		var fb = projector.splashFb = new FocusBox(splashInfo);
		fb.show();
	};

	/**
	 * Makes the splash go away!
	 */
	projector.hideSplash = function() {
		$j('#splash_container').remove();
		$j('#right_content').removeClass('splash');
		if (projector.splashFb) {
			projector.splashFb.hide();
		}
	};

	/**
	 * Sets up the splash page so it'll show the next time the projector is shown
	 */
	projector.showSplashDelayed = function() {
		projector.splashWaiting = true;
	};

	/**
	 * Highlights a specific project to indicate it's been selected
	 * @param {int} projectId the id of the project to highlight
	 */
	projector.highlight = function(projectId) {
		projector.highlightedProject = projectId;
		projector.populate();
	};

	/**
	 * Unhighlights a projects when it's no longer selected
	 */
	projector.unhighlight = function() {
		if (projector.highlightedProject) {
			projector.highlightedProject = 0;
			projector.populate();
		}
	};

	/**
	 * Only attaches if show has been called previously
	 */
	projector.attach = function() {
		if (autoShow) {
			projector.show();
		}
	};

	/**
	 * Sets up the basic container for the projector
	 */
	projector.build = function() {

		templates = sa.templates.get('projector');

		var container = projector.container = templates.get('projector', { signupLink : getSignupLink(), loginLink : getLoginLink(), playlistText : playlistText, playlistsText : playlistsText });

		// new playlists and folders
		container.find('.new_playlist').on('click', function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			if (!user.logged) {
				return sa.notify({ text : 'You must be logged in to use this feature.' });
			}
			projector.showNewProjectBox();
			container.find('.new_folder').hide();
			container.find('.new_playlist').removeClass('with_new_folder');
		});
		container.find('.new_folder').on('click', function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			if (!user.logged) {
				return sa.notify({ text : 'You must be logged in to use this feature.' });
			}
			projector.showNewProjectBox(true);
			container.find('.new_folder').hide();
			container.find('.new_playlist').removeClass('with_new_folder');
		});
		container.find('.drop_button').on('click', function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			var newFolder = container.find('.new_folder');
			if (newFolder.filter(':visible').length) {
				newFolder.hide();
				container.find('.new_playlist').removeClass('with_new_folder');
			} else {
				newFolder.show();
				container.find('.new_playlist').addClass('with_new_folder');
			}
		});
		container.on('mouseleave', function() {
			container.find('.new_folder').hide();
			container.find('.new_playlist').removeClass('with_new_folder');
		});
		if (!config.showAIPlaylists) {
			container.find('.ai_playlist').hide();
		} else {
			container.find('.ai_playlist').on('click', function () {
				if (lockdown) {
					return sa.showLockdownMessage();
				}
				if (!user.logged) {
					return sa.notify({ text: 'You must be logged in to use this feature.' });
				}
				console.log('ai_playlist');
				const aiModal = new AIPlaylistModal();
				aiModal.init();
			});
		}

		// expanding
		container.find('.expand_state').on('click', function() {
			const content = $j(this).closest('.left_nav_section').find('.projector');
			const projectList = content.find('.project_list');
			const heading = $j(this).closest('.left_nav_heading');
			container.toggleClass('expanded');
			if (container.hasClass('expanded')) {
				sa.components.leftNav.setMaxComponentHeight(heading, content);
				// now set the project list's max height to fit with the rest of the stuff in the box
				let siblingsHeight = 0;
				projectList.siblings().each(function() {
					siblingsHeight += $j(this)[0].clientHeight;
				});
				projectList.css({ maxHeight: parseInt(content.css('maxHeight')) - siblingsHeight - heading[0].clientHeight });
			} else {
				// this resets the max heights
				projector.resize();
			}
		})

		// make the search box work
		container.find('#search input').on('input', function() {
			projector.applyFrom(projector.FILTER);
		}).on('focus', function() {
			container.find('#search').addClass('focused');
		}).on('blur', function() {
			container.find('#search').removeClass('focused');
		});

		// make the sort options work
		var sortBy = function(optionsMenuItem) {
			container.find('#sort').val(optionsMenuItem.name);
			projector.applyFrom(projector.SORT);
		};
		var sortOptionsMenu = new sa.components.OptionsMenu({
			items : [
				{ name : 'Sort Folders', heading : true },
				{ name : 'Playlist Count', onClick : sortBy },
				{ name : 'Folder Name', onClick : sortBy },
				{ name : 'Sort Playlists', heading : true },
				{ name : 'Track Count', onClick : sortBy },
				{ name : gde('album', { c : 'upper', p : false }) + ' Count', onClick : sortBy },
				{ name : 'Playlist Name', onClick : sortBy },
				{ name : 'Date Created', onClick : sortBy },
				{ name : 'Date Added To', onClick : sortBy },
				{ name : 'Shortcuts', heading : true },
				{ name : 'New Playlist', onClick : function() {
					container.find('.new_playlist').trigger('click');
				}},
				{ name : 'New Folder', onClick : function() {
					container.find('.new_folder').trigger('click');
				}}
			],
			hideOnMouseLeave : true
		});
		container.find('.left_nav_heading_title').after(sortOptionsMenu.getAnchor());

		if (!user.isFullyAuthorized()) {
			projector.populate();
		}

		if (BrowserDetect.isMac) {
			let scrollbarTest = templates.get('scrollbar_test');
			let body = $j('body');
			body.append(scrollbarTest);
			let scrollBarWidth = scrollbarTest[0].offsetWidth - scrollbarTest[0].clientWidth;
			scrollbarTest.remove();
			if (scrollBarWidth > 0) {
				body.addClass('forcing_scrollbars');
			}
		}

		sa.on('beforeRouteChange', function() {
			projector.unhighlight();
		});
	};

	return projector;

})();
/**
 * The cueSheet manager that lives in the left nav
 */
sa.components.cueSheeter = (function() {

	/** @var TemplateSet */
	var templates;

	var cueSheeter = {};

	// if true, cue sheeter will attach
	var autoShow = false;

	/**
	 * Some globals used to start an applyFrom chain. See this.applyFrom for details
	 */
	cueSheeter.SORT = 'sort';
	cueSheeter.FILTER = 'filter';

	/**
	 * {JQuery} the container for the whole left nav element the cueSheeter lives in
	 */
	cueSheeter.container = null;

	/**
	 * All the cueSheets, sorted
	 */
	cueSheeter.sortedCueSheets = [];

	/**
	 * The cueSheets once they've been filtered by source
	 */
	cueSheeter.sourcedCueSheets = [];

	/**
	 * The cueSheets filtered by the current search
	 */
	cueSheeter.filteredCueSheets = [];

	/**
	 * The id of the cueSheet that's currently highlighted
	 */
	cueSheeter.highlightedCueSheet = 0;

	/**
	 * The cueSheet that we're currently showing options for
	 */
	cueSheeter.optionsCueSheet = null;

	/**
	 * The cueSheets we're in quick cueSheet mode for
	 */
	cueSheeter.quickCueSheets = [];

	/**
	 * Should we show the splash page when the cueSheeter is added to a page?
	 */
	cueSheeter.splashWaiting = false;

	/**
	 * Is the cue sheeter showing?
	 */
	cueSheeter.showing = false;

	/**
	 * Updates the list of all cueSheets and then applies the current applyFrom chain and displays them
	 * @param {Array} cueSheets the cueSheets to display
	 */
	cueSheeter.setCueSheets = function (cueSheets) {
		if (!cueSheeter.container) {
			console.error('Cue Sheeter container is null when calling setCueSheets');
			return;
		}
		cueSheeter.sortedCueSheets = cueSheets;
		cueSheeter.applyFrom(cueSheeter.SORT);
		// for the mobile menu
		sa.trigger('cuesheets_reload');
	};

	/**
	 * CueSheets come in as a list of all cueSheets and then go through a chain of filters and sorts before
	 * they're ready to display. This function manages going through those stages in order
	 * @param {string} from one of the cueSheeter.STAGE vars defined at top. Determines what step in the chain to begin with
	 */
	cueSheeter.applyFrom = function(from) {
		//noinspection FallThroughInSwitchStatementJS - the fallthrough is intentional
		switch (from) {
			case cueSheeter.SORT:
				cueSheeter.applySort();
			case cueSheeter.FILTER:
				cueSheeter.applyFilter();
		}
		cueSheeter.populate();
	};

	/**
	 * Adds the cueSheeter to the left nav
	 */
	cueSheeter.show = function() {
		if (!cueSheeter.container) {
			autoShow = true;
			return;
		}
		sa.components.leftNav.addComponent(cueSheeter.container);
		if (cueSheeter.splashWaiting) {
			setTimeout(function() { cueSheeter.showSplash(); }, 250);
			cueSheeter.splashWaiting = false;
		}
		cueSheeter.container.find('#cs_sort select').trigger('change');

		let resizeIframe = cueSheeter.container.find('.resize_detector iframe')[0];
		(resizeIframe.contentWindow || resizeIframe).addEventListener('resize', function () {
			cueSheeter.trigger('resize');
		});
	};



	/**
	 * Creates a button that activates quick project mode for a specific project
	 * @param {CueSheet} cueSheet the project to activate mode for
	 * @param {Object=} options
	 * 	@property {boolean} small should we use a small button? defaults to false
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery} the button
	 */
	cueSheeter.generateQuickCueSheetModeButton = function(cueSheet, options) {
		options = $j.extend({
			small : false,
			wide : false,
			text : 'Add/Remove'
		}, options);
		var img = templates.get('quick_cue_sheet_mode_button' + (options.wide ? '_wide' : ''), { cueSheetId : cueSheet.id, text : options.text });
		if (options.small) {
			img.addClass('small');
		}
		if (sa.components.cueSheeter.isQuickCueSheet(cueSheet.id)) {
			img.addClass('active');
		}
		img.on('click', function() {
			sa.components.cueSheeter.toggleQuickCueSheetMode(cueSheet);
			this.blur();
			return false;
		});
		return img;
	};

	/**
	 * Creates a button that adds/removes a track to the current quick cue sheet
	 * @param {int} trackId the track to add/remove from the current quick cue sheet
	 * @param {boolean=} custom
	 * @return {JQuery} the button
	 */
	cueSheeter.generateQuickCueSheetTrackButton = function(trackId, custom) {
		var img = templates.get('quick_cue_sheet_track_button', { trackId : trackId });
		img.on('click', function() {
			let cueSheetInstanceId = 0; // if you're on the cue sheet page and you remove a track, it should only remove that instance of the track and not all the copies
			if (sa.currentPage.name === sa.pages.cueSheet.name) {
				cueSheetInstanceId = $j(this).parents('.cue_sheet_block').prop('id');
				if (cueSheetInstanceId !== undefined) {
					cueSheetInstanceId = parseInt(cueSheetInstanceId.replace('track_', '').replace('_row', ''));
				} else {
					cueSheetInstanceId = 0;
				}
			}
			cueSheeter.addQuickCueSheetTrack(trackId, !img.hasClass('has_projects'), custom, cueSheetInstanceId);
			return false;
		});
		if (custom) {
			img.addClass('has_projects');
		} else {
			var track = trackBank.find(trackId);
			if (!track) return null; // this can happen if you go into add more with an empty project open
			if (cueSheeter.hasAllQuickCueSheets(track.user_cue_sheets)) {
				img.addClass('has_projects');
			}
		}
		return img;
	};

	/**
	 * Sets the state for all the currently displayed quick cue sheet buttons for a single track
	 * @param {int} trackId
	 * @param {boolean} hasProject
	 */
	function updateQuickCueSheetTrackButtons(trackId, hasProject) {
		if (hasProject) {
			$j('.quick_cue_sheet_track_button_' + trackId).addClass('has_projects');
		} else {
			$j('.quick_cue_sheet_track_button_' + trackId).removeClass('has_projects');
		}
	}

	/**
	 * Lets you know whether or not quick cueSheet mode is active
	 * @return {boolean} is it?
	 */
	cueSheeter.inQuickCueSheetMode = function() {
		return !!cueSheeter.quickCueSheets.length;
	};

	/**
	 * Determines if a given cueSheet is in the quick cueSheets
	 * @param {int} cueSheetId the id of the cueSheet to check
	 * @return {boolean} is it?
	 */
	cueSheeter.isQuickCueSheet = function(cueSheetId) {
		for (var i = 0; i < cueSheeter.quickCueSheets.length; i++) {
			if (cueSheeter.quickCueSheets[i].id == cueSheetId) return true;
		}
		return false;
	};

	/**
	 * Checks if the passed in cueSheets is a superset of the quick cueSheets
	 * 	ex: cueSheet.quickCueSheets = [1,2]; cueSheeter.hasAllQuickCueSheets([1,2,3]) === true
	 * 	despite that example, these things are cueSheets and NOT ints
	 * @param {Array} cueSheets array of cueSheet objects
	 * @return {boolean} is it?
	 */
	cueSheeter.hasAllQuickCueSheets = function(cueSheets) {
		if (!cueSheets || !cueSheets.length || !cueSheeter.quickCueSheets.length || cueSheets.length < cueSheeter.quickCueSheets.length) return false;
		for (var i = 0; i < cueSheeter.quickCueSheets.length; i++) {
			var found = false;
			for (var j = 0; j < cueSheets.length; j++) {
				if (cueSheets[j].id == cueSheeter.quickCueSheets[i].id) {
					found = true;
					break;
				}
			}
			if (!found) return false;
		}
		return true;
	};

	/**
	 * Turns quick cueSheet mode on or off
	 * @param {CueSheet} cueSheet the cueSheet to activate/deactive mode for
	 */
	cueSheeter.toggleQuickCueSheetMode = function(cueSheet) {
		if (sa.components.nester.inNestingMode()) {
			sa.components.nester.disable();
		}
		if (sa.components.projector.inQuickProjectMode()) {
			sa.components.projector.disableQuickProjectMode();
		}
		if (cueSheeter.isQuickCueSheet(cueSheet.id)) {
			// quick cueSheet mode is already on for this track. kill it
			cueSheeter.removeQuickCueSheet(cueSheet);
			// in this case, we don't want to activate the new one
			return;
		}
		cueSheeter.quickCueSheets.push(cueSheet);
		cueSheeter.handleQuickCueSheetsChange();
	};

	/**
	 * Does everything you need to do once you've changed the quick cueSheet list
	 */
	cueSheeter.handleQuickCueSheetsChange = function() {
		// enable the buttons on the track lists
		getTrackList().disableQuickProjects();
		if (cueSheeter.quickCueSheets.length) {
			getTrackList().enableQuickCueSheets();
			sa.components.bottomBar.enableQuickCueSheets();
		} else {
			sa.components.bottomBar.disableQuickProjects();
		}
		// enable the button on the details page
		if (sa.getCurrentPageName() == 'details') {
			if (cueSheeter.quickCueSheets.length) {
				sa.pages.details.enableQuickCueSheets();
			} else {
				sa.pages.details.disableQuickProjects();
			}
		}
		// set up the quick project bar
		var quickProjectBar = sa.components.quickProjectBar;
		if (cueSheeter.quickCueSheets.length) {
			quickProjectBar.setCueSheets(cueSheeter.quickCueSheets);
			quickProjectBar.show('cue_sheet', function() { cueSheeter.disableQuickCueSheetMode(); });
		} else {
			quickProjectBar.hide();
		}
		sa.trigger('scroll');
		// swap the buttons
		$j('.quick_cue_sheet_button.active').removeClass('active');
		for (var qp = 0, qpLen = cueSheeter.quickCueSheets.length; qp < qpLen; qp++) {
			$j('.quick_cue_sheet_' + cueSheeter.quickCueSheets[qp].id).addClass('active');
		}
	};

	/**
	 * Removes a cueSheet from the quick cueSheets
	 * @param {CueSheet} cueSheet the cueSheet to remove
	 */
	cueSheeter.removeQuickCueSheet = function(cueSheet) {
		// remove the cueSheet from the list
		for (var i = 0; i < cueSheeter.quickCueSheets.length; i++) {
			if (cueSheeter.quickCueSheets[i].id == cueSheet.id) {
				cueSheeter.quickCueSheets.splice(i, 1);
			}
		}
		if (cueSheeter.quickCueSheets.length) {
			// if there are more cueSheets, we need to regenerate the header
			cueSheeter.handleQuickCueSheetsChange();
		} else {
			// that was it. just disable
			cueSheeter.disableQuickCueSheetMode();
		}
	};

	/**
	 * Turns quick cueSheet mode off
	 */
	cueSheeter.disableQuickCueSheetMode = function() {
		cueSheeter.quickCueSheets = [];
		cueSheeter.handleQuickCueSheetsChange();
	};

	/**
	 * Adds or removes a track from a quick cueSheet
	 * @param {int} trackId the id of the track to add/remove
	 * @param {boolean} add should we add the album or remove it
	 * @param {boolean=} custom is it a custom cue sheet item?
	 * @param {int} cueSheetInstanceId if set and non-zero, the current cue sheet will only remove this instance of the track (should be `sa_cue_sheets_tracks`.`id`)
	 */
	cueSheeter.addQuickCueSheetTrack = function(trackId, add, custom, cueSheetInstanceId) {
		// you should also always have a quick cueSheet but again, jic
		if (!cueSheeter.quickCueSheets.length) return console.log('Add track called without quick cue sheet ' + trackId);

		if (custom) { // it's a custom item we're removing, so we can skip a lot of the regular processing
			var cueSheetId = cueSheeter.quickCueSheets[0].id;
			ajax('cueSheetId=' + cueSheetId + '&customId=' + trackId,
				function () {
					console.log('removed!');
					sa.router.reloadPage();
					sa.router.routeTo(`/cue-sheet/${cueSheetId}`);
				}, 
				'POST', 
				'p=cue_sheets&action=remove_custom_item'
			);

			return;
		}

		// figure out if the current quick cueSheet is one of the track's cueSheets
		var addTrack = add ? 1 : 0;
		// now either send the command to remove the track or add it
		var cueSheetIds = [];
		for (var q = 0; q < cueSheeter.quickCueSheets.length; q++) {
			cueSheetIds.push(cueSheeter.quickCueSheets[q].id);
		}
		let currentCueSheetId = (sa.currentPage.name === sa.pages.cueSheet.name) ? sa.pages.cueSheet.cueSheet.id : 0;
		ajax(
			{
				p: 'cue_sheets',
				action: 'quick_track',
				add: addTrack,
				trackId: trackId,
				cueSheetIds: cueSheetIds,
				cueSheetInstanceId: cueSheetInstanceId,
				currentCueSheet: currentCueSheetId
			},
			function(response) {
				cueSheeter.addQuickCueSheetItemResponse(response, function() {
					cueSheeter.addQuickCueSheetTrack(trackId, !add, custom, cueSheetInstanceId);
				});
			}
		);
		// we should change the button they clicked so they get some instant feedback
		if (cueSheetInstanceId && !addTrack && cueSheetIds.indexOf(currentCueSheetId) !== -1) {
			// they're on the cue sheet page showing this track block. just remove it
			sa.pages.cueSheet.removeInstance(cueSheetInstanceId);
		} else {
			updateQuickCueSheetTrackButtons(trackId, !!addTrack);
		}
		// now we want to update cueSheet track counts. could let the server do this but it's a lot faster to do it ourselves
		// we also need to update the track bank so all copies of the track have the correct cueSheets
		// you could do this with a page reload but we want you to be able to add/remove tracks without the page constantly refreshing
		if (!addTrack) addTrack = -1;
		sa.components.quickProjectBar.updateChangeSummary(addTrack, 0);
		var track = trackBank.find(trackId);
		for (var i = 0; i < user.cueSheets.length; i++) {
			if (cueSheeter.isQuickCueSheet(user.cueSheets[i].id)) {
				// need to see if track already has cueSheet
				var notInCueSheet = true;
				if (track) {
					for (var j = 0; j < track.user_cue_sheets.length; j++) {
						if (track.user_cue_sheets[j].id == user.cueSheets[i].id) {
							notInCueSheet = false;
							// need to update the local cache of the track
							if (addTrack < 0) {
								track.user_cue_sheets.splice(j, 1);
							}
							break;
						}
					}
				}
				//console.log('for cueSheet ' + user.cueSheets[i].id + ' notInCueSheet was ' + (notInCueSheet ? 1 : 0) + ' and addTrack is ' + addTrack);
				// need to update the local cache of the track
				if (addTrack > 0 && track) {
					track.user_cue_sheets.push(user.cueSheets[i]);
				}
				// if the track is not in the cueSheet and we're adding it, or the track is in the cueSheet and we're removing it
				if ((notInCueSheet && addTrack > 0) || (!notInCueSheet && addTrack < 0)) {
					//console.log('updating track count for ' + user.cueSheets[i].id);
					user.cueSheets[i].trackCount += addTrack;
					$j('#total_track_count_' + user.cueSheets[i].id).html(user.cueSheets[i].trackCount);
				}
			}
		}
		if (track) {
			// need to update all instances of the track in the track bank so they show up correctly everywhere
			trackBank.updateAll(track.id, 'user_cue_sheets', track.user_cue_sheets);
		}
		cueSheeter.setCueSheets(user.cueSheets);
		// clear the cache so if we go back to a cueSheet page, we get a new one
		sa.requestCache.clear();
	};

	/**
	 * Handles the response from the server after adding/removing a track or album from the quick cueSheet
	 *  Typically doesn't actually do anything with the response but potentially causes a reload
	 *  Handles server failure response, currently generated if you try to add a track that's not on your site (requests)
	 * @param {object} newData server response
	 * @param {function} failureCallback if the server response isn't "success", call this function
	 */
	cueSheeter.addQuickCueSheetItemResponse = function(newData, failureCallback) {
		if (newData.length && newData[0].result != 'Success') {
			failureCallback();
			return sa.notify({ text : newData[0].result });
		}
		// see if they're on the cueSheet list page, in which case we want to refresh
		for (var i = 0; i < cueSheeter.quickCueSheets.length; i++) {
			let currentPath = sa.router.getCurrentPath();
			let cueSheetLink = getCueSheetLink(cueSheeter.quickCueSheets[i].id);
			if (currentPath === cueSheetLink) {
				sa.requestCache.clear();
				sa.router.reloadPage();
				return;
			}
		}
	};

	/**
	 * Adds a set of tracks to a cue sheet
	 * @param {int} cueSheetId the id of the cue sheet to add to
	 * @param {Array.<int>} trackIds int ids of the tracks to add
	 */
	cueSheeter.addTracksToCueSheet = function(cueSheetId, trackIds) {
		// now either send the command to remove the track or add it
		var cueSheetIds = [];
		for (var i = 0; i < cueSheeter.quickCueSheets.length; i++) {
			cueSheetIds.push(cueSheeter.quickCueSheets[i].id);
		}
		ajax('trackIds[]=' + trackIds.join('&trackIds[]=') + '&cueSheetId=' + cueSheetId,
			function(response) {
				const resp = response.result ? response : response[0];
				if (resp.result !== 'Success') {
					sa.notify({ text: resp.result });
					return;
				}
				var newCueSheet = resp.cueSheets[0];
				for (var t = 0, tLen = trackIds.length; t < tLen; t++) {
					var trackId = trackIds[t];
					// now we want to update cue sheet track counts. could let the server do this but it's a lot faster to do it ourselves
					// we also need to update the track bank so all copies of the track have the correct cue sheets
					// you could do this with a page reload but we want you to be able to add/remove tracks without the page constantly refreshing
					var track = trackBank.find(trackId);
					if (track) {
						// need to see if track already has cue sheet
						for (var j = 0; j < track.user_cue_sheets.length; j++) {
							if (track.user_cue_sheets[j].id == cueSheetId) {
								// need to update the local cache of the track
								track.user_cue_sheets.splice(j, 1);
								break;
							}
						}
						track.user_cue_sheets.push(newCueSheet);
						trackBank.updateAll(track.id, 'user_cue_sheets', track.user_cue_sheets);
						// change any quick buttons so they get some instant feedback
						// need to know if the track is in all quick cue sheets
						var inCueSheet = cueSheeter.hasAllQuickCueSheets(track.user_cue_sheets);
						$j('.quick_cue_sheet_track_image_' + trackId).attr('src', 'images/buttons/project_' + (inCueSheet ? 'remove' : 'add') + '.png');
					}
				}
				// update the user cue sheets
				for (var i = 0, len = user.cueSheets.length; i < len; i++) {
					if (user.cueSheets[i].id == newCueSheet.id) {
						user.cueSheets.splice(i, 1);
						break;
					}
				}
				user.cueSheets.push(newCueSheet);
				cueSheeter.setCueSheets(user.cueSheets);
				// clear the cache so if we go back to a cue sheet page, we get a new one
				sa.requestCache.clear();
			}, 'POST', 'p=cue_sheets&action=add_tracks');
	};

	/**
	 * Validates and saves changes to a cueSheet's name
	 * @param {CueSheet} cueSheet the cueSheet being changed
	 * @param {string} newName the new name for the cueSheet
	 * @param {Object} interactionOptions the inputBox the user was entering information into
	 * @return {boolean} true of failure, false on success
	 */
	cueSheeter.editCueSheet = function(cueSheet, newName, interactionOptions) {
		// if they didn't change the name, make them
		if (newName == cueSheet.name) {
			interactionOptions.showError('Please enter a new name or cancel');
			return true;
		}
		// validate new name
		if (!newName.trim()) {
			interactionOptions.showError('Please enter a name for the cue sheet');
			return true;
		}
		// make sure it's not a duplicate name
		for (var c = 0; c < user.cueSheets.length; c++) {
			// if they entered the name of an existing cueSheet, don't let them change the name
			if (user.cueSheets[c].name == newName && user.cueSheets[c].id != cueSheet.id) {
				interactionOptions.showError('There\'s already a cue sheet with this name. Please choose another.');
				return true;
			}
		}
		// notify the server of the name change
		ajax('newName=' + encodeURIComponent(newName) + '&cueSheetId=' + cueSheet.id, function(response) { cueSheeter.editCueSheetResponse(response); }, 'POST', 'p=cue_sheets&action=change_name');
		// update the local copy
		for (var i = 0; i < user.cueSheets.length; i++) {
			if (user.cueSheets[i].id == cueSheet.id) {
				user.cueSheets[i].name = htmlEncode(newName);
			}
		}
		cueSheeter.setCueSheets(user.cueSheets);
		return false;
	};

	/**
	 * Handles the response from the server after submitted a name change
	 */
	cueSheeter.editCueSheetResponse = function() {
		// reload the page
		sa.requestCache.clear();
		sa.router.reloadPage();
	};

	/**
	 * Deletes a cueSheet
	 * @param {CueSheet} cueSheet the cueSheet to remove
	 */
	cueSheeter.removeCueSheet = function(cueSheet) {
		// remove the cueSheet on the server
		ajax('cueSheetId=' + cueSheet.id, function(response) { cueSheeter.removeCueSheetResponse(response); }, 'POST', 'p=cue_sheets&action=remove_cue_sheet');
		// remove from the local list
		for (var i = 0; i < user.cueSheets.length; i++) {
			if (user.cueSheets[i].id == cueSheet.id) {
				user.cueSheets.splice(i, 1);
				break;
			}
		}
		cueSheeter.setCueSheets(user.cueSheets);
		return false;
	};

	/**
	 * Handles the response from the server after you delete a cueSheet
	 */
	cueSheeter.removeCueSheetResponse = function() {
		sa.requestCache.clear();
		// need to take them to another page
		if (user.cueSheets.length) {
			// if they have another cueSheet, take them to that
			sa.router.routeTo(getCueSheetLink(user.cueSheets[0].id));
		} else {
			sa.router.routeTo('/');
		}
		sa.notify({ text : 'Cue sheet removed.' });
	};

	/**
	 * Validates and saves a copy of a cueSheet
	 * @param {CueSheet} cueSheet the cueSheet being copied
	 * @param {string} newName the name for the copy
	 * @param {Object} interactionOptions the inputBox the user was entering information into
	 * @return {boolean} true of failure, false on success
	 */
	cueSheeter.copyCueSheet = function(cueSheet, newName, interactionOptions) {
		// if they didn't change the name, make them
		if (newName == cueSheet.name) {
			interactionOptions.showError('Please enter a new name or cancel');
			return true;
		}
		// validate new name
		if (!newName.trim()) {
			interactionOptions.showError('Please enter a name for the cue sheet');
			return true;
		}
		// make sure it's not a duplicate name
		for (var i = 0; i < user.cueSheets.length; i++) {
			// if they entered the name of an existing cueSheet, don't let them change the name
			if (user.cueSheets[i].name == newName && user.cueSheets[i].id != cueSheet.id) {
				interactionOptions.showError('There\'s already a cue sheet with this name. Please choose another.');
				return true;
			}
		}
		// notify the server of the name change
		ajax({ name: newName, cueSheetId: cueSheet.id }, function (response) {
			cueSheeter.copyCueSheetResponse(response);
		}, 'POST', 'p=cue_sheets&action=copy');
		// can't do a local update. need to get the new cueSheet from the server
		return false;
	};

	/**
	 * Handles the response from the server after a copy
	 * @param {json} newData
	 */
	cueSheeter.copyCueSheetResponse = function(newData) {
		const data = newData.cueSheets ? newData : newData[0];
		const cueSheets = data.cueSheets;
		if (cueSheets.length) {
			user.cueSheets.push(cueSheets[0]);
			cueSheeter.setCueSheets(user.cueSheets);
			sa.router.routeTo(getCueSheetLink(cueSheets[0].id));
		} else {
			sa.notify({ text : data.result ? data.result : 'An unknown error has occurred. Please try again later.' });
		}
	};

	/**
	 * Changes a cueSheet so it's created instead of received
	 * @param {CueSheet} cueSheet the cueSheet to send
	 * @param {boolean} sendConfirmation should we force copy in case of viewing permission errors?
	 */
	cueSheeter.makeCreated = function (cueSheet, sendConfirmation) {
		ajax('cueSheetId=' + cueSheet.id + (sendConfirmation ? '&conf=1' : ''), (response) => {
			const resp = response.result ? response : response[0];
			if (resp.result === 'viewing_error') {
				sa.confirm({
					text: 'If you change this cue sheet, you will lose access to some of its tracks. Continue?',
					yesFunction: () => cueSheeter.makeCreated(cueSheet, true),
					yesText: 'Continue'
				});
			} else {
				const newCueSheet = resp.cueSheets[0];
				// Moves this cueSheet to your created list
				for (let i = 0; i < user.cueSheets.length; i++) {
					if (parseInt(user.cueSheets[i].id) === parseInt(cueSheet.id)) {
						user.cueSheets[i].created = true;
						user.cueSheets[i].trackCount = newCueSheet.trackCount;
					}
				}
				cueSheeter.setCueSheets(user.cueSheets);
				// reload the page so they have all the options
				sa.requestCache.clear();
				sa.router.reloadPage();
			}
		}, 'POST', 'p=cue_sheets&action=make_created');
	};

	/**
	 * Whenever the cueSheets to display changes, this function will repopulate the cueSheets in the list
	 */
	cueSheeter.populate = function() {
		if (!user.logged) return;
		var cueSheets = cueSheeter.filteredCueSheets;
		// set the title so it includes the cueSheet count
		let titleContainer = cueSheeter.container.find('.left_nav_heading_title');
		titleContainer.html('My Cue Sheets' + ' (' + cueSheets.length + (cueSheeter.sortedCueSheets.length == cueSheets.length ? '' : '/' + cueSheeter.sortedCueSheets.length) + ')');
		if (cueSheeter.sortedCueSheets.length > 999) {
			titleContainer.addClass('long');
		} else {
			titleContainer.removeClass('long');
		}
		
		// grab the list body we'll add elements to
		var list = cueSheeter.container.find('#cue_sheet_list').empty();
		if (lockdown) {
			list.append('<span class="none"><a class="request_authorization" href="#0">Request authorization</a> to access cue sheets.</span>');
			list.find('.request_authorization').on('click', function() {
				sa.showAuthForm();
			});
			return;
		}
		
		// go through all the cueSheets and add them as links
		for (let i = 0; i < cueSheets.length; i++) {
			const cueSheet = cueSheets[i];
			const cuesheetLink = $j(`
				<a id="cue_sheet_${cueSheet.id}" href="${getCueSheetLink(cueSheet.id)}" class="project_list_project">
					${cueSheet.name} (${cueSheet.trackCount})
				</a>
			`.trim());
			
			if (parseInt(cueSheet.id) === parseInt(cueSheeter.highlightedCueSheet)) {
				cuesheetLink.addClass('selected');
			}
			
			list.append(cuesheetLink);
			
			if (parseInt(cueSheet.created)) {
				cuesheetLink.append(cueSheeter.generateQuickCueSheetModeButton(cueSheet, {
					small: true 
				})).addClass('created');
			}
			
			if (sa.getCurrentPageName() === 'cueSheet' && parseInt(sa.pages.cueSheet.cueSheet.id) === parseInt(cueSheet.id)) {
				cuesheetLink.on('click', () => cueSheeter.hideSplash());
			}
		}
		if (!cueSheets.length) {
			list.append('<span class="none">' + 'No cue sheets matched' + '</a>');
		}
		
		// show/hide expander
		if (list[0].scrollHeight > list[0].clientHeight) {
			cueSheeter.container.find('.expand_state').removeClass('hide')
		} else {
			cueSheeter.container.find('.expand_state').addClass('hide')
		}
	};

	/**
	 * Sorts the cueSheets in sortedCueSheets by the current sort value and puts the result back in sortedCueSheets
	 */
	cueSheeter.applySort = function() {
		const cueSheets = cueSheeter.sortedCueSheets;
		// grab the currently selected sort
		const sort = cueSheeter.container.find('#cs_sort').val();
		// we need to create a comparison function depending on which sort is selected
		let compare;
		switch (sort) {
			case 'Cue Sheet Name':
				compare = function (a, b) {
					return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
				};
				break;
			case 'Date Created':
				compare = function (a, b) {
					return parseInt(a.dateCreated) < parseInt(b.dateCreated) ? 1 : -1;
				};
				break;
			case 'Date Added To':
				compare = function (a, b) {
					return parseInt(a.dateAltered) < parseInt(b.dateAltered) ? 1 : -1;
				};
				break;
			default:
				compare = function (a, b) {
					return parseInt(a.trackCount) < parseInt(b.trackCount) ? 1 : -1;
				};
				break;
		}
		// now do the sort!
		cueSheets.sort(compare);
		// and that's all there is to it. Save the result in the global var
		cueSheeter.sortedCueSheets = cueSheets;
	};

	/**
	 * Filters the cueSheets by the current search term and puts the result in filteredCueSheets
	 */
	cueSheeter.applyFilter = function() {
		var cueSheets = cueSheeter.sortedCueSheets;
		// grab the current filter value from the input box
		var filter = cueSheeter.container.find('#search input').val().toLowerCase();
		// if they didn't set a filter, we don't have to do anything
		if (!filter) {
			cueSheeter.filteredCueSheets = cueSheets;
			return;
		}
		filter = filter.toLowerCase();
		// now we need to go through each of the cueSheets and see if they match the filter
		// make a new var to hold the matches
		var matchedCueSheets = [];
		for (var i = 0; i < cueSheets.length; i++) {
			if (cueSheets[i].name.toLowerCase().indexOf(filter) != -1) {
				matchedCueSheets.push(cueSheets[i]);
			}
		}
		// all done! set it in the storage var
		cueSheeter.filteredCueSheets = matchedCueSheets;
	};

	/**
	 * Shows a prompt, allowing the user to enter a name for a new cueSheet
	 */
	cueSheeter.showNewCueSheetBox = function(callback = function() {}) {
		sa.prompt({
			placeholder : 'New cue sheet name',
			yesFunction : function(newName, interactionOptions) {
				if (!newName) {
					interactionOptions.showError('Please enter a name for the cue sheet');
					return true;
				}

				for (var i = 0; i < user.cueSheets.length; i++) {
					if (user.cueSheets[i].name == newName) {
						interactionOptions.showError("There's already a cue sheet with this name. Please choose another.");
						return true;
					}
				}

				ajax({ name: newName }, function (response) {
					const resp = response.result ? response : response[0];
					if (resp.result !== 'Success') {
						sa.notify({ text: resp.result });
					} else {
						// it worked! add the cueSheet to our list, resort, and go into add mode
						const cueSheet = resp.cueSheets[0];
						user.cueSheets.push(cueSheet);
						cueSheeter.setCueSheets(user.cueSheets);
						cueSheeter.toggleQuickCueSheetMode(cueSheet);
						callback(user.cueSheets);
					}
				}, 'POST', 'p=cue_sheets&action=new');

				return false;
			},
			yesText : 'Create'
		});
	};

	function makeGenericButton(options) {

		options = $j.extend({
			cueSheet : null,
			wide : false,
			text : '',
			onClick : function() {},
			templateName : ''
		}, options);

		if (!options.cueSheet) {
			console.error('cueSheeter makeGenericButton called without a cueSheet', options);
			return $j();
		}

		var img = templates.get(options.templateName + (options.wide ? '_wide' : ''), { text : options.text });

		img.on('click', function() {
			options.onClick();
		});

		return img;
	}

	/**
	 * Creates a button that lets a user edit a cueSheet's name
	 * @param {Object} options
	 * 	@property {CueSheet} cueSheet the cueSheet to edit
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery} the button
	 */
	cueSheeter.generateCueSheetEditButton = function(options) {

		options.templateName = 'cue_sheet_edit_button';
		options.onClick = function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			sa.prompt({
				placeholder : 'New cue sheet name',
				yesFunction : function(newValue, interactionOptions) {
					return cueSheeter.editCueSheet(options.cueSheet, newValue, interactionOptions);
				},
				yesText : 'Save'
			});
		};

		return makeGenericButton(options);
	};

	/**
	 * Creates a button that lets a user change a cueSheet to make it created
	 * @param {Object} options
	 * 	@property {CueSheet} cueSheet the cueSheet to make created
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery} the button
	 */
	cueSheeter.generateCueSheetMakeCreatedButton = function(options) {

		options.templateName = 'cue_sheet_make_created_button';
		options.onClick = function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			cueSheeter.makeCreated(options.cueSheet);
		};

		return makeGenericButton(options);
	};

	/**
	 * Creates a button that lets a user copy a cueSheet
	 * @param {Object} options
	 * 	@property {CueSheet} cueSheet the cueSheet to copy
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery} the button
	 */
	cueSheeter.generateCueSheetCopyButton = function(options) {

		options.templateName = 'cue_sheet_copy_button';
		options.onClick = function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			sa.prompt({
				placeholder : 'Cue sheet copy name',
				yesFunction : function(newName, interactionOptions) {
					return cueSheeter.copyCueSheet(options.cueSheet, newName, interactionOptions);
				}
			});
		};

		return makeGenericButton(options);
	};

	/**
	 * Creates a button that lets a user remove a cueSheet
	 * @param {Object} options
	 * 	@property {CueSheet} cueSheet the cueSheet to remove
	 * 	@property {boolean} wide should we display the button as part of a <a class="button"></a> or should it just be an icon
	 * 	@property {string} text the text to display inside the button if wide (defaults to something reasonable)
	 * @return {JQuery} the button
	 */
	cueSheeter.generateCueSheetRemoveButton = function(options) {

		options.templateName = 'cue_sheet_remove_button';
		options.onClick = function() {
			sa.confirm({
				text : 'Are you sure you want to delete cue sheet "' + options.cueSheet.name + '"?',
				yesFunction : function() { return sa.components.cueSheeter.removeCueSheet(options.cueSheet); },
				yesText : 'Delete'
			});
		};

		return makeGenericButton(options);
	};

	/**
	 * Handles the response after a user converts a project into a cueSheet
	 * @param {json} newData the server's response
	 */
	cueSheeter.projectCopyResponse = function(newData) {
		if (newData.result != 'Success') {
			sa.notify({ text : createText(newData[0].result) });
		} else {
			// it worked! add the cueSheet to our list, resort, and display it
			var cueSheet = newData.cueSheets[0];
			user.cueSheets.push(cueSheet);
			cueSheeter.setCueSheets(user.cueSheets);
			console.log('cue sheet project copy response');
			sa.router.routeTo(getCueSheetLink(cueSheet.id));
		}
	};

	/**
	 * Shows a small splash page, letting the user see a little bit about cueSheets
	 */
	cueSheeter.showSplash = function() {
		// remove any old covers (in case you double clicked on the cueSheet link?)
		$j('#splash_container').remove();
		// create the container
		var splashContainer = $j('<div id="splash_container"></div>');
		// hide the splash if someone clicks it
		splashContainer.on('click', function() {
			cueSheeter.hideSplash();
		});
		// add it to the page
		$j('#right_content').append(splashContainer).addClass('splash');
		// add the info focus box
		var splashInfo = $j('<div id="splash_info"><div class="highlight"><h2>' + 'Cue Sheets' + '</h2><a id="close" href="' + getDefaultLink() + '" class="fa fa-times"></a></div>'
			+ '<div class="unhighlight">'
				+ (user.cueSheets.length ? 
				'Select a cue sheet on the left to see its tracks, download it, send it to someone, edit it, and more!<br/><br/>You can also search for a specific cue sheet or sort them to find the cue sheet you\'re looking for.<br/><br/>To make a new cue sheet, use the button at the bottom of the left My Cue Sheets widget.' 
				: 'Cue Sheets let you group tracks together to download, send to people, save for later, etc.<br/><br/>To make a new cue sheet, click the "New Cue Sheet" button at left and then you can use the "My Cue Sheets" widget on the left to view and manage your cue sheets.')
			+ '</div></div>');
		// make the close button work
		splashInfo.find('#close').on('click', function() {
			cueSheeter.hideSplash();
		});
		// add it to a focus box
		var fb = cueSheeter.splashFb = new FocusBox(splashInfo);
		fb.show();
	};

	/**
	 * Makes the splash go away!
	 */
	cueSheeter.hideSplash = function() {
		$j('#splash_container').remove();
		$j('#right_content').removeClass('splash');
		if (cueSheeter.splashFb) {
			cueSheeter.splashFb.hide();
		}
	};

	/**
	 * Sets up the splash page so it'll show the next time the cueSheeter is shown
	 */
	cueSheeter.showSplashDelayed = function() {
		cueSheeter.splashWaiting = true;
	};

	/**
	 * Toggles whether or not the full cueSheeter is showing
	 */
	cueSheeter.collapse = function() {
		var cueSheeter = cueSheeter.container.find('#cue_sheeter');
		if (cueSheeter.css('display') == 'none') {
			cueSheeter.show();
			cueSheeter.showing = true;
		} else {
			cueSheeter.hide();
			cueSheeter.showing = false;
		}
	};

	/**
	 * Highlights a specific cueSheet to indicate it's been selected
	 * @param {int} cueSheetId the id of the cueSheet to highlight
	 */
	cueSheeter.highlight = function(cueSheetId) {
		cueSheeter.highlightedCueSheet = cueSheetId;
		cueSheeter.populate();
	};

	/**
	 * Unhighlights a cueSheets when it's no longer selected
	 */
	cueSheeter.unhighlight = function() {
		if (cueSheeter.highlightedCueSheet) {
			cueSheeter.highlightedCueSheet = 0;
			cueSheeter.populate();
		}
	};

	/**
	 * Only attaches if show has been called previously
	 */
	cueSheeter.attach = function() {
		if (autoShow) {
			cueSheeter.show();
		}
	};

	/**
	 * Sets up the basic container for the cueSheeter
	 */
	cueSheeter.build = function() {

		templates = sa.templates.get('cue_sheeter');
		sa.eventify(cueSheeter);

		var container = cueSheeter.container = templates.get('cue_sheeter', { signupLink : getSignupLink(), loginLink : getLoginLink() });

		// new cue sheets
		container.find('.new_cue_sheet').on('click', function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			if (!user.logged) {
				return sa.notify({ text : 'You must be logged in to use this feature.' });
			}
			cueSheeter.showNewCueSheetBox();
		});

		// make the search box work
		container.find('#search input').on('keyup', function() {
			cueSheeter.applyFrom(cueSheeter.FILTER);
		}).on('focus', function() {
			container.find('#search').addClass('focused');
		}).on('blur', function() {
			container.find('#search').removeClass('focused');
		});


		// expanding
		container.find('.expand_state').on('click', function() {
			const content = $j(this).closest('.left_nav_section').find('.projector');
			const projectList = content.find('.project_list');
			const heading = $j(this).closest('.left_nav_heading');
			container.toggleClass('expanded');
			if (container.hasClass('expanded')) {
				sa.components.leftNav.setMaxComponentHeight(heading, content);
				// now set the cue sheet list's max height to fit with the rest of the stuff in the box
				let siblingsHeight = 0;
				projectList.siblings().each(function() {
					siblingsHeight += $j(this)[0].clientHeight;
				});
				projectList.css({ maxHeight: parseInt(content.css('maxHeight')) - siblingsHeight - heading[0].clientHeight });
			} else {
				content.css({
					maxHeight: ''
				})
				projectList.css({ maxHeight: '' });
			}
		})


		// make the sort options work
		var sortBy = function(optionsMenuItem) {
			container.find('#cs_sort').val(optionsMenuItem.name);
			cueSheeter.applyFrom(cueSheeter.SORT);
		};
		var sortOptionsMenu = new sa.components.OptionsMenu({
			items : [
				{ name : 'Sort Cue Sheets', heading : true },
				{ name : 'Track Count', onClick : sortBy },
				{ name : 'Cue Sheet Name', onClick : sortBy },
				{ name : 'Date Created', onClick : sortBy },
				{ name : 'Date Added To', onClick : sortBy },
				{ name : 'Shortcuts', heading : true },
				{ name : 'New Cue Sheet', onClick : function() {
					container.find('.new_cue_sheet').trigger('click');
				}}
			],
			hideOnMouseLeave : true
		});
		container.find('.left_nav_heading_title').after(sortOptionsMenu.getAnchor());

		if (!user.isFullyAuthorized()) {
			cueSheeter.populate();
		}

		sa.on('beforeRouteChange', function() {
			cueSheeter.unhighlight();
		});
	};

	return cueSheeter;

})();

function CueSheetPageTwo() { //
	var page = this;
	this.vars = null;
	this.div = null;
	this.name = 'cueSheet';

	// templates
	var templates = sa.templates.get('cuesheet');

	/**
	 * Creates the basic framework for the page
	 */
	this.generatePage = function(vars) {
		setTitle('Cue Sheet');
		page.vars = sa.router.paramsToVars(vars);

		clearBody();
		var container = createDiv('cuesheet_container', 'max_width');
		sa.components.leftNav.show();
		sa.components.leftNav.disableAll();
		var right = createDiv('right_content', 'right_content');
		container.appendChild(right);
		container.appendChild(createDiv('', 'clr'));
		get('body').appendChild(container);
		page.div = $j(right);

		showLoader( page.div, 'Loading Cue Sheet');

		sa.router.routeTo('/cuesheet?' + sa.router.queryParamsToString(params));
		sa.currentPage = this;
	};

}
/**
 * A tab element for a LeftTabbedPage
 * @param {string} id an id that'll be passed into set page when this tab is clicked. should be unique in the tab set
 * @param {string} href
 * @param {function} callback the function to call when the tab is clicked
 * 	functions do not need to include any LeftTabbedPage functionality. That'll be handled automatically
 * 	this function will be called with two parameters, the tab id and a jQueryElement - the container to generate the page in
 * @param {string} title the title text to display in bold at the top of the tab
 * @param {string} icon the class to put on the icon span. typically a font awesome fa-* class
 * @param {string} logo path to an image to use in the page header instead of a title and icon if you want one
 * @param {boolean} disabled should the page be greyed out? (we sometimes want to show people what they're missing)
 * @returns {LeftTab}
 */
function LeftTab(id, href, callback, title, icon, logo, disabled) {
	this.id = id;
	this.href = href;
	this.callback = callback;
	this.title = title;
	this.icon = icon;
	this.logo = logo;
	this.disabled = disabled;
	this.divider = false;
}

function LeftDivider(title) {
	this.title = title;
}

/**
 * A page with a large left nav section for displaying tabbed content, like the dashboard or admin panel
 * @returns {LeftTabbedPage}
 */
function LeftTabbedPage() {
	/**
	 * @var {string} unique id for the page, included in its class
	 */
	this.id = '';
	/**
	 * @var {Array.<LeftTab|LeftDivider>} an array of LeftTab objects that will be displayed on the left
	 */
	this.tabs = [];
	/**
	 * @var {HTMLElement|JQuery} the header to show at the top of the page
	 */
	this.header = null;

	/**
	 * Sets the currently selected tab in the left
	 * @param {string} tabId the id of the tab to be selected. corresponds to the id element of a tab that was passed in
	 */
	this.setTab = function(tabId) {
		// find the newly selected tab
		let selectedTab = $j('.ltp_nav #tab_' + tabId);
		if (!selectedTab.length) return;
		// remove any old selected tabs
		$j('.ltp_nav .selected').removeClass('selected');
		// select the new tab
		selectedTab.addClass('selected');
		// set the right header
		let tabData = selectedTab.data('tab');
		let rightHead = $j('#right_content .right_head');
		if (selectedTab.hasClass('tab_0') || selectedTab.hasClass('tab_1')) {
			rightHead.removeClass('with_icon');
		} else {
			rightHead.addClass('with_icon');
			rightHead.find('.icon_container').attr('class', 'icon_container ' + tabData.icon);
		}
		rightHead.find('.title').html(tabData.title);
		if (tabData.logo) {
			rightHead.find('.right_head_logo_image').attr('src', tabData.logo);
			rightHead.addClass('with_logo_image');
		} else {
			rightHead.removeClass('with_logo_image');
		}
		// clear the right content and call the callback to generate the page
		tabData.callback(tabId, $j('#right_content .right_body').html('').attr('class', 'right_body').addClass('tab_' + tabData.id));
	};
}


/**
 * Sets up the frame of the page, adding the left nav and the basic container
 * @param {string} id a unique id for the page, included in its class
 * @param {Array} tabs an array of LeftTab objects that will be displayed on the left
 * @param {Array} pageSwitchOptions a list of items to show in a drop down in the upper left. first will be selected. should have name and href strings
 * @param {Array} shortcuts an optional list of icons to display on the upper right. should have icon, href strings. if count is specified, a superscript number will display
 */
LeftTabbedPage.prototype.show = function(id, tabs, pageSwitchOptions, shortcuts) {
	// remove old elements and create the basic container
	clearBody();
	var container = sa.templates.get('left_tabbed_page').get('page', { id : id });

	// populate page switcher
	var switcherContainer = container.find('.page_switcher');
	for (var p = 0, pLen = pageSwitchOptions.length; p < pLen; p++) {
		var option = pageSwitchOptions[p];
		switcherContainer.append('<a class="page_switch_option" href="' + option.href + '">' + option.name + (p || pLen == 1 ? '' : '<span class="fa fa-chevron-down chevron"></span>') + '</a>');
	}
	// switcherContainer.on('mouseenter', function() {
	// 	switcherContainer.css({ overflow : 'visible' });
	// });
	// switcherContainer.on('mouseleave', function() {
	// 	switcherContainer.css({ overflow : 'hidden' });
	// });

	// populate shortcuts
	var shortcutContainer = container.find('.shortcuts');
	if (config.siteType !== 'drop') {
		for (var s = 0, sLen = shortcuts.length; s < sLen; s++) {
			var cut = shortcuts[s];
			shortcutContainer.append('<a class="shortcut" href="' + cut.href + '"><span class="icon ' + cut.icon + '"></span>' + cut.title + '</a>');
		}
	} else {
		shortcutContainer.remove();
	}

	// populate nav
	let navContainer = container.find('.ltp_nav');
	tabs.each(function(t, tab) {
		if (tab instanceof LeftDivider) {
			navContainer.append('<span class="ltp_divider">' + tab.title + '</span>');
		} else {
			let jTab = $j('<a href="' + tab.href + '" class="ltp_tab' + (tab.disabled ? ' disabled' : '') + ' tab_' + t + '" id="tab_' + tab.id + '"><span class="icon ' + tab.icon + '"></span>' + tab.title + '</a>');
			jTab.on('click', function () {
				this.blur();
				navContainer.removeClass('show-mobile')
			}).data({
				tab : tab
			});
			navContainer.append(jTab);
		}
	});

	// closer
	var closer = $j('<div class="ltp_close"><a class="fa fa-times"></a></div>');
	navContainer.prepend(closer);
	closer.on('click', function(e) {
		navContainer.removeClass('show-mobile');
	})

	// Nav open/close on mobile
	container.find('.mobile_toggle').on('click', function(e) {
		e.stopPropagation();
		navContainer.closest('#ltp_container').toggleClass('show-mobile')
		navContainer.toggleClass('show-mobile');
		if (navContainer.hasClass('show-mobile')) {
			$j('body').on('click.left_menu_open', function(e) {
				if ($j(e.target).closest(navContainer).length == 0) {
					navContainer.removeClass('show-mobile');
					navContainer.closest('#ltp_container').removeClass('show-mobile')
				}
			})
		} else {
			$j('body').off('click.left_menu_open');
		}
	
	})

	// add it and we're done!
	$j('#body').append(container);
};
sa.collapsingAdminPage = function() {

	var cap = this;

	var sectionTemplate = sa.templates.get('collapsing_admin_page').get('section');

	/** @var Array<{ name : string, contents : (string|JQuery|HTMLElement), open : (boolean|undefined) }> **/
	var sections = [];

	/**
	 * @param {{ name : string, contents : (string|JQuery|HTMLElement), open : (boolean|undefined) }} sectionOptions
	 */
	cap.addSection = function(sectionOptions) {
		var baseSectionOptions = {
			name : 'Please add a name!',
			contents : 'Put something in here',
			open : false
		};
		$j.extend(baseSectionOptions, sectionOptions);
		sections.push(sectionOptions);
	};

	/**
	 * Actually adds all the sections to the container
	 * @param {JQuery} container
	 */
	cap.addToContainer = function(container) {
		container.addClass('collapsing').html('');

		for (var s = 0, sLen = sections.length; s < sLen; s++) {

			var section = sections[s];
			var sectionContainer = sectionTemplate.clone();

			sectionContainer.find('.section_name').html(section.name);
			sectionContainer.find('.elements').append(section.contents);

			if (section.open) {
				sectionContainer.addClass('open');
			}

			container.append(sectionContainer);

		}

		container.find('h2').on('click', function() {
			var elementsContainer = $j(this).parent().find('.elements');
			if (elementsContainer.hasClass('showing')) {
				elementsContainer.stop(true).slideUp();
				elementsContainer.removeClass('showing');
				$j(this).removeClass('open');
			} else {
				elementsContainer.stop(true).slideDown(function() {
					if (container.closest('.foxar').length > 0) {
						elementsContainer.css('height', 'auto')
					}
				});
				elementsContainer.addClass('showing');
				$j(this).addClass('open');
				// when a section expands, any sa.forms input containers inside it may be the wrong height if they were initialized when it was closed
				elementsContainer.find('.input_container').trigger('formsVisibilityChange');
			}
		});

	};

};
/**
 * Header we use for page banners
 */
class HeroImage {

	constructor(options = {}) {
		const self = this
		const defaults = {
			templates: sa.templates.get('hero_image'),
			template: 'hero_title', // possibility to override the template
			title: 'Hero', // should always override this, the main title
			item: {}, // the item this banner is for
			imgSrc: '', // shown as a square image on the left side of the banner
			imgIsDefault: false, // is the image the default for that type (in which case shrink it)
			bgImgSrc: '', // background image src
			bgImgAttachment: 'fixed', // as in CSS background-attachment
			bgFocusX: '50%', // where to focus in the background image
			bgFocusY: '50%', // where to focus in the background image
			bgVideoSrc: '', // TODO: was meant to allow videos but was scrapped.  could be useful someday
			bgVideoMimeType: '', // TODO: see bgVideoSrc
			preamble: '', // "artist", "album", etc.
			subtext: '', // Description or otherwise
			details: '', // extra details like on albums where it lists the catalog, label, number of tracks etc.
			textColor: '', // text color for the banner
			dynamicColor: true, // dynamically generate a gradient background
			type: 'default', // adds a class for the type of banner it is, i.e. "person", "album", etc.
			artOverBanner: false, // show imgSrc over the the background image? (bgSrc)
			fullHeightImage: false, // should we show the main image (imgSrc) as full height of the banner?
			playButton: '', // play button if desired
			aiGenerateArtButtonOverImage : false // add an AI Bolt button over the image when hovered
		}

		// attachment fixed try background-size: 150% with background-position-x whatever percentage and 
		// background-position-y unset or try figuring out how it works
		options = _.extend(defaults, options)

		// if default image don't do any of the fanfare
		if (options.imgIsDefault) {
			options.dynamicColor = false;
			options.artOverBanner = false;
		}

		// Make all options properties of this
		Object.assign(this, options)

		// VERY NAIVE MIME TYPE GUESS, not intended for production
		if (this.bgVideoSrc && !this.bgVideoMimeType) {
			this.bgVideoMimeType = 'video/' + this.bgVideoSrc.split('.').pop()
		}

		// create the root element
		this.$el = this.templates.get(this.template, {
			name: this.title,
			image: this.imgSrc ? '<img src="' + this.imgSrc + '"/>' : '',
			preamble: options.preamble,
			subtext: options.subtext && options.subtext instanceof jQuery ? '' : options.subtext,
			details: options.details && options.details instanceof jQuery ? '' : options.details,
			play_button: options.playButton && options.playButton instanceof jQuery ? '' : options.playButton,
		});

		// init other element references
		this.$heroContentLeft = this.$el.find('.left');
		this.$heroContentRight = this.$el.find('.right');
		this.$heroOptions = this.$el.find('.options');
		this.$heroDetails = this.$el.find('.details');

		if (options.playButton instanceof jQuery) {
			this.$el.find('.play-button').append(options.playButton);
		}
		if (options.subtext instanceof jQuery) {
			this.$el.find('.subtext').append(options.subtext);
		}

		if (options.subtext != '') {
			this.$el.addClass("with_subtext")
		}

		if (options.details != '') {
			this.$el.addClass("with_details")
		}

		// add full height image handling
		if (this.fullHeightImage && !this.imgIsDefault) {
			this.$el.addClass('full_height_image')
		} else {
			this.$el.removeClass('full_height_image')
		}

		//  this is the default image that comes with an artist/album/composer/etc.
		this.$img = this.$el.find('.image img')

		if (this.imgIsDefault) {
			this.$el.find('.image').addClass('is_default')
			
			if (this.imgSrc == '') {
				// get default album art
				console.log("default art el for type", this.type)
				this.$el.find('.image').append(getDefaultArtElement(this.type))
				if (this.$img.length) this.$img.remove()
			}

		}

		// add ai art generation button if applicable
		if (this.aiGenerateArtButtonOverImage && this.imgSrc && ((this.artOverBanner && this.haveBgMedia()) || !this.haveBgMedia())) {
			const $aiArtButton = sa.components.buttons.generateAIArtButton({entityObj: this.item, entityType: this.type })
			this.$el.find('.image .ai-art-generate-button').append($aiArtButton)
			this.$el.find('.image .ai-art-generate-button').addClass('active')
		}

		if (this.type != 'default') {
			this.$el.addClass(this.type)
		}

		// render the background media
		if (this.haveBgMedia()) {
			this.showBgMedia()
		} else if (this.dynamicColor) {
			this.showBgColors()
		}

		// banner text color
		if (this.textColor) {
			this.$el.css({ color: this.textColor })
		}

		// after rendering logic
		const renderInt = setInterval(() => {
			if (document.contains(this.$el[0])) {
				clearInterval(renderInt)
				this.onRender()
			}
		}, 150);

		// bind events
		sa.on('resize', _.debounce(this.padTabs.bind(this), 200));
		// sa.on('resize', _.debounce(this.setBannerGradient.bind(this), 150));

		this.isMobile = sa.isMobile()

		return this
	}

	onRender() {
		this.padTabs();
		// this.setBannerGradient();
	}
	getInstance() {
		return this
	}

	showFallbackColors() {
		this.$el.removeAttr('style')
		this.$el.removeClass('dynamic-color')
	}

	hideBgImg() {
		this.$el.css({ background: 'transparent' })
	}

	haveBgMedia() {
		return !!this.bgImgSrc || !!this.bgVideoSrc
	}
	haveImg() {
		return !!this.imgSrc
	}

	padTabs() {
		const $tabContainer = this.$el.siblings('.tab_container');
		if (this.$el.closest('#heading.with_tabs').length > 0 && $tabContainer.length > 0) {
			this.$el.css({ paddingBottom: '' });
			const $image = this.$el.find('.image');
			const $details = this.$el.find('.details');
			const imageBottom = $image.offset().top + $image.outerHeight();
			const imageRight = $image.offset().left + $image.width();
			const detailsBottom = $details.offset().top + $details.outerHeight();
			const detailsRight = $details.offset().left + $details.width();
			const heightFudge = 5;
			const tabTop = $tabContainer.offset().top + heightFudge;
			const tabHeight = $tabContainer.height();
			const tabLeft = $tabContainer.offset().left;
			if (tabTop < imageBottom && imageRight >= tabLeft) {
				// overlapping image
				this.$el.css({ paddingBottom: tabHeight + Math.abs(tabTop - imageBottom) / 4 })
			} else if (tabTop < detailsBottom && detailsRight >= tabLeft) {
				// overlapping details
				this.$el.css({ paddingBottom: tabHeight + Math.abs(tabTop - detailsBottom) / 4 })
			}
		}
	}

	/**
	 * Extract image colors from the main image and use as a gradient.
	 * 
	 * Best way to do this is to load the image into the `img` element as it will be shown, then 
	 * extract the colors from that, RATHER than loading the image from a URL. 
	 */
	showBgColors() {
		if (this.imgSrc && this.$img.length > 0) {
			const imgEl = this.$img[0]
			// required for CORS reasons
			imgEl.crossOrigin = 'Anonymous'
			imgEl.addEventListener('load', () => {
				// extract the colors
				extractImageColors(imgEl).then(colors => {
					const currentTheme = config.theme.colors;
					let headingTextColor = false;
					// get the heading text color or if can't get that, then
					// fallback to pulling it from elements
					if (currentTheme) {
						headingTextColor = currentTheme['headingTextColor']
					} else if ($j('#heading').length) {
						headingTextColor = $j('#heading').css('color')
					} else if ($j('#artist-title-bar').length) {
						headingTextColor = $j('#artist-title-bar').css('color')
					}

					// make sure heading text color is hex
					if (headingTextColor && headingTextColor.indexOf('rgb') != -1) {
						headingTextColor = rgba2Hex(headingTextColor)
					}

					if (colors && colors.length > 1) {
						// we've extracted some colors, let's use tem
						this.bgColors = colors
						let useTextContrast = true

						// TODO: only do dark color on bottom if TEXT is dark
						// Make sure a dark color is on the bottom
						let gradColors = [colors[0], colors[1]]
						if (colors[0].key.includes('Dark') && !colors[1].key.includes('Dark')) {
							// if the most prevalent color is dark, put it on the bottom
							gradColors = [colors[1], colors[0]]
						} else if (!colors[0].key.includes('Dark') && !colors[1].key.includes('Dark')) {
							// if neither of the first two are dark, get the first dark and use that as the second color
							gradColors = [colors[0], _.filter(colors, a => a.key.includes('DarkVibrant')).shift()]
						}


						// find colors with the best constrast ratios with the text
						if (useTextContrast && headingTextColor) {
							let textColorRGB = Object.values(hexToRgb(headingTextColor))
							let sortedColors = colors.map(color => {
								color.textContrast = colorContrastRatio(Object.values(hexToRgb(color.hex)), textColorRGB)
								return color
							})
								.sort((a, b) => {
									let aPoints = 0
									let bPoints = 0

									// big boost for higher text contrast
									if (b.textContrast > a.textContrast) {
										bPoints = bPoints + 2
									} else if (a.textContrast > b.textContrast) {
										aPoints = aPoints + 2
									}

									// boost for "Vibrant" colors
									const aVibrant = a.key.toLowerCase().includes('vibrant')
									const bVibrant = b.key.toLowerCase().includes('vibrant')
									if (bVibrant && !aVibrant) {
										bPoints++
									} else if (aVibrant && !bVibrant) {
										aPoints++
									}

									// boost if there is more of this color in the image
									if (b.population > a.population) {
										bPoints++
									} else if (a.population > b.population) {
										aPoints++
									}


									if (bPoints == aPoints) {
										return 0
									}

									return bPoints > aPoints ? 1 : -1
								})

							// remove ones with text contrast less than 3, see docblock for utils::colorContrastRatio
							let mostTextContrast = sortedColors.filter(t => t.textContrast >= 3);

							if (mostTextContrast.length >= 2) {
								sortedColors = mostTextContrast;
							}

		
							gradColors = [sortedColors[0], sortedColors[1]]
							if (sortedColors[0].key.includes('Dark') && !sortedColors[1].key.includes('Dark')) {
								// if the most prevalent color is dark, put it on the bottom
								gradColors = [sortedColors[1], sortedColors[0]]
							}

							/**
							 * TODO: only put dark one on bottom if text is LIGHT
							 */
							// if both colors are light, get a darker one for the second one
							if (sortedColors.length > 2 && sortedColors[0].key.includes('Light') && sortedColors[1].key.includes('Light')) {
								gradColors = [sortedColors[0], sortedColors[2]]
							}
						}

						this.$el.css({
							background: `linear-gradient(${gradColors[0].hex}, ${gradColors[1].hex})`
						})

						this.$el.addClass('dynamic-color');

					} else {
						this.showFallbackColors()
					}
				}).catch(e => {
					console.error(e)
					// error has already been logged
					this.showFallbackColors()
				})
			});

		} else {
			this.$el.addClass('no-image')
		}
	}

	setBannerGradient() {
		this.$el.find('.gradient').css({
			top: Math.abs(this.$el.find('.middle').offset().top - (this.$el.height() + this.$el.offset().top)),
		})
	}

	/**
	 * Show background media for the banner
	 * 
	 * @returns boolean did we set a background image
	 */
	showBgMedia() {
		let set = false
		if (this.bgVideoSrc && this.bgVideoMimeType) {
			this.$el.addBackgroundVideo([{ src: this.bgVideoSrc, type: this.bgVideoMimeType }])
			set = true
		} else if (this.bgImgSrc) {
			this.$el.addClass('banner')
			if (this.artOverBanner) {
				this.$el.addClass('art_over_banner')
			}
			this.$el.addBackgroundImage(this.bgImgSrc, {
				position: this.bgFocusX + ' ' + this.bgFocusY,
				attachment: this.bgImgAttachment
			})
			set = true
		}

		if (set && !this.artOverBanner) {
			// don't load other image
			this.$img.attr('src', '')
		}
		return set
	}
}
/**
 * Wrapper for the ffmpeg wasm, letting us use ffmpeg in JavaScript 
 * To use:
 * await sa.ffmpeg.load(); // you don't have to await this if it'll be a little bit before it's used
 * let params = sa.ffmpeg.createParams(...see function docs);
 * // make any changes to params necessary. they're the same as the cli params
 * let outputBlob = awaait sa.ffmpeg.exec(params, ...see function docs);
 * 
 * Read through download_studio.js if you want a working example
 * 
 * @type {{loaded: boolean, load: ffmpeg.load}}
 */
sa.ffmpeg = (function() {
	
	const ffmpeg = {
		loaded: false,
		load : async function() {
			if (loaded || loading || disabled) return;
			return await loadFFmpeg();
		}
	};
	let loaded = false;
	let loading = false;
	let disabled = false;
	let ffmpegObject;

	/**
	 * Creates a parameter array that ffmpeg.exec expects as its first parameter. 
	 * @param {string} newFormat mp3, etc.
	 * @param {string|int} sampleRate 
	 * @param {string|int} bitRate
	 * @param {string|int} bitDepth
	 * @returns {string[]} flags you'd pass to the cli version of ffmpeg, like [ '-map_metadata', '-vn', etc. ]
	 */
	ffmpeg.createParams = function(newFormat, sampleRate, bitRate, bitDepth) {
		const ffmpegParams = [ '-map_metadata', '0', '-vn' ];
		if (newFormat === 'mp3') {
			if (bitRate !== '-1') {
				ffmpegParams.push('-ab', bitRate);
			}
		} else if (bitDepth !== '-1') {
			ffmpegParams.push('-acodec', 'pcm_s' + bitDepth + (newFormat === 'wav' ? 'le' : 'be'));
		}
		if (sampleRate !== '-1') {
			ffmpegParams.push('-ar', sampleRate);
		}
		return ffmpegParams;
	};

	/**
	 * Updates params so as little metadata as possible is injected into the output file
	 * @param {string[]} params from ffmpeg.createParams
	 * @param {string} outputFormat mp3, etc. 
	 * @returns {string[]}
	 */
	ffmpeg.disableMetadata = function(params, outputFormat) {
		if (outputFormat === 'mp3') {
			params.push('-write_xing', '0', '-id3v2_version', '0');
		} else {
			params.push('-map_metadata', '-1');
		}
		return params;
	};

	/**
	 * Runs ffmpeg
	 * @param {string[]} params from ffmpeg.createParams()
	 * @param {string} inputFormat mp3, etc.
	 * @param {string} outputFormat mp3, etc.
	 * @param {Blob[]|Blob} inputBlobs one or more Blob's of audio data to process
	 * @param {function} logFunction called without debugging output strings
	 * @returns {Promise<module:buffer.Blob|null>} returns the output blob if there's no error
	 */
	ffmpeg.exec = async function(params, inputFormat, outputFormat, inputBlobs, logFunction = console.log) {
		if (disabled || !loaded) return null;
		logFunction('sa.ffmpeg.exec', 'ran ffmpeg');
		const rand = new Date().getTime(); // random component of filenames so we don't overwrite existing
		const toDelete = []; // temp files we can remove after execution finishes
		const outputPath = 'output-' + rand + '.' + outputFormat; // where our output file will go
		toDelete.push(outputPath); // remove it when we're done
		params.push(outputPath); // output path should be the last param
		
		// if the user is processing a single blob but it's in an array, don't try to mix it from one into one. ffmpeg will throw an error
		if (Array.isArray(inputBlobs) && inputBlobs.length === 1) {
			inputBlobs = inputBlobs[0];
		}
		// if the user is only processing a single input, that's easier to format and doesn't require a filter
		if (!Array.isArray(inputBlobs)) {
			const inputPath = `input-${rand}.${inputFormat}`; // temp file for our input data
			toDelete.push(inputPath); // remove it when we're done
			await ffmpegObject.writeFile(inputPath, await FFmpegUtil.fetchFile(inputBlobs)); // store the input blob on disk for processing
			params.unshift('-i', inputPath); // input file should be the first parameter
		} else {
			// if they sent an array of blobs, we combine them into one as part of the processing, overlapping them on top of one another
			// each one needs to be passed as params (-i filename1 -i filename2) into ffmpeg
			// then we use a filter_complex to layer them 
			// if there's already a filter_complex, we have to modify it to use our layered data as the filter input
			
			// filter_complex strings are semi-colon separated, ordered lists of operations, with inputs and outputs at each step
			// it will look like "[first_input][second_input]operation=inputs=2:option1=value:option2=value[output_name];[output_name]second_operation=..."
			let filterComplex = '';
			for (let i = 0; i < inputBlobs.length; i += 1) {
				const inputPath = `input-${i}-${rand}.${inputFormat}`; // temp file for our input data
				toDelete.push(inputPath); // remove it when we're done
				await ffmpegObject.writeFile(inputPath, await FFmpegUtil.fetchFile(inputBlobs[i])); // store the input blob on disk for processing
				params.unshift('-i', inputPath); // add the input file to ffmpeg's param list
				filterComplex += `[${i}:a]`; // add this input as a numbered audio stream in our filter
			} // techincally, this is adding the inputPath params and filterComplexes backwards but it doesn't matter
			
			// this filter string will combine the input streams into one, named somethinguniqueplzk - this name doesn't matter but can't be used in another filter so i made it weird
			// duration=longest means the output will be as long as the longest input. normalize=0 means it won't adjust volume of inputs
			filterComplex += `amix=inputs=${inputBlobs.length}:duration=longest:normalize=0[somethinguniqueplzk]`;
			
			// now [somethinguniqueplzk] will contain a mixed version of all the inputs. append the existing filter_complex, if there is one
			// and update its references to the original input (named [0:a]) to reference [somethinguniqueplzk] instead
			const filterComplexIndex = params.indexOf('-filter_complex');
			if (filterComplexIndex !== -1) {
				filterComplex = filterComplex + ';' + params[filterComplexIndex + 1].replace(/\[0:a]/g, "[somethinguniqueplzk]");
			}
			
			// HAHA you fool! - if only it were that easy. filters can do any number of operations to an original input stream but on a generated stream, like ours, it can only do one.
			// to do multiple operations, we have to explicitly do an "asplit" (audio split) operation on our generated stream and make a unique copy for each subsequent operation.
			// to do THAT, we iterate through each reference to [somethinguniqueplzk] and change it [somethinguniqueplzk${i}], where ${i} is unique
			let splitStreamIndex = -1;
			filterComplex = filterComplex.replace(/\[somethinguniqueplzk]/g, () => {
				splitStreamIndex++;
				return `[somethinguniqueplzk${splitStreamIndex}]`;
			});
			
			// the output of our amix is now [somethinguniqueplzk0] and we insert the asplit operation immediately after that, splitting into as many streams as we have uses of the stream
			// it'll end as something like "[somethinguniqueplzk0]asplit=[somethinguniqueplzk1][somethinguniqueplzk2];"
			if (splitStreamIndex > 0) {
				filterComplex = filterComplex.replace(/\[somethinguniqueplzk0];/, () => {
					let splitString = `[somethinguniqueplzk0];[somethinguniqueplzk0]asplit=${splitStreamIndex}`;
					for (let i = 1; i <= splitStreamIndex; i += 1) {
						splitString += `[somethinguniqueplzk${i}]`;
					}
					return splitString + ';';
				});
			}
			
			// our filter_complex is now finished and we just have to insert it into the appropriate place in the params array
			if (filterComplexIndex === -1) { // there is not one currently
				// this can go after the last input. since we just added them all and there's two per input, we know where that is. it's inputBlobs.length * 2
				params.splice(inputBlobs.length * 2, 0, '-filter_complex', filterComplex, '-map', `[somethinguniqueplzk${splitStreamIndex}]`);
			} else { // replace the current one
				// the filter complex string will be the next index. add our new filter in front and convert all existing references to the input stream into our new one 
				params[filterComplexIndex + 1] = filterComplex;
			}
		}
		
		if (user.logged && user.hasAdminPermission('super_admin')) {
			logFunction('sa.ffmpeg.exec', 'Running ffmpeg with', params);
		}
		
		// run ffmpeg
		await ffmpegObject.exec(params);
		logFunction('sa.ffmpeg.exec', 'ran ffmpeg');
		
		// read the final file back into memory so we return it after we clean up
		const data = new Blob([ await ffmpegObject.readFile(outputPath) ]);
		logFunction('sa.ffmpeg.exec', 'got final data');
		
		// clean up, deleting all our temp files
		for (let path of toDelete) {
			logFunction('sa.ffmpeg.exec', 'deleting', path);
			try {
				await ffmpegObject.deleteFile(path);
			} catch (err) {
				logFunction(err);
			}
		}
		logFunction('sa.ffmpeg.exec', 'cleaned up');
		
		return data;
	};
	

	/**
	 * Loads the ffmpeg library
	 * @returns {Promise<void>}
	 */
	async function loadFFmpeg() {
		if (loaded) return;
		if (loading) {
			// we are in the process of loading. just wait
			await new Promise((resolve) => {
				const interval = setInterval(() => {
					if (loaded) {
						clearInterval(interval);
						resolve();
					}
					console.log('ffmpeg still loading...');
				}, 100);
			});
			return;
		}
		loading = true;
		try {
			await loadScriptPromise(`../node_modules/@ffmpeg/ffmpeg/dist/umd/ffmpeg.js`);
			await loadScriptPromise(`../node_modules/@ffmpeg/util/dist/umd/index.js`);
			ffmpegObject = new FFmpegWASM.FFmpeg();
			ffmpegObject.on('log', ({ message }) => console.log(message));
			ffmpegObject.on('progress', ({ progress, time }) => {
				console.log("progress", progress, time);
				//ffmpeg.#updateProgress(progress * 100);
			});
			await ffmpegObject.load({
				coreURL : await FFmpegUtil.toBlobURL(`node_modules/@ffmpeg/core/dist/umd/ffmpeg-core.js`, 'text/javascript'),
				wasmURL : await FFmpegUtil.toBlobURL(`node_modules/@ffmpeg/core/dist/umd/ffmpeg-core.wasm`, 'application/wasm'),
			});
			loading = false;
			loaded = true;
			ffmpeg.loaded = true;
		} catch (e) {
			disabled = true;
			loading = false;
			loaded = true; // to disable the loading promise
			console.error(e);
			sa.api.request({
				handler : 'download-studio',
				action : 'recordError',
				postData : { stage: 'ffmpeg loading', logs : [ 'ffmpeg loading failure', e ], url: document.location.href }
			});
		}
	}
	
	return ffmpeg;
	
})();
class AITagDemoPage {
	constructor() {
		this.name = 'AI Tagging Demo'
		this.title = 'AI Tagging Demo';
		this.register = {
			routes: [
				{
					name: 'aitagdemo',
					pattern: '/aitagdemo',
					hash: '#!aitagdemo'
				}
			]
		};
	}

	async show(params) {
		if (config.id !== 9537) {
			setTimeout(function () {
				sa.router.goTo404Page();
			}, 250);
			return;
		}
	
		sa.currentPage = this;
		clearBody();

		// create the div on the body
		this.div = $j('<div class="ai-tag-demo"></div>').appendTo('#body');

		// bind the component to the div
		window.mountReactComponent(this.div[0], 'page-ai-tag-demo');

	}
}

sa.pages.aitagdemo = new AITagDemoPage();
sa.pages.grouping = (function() {

	var page = {
		tabData : {}
	};
	var templates;

	var currentVars = {};
	var req = 0;
	var listMetadata = {};

	var trackList = createTrackList((function() {
		let conf = new TrackListConfig({
			allowMiniBlock : true,
			bankKey : 'gp_tracks',
			callback : function (response) {
				setPageData(trackList, response);
			},
			callbackActual : function (response) {
				setPageData(trackList, response);
			},
			topBar : true,
			useFilters : true,
			useMusicSupplierData : config.showExternalCatalogData
		});
		conf.useStandardColumnList();
		return conf;
	})());
	

	var artistList = createArtistList((function() {
		let conf = new ListConfig({
			callback : function (response) {
				setPageData(artistList, response);
			},
			callbackActual : function (response) {
				setPageData(artistList, response);
			},
			useFilters : true,
			bankKey : 'gp_artists',
			topBar : true
		});
		conf.addColumnList(getStandardArtistColumnList());
		return conf;
	})());

	var albumList = createAlbumList((function() {
		let conf = new ListConfig({
			callback : function (response) {
				setPageData(albumList, response);
			},
			callbackActual : function (response) {
				setPageData(albumList, response);
			},
			useFilters : true,
			bankKey : 'gp_albums',
			topBar : true
		});
		conf.addColumnList(getStandardAlbumColumnList(true, false));
		return conf;
	})());

	var labelList = createLabelList((function() {
		let conf = new ListConfig({
			callback : function (response) {
				setPageData(labelList, response);
			},
			callbackActual : function (response) {
				setPageData(labelList, response);
			},
			useFilters : true,
			bankKey : 'gp_labels',
			topBar : true
		});
		conf.addColumnList(getStandardLabelColumnList(true));
		return conf;
	})());

	var catalogList = createCatalogList((function() {
		let conf = new ListConfig({
			callback : function (response) {
				setPageData(catalogList, response);
			},
			callbackActual : function (response) {
				setPageData(catalogList, response);
			},
			useFilters : true,
			bankKey : 'gp_catalogs',
			topBar : true
		});
		conf.addColumnList(getStandardLabelColumnList(true));
		return conf;
	})());

	var publisherList = createPublisherList((function() {
		let conf = new ListConfig({
			callback : function (response) {
				setPageData(publisherList, response);
			},
			callbackActual : function (response) {
				setPageData(publisherList, response);
			},
			useFilters : true,
			bankKey : 'gp_publishers',
			topBar : true
		});
		conf.addColumnList(getStandardPublisherColumnList());
		return conf;
	})());

	var writerList = createWriterList((function() {
		let conf = new ListConfig({
			callback : function (response) {
				setPageData(writerList, response);
			},
			callbackActual : function (response) {
				setPageData(writerList, response);
			},
			useFilters : true,
			bankKey : 'gp_writers',
			topBar : true
		});
		conf.addColumnList(getStandardWriterColumnList());
		return conf;
	})());

	/**
	 * Shows the page based on data from the hash and the calling page object
	 * @param {Object} vars
	 * @param {function} setObject
	 */
	page.showFromVars = function(vars, setObject) {

		if (!templates) {
			templates = sa.templates.get('pages.grouping_page');
		}

		vars = $j.extend({
			name : 'unknown',
			supplierId : null,
			catalogId : null,
			labelId : null,
			publisherId : null,
			writerId : null,
			defaultTab : 't',
			page : '',
			linkFunction : function() { return ''; }
		}, vars);

		var tab = vars.page;
		if (!tab && vars.defaultTab) {
			if (vars.defaultTab == 't') {
				tab = 'tracks';
			} else if (vars.defaultTab == 'c') {
				tab = 'catalogs';
			} else if (vars.defaultTab == 'l') {
				tab = 'labels';
			} else if (vars.defaultTab == 'a') {
				tab = 'artists';
			} else if (vars.defaultTab == 'b') {
				tab = 'albums';
			}else if (vars.defaultTab == 'w') {
				tab = 'writers';
			}else if (vars.defaultTab == 'p') {
				tab = 'publishers';
			}
		} else if (!tab) {
			tab = 'tracks';
		}

		if (vars.catalogId != currentVars.catalogId 
			|| vars.labelId != currentVars.labelId
			|| vars.supplierId != currentVars.supplierId
			|| vars.publisherId != currentVars.publisherId
			|| vars.writerId != currentVars.writerId
			) {

			let currentPath = sa.router.getCurrentPath();
			ajax($j.extend({ p : 'grouping_page_tabs', linkFunction : '' }, vars), function (data) {
				if (!data || !data.data) {
					sa.router.routeTo(sa.router.pathConversionLookup(config.home));
					return;
				}

				if (currentPath !== sa.router.getCurrentPath()) return; // make sure the user hasn't navigated away

				sa.body.empty();

				page.tabData = data;

				setObject(page.tabData.data);

				showTab(tab, vars);

			});

		} else {

			setObject(page.tabData.data);

			showTab(tab, vars);

		}

		currentVars = vars;
	};

	/**
	 * Allows overriding the current object representing the catalog/label/etc.
	 * 
	 * @param {object} data 
	 */
	page.overrideTabData = function(data) {
		page.tabData.data = data;
	}

	/**
	 * @param {string} type
	 * @param {Object} vars
	 */
	function showTab(type, vars) {

		var container = $j('#grouping_page_' + type + '_container');
		var tabAlreadyShowing = true;
		if (!container.length) {
			container = templates.get(type);
			sa.body.empty().append(container);
			sa.components.leftNav.show();
			tabAlreadyShowing = false;

			showHeading(type);
		}

		var showExternal = config.showExternalCatalogData && vars.catalogId ? vars.catalogId : 0;

		req++;

		if (type == 'tracks') {

			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableAlbumFilters();
				sa.components.leftNav.enableTrackFilters(['catalog', 'network'], showExternal);
				trackList.generatePage(container.find('.track_list'));
			}

			trackList.loadPage(varsToInfoParams(vars) + '&reqOverride=' + req);

		} else if (type == 'albums') {

			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableTrackFilters();
				sa.components.leftNav.enableAlbumFilters(['catalog', 'network'], showExternal);
				albumList.generatePage(container.find('.track_list'));
			}

			albumList.loadPage(varsToInfoParams(vars) + '&reqOverride=' + req);

		} else if (type == 'artists') {

			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableTrackFilters();
				sa.components.leftNav.disableAlbumFilters();
				artistList.generatePage(container.find('.track_list'));
			}

			artistList.loadPage(varsToInfoParams(vars) + '&reqOverride=' + req);

		} else if (type == 'labels') {

			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableTrackFilters();
				sa.components.leftNav.disableAlbumFilters();
				labelList.generatePage(container.find('.track_list'));
			}

			labelList.loadPage(varsToInfoParams(vars) + '&reqOverride=' + req);

		} else if (type == 'catalogs') {

			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableTrackFilters();
				sa.components.leftNav.disableAlbumFilters();
				catalogList.generatePage(container.find('.track_list'));
			}

			catalogList.loadPage(varsToInfoParams(vars) + '&reqOverride=' + req);

		} else if (type == 'licensing') {

			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableTrackFilters();
				sa.components.leftNav.disableAlbumFilters();
			}

			container.find('.music_supplier_licensing_name').html(page.tabData.data['licenseContactName']);
			container.find('.music_supplier_licensing_phone').html(page.tabData.data['licenseContactPhone']);
			container.find('.music_supplier_licensing_email').html(page.tabData.data['licenseContactEmail'])
				.attr('href', 'mailto:' + page.tabData.data['licenseContactEmail']);

			showExtraTabs({ pageVars : '' });

		} else if (type == 'writers') {
			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableTrackFilters();
				sa.components.leftNav.disableAlbumFilters();
				writerList.generatePage(container.find('.track_list'));
			}

			writerList.loadPage(varsToInfoParams(vars) + '&reqOverride=' + req);
		} else if (type == 'publishers') {
			if (!tabAlreadyShowing) {
				sa.components.leftNav.disableTrackFilters();
				sa.components.leftNav.disableAlbumFilters();
				publisherList.generatePage(container.find('.track_list'));
			}

			publisherList.loadPage(varsToInfoParams(vars) + '&reqOverride=' + req);
		}

	}

	/**
	 * @param {Object} listMetadata
	 */
	function showExtraTabs(listMetadata) {
		if (listMetadata.pageVars.match(/\bs=/)) {
			sa.components.heading.addTab({
				title : 'Search Results',
				href : sa.router.getCurrentPath(true),
				count : listMetadata.count,
				selected : true
			}, 'grouping_page_s');
		} else if (sa.components.heading.removeTab('grouping_page_s')) {
			var typeMatch = listMetadata.pageVars.match(/type=([a-z]+)/);
			if (typeMatch) {
				$j('#heading .tab[href*="page=' + typeMatch[1] + '"]').addClass('selected');
			}
		}
	}

	/**
	 * @param {List} list
	 * @param {Array} pageData
	 */
	function setPageData(list, pageData) {
		listMetadata = pageData[0];
		if (listMetadata.req != req) {
			console.log('skipped old request data because it returned', listMetadata.req, 'and i expected', req);
			return;
		}

		showExtraTabs(listMetadata);

		list.setData(pageData, currentVars.linkFunction);

		if (listMetadata.filters) {
			sa.components.leftNav.showSmartFilters(listMetadata.filters);
		}
	}

	/**
	 * @param {Object} vars
	 * @returns {string}
	 */
	function varsToInfoParams(vars) {
		var usefulVars = jQuery.extend({}, vars);

		const map = {
			'catalogId' 	: 'c',
			'labelId' 		: 'l',
			'publisherId' 	: 'publisher',
			'writerId'		: 'writer',
		}

		// Map values to the track_info values required for the track list
		for (let [key, mapKey] of Object.entries(map)) {
			if (usefulVars[key]) {
				usefulVars[mapKey] = usefulVars[key]
				delete usefulVars[key]
			}
		}
		
		if (usefulVars.supplierId && usefulVars.supplier) {
			delete usefulVars.supplier;
		}
	
		delete usefulVars.page;
		return sa.router.varsToParams(usefulVars);
	}

	/**
	 * @param {string} type
	 */
	function showHeading(type) {
		sa.components.heading.resetOptions();
		var facets = {};
		if (page.tabData.catalogCount && page.tabData.catalogCount > 1 && (user.hasAdminPermission(AdminPermission.Any) || config.hiddenFields.indexOf('catalog') === -1)) {
			facets.catalogs = page.tabData.catalogCount;
		}
		if (page.tabData.labelCount && page.tabData.labelCount > 1 && (user.hasAdminPermission(AdminPermission.Any) || config.hiddenFields.indexOf('label') === -1)) {
			facets.labels = page.tabData.labelCount;
		}
		if (page.tabData.albumCount && page.tabData.albumCount > 1 && (user.hasAdminPermission(AdminPermission.Any) || config.hiddenFields.indexOf('album') === -1)) {
			facets.albums = page.tabData.albumCount;
		}
		if (page.tabData['artistCount'] && page.tabData['artistCount'] > 1 && (user.hasAdminPermission(AdminPermission.Any) || config.hiddenFields.indexOf('artist') === -1)) {
			facets.artists = page.tabData['artistCount'];
		}
		if (page.tabData['writerCount'] && page.tabData['writerCount'] > 1 && (user.hasAdminPermission(AdminPermission.Any) || config.hiddenFields.indexOf('writer') === -1)) {
			facets.writers = page.tabData['writerCount'];
		}
		if (page.tabData['publisherCount'] && page.tabData['publisherCount'] > 1 && (user.hasAdminPermission(AdminPermission.Any) || config.hiddenFields.indexOf('publisher') === -1)) {
			facets.publishers = page.tabData['publisherCount'];
		}
		if (page.tabData.trackCount && page.tabData.trackCount > 1) {
			facets.tracks = page.tabData.trackCount;
		}
		var headingExtra = {
			image : page.tabData.data.image,
			preamble : gde(page.tabData.type, { c : 'u', p : false }),
			bannerImage: _.get(page, 'tabData.data.bannerImage', {}),
			item: page.tabData.data,
			type: page.tabData.type,
			subtext: page.tabData.data.description || page.tabData.data.subtext || '',
		};
		setTitle(gde(type, { c : 'u', p : false }) + ' - ' + page.tabData.data.name, headingExtra.preamble )
		// since the router will try to set it again
		page.title = document.title
		// setTitle(headingExtra.preamble + ' - ' + page.tabData.data.name);
		
		// Check the current URL		
		let currentUrl = sa.router.buildFullUrl(sa.router.getCurrentPath(true));
		
		// Search match is what causes the tabs to be built correctly for the the facet tabs
		// if you want the tabs to be the correct links, need to add the type here
		const allowedTypes = [
			'catalog',
			'music-supplier',
			'label',
			'writer',
			'publisher'
		];
		const typesRegexStr = allowedTypes.map(a => a + '\\/').join('|')
		const searchRegex = new RegExp(`\\b((${typesRegexStr})\\d+)`)
		let searchMatch = currentUrl.href.match(searchRegex);
		let hrefBase = searchMatch ? searchMatch[1] + '?page=$t' : '';
		
		sa.components.heading.buildFacetTabs(facets, headingExtra, type, '', hrefBase);
		
		if (page.tabData.licensing) {
			hrefBase = hrefBase.replace('$t', 'licensing');
			let [_, searchParams] = hrefBase.split('?');
			currentUrl.search = searchParams;
			headingExtra.tabs.push({
				title : 'Licensing',
				href : currentUrl.href,
				count : '',
				selected : type === 'licensing'
			});
		}

		if (type === 'tracks' && user.hasAdminPermission(AdminPermission.Metadata) && !BrowserDetect.isAdobePanel) {
			const exportButton = $j('<a class="button">Export Metadata</a>');
			exportButton.on('click', function () {
				window.location.href = 'export.php?type=tracks&format=csv&fromTrackList=1&' + listMetadata.pageVars;
			})
			sa.components.heading.addOption(exportButton, sa.components.heading.LocationBottom);
		}

		sa.components.heading.show(page.tabData.data.name, headingExtra);

	}

	/**
	 * @returns {boolean}
	 */
	page.isShowingTrackList = function() {
		return !!$j('#grouping_page_tracks_container').length;
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingAlbumList = function() {
		return !!$j('#grouping_page_albums_container').length;
	};

	/**
	 * @return {List}
	 */
	page.getTrackList = function() {
		return trackList;
	};

	/**
	 * @return {List}
	 */
	page.getAlbumList = function () {
		return albumList;
	};

	return page;

})();

sa.pages.person = (function() {

	var page = {
	};

	var templates;

	page.show = function(options) {

		options = $j.extend({
			ajaxParameters : {},
			dictionaryType : '',
			listPageHash : '',
			listVarName : '',
			objectType : null,
			getEditButton : function(object) { console.warn('no getEditButton for object', object); return $j(); },
			forceEditButton : false,
			id : 0
		}, options);

		if (!templates) templates = sa.templates.get('pages.person');

		var container = templates.get('page');
		sa.components.leftNav.show();
		sa.components.leftNav.disableAll();

		$j('#body').empty().append(container);

		sa.currentPage = page;
		loadPage(container, options);

	};

	function loadPage(container, options) {
		
		ajax(options.ajaxParameters, function(response) {
			if (response.length < 2) {
				sa.router.routeTo('/' + options.listPageHash);
				return sa.notify({ text : gde(options.dictionaryType, { p : false, c : 'upper' }) + ' not found' });
			}
			if (response[0].error) return;
			setData(container, new window[options.objectType](response[1]), options);
		});

	}

	/**
	 * @param {JQuery} container
	 * @param {Artist} person
	 * @param {Object} options
	 */
	function setData(container, person, options) {
		console.log("setting person data", person, options)

		setTitle(person.name, gde(sa.getCurrentPageName(), { c : 'upper', p : false }));

		let preamble = sa.getCurrentPageName() ? gde(sa.getCurrentPageName()) : ''


		// banner type
		let bannerTypeGlobal = _.get(config, `theme.bannerTypes.${options.dictionaryType}`, false);
		let bannerTypeLocal = _.get(person, `bannerImage.type`, _.get(person, `bannerImage.bannerType`, false)); // bannerType key is backwards compatibility
		const currentBannerType = bannerTypeLocal || bannerTypeGlobal;
		let useDynamicColor = currentBannerType == 'gradient';
		if (_.get(person, 'imageIsDefault', false)) {
			// if image is default image, don't do it
			useDynamicColor = false;
		}
		// const useDynamicColor = dynColorSetting !== '' ? dynColorSetting : !!!person.imageIsDefault;
		const artOverBanner =  _.get(person, 'bannerImage.artOverBanner', false);

		

		let heroOptions = {
			title: person.name,
			imgSrc: person.image || '',
			imgIsDefault: person.imageIsDefault || false,
			dynamicColor: useDynamicColor,
			preamble: preamble,
			type: 'person',
			subtext: (person.description || ''),
			fullHeightImage: true,
		}
		
		if (currentBannerType == 'image') {
			heroOptions = _.extend(heroOptions, {
				textColor: _.get(person, 'bannerImage.textColor', ''),
				bgImgSrc: _.get(person, 'bannerImage.image', ''),
				bgFocusX: _.get(person, 'bannerImage.focusX', '50%'),
				bgFocusY: _.get(person, 'bannerImage.focusY', '50%'),
				artOverBanner
			})
		}

		const hero = new HeroImage(heroOptions)

		const $heroTitle = hero.$el;
		container.append($heroTitle)

		let baseUrl = siteBaseUrl();

		// container.append(templates.get('details' + (person.description ? '_with_description' : ''), {
		// 	name : person.name,
		// 	image : person.image ? '<img src="' + baseUrl + '/' + person.image + '"/>' : '',
		// 	description : person.description,
		// 	type : gde(options.dictionaryType, { c : 'u', p : false })
		// }));

		///////

		if (!person.image || config.siteType === 'drop') {
			// TODO: ASK PRIME ABOUT WHAT TO DO HERE
			container.find('.art_image').remove();
		}
		
		let personType = options.listPageHash === 'composers' ? 'composer' : 'artist';

		let linkHref = '';
		if (options.objectType === 'Artist' && options.listVarName === 'a') {
			linkHref = `${baseUrl}/artist/${options.id}/tracks`;	
		} else {
			linkHref = `${baseUrl}/tracks?${options.listVarName}=${options.id}`;
		}

		let template = templates.get('work', {
			fullLink: linkHref,
			baseUrl: siteBaseUrl(),
			type: personType,
			id: person.id,
			listVarName: options.listVarName
		})
		
		container.append(template);

		//description expand
		setTimeout(function() {
			var h = $j('#artist-title-bar .artist-details').height() + 10;
			var isMobile = sa.isMobile();
			if (h > 175 && !isMobile) {
				$j('#artist-title-bar .artist-details').css({height: '175px'});
				$j('#artist-title-bar .artist-seemore').show().on('click', function(e) {
					e.preventDefault();
					$j('#artist-title-bar .artist-seemore').fadeOut();
					$j('#artist-title-bar .fadeout').fadeOut();

					$j('#artist-title-bar .artist-seeless').fadeIn();
					$j('#artist-title-bar .artist-details').transition({height: h + 'px'});
				});

				$j('#artist-title-bar .artist-seeless').on('click', function(e) {
					e.preventDefault();
					$j('#artist-title-bar .artist-seemore').fadeIn();
					$j('#artist-title-bar .fadeout').fadeIn();

					$j('#artist-title-bar .artist-seeless').fadeOut();
					$j('#artist-title-bar .artist-details').transition({height: '175px'});
				});
			} else {
				$j('#artist-title-bar .artist-seemore').hide();
				$j('#artist-title-bar .fadeout').hide();
			}
		}, 100);

		// edit link
		if (person.editable || options.forceEditButton) {
			let optionButtons = [options.getEditButton(person)];

			// extract download buttons
			let dlButton = false;
			for (let i = optionButtons.length - 1; i > -1; i--) {
				let option = optionButtons[i];
				if (option.is('.download_button')) {
					dlButton = option
					optionButtons.splice(i, 1);
					break
				}

			}
			if (dlButton) {
				dlButton.text('').addClass('fa fa-download').removeClass("wide")
				hero.$heroOptions.append(dlButton)
			}

			var anchor = sa.components.OptionsMenu.GenerateFromButtons({ buttons: optionButtons });
			hero.$heroOptions.append(anchor)
		}

		// tracks
		const conf = new TrackListConfig();
		conf.allowBlock = true;
		conf.bankKey = 'artist_tracks';
		conf.callbackActual = conf.callback = function (response) {
			trackList.setData(response, getTrackLink);
		};
		conf.useStandardColumnList();
		conf.defaultResultsPerPage = 10;
		conf.headerBackground = false;
		conf.pagination = false;
		conf.resultCountChanging = false;
		conf.resultsPerPageCookie = false;
		conf.sortable = false;
		conf.viewCookie = true;
		conf.topBar = true;
		
		let trackList = createTrackList(conf);
		trackList.generatePage($j('#artist-tracks'));
		trackList.loadPage('recent=1&show=10&' + options.listVarName + '=' + person.id);

		//load albums
		ajax('p=album_info&show=10&' + options.listVarName + '=' + person.id, function(albums) {

			if (albums[0].error) return;

			if (albums.length < 2) {
				container.find('#artist-albums-title, #artist-albums').hide();
			} else {
				container.find('#artist-albums-title, #artist-albums').show();

				var albumList = container.find('#artist-albums').empty();

				for (var i = 1, len = albums.length; i < len; i++) {
					var album = new Album(albums[i]);
					albumList.append(album.generateArtElement({ showCatalog : false, showArtist : false, showCode : false, showReleaseDate : false, hovers : true, showing : true }));
				}
				albumList.append('<div class="clr"></div>');
			}

		});
	}

	return page;

})();

sa.pages.albumList = (function() {
	let page = {
		name : 'albums',
		title : gde('albums', { c : 'upper', p : false}) + ' List',
		register : {
			routes: [{
				hash : '#!albums',
				name: 'albums',
				pattern: '/albums',
			}, {
				name: 'artist-albums',
				hash : '#!albums',
				pattern: '/artist/:int/albums',
				id: 'a'
			}, {
				name: 'composer-albums',
				hash: '#!albums',
				pattern: '/composer/:int/albums',
				id: 'comp'
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;
	
	page.disableQuickProjects = function() {
		if (list) {
			list.disableQuickProjects();
		}
	};
	
	page.enableQuickProjects = function() {
		if (list) {
			list.enableQuickProjects();
		}
	};
	
	page.show = function(params) {

		if (!list) {

			var listConfig = new ListConfig();
			listConfig.addColumnList(getStandardAlbumColumnList(!!config.singleCatalog));
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = true;
			listConfig.bankKey = 'albumPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;

			list = createAlbumList(listConfig);

			templates = sa.templates.get('pages.album_list');

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('album_list');
			sa.components.leftNav.show();
			sa.components.leftNav.enableAlbumFilters();
			sa.components.leftNav.disableTrackFilters();

			list.generatePage(container.find('.list'));

			$j('#body').empty().append(container);
		}

		sa.currentPage = page;
		loadPage(params);

	};

	function loadPage(params) {
		list.loadPage(params);
	}

	function setData(newData) {
		list.setData(newData, getAlbumsLink);
		sa.components.heading.hide();
		var headingExtra = {};
		var filters = newData[0].filters;
		if (newData[0].facets) {
			sa.components.heading.buildFacetTabs(newData[0].facets, headingExtra, 'albums', sa.router.paramsToVars(newData[0].pageVars).s);
		}
		if (newData[0].headingName && newData[0].headingValue) {
			headingExtra.count = newData[0].count;
			headingExtra.preamble = newData[0].headingName;
			sa.components.heading.show(newData[0].headingValue, headingExtra);
		} else {
			sa.components.heading.show('All ' + config.getDictionaryEntry('album', true), headingExtra);
		}
		if (filters) {
			sa.components.leftNav.showSmartFilters(filters);
		}
	}
	
	return page;
	
})();
sa.pages.artist = (function() {

	let page = {
		name : 'artist',
		title : gde('artist', { c : 'upper', p : false }) + ' Details',
		register : {
			routes: [{
				name: 'artist',
				hash: '#!explorer',
				pattern: '/artist/:int/tracks',
				id: 'a',
				cb: (params) => {
					sa.pages.explorer.show(params);
					setTitle(page.title)
				}
			}, {
				name: 'artist',
				hash : '#!artist',
				pattern: '/artist/:int/:any?',
				id: 'id',
			}]
		},		
		artistId : 0
	};
	
	page.show = function(params) {

		var v = sa.router.paramsToVars(params);
		page.artistId = v.id;
		
		sa.pages.person.show({
			ajaxParameters : { p : 'artist_info', id : v.id },
			dictionaryType : 'artist',
			listPageHash : 'artists',
			listVarName : 'a',
			objectType : 'Artist',
			getEditButton : function(object) {
				return sa.components.buttons.generateEditButton({ type : 'artist', item : object, wide : true });
			},
			id : v.id
		});
		
		sa.currentPage = page;
		
	};
	
	return page;

})();

sa.pages.artistList = (function() {
	
	let page = {
		name : 'artist_list',
		title : gde('artist', { c : 'upper', p : false}) + ' List',
		register : {
			routes: [{
				name: 'artists',
				hash : '#!artists',
				pattern: '/artists'
			}]
		}
	};
	
	/** @var {List} */
	var list;
	var templates;
	
	page.show = function(params) {
		
		if (!list) {

			var listConfig = new ListConfig();
			listConfig.addColumnList(getStandardArtistColumnList());
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = true;
			listConfig.bankKey = 'artistPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;

			list = createArtistList(listConfig);
			
			templates = sa.templates.get('pages.artist_list');
			
		}

		if (sa.getCurrentPageName() != page.name) {
			
			var container = templates.get('artist_list');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();
			
			list.generatePage(container.find('.list'));
			
			$j('#body').empty().append(container);
		}
		
		sa.currentPage = page;
		loadPage(params);
		
	};

	function loadPage(params) {
		list.loadPage(params);
	}

	function setData(newData) {
		list.setData(newData, getArtistsLink);
		sa.components.heading.hide();
		var headingExtra = {};
		if (newData[0].facets) {
			sa.components.heading.buildFacetTabs(newData[0].facets, headingExtra, 'artists', sa.router.paramsToVars(newData[0].pageVars).s);
		}
		if (newData[0].headingName && newData[0].headingValue) {
			headingExtra.count = newData[0].count;
			headingExtra.preamble = newData[0].headingName;
			sa.components.heading.show(newData[0].headingValue, headingExtra);
		} else {
			sa.components.heading.show('All ' + config.getDictionaryEntry('artist', true), headingExtra);
		}
	}
	
	return page;
	
})();

sa.pages.catalog = (function() {
	
	let page = {
		name: 'catalog',
		title: gde('catalog', { c : 'upper', p : false }) + ' Details',
		register: {
			routes: [{
				name: 'catalog',
				hash: '#!catalog',
				pattern: '/catalog/:int/:any?',
				id: 'c',
				dontSetTitle: true,
			}]
		}
	};
	
	/** @var {Catalog} */
	var catalog;
	
	page.show = function(params) {
		let vars = sa.router.paramsToVars(params);
		
		if (!vars.c) {
			sa.router.routeTo('/');
			// sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			return;
		}
		
		catalog = null;

		sa.currentPage = page;
		
		sa.pages.grouping.showFromVars(jQuery.extend(vars, {
			name : page.name,
			catalogId : vars.c,
			defaultTab : config.defaultCatalogTab,
			linkFunction : getCatalogLinkExact
		}), function(catalogData) {
			setTitle(catalogData.name, gde('catalog', { c : 'upper', p : false }))
			catalog = new Catalog(catalogData);
		});
		
		sa.search.showCurrentCatalog();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingTrackList = function() {
		return sa.pages.grouping.isShowingTrackList();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingAlbumList = function() {
		return sa.pages.grouping.isShowingAlbumList();
	};
	
	/**
	 * @returns {Catalog}
	 */
	page.getCatalog = function() {
		return catalog;
	};

	/**
	 * @returns {int}
	 */
	page.getCatalogId = function() {
		return catalog ? catalog.id : 0;
	};

	/**
	 * @return {List}
	 */
	page.getTrackList = function() {
		return sa.pages.grouping.getTrackList();
	};

	/**
	 * @return {List}
	 */
	page.getAlbumList = function () {
		return sa.pages.grouping.getAlbumList();
	};

	page.setCatalog = function(cat) {
		catalog = cat
	}
	
	return page;
	
})();

sa.pages.catalogList = (function() {

	let page = {
		name : 'catalog_list',
		title : gde('catalog', { c : 'upper', p : false}) + ' List',
		register : {
			routes: [{
				name: 'catalogs',
				pattern: '/catalogs',
				hash: '#!catalogs'
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;

	page.show = function(params) {

		if (!list) {

			var listConfig = new ListConfig();
			listConfig.addColumnList([
				new ListColumn('name', ['name'], true),
				new ListColumn('track count', ['track count'], true),
				new ListColumn(config.getDictionaryEntry('album', false) + ' count', ['album count'], true),
				new ListColumn(config.getDictionaryEntry('label', false) + ' count', ['label count'], true),
				new ListColumn('plays', ['plays'], true)
			]);
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = true;
			listConfig.bankKey = 'catalogListPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;

			list = createCatalogList(listConfig);

			templates = sa.templates.get('pages.catalog_list');

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('catalog_list');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();

			list.generatePage(container.find('.list'));

			$j('#body').empty().append(container);
		}

		sa.currentPage = page;
		loadPage(params);

	};

	function loadPage(params) {
		list.loadPage(params);
	}

	function setData(newData) {
		list.setData(newData, getCatalogListLink);
		sa.components.heading.hide();
		var headingExtra = {};
		if (newData[0].facets) {
			sa.components.heading.buildFacetTabs(newData[0].facets, headingExtra, 'catalogs', sa.router.paramsToVars(newData[0].pageVars).s);
		}
		if (newData[0].headingName && newData[0].headingValue) {
			headingExtra.count = newData[0].count;
			headingExtra.preamble = newData[0].headingName;
			sa.components.heading.show(newData[0].headingValue, headingExtra);
		} else {
			sa.components.heading.show('All ' + config.getDictionaryEntry('catalog', true), headingExtra);
		}
	}

	return page;

})();
/* eslint-disable */
sa.pages.cueSheet = (function() {

	let page = {
		name : 'cue_sheet',
		title : 'Cue Sheet Details',
		register : {
			routes: [{
				name: 'cue-sheet',
				hash: '#!cue_sheet',
				id: 'cueSheetId',
				pattern: '/cue-sheet/:int/:any?',
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;
	var lastVars;
	/** @var {TrackListConfig} */
	var listConfig;

	page.cueSheet = {};
	page.trackFields = null;

	page.getTemplates = function() {
		if (!templates) {
			templates = sa.templates.get('pages.cue_sheet');
		}
		return templates;
	};

	page.show = function(params) {

		if (!list) {

			listConfig = new TrackListConfig();
			listConfig.allowBlock = true;
			listConfig.allowMiniBlock = false;
			listConfig.bankKey = 'cueSheet';
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			let columnList = getStandardColumnList();
			columnList[0].addDisplayColumn('reorder');
			listConfig.addColumnList(columnList);
			listConfig.defaultResultsPerPage = 100;
			listConfig.selectable = false;
			listConfig.useCache = false;
			listConfig.useFilters = false;
			listConfig.emptyMessage = 'No tracks have been added to this cue sheet yet.';

			list = createCueSheetList(listConfig);

			templates = page.getTemplates();

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('cue_sheet');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();

			list.generatePage(container.find('.track_list'));

			$j('#body').empty().append(container);
		}

		var cp = sa.getCurrentPageName();
		sa.currentPage = page;
		loadPage(params, cp != page.name);

	};

	function loadPage(params, dontHideSplash) {
		if (!dontHideSplash) {
			sa.components.cueSheeter.hideSplash();
		}
				
		// some pages expect this to always have a project if it's the page
		// let's make sure we have something for them
		var vars = sa.router.paramsToVars(params);
		lastVars = vars;
		if (vars.cueSheetId) {
			page.cueSheet = { id : vars.cueSheetId };
		}
		
		list.loadPage(params);
		if (firstCheck) {
			if (vars.s) {
				sa.search.addSearchTerm(vars.s);
			}
		}
	}

	function setUpColumnList(created) {
		listConfig.useStandardColumnList();
		if (!created && config.siteType !== 'drop') return; // these are only two flags that affect anything that follows

		for (let view of [ ListViewType.List, ListViewType.MiniBlock, ListViewType.Block ]) {
			let columnList = listConfig.getColumnList(view);
			for (let i = 0, len = columnList.length; i < len; i++) {
				// if this is a created list, meaning we can change it, add a reordering option
				if (created && columnList[i].hasDisplayColumn('title')) {
					columnList[i].addDisplayColumn('reorder');
				}
				// if this a drop site, remove the date columns
				if (config.siteType === 'drop' && columnList[i].hasDisplayColumn('date') || columnList[i].hasDisplayColumn('added_by')) {
					columnList.splice(i, 1);
					i--;
				}
			}
			listConfig.addColumnList(columnList, view);
		}
	}

	function setData(newData) {
		if (!newData.length || !newData[0].cueSheet || !newData[0].cueSheet.id) {
			sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			sa.notify({ text : 'Cue sheet not found or not accessible.'});
			return;
		}
		
		page.cueSheet = newData[0].cueSheet;
		page.trackFields = newData[0].trackFields;
		let cueSheetFields = newData[0].cueSheetFields;
		cueSheetFields = cueSheetFields.map(field => {
			field.value = StringSanitize.ifEncodedDecode(field.value);
			return field;
		});
		if (newData[0]['recount']) {
			user.reloadCueSheets();
		}
		
		setUpColumnList(page.cueSheet.created);
		if (!list.setData(newData, getCueSheetLinkExact)) return;
		// make sure this cueSheet is in the user's list
		// it might not be if they typed in a cueSheet url for a cueSheet they don't have
		var found = false;
		for (var c = 0; c < user.cueSheets.length; c++) {
			if (user.cueSheets[c].id == page.cueSheet.id) {
				found = true;
				break;
			}
		}
		if (!found) {
			// we need to add it to the user's cueSheet list and the cueSheeter
			user.cueSheets.push(page.cueSheet);
			sa.components.cueSheeter.setCueSheets(user.cueSheets);
		}
		sa.components.heading.hide();
		setTitle('Cue Sheet Details - ' + page.cueSheet.name);
		sa.components.cueSheeter.highlight(page.cueSheet.id);
		// black bar
		sa.components.heading.resetOptions();
		// pdf button
		sa.components.heading.addOption(generatePdfButton('type=cue_sheet&cueSheetId=' + page.cueSheet.id, true, 'Save as PDF'), sa.components.heading.LocationTop);
		// excel button
		sa.components.heading.addOption(generateExcelButton('type=cue_sheet&cueSheetId=' + page.cueSheet.id, true, 'Save as Excel'), sa.components.heading.LocationTop);
		// csv button
		sa.components.heading.addOption(generateCsvButton('type=cue_sheet&cueSheetId=' + page.cueSheet.id, true, 'Save as CSV'), sa.components.heading.LocationTop);
		// email button
		sa.components.heading.addOption(sa.components.emailer.generateEmailButton({ type : 'cue_sheet', item : page.cueSheet, wide : true, text : 'Email Link' }), sa.components.heading.LocationLeft);
		// copy to project button
		sa.components.heading.addOption(generateCueSheetToProjectButton(page.cueSheet, true, 'Copy to Playlist'), sa.components.heading.LocationTop);
		if (page.cueSheet.created) {
			// add/remove button
			sa.components.heading.addOption(sa.components.cueSheeter.generateQuickCueSheetModeButton(page.cueSheet, { wide : true }), sa.components.heading.LocationLeft);
			// edit
			sa.components.heading.addOption(sa.components.cueSheeter.generateCueSheetEditButton({ cueSheet : page.cueSheet, wide : true, text : 'Edit Cue Sheet Info' }), sa.components.heading.LocationTop);
			// copy
			sa.components.heading.addOption(sa.components.cueSheeter.generateCueSheetCopyButton({ cueSheet : page.cueSheet, wide : true, text : 'Copy/Make New' }), sa.components.heading.LocationTop);
		} else if (user.logged) {
			// make created
			sa.components.heading.addOption(sa.components.cueSheeter.generateCueSheetMakeCreatedButton({ cueSheet : page.cueSheet, wide : true, text : 'Enable Editing' }), sa.components.heading.LocationTop);
		}
		if (user.logged) {
			// remove
			sa.components.heading.addOption(sa.components.cueSheeter.generateCueSheetRemoveButton({ cueSheet : page.cueSheet, wide : true, text : 'Delete' }), sa.components.heading.LocationTop);
		}
		if (page.cueSheet.id) {			
			sa.components.heading.show(page.cueSheet.name, {
				count: page.cueSheet.trackCount, 
				preamble: 'Cue Sheet', 
				readonly: Boolean(!page.cueSheet.created), 
				pillType: 'cuesheet'
			});
			
			$j('.read-only-pill-explainer .faux-link').on('click', function () {
				if (lockdown) {
					return sa.showLockdownMessage();
				}
				
				sa.confirm({
					text: 'Enable Editing?',
					yesFunction: function () {
						return sa.components.cueSheeter.makeCreated(page.cueSheet, false);
						// return sa.components.cueSheeter.copyCueSheet(page.cueSheet, newName, interactionOptions);
					}
				});
			});
		} else {
			sa.components.heading.show('Cue Sheet not found');
		}

		// show cue sheet editable fields
		$j('.cue_sheet_field_editing').remove();
		var cueSheetFieldsContainer = templates.get('cue_sheet_field_editing');
		var cueSheetFieldsTable = cueSheetFieldsContainer.find('#cue_sheet_details_fields');
		for (var i = 0, len = cueSheetFields.length; i < len; i++) {
			var field = cueSheetFields[i];
			var fieldTemplate = templates.get('cue_sheet_details_field', { name : field.name, id : field.id });
			// Replace any <br> with newlines
			field.value = field.value.replace(/<br\/?>/g, '\n');
			fieldTemplate.find('textarea').val(field.value);
			cueSheetFieldsTable.append(fieldTemplate);
		}
		sa.forms.init(cueSheetFieldsTable, {
			realTimeValidation : true,
			realTimeValidationCallback : function(validationResult) {
				if (validationResult.error) return;
				if (lockdown) {
					return sa.showLockdownMessage();
				}

				ajax({ cueSheetId : page.cueSheet.id, fieldId : validationResult.name.substring(6), fieldValue : validationResult.value },
					function() {
						validationResult.showSuccess('Saved!', false);
						setTimeout(function() { validationResult.hideSuccess(); }, 1000);
					}, 'POST', 'p=cue_sheets&action=update_field');

			}
		});
		$j('#heading').after(cueSheetFieldsContainer);
		
		const $cueSheetHeader = $j('<div class="cue_sheet_header"></div>');
		// Remove any existing cue sheet headers
		$j('.cue_sheet_header').remove();
		$j('#heading').after($cueSheetHeader);

		// add external track button and EDL Upload button
		$j('.cue_sheet_external_track').remove();

		$cueSheetHeader.append(cueSheetFieldsContainer).append(templates.get('external_track'));
		
		if (!page.cueSheet.created) {
			$cueSheetHeader.find('#cue_sheet_details_fields textarea').off().prop('disabled', 'disabled');
			$cueSheetHeader.find('#cue_sheet_details_fields textarea, #cue_sheet_details_fields label').css({
				cursor: 'not-allowed',
				color: 'grey'
			});
		}
		

		sa.components.EDLImporter.generateButton( $j('#cue_sheet_edl_button').get(0), page.cueSheet.id );
		
		$j('#cue_sheet_add_custom_button').on('click', function() {
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			console.log('adding custom cue sheet item...');

			ajax('cueSheetId=' + page.cueSheet.id,
				function(resp) {
					if (resp.error) {
						sa.alert({
							text: resp.result
						});
						return;
					}
					console.log('added!');
					sa.router.reloadPage();
					sa.router.routeTo('/cue-sheet/' + page.cueSheet.id + '?focus=1');
				}, 'POST', 'p=cue_sheets&action=add_custom_item');
		});
		
		if (!page.cueSheet.created) {
			$j('#cue_sheet_add_by_file, #cue_sheet_edl_button').addClass('disabled').css('cursor', 'not-allowed');
			$j('#cue_sheet_edl_button').off('click');
			$j('.cue_sheet_block .relocate').hide();
		}

		$j("#cue_sheet_add_by_file").on('click', function (e) {
			if (!page.cueSheet.created) {
				e.preventDefault();
				return;
			}
			
			if (lockdown) {
				return sa.showLockdownMessage();
			}
			var context = templates.get('cue_sheet_add_by_file');
			var fb = new FocusBox(context);

			fb.show();

			function addTrack(trackId) {
				$j(context).html('Adding track...');
				ajax('cueSheetId=' + page.cueSheet.id + '&trackIds[]=' + trackId, function () {
					$j(context).html('Success! Reloading track list...');
					sa.router.reloadPage();
					sa.router.routeTo('/cue-sheet/' + page.cueSheet.id + '?focus=1');
				}, 'POST', 'p=cue_sheets&action=add_tracks');
			}

			function onAddByFileSearchSubmit() {
				var filename = $j(".filename", context).val();

				if (!(/\.\w+$/.test(filename))) {
					filename += ".mp3";
				}

				$j(".results", context).html("Searching...");

				ajax('p=track_info&s=' + encodeURIComponent(filename) + '&show=1&suppress=1', function (response) {
					var track, playButton;

					if (response[0].count > 0) {
						track = response[1];
						playButton = sa.components.player.generatePlayButton(track.id, { location : 'cueSheetAddByFilename' });
						$j(".results", context).empty().append(templates.get('cue_sheet_add_by_file_response', { title : track.title, length : track.length, id : track.id }));
						$j(".insert_play_button", context).append(playButton);

						$j(".add_file", context).on('click', function (e) {
							addTrack($j(this).data('track-id'));
						});
					} else {
						$j(".results", context).html("No such file found.");
					}
				});
			}

			$j(".submit", context).on('click', function () {
				onAddByFileSearchSubmit();
			});
			$j(".close", context).on('click', function () {
				fb.hide();
			});
			$j(".filename", context).trigger('focus');
			$j(".filename", context).on('keyup', function (e) {
				if (13 == e.keyCode) {
					onAddByFileSearchSubmit();
					return false;
				}

				return true;
			});
		});

		if (lastVars.focus) {
			$j('#list_blocks input:first').trigger('focus');
		}
		
		// Disable inputs if the cue sheet is in "read only" mode
		if (!page.cueSheet.created) {
			$j('.cue_sheet_block input, .cue_sheet_block select, .cue_sheet_block textarea').prop('disabled', 'disabled').css('background-color', '#c1c2c5');
		}
	}

	/**
	 * Removes a single instance of a track from the display of the cue sheet
	 * @param {int} instanceId
	 */
	page.removeInstance = function(instanceId) {
		let block = $j('#track_' + instanceId + '_row');
		block.css({
			height : block.height(),
			overflow : 'hidden',
			opacity : 1
		});
		block.animate(
			{
				height : 0,
				marginTop : 0,
				marginBottom : 0,
				opacity : 0
			},
			function() {
				block.remove();
				list.numberCueBlocks();
			}
		);
	};

	page.getList = function() {
		return list;
	};

	return page;

})();
/**
 * Shows detailed information about one track, as well as any alternate versions or similar tracks
 */
sa.pages.details = (function() {

	let page = {
		name: 'details',
		title: 'Track Details',
		register: {
			routes: [{
				name: 'track',
				hash: '#!details',
				pattern: '/track/:int/:any?',
				id: 'id',
			}]
		}
	};

	var alternatesSet = true;
	var cartItem = {};
	var editOn = false;
	var currentTab = '';
	var statsUserList = null;
	var templates;
	/** @var {Track|null} trackData */
	var trackData;
	var trackId = 0;
	var trackNotFound = false;

	/** @var {List} */
	var alternateTrackList = null;
	/** @var {List} */
	var similarTrackList = null;

	let showSimilarAndAlternate = true;
	let disableLinksAndSharing = false;

	/**
	 * Gets the current track id that's being displayed
	 * @returns {number}
	 */
	page.getTrackId = function() {
		return trackId;
	};

	function DetailsField(options) {

		this.name = options.name;
		this.value = options.value;

		this.wide = !!options.wide;
		this.editable = options.editable !== false;
		this.link = !!options.getLink;
		this.workNumbers = !!options.workNumbers;
		this.inputType = options.inputType ? options.inputType : '';
		this.hiddenCustomField = options.hiddenCustomField !== undefined ? options.hiddenCustomField : null;
		this.maxLength = options.maxLength !== undefined ? options.maxLength : 0;
		this.select = options.select ? options.select : false;

		this.setFieldData = options.setFieldData ? options.setFieldData : null;

		this.cwrField = !!options.cwrField;
		this.saveField = options.saveField ? options.saveField : null;

		this.deprecated = !!options.deprecated;

		this.hasValue = function(v) {
			if (!options.hasValue) {
				return !!v;
			} else {
				return options.hasValue(v);
			}
		};

		this.getNoticeContainer = function(container) {
			if (!options.getNoticeContainer) {
				return container;
			}
			return options.getNoticeContainer(container);
		};

		this.setValue = function(newValue) {
			if (!options.setValue) {
				trackData[this.name] = newValue;
			} else {
				options.setValue(newValue);
			}
		};

		this.getInputValue = function() {
			if (!options.getInputValue) {
				return this.value;
			}
			return options.getInputValue(this.value);
		};

		this.getLink = function() {
			if (!options.getLink) {
				return '';
			}
			return options.getLink(this.value);
		};

		this.getDisplayName = function() {
			if (!options.getDisplayName) {
				return gde(this.name.replace(/_/g, ' '), { c : 'upper', p : false });
			}
			return options.getDisplayName();
		};

		this.getDisplayValue = function() {
			if (!options.getDisplayValue) {
				return this.value;
			}
			return options.getDisplayValue(this.value);
		};

		this.getSelectValue = function() {
			if (!options.getSelectValue) {
				return this.value;
			}
			return options.getSelectValue(this.value);
		};

		this.getDatasetValues = function() {
			if (!options.getDatasetValues) {
				return createSafeObject();
			}
			return options.getDatasetValues();
		};

	}

	page.resetTrackData = function() {
		trackData = null;
	};

	/**
	 * Loads information for the track, depending on what page we're on
	 * @param {string} params the parameters for the page (probably includes track id and rep id)
	 * @param {string} section what section we're on (details|license) (download deprecated)
	 */
	function loadData(params, section) {
		var vars = sa.router.paramsToVars(params);

		alternatesSet = false;
		// if we already have data loaded, don't make another call to track_info
		if (trackData && trackData.id == vars.id && (section != 'works_registration' || trackData.worksRegistrationData)) {
			var wrapper = [{"count":1,"page":0,"perPage":15,"pageVars":"&show=15&pg="},trackData];
			switch (section) {
				case 'details':
					setData(wrapper);
					if (showSimilarAndAlternate) {
						similarTrackList.loadPage(params.replace('id', 'sim'));
						alternateTrackList.loadPage(params.replace('id', 'alt'));
					}
					break;
				case 'stats':
				case 'works_registration':
					setPreData(section, wrapper);
					break;
			}
		} else {
			switch (section) {
				case 'details':

					ajax('p=track_info&customs=1&' + params, function(response) {
						setData(response);
						if (showSimilarAndAlternate) {
							similarTrackList.loadPage(params.replace('id', 'sim'));
							alternateTrackList.loadPage(params.replace('id', 'alt'));
						}
					});
					break;
				case 'stats':
					ajax('p=track_info&customs=1&' + params, function(response) { setPreData(section, response); });
					break;
				case 'works_registration':
					ajax('p=track_info&customs=1&works_registration=1&' + params, function(response) { setPreData(section, response); });
					break;
			}
		}

	}

	/**
	 * Called when the user goes to the works_registration or stats page
	 * Had to create this because when the user goes directly to the download page without hitting the details
	 * page and loading the track data, trackData doesn't load as quickly as p=download, which then
	 * errors out. This way, we make sure we have the track info before loading the download info
	 */
	function setPreData(section, newData) {
		currentTab = section;
		setData(newData);
	}

	/**
	 * Callback after data's loaded
	 * @param {Array} newData the data for the track
	 */
	function setData(newData) {
		hideCover();
		let profilesWithTrackAccess = [];
		if (newData.length > 1) {
			trackData = newData[1];
			trackBank.clear('details');
			trackBank.add(trackData, 'details');
			setTitle(trackData.title, ((currentTab == 'details' || currentTab == 'stats' || currentTab == 'works_registration') ? 'Track Details' : 'License Track'));
		} else if (newData.length === 1 && newData[0].profilesWithTrackAccess) {
			profilesWithTrackAccess = newData[0].profilesWithTrackAccess;
		}
		switch (currentTab) {
			case 'details':
				setDetails(profilesWithTrackAccess);
				break;
			case 'stats':
				showStats();
				break;
			case 'works_registration':
				showWorksRegistration();
				break;
		}
		setNav(currentTab);
	}

	function initializeTemplates() {
		if (!templates) {
			templates = sa.templates.get('pages.details');
		}
	}

	/**
	 * Generates the basic page frame
	 * @param {string} params the parameters for the page
	 */
	page.show = function(params) {
		clearBody();

		initializeTemplates();

		showSimilarAndAlternate = !lockdown && config.siteType !== 'drop';
		disableLinksAndSharing = lockdown || config.siteMode === 'receive';

		var v = sa.router.paramsToVars(params);
		var requestedPage = v.page;
		var container = $j('#body').empty();

		if (!requestedPage) {
			requestedPage = 'details';
		}
		trackId = v.id;
		trackNotFound = false;

		if (requestedPage == 'license') {
			showLicenseModal();
			requestedPage = 'details';
		}

		if (requestedPage == 'stats' && !user.hasAdminPermission(AdminPermission.Statistics)) {
			requestedPage = 'details';
		}
		if (requestedPage == 'works_registration' && !user.hasAdminPermission(AdminPermission.WorksRegistration)) {
			requestedPage = 'details';
		}

		if (sa.components.leftNav) {
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();
		}

		showCover();

		switch (requestedPage) {
			case 'details':
				var details = templates.get('details_page');

				if (!lockdown) {
					var baseConfig = new TrackListConfig();
					baseConfig.allowMiniBlock = true;
					baseConfig.useStandardColumnList();
					baseConfig.resultsPerPageCookie = false;
					baseConfig.pagination = false;
					baseConfig.resultCountChanging = false;
					baseConfig.headerBackground = false;
					baseConfig.sortable = false;

					if (showSimilarAndAlternate) {

						// alternate versions
						var alternateTrackListConfig = new TrackListConfig(baseConfig);
						alternateTrackListConfig.defaultResultsPerPage = 50;
						alternateTrackListConfig.callback = function (response) {
							setAlternates(response);
						};
						alternateTrackListConfig.bankKey = 'details_alternate';
						alternateTrackListConfig.addColumnList(getCustomColumnList(config.trackColumnLists.simple.alternate), [ ListViewType.List, ListViewType.MiniBlock ]);
						alternateTrackListConfig.addColumnList(getCustomColumnList(config.trackColumnLists.wave.alternate), ListViewType.Block);
						alternateTrackListConfig.emptyMessage = 'You haven\'t set any alternates for this track. Click Edit Track Metadata to add some.';
						alternateTrackList = createTrackList(alternateTrackListConfig);

						// similar tracks
						var similarTrackListConfig = new TrackListConfig(baseConfig);
						similarTrackListConfig.defaultResultsPerPage = 5;
						similarTrackListConfig.callback = function (response) {
							setSimilar(response);
						};
						similarTrackListConfig.bankKey = 'details_similar';
						similarTrackListConfig.useStandardColumnList();
						similarTrackList = createTrackList(similarTrackListConfig);

					}
				}

				// append it all and do any extra generation
				container.append(details);
				if (showSimilarAndAlternate) {
					alternateTrackList.generatePage(details.find('#track_list_details_alternate'));
					similarTrackList.generatePage(details.find('#track_list_details_similar'));
				} else {
					details.find('#alternate_tracks_container').remove();
					details.find('#similar_tracks_container').remove();
				}
				break;
			case 'stats':
				container.append(templates.get('stats_page'));
				break;
			case 'works_registration':
				container.append(templates.get('works_registration_page'));
				break;
		}

		currentTab = requestedPage;
		loadData(params, requestedPage);

		sa.currentPage = this;
	};

	function setNav(section) {
		$j('#details_nav .tab').removeClass('selected').parent().find('#' + section).addClass('selected');
	}

	function setEditState(on) {
		editOn = on;
		addTitleContainer();
		addStatsContainer();
		addTrackDataContainer();
		addInteractionContainer();
		setAlternatesEdit();
	}

	function addTitleContainer() {
		var titleContainer = $j('#title_container');


		titleContainer.empty().append(templates.get('title_container').html());
		var titleElement = titleContainer.find('.title');

		console.log("track album", trackData.album);
		if (trackData.album && trackData.album.image && !trackData.album.imageIsDefault) {
			titleContainer.find('.album_art').append('<img src="' + trackData.album.image + '"/>');
		} else {
			titleContainer.find('.album_art').remove();
		}
		// watermarking notice
		if (!trackData.watermarked) {
			titleContainer.find('.watermark_notice').remove();
		} else if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			titleContainer.find('.watermark_notice').attr('href', 'https://' + ImportDomain + '/watermarker.php?fileId=&trackId=' + trackData.id + '&queueId=&action=lookup');
		}

		// title
		titleElement.html(trackData.title);

		if (editOn) {
			titleElement.addClass('editable_field');
			enableEditing(new DetailsField({
				name : 'title',
				value : trackData.title,
				setFieldData : function(field, container) {
					field.setValue(field.value);
					setTimeout(function() {
						titleElement.html(field.value);
						enableEditing(field, container);
					}, 1750);
				},
				setValue : function(newValue) {
					if (trackData.title !== newValue) {
						trackData.title = newValue;
						setTitle(trackData.title, 'Track Details');
					}
				},
				getNoticeContainer : function(container) {
					return container.find('.value_edit_container');
				}
			}), titleElement);
		}

		// create the waveform!
		let waveform = new Waveform(trackData.id, titleContainer.find("#waveform_container"), true, trackData.comments);
		var canComment = user.hasAdminPermission(AdminPermission.Sharing) && config.siteType !== 'drop';
		if (canComment) {
			waveform.enableCommenting()
		}
		titleContainer.find('#waveform_container .timeline_0').addClass('marker');

		// play button
		titleContainer.find('.play_button_container').append(sa.components.player.generatePlayButton(trackData.id, { location : 'details_page' }));

		if (trackData.album && trackData.album.image && !trackData.album.imageIsDefault) {
			titleContainer.find(".art").append(`<img src="${trackData.album.image}" />`);
		} else {
			titleContainer.addClass('no-art').find(".art").remove()
		}
	}

	function addEditingContainer() {
		var editingContainer = $j('#editing_container');
		var canComment = user.hasAdminPermission(AdminPermission.Sharing) && config.siteType !== 'drop';
		var canEdit = user.hasAdminPermission(AdminPermission.Metadata) && trackData.editable;

		if (!canComment && !canEdit) {
			editingContainer.remove();
			return;
		}

		editingContainer.empty().append(templates.get('editing_container').html());

		if (canComment) {

			editingContainer.find('.comment_options .button').on('click', function () {
				var comment = editingContainer.find('#comment_entry').val();
				var time = editingContainer.find('#comment_time').val();
				var seconds = 0;
				if (!comment) {
					return sa.alert({ text : 'Please enter a comment' });
				} else if (!time.match(/^([0-9]+)?:?[0-9]+$/)) {
					return sa.alert({ text : 'Please enter a time as either a number of seconds or in a mm:ss format' });
				}
				// turn time into seconds
				if (time[0] == ':') time = time.substring(1);
				var times = time.split(':');
				for (var i = times.length - 1; i >= 0; i--) {
					seconds += parseInt(times[i] * Math.pow(60, times.length - 1 - i));
				}
				ajax({ trackId : trackId, time : seconds, comment : comment },
					function (response) {
						if (response[0].success) {
							sa.notify({ text : 'Comment added!', type : sa.notify.notificationTypes.success });
							reloadDetailsPage();
						} else {
							sa.alert({ text : response[0].message });
						}
					}, 'POST', 'p=comments&action=add');
			});

			editingContainer.find('form').on('submit', function () {
				setTimeout(function () {
					editingContainer.find('.button').trigger('click');
				}, 10); // don't let errors submit form
				return false;
			});

		} else {

			editingContainer.find('.comment_options, .or').remove();
			editingContainer.addClass('no_commenting');

		}

		if (canEdit) {

			editingContainer.find('#swap_editing').on('click', function() {
				setEditState(!editOn);
				if (editOn) {
					$j(this).addClass('edit_on');
				} else {
					$j(this).removeClass('edit_on');
				}
			});

		} else {

			editingContainer.find('.editing_options, .or').remove();
			editingContainer.addClass('no_editing');

		}

	}

	function addStatsContainer() {
		var statsContainer = $j('#stats_container');

		let showReleaseDate = (config.hiddenFields.indexOf('release date') == -1 || user.hasAdminPermission(AdminPermission.Metadata)) && (trackData.date != formatDate(config.dateFormatString, 0));

		statsContainer.empty().append(templates.get('stats_container').html());

		// watermarking notice
		if (!trackData.watermarked) {
			statsContainer.find('.watermark_notice').remove();
		} else if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			statsContainer.find('.watermark_notice').attr('href', 'https://' + ImportDomain + '/watermarker.php?fileId=&trackId=' + trackData.id + '&queueId=&action=lookup');
		}

		// release date visibility and editing
		if (showReleaseDate) {
			statsContainer.find('#release_date .value').html(trackData.date);
			if (config.hiddenFields.indexOf('release date') !== -1) {
				statsContainer.find('#release_date').addClass('hidden_field').append(templates.get('hidden_field_notice'));
			}
		}

		// Create a link to sonic search similar tracks
		statsContainer.find('#find_similar a').attr('href', siteBaseUrl() + '/sonicsearch?track_search=' + trackData.id);

		if (editOn) {
			enableEditing(new DetailsField({
				name : 'date',
				value : trackData.date,
				inputType : 'date',
				getInputValue : function(v) {
					if (!showReleaseDate) {
						return '';
					}
					var formatSplit = config.dateFormatString.split('/');
					var dateSplit = v.split('/');
					return dateSplit[formatSplit.indexOf('Y')] + '-' + dateSplit[formatSplit.indexOf('m')] + '-' + dateSplit[formatSplit.indexOf('d')];
				},
				setFieldData : function(field, container) {
					field.setValue(field.value);
					container.find('.value').html(field.value);
					enableEditing(field, container);
				}
			}), statsContainer.find('#release_date'));
		} else if (!showReleaseDate) {
			statsContainer.find('#release_date').remove();
		}

		// privacy visibility and editing
		if (editOn && config.siteType !== 'drop') {
			statsContainer.find('#private .value').html(trackData.private ? 'Yes' : 'No');
			enableEditing(new DetailsField({
				name : 'private',
				value : trackData.private,
				getDisplayValue : function(v) {
					return v == 1 ? 'Yes' : 'No';
				},
				select : { list : 'binary', hideUnspecified : true },
				setFieldData : function(field, container) {
					field.setValue(field.value);
					container.find('.value').html(field.value == 1 ? 'Yes' : 'No');
					enableEditing(field, container);
				}
			}), statsContainer.find('#private'));
		} else {
			statsContainer.find('#private').remove();
		}

		statsContainer.find('#length .value').html(trackData.actualLength < 1 ? (Math.round(trackData.actualLength * 100) / 100) + 's' : trackData.length);
		if (config.siteType == 'drop') {
			let dateAdded = trackData.dateAdded;
			statsContainer.find('#dateAdded').html(dateAdded);
			statsContainer.find('#addedBy').html(trackData.addedBy.username);
		} else {
			statsContainer.find('#addedByInfo').remove();
		}

	}

	function addSubpageTabs(container) {
		const templ = templates.get('subpage_tabs');
		container.find('.page_buttons').append(templ);
		// Stats / Details / Registration tabs
		const canViewStats = user.hasAdminPermission(AdminPermission.Statistics) && config.siteType !== 'drop';
		const canViewWorksRegistration = user.hasAdminPermission(AdminPermission.WorksRegistration);
		if (!canViewStats && !canViewWorksRegistration) {
			container.find('.page_buttons').remove();
		} else {
			const trackBaseLink = siteBaseUrl() + '/track/' + trackId;
			container.find('#details_link').attr('href', trackBaseLink + '?page=details');

			// Find Similar Button
			container.find('#find_similar_btn').attr('href', siteBaseUrl() + '/sonicsearch?track_search=' + trackId);

			if (canViewStats) {
				container.find('#stats_link').attr('href', trackBaseLink + '?page=stats');
			} else {
				container.find('#stats_link').remove();
			}
			if (canViewWorksRegistration) {
				container.find('#works_registration_link').attr('href', trackBaseLink + '?page=works_registration');
			} else {
				container.find('#works_registration_link').remove();
			}

			if (currentTab) {
				setNav(currentTab);
				container.find("#" + currentTab + "_link").remove()
			}
		}
	}

	function getFields() {

		var fields = [];

		fields.push(new DetailsField({
			name: 'filename',
			value: trackData.file.filename,
			maxLength: 252,
			getDisplayValue: function (v) {
				return v.replace('.mp3', '');
			},
			getInputValue: function (v) {
				return v.replace('.mp3', '');
			},
			setValue: function (newValue) {
				trackData.file.filename = newValue;
			}
		}));

		fields.push(new DetailsField({
			name: 'artist',
			value: trackData.artist,
			getDisplayValue: function (v) {
				//return v.name;
				return formatRelationalField([v], getArtistLink, 'artist');
			},
			/*getLink: function (v) {
				return getArtistLink(v.id);
			},*/
			getSelectValue: function (v) {
				return v.id;
			},
			hasValue: function (v) {
				return v && v.id != 0;
			},
			select: { list: 'artist', allowNew: true }
		}));

		fields.push(new DetailsField({
			name: 'album',
			value: trackData.album,
			getDisplayValue: function (v) {
				//return v.name;
				return formatRelationalField([v], getAlbumLink, 'album');
			},
			/*getLink: function (v) {
				return getAlbumLink(v.id);
			},*/
			getSelectValue: function (v) {
				return v.id;
			},
			hasValue: function (v) {
				return v && v.id != 0;
			},
			select: { list: 'album', allowNew: true }
		}));

		if (config.siteType == 'buyer' && trackData.musicSupplier) {
			fields.push(new DetailsField({
				name: 'music_supplier',
				value: trackData.musicSupplier,
				getDisplayValue: function (v) {
					//return v.name;
					return formatRelationalField([v], getMusicSupplierLink);

				},
				getLink: function (v) {
					return getMusicSupplierLink(v.id);
				},
				editable: false
			}));
		}

		fields.push(new DetailsField({
			name: 'track_number',
			value: trackData.album.number,
			maxLength: 16,
			getDisplayValue: function (v) {
				return v != '0' ? v : '';
			},
			getInputValue: function (v) {
				return v != '0' ? v : '';
			},
			setValue: function (newValue) {
				trackData.album.number = newValue;
			},
			hasValue: function (v) {
				return v != '0';
			}
		}));

		if (config.siteType !== 'drop') {

			fields.push(new DetailsField({
				name: 'catalog',
				value: trackData.catalog,
				getDisplayValue: function (v) {
					//return v.name;
					return formatRelationalField([v], getCatalogLink, 'catalog');
				},
				/*getLink: function (v) {
					return getCatalogLink(v.id);
				},*/
				editable: !config.singleCatalog,
				getSelectValue: function (v) {
					return v.id;
				},
				select: { list: 'catalog', allowNew: false }
			}));

			fields.push(new DetailsField({
				name: 'label',
				value: trackData['label'],
				getDisplayValue: function (v) {
					//return v.name;
					return formatRelationalField([v], getLabelLink, 'label');
				},
				/*getLink: function (v) {
					return getLabelLink(v.id);
				},*/
				getSelectValue: function (v) {
					return v.id;
				},
				select: { list: 'label', allowNew: true }
			}));
		}

		fields.push(new DetailsField({
			name : 'genre',
			value : trackData.genres,
			getDisplayValue : function(v) {
				return formatRelationalField(v, getGenreLink, 'genre');
			},
			getSelectValue : function(v) {
				return v;
			},
			setValue : function(newValue) {
				trackData.genres = newValue;
			},
			hasValue : function(v) {
				var len = v.length;
				if (len < 1) return false;
				for (var i = 0; i < len; i++) {
					var valueName = v[i].name;
					if (valueName != 'Unspecified' && valueName != 'Unknown') {
						return true;
					}
				}
				return false;
			},
			getDatasetValues : function() {
				let values = createSafeObject();
				for (let dataset of trackData.datasets) {
					if (dataset.genreNames) {
						values[dataset.type] = dataset.genreNames;
					}
				}
				return values;
			},
			select: { list : 'genre', allowNew : true, multiple : true }
		}));

		if (config.siteType !== 'drop') {

			if (trackData.musicSupplierGenres && trackData.musicSupplierGenres.length) {
				fields.push(new DetailsField({
					name : 'music_supplier_genre',
					value : trackData.musicSupplierGenres,
					getDisplayName : function () {
						return trackData.musicSupplier.name + ' ' + gde('genre');
					},
					getDisplayValue : function (v) {
						//return formatRelationalField(v, getSearchLink);
						return formatTags(v.map(f => { return f.name; })); // nothing to link to since that genre isn't here, but we can search for it
					},
					hasValue : function (v) {
						return v.length > 0;
					},
					editable : false
				}));
			}

			fields.push(new DetailsField({
				name : 'tempo',
				value : trackData.tempos,
				getDisplayValue : function (v) {
					return formatRelationalField(v, getTempoLink, 'tempo');
				},
				getSelectValue : function (v) {
					return v;
				},
				setValue : function (newValue) {
					trackData.tempos = newValue;
				},
				hasValue : function (v) {
					var len = v.length;
					if (len < 1) return false;
					for (var i = 0; i < len; i++) {
						var valueName = v[i].name;
						if (valueName != 'Unspecified' && valueName != 'Unknown') {
							return true;
						}
					}
					return false;
				},
				getDatasetValues : function() {
					let values = createSafeObject();
					for (let dataset of trackData.datasets) {
						if (dataset.tempoNames) {
							values[dataset.type] = dataset.tempoNames;
						}
					}
					return values;
				},
				select : { list : 'tempo', allowNew : true, multiple : true }
			}));

			if (trackData.musicSupplierTempos && trackData.musicSupplierTempos.length) {
				fields.push(new DetailsField({
					name : 'music_supplier_tempo',
					value : trackData.musicSupplierTempos,
					getDisplayName : function () {
						return trackData.musicSupplier.name + ' ' + gde('tempo');
					},
					getDisplayValue : function (v) {
						//return formatRelationalField(v, getSearchLink);
						return formatTags(v.map(f => { return f.name; }));
					},
					hasValue : function (v) {
						return v.length > 0;
					},
					editable : false
				}));
			}

		}

		fields.push(new DetailsField({
			name : 'bpm',
			value : trackData.bpm,
			getDisplayValue : function (v) {
				return v ? v : '';
			},
			hasValue : function(v) {
				return !!v;
			},
			getDatasetValues : function() {
				let values = createSafeObject();
				for (let dataset of trackData.datasets) {
					if (dataset.bpm) {
						values[dataset.type] = dataset.bpm;
					}
				}
				return values;
			},
		}));

		if (config.siteType !== 'drop') {

			fields.push(new DetailsField({
				name : 'cue_type',
				value : trackData.cueTypes,
				getDisplayValue : function (v) {
					return formatRelationalField(v, getCueTypeLink);
				},
				getSelectValue : function (v) {
					return v;
				},
				setValue : function (newValue) {
					trackData.cueTypes = newValue;
				},
				hasValue : function (v) {
					var len = v.length;
					if (len < 1) return false;
					for (var i = 0; i < len; i++) {
						var valueName = v[i].name;
						if (valueName != 'Unspecified' && valueName != 'Unknown') {
							return true;
						}
					}
					return false;
				},
				select : { list : 'cue_type', allowNew : true, multiple : true }
			}));

			if (trackData.musicSupplierCueTypes && trackData.musicSupplierCueTypes.length) {
				fields.push(new DetailsField({
					name : 'music_supplier_cue_type',
					value : trackData.musicSupplierCueTypes,
					getDisplayName : function () {
						return trackData.musicSupplier.name + ' ' + gde('cue type');
					},
					getDisplayValue : function (v) {
						//return formatRelationalField(v, getSearchLink);
						return formatTags(v.map(f => { return f.name; }));
					},
					hasValue : function (v) {
						return v.length > 0;
					},
					editable : false
				}));
			}

			fields.push(new DetailsField({
				name : 'mood',
				value : trackData.moods,
				getInputValue : function (v) {
					// if any of the values has a comma, we need to combine with semi-colons instead
					for (let vi = 0, len = v.length; vi < len; vi++) {
						if (v[vi].indexOf(',') !== -1) {
							return v.join('; ');
						}
					}
					return v.join(', ');
				},
				hasValue : function (v) {
					return v.length > 0;
				},
				getDisplayValue : function (v) {
					return formatTags(v, {
						isSiteWideSearch: true,
						areMoodOrStyleTags: true
					});
				},
				getDatasetValues : function() {
					let values = createSafeObject();
					for (let dataset of trackData.datasets) {
						if (dataset.moods) {
							values[dataset.type] = dataset.moods;
						}
					}
					return values;
				},
			}));

			fields.push(new DetailsField({
				name : 'style',
				value : trackData.styles,
				getInputValue : function (v) {
					// if any of the values has a comma, we need to combine with semi-colons instead
					for (let vi = 0, len = v.length; vi < len; vi++) {
						if (v[vi].indexOf(',') !== -1) {
							return v.join('; ');
						}
					}
					return v.join(', ');
				},
				hasValue : function (v) {
					return v.length > 0;
				},
				getDisplayValue : function (v) {
					return formatTags(v, {
						isSiteWideSearch: true,
						areMoodOrStyleTags: true
					});
				},
				getDatasetValues : function() {
					let values = createSafeObject();
					for (let dataset of trackData.datasets) {
						if (dataset.styles) {
							values[dataset.type] = dataset.styles;
						}
					}
					return values;
				},
			}));

			fields.push(new DetailsField({
				name : 'style_of',
				value : trackData.style_of,
				getDatasetValues : function() {
					let values = createSafeObject();
					for (let dataset of trackData.datasets) {
						if (dataset.styleOf) {
							values[dataset.type] = dataset.styleOf;
						}
					}
					return values;
				},
			}));

			if (config.syncFlags.length > 0) {
				fields.push(new DetailsField({
					name : 'sync_flags',
					value : trackData.syncFlags || [],
					select : { list : config.syncFlags.map(val => { return { id : val, value : val }; }), multiple : true, saveWithoutObjects : true },
					hasValue : function (v) {
						return v.length > 0;
					},
					setValue : function(newValue) {
						console.log('set to', newValue);
					},
					getDisplayValue : function (v) {
						return v.join(', ');
					},
					getDisplayName : function() {
						return config.getDictionaryEntry('syncflag', true);
					}
				}));
			}

		}

		fields.push(new DetailsField({
			name : 'key',
			value : trackData.key,
			getDisplayValue : function(v) {
				return v.name;
			},
			getSelectValue : function(v) {
				return v['minorId'];
			},
			hasValue : function(v) {
				return v && v.id != 0;
			},
			getDatasetValues : function() {
				let values = createSafeObject();
				for (let dataset of trackData.datasets) {
					if (dataset.key && dataset.key.id) {
						values[dataset.type] = dataset.key.name;
					}
				}
				return values;
			},
			select : { list : 'key' }
		}));

		if (config.siteType !== 'drop') {

			fields.push(new DetailsField({
				name : 'has_vocal',
				value : trackData.has_vocal,
				getDisplayName : function() {
					return 'Has Vocals';
				},
				getDisplayValue : function (v) {
					return v == 2 ? '' : (v ? 'Yes' : 'No');
				},
				hasValue : function (v) {
					return v != 2;
				},
				getDatasetValues : function() {
					let values = createSafeObject();
					for (let dataset of trackData.datasets) {
						if (dataset.hasVocal !== null && dataset.hasVocal !== 2) {
							values[dataset.type] = dataset.hasVocal == 2 ? '' : (dataset.hasVocal ? 'Yes' : 'No');
						}
					}
					return values;
				},
				select : { list : 'binary' }
			}));

			fields.push(new DetailsField({
				name : 'explicit',
				value : trackData.explicit,
				getDisplayValue : function (v) {
					return v == 2 ? '' : (v == 1 ? 'Yes' : 'No');
				},
				hasValue : function (v) {
					return v != 2;
				},
				select : { list : 'binary' }
			}));

		}

		fields.push(new DetailsField({
			name : 'isrc',
			value : trackData.isrc,
			maxLength : 32
		}));

		if (config.siteType !== 'drop'){
			fields.push(new DetailsField({
				name : 'iswc',
				value : trackData.iswc,
				maxLength : 32
			}));

			// work numbers
			fields.push(new DetailsField({
				name : 'pro_work_numbers',
				value : trackData.workNumbers,
				/**
				 * @param {Array.<WorkNumber>} v
				 * @returns {string}
				 */
				getDisplayValue : function(v) {
					var workNumbers = '';
					for (var w = 0, wLen = v.length; w < wLen; w++) {
						var workNumberTemplate = templates.get('details_work_number');
						var workNumber = v[w];
						workNumberTemplate.find('.affiliation').html(workNumber.affiliation.name);
						workNumberTemplate.find('.number').html(workNumber.workNumber);
						workNumbers += workNumberTemplate[0].outerHTML;
					}
					return workNumbers;
				},
				setValue : function(newValue) {
					trackData.workNumbers = newValue;
				},
				hasValue : function(v) {
					return v.length > 0;
				},
				workNumbers : true
			}));

			fields.push(new DetailsField({
				name : 'keywords',
				value : trackData.keywords,
				maxLength : 65535,
				getDisplayValue : function(v) {
					var tags = detectTags(v, false, true);
					if (tags) {
						return tags;
					} else {
						return v;
					}
				},
				getDatasetValues : function() {
					let values = createSafeObject();
					for (let dataset of trackData.datasets) {
						if (dataset.keywords) {
							values[dataset.type] = dataset.keywords;
						}
					}
					return values;
				},
			}));

			fields.push(new DetailsField({
				name : 'instruments',
				value : trackData.instruments,
				maxLength : 65535,
				getDisplayValue : function(v) {
					var tags = detectTags(v, false, true);
					if (tags) {
						return tags;
					} else {
						return v;
					}
				}
			}));

			fields.push(new DetailsField({
				name : 'version',
				value : trackData.version,
				maxLength : 256
			}));

			fields.push(new DetailsField({
				name : 'external_id',
				value : trackData.externalId,
				maxLength : 32
			}));

			// custom fields
			if (editOn || user.hasAdminPermission(AdminPermission.Metadata)) {
				trackData.fullCustomFields.each(function () {
					var custom = this;
					var customValue = '';
					var customFieldIndex = -1;
					for (var cf = 0, cfLen = trackData.custom_fields.length; cf < cfLen; cf++) {
						if (trackData.custom_fields[cf].id == custom.id) {
							customValue = trackData.custom_fields[cf].value;
							customFieldIndex = cf;
							break;
						}
					}
					fields.push(new DetailsField({
						name : 'custom_' + custom.id,
						value : customValue,
						hiddenCustomField : custom.hidden,
						maxLength : 65535,
						getDisplayName : function () {
							return custom.name;
						},
						setValue : function (newValue) {
							if (customFieldIndex != -1) {
								trackData.custom_fields[customFieldIndex].value = newValue;
							} else {
								trackData.custom_fields.push({
									id : custom.id,
									name : custom.name,
									value : newValue,
									hidden : 0
								});
							}
						},
						getDisplayValue : function (v) {
							var tags = detectTags(v, false, true);
							if (tags) {
								return tags;
							} else {
								// convert all URLs to links
								return $j('<span>' + v + '</span>').linkify({
									target : function(href) {
										// if they are linking internally, don't open a new tab
										if (href.indexOf('https://' + config.domain + '/') === 0) {
											return null;
										}
										return '_blank';
									}
								}).html();
							}
						}
					}));
				});
			} else if (trackData.custom_fields) {
				trackData.custom_fields.sort(function (a, b) {
					return a.name.localeCompare(b.name);
				});
				trackData.custom_fields.each(function () {
					var custom = this;
					if (!custom.hidden) {
						fields.push(new DetailsField({
							name : 'custom_' + custom.id,
							value : custom.value,
							maxLength : 65535,
							getDisplayName : function () {
								return custom.name;
							},
							getDisplayValue : function (v) {
								var tags = detectTags(v, false, true);
								if (tags) {
									return tags;
								} else {
									// convert all URLs to links
									return $j('<span>' + v + '</span>').linkify({
										target : function(href) {
											// if they are linking internally, don't open a new tab
											if (href.indexOf('https://' + config.domain + '/') === 0) {
												return null;
											}
											return '_blank';
										}
									}).html();
								}
							}
						}));
					}
				});
			}
		}

		// show the track id
		fields.push(new DetailsField({
			name : 'sourceaudio_id',
			value : trackData.id,
			getDisplayName : function() {
				return 'Track ID';
			},
			editable : false
		}));

		// the wide fields
		fields.push(new DetailsField({
			name : 'description',
			value : trackData.description,
			maxLength : 65535,
			wide : true,
			getDisplayValue : function(v) {
				var tags = detectTags(v, false, true);
				if (tags) {
					return tags;
				} else {
					return v;
				}
			}
		}));

		fields.push(new DetailsField({
			name : 'lyrics',
			value : trackData.lyrics,
			maxLength : 4294967295,
			wide : true
		}));

		return fields;
	}

	function actualValueToInputValue(actualValue) {
		return actualValue
			.replace(/&quot;/g, '"')
			.replace(/&lt;/g, '<')
			.replace(/&gt;/g, '>')
			.replace(/<br\/>/g, '\n');
	}

	function inputValueToActualValue(inputValue) {
		var actualValue = inputValue
			.replace(/"/g, '&quot;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/\n/g, '<br/>');
		// at least in chrome, if the inner html of the element ends with a <br/>, the last line break is ignored.
		// need to pad with something to make the line break real
		var trimmedActualValue = actualValue.trim();
		if (trimmedActualValue.lastIndexOf('<br/>') == trimmedActualValue.length - 5) {
			actualValue += 'a'; // no one can see the value so it doesn't matter what it is
		}
		if (!actualValue.length) {
			actualValue = '&nbsp;'; // if the value is empty, we need to put something in there so the element has a height
		}
		return actualValue;
	}

	function formatTags(tags, options = {}) {
		const tagElements = [];
		let joinOn = ', '; // if any of the tags has a comma in it, we need to join on semicolons instead

		for (let m = 0, mLen = tags.length; m < mLen; m++) {
			let tag = options?.areMoodOrStyleTags ? StringSanitize.ifEncodedDecode(tags[m]) : tags[m];
			const originalTag = tag;

			tag = searchTermTagFormatter(tag);

			const tagElement = templates.get('tag');
			const searchQuery = 's=' + encodeURIComponent(tag);

			// Reset Tag to original value
			tag = originalTag;

			tagElement.attr('href', getExplorerLink(searchQuery, options.isSiteWideSearch));
			tagElement.attr('title', 'Shift-Click to add this term to your search bar.');
			tagElement.attr('data-search_tag', tag.trim().replace(/'/g, '&apos;'));
			tagElement.html(StringSanitize.encodeIfNotEncoded(tag));

			tagElements.push(tagElement[0].outerHTML);
			if (tag.indexOf(',') !== -1) {
				joinOn = '; ';
			}
		}
		return tagElements.join(joinOn);
	}

	function formatRelationalField(fieldData, linkFunction, searchPrefix) {
		var elements = [];
		for (var f = 0, fLen = fieldData.length; f < fLen; f++) {
			var field = fieldData[f];
			if (field.id && field.name && field.name != 'Unassigned' && field.name != 'Unspecified' && field.name != 'Unknown') {
				var element = templates.get('tag');
				element.attr('href', linkFunction(field.id));
				let tagSearch = field.name.replace("'", "\\\'");
				if (searchPrefix) tagSearch = searchPrefix + ':"' + field.name.replace(/"/g, '') + '"';
				element.attr('title', 'Shift-Click to add this term to your search bar.');
				//element.attr('onclick', 'sa.search.searchTagHandler(event, \'' + tagSearch.replace(/'/g, '&apos;') + '\');');
				element.data('search_tag', tagSearch.trim().replace(/'/g, '&apos;'));
				//element.on('click', e => { sa.search.searchTagHandler(e, tagSearch); });
				element.html(field.name);
				elements.push(element[0].outerHTML);
			}
		}
		return elements.join(', ');
	}

	function getRelationalFieldValue(fieldData) {
		var elements = [];
		for (var f = 0, fLen = fieldData.length; f < fLen; f++) {
			var field = fieldData[f];
			if (field.id && field.name && field.name != 'Unassigned' && field.name != 'Unspecified' && field.name != 'Unknown') {
				elements.push(field.name);
			}
		}
		return elements.join(', ');
	}

	function addTrackDataContainer() {
		const container = $j('#information_container');
		let dividedFieldContainer;
		const fieldRowTemplate = templates.get('information_field_row');
		const fieldTemplate = templates.get('information_field');
		const fieldLinkTemplate = templates.get('information_field_link');
		const fieldWideTemplate = templates.get('information_field_wide');
		const fieldDividerTemplate = templates.get('information_field_divider');
		const hiddenFieldNotice = templates.get('hidden_field_notice');
		const deprecatedFieldNotice = templates.get('deprecated_field_notice');
		const datasetTemplate = templates.get('information_field_dataset');
		let fieldsInRow = 0;
		let maxFieldsInRow = 2;
		let fieldRow;
		const adminUser = user.hasAdminPermission(AdminPermission.Metadata);

		container.empty().append(templates.get('information_container').html());
		dividedFieldContainer = container.find('.divided_field_container');

		// build a field list to display. start with basic fields
		var fields = getFields();

		// add all the fields to the page
		/** @var {DetailsField} field */
		fields.each(function(i, field) {
			var template;
			const datasetValues = field.getDatasetValues();
			const hasDatasetValues = Object.keys(datasetValues).length > 0;

			if (!editOn && !field.hasValue(field.value) && !hasDatasetValues) return;

			var fieldVisible = isFieldVisible(field.name, field.hiddenCustomField);
			if (!adminUser && (!fieldVisible && (!hasDatasetValues || !isFieldVisible('ai ' + field.name)))) return;

			if (field.link && !disableLinksAndSharing) {
				template = fieldLinkTemplate.clone();
			} else if (field.wide) {
				template = fieldWideTemplate.clone();
			} else {
				template = fieldTemplate.clone();
			}

			if (!fieldVisible && adminUser) {
				template.addClass('hidden_field');
				template.append(hiddenFieldNotice.clone());
			}

			if (field.deprecated && adminUser) {
				template.addClass('deprecated_field');
				template.append(deprecatedFieldNotice.clone());
			}

			setFieldData(field, template);

			if (hasDatasetValues && config.showAIMetadata) {
				for (let datasetType in datasetValues) {
					if (datasetValues.hasOwnProperty(datasetType)) {
						const fieldDatasetTemplate = datasetTemplate.clone();
						let fieldDatasetValue = datasetValues[datasetType];
						// this commented out block lets you set alternate text for the dataset value if it's the same as the field's value
						// if (datasetType === 'amg' && field.value == fieldDatasetValue) {
						// 	fieldDatasetValue = 'Confirmed';
						// }
						fieldDatasetTemplate.addClass('dataset_' + datasetType);
						fieldDatasetTemplate.find('.dataset_container_value .actual_value').text($j('<div>' + fieldDatasetValue + '</div>').text());
						if (datasetType.indexOf('amg_v') === 0) {
							fieldDatasetTemplate.find('.dataset_container_type').addClass('fa-light fa-microchip-ai');
						}
						template.append(fieldDatasetTemplate);

						if (editOn) {
							const fieldValueContainer = template.find('.value');
							if (!fieldValueContainer[0].childNodes.length) {
								fieldValueContainer.append('&nbsp;');
							}
							// if we're editing, the input box is set to the container's height but if we've added a dataset to the container, we want that to stay visible
							// while editing so we have to adjust the input box's height accordingly.
							// we need to offset by the dataset's height but we can't do that until it's added to the page so we use a mutation observer to detect that event
							const obs = new MutationObserver((mutationList, observer) => {
								if (document.contains(fieldDatasetTemplate[0])) {
									observer.disconnect();
									adjustEditingBoxForDatasetContainer(template, fieldDatasetTemplate);
								}
							});
							obs.observe(document, { childList: true, subtree: true });
							// template.find('.value_edit_container').css({
							// 	bottom: (fieldDatasetTemplate.height() + 20 + 11) + 'px'
							// });
							setTimeout(() => { obs.disconnect(); }, 1000); // if it's never added, stop observing
						}
					}
				}
				if (!editOn && !field.hasValue(field.value)) {
					template.addClass('only_dataset_value');
				}
			}

			// add the field to the page
			if (field.wide) {

				if (fieldRow) {
					fieldRow.append(fieldDividerTemplate.clone());
					dividedFieldContainer.append(fieldRow);
				}

				fieldRow = fieldRowTemplate.clone();

				fieldRow.append(template);
				fieldRow.append(fieldDividerTemplate.clone());

				container.append(fieldRow);

				fieldsInRow = 0;
				fieldRow = null;

			} else {

				if (!fieldsInRow) {
					fieldRow = fieldRowTemplate.clone();
				}

				fieldRow.append(template);
				fieldsInRow++;

				if (fieldsInRow == maxFieldsInRow) {
					fieldRow.append(fieldDividerTemplate.clone());
					dividedFieldContainer.append(fieldRow);
					fieldsInRow = 0;
					fieldRow = null;
				}

			}
		});

		if (fieldRow) {
			fieldRow.append(fieldDividerTemplate.clone());
			dividedFieldContainer.append(fieldRow);
		}

		// writers and publishers
		showInterestedParties(container);

		if (lockdown) {
			container.find('a').off('click').on('click', function() {
				sa.showLockdownMessage();
				return false;
			});
		}
	}

	/**
	 * @param {DetailsField} field
	 * @param {JQuery} container
	 */
	function setFieldData(field, container) {

		if (field.link) {
			container.find('.value').attr('href', field.getLink());
		}

		let displayValue = field.getDisplayValue();
		let textDisplayValue = $j('<div>' + displayValue + '</div>').text();
		if (disableLinksAndSharing) {
			displayValue = StringSanitize.encodeIfNotEncoded(textDisplayValue);
		}
		container.find('.value').html(displayValue).prop('title', textDisplayValue);
		container.find('.field_name').html(field.getDisplayName() + ':').attr('title', field.getDisplayName());
		container.attr('id', field.name);
		sa.search.addSearchTagListeners(container);

		if (field.editable) {
			enableEditing(field, container);
		}

	}

	/**
	 * @param {DetailsField} field
	 * @param {JQuery} container
	 */
	function enableEditing(field, container) {
		if (!editOn) return;

		if (field.select) {
			enableSelectEditing(field, container);
		} else if (field.workNumbers) {
			enableWorkNumberEditing(field, container);
		} else {
			enableInputEditing(field, container);
		}

		const datasetContainer = container.find('.dataset_container');
		if (datasetContainer.length) {
			adjustEditingBoxForDatasetContainer(container, datasetContainer);
		}

	}

	function adjustEditingBoxForDatasetContainer(fieldContainer, datasetContainer) {
		// the offset is the dataset's height plus some padding (41) plus the distance from the bottom of the dataset to the bottom of the container (only necessary if you're in a shorter details page grid cell next to a taller one)
		fieldContainer.find('.value_edit_container').css({
			bottom: (datasetContainer.height() + 41 + (fieldContainer.height() - datasetContainer.position().top - datasetContainer.outerHeight())) + 'px'
		});
	}

	/**
	 * @param {DetailsField} field
	 * @param {JQuery} container
	 */
	function enableInputEditing(field, container) {

		var editContainer = templates.get('information_field_editing' + (field.inputType ? '_' + field.inputType : ''));
		var editBox = editContainer.find('.value_edit');
		var fieldValueContainer = container.find('.value');
		var originalValue = fieldValueContainer.html();
		var fieldValue = field.getInputValue();
		var maxLengthTimeout;

		container.find('.value_edit_container').remove();
		container.off('.editing');
		editBox.off('.editing');
		container.removeClass('changed');

		// have to swap back and forth values to account for encoding &quot; vs ", etc.
		fieldValue = actualValueToInputValue(fieldValue ? fieldValue.toString() : '');

		if (field.maxLength) {
			editContainer.find('.max_length').html(field.maxLength.numberFormat());
			editBox.on('input.editing', function() {
				var newValue = this.value;
				if (newValue.length > field.maxLength) {
					this.value = newValue.substring(0, field.maxLength);
					container.addClass('blocking_max_length');
					if (maxLengthTimeout) {
						clearTimeout(maxLengthTimeout);
					}
					maxLengthTimeout = setTimeout(function() {
						container.removeClass('blocking_max_length');
						maxLengthTimeout = null;
					}, 1000);
				}
			});
		}

		editBox.val(fieldValue);

		// some event handling to make sure the box doesn't disappear if you're editing it
		container.on('mouseenter.editing', function() {
			if (!$j('.input_editable_field.focused').length) {
				editBox.trigger('focus');
			}
		});
		editBox.on('click.editing', function() {
			$j('.input_editable_field.focused').removeClass('focused');
			container.addClass('focused');
		});
		function updateChanged() {
			var newValue = editBox.val();
			if (newValue != fieldValue) {
				container.addClass('changed');
				fieldValueContainer.html(inputValueToActualValue(newValue));
			} else {
				container.removeClass('changed');
				fieldValueContainer.html(originalValue);
			}
		}
		container.on('mouseleave.editing', updateChanged);
		editBox.on('keyup', updateChanged);
		if (field.inputType == 'date') {
			editBox.on('change', updateChanged);
		}

		// saving
		editContainer.find('.save_button').on('click', function() {
			var newValue = editBox.val();
			if (newValue == fieldValue) return;
			saveField(field, newValue, container);
			container.removeClass('focused');
		});

		// account for dataset height
		// const datasetContainer = container.find('.dataset_container');
		// if (datasetContainer.length) {
		// 	editContainer.css({
		// 		bottom: (datasetContainer.height() + 20 + 11) + 'px'
		// 	});
		// }

		container.addClass('input_editable_field');
		container.append(editContainer);
	}

	/**
	 * @param {DetailsField} field
	 * @param {JQuery} container
	 */
	function enableSelectEditing(field, container) {

		var options = field.select;
		var selectContainer = templates.get('information_field_select');
		var select = selectContainer.find('select');
		var fieldValueContainer = container.find('.value');
		var newValues = createSafeObject();
		var newValueIndex = 0;
		var currentValue = field.getSelectValue();
		var currentDisplayValue = field.getDisplayValue();

		container.find('.value_edit_container').remove();
		container.removeClass('changed');

		var selectizeOptions = {
			delimiter : '\n',
			placeholder : 'Click to add a value to this field',
			labelField : 'value',
			searchField : 'value',
			sortField : 'value',
			valueField : 'id',
			onChange : function(newValue) {
				var changed = false;
				if (options.multiple) {
					if (!newValue || !newValue.isArray) {
						newValue = [];
					}
					if (newValue.length != currentValue.length) {
						changed = true;
					} else {
						currentValue.each(function() {
							if (newValue.indexOf(this.id) === -1) {
								changed = true;
							}
						});
					}
					if (changed) {
						var valueObjects = [];
						newValue.each(function() {
							valueObjects.push({ id : this, name : selectContainer.find('div[data-value="' + this + '"]').html() });
						});
						fieldValueContainer.html(getRelationalFieldValue(valueObjects));
					}
				} else if (newValue !== currentValue) {
					changed = true;
					if (field.cwrField) {
						field.getDisplayValue(newValue);
					} else {
						if (newValue) {
							fieldValueContainer.html(selectContainer.find('div[data-value="' + newValue + '"]').html());
						} else {
							fieldValueContainer.html("");
						}
					}
				}
				if (changed) {
					container.addClass('changed');
				} else {
					container.removeClass('changed');
					fieldValueContainer.html(currentDisplayValue);
					sa.search.addSearchTagListeners(fieldValueContainer);
				}
			}
		};

		// binary option lists like explicit and has_vocal have a predetermined set of values
		if (options.list == 'binary') {
			selectizeOptions.options = [];
			if (!options.hideUnspecified) {
				selectizeOptions.options.push({ id : 2, value : 'Unspecified' });
			}
			selectizeOptions.options.push({ id : 1, value : 'Yes' });
			selectizeOptions.options.push({ id : 0, value : 'No' });
		} else if (options.list.isArray) {
			selectizeOptions.options = options.list;
		} else {
			// other lists load from the server
			selectizeOptions.load = function (query, callback) {
				if (!query.length) return callback([]);
				ajax({ p : 'list', type : options.list, ids : 1, part : query, excludeSyncs : 1 }, function (response) {
					var items = [];
					if (response && response.length && response[0].items) {
						response[0].items.each(function() {
							items.push({ id : this.id, value : this.value.replace(/&quot;/g, '"') });
						});
					}
					callback(items);
				});
			};
		}

		// if they can enter new values, we cache them locally
		if (options.allowNew) {
			selectizeOptions.create = function(input) {
				newValueIndex--;
				newValues[newValueIndex] = input;
				return { id : newValueIndex, value : input };
			};
		}

		if (options.multiple) {
			select.attr('multiple', 'multiple');
			var valueTemplate = select.find('.initial_value').clone();
			select.find('.initial_value').remove();
			currentValue.each(function() {
				var val = valueTemplate.clone();
				val.attr('value', this['id']).html(this['name']);
				select.append(val);
			});
		} else if ((options.list == 'binary' || currentValue != 0) && currentDisplayValue != '') {
			select.find('.initial_value').attr('value', currentValue).html(currentDisplayValue);
		}

		select.selectize(selectizeOptions);

		// saving
		selectContainer.find('.save_button').on('click', function() {
			var selectVal = select.val();
			var newValue;
			if (options.multiple) {
				newValue = [];
				if (selectVal && selectVal.isArray) {
					selectVal.each(function () {
						var singleVal = this;
						if (singleVal < 0) {
							newValue.push(options.saveWithoutObjects ? newValues[singleVal] : { name : newValues[singleVal] });
						} else {
							newValue.push(options.saveWithoutObjects ? singleVal : { id : singleVal });
						}
					});
				}
			} else {
				if (selectVal < 0) {
					newValue = options.saveWithoutObjects ? newValues[selectVal] : { name : newValues[selectVal] };
				} else {
					newValue = options.saveWithoutObjects ? selectVal : { id : selectVal };
				}
				if (options.multiple) {
					newValue = [ newValue ];
				}
			}
			saveField(field, newValue, container);
		});

		container.addClass('select_editable_field');
		container.append(selectContainer);
	}

	page.showWorkNumberEditor = function(values, callback) {
		var field = new DetailsField({
			name : 'pro_work_numbers',
			value : values,
			/**
			 * @param {Array.<WorkNumber>} v
			 * @returns {string}
			 */
			getDisplayValue : function(v) {
				var workNumbers = '';
				for (var w = 0, wLen = v.length; w < wLen; w++) {
					var workNumberTemplate = templates.get('details_work_number');
					var workNumber = v[w];
					workNumberTemplate.find('.affiliation').html(workNumber.affiliation.name);
					workNumberTemplate.find('.number').html(workNumber.workNumber);
					workNumbers += workNumberTemplate[0].outerHTML;
				}
				return workNumbers;
			},
			saveField : function(newValue) {
				callback(newValue);
			},
			workNumbers : true
		});

		initializeTemplates();

		var fieldContainer = $j('<div></div>');
		enableWorkNumberEditing(field, fieldContainer);
		fieldContainer.find('.work_number_edit_button').trigger('click');
	};

	/**
	 * Editing work numbers is too complicated to cram into the page. We show it in an overlay instead
	 * @param {DetailsField} field
	 * @param {JQuery} container
	 */
	function enableWorkNumberEditing(field, container) {
		var button = templates.get('information_field_work_numbers');

		container.find('.work_number_edit_button').remove();

		button.on('mouseenter', function() {
			loadPersonListFields(function() {});
		});

		button.on('click', function() {

			var editingContainer = templates.get('work_number_editing');
			var workNumberRow = editingContainer.find('.work_number_row').detach();
			var workNumberRowContainer = editingContainer.find('.work_numbers');
			var headerRow = editingContainer.find('tbody:first');
			var fb;

			function showHideHeader() {
				if (!workNumberRowContainer[0].childNodes.length) {
					headerRow.hide();
				} else {
					headerRow.show();
				}
			}

			/**
			 * @param {WorkNumber=} values
			 */
			function addWorkNumber(values) {
				var row = workNumberRow.clone();
				var proSelect = row.find('.pwn_pro');

				loadPersonListFields(function(listFields) {
					if (values) {
						proSelect.html('<option value="' + values.affiliationId + '">' + values.affiliation.name + '</option>');
					}
					proSelect.selectize({
						placeholder : 'Required',
						labelField : 'name',
						searchField : 'name',
						sortField : 'name',
						valueField : 'id',
						options : listFields['affiliations']
					});
				});

				if (values) {
					row.find('.pwn_number').val(values.workNumber);
					if (values.registrationDate != 0) {
						row.find('.pwn_date').val(formatDate('Y-m-d', values.registrationDate, true));
					}
				}

				row.find('.remove_work_number').on('click', function() {
					row.remove();
					showHideHeader();
				});

				workNumberRowContainer.append(row);
			}

			field.value.each(function() {
				addWorkNumber(this);
			});

			showHideHeader();

			editingContainer.find('.add_new').on('click', function() {
				addWorkNumber();
				showHideHeader();
			});

			editingContainer.find('.save').on('click', function() {
				var values = sa.forms.validate(editingContainer).values;
				saveField(field, values, container);
				fb.hide();
			});

			fb = new FocusBox(editingContainer);
			fb.show();

		});

		container.append(button);
	}

	function isFieldVisible(fieldName, hiddenCustomField) {
		if (editOn && user.hasAdminPermission(AdminPermission.Metadata)) return true;
		if (hiddenCustomField !== undefined && hiddenCustomField !== null) {
			return !hiddenCustomField;
		}
		if (fieldName == 'has_vocal') {
			fieldName = 'has vocals'; // after the redesign is live, feel free to fix this permanently
		}
		return config.hiddenFields.indexOf(fieldName) == -1 && config.hiddenFields.indexOf(fieldName.replace(/_/g, ' ')) == -1;
	}

	function applyExtraFormatClass(element, type) {
		if (type == 'aif') type = 'aiff';
		if (type == 'mp3' || type == 'aiff' || type == 'wav') {
			return element;
		} else if (type == 'xls' || type == 'xlsx' || type == 'csv') {
			element.find('.image').addClass('fa fa-file-excel-o');
		} else if (type == 'pdf') {
			element.find('.image').addClass('fa fa-file-pdf-o');
		} else if (type == 'doc' || type == 'docx') {
			element.find('.image').addClass('fa fa-file-word-o');
		} else if (type == 'txt') {
			element.find('.image').addClass('fa fa-file-text-o');
		} else if (type == 'zip') {
			element.find('.image').addClass('fa fa-file-zip-o');
		} else if (type == 'transcode') {
			element.find('.image').addClass('fa fa-arrow-right-arrow-left');
		} else {
			element.find('.image').addClass('fa fa-file-o');
		}
		return element;
	}

	function addDownloadButtons(container) {
		var formatList = container.find('#format_container .list');
		var nestedFormatList = container.find('#nested_format_container .list');
		var basicFormats = [ 'mp3' , 'aiff', 'wav' ];

		function getExtraFormatTemplate(templateBase, type, vars) {
			return applyExtraFormatClass(templates.get(templateBase, vars), type);
		}

		if (!trackData.can_download || sa.disableDownloading) {

			basicFormats.each(function () {
				if (trackData.formats[this]) {
					formatList.append(templates.get('format_no_dl', {
						type : this,
						size : sizeFormat(trackData.formats[this])
					}));
				}
			});
			trackData.formats.extras.each(function () {
				formatList.append(getExtraFormatTemplate('format_no_dl_extra', this['extension'], {
					type : (this['extension'] == 'aif' ? 'aiff' : this['extension']),
					extraType : this.type,
					size : sizeFormat(this.size)
				}));
			});

			if (sa.disableDownloading) {
				formatList.find('.non_download').on('click', function() {
					sa.alert({ text : 'Downloading this file type is disabled by administrators.' });
				});
			} else if (config.licensing.coupons) { // let's give them the ability to use credit here
				formatList.find('.non_download').on('click', function () {
					var typeA = $j(this).attr('id').split('_');
					var type = typeA[1];
					console.log('click of nondl/credit with type:', type);

					var box = new DownloadCreditConfirm(trackData, type);
					box.afterSuccess = function () {
						$j('.non_download').off();
					};
					box.show();
				});
			} else if (config.licensingConfig.show && !config.licensingConfig.options.allowRequests && (config.licensingConfig.coupons_active || config.licensingConfig.subscriptions_active)) {
				licensingModal.getProfile( trackData, function(profile) {
					if (profile.oneprice) {
						formatList.find('.non_download').on('click', function() {
							var typeA = $j(this).attr('id').split('_');
							var type = typeA[1];
							console.log('click of nondl/credit with type:', trackData, type);

							AutoCreditPurchase.attempt(trackData, type, profile, function() {
								//formatList.find('.non_download').off();
							});
						});


					}
				});
			} else {
				formatList.find('.non_download').on('click', function() {
					sa.components.downloader.show({ type : 'track', item : trackData, format : this.dataset.format, nested : false });
					//sa.alert({ text : 'You do not have permission to download this file' });
				});
			}

		} else {

			basicFormats.each(function () {
				if (trackData.formats[this] && config.downloadFormats[this]) {
					formatList.append(templates.get(trackData.formats['disable' + this['ucfirst']()] ? 'format_temporary_no_dl' : 'format_dl', {
						type : this,
						size : sizeFormat(trackData.formats[this]),
						link : siteBaseUrl() + '/download.php?track_id=' + trackId + '&type=' + this + '&source=details'
					}));
				}
			});
			trackData.formats.extras.each(function () {
				formatList.append(getExtraFormatTemplate('format_dl_extra', this['extension'], {
					type : (this['extension'] == 'aif' ? 'aiff' : this['extension']),
					extraType : this.type,
					size : sizeFormat(this.size),
					link : siteBaseUrl() + '/download.php?&' + 'track_id=' + trackId + '&type=extra&extraType=' + encodeURIComponent(this.type) + '&source=details'
				}));
			});

			if (Object.keys(trackData.alternateDownloadFormats).length) {
				// The file count includes the master file, but this number is being used to show the number of alternates, so we subtract one
				let fileCount = Number(trackData.alternateDownloadFormats[Object.keys(trackData.alternateDownloadFormats)[0]].files);
				if (fileCount > 1) {
					fileCount = fileCount - 1;
				}
				container.find('.nested_track_count').html(fileCount);
				basicFormats.each(function () {
					if (trackData.alternateDownloadFormats[this] && config.downloadFormats[this]) {
						nestedFormatList.append(templates.get(trackData.alternateDownloadFormats['disable' + this['ucfirst']()] ? 'format_temporary_no_dl' : 'format_dl', {
							type : this,
							size : sizeFormat(trackData.alternateDownloadFormats[this].size),
							link : siteBaseUrl() + '/download.php?track_id=' + trackId + '&type=' + this + '&source=details&includeNested=1'
						}));
					}
				});
			}

			if (config.showUserTrackDLIndicator) {
				formatList.add(nestedFormatList).find('.download_button').on('click', function () {
					trackBank.updateAll(trackId, 'userDownloaded', 1);
					trackBank.updateAll(trackId, 'userLastDLdate', Math.floor(new Date().getTime() / 1000));
					trackData.userLastDLdate = Math.floor(new Date().getTime() / 1000);
					addUserTrackLastDLdate(container);
				});
			}

		}

		if (!formatList[0].childNodes.length) {
			container.find('#format_container').remove();
		}
		if (!nestedFormatList[0].childNodes.length) {
			container.find('#nested_format_container').remove();
		}

		enableFormatEditing(container);

	}

	function enableFormatEditing(container) {

		if (!editOn) {
			container.find('#edit_downloads').remove();
			return;
		}

		container.find('#edit_downloads').off('click').on('click', function() {

			var editingContainer = templates.get('download_format_editing');
			var downloadFormatContainer = editingContainer.find('.download_format_container');
			var formatContainer = editingContainer.find('.formats');
			var basicFormatTemplate = editingContainer.find('.basic_format_row').detach();
			var extraFormatTemplate = editingContainer.find('.extra_format_row').detach();
			var basicFormats = [ 'mp3' , 'aiff', 'wav' ];
			var fb;

			function showProgressBar(formatElement, text, autoHide) {
				var progressBarContainer = templates.get('upload_progress_bar');
				progressBarContainer.find('.current_progress').html(text).css({ width : '100%' });
				progressBarContainer.css({ top : formatElement.position().top + downloadFormatContainer.position().top + parseInt(downloadFormatContainer.css('marginTop')) + editingContainer[0].scrollTop });
				progressBarContainer.addClass('hiding');
				editingContainer.append(progressBarContainer);
				setTimeout(function() {
					progressBarContainer.removeClass('hiding');
				}, 100);
				if (autoHide) {
					setTimeout(function () {
						progressBarContainer.addClass('hiding');
					}, 1600);
					setTimeout(function () {
						progressBarContainer.remove();
					}, 1750);
				}
				return progressBarContainer;
			}

			// iterate over formats and add as necessary. add basics regardless. image, name, size
			function getBasicFormatElement(format) {
				var formatElement = basicFormatTemplate.clone();
				var transcodeButton = formatElement.find('.transcode_button');
				var downloadSelect = formatElement.find('.download_options');

				format = format.toString(); // after compression, this being a String object instead of a string primitive throws jquery errors
				formatElement.addClass('download_' + format);
				formatElement.find('.format_name').html(format);

				if (trackData.formats[format]) {
					formatElement.find('.format_size').html(sizeFormat(trackData.formats[format]));

					if (trackData.metadataEmbedderProfiles && trackData.metadataEmbedderProfiles.length > 1) {
						var insertBefore = downloadSelect.find('option[value=no_metadata]');
						trackData.metadataEmbedderProfiles.each(function() {
							var profileId = this['id'];
							if (profileId == 0) return;
							insertBefore.before('<option value="with_metadata_' + profileId + '">Download with the ' + this['name'] + ' metadata embedding profile</option>');
						});
					}

					formatElement.find('.format_download_button').on('click', function() {
						var downloadOption = downloadSelect.val();
						var path = siteBaseUrl() + '/download.php?&' + 'track_id=' + trackId + '&type=' + format + '&source=details';
						if (downloadOption == 'with_metadata') {
							path += '&injected=1';
						} else if (downloadOption == 'no_metadata') {
							path += '&injected=0';
						} else if (downloadOption == 'no_watermark') {
							path += '&watermarked=0';
						} else {
							var profileId = parseInt(downloadOption.substring(14));
							if (!isNaN(profileId)) {
								path += '&metadataEmbedderProfile=' + profileId;
							}
						}
						document.location.href = path;
					});
					if (!trackData.watermarked) {
						formatElement.find('option[value=no_watermark]').remove();
					}

					applyExtraFormatClass(formatElement, format);
					transcodeButton.hide();

					formatElement.find('.remove_item').on('click', function() {
						sa.confirm({
							text : 'Are you sure you want to delete this file?<br/><br/><b>This action is permanent and NOT undoable.</b>',
							yesFunction : function () {

								var progressBarContainer = showProgressBar(formatElement, 'Deleting...', false);

								ajax({ deleteFormat : format }, function (response) {
									progressBarContainer.remove();
									if (response[0].result == 'success') {
										trackData.formats[format] = null;
										formatElement.after(getBasicFormatElement(format));
										formatElement.remove();
										addInteractionContainer();
									} else {
										sa.alert({ text : response[0].result });
									}
								}, 'POST', 'p=track_details&id=' + trackData.id);

							},
							yesText : 'Delete'
						});
					});
				} else {
					formatElement.find('.format_size').html('None');
					formatElement.find('.format_download_button, .download_options').hide();
					formatElement.find('.remove_item').hide();

					if (trackData.formats.transcodeFormats && trackData.formats.transcodeFormats.indexOf(format) != -1) {
						setTimeout(function() { // won't work right until formatElement is added
							showProgressBar(formatElement, 'Queued for transcode', false);
						}, 500);
						transcodeButton.remove();
					} else {
						transcodeButton.on('click', function () {
							transcodeButton.remove();

							sa.api.request({
								handler : 'transcode',
								action : 'transcode-track',
								postData : { trackId : trackId, outputFormat : format }
							}).catch(function(e) {
								sa.alert(e.message);
							}).then(function() {
								showProgressBar(formatElement, 'Queued for transcode!', false);
								trackData.formats.transcodeFormats.push(format);
							});
						});
					}
				}

				var uploaderConstant = UploaderConstants.MP3;
				if (format == 'aiff') {
					uploaderConstant = UploaderConstants.AIFF;
				} else if (format == 'wav') {
					uploaderConstant = UploaderConstants.WAV;
				}

				enableUploading(formatElement, format, uploaderConstant, function() {
					return 'format=' + format;
				});

				return formatElement;
			}

			basicFormats.each(function () {
				'use strict';
				formatContainer.append(getBasicFormatElement(this));
			});

			function getExtraFormatElement(data) {
				var formatElement = extraFormatTemplate.clone();
				var formatName = formatElement.find('.format_name');

				if (data) {
					formatElement.addClass('download_' + (data.extension == 'aif' ? 'aiff' : data.extension));
					formatName.val(data.type);
					formatElement.find('.format_size').html(sizeFormat(data.size));
					formatElement.find('.format_download_button').attr('href', siteBaseUrl() + '/download.php?track_id=' + trackId + '&type=extra&extraType=' + encodeURIComponent(data.type) + '&source=details');
					applyExtraFormatClass(formatElement, data.extension);

					formatName.on('keyup', function() {
						var newValue = formatName.val();
						if (newValue != data.type) {
							formatElement.addClass('changed');
						} else {
							formatElement.removeClass('changed');
						}
					});

					formatElement.find('.save_button').on('click', function() {
						var newValue = formatName.val().trim();
						if (newValue == data.type) {
							return;
						}
						if (newValue == '') {
							sa.alert({ text : 'Please enter a name or delete the file.' });
						} else {
							var progressBarContainer = showProgressBar(formatElement, 'Saving...', false);
							ajax({ updateExtraType : newValue, extraId : data.id }, function(response) {
								if (response[0].result == 'success') {
									data.type = newValue;
									trackData.formats.extras.each(function(index, extra) {
										if (extra.id == data.id) {
											trackData.formats.extras[index].type = newValue;
										}
									});
									addInteractionContainer();
									formatElement.removeClass('changed');
									progressBarContainer.find('.current_progress').html('Saved!');
									setTimeout(function() {
										progressBarContainer.addClass('hiding');
										setTimeout(function() {
											progressBarContainer.remove();
										}, 150);
									}, 1500);
								} else {
									progressBarContainer.remove();
									sa.alert({ text : response[0].result });
								}
							}, 'POST', { p : 'track_details', id : trackId })
						}
					});

					formatElement.find('.remove_item').on('click', function() {
						sa.confirm({
							text : 'Are you sure you want to delete this file?<br/><br/><b>This action is permanent and NOT undoable.</b>',
							yesFunction : function () {

								var progressBarContainer = showProgressBar(formatElement, 'Deleting...', false);

								ajax({ deleteFormat : 'extra', extraId : data.id }, function (response) {
									progressBarContainer.remove();
									if (response[0].result == 'success') {
										formatElement.remove();
										trackData.formats.extras.each(function(index, extra) {
											if (extra.id == data.id) {
												trackData.formats.extras.splice(index, 1);
											}
										});
										addInteractionContainer();
									} else {
										sa.alert({ text : response[0].result });
									}
								}, 'POST', { p : 'track_details', id : trackId });

							},
							yesText : 'Delete'
						});
					});
				} else {
					formatElement.find('.format_download_button').hide();
					formatElement.find('.remove_item').on('click', function() {
						formatElement.remove();
					});
				}

				enableUploading(formatElement, 'extra', UploaderConstants.ALL, function() {
					return 'format=extra&extraType=' + encodeURIComponent(formatName.val()) + (data ? '&extraId=' + data.id : '');
				});

				return formatElement;
			}

			// TODO you can delete additional formats and upload new ones (if type is set)

			trackData.formats.extras.each(function () {
				formatContainer.append(getExtraFormatElement(this));
			});

			// make upload buttons work
			function enableUploading(container, format, uploadFormat, getFormatString) {
				new Uploader({
					button : container.find('.upload_format'),
					browseCallback : function(uploader) {

						var formatString = getFormatString();

						var fileList = uploader.getFileDetails();
						if (!fileList.length) {
							return;
						}

						var progressBarContainer = showProgressBar(container, '', false);
						var progressBar = progressBarContainer.find('.current_progress').css({ width : 0 });
						var uploadComplete = false;

						uploader.upload({
							params : 't=track&attachType=track&attachTo=' + trackId + '&' + formatString,
							complete : function(e, response) {
								// with html5, the uploader can return json data and we can parse. i'm not sure that works with flash, hence the else block
								if (response) {
									response = JSON.parse(response);
									if (response['newExtra']) {
										var newExtra = response['newExtra'];
										if (newExtra.update) {
											trackData.formats.extras.each(function(i, extra) {
												if (extra.id == newExtra.id) {
													trackData.formats.extras[i] = newExtra;
												}
											});
										} else {
											trackData.formats.extras.push(newExtra);
										}
										container.after(getExtraFormatElement(newExtra));
									} else if (response['size']) {
										trackData.formats[response['format']] = response['size'];
										container.after(getBasicFormatElement(response['format']));
									} else if (response['message']) {
										sa.alert({ text : response['message'] });
										progressBarContainer.remove();
										return;
									} else {
										sa.alert({ text : 'Unable to process file. Please reload, check your file type, and try again.' });
										progressBarContainer.remove();
										return;
									}
									container.remove();
									addInteractionContainer();
									progressBarContainer.addClass('hiding');
									setTimeout(function() {
										progressBarContainer.remove();
									}, 150);
								} else {
									// set new format in trackData and update row
									ajax({ p : 'track_info', id : trackId }, function (response) {
										if (response.length < 2) {
											sa.router.routeTo('/');
											sa.alert({ text : 'Unable to load new format data. Has this track been deleted?' });
										} else {
											// is this an extra or a basic?
											if (format == 'extra') {
												// for an extra format, we need to figure out its data. have to search both lists for differences
												var newExtra;
												response[1].formats.extras.each(function () {
													var formatId = this['id'];
													var found = false;
													trackData.formats.extras.each(function () {
														if (formatId == this['id']) found = true;
													});
													if (!found) {
														newExtra = this;
													}
												});
												if (newExtra) {
													container.after(getExtraFormatElement(newExtra));
													container.remove();
												} else {
													sa.alert({ text : 'Unable to load new format data. Please reload and try again.' });
												}
											} else {
												container.after(getBasicFormatElement(format));
												container.remove();
											}
											trackData.formats = response[1].formats;
											addInteractionContainer();
										}
										progressBarContainer.addClass('hiding');
										setTimeout(function() {
											progressBarContainer.remove();
										}, 150);
									});
								}
							},
							progress : function(e, bytesLoaded, bytesTotal) {
								if (uploadComplete) return;

								var progressPercentage = Math.min(1, bytesLoaded / bytesTotal);
								progressBar.css({ width : (progressPercentage  * 100) + '%' });
								if (progressPercentage == 1) {
									uploadComplete = true;
									setTimeout(function() { progressBar.html('Processing...'); }, 500); // for the animation to complete
								}
							},
							error : function() {
								sa.alert({ text : 'Unable to upload file. Please check file permissions and type and try again later.' });
							},
							fileId : fileList[0].id,
							useImportIndex : true
						});

					},
					fileType : uploadFormat
				});
			}

			// metadata embedding profile editing link?
			editingContainer.find('.create_new').on('click', function() {
				var href = 'admin?p=metadata&tab=downloading';
				sa.confirm({
					text : 'Leaving this page will discard any unsaved changes. Are you sure?',
					yesFunction : function () {
						sa.router.routeTo(href);
					}
				});
				return false;
			});

			// add additional formats option
			editingContainer.find('.add_new').on('click', function() {
				formatContainer.append(getExtraFormatElement());
			});

			fb = new FocusBox(editingContainer);
			fb.show();

		});

	}

	function addDropButtons(container) {

		if (config.siteType !== 'drop') {
			container.find('#add_to_drop_container').remove();
			return;
		}

		container.find('#add_to_drop_container .list').append(sa.components.buttons.generateAddToDropButton({
			addClass: 'send_share_button',
			type: 'track',
			itemId : trackId,
			text : ''
		}));

	}

	function addSharingButtons(container) {

		if (disableLinksAndSharing) {
			container.find('#send_share_container').remove();
			return;
		}

		var shareList = container.find('#send_share_container .list');

		var encodedLink = encodeURIComponent('https://' + config.domain + '/link.php?page=track&trackId=' + trackData.id);
		var encodedTitle = encodeURIComponent(trackData.title);

		// email button
		shareList.append(sa.components.emailer.generateEmailButton({ type : 'track', item : trackData }).addClass('send_share_button'));

		// drop doesn't use most of these buttons
		if (config.siteType !== 'drop') {

			// embed button
			if (config.showEmbeds || user.hasAdminPermission(AdminPermission.Sharing)) {
				shareList.append(sa.components.embedder.generateEmbedButton({
					type : 'track',
					item : trackData
				}).addClass('send_share_button'));
			}

			// tweet button
			shareList.append(templates.get('twitter_button', { link : 'http://twitter.com/share?text=' + encodedTitle + '&url=' + encodedLink + '&via=sourceaudio' }));

			// facebook button
			shareList.append(templates.get('facebook_button', { link : 'https://www.facebook.com/sharer/sharer.php?u=' + encodedLink }));

			// linkedin button (for some reason)
			shareList.append(templates.get('linkedin_button', { link : 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodedLink + '&title=' + encodedTitle }));
		}

		if (!shareList[0].childNodes.length) {
			container.find('#send_share_container').remove();
		}
	}

	function addMcpsButton(container) {

		var mcpsContainer = container.find('#mcps_container');
		var showingMcps = false;

		if (config.siteType !== 'drop' && config.showMCPS) {
			var mcpsUrl = getMCPSUrl(trackData);
			if (mcpsUrl) {
				var mcpsButton = templates.get('mcps_license_now_button');
				mcpsButton.attr('href', mcpsUrl);
				mcpsContainer.append(mcpsButton);
				showingMcps = true;
			}
		}

		if (!showingMcps) {
			mcpsContainer.remove();
		}
	}

	function addSimiliarTracksButton(container) {
		// Render the button
		const similarTracksButtonContainer = container.find('#similar_tracks_button_container');
		const similarTracksButton = templates.get('similar_tracks_button', { link: siteBaseUrl() + '/sonicsearch?track_search=' + trackData.id });

		similarTracksButtonContainer.append(similarTracksButton);
	}

	function addSongbirdButton(container) {
		// If this isn't the right domain
		const isMusicHub = config.id === 7494;
		if (!isMusicHub) return;

		// Check if there is an email
		const email = user.userData?.email;
		if (!email) return;

		// Check if the track has the `grammy_track_id` field
		const grammyTrackId = trackData.custom_fields.find(field => field.name === 'grammy_track_id');
		if (!grammyTrackId) return;

		const isNetflixEmail = ['netflix.com', 'netflixanimation.com', 'netflixcontractors.com'].includes(email.split('@')[1]);

		if (!isNetflixEmail && !user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			return;
		}

		// Render the button
		const songbirdButtonContainer = container.find('#songbird_button_container');
		const songbirdButton = templates.get('netflix_songbird_button', { grammy_track_id: grammyTrackId.value });

		songbirdButtonContainer.append(songbirdButton);
	}

	function addLicenseButton(container) {

		var licenseButtonContainer = container.find('#license_button_container');
		let licenseNowText = config.id === 7494 ? 'Request License' : 'License Now'; // change for Netflix #4293

		// licensing buttons
		var licenseButton;
		if (config.siteType === 'drop' || !config.showLicensing) {

			licenseButtonContainer.remove();

		} else if (config.licensingConfig && config.licensingConfig.show) {

			licensingModal.getProfile( trackData, function(profile) {
				var trackassigned = profile.trackassigned;

				if (profile) {

					if (profile.oneprice && profile.oneprice == -1) { // -1 => contact us
						licenseButton = templates.get('license_now_button', { trackId : trackData.id, text : licenseNowText });
						if (config.licenseUrl) {
							licenseButton.attr({ href : decodeURIComponent(config.licenseUrl), target : '_blank' });
						} else {
							licenseButton.on('click', function () {
								showLicenseModal();
								return false;
							});
						}
						licenseButtonContainer.append(licenseButton);
					} else {
						var licenseTitle = profile.oneprice ? 'Buy Now' + (profile.oneprice < 0 ? '' : ': <span>' + profile.oneprice.currencyFormat( config.licensingConfig.currency ) + '</span>') : 'License This Track';

						licenseButtonContainer.append(templates.get('add_to_cart', { licenseTitle : licenseTitle }));
						licenseButtonContainer.find('.cart_title').remove();

						licenseButtonContainer.find('#add_to_cart').on('click',  function(e) {
							licensingModal.show( profile, trackData, e);
						});

						if (!(profile.oneprice && (config.licensingConfig.coupons_active || config.licensingConfig.subscriptions_active))) {
							$j('#format_container .non_download').on('click', function() {
								sa.alert({ text : 'You do not have a license for this track. Buy it!' });
							});
						}
					}
				}

				if (config.licensingConfig.options && config.licensingConfig.options.trackAssignment && user.hasAdminPermission(AdminPermission.Licensing)) {
					licenseButtonContainer.append('<div class="profile-select"><span>Profile: </span><select><option value="-2">' + (trackassigned ? 'Assigned' : 'Inherited') + ': ' + (profile ? profile.title : 'None') + '</option><option value="-1">None</option></select></div>');
					if (trackassigned) {
						licenseButtonContainer.find('select').append('<option value="0">Inherit</option>');
					}
					_.each(config.licensingConfig.profiles, function(p) {
						licenseButtonContainer.find('select').append('<option value="' + p.id + '">' + p.title + '</option>');
					});

					licenseButtonContainer.find('select').on('change', function() {
						var val = parseInt( $j(this).val() );
						console.log('- selected profile:', val);
						if (val == -2) return;

						licenseButtonContainer.find('.profile-select span').html( 'Profile: <i class="fa fa-refresh fa-spin"></i>' );

						sa.api.request({
							handler: 'licensing/licensingAdmin',
							action: 'setTrackProfile',
							getData: {
								track_id: trackData.id,
								profile: val
							}
						}).then(function (r) {
							licenseButtonContainer.find('.profile-select span').html('Profile: ');
							console.log('- set track profile response:', r);
						});
					});
				}

			});

		} else if (config.id == 162) { // m4p http://bugs.sourceaudio.com/show_bug.cgi?id=1094

			if (trackData.description.toLowerCase().indexOf('per quote') == -1) {
				licenseButtonContainer.append(templates.get('m4p_license_now').html());
				licenseButtonContainer.find('#m4p_add_to_new_project').on('click', function () {
					m4pAddToNewProject(trackData.id);
				});
				licenseButtonContainer.find('#m4p_add_to_existing_project').on('click', function () {
					m4pAddToExistingProject(trackData.id);
				});
			} else {
				licenseButtonContainer.append(templates.get('m4p_special_clearance_button', { trackId : trackId }));
			}

		} else if (config.siteType != 'radio' && !(config.licensing.show || (config.id == 49 || config.id == 118 || config.id == 225 || config.id == 104))) { // bb & p&p Bugzilla:1079 also spot me and absolute imaging Bugzilla:1082

			licenseButton = templates.get('license_now_button', { trackId : trackData.id, text : licenseNowText });
			if (config.licenseUrl) {
				licenseButton.attr({ href : decodeURIComponent(config.licenseUrl), target : '_blank' });
			} else {
				licenseButton.on('click', function (e) {
					e.preventDefault();
					showLicenseModal();
					return false;
				});
			}
			licenseButtonContainer.append(licenseButton);

		} else {

			licenseButtonContainer.remove();

		}

	}

	function addUserTrackLastDLdate(container) {
		$j('#user_track_last_dl_container').empty();
		var userTrackLastDLdateContainer = container.find('#user_track_last_dl_container');

		if (config.showUserTrackDLIndicator && trackData.userLastDLdate) {
			var lastDlDate = formatDate(config.dateTimeFormatString, trackData.userLastDLdate);
			if ($j('#user_track_last_dl_date').length) {
				$j('#user_track_last_dl_container').empty()
			}
			userTrackLastDLdateContainer.append(templates.get('user_track_last_dl_date', { userLastDlDate: lastDlDate }));
		}

		if (!config.showUserTrackDLIndicator) {
			userTrackLastDLdateContainer.remove();
		}
	}
	
	function addDownloadStudioButton(container) {
		if (config.showDownloadStudio === 0 || (config.showDownloadStudio === 2 && !user.hasAdminPermission(AdminPermission.Any))) return;
		
		var downloadStudioButtonContainer = container.find('#download_studio_button_container');
		downloadStudioButtonContainer.empty();

		downloadStudioButtonContainer.append(templates.get('download_studio_button', { link: siteBaseUrl() + sa.pages.downloadStudio.generateRoute(trackId), buttonText : 'Make stems &amp; cut-downs' }));
	}

	function addInteractionEditingButtons(container) {

		if (editOn) {

			setTimeout(function() { container.addClass('editing'); }, 50);

			container.find('#delete_button').on('click', function() {
				deleteTrack();
			});

			container.find('#clone_button').on('click', function() {
				sa.showTrackCloner(trackData);
			});

		} else {

			if ($j('.interaction_sub_container.editing').length) {
				container.addClass('editing');
			}

			setTimeout(function() { container.removeClass('editing'); }, 50);

		}

	}

	function showLicenseModal() {
		var modal = new LicenseNowModal();
		modal.trackId = trackId;
		modal.init();
	}

	function addInteractionContainer() {
		var container = templates.get('interaction_container');

		if (config.siteType === 'drop') {
			$j('#details_page').addClass('with_single_interaction_options');
		}

		// add editing buttons
		var canEdit = user.hasAdminPermission(AdminPermission.Metadata) && trackData.editable;

		if (canEdit) {
			if (editOn) {
				container.find('#swap_editing').addClass('edit_on')
			}
			container.find('#swap_editing').on('click', function() {
				setEditState(!editOn);
				if (editOn) {
					$j(this).addClass('edit_on');
				} else {
					$j(this).removeClass('edit_on');
				}
			});

		} else {

			container.find('#swap_editing').remove();
			container.addClass('no_editing');

		}

		// download formats
		addDownloadButtons(container);

		// sending/sharing buttons
		addSharingButtons(container);

		// add to drop button
		addDropButtons(container);

		// add mcps button, if they have it enabled
		addMcpsButton(container);

		// add a license button
		addLicenseButton(container);

		// add similar tracks button
		addSimiliarTracksButton(container);

		// add Songbird Button
		addSongbirdButton(container);

		// add row to display last track DL date if enabled
		addUserTrackLastDLdate(container);

		// add a link to Download Studio
		addDownloadStudioButton(container);

		// add the delete and copy buttons (if necessary)
		addInteractionEditingButtons(container);

		addSubpageTabs(container);

		$j('#interaction_container').empty().append(container);
	}

	function setDetails(profilesWithTrackAccess) {
		const rightContentMinHeight = 300;
		$j('#details_page #right_content').css({ minHeight: rightContentMinHeight });

		if (!trackData) {
			// we couldn't load the track.
			let notFoundMessage = '';
			if (profilesWithTrackAccess && profilesWithTrackAccess.length) {
				notFoundMessage = templates.get('track_not_in_profile', { profileList : profilesWithTrackAccess.join('</li><li>') });
				if (profilesWithTrackAccess.length > 10) {
					let elements = notFoundMessage.find('li:not(:last)');
					for (let i = 10; i < elements.length; i++) {
						elements[i].className = 'hidden';
					}
					notFoundMessage.find('.show_all').on('click', function() {
						$j(this).remove();
						notFoundMessage.find('.hidden').removeClass('hidden');
						$j('#details_page #right_content').css({ minHeight: Math.max(rightContentMinHeight, notFoundMessage.find('.message').height() + 60) });
					});
				} else {
					notFoundMessage.find('.show_all').remove();
				}
			} else {
				notFoundMessage = templates.get('track_not_found');
			}
			$j('.right_content').append(notFoundMessage);
			trackNotFound = true;
			return;
		}
		trackBank.clear('details_page');
		trackBank.add(trackData, 'details_page');


		// determine if we have edit perms and if we do, is edit mode on
		editOn = false;

		// add the title container
		addTitleContainer();

		// show the comment container for admins
		// addEditingContainer();

		// stats container for those who allow it
		addStatsContainer();

		// show all the track data
		addTrackDataContainer();

		// add the download, license, and sending button
		addInteractionContainer();

		if (trackData.outOfDate) {
			sa.notify({ text : 'The track ' + trackData.title + ' has updates pending and may appear out of place until those updates have finished processing.<br/><br/>Only admins will see this message.' });
		}

		if (sa.components.projector && sa.components.projector.inQuickProjectMode()) {
			page.enableQuickProjects();
		} else if (sa.components.nester && sa.components.nester.inNestingMode()) {
			page.enableNesters();
		} else if (sa.components.cueSheeter && sa.components.cueSheeter.inQuickCueSheetMode()) {
			page.enableQuickCueSheets();
		}
	}

	/**
	 * Gets the link to the MCPS system for this track, if it has all the correct fields. If it doesn't will return an empty string
	 * @param {Track} datum
	 * @return {string}
	 */
	function getMCPSUrl(datum) {
		var fields = {
			newapp : 'True',
			thirdPartyApp : 'True',
			workTitle1 : datum.title
		};

		// mcps requires at least one writer and one publisher so we can send a last name (composerLastName1) and ipi number (musicLibraryIPINumber1)
		var foundWriter = false;
		var foundPublisher = false;
		for (var w = 0, wLen = datum.writers.length; !foundWriter && w < wLen; w++) {
			var writer = datum.writers[w];
			if (writer.lastName) {
				fields.composerLastName1 = writer.lastName;
				foundWriter = true;
			}
		}
		if (!foundWriter) {
			return '';
		}

		// figure and groove wants these URLs to not include publishers and iswc numbers
		if (config.id != 46) {
			for (var p = 0, pLen = datum.publishers.length; !foundPublisher && p < pLen; p++) {
				var publisher = datum.publishers[p];
				if (publisher.ipi) {
					fields.musicLibraryIPINumber1 = publisher.ipi;
					foundPublisher = true;
				}
			}
			if (!foundPublisher) {
				return '';
			}

			// iswc1 is optional
			if (datum.iswc) {
				fields.iswc1 = datum.iswc;
			}
		}

		return 'https://musicshop.prsformusic.com/lmgr/inc/landing.aspx' + sa.router.queryParamsToString(fields);
	}

	/**

	 * Reloads the page, showing the user a message through the alert manager if one is set
	 * @param {string=} message the message to show
	 */
	function reloadDetailsPage(message) {
		if (message) {
			sa.notify({ text : message });
		}
		sa.requestCache.clear();
		trackId = 0;
		page.resetTrackData();
		sa.router.reloadPage();
	}

	/**
	 * Turns nesting mode on for this track
	 */
	page.enableNesters = function() {
		$j('.quick_project_button_container').empty().append(sa.components.nester.generateButton(trackId));
	};

	/**
	 * Turns quick project mode on for this track
	 */
	page.enableQuickProjects = function() {
		$j('.quick_project_button_container').empty().append(sa.components.projector.generateQuickProjectTrackButton(trackId));
	};

	/**
	 * Turns quick project mode on for this track
	 */
	page.enableQuickCueSheets = function() {
		$j('.quick_project_button_container').empty().append(sa.components.cueSheeter.generateQuickCueSheetTrackButton(trackId));
	};

	/**
	 * Turns quick project mode off
	 */
	page.disableQuickProjects = page.disableNesters = function() {
		var currentButton = $j('.quick_project_button_container .quick_project_button');
		setTimeout(function() {
			currentButton.remove();
		}, 150);
	};

	/**
	 * Callback after the similar tracks have loaded
	 * @param {JSON} newData the data for the similar tracks
	 */
	function setSimilar(newData) {
		similarTrackList.setData(newData, getTrackLink);
		$j('#details_similar_tracks')
			.append(createA('details_more_link', '', siteBaseUrl() + '/tracks?sim=' + trackId, '', '', 'See More' + ' &raquo;'))
			.append('<div class="clr"></div>');
	}

	/**
	 * Callback after the alternate versions of this track have loaded
	 * If there are no alternates, removes that section
	 * @param {JSON} newData the data for the tracks
	 */
	function setAlternates(newData) {
		if (!trackData) { // make sure the track data is loaded
			if (trackNotFound) {
				$j('#alternate_tracks_container').hide();
			} else {
				setTimeout(function () {
					setAlternates(newData);
				}, 250);
			}
			return;
		}
		var canEdit = user.hasAdminPermission(AdminPermission.Metadata) && trackData.editable;
		if (!newData[0].count && !canEdit) {
			$j('#alternate_tracks_container').hide();
		} else {
			$j('#alternate_tracks_container').show();
			alternateTrackList.setData(newData, getTrackLink);
		}
		alternatesSet = true;
		setAlternatesEdit();
	}

	function setAlternatesEdit() {
		if (!alternatesSet) return;
		if (editOn) {
			$j('.manage_alternates').show().off('click').on('click', function() {
				sa.components.nester.swap(trackData);
			});
		} else {
			$j('.manage_alternates').hide();
		}
		let shouldUpdateColumnList = false;
		for (let view of [ ListViewType.List, ListViewType.MiniBlock, ListViewType.Block ]) {
			let columnList = alternateTrackList.conf.getColumnList(view);
			let shouldAddColumnList = false;
			for (let i = 0, len = columnList.length; i < len; i++) {
				let column = columnList[i];
				// if this is a list we can edit, add a reordering option. else, remove it
				if (editOn && trackData.masterId == trackId && column.hasDisplayColumn('title') && !column.hasDisplayColumn('reorder')) {
					column.addDisplayColumn('reorder', 0);
					shouldUpdateColumnList = shouldAddColumnList = true;
					break;
				} else if ((!editOn || trackData.masterId != trackId) && column.hasDisplayColumn('reorder')) {
					column.removeDisplayColumn('reorder');
					shouldUpdateColumnList = shouldAddColumnList = true;
					break;
				}
			}
			if (shouldAddColumnList) {
				alternateTrackList.conf.addColumnList(columnList, view);
			}
		}
		if (shouldUpdateColumnList) {
			alternateTrackList.updateColumnList();
			alternateTrackList.generatePage($j('#track_list_details_alternate').empty());
			alternateTrackList.setData(alternateTrackList.lastNewData, getTrackLink);
			if (editOn) {
				alternateTrackList.on('reorder', function(e, order, page, perPage) {
					console.log(order, page, perPage);
					//order = order.map(item => item.id);
					sa.api.request({
						handler : 'nesting',
						action : 'changeOrder',
						postData : {
							masterId : trackId,
							sortedChildIds : order.map(item => item.id),
							page : page,
							perPage : perPage
						}
					}).then(function() {
						console.log('nesting order saved');
					});
				});
			} else {
				alternateTrackList.off('reorder');
			}
		}
		if (editOn && trackData.masterId != trackId) {
			$j('.sort_alternates').show().attr('href', 'track/' + trackData.masterId);
		} else {
			$j('.sort_alternates').hide();
		}
	}

	/**
	 * Starts the track deletion process, prompting the user to make sure they're sure
	 */
	function deleteTrack() {
		sa.confirm({
			text : 'Are you sure you want to delete this track, "' + trackData.title + '"?<br/><br/><b>This action is permanent and NOT undoable.</b><br/><br/>If it\'s the only track in an album or label, that item will be removed.',
			yesFunction : function() {
				ajax('delete=' + sa.cookies.get(window['secureUserCookieName']) + '&secureToken=' + user.secureToken,
					function(response) {
						if (response[0].result == 'success') {
							sa.notify({ text : 'Track deleted! It may take up to five minutes for it to actually disappear.' });
							trackId = 0;
							trackData = null;
							sa.requestCache.clear();
							sa.router.routeTo(decodeURIComponent(config.home));
						} else {
							sa.notify({ text : response[0].result });
						}
					}, 'POST', 'p=track_details&t=' + trackId);
			},
			yesText : 'Delete'
		});
	}

	// you can make several calls to this function before it has time to load anything. only the first call will initiate an ajax request and the other callbacks are added to a list, to be fired when we get the data
	var personListFields = null,
		personListFieldCallbacks = [],
		loadingPersonListFields = false;
	function loadPersonListFields(callback) {
		if (personListFields) {
			return callback(personListFields);
		}
		personListFieldCallbacks.push(callback);
		if (loadingPersonListFields) return;
		loadingPersonListFields = true;
		ajax({ p : 'people', action : 'loadListFieldValues' }, function(response) {
			personListFields = response;
			for (var i = 0, len = personListFieldCallbacks.length; i < len; i++) {
				personListFieldCallbacks[i](personListFields);
			}
		});
	}

	function saveField(field, value, container) {

		if (field.saveField) {
			field.saveField(value);
			return;
		}

		var animationDuration = 250;
		var showWait = 50;
		var saveNoticeDuration = 1500;
		var noticeContainer = field.getNoticeContainer(container);
		console.log('saving field', field.name, value);
		noticeContainer.append(templates.get('field_saving'));
		setTimeout(function() { noticeContainer.addClass('currently_saving'); }, showWait);

		ajax({ field : field.name, value : value, cwrField : field.cwrField ? 1 : 0 },
			function(response) {
				noticeContainer.removeClass('currently_saving');
				setTimeout(function() { noticeContainer.find('.saving').remove(); }, animationDuration);
				if (!response.length) {
					sa.alert({ text : 'Unable to save. Please reload and try again' });
				} else if (response[0].result != 'success') {
					sa.alert({ text : response[0].result });
				} else {
					noticeContainer.append(templates.get('field_saved')).addClass('currently_saved');
					setTimeout(function() {	noticeContainer.removeClass('currently_saved');	}, saveNoticeDuration);
					setTimeout(function() { noticeContainer.find('.saved').remove(); }, saveNoticeDuration + animationDuration);

					field.value = response[0].value;
					if (field.setFieldData) {
						field.setFieldData(field, container); // writers and publishers roll their own
					} else {
						field.setValue(field.value);
						setFieldData(field, container);
					}
				}
			}, 'POST', { p : 'track_details', t : trackId });

	}

	/**
	 * Adds the current track to the cart
	 */
	function addToCart() {
		if(sa.components.shoppingCart.addItem(cartItem)) {
			let baseUrl = siteBaseUrl();
			sa.notify({ text : $j('<div>' + 'Added to cart!' + '<br/><a href="'+ baseUrl  +'/shopping-cart">'
					+ 'Click to go to cart.' + '</a></div>') });
			$j('.price_container .message').html('Added to Cart');
			$j('.price_container .remove').remove();
			$j('.price_container').append('<a class="remove faux_button">[x] ' + 'Remove' + '</a>').find('.remove').on('click', function() {
				removeFromCart();
				return false;
			});
		}
	}

	/**
	 * Removes the current track from the cart
	 */
	function removeFromCart() {
		let baseUrl = siteBaseUrl();
		sa.components.shoppingCart.removeItem(cartItem);
		sa.notify({ text : $j('<div>' + 'Removed from cart,' + '<br/><a href="'+ baseUrl  +'/shopping-cart">'
				+ 'Click to go to cart.' + '</a></div>') });
		$j('.price_container .message').html('Add to Cart');
		$j('.price_container .remove').remove();
		$j('#add_to_cart').on('click', function() {
			addToCart();
			return false;
		});
	}

	/**
	 * Shows a transparent cover with loader gif on top of the page
	 */
	function showCover() {
		showLoader($j('#body'), 'Loading track details').addClass('details_loader');
	}

	/**
	 * Hides the cover if it's visible
	 */
	function hideCover() {
		var cover = $j('.details_loader');
		cover.addClass('hiding');
		setTimeout(function() {
			cover.remove();
		}, 250);
	}

	/**
	 * Shows stats
	 */
	function showStats() {

		if (!trackData) {
			// we couldn't load the track.
			$j('.right_content').append(templates.get('track_not_found'));
			trackNotFound = true;
			return;
		}

		editOn = false;

		addTitleContainer();

		var numbersContainer = $j('#stats_container');

		numbersContainer.find('#plays .value').html(trackData.plays.toString());
		numbersContainer.find('#downloads .value').html(trackData.downloads.toString());

		addSubpageTabs(numbersContainer)
		let trackBaseLink = siteBaseUrl() + '/track/' + trackId;
		var statsContainer = templates.get('stats_page_details', {detailsLink: trackBaseLink + '?page=details'} );

		statsContainer.find('.tab').on('click', function() {
			statsContainer.find('.tab.selected').removeClass('selected');
			$j(this).addClass('selected');
			if (this['id'] == 'plays') {
				loadPlayStats();
			} else if (this['id'] == 'edits') {
				loadEditHistory();
			} else {
				loadDownloadStats();
			}
		});

		$j('#details_stats').empty().append(statsContainer);

		loadPlayStats();
	}

	/**
	 * Loads play stats for the track
	 */
	function loadPlayStats(params) {
		loadGenericStats(params, 'plays');
	}

	function loadDownloadStats(params) {
		loadGenericStats(params, 'downloads');
	}

	function loadGenericStats(params, type) {
		let otherType = type == 'plays' ? 'downloads' : 'plays';
		let history = $j('#history').show();
		$j('#edit_list').hide();
		sa.api.request({
			handler : 'stats',
			action : 'get-track-stats',
			getData : params ? sa.router.paramsToVars(params) : {
				trackId : trackId,
				type : type
			}
		}).then(function (data) {
			if (!history.find('.list').length) {
				history.addClass(type).removeClass(otherType).html('');
				// insert data
				var userListConfig = new ListConfig();
				userListConfig.addColumnList([
					new ListColumn('username', ['user avatar', 'username']),
					new ListColumn('date', (user.hasAdminPermission('super_admin') ? ['date', 'watermarked'] : ['date']))
				]);
				userListConfig.bankKey = 'users';
				userListConfig.selectable = false;
				userListConfig.sortable = false;

				statsUserList = createUserList(userListConfig);
				statsUserList.generatePage(history[0]);
			}
			statsUserList.setData(data, function() { return getTrackLink(trackId, 'stats'); }, function(params) { loadGenericStats(params, type); return false;});
		});
	}

	function loadEditHistory() {
		var editContainer = $j('#edit_list').show();
		$j('#history').hide();
		ajax('p=track_info&customs=1&page=details&includeEdits=1&id=' + trackId, function(newData) {
			if (newData.length != 2 || !newData[1]['edits'] || !newData[1]['edits'].length) {
				editContainer.html('No history yet.');
			} else {
				editContainer.empty();
				// we want to group edits that were done by the same person on the same minute
				// so we keep track of the last person/date combination we came across and only actually display anything when that changes
				var lastDate = ''; // the last person/date combination we came across
				var edits = []; // all the edits we've found so far for that person/date. this is reset when we change people/dates
				newData[1]['edits'].each(function() {
					var edit = this;
					var formattedDate = formatDate(config.dateTimeFormatString, edit.date) + ' by ' + edit.username;
					// if the date changes, we output all edits we've collected and reset the list
					if (lastDate && lastDate != formattedDate) {
						editContainer.append(templates.get('history_edit', { date : lastDate, edits : edits.join('') }));
						edits = [];
					}
					edits.push(templates.get('history_single_edit', { edit : edit.description })[0].outerHTML);
					lastDate = formattedDate;
				});
				// once we're done, we'll have one more edit group that was never displayed because we never hit the "doesn't match" trigger since the array just ended. output it here
				if (lastDate) {
					editContainer.append(templates.get('history_edit', { date : lastDate, edits : edits.join('') }));
				}
			}

		});
	}

	/**
	 * Shows work registration fields and lets the user edit them
	 */
	function showWorksRegistration() {

		if (!trackData) {
			// we couldn't load the track.
			$j('.right_content').append(templates.get('track_not_found'));
			trackNotFound = true;
			return;
		}

		addTitleContainer();

		editOn = true;

		showInterestedParties($j('#interested_parties_container'));

		showCWRFields($j('#cwr_container'));

	}

	/**
	 * Shows all the CWR related fields
	 * @param container
	 */
	function showCWRFields(container) {

		var dividedFieldContainer;
		var fieldRowTemplate = templates.get('information_field_row');
		var fieldTemplate = templates.get('information_field');
		var fieldDividerTemplate = templates.get('information_field_divider');
		var fieldsInRow = 0;
		var maxFieldsInRow = 2;
		var fieldRow;

		container.empty().append(templates.get('information_container').html());
		dividedFieldContainer = container.find('.divided_field_container');

		getCWRFields().each(function(i, field) {
			var template = fieldTemplate.clone();

			setFieldData(field, template);

			if (!fieldsInRow) {
				fieldRow = fieldRowTemplate.clone();
			}

			fieldRow.append(template);
			fieldsInRow++;

			if (fieldsInRow == maxFieldsInRow) {
				fieldRow.append(fieldDividerTemplate.clone());
				dividedFieldContainer.append(fieldRow);
				fieldsInRow = 0;
				fieldRow = null;
			}
		});

		if (fieldRow) {
			fieldRow.append(fieldDividerTemplate.clone());
			dividedFieldContainer.append(fieldRow);
		}

	}

	function getCWRFields() {

		var fields = [];

		trackData.worksRegistrationData.cwr.each(function(i, cwrField) {

			var fieldOptions = {
				name : cwrField.name,
				value : cwrField.value,
				editable : true,
				cwrField : true,
				getDisplayValue : function(value) {
					if (value === undefined) {
						value = cwrField.value;
					}
					if (fieldOptions.select) {
						for (var f = 0, fLen = cwrField.options.length; f < fLen; f++) {
							if (cwrField.options[f].value === value) {
								return cwrField.options[f].name;
							}
						}
					} else if (cwrField.type === 'date' && value !== '') {
						var m = value.match(/([0-9]{4})-?([0-9]{2})-?([0-9]{2})/);
						if (m) {
							return config.dateFormatString.replace('Y', m[1]).replace('m', m[2]).replace('d', m[3]);
						}
					}
					return value;
				},
				getInputValue : function(v) {
					if (cwrField.type == 'date') {
						var m = cwrField.value.match(/([0-9]{4})-?([0-9]{2})-?([0-9]{2})/);
						if (m) {
							return m[1] + '-' + m[2] + '-' + m[3];
						}
					}
					return cwrField.value;
				},
				setValue : function(newValue) {
					cwrField.value = newValue;
				}
			};

			if (cwrField.type == 'list' || cwrField.type == 'boolean' || cwrField.type == 'flag') {

				fieldOptions.getSelectValue = function() {
					return cwrField.value;
				};
				fieldOptions.select = { list : [], allowNew : false };
				cwrField.options.each(function(j, option) {
					var displayValue = option.name;
					if (option.description !== '') {
						displayValue += ' - ' + option.description;
					}
					fieldOptions.select.list.push({ id : option.value, value : displayValue });
				});

			} else if (cwrField.type == 'date') {

				fieldOptions.inputType = 'date';

			} else {

				fieldOptions.maxLength = cwrField.maxLength;

			}

			fields.push(new DetailsField(fieldOptions));

		});

		return fields;

	}

	function showInterestedParties(cont) {

		var ipContainer = templates.get('interested_party_container');

		var foundWriters = showInterestedPartyType(ipContainer.find('#interested_parties_writers'), 'writers', trackData.writers);
		var foundPublishers = showInterestedPartyType(ipContainer.find('#interested_parties_publishers'), 'publishers', trackData.publishers);

		if (foundWriters || foundPublishers) {
			cont.find('#details_interested_parties').remove();
			cont.append(ipContainer);
		}

	}

	/**
	 * Adds an interested party to the list
	 * @param {JQuery} cont
	 * @param {string} type
	 * @param {Array.<Publisher>} people
	 * @return {boolean} did we add any?
	 */
	function showInterestedPartyType(cont, type, people) {

		var fieldVisible = isFieldVisible(type);
		if ((!fieldVisible && !user.hasAdminPermission(AdminPermission.Metadata)) && !editOn) {
			cont.remove();
			return false;
		}

		var found = false;
		var list = cont.find('#' + type).empty();

		let baseUrl = siteBaseUrl();

		for (var i = 0, len = people.length; i < len; i++) {

			var person = people[i];
			var template = templates.get('interested_party');

			let personNameElement = template.find('.name').html(person.name);
			if (!disableLinksAndSharing) {
				personNameElement.attr('href', baseUrl + '/' + type.substring(0, type.length - 1) + '/' + person.id);
				personNameElement.attr('title', 'Shift-Click to add this term to your search bar.');
				personNameElement.data('search_tag', type.substring(0, type.length - 1) + ':"' + person.name.trim().replace(/'/g, '&apos;'));
				//personNameElement.on('click', e => { sa.search.searchTagHandler(e, type.substring(0, type.length - 1) + ':"' + person.name.trim()); });
			} else {
				personNameElement.addClass('non_link');
			}
			if (person.ownershipShare) {
				template.find('.ownership_share').html(person.ownershipShare + '%');
			}
			template.find('.affiliation').html(person.affiliation.name);

			if (person.ipi != 0) {
				template.find('.ipi').html(person.ipi);
			}

			if (person.role.id != 0) {
				template.find('.role').html(person.role.code);
			}

			if (type == 'writers') {

				template.find('.collection_share_list').remove();

			} else if (person.collectionShares && person.collectionShares.length) {
				for (var c = 0, cLen = person.collectionShares.length; c < cLen; c++) {

					var shareTemplate = templates.get('interested_party_collection_share'),
						share = person.collectionShares[c];

					shareTemplate.find('.country').html(share.territory.name);
					shareTemplate.find('.percentage').html(share.collectionShare + '%');

					template.find('.collection_share_list').append(shareTemplate);
				}
			}

			found = true;
			list.append(template);

		}

		sa.search.addSearchTagListeners(list);

		if (!found && !editOn) {
			cont.remove();
		} else if (!editOn) {
			cont.find('.ip_edit_button').remove();
			if (!fieldVisible) {
				cont.addClass('hidden_field');
				cont.append(templates.get('hidden_field_notice'));
			}
		} else {
			cont.find('.ip_edit_button').off().on('click', function() {
				showInterestedPartyEditor(cont, type.substring(0, type.length - 1), people);
			});
			if (!found) {
				list.append(templates.get('no_' + type));
				found = true;
			}
		}

		return found;

	}

	/**
	 * Shows the IP editor used on the details page but abstracts it for use elsewhere
	 * @param {Writer[]|Publisher[]} values
	 * @param {string} type
	 * @param {function} callback
	 * @param {Publisher[]=} publishers the publishers to choose from if type is writer
	 */
	page.showInterestedPartyEditor = function(values, type, callback, publishers) {
		initializeTemplates();

		showInterestedPartyEditor($j(), type, values, callback, publishers);
	};

	function showInterestedPartyEditor(container, type, people, saveOverride, publishers) {

		var editingContainer = templates.get(type + '_editing');
		var personRow = editingContainer.find('.people_row').detach();
		var personContainer = editingContainer.find('.people');
		var headerRow = editingContainer.find('tbody:first');
		var fb;

		if (type == 'publisher') {
			personRow = personRow.add(editingContainer.find('.collection_share_row').detach());
		}

		function showHideHeader() {
			if (!personContainer[0].childNodes.length) {
				headerRow.hide();
			} else {
				headerRow.show();
			}
		}

		/**
		 * @param {Writer|Publisher=} person
		 */
		function addPerson(person) {
			var row = personRow.clone();
			var roleSelect = row.find('.ip_role');
			var personSelect = row.find('.ip_name');

			loadPersonListFields(function(listFields) {
				if (person) {
					roleSelect.html('<option value="' + person.role.id + '">' + person.role.name + '</option>');
				}
				roleSelect.selectize({
					placeholder : 'Required',
					labelField : 'name',
					searchField : 'name',
					sortField : 'name',
					valueField : 'id',
					options : listFields[type + 'Roles']
				});
			});

			if (person) {
				personSelect.html('<option value="' + person.id + '" selected="selected">' + person.name + '</option>');
				row.find('.ip_ownership_share').val(person.ownershipShare);
			}

			personSelect.selectize({
				placeholder : 'Click to add a ' + gde(type),
				labelField : 'display',
				searchField : 'display',
				sortField : 'display',
				valueField : 'id',
				load : function (query, callback) {
					if (!query.length) return callback([]);
					ajax({ p : 'people', action : 'search', type : type + 's', s : query }, function (response) {
						callback(response);
					});
				}
			});

			if (type == 'writer') {
				var publishingInterestSelect, $publishingInterestSelect;
				publishingInterestSelect = row.find('.ip_publishing_interest');
				var originalPublishers = [];
				if (!publishers) {
					publishers = trackData.publishers;
				}
				publishers.each(function(i, publisher) {
					/** @var {Publisher} publisher */
					if (publisher.role && publisher.role.code == 'OP') {
						originalPublishers.push(publisher);
					}
				});
				if (person && person.publisherId) {
					var selectedPublisher = null;
					originalPublishers.each(function(i, publisher) {
						/** @var {Publisher} publisher */
						if (publisher.id == person.publisherId) {
							selectedPublisher = this;
						}
					});
					if (selectedPublisher) {
						publishingInterestSelect.html('<option value="' + selectedPublisher.id + '" selected="selected">' + selectedPublisher.name + '</option>');
					}
				}

				var piSelectOpts = {
					placeholder: 'None (unspecified)',
					labelField: 'name',
					searchField: 'name',
					sortField: 'name',
					valueField: 'id',
					options: originalPublishers
				};

				if (!originalPublishers.length) {
					piSelectOpts.maxItems = '1';
					piSelectOpts.placeholder = 'Add publishers first';
				}

				$publishingInterestSelect = publishingInterestSelect.selectize(piSelectOpts);
				publishingInterestSelect = $publishingInterestSelect[0].selectize;
				if (!originalPublishers.length) publishingInterestSelect.disable();

			} else {

				var collectionSharesContainer = row.find('.collection_shares');
				var collectionShares = collectionSharesContainer.find('.shares');
				var collectionShareRow = collectionShares.find('.share_row').detach();

				function showHideCollectionShares() {
					if (collectionShares[0].childNodes.length) {
						collectionSharesContainer.addClass('show');
					} else {
						collectionSharesContainer.removeClass('show');
					}
				}

				function addCollectionShare(share) {
					var csRow = collectionShareRow.clone();
					var territorySelect = csRow.find('.ip_collection_territory');

					if (share) {
						csRow.find('.ip_collection_share').val(share.collectionShare);
					}

					// selectize territory
					loadPersonListFields(function(listFields) {
						if (share) {
							territorySelect.html('<option value="' + share.territory.id + '">' + share.territory.name + '</option>');
						}
						territorySelect.selectize({
							placeholder : 'Required',
							labelField : 'name',
							searchField : 'name',
							sortField : 'name',
							valueField : 'id',
							options : listFields['territories']
						});
					});

					csRow.find('.remove_share').on('click', function() {
						csRow.remove();
						showHideCollectionShares();
					});

					collectionShares.append(csRow);

					showHideCollectionShares();
				}

				// add existing shares
				if (person) {
					person.collectionShares.each(function () {
						addCollectionShare(this);
					});
				}

				showHideCollectionShares();

				row.find('.add_share').on('click', function() {
					addCollectionShare();
				});

			}

			row.find('.remove_person').on('click', function() {
				row.remove();
				showHideHeader();
			});

			personContainer.append(row);
		}

		people.each(function() {
			addPerson(this);
		});

		showHideHeader();

		editingContainer.find('.add_new').on('click', function() {
			addPerson();
			showHideHeader();
		});

		// create new writer and add to interface
		editingContainer.find('.create_new').on('click', function() {
			sa.components.itemEditInterface.show({ type, title: 'Add New ' + gde(type), reloadAfterSave: false, callback: function(response) {
					if (response && response[1]) {
						addPerson(response[1]);
					}
				}});
			return false;
		});

		editingContainer.find('.save').on('click', function() {

			// convert the {index} input names into real names
			if (type == 'publisher') {
				$j('.collection_share_row').each(function(i) {
					$j(this).find('.ip_collection_share').attr('name', 'collectionShares[' + i + '][share][]');
					$j(this).find('.ip_collection_territory').attr('name', 'collectionShares[' + i + '][territory][]');
				});
			}

			var values = sa.forms.validate(editingContainer).values;

			if (saveOverride) {
				saveOverride(values);
			} else {
				saveField(new DetailsField({
					name : type + 's',
					setFieldData : function (field, container) {
						trackData[field.name] = field.value;
						showInterestedPartyType(container.parents('.details_field_row'), field.name, field.value);
					}
				}), values, container.find('.details_field'));
			}

			fb.hide();
		});

		editingContainer.find('.hint').on('click', function() {
			sa.alert({
				text : this.title
			});
		});

		fb = new FocusBox(editingContainer);
		fb.getFocusedContainer().addClass('editing_box')
		fb.show();

	}

	return page;

})();
sa.pages.downloadStudio = (function () {

	const page = {
		name: 'downloadStudio',
		title: 'Download Studio',
		register: {
			routes: [{
				name: 'download-studio',
				hash: '#!download_studio',
				pattern: '/download-studio/track/:int/:any?',
				id: 'id'
			}]
		},
		generateRoute: trackId => '/download-studio/track/' + trackId,
		buttonText: 'Make stems, cut-downs, &amp; transcode'
	};
	//https://debug.sourceaudio.com/git-dlstudio/download-studio/track/44926297
	//https://github.com/SourceAudio/SourceAudio/issues/6728
	//https://www.figma.com/proto/yCh0tA76gfRxeKwFHrt5ej/Download-Studio?page-id=61%3A5767&node-id=61-5769&node-type=frame&viewport=517%2C399%2C0.13&t=NER31cEeSwLwHmYi-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=61%3A5769

	let templates;
	let sectionInterval;
	let cutdownOptions;
	const defaultCutdown = 'Full Length';
	const defaultStem = 'Original';
	let downloadOptionInputType = 'checkbox';

	page.show = function (params) {
		if (!user.logged) {
			setTimeout(function () {
				const vars = sa.router.paramsToVars(params);
				sa.router.routeTo('/track/' + vars.id);
			}, 250);
			sa.notify({ text: $j('<span>Please <a style="text-decoration: underline;" href="' + getLoginLink() + '">log in</a> to access Download Studio</span>') });
			return;
		}
		if (!templates) {
			templates = sa.templates.get('download_studio');
			sa.ffmpeg.load();
		}

		clearBody();
		const container = templates.get('page');
		const loader = showLoader(container, 'Loading track data...');
		const vars = sa.router.paramsToVars(params);
		const data = new DownloadStudioData();

		$j('#body').empty().append(container);

		sa.api.request({
			handler: 'download-studio',
			action: 'getTrackData',
			postData: {
				trackId: vars.id
			}
		}).then(function (response) {
			data.trackData = response.track;
			trackBank.add(data.trackData, 'downloadStudio');
			data.sections = response.sections.sections;
			data.beatMap = response.sections.beatMap;
			data.stemOptions = response.stemOptions;
			loader.remove();
			container.find('#loader_element').remove();
			renderPage(container, data);
		}).catch(err => {
			console.error(err);
			window.lastError = err;
			container.empty().append(templates.get('error', { message: err.message }));
		});

		sa.currentPage = this;
	};

	/**
	 * Renders the page's actual content once data has been loaded from the server
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 */
	function renderPage(container, data) {
		container.find('.title').text(data.trackData.title);
		container.find('.play_button_container').append(sa.components.player.generatePlayButton(data.trackData.id, { location: 'download_studio' }));

		container.find('.return-back-link').on('click', (e) => {
			e.preventDefault();

			// If we came from an internal page, go back to that page
			const prevUrl = sa.router.getPreviousUrl();
			if (prevUrl) {
				sa.router.routeTo(prevUrl);
			} else {
				sa.router.routeTo('/track/' + data.trackData.id);
			}
		});

		// show the waveform
		new Waveform(data.trackData.id, container.find('#download_studio_waveform_container'), true, [], 0);

		if (data.sections.length) {
			showSections(container, data);
		}

		// stems
		const stemContainer = container.find('.stem_options');
		stemContainer.empty();
		data.stemOptions.forEach(option => {
			if (option === defaultStem) {
				return;
			}
			let displayValue = option;
			if (option === 'Other') {
				displayValue = 'Everything else';
			}
			stemContainer.append(templates.get('stem_option', { value: option, displayValue: displayValue }));
		});

		// cutdowns
		renderCutdownsSection(container, data);

		// apply mobile-specific changes
		updateForMobile(container)

		// download options interactions
		const downloadOptionsList = container.find('.download_options_list');
		downloadOptionsList.find('.header input').on('change', function () {
			if (this.checked) {
				downloadOptionsList.find('input').prop('checked', 1);
			} else {
				downloadOptionsList.find('input').prop('checked', 0);
			}
			updateDownloadOptionsSelectedCount(downloadOptionsList, container);
		});

		// interactions between stems and download options
		stemContainer.find('input').on('change', function () {
			updateDownloadOptions(container);
			updateOtherStemDisplays(container);
		});
		updateDownloadOptions(container);

		// transcoding options
		const formatSelect = container.find('select[name=format]');
		formatSelect.on('change', function () {
			if ($j(this).val() === 'mp3') {
				container.find('.for_pcm').hide();
				container.find('.for_mp3').show();
			} else {
				container.find('.for_pcm').show();
				container.find('.for_mp3').hide();
			}
		});
		formatSelect.val('wav').trigger('change');

		// try to load user settings
		/** @type {{ bitDepth: number, bitRate: number, sampleRate: number, newFormat: string }} userSelections */
		const userSelections = user.getOption('transcode_options');
		if (userSelections) {
			if (userSelections.bitDepth) {
				container.find('select[name=bit_depth]').val(userSelections.bitDepth);
			}
			if (userSelections.bitRate) {
				userSelections.bitRate = userSelections.bitRate === '-1' ? '96k' : userSelections.bitRate;
				container.find('select[name=bit_rate]').val(userSelections.bitRate);
			}
			if (userSelections.sampleRate) {
				container.find('select[name=sample_rate]').val(userSelections.sampleRate);
			}
			if (userSelections.newFormat) {
				formatSelect.val(userSelections.newFormat).trigger('change');
			}
		}

		// go button
		container.find('#download_studio_download_button').on('click', async function () {
			try {
				await startDownloading(container, data);
			} catch (error) {
				console.error(error);
				sa.alert({ text: error.message });
				setProcessing(false, container);
			}
		});
	}

	/**
	 * Apply mobile-specific changes
	 * Mobile browsers only support downloading one file at a time
	 * @param container
	 */
	function updateForMobile(container) {
		if (ios || android) {
			container.find('.download_options_list .header').html(templates.get('mobile_download_options_list_header').html());
			downloadOptionInputType = 'radio';
		}
	}

	function updateOtherStemDisplays(container) {
		const displayValue = getFriendlyOtherStemDisplayValue(container);
		container.find('.stem_option:last .stem_display_value').text(displayValue);
		container.find('.item .stem_display_value[data-stem="Other"]').text(displayValue + ' - ');
	}

	function getFriendlyOtherStemDisplayValue(container) {
		const stemInputs = container.find('.stem_option input:checked');
		const selectedStems = new Map();
		stemInputs.each((i, option) => {
			if (option.value !== 'Other') {
				selectedStems.set(option.value, option.value);
			}
		});
		let selectedStemCount = selectedStems.size;

		if (selectedStemCount === 0) {
			return 'Everything else';
		}

		let displayValue = '';
		if (selectedStems.get('Vocals')) {
			displayValue = 'Instrumental';
			selectedStems.delete('Vocals');
			selectedStemCount--;
		} else {
			displayValue = 'Original';
		}

		const removedStems = [];
		selectedStems.forEach(stem => {
			removedStems.push(stem);
		});
		if (removedStems.length === 1) {
			displayValue += ' Minus ' + removedStems[0];
		} else if (removedStems.length === 2) {
			displayValue += ' Minus ' + removedStems.join(' and ');
		} else if (removedStems.length) {
			displayValue += ' Minus ' + removedStems.slice(0, -1).join(', ') + ', and ' + removedStems.slice(-1)[0];
		}
		return displayValue;
	}

	/**
	 * Shows the cutdown section and sets up its interactions. Abstracted into a separate function bc of the amount of logic involved
	 * @param container
	 * @param {DownloadStudioData} data
	 */
	function renderCutdownsSection(container, data) {
		// reinitialize the cutdown options
		cutdownOptions = [defaultCutdown];
		// the element that has options for cutdowns
		const cutdownOptionsContainer = container.find('.cutdown_options');
		const customCutdownsContainer = container.find('#custom_cutdown_options_container');

		// selecting a cutdown in the options needs to indicate selection
		const cutdownOptionCheckboxes = cutdownOptionsContainer.find('.cutdown_option');

		cutdownOptionCheckboxes.find('input[type="checkbox"]').on('change', function () {
			const isChecked = $j(this).is(':checked');
			if (isChecked) {
				const { value } = $j(this)[0].dataset;
				cutdownOptions.push(value);
				cutdownOptions.removeDuplicates();
				updateDownloadOptions(container);
			} else {
				const { value } = $j(this)[0].dataset;
				cutdownOptions = cutdownOptions.filter(option => option !== value);
				updateDownloadOptions(container);
			}
		});

		customCutdownsContainer.find('.custom_cutdown_option_inputs input[type="number"]').on('input', () => {
			const min = parseInt(customCutdownsContainer.find('input[name=min]').val());
			const sec = parseInt(customCutdownsContainer.find('input[name=sec]').val());

			if (min > 0 || sec > 0) {
				customCutdownsContainer.find('#add_cutdown_button').removeAttr('disabled');
			} else {
				customCutdownsContainer.find('#add_cutdown_button').attr('disabled', 'disabled');
			}
		});

		// clicking the final "add" button adds this option to the list and resets the cutdown entry state
		customCutdownsContainer.find('#add_cutdown_button').on('click', () => {
			const min = parseInt(customCutdownsContainer.find('input[name=min]').val());
			const sec = parseInt(customCutdownsContainer.find('input[name=sec]').val());

			let value = '';
			if (min > 0) {
				value += min + 'm';
			}
			if (sec > 0) {
				value += sec + 's';
			}
			if (!value) {
				sa.alert({ text: 'Please enter a valid duration for your custom cutdown' });
				return;
			}

			cutdownOptions.push(value);
			cutdownOptions.removeDuplicates();
			updateDownloadOptions(container);
		});

	}

	/**
	 * Called once anything on the page changes that might affect the list of tracks available for download.
	 * Updates that list, trying to maintain anything the user had checked previously
	 * @param container
	 */
	function updateDownloadOptions(container) {
		// clear out the current options and create new ones
		// what has the user checked currently?
		const currentlyCheckedValues = [];
		container.find('.download_options_list input:checked').each((i, input) => { currentlyCheckedValues.push({ cutdown: input.dataset.cutdown, stem: input.dataset.stem }); });

		// clear the download options list and get our template item
		const downloadOptionsList = container.find('.download_options_list');
		downloadOptionsList.find('.item').remove();

		// these are all the download options the user will have
		const options = [
			{ value: defaultStem, displayValue: 'Original Audio' }
		];

		// these are all the available stem values
		const checkedStemValues = [{ value: defaultStem, displayValue: 'Original Audio - ' }];
		container.find('.stem_container input:checked').each((i, input) => { checkedStemValues.push({ value: input.value, displayValue: input.dataset.display + (input.value === 'Other' ? '' : ' Stem') + ' - ' }); });

		// the available cutdown values are stored in cutdownOptions

		// nested loop over the selected stems and the added cutdowns to produce a final list
		cutdownOptions.forEach(cutdownOption => {
			checkedStemValues.forEach(checkedStemValue => {
				const uniqueId = cutdownOption.replace(/[^a-zA-Z0-9]/g, '_') + '_' + checkedStemValue.value.replace(/[^a-zA-Z0-9]/g, '_');
				const downloadOptionTemplate = templates.get('download_option', {
					cutdown: cutdownOption,
					stem: checkedStemValue.value,
					stemDisplayValue: checkedStemValue.displayValue,
					cutdownDisplayValue: cutdownOption,
					uniqueId: uniqueId.toLowerCase(),
					inputType: downloadOptionInputType
				});
				downloadOptionsList.append(downloadOptionTemplate);
			});
		});

		// now check everything in currentlyCheckedValues
		// if they checked "all" before, we can just check everything. easy
		if (downloadOptionsList.find('.header input:checked').length) {
			downloadOptionsList.find('input').prop('checked', 1);
		} else {
			currentlyCheckedValues.forEach(currentlyCheckedValue => {
				downloadOptionsList.find('input[data-stem="' + currentlyCheckedValue.stem + '"][data-cutdown="' + currentlyCheckedValue.cutdown + '"]').prop('checked', 1);
			});
		}

		// Update the count
		updateDownloadOptionsSelectedCount(downloadOptionsList, container);

		// interactions related to download options selection
		downloadOptionsList.find('.item input').on('change', function () {
			// if they uncheck an option, uncheck the master option also
			if (!this.checked) {
				downloadOptionsList.find('.header input').prop('checked', 0);
			}
			// also update the count
			updateDownloadOptionsSelectedCount(downloadOptionsList, container);
		});
	}

	/**
	 * Shared helper function to set the "X files selected" text for the download tracks area
	 * @param downloadOptionsList
	 * @param container
	 */
	function updateDownloadOptionsSelectedCount(downloadOptionsList, container) {
		const selected = downloadOptionsList.find('.item input:checked').length;
		downloadOptionsList.find('.count').text(selected + ' file' + (selected === 1 ? '' : 's') + ' selected');

		// enable or disable the download button
		if (selected > 0) {
			container.find('#download_studio_download_button').removeAttr('disabled');
		} else {
			container.find('#download_studio_download_button').attr('disabled', 'disabled');
		}
	}

	/**
	 * Shows section data on the original audio waveform once it's available
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 */
	function showSections(container, data) {
		container.find('.waveform_wrapper').addClass('with_sections');

		const sectionContainer = container.find('.waveform_sections');
		sectionContainer.empty();
		let sectionElements = $j();
		for (let i = 0, length = data.sections.length; i < length; i++) {
			const section = data.sections[i];
			const sectionElement = templates.get('waveform_section', { type: section.label, classType: section.label.toLowerCase().replace(/ /g, '_') });
			const percentIn = i === 0 ? 0 : section.start / data.trackData.actualLength;
			const percentOut = i === length - 1 ? 1 : section.end / data.trackData.actualLength;
			sectionElement.css({
				left: (percentIn * 100) + '%',
				right: (100 - percentOut * 100) + '%'
			});
			sectionElement[0].dataset.percentIn = percentIn;
			sectionElement[0].dataset.percentOut = percentOut;
			sectionElements = sectionElements.add(sectionElement);
			sectionContainer.append(sectionElement);
		}

		if (sectionInterval) clearInterval(sectionInterval);
		sectionInterval = setInterval(function () {
			if (sa.currentPage.title !== page.title) {
				clearInterval(sectionInterval);
				sectionInterval = null;
				return;
			}
			if (sa.components.player.isPlayingTrack(data.trackData.id)) {
				const progress = sa.components.player.getProgress(); // between 0 and 1
				sectionElements.each(function (i, sectionElement) {
					if (sectionElement.dataset.percentIn < progress && sectionElement.dataset.percentOut > progress) {
						$j(sectionElement).addClass('current');
					} else if (sectionElement.className.indexOf('current') !== -1) {
						$j(sectionElement).removeClass('current');
					}
				})
			} else {
				sectionElements.removeClass('current');
			}
		}, 50);

	}

	/**
	 * 
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 * @returns {Promise<void>}
	 */
	async function startDownloading(container, data) {
		// did they want cutdowns?
		let requestedCutdowns = false;
		// which stems did they request?
		let requestedStems = [];
		// what did they check?
		const currentlyCheckedValues = [];
		container.find('.download_options_list .item input:checked').each((i, input) => {
			currentlyCheckedValues.push({ cutdown: input.dataset.cutdown, stem: input.dataset.stem });
			requestedCutdowns = requestedCutdowns || (input.dataset.cutdown !== defaultCutdown);
			requestedStems.push(input.dataset.stem);
		});
		if (!currentlyCheckedValues.length) return; // the button should have looked disabled anyway

		// record the download request
		data.downloadKey = await recordDownload(container, data, currentlyCheckedValues);

		// to create the requested files, we need several things to happen, which we process in parallel
		// make a list of those promises so we can await them all to finish
		const promises = [];

		// if they requested cutdowns, we need file section data
		if (requestedCutdowns && !data.sections.length) {
			promises.push(getSectionData(container, data));
			data.log('startDownloading - requesting section data');
		} else if (requestedCutdowns) {
			promises.push(recordGetSectionData(data));
			data.log('startDownloading - recording section data');
		}

		// we need stem data regardless of what they checked bc we need the original, if nothing else
		promises.push(getStems(container, data, requestedStems.removeDuplicates()));
		data.log('startDownloading - requesting stems');

		// we need metadata regardless also
		if (!Object.keys(data.metadataBlobs).length) {
			promises.push(getMetadataBlobs(container, data));
			data.log('startDownloading - requesting metadata blobs');
		}

		setProcessing(true, container);

		// wait for all promises to resolve
		data.log('startDownloading - waiting for completion');
		await Promise.all(promises);
		data.log('startDownloading - all promises complete');

		// now we should have everything we need to create the requested files
		await createDownloadFiles(container, data, currentlyCheckedValues);
		setProcessing(false, container);
	}

	/**
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 * @param currentlyCheckedValues
	 * @returns {Promise<unknown>}
	 */
	async function recordDownload(container, data, currentlyCheckedValues) {
		return new Promise((resolve, reject) => {
			sa.api.request({
				handler: 'download-studio',
				action: 'recordDownload',
				postData: {
					trackId: data.trackData.id,
					format: container.find('select[name=format]').val(),
					bitDepth: container.find('select[name=bit_depth]').val(),
					bitRate: container.find('select[name=bit_rate]').val(),
					sampleRate: container.find('select[name=sample_rate]').val(),
					fileSets: currentlyCheckedValues
				}
			})
				.then(response => {
					resolve(response.key);
				})
				.catch(error => {
					reject(error);
				})
		});
	}

	/**
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 * @param {Array} requestedFileList
	 * @returns {Promise<void>}
	 */
	async function createDownloadFiles(container, data, requestedFileList) {
		data.log('createDownloadFiles - requested file list', requestedFileList);
		// see what options they selected
		const bitDepth = container.find('select[name=bit_depth]').val();
		const bitRate = container.find('select[name=bit_rate]').val();
		const sampleRate = container.find('select[name=sample_rate]').val();
		const newFormat = container.find('select[name=format]').val();
		cutdownFilters = {};

		user.setOption('transcode_options', { bitDepth: bitDepth, bitRate: bitRate, sampleRate: sampleRate, newFormat: newFormat });
		const cutdownFinder = new CutdownFinder(data.sections, {}, data.log);
		// stems and sections should be populated with everything we need. go through each file and create it
		for (let i = 0, len = requestedFileList.length; i < len; i++) {
			const requestedFile = requestedFileList[i];
			const cutdown = requestedFile.cutdown;
			const stemType = requestedFile.stem;
			const stemData = data.stems[stemType];
			const inputBlobs = [];
			data.log('createDownloadFiles - processing', cutdown, stemType);

			if (stemType === 'Other') {
				// this is a combination of all unselected files except Original
				// which stem types are checked? Get them checked elements, convert to values, make it an array, and remove non-strings and "Other"
				const selectedStems = Object.values(container.find('.stem_option input:checked').map((i, elem) => elem.value)).filter(stemType => typeof stemType === 'string' && stemType !== 'Other')
				// if they didn't select anything, "other" is just "Other"
				// if they have selected things, "other" is everthing other than what was selected
				const stemsToCombine = selectedStems.length ? data.stemOptions.filter(option => option !== defaultStem && selectedStems.indexOf(option) === -1) : ['Other'];
				// combine with ffmpeg
				for (let stemType of stemsToCombine) {
					inputBlobs.push(data.stems[stemType].blob);
				}
				inputBlobs.push(data.stems['Wind'].blob);
				inputBlobs.push(data.stems['Strings'].blob);
			} else {
				inputBlobs.push(stemData.blob);
			}

			let ffmpegParams;
			if (cutdown === defaultCutdown) {
				// in this case, we already have the data downloaded. just transform it based on the format selections
				ffmpegParams = sa.ffmpeg.createParams(newFormat, sampleRate, bitRate, bitDepth);
			} else {
				// in this case, we need to create the cutdown file
				let cutdownSeconds = 0;
				const minutesMatch = cutdown.match(/(\d+)m/);
				const secondsMatch = cutdown.match(/(\d+)s/);
				if (minutesMatch) cutdownSeconds += parseInt(minutesMatch[1]) * 60;
				if (secondsMatch) cutdownSeconds += parseInt(secondsMatch[1]);

				ffmpegParams = sa.ffmpeg.createParams(newFormat, sampleRate, bitRate, bitDepth);

				let cutdownSections;
				if (!cutdownFinder.foundLengths[cutdownSeconds]) {
					const stepTime = data.startStepTime('cutdown-' + cutdownSeconds);
					cutdownSections = cutdownFinder.find(cutdownSeconds);
					data.endStepTime(stepTime);
				} else {
					cutdownSections = cutdownFinder.foundLengths[cutdownSeconds];
				}
				const filterComplex = getCutdownFilter(cutdownSeconds, cutdownSections);
				data.log('createDownloadFiles - cutdown command for', cutdownSeconds, 'is', filterComplex);
				ffmpegParams = ffmpegParams.concat(filterComplex);
			}
			ffmpegParams = sa.ffmpeg.disableMetadata(ffmpegParams, newFormat);

			try {
				data.log('createDownloadFiles - ffmpegParams', ffmpegParams);
				const stepTime = data.startStepTime('ffmpeg');
				let outputBlob = await sa.ffmpeg.exec(ffmpegParams, 'flac', newFormat, inputBlobs, function () { data.log.apply(data, arguments); });
				data.endStepTime(stepTime);
				if (newFormat === 'wav') {
					outputBlob = await addMetadataToWav(outputBlob, data);
				} else if (newFormat === 'aiff') {
					outputBlob = await addMetadataToAiff(outputBlob, data);
				} else if (newFormat === 'mp3') {
					outputBlob = await addMetadataToMp3(outputBlob, data);
				} else {
					data.log('createDownloadFiles - not injecting metadata because of unknown output format', newFormat);
				}
				showSaveDialog(outputBlob, newFormat, cutdown, stemType, data);
			} catch (e) {
				sa.alert({ text: 'Error converting file. Your browser might not support this feature. Please try a different one or choose another format.' });
				data.log('createDownloadFiles - logged error', e);
				data.saveLogs('ffmpeg exec');
			}
		}
		data.saveStepTimes();
	}

	/**
	 * Adds our metadata to the new wav file
	 * Wavs are the most complicated for us because we need to remove the LIST chunk that ffmpeg adds automatically
	 * So we look through ffmpeg's file, find the start of the data (music) chunk, the start of the LIST chunk, and
	 * combine everything together. We also have to set the total filesize in bytes 5-8 as a little endian number
	 * References: https://en.wikipedia.org/wiki/WAV https://docs.fileformat.com/audio/wav/
	 * @param wavBlob
	 * @param {DownloadStudioData} data
	 * @returns {Promise<*|module:buffer.Blob>}
	 */
	async function addMetadataToWav(wavBlob, data) {
		if (!data.metadataBlobs['wav']) {
			console.error('No metadata blob found.');
			return wavBlob;
		}

		// read the wav until we find the start of the "data" and "LIST" chunks
		const wavAsUint8 = new Uint8Array(await wavBlob.arrayBuffer());

		// this is what we're looking for, as uint8's
		const dataMarker = [0x64, 0x61, 0x74, 0x61]; // data
		const listMarker = [0x4C, 0x49, 0x53, 0x54]; // LIST
		let dataPos = -1;
		let listPos = -1;

		// search through the wav until we find that section. this should not be deep. around 94 bytes in 
		for (let i = 0; (dataPos === -1 || listPos === -1) && (i < wavAsUint8.length - 3); i++) {
			if (
				dataPos === -1 &&
				wavAsUint8[i] === dataMarker[0] &&
				wavAsUint8[i + 1] === dataMarker[1] &&
				wavAsUint8[i + 2] === dataMarker[2] &&
				wavAsUint8[i + 3] === dataMarker[3]
			) {
				dataPos = i;
			} else if (
				listPos === -1 &&
				wavAsUint8[i] === listMarker[0] &&
				wavAsUint8[i + 1] === listMarker[1] &&
				wavAsUint8[i + 2] === listMarker[2] &&
				wavAsUint8[i + 3] === listMarker[3]
			) {
				listPos = i;
			}
		}

		// "data" is the music. if we can't find it, that's pretty bad. just return the original and maybe the user will have better luck playing it
		if (dataPos === -1) {
			console.error('"data" chunk not found in blob1');
			return wavBlob;
		}

		// these are the parts we're going to combine into our final file
		const parts = [
			wavBlob.slice(0, 4), // first four bytes are standard
			new Blob(), // this is the size of the final file
			wavBlob.slice(8, Math.min(dataPos, listPos > -1 ? listPos : dataPos)), // everything up tp the first LIST or data (typically playback spec stuff, like bitrate, etc.)
			data.metadataBlobs['wav'] // the metadata from the server
		];
		// if the "data" chunk is last, just add it to the end of our parts list
		if (dataPos > listPos) {
			parts.push(wavBlob.slice(dataPos));
		} else {
			// if not, we found a "data" and a LIST, in that order. add the area between, which should just be the "data".
			parts.push(wavBlob.slice(dataPos, listPos));
		}
		// now that we have all the parts, sum up their total size and set that in place of our placeholder blob in the second index
		const ab = new ArrayBuffer(4);
		const view = new DataView(ab);
		// reduce() starts with -4 because the spec says the size should not include the first 8 bytes and the placeholder blob in parts[1] is empty but should be 4.
		// so sizeToStore = sumOfAllCurrentSizes + placeholdersFutureSize(4) - 8; sizeToStore = sumOfAllCurrentSizes - 4
		view.setUint32(0, parts.reduce((accumulator, currentBlob) => accumulator + currentBlob.size, -4), true);
		parts[1] = new Blob([ab]);

		return new Blob(parts, { type: wavBlob.type });
	}

	/**
	 * Adds our metadata to the generated aiff file
	 * Reference: https://www.mmsp.ece.mcgill.ca/Documents/AudioFormats/AIFF/Docs/AIFF-1.3.pdf
	 * @param aiffBlob
	 * @param {DownloadStudioData} data
	 * @returns {Promise<*|module:buffer.Blob>}
	 */
	async function addMetadataToAiff(aiffBlob, data) {
		if (!data.metadataBlobs['aiff']) {
			console.error('No metadata blob found.');
			return aiffBlob;
		}

		// these are the parts we're going to combine into our final file
		const parts = [
			aiffBlob.slice(0, 4), // first four bytes are standard
			new Blob(), // placefolder where we will later store the size of the final file
			aiffBlob.slice(8), // the music, etc. from the ffmpeg file
			data.metadataBlobs['aiff'] // the actual metadata
		];
		// set the length into the second index
		const ab = new ArrayBuffer(4);
		const view = new DataView(ab);
		// reduce() starts with -4 because the spec says the size should not include the first 8 bytes and the placeholder blob in parts[1] is empty but should be 4.
		// so sizeToStore = sumOfAllCurrentSizes + placeholdersFutureSize(4) - 8; sizeToStore = sumOfAllCurrentSizes - 4
		view.setUint32(0, parts.reduce((accumulator, currentBlob) => accumulator + currentBlob.size, -4), false);
		parts[1] = new Blob([ab]);

		return new Blob(parts, { type: aiffBlob.type });
	}

	/**
	 * Adds our metadata to the generated mp3 file
	 * ID3v2 tags are simple. They just appear at the very beginning of the MP3 file. ID3v1 tags appear at the end but we don't use those
	 * Here's the ID3v2 spec, in case you're interested. https://mutagen-specs.readthedocs.io/en/latest/id3/id3v2.2.html
	 * @param mp3Blob
	 * @param {DownloadStudioData} data
	 * @returns {Promise<*|module:buffer.Blob>}
	 */
	async function addMetadataToMp3(mp3Blob, data) {
		if (!data.metadataBlobs['mp3']) {
			console.error('No metadata blob found.');
			return mp3Blob;
		}

		// these are the parts we're going to combine into our final file
		const parts = [
			data.metadataBlobs['mp3'].slice(8), // the id3 tag, generated in class.metadataembedder.php->prepare(), is preceeded by an AIFF (big endian) style chunk header. just strip the first 8 bytes
			mp3Blob // the actual mp3
		];
		// mp3's don't store a length or anything else interesting. they're very simple

		return new Blob(parts, { type: mp3Blob.type });
	}

	// cache for the cutdown filters so we don't have to recalculate them for repeated cutdowns
	let cutdownFilters = {};

	/**
	 * Gets the ffmpeg parameter array that applies a cutdown based on the length provided
	 * @param cutdownSeconds
	 * @returns {*}
	 */
	function getCutdownFilter(cutdownSeconds, cutdownSections) {
		if (cutdownFilters[cutdownSeconds]) {
			return cutdownFilters[cutdownSeconds];
		}
		let filterComplex = '';
		let previousSegment = '';

		// Generate atrim filters for each section
		cutdownSections.forEach((section, index) => {
			const segment = `[seg${index}]`;
			filterComplex += `[0:a]atrim=start=${section.start}:end=${section.end},asetpts=PTS-STARTPTS${segment};`;

			if (index > 0) {
				const mixedSegment = `[mixed${index}]`;
				filterComplex += `${previousSegment}${segment}concat=n=2:v=0:a=1${mixedSegment};`;
				previousSegment = mixedSegment;
			} else {
				previousSegment = segment;
			}
		});

		// Add fade out at the end
		filterComplex += `${previousSegment}afade=t=out:st=${Math.max(0, cutdownSeconds - 1)}:d=1[final]`;

		cutdownFilters[cutdownSeconds] = ["-filter_complex", filterComplex, "-map", "[final]"];

		return cutdownFilters[cutdownSeconds];
	}

	/**
	 * @param {Blob} blob
	 * @param {string} newFormat
	 * @param {string} cutdown
	 * @param {string} stemType
	 * @param {DownloadStudioData} data
	 */
	function showSaveDialog(blob, newFormat, cutdown, stemType, data) {
		const tempEl = document.createElement("a");
		document.body.appendChild(tempEl);
		tempEl.style = "display: none";
		const url = window.URL.createObjectURL(blob);
		tempEl.href = url;
		tempEl.download = data.trackData.file.filename.replace('.mp3', (stemType !== defaultStem ? ' - ' + stemType : '') + (cutdown !== defaultCutdown ? ' - ' + cutdown : '') + '.' + newFormat);
		tempEl.click();
		window.URL.revokeObjectURL(url);
	}

	let gettingSectionData = false; // don't double run this function
	/**
	 * Gets section data for the current track. Calls startDownloading again when finished
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 * @param stepTime
	 * @return {Promise}
	 */
	async function getSectionData(container, data, stepTime) {
		return new Promise(async (resolve, reject) => {
			if (gettingSectionData) {
				resolve(null);
				return;
			}
			if (!stepTime) {
				stepTime = data.startStepTime('getSectionData');
			}
			gettingSectionData = true;
			sa.api.request({
				handler: 'download-studio',
				action: 'getFileSections',
				postData: {
					trackId: data.trackData.id,
					generateSections: 1,
					cacheBreak: window.cacheBreak ? 1 : 0,
					downloadKey: data.downloadKey,
				}
			}).then(function (response) {
				gettingSectionData = false;
				if (response.status === 'completed') {
					data.sections = response.sections;
					data.beatMap = response.beatMap;
					showSections(container, data);
					data.endStepTime(stepTime);
					resolve(null);
				} else if (response.status === 'failed') {
					reject(new Error('Sorry, we cannot generate cutdowns for this track at this time. We are investigating the issue. Please try again later.'));
				} else {
					setTimeout(function () {
						getSectionData(container, data, stepTime)
							.then(() => resolve(null));
					}, 2000);
				}
			}).catch(err => {
				gettingSectionData = false;
				sa.alert({ text: err.message });
				setProcessing(false, container);
				reject(err);
			});
		});
	}

	/**
	 * Makes an unnecessary call to getFileSections for timing and logging purposes.
	 * @param {DownloadStudioData} data
	 * @returns {Promise<unknown>}
	 */
	async function recordGetSectionData(data) {
		return new Promise(async (resolve, reject) => {
			const stepTime = data.startStepTime('getSectionData');
			sa.api.request({
				handler: 'download-studio',
				action: 'getFileSections',
				postData: {
					trackId: data.trackData.id,
					generateSections: 0,
					downloadKey: data.downloadKey,
				}
			}).then(function (response) {
				data.endStepTime(stepTime);
				resolve(null);
			}).catch(err => {
				data.log(err.message);
				resolve(null);
			});
		});
	}

	let gettingStems = false; // don't double run this function
	/**
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 * @param {Array} requestedStems
	 * @param stepTime
	 * @returns {Promise<unknown>}
	 */
	async function getStems(container, data, requestedStems, stepTime) {
		return new Promise(async (resolve, reject) => {
			if (gettingStems) {
				resolve(null);
				return;
			}
			if (!stepTime) {
				stepTime = data.startStepTime('getStems');
			}
			gettingStems = true;
			sa.api.request({
				handler: 'download-studio',
				action: 'getStemPaths',
				postData: {
					trackId: data.trackData.id,
					generateStems: 1,
					stems: requestedStems,
					cacheBreak: window.cacheBreak ? 1 : 0,
					downloadKey: data.downloadKey
				}
			}).then(async function (response) {
				gettingStems = false;
				if (response.status === 'completed') {
					// download them
					try {
						data.endStepTime(stepTime);
						data.stems = await downloadAllStems(data, response.stems);
						resolve(null);
					} catch (err) {
						gettingStems = false;
						sa.alert({ text: err.message });
						setProcessing(false, container);
						reject(err);
					}
				} else if (response.status === 'failed') {
					reject(new Error('Sorry, we cannot generate stems for this track at this time. We are investigating the issue. Please try again later.'));
				} else {
					setTimeout(function () {
						getStems(container, data, requestedStems, stepTime)
							.then(() => resolve(null));
					}, 2000);
				}
			}).catch(err => {
				gettingStems = false;
				sa.alert({ text: err.message });
				setProcessing(false, container);
				reject(err);
			});
		});
	}

	/**
	 * @param {DownloadStudioData} data
	 * @param {Array} stemObjects
	 * @returns {Promise<unknown>}
	 */
	function downloadAllStems(data, stemObjects) {
		return new Promise((resolve, reject) => {
			const stepTime = data.startStepTime('downloadAllStems');
			const stemMap = {};
			let rejected = false;
			let done = 0;
			for (let i = 0, len = stemObjects.length; i < len; i++) {
				let stemObject = stemObjects[i];
				if (data.stems[stemObject.stemType]) {
					// if we've already downloaded it, no need to do it again
					data.log(`downloadAllStems - skipping download of ${stemObject.stemType} because it's already been downloaded`);
					stemMap[stemObject.stemType] = data.stems[stemObject.stemType];
					done++;
					if (done === len && !rejected) {
						resolve(stemMap);
					}
				} else {
					downloadStemFile(data, stemObject)
						.then(updatedStemObject => {
							stemMap[updatedStemObject.stemType] = updatedStemObject;
							done++;
							if (done === len && !rejected) {
								data.endStepTime(stepTime);
								resolve(stemMap);
							}
						})
						.catch(err => {
							rejected = true;
							reject(new Error('Sorry, we cannot generate stems for this track at this time. We are investigating the issue. Please try again later.'));
						});
				}
			}
		})
	}

	/**
	 * Pulls the source file down so we can process it
	 * @param {DownloadStudioData} data
	 * @param {{ stemType: string, size: int, signedPath: string }} stemObject data about the object
	 * @returns {Promise<unknown>}
	 */
	function downloadStemFile(data, stemObject) {
		stemObject.blob = null;
		return new Promise((resolve, reject) => {
			data.log(`downloadStemFile - downloading ${stemObject.stemType}`);
			downloadBlob(stemObject.signedPath)
				.then(blob => {
					stemObject.blob = blob;
					resolve(stemObject);
				})
				.catch(err => reject(err));
		});
	}

	/**
	 * Helper function to download a blob with ajax
	 * @param path
	 * @returns {Promise<unknown>}
	 */
	function downloadBlob(path) {
		return new Promise((resolve, reject) => {
			const xmlHTTP = new XMLHttpRequest();
			let error = false;
			let blob;
			xmlHTTP.open('GET', path, true);
			xmlHTTP.responseType = 'arraybuffer';
			xmlHTTP.onload = function (e) {
				blob = new Blob([this.response]);
			};
			xmlHTTP.onerror = function (e) {
				console.error('Download failed', e);
				error = true;
				// sa.api.request({
				// 	handler : 'transcode',
				// 	action : 'recordError',
				// 	postData : { stage: 'downloading', error : e }
				// }).then(() => {}).catch(ee => console.error('Error recording error', ee));
				reject(e);
			};
			xmlHTTP.onprogress = function (pr) {
				//transcoder.#updateProgress(pr.loaded / pr.total * 100);
			};
			xmlHTTP.onloadend = function (e) {
				if (error) return;
				//showSaveDialog(blob, filename);
				resolve(blob);
			}
			xmlHTTP.send();
		});
	}

	let gettingMetadataBlobs = false; // don't double run this function
	/**
	 * @param {JQuery} container
	 * @param {DownloadStudioData} data
	 * @returns {Promise<unknown>}
	 */
	function getMetadataBlobs(container, data) {
		return new Promise((resolve, reject) => {
			if (gettingMetadataBlobs) {
				resolve(null);
				return;
			}
			const stepTime = data.startStepTime('getMetadataBlobs');
			gettingMetadataBlobs = true;
			sa.api.request({
				handler: 'download-studio',
				action: 'getMetadataPaths',
				postData: {
					trackId: data.trackData.id,
					generateStems: 1,
					cacheBreak: window.cacheBreak ? 1 : 0,
					downloadKey: data.downloadKey
				}
			}).then(async function (response) {
				// download the blobs so we're ready
				const types = Object.keys(response);
				let typesInProgress = types.length;
				do {
					const type = types.pop();
					downloadBlob(response[type])
						.then(blob => {
							data.metadataBlobs[type] = blob;
							typesInProgress--;
							if (!typesInProgress) {
								// all are done
								gettingMetadataBlobs = false;
								data.endStepTime(stepTime);
								resolve(null);
							}
						})
						.catch(err => {
							// well that's a bummer, man
							console.error('Unable to download metadata blob for URL', response[type], err);
							gettingMetadataBlobs = false;
							sa.alert({ text: err.message });
							setProcessing(false, container);
							reject(err);
						});
				} while (types.length);
			});
		});
	}

	/**
	 * Toggles a warning to the user if they try to leave while we're processing
	 * @param {boolean} isProcessing
	 * @param {JQuery} container
	 */
	function setProcessing(isProcessing, container) {
		if (isProcessing) {
			container.find('#waiting_loader').addClass('showing');
			unloadFunctions = [function () {
				sa.notify({
					text: `Your files will continue processing and will start downloading when they're ready.`,
					type: sa.notify.notificationTypes.download
				})
				unloadFunctions = [];
				return false;
			}];
		} else {
			unloadFunctions = [];
			container.find('#waiting_loader').removeClass('showing');
		}
	}

	return page;
})();

/**
 * A class to find the best cutdown of a track based on its sections
 * @param sections - an array of objects with start and end properties
 * @param customSettings - an object with settings to override the defaults
 *
 * run find(targetLength) to get the best cutdown
 *
 * This uses an A* search to find the best cutdown based on the settings
 * it calculates a cost of each added section based on its the musicality
 * of a transition from the previous section, minimizing cuts, reuse, and
 * preferring certain types of sections to be included. The heuristic is
 * an estimate of the transition cost of the remaining sections. It will
 * naturally grow, pruning any paths that exceed the target length,
 * finding the path that minimizes the cost of transitions and distance
 * from the target length. It will stop early if it finds a cutdown that
 * is within the accuracy threshold (accuracyThreshold), is unable improve
 * the best solution for a certain amount of time (stagnation), or
 * if it has searched for the maximum amount of time (maxSearchTime).
 *
 * Once a solution is found, it will adjust the last section of
 * the cutdown to meet the target length
 *
 * For targets shorter than the smallest section, it will return a shortened version of the
 * smallest section.
 */
class CutdownFinder {
	defaultSettings = {
		maxSearchTime: 60, // seconds. how long we're willing to search for the best cutdown
		maxOpenSetSize: 50000, // how many nodes we're willing to keep in memory
		maxStagnationTime: 15, // seconds to wait for improvement before stopping
		accuracyThreshold: 1, // seconds. how close to the target length we need to be to stop looking early
		baseCost: 5, // base cost for a step, keeps bonuses from making negative costs
		cutCost: 3, // penalizes non-consecutive sections
		reuseCost: 3, // penalizes reusing the same section
		maxReuses: 3, // how many times we can reuse the same section
		// consistencyCost: 5, // penalizes transitions with dissimilar intensities
		typeCost: { // how much we penalize sections based on their type
			'Chorus': 1,
			'Prechorus': 1,
			'Verse': 1,
			'Instrumental': 2,
			'Instrumental Solo': 3,
			'Intro': 4,
			'Bridge': 5,
			'Outro': 6, // outro is the least flexible
			'default': 3 // if it's an unknown type, use this
		},
		orderCosts: {
			'Verse': {
				'Verse': 1, // small penalty for repeating
				'Intro': 5, // Penalty for going backwards
				'Chorus': -2, // Bonus for good initial transition
				'Bridge': 2,
				'Outro': 5, // Penalty for skipping Chorus
				'Prechorus': -1 // Bonus for good transition
			},
			'Prechorus': {
				'Prechorus': 5, // penalty for repeating
				'Verse': 2, // Natural flow
				'Chorus': -2, // Natural flow
				'Bridge': 5, // penalty for unusual transition
				'Outro': 5, // penalty for unusual transition
				'Intro': 10 // penalty for unusual transition
			},
			'Chorus': {
				'Chorus': 2, // small penalty for repeating
				'Intro': 5, // Penalty for going backwards
				'Verse': 2, // Slight penalty
				'Bridge': -1, // Small bonus for good transition
				'Prechorus': 5 // weird transition
			},
			'Intro': {
				'Intro': 5, // penalty for repeating
				'Verse': -1, // Natural flow
				'Chorus': 5 // Penalty for skipping Verse
			},
			'Outro': {
				'Outro': 5, // penalty for repeating
				'Intro': 20, // outro shouldn't go with anything
				'Verse': 10, // penalty for unusual transition
				'Prechorus': 10, // penalty for unusual transition
				'Chorus': 5, // penalty for unusual transition
				'Bridge': 10, // penalty for unusual transition
				'Instrumental': 10, // penalty for unusual transition
				'Instrumental Solo': 10, // penalty for unusual transition
			},
			'Bridge': {
				'Bridge': 10, // penalty for repeating
				'Chorus': -1, // Good transition
				'Intro': 10 // Penalty for unusual transition
			},
			'default': 3 // if it's an unknown type, use this
		}
	};

	settings = {};
	sections = [];
	averageSectionLength = 0;
	estimatedStepCost = 0;
	smallestSection;
	customLoggingFunction;
	foundLengths = {};

	constructor(sections, customSettings = {}, customLoggingFunction = console.log) {
		this.customLoggingFunction = customLoggingFunction;
		this.settings = { ...this.defaultSettings, ...customSettings };
		this.preprocess(sections);
	}

	/**
	 * - make a deep copy of the sections
	 * - add length property
	 * - add unique IDs
	 * - calculate the average length of a section
	 * - find the smallest section in case the user asks for a cutdown smaller than any section
	 * - calculate the estimated step cost
	 * */
	preprocess(sections) {
		if (this.sections.length) return; // already done

		let sectionLengthSum = 0; // for calculating average
		for (const section of sections) {
			// make a copy so we don't mess with the original
			const sectionCopy = { ...section };

			//calculate lengths
			sectionCopy.length = sectionCopy.end - sectionCopy.start;
			sectionLengthSum += sectionCopy.length;

			// Keep track of the smallest section in case the user asks for a cutdown smaller than any section
			if (!this.smallestSection || sectionCopy.length < this.smallestSection.length) this.smallestSection = sectionCopy;

			// Create a unique identifier for each section based on its type position
			sectionCopy.id = `${sectionCopy.label}_${sectionCopy.start}_${sectionCopy.end}`;
			this.sections.push(sectionCopy);
		}

		// Calculate the average length of a section
		this.averageSectionLength = sectionLengthSum / this.sections.length;
		this.estimatedStepCost = this.getEstimatedStepCost();
	}

	/** estimates the step cost to use for the heuristic based on the settings */
	getEstimatedStepCost() {
		// penalty for cutting and re-use should rarely happen, just skip them
		let cost = this.settings.baseCost;

		// average of all type costs
		cost += this.sections.reduce((total, section) => total + (this.settings.typeCost[section.label] || this.settings.typeCost.default), 0) / this.sections.length;
		// average of all order costs
		cost += Object.keys(this.settings.orderCosts).reduce((total, from) => {
			return total + Object.keys(this.settings.orderCosts[from]).reduce((total, to) => {
				return total + this.settings.orderCosts[from][to];
			}, 0);
		}, 0) / (Object.keys(this.settings.orderCosts).length * Object.keys(this.settings.orderCosts).length);

		return cost;
	}

	createNode({ path, length, pathCost, heuristic, usageCount }) {
		return {
			path: path,
			length: length,
			pathCost: pathCost,
			heuristic: heuristic,
			estimatedCost: pathCost + heuristic,
			usageCount: { ...usageCount }
		}
	}

	getStepCost(currentNode, newSection) {
		let cost = this.settings.baseCost;

		// penalize less preferred sections
		cost += this.settings.typeCost[newSection.label] || this.settings.typeCost.default;

		// Penalize reuse of the same exact section (by ID, not just label)
		cost += (currentNode.usageCount[newSection.id] || 0) * this.settings.reuseCost;

		// first node won't have transition costs
		const lastSection = currentNode.path[currentNode.path.length - 1];

		if (lastSection) {
			// penalty for cutting between sections
			if (lastSection.end !== newSection.start) cost += this.settings.cutCost;

			// type order cost from the matrix
			cost += this.settings.orderCosts[lastSection.label]?.[newSection.label] || this.settings.orderCosts.default;

			// consistency penalty
			// cost += Math.abs(lastSection.intensity - newSection.intensity) * this.settings.consistencyCost;
		}

		// Scale cost by section length relative to average length
		// This makes shorter sections proportionally "cheaper" so they aren't unfairly penalized
		cost *= newSection.length / this.averageSectionLength;

		// Ensure cost isn't negative
		return Math.max(0, cost);
	}

	getHeuristic(targetLength, length) {
		if (length > targetLength) return Infinity; // we went over
		const distanceFromTarget = targetLength - length;
		const remainingSteps = distanceFromTarget / this.averageSectionLength;

		return remainingSteps * this.estimatedStepCost;
	}

	find(targetLength) {
		if (this.foundLengths[targetLength]) {
			return this.foundLengths[targetLength];
		}
		// if all our sections are bigger than the target, skip searching and shorten the smallest one.
		if (this.smallestSection.length > targetLength) {
			let smallestSection = { ...this.smallestSection };
			this.adjustSectionLength(smallestSection, targetLength);
			this.foundLengths[targetLength] = [smallestSection];
			return this.foundLengths[targetLength];
		}

		let openSet = [];
		let startNode = this.createNode({
			path: [],
			length: 0,
			pathCost: 0,
			heuristic: this.getHeuristic(targetLength, 0),
			usageCount: {}
		});
		openSet.push(startNode);

		let bestSolution = startNode;
		let startTime = Date.now();
		let nodesExplored = 0;
		let nodesAdded = 0;
		let nodesPruned = 0;

		// Track the last time we found a better solution
		let lastImprovementTime = startTime;

		// Keep searching while we have options and haven't stagnated
		while (
			// stop if we've run out of options
			openSet.length > 0 &&
			// stop if our best solution is within the accuracy threshold
			Math.abs(targetLength - bestSolution.length) > this.settings.accuracyThreshold &&
			// Stop if no improvement for a while
			(Date.now() - lastImprovementTime) / 1000 < this.settings.maxStagnationTime &&
			// stop if we've been searching too long
			(Date.now() - startTime) / 1000 < this.settings.maxSearchTime

		) {
			// Sort and prune the open set
			openSet.sort((a, b) => a.estimatedCost - b.estimatedCost); // Prioritize lowest cost

			// Prune the open set if it gets too big
			if (openSet.length > this.settings.maxOpenSetSize) {
				const prunedCount = openSet.length - this.settings.maxOpenSetSize;
				openSet = openSet.slice(0, this.settings.maxOpenSetSize);
				nodesPruned += prunedCount;
			}

			// Get the best option to try
			let current = openSet.shift();
			nodesExplored++;

			for (let section of this.sections) {
				// Skip if we're over target
				const newLength = current.length + section.length;
				if (newLength > targetLength) continue;

				// Update reuse count by section ID (not just label)
				const newUsageCount = { ...current.usageCount };
				newUsageCount[section.id] = (newUsageCount[section.id] || 0) + 1;

				// Skip if reusing the exact same section too many times
				if (newUsageCount[section.id] > this.settings.maxReuses) continue;

				// Create new node
				const newNode = this.createNode({
					path: [...current.path, section],
					length: newLength,
					pathCost: current.pathCost + this.getStepCost(current, section),
					heuristic: this.getHeuristic(targetLength, newLength),
					usageCount: newUsageCount
				});

				// Track best valid path: lowest cost estimate, highest accuracy
				if (
					newNode.estimatedCost < bestSolution.estimatedCost &&
					newNode.heuristic < bestSolution.heuristic
				) {
					bestSolution = newNode;

					// Update the improvement time whenever we find any better solution
					lastImprovementTime = Date.now();
					this.customLoggingFunction('New best solution found:', bestSolution);
				}

				// if the new nodes distance to the target is smaller than the smallest section, it cannot be improved. don't push it
				if (targetLength - newNode.length < this.smallestSection.length) continue;

				openSet.push(newNode);
				nodesAdded++;
			}
		}

		// log last improvement time
		this.customLoggingFunction(
			'=== Final Statistics ===\n',
			`Runtime: ${((Date.now() - startTime) / 1000).toFixed(2)} seconds\n`,
			`Nodes added: ${nodesAdded}\n`,
			`Nodes explored: ${nodesExplored}\n`,
			`Nodes pruned: ${nodesPruned}\n`,
			`Solution accuracy: ${Math.abs(targetLength - bestSolution.length).toFixed(2)} seconds\n`,
			`Estimated step cost: ${this.estimatedStepCost.toFixed(2)}\n`,
			`Solution step cost: ${(bestSolution.pathCost / bestSolution.path.length).toFixed(2)}\n`,
			'=== Best Solution ===\n',
			bestSolution
		);

		// Make a copy of the sections we came up with so we can make the final adjustments
		const bestSections = bestSolution.path.map(section => ({ ...section }));

		// Extend the last section to reach the target length
		const extendLastSectionBy = targetLength - bestSolution.length;
		const lastSection = bestSections[bestSections.length - 1];
		this.adjustSectionLength(lastSection, lastSection.length + extendLastSectionBy);

		this.foundLengths[targetLength] = bestSections;
		return this.foundLengths[targetLength];
	}

	adjustSectionLength(section, length) {
		section.length = length;
		section.end = section.start + length;
		return section;
	}

}

class DownloadStudioData {
	trackData;
	sections;
	beatMap;
	stems = {};
	stemOptions;
	metadataBlobs = {};
	logHistory = [];
	logHistoryLastTime = Date.now();
	stepTimes = {};
	downloadKey;

	startStepTime(type) {
		if (!this.stepTimes[type]) {
			this.stepTimes[type] = [];
		}
		const stepTime = { start: Date.now() };
		this.stepTimes[type].push(stepTime);
		return stepTime;
	}

	endStepTime(stepTime) {
		stepTime.end = Date.now();
	}

	saveStepTimes() {
		sa.api.request({
			handler: 'download-studio',
			action: 'recordStepTimes',
			postData: {
				stepTimes: this.stepTimes,
				downloadKey: this.downloadKey,
				trackId: this.trackData.id,
			}
		}).then(() => {
			this.stepTimes = {};
		}).catch((e) => { });
	}

	log() {
		const args = [];
		for (let i = 0, len = arguments.length; i < len; i++) {
			let argument = arguments[i];
			if (typeof argument === 'string') {
				argument = argument.replace(/\r?\n/g, '\r');
			} else if (typeof argument === 'object') {
				argument = JSON.stringify(argument);
			}
			args.push(argument);
		}
		// add the time
		const timeNow = Date.now();
		args.push((timeNow - this.logHistoryLastTime) / 1000);
		this.logHistoryLastTime = timeNow;
		// store the log into our history in case we need to save it to the server
		if (!this.logHistory) {
			this.logHistory = [];
		}
		this.logHistory.push(args);
		// non-superadmins don't see these
		if (!user.hasAdminPermission(AdminPermission.SuperAdmin)) return;
		// superadmins do!
		console.log.apply(Object.create(null), args);
	}

	/**
	 * Sends the current console log history to the server
	 * @param {string} stage
	 */
	saveLogs(stage) {
		sa.api.request({
			handler: 'download-studio',
			action: 'recordError',
			postData: { stage: stage, logs: this.logHistory, url: document.location.href }
		});
	}
}
sa.pages.explorer = (function() {
	let page = {
		name: 'explorer',
		title: 'Track List',
		register: {
			routes: [{
				hash: '#!explorer',
				name: 'tracks',
				pattern: '/tracks'
			}, {
				hash: '#!tracks',
				name: 'tracks',
				pattern: '/tracks',
				id: 'code'
			}, {
				name: 'album',
				hash: '#!album',
				pattern: '/album/:int/:any?',
				id: 'b',
				dontSetTitle: true,
			}, {
				name: 'album',
				hash: '#!explorer',
				pattern: '/album/:int/:any?',
				id: 'b',
				dontSetTitle: true,
			}, {
				name: 'cue-type',
				hash: '#!explorer',
				pattern: '/cue-type/:int/:any?',
				id: 'ct'
			}, {
				name: 'genre',
				hash: '#!explorer',
				pattern: '/genre/:int/:any?',
				id: 'g'
			}, {
				name: 'tempo',
				hash: '#!explorer',
				pattern: '/tempo/:int/:any?',
				id: 't'
			}, {
				name: 'tracks',
				hash: '#!explorer',
				pattern: '/tracks',
				id: 'sim',
				appendParams: true
			}]
		}
	};

	var templates;
	let container;
	var trackList;
	var trackListConfig = new TrackListConfig();
	var albumListAlbum = null;
	var lastParams = '';

	trackListConfig.allowMiniBlock = true;
	trackListConfig.allowBlock = true;
	trackListConfig.bankKey = 'explorer';
	trackListConfig.callback = function(data) { setData(data); };
	trackListConfig.callbackActual = function(data) { setData(data); };
	trackListConfig.useStandardColumnList();
	// trackListConfig.columnList = getStandardColumnList(); // if you change this, change the sorter tool below
	trackListConfig.topBar = true;
	trackListConfig.useCache = true;
	trackListConfig.useFilters = true;

	trackList = createTrackList(trackListConfig);

	page.show = function(params) {
		if (!templates) {
			templates = sa.templates.get('pages.explorer');
		}

		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});

		// Check if it's an album page and hide track filters accordingly
		let isAlbumPage = sa.router.isCurrentRoute('album');

		if (sa.components.leftNav && isAlbumPage) {
			sa.components.leftNav.disableTrackFilters();
		} else if (sa.components.leftNav) {
			sa.components.leftNav.enableTrackFilters();
		}

		if (sa.getCurrentPageName() !== page.name) {

			var template = templates.get('explorer');

			if (sa.components.leftNav) {
				sa.components.leftNav.show();
				sa.components.leftNav.disableAlbumFilters();
			}

			trackList.generatePage(template.find('.track_list'));

			$j('#body').empty().append(template);
			container = template;

		} else if (params.replace(/\??&?start=[0-9.]+/, '') == lastParams.replace(/\??&?start=[0-9.]+/, '')) {
			return;
		}
		
		if (isAlbumPage) {
			// override loading text to say "Loading album..." for albums
			trackListConfig.loadingTextOverride = 'Loading' + ' ' + config.getDictionaryEntry('album', false, true);

			// load related albums if on album page
			const pageParams = sa.router.paramsToVars(params);
			if (pageParams.b && (user.logged || config.showUnloggedHome)) {
				ajax(`p=album_info&sim=${pageParams.b}&show=15`, function (response) {
					if (response.length === 1 || !container) {
						return;
					} else {
						container.find('.similar_albums_container').removeClass('hide');
					}

					var albumContainer = container.find('.similar_albums');
					albumContainer.empty();

					for (var i = 1, len = response.length; i < len; i++) {
						const album = new Album(response[i]);
						const albumEl = (album).generateArtElement({});
						// show genres for debugging
						// albumEl.find('.info').append('<div class="genres">' + album.genres.map(a => a.name).join(', ') + '</div>')
						albumContainer.append(albumEl);
					}

					if (lockdown) {
						sa.lockdownLinks(albumContainer.find('a'));
					}
				});
			}
		} else {
			trackListConfig.loadingTextOverride = '';
			container.find('.similar_albums_container').addClass('hide');

		}
		lastParams = params;
		sa.currentPage = page;
		loadData(params);

		if (user.hasAdminPermission(AdminPermission.Metadata) && config.siteType !== 'buyer') {
			sa.importTrackManager.createDropZone('#explorer_container');
		}
	};

	function loadData(params) {
		let vars = sa.router.getCurrentParamsAsObject();

		if (vars.s) {
			// unset loading text override when searching
			trackListConfig.loadingTextOverride = false;

			if (firstCheck) {
				sa.search.addSearchTerm(vars.s);
				// if the user comes into the site with s=URL, do a Sonic Search instead of a regular search
				if (vars.s.isValidUrl && vars.s.isValidUrl() && config.showSonicSearch) {
					console.log('starting doSearch with', vars.s);
					setTimeout(() => { sa.search.doSearch(vars.s); }, 200);
					trackList.showCover('', 'Running Sonic Search...');
					return;
				}
			}
		}

		trackList.loadPage(params);
	}

	function setData(newData) {
		if (!trackList.setData(newData, getExplorerLink)) return;

		/** @var {ListMetaData} listMetaData */
		var listMetaData = newData[0];
		var vars = sa.router.paramsToVars(listMetaData.pageVars);
		var headingExtra = listMetaData.headingExtra == undefined ? {} : listMetaData.headingExtra;
		sa.components.heading.hide();
		headingExtra.image = listMetaData.headingImage;
		headingExtra.preamble = listMetaData.headingName;
		if (Array.isArray(newData) && newData[0] && newData[0].hasOwnProperty('aiIWantResponse')) {
			// special formatting for AI responses
			headingExtra.aiIWantResponse = newData[0].aiIWantResponse;
		}

		if (listMetaData.album) {
			headingExtra.item = classFromType('album', listMetaData.album);
			headingExtra.type = 'album';
			setTitle(listMetaData.album.name, 'Album');
		}

		if (listMetaData.facets) {
			sa.components.heading.buildFacetTabs(listMetaData.facets, headingExtra, vars.lyrics ? 'lyrics' : 'tracks', vars.lyrics ? vars.lyrics : vars.s);
		}

		albumListAlbum = null;

		$j('#drop_bar').remove();
		if (listMetaData.headingName && listMetaData.headingValue) {
			/**
			 * ALBUM-SPECIFIC RENDERING
			 */
			if (listMetaData.album && newData.length > 1) {
				// Render album
				var album = listMetaData.album;
				albumListAlbum = album;

				// download
				sa.components.heading.addOption(sa.components.downloadFormatSelector.generateDownloadButton({
					type: 'album',
					item: album,
					wide: true,
				}), sa.components.heading.LocationTop);
				// drop receive mode only shows download and add button
				if (config.siteType === 'drop' && config.siteMode === 'receive') {
					sa.components.heading.addOption(sa.components.buttons.generateAddToDropButton({
						type: 'album',
						itemId: album.id
					}), sa.components.heading.LocationBottom);
				} else {
					// email
					sa.components.heading.addOption(sa.components.emailer.generateEmailButton({
						type: 'album',
						item: album,
						wide: true
					}), sa.components.heading.LocationBottom);
					if (user.hasAdminPermission(AdminPermission.Feature)) {
						// featuring
						sa.components.heading.addOption(sa.components.buttons.generateFeatureButton({
							id: album.id,
							type: 'album',
							featured: album.featured,
							wide: true,
							text: 'Feature this ' + gde('album', { plural: false, case: 'lower' })
						}), sa.components.heading.LocationBottom);
					}
					if (album.editable) {
						// edit
						sa.components.heading.addOption(sa.components.buttons.generateEditButton({
							type: 'album',
							item: album,
							wide: true
						}), sa.components.heading.LocationBottom);
						// delete
						sa.components.heading.addOption($j('<a class="button faux_button"><img src="images/shared/delete.png" alt="Delete Album"/> ' + 'Delete' + '</a>').on('click', function() {
							(new Album(album)).delete(function() {
								sa.router.routeTo('/albums');
							});
							return false;
						})[0], sa.components.heading.LocationBottom);
					}
				}
				if (album.hasOwnProperty("image") && album.image) {
					sa.components.heading.addOption(generateArtDownloadButton(album, true, 'Download Cover Art'), sa.components.heading.LocationBottom);
				}
				headingExtra.subtext = album.description;
			}
			if (vars.code) {
				// download
				sa.components.heading.addOption(sa.components.downloadFormatSelector.generateDownloadButton({ type: 'code', item: vars.code, wide: true }), sa.components.heading.LocationTop);
			}

			if (config.showTrackCount && (config.showAllCounts || !listMetaData.headingAll)) {
				headingExtra.count = !config.showNestedCounts && listMetaData.trackCount ? listMetaData.trackCount : listMetaData.count;
			}

			if (user.hasAdminPermission(AdminPermission.Metadata)) {
				if (config.siteType === 'drop') {
					if (listMetaData.headingAll) {
						let dropBar = templates.get('drop_bar');
						dropBar.append(sa.importTrackManager.getUploadButton());
						trackList.container.find('#drop_bar').remove();
						trackList.container.find('#list_top_bar').after(dropBar);
					}
				} else {
					let exportUrl = 'export.php?type=tracks&format=csv&fromTrackList=1&' + listMetaData.pageVars;
					sa.components.heading.addOption($j(`<a class="button" href="${exportUrl}" >Export Metadata</a>`), sa.components.heading.LocationBottom);
				}
			}

			if (listMetaData.spellcheckResult) {
				// show this somehow
				let vars = sa.router.getCurrentParamsAsObject();
				vars.s = listMetaData.spellcheckResult.suggestion;

				let spellCheckedPath = `${sa.router.getCurrentPath()}${sa.router.queryParamsToString(vars)}`;

				if (listMetaData.spellcheckResult.automaticallyApplied) {
					headingExtra.subtext = `No results for <b>${listMetaData.spellcheckResult.original}</b>. Showing results for <b>${listMetaData.spellcheckResult.suggestion}</b>.`;
					sa.router.setHistory(spellCheckedPath, true);
				} else {
					headingExtra.subtext = `Did you mean <a href="${spellCheckedPath}">${listMetaData.spellcheckResult.suggestion}</a>?`;
				}
			}
			sa.components.heading.show(listMetaData.headingValue, headingExtra);
		}
		if (sa.components.leftNav && listMetaData.filters) {
			sa.components.leftNav.showSmartFilters(listMetaData.filters);
		}

		if (sa.components.projector && sa.components.projector.inQuickProjectMode()) {
			page.enableQuickProjects();
		}
	}

	/**
	 * Turns on fast tagging if we're on an album track list page
	 */
	page.enableQuickProjects = function() {
		page.disableQuickProjects();
		// if this is an album track list page, the preamble will talk about albums
		if (albumListAlbum) {
			sa.components.heading.addOption(sa.components.projector.generateQuickProjectAlbumButton(albumListAlbum, { wide: true }), sa.components.heading.LocationLeft, true);
		}
	};

	/**
	 * Turns off fast tagging if we're on a page where it's on
	 */
	page.disableQuickProjects = function() {
		// $j('.button_options .quick_project_button').remove();
		sa.components.heading.removeOption('.quick_project_button', sa.components.heading.LocationLeft, true);
	};

	return page;
})();

sa.pages.genres = (function() {

	let page = {
		name : 'genres',
		title : gde('genre', { c : 'upper', p : true }),
		register : {
			routes: [{
				name: 'genres',
				hash: '#!genres',
				pattern: '/genres',
			}]
		}
	};
	
	var templates;

	page.show = function(params) {
		
		if (!templates) {
			templates = sa.templates.get('pages.genres');
		}

		var template = templates.get('genre_page');
		sa.body.empty().append(template);

		sa.components.leftNav.show();
		sa.components.leftNav.disableAll();

		sa.currentPage = page;

		loadPage();

	};

	function loadPage() {
		ajax({ p : 'genres' }, function(response) {
			setData(response);
		});
	}

	function setData(genres) {

		// determine whether we want to link to filters or just straight results
		if (!sa.components.leftNav.isLoaded()) {
			setTimeout(function() { setData(genres); }, 100);
			return;
		}
		var hasGenreFilter = sa.components.leftNav.hasGenreFilter();

		var container = $j('.genre_list');
		var linkBase = siteBaseUrl() + '/tracks?' + (hasGenreFilter ? 'genre%5B%5D' : 'g') + '=';

		for (var i = genres.length - 1; i >= 0; i--) {
			var genre = genres[i];
			var template = templates.get('genre_button', {
				link : linkBase + genre.id,
				genreName : genre.name,
				genreCount : genre.count.numberFormat()
			});
			container.prepend(template);
		}

		sa.components.heading.hide();
		sa.components.heading.show('Browse by ' + gde('genre', { p : false, c : 'upper' }));

	}

	return page;

})();
sa.pages.home = (function () {
	const page = {
		name: 'home',
		title: 'Home',
		register: {
			routes: [{
				hash: '#!home',
				name: 'home',
				pattern: '/home'
			}, {
				hash: '#!home',
				name: 'blog',
				pattern: '/blog/:int?',
				id: 'blogId'
			}]
		}
	};
	
	page.show = function (params) {
		const urlParams = new URLSearchParams(params);
		if (config.siteType === 'buyer') {
			sa.pages.home.licensee.show(params);
		} else if (urlParams.has('editMode') && urlParams.get('editMode') === true) {
			sa.pages.home.homemaker.showEdit(params);
		} else {
			sa.pages.home.homemaker.show(params);
		}
	};
	
	return page;
})();
sa.pages.pageNotFound = (function() {
	const page = {
		name: 'Page Not Found',
		title: '404 - Not Found',
		register: {
			routes: [{
				hash: '#!pageNotFound',
				name: 'page-not-found',
				pattern: '/page-not-found',
			}],
		},
	};
	
	let templates;
	
	page.show = (failedUrl) => {
		if (!templates) {
			templates = sa.templates.get('pages.page_not_found');
		}
		
		const template = templates.get('not-found', {
			homePageUrl: siteBaseUrl(),
		});
		template.find('#take_me_back').on('click', () => { history.go(-2); });
		
		// Set requested URL if applicable
		if (failedUrl) {
			if (BrowserDetect.isIE11) {
				let infoHtml = `<div>The requested url was: ${failedUrl.href}</div>`;
				template.find('.requested-url').show().html(infoHtml);
			} else {
				let infoHtml = `
					<span class="info-name">
						Requested URL:
					</span>
					<span class="info-value">${failedUrl.href}</span>
					<span class="info-copy"><a><i class="fa fa-clone"></i></a></span>
				`;
				template.find('.requested-url').show().html(infoHtml);
				// copy text button
				template.find('.info-copy a').on('click', function(e) {
					const url = $j(this).closest('.requested-url').find('.info-value').text();
					// Copy the text inside the text field
  					navigator.clipboard.writeText(url);
				})
			}
		}
		
		// Find good color
		const bgColor = $j('body').css('background-color');
		// Since, the background-color comes back as "rgb(255, 255, 255)", this works
		const [r, g, b] = bgColor.match(/\d+/g);
		const textColor = getBWContrastingColor(r, g, b);
		
		template.find('#right_content').css('color', textColor);
		template.find('#right_content a').css('color', textColor);
		
		sa.body.empty().append(template);

		sa.components.leftNav.hide();
		sa.components.leftNav.disableAll();

		sa.currentPage = page;
	};
	
	return page;
})();
/*
	The core concept to understand for the page building is how the layout works. The data is stored in rows that
	have a type (wide, split, etc.) and a list of components. The components are stored in the order they appear.
	
	// Components
	const A = { data..., type: 'wide };
	const B = { data...,  type: 'left };
	const C = { data...,  type: 'right' };
	
	// Overall Layout
	const layout = [
		{ type: 'wide', items: [A] },
		{ type: 'split', items: [B, C] }
	];
	
	|---------------------|
	|         A           | <-- row 0
	|_____________________|
	|--------------|------|
	|     B        |  C   | <-- row 1
	|______________|______|
	|---------------------|
	
	When new components are added, their place in the layout are calculated based on siblings and parent elements.
	Each component is given a UUID to help when filtering/finding/removing components in the array/layout.
	
	When components are dragged around, the layout is updated to reflect the new order.
 */

sa.pages.home.homemaker = (function () {
	const home = {
		name: 'home',
		saving: false,
		layout: [],
		rowLayout: [],
		rowInitialIndex: -1,
		componentInitialIndex: null,
		clonedLayout: [],
		appendOrPrepend: null,
		hoveredComponent: null,
		blogs: null,
		hcode: null,
		editingModeOn: false,
		narrowLayout: true
	};
	
	let templates;
	
	let components = [];
	
	let eventAbortController = registerEventAbortController('homepage');

	function getComponent(key) {
		return components.find(component => component.key === key);
	}

	function showBlog(blogId) {
		ajax(`p=homemaker&action=blog&blogId=${blogId}&cacheBreak=${new Date().getTime()}`, (response) => {
			if (sa.currentPage.name !== home.name) {
				return; // don't overwrite if the user has navigated away
			}

			const r = response[0];

			const cont = templates.get('frame');

			if (!r.blog) {
				cont.html('No such blog exists.');
				return;
			}

			const component = new HomemakerBlog();
			component.buildBlogPage(cont, r.blog);

			$j('#body').empty().append(cont);
		});
	}
	
	function resetGridSizes() {
		$j('.component-body .custom-items-component-container').each(function () {
			const componentContainer = $j(this);
			const homemakerComponent = new HomemakerComponent();
			homemakerComponent.configureItemsPerRow(componentContainer);
		});
		
		// Re-render any carousels -- the carousels don't resize appropriately when the grid size changes, so we force them to re-render
		home.layout.forEach(row => {
			row.items.forEach(component => {
				if (component.key === 'carousel') {
					const componentBuilder = getComponent(component.key).build;
					home.rerenderComponent(component, componentBuilder);
				}
			});
		});
	}
	
	/**
	 * Build out the component menu for when user is editing the home page
	 */
	function buildComponentMenuIcons() {
		if ($j('.component-options .component-option').length) return;
		
		// Component Menu Icon Template
		const componentTemplate = $j(`
			<div class="component-option draggable-item">
				<i class="fa"></i>
				<div class="component-title">Carousel</div>
			</div>
		`);

		// Loop through the available component and build out the component menu
		for (let i = 0; i < components.length; i++) {
			const component = components[i];

			const componentIcon = componentTemplate.clone();
			componentIcon.find('i').addClass(component.icon);
			componentIcon.find('.component-title').html(component.title);
			componentIcon.data('component', component);

			$j('.component-options .component-options-list').append(componentIcon);
		}
		
		// Adding toggles to menu
		home.addDisplaySizeToggle();
		home.addComponentShadowToggle();
		home.addComponentHeaderDisplayToggle();
		
		// Check if it should already be set
		if (home.narrowLayout) {
			$j('.homepage-editing-display-size-options input').prop('checked', 'checked');
		}
		
		// Build the Layout Option Components
		const fullWidthOption = componentTemplate.clone();
		fullWidthOption.addClass('wide-column-option').addClass('add-row-component-option');
		fullWidthOption.find('.component-title').text('Full Width');
		fullWidthOption.find('.fa').addClass('fa-window-maximize');
		
		const splitColumnOption = componentTemplate.clone();
		splitColumnOption.addClass('split-column-option').addClass('add-row-component-option');
		splitColumnOption.find('.component-title').text('Split Row');
		splitColumnOption.find('.fa').addClass('fa-columns');
		
		$j('.component-row-options-list').append(fullWidthOption);
		$j('.component-row-options-list').append(splitColumnOption);
	}
	
	function resizeComponentSidebar() {
		const optionsSidebar = $j('.component-options-fixed');
		const editingBarVisible = isElementInViewport($j('.editing-bar'));
		const editingBarDimensionInfo = getElementDimensionInfo($j('.editing-bar'));
		const searchBarDimensionInfo = getElementDimensionInfo($j('#search_container'));
		const bottomBarDimensionInfo = getElementDimensionInfo($j('#bottom_bar'));
		const playerControls = isElementInViewport($j('.player_controls_container'), { bottom: -40 });
		const playerControlsDimensions = getElementDimensionInfo($j('.player_controls_container'));
		
		if (editingBarVisible) {
			// Height of sidebar is from bottom of editing bar to top of play bar
			optionsSidebar.css({
				height: bottomBarDimensionInfo.top - editingBarDimensionInfo.bottom,
				overflowY: 'scroll',
				top: editingBarDimensionInfo.bottom
			});
		} else if (playerControls) {
			// Height of sidebar is from bottom of search bar to top of footer
			optionsSidebar.css({
				height: playerControlsDimensions.top - searchBarDimensionInfo.bottom,
				overflowY: 'scroll',
				top: searchBarDimensionInfo.bottom
			});
		} else {
			optionsSidebar.css({
				height: bottomBarDimensionInfo.top - searchBarDimensionInfo.bottom,
				overflowY: 'scroll',
				top: searchBarDimensionInfo.bottom
			});
		}
	}

	/**
	 * Build out a components information object that is used to build the component later
	 */
	const buildComponentData = (currentEl) => {
		const componentBuilderData = $j(currentEl).data('component');
		const parentContainer = $j(currentEl).parent();

		// Get div positioning info
		let side = 'wide';
		if (parentContainer) {
			const inLeftColumn = parentContainer.hasClass('left-column');
			const inRightColumn = parentContainer.hasClass('right-column');

			if (inLeftColumn) side = 'left';
			if (inRightColumn) side = 'right';
		}

		// Build out the new component's data that is passed to it's "build" method
		const componentData = {
			div: componentBuilderData.div.clone(),
			type: side,
			key: componentBuilderData.key,
			temp: true,
			first: true,
			settings: {
				hcode: home.hcode ? home.hcode : ''
			}
		};

		// Add in example data for the carousel, otherwise it will break when rendering
		if (componentBuilderData.key === 'carousel') {
			componentData.settings.items = [
				{
					title: '',
					url: '',
					heading: 'Your heading here',
					subheading: 'Description Goes Here',
					image: 'images/home/default-carousel.jpg'
				}
			];
		}

		return [componentData, componentBuilderData];
	};

	/**
	 * Handle the layout change when a component is added or modified on the page
	 * 
	 * @param component
	 * @param siblingOrWideEl
	 * @param type
	 */
	function handleComponentChange(component, siblingOrWideEl, type) {
		const rowIndex = $j('.homepage-columns').index(siblingOrWideEl.closest('.homepage-columns'));
		const row = home.layout.at(rowIndex);

		const parentEl = siblingOrWideEl.parent();
		const isInsideLeftColumn = siblingOrWideEl.hasClass('left-column') || siblingOrWideEl.parent().hasClass('left-column');
		const isInsideRightColumn = siblingOrWideEl.hasClass('right-column') || siblingOrWideEl.parent().hasClass('right-column');

		component.type = 'wide';
		if (isInsideLeftColumn) component.type = 'left';
		if (isInsideRightColumn) component.type = 'right';

		const componentIndex = parentEl.find('.component').index(siblingOrWideEl);

		if (type === 'new') {
			row.items.push(component);
		} else if (type === 'prev') {
			row.items.splice(componentIndex, 0, component);
		} else if (type === 'next') {
			row.items.splice(componentIndex - 1, 0, component);
		}
	}

	/**
	 * Build the component
	 * 
	 * @param event
	 * @param ui
	 */
	function buildComponentFromData(evt) {
		// If we weren't dragging a component option, don't do anything
		if (!$j(evt.item).hasClass('component-option')) {
			return;
		}
		
		// Assign some variables for the different elements we will be working with
		let droppingIntoEl = $j(evt.to);
		const currentEl = $j(evt.item);

		// Extract the component information and the builder object from stored data in component type option
		const [component, componentBuilder] = buildComponentData(currentEl);

		if (component && component.key === 'blog' && home.blogs && home.blogs.length) {
			component.settings.blogs = home.blogs;
		}

		// Set the unique id on the div to aid with finding and working with the component in the layout
		const componentUUID = uuidv4();
		component.uuid = componentUUID;
		component.div.attr('data-uuid', componentUUID);

		// Component Delete Click Event Handler
		component.div.find('.delete-component-option').on('click', function () {
			const currentComponent = $j(this).closest('.component');

			const rowIndex = $j('.homepage-columns').index(currentComponent.closest('.homepage-columns'));
			const componentIndex = currentComponent.closest('.homepage-columns').find('.component').index(currentComponent);

			home.layout[rowIndex].items.splice(componentIndex, 1);

			currentComponent.remove();
		});

		// Component Edit Click Event Handler
		component.div.find('.edit-component-option').on('click', () => {
			componentBuilder.showSettings(component, home);
		});

		// Copying component data into the new component
		component.div.data('component', component);
		$j(component.div).insertAfter($j(evt.item));
		
		// Add "isNew" property to component to indicate this is a new component and not an existing one
		component.isNew = true;

		// Calling the component "build" method to render the component to the page
		componentBuilder.build(component, home);

		// Check for siblings
		const prevSibling = component.div.prev('.component');
		const nextSibling = component.div.next('.component');
		
		if (!prevSibling.length && !nextSibling.length) {
			droppingIntoEl = component.div.parent();
			handleComponentChange(component, droppingIntoEl, 'new');
		} else if (prevSibling.length) {
			handleComponentChange(component, prevSibling, 'prev');
		} else if (nextSibling.length) {
			handleComponentChange(component, nextSibling, 'next');
		}

		// Remove old icon
		setTimeout(() => {
			$j('.home-content .component-option').remove();
		}, 0);
	}

	/**
	 * Set up the drag and drop system for the components
	 * 
	 * @param {HTMLElement} rowEl
	 */
	function initializeColumnComponentSorting(rowEl) {
		const columnOptions = {
			group: {
				name: 'components',
			},
			dragClass: 'dragged-component',
			handle: '.move-component-option',
			forceFallback: true,
			onChoose: function (evt) {
				const { from, item } = evt;
				// Figure out row and component indexes
				const fromRowIndex = $j('.homepage-columns').index($j(from).parent());
				const componentIndex = $j(from).parent().find('.component').index($j(item));
				
				// Is this component in a wide row, or a split row?
				let side = 'wide';
				side = $j(from).hasClass('left-column') ? 'left' : side;
				side = $j(from).hasClass('right-column') ? 'right' : side;

				// Set the info about where the component is coming from (to be used to calculate later)
				home.currentComponentInfo = {
					fromRowIndex,
					componentIndex,
					side
				};
			},
			onEnd: function (evt) {
				const { from, to, item } = evt;

				const fromEl = $j(from);
				const toEl = $j(to);
				const currentItem = $j(item);

				// Figure out row and component indexes
				const fromRowIndex = $j('.homepage-columns').index(fromEl.parent());
				const toRowIndex = $j('.homepage-columns').index(toEl.parent());
				const fromComponentIndex = home.currentComponentInfo.componentIndex;
				const toComponentIndex = toEl.parent().find('.component').index($j(item));

				// Is this component in a wide row, or a split row?
				let side = 'wide';
				side = toEl.hasClass('left-column') ? 'left' : side;
				side = toEl.hasClass('right-column') ? 'right' : side;

				// If we've "moved" the component (like clicking and holding, but not swapping with another), don't do anything
				const hasNotMoved = fromRowIndex === toRowIndex
					&& fromComponentIndex === toComponentIndex
					&& side === home.currentComponentInfo.side;

				if (hasNotMoved) return;

				// Get the component to move and modify if necessary
				const componentToMove = home.layout[fromRowIndex].items.splice(fromComponentIndex, 1)[0];
				if (!componentToMove) return;

				// Set the correct position type for the component based on where it's been dropped
				if (currentItem.parent().hasClass('left-column')) {
					componentToMove.type = 'left';
					currentItem.removeClass(['right', 'wide']).addClass('left');
				}
				if (currentItem.parent().hasClass('right-column')) {
					componentToMove.type = 'right';
					currentItem.removeClass(['left', 'wide']).addClass('right');
				}
				if (currentItem.parent().hasClass('homepage-wide-column')) {
					componentToMove.type = 'wide';
					currentItem.removeClass(['right', 'left']).addClass('wide');
				}

				// Get the build method from the component type and re-render the component
				const componentBuilder = getComponent(componentToMove.key).build;
				home.rerenderComponent(componentToMove, componentBuilder);

				// Move component within the layout array
				home.layout[toRowIndex].items.splice(toComponentIndex, 0, componentToMove);
			}
		};

		Sortable.create(rowEl, columnOptions);
	}

	/**
	 * Initialize the sortable logic for the homepage builder
	 */
	function setUpSortingLogic() {
		// Set up the Row Sorting / Dragging Logic
		const homeContent = document.querySelector('.home-content');
		Sortable.create(homeContent, {
			group: {
				name: 'rows'
			},
			draggable: '.sortable-row',
			handle: '.move-row',
			forceFallback: true,
			onChoose: function (evt) {
				const oldRowIndex = $j('.homepage-columns').index($j(evt.item));
				
				home.currentRowInfo = {
					oldRowIndex	
				};
			},
			onEnd: function (evt) {
				const currentRowIndex = $j('.homepage-columns').index($j(evt.item));
				
				// Replace the row from the old index to the new index in the layout array
				const row = home.layout.splice(home.currentRowInfo.oldRowIndex, 1)[0];
				home.layout.splice(currentRowIndex, 0, row);
			}
		});
		
		// Set up the row type creation draggable
		const rowTypeOptions = document.querySelector('.component-row-options-list');
		Sortable.create(rowTypeOptions, {
			group: {
				name: 'rows',
				put: false,
				pull: 'clone'
			},
			sort: false,
			item: '.component-option',
			chosenClass: 'chosen-component',
			forceFallback: true,
			onEnd: function (evt) {
				if (evt.from === evt.to) return;

				const containingElement = $j(evt.to);

				// Load possible templates
				const wideColumnTemplate = templates.get('widecolumn');
				const splitColumnTemplate = templates.get('columns');

				// Get new row element and index
				const newRowPlaceholder = $j(evt.item);
				const newRowIndex = evt.newIndex;

				// Check what kind of row is going to be added
				const isWideRow = newRowPlaceholder.hasClass('wide-column-option');
				const rowTemplateToUse = isWideRow ? wideColumnTemplate : splitColumnTemplate;
				const rowType = isWideRow ? 'wide' : 'split';

				// Check if there is an element already at the new row's index in order to determine to insert new one before or after it
				const existingRow = containingElement.find('.sortable-row').eq(newRowIndex);
				const existingRowIndex = existingRow.length ? containingElement.find('.sortable-row').index(existingRow) : 0;
				
				if (existingRow.length) {
					$j(rowTemplateToUse).insertBefore(existingRow);
				} else {
					$j(rowTemplateToUse).appendTo(containingElement);
				}

				home.layout.splice(newRowIndex, 0, {
					type: rowType,
					items: []
				});

				// This is the icon for the row type that is replaced by the rendered component
				newRowPlaceholder.remove();

				// Since we've added a new row, we need to make sure that it (and any others) have sorting logic applied to them
				$j('.sortable-row').eq(newRowIndex).find('.sortable-section').each(function () {
					const el = $j(this)[0];
					initializeColumnComponentSorting(el);
				});
			}
		});
		
		// Set up the component options sorting / dragging logic
		const componentOptionsList = document.querySelector('.component-options-list');
		Sortable.create(componentOptionsList, {
			group: {
				name: 'components',
				put: false,
				pull: 'clone'
			},
			item: '.component-option',
			chosenClass: 'chosen-component',
			forceFallback: true,
			sort: false,
			onEnd: function (evt) {
				if (evt.from === evt.to) return;
				
				buildComponentFromData(evt);
			}
		});
		
		// Set up the components sorting / dragging logic
		const columns = document.querySelectorAll('.left-column, .right-column, .homepage-wide-column');
				
		[...columns].forEach(column => {
			initializeColumnComponentSorting(column);
		});
	}

	/**
	 * Set up the event listeners for components and rows
	 */
	function handleComponentEvents() {
		// Set up the component close handler
		$j(document).on('click', '.component-close', function () {
			$j(this).closest('.component-settings-container').fadeOut(400, function () {
				$j(this).remove();
			});
		});

		$j(document).on('keydown', (e) => {
			const componentSettingsOpen = !!$j('.component-settings-container').length;
			if (e.which === 27 && componentSettingsOpen) {
				$j('.component-settings-container').fadeOut(400, function () {
					$j(this).remove();
				});
			}
		});
		
		// Handle Removing a Row
		$j(document).on('click', '.remove-row', function () {
			const row = $j(this).closest('.homepage-columns');
			const rowIndex = $j('.homepage-columns').index(row);
			if (rowIndex < 0) return;
			
			const numberOfRemainingRows = $j('.homepage-columns').length;
			if (numberOfRemainingRows === 1) {
				sa.alert({
					text: 'You must have at least one row on the homepage.'
				});
				return;
			}
			
			row.remove();
			
			home.rowLayout = !home.rowLayout.length ? home.layout : home.rowLayout;
			home.rowLayout.splice(rowIndex, 1);

			loadComponents(true);
			setUpSortingLogic();
		});
		
		// Handle Split / Join Events for Rows
		$j(document).on('click', '.join-row', function () {
			const row = $j(this).closest('.homepage-columns');
			const rowIndex = $j('.homepage-columns').index(row);
			if (rowIndex < 0) return;
			
			home.rowLayout = !home.rowLayout.length ? home.layout : home.rowLayout;
			
			home.rowLayout[rowIndex].type = 'wide';
			home.rowLayout[rowIndex].items.map(item => {
				item.type = 'wide';
				return item;
			});

			loadComponents(true);
			setUpSortingLogic();
		});

		// Handles the logic for turning a row into two column / split layout
		$j(document).on('click', '.split-row', function () {
			const row = $j(this).closest('.homepage-columns');
			const rowIndex = $j('.homepage-columns').index(row);

			if (rowIndex < 0) return;

			home.rowLayout = !home.rowLayout.length ? home.layout : home.rowLayout;
			
			home.rowLayout[rowIndex].type = 'split';
			home.rowLayout[rowIndex].items.map(item => {
				item.type = 'left';
				return item;
			});

			loadComponents(true);
			setUpSortingLogic();
		});
		
		// Handle Resize Events for all components
		const componentResizeListener = _.debounce(() => {
			if (BrowserDetect.isTouchDevice) return;
			resetGridSizes();
		}, 500);

		const orientationChangeListener = _.debounce(() => {
			resetGridSizes();
		}, 500);

		if (eventAbortController && !eventAbortController.signal.aborted) {
			// Remove old abort controller and make a new one
			eventAbortController = registerEventAbortController('homepage', true);
		}
		window.addEventListener('resize', componentResizeListener, { signal: eventAbortController.signal });
		window.addEventListener('orientationchange', orientationChangeListener, { signal: eventAbortController.signal });
	}

	/**
	 * Rebuild a component after it has been updated
	 * 
	 * @param component
	 * @param build
	 * @param home
	 */
	home.rerenderComponent = function (component, build) {
		component.isNew = false;
		component.div.find('.component-body').empty();
		build(component, home);
	};

	/**
	 * Remove a component from the layout based on it's UUID
	 * 
	 * @param uuid
	 */
	home.removeComponentFromLayout = function (uuid) {
		for (let i = 0; i < home.layout.length; i++) {
			const row = home.layout[i];
			for (let j = 0; j < row.items.length; j++) {
				const component = row.items[j];
				if (component.uuid === uuid) {
					row.items.splice(j, 1);
					break;
				}
			}
		}
	};

	/**
	 * Reloads (rebuilds) component(s) after modification or when saving the page
	 * 
	 * @param components
	 * @param build
	 */
	home.reloadComponents = function (components, build) {
		if (Array.isArray(components)) {
			// handle multiple
			components.forEach(component => {
				home.rerenderComponent(component, build);
			});
		} else {
			// handle single component re-render
			home.rerenderComponent(components, build);
		}
	};

	/**
	 * Loads in all the different types of components, ready to be used
	 */
	function loadComponentData() {
		if (!components.length) {
			components = [
				new HomemakerCarousel(),
				new HomemakerTextBlock(),
				new HomemakerFeaturedTracks(),
				new HomemakerFeaturedAlbums(),
				new HomemakerFeaturedArtists(),
				new HomemakerFeaturedWriters(),
				new HomemakerFeaturedLabels(),
				new HomemakerFeaturedCatalogs(),
				new HomemakerFeaturedPlaylists(),
				new HomemakerBlog(),
				new HomemakerSocial()
			];
		}
	}

	/**
	 * Loads and builds all the actual components that exist in a user's homepage layout
	 * 
	 * @param {boolean} reloadAll
	 */
	function loadComponents(reloadAll = false) {
		if (reloadAll) {
			$j('.home-content').empty();
		}
		
		const homeContent = $j('.home-content');
		
		// Loop through the layout rows
		for (let i = 0; i < home.rowLayout.length; i++) {
			// Loading in rows
			const row = home.rowLayout[i];
			const rowEl = row.type === 'split' ? templates.get('columns') : templates.get('widecolumn');
			
			const componentsToRender = [];
			
			// Loop through components in the row
			for (let y = 0; y < row.items.length; y++) {
				const item = row.items[y];
				item.uuid = uuidv4();
				
				const component = getComponent(item.key);
				
				if (!component) {
					console.warn(`No component found matching the key: ${item.key}`);
					continue;
				}

				// Set the current component's div to a clone of the default component's HTML and add a "type" class
				item.div = component.div.clone(true).addClass(item.type);
				
				// Set the unique id on the div
				item.div.attr('data-uuid', item.uuid);
				
				// Setup Click Handlers
				item.div.find('.delete-component-option').on('click', function () {
					// get the position of this component					
					const currentComponent = $j(this).closest('.component');
					
					const rowIndex = $j('.homepage-columns').index(currentComponent.closest('.homepage-columns'));
					const componentIndex = currentComponent.closest('.homepage-columns').find('.component').index(currentComponent);
					
					home.layout[rowIndex].items.splice(componentIndex, 1);
					
					currentComponent.remove();
				});

				item.div.find('.edit-component-option').on('click', function () {
					component.showSettings(item, home);
				});

				// Set up some properties on the component
				if (!item.settings) item.settings = {};
				if (home.hcode) item.settings.hcode = home.hcode;
				if (item.key === 'blog') item.settings.blogs = home.blogs;
				
				// Add the component to the row
				if (item.type === 'left') {
					rowEl.find('.left-column').append(item.div);
				} else if (item.type === 'right') {
					rowEl.find('.right-column').append(item.div);
				} else {
					rowEl.find('.homepage-wide-column').append(item.div);
				}
				
				// Add the component and it's data to the queue to be rendered
				componentsToRender.push({
					data: item,
					builder: component
				});
			}

			homeContent.append(rowEl);
			
			componentsToRender.forEach(component => {
				component.builder.build(component.data, home);
			});
		}
		
		// Fix order in layout -- the layout array and the actual elements laid out on the page aren't always in sync
		$j('.home-content .homepage-columns').each(function (rowIndex) {
			$j(this).find('.component').each(function (componentIndex) {
				const uuid = $j(this).attr('data-uuid');
				const visualRowIndex = rowIndex;
				const visualComponentIndex = componentIndex;
				
				const layoutIndexes = {};
				home.rowLayout.forEach((row, index) => {
					const layoutComponentIndex = row.items.findIndex(component => component.uuid === uuid);
					if (layoutComponentIndex > -1) {
						layoutIndexes.rowIndex = index;
						layoutIndexes.componentIndex = layoutComponentIndex;
					}
				});
				
				if (layoutIndexes.hasOwnProperty('rowIndex')) {
					if (layoutIndexes.rowIndex !== visualRowIndex || layoutIndexes.componentIndex !== visualComponentIndex) {
						const component = home.rowLayout[layoutIndexes.rowIndex].items.splice(layoutIndexes.componentIndex, 1);
						home.rowLayout[visualRowIndex].items.splice(visualComponentIndex, 0, component[0]);
					}
				}
			});
		});
		
		home.layout = home.rowLayout;
	}

	function showHome(params) {
		if (BrowserDetect.isMobile()) {
			sa.body.addClass('is-mobile');
		} else {
			sa.body.removeClass('is-mobile');
		}
		
		ajax('p=homemaker&action=load&cacheBreak=' + (new Date().getTime()), (response) => {
			$j('body').addClass('is-home-page');

			// don't overwrite if the user has navigated away
			if (sa.currentPage.name !== home.name) {
				return; 
			}

			// Get the main home container template
			const homeContainer = templates.get('frame');

			// Check if a user has access to edit the homepage
			const canAccessEdit = home.editPermission
				|| user.userData.siteOwner
				|| (user.userData.adminPermissions && user.userData.adminPermissions.includes('custom_pages'));

			if (!canAccessEdit) {
				homeContainer.find('.editing-bar').remove();
				homeContainer.find('.no-content-placeholder').remove();
			}
			
			// If the workspace is a gray label workspace, hide the home page builder
			if (config.grayLabel) {
				homeContainer.find('.editing-bar').remove();
				homeContainer.find('.no-content-placeholder').html(`
					<span style='text-align: center;'>Your workspace is a free grey label, upload and music management only workspace. 
					<br>To use the home page builder and other advanced features, please contact us 
					(<a href="mailto:sales@sourceaudio.com">sales@sourceaudio.com</a>) and upgrade your workspace.</span>
				`).css('border', 'none');

				sa.body.addClass('empty-homepage-layout');

				sa.body.empty().append(homeContainer);
				
				return;
			}
			
			// If no response or no layout available
			if ((!response[0] || response[0].layout.length === 0) && !params.editMode) {
				sa.body.addClass('empty-homepage-layout');
				
				homeContainer.find('.no-content-placeholder button').on('click', () => {
					sa.router.routeTo('/home?editMode=true');
				});
				
				sa.body.empty().append(homeContainer);
				return;
			}
			
			// If no components loaded, load 'em here
			loadComponentData();
			
			// Get the response and set some property values on the home object
			const resp = response[0];
			const { 
				layout,
				showShadows,
				showComponentHeaders,
				blogs,
				hcode,
				editPermission,
				narrowLayout 
			} = resp;
			home.blogs = blogs;
			home.hcode = hcode;
			home.showShadows = showShadows;
			home.showComponentHeaders = showComponentHeaders;
			home.narrowLayout = narrowLayout;
			home.editPermission = editPermission;
			home.layout = layout || home.layout;
			home.homeBackgroundRepeat = config.theme.homeBackground.options.repeat || 'no-repeat';
			home.homepageBgImage = config.theme.homeBackground.path || '';
			
			home.setupHomeBackgroundStyles();

			// Converts the old layout format into the new layout format
			home.rowLayout = home.transformLayout(home.layout);

			homeContainer.find('#activate-edit-mode').on('click', () => {
				sa.router.routeTo('/home?editMode=true');
			});
			
			// Show the "Add Blogs" button if there are blogs available. If not, adding a blog component will have a link to add them
			if (home.blogs && home.blogs.length) {
				homeContainer.find('#add-blogs').show();
				homeContainer.find('#add-blogs').on('click', () => {
					sa.confirm({
						text: 'Are you sure you want to leave this page? All unsaved changes will be lost.',
						yesFunction: () => {
							sa.router.routeTo('/admin?p=custom_pages&tab=blog');
						}
					});
				});
			}

			// Toggle editing mode / preview mode
			homeContainer.find('#preview-home-page-btn').on('click', function () {
				const inEditingMode = $j('#homepage').hasClass('editing-home-content');
				if (inEditingMode) {
					$j('#homepage').removeClass('editing-home-content');
					$j('#body').removeClass('homepage-editing-mode-on');
					$j(this).text('Resume Editing');
				} else {
					$j('#homepage').addClass('editing-home-content');
					$j('#body').addClass('homepage-editing-mode-on');
					$j(this).text('Preview Changes');
				}
				
				resetGridSizes();
			});

			// Save the homepage
			homeContainer.find('#save-home-page-btn').on('click', () => {
				// Remove component menu options
				$j('.component-options .component-options-list').empty();

				// Turn off event handlers (temporary)
				$j('#add-multi-column').off('click');
				$j('#add-wide-column').off('click');

				// Remove editing class
				$j('#homepage').removeClass('editing-home-content');
				home.save();
			});
			
			// If there are components, hide the default placeholder information
			if (home.layout.length > 0) {
				homeContainer.find('.no-content-placeholder').remove();
			}

			// Clear the page and add the home container
			sa.body.empty().append(homeContainer);

			if (lockdown) {
				sa.lockdownLinks($j('#homepage .component:not(.textblock-component,.carousel-component) a:not(.lc_alternates,.download_button)'));
			}

			// Set up some background styles
			if (config.theme.homeBackground && config.theme.homeBackground.path) {
				let { repeat } = config.theme.homeBackground.options;
				if (!repeat) {
					repeat = 'no-repeat';
				}
				$j('body').css({
					backgroundImage: 'url(' + config.theme.homeBackground.path + ')',
					backgroundRepeat: repeat
				});
			}
			
			sa.body.addClass('homemaker_body');
			
			// Load in all the components and their data
			if (home.layout.length) {
				loadComponents();
				handleComponentEvents();
			} else {
				const emptyRow = templates.get('columns');
				$j('.home-content').append(emptyRow);
				home.layout.push({
					type: 'split',
					items: []
				});

				handleComponentEvents();
			}
			
			if (home.narrowLayout) {
				$j('.home-sections').addClass(['narrow-editing-area', 'narrow']);
			}
			
			if (home.showShadows || typeof home.showShadows === 'undefined') {
				$j('.home-sections').removeClass('no-component-shadows');
			} else {
				$j('.home-sections').addClass('no-component-shadows');
			}

			if (home.showComponentHeaders || typeof home.showComponentHeaders === 'undefined') {
				$j('.home-sections').removeClass('no-component-headers');
			} else {
				$j('.home-sections').addClass('no-component-headers');
			}

			// show edit button
			if (canAccessEdit) {
				$j('.icon-edit-btn').css('display', 'flex');
			} else {
				$j('.icon-edit-btn').css('display', 'none');
			}
			
			// If we're in edit mode, load the edit page instead
			if (params.editMode) {
				home.editingModeOn = false;
				showHomeEdit();
				$j('.icon-edit-btn').css('display', 'none');
			}

			// When this page is navigate away from, run this callback
			const removeFunction = function () {
				$j('body').css({ 
					backgroundImage: '', 
					backgroundRepeat: ''
				});
				sa.body.removeClass('homemaker_body');
				sa.off('routeChange', removeFunction);
			};

			sa.on('routeChange', removeFunction);
		});
	}

	function showHomeEdit() {
		// if you don't have permission, redirect back to home
		const canAccessEdit = !config.grayLabel
			&& (home.editPermission
			|| user.userData.siteOwner
			|| (user.userData.adminPermissions && user.userData.adminPermissions.includes('custom_pages')));
		
		if (!canAccessEdit) {
			sa.router.routeTo('/home');
			return;
		}

		sa.body.removeClass('empty-homepage-layout');
		
		$j('.home-sections .no-content-placeholder').remove();

		// Don't rerun the edit actions
		if (home.editingModeOn) return;
		
		// Hide the footer
		$j('#footer').hide();

		// Show the editing bar
		$j('.editing-bar.edit-on').css('display', 'flex');
		$j('.editing-bar.edit-off').hide();

		// Build the component options menu
		buildComponentMenuIcons();

		// Add editing class to the homepage to turn on extra functionality
		$j('#homepage').addClass('editing-home-content');
		$j('#body').addClass('homepage-editing-mode-on');
		home.editingModeOn = true;

		setUpSortingLogic();
		
		// Background changes, uploads, etc.
		home.handleBackgroundConfiguration();

		// Component headers, colors, etc.
		home.handleComponentStyles();
		
		// Handle mobile editing message
		function handleMobile() {
			$j('#carousel-component-settings').remove();
		}

		$j('.mobile-editing-home-window-too-small,.mobile-editing-home-unavailable')
			.find('.button')
			.off('click.editingMode')
			.on('click.editingMode', () => {
				home.leaveEditingMode();
				return false;
			}
		);
		
		if (document.body.getBoundingClientRect().width <= 1366 && $j('#homepage').hasClass('editing-home-content')) {
			handleMobile();
		}

		resizeComponentSidebar();
		
		const scrollListener = _.debounce(() => {
			if (window.scrollY > 75) {
				$j('.component-options-fixed').addClass('scrolled-down');
				resizeComponentSidebar();
			} else {
				$j('.component-options-fixed').removeClass('scrolled-down');
				resizeComponentSidebar();
			}
		}, 1);
		
		const resizeListener = _.debounce(() => {
			handleMobile();
			resizeComponentSidebar();
		}, 10);
		
		if (eventAbortController && !eventAbortController.signal.aborted) {
			// Remove old abort controller and make a new one
			eventAbortController = registerEventAbortController('homepage', true);
		}
		window.addEventListener('scroll', scrollListener, { signal: eventAbortController.signal });
		window.addEventListener('resize', resizeListener, { signal: eventAbortController.signal });
	
		// When this page is navigated away from, run this callback
		unloadFunctions.push(() => {
			// Show the footer if we navigate away from the homepage
			$j('#footer').show();

			// Remove the home page editing class when 
			$j('#body').removeClass('homepage-editing-mode-on');
			
			// Remove event listeners
			const removeEventController = getEventAbortController('homepage');
			if (removeEventController) removeEventController.abort();
		});
	}
	
	home.setupHomeBackgroundStyles = function () {		
		if (home.homepageBgImage) {
			$j('body').css('background-image', `url('${home.homepageBgImage}')`);
			sa.body.addClass('has-background-image');
		}

		if (home.homeBackgroundRepeat) {
			if (home.homeBackgroundRepeat === 'cover') {
				$j('body').css({
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat'
				});
			} else {
				$j('body').css({
					backgroundSize: 'unset',
					backgroundRepeat: home.homeBackgroundRepeat === 'none' ? 'no-repeat' : home.homeBackgroundRepeat
				});
			}
		}
	};
	
	home.handleBackgroundConfiguration = function () {
		// Set up the background image uploader
		if (home.homepageBgImage) {
			$j('.homepage-background-image-preview').html(`<img width="125" src="${home.homepageBgImage}" alt="Homepage Background Preview Image"/>`);

			// Show the remove background link if there is an image 
			$j('#homepage-remove-background').show();
		} else {
			$j('#homepage-remove-background').hide();
		}
		const backgroundUploadBtn = $j('#homepage-editor-background-uploader');
		backgroundUploadBtn.off('click');
		home.setupHomepageBackgroundUploader(backgroundUploadBtn);

		$j('#homepage-remove-background').on('click', function () {
			$j('body').css('background-image', 'none');
			home.homepageBgImage = '';
			config.theme.homeBackground.path = null;
			$j('.homepage-background-image-preview').html('');
			
			sa.body.removeClass('has-background-image');

			backgroundUploadBtn.text('Upload Background Image');

			$j(this).hide();
		});

		$j('#homepage-background-image-repeat-options').val(home.homeBackgroundRepeat === 'none' ? 'no-repeat' : home.homeBackgroundRepeat);

		$j('#homepage-background-image-repeat-options').on('change', function () {
			home.homeBackgroundRepeat = $j(this).val();
			config.theme.homeBackground.options.repeat = $j(this).val();

			if (home.homeBackgroundRepeat === 'cover') {
				$j('body').css({
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat'
				});
			} else {
				$j('body').css({
					backgroundRepeat: home.homeBackgroundRepeat,
					backgroundSize: 'unset'
				});
			}
		});
	};
	
	home.handleComponentStyles = function () {
		// Component Hide / Show Header BGs
		if (home.showComponentHeaders || typeof home.showComponentHeaders === 'undefined') {
			$j('.editing-show-component-headers-toggle input').prop('checked', 'checked');
			$j('.component').removeClass('hide-header-bgs');
		} else {
			$j('.editing-show-component-headers-toggle input').prop('checked', false);
			$j('.component').addClass('hide-header-bgs');
		}

		// Component Box Shadow Toggle
		if (home.showShadows || typeof home.showShadows === 'undefined') {
			$j('.editing-show-shadows-toggle input').prop('checked', 'checked');
		} else {
			$j('.editing-show-shadows-toggle input').prop('checked', false);
		}
	};

	/**
	 * Set up the homepage background uploader
	 * 
	 * @param uploadBtn
	 */
	home.setupHomepageBackgroundUploader = function (uploadBtn) {
		const homepageBgUploader = new Uploader({
			button: uploadBtn[0],
			allowMultiple: false,
			browseCallback(uploader) { // after selecting an image
				let fileList = uploader.getFiles();
				// Take the last added file
				fileList = [fileList.at(-1)];
				
				// Check file extension
				const file = fileList[0];
				const allowedFileExtensions = ['gif', 'jpeg', 'png', 'jpg'];
				const isAllowedType = allowedFileExtensions.includes(file.split('.').at(-1).toLowerCase());
				
				if (!isAllowedType) {
					sa.alert('Invalid File Type');
					return;
				}
				
				const key = new Date().getTime();
				if (fileList && fileList.length === 1) {
					// auto-upload
					uploadBtn.html('Uploading...');
					uploader.upload({
						params: `u=${user.userData.id}&t=temp&key=${key}&source=home_background`,
						complete(e, resp) { // success function
							uploader.removeAllFiles();
							let newPath;
							if (resp && resp[0] && resp[0].file) {
								newPath = resp[0].file;
							} else {
								newPath = user.userData.id + '-' + key + '.jpg';
							}

							newPath = 'https://sourceaudio-images.s3.amazonaws.com/temp/' + newPath;
							
							$j('body').css('background-image', `url('${newPath}')`);
							
							// set the value where we need it
							$j('.homepage-background-image-preview').html(`<img width="125" src="${newPath}" alt="Homepage Background Preview Image"/>`);
							home.homepageBgImage = newPath;
							config.theme.homeBackground.path = newPath;

							$j('#homepage-remove-background').show();
							
							// Remove extra file uploader inputs
							const latestUploaderId = $j('.homepage-editing-background-options .file_uploader').last().attr('id');
							$j('.homepage-editing-background-options .file_uploader').not(`#${latestUploaderId}`).remove();
							
							sa.body.addClass('has-background-image');
							
							// let them upload again
							uploadBtn.text('Browse');
						},
						error() { // error function
							uploadBtn.text('Browse');
						}
					});
				}
			},
			fileType: UploaderConstants.IMAGES
		});
	};

	/**
	 * Transform layout array to new format
	 * 
	 * @param layout
	 * @returns {*|*[]}
	 */
	home.transformLayout = function (layout) {
		const layoutIsNewFormat = !!layout.filter(row => {
			return row.hasOwnProperty('items') && row.hasOwnProperty('type');
		}).length;
		if (layoutIsNewFormat) {
			home.layout = layout;
			return layout;
		}
		
		const newLayout = [];
		let currentType = null;
		
		layout.forEach(component => {
			if (component.type === 'left' || component.type === 'right') {
				const splitRows = newLayout.filter(row => row.type === 'split');
				
				if (splitRows.length && currentType === 'split') {
					splitRows.at(-1).items.push(component);
				} else {
					newLayout.push({
						type: 'split',
						items: [component]
					});

					currentType = 'split';
				}
			} else if (component.type === 'wide') {
				const wideRows = newLayout.filter(row => row.type === 'wide');

				if (wideRows.length && currentType === 'wide') {
					wideRows.at(-1).items.push(component);
				} else {
					newLayout.push({
						type: 'wide',
						items: [component]
					});

					currentType = 'wide';
				}
			}
		});

		home.layout = newLayout;
		return newLayout;
	};

	home.save = async function () {		
		if (home.saving) return;
		home.saving = true;
		const saveButton = $j('.homemaker-save');
		const oldSave = saveButton.html();
		saveButton.html('<i class="fa fa-refresh fa-spin"></i> Saving...');

		// the divs are circular and ruin json.stringify
		for (let i = 0; i < home.layout.length; i++) {
			const row = home.layout[i];
			for (let y = 0; y < row.items.length; y++) {
				const component = row.items[y];
				delete component.div;
			}
		}
		
		// Check for empty rows and remove them
		home.layout = home.layout.filter(row => row.items.length);

		await sa.api.request({
			handler: 'settings',
			action: 'save-homepage-background',
			postData: {
				saveFromHomePage: true,
				homepageBgImage: home.homepageBgImage || '',
				homeBackgroundRepeat: home.homeBackgroundRepeat || true
			}
		});
		
		const oldLayout = [];
		home.layout.forEach(row => {
			row.items.forEach(component => oldLayout.push(component));
		});
		
		const showShadowsEnabled = !!$j('.editing-show-shadows-toggle input:checked').length;
		const showComponentHeaders = !!$j('.editing-show-component-headers-toggle input:checked').length;

		ajax({ 
			layout: JSON.stringify(home.layout),
			narrow: home.narrowLayout,
			showShadows: showShadowsEnabled,
			showComponentHeaders: showComponentHeaders,
		}, (r) => {
			r = r[0];
			
			home.saving = false;

			if (r.error) {
				console.error(r.error);
				sa.alert({
					text: r.userError ? r.userError : 'Unable to save. Please contact SourceAudio and let them know about this issue.'
				});

				home.editingModeOn = true;
				
				saveButton.html(oldSave);
			} else {
				home.editingModeOn = false;
				$j('#body').removeClass('homepage-editing-mode-on');
				sa.router.routeTo('/home');
			}
		}, 'POST', { p: 'homemaker', action: 'save' });
	};
	
	home.leaveEditingMode = function () {
		$j('#body').removeClass('homepage-editing-mode-on');
		home.editingModeOn = false;
		sa.router.routeTo('/home');
	};

	home.show = function (params) {
		if (!templates) {
			templates = sa.templates.get('pages.home.homemaker');
		}

		sa.components.leftNav.hide();

		const vars = sa.router.paramsToVars(params);

		if (vars.blogId) {
			showBlog(vars.blogId);
		} else {
			showHome(vars);
		}
		
		sa.currentPage = sa.pages.home;
	};

	/**
	 * Add the component shadow display toggle to the editing options
	 */
	home.addComponentShadowToggle = function () {
		let componentShadowToggle = home.componentsOptionToggle(
			'editing-show-shadows-toggle',
			'Hide',
			'Show',
			'Show Shadows on Components'
		);
		componentShadowToggle = $j(componentShadowToggle);
		
		componentShadowToggle.find('input').on('change', function () {
			const show = $j(this).prop('checked');
			if (show) {
				$j('.home-sections').removeClass('no-component-shadows');
			} else {
				$j('.home-sections').addClass('no-component-shadows');
			}
		});
		
		$j('.show-shadows-on-components').append(componentShadowToggle);
	};

	/**
	 * Adds the component header display toggle to the editing options
	 */
	home.addComponentHeaderDisplayToggle = function () {
		let componentShowHeaders = home.componentsOptionToggle(
			'editing-show-component-headers-toggle',
			'Hide',
			'Show',
			'Show Component Header Background'
		);
		componentShowHeaders = $j(componentShowHeaders);

		componentShowHeaders.find('input').on('change', function () {
			const show = $j(this).prop('checked');
			if (show) {
				$j('.home-sections').removeClass('no-component-headers');
			} else {
				$j('.home-sections').addClass('no-component-headers');
			}
		});
		
		// Check if the user has previously saved a preference for showing component headers
		if (home.showComponentHeaders || typeof home.showComponentHeaders === 'undefined') {
			$j('.home-sections').removeClass('no-component-headers');
		} else {
			$j('.home-sections').addClass('no-component-headers');
		}

		$j('.show-component-header-backgrounds').append(componentShowHeaders);
	};

	/**
	 * Adds the display size toggle to the editing options
	 */
	home.addDisplaySizeToggle = function () {
		let displaySizeToggle = home.componentsOptionToggle(
			'editing-display-size-toggle',
			'Flexible',
			'Fixed Width (1000px)'
		);
		displaySizeToggle = $j(displaySizeToggle);

		displaySizeToggle.find('input').on('change', function () {
			const narrow = $j(this).prop('checked');
			
			if (narrow) {
				$j('.home-sections').addClass(['narrow-editing-area', 'narrow']);
				home.narrowLayout = true;
			} else {
				$j('.home-sections').removeClass(['narrow-editing-area', 'narrow']);
				home.narrowLayout = false;
			}

			resetGridSizes();
		});

		$j('.homepage-editing-display-size-options').append(displaySizeToggle);
	};

	/**
	 * Helper to build a component option toggle
	 */
	home.componentsOptionToggle = function (className, optionA, optionB, header = '') {
		return `
			<div class="toggle-body ${className}">
				${header ? `<span class="homepage-toggle-header">${header}</span>` : ''}
				<div class="toggle-option-alignment">
					<span class="text-options">${optionA}</span>
					<label class="homepage-editor-toggle homepage-editor-toggle-switch">
					  <input type="checkbox">
					  <span class="homepage-editor-toggle-slider round"></span>
					</label>
					<span class="text-options">${optionB}</span>
				</div>
			</div>
		`;
	};

	return home;
})();

sa.pages.home.licensee = (function() {
	
	var home = {};
	var templates;
	
	home.show = function() {
		
		if (!templates) {
			templates = sa.templates.get('pages.home.licensee');
		}
		
		if (sa.getCurrentPageName() !== sa.pages.home.name) {

			let tracksUrl = siteBaseUrl() + '/tracks';
			
			let cont = templates.get('home', {
				'tracksUrl': tracksUrl
			});
			
			cont.find('.welcome').attr('src', config.logo);
			
			sa.components.leftNav.hide();
			sa.components.brandingHeader.hide();
			sa.components.nav.hide();
			sa.components.projector.disableQuickProjectMode();
			sa.components.cueSheeter.disableQuickCueSheetMode();
			sa.components.nester.disable();
			
			$j('#body').empty().append(cont);

		}
		
		sa.currentPage = sa.pages.home;
		
	};
	
	return home;

})();

sa.pages.label = (function() {

	var page = {
		name : 'label',
		title : gde('label', { c : 'upper', p : false }) + ' Details',
		register : {
			routes: [{
				name: 'label',
				pattern: '/label/:int/:any?',
				hash: '#!label',
				id: 'l'
			}]
		}
	};

	/** @var {Label} */
	var label;

	page.show = function(params) {

		var vars = sa.router.paramsToVars(params);

		if (!vars.l) {
			sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			return;
		}

		label = null;

		sa.currentPage = page;

		sa.pages.grouping.showFromVars(jQuery.extend(vars, {
			name : page.name,
			labelId : vars.l,
			defaultTab : config.defaultLabelTab,
			linkFunction : getLabelLinkExact
		}), function(labelData) {
			setTitle(labelData.name, gde('label', { c : 'upper', p : false }))
			label = new Label(labelData);
		});

		sa.search.showCurrentLabel();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingTrackList = function() {
		return sa.pages.grouping.isShowingTrackList();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingAlbumList = function() {
		return sa.pages.grouping.isShowingAlbumList();
	};

	/**
	 * @returns {Label}
	 */
	page.getLabel = function() {
		return label;
	};

	/**
	 * @returns {int}
	 */
	page.getLabelId = function() {
		return label ? label.id : 0;
	};

	/**
	 * @return {List}
	 */
	page.getTrackList = function() {
		return sa.pages.grouping.getTrackList();
	};

	/**
	 * @return {List}
	 */
	page.getAlbumList = function () {
		return sa.pages.grouping.getAlbumList();
	};

	return page;

})();

sa.pages.labelList = (function() {

	var page = {
		name : 'label_list',
		title : gde('label', { c : 'upper', p : false}) + ' List',
		register : {
			routes: [{
				hash : '#!labels',
				name: 'labels',
				pattern: '/labels'
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;

	page.show = function(params) {

		if (!list) {

			var listConfig = new ListConfig();
			listConfig.addColumnList(getStandardLabelColumnList());
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = true;
			listConfig.bankKey = 'labelListPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;

			list = createLabelList(listConfig);

			templates = sa.templates.get('pages.label_list');

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('label_list');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();

			list.generatePage(container.find('.list'));

			$j('#body').empty().append(container);
		}

		sa.currentPage = page;
		loadPage(params);

	};

	function loadPage(params) {
		list.loadPage(params);
	}

	function setData(newData) {
		list.setData(newData, getLabelsLink);
		sa.components.heading.hide();
		var headingExtra = {};
		if (newData[0].facets) {
			sa.components.heading.buildFacetTabs(newData[0].facets, headingExtra, 'labels', sa.router.paramsToVars(newData[0].pageVars).s);
		}
		if (newData[0].headingName && newData[0].headingValue) {
			headingExtra.count = newData[0].count;
			headingExtra.preamble = newData[0].headingName;
			sa.components.heading.show(newData[0].headingValue, headingExtra);
		} else {
			sa.components.heading.show('All ' + config.getDictionaryEntry('label', true), headingExtra);
		}
	}

	return page;

})();

sa.pages.musicSupplier = (function() {

	let page = {
		name : 'musicSupplier',
		title : 'Music Supplier Details',
		register : {
			routes: [{
				hash: '#!music_provider',
				name: 'music-provider',
				pattern: '/music-provider/:int',
				id: 'provider',
				redirect: '/music-supplier'
			}, {
				hash: '#!music_supplier',
				name: 'music-supplier',
				pattern: '/music-supplier/:int',
				id: 'supplierId'
			}]
		}
	};

	/** @var {MusicSupplier} */
	var musicSupplier;

	page.show = function(params) {

		var vars = sa.router.paramsToVars(params);

		if (!vars.supplier && !vars.supplierId) {
			sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			return;
		}

		musicSupplier = null;

		sa.currentPage = page;

		sa.pages.grouping.showFromVars(jQuery.extend(vars, {
			name : page.name,
			supplierId : vars.supplier || vars.supplierId,
			defaultTab : 't',
			linkFunction : getMusicSupplierLinkExact
		}), function(musicSupplierData) {
			musicSupplier = new MusicSupplier(musicSupplierData);
		});

		sa.search.showCurrentMusicSupplier();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingTrackList = function() {
		return sa.pages.grouping.isShowingTrackList();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingAlbumList = function() {
		return sa.pages.grouping.isShowingAlbumList();
	};

	/**
	 * @returns {MusicSupplier}
	 */
	page.getMusicSupplier = function() {
		return musicSupplier;
	};

	/**
	 * @return {List}
	 */
	page.getTrackList = function() {
		return sa.pages.grouping.getTrackList();
	};

	/**
	 * @return {List}
	 */
	page.getAlbumList = function () {
		return sa.pages.grouping.getAlbumList();
	};

	return page;

})();

sa.pages.musicSupplierList = (function() {

	let page = {
		name : 'music_suppliers',
		title : 'Music Supplier List',
		register : {
			routes: [{
				hash: '#!music_providers',
				name: 'music-providers',
				pattern: '/music-providers',
				redirect: '/music-suppliers'
			},
			{
				hash: '#!music_suppliers',
				name: 'music-suppliers',
				pattern: '/music-suppliers'
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;

	page.show = function(params) {

		if (!list) {

			var listConfig = new ListConfig();
			listConfig.addColumnList([
				new ListColumn('name', ['name'], true),
				new ListColumn('track count', ['track count'], true),
				new ListColumn(config.getDictionaryEntry('label', false) + ' count', ['label count'], true),
				new ListColumn(config.getDictionaryEntry('album', false) + ' count', ['album count'], true),
				new ListColumn(config.getDictionaryEntry('artist', false) + ' count', ['artist count'], true)
			]);
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = true;
			listConfig.bankKey = 'musicSupplierListPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;
			listConfig.emptyMessage = 'No music suppliers found.';

			list = createMusicSupplierList(listConfig);

			templates = sa.templates.get('pages.music_supplier_list');

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('music_supplier_list');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();
			list.generatePage(container.find('.list'));

			$j('#body').empty().append(container);
		}

		sa.currentPage = page;
		loadPage(params);

	};

	function loadPage(params) {
		list.loadPage(params);
	}

	function setData(newData) {
		list.setData(newData, getMusicSupplierListLink);
		sa.components.heading.hide();
		if (newData[0].headingName && newData[0].headingValue) {
			sa.components.heading.show(newData[0].headingValue, { count : newData[0].count, preamble : newData[0].headingName });
		} else {
			sa.components.heading.show('All Music Suppliers');
		}
	}

	return page;

})();

sa.pages.projectList = (function() {

	var page = {
		name : 'projects',
		title : 'Playlists',
		register : {
			routes: [{
				hash: '#!projects',
				name: 'playlists',
				pattern: '/playlists'
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;
	var lastParams;

	page.show = function(params) {

		if (!list) {

			var listConfig = new ListConfig();
			let columnList = [
				new ListColumn('name', ['name'], true)
			];
			if (config.siteType == 'buyer') {
				columnList.push(new ListColumn('music supplier', ['music supplier']));
			}
			columnList.push(new ListColumn('album count', ['project album count'], true));
			columnList.push(new ListColumn('track count', ['project track count'], true));
			columnList.push(new ListColumn('total tracks', ['project total track count'], true));
			listConfig.addColumnList(columnList);
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = false;
			listConfig.bankKey = 'projectListPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;

			list = createProjectList(listConfig);

			templates = sa.templates.get('pages.project_list');

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('project_list');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();

			list.generatePage(container.find('.list'));

			$j('#body').empty().append(container);
		}

		sa.currentPage = page;
		loadPage(params);

	};

	function loadPage(params) {
		lastParams = params;
		list.loadPage(params);
	}

	function setData(newData) {
		if (newData.length < 2 && lastParams.indexOf('regenerate=1') === -1) {
			// bad cache?
			lastParams += '&regenerate=1';
			list.loadPage(lastParams);
			return;
		}
		list.setData(newData, function(vars) {
			vars = vars.replace(/^([&?])/, '');
			return '/playlists?' + vars;
		});
		sa.components.heading.hide();
		if (newData[0].headingName && newData[0].headingValue) {
			sa.components.heading.show(newData[0].headingValue, { count : newData[0].count, type: 'project_list', preamble : newData[0].headingName, subtext : newData[0].description });
		} else {
			sa.components.heading.show(config.siteType === 'drop' ? 'Public Playlists' : 'All Playlists');
		}
	}

	return page;

})();
class ProjectItemLIst {

	constructor() {
		const page = this;
		page.name = 'project_item_list';
		page.title = 'Playlist Details';
		page.register = {
			routes: [{
				hash: '#!project',
				name: 'playlist',
				pattern: '/playlist/:int/:any?',
				id: 'projectId'
			}]
		};
		page.project = {};
		page.extraButtons = [];
		/** @var {List} */
		page.list = null;
		page.templates = null;
		page.lastParams = null;
		/** @var {TrackListConfig} */
		page.listConfig = null;
		page.listMeta = {};		
	}

	/**
	 * Gets the project id of the currently shown project (if there is one)
	 * @returns {number|*}
	 */
	getProjectId() {
		if (this.project) {
			return this.project.id;
		}
		return 0;
	}

	displayConcurrentUsersList(users, project) {
		const page = this;
		if (sa.getCurrentPageName() !== page.name || page.project.id !== project.id) return;
		$j('.concurrent_user_list').remove();
		if (users.length < 2) return; // only you are viewing. no need to show a list
		const userStrings = [];
		for (let i = 0, len = users.length; i < len; i++) {
			if (users[i].id === user.userData.id) continue;
			userStrings.push(users[i].username);
		}
		$j('#heading').after(page.templates.get('concurrency_user_list', { userList: userStrings.join(', ') }));
	}

	reload(newItems) {
		const page = this;
		// see if we can rearrange the current items to make the new list or if we need to actually reload
		// we do this because there's no way to tell if the change requiring reload came from the current user rearranging tracks, which shouldn't reload
		if (page.listMeta.count !== newItems.length) {
			// there were more or less items in the list. just reload
			console.log(' item count was different for reordering');
			return page.loadPage(page.lastParams);
		}
		// go through all items
		const currentItems = page.list.container.find('.track_list_table:first > div:not(:first)');
		let lastItem = page.list.container.find('.track_list_table:first .l_header:first');
		for (let i = page.listMeta.page * page.listMeta.perPage, len = Math.min(i + page.listMeta.perPage, page.listMeta.count); i < len; i++) {
			const newItem = newItems[i];
			const currentItem = currentItems.filter('#' + (newItem.type === 'album' ? 'item_' : 'lr_') + newItem.id);
			if (!currentItem.length) {
				// the item we need to show isn't one we have
				console.log(' do not have an item we need for reordering');
				return page.loadPage(page.lastParams);
			} 
			lastItem.after(currentItem);
			lastItem = currentItem;
			
		}
		console.log(' successfully reordered items!');
	}

	/**
	 * Updates the number of items the the page is showing based on the number in the project
	 */
	updateItemCount() {
		const page = this;
		const newProject = user.getProject(page.project.id);
		if (newProject.totalTrackCount === page.project.totalTrackCount) return;
		
		page.project.totalTrackCount = newProject.totalTrackCount;
		const textContainer = $j('#project_container #heading #text');
		let text = textContainer.html();
		text = text.substring(0, text.lastIndexOf('(')) + '(' + page.project.totalTrackCount + ')';
		textContainer.html(text);
	}

	show(params) {
		const page = this;

		if (!page.list) {

			page.listConfig = new window.TrackListConfig();
			page.listConfig.allowBlock = true;
			page.listConfig.allowList = true;
			page.listConfig.allowMiniBlock = false;
			page.listConfig.bankKey = 'project';
			page.listConfig.callback = function (data) { page.setData(data); };
			page.listConfig.callbackActual = function (data) { page.setData(data); };
			page.listConfig.defaultResultsPerPage = 50;
			page.listConfig.useCache = false;
			page.listConfig.useFilters = false;
			page.listConfig.topBar = true;
			
			page.setUpColumnList(true);

			page.list = window.createProjectItemList(page.listConfig);
			page.list.on('reorder', (e, order, opage, perPage) => {
				let orderString = '&page=' + opage + '&perPage=' + perPage;
				for (let i = 0, len = order.length; i < len; i++) {
					orderString += '&newOrder[]=' + order[i].type + '-' + order[i].id;
				}
				ajax('projectId=' + page.project.id + orderString, () => {}, 'POST', 'p=projects&action=reorder_page');
			});
			
			page.templates = sa.templates.get('pages.project_item_list');
			
		}

		if (sa.getCurrentPageName() !== page.name) {
			
			const container = page.templates.get('project_item_list');
			if (sa.components.leftNav) {
				sa.components.leftNav.show();
				sa.components.leftNav.disableAll();
			}
			
			page.list.generatePage(container.find('.track_list'));
			
			$j('#body').empty().append(container);
		}
		
		const cp = sa.getCurrentPageName();
		sa.currentPage = page;
		page.loadPage(params, cp !== 'project');
	}

	loadPage(params, dontHideSplash) {
		const page = this;
		if (!dontHideSplash && sa.components.projector) {
			sa.components.projector.hideSplash();
		}
		
		// some pages expect this to always have a project if it's the page
		// let's make sure we have something for them
		const vars = sa.router.paramsToVars(params);
		if (vars.projectId) {
			page.project = { id: vars.projectId };
		}
		
		page.lastParams = params;
		page.list.loadPage(params);
		// if (firstCheck) {
		// 	if (vars.s) {
		// 		sa.search.addSearchTerm(vars.s);
		// 	}
		// }
	}

	setUpColumnList(enableEditing) {
		const page = this;
		page.listConfig.useStandardColumnList();
		
		for (const view of [window.ListViewType.List, window.ListViewType.MiniBlock, window.ListViewType.Block]) {
			const columnList = page.listConfig.getColumnList(view);
			for (let i = 0, len = columnList.length; i < len; i++) {
				const column = columnList[i];
				// if this is a list we can edit, add a reordering option. else, remove it
				if (enableEditing && column.hasDisplayColumn('title') && !column.hasDisplayColumn('reorder')) {
					column.addDisplayColumn('reorder');
				} else if (!enableEditing && column.hasDisplayColumn('reorder')) {
					column.removeDisplayColumn('reorder');
				}
				// if this a drop site, remove the date columns
				if (config.siteType === 'drop' && (column.hasDisplayColumn('date') || column.hasDisplayColumn('added_by'))) {
					columnList.splice(i, 1);
					i--;
					len--;
				}
			}
			page.listConfig.addColumnList(columnList, view);
		}
		if (page.list) {
			page.list.updateColumnList();
		}
	}

	setData(newData, userLoaded) {
		const page = this;
		if (!newData.length || !newData[0].project || !newData[0].project.id) {
			sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			sa.notify({ text: 'Playlist not found or not accessible.' });
			return;
		}
		// this only works if the user's projects have finished loading
		if (!userLoaded) {
			// console.log('project item page asking for user onLoad callback');
			user.onLoad(() => {
				// console.log('project item page callback firing');
				page.setData(newData, true);
			});
			return;
		}
		$j('.concurrent_user_list').remove();
		page.project = newData[0].project;
		const owned = page.project.userId === user.userData.id;
		const local = page.project.whiteId === config.id; // need to know if it's based on this while label because it affects the owner's options
		if (newData[0].recount) {
			user.reloadProjects();
		}
		page.setUpColumnList(local && ((owned && page.project.created) || page.project.shared));
		[page.listMeta] = newData;
		page.list.conf.commentLoadVars = { projectId: page.project.id };
		page.list.conf.commentSaveVars = (page.project.created && local && (owned || page.project.shared)) ? page.list.conf.commentLoadVars : null;
		if (!page.list.setData(newData, window.getProjectLinkExact)) return;
		// make sure this project is in the user's list (if it's not published)
		if (owned && local) {
			// it might not be if they typed in a project url for a project they don't have
			user.ensureProject(page.project);
			
			// allow drag and drop uploads on drop sites
			if (config.siteType === 'drop' && user.hasAdminPermission(AdminPermission.Metadata)) {
				sa.importTrackManager.createDropZone('#project_container', { projectId: page.project.id });
			}
		}
		if (local && sa.components.projector) {
			sa.components.projector.checkConcurrency(page.project);
		}
		
		sa.components.heading.hide();
		window.setTitle('Playlist Details - ' + page.project.name);
		if (sa.components.projector) {
			sa.components.projector.highlight(page.project.id);
		}
		const extraButtons = page.extraButtons.slice(0);
		// black bar
		sa.components.heading.resetOptions();

		// xml export for fox sports
		if (config.id === 2068) {
			sa.components.heading.addOption($j('<a class="button" href="export.php?type=tracks&format=foxxml&projectId=' + page.project.id + '">Export as XML</a>'), sa.components.heading.LocationBottom);
		}

		// add the buttons to the heading, extracting the drop upload button so we can put it in the drop bar
		let dropUploadButton = null;
		$j.each(window.generateProjectActionsList(page.project), (index, action) => {
			const button = action.getButton();
			if (button.hasClass('drop_upload_button')) {
				dropUploadButton = button;
			} else {
				sa.components.heading.addOption(action.getButton(), action.getLocation());
			}
		});

		// extra buttons
		if (extraButtons.length) {
			for (let i = 0, len = extraButtons.length; i < len; i++) {
				const button = $j(extraButtons[i]);
				button.data('projectId', page.project.id);
				button.addClass('no_toggle bottom_button');
				button.attr('href', button.attr('href').replace('[projectId]', page.project.id));
				sa.components.heading.addOption(button, sa.components.heading.LocationLeft);
			}
		}
		if (page.project.id) {
			const totalTrackCount = page.project.totalTrackCount.numberFormat();
			const unfilteredTrackCount = page.project.unfilteredTrackCount.numberFormat();
			let countText;
			if (totalTrackCount !== unfilteredTrackCount) {
				countText = page.templates.get('permission_profile_count_filter', { totalTrackCount, unfilteredTrackCount })[0].outerHTML;
			} else {
				countText = '(' + (config.showNestedCounts ? page.listMeta.count.numberFormat() : totalTrackCount) + ')';
			}
			sa.components.heading.show(page.project.name + ' ' + countText, {
				preamble: 'Playlist',
				image: page.project.image,
				subtext: page.project.description,
				type: 'project_item_list',
				item: page.project,
			});
			const filterText = $j('.permission_profile_count_filter');
			if (filterText.length) {
				sa.components.helpExplanation.show(filterText, filterText.attr('title'));
			}

			// drop and drop notice
			if (dropUploadButton !== null) {
				const dropBar = sa.templates.get('pages.explorer').get('drop_bar');
				dropBar.append(dropUploadButton);
				page.list.container.find('#drop_bar').remove();
				page.list.container.find('#list_top_bar').after(dropBar);
			}

			// add a get more button
			page.list.container.find('#ai_more_button').remove(); // on subsequent loads, we need to remove the old button
			if (config.showAIPlaylists && page.project.totalTrackCount && page.project.userId === user.userData.id && page.project.whiteId === config.id) { // owned and local
				// get more button
				page.getMoreButton = page.templates.get('more_button').clone();
				page.getMoreButton.on('click', () => { page.getMore(); });
				page.list.container.find('#list_bottom_bar').addClass('with_button').append(page.getMoreButton);
			}
		} else {
			sa.components.heading.show('Playlist not found');
		}
	}

	async getMore() {
		const page = this;
		
		if (page.gettingmore) return;
		page.gettingmore = true;

		// make the icon a spinny one while we're waiting
		$j('#ai_more_button').find('i').removeClass('fa-bolt').addClass('fa-refresh fa-spin');

		await sa.api.request({
			handler: 'agp',
			action: 'generateFromPlaylist',
			getData: { id: this.project.id },
		});

		page.gettingmore = false;
		page.list.loadPage(page.lastParams);
	}

	/**
	 * Gets the list that's displaying the project items
	 * @returns {List}
	 */
	getList() {
		return this.list;
	}
}

sa.pages.projectItemList = new ProjectItemLIst();

sa.pages.publisher = (function() {
	
	let page = {
		name: 'publisher',
		title: gde('publisher', { c : 'upper', p : false }) + ' Details',
		register: {
			routes: [{
				name: 'publisher',
				hash: '#!publisher',
				pattern: '/publisher/:int/:any?',
				id: 'u',
				dontSetTitle: true,
			}]
		}
	};
	
	/** @var {Catalog} */
	var publisher;
	
	page.show = function(params) {
		let vars = sa.router.paramsToVars(params);
		if (!vars.u) {
			sa.router.routeTo('/');
			// sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			return;
		}
		
		publisher = null;

		sa.currentPage = page;
		sa.pages.grouping.showFromVars(jQuery.extend(vars, {
			name : page.name,
			publisherId : vars.u,
			linkFunction : getPublisherLinkExact
		}), function(publisherData) {
			setTitle(publisherData.name, gde('publisher', { c : 'upper', p : false }))
			publisher = new Publisher(publisherData);
		});
		
		// TODO:
		// sa.search.showCurrentCatalog();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingTrackList = function() {
		return sa.pages.grouping.isShowingTrackList();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingAlbumList = function() {
		return sa.pages.grouping.isShowingAlbumList();
	};
	
	/**
	 * @returns {Catalog}
	 */
	page.getCatalog = function() {
		return publisher;
	};

	/**
	 * @return {List}
	 */
	page.getTrackList = function() {
		return sa.pages.grouping.getTrackList();
	};

	/**
	 * @return {List}
	 */
	page.getAlbumList = function () {
		return sa.pages.grouping.getAlbumList();
	};

	page.setCatalog = function(cat) {
		publisher = cat
	}
	
	return page;
	
})();

sa.pages.publisherList = (function() {

	let page = {
		name: 'publisher_list',
		title: gde('publisher', { c: 'upper', p: false}) + ' List',
		register: {
			routes: [{
				name: 'publishers',
				pattern: '/publishers',
				hash: '#!publishers',
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;

	page.show = function(params) {
		console.log("params", params)

		if (!list) {

			var listConfig = new ListConfig();
			listConfig.addColumnList(getStandardPublisherColumnList());
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = true;
			listConfig.bankKey = 'publisherPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;

			list = createPublisherList(listConfig);

			templates = sa.templates.get('pages.publisher_list');

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('publisher_list');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();

			list.generatePage(container.find('.list'));

			$j('#body').empty().append(container);
		}

		sa.currentPage = page;
		loadPage(params);

	};

	function loadPage(params) {		
		list.loadPage(params);
	}

	function setData(newData) {
		list.setData(newData, getPublishersLink);
		sa.components.heading.hide();
		var headingExtra = {};
		if (newData[0].facets) {
			sa.components.heading.buildFacetTabs(newData[0].facets, headingExtra, 'publishers', sa.router.paramsToVars(newData[0].pageVars).s);
		}
		if (newData[0].headingName && newData[0].headingValue) {
			headingExtra.count = newData[0].count;
			headingExtra.preamble = newData[0].headingName;
			sa.components.heading.show(newData[0].headingValue, headingExtra);
		} else {
			sa.components.heading.show('All ' + config.getDictionaryEntry('publisher', true), headingExtra);
		}
	}

	return page;

})();
/**
 * This is a page framework referenced by dashboard.sent and admin.stats.sent. Don't create this page directly.
 * @type {{name: string, title: string}}
 */
sa.pages.sent = (function() {

	let page = {
		name : 'sent',
		title : 'Sent',
		SentTypeAdmin : 'admin',
		SentTypeUser : 'user',
	};
	
	let options = {
		type : page.SentTypeUser,
		emptyMessage : '',
		topMessage : ''
	};
	
	let templates;
	let container;
	let selectedUserId = 0;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {object} newOptions like above
	 * @param outerContainer
	 */
	page.show = function(newOptions, outerContainer) {
		if (!templates) {
			templates = sa.templates.get('pages.sent');
		}
		
		options = $j.extend(options, newOptions);
		container = templates.get('container');
		outerContainer.empty().append(container);
		selectedUserId = 0;
		let vars = sa.router.getCurrentParamsAsObject();
		loadSent(vars.pg ? vars.pg : 0, vars.userId ? vars.userId : 0);
		
		// if we're showing admin sent, let them filter by user
		showUserFilter();
	};

	/**
	 * Loads sent items from the server
	 * @param {int} pg the page to load
	 * @param {int=} userId the id of the user's data to load
	 */
	function loadSent(pg, userId) {
		if (!pg) pg = 0;
		if (!userId) userId = 0;
		let paramPieces = sa.router.getCurrentParamsAsObject();
		if (pg || paramPieces.pg !== undefined) { // only set if the pg is not 0
			paramPieces.pg = pg;
		}
		if (userId || paramPieces.userId !== undefined) {
			paramPieces.userId = userId;
			selectedUserId = userId;
		}
		if (paramPieces.pg !== undefined || paramPieces.userId !== undefined) {
			let params = sa.router.varsToParams(paramPieces);
			let basePath = sa.router.getCurrentPath();
			let link = params.includes('?') ? basePath + params : basePath + '?' + params;
			sa.router.routeTo(link);
		}
		sa.api.request({
			handler : 'mail-tracking',
			action : 'get-tracking',
			getData : { type : options.type, pg : pg, userId : userId }
		}).then(setSent).catch(e => {
			sa.notify(e.message);
		});
	}

	/**
	 * Populates the sent after load
	 * @param {{ mails : Array, totalPages : int, page : int, totalItems : int, perPage : int }} newData the data for the sent
	 */
	function setSent(newData) {
		let sentList = container.find('.sent_list').empty();
		let topMessageContainer = container.find('#sent_top_message');
		let paginationContainer = container.find('.list_control_bar');
		
		paginationContainer.empty();
		
		if (options.topMessage) {
			topMessageContainer.html(options.topMessage);
		} else {
			topMessageContainer.remove();
		}
		if (!newData.mails.length){
			sentList.html(options.emptyMessage);
			showUserFilter();
			return;
		}
		newData.mails.each(function(i, mail) {
			let mailItem = templates.get('mail_item', {
				id : mail.id,
				button : sa.components.buttons.generateInteractionHistoryButton({ type : mail.type })[0].outerHTML,
				name : mail.name,
				senderName: mail.sender.id == user.userData.id ? 'you' : mail.sender.username,
				date : formatDate(config.dateTimeFormatString, mail.date)
			});
			mailItem.find('.mail_head').on('click', function() {
				swapMail(mail, mailItem);
			});
			sentList.append(mailItem);
		});

		sa.pagination.addPagination({
			totalpages : newData.totalPages,
			currentPage : newData.page,
			totalItems : newData.totalItems,
			perPage : newData.perPage,
			callback : function(pageNumber) {
				loadSent(pageNumber, selectedUserId);
			},
			container : paginationContainer,
			showTitle : true
		});
		showUserFilter();
	}

	/**
	 * Shows or hides information about a specific mail
	 * @param {object} mail the mail to show/hide
	 * @param mailItem the jQuery container
	 */
	function swapMail(mail, mailItem) {
		let cont = mailItem.find('.mail_container');
		if (cont.hasClass('showing')) {
			cont.removeClass('showing');
			return;
		}
		cont.empty();
		mail.emails.each(function(i, email) {
			let recipientContainer = email.email ? templates.get('email_recipient', { email : email.email }) : templates.get('link_recipient');
			let list = recipientContainer.find('.recipient_list');
			email.recipients.each(function(j, recipient) {
				let playTotal = 0;
				let dlTotal = 0;
				for (let trackId in recipient['stats']) {
					if (!recipient['stats'].hasOwnProperty(trackId)) continue;
					playTotal += recipient['stats'][trackId].plays;
					dlTotal += recipient['stats'][trackId].downloads;
				}
				let userHeader = templates.get('recipient_heading', {
					id : recipient.id,
					username : recipient.user.username,
					clicks : recipient.clicks,
					plays : playTotal,
					downloads : dlTotal
				});
				userHeader.on('click', function() {
					swapRecipient(recipient, mail);
				});
				list.append(userHeader);
			});
			cont.append(recipientContainer);
		});
		cont.addClass('showing');
	}

	/**
	 * Shows or hides information about a recipient
	 * @param {object} recipient the recipient to show/hide
	 * @param {object} mail the mail whose recipient this is
	 */
	function swapRecipient(recipient, mail) {
		let mc = container.find('#recipient_' + recipient.id);
		if (mc.length) {
			mc.remove();
			return;
		}
		let conf = new TrackListConfig();
		let len = expandedTrackLists.length;
		let trackList;
		conf.affectFilters = false;
		conf.allowMiniBlock = true;
		conf.bankKey = 'recipient_' + recipient.id;
		let columnList = [];
		let cols = [{ name: 'play', columns: ['play'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop'] },
			{ name: 'title', columns: ['title'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop'] },
			{ name: 'music rep', columns: ['avatar', 'rep'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
			{ name: 'album', columns: ['album'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop'] },
			{ name: 'artist', columns: ['artist'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop'] },
			{ name: 'genre', columns: ['genre'], enabledSiteTypes: ['drop'] },
			{ name: 'added by', columns: ['added_by'], enabledSiteTypes: ['drop'] },
			{ name: 'length', columns: ['length'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop'] },
			{ name: 'plays', columns: ['plays'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop'] },
			{ name: 'downloads', columns: ['downloads'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop'] }];
		for (var col of cols) {
			if (col.enabledSiteTypes.includes(config.siteType)) columnList.push(new ListColumn(col.name, col.columns));
		}
		conf.addColumnList(columnList);
		conf.defaultResultsPerPage = 10;
		conf.pagination = true;
		conf.resultCountChanging = false;
		conf.resultsPerPageCookie = false;
		conf.sortable = false;
		conf.useFilters = false;

		trackList = createTrackList(conf);
		expandedTrackLists[expandedTrackLists.length] = trackList;
		container.find('#mail_recipient_header_' + recipient.id).after(templates.get('recipient_container', { id : recipient.id }));
		trackList.generatePage($j('#track_list_recipient_' + recipient.id).get(0));

		/**
		 * We're creating a new, anonymous object to manage this track list
		 * We have to do this because when the user clicks the next button on a track list, we need to know which
		 * track list to advance. The TrackList accepts a function to call on page change but that function won't
		 * know which list it's supposed to be operating on. So what we do is create a function with its own scope
		 * and that scope contains a variable that has the track list. It's all about anonymous functions
		 * being able to access some variables
		 *
		 * This code is all stolen and modified from the project page
		 * 
		 * RAC 2019-02-08 - It's entirely possible this whole monstrosity could be refacted down to nothing
		 * but it does work and I don't want to break anything. If you're bored, give it a shot. Assume whoever wrote it
		 * doesn't understand JavaScript scope very well. Also look for duplicates in other code
		 */
		trackList.manager = { type:{mailId:mail.id, recipientId:recipient.id}, trackList:trackList, rpp:conf.defaultResultsPerPage, first:true,
			/**
			 * Sets the tracks of the project after they're loaded on the server
			 * @param {JSON} newData the track data
			 */
			setTracks:function(newData) {
				/**
				 * We create the "next page" function, func, within its own scope so it can get to the manager
				 * By passing "this" into the unnamed anonymous function, js creates an internal scope around
				 * func and when "next page" is clicked, func still has that scope that includes the manager, o
				 */
				(function (o) {
					function func(vars) {
						if (typeof vars === 'string') {
							var matches = vars.match(/pg=([0-9]+)/);
							if (matches) {
								vars = matches[1];
							}
						}
						o.loadPage(vars);
						return false;
					}
					o.trackList.setData(newData, function() { return getDefaultLink(); }, func);
					if (o.first) {
						o.first = false;
					}
				})(this);
			},
			/**
			 * Calls the load to actually commence loading the next page's data
			 * @param {int} page the page to load
			 */
			loadPage:function(page) {
				/**
				 * Doesn't require the same kind of scope considerations because loadPage is called through
				 * an eval, which lets us create a reference to it as a string
				 * expandedTrackLists[' + index + '].manager.setTracks
				 * in the conf
				 */
				trackList.loadApiPage({
					handler : 'mail-tracking',
					action : 'get-tracks',
					getData : {
						mailId : this.type.mailId,
						recipientId : this.type.recipientId,
						show : this.rpp,
						pg : page
					}
				}).then(data => {
					if (expandedTrackLists.length <= len) {
						expandedTrackLists[len] = trackList;
					}
					
					data = data.map(item => Object.assign(item, { skipWaveForm: true }));
					trackList.manager.setTracks(data);
				}).catch(e => {
					sa.notify(e.message);
				});
			}
		};
		trackList.manager.loadPage(0);
	}
	
	let userList;

	function showUserFilter() {
		if (options.type !== page.SentTypeAdmin) {
			return;
		}
		if (!userList) {
			userList = [];
			sa.api.request({
				handler : 'mail-tracking',
				action : 'list-senders'
			}).then(function(senders) {
				userList = senders;
				showUserFilter();
			}).catch(function(e) {
				sa.notify(e.message);
			});
		} else if (userList.length < 1) {
			return;
		}
		
		let userFilterContainer = templates.get('user_filter');
		let userFilter = userFilterContainer.find('*[name=selector]');
		userList.each(function(i, user) {
			userFilter.append(new Option(user.username, user.id, selectedUserId == user.id, selectedUserId == user.id));
		});
		userFilter.on('change', function() {
			loadSent(0, this.value);
		});
	
		container.find('.list_control_bar').append(userFilterContainer);
		
	}

	return page;

})();

if (config.siteType === 'drop') {
	
	/**
	 * The page on drop sites that lets you see what users have been search for
	 */
	sa.pages.dropSent = (function () {

		let page = {
			name : 'dropSent',
			title : 'Sent',
			register : {
				routes: [{
					name: 'sent',
					pattern: '/sent-drop',
					page: 'sent.drop',
					hash: '#!sent'
				}]
			}
		};
		
		var templates;

		/**
		 * Sets up the basic framework of the page and its objects
		 * @param {string} params the parameters from the url
		 */
		page.show = function (params) {

			if (sa.getCurrentPageName() !== page.name) {
				
				if (!templates) {
					templates = sa.templates.get('pages.sent.drop');
				}

				let container = templates.get('container');
				
				sa.components.leftNav.show();
				sa.components.leftNav.disableAlbumFilters();
				sa.components.leftNav.disableTrackFilters();
				sa.components.heading.hide();

				sa.pages.sent.show({
					type : sa.pages.sent.SentTypeAdmin,
					topMessage : '',
					emptyMessage : 'No one has sent anything yet. You can send playlists, albums, and tracks by clicking the <span class="fa fa-share"></span> anywhere it appears or in the More Options drop downs.'
				}, container.find('#sent_container'));
				
				sa.body.empty().append(container);
				
				sa.components.heading.show('Sent Playlists, Albums, and Tracks');
				

			}
			
			sa.currentPage = page;
			
		};
		
		return page;

	})();

}
/* eslint-disable no-undef */

/**
 * The page that shows results from a Sonic Search
 */
class SonicSearchPage {
	constructor() {
		const page = this;

		page.name = 'sonicsearch';
		page.title = 'Sonic Search';
		page.register = {
			routes: [{
				name: 'sonicsearch',
				pattern: '/sonicsearch/:int',
				hash: '#!sonicsearch',
				id: 'id'
			},
			{
				name: 'sonicsearch',
				pattern: '/sonicsearch',
				hash: '#!sonicsearch'
			}]
		};

		page.container = null;
		page.rightContainer = null;
		page.ss_id = null;
		page.listConfig = new TrackListConfig();
		const { listConfig } = page;

		// How many results to show, ideally
		page.howManyToShow = 100;

		listConfig.allowMiniBlock = true;
		listConfig.useStandardColumnList();
		listConfig.callback = function (data) { page.setData(data); };
		listConfig.callbackActual = function (data) { page.setData(data); };
		listConfig.useFilters = true;
		listConfig.sortable = false;
		listConfig.bankKey = 'sonicSearchResultsPage';
		listConfig.defaultResultsPerPage = page.howManyToShow;
		listConfig.selectable = true;
		listConfig.topBar = true;
		listConfig.pagination = false;
		listConfig.resultCountChanging = false;

		page.vars = {};
		page.maxResults = page.howManyToShow;
		page.maxLoops = 5;
		page.seedDuration = null;
		page.name = 'sonicsearch';
		page.resultsSoFar = 0;
		page.loopsSoFar = 0;
		page.lastStart = 0;
		page.lastLimit = 100;
		page.ids_used = [];

		// page.list = createSonicSearchResultsList(listConfig);
		/**
		 * FILL THIS ARRAY IN THE REVERSE ORDER THAT YOU WANT THE TABS TO SHOW UP
		 */
		page.sonicsearchResultsLists = [];

		page.sonicsearchResultsLists.push({
			// showFirst/: true,
			name: 'ssv3',
			tabTitle: 'Sonic Search' + (config.showAims ? ' V3' : ''),
			list: createSonicSearchResultsList(listConfig),
			dataFetcher: page.getSonicSearch3Data.bind(page),
			div: createDiv('list_ssv3_' + page.listConfig.bankKey, 'list ss-results-list'),
		});

		page.ssv3List = createSonicSearchResultsList(listConfig);

		if (config.showAims) {
			page.sonicsearchResultsLists.push({
				// showFirst: true,
				name: 'aims',
				tabTitle: 'AIMS',
				list: createSonicSearchResultsList(listConfig),
				dataFetcher: page.getAimsData.bind(page),
				div: createDiv('list_aims_' + page.listConfig.bankKey, 'list ss-results-list'),
			});
			page.aimsList = createSonicSearchResultsList(listConfig);
		}
		
	}

	/**
	 * Called when the page is shown by the router
	 * @param {string} params - the query params string sent to the page
	 */
	show(params) {
		const page = this;
		const pageVars = sa.router.paramsToVars(params);
		if (!config.showSonicSearch) {
			sa.alert({
				text: 'Sorry, this workspace has disabled Sonic Search.',
				onClose() {
					sa.router.routeTo(sa.router.pathConversionLookup(config.home));
				}
			});
			return;
		}

		if (sa.getCurrentPageName() !== 'sonicsearch') {
			clearBody();
			page.container = createDiv('wang_container', 'max_width');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAlbumFilters();
			sa.components.leftNav.enableTrackFilters();
			const right = createDiv('right_content', 'right_content');
			// const expList = createDiv('list_' + page.listConfig.bankKey, 'list');
			// page.list.generatePage(expList);
			// right.appendChild(expList);

			// Show other lists
			for (const otherList of page.sonicsearchResultsLists) {
				$j(otherList.div).empty();
				otherList.list.generatePage(otherList.div);
				right.appendChild(otherList.div);
			}

			page.container.appendChild(right);
			page.container.appendChild(createDiv('', 'clr'));
			get('body').appendChild(page.container);
			page.rightContainer = $j(right);

			// heading
			sa.components.heading.hide();

			// build the heading
			const genTab = function (name, title, listDiv) {
				const tab = $j(`<span id="${name}-tab" class="tab">${title} <i id="${name}-header-spinner" class="fa fa-refresh fa-spin"></i></span>`);
				tab.data('list', $j(listDiv));
				tab.click(function () {
					// hide other lists
					$j(this).siblings('.tab').each(function () {
						$j(this).removeClass('selected');
						$j(this).data('list').css('opacity', 0).css({
							visibility: 'hidden',
							position: 'absolute',
							opacity: 0,
						});
					});
					// show this list
					$j(this).addClass('selected');

					$j(this).data('list').css({
						visibility: 'visible',
						position: 'relative',
						opacity: 1
					});
				});
				return tab;
			};

			if (config.showAims) {
				sa.components.heading.show('Audio Search');
			} else {
				sa.components.heading.show('Sonic Search');
			}
			const $heading = sa.getDomBody().find('#heading');
			$heading.addClass('with_sonicsearch');

			if ($heading.find('.title-wrapper').length === 0) {
				$heading.find('#text').wrap('<div class="title-wrapper"></div>');
				$heading.find('.title-wrapper').append('<div class="powered-by"><a href="https://www.sourceaudio.com/ai-features/" target="_blank">Powered By Artemis</a></div>');
			}

			sa.getDomBody().find('#heading #text').addClass('supersonicsearch_title');

			// add the tabs
			if (page.sonicsearchResultsLists.length > 1) {
				/**
				 * handle tabs here rather than in the header, since we are custom handling for
				 * the tab counts and showing/hiding the lists
				 */
				const tabContainer = $j('<div class="tab_container"></div>');
			
				for (const otherList of page.sonicsearchResultsLists) {
					const tab = genTab(otherList.name, otherList.tabTitle, otherList.div);
					tabContainer.append(tab);
				}
				sa.getDomBody().find('#heading').prepend(tabContainer);
				sa.getDomBody().find('#heading').addClass('with_tabs');

				// click the tab that should be shown first
				const showFirst = page.sonicsearchResultsLists[page.sonicsearchResultsLists.length - 1];
				tabContainer.find('#' + showFirst.name + '-tab').click();
			}
		}

		if (pageVars.track_search && trackBank.find(pageVars.track_search)) {
			// show header immediately if we already have the track loaded
			this.addHeader({
				search_data: {
					seed_track: {
						id: pageVars.track_search,
						title: trackBank.find(pageVars.track_search).title
					}
				}
			});
			
			$j('#ss_container').removeClass('show');
		}
		sa.currentPage = this;
		page.params = params;
		page.loadPage(pageVars);
	}

	/**
	 * Begins the actual search
	 * @param {Object} vars - the params from show turned into vars
	 */
	loadPage(vars) {
		const page = this;
		page.currentUrlPath = sa.router.getCurrentPath();

		const listShowFirst = page.sonicsearchResultsLists[page.sonicsearchResultsLists.length - 1].list;
		listShowFirst.showCover('', 'Finding Matches...');

		page.vars = vars;

		if (vars.id !== page.ss_id) {
			console.log('resetting leftnav');
			sa.components.leftNav.reset();
			page.ss_id = vars.id;
		}

		for (const listData of page.sonicsearchResultsLists) {
			listData.dataFetcher(vars);
		}
	}

	addSonicSearchFilters(pageVars, apiData) {
		const page = this;
		const data = apiData;
		const { search_data: searchData } = data;

		if (page.vars.s) {
			pageVars.s = page.vars.s;
		}
		if (page.vars.track_search) {
			pageVars.ts = page.vars.track_search;
			pageVars.tstitle = data.track_search_title;
		}
		if (searchData.url) {
			// set vars to help us format the title of the search results page
			if (searchData.url.indexOf('youtu') !== -1) {
				pageVars.youtube = 1;
			} else if (searchData.url.indexOf('soundcloud') !== -1) {
				pageVars.soundcloud = 1;
			}
			
			console.log('adding ssurl as', searchData.url, encodeURIComponent(searchData.url));
			pageVars.ssurl = searchData.url;
			pageVars.sstitle = searchData.title || searchData.url;
		}
		
		if (searchData.filename) {
			pageVars.ss = searchData.filename;
		}
	}

	/**
	 * Sets the list data using the sonic search request results
	 * @param {Object} data - the sonic search response data
	 * @param whichList
	 */
	setData(data, whichList = 'ss') {
		const page = this;
		page.setHeaderCount(whichList, data.match_count);
		
		data.track_info = JSON.parse(data.tracks_raw);

		page.resultsSoFar += data.results_count;

		const searchData = data.search_data;
		const ts = Math.round((new Date()).getTime() / 1000);

		// now completely overhaul the titles
		this.addHeader(data);

		if (searchData.seed_track) {
			const seed = searchData.seed_track;
			console.log('seed track:', seed);
			seed.id = parseInt(seed.id);
			page.seedDuration = seed.actualLength;
			page.vars.track_search = seed.id; // just in case we loaded this
			page.addPlayer(seed, true);
			data.track_search_title = seed.title;
		} else if (searchData.waveform && searchData.date + (86400 * 30) > ts) {
			page.seedDuration = searchData.duration;
			page.addPlayer(searchData);
		} else {
			// make sure it's clear
			$j('#ss_container').remove();
		}

		// is this a segment? let's place our grabbers
		console.log('- search data at clipper dec:', searchData);
		if (searchData.cl) {
			page.placeClippers(searchData.cs, searchData.cl);
		} else if (page.seedDuration) {
			page.placeClippers(0, page.seedDuration);
		}

		$j('#ss_container').addClass('show');

		const tracksList = {};
		const infoVars = data.track_info.shift();
		infoVars.filters = data.all_filters; // this is an override with all tracks available

		// When ss adds to the pageVars, it must ensure each var is only present a single time in the list or the List will throw an error when parsing them.
		// This is now done by parsing the pageVars from a string to an indexed object, updating the object, and then converting it back into a string
		const pageVars = sa.router.paramsToVars(infoVars.pageVars);
		page.addSonicSearchFilters(pageVars, data);

		// show only save search if no other filters
		const nonFilterKeys = ['o', 'd', 'show', 'pg'];
		const haveFilters = Object.keys(pageVars).filter(a => !nonFilterKeys.includes(a)).length > 0;
		if (!haveFilters) pageVars.showSaveSearchOnly = true;
		infoVars.pageVars = sa.router.varsToParams(pageVars);
		console.log('info page vars', infoVars.pageVars);

		console.log('pageVars', pageVars);

		for (const track of data.track_info) {
			tracksList[track.id] = track;
		}

		// round the number to show to the nearest 50
		// We may have gotten back more than we requested because we request more so that once they are filtered, 
		// we get the number we expect.  SO display them all, with the "perPage" being a nice round multiple of 50
		const numResults = Object.keys(tracksList).length;
		const listParams = {
			count: Math.min(page.howManyToShow, numResults),
			page: 0,
			perPage: page.howManyToShow,
			pageVars: infoVars.pageVars
		};

		// format data
		const listItems = [];
		listItems.push(listParams);
		let toShow = page.howManyToShow;

		for (const t of data.matches) {
			const item = tracksList[parseInt(t.track_id)];
			if (!item) { // this got filtered
				continue;
			}
			if (page.ids_used.includes(t.track_id)) { // already used
				continue;
			}
			if (toShow) {
				toShow--;
			} else {
				break; // breaks loop, we're got our 50
			}

			const perc = Math.min(100, Math.round(200 - t.score));
			item.wang_score = ((perc > 1) ? perc + '% ' : 'Poor Match');
			listItems.push(item);
			page.ids_used.push(t.track_id);
		}

		sa.components.leftNav.reset();
		sa.components.leftNav.setParams(infoVars.pageVars, 'tracks');
		sa.components.leftNav.showSmartFilters(infoVars.filters);

		page.sonicsearchResultsLists.find(l => l.name === whichList).list.setData(listItems, (params) => {
			return '/sonicsearch/' + page.vars.id + '?' + params;
		}, () => { console.log('sort click'); return true; });

		page.loopsSoFar++;
	}

	addHeader(data) {
		// set title
		let titleText;
		console.log('data', data);
		
		if (this.vars.track_search || data?.search_data?.seed_track) {
			const trackLink = getTrackLink(data?.search_data?.seed_track?.id);
			titleText = `<a href="${trackLink}">${data?.search_data?.seed_track?.title}</a>`;
		} else if (data?.search_data?.url) {
			titleText = `<a href="${data?.search_data?.url}" target="_blank">${data?.search_data?.title || data?.search_data?.url}</a>`;
		} else {
			titleText = data?.search_data?.filename;
		}
		
		const $headBar = $j('#heading');
		const $titles = $headBar.find('.titles');
		$headBar.find('.heading_left').addClass('with_result');
		
		// current text
		const sonicSearchTitle = $titles.find('h1').text();
		if ($titles.find('.ss-colon').length === 0) {
			$titles.find('h1').append('<span class="ss-colon">:</span>');
		}
		
		if (sonicSearchTitle && titleText) {
			// add colon to sonicsearch text
			$titles.find('.ss-colon').addClass('show');
		} else if (sonicSearchTitle && !titleText) {
			// remove colon
			$titles.find('.ss-colon').removeClass('show');
		}

		if ($titles.find('.search-title').length === 0 && titleText) {
			$titles.append(`<div class="search-title">${titleText}</div>`);
		} else {
			$titles.find('.search-title').html(titleText);
		}

		// Pro tip
		if ($headBar.find('.pro-tip').length === 0) {
			$headBar.find('.heading_right').append('<div class="pro-tip">' + '<b>Pro tip</b>: You can further refine your search with keywords from the search bar.' + '</div>');
		}
	}

	/**
	 * Adds the player to the page, which is custom from other parts of the site
	 * @param {Object} data
	 * @param {boolean} realTrack - is this a SourceAudio track or an upload?
	 */
	addPlayer(data, realTrack) {
		const page = this;
		if (!$j('#ss_player').length) {
			const headBar = $j('#heading');
			const cont = $j(''
				+ '<div id="ss_container">'
				// + '<div id="ss_header">'
				// + '<div class="header_left">Sonic Search: <span>filename.mp3</span></div>'
				// + '<div class="header_left"></div>'
				// + '<div class="header_right"><b>Pro tip</b>: You can further refine your search with keywords from the search bar.</div>'
				// + '<div class="clr"></div>'
				// + '</div>'
				+ '<div id="ss_player">'
				+ '<div class="ss_player_clip_button button faux_button">Go</div>'
				+ '<div class="ss_player_button">button</div>'
				+ '<div class="ss_player_waveform">waveform</div>'
				+ '<div class="clr"></div>'
				+ '</div>'
				+ '<div id="ss_clipper">'
				+ '<div id="ss_clipper_right">'
				+ '<div class="ss_clipper_overlay"></div>'
				+ '<div id="ss_clipper_right_tab" class="ss_clipper_tab button faux_button"><i class="fa fa-caret-up"></i></div>'
				+ '<div class="clr"></div>'
				+ '</div>'
				+ '<div id="ss_clipper_left">'
				+ '<div class="ss_clipper_overlay"></div>'
				+ '<div id="ss_clipper_left_tab" class="ss_clipper_tab button faux_button"><i class="fa fa-caret-up"></i></div>'
				+ '<div class="clr"></div>'
				+ '</div>'
				+ '</div>'
				+ '</div>');
		
			if (page.sonicsearchResultsLists.length === 1) {
				headBar.after(cont); // add it to the dom
			} else {
				headBar.before(cont); // add it to the dom
			}
		}

		// set title
		// let $titleText = '';
		// if (page.vars.track_search) {
		// 	let trackLink = getTrackLink(data.id);
		// 	$titleText = `<a href="${trackLink}">${data.title}</a>`
		// } else {
		// 	if (data.url) {
		// 		$titleText = `<a href="${data.url}" target="_blank">${data.title || data.url}</a>`
		// 	} else {
		// 		$titleText = data.filename;
		// 	}
		// }
		// $j('#ss_header .header_left span').html($titleText);

		// make a fake track object
		let track;
		let button;
		let fakeBankTrack;
		if (realTrack) {

			track = data;
			trackBank.add(track, 'sonicSearchResultsWaveForm');

			button = sa.components.player.generatePlayButton(data.id, { location: 'sonicsearch' });

		} else {

			// get wf id
			let wfA = data.waveform.split('/');
			wfA = wfA[wfA.length - 1].split('.');
			const waveFormId = wfA[0];
			console.log('- waveform id:', waveFormId);
			track = {
				type: 'sonicsearch',
				id: data.search_id,
				artist: 'Sonic Search Upload',
				title: data.title ? data.title : data.filename,
				playHtml5File: 'https://sourceaudio-ss.s3.amazonaws.com/' + data.files.mp3,
				file: {
					waveform: 'https://sourceaudio-ss.s3.amazonaws.com/' + data.waveform,
					waveformCallbackId: waveFormId
				},
				length: data.duration || data.length
			};
			fakeBankTrack = track;
			fakeBankTrack.id = 0 - fakeBankTrack.id;

			trackBank.add(fakeBankTrack, 'sonicSearchResultsWaveForm');

			button = sa.components.player.generatePlayButton(data.id, { location: 'sonicsearch', importTrack: track });
		}

		// make the play button
		$j('#ss_player .ss_player_button').html(button);

		// make the waveform
		const wf = new Waveform(fakeBankTrack ? fakeBankTrack.id : track.id, $j('#ss_player .ss_player_waveform'), false);

		// set up the clipper
		$j('#ss_clipper_left .ss_clipper_tab, #ss_clipper_right .ss_clipper_tab').off();
		$j('#ss_clipper_left .ss_clipper_tab, #ss_clipper_right .ss_clipper_tab').on('mousedown touchstart', e => page.clipperDown(e));
		$j('#ss_clipper_left .ss_clipper_tab, #ss_clipper_right .ss_clipper_tab').on('dblclick', e => page.clipperReset(e));
		$j('.ss_player_clip_button').off().on('click', e => page.clipperGo(e));
	}

	/**
	 * initial placement of clipper given a start time and length
	 * @param {number} cs - clip start
	 * @param {number} cl - clip length
	 */
	placeClippers(cs, cl) {
		const page = this;

		console.log('- placing clippers:', cs, cl);
		const leftClipper = $j('#ss_clipper_left');
		const rightClipper = $j('#ss_clipper_right');
		const canvas = $j('.ss_player_waveform canvas');

		const pixPerSecond = canvas.width() / page.seedDuration;

		leftClipper.find('.ss_clipper_overlay').width(cs * pixPerSecond);
		rightClipper.find('.ss_clipper_overlay').width(canvas.width() - (cs + cl) * pixPerSecond);

		const leftTime = Math.round(leftClipper.find('.ss_clipper_overlay').width() / pixPerSecond);
		const rightTime = Math.round((canvas.width() - rightClipper.find('.ss_clipper_overlay').width()) / pixPerSecond);
		const length = rightTime - leftTime;

		page.currentLeft = leftTime;
		page.currentLength = length;
	}

	/**
	 * Triggers moving the clippers on resize event
	 */
	clipperResize() {
		const page = this;
		page.placeClippers(page.currentLeft, page.currentLength);
	}

	/**
	 * Run a search with the clip selected by the clippers
	 */
	clipperGo() {
		const page = this;
		// let's caculate our current time positions
		const leftClipper = $j('#ss_clipper_left');
		const rightClipper = $j('#ss_clipper_right');
		const canvas = $j('.ss_player_waveform canvas');

		const pixPerSecond = canvas.width() / page.seedDuration;

		const leftTime = Math.round(leftClipper.find('.ss_clipper_overlay').width() / pixPerSecond);
		const rightTime = Math.round((canvas.width() - rightClipper.find('.ss_clipper_overlay').width()) / pixPerSecond);
		const length = rightTime - leftTime;

		console.log('clipper go:', leftTime, rightTime, length);

		// let's process the clip
		const listShowFirst = page.sonicsearchResultsLists[0].list;
		if (page.vars.track_search) { // track search
			listShowFirst.showCover(null, 'Processing Clip...');

			sa.api.request({
				handler: 'sonicsearch',
				action: 'processTrackClip',
				getData: {
					track_search: page.vars.track_search,
					cs: leftTime,
					cl: length
				}
			}).then((response) => {
				console.log('clip process response', response);

				if (response.error) {
					sa.error(response.error);
					listShowFirst.hideCover();
					return;
				}

				sa.router.routeTo('/sonicsearch/' + response.search_id);
			});
			
		} else { // regular track

			listShowFirst.showCover(null, 'Processing Clip...');

			sa.api.request({
				handler: 'sonicsearch',
				action: 'processFileClip',
				getData: {
					search_id: page.vars.id,
					cs: leftTime,
					cl: length
				}
			}).then((response) => {
				console.log('clip process response', response);

				if (response.error) {
					sa.error(response.error);
					listShowFirst.hideCover();
					return;
				}

				sa.router.routeTo('/sonicsearch/' + response.search_id);
			});
		} // end if else
	} // end clipperGo

	/**
	 * Places the clippers at the original locations
	 * @param {Event} event
	 */
	clipperReset(event) {
		const page = this;
		event.preventDefault();
		event.stopPropagation();
		page.placeClippers(0, page.seedDuration);
	}

	/**
	 * Handles when the clipper is clicked
	 * @param {Event} event
	 */
	clipperDown(event) {
		const page = this;
		const ogEvent = event;

		if (event.originalEvent && (event.originalEvent.touches || event.originalEvent.changedTouches)) {
			event = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0]; // override because jquery doesn't track
		}

		$j(window).one('mouseup.clippers touchend.clippers', (e) => page.clipperUp(e));
		$j(window).on('mousemove.clippers touchmove.clippers', (e) => page.clipperMove(e));

		if (ogEvent.currentTarget?.id === 'ss_clipper_left_tab') { // left!
			page.currentClipper = 'left';
		} else { // right!
			page.currentClipper = 'right';
		}

		ogEvent.preventDefault();
		ogEvent.stopPropagation();

		page.clipperMove(event); // placement code is in move, but we still want to do it
	}

	/**
	 * Handles dragging of the clipper
	 * @param {Event} event
	 */
	clipperMove(event) {
		const page = this;

		// console.log("clipper move event", event)

		if (event.originalEvent && (event.originalEvent.touches || event.originalEvent.changedTouches)) {
			event = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0]; // override because jquery doesn't track
		}

		const leftClipper = $j('#ss_clipper_left');
		const rightClipper = $j('#ss_clipper_right');

		// console.log('move!', event.pageX, event.pageY);
		const canvas = $j('.ss_player_waveform canvas');
		const anchor = canvas.offset();

		const pixPerSecond = canvas.width() / page.seedDuration;
		const fivesecs = 5 * pixPerSecond;
		const sixtysecs = 60 * pixPerSecond;
		const aimsActive = $j('#aims-tab').hasClass('selected');
		const clipperMax = canvas.width() - fivesecs;

		// where do we put anchor?
		const xdiff = event.pageX - anchor.left;

		let newWidth;
		if (page.currentClipper === 'left') {
			newWidth = Math.min(Math.max(0, xdiff), clipperMax);

			leftClipper.find('.ss_clipper_overlay').width(newWidth);
			// do we have five seconds between our clippers? if not, we need to move the right one to make room
			if (newWidth + fivesecs + rightClipper.find('.ss_clipper_overlay').width() > canvas.width()) {
				rightClipper.find('.ss_clipper_overlay').width(canvas.width() - (newWidth + fivesecs));
			}

			// if the clip would be longer than 60s and aims is active, we need to max it to 60
			if (aimsActive && newWidth + sixtysecs + rightClipper.find('.ss_clipper_overlay').width() < canvas.width()) {
				rightClipper.find('.ss_clipper_overlay').width(canvas.width() - (newWidth + sixtysecs));
			}

		} else { // right
			newWidth = Math.min(Math.max(0, canvas.width() - xdiff), clipperMax);

			rightClipper.find('.ss_clipper_overlay').width(newWidth);

			// do we have five seconds between our clippers? if not, we need to move the right one to make room
			if (newWidth + fivesecs + leftClipper.find('.ss_clipper_overlay').width() > canvas.width()) {
				leftClipper.find('.ss_clipper_overlay').width(canvas.width() - (newWidth + fivesecs));
			}

			// if the clip would be longer than 60s and aims is active, we need to max it to 60
			if (aimsActive && newWidth + sixtysecs + leftClipper.find('.ss_clipper_overlay').width() < canvas.width()) {
				leftClipper.find('.ss_clipper_overlay').width(canvas.width() - (newWidth + sixtysecs));
			}
		}
	}

	/**
	 * Handles releasing the clipper
	 * @param {Event} event
	 */
	clipperUp(event) {
		const page = this;
		// console.log("clipper up event", event)
		if (event.originalEvent.touches || event.originalEvent.changedTouches) {
			event = event.originalEvent.touches[0] || event.originalEvent.changedTouches[0]; // override because jquery doesn't track
		}
		const canvas = $j('.ss_player_waveform canvas');
		
		$j(window).off('mouseup.clippers touchend.clippers');
		$j(window).off('mousemove.clippers touchmove.clippers');

		const pixPerSecond = canvas.width() / page.seedDuration;
		const leftClipper = $j('#ss_clipper_left');
		const rightClipper = $j('#ss_clipper_right');

		const leftTime = Math.round(leftClipper.find('.ss_clipper_overlay').width() / pixPerSecond);
		const rightTime = Math.round((canvas.width() - rightClipper.find('.ss_clipper_overlay').width()) / pixPerSecond);
		const length = rightTime - leftTime;

		page.currentLeft = leftTime;
		page.currentLength = length;
	}

	/**
	 * Sets the spinner in the header tabs to the amount of results from the provided service
	 * @param {string} service - the service the results are for
	 * @param {int} count - the number of results
	 */
	setHeaderCount(service, count) {
		$j('#' + service + '-header-spinner').replaceWith('(' + count + ')');
	}

	/**
	 * Handles the AIMS search request to backend
	 * @param {Object} vars - the query params in object form
	 */
	async getAimsData(vars) {
		const page = this;

		page.resultsSoFar = 0;
		page.loopsSoFar = 0;
		page.lastStart = 0;
		page.lastLimit = 50;

		page.ids_used = [];

		if (!vars.id && !vars.track_search) {
			rightContainer.html('no id provided.');
			return;
		}

		// New supersonicsearch
		page.vars.strategy = vars.strategy || 'default';

		// console.log('getting data', vars);
		const pathBeforeLoad = sa.router.getCurrentRoute(true);
		console.time('first aims search');
		const r = await sa.api.request({
			handler: 'aimssearch',
			action: 'search',
			getData: vars
		});
		console.timeEnd('first aims search');

		console.log('sonic search load:', r);
		const baseUrl = siteBaseUrl();
		const newPath = sa.router.buildFullUrl(pathBeforeLoad);

		// this page takes a long time to load and if the user gives up and navigates away, it tries to take back over and ends up throwing errors
		if (sa.router.getCurrentRoute(true) !== pathBeforeLoad) {
			console.log('skipping sonic search page bc url changed');
			sa.notify({ text: 'Your Sonic Search results are ready: <a href="' + newPath.href + '">click here to view them</a>' });
			return;
		}
		
		if (r.error) return sa.alert({ text: r.error, error: 1, onClose() { if (!config.showAims) window.location.href = baseUrl; } });
		page.searchData = r;
		page.setData(r, 'aims');
	}

	async getSonicSearch3Data(vars) {
		const page = this;

		page.resultsSoFar = 0;
		page.loopsSoFar = 0;
		page.lastStart = 0;
		page.lastLimit = 50;

		page.ids_used = [];

		if (!vars.id && !vars.track_search) {
			page.rightContainer.html('no id provided.');
			return;
		}

		// New supersonicsearch
		page.vars.strategy = vars.strategy || 'default';

		// console.log('getting data', vars);
		const pathBeforeLoad = sa.router.getCurrentRoute(true);
		console.time('first ssv3 search');
		const r = await sa.api.request({
			handler: 'sonicsearch',
			action: 'getV3Results',
			getData: vars
		});
		console.timeEnd('first ssv3 search');

		console.log('sonic search ssv3 load:', r);
		const baseUrl = siteBaseUrl();
		const newPath = sa.router.buildFullUrl(pathBeforeLoad);

		if (sa.router.getCurrentRoute(true) !== pathBeforeLoad) { // this page takes a long time to load and if the user gives up and navigates away, it tries to take back over and ends up throwing errors
			console.log('skipping sonic search page bc url changed');
			sa.notify({ text: 'Your Sonic Search results are ready: <a href="' + newPath.href + '">click here to view them</a>' });
			return;
		}
		if (r.error) return sa.alert({ text: r.error, error: 1, onClose() { if (!config.showAims) window.location.href = baseUrl; } });
		page.searchData = r;
		page.setData(r, 'ssv3');
	}
}

sa.pages.sonicsearch = new SonicSearchPage();
/**
 * The page that generates AI playlists
 */

class AgpDemoPage {

	constructor() {
		const page = this;

		page.name = 'agpdemo';
		page.title = 'AI Generated Playlists';
		page.register = {
			routes: [{
				name: 'agp',
				pattern: '/agp/:int',
				hash: '#!agp',
				id: 'id'
			},
			{
				name: 'agp',
				pattern: '/agp',
				hash: '#!agp'
			}]
		};

		page.container = null;
		page.rightContainer = null;

		page.howManyToShow = 50;
		page.ids_used = [];

		const listConfig = new window.TrackListConfig();
		page.listConfig = listConfig;
		listConfig.allowMiniBlock = true;
		listConfig.useStandardColumnList();
		listConfig.callback = function (data) { page.setData(data); };
		listConfig.callbackActual = function (data) { page.setData(data); };
		listConfig.useFilters = true;
		listConfig.sortable = false;
		listConfig.bankKey = 'agpResultsPage';
		listConfig.defaultResultsPerPage = page.howManyToShow;
		listConfig.selectable = true;
		listConfig.topBar = true;
		listConfig.pagination = false;
		listConfig.resultCountChanging = false;

		page.list = window.createSonicSearchResultsList(listConfig);
		page.seedsList = window.createSonicSearchResultsList(listConfig);
	}

	/**
	 * Called when the page is shown by the router
	 * @param {string} params - the query params string sent to the page
	 */
	show(params) {
		const page = this;
		page.vars = sa.router.paramsToVars(params);

		// make sure we just arrived on this page
		if (sa.getCurrentPageName() === page.name) return;

		// build the page
		window.clearBody();
		page.rightContainer = $j('<div id="right_content" class="right_content max_width"><div id="agp_page">Loading...</div></div>');
		
		$j('#body').append(page.rightContainer);
		page.container = $j('#agp_page');
		page.templates = sa.templates.get('agp_demo');

		sa.components.leftNav.show();
		sa.components.leftNav.disableAlbumFilters();
		sa.components.heading.hide();
		sa.components.heading.show('AI Playlist Generator');

		// prompt box
		page.promptBox = page.templates.get('prompt_box').clone();
		page.container.html('').append(page.promptBox);

		// results list
		page.resultsList = page.templates.get('results_list').clone();
		page.container.append(page.resultsList);
		page.list.generatePage(page.container.find('#agp_results_list'));
		page.seedsList.generatePage(page.container.find('#agp_seeds_list'));

		// set up generate button
		page.promptBox.find('#agp_submit').click(async () => {
			const buttonText = page.promptBox.find('#agp_submit').text();
			page.promptBox.find('#agp_submit').html('<i class="fa fa-refresh fa-spin"></i>');
			const prompt = page.promptBox.find('#agp_prompt_input').val();
			console.log('- generating with:', prompt);

			// hide any previous results
			page.promptBox.find('#agp_keywords').html('');

			// show loader
			page.list.showCover(null, 'Loading...');

			page.statusKey = user.userData.id + 'AGP' + Math.round((new Date()).getTime() / 1000);
			console.log('- using status key:', page.statusKey);
			page.checkingStatus = false;
			page.int = setInterval(async () => {
				if (page.checkingStatus) return; // we're already running
				page.checkingStatus = true;
				const r = await sa.api.request({
					handler: 'agp',
					action: 'getPlaylistStatus',
					getData: { statusKey: page.statusKey }
				});
				page.checkingStatus = false;
				if (page.lastStatus === r.status) return;
				page.lastStatus = r.status;
				console.log('- status:', r);
				sa.getDomBody().find('#agp_status').html('<b>Status:</b> ' + r.status);
				if (r.prompt_info) {
					const { genres, keywords } = r.prompt_info.aiIWantResponse;
					sa.getDomBody().find('#agp_keywords').html('<b>Keywords:</b> <span class="pill">' + genres.concat(keywords).join('</span> <span class="pill">') + '</span>');
				}
				if (r.status === 'done') {
					clearInterval(page.int);
					sa.getDomBody().find('#agp_status').html('');
				}
			}, 500);
			const r = await sa.api.request({
				handler: 'agp',
				action: 'generatePlaylistFromPrompt',
				getData: { prompt, statusKey: page.statusKey }
			});
			if (r.error) return sa.alert({ text: r.error, error: 1 });
			page.promptBox.find('#agp_submit').text(buttonText);
			console.log('- timing:', r.timing);
			page.setData(r.results);
			page.setSeedData(r.seeds);
			return sa.getDomBody().find('.tab_container').show();
		});

		const tabContainer = $j('<div class="tab_container" style="display: none;"></div>');

		const tab = page.genTab('results', 'Results', page.container.find('#agp_results_list'));
		tabContainer.append(tab);
		const seedTab = page.genTab('seeds', 'Seeds', page.container.find('#agp_seeds_list'));
		tabContainer.append(seedTab);

		// click the tab that should be shown first
		tabContainer.find('#results-tab').click();
	}

	/**
	 * Builds a heading tab
	 * @param {string} name - the name of the tab
	 * @param {string} title - the title of the tab
	 * @param {string} listDiv - the div containing the list
	 */
	genTab(name, title, listDiv) {
		const tab = $j(`<span id="${name}-tab" class="tab">${title}</span>`);
		tab.data('list', $j(listDiv));
		tab.click(function () {
			// hide other lists
			$j(this).siblings('.tab').each(function () {
				$j(this).removeClass('selected');
				$j(this).data('list').css('opacity', 0).css({
					visibility: 'hidden',
					position: 'absolute',
					opacity: 0,
				});
			});
			// show this list
			$j(this).addClass('selected');

			$j(this).data('list').css({
				visibility: 'visible',
				position: 'relative',
				opacity: 1
			});
		});
		return tab;
	}

	/**
	 * Sets the list data using the sonic search request results
	 * @param {Object} data - the sonic search response data
	 */
	setData(data) {
		const page = this;

		data.track_info = JSON.parse(data.tracks_raw);

		page.resultsSoFar += data.results_count;

		const tracksList = {};
		data.track_info.shift();

		for (const track of data.track_info) {
			tracksList[track.id] = track;
		}

		// round the number to show to the nearest 50
		// We may have gotten back more than we requested because we request more so that once they are filtered, 
		// we get the number we expect.  SO display them all, with the "perPage" being a nice round multiple of 50
		const numResults = Object.keys(tracksList).length;
		const listParams = {
			count: Math.min(page.howManyToShow, numResults),
			page: 0,
			perPage: page.howManyToShow,
			pageVars: ''
		};

		const listItems = [];
		listItems.push(listParams);
		let toShow = page.howManyToShow;

		for (const t of data.matches) {
			const item = tracksList[parseInt(t.track_id)];
			if (!item) { // this got filtered
				continue;
			}
			if (page.ids_used.includes(t.track_id)) { // already used
				continue;
			}
			if (toShow) {
				toShow--;
			} else {
				break; // breaks loop, we're got our 50
			}

			listItems.push(item);
			page.ids_used.push(t.track_id);
		}

		console.log('- results list items:', listItems);
		page.list.setData(listItems, () => {
			return true;
		}, () => { console.log('sort click'); return true; });

		page.list.hideCover();

		// show it, just in case we had a different tab up on a previous search
		sa.getDomBody().find('#results-tab').trigger('click');
	}

	/**
	 * Sets the list data using the sonic search request results
	 * @param {Object} data - the sonic search response data
	 */
	setSeedData(data) {
		const page = this;
		// page.setHeaderCount(whichList, data.match_count);

		page.resultsSoFar += data.results_count;

		const tracksList = {};
		data.shift();

		for (const track of data) {
			tracksList[track.id] = track;
		}

		// round the number to show to the nearest 50
		// We may have gotten back more than we requested because we request more so that once they are filtered, 
		// we get the number we expect.  SO display them all, with the "perPage" being a nice round multiple of 50
		const numResults = Object.keys(tracksList).length;
		const listParams = {
			count: Math.min(page.howManyToShow, numResults),
			page: 0,
			perPage: page.howManyToShow,
			pageVars: ''
		};

		// console.log('list params:', listParams);
		// format data
		let listItems = [];
		listItems.push(listParams);
		listItems = listItems.concat(data);

		console.log('- seeds list items:', listItems);
		page.seedsList.setData(listItems, () => {
			return true;
		}, () => { console.log('sort click'); return true; });

	}
	
}

sa.pages.agpdemo = new AgpDemoPage();
/**
 * The page that generates AI playlists
 */

class AIPlaylistResultsPage {

	constructor() {
		const page = this;

		page.name = 'ai-playlist';
		page.title = 'AI Playlist Results';
		page.register = {
			routes: [{
				name: 'ai-playlist',
				pattern: '/ai-playlist/:any',
				hash: '#!ai-playlist',
				id: 'key'
			},
			{
				name: 'ai-playlist',
				pattern: '/ai-playlist',
				hash: '#!ai-playlist'
			}]
		};

		page.container = null;
		page.rightContainer = null;

		page.howManyToShow = 20;
		page.ids_used = [];

		const listConfig = new window.TrackListConfig();
		page.listConfig = listConfig;
		listConfig.allowMiniBlock = true;
		listConfig.useStandardColumnList();
		listConfig.callback = function (data) { page.setData(data); };
		listConfig.callbackActual = function (data) { page.setData(data); };
		listConfig.useFilters = true;
		listConfig.sortable = false;
		listConfig.bankKey = 'agpResultsPage';
		listConfig.defaultResultsPerPage = page.howManyToShow;
		listConfig.selectable = true;
		listConfig.topBar = true;
		listConfig.pagination = false;
		listConfig.resultCountChanging = false;

		page.list = window.createSonicSearchResultsList(listConfig);
	}

	/**
	 * Called when the page is shown by the router
	 * @param {string} params - the query params string sent to the page
	 */
	async show(params) {
		const page = this;
		page.vars = sa.router.paramsToVars(params);
		console.log('- vars:', page.vars);

		// set the current page
		sa.currentPage = page;

		// build the page
		window.clearBody();
		page.rightContainer = $j('<div id="right_content" class="right_content max_width"><div id="agp_page"></div></div>');
		
		$j('#body').append(page.rightContainer);
		page.container = $j('#agp_page');
		page.templates = sa.templates.get('ai_playlist_results');

		sa.components.leftNav.show();
		sa.components.leftNav.disableAlbumFilters();
		sa.components.heading.hide();

		// get the playlist
		const loader = window.showLoader('#agp_page', 'Loading playlist...');
		const statusKey = page.vars.key;
		let r;
		try {
			r = await sa.api.request({
				handler: 'agp',
				action: 'getPlaylistStatus',
				getData: { statusKey, withResults: true }
			});
		} catch (err) {
			loader.remove();

			if (err.message.startsWith('Please log in')) {
				sa.alert({
					text: err.message,
					buttonText: 'OK',
					onClose: () => { window.location.href = 'login.php'; }
				});
			} else {
				sa.alert({
					text: 'Error getting playlist results: ' + err.message,
					buttonText: 'OK',
					onClose: () => { sa.router.routeTo('/'); }	
				});
			}
			return;
		}

		console.log('- playlist:', r);
		loader.remove();

		// results list
		page.howManyToShow = 20;
		page.resultsList = page.templates.get('results_list');
		page.container.append(page.resultsList);
		page.list.generatePage(page.container.find('#agp_results_list'));
		page.results = r.status.results;
		page.setData(r.status.results);

		page.headingData = {
			title: r.title || r.status.prompt || 'AI Playlist',
			type: 'hero',
			preamble: 'AI Generated Playlist',
			subtext: r.status.prompt || '',
			image: r.art || '',
			bigButtons: [
				{
					id: 'save-to-playlists',
					text: 'Save To My Playlists',
					icon: 'fa-solid fa-floppy-disk',
					action: () => { page.savePlaylist(); }
				}
			]
		};

		sa.components.heading.show(page.headingData.title, page.headingData);

		// get more button
		if (page.results.track_info.length > page.howManyToShow) {
			page.getMoreButton = page.templates.get('more_button');
			page.getMoreButton.on('click', () => { page.getMore(); });
			page.container.append(page.getMoreButton);
		}
		
		// if there's no image, let's keep checking for it
		if (!r.art || !r.title) page.checkForAlbumArt();
	}

	/**
	 * Gets more results (from what we already retrieved) and adds them to the list
	 */
	async getMore() {
		const page = this;

		page.howManyToShow += 10;
		page.setData(page.results);

		if (page.howManyToShow >= page.results.track_info.length) page.getMoreButton.hide();
	}

	/**
	 * Saves the playlist
	 */
	async savePlaylist() {
		const page = this;
		if (page.saving) return;
		console.log('- save playlist', page.howManyToShow);
		page.saving = true;
		$j('#save-to-playlists').find('i').removeClass('fa-floppy-disk').addClass('fa-refresh fa-spin');
		const r = await sa.api.request({
			handler: 'agp',
			action: 'saveToMyPlaylists',
			getData: { statusKey: page.vars.key, numToSave: page.howManyToShow },
		});
		console.log('- save playlist:', r);
		page.saving = false;

		// go to playlist page
		sa.router.routeTo('/playlist/' + r.id);
	}

	/**
	 * Checks for album art and updates the heading if it's found
	 */
	async checkForAlbumArt() {
		const page = this;
		console.log('- starting album art check');
		
		page.artChecks = 0;
		page.int = setInterval(async () => {
			const statusKey = page.vars.key;
			const r = await sa.api.request({
				handler: 'agp',
				action: 'getPlaylistStatus',
				getData: { statusKey, withResults: 0 }
			});
			console.log('- album art check:', r);

			page.artChecks++;
			if (page.artChecks > 10) clearInterval(page.int); // stop checking after 10 rounds
			if (sa.router.currentRoute.name !== 'ai-playlist') {
				clearInterval(page.int); // stop checking if we're not on the page anymore
				return;
			}

			if (r.art) page.headingData.image = r.art;
			if (r.title) page.headingData.title = r.title;
			if (r.art || r.title) {
				$j('#heading').remove();
				sa.components.heading.show(page.headingData.title, page.headingData);
			}
			if (r.art && r.title) clearInterval(page.int);
		}, 5000);
	}

	/**
	 * Sets the list data using the sonic search request results
	 * @param {Object} data - the sonic search response data
	 */
	setData(data) {
		const page = this;

		data.track_info = JSON.parse(data.tracks_raw);
		page.resultsSoFar += data.results_count;

		const tracksList = {};
		data.track_info.shift();

		for (const track of data.track_info) {
			tracksList[track.id] = track;
		}

		const numResults = Object.keys(tracksList).length;
		const listParams = {
			count: Math.min(page.howManyToShow, numResults),
			page: 0,
			perPage: page.howManyToShow,
			pageVars: ''
		};

		const listItems = [];
		listItems.push(listParams);

		listItems.push(...data.track_info.slice(0, page.howManyToShow));

		page.list.setData(listItems, () => {
			return true;
		}, () => { console.log('sort click'); return true; });

		page.list.hideCover();
	}

	/**
	 * Sets the list data using the sonic search request results
	 * @param {Object} data - the sonic search response data
	 */
	setSeedData(data) {
		const page = this;
		// page.setHeaderCount(whichList, data.match_count);

		page.resultsSoFar += data.results_count;

		const tracksList = {};
		data.shift();

		for (const track of data) {
			tracksList[track.id] = track;
		}

		// round the number to show to the nearest 50
		// We may have gotten back more than we requested because we request more so that once they are filtered, 
		// we get the number we expect.  SO display them all, with the "perPage" being a nice round multiple of 50
		const numResults = Object.keys(tracksList).length;
		const listParams = {
			count: Math.min(page.howManyToShow, numResults),
			page: 0,
			perPage: page.howManyToShow,
			pageVars: ''
		};

		// console.log('list params:', listParams);
		// format data
		let listItems = [];
		listItems.push(listParams);
		listItems = listItems.concat(data);

		console.log('- seeds list items:', listItems);
		page.seedsList.setData(listItems, () => {
			return true;
		}, () => { console.log('sort click'); return true; });

	}
	
}

sa.pages.aiplaylist = new AIPlaylistResultsPage();

sa.pages.writer = (function() {
	
	let page = {
		name: 'writer',
		title: gde('writer', { c : 'upper', p : false }) + ' Details',
		register: {
			routes: [{
				name: 'writer',
				hash: '#!writer',
				pattern: '/writer/:int/:any?',
				id: 'w',
				dontSetTitle: true,
			}]
		}
	};
	
	/** @var {Catalog} */
	var writer;
	
	page.show = function(params) {
		let vars = sa.router.paramsToVars(params);
		if (!vars.w) {
			sa.router.routeTo('/');
			// sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			return;
		}
		
		writer = null;

		sa.currentPage = page;
		console.log("params", params)
		sa.pages.grouping.showFromVars(jQuery.extend(vars, {
			name : page.name,
			writerId : vars.w,
			linkFunction : getWriterLinkExact
		}), function(writerData) {
			setTitle(writerData.name, gde('writer', { c : 'upper', p : false }))
			writer = new Writer(writerData);
		});
		
		// TODO:
		// sa.search.showCurrentCatalog();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingTrackList = function() {
		return sa.pages.grouping.isShowingTrackList();
	};

	/**
	 * @returns {boolean}
	 */
	page.isShowingAlbumList = function() {
		return sa.pages.grouping.isShowingAlbumList();
	};

	/**
	 * @return {List}
	 */
	page.getTrackList = function() {
		return sa.pages.grouping.getTrackList();
	};

	/**
	 * @return {List}
	 */
	page.getAlbumList = function () {
		return sa.pages.grouping.getAlbumList();
	};
	
	return page;
	
})();

sa.pages.writerList = (function() {

	let page = {
		name: 'writer_list',
		title: gde('writer', { c: 'upper', p: false}) + ' List',
		register: {
			routes: [{
				name: 'writers',
				pattern: '/writers',
				hash: '#!writers',
			}]
		}
	};

	/** @var {List} */
	var list;
	var templates;

	page.show = function(params) {
		if (!list) {

			var listConfig = new ListConfig();
			listConfig.addColumnList(getStandardWriterColumnList());
			listConfig.callback = function(data) { setData(data); };
			listConfig.callbackActual = function(data) { setData(data); };
			listConfig.useFilters = true;
			listConfig.bankKey = 'writerPage';
			listConfig.defaultResultsPerPage = 100;
			listConfig.topBar = true;

			list = createWriterList(listConfig);

			templates = sa.templates.get('pages.writer_list');

		}

		if (sa.getCurrentPageName() != page.name) {

			var container = templates.get('writer_list');
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();

			list.generatePage(container.find('.list'));

			$j('#body').empty().append(container);
		}

		sa.currentPage = page;
		loadPage(params);

	};

	function loadPage(params) {		
		list.loadPage(params);
	}

	function setData(newData) {
		list.setData(newData, getWritersLink);
		sa.components.heading.hide();
		var headingExtra = {};
		if (newData[0].facets) {
			sa.components.heading.buildFacetTabs(newData[0].facets, headingExtra, 'writers', sa.router.paramsToVars(newData[0].pageVars).s);
		}
		if (newData[0].headingName && newData[0].headingValue) {
			headingExtra.count = newData[0].count;
			headingExtra.preamble = newData[0].headingName;
			sa.components.heading.show(newData[0].headingValue, headingExtra);
		} else {
			sa.components.heading.show('All ' + config.getDictionaryEntry('writer', true), headingExtra);
		}
	}

	return page;

})();
/**
 * The frame of the requests page
 * @returns {object}
 */
function Requests() {
	
	let page = {
		name: 'requests',
		title: 'Requests',
		register: {
			routes: [{
				pattern: '/requests',
				hash: '#!requests',
				name: 'requests'
			}]
		}
	};
	
	/**
	 * {Page} The object that's the current page being shown in the admin
	 */
	page.currentPage = null;
	/**
	 * {string} the type of page we're showing
	 */
	page.currentPageType = '';
	
	page.show = async function (params) {
		if (!user.logged || (!user.hasAdminPermission(AdminPermission.Licensees) && config.siteType == 'seller')) {
			// requests are only available on licensee and network sites and to admins on seller sites
			sa.notify({ text : $j('<span>' + (user.logged ? 'Requests are only accessible to admin users.' : 'Requests are only accessible to logged in users. Did you mean to <a href="' + getLoginLink() + '">Log In</a>?</span>')) });
			return sa.router.routeTo(sa.router.pathConversionLookup(config.home));
		}

		// Redirect to the new inbox
		const inboxLocation = config.siteType === 'seller' ? '/admin?p=inbox' : '/dashboard?p=inbox';
		sa.router.routeTo(inboxLocation);
		return;

		var container = $j('#body');

		// check if user has permission to view requests
		const activeProfileId = user.getActivePermissionProfileId()
		if (activeProfileId) {
			const activeProfile = user.userData.permissionProfiles.find(profile => profile.id == activeProfileId)
			if (!activeProfile?.allowPitchRequests) {
				sa.alert({ text: 'You do not have permission to view requests' });
				container.html('');
				return;
			}
		}

		if (sa.getCurrentPageName() !== 'requests') {
			// reset vars
			page.currentPage = null;
			page.currentPageType = '';
			sa.currentPage = this;
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.p) vars.p = 'list';

		page.setPage(vars.p, container);
	};
	
	/**
	 * Changes which requests page is showing
	 */
	page.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (page.currentPageType === pageId) {
			page.currentPage.show(sa.router.getCurrentQueryParams(), container);
			return;
		}
		// they were on a different page so we need to find the correct page object
		let newPage = null;
		switch (pageId) {
			case 'create':
				newPage = new RequestsEdit();
				break;
			case 'edit':
				newPage = new RequestsEdit();
				break;
			case 'details':
				newPage = new RequestsDetails();
				break;
			case 'list':
			default:
				newPage = new RequestsList();
		}
		// and then if we found it, have it load based on the current params
		clearBody();
		container.html('<div class="max_width requests-page"></div>');
		container = container.find('div');
		sa.components.leftNav.disableAll();
		container.append('<div class="request_container non-admin-request-container right_content"></div><div class="clr"></div>');
		container = container.find('.request_container');
		if (newPage) {
			newPage.show(sa.router.getCurrentQueryParams(), container);
		} else {
			container.html('Daskboard says ' + pageId);
		}
	};
	
	/**
	 * Gets a list of all the track lists currently displayed. Used by the MetaTrackList function
	 * @return {Array} of list objects
	 */
	page.getTrackLists = function() {
		return [];
	};
	
	return {
		name: page.name,
		title: page.title,
		register: page.register,
		show: page.show
	};
}

sa.pages.request = Requests();
function RequestsDetails() {

	var page = this;
	var templates = sa.templates.get('requests');

	/**
	 * Sets up the frame of the request list and the search box
	 */
	this.show = function(params, container, windowed) {
		var vars = sa.router.paramsToVars(params);
		if (!vars.requestId) {
			sa.router.routeTo('/requests');
			return;
		}
		var template = templates.get('request_details_container');
		if (windowed) {
			template.find('.title_section').remove();
		}
		container.empty().append(template);
		this.loadRequest(vars.requestId);
	};

	/**
	 * Loads requests from the server
	 * @param {int} requestId the request to load
	 */
	this.loadRequest = function(requestId) {
		ajax('p=requests&action=requestDetails&requestId=' + requestId, function(response) { page.showRequest(response[0]); });
	};

	/**
	 * Displays the details of the request and the current responses
	 * @param {Object} response the data to display
	 */
	this.showRequest = function(response) {
		if (response.result != 'success') {
			$j('.requests_details').empty().append(templates.get('request_details_not_found'));
			return;
		}
		/** @var {Request} */
		const request = response.request;

		const template = templates.get('request_details', {
			title: request.title,
			datePosted: formatDate('F d, Y', request.datePosted),
			user: request.user ? request.user : '',
			email: request.email ? request.email : '',
			description: request.description,
			budgetPerCue: request.budgetPerCue,
			whiteName: request.whiteName,
			id: request.id,
			domain: config.domain
		});
		
		if (request.user) {
			template.find('.request-details-company').remove();
		} else {
			template.find('.request-details-user').remove();
		}

		if (config.siteType == 'network' || request.budgetPerCue === '') {
			template.find('.price_per_cue').remove();
		}

		if (!request['email']) {
			template.find('.email_container').remove();
		}

		if (request.briefs && request.briefs.length) {
			var briefsList = template.find('.briefs ul');
			for (var b = 0, bLen = request.briefs.length; b < bLen; b++) {
				var brief = request.briefs[b];
				briefsList.append(templates.get('request_brief', {
					savePath : 'save.php?&type=request_attachment&requestId=' + request.id + '&fileId=' + brief.id,
					filename : brief.filename,
					size : sizeFormat(brief.filesize, 1)
				}));
			}
		} else {
			template.find('.attachments.briefs').remove();
		}
		if (request.references && request.references.length) {
			var referencesList = template.find('.references ul');
			for (var a = 0, aLen = request.references.length; a < aLen; a++) {
				var reference = request.references[a];
				referencesList.append(templates.get('request_brief', {
					savePath : 'save.php?&type=request_attachment&requestId=' + request.id + '&fileId=' + reference.id,
					filename : reference.filename,
					size : sizeFormat(reference.filesize, 1)
				}));
			}
		} else {
			template.find('.attachments.references').remove();
		}
		if (request.editable) {
			template.find('.request_recipient_element').remove();
			// enable closing
			template.find('.status_options input[value=' + request.closed + ']').prop('checked', true);
			template.find('.status_options input').on('click', function() {
				var val = this.value;
				if (val == request.closed) return;
				ajax('p=requests&requestId=' + request.id + '&action=close&close=' + this.value, function() {
					request.closed = val;
					sa.notify({ text : 'Request ' + (val == 0 ? 're-opened' : 'closed'), type : sa.notify.notificationTypes.success });
				});
			});

			// show responses
			if (request.responses && request.responses.length) {
				template.find('.responses.empty').remove();

				var responseFromRecipientContainer = template.find('.responses.has_responses');
				for (var r = 0, rLen = request.responses.length; r < rLen; r++) {
					var responseFromRecipient = request.responses[r];

					var responseFromRecipientTemplate = templates.get('request_response_received', {
						supplierName : responseFromRecipient.supplier.name,
						listenLink : 'https://' + config.domain + '/link.php?page=request_response&requestId=' + request.id + '&responseId=' + responseFromRecipient.id,
						count : responseFromRecipient.trackCount.numberFormat(),
						date : formatDate('F d, Y', responseFromRecipient.date),
						time : formatDate('g:ia', responseFromRecipient.date),
						comments : responseFromRecipient.comments,
						username : responseFromRecipient.username
					});

					if (responseFromRecipient.projectId) {
						responseFromRecipientTemplate.find('.pitch_details_album, .pitch_details_track').remove();
					} else if (responseFromRecipient.trackId) {
						responseFromRecipientTemplate.find('.pitch_details_album, .pitch_details_project').remove();
					} else {
						responseFromRecipientTemplate.find('.pitch_details_track, .pitch_details_project').remove();
					}

					(function(response, responseTemplate) {
						responseTemplate.find('.contact_publisher').on('click', function() {
							showPublisherContactForm(request, response);
						});

					})(responseFromRecipient, responseFromRecipientTemplate);

					responseFromRecipientContainer.append(responseFromRecipientTemplate);
				}
			} else {
				template.find('.responses.has_responses').remove();
			}

		} else if (user.hasAdminPermission(AdminPermission.Licensees) && config.siteType == 'seller') {
			template.find('.request_sender_element').remove();

			// show responses
			if (request.responses && request.responses.length) {

				var responseYouSentContainer = template.find('.responses.has_responses');
				for (var i = 0, len = request.responses.length; i < len; i++) {
					var responseYouSent = request.responses[i];

					var responseYouSentTemplate = templates.get('request_response_sent', {
						listenLink : (responseYouSent.projectId ? '/playlist/' + responseYouSent.projectId : (responseYouSent.albumId ? '/album/' + responseYouSent.albumId : '/track/' + responseYouSent.trackId)),
						count : responseYouSent.trackCount.numberFormat(),
						date : formatDate('F d, Y', responseYouSent.date),
						time : formatDate('g:ia', responseYouSent.date),
						comments : responseYouSent.comments
					});

					if (responseYouSent.projectId) {
						responseYouSentTemplate.find('.pitch_details_album, .pitch_details_track').remove();
					} else if (responseYouSent.trackId) {
						responseYouSentTemplate.find('.pitch_details_album, .pitch_details_project').remove();
					} else {
						responseYouSentTemplate.find('.pitch_details_track, .pitch_details_project').remove();
					}

					responseYouSentContainer.append(responseYouSentTemplate);
				}

			} else {
				template.find('.responses.has_responses').remove();
			}

			sa.forms.init(template.find('.pitch'), {
				realTimeValidation : true,
				realTimeValidationCallback : function(validationResult) {
					if (validationResult.name === 'pitch_link' && validationResult.value) {
						if (validationResult.value.split(/https?:\/\//i).length > 2) {
							validationResult.showError('Please only enter one link. If you need to send more tracks, please combine them into a single playlist.');
						} else {
							validationResult.hideError();
						}
					}
				}
			});

			template.find('.new_pitch').on('click', function() {
				let button = this;
				if (button.dataset.processing === '1') return;
				button.dataset.processing = '1';
				let link = template.find('input[name=pitch_link]').val();
				let comments = template.find('textarea[name=pitch_comments]').val();
				ajax({
					link: link,
					comments: comments 
				}, function(response) {
					button.dataset.processing = '0';
					let result = response[0].result;
					if (result != 'success') {
						sa.alert({ text : result });
					} else {
						template.find('.pitch').html(templates.get('request_after_pitch_message').html()).addClass('pitched');
					}
				}, 'POST', 'p=requests&action=pitch&requestId=' + request.id);
			});
			template.find('.hide_request').on('click', function() {
				sa.confirm({
					text : 'Are you sure you want to hide this request? You will never see it again.',
					yesFunction : function () {
						ajax({ id : request.id }, function () {
							sa.router.routeTo('/admin?p=syndication&tab=requests');
							sa.notify({ text : 'Request hidden' });
						}, 'POST', { p : 'requests', action : 'hide' });
					},
					yesText : 'Hide'
				});
				return false;
			});
		} else {
			template.find('.request_sender_element').remove();
		}

		$j('.requests_details').empty().append(template);
	};

	/**
	 * Shows a form so you can send a message to the publisher without knowing their email
	 * @param {Request} request the request
	 * @param {RequestResponse} response the response
	 */
	function showPublisherContactForm(request, response) {
		var contactForm = templates.get('publisher_contact_form');
		var fb;

		contactForm.find('#license_name').val(user.userData.username);
		contactForm.find('#license_company').val(config.name);
		contactForm.find('#license_email').val(user.userData.email);

		contactForm.find('.confirm_no').on('click', function() {
			fb.hide();
		});

		contactForm.find('.confirm_yes').on('click', function() {
			var validationResult = sa.forms.validate(contactForm);

			if (validationResult.error) return;

			var postVars = validationResult.values;
			postVars.requestId = request.id;
			postVars.responseId = response.id;

			fb.showLoader('Sending message');
			ajax(postVars, function(response) {
				if (response[0].result == 'success') {
					sa.notify({ text : 'Message sent!' });
					fb.hide();
				} else {
					fb.hideLoader();
					fb.showErrorMessage(response[0].result);
				}
			}, 'POST', 'p=requests&action=contact');
		});

		sa.forms.init(contactForm);

		fb = new FocusBox(contactForm, {
			title : 'Contact ' + response.supplier.name
		});
		fb.show();
	}

}

function RequestsEdit() {

	this.show = function(params, container) {

		var template = sa.templates.get('requests').get('edit_request');

		var storageKey = 'request_provider_' + config.id + '_' + user.id,
			checkedBoxes = safeLocalStorage.getItem(storageKey),
			vars = sa.router.paramsToVars(params),
			requestId = vars.requestId;

		if (checkedBoxes) checkedBoxes = checkedBoxes.split(',');
		else checkedBoxes = [];
		if (!checkedBoxes.length) {
			template.find('.all_suppliers_container input').prop('checked', true);
		} else if (config.id == 2570 && checkedBoxes.indexOf(7301) === -1 && (checkedBoxes.indexOf(172) !== -1 || checkedBoxes.indexOf(885) !== -1)) {
			// netflix moved some catalogs to a new site and if a user had the old sites checked, they should auto-check this new one
			// see https://github.com/SourceAudio/SourceAudio/issues/3990
			checkedBoxes.push(7301);
		}
		// network sites don't show prices per cue because they're all blankets
		if (config.siteType == 'network') {
			template.find('input[name=per_cue]').remove();
		}
		// uploader
		var deletedFiles = [],
			docUploadAttachments = template.find('.doc_upload_container .attachments'),
			refUploadAttachments = template.find('.ref_upload_container .attachments'),
			uploaderBrowseCallback = function(uploadContainer) { return function(uploader) {
				var files = uploader.getFileDetails();
				uploadContainer.empty();
				if (!files.length) return;
				for (var i = 0, len = files.length; i < len; i++) {
					var file = files[i],
						attachmentElement = $j('<li><span class="icon fa fa-paperclip"></span> ' + file.name + ' (' + sizeFormat(file.size, 1) + ') <span class="icon fa fa-times faux_button"></span></li>');
					uploadContainer.append(attachmentElement);
					attachmentElement.find('.fa-times').on('click', function(file, attachmentElement) { return function() {
						uploader.removeFile(file.id);
						attachmentElement.remove();
					}; }(file, attachmentElement));
				}
			}; },
			docUploader = new Uploader({
				button : template.find('.doc_upload_container .attach'),
				allowMultiple : true,
				allowFolder : false,
				fileType : UploaderConstants.DOCS,
				browseCallback : uploaderBrowseCallback(docUploadAttachments)
			}),
			refUploader = new Uploader({
				button : template.find('.ref_upload_container .attach'),
				allowMultiple : true,
				allowFolder : false,
				fileType : UploaderConstants.AV,
				browseCallback : uploaderBrowseCallback(refUploadAttachments)
			});
		// load the supplier list
		ajax('p=music_supplier_info&show=all&o=name', function(response) {
			if (!template) return;
			var list = template.find('.supplier_list').empty();
			for (var i = 1, len = response.length; i < len; i++) {
				let supplier = response[i];
				list.append('<label><input type="checkbox" name="suppliers[]" value="' + supplier.id + '"' + (checkedBoxes.indexOf(supplier.id) != -1 ? ' checked="checked"' : '') + '/> ' + supplier.name + '</label>');
			}
			if (response.length <= 1) {
				if (config.siteType == 'buyer') {
					list.append('Before you make a request, you need to <a href="' + getSecureLink('admin?p=music_suppliers') + '">add some Music Suppliers</a>');
				} else if (config.siteType == 'network') {
					list.append('Before you make a request, you need to add some music to your workspace');
				}
			}
			list.append('<div class="clr"></div>');
			template.find('.supplier_list input').on('click', function() {
				template.find('input[name=all_suppliers]').prop('checked', false);
			});
			// load request data (do this in here because we need the recipients)
			if (requestId) {
				ajax('p=requests&action=requestDetails&requestId=' + requestId, function(response) {
					if (response[0].result != 'success') return;
					var i, len, cont;
					var request = response[0].request;
					template.find('input[name=title]').val(request.title);
					template.find('input[name=per_cue]').val(request.budgetPerCue);
					template.find('textarea[name=description]').val(request.description);
					template.find('input[name=all_suppliers]').prop('checked', false);
					template.find('.supplier_list input').prop('checked', false);
					for (i = 0, len = request.recipientWhiteIds.length; i < len; i++) {
						template.find('.supplier_list input[value=' + request.recipientWhiteIds[i] + ']').prop('checked', true);
					}
					var addFile = function(file, fileContainer) {
						var attachmentElement = $j('<li><span class="icon fa fa-paperclip"></span> ' + file.filename + ' (' + sizeFormat(file.filesize, 1) + ') <span class="icon fa fa-times faux_button"></span></li>');
						fileContainer.append(attachmentElement);
						attachmentElement.find('.fa-times').on('click', function() {
							console.log(file);
							deletedFiles.push(file.id);
							attachmentElement.remove();
						});
					};
					if (request.briefs) {
						cont = template.find('.doc_upload_container .current_attachments');
						for (i = 0, len = request.briefs.length; i < len; i++) {
							addFile(request.briefs[i], cont);
						}
					}
					if (request.references) {
						cont = template.find('.ref_upload_container .current_attachments');
						for (i = 0, len = request.references.length; i < len; i++) {
							addFile(request.references[i], cont);
						}
					}
					template.find('.disclaimer').hide();
				});
			}
		});
		// include email option
		if (requestId || config.siteType != 'network' || !config.showRequestEmailOptions) {
			template.find('.include_email').remove();
		} else {
			template.find('.user_email_address').html(user.userData.email);
		}
		// add some interactivity
		template.find('input[name=all_suppliers]').on('click', function() {
			template.find('.supplier_list input:checked').prop('checked', false);
		});
		let saveFunction = function(ignoreUnattached) {
			var title = template.find('input[name=title]').val(),
				perCue = template.find('input[name=per_cue]').val(),
				description = template.find('textarea[name=description]').val(),
				suppliers,
				saveSuppliers = template.find('input[name=save_suppliers]:checked').length,
				docFiles = docUploader.getFileDetails(),
				refFiles = refUploader.getFileDetails(),
				includeEmail = template.find('input[name=include_email]:checked').length,
				filesToUpload = [];
			var i, len;
			// title, description, and attachment check
			if (!title || !description) {
				return sa.notify({ text : 'Please enter a title and description.' });
			}
			if (!ignoreUnattached && !docFiles.length && !refFiles.length && description.match(/\battach/i)) {
				return sa.confirm({ 
					text : 'Did you mean to attach a brief or reference files?', 
					yesText : 'Yes',
					yesFunction : function() {},
					noText : 'No',
					noFunction : function() {
						saveFunction(true);
					}
				});
			}
			// validate attached files
			if (docFiles.length > 5) {
				return sa.notify({ text : 'You may only have up to 5 briefs attached. Please remove ' + (docFiles.length - 5) });
			}
			if (refFiles.length > 5) {
				return sa.notify({ text : 'You may only have up to 5 reference files attached. Please remove ' + (refFiles.length - 5) });
			}
			for (i = 0, len = docFiles.length; i < len; i++) {
				if (docFiles[i].size > 10 * 1024 * 1024) {
					return sa.notify({ text : 'Briefs must be 10MB or smaller. Please remove ' + docFiles[i].name });
				}
				filesToUpload.push({ file : docFiles[i], uploader : docUploader });
			}
			for (i = 0, len = refFiles.length; i < len; i++) {
				if (refFiles[i].size > 20 * 1024 * 1024) {
					return sa.notify({ text : 'Reference files must be 20MB or smaller. Please remove ' + refFiles[i].name });
				}
				filesToUpload.push({ file : refFiles[i], uploader : refUploader });
			}
			// what suppliers are checked
			if ($j('input[name=all_suppliers]:checked').length) {
				suppliers = 'all';
				if (saveSuppliers) {
					safeLocalStorage.setItem(storageKey, '');
				}
			} else {
				const checks = template.find('.supplier_list input:checked');
				let supplierIds = [];
				for (i = 0, len = checks.length; i < len; i++) {
					supplierIds.push(checks[i].value);
				}
				suppliers = supplierIds;
				if (saveSuppliers) {
					safeLocalStorage.setItem(storageKey, supplierIds.join(','));
				}
			}

			var complete = function(response) {
					saveButton.show();
					template.find('.cover').remove();
					var result = response[0].result;
					if (result == 'success') {
						sa.notify({ text : 'Request ' + (requestId ? 'saved!' : 'created!') });
						if (!requestId) {
							sa.router.routeTo('/requests'); // take them back to the request list
						}
					} else {
						sa.notify({ text : result });
					}
				};
			var tempFileId = new Date().getTime() + '-' + user.userData.id;
			var baseParams = { title : title, perCue : perCue, description : description,  suppliers : suppliers, includeEmail : includeEmail };

			if (requestId) {
				baseParams.requestId = requestId;
			}

			if (deletedFiles.length) {
				baseParams.deletedFiles = deletedFiles;
			}

			saveButton.hide();

			if (filesToUpload.length) {
				template.find('.right').append('<div class="cover"></div>');
				showLoader(template.find('.cover'), 'Saving Request.' + '<br/>' + 'Uploading' + '<span class="file">...</span><br/>' + 'Please be patient.');
				// upload the files recursively
				var totalFiles = filesToUpload.length,
					uploadFile = function() {
						if (!filesToUpload.length) {
							// do ajax call
							baseParams.tempFileId = tempFileId;
							ajax(baseParams, complete, 'POST', 'p=requests&action=' + (requestId ? 'edit' : 'create'));
							return;
						}
						var fileDetails = filesToUpload.shift(),
							file = fileDetails.file,
							uploader = fileDetails.uploader;
						console.log('Uploading file', file.name);
						template.find('.cover .file').html(' ' + file.name + ' - file ' + (totalFiles - filesToUpload.length) + ' of ' + totalFiles);
						uploader.upload({
							params : 'tempFileId=' + tempFileId + '&action=addTempFile',
							complete : function(e, response) {
								console.log('File', file.name, 'complete');
								var result = response[0].result;
								if (result == 'success') {
									uploadFile();
								} else {
									sa.notify({ text : result });
									saveButton.show();
								}
							},
							fileId : file.id,
							parseComplete : true,
							p : 'requests'
						});
					};
				uploadFile();
			} else {
				ajax(baseParams, complete, 'POST', 'p=requests&action=' + (requestId ? 'edit' : 'create'));
			}
		};
		var saveButton = template.find('.save_request').on('click', function() { saveFunction(); });

		container.empty().append(template);
	};
}
function RequestsList() {
	let baseUrl = siteBaseUrl();
	
	var page = this,
		detailsBase = siteBaseUrl() + '/requests?p=details&requestId=';
	
	/**
	 * Sets up the frame of the request list and the search box
	 */
	this.show = function(params, container, newDetailsBase, windowed) {
		if (newDetailsBase) {
			detailsBase = newDetailsBase;
		}
		container.html(
			(!windowed ? '<div class="title_section">'
				+ '<img src="images/dashboard/paper_content.png"/>'
				+ '<h2>Pitch Request Highlights</h2>'
				+ '<div class="tabs">'
					+ '<a class="tab selected" href="'+baseUrl+'/requests">All Requests</a>'
					+ (config.siteType != 'seller' ? '<a class="create tab" href="'+baseUrl+'/requests?p=create">Create a New Pitch Request</a>' : '')
					+ '<div class="clr"></div>'
				+ '</div>'
			+ '</div>' : '')
			+ '<div class="requests_list">'
				+ '<h2>' + (config.siteType != 'seller' ? '&raquo; Your Pitch Request History' : '&raquo; Respond to each brief below with a playlist you\'d like to pitch') + '</h2>'
				+ '<div class="header"><div class="details">' + (config.siteType != 'seller' ? 'Details' : 'Highlights') + '</div><div class="clr"></div></div>'
				+ '<div class="requests">'
				+ '</div>'
			+ '</div>');
		this.loadRequests();
	};
	
	/**
	 * Loads requests from the server
	 * @param {int} pg the page to load
	 */
	this.loadRequests = function(pg) {
		if (!pg) pg = 0;
		$j('.requests_list .requests').html('<div class="empty">Loading...</div>');
		$j('#list_page_numbers').remove();
		ajax('p=requests&action=list&pg=' + pg, function(response) { page.showRequests(response); });
	};
	
	/**
	 * Displays the list of requests after load
	 *  If the list is empty and there's no search var in the pagevars, will forward to create
	 * @param {json} response the data to display
	 */
	this.showRequests = function(response) {
		var meta = response[0].meta,
			list = response[0].list,
			container = $j('.requests_list');
		if (!list.length) {
			return container.find('.requests').html('<div class="empty">' + (config.siteType != 'seller' ? 'Click "Create a New Pitch Request" to request music for your project.' : 'You have no open requests right now.') + '</div>');
		}
		// add the requests
		var requestContainer = container.find('.requests').empty();
		for (var i = 0, len = list.length; i < len; i++) {
			var r = list[i];
			requestContainer.append(
				'<div class="request">'
					+ '<div class="right">'
						+ '<a href="' + detailsBase + r.id + '" class="' + (r.replyCount ? 'has_replies' : 'has_no_replies') + '">'
							+ (config.siteType != 'seller' ? 'View '+ (r.replyCount ? r.replyCount : 0) +' Pitches' + ' &raquo;' : '<span class="icon fa fa-envelope"></span> Pitch Music &raquo;'
							+ (r.replyCount ? '<sub>&raquo; ' + 'You have previously replied to this request' + '</sub>' : ''))
						+ '</a>'
					+ '</div>'
					+ '<div class="left">'
						+ '<a class="details" href="' + detailsBase + r.id + '">' + r.title + '</a>'
						+ '<div class="date_posted">' + formatDate('F d, Y', r.datePosted) + '</div>'
						+ (config.siteType == 'seller' ? '<div class="company"><h4>' + 'Company' + ':</h4> ' + r.whiteName + '</div>' : '')
						+ '<div class="description"><h4>' + 'Music Needs' + ':</h4>' + r.description + '</div>'
					+ '</div>'
					+ '<div class="clr"></div>'
				+ '</div>'
			);
		}
		// pagination
		sa.pagination.addPagination({
			currentPage: meta.page,
			totalItems: meta.count,
			perPage: meta.perPage,
			callback: function(newPage) {
				page.loadRequests(newPage);
			},
			container: container
		});
	};
}
/**
 * A tab element for a RightTabbedPage
 * @param {string} id an id that'll be passed into set page when this tab is clicked. should be unique in the tab set
 * @param {string} hash
 * @param {string} title the title text to display in bold at the top of the tab
 * @param {function} callback the function to call when the tab is clicked
 * 	functions do not need to include any LeftTabbedPage functionality. That'll be handled automatically
 * 	this function will be called with two parameters, the tab id and a jQueryElement - the container to generate the page in
 * @param {boolean=} disabled should this tab be usable? does not disable the target page
 * @returns {RightTab}
 */
function RightTab(id, hash, title, callback, disabled) {
	this.id = id;
	this.hash = hash;
	this.title = title;
	this.callback = callback;
	this.disabled = disabled !== undefined && disabled;
}

/**
 * A LeftTabbedPage subpage with another tabbed nav on the right
 * @returns {RightTabbedPage}
 */
function RightTabbedPage() {
	/**
	 * @var {string} unique id for the page, included in its class
	 */
	this.id = '';
	/**
	 * @var {Array.<LeftTab>} an array of LeftTab objects that will be displayed on the left
	 */
	this.tabs = [];
	/**
	 * @var {HTMLElement|JQuery} the header to show at the top of the page
	 */
	this.header = null;

	/**
	 * Sets the currently selected tab in the left
	 * @param {string} tabId the id of the tab to be selected. corresponds to the id element of a tab that was passed in
	 */
	this.setTab = function (tabId) {
		// find the newly selected tab
		var selectedTab = $j('#rtp_nav #' + tabId);
		if (!selectedTab) return;
		// remove any old selected tabs
		$j('#rtp_nav .selected').removeClass('selected');
		// select the new tab
		selectedTab.addClass('selected');
		// set the right header
		var tabData = selectedTab.data('tab');
		// clear the right content
		// call the callback to generate the page
		if (tabData) {
			tabData.callback(tabId, $j('.tabbed_body').html(''));
		} else {
			console.warn('Tab not found:', tabId);
		}
	};
}


/**
 * Sets up the frame of the page, adding the tabs and the basic container
 * @param {string} id a unique id for the page, included in its class
 * @param {JQuery} container the container the page should be displayed in
 * @param {Array.<RightTab>} tabs an array of RightTab objects that will be displayed on the left
 * @param {JQuery} rightObject something to display to the right of the tabs (optional)
 */
RightTabbedPage.prototype.show = function (id, container, tabs, rightObject) {
	// Bit of a hack, but need to reset from the modified inbox styles
	$j('#ltp_container').removeClass('admin-inbox');
	
	// remove old elements and create the basic container
	container.addClass(id).html('');
	// add our nav
	var tabContent = $j('<div id="rtp_nav"></div>');
	// add the container
	container.append(tabContent);
	container.append('<div class="tabbed_body"></div>');
	for (var i = 0, len = tabs.length; i < len; i++) {
		var tab = tabs[i],
			jTab = $j('<a href="' + tab.hash + '" class="rtp_tab' + (i == len - 1 ? ' last' : '') + (tab.disabled ? ' disabled' : '') + '" id="' + tab.id + '">' + tab.title + '</a>').prop('title', tab.title);
		jTab.on('click', function () {
			$j(this).addClass('selected').trigger('blur');
		}).data({
			tab: tab
		});
		tabContent.append(jTab);
	}
	
	// add the right object if there is one
	if (rightObject) {
		tabContent.append($j('<div id="rtp_right"></div>').append(rightObject));
	}
};
/**
 * Holds the shopping cart items
 * each shopping cart item needs a unique 'index', 'type', 'price', and 'time' property
 * if you don't give it an index or time, i'll make one, but it needs its type
 * otherwise, the cart items structure can fit the specific type of item (license, .99 dl, etc.)
 */
/* eslint-disable */
sa.components.shoppingCart = (function() {

	//private vars
	var cart = {},
		loaded = false,
		itemLoadCallbacks = [],
		items = [],
		backupItems = [];

	cart.setFromItems = function(newItems, newBackupItems) {
		console.log('setting cart from', newItems);
		items = newItems;
		backupItems = newBackupItems;
	};

	cart.loadItems = async function(cb) {
		const r = await sa.api.request({
			handler: 'shoppingCart',
			action: 'getCartContents',
			getData: {
				cacheBreak: new Date().getTime()
			}
		});
		if (!r.items) return;
		items = r.items;
		backupItems = r.backupItems;
		loaded = true;
		if (itemLoadCallbacks.length) {
			for (var i = 0, len = itemLoadCallbacks.length; i < len; i++) {
				itemLoadCallbacks[i](items, backupItems);
			}
			itemLoadCallbacks = [];
		}
		sa.components.topBar.updateCartContents(cart.count());

		if (cb) cb();
	};

	//public vars
	cart.verbose = false;

	/**
	 * Sends all the items in the cart to a callback function as soon as they're available (might still be loading from the server)
	 * @param {function} callback
	 */
	cart.getItemsAsync = function(callback) {
		if (loaded) {
			callback(items, backupItems);
		} else {
			itemLoadCallbacks.push(callback);
		}
	};

	cart.outputItems = function() {
		console.log(items);
	};

	cart.count = function () {
		var nonCouponItems = _.reject(items, function (item) {
			return item.type == 'coupon';
		});
		return nonCouponItems.length;
	};

	cart.overrideItems = function() {
		//the point is to archive the current items and put something else in here (like a subscription), and then bring them back when you're done
		cart.clearSubscriptions(); //we aren't going to backup subscriptions
		backupItems = items;
		items = [];
		sa.api.request({
			handler: 'shoppingCart',
			action: 'backupCart'
		});
	};

	cart.restoreBackupItems = function() {
		items = backupItems;
		backupItems = [];
		sa.api.request({
			handler: 'shoppingCart',
			action: 'restoreCartBackup'
		});
	};

	cart.getBackupItems = function() {
		return backupItems;
	};

	cart.hasBackupItems = function() {
		return backupItems.length;
	};

	/**
	 * Checks if the cart already has the given item, based on its type and track_id
	 * @param {object} item like what was passed into addItem
	 * @return {boolean} is it?
	 */
	cart.hasItem = function(item) {
		for (var i = 0, len = items.length; i < len; i++) {
			if (items[i].type == 'subscription') {
				if (items[i].id == item.id) return true;
			} else if (items[i].track_id == item.track_id && items[i].type == item.type) {
				item.index = items[i].index;
				return true;
			}
		}
		return false;
	};

	cart.addItem = function(item) {
		if (cart.hasItem(item)) {
			if (cart.verbose) console.log('-- shopping cart: tried to add', item, 'but already in cart');
			return;
		}
		if (!user.logged) {
			sa.notify({ text : 'Please log in to add things to your shopping cart.' });
			return false;
		}

		cart.clearSubscriptions(); //we can't have those in with other stuff cause they're different charge methods

		//let's check the item, if it doesn't have index or time, let's add it
		if (!item.time) {
			item.time = Math.round(new Date().getTime() / 1000);
		}
		if (!item.index) {
			item.index = (items.length + 1) + '_' + item.time;
		}
		if (!item.item_id) {
			item.item_id = item.type + '_' + (item.id ? item.id : item.track_id ? item.track_id : item.index);
		}
		item.price = parseInt(item.price);
		items.push(item);
		if (cart.verbose) console.log('-- shopping cart: added', item, 'to cart');
		
		sa.api.request({
			handler: 'shoppingCart',
			action: 'addToCart',
			postData: {
				item: JSON.stringify(item)
			}
		});

		// ajax('item=' + encodeURIComponent(JSON.stringify(item)), function () { }, 'POST', 'p=shopping_cart&action=add_to_cart');
		sa.components.topBar.updateCartContents(cart.count());

		// let's update the project details defaults if necessary
		if (item.project) {
			// we might not have the right object structure, let's build it
			if (!user.userData.licensing_uo) user.userData.licensing_uo = {options: {}};
			if (!user.userData.licensing_uo.options) user.userData.licensing_uo.options = { project_defaults: {} };
			if (!user.userData.licensing_uo.options.project_defaults) user.userData.licensing_uo.options.project_defaults = {};

			_.each(item.project, function(pd) {
				user.userData.licensing_uo.options.project_defaults[pd.name] = pd.value;
			});
		}

		return true;
	};

	/**
	 * Only works if the item ids are unique (not good when mixing item types)
	 */
	cart.removeItemById = function(id) {
		for (var ii in items) {
			if (!items.hasOwnProperty(ii)) continue;
			console.log(items[ii]);
			if (items[ii].item_id == id) {
				return cart.removeItem(items[ii]);
			}
		}
	};

	cart.removeItem = function(item, onlySentIndex) {
		var index = (onlySentIndex) ? item : item.index;
		for (var ii in items) {
			if (!items.hasOwnProperty(ii)) continue;
			if (items[ii].index == index) {
				var itemInCart = items[ii];
				items.splice(ii, 1);
				if (cart.verbose) console.log('-- shopping cart: removed', item);

				sa.api.request({
					handler: 'shoppingCart',
					action: 'removeFromCart',
					postData: {
						item: JSON.stringify(itemInCart)
					}
				});

				sa.components.topBar.updateCartContents(cart.count());
				return;
			}
		}

		if (cart.verbose) console.log('-- shopping cart: item', item, 'was not found in shopping cart to remove');
		sa.components.topBar.updateCartContents(cart.count());
	};

	cart.clearSubscriptions = function() {
		for (var ii in items) {
			if (!items.hasOwnProperty(ii)) continue;
			var item = items[ii];
			if (item.type == 'subscription') {
				return cart.removeItem(item);
			}
		}
	};

	cart.clear = function() {
		items = [];
		if (backupItems && backupItems.length) {
			items = backupItems;
			backupItems = [];
		}
		if (cart.verbose) console.log('-- shopping cart: cleared');

		sa.api.request({
			handler: 'shoppingCart',
			action: 'clearCart'
		});
		// ajax('p=shopping_cart&action=clear_cart', function() {}, 'GET');
		sa.components.topBar.updateCartContents(cart.count());
	};

	/**
	 * totals the items with regard to any free dls if specified
	 */

	cart.getTotal = function(free_dls, credit, sub_trial) {
		var total = 0;
		free_dls = parseInt(free_dls);

		$j.each(items, function(index, item) {
			if (sub_trial && item.type == 'subscription' && item.id == sub_trial) {
				return true;
			}
			if (free_dls && item.type != 'subscription') {
				free_dls--;
				return true;
			}
			if (credit && item.type != 'subscription') {
				if (item.price <= credit) {
					credit -= item.price;
					return true;
				} else {
					total += (item.price - credit);
					return true;
				}
			}
			if (item.price) {
				total += item.price;
			}
		});

		return total / 100;
	};

	cart.build = function() {
		if (config.licensingConfig.show || (config.licensing && (config.licensing.royalty_free || config.licensing.paid_downloads))) {
			cart.loadItems();
		}
	};

	return cart;

})();
/**
 * Shopping Cart / Checkout Page
 */
function ShoppingCartPage() {
	
	//private vars
	var page = this;
	var cart = sa.components.shoppingCart;

	//public vars
	this.container = null;
	this.section = null;
	this.vars = null;
	this.name = 'shopping_cart';
	this.title = "Shopping Cart";
	this.register = {
		hash : 'shopping_cart',
		routes: [{
			name: 'shopping-cart',
			pattern: '/shopping-cart',
			hash: '#!shopping_cart'
		}]
	};

	/**
	 * Generates the basic page frame
	 * @param {string} params the parameters for the page
	 */
	this.show = async function(params) {
		if (!user.logged) window.location.href = getLoginLink();

		window.page = page;
		page.vars = sa.router.paramsToVars(params);
		page.templates = sa.templates.get('shopping_cart');

		if (page.vars.cart) {
			console.log('- new cart items detected:', page.vars.cart);
			var loadTemplate = page.templates.get('loading_cart');
			$j('#body').html( loadTemplate );
			const r = await sa.api.request({
				handler: 'shoppingCart',
				action: 'addItemFromCode',
				getData: {
					code: page.vars.cart
				}
			});

			if (r.error) {
				return sa.error({
					text: r.error,
					onClose: function () {
						sa.router.routeTo('/shopping-cart');
					}
				});
			}
			
			sa.components.shoppingCart.loadItems(function () {
				sa.notify({ text: 'Items have been added to your cart!' });
				sa.router.routeTo('/shopping-cart');
			});

			return;
		}

		var pageTemplate = page.templates.get('page_frame');
		$j('#body').html( pageTemplate );
		let container = pageTemplate;

		window.activePage = page;
		page.container = container;

		//let's make sure licensing is turned on for them
		if (!config.licensingConfig.show) {
			container.html('This workspace does not have online licensing activated.');
			return;
		}
		showLoader(container[0], 'Loading Shopping Cart');
		
		sa.currentPage = this;

		console.log('requested section was:', page.vars.section);

		if (page.vars.section === 'confirmation') {
			this.section = 'confirmation';
			this.afterLoad = page.confirmPaymentPage;
		} else {
			this.section = 'show_cart';
			this.afterLoad = page.showCartPage;
		}

		page.load();
	};

	this.load = function() {

		var toLoad = {

			cart: function(cb) {
				cart.getItemsAsync(function (items) {
					items = _.filter(items, function (item) {
						return (item.type == 'licensing' && item.track) || item.type == 'coupon';
					});
					page.cartItems = items;
					cb();
				});
			},
			options: function(cb) {
				page.loadOptions(cb);
			}
		};

		var loadCount = Object.keys(toLoad).length;
		var sofar = 0;

		function loadCheck() {
			sofar++;
			if (sofar == loadCount) page.afterLoad();
		}

		_.each(toLoad, function(f) {
			f(loadCheck);
		});
	};

	this.loadOptions = async function(cb) {

		const r = await sa.api.request({
			handler: 'licensing/licensingCheckout',
			action: 'getUserOptions'
		});

		if (r.error) {
			console.log('- error loading options:', r.error);
			return cb();
		}

		page.userOptions = r;
		console.log('- loaded options', r);
		cb();
	};


	this.confirmPaymentPage = async function() {
		console.log('- vars:', page.vars);

		const r = await sa.api.request({
			handler: 'licensing/licensingCheckout',
			action: 'paypalConfirm',
			postData: { transaction: page.vars.transaction, token: page.vars.token, payerId: page.vars.PayerID }
		});

		console.log('paypal confirm response:', r);

		cart.clear();
		window.location.href = getSecureLink('dashboard?p=licensing-history&transaction=' + r.transaction_id);

	};

	this.calcDiscount = function (coupon, itemTotal) {
		var total = itemTotal;
		var couponValue = 0;
		var discountedTotal = 0;
		couponValue = total * coupon.percent / 100;
		discountedTotal = (total - couponValue) <= 0 ? 0 : (total - couponValue);

		var cartItemIndex = (page.cartItems).findIndex((obj => obj.index == coupon.index));
		page.cartItems[cartItemIndex].price = -Math.abs(couponValue);

		return {
			couponValue,
			discountedTotal
		};
	};

	this.showCartPage = function() {
		var t = page.templates.get('cart_page');
		page.container.html( t );

		var itemTemplate = t.find('.cart-item').detach();
		var creditTemplate = t.find('.cart-credit').detach();
		let discountTemplate = t.find('.cart-coupon-item').detach();
		var nonCouponItems = _.reject(page.cartItems, function (item) {
			return item.type == 'coupon';
		});
		t.find('.cart-title span.cart-count').html(nonCouponItems.length);
		if (!nonCouponItems.length) {
			page.container.find('.bottom-box').hide();
			return;
		}

		t.find('.no-items').hide();

		t.find('.document_viewer_button').on('click', function () {
			sa.components.documentViewer.show('privacy_policy');
		});

		page.coupons = _.find(page.cartItems, function (item) {
			return item.type == 'coupon';
		});

		var totalPrice = 0;
		var needsCredit = false;
		var totalCredit = Math.min(99999, page.userOptions.coupon_credit + page.userOptions.download_credit);
		var whitelist = false;
		var totalCartDiscounts = 0;
		var discountItemId, discountItemPrice, discountItemDesc;

		var currency = getCurrencyInfo(config);

		_.each(page.cartItems, function (item) {
			if (item.type !== 'coupon') {
				var idiv = itemTemplate.clone();
				let isValidImage = function (image) {
					if (!image || typeof image === undefined) return false;
					
					if (image && image !== 'images/shared/default_album.jpg') return image;
					
					return false;
				};
			
				let itemArt = (
					isValidImage(_.get(item, 'track.album.image', ''))
					|| isValidImage(_.get(item, 'track.label.image', ''))
					|| isValidImage(_.get(item, 'track.catalog.image', ''))
					|| isValidImage(_.get(item, 'album.image', ''))
					|| isValidImage(_.get(item, 'label.image' , ''))
					|| isValidImage(_.get(item, 'catalog.image', ''))
					|| isValidImage(config.logo)
					|| false );
				idiv.attr('id', item.item_id );
				if (itemArt) idiv.find('.art img').attr('src', itemArt);
				var artistName = item.track.hasOwnProperty('artist') && item.track.artist.name ? item.track.artist.name : '';
				var labelName = item.track.hasOwnProperty('label') && item.track.label.name ? item.track.label.name : '';
				var trackSeperator = !artistName && !labelName ? '' : ' - ';
				var trackPrepend = artistName ? artistName : labelName;
				idiv.find('.artist-title').html( htmlEncode(trackPrepend) + trackSeperator + htmlEncode(item.track.title) + (config.licensingConfig.options.includeAlts && item.track.alternates.length ? ' <span>[+' + item.track.alternates.length + ' alt' + (item.track.alternates.length > 1 ? 's' : '') + ']' : '') );
				idiv.find('.usage').html( htmlEncode(_.map(item.license, 'title').join(' - ')) + ' | <a target="_blank" href="pdf.php?&type=licensing_license&preview=' + item.license[0].agreement + '">Preview License <i class="fa fa-external-link"></a></span>' );
				whitelist = whitelist || _.find(item.license, function(l) { return l.whitelist ? parseInt(l.whitelist) : 0; }) ? true : false;
				var sel = item.license[ item.license.length - 1];
				if (sel.description) {
					idiv.find('.description').html( htmlEncode(sel.description).replace(/\n/g, '<br/>') );
					idiv.addClass('doubleusage');
				} else {
					idiv.find('.description').hide();
				}
				totalPrice += parseFloat(sel.price);
				idiv.find('.cart-price').html( sel.price == -2 ? '1 Credit' : (new Currency(currency.code, parseFloat( sel.price ), false)).getResult());
				idiv.find('.cart-remove').on('click',  page.removeClick );
				t.find('.cart-items').append( idiv );

				var creditUsed = false;
				if (page.userOptions.coupon_credit) { // coupon credit
					page.userOptions.coupon_credit--;
					if (totalCredit != 99999) totalCredit--;
					creditUsed = true;
					totalCartDiscounts += sel.price;

					let cdiv = creditTemplate.clone();
					cdiv.find('.text').html( 'Coupon Credit' );
					cdiv.find('.remaining span').html( totalCredit == 99999 ? 'Unlimited' : totalCredit );
					cdiv.find('.cart-price').html( '<span>-</span>' + (sel.price == -2 ? '1 Credit' : (new Currency(currency.code, parseFloat( sel.price ), false)).getResult()));
					totalPrice -= sel.price;
					t.find('.cart-items').append( cdiv );
				}

				if (page.userOptions.download_credit && !creditUsed) { // subscription credit
					if (page.userOptions.download_credit != 99999) page.userOptions.download_credit--;
					if (totalCredit != 99999) totalCredit--;
					creditUsed = true;
					totalCartDiscounts += sel.price;

					let cdiv = creditTemplate.clone();
					cdiv.find('.text').html( 'Subscription Download Credit' );
					cdiv.find('.remaining span').html( totalCredit == 99999 ? 'Unlimited' : totalCredit );
					cdiv.find('.cart-price').html( sel.price == -2 ? '-1 Credit' : '<span>-</span>' + (new Currency(currency.code, parseFloat( sel.price ), false)).getResult() );
					totalPrice -= sel.price;
					t.find('.cart-items').append( cdiv );
				}

				if (!creditUsed && page.coupons) {
					if (!discountItemId) {
							discountItemId =  item.item_id;
							discountItemPrice = sel.price;
							discountItemDesc = (artistName ? artistName : labelName) + ' - ' + item.track.title;
					} else if (sel.price > discountItemPrice) {
						discountItemId = item.item_id;
						discountItemPrice = sel.price;
						discountItemDesc = (artistName ? artistName : labelName) + ' - ' + item.track.title;
					}
				}

				if (sel.price == -2 && !creditUsed) {
					needsCredit = true;
				}
			}
		});
		
		if (whitelist) {
			console.log('- whitelist channel entry');
			page.container.find('.whitelist-channel-entry').show();
			page.container.on('click', 'a.yt-search-link', function () {
				sa.components.yt_channel_search.show(setChannelId);
			});

			function setChannelId(selectedChannelId) {
				page.container.find('#whitelist-channel').val(selectedChannelId);
			}
		}

		if (config.licensingConfig.coupons_active) {
			page.container.find('.coupon-input .button').on('click',  page.couponClick );
			page.container.find('.coupon-input input').on('keydown', function(e) {
				if (e.keyCode == 13) page.couponClick();
			});
		} else {
			page.container.find('.pay-box').addClass('nocoupons');
		}

		if (needsCredit) {

			page.container.find('.total-box, .pay-box').hide();
			page.container.find('.needs-credit').show();
			page.container.find('.needs-credit .sub-button').on('click', function() {
				sa.router.routeTo('/subscriptions');
			});

		} else {
			var currency = getCurrencyInfo(config);

			page.totalPrice = totalPrice;
			if (totalPrice !== 0 && !_.isEmpty(page.coupons)) {
				page.coupons.discount_type = 'percent';
				page.coupons.description = (page.coupons.coupon_type != 'percent_off') ? '% off cart total' : '% off the highest priced item in your cart';

				var coupon_div = discountTemplate.clone(),
					coupon_type = (page.coupons.coupon_type != 'percent_off') ? 'cart' : 'item',
					coupon_description = page.coupons.percent + page.coupons.description + ' (' + page.coupons.code + ') <span class="limit">limit 1 per transaction </span>',
					coupon_item_price = (page.coupons.coupon_type != 'percent_off') ? totalPrice : discountItemPrice,
					coupon_calcResult = page.calcDiscount(page.coupons, coupon_item_price),
					coupon_item_desc = (page.coupons.coupon_type != 'percent_off') ? 'cart total' : discountItemDesc,
					discounted_item_total = coupon_calcResult.discountedTotal > 0 ? coupon_calcResult.discountedTotal : 0;

				totalCartDiscounts += coupon_calcResult.couponValue;
				page.totalPrice = page.totalPrice - coupon_calcResult.couponValue;

				coupon_div.attr('id', page.coupons.item_id);
				coupon_div.find('.coupon-code').html(page.coupons.code);
				coupon_div.find('.coupon-description').html(coupon_description);

				var formattedCouponItemPrice = (new Currency(currency.code, parseFloat(coupon_item_price), false )).getResult();
				var formattedDiscountedItemTotal = (new Currency(currency.code, parseFloat(discounted_item_total), false)).getResult();
				var formattedCouponValue = (new Currency(currency.code, parseFloat(coupon_calcResult.couponValue), false)).getResult();
				coupon_div.find('.coupon-detail').html(coupon_item_desc + '&nbsp; &nbsp; <span class="original-total">' + formattedCouponItemPrice + '</span>&nbsp; &nbsp; ' + formattedDiscountedItemTotal);
				coupon_div.find('.cart-price').html('<span>-</span>' + formattedCouponValue);

				coupon_div.find('.cart-remove').on('click', page.removeClick);
				(coupon_type != 'item') ? t.find('.cart-items').append(coupon_div) : $j(coupon_div).insertAfter(t.find('#' + discountItemId));
				var formattedPrice = new Currency(currency.code, parseFloat(page.totalPrice), false);
				page.container.find('.total-box .price').html(formattedPrice.getResult());
				totalPrice = page.totalPrice;

			} else {
				var formattedTotalPrice = new Currency(currency.code, totalPrice, false);
				page.container.find('.total-box .price').html(totalPrice > 0 ? formattedTotalPrice.getResult() : 'FREE');
			}

			if (!totalPrice) page.container.find('.pay-button').addClass('credit').html( 'Redeem<br>Credit' );
			page.container.find('.pay-button').on('click', page.payClick);

		}
	};

	var processing = false;
	var buttonText = 'Pay';
	this.payClick = function() {
		if (processing) return;
		buttonText = $j(this).html();
		$j(this).html('<i class="fa fa-spin fa-refresh"></i>');
		processing = true;
		var cart = _.map(page.cartItems, function(i) { i.track = {track_id: i.track_id}; return i;});
		var channelId = page.container.find('#whitelist-channel').val() || '';
		if (!page.totalPrice) {

			sa.api.request({
				handler: 'licensing/licensingCheckout',
				action: 'creditCheckout',
				postData: { cartItems: JSON.stringify(page.cartItems), channelId: channelId }
			}).then(page.handlePurchase);
				
		} else
			if (config.licensingConfig.processor === 'braintree') {
				purchaseModal.show('licensing', page.handlePurchase, 1, {
					cartItems: JSON.stringify(page.cartItems), channelId: channelId
				}, true);
		} else
		if (config.licensingConfig.processor === 'paypal') {
			sa.api.request({
				handler: 'licensing/licensingCheckout',
				action: 'paypalCheckout',
				postData: { cartItems: JSON.stringify(page.cartItems), channelId: channelId }
			}).then(function (r) {
				console.log('paypal checkout response:', r);
				processing = false;

				if (r.forward) {
					window.location.href = r.forward;
				}
			});
		}
	};

	this.removeClick = function() {
		var id = $j(this).parent().attr('id');

		cart.removeItemById(id);
		page.load();
	};

	this.couponClick = function() {
		var code = page.container.find('.coupon-input input').val();
		if (!code) {
			code = page.container.find('.no-plan-coupon-input input').val();
		}
		if (!code) return sa.notify({ text : 'No code entered.' });

		console.log('- submitting code:', code);
		sa.api.request({
			handler: 'licensing/licensingCoupons',
			action: 'submitCoupon',
			postData: {
				code: code
			}
		}).then(function (data) {
			console.log('- coupon response:', data);

			if (data.error) return sa.notify({ text: data.error });

			if (data.success) {
				if (data.amount) sa.notify({ text: data.amount + ' downloads were added to your account.' });

				if (data.coupon) {
					var couponUsed = cart.hasItem(data.coupon);
					if (!couponUsed) {
						cart.addItem(data.coupon);
					} else {
						return sa.notify({ text: 'You may only use one percent off coupon per transaction.' });
					}
				}

				return window.location.reload();
			}
			if (data.subscriptionCoupon) {
				purchaseModal.show('licensing_subscription', page.handlePurchase, code, data.plan, true);
			}
		});
	};

	this.handlePurchase = function(r) {
		processing = false;
		console.log('- handle purchase:', r);
		if (r) {
			if (r.error) {
				page.container.find('.pay-button').html( buttonText );
				return sa.alert({ text: r.error });
			}
			
			if (r.hasOwnProperty('uo') && r.uo.download_credit !== undefined) {
				var remainingCredits = parseInt(r.uo.download_credit);
				$j('#header-credit-amount').text(remainingCredits);
			}
			
			cart.clear();
			let link = getSecureLink('dashboard?p=licensing-history&transaction=' + (r.transaction_id || r.cbr.transaction_id));
			sa.router.routeTo(link);
			return;
		}

		page.container.find('.pay-button').html( buttonText );
	};
	
	return page;
}

if (config.licensingConfig.show) {
	sa.pages.shoppingCart = new ShoppingCartPage();
}
(function(t,e){if(typeof exports=="object")module.exports=e();else if(typeof define=="function"&&define.amd)define(e);else t.Spinner=e()})(this,function(){"use strict";var t=["webkit","Moz","ms","O"],e={},i;function o(t,e){var i=document.createElement(t||"div"),o;for(o in e)i[o]=e[o];return i}function n(t){for(var e=1,i=arguments.length;e<i;e++)t.appendChild(arguments[e]);return t}var r=function(){var t=o("style",{type:"text/css"});n(document.getElementsByTagName("head")[0],t);return t.sheet||t.styleSheet}();function s(t,o,n,s){var a=["opacity",o,~~(t*100),n,s].join("-"),f=.01+n/s*100,l=Math.max(1-(1-t)/o*(100-f),t),d=i.substring(0,i.indexOf("Animation")).toLowerCase(),u=d&&"-"+d+"-"||"";if(!e[a]){r.insertRule("@"+u+"keyframes "+a+"{"+"0%{opacity:"+l+"}"+f+"%{opacity:"+t+"}"+(f+.01)+"%{opacity:1}"+(f+o)%100+"%{opacity:"+t+"}"+"100%{opacity:"+l+"}"+"}",r.cssRules.length);e[a]=1}return a}function a(e,i){var o=e.style,n,r;if(o[i]!==undefined)return i;i=i.charAt(0).toUpperCase()+i.slice(1);for(r=0;r<t.length;r++){n=t[r]+i;if(o[n]!==undefined)return n}}function f(t,e){for(var i in e)t.style[a(t,i)||i]=e[i];return t}function l(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var o in i)if(t[o]===undefined)t[o]=i[o]}return t}function d(t){var e={x:t.offsetLeft,y:t.offsetTop};while(t=t.offsetParent)e.x+=t.offsetLeft,e.y+=t.offsetTop;return e}var u={lines:12,length:7,width:5,radius:10,rotate:0,corners:1,color:"#000",direction:1,speed:1,trail:100,opacity:1/4,fps:20,zIndex:2e9,className:"spinner",top:"auto",left:"auto",position:"relative"};function p(t){if(typeof this=="undefined")return new p(t);this.opts=l(t||{},p.defaults,u)}p.defaults={};l(p.prototype,{spin:function(t){this.stop();var e=this,n=e.opts,r=e.el=f(o(0,{className:n.className}),{position:n.position,width:0,zIndex:n.zIndex}),s=n.radius+n.length+n.width,a,l;if(t){t.insertBefore(r,t.firstChild||null);l=d(t);a=d(r);f(r,{left:(n.left=="auto"?l.x-a.x+(t.offsetWidth>>1):parseInt(n.left,10)+s)+"px",top:(n.top=="auto"?l.y-a.y+(t.offsetHeight>>1):parseInt(n.top,10)+s)+"px"})}r.setAttribute("role","progressbar");e.lines(r,e.opts);if(!i){var u=0,p=(n.lines-1)*(1-n.direction)/2,c,h=n.fps,m=h/n.speed,y=(1-n.opacity)/(m*n.trail/100),g=m/n.lines;(function v(){u++;for(var t=0;t<n.lines;t++){c=Math.max(1-(u+(n.lines-t)*g)%m*y,n.opacity);e.opacity(r,t*n.direction+p,c,n)}e.timeout=e.el&&setTimeout(v,~~(1e3/h))})()}return e},stop:function(){var t=this.el;if(t){clearTimeout(this.timeout);if(t.parentNode)t.parentNode.removeChild(t);this.el=undefined}return this},lines:function(t,e){var r=0,a=(e.lines-1)*(1-e.direction)/2,l;function d(t,i){return f(o(),{position:"absolute",width:e.length+e.width+"px",height:e.width+"px",background:t,boxShadow:i,transformOrigin:"left",transform:"rotate("+~~(360/e.lines*r+e.rotate)+"deg) translate("+e.radius+"px"+",0)",borderRadius:(e.corners*e.width>>1)+"px"})}for(;r<e.lines;r++){l=f(o(),{position:"absolute",top:1+~(e.width/2)+"px",transform:e.hwaccel?"translate3d(0,0,0)":"",opacity:e.opacity,animation:i&&s(e.opacity,e.trail,a+r*e.direction,e.lines)+" "+1/e.speed+"s linear infinite"});if(e.shadow)n(l,f(d("#000","0 0 4px "+"#000"),{top:2+"px"}));n(t,n(l,d(e.color,"0 0 1px rgba(0,0,0,.1)")))}return t},opacity:function(t,e,i){if(e<t.childNodes.length)t.childNodes[e].style.opacity=i}});function c(){function t(t,e){return o("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',e)}r.addRule(".spin-vml","behavior:url(#default#VML)");p.prototype.lines=function(e,i){var o=i.length+i.width,r=2*o;function s(){return f(t("group",{coordsize:r+" "+r,coordorigin:-o+" "+-o}),{width:r,height:r})}var a=-(i.width+i.length)*2+"px",l=f(s(),{position:"absolute",top:a,left:a}),d;function u(e,r,a){n(l,n(f(s(),{rotation:360/i.lines*e+"deg",left:~~r}),n(f(t("roundrect",{arcsize:i.corners}),{width:o,height:i.width,left:i.radius,top:-i.width>>1,filter:a}),t("fill",{color:i.color,opacity:i.opacity}),t("stroke",{opacity:0}))))}if(i.shadow)for(d=1;d<=i.lines;d++)u(d,-2,"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");for(d=1;d<=i.lines;d++)u(d);return n(e,l)};p.prototype.opacity=function(t,e,i,o){var n=t.firstChild;o=o.shadow&&o.lines||0;if(n&&e+o<n.childNodes.length){n=n.childNodes[e+o];n=n&&n.firstChild;n=n&&n.firstChild;if(n)n.opacity=i}}}var h=f(o("group"),{behavior:"url(#default#VML)"});if(!a(h,"transform")&&h.adj)c();else i=a(h,"animation");return p});/**
 * Drag and drop functionality
 * - this handles the detection of the drag and showing of the div/drop zones
 * - actual drop handling is dived by the drop zones themselves
 */

sa.components.edad = (function() {

	var edad = {
		attachOnLoad : true
	};
	var zoneContainer;
	var container;
	var firefoxLeaveTimer;

	var built = false;
	var earlyDropZones = [];
	
	edad.collection = $j();
	edad.dropZones = [];
	edad.needsUpgrade = false;
	
	edad.templates = null;
	
	/**
	 * Helper function so we don't suggest drag and drop if it's not available
	 */
	edad.enabled = function() {
		return edad.needsUpgrade;
	};
	
	/**
	 * builds the div container
	 * - actual drop zones are handled by their respective draw(), this is just the cover
	 * - drop zones must be added before the div is built, as it's only built once
	 */
	
	edad.build = function() {

		edad.templates = sa.templates.get('edad');

		if (!window['FormData']) { //is our browser cool?
			edad.needsUpgrade = true;
		}

		container = edad.templates.get('cover');
		zoneContainer = container.find('#edad_zone_container');
		
		if (edad.needsUpgrade) {
			$j('#edad_upgrade').show();
		}
		
		//append drop zones
		$j.each(edad.dropZones, function(key, zone) {
			zone.draw(zoneContainer);
		});

		built = true;
		if (earlyDropZones.length) {
			for (var e = 0, eLen = earlyDropZones.length; e < eLen; e++) {
				edad.addGenericDropZone(earlyDropZones[e]);
			}
		}
		
	};

	edad.attach = function() {

		$j(window).on('dragenter', function(e) { edad.dragEnter(e); });
		$j(window).on('dragleave', function(e) { edad.dragLeave(e); });
		$j(window).on('dragover', function(e) { edad.dragOver(e); });

		if(!edad.needsUpgrade) { //dont' handle drops on loser browsers
			$j(window).on('drop', edad.dragDrop);
		} else {
			$j(window).on('drop', edad.dragFailDrop);
		}

		$j('body').append(container);
	};
	
	edad.show = function() {
		updateDropZonePositions();
		
		$j(window).on('scroll.edad', function() {
			updateDropZonePositions();
		});
		
		container.show();
	};
	
	function updateDropZonePositions() {
		let cache = {};
		edad.dropZones.each(function(key, zone) {
			zone.updateZonePosition(zoneContainer, cache);
		});
	}
	
	edad.hide = function() {
		edad.unsetActiveDrop();
		edad.collection = $j(); //probalby not needed, but could result in perma-hidden state if not
		if (container) container.hide();

		$j(window).off('.edad');
	};
	
	edad.isFileTransfer = function(e) {
		e = e.originalEvent;
		if (e.dataTransfer.types) {
			for (var i=0; i<e.dataTransfer.types.length; i++) {
				if (e.dataTransfer.types[i] == "Files") {
					return true;
				}
			}
		}
		return false;
	};

	edad.isProtectedPage = function(e) {
		// If we are on a page that has its own drag and drop (like sa editor) we don't want to interfere
		const protectedPages = ['dashboard?p=inbox', 'admin?p=inbox'];
		// Also make sure, if it's on one of those pages, that it's on a page that creates or edits briefs
		const matchingRegex = /(briefs\/new)|(briefs\/\d+\/edit)/;
		const isProtectedPage = protectedPages.some(page => {
			return window.location.href.includes(page) && matchingRegex.test(window.location.href);
		});
		if (isProtectedPage) {
			e.preventDefault();
			return true;
		}

		return false;
	}
	
	edad.isProtectedPage = function(e) {
		// If we are on a page that has its own drag and drop (like sa editor) we don't want to interfere
		const protectedPages = ['dashboard?p=inbox', 'admin?p=inbox'];
		// Also make sure, if it's on one of those pages, that it's on a page that creates or edits briefs
		const matchingRegex = /(briefs\/new)|(briefs\/\d+\/edit)/;
		const isProtectedPage = protectedPages.some(page => {
			return window.location.href.includes(page) && matchingRegex.test(window.location.href);
		});
		if (isProtectedPage) {
			e.preventDefault();
			return true;
		}
		
		return false;
	}
	
	edad.dragEnter = function(e) {
		//console.log('drag enter', e);

		// Check if the current page has its own drag and drop functionality
		if (edad.isProtectedPage(e)) return;
		
		// Check if the current page has its own drag and drop functionality
		if (edad.isProtectedPage(e)) return;
		
		if (!edad.isFileTransfer(e)) return; //we dragged text or something
		
		if (edad.collection.length == 0) {
			//console.log('WINDOW ENTER!');
			edad.show();
		}
		
		//are we over a drag zone?
		$j.each(edad.dropZones, function(key, zone) {
		if (!zone || !zone.hitbox) return;
			if (e.target == zone.hitbox.get(0)) {
				zone.enter();
				edad.setActiveDrop(zone);
				return false;
			}
		});

		edad.collection = edad.collection.add(e.target);
		
		edad.dragIgnore(e);
	};
	
	edad.dragLeave = function(e) {
		// Check if the current page has its own drag and drop functionality
		if (edad.isProtectedPage(e)) return;
		
		edad.collection = edad.collection.not(e.target);
		
		if(edad.collection.length == 0) {
			//console.log('WINDOW LEAVE!');
			edad.hide();
		}
		
		//are we over a drag zone?
		$j.each(edad.dropZones, function(key, zone) {
			if(zone && zone.hitbox && e.target == zone.hitbox.get(0)) {
				zone.leave();
				edad.unsetActiveDrop();
				return false;
			}
		});
		
		edad.dragIgnore(e);
	};
	
	edad.dragDrop = function(e) {
		// Check if the current page has its own drag and drop functionality
		if (edad.isProtectedPage(e)) return;
		
		edad.dragIgnore(e);
		
		
		if(edad.activeDrop) {
			edad.activeDrop.drop(e);
		} else {
			edad.hide();
		}
		
		return false;
	};
	
	edad.dragFailDrop = function(e) {
		edad.dragIgnore(e);
		
		edad.hide();
		
		return false;
	};
	
	edad.setActiveDrop = function(zone) {
		edad.activeDrop = zone;
	};
	
	edad.unsetActiveDrop = function() {
		edad.activeDrop = false;
	};
	
	edad.dragOver = function(e) {
		// Check if the current page has its own drag and drop functionality
		if (edad.isProtectedPage(e)) return;
		
		// firefox isn't firing window dragleave events so we never record a leave
		// drag over fires continuously as something is over the window so we can wait for it to not fire, in which case the object has left
		if (BrowserDetect.isFirefox) {
			if (firefoxLeaveTimer) {
				clearTimeout(firefoxLeaveTimer);
			}
			firefoxLeaveTimer = setTimeout(function() {
				edad.hide();
			}, 500);
		}
		edad.dragIgnore(e);
		if (!edad.activeDrop) {
			e.originalEvent.dataTransfer.effectAllowed = 'copy';
			e.originalEvent.dataTransfer.dropEffect = 'none';
		} else {
			e.originalEvent.dataTransfer.dropEffect = 'copy';
		}
	};
	
	edad.dragIgnore = function(e) {
		e.originalEvent.stopPropagation();
		e.originalEvent.preventDefault();
	};

	/**
	 * Removes drop zones based on their zoneClass
	 * Used by the projector to remove all of its zones before it regenerates them
	 * @param {string} zoneClass
	 */
	edad.removeZonesByZoneClass = function(zoneClass) {
		for (let i = 0, len = edad.dropZones.length; i < len; i++) {
			let zone = edad.dropZones[i];
			if (zone.zoneClass === zoneClass) {
				zone.destroy();
				edad.dropZones.splice(i, 1);
				len--;
				i--;
			}
		}
	};

	/**
	 * Adds a new drop zone to the list
	 * @param {EdadDropZoneOptions} options
	 */
	edad.addGenericDropZone = function(options) {

		var baseOptions = {
			allowedExtensions : [ 'mp3' ],
			anchorSelector : '',
			templateSelector : '',
			prepareTemplate : function(template) { return template; },
			uniqueKey : '',
			zoneClass : '',
			dropCallback : function() {
				console.warn('Make sure you set a drop callback for your generic drop zones');
			}
		};
		options = $j.extend(baseOptions, options);

		if (!built) {
			earlyDropZones.push(options);
			return;
		}

		// remove any old drop zones for this key
		for (var i = 0, len = edad.dropZones.length; i < len; i++) {
			var zone = edad.dropZones[i];
			if (zone['uniqueKey'] && zone['uniqueKey'] == options.uniqueKey) {
				edad.dropZones[i].destroy();
				edad.dropZones.splice(i, 1);
				break;
			}
		}

		// add the new one
		var dropZone = new GenericDropZone(options);
		if (zoneContainer) {
			dropZone.draw(zoneContainer);
		}
		edad.dropZones.push(dropZone);
		
	};

	return edad;
	
})();

/**
 * @param {EdadDropZoneOptions} options
 * @constructor
 */
function GenericDropZone(options) {

	var zone = this;
	var edad = sa.components.edad;
	var allowedExtensions = options.allowedExtensions;
	var anchorSelector = options.anchorSelector;
	var dropCallback = options.dropCallback;
	var prepareTemplate = options.prepareTemplate;

	this.templateSelector = options.templateSelector;
	this.uniqueKey = options.uniqueKey;
	this.zoneClass = options.zoneClass ? options.zoneClass : '';

	this.div = null;
	
	this.destroy = function() { 
		if (this.div) {
			this.div.remove();
			this.div = null;
		}
		edad = null;
		dropCallback = null;
		anchorSelector = null;
		allowedExtensions = null;
		this.templateSelector = null;
		this.uniqueKey = null;
	};

	this.draw = function(zoneContainer) {

		zone.div = prepareTemplate(edad.templates.get(this.templateSelector));
		zoneContainer.append(zone.div);
		zone.hitbox = zone.div.filter('.edad_zone_hitbox'); //this is the same size as the normal box and z-indexed above it

		this.updateZonePosition(zoneContainer, {});
	};

	/**
	 * Resizes and positions the zone container so it's in the right spot on the page and the right size
	 * @param zoneContainer jQuery object to which to add the zone (just used by draw)
	 * @param cache an object used to cache values that don't change when you're calling this in a loop. prevents duplicate calculations
	 */
	this.updateZonePosition = function(zoneContainer, cache) {
		let anchor = $j(anchorSelector);

		if (!zone.div) {
			return zone.draw(zoneContainer);
		}

		if (!anchor.length) {
			zone.div.hide();
			return;
		} else {
			zone.div.show();
		}

		// partially/completely hide zone based on scrolling of the page, collisions with the top and bottom bars, scrolling of containers, and the height/overflow/display settings of containers
		let rect = anchor[0].getBoundingClientRect();
		let cssChange = {
			top : rect.top,
			left : rect.left,
			width : rect.width,
			height : rect.height,
			bottom : rect.bottom, // will be removed before application
			right : rect.right, // well be removed before application
			display : 'block'
		}; // what we'll apply to the zone's css
		
		let parents = anchor.parents();
		if (!parents.filter('#top_bar, #bottom_bar').length) { // elements in the top and bottom bar don't get adjusted any further. they always display fully
			
			if (parents.filter('#left_nav.collapsible:not(.expanded)').length) {
				// if the element is inside the collapsible left nav and it's collapsed, don't display it
				cssChange.display = 'none';
			} else {
				// make sure all parents are visible
				let inclusiveParents = parents.add(anchor);
				for (let i = 0, len = inclusiveParents.length; i < len; i++) {
					let styles = window.getComputedStyle(inclusiveParents[i]);
					if (styles.display === 'none' || ((parseInt(styles.height) === 0 || parseInt(styles.maxHeight) === 0) && styles.overflowY === 'hidden')) { // invisibility includes height: 0; overflow: hide stuff;
						cssChange.display = 'none';
						break;
					}
				}
			}
			
			if (cssChange.display === 'block') {
				// the zone's anchor is not explicitly hidden by css. determine its size and position
				// "bottom" is used in this block to refer to the number of px from top of viewport to bottom of an element - this is how getBoundingClientRect uses bottom, as opposed to css bottom
				cache.windowHeight = cache.windowHeight || Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
				cache.realTop = cache.realTop || $j('#top_bar').height(); // don't render over the top bar
				cache.realBottom = cache.realBottom || (cache.windowHeight - $j('#bottom_bar').height()); // don't render over the bottom bar

				// first make sure the element isn't hidden by the top or bottom bar or scrolled off the page altogether
				cssChange = applyBoundsToCssChange(cssChange, cache.realTop, cache.realBottom, cssChange);
				// then iterate through all parent elements and determine how much of the element is hidden by their bounds. the last two elements are the body and html elements which won't affect bounds so we skip them
				for (let i = 0, len = parents.length - 2; cssChange.display === 'block' && i < len; i++) {
					let parent = parents[i];
					let styles = window.getComputedStyle(parent);
					if (styles.overflowY === 'hidden' || styles.overflowY === 'auto' || styles.overflowY === 'scroll') { // bounds only matter if parent is hiding what's outside of it
						let parentRect = parent.getBoundingClientRect();
						cssChange = applyBoundsToCssChange(cssChange, Math.max(cache.realTop, parentRect.top), Math.min(cache.realBottom, parentRect.bottom), cssChange);
					}
				}
			}
			
			// if the left nav is collapsible and the zone's anchor isn't in the left nav, make sure it's properly occluded
			cache.expandedCollapsibleLeftNav = cache.expandedCollapsibleLeftNav !== undefined ? cache.expandedCollapsibleLeftNav : $j('#left_nav.collapsible.expanded').length;
			if (cssChange.display === 'block' && cache.expandedCollapsibleLeftNav && !parents.filter('#left_nav').length) {
				cache.leftNavBoundingClientRect = cache.leftNavBoundingClientRect || $j('#left_nav')[0].getBoundingClientRect();
				if (cssChange.left < cache.leftNavBoundingClientRect.right) {
					// element is overlapping the left nav (we're assuming it's underneath)
					cssChange.width -= cache.leftNavBoundingClientRect.right - cssChange.left;
					cssChange.left = cache.leftNavBoundingClientRect.right;
				}
			}
		}
		
		// getBoundingClientRect generates some crazy floats. round those out
		for (let i in [ 'width', 'height', 'top', 'left']) {
			if (cssChange.hasOwnProperty(i)) {
				cssChange[i] = Math.round(cssChange[i]);
			}
		}
		
		// we have to position the text differently in the zone depending on if the top or the bottom is being cut off
		// if it's the top, we stick the text to the bottom so the top of the text is cut off as well and vice versa
		if (cssChange.top !== Math.round(rect.top)) {
			zone.div.find('.edad_default, .edad_active').css({ top : 'initial', bottom : 0 });
		} else if (cssChange.bottom !== Math.round(rect.bottom)) {
			zone.div.find('.edad_default, .edad_active').css({ top : 0, bottom : 'initial' });
		}

		// we use these for math but don't actually want to apply them
		delete cssChange.right; 
		delete cssChange.bottom;

		zone.div.css(cssChange);
		zone.hitbox.css(cssChange);
	};
	
	function applyBoundsToCssChange(rect, top, bottom, cssChange) {
		if (rect.bottom < top) {
			// it's off the top of the page completely. hide it
			cssChange.display = 'none';
		} else if (rect.top > bottom) {
			// it's off the bottom of the page completely. hide it
			cssChange.display = 'none';
		} else {
			if (rect.top < top) {
				// element is poking out the top
				cssChange.height -= top - rect.top;
				cssChange.top = top;
			}
			if (rect.bottom > bottom) {
				// element is poking out the bottom
				cssChange.height -= rect.bottom - bottom;
				cssChange.bottom = bottom;
			}
		}
		return cssChange;
	}

	this.enter = function() {
		zone.div.addClass('hover');
		//zone.div.find('.edad_default').hide();
		let edadActive = zone.div.find('.edad_active');
		// this css aligns the edad active div so it's the height of its container, if its container was fully displayed (not scrolled out of view)
		// that's important so the "Drop whatever" text appears in the right place (remove and try dragging into a playlist with a multi-line name)
		edadActive.css({ height : ($j(anchorSelector)[0].getBoundingClientRect().height - parseInt(window.getComputedStyle(zone.div[0]).borderWidth) * 2) + 'px' });
		//edadActive.show();
	};

	this.leave = function() {
		zone.div.removeClass('hover');
		//zone.div.find('.edad_default').show();
		//zone.div.find('.edad_active').hide();
	};

	this.drop = function(e) {
		// we want all the files with acceptable extensions
		var validFiles = [],
			files = e.originalEvent.dataTransfer.files;

		for (var f = 0, fLen = files.length; f < fLen; f++) {

			var extension = files[f].name.split('.').pop().toLowerCase();

			if (allowedExtensions.indexOf(extension) !== -1) {
				validFiles.push(files[f]);
			} else {
				console.log('skipping', files[f].name, 'because its extension wasn\'t allowed');
			}

		}

		if (validFiles.length) {

			zone.leave(e);
			edad.hide();

			dropCallback(validFiles);

		} else {
			var otext = zone.div.find('.edad_active').html();
			zone.div.find('.edad_active').html('Invalid File Type.');

			//let's let them see the error message for a couple second, then reset everything
			setTimeout(function() {
				zone.div.find('.edad_active').html(otext);
				zone.leave(e);
				edad.hide();
			}, 2000);
		}

	};

	this.leave = function() {
		zone.div.removeClass('hover');
		//zone.div.find('.edad_default').show();
		//zone.div.find('.edad_active').hide();
	};

}
/**
 * File Uploading class
 * - because we're not using Flash anymore
 * - See uploader.js for legacy support, this is meant to be used with drag and drop
 */

var UploadServers = {
	TRACK_SERVER: '//' + ImportDomain + '/index.php?whiteId=' + config.id
};

function FileUploader() {
	var fu = this;
	
	/**
	 * Callbacks, set these before you call the uploadFromX functions
	 */
	
	this.onProgress = null; //onProgress(bytesLoaded, bytesTotal)
	this.onComplete = null; //onComplete(xhr.responseText)
	this.onError = null; //onError(xhr.status)
	
	/**
	 * Upload file(s) selected by browse
	 * - if supported (read: not <=IE9), then this uses XHR2 to create a FormData and track progess that way
	 * - because I want Ryan to love me, I'll code in backwards compat support the current flash support from uploader.js
	 * @param {HTMLElement} form is the HTML form element, not a jq object
	 */
	this.uploadFromForm = function(form) {
		
	};
	
	/**
	 * upload file from a drag and drop event
	 * - because this originates from drag and drop that shares the same browser compat as XHR2, that's all we'll use
	 * @param {File} file object, from event.dataTransfer.files
	 * @param {string} getVars is a string to append to the form action's get - type of thing you're uploading etc.
	 * @param {string} server is a server key from UploadServers to send the file to
	 */
	
	this.uploadFromDrop = function(file, getVars, server) {
		if(!file) {
			console.log('-- fu: error, no file sent');
			return;
		}
		
		//is it a valid server?
		if(!(server in UploadServers)) {
			console.log('-- fu: error, invalid server sent');
			return;
		} else {
			server = UploadServers[server];
		}
		
		//string of cookie stuff for login since this is likely not the same server
		var login_string = 'l=' + sa.cookies.get(window['normalUserCookieName']) + '&ua=' + encodeURIComponent(navigator.userAgent.replace(/(Trident\/[5-9]\.[0-9.]+);.*/, '$1)')) + '&s=' + sa.cookies.get(window['secureUserCookieName']);
		
		//construct the action path
		var path = server + '&' + login_string + '&' + (getVars ? getVars : '');
		
		//make our form
		var f = new FormData();
		f.append('file', file);
		
		//make our request
		var xhr = new XMLHttpRequest();
		xhr.open('POST', path);
		
		xhr.upload.addEventListener('progress', function(e) {
			//if(e.lengthComputable) e.loaded / e.total
			if(e.lengthComputable) {
				if(fu.onProgress) fu.onProgress(e.loaded, e.total);
			} else {
				if(fu.onProgress) fu.onProgress(0, 1);
			}
		});
		
		xhr.addEventListener('load', function() {
			if(xhr.status == 200) {
				console.log('upload complete');
				if(fu.onComplete) fu.onComplete(xhr.responseText);
			} else {
				console.log('upload error');
				if(fu.onError) fu.onError(xhr.status);
			}
		});
		
		xhr.send(f);
		
	};
	
}
/**
 * Clippy Notifications Manager
 * - floating notifications that are typically one-use to show off new features
 * - the premise is for this to be generic enough to accomodate any type of floating notification
 * and as such, most of the placement and triggering mechanisms will be on the clippy classes themselves
 */

var clippyManager = new ClippyManager();

function ClippyManager() {
	var man = this;
	var cookieName = 'clippynotifications';

	this.clippies = [];


	this.init = function() {

		$j.each(man.clippies, function(key, clippy) {
			if(!man.hasSeen(clippy)) {
				clippy.init();
			}
		});

	};

	this.getClippy = function(clippy_id) {
		var foundClip = false;
		$j.each(man.clippies, function(key, clippy) {
			//console.log('get clippy:', clippy.id, clippy_id, clippy.id == clippy_id);
			if(clippy.id == clippy_id) foundClip = clippy;
		});

		return foundClip;
	};

	this.hasSeen = function(clippy) {

		var cookie = sa.cookies.get(man.getCookieName(clippy));
		//console.log('clippy cookie is:', cookie);

		if(cookie && clippy.time_cutoff) {
			return cookie > clippy.time_cutoff;
		} else if(cookie) {
			return true;
		} else {
			return false;
		}
	};

	this.setSeen = function(clippy) {
		var now = new Date().getTime();
		sa.cookies.setIfAllowed(sa.cookieTypes.preference, man.getCookieName(clippy), now, clippy.expiration ? clippy.expiration : 86400 * 180);

		console.log('clippy cookie set', man.getCookieName(clippy));
	};

	this.getCookieName = function(clippy) {
		return 'clippy-' + clippy.id + '-' + ((user.logged) ? user.userData.id : 0);
	};

}

/**
 * Clippy Notifications
 * -- time_cutoff: set to a unix time to invalidate all cookies before that point, like if you update the feature
 * -- expiration: set to a js unix time length for how long it should last. 0 for forever
 * -- init(): the manager calls this to start the process
 * -- man.setSeen(clip) should be called upon click, or display, whatever you want to trigger from
 *
 */

function SonicSearchClippy() {
	var clip = this;

	this.div = null;
	this.id = 'sonicsearch4';
	this.expiration = 0;
	this.time_cutoff = 0;
	this.hidden = false;

	this.draw = function() {
		clip.div = $j('<div id="clippy-'+clip.id+'" class="clippy_anchored" style="display: none;"></div>');
		$j('body').append(clip.div);

		clip.div.html(''
			+ '<div class="clippy_title">Sonic Search Beta</div>'
			+ '<div class="clippy_desc">Upload an audio file to return musically similar results. Give it a shot!</div>'
			+ '<div class="clippy_tip">Tip: Drag &amp; drop for easy uploading!</div>'
			+ '<div class="clippy_close faux_button">x</div>'
			+ '<div class="clippy_top_carrot"></div>'
		);

		clip.div.on('click', clip.press);

		clip.place();

		clip.div.slideDown();

		console.log('clip initialized');
	};

	this.press = function(e) {
		if(!clip.div) return;
		console.log('ss clippy press');
		clip.div.slideUp();
		clip.setSeen();
	};

	this.place = function() {
		if(clip.hidden) return;

		//we want to place this at the search note
		var note = $j('.search_note');
		if(!note.length) return;

		var pos = note.offset();

		//is the search bar centered?
		var centered = $j('.search_browse').hasClass('centered');

		if(centered) {
			console.log('centered');
			clip.div.find('.clippy_top_carrot').css('left', '10px');
			clip.div.find('.clippy_top_carrot').css('right', 'auto');
			clip.div.css('left', (pos.left - 8) + 'px');
			clip.div.css('top', (pos.top + 40) + 'px');
		} else {
			console.log('not centered');
			clip.div.find('.clippy_top_carrot').css('left', 'auto');
			clip.div.find('.clippy_top_carrot').css('right', '10px');
			clip.div.css('left', (pos.left + 10 - clip.div.width()) + 'px');
			clip.div.css('top', (pos.top + 40) + 'px');
		}
	};

	this.setSeen = function() {
		clippyManager.setSeen(clip);
	};

	this.init = function() {
		if(BrowserDetect.isIE8down || ios || !$j('.search_note').length) {
			console.log('ie8 detected, no clips');
			return;
		}
		$j('#search_container').mouseover(function(e) {
			$j('#search_container').off();
			clip.draw();
			$j(window).on('resize', function() {
				clip.place();
			});
		});
		console.log('clip init end');
	};
}

function SaveSearchClippy() {
	var clip = this;

	this.div = null;
	this.id = 'savesearch';
	this.expiration = 0;
	this.time_cutoff = 0;
	this.hidden = false;

	this.draw = function() {
		clip.div = $j('<div id="clippy-'+clip.id+'" class="clippy_anchored" style="display: none;"></div>');
		$j('body').append(clip.div);

		clip.div.html(''
			+ '<div class="clippy_title">Pro Tip: Save your searches!</div>'
			+ '<div class="clippy_desc">Click the star to save this search so you can quickly run it again in the future! Access saved searches from your dashboard or by typing its name into the search bar!</div>'
			+ '<div class="clippy_close faux_button">x</div>'
			+ '<div class="clippy_top_carrot"></div>'
		);

		clip.div.on('click', clip.press);

		clip.place();

		clip.div.slideDown();

		console.log('clip initialized');
	};

	this.press = function(e) {
		if(!clip.div) return;
		console.log('ss clippy press');
		clip.div.slideUp();
		clip.setSeen();
	};

	this.place = function() {
		if(clip.hidden) return;

		//we want to place this at the search note
		var note = $j('#save_search');
		if(!note.length) return;

		var pos = note.offset();

		clip.div.find('.clippy_top_carrot').css('left', 'auto');
		clip.div.find('.clippy_top_carrot').css('right', '10px');
		clip.div.css('left', (pos.left + 10 - clip.div.width()) + 'px');
		clip.div.css('top', (pos.top + 40) + 'px');

		var resizeFunction = function() {
			if (!clip.div.filter(':visible')) {
				return $j(window).off('resize', resizeFunction);
			}
			clip.place();
		};
		$j(window).on('resize', resizeFunction);
	};

	this.setSeen = function() {
		clippyManager.setSeen(clip);
	};

	this.init = function() {
		if(BrowserDetect.isIE8down || ios || !$j('.search_note').length) {
			console.log('ie8 detected, no clips');
			return;
		}
		if ($j('#clippy-savesearch').length || clippyManager.hasSeen(clip)) return;
		this.draw();
		unloadFunctions = [function() {
			clip.div.remove();
			return false;
		}];
	};
}

var ProfileImporter =  {

	generateButton: function(button) {
		var importer = this;

		var up = new Uploader({
			button : button,
			browseCallback : function(uploader) {

				var file = uploader.getFileDetails()[0];
				console.log('- profile import file:', file);
				var fileType = file.name.toLowerCase().match(/\.([a-z3]+)$/)[1];

				var buttonTitle = $j(button).html();
				$j(button).html('Loading...');

				console.log('file info:', file);
				uploader.upload({
					params : 't=profile_import',
					complete : function(e, jsonData) {
						var r = JSON.parse(jsonData);
						console.log(r);
						var data = r.content[0].data;
						console.log('- upload complete:', data);
						$j(button).html(buttonTitle);
						ProfileImporter.showReview(data);
					},
					progress : function(e, bytesLoaded, bytesTotal) {
						console.log('- profile import progress:', bytesLoaded / bytesTotal);
					},
					error : function() { console.log('error during upload'); },
					fileId : file.id
				});
			},
			fileType : UploaderConstants.LPROFILE
		});

		return up;
	},

	showReview: function(data) {
		console.log('- profile import data:', data);
		sa.notify({ text :  data.updated + ' tracks assignments updated!'  });
		setTimeout(function() {
			window.location.reload();
		}, 1000);
	}
}

window.noAlert = true; // for change notifier

var ContentIdImporter =  {

	generateButton: function(button, replace) {
		var importer = this;

		var up = new Uploader({
			button : button,
			browseCallback : function(uploader) {

				var file = uploader.getFileDetails()[0];
				console.log('- profile import file:', file);
				var fileType = file.name.toLowerCase().match(/\.([a-z3]+)$/)[1];

				var buttonTitle = $j(button).html();
				$j(button).html('Loading...');

				console.log('file info:', file);
				uploader.upload({
					params : 't=contentid_import' + (replace ? '&replace=1' : ''),
					complete : function(e, encodedData) {
						var r = JSON.parse(encodedData);
						console.log(r);
						var data = r.content[0].data;
						console.log('- upload complete:', data);
						$j(button).html(buttonTitle);
						ContentIdImporter.showReview(data);
					},
					progress : function(e, bytesLoaded, bytesTotal) {
						console.log('- contentid import progress:', bytesLoaded / bytesTotal);
					},
					error : function() { console.log('error during upload'); },
					fileId : file.id
				});
			},
			fileType : UploaderConstants.LPROFILE
		});

		return up;
	},

	showReview: function(r) {
		console.log('- contentid import data:', r);

		$j('#ingest-info').html( ((r.counts.total - 1) || 0) + ' rows processed. Refreshing page...');
		let currentUrl = sa.router.getFullUrl();
		if (currentUrl.indexOf('noreload') === -1) {
			setTimeout(function() { 
				window.location.reload(); 
			}, 2000);
		}
	}
};
/**
 * Purchase Modal: The js front-end to the Purchaser PHP class for charging users for one-time features in a configurable way.
 * Usage:
 *	- The modal is accessed through the variable 'purchaseModal'
 *	- Simply call purchaseModal.show('item_key', callback);
 *	- When the window exits, it will call the callback with either false if it was cancelled, or the purchase info if it was successful
 *	- Purchase items are held in the sa_purchaser_items table, and purchase logs go to sa_purchser_purchases
 *	- On the PHP side, the item's callback will be called only if the purchase was successful.
 */

function PurchaseModal() {
	var pm = this;
	this.useWhite = false;
	this.div = null;
	this.built = false;
	this.purchasing = false;
	this.data = null;
	this.cards = [];
	this.selectedCard = null;
	this.key = '';
	this.cb = function(r) {};
	this.subscriptionId = 0;
	this.postData = {};

	this.setData = function(data) {
		// pm.data = pm.data === null ? data.item : pm.data;
		pm.data = data.item;

		pm.cards = data.cards;

		if (pm.data.data.buttonText && pm.data.data.buttonText === 'Update Card') {
			pm.div.find('.purchase_text').hide();
			pm.div.find('.subscription_change_text').show();
			pm.data['buttonText'] = pm.data.data.buttonText;
			pm.div.find('.content').hide();
			pm.div.find('.loader').hide();
		} else {
			//set item fields
			pm.div.find('.purchase_text .item-title').html((pm.data.num ? pm.data.num + 'x ' : '') + pm.data.title);
			pm.data.description = pm.data.description.replace(/\{\$\$(.*?)\}/gm, function (match, p1) { return p1.currencyFormat(); });
			pm.div.find('.purchase_text .item-desc').html(pm.data.description);

			// dynamic height of description
			pm.div.find('.content').show();
			var descriptionLines = Math.floor(pm.div.find('.purchase_text .item-desc').height() / 15); // should be 19 but we give it some flex to allow for os/browser font rendering differences
			if (descriptionLines > 1 && !sa.isMobile()) {
				var additionalHeight = 19 * (descriptionLines - 1);
				pm.div.find('.purchase_text .item').css({ height: 54 + additionalHeight });
				pm.div.find('.purchase_text .price').css({ height: 64 + additionalHeight, 'line-height': 64 + additionalHeight + 'px' }); // why do you need px for line height but not height? who knows!
			}
			pm.div.find('.content').hide();

			if (pm.data.data.showPrice != null) pm.data.price = pm.data.data.showPrice;

			var price = pm.data.price / 100;
			var dollars = Math.floor(price);
			var cents = Math.round(100 * (price - dollars));
			cents = (1e15 + cents + '').slice(-2);

			var currency = getCurrencyInfo(config);
			var formattedCurrency = (new Currency(currency.code, parseFloat(price), false)).getResult();

			console.log('- currency:', formattedCurrency);
			
			pm.div.find('.item-line .price').html(formattedCurrency + (pm.data.subline ? '<div class="sub-line">' + pm.data.subline + '</div>' : ''));
			if (!dollars) {
				pm.div.find('.item-line .price').addClass('underdollar');
			}
		}

		if (pm.data['buttonText']) {
			pm.div.find('#purchase-button').html(pm.data['buttonText']);
		} else {
			pm.div.find('#purchase-button').html('Purchase');
		}

		if (pm.data['data'] && pm.data['data']['notice']) {
			pm.div.find('#notice').html(pm.data['data']['notice']).show();
		} else {
			pm.div.find('#notice').hide();
		}

		if (pm.data['data'] && pm.data['data']['purchaserTitle']) {
			pm.div.find('.title .purchase_text').html(pm.data['data']['purchaserTitle']);
		}

		pm.div.find('.content').fadeIn();
	};

	this.build = function() {
		console.log('- building purchase modal...');

		$j('#purchase-modal').remove();
		
		const baseUrl = siteBaseUrl();

		$j('body').append(sa.templates.get('purchase_modal').get('modal', {
			baseUrl: baseUrl
		}));
		
		pm.div = $j('#purchase-modal');

		// cancel button
		pm.div.find('#purchase-cancel').on('click', function(e) {
			pm.hide();

			// If it's not the billing site, we don't need to do this check
			if (!pm.key === 'billing_site') return;
			
			// Check if there is a card available after we close the modal and change the status on the page accordingly
			ajax({ p: 'billing', action: 'getDetails', liveProcessing: (sa.router.getCurrentParamsAsObject()).liveProcessing ? 1 : 0 }, (billingDetails) => {
				if (!billingDetails.cardType || !billingDetails.cardDigits) {
					$j('.admin_billing .card_state').removeClass('has_card').addClass('no_card');
					$j('.admin_billing .card_state .card_on_file').text('You have no card on file!');
					$j('.admin_billing .card_icon').removeClass().addClass('card_icon fa fa-credit-card internal_element');
					
					if (!$j('.non-payment-warning').length) {
						$j('.admin_billing .card_state').after('<div class="non-payment-warning no_card"><span>Please add or update your card. Non-payment can result in the workspace being deleted.</span></div>');
					}
				}
			});
		});

		$j('#privacy-link').on('click', function() {
			sa.components.documentViewer.show('privacy_policy');
			return false;
		});

		pm.built = true;
	};

	this.braintreeSetup = function () {
		// For 3D Secure purchases, the transaction needs additional details - the more the better.
		// For this use case, we are only including the amount and the user's email address, but some
		// more stringent checks may require a billing address or other additional information.
		const threeDSecureParameters = {
			amount: `${pm.data.price / 100}`,
			email: user.userData.email,
		};
		
		// Get the Purchase Button Element
		const button = document.querySelector('#purchase-button');

		// The Drop-In UI requires some configuration. 
		// In addition to the usual card overrides, authorization tokens, and element container selector
		// we also include `dataCollector` and `threeDSecure` to allow for 3D Secure verified transactions
		const dropInOptions = {
			authorization: pm.token,
			container: '#dropin',
			dataCollector: true,
			// Only allow managing cards from the site's billing page
			vaultManager: pm.key === 'site_billing',
			card: {
				cardholderName: {
					required: true
				},
				overrides: {
					fields: {
						number: {
							placeholder: '4111 1111 1111 1111'
						},
						cvv: {
							placeholder: '123',
						}
					}
				}
			}
		};

		const use3DSecure = config.licensingConfig.braintree_credentials && config.licensingConfig.braintree_credentials.is3dSecure;

		// If 3D Secure is on and it's NOT the site's billing page
		if (use3DSecure && pm.key !== 'site_billing') {
			dropInOptions.threeDSecure = true;
		}
		
		braintree.dropin.create(dropInOptions, (createErr, instance) => {		
			// Click event for saving/updating/paying with card
			button.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const requestOptions = {};

				if (use3DSecure) {
					requestOptions.threeDSecure = threeDSecureParameters;
				}

				instance.requestPaymentMethod(requestOptions, (err, payload) => {
					if (err) {
						// Handle errors in requesting payment method
						console.log(err);
						pm.purchasing = false;
						return;
					}
					
					// Send payload.nonce to your server
					// The 3D Secure Authentication ID can be found
					//  at payload.threeDSecureInfo.threeDSecureAuthenticationId
					pm.payload = payload;
					
					console.log('payment:', payload);
					if (payload.message) {
						sa.alert({ text: payload.message });
						return;
					}

					pm.nonce = payload.nonce;
					pm.purchasing = false;
					pm.submit();
				});
			}, { once: true });
		});
	};

	/**
	 * Takes in a Braintree Card processing status message and returns if it was an error status
	 * 
	 * @param {string} status
	 * @returns {boolean|string}
	 */
	this.handlePurchaseErrorStatus = function (status) {
		switch (status) {
			case 'authenticate_error':
			case 'authenticate_failed':
			case 'authenticate_signature_verification_failed':
			case 'authenticate_unable_to_authenticate':
			case 'lookup_failed_acs_error':
			case 'authenticate_failed_acs_error':
			case 'lookup_card_error':
			case 'lookup_error':
				return 'Something went wrong with the purchase. Please try again.';
				
			case 'authenticate_successful_issuer_not_participating':
			case 'unsupported_account_type':
			case 'authenticate_rejected':
			case 'authenticate_frictionless_failed':
				return 'The card in use cannot be processed. Please try a different card.';
				
			case 'authentication_unavailable':
				return 'Something went wrong. Please contact us if this continues.';
				
			case 'lookup_server_error':
				return 'Something went wrong processing the card. If this continues, try again later, or contact us.';
			default:
				return false;
		}
	};

	this.submit = function() {
		console.log('purchase pressed');
		if (pm.purchasing) return;

		pm.cardholder = pm.payload.details.cardholderName;

		console.log('we are good', pm.key, pm.num);

		pm.purchasing = true;
		pm.div.find('#purchase-button').html('Processing...');

		let postData = $j.extend({
			key: pm.key + (pm.num && pm.num !== 1 ? '#' + pm.num : ''), 
			affiliate: sa._aff || '', 
			nonce: pm.nonce, 
			cardholder: pm.cardholder, 
			token: pm.selectedCard ? pm.selectedCard.token : null, 
			subscriptionId : pm.subscriptionId,
			deviceData: pm.payload.deviceData
		}, pm.postData);
		
		postData.useWhite = pm.useWhite;
		
		sa.api.request({
			handler: 'purchaser',
			action: (pm.key === 'update_sub_payment' ? 'updateSubscriptionCard' : 'charge'),
			postData
		}).then(function (r) {
			console.log('purchase charge response:', r);
			pm.div.find('#purchase-button').html('Complete!');
			
			if (r.hasOwnProperty('cbr') && r.cbr.hasOwnProperty('uo') && r.cbr.uo.download_credit !== undefined) {
				var remainingCredits = parseInt(r.cbr.uo.download_credit);
				if (remainingCredits < 99999) {
					$j('#header-credit-amount').text(remainingCredits);
				} else {
					$j('#header-credit-amount').html('<span class="inf">∞</span>');
				}
			}
			
			setTimeout(function () {
				if (pm.cb) pm.cb(r);
				pm.nonce = "";
				pm.selectedCard = null;
				pm.hide();
			}, 2000);
		}).catch(function (e) {
			console.log('SA-API Error:', e);
			sa.alert({text: e.message});
			if (pm.data['buttonText']) {
				pm.div.find('#purchase-button').html(pm.data['buttonText']);
			} else {
				pm.div.find('#purchase-button').html('Purchase');
			}
			pm.nonce = "";
			pm.selectedCard = null;
			pm.purchasing = false;

			$j('#dropin').empty();
			pm.braintreeSetup();
		});
	};

	this.show = async function(key, cb, num, postData, useWhite) {
		pm.build();

		pm.div.find('.content').hide();
		pm.div.find('.loader').show();
		pm.div.fadeIn();

		if (num) pm.num = num;
		pm.key = key;
		pm.cb = cb;
		pm.purchasing = false;
		pm.subscriptionId = 0;
		pm.useWhite = useWhite || 0;

		if (!postData) {
			postData = {};
		}

		pm.postData = postData;
		pm.div.find('.subscription_change_text').hide();
		pm.div.find('.purchase_text').show();
		const t = await sa.api.request({
			handler: 'licensing/licensingCheckout',
			action: 'getClientToken',
			getData: {
				useWhite: pm.useWhite,
			}
		});

		pm.token = t.token;
	
		postData.key = key + (num && num != 1 ? '#' + num : '');
		postData.useWhite = pm.useWhite;
		const r = await sa.api.request({
			handler: 'purchaser',
			action: 'load',
			postData: postData
		});

		console.log('purchase load response:', r);
		if (r.item.error) {
			pm.div.hide();
			setTimeout(function () {
				sa.alert({ text : r.item.error });
			}, 1); //settimeout to get around chrome bug with the hide()
			return;
		}
		if (!r.item) {
			pm.div.hide();
			setTimeout(function () { alert('No such item. Code error.'); }, 1);
			return;
		}

		pm.setData(r);
		
		// Display the info about sandbox mode, if we're in sandbox mode
		const isSandboxMode = config.licensingConfig 
			&& config.licensingConfig.processor 
			&& config.licensingConfig[`${config.licensingConfig.processor}_credentials`].sandbox === 1;

		if ((isSandboxMode && pm.key !== 'site_billing' && (user && user.siteOwner))) {
			pm.div.find('.sandbox-info-block').removeClass('hide-sandbox-info');
		} else {
			pm.div.find('.sandbox-info-block').addClass('hide-sandbox-info');
		}

		return pm.braintreeSetup();
	};

	this.hide = function() {
		pm.div.fadeOut('fast');
		if (pm.cb) pm.cb(false);
	};

	this.showSubscriptionChanger = function (key, cb) {
		if (!key || key != 'update_sub_payment') return alert('Invalid item key, expected key: update_sub_payment.');
		pm.show(key, cb, null, {}, true);
	};

}

var purchaseModal = new PurchaseModal();
/**
 * Licensing Modal
 */

function LicensingModal() {
	var lm = this;
	this.div = null;
	this.cb = function(r) {};
	this.demo = false;

	this.show = function(profile, track, e, cb) {
		lm.e = e;
		lm.key = 0;
		lm.selection = [];
		lm.success = 0;
		lm.trackId = track ? track.id : null;
		if (cb) {
			lm.cb = cb;
		} else {
			lm.cb = function(){};
		}
		lm.div = sa.templates.get('licensing_modal').get('modal');
		lm.fileFly = lm.div.find('#file-fly').detach();

		$j('body').append( lm.div );

		lm.loadProfile(profile, track);

		lm.div.on('click',  lm.hide );
		lm.div.find('.content').on('click', function(e) {
			e.stopPropagation();
		});
	};

	this.hide = function() {
		lm.demo = false;
		lm.div.hide();
		lm.div.detach();
		lm.cb( lm.success );
	};

	this.showLogin = function() {
		lm.hide();

		sa.confirm({
			text: 'You must be logged in to purchase tracks.',
			yesText: 'Log In',
			yesFunction: function() {
				const cartKey = lm.track.id + '-' + lm.profile.id + '-0';
				window.location.href = lm.buildShoppingCartLink(cartKey);
			},
			noText: 'Cancel'
		});
	};
	
	this.buildShoppingCartLink = function (cartKey) {
		const baseUrl = siteBaseUrl();
		return baseUrl + '/shopping-cart?cart=' + cartKey;
	}

	this.showLoginOld = function() {
		lm.div.find('.loader').hide();
		lm.div.find('.content').show();
		lm.div.find('.content > div').hide();
		lm.div.find('.content .login-required').show();
		lm.div.find('.content .login-required a').attr('href', getLoginLink());
	};

	this.getProfile = function( track, cb, returnassigned ) {
		var a = config.licensingConfig.assignments;
		var p = a[0]; // default

		// if by chance we're sent an id, but not label, we need to look up this data
		if (track.id && !track.label) return lm.getTrackInfo(track.id, function(err, t) {
			if (err) return cb(err);
			if (!t?.label) return cb('No label found for this track.');

			return lm.getProfile(t, cb, returnassigned);
		});

		if (a[ track?.label?.id ]) p = a[ track.label.id ];
		lm.getTrackProfile( track, function(t) {
			if (t) p = t;

			if (!p) return cb(false);
			var profile = config.licensingConfig.profiles[ p.profile ];
			if ((!profile || profile.notfound) && t && returnassigned) return cb({id: -1, trackassigned: 1});
			if (!profile || profile.notfound) return cb(false);
			if (t) profile.trackassigned = true;


			// is this a one-price profile?
			//console.log('- check profile:', p, profile);
			if (profile.data.children.length == 1 && profile.data.children[0].price) {
				profile.oneprice = profile.data.children[0].price;
			}

			cb(profile);
		});
	};

	this.getTrackProfile = async function(track, cb) {
		if (!config.licensingConfig.options.trackAssignment) {
			return cb(false);
		}
		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'getTrackProfile',
			getData: {
				track_id: track.id,
			}
		});

		if (r.notfound) return cb(false);
		//console.log('- track profile override:', r.profile);

		cb(r);
	};

	this.loadProfile = function(profile, track, checked ) {

		if (!checked && ( !profile || profile.notfound || (track && config.licensingConfig.options.trackAssignment))) {
			// figure out what profile to use from track and label
			lm.getProfile( track, function(p) {
				if (!p) p = {notfound: 1};
				console.log('- found:', p);
				lm.loadProfile(p, track, true);
			});
			return;
		}

		if (!track) {
			var track = {
				title: 'Example Track',
				album: {
					name: 'Greatest Hits',
					image: null
				},
				artist: {
					name: user.userData.username
				}
			};
		}

		lm.track = track;
		lm.profile = profile;
		lm.div.show();
		lm.render();

		if (config.licensingConfig.options.bypassSingles && lm.profile.oneprice) {
			console.log('- bypassing modal for single option license');
			if (user.logged) {
				lm.addToCart();
			} else {
				lm.showLogin();
			}
		}
	};

	this.getTrackInfo = function(trackId, cb) {
		ajax({
			p: 'track_info',
			id: trackId
		}, function(r) {
			var track = r[1]; // r[0] is the filters object
			return cb(null, track);
		});
	};

	this.render = function() {
		lm.div.find('.loader').hide();
		lm.div.find('.content').show();

		// left column
		lm.chosenTemplate = lm.div.find('.usage-chosen').detach();
		lm.optionTemplate = lm.div.find('.usage-option').detach();
		lm.optionListTemplate = lm.div.find('.usage-options').detach();

		// right column
		lm.detailItemTemplate = lm.div.find('.detail-item').detach();

		// render track
		lm.div.find('#track-block .track-title').html( lm.track.title );
		if (lm.track.artist) {
			lm.div.find('#track-block .track-artist').html( lm.track.artist.name );
		} else {
			lm.div.find('#track-block .track-artist').hide();
		}
		lm.div.find('#track-block .track-album').html(lm.track.album ? lm.track.album.name : lm.track.label.name);

		let isValidImage = function (image) {
			if (image && image !== 'images/shared/default_album.jpg') return image;
			return false;
		};

		let itemArt = !lm.demo ? (
					isValidImage(_.get(lm, 'track.album.image', ''))
					|| isValidImage(_.get(lm, 'track.label.image', ''))
					|| isValidImage(_.get(lm, 'track.catalog.image', ''))
					|| isValidImage(_.get(lm, 'album.image', ''))
					|| isValidImage(_.get(lm, 'label.image' , ''))
					|| isValidImage(_.get(lm, 'catalog.image', ''))
					|| isValidImage(config.logo)
					|| false
		) : false;
		if (itemArt) lm.div.find('#track-block .track-art img').attr('src', itemArt);

		// render option
		lm.renderSelection();
		lm.div.find('.usage-choose').on('click',  lm.chooseOption );
		lm.div.find('.usage-cart .button').on('click',  lm.addToCart );
		lm.div.find('.usage-project-details').on('click',  lm.showProjectDetails );

		// license link
		lm.div.find('.usage-cart .disclaimer a').attr('href', 'pdf.php?type=licensing_license&preview=' + lm.profile.data.agreement);

		lm.div.find('.close').on('click', function() {
			lm.hide();
		})
	};

	this.renderSelection = function() {
		lm.div.find('.usage-list').html('');
		lm.key = '0';

		if (!lm.selection || !lm.selection.length) return lm.renderOption( lm.profile.data );

		var s = lm.selection.concat([]);
		while (s.length) {
			var op = s.shift();
			console.log('- render chosen', op.key);
			if (op.key !== undefined) lm.key += '-' + op.key;
			lm.renderChosen( op );
		}
		lm.renderOption( op );

	};

	this.renderChosen = function( op ) {
		var cdiv = lm.chosenTemplate.clone();
		var key = lm.key + '';
		cdiv.data('option', op);
		cdiv.find('.title').html( op.title );
		cdiv.find('.action').on('click',  function() {
			lm.changeOption( key );
		});
		lm.div.find('.usage-list').append( cdiv );
	};

	this.changeOption = function( key ) {
		console.log('- changing', key);
		var l = key.split('-').length;

		// if the key is length 2, then it's a full reset, if 3, keep the first, etc.
		l -= 2;
		lm.selection = l > 0 ? lm.selection.slice(0, l) : [];
		lm.div.find('.usage-choose').hide();
		lm.div.find('.usage-cart').hide();
		lm.div.find('.usage-project-details').hide();
		lm.renderSelection();
		lm.renderDetails();

	};

	this.renderOption = function( op ) {
		var oldiv = lm.optionListTemplate.clone();
		oldiv.data('option', op);

		var ii = 0;
		_.each(op.children, function(child) {
			var odiv = lm.optionTemplate.clone();
			odiv.find('input').attr('id', lm.key + '-' + ii);
			odiv.find('label').html( htmlEncode( child.title ) );
			odiv.find('label').attr('for', lm.key + '-' + ii);
			odiv.data('option', child);

			var col = ii % 2 == 0 ? 'left' : 'right';
			oldiv.find('.usage-' + col).append( odiv );
			ii++;
		});
		oldiv.find('input').attr('name', lm.key);
		oldiv.find('input').on('change',  lm.selectOption );
		lm.div.find('.usage-list').append( oldiv );

		// if there's only one option, select it
		if (op.children.length == 1) {
			oldiv.find('input').trigger('click');
		}
	};

	this.selectOption = function() {
		var id = $j(this).attr('id');
		var checked = !!$j(this).filter(':checked').length;

		// what did we choose?
		var idA = id.split('-');
		idA.shift();
		var selection = [];
		var last = lm.profile.data;
		while (idA.length) {
			var key = idA.shift();
			var last = last.children[key];
			last.key = key;
			selection.push( last );
		}

		lm.selection = selection;

		console.log('- select', id, checked, last.title );

		lm.renderDetails();
		lm.div.find('.usage-choose').hide();
		lm.div.find('.usage-cart').hide();
		lm.div.find('.usage-unlogged').hide();
		lm.div.find('.usage-project-details').hide();

		if (last.children && last.children.length) {
			lm.div.find('.usage-choose').show();
		} else
		if (last.price != -1) {

			if (!user.logged) {
				const cartKey = lm.track.id + '-' + lm.profile.id + '-' + id.substr(2);
				const link = lm.buildShoppingCartLink(cartKey);

				lm.div.find('.usage-unlogged a').attr('href', link);
				return lm.div.find('.usage-unlogged').show();
			}

			if (lm.profile.data && config.licensingConfig.project_fields && config.licensingConfig.project_fields.length) {
				lm.div.find('.usage-project-details').show();
			} else {
				lm.div.find('.usage-cart').show();
			}
		} else {
			lm.div.find('.usage-cart').hide();
			lm.div.find('.usage-unlogged').hide();
			lm.div.find('.usage-project-details').hide();
		}
	};

	this.renderDetails = function() {
		// clear
		lm.div.find('#license-details').html('');

		if (!lm.selection || !lm.selection.length) return;

		_.each(lm.selection, function(d) {
			var ddiv = lm.detailItemTemplate.clone();
			ddiv.find('.detail-title').html( htmlEncode( d.title ) );
			if (d.description) {
				d.description = d.description.replace(/\\n/g, "\n")
				ddiv.find('.detail-text').html( htmlEncode( d.description ).replace(/\n/g, '<br/>') );
			} else {
				ddiv.find('.detail-text').hide();
			}

			if (d.price) {
				lm.div.find('#license-price').show();
				if (d.price == -2) {
					lm.div.find('#license-price .price-title').hide();
					lm.div.find('#license-price .price').html( '' );
				} else
				if (d.price == -1) {
					lm.div.find('#license-price .price-title').hide();
					
					if (lm.profile.data.hasOwnProperty('overrideUrl') && lm.profile.data.overrideUrl) {
						lm.div.find('#license-price .price').html( '<a href="'+ decodeURIComponent(lm.profile.data.overrideUrl)  +'" target="_blank">Contact Us</a>' );
						lm.div.find('#license-price .price a').css('color', 'white');
					} else {
						lm.div.find('#license-price .price').html( '<span>Contact Us</span>' );
						lm.div.find('#license-price .price').on('click', function() {
							var modal = new LicenseNowModal();
							modal.trackId = lm.trackId;
							modal.init();
						});
					}
					
					lm.div.find('#license-price .price').addClass('licensing-contact-us-button');
					
				} else {
					lm.div.find('#license-price .price').removeClass('licensing-contact-us-button');
					lm.div.find('#license-price .price-title').show();
					lm.div.find('#license-price .price').html( d.price.currencyFormat() );
				}
			} else {
				lm.div.find('#license-price').hide();
			}

			lm.div.find('#license-details').append( ddiv );
		});
	};

	this.chooseOption = function() {
		lm.div.find('.usage-choose').hide();
		lm.renderSelection();
	};

	this.fileFlyToCart = function(cb) {
		$j('body').append( lm.fileFly );
		lm.fileFly.show();

		lm.fileFly.css({top: lm.e.pageY - 10, left: lm.e.pageX - 10});
		var carto = $j('#shopping_cart.top_bar_button').offset();
		lm.fileFly.transition({top: carto.top, left: carto.left + 10}).transition({opacity: 0}, function() {
			$j(this).hide();
			cb();
		});
	};

	this.showProjectDetails = function() {
		lm.projectDetails = true;

		lm.div.find('.usage-title').html('Project Details');
		lm.div.find('.usage-list').hide();
		lm.div.find('.project-details').show();

		var it = lm.div.find('.project-detail.field-input').detach();
		var tt = lm.div.find('.project-detail.field-textarea').detach();

		_.each(config.licensingConfig.project_fields, function(f) {
			var fd = f.type == 'textarea' ? tt.clone() : it.clone();
			fd.find(f.type == 'textarea' ? f.type : 'input').attr('placeholder', f.name);
			fd.data('field', f);

			if (user.userData.licensing_uo && user.userData.licensing_uo.options.project_defaults) {
				var lastval = user.userData.licensing_uo.options.project_defaults[ f.name ];
				if (lastval) {
					console.log('- found default value in user options for', f.name, 'adding "' + lastval + '"');

					if (f.type == 'textarea') {
						fd.find('textarea').val( lastval );
					} else {
						fd.find('input').val( lastval );
					}
				}
			}

			lm.div.find('.project-details').append( fd );
		});

		lm.div.find('.usage-project-details').hide();
		lm.div.find('.usage-cart').show();
	};

	this.addToCart = function(e) {
		if (e) lm.e = e;
		if (!lm.demo) {
			// add to cart!
			lm.selection[0].agreement = lm.profile.data.agreement;

			var project = [];
			if (lm.projectDetails) {
				var error = false;
				lm.div.find('.project-detail').each(function() {
					var pf = $j(this).data('field');
					var f = {
						name: pf.name,
						type: pf.type,
						value: $j(this).find('input, textarea').val()
					};
					project.push(f);

					if (!f.value) error = true;
				});
				if (error) return sa.notify({ text : 'You must fill out all project fields.' });
			}

			// let's make sure we detect if the root had whitelisting
			if (lm.profile.data.whitelist) {
				lm.selection[0].whitelist = 1;
			}

			var item = {
				type: 'licensing',
				item_id: lm.track.id + '-' + lm.profile.id + '-' + lm.key,
				track_id: lm.track.id,
				track: lm.track,
				//profile: lm.profile,
				license: lm.selection,
				project: project,
				price: lm.selection[ lm.selection.length - 1].price,
				affiliate: sa._aff || null
			};
			console.log('- add to cart!', item);
			sa.components.shoppingCart.verbose = true;
			lm.fileFlyToCart(function() {
				sa.components.shoppingCart.addItem(item);
			});
		}
		lm.success = 1;

		lm.hide();
	};
}

var licensingModal = new LicensingModal();
/* eslint-disable no-unused-vars */
/**
 * Modal for previewing output from lyric extractor
 */

class LyricsModal {
	init() {
		// create the div on the body
		this.div = $j('<div class="lyrics-modal"></div>').appendTo('body');

		// bind the component to the div
		window.mountReactComponent(this.div[0], 'lyrics-modal', { trackId: this.trackId });
	}
}
/* eslint-disable no-unused-vars */
/**
 * Modal for previewing output from lyric extractor
 */

class AIPlaylistModal {
	init() {
		// create the div on the body
		this.div = $j('<div class="ai-playlist-modal"></div>').appendTo('body');

		// bind the component to the div
		window.mountReactComponent(this.div[0], 'ai-playlist-modal');
	}
}

function LicenseNowModal() {
	var modal = this;
	var templates = sa.templates.get('modal.licensenow');
	this.div = templates.get('modal');
	this.fb = null;
	this.trackId = null;

	this.init = function() {
		// is there an override url?
		if (config.licenseUrl) {
			let url = decodeURIComponent(config.licenseUrl);
			if (url.indexOf('http') === 0) {
				window.open(url);
			} else {
				window.location.href = url;
			}
			return;
		}

		sa.api.request({
			handler : 'contact',
			action : 'get-license-contact'
		}).then(function(licenseContact) {
			modal.div.find('.contactinfo').html( '<b>' + licenseContact.name + '</b> at <b>' + htmlEncode(licenseContact.phone || licenseContact.email.split(',')[0]) + '</b>' );
		});
		if (user) {
			modal.div.find('input[name=name]').val( user.userData.username );
			modal.div.find('input[name=email]').val( user.userData.email );
		}

		sa.forms.init(modal.div);

		modal.div.find('.cancel').on('click', function() { modal.close(); });
		modal.div.find('.submit').on('click', function() { modal.submit(); });

		modal.fb = new FocusBox(modal.div, { title : 'License Request Form' });
		modal.fb.show();
	};

	this.close = function() {
		modal.fb.hide();
	};

	this.submit = function() {

		var validationResults = sa.forms.validate(modal.div);
		if (validationResults.error) return;

		modal.fb.showLoader('Sending request');
		
		sa.api.request({
			handler: 'license-request',
			action: 'submitRequest',
			postData: {
				trackId: modal.trackId,
				name: validationResults.values.name,
				email: validationResults.values.email,
				phone: validationResults.values.phone,
				company: validationResults.values.company,
				comments: validationResults.values.comments
			}
		}).then(() => {
			modal.fb.hideLoader();
			sa.notify({ text : 'Request sent!' });
			modal.close();
		}).catch((err) => {
			modal.fb.hideLoader();
			modal.fb.showErrorMessage(err.message);
		});
	};
}

function contactUsLicenseModal(id) {
	var modal = new LicenseNowModal();
	modal.trackId = id;
	modal.init();
}
function HomemakerComponent() {
	const self = this;

	// these should ALL be set in the child class
	this.key = 'unknown';
	this.icon = 'fa-meh-o';
	this.title = 'Unknown';
	this.div = null; // version of component that appears in the actual home page

	/*
	 * Fills out the content of the div using the component item settings
	 */
	this.build = function (item) {};

	this.setDefaultValues = function (item, fields) {
		const results = createSafeObject();
		fields.forEach(field => {
			if (item.settings && item.settings.hasOwnProperty(field.name)) {
				results[field.name] = item.settings[field.name];
			} else {
				results[field.name] = field.fallbackValue;
			}
		});

		item.settings = results;

		return results;
	};

	this.handleComponentSave = function (settingsEl, item, fields, home, build) {
		settingsEl.find('.component-settings-save-btn').on('click', function () {
			// Check for a custom list of items and a mismatch between the number of items and the display count
			const displayCount = parseInt(settingsEl.find('.display-count-input').val());
			const itemCount = parseInt(settingsEl.find('#featured-items li').length);
			const customItemsEnabled = !settingsEl.find('#toggleCustomItems').prop('checked');

			if (displayCount < itemCount && customItemsEnabled) {
				item.settings.displayCount = itemCount;
			}

			fields.forEach(field => {
				let fieldValue = $j(this).closest('.component-settings-container').find(field.selector);

				if (field.saveFromPropertyName) {
					fieldValue = item.settings[field.propertyName];
				} else {
					switch (field.fieldType) {
						case 'text':
						case 'textarea':
							fieldValue = fieldValue.val().trim();
							fieldValue = StringSanitize.encodeIfNotEncoded(fieldValue);
							break;
						case 'number':
							fieldValue = parseInt(fieldValue.val());
							if (field.min && field.max) {
								if (fieldValue < field.min) {
									fieldValue = field.min;
								} else if (fieldValue > field.max) {
									fieldValue = field.max;
								}
							}
							break;
						case 'checkbox':
							fieldValue = fieldValue.prop('checked');

							// Handle alignment (non-bool) case
							if (field.propertyName === 'alignmentType') {
								fieldValue = fieldValue ? 'center' : 'left';
							}

							break;
						case 'select':
							fieldValue = fieldValue.val();
							break;
						default:
							fieldValue = fieldValue.val().trim();
							fieldValue = StringSanitize.encodeIfNotEncoded(fieldValue);
							break;
					}
				}

				fieldValue = field.valueType === 'number' ? parseInt(fieldValue) : fieldValue;

				if (!item.settings) {
					item.settings = createSafeObject();
				}

				if (field.fieldType === 'checkbox') {
					item.settings[field.propertyName] = fieldValue;
				} else {
					item.settings[field.propertyName] = fieldValue !== false ? fieldValue : field.fallbackValue;
				}
			});

			// Reset the featured items if we're in featured mode
			if (item.settings?.mode && item.settings.mode === 'featured') {
				item.settings.featuredItems = [];
			}

			home.reloadComponents(item, build);

			$j(this).closest('.component-settings-container').fadeOut(400, function () {
				$j(this).remove();
			});
		});

		return settingsEl;
	};

	this.buildSettingsFields = function (settingsEl, fieldsConfig) {
		let fields = [];
		fieldsConfig.fields.forEach(field => {
			switch (field.type) {
				case 'title':
					fields.push(this.componentTitleField(field.componentType));
					break;
				case 'displayCount':
					fields.push(this.componentDisplayCountField(field.componentType));
					break;
				case 'alignmentType':
					fields.push(this.itemAlignmentFields(field.componentType));
					break;
				case 'showComponentHeader':
					fields.push(this.componentShowHeaderField(field.componentType));
					break;
				case 'showItemDetails':
					fields.push(this.componentShowItemDetailsField(field.componentType));
					break;
				case 'customToggle':
					fields.push(this.componentCustomListToggle(field.componentType));
					break;
				case 'customSearch':
					fields.push(this.customSearchField());
					break;
				case 'mode':
					fields.push(this.itemsModeTypeDropdownField(field.componentType));
					break;
				case 'text':
					fields.push(this.componentTextblockField(field.componentType));
					break;
				case 'social':
					fields.push(this.componentSocialFields(field.componentType));
					break;
				case 'displayGrid':
					fields.push(this.componentDisplayAsGrid());
					break;
				case 'featuredPlaylistSelector':
					fields.push(this.featuredPlaylistSelector(field.componentType));
					break;
				default:
					return false;
			}
		});

		fields = $j(fields.join(''));

		settingsEl.find('.settings-form').append(fields);

		return $j(settingsEl).clone();
	};

	this.componentTitleField = function (componentType) {
		return `
			<div class="input-pair">
				<label for="${componentType}-title">Title</label>
				<input type="text" class="settings-input" id="${componentType}-title" placeholder="Title">
			</div>
		`;
	};

	this.componentDisplayCountField = function (componentType) {
		const placeholder = componentType.split('-').map(word => {
			return word[0].toUpperCase() + word.slice(1).toLowerCase();
		}).join(' ');
		return `
			<div class="input-pair">
				<label for="${componentType}-count">Display Count</label>
				<input type="number" min="1" class="settings-input display-count-input" id="${componentType}-count" placeholder="${placeholder} Display Count">
			</div>	
		`;
	};

	this.componentDisplayAsGrid = function () {
		return `
			<div class="input-pair">
				<label for="display-grid-tiles">Display as Grid</label>
				<input type="checkbox" id="display-grid-tiles">
			</div>
		`;
	};

	this.componentCustomListToggle = function (componentType) {
		return `
			<div class="input-pair" style="flex-direction: row;">
				<span class="text-options">Use Workspace Featured ${StringSanitize.ifEncodedDecode(componentType)}</span>
				<label class="home-page-editor-toggle editing-display-size-switch">
					<input type="checkbox" id="toggleCustomItems">
					<span class="editing-display-size-slider round"></span>
				</label>
			</div>
		`;
	};

	this.createLoadingElement = function (container) {
		const addLoadingBar = () => {
			container.append(`
				<div class="loading-bars-container">
					<div class="loading-bars"><div></div><div></div><div></div><div></div></div>
				</div>
			`);
		};

		const removeLoadingBar = () => {
			container.find('.loading-bars-container').remove();
		};

		return [addLoadingBar, removeLoadingBar];
	};

	this.componentTextblockField = function (componentType) {
		return `
			<div class="input-pair">
				<label for="${componentType}-text">Body</label>
				<textarea id="${componentType}-text"></textarea>
			</div>
		`;
	};

	this.componentShowHeaderField = function (componentType) {
		return `
			<div class="input-pair" style="flex-direction: row;">
				<span class="text-options">Show Component Header</span>
				<label class="home-page-editor-toggle editing-display-size-switch">
					<input type="checkbox" id="showComponentHeader">
					<span class="editing-display-size-slider round"></span>
				</label>
			</div>
		`;
	};

	this.componentShowItemDetailsField = function (componentType) {
		return `
			<div class="input-pair" style="flex-direction: row;">
				<span class="text-options">Show Item Details</span>
				<label class="home-page-editor-toggle editing-display-size-switch">
					<input type="checkbox" id="showItemDetails">
					<span class="editing-display-size-slider round"></span>
				</label>
			</div>
		`;
	};

	this.componentSocialFields = function () {
		return `
			<div class="input-pair">
				<label for="facebook-social-url">Facebook URL</label>
				<input type="text" class="settings-input" id="facebook-social-url" placeholder="https://www.facebook.com/pages/SourceAudio/158459084192047">
			</div>
			<div class="input-pair">
				<label for="twitter-social-name">Twitter Name</label>
				<input type="text" class="settings-input" id="twitter-social-name" placeholder="@sourceaudio">
			</div>
			<div class="input-pair">
				<label for="instagram-username">Instagram Username</label>
				<input type="text" class="settings-input" id="instagram-username" placeholder="@sourceaudio">
			</div>
			<div class="input-pair">
				<label for="mastodon-link">Mastodon Link</label>
				<input type="text" class="settings-input" id="mastodon-link" placeholder="https://example-mastodon-site.com/@sourceaudio">
			</div>
		`;
	};

	// Handle Component Alignment Fields
	this.itemAlignmentFields = function (componentType) {
		return `
			<div class="input-pair alignment-icons">
				<label for="left-align-items">${StringSanitize.ifEncodedDecode(componentType)} Alignment</label>
				<div style="display: flex; gap: 8px;">
					<input type="checkbox" class="settings-input" id="left-align-items" style="display: none;">
					<div class="component-alignment-icon">
						<i class="fa fa-align-left"></i>
					</div>
					<input type="checkbox" class="settings-input" id="center-align-items" style="display: none;">
					<div class="component-alignment-icon">
						<i class="fa fa-align-center"></i>
					</div>
				</div>
			</div>
		`;
	};

	this.handleAlignmentClickEvents = function (settingsEl) {
		settingsEl.find('.component-alignment-icon').on('click', function () {
			$j('.alignment-icons input[type="checkbox"]').prop('checked', false);
			const closestCheckbox = $j(this).prev('input[type="checkbox"]');
			if (closestCheckbox.prop('checked')) {
				closestCheckbox.prop('checked', false);
			} else {
				closestCheckbox.prop('checked', 'checked');
			}
		});

		return settingsEl;
	};

	this.handleComponentAlignmentFields = function (settingsEl, alignmentType) {
		settingsEl.find('.alignment-icons input[type="checkbox"]').prop('checked', false);
		if (alignmentType === 'left' || !alignmentType) {
			settingsEl.find('#left-align-items').prop('checked', 'checked');
		} else {
			settingsEl.find('#center-align-items').prop('checked', 'checked');
		}
	};

	// Handling Custom Search Fields
	this.buildSearchQuery = function (type, item, show) {
		// Is this a new component?
		const isNewComponent = item.isNew && item.isNew === true;
		const mode = item.settings.mode ? item.settings.mode : 'custom';
		const customSearchOn = isNewComponent || mode === 'custom';
		const isNewestItemMode = mode === 'newest';
		const specificItems = item.settings.featuredItems && item.settings.featuredItems.length ? item.settings.featuredItems.map(item => item.id) : [];
		let featuredOnly = (customSearchOn && specificItems.length) || isNewComponent ? '&featured=0' : '&featured=1';
		let newestItems = isNewestItemMode ? '&o=release_date' : '';
		const hcode = item.settings.hcode ? '&' + item.settings.hcode : '';

		// Is this a component that has never been edited?
		// Default to featured items for backward compatibility
		if (item.settings.neverEdited) {
			let featured = '&featured=1';
			// The fallback for playlists doesn't take a featured flag
			if (type === 'project_info') {
				featured = '&featured=1&featured_playlist_id=1';
				item.settings.featuredPlaylistId = 1;
				item.settings.mode = 'featured';
			}

			return `p=${type}${featured}&show=${show}${newestItems}${hcode}&homepage=1`;
		}

		// Don't re-run query if the custom search is on, but nothing has been specified
		if (!item.settings.neverEdited && (customSearchOn && !specificItems.length)) return false;

		let specificItemsUrlQuery;
		let featuredPlaylistId;
		switch (type) {
			case 'track_info':
			case 'album_info':
				specificItemsUrlQuery = specificItems.length ? '&specificItemIds=' + specificItems.join(',') : '';
				break;
			case 'catalog_info':
				specificItemsUrlQuery = specificItems.length ? '&specificItemIds=' + specificItems.join(',') : '';
				newestItems = '&o=join_date';
				break;
			case 'artist_info':
				specificItemsUrlQuery = specificItems.length ? '&specificItemIds=' + specificItems.join(',') : '';
				newestItems = '&o=artist_id';
				break;
			case 'label_info':
				specificItemsUrlQuery = specificItems.length ? '&specificItemIds=' + specificItems.join(',') : '';
				newestItems = '&o=label_id';
				break;
			case 'project_info':
				featuredPlaylistId = item.settings.featuredPlaylistId ? item.settings.featuredPlaylistId : '';

				if (customSearchOn && specificItems.length) {
					specificItemsUrlQuery = '&specificItemIds=' + specificItems.join(',');
				} else if (featuredPlaylistId && item.settings.mode === 'featured') {
					specificItemsUrlQuery = '&featured_playlist_id=' + featuredPlaylistId;
				} else {
					specificItemsUrlQuery = '';
					newestItems = '&o=publish_date';
				}

				break;
			case 'person_info':
				if (mode === 'custom') {
					const search = `&ids=${specificItems.join(',')}&t=writer`;
					specificItemsUrlQuery = customSearchOn ? search : '';
				} else if (mode === 'featured') {
					featuredOnly = '&featured=0';
					specificItemsUrlQuery = '';
				} else {
					specificItemsUrlQuery = '';
				}

				break;
			default:
				specificItemsUrlQuery = '';
		}

		if (item.settings.neverEdited) {
			featuredOnly = '&featured=1';
			specificItemsUrlQuery = '';
		}

		if (isNewestItemMode) {
			specificItemsUrlQuery = '';
			featuredOnly = '';
		}

		if (featuredOnly === '&featured=1' && type !== 'project_info') {
			specificItemsUrlQuery = '';
		}

		return `p=${type}${featuredOnly}&show=${show}${hcode}${specificItemsUrlQuery}${newestItems}&homepage=1`;
	};

	this.handleCustomSearchEvents = function (settingsEl, item, type) {
		settingsEl.find('.editing-display-size-switch #toggleCustomItems').on('change', function () {
			const customSearchOn = $j(this).prop('checked');
			if (!customSearchOn) {
				settingsEl.find('.custom-search-fields').show();
				settingsEl.find('.featured-playlist-selector').hide();
			} else {
				settingsEl.find('.custom-search-fields').hide();
				settingsEl.find('.featured-playlist-selector').show();
			}
		});

		let isSearching = false;
		settingsEl.find('#search-items').on('input', _.debounce(async function () {
			const searchValue = $j(this).val();

			if (!searchValue || searchValue.length < 1) {
				settingsEl.find('#custom-search-results').addClass('hidden');
				return;
			}

			if (isSearching) return;

			$j(this).closest('.custom-search-fields').addClass('loading-search-results');

			isSearching = true;
			let results = await self.customSearch(searchValue, type, item);
			isSearching = false;

			$j(this).closest('.custom-search-fields').removeClass('loading-search-results');

			if (!results.length) {
				settingsEl.find('#custom-search-results .items').html('No results found.');
				settingsEl.find('#custom-search-results').removeClass('hidden');

				// Set result count to zero
				$j('.custom-search-results-header .custom-search-results-count').text(0);
				return;
			}

			if (item.settings.featuredItems && item.settings.featuredItems.length) {
				results = results.filter(result => {
					return !item.settings.featuredItems.find(existingItem => {
						return parseInt(existingItem.id) === parseInt(result.id);
					});
				});
			}

			const list = $j('<ul>').append(results.map(result => {
				const name = StringSanitize.encodeIfNotEncoded(result.name);
				return `<li data-id="${result.id}" title="${name} (${result.id})">
							<div class="custom-list-item-grouping">
								<i class="fas fa-plus-square add-custom-item-to-list-icon"></i>
								${name}
							</div>
						</li>`;
			}).join(''));

			settingsEl.find('#custom-search-results .items').html(list);
			settingsEl.find('#custom-search-results').removeClass('hidden');

			// Tally up results
			$j('.custom-search-results-header .custom-search-results-count').text($j('#custom-search-results .items ul li').length);
		}, 500));

		// Handle selecting items from list
		settingsEl.find('#custom-search-results').on('click', '.items li', function () {
			const itemId = parseInt($j(this).attr('data-id'));
			const name = $j(this).text().trim();
			if (!item.settings.featuredItems) {
				item.settings.featuredItems = [{
					id: itemId,
					name: name
				}];
			} else {
				item.settings.featuredItems.push({
					id: itemId,
					name: name
				});
			}

			$j('#featured-items').removeClass('hidden');
			const clonedLi = $j(this).clone();
			clonedLi.attr('title', `${name} (${itemId})`);
			clonedLi.addClass('selected-track');
			clonedLi.append('<i class="featured-item-sort-handle fas fa-arrows"></i>');
			clonedLi.find('.custom-list-item-grouping').prepend('<i class="fas fa-minus-square remove-custom-item-from-list-icon"></i>');
			clonedLi.find('.add-custom-item-to-list-icon').remove();
			clonedLi.on('click', (e) => {
				e.preventDefault();
			});
			$j('#featured-items .items ul').append(clonedLi);

			$j(this).remove();

			// Tally count of featured items and results
			const featuredItemCount = $j('#featured-items .items ul li').length;
			$j('.featured-items-header .featured-items-count').text(featuredItemCount);
			$j('.component-settings-content .display-count-input').val(featuredItemCount);
			$j('.custom-search-results-header .custom-search-results-count').text($j('#custom-search-results .items ul li').length);

			// Check if any results remain
			if (settingsEl.find('#custom-search-results .items li').length === 0) {
				settingsEl.find('#custom-search-results').addClass('hidden');
			}
		});

		// Handle unselecting items from list
		settingsEl.find('#featured-items').on('click', '.items li .remove-custom-item-from-list-icon', function () {
			if ($j(this).closest('#featured-items ul').find('li').length === 1) {
				$j(this).closest('#featured-items').addClass('hidden');
			}

			const selectedItem = $j(this).closest('li');

			// Remove from featured items
			const id = parseInt(selectedItem.data('id'));
			item.settings.featuredItems = item.settings.featuredItems.filter(item => item.id !== id);

			// Add back to the list of results
			const clone = selectedItem.clone();
			clone.find('.featured-item-sort-handle').remove();
			clone.removeClass('selected-track');
			clone.find('.remove-custom-item-from-list-icon').removeClass().addClass('fas fa-plus-square add-custom-item-to-list-icon');
			$j('#custom-search-results .items ul').append(clone);

			if (settingsEl.find('#custom-search-results .items li').length > 0) {
				settingsEl.find('#custom-search-results').removeClass('hidden');
			}

			$j(this).closest('li').remove();

			// Tally count of featured items and results
			const featuredItemCount = $j('#featured-items .items ul li').length;
			$j('.featured-items-header .featured-items-count').text(featuredItemCount);
			$j('.component-settings-content .display-count-input').val(featuredItemCount);
			$j('.custom-search-results-header .custom-search-results-count').text($j('#custom-search-results .items ul li').length);
		});

		this.handleSortableItemResults(settingsEl, item);

		return settingsEl;
	};

	this.handleSortableItemResults = function (settingsEl, item) {
		Sortable.create(settingsEl.find('#featured-items ul')[0], {
			group: {
				name: 'featured-items',
			},
			draggable: 'li',
			handle: '.featured-item-sort-handle',
			onEnd: function (evt) {
				const { oldIndex, newIndex } = evt;

				item.settings.featuredItems.splice(newIndex, 0, item.settings.featuredItems.splice(oldIndex, 1)[0]);
			}
		});
	};

	this.itemsModeTypeDropdownField = function (componentType) {
		const sanitizedComponentType = StringSanitize.ifEncodedDecode(componentType);
		return `
			<div class="input-pair item-type-dropdown">
				<label for="add-tracks">${sanitizedComponentType} Display Items Mode</label>
				<select name="item-types" id="item-types">
					<option value="newest">Newest ${sanitizedComponentType}</option>
					<option value="featured">Workspace Featured ${sanitizedComponentType}</option>
					<option value="custom">Custom ${sanitizedComponentType} List</option>
				</select>
			</div>
		`;
	};

	this.handleItemModeDropdown = function (settingsEl, item) {
		const mode = item.settings.mode || 'custom';
		settingsEl.find('#item-types').val(mode);

		// Hide these sections initially
		settingsEl.find('.custom-search-fields').hide();
		settingsEl.find('.featured-playlist-selector').hide();

		if (mode === 'custom') {
			settingsEl.find('.custom-search-fields').show();
			settingsEl.find('.featured-playlist-selector').hide();
		} else if (mode === 'featured' && item.key === 'featplaylists') {
			settingsEl.find('.featured-playlist-selector').show();
		}
	};

	this.handleItemModeDropdownEvent = function (settingsEl, item) {
		settingsEl.find('#item-types').on('change', function () {
			const mode = $j(this).val();
			item.settings.mode = mode;
			console.log(item.settings.mode);
			console.log(item);

			// Hide these sections initially
			settingsEl.find('.custom-search-fields').hide();
			settingsEl.find('.featured-playlist-selector').hide();

			if (mode === 'custom') {
				settingsEl.find('.custom-search-fields').show();
				settingsEl.find('.featured-playlist-selector').hide();
			} else if (mode === 'featured' && item.key === 'featplaylists') {
				settingsEl.find('.featured-playlist-selector').show();
			}
		});
	};

	this.customPlaylistSearch = async function (searchQuery) {
		const resp = await sa.api.request({
			handler: 'features',
			action: 'searchPlaylists',
			postData: {
				type: 'playlists',
				search: searchQuery,
			}
		});

		if (resp && resp.result === 'success') {
			return resp.items;
		}

		return [];
	};

	this.customSearch = async function (searchQuery, type, item) {
		if (type === 'playlists') {
			return this.customPlaylistSearch(searchQuery);
		}

		const resp = await sa.api.request({
			handler: 'features',
			action: 'search',
			postData: {
				limit: 500,
				type: type || 'tracks',
				search: searchQuery
			}
		});

		if (resp && resp.result === 'success') {
			return resp.items;
		}

		return [];
	};

	this.customSearchField = function () {
		return `
			<div class="input-pair custom-search-fields" style="display: none;">
				<label for="add-tracks">Search</label>
				<div class="search-input-and-loader">
					<input type="text" class="settings-input" id="search-items" placeholder="Search">
					<i class="fa-duotone fa-spinner-third fa-spin custom-search-fields-loading-spinner"></i>
				</div>
				<div id="custom-search-results" class="hidden">
					<div class="custom-search-results-header">
						<h4>Results</h4>
						<div>
							Count: <span class="custom-search-results-count"></span>
						</div>
					</div>
					<div class="items"></div>
				</div>
				<div id="featured-items" class="hidden">
					<div class="featured-items-header">
						<h4>Selected Items</h4>
						<div>
							Count: <span class="featured-items-count"></span>
						</div>
					</div>
					<div class="items"><ul></ul></div>
				</div>
			</div>
		`;
	};

	this.featuredPlaylistSelector = function () {
		return `
			<div class="input-pair featured-playlist-selector" style="display: none;">
				<select name="featured-playlists" id="featured-playlists" class="settings-input">
				</select>
			</div>
		`;
	};

	// Featured Playlist Form Section
	this.loadFeaturedPlaylistData = async function (settingsDiv, item) {
		// Base template for this section
		const featuredPlaylistsTemplate = settingsDiv.find('.featured-playlist-selector');

		// Figure out if the selector should be shown or not
		const featuredToggledOn = item.settings.customSearchToggle;
		if (featuredToggledOn) {
			settingsDiv.find('.featured-playlist-selector').show();
		} else {
			settingsDiv.find('.featured-playlist-selector').hide();
		}

		// Check if there is an already selected featured playlist
		const currentlyFeaturedPlaylist = item.settings.featuredPlaylistId ? item.settings.featuredPlaylistId : null;

		// Load the data
		const resp = await sa.api.request({
			handler: 'features',
			action: 'featuredPlaylists',
			postData: {
				type: 'playlists'
			}
		});

		const availableFeaturedPlaylists = resp && resp.result === 'success' ? resp.items : [];

		// Build out the elements for this section
		if (!availableFeaturedPlaylists.length) {
			featuredPlaylistsTemplate.html('<p>No featured playlists found.</p>');
		} else {
			featuredPlaylistsTemplate.find('select').append('<option value="-1">Select a playlist</option>');
			featuredPlaylistsTemplate.find('select').append(availableFeaturedPlaylists.map(playlist => {
				return `<option value="${playlist.id}" ${currentlyFeaturedPlaylist === parseInt(playlist.id) ? 'selected' : ''}>${StringSanitize.ifEncodedDecode(playlist.name)}</option>`;
			}).join(''));
		}
	};

	this.createComponentMessage = function (response, item, typeContainer, typeName, component) {
		const noResults = response.length <= 1;
		const isFeaturedMode = item.settings.customSearchToggle || item.settings?.mode === 'featured';
		const isCustomMode = !item.settings.customSearchToggle || item.settings.mode === 'custom';
		const hasPermissions = user.isSiteOwner() || user.hasAdminPermission(AdminPermission.CustomPages);
		const type = component.title.toLowerCase();

		if (noResults && isFeaturedMode && hasPermissions) {
			if (hasPermissions) {
				item.div.find('.get-started-component-text').remove();

				if (component.key === 'featplaylists') {
					item.div.find('.component-body').html(`<span class="get-started-component-text">You haven't selected your featured ${StringSanitize.ifEncodedDecode(type.replace(/s$/, ''))} yet</span>`);
				} else {
					item.div.find('.component-body').html(`<span class="get-started-component-text">You don't have any featured ${StringSanitize.ifEncodedDecode(type)} yet</span>`);
				}

				return false;
			}
		} else if (noResults && isCustomMode && hasPermissions) {
			item.div.find('.get-started-component-text').remove();
			item.div.find('.component-body').html(`<span class="get-started-component-text">You haven't added any custom ${StringSanitize.ifEncodedDecode(type)} yet</span>`);
			return false;
		} else if (!noResults) {
			item.div.find('.get-started-component-text').remove();
			typeContainer.show();
			return true;
		} else {
			item.div.find('.get-started-component-text').remove();
			item.div.find('.component-body').html(`<span class="get-started-component-text">No ${StringSanitize.ifEncodedDecode(type)} available yet.</span>`);
			return false;
		}

		return true;
	};

	this.handleComponentHeaderDisplay = function (item) {
		if (item.settings && item.settings.showComponentHeader === false) {
			item.div.find('.component-header').hide();
			item.div.addClass('component-no-header');
		} else {
			item.div.find('.component-header').show();
			item.div.removeClass('component-no-header');
		}
	};

	this.handleComponentHeaderToggle = function (settingsDiv, item) {
		if (item.settings.showComponentHeader === false) {
			settingsDiv.find('#showComponentHeader').attr('checked', false);
		} else {
			settingsDiv.find('#showComponentHeader').attr('checked', true);
		}

		settingsDiv.find('.editing-display-size-switch #showComponentHeader').on('change', function () {
			const headerHidden = !$j(this).prop('checked');
			if (headerHidden) {
				item.div.find('.component-header').hide();
				item.div.addClass('component-no-header');
			} else {
				item.div.find('.component-header').show();
				item.div.removeClass('component-no-header');
			}
		});
	};

	this.handleShowItemDetails = function (settingsDiv, item) {
		if (item.settings.showItemDetails === false) {
			settingsDiv.find('#showItemDetails').attr('checked', false);
		} else {
			settingsDiv.find('#showItemDetails').attr('checked', true);
		}

		settingsDiv.find('.editing-display-size-switch #showItemDetails').on('change', function () {
			const headerHidden = !$j(this).prop('checked');
			if (headerHidden) {
				item.div.find('.item-detail').hide();
			} else {
				item.div.find('.item-detail').show();
			}
		});
	};

	this.showHideItemDetails = function (container, item) {
		if (item.settings.showItemDetails) {
			container.find('.info .item-detail').show();
		} else {
			container.find('.info .item-detail').hide();
		}
	};

	this.handleCustomSearchFields = function (settingsEl, featuredItems, item) {
		// Show featured items if they exist
		if (featuredItems && featuredItems.length) {
			settingsEl.find('.custom-search-fields #featured-items').removeClass('hidden');
			featuredItems.forEach(item => {
				const name = StringSanitize.encodeIfNotEncoded(item.name);
				const listItem = $j(`<li data-id="${item.id}" class="selected-track" title="${name} (${item.id})">
							<div class="custom-list-item-grouping">
								<i class="fas fa-minus-square remove-custom-item-from-list-icon"></i>
								${name}
							</div>
							<i class="featured-item-sort-handle fas fa-arrows"></i>
						</li>`);
				settingsEl.find('.custom-search-fields #featured-items .items ul').append(listItem);
			});

			settingsEl.find('.custom-search-fields .featured-items-count').text(featuredItems.length);

			this.handleSortableItemResults(settingsEl, item);
		}
	};

	this.configureItemsPerRow = function (container) {
		const isLeftSide = container.closest('.sortable-section').hasClass('left-column');
		const isFullSize = container.closest('.sortable-section').hasClass('homepage-wide-column');
		
		// check if the container has "space-out" for centered items
		const childrenCount = container.children().length;
		
		// If the total window width < 1081px then set all the boxes to 180px
		// If the total window width < 770px then set all the boxes to 130px
		let leftBoxSize = 190;
		let rightBoxSize = 130;
		if (document.body.getBoundingClientRect().width < 1081) {
			leftBoxSize = 180;
			rightBoxSize = 180;
		} else if (document.body.getBoundingClientRect().width < 770) {
			leftBoxSize = 130;
			rightBoxSize = 130;
		}
		
		// Dynamically set a css variable for the box size
		// Set how many child elements there are on the container
		// container.closest('.component').css({
		// 	'--box-size': (isLeftSide || isFullSize ? leftBoxSize : rightBoxSize) + 'px',
		// 	'--children-count': childrenCount
		// });

		return container;
	};

	this.sortFeaturedItems = function (data, { mode, featuredItems }) {
		const featuredItemData = Array.isArray(data) ? data.splice(1) : [];

		// If the mode is featured, sort by the order of the featured items
		if (featuredItemData.length && mode === 'featured') {
			featuredItemData.sort((a, b) => b.featured - a.featured);
			return featuredItemData;
		}

		if (featuredItems && featuredItems.length > 0) {
			const featuredItemIds = featuredItems.map(item => item.id);
			featuredItemData.sort((a, b) => {
				return featuredItemIds.indexOf(a.id) - featuredItemIds.indexOf(b.id);
			});
		}

		return featuredItemData;
	};

	/**
	 * Get the mode of the item (custom or featured) for backward compatability
	 *
	 * @param item
	 * @returns {string}
	 */
	this.getItemMode = function (item) {
		if (item.settings.hasOwnProperty('customSearchToggle')) {
			return !item.settings.customSearchToggle ? 'custom' : 'featured';
		}

		return 'custom';
	};
}
function HomemakerCarousel() {
	const self = this;
	const templates = sa.templates.get('homemaker.carousel');

	this.key = 'carousel';
	this.icon = 'fa-picture-o';
	this.title = 'Carousel';
	this.homemaker = null;
	this.sliderInstances = [];
	
	this.events = [];
	
	this.div = templates.get('carousel_component');
	this.settings = null;
	this.settingsDiv = templates.get('settings_div');

	this.build = function (item, home) {
		if (BrowserDetect.isIE8down) {
			item.div.hide();
			return;
		}

		const defaultSettings = {
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('customSearchToggle'))
		};
		item.settings = { ...defaultSettings, ...item.settings };
		
		if (!item.div.find('#slider').length) {
			item.div.find('.component-body').append(`
				<div class="slider-wrapper theme-default">
					<div id="slider"></div>
				</div>
			`);
		}

		const carouselIsActive = item.settings && item.settings.items && item.settings.items.length;
		
		const carousel = item.div.find('.carousel-container');
		
		carousel.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title));

		if (item.settings && item.settings.showComponentHeader) {
			item.div.find('.component-header').hide();
			item.div.addClass('component-no-header');
		} else {
			item.div.find('.component-header').show();
			item.div.removeClass('component-no-header');
		}
		
		if (item.settings.neverEdited) {
			item.settings.bgTransparent = true;
		}

		if (item.type === 'wide' && item.settings.bg && !item.settings.bgTransparent) {
			if (item.settings.bg.charAt(0) !== '#') item.settings.bg = '#' + item.settings.bg;
			item.div.prepend('<div class="carousel-bg"></div>');
			item.div.find('.carousel-bg').css({
				background: item.settings.bg,
				display: 'block'
			});
		} else {
			item.div.find('.carousel-bg').remove();
		}

		if (!carouselIsActive) {
			item.div.remove();
			
			// Find the carousel and remove from the layout
			home.removeComponentFromLayout(item.uuid);
		} else {
			loadScript(ExtraScripts.slickSlider, () => {
				const count = HomemakerCarousel.sliderNumber++;
								
				const slider = carousel.find('#slider');
				
				// Loop through slides
				for (let i = 0; i < item.settings.items.length; i++) {
					const slide = item.settings.items[i];

					const urlStartsWithHttp = slide.url.indexOf('http') === 0;
					const urlStartsWithSlash = slide.url.indexOf('/') === 0;
					const lockdownAndNoFullUrl = lockdown && (!slide.url || !urlStartsWithHttp);

					let slideUrl = '';
					if (!slide.url) {
						slideUrl = '#0';
					} else if (slide.url && urlStartsWithHttp) {
						slideUrl = slide.url;
					} else if ((slide.url && urlStartsWithSlash) || slide.url.includes('#!')) {
						slideUrl = sa.router.buildFullUrl(slide.url);
						slideUrl.pathname = sa.router.addDevFragment(slideUrl.pathname);
						slideUrl = slideUrl.href;
					} else {
						slideUrl = '#0';
					}

					// add the item
					const sliderItem = templates.get('carousel_item', {
						href: lockdownAndNoFullUrl ? '#0' : StringSanitize.encodeIfNotEncoded(slideUrl),
						id: `carousel_${count}_${i}`,
						heading: StringSanitize.encodeIfNotEncoded(slide.heading),
						subheading: StringSanitize.encodeIfNotEncoded(slide.subheading),
					});
					
					sliderItem.on('click', function () {
						// Check if we're in editing mode
						const currentPageParams = (new URL(window.location.href)).searchParams;
						if (currentPageParams.has('editMode')) {
							$j(this).attr('href', '#0');
						}
					});

					if (slide.heading.trim() === '' && slide.subheading.trim() === '') {
						sliderItem.find('div[id^="carousel_"]').css('opacity', 0);
						sliderItem.find('img').attr('title', '');
					}
					
					sliderItem.find('img').attr('src', slide.image);
					
					if (slide.title) {
						slider.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(slide.title));
					}
					
					slider.append(sliderItem);
				}
				
				let pauseTime = item.settings.pauseTime ? parseInt(item.settings.pauseTime) : 7;
				
				if (Number.isNaN(pauseTime)) pauseTime = 7;
				
				// Due to all the things being loaded on the page, the slider isn't quite finishing the render
				// unless it's initialization is deferred just slightly.
				const slickSettings = {
					autoplaySpeed: pauseTime * 1000,
					autoplay: true,
					useTransform: false
				};
				
				setTimeout(() => {
					self.sliderInstances.push(slider.slick(slickSettings));

					self.sliderInstances.forEach(slider => {
						slider.slick('setPosition').slick('setDimensions');
					});
				}, 100);
				
				const eventController = registerEventAbortController('homepage');
				
				const resizeEvent = _.debounce(() => {
					if (BrowserDetect.isTouchDevice) return;
					self.sliderInstances.forEach(slider => {
						slider.slick('setPosition').slick('setDimensions');
					});
				}, 500);
				
				const orientationChangeEvent = _.debounce(() => {
					self.sliderInstances.forEach(slider => {
						slider.slick('setPosition').slick('setDimensions');
					});
				}, 500);
				
				window.addEventListener('resize', resizeEvent, { signal: eventController.signal });
				window.addEventListener('orientationchange', orientationChangeEvent, { signal: eventController.signal });
				
				$j('#preview-home-page-btn').on('click', () => {
					self.sliderInstances.forEach(slider => {
						slider.slick('setPosition').slick('setDimensions');
					});
				});
			});
		}
	};

	this.showSettings = function (item, home) {
		if (!item.settings) {
			item.settings = {
				title: 'Featured Music & Updates',
				items: [],
				bg: null,
				pauseTime: 7
			};
		}
		self.settings = item.settings;
		
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));

		// Create the Input Fields / Settings Fields
		const inputFields = $j(`
			<div class="input-pair">
				<label for="carousel-title-field">Title:</label>
				<input type="text" class="settings-input" id="carousel-title-field" placeholder="Featured Music & Updates">
				<small>This appears above the carousel at all times</small>
			</div>
			<div class="input-pair">
				<label for="carousel-background-color">Background Color</label>
				<div class="component-fields-inline">
					<input type="text" class="settings-input" id="carousel-background-color" placeholder="ffffff">
					<input type="color" id="carousel-background-color-picker">
					<input type="checkbox" name="carousel-background-transparent" id="carousel-background-transparent">
					<label for="carousel-background-transparent">transparent</label>
				</div>
				
				<small>This only appears for full-width carousels.</small>
			</div>
			<div class="input-pair">
				<label for="carousel-display-time">Display Time:</label>
				<input type="text" class="settings-input" id="carousel-display-time" placeholder="7">
				<small>The carousel will cycle every this many seconds.</small>
			</div>
			<div class="input-pair" style="flex-direction: row;">
				<span class="text-options">Hide Component Header</span>
				<label class="home-page-editor-toggle editing-display-size-switch">
					<input type="checkbox" id="showComponentHeader">
					<span class="editing-display-size-slider round"></span>
				</label>
			</div>
			<div class="input-pair">
				<label>Carousel Items</label>
				<div class="carousel-items-list"></div>
				<button class="carousel-add-item">+ add new carousel item</button>
			</div>
		`);
		
		// Set existing values if they exist
		inputFields.find('#carousel-title-field').val(StringSanitize.ifEncodedDecode(item.settings.title) || '');
		inputFields.find('#carousel-background-color').val(item.settings.bg || '#FFFFFF');
		inputFields.find('#carousel-background-color-picker').val(item.settings.bg || '#FFFFFF');
		
		if (item.settings.showComponentHeader) {
			inputFields.find('#showComponentHeader').attr('checked', true);
		} else {
			inputFields.find('#showComponentHeader').attr('checked', false);
		}
		
		if (item.settings.bgTransparent || typeof item.settings.bgTransparent === 'undefined') {
			inputFields.find('#carousel-background-transparent').attr('checked', true);
		} else {
			inputFields.find('#carousel-background-transparent').attr('checked', false);
		}
		
		inputFields.find('#carousel-display-time').val(item.settings.pauseTime || 7);
		
		// Loop through any existing carousel entries and add them to the list
		if (item.settings && item.settings.items) {
			item.settings.items.forEach(carouselItem => {
				const carouselItemClone = self.buildCarouselListItem(carouselItem);
				// Add carousel item to the list
				inputFields.find('.carousel-items-list').append(carouselItemClone);
			});
		}

		// Add input fields to the main template
		componentSettings.find('.settings-form').append(inputFields);

		// Clone the component settings template
		const settingsDiv = $j(componentSettings).clone();
		
		// Add event listeners
		settingsDiv.find('#carousel-background-color-picker').on('change, input', function () {
			const colorHex = $j(this).val();
			settingsDiv.find('#carousel-background-color').val(colorHex);
		});

		// Edit Existing Carousel Item
		settingsDiv.find('.carousel-items-list').on('click', '.edit-carousel-item .carousel-action-btn', function () {
			const carouselItemId = $j(this).closest('.carousel-item').attr('id');
			const carouselItemInfo = item.settings.items.find(carouselItem => carouselItem.id === carouselItemId);
			self.buildOrCreateCarouselItem(item, carouselItemInfo, true);
		});

		// Delete Existing Carousel Item
		settingsDiv.find('.carousel-items-list').on('click', '.delete-carousel-item .carousel-action-btn', function () {
			const carouselItemId = $j(this).closest('.carousel-item').attr('id');
			
			item.settings.items = item.settings.items.filter(carouselItem => carouselItem.id !== carouselItemId);
			
			$j(this).closest('.carousel-item').remove();
		});

		// Add New Carousel Item
		settingsDiv.find('.carousel-add-item').on('click', function () {
			self.buildOrCreateCarouselItem(item);
		});
		
		function saveCarousel(item, settingsDiv, home) {
			const carouselBgTransparent = settingsDiv.find('#carousel-background-transparent').prop('checked');

			item.settings.title = settingsDiv.find('#carousel-title-field').val();
			item.settings.pauseTime = settingsDiv.find('#carousel-display-time').val();

			const componentHeaderShown = settingsDiv.find('#showComponentHeader').prop('checked');
			item.settings.showComponentHeader = componentHeaderShown;

			if (carouselBgTransparent) {
				item.settings.bgTransparent = true;
			} else {
				item.settings.bg = settingsDiv.find('#carousel-background-color').val() || item.settings.bg;
				item.settings.bgTransparent = false;
			}

			item.settings.neverEdited = false;

			home.reloadComponents(item, self.build);

			settingsDiv.fadeOut(400, () => {
				settingsDiv.remove();
			});
		}
		
		settingsDiv.find('.component-settings-content .component-settings-save-btn').on('click', function () {
			// If there are no carousel items, alert the user to make sure they want to save and inform them the component will be removed.
			if (item.settings.items.length === 0) {
				sa.confirm({
					title: 'No Carousel Items',
					text: 'There are no carousel items. If you save, this component will be removed from the page. Are you sure you want to save?',
					noFunction: () => {
						return false;
					},
					yesFunction: () => {
						saveCarousel(item, settingsDiv, home);
					}
				});
				
				return;
			}
			
			saveCarousel(item, settingsDiv, home);
		});

		// Add the settings elements / modal to the page
		$j('body').append(settingsDiv);

		const sortableCarouselItems = [...document.querySelectorAll('.carousel-items-list')];
		sortableCarouselItems.forEach(carouselItemsList => {
			Sortable.create(carouselItemsList, {
				group: {
					name: 'carousel-items'
				},
				draggable: '.carousel-item',
				handle: '.draggable-bar',
				onEnd: function (evt) {
					const { oldIndex, newIndex } = evt;
					self.settings.items.splice(newIndex, 0, self.settings.items.splice(oldIndex, 1)[0]);

					self.renderCarouselOptions(true);
				}
			});
		});

		settingsDiv.fadeIn();
	};
	
	this.renderCarouselOptions = function (wasEdit = false) {
		if (!self.settings.items) return;
		
		// Remove existing carousel items
		$j('.carousel-item').remove();
		
		const carouselItemList = $j('.carousel-items-list');
		
		if (wasEdit) {
			self.settings.items.sort((a, b) => {
				return b.id - a.id;
			});
		}
		
		// Add 'em all back
		self.settings.items.forEach((item, index) => {
			item.id = `item_${index}`;
			const carouselItem = self.buildCarouselListItem(item);
			carouselItemList.append(carouselItem);
		});
	};
	
	this.buildCarouselListItem = function (carouselItem) {
		// Carousel Item Template
		const carouselItemTemplate = $j(`
			<div class="carousel-item">
				<div class="draggable-bar"></div>
				<div class="carousel-item-thumbnail"></div>
				<div class="carousel-item-info">
					<div class="carousel-item-heading">
						<span class="carousel-item-field-type">Heading: </span>
						<span class="carousel-item-field-value"></span>
					</div>
					<div class="carousel-item-description">
						<span class="carousel-item-field-type">Description: </span>
						<span class="carousel-item-field-value"></span>
					</div>
					<div class="carousel-item-url">
						<span class="carousel-item-field-type">Click URL: </span>
						<span class="carousel-item-field-value"></span>
					</div>
				</div>
				<div class="carousel-item-options">
					<span class="edit-carousel-item">
						<button class="carousel-action-btn"><i class="fa fa-edit"></i> Edit</button>
					</span>
					<span class="delete-carousel-item">
						<button class="carousel-action-btn"><i class="fa fa-times"></i> Delete</button>
					</span>
				</div>
			</div>
		`);
		
		const carouselItemClone = carouselItemTemplate.clone();
		const image = carouselItem.image
			? $j(`<img src='${carouselItem.image}' alt="${StringSanitize.encodeIfNotEncoded(carouselItem.heading)}" height="50" />`)
			: '';

		carouselItemClone.attr('id', carouselItem.id);
		carouselItemClone.find('.carousel-item-thumbnail').append(image);
		carouselItemClone.find('.carousel-item-heading .carousel-item-field-value').html(StringSanitize.encodeIfNotEncoded(carouselItem.heading));
		carouselItemClone.find('.carousel-item-description .carousel-item-field-value').html(StringSanitize.encodeIfNotEncoded(carouselItem.subheading));
		carouselItemClone.find('.carousel-item-url .carousel-item-field-value').html(StringSanitize.encodeIfNotEncoded(carouselItem.url));
		
		return carouselItemClone;
	};
	
	this.buildOrCreateCarouselItem = function (item, carouselItemInfo = {}, isEditingMode = false) {		
		// Set some defaults for a new carousel item
		let carouselItemOptions = {
			heading: 'Your heading here',
			subheading: 'Description Goes Here',
			image: 'images/home/default-carousel.jpg',
			url: '/'
		};
		
		// Merge options if we've got 'em
		carouselItemOptions = Object.assign(carouselItemOptions, carouselItemInfo);

		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: 'carousel-edit-add',
			componentSettingsTitle: isEditingMode ? `Edit ${this.title} Item` : `Create ${this.title} Item`
		}));
		
		carouselItemOptions.heading = StringSanitize.encodeIfNotEncoded(carouselItemOptions.heading);
		carouselItemOptions.subheading = StringSanitize.encodeIfNotEncoded(carouselItemOptions.subheading);
		carouselItemOptions.url = StringSanitize.encodeIfNotEncoded(carouselItemOptions.url);
		
		const headingForInput = StringSanitize.forInputField(carouselItemOptions.heading).replace('"', '');

		// Create the Input Fields / Settings Fields
		const inputFields = $j(`
			<div class="carousel-item-preview">
				<label>Preview</label>
				<a href='#0' class="preview-carousel-link">
					<div class="preview-container">
						<div class="preview-container-title">Preview Title</div>
						<img id="preview-container-image" src="${carouselItemOptions.image}" alt="${headingForInput}" />
						<div class="preview-container-bottom-banner">
							<span class="heading">${carouselItemOptions.heading}</span>
							<span class="description">${carouselItemOptions.subheading}</span>
						</div>
					</div>
				</a>
			</div>
			<div class="input-pair">
				<label for="carousel-heading-field">Heading</label>
				<input type="text" class="settings-input" id="carousel-heading-field" placeholder="${headingForInput}" value="${headingForInput}">
				<small>(max 90 characters)</small>
			</div>
			<div class="input-pair">
				<label for="carousel-description-field">Description</label>
				<textarea class="settings-input" id="carousel-description-field">${carouselItemOptions.subheading}</textarea>
			</div>
			<div class="input-pair">
				<label for="carousel-image-field">Image</label>
				<a class="button file_upload_container" id="carousel-image-field" style="padding-inline: 10px;">Browse</a>
				<small>Should be 1600x900. Will be resized to those dimensions if it isn't.</small>
			</div>
			<div class="input-pair">
				<label for="carousel-url-field">Click URL</label>
				<input type="text" class="settings-input" id="carousel-url-field" placeholder="${carouselItemOptions.url}" value="${carouselItemOptions.url}">
				<small>where should the user go when they click the slide?</small>
			</div>
		`);
		
		componentSettings.find('.settings-form').append(inputFields);
		componentSettings.find('.component-settings-save-btn').text('Save Component');
		
		const carouselItemDiv = $j(componentSettings).clone();
		
		// Link/URL typing event listener
		carouselItemDiv.find('#carousel-url-field').on('keyup', function () {
			const url = $j(this).val();
			carouselItemDiv.find('.preview-carousel-link').attr('href', url);
			carouselItemOptions.url = url;
		});
		
		// Heading typing event listener
		carouselItemDiv.find('#carousel-heading-field').on('keyup', function () {
			const heading = $j(this).val();
			carouselItemDiv.find('.carousel-item-preview .heading').text(heading);
			carouselItemOptions.heading = heading;
		});

		// Description typing event listener
		carouselItemDiv.find('#carousel-description-field').on('keyup', function () {
			const description = $j(this).val();
			carouselItemDiv.find('.carousel-item-preview .description').text(description);
			carouselItemOptions.subheading = description;
		});
		
		// Configure the Image Uploader
		const uploadButton = carouselItemDiv.find('#carousel-image-field');
		self.configureImageUploader(uploadButton, carouselItemDiv, carouselItemOptions);
		
		// Save Carousel Item Event Listener
		carouselItemDiv.find('.component-settings-save-btn').on('click', function () {
			if (item.settings) {
				item.settings.items = item.settings.items || [];
				
				if (isEditingMode) {
					item.settings.items = item.settings.items.map(carouselItem => {
						if (carouselItem.id === carouselItemOptions.id) {
							return carouselItemOptions;
						}
						
						return carouselItem;
					});
				} else {
					// Assign an id to the newly created element based on the previous 
					let lastId;
					if (item.settings.items.length) {
						lastId = item.settings.items.at(-1);
						lastId = lastId.id ? parseInt(lastId.id.split('_')[1]) : 0;
					} else {
						lastId = 0;
					}
					
					carouselItemOptions.id = lastId + 1;
					
					item.settings.items.push(carouselItemOptions);
				}
				
				self.renderCarouselOptions(isEditingMode);
				
				carouselItemDiv.fadeOut(400, function () {
					carouselItemDiv.remove();
				});
			}
		});
		
		$j('body').append(carouselItemDiv);

		carouselItemDiv.fadeIn();
	};
	
	this.configureImageUploader = function (uploadButton, carouselItemContainer, carouselItemOptions) {
		// create the uploader so they can add a new image
		return new Uploader({
			button: uploadButton[0],
			browseCallback: function (uploaderInstance) { // after selecting an image
				const fileList = uploaderInstance.getFiles();
				const key = new Date().getTime();

				if (fileList && fileList.length === 1) {
					// auto-upload
					uploadButton.html('Uploading...');
					uploaderInstance.upload({
						params: 'u=' + user.userData.id + '&t=homemaker&key=' + key + '&source=carousel',
						complete: function () { // success function
							const newPath = 'https://sourceaudio-images.s3.amazonaws.com/user_data/' + user.userData.id + '/' + user.userData.id + '-' + key + '.jpg';
							carouselItemContainer.find('#preview-container-image').attr('src', newPath);
							carouselItemOptions.image = newPath;
							// let them upload again
							uploadButton.html('Browse');
						},
						error: function (e) { // error function
							uploadButton.html('Browse');
						}
					});
				}
			},
			fileType: UploaderConstants.IMAGES
		});	
	};

	this.hideSettings = function () {
		$j('#carousel-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerCarousel.sliderNumber = 0;

HomemakerCarousel.prototype = new HomemakerComponent();
function HomemakerTextBlock() {
	const self = this;

	this.saveTextContent = null;
	this.key = 'text-block';
	this.icon = 'fa-font';
	this.title = 'Text Block';

	this.div = $j(`
		<div class="textblock-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3 class="textblock-title">Text Block Title</h3>
			</div>
			<div class="component-body">
				<div class="textblock-text">Text</div>
			</div>
		</div>'
	`);

	this.settings = null;
	
	this.build = function (item) {
		const defaultSettings = {
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('customSearchToggle'))
		};
		item.settings = { ...defaultSettings, ...item.settings };
		
		if (!item.settings.title) {
			item.settings.showComponentHeader = false;
		}
		
		if (item.settings.title) {
			const hasH3 = item.div.find('.component-header').find('h3').length;
			if (hasH3) {
				item.div.find('.component-header').find('h3').text(StringSanitize.ifEncodedDecode(item.settings.title));
			} else {
				item.div.find('.component-header').append(`<h3 class="textblock-title">${sanitizeHtml(item.settings.title)}</h3>`);
			}
		}

		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		if (!item.div.find('.textblock-text').length) {
			item.div.find('.component-body').append('<div class="textblock-text">Text</div>');
		}
		
		const textBlockContent = item.settings.text ? cleanCkeditorOutput(item.settings.text.replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"')) : '';
		item.div.find('.component-body').find('.textblock-text')[0].innerHTML = textBlockContent || 'Click the edit button to get started.';
	};

	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: 'Text Block Settings'
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'textblock' },
				{ type: 'showComponentHeader', componentType: 'featured-writers' },
				{ type: 'text', componentType: 'textblock' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, text } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: '' },
			{ name: 'text', fallbackValue: '' },
			{ name: 'showComponentHeader', fallbackValue: false },
		]);

		// Set the values into the inputs
		settingsDiv.find('#textblock-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#textblock-text').val(item.settings.text ? cleanCkeditorOutput(item.settings.text, true) : '');

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#textblock-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#textblock-text', propertyName: 'text', valueType: 'text', fieldType: 'textarea', fallbackValue: '', saveFromPropertyName: true },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
		], home, self.build);

		$j('body').append(settingsDiv);
		
		showWysiwygEditor('#textblock-text', {}, function(newContent) { item.settings.text = newContent; });
		
		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#textblock-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerTextBlock.prototype = new HomemakerComponent();

function HomemakerAlbums() {
	const self = this;

	this.key = 'albums';
	this.icon = 'fa-compact-disc';
	this.title = 'Albums';

	this.div = $j('<div class="featalbums-component droppable-item art-component component"><h3>Albums</h3></div>');

	this.settings = null;
	
	this.build = function(item) {

		item.div.addClass(item.type);

		var show = (item.type == 'right') ? 3 : 5;

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();
		
		ajax('p=album_info&featured=1&show=' + show, function(response) {
			item.div.append('<div class="album_container"></div>');
			var albumContainer = item.div.find('.album_container');

			removeLoadingBar();
			
			if (response.length == 1) {
				return albumContainer.addClass('empty').html('No featured '+ config.getDictionaryEntry('album', true, true) +' yet');
			}

			var displayOptions = {
				hovers : false,
				showCatalog : false,
				showArtist : false,
				showCode : false,
				showReleaseDate : false,
				showing : true
			};
			if (item.type != 'wide') {
				displayOptions.size = 'small';
			}
			for (var i = 1, len = response.length; i < len; i++) {
				albumContainer.append((new Album(response[i])).generateArtElement(displayOptions));
			}

			if (lockdown) {
				sa.lockdownLinks(albumContainer.find('a'));
			}
		});
	};

	this.showSettings = function(item) {
		const div = self.settingsDiv.clone();
		$j('body').append(div);
		
		div.fadeIn();
	};

	this.hideSettings = function() {
		$j('#albums-component-settings').fadeOut(function() {
			$j(this).remove();
		});
	};
}

HomemakerAlbums.prototype = new HomemakerComponent();
function HomemakerFeaturedTracks() {
	const self = this;
	const tracks = gde('track', { case: 'upper', plural: true });

	this.key = 'feattracks';
	this.icon = 'fa-music';
	this.title = tracks;

	this.div = $j(`
		<div class="feattracks-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>${tracks}</h3>
			</div>
			<div class="component-body">
				<span class="get-started-component-text"></span>
			</div>
		</div>
	`);

	this.settings = null;	
	
	this.build = function (item) {
		item.div.addClass(item.type);
		
		const show = item.settings.displayCount || 5;
		const defaultSettings = {
			displayCount: 6,
			featuredItems: [],
			mode: self.getItemMode(item),
			showItemDetails: false,
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('mode'))
		};
		item.settings = { ...defaultSettings, ...item.settings };
		
		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		// Build the search / item query
		const query = self.buildSearchQuery('track_info', item, show);
		if (!query) {			
			self.createComponentMessage([], item, item.div.find('.component-body'), self.title, self);
			
			// Update the title, since we aren't going to load the query block
			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
			return;	
		}

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();
		
		ajax(query, response => {
			if (response.length > 1) {
				item.div.find('.component-body').empty();
			}
			
			item.div.find('.component-body').append('<div class="track_container custom-items-component-container"></div>');
			let trackContainer = item.div.find('.component-body').find('.track_container');

			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);

			removeLoadingBar();

			// Configures the instruction message for the component: "Click the edit button to get started adding tracks.", etc.
			const instructionMessage = self.createComponentMessage(response, item, trackContainer, self.title, self);
			if (!instructionMessage) return;

			if (item.settings.alignmentType === 'center') {
				trackContainer.addClass('space-out');
			}

			const displayOptions = {
				hovers: false,
				showCatalog: true,
				showArtist: true,
				showCode: false,
				showReleaseDate: true,
				showing: true,
				showPlayBtn: true,
				showDetailLabels: true
			};
			
			displayOptions.size = item.type === 'right' ? 'small' : 'large';

			// Sort the IDs so they maintain the order that the user specifies
			const trackData = self.sortFeaturedItems(response, item.settings);

			trackData.forEach(track => {
				trackContainer.append((new Track(track)).generateArtElement(displayOptions));
			});

			// Set number of items per row
			trackContainer = self.configureItemsPerRow(trackContainer);

			if (lockdown) {
				sa.lockdownLinks(trackContainer.find('a'));
			}
			
			self.showHideItemDetails(trackContainer, item);
		});
	};

	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));
		
		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'featured-tracks' },
				{ type: 'displayCount', componentType: 'featured-tracks' },
				{ type: 'alignmentType', componentType: this.title },
				{ type: 'showComponentHeader', componentType: 'featured-tracks' },
				{ type: 'showItemDetails', componentType: 'featured-tracks' },
				{ type: 'mode', componentType: this.title },
				{ type: 'customSearch' }
			]
		};
		
		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, displayCount, alignmentType, featuredItems } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: this.title },
			
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'alignmentType', fallbackValue: 'left' },
			{ name: 'showComponentHeader', fallbackValue: true },
			{ name: 'showItemDetails', fallbackValue: false },
			{ name: 'mode', fallbackValue: 'custom' },
			{ name: 'featuredItems', fallbackValue: [] }
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);
		
		// Handle the component item "mode" - custom, featured, newest items, etc.
		this.handleItemModeDropdown(settingsDiv, item);
		this.handleItemModeDropdownEvent(settingsDiv, item);

		// Set the values into the inputs
		settingsDiv.find('#featured-tracks-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#featured-tracks-count').val(displayCount);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);
		
		// Handle showing and hiding the item details
		this.handleShowItemDetails(settingsDiv, item);

		// Handle Alignment 
		this.handleComponentAlignmentFields(settingsDiv, alignmentType);

		// Handle Custom Search Field Loading
		this.handleCustomSearchFields(settingsDiv, featuredItems, item);

		// Handle the custom search
		settingsDiv = this.handleCustomSearchEvents(settingsDiv, item, 'tracks');
		
		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#featured-tracks-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#featured-tracks-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'number', fallbackValue: 4, min: 1, max: 20 },
			{ selector: '#center-align-items', propertyName: 'alignmentType', valueType: 'text', fieldType: 'checkbox', fallbackValue: 'left' },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
			{ selector: '#showItemDetails', propertyName: 'showItemDetails', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			// { selector: '#toggleCustomItems', propertyName: 'customSearchToggle', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#feattracks-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerFeaturedTracks.prototype = new HomemakerComponent();
function HomemakerFeaturedAlbums() {
	const self = this;
	const albums = gde('album', { case: 'upper', plural: true });

	this.key = 'featalbums';
	this.icon = 'fa-compact-disc';
	this.title = albums;

	this.div = $j(`
		<div class="featalbums-component art-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>${albums}</h3>
			</div>
			<div class="component-body">
				<span class="get-started-component-text"></span>
			</div>
		</div>
	`);

	this.settings = null;

	this.build = function (item) {
		item.div.addClass(item.type);

		const defaultSettings = {
			displayCount: 6,
			mode: self.getItemMode(item),
			featuredItems: [],
			showItemDetails: false,
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('mode'))
		};
		item.settings = { ...defaultSettings, ...item.settings };

		let show = item.settings.displayCount;

		// beatbox override
		if (config.id === 382 || config.id === 1494) {
			show = 20;
			item.div.find('.component-header').find('h3').html('New Releases');
		}

		// Hide / show header
		self.handleComponentHeaderDisplay(item);

		// Build the search / item query
		const query = self.buildSearchQuery('album_info', item, show);
		if (!query) {
			self.createComponentMessage([], item, item.div.find('.component-body'), self.title, self);

			// Update the title, since we aren't going to load the query block
			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
			return;
		}

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();

		ajax(query, function (response) {
			if (response.length > 1) {
				item.div.find('.component-body').empty();
			}

			item.div.find('.component-body').append('<div class="album_container custom-items-component-container"></div>');
			let albumContainer = item.div.find('.component-body').find('.album_container');

			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);

			removeLoadingBar();

			// Configures the instruction message for the component: "Click the edit button to get started adding albums.", etc.
			const instructionMessage = self.createComponentMessage(response, item, albumContainer, self.title, self);
			if (!instructionMessage) return;

			if (item.settings.alignmentType === 'center') {
				albumContainer.addClass('space-out');
			}

			const displayOptions = {
				hovers: false,
				showCatalog: false,
				showArtist: false,
				showCode: false,
				showReleaseDate: false,
				showing: true
			};

			if (item.type !== 'wide') {
				displayOptions.size = 'small';
			}

			// Sort the IDs so they maintain the order that the user specifies
			const albumData = self.sortFeaturedItems(response, item.settings);
			
			albumData.forEach(album => {
				albumContainer.append((new Album(album)).generateArtElement(displayOptions));
			});

			// Set number of items per row
			albumContainer = self.configureItemsPerRow(albumContainer);

			if (lockdown) {
				sa.lockdownLinks(albumContainer.find('a'));
			}

			self.showHideItemDetails(albumContainer, item);
		});
	};

	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'featured-albums' },
				{ type: 'displayCount', componentType: 'featured-albums' },
				{ type: 'alignmentType', componentType: this.title },
				{ type: 'showComponentHeader', componentType: 'featured-albums' },
				{ type: 'showItemDetails', componentType: 'featured-albums' },
				{ type: 'mode', componentType: this.title },
				{ type: 'customSearch' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, displayCount, alignmentType, featuredItems } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: this.title },
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'alignmentType', fallbackValue: 'left' },
			{ name: 'showComponentHeader', fallbackValue: true },
			{ name: 'showItemDetails', fallbackValue: false },
			{ name: 'mode', fallbackValue: 'custom' },
			{ name: 'featuredItems', fallbackValue: [] }
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Handle the component item "mode" - custom, featured, newest items, etc.
		this.handleItemModeDropdown(settingsDiv, item);
		this.handleItemModeDropdownEvent(settingsDiv, item);

		// Set the values into the inputs
		settingsDiv.find('#featured-albums-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#featured-albums-count').val(displayCount);

		// Handle Alignment
		this.handleComponentAlignmentFields(settingsDiv, alignmentType);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle showing and hiding the item details
		this.handleShowItemDetails(settingsDiv, item);

		// Handle Custom Search Field Loading
		this.handleCustomSearchFields(settingsDiv, featuredItems, item);

		// Handle the custom search
		settingsDiv = this.handleCustomSearchEvents(settingsDiv, item, 'albums');

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#featured-albums-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#featured-albums-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'text', fallbackValue: 4 },
			{ selector: '#center-align-items', propertyName: 'alignmentType', valueType: 'text', fieldType: 'checkbox', fallbackValue: 'left' },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
			{ selector: '#showItemDetails', propertyName: 'showItemDetails', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			// { selector: '#toggleCustomItems', propertyName: 'customSearchToggle', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#featalbums-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerFeaturedAlbums.prototype = new HomemakerComponent();
function HomemakerFeaturedArtists() {
	const self = this;
	const artists = gde('artist', { case: 'upper', plural: true });

	this.key = 'featartists';
	this.icon = 'fa-user';
	this.title = artists;

	this.div = $j(`
		<div class="featartists-component art-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>${artists}</h3>
			</div>
			<div class="component-body">
				<span class="get-started-component-text"></span>
			</div>
		</div>
	`);

	this.settings = null;
	
	this.build = function (item) {
		item.div.addClass(item.type);

		const defaultSettings = {
			displayCount: 6,
			mode: self.getItemMode(item),
			featuredItems: [],
			showItemDetails: false,
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('mode'))
		};
		item.settings = { ...defaultSettings, ...item.settings };

		let show = (item.type === 'right') ? 3 : 4;
		show = item.settings.displayCount ? item.settings.displayCount : show;

		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		// Build the search / item query
		const query = self.buildSearchQuery('artist_info', item, show);
		if (!query) {
			self.createComponentMessage([], item, item.div.find('.component-body'), self.title, self);

			// Update the title, since we aren't going to load the query block
			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
			return;	
		}

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();
		
		ajax(query, (response) => {
			if (response.length > 1) {
				item.div.find('.component-body').empty();
			}
			
			item.div.find('.component-body').append('<div class="artist_container custom-items-component-container"></div>');
			let artistContainer = item.div.find('.component-body').find('.artist_container');

			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);

			removeLoadingBar();
			
			// Configures the instruction message for the component: "Click the edit button to get started adding Artists.", etc.
			const instructionMessage = self.createComponentMessage(response, item, artistContainer, self.title, self);
			if (!instructionMessage) return;
			
			if (item.settings.alignmentType === 'center') {
				artistContainer.addClass('space-out');
			}
			
			const displayOptions = {
				hovers: false,
				showing: true
			};
			
			if (item.type !== 'wide') {
				displayOptions.size = 'small';
			}

			// Sort the IDs so they maintain the order that the user specifies
			const artistData = self.sortFeaturedItems(response, item.settings);
			
			artistData.forEach(artist => {
				artistContainer.append((new Artist(artist)).generateArtElement(displayOptions));
			});

			// Set number of items per row
			const itemCount = response.length - 1;
			artistContainer = self.configureItemsPerRow(artistContainer);

			if (lockdown) {
				sa.lockdownLinks(artistContainer.find('a'));
			}

			self.showHideItemDetails(artistContainer, item);
		});
	};
	
	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'featured-artists' },
				{ type: 'displayCount', componentType: 'featured-artists' },
				{ type: 'alignmentType', componentType: this.title },
				{ type: 'showComponentHeader', componentType: 'featured-artists' },
				{ type: 'showItemDetails', componentType: 'featured-artists' },
				{ type: 'mode', componentType: this.title },
				{ type: 'customSearch' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, displayCount, alignmentType, featuredItems } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: this.title },
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'alignmentType', fallbackValue: 'left' },
			{ name: 'showComponentHeader', fallbackValue: true },
			{ name: 'showItemDetails', fallbackValue: false },
			{ name: 'mode', fallbackValue: 'custom' },
			{ name: 'featuredItems', fallbackValue: [] }
		]);
		
		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Handle the component item "mode" - custom, featured, newest items, etc.
		this.handleItemModeDropdown(settingsDiv, item);
		this.handleItemModeDropdownEvent(settingsDiv, item);

		// Set the values into the inputs
		settingsDiv.find('#featured-artists-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#featured-artists-count').val(displayCount);

		// Handle Alignment 
		this.handleComponentAlignmentFields(settingsDiv, alignmentType);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle showing and hiding the item details
		this.handleShowItemDetails(settingsDiv, item);

		// Handle Custom Search Field Loading
		this.handleCustomSearchFields(settingsDiv, featuredItems, item);

		// Handle the custom search
		settingsDiv = this.handleCustomSearchEvents(settingsDiv, item, 'artists');

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#featured-artists-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#featured-artists-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'text', fallbackValue: 4 },
			{ selector: '#center-align-items', propertyName: 'alignmentType', valueType: 'text', fieldType: 'checkbox', fallbackValue: 'left' },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
			{ selector: '#showItemDetails', propertyName: 'showItemDetails', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			// { selector: '#toggleCustomItems', propertyName: 'customSearchToggle', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#featartists-component-settings').fadeOut(function() {
			$j(this).remove();
		});
	};
}

HomemakerFeaturedArtists.prototype = new HomemakerComponent();
function HomemakerFeaturedWriters() {
	const self = this;
	const writers = gde('writer', { case: 'upper', plural: true });

	this.key = 'featwriters';
	this.icon = 'fa-user-edit';
	this.title = writers;

	this.div = $j(`
		<div class="featcomps-component art-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>${writers}</h3>
			</div>
			<div class="component-body">
				<span class="get-started-component-text"></span>
			</div>
		</div>
	`);

	this.settings = null;
	
	this.build = function (item) {
		item.div.addClass(item.type);

		const defaultSettings = {
			displayCount: 6,
			featuredItems: [],
			mode: self.getItemMode(item),
			showItemDetails: false,
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('mode'))
		};
		item.settings = { ...defaultSettings, ...item.settings };
		
		let show = (item.type === 'right') ? 3 : 4;
		show = item.settings.displayCount ? item.settings.displayCount : show;

		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		// Build the search / item query
		const query = self.buildSearchQuery('person_info', item, show);
		if (!query) {
			self.createComponentMessage([], item, item.div.find('.component-body'), self.title, self);

			// Update the title, since we aren't going to load the query block
			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
			return;	
		}

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();
		
		ajax(query, (response) => {
			if (response.length > 1) {
				item.div.find('.component-body').empty();
			}
			
			item.div.find('.component-body').append('<div class="writer_container custom-items-component-container"></div>');
			let writerContainer = item.div.find('.component-body').find('.writer_container');

			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);

			removeLoadingBar();

			// Configures the instruction message for the component: "Click the edit button to get started adding Writers.", etc.
			const instructionMessage = self.createComponentMessage(response, item, writerContainer, self.title, self);
			if (!instructionMessage) return;

			if (item.settings.alignmentType === 'center') {
				writerContainer.addClass('space-out');
			}

			const displayOptions = {
				hovers: false,
				showing: true
			};

			if (item.type !== 'wide') {
				displayOptions.size = 'small';
			}
			
			item.isNew = false;

			// Sort the IDs so they maintain the order that the user specifies
			const writerData = self.sortFeaturedItems(response, item.settings);

			writerData.forEach(writer => {
				writerContainer.append((new Writer(writer)).generateArtElement(displayOptions));
			});

			// Set number of items per row
			writerContainer = self.configureItemsPerRow(writerContainer);

			if (lockdown) {
				sa.lockdownLinks(writerContainer.find('a'));
			}

			writerContainer.append('<div class="clr"></div>');

			self.showHideItemDetails(writerContainer, item);
		});
	};

	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'featured-writers' },
				{ type: 'displayCount', componentType: 'featured-writers' },
				{ type: 'alignmentType', componentType: this.title },
				{ type: 'showComponentHeader', componentType: 'featured-writers' },
				{ type: 'showItemDetails', componentType: 'featured-writers' },
				{ type: 'mode', componentType: this.title },
				{ type: 'customSearch' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);
		settingsDiv.find('#item-types option[value="newest"]').remove();

		// Set some default values
		const {	title, displayCount, alignmentType, featuredItems } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: this.title },
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'alignmentType', fallbackValue: 'left' },
			{ name: 'showComponentHeader', fallbackValue: true },
			{ name: 'showItemDetails', fallbackValue: false },
			{ name: 'mode', fallbackValue: 'custom' },
			{ name: 'featuredItems', fallbackValue: [] }
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Handle the component item "mode" - custom, featured, newest items, etc.
		this.handleItemModeDropdown(settingsDiv, item);
		this.handleItemModeDropdownEvent(settingsDiv, item);

		// Set the values into the inputs
		settingsDiv.find('#featured-writers-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#featured-writers-count').val(displayCount);

		// Handle Alignment 
		this.handleComponentAlignmentFields(settingsDiv, alignmentType);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle showing and hiding the item details
		this.handleShowItemDetails(settingsDiv, item);

		// Handle Custom Search Field Loading
		this.handleCustomSearchFields(settingsDiv, featuredItems, item);

		// Handle the custom search
		settingsDiv = this.handleCustomSearchEvents(settingsDiv, item, 'writers');

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#featured-writers-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: this.title },
			{ selector: '#featured-writers-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'text', fallbackValue: 4 },
			{ selector: '#center-align-items', propertyName: 'alignmentType', valueType: 'text', fieldType: 'checkbox', fallbackValue: 'left' },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
			{ selector: '#showItemDetails', propertyName: 'showItemDetails', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			// { selector: '#toggleCustomItems', propertyName: 'customSearchToggle', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#featwriters-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerFeaturedWriters.prototype = new HomemakerComponent();
function HomemakerFeaturedLabels() {
	const self = this;
	const labels = gde('label', { case: 'upper', plural: true });

	this.key = 'featlabels';
	this.icon = 'fa-cube';
	this.title = labels;

	this.div = $j(`
		<div class="featlabels-component art-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>${labels}</h3>
			</div>
			<div class="component-body">
				<span class="get-started-component-text"></span>
			</div>
		</div>
	`);

	this.settings = null;

	this.build = function (item) {
		item.div.addClass(item.type);

		const defaultSettings = {
			displayCount: 6,
			mode: self.getItemMode(item),
			featuredItems: [],
			showItemDetails: false,
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('mode'))
		};
		item.settings = { ...defaultSettings, ...item.settings };
		
		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		let show = (item.type === 'right') ? 3 : 4;
		show = item.settings.displayCount ? item.settings.displayCount : show;

		// Build the search / item query
		const query = self.buildSearchQuery('label_info', item, show);
		if (!query) {
			self.createComponentMessage([], item, item.div.find('.component-body'), self.title, self);

			// Update the title, since we aren't going to load the query block
			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
			return;
		}

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();
		
		ajax(query, (response) => {
			if (response.length > 1) {
				item.div.find('.component-body').empty();
			}
			
			item.div.find('.component-body').append('<div class="label_container custom-items-component-container"></div>');
			let labelContainer = item.div.find('.component-body').find('.label_container');

			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);

			removeLoadingBar();

			// Configures the instruction message for the component: "Click the edit button to get started adding labels.", etc.
			const instructionMessage = self.createComponentMessage(response, item, labelContainer, self.title, self);
			if (!instructionMessage) return;

			if (item.settings.alignmentType === 'center') {
				labelContainer.addClass('space-out');
			}

			const displayOptions = {
				hovers: false,
				showing: true
			};
			
			if (item.type !== 'wide') {
				displayOptions.size = 'small';
			}

			// Sort the IDs so they maintain the order that the user specifies
			const labelData = self.sortFeaturedItems(response, item.settings);

			labelData.forEach(label => {
				labelContainer.append((new Label(label).generateArtElement(displayOptions)));
			});

			// Set number of items per row
			labelContainer = self.configureItemsPerRow(labelContainer);

			if (lockdown) {
				sa.lockdownLinks(labelContainer.find('a'));
			}

			self.showHideItemDetails(labelContainer, item);
		});
	};

	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'featured-labels' },
				{ type: 'displayCount', componentType: 'featured-labels' },
				{ type: 'alignmentType', componentType: this.title },
				{ type: 'showComponentHeader', componentType: 'featured-labels' },
				{ type: 'showItemDetails', componentType: 'featured-labels' },
				{ type: 'mode', componentType: this.title },
				{ type: 'customSearch' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, displayCount, alignmentType, featuredItems } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: this.title },
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'alignmentType', fallbackValue: 'left' },
			{ name: 'showComponentHeader', fallbackValue: true },
			{ name: 'showItemDetails', fallbackValue: false },
			{ name: 'mode', fallbackValue: 'custom' },
			{ name: 'featuredItems', fallbackValue: [] }
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Handle the component item "mode" - custom, featured, newest items, etc.
		this.handleItemModeDropdown(settingsDiv, item);
		this.handleItemModeDropdownEvent(settingsDiv, item);

		// Set the values into the inputs
		settingsDiv.find('#featured-labels-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#featured-labels-count').val(displayCount);

		// Handle Alignment 
		this.handleComponentAlignmentFields(settingsDiv, alignmentType);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle showing and hiding the item details
		this.handleShowItemDetails(settingsDiv, item);

		// Handle Custom Search Field Loading
		this.handleCustomSearchFields(settingsDiv, featuredItems, item);

		// Handle the custom search
		settingsDiv = this.handleCustomSearchEvents(settingsDiv, item, 'labels');

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#featured-labels-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#featured-labels-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'text', fallbackValue: 4 },
			{ selector: '#center-align-items', propertyName: 'alignmentType', valueType: 'text', fieldType: 'checkbox', fallbackValue: 'left' },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
			{ selector: '#showItemDetails', propertyName: 'showItemDetails', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			// { selector: '#toggleCustomItems', propertyName: 'customSearchToggle', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#featlabels-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerFeaturedLabels.prototype = new HomemakerComponent();
function HomemakerFeaturedCatalogs() {
	const self = this;
	const catalogs = gde('catalog', { plural: true, case: 'upper' });

	this.key = 'featcatalogs';
	this.icon = 'fa-cubes';
	this.title = catalogs;

	this.div = $j(`
		<div class="featcats-component art-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>${catalogs}</h3>
			</div>
			<div class="component-body">
				<span class="get-started-component-text"></span>
			</div>
		</div>
	`);

	this.settings = null;

	this.build = function (item) {
		item.div.addClass(item.type);

		const defaultSettings = {
			displayCount: 6,
			mode: self.getItemMode(item),
			featuredItems: [],
			showItemDetails: false,
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('mode'))
		};
		item.settings = { ...defaultSettings, ...item.settings };

		let show = (item.type === 'right') ? 3 : 4;
		show = item.settings.displayCount ? item.settings.displayCount : show;

		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		// Build the search / item query
		const query = self.buildSearchQuery('catalog_info', item, show);
		if (!query) {
			self.createComponentMessage([], item, item.div.find('.component-body'), self.title, self);

			// Update the title, since we aren't going to load the query block
			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
			return;	
		}

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();
		
		ajax(query, (response) => {
			if (response.length > 1) {
				item.div.find('.component-body').empty();
			}
			
			item.div.find('.component-body').append('<div class="catalog_container custom-items-component-container"></div>');
			let catalogContainer = item.div.find('.component-body').find('.catalog_container');

			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);

			removeLoadingBar();

			// Configures the instruction message for the component: "Click the edit button to get started adding catalogs.", etc.
			const instructionMessage = self.createComponentMessage(response, item, catalogContainer, self.title, self);
			if (!instructionMessage) return;

			if (item.settings.alignmentType === 'center') {
				catalogContainer.addClass('space-out');
			}

			const displayOptions = {
				hovers: false,
				showing: true
			};
			
			if (item.type !== 'wide') {
				displayOptions.size = 'small';
			}

			// Sort the IDs so they maintain the order that the user specifies
			const catalogData = self.sortFeaturedItems(response, item.settings);

			catalogData.forEach(catalog => {
				catalogContainer.append((new Catalog(catalog)).generateArtElement(displayOptions));
			});

			// Set number of items per row
			const itemCount = response.length - 1;
			catalogContainer = self.configureItemsPerRow(catalogContainer);

			if (lockdown) {
				sa.lockdownLinks(catalogContainer.find('a'));
			}

			self.showHideItemDetails(catalogContainer, item);
		});
	};

	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'featured-catalogs' },
				{ type: 'displayCount', componentType: 'featured-catalogs' },
				{ type: 'alignmentType', componentType: this.title },
				{ type: 'showComponentHeader', componentType: 'featured-catalogs' },
				{ type: 'showItemDetails', componentType: 'featured-catalogs' },
				{ type: 'mode', componentType: this.title },
				{ type: 'customSearch' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, displayCount, alignmentType, featuredItems } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: this.title },
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'alignmentType', fallbackValue: 'left' },
			{ name: 'showComponentHeader', fallbackValue: true },
			{ name: 'showItemDetails', fallbackValue: false },
			{ name: 'mode', fallbackValue: 'custom' },
			{ name: 'featuredItems', fallbackValue: [] }
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Handle the component item "mode" - custom, featured, newest items, etc.
		this.handleItemModeDropdown(settingsDiv, item);
		this.handleItemModeDropdownEvent(settingsDiv, item);

		// Set the values into the inputs
		settingsDiv.find('#featured-catalogs-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#featured-catalogs-count').val(displayCount);

		// Handle Alignment 
		this.handleComponentAlignmentFields(settingsDiv, alignmentType);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle showing and hiding the item details
		this.handleShowItemDetails(settingsDiv, item);

		// Handle Custom Search Field Loading
		this.handleCustomSearchFields(settingsDiv, featuredItems, item);

		// Handle the custom search
		settingsDiv = this.handleCustomSearchEvents(settingsDiv, item, 'catalogs');

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#featured-catalogs-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#featured-catalogs-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'text', fallbackValue: 4 },
			{ selector: '#center-align-items', propertyName: 'alignmentType', valueType: 'text', fieldType: 'checkbox', fallbackValue: 'left' },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
			{ selector: '#showItemDetails', propertyName: 'showItemDetails', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			// { selector: '#toggleCustomItems', propertyName: 'customSearchToggle', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#featcats-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerFeaturedCatalogs.prototype = new HomemakerComponent();
function HomemakerFeaturedPlaylists() {
	const self = this;
	const playlists = gde('playlist', { case: 'upper', plural: true });

	this.key = 'featplaylists';
	this.icon = 'fa-list-music';
	this.title = playlists;

	this.div = $j(`
		<div class="featplaylists-component art-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>${playlists}</h3>
			</div>
			<div class="component-body">
				<span class="get-started-component-text"></span>
			</div>
		</div>
	`);

	this.settings = null;

	this.build = function (item) {
		item.div.addClass(item.type);

		const defaultSettings = {
			displayCount: 6,
			mode: self.getItemMode(item),
			featuredItems: [],
			showItemDetails: false,
			neverEdited: (!item.settings || !item.settings.hasOwnProperty('mode'))
		};
		item.settings = { ...defaultSettings, ...item.settings };
		
		const show = item.settings.displayCount;

		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		// Build the search / item query
		const query = self.buildSearchQuery('project_info', item, show);
		if (!query) {
			self.createComponentMessage([], item, item.div.find('.component-body'), self.title, self);

			// Update the title, since we aren't going to load the query block
			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
			return;
		}

		const [addLoadingBar, removeLoadingBar] = self.createLoadingElement(item.div.find('.component-body'));
		addLoadingBar();
		
		ajax(query, (response) => {
			if (response.length > 1) {
				item.div.find('.component-body').empty();
			}
			
			item.div.find('.component-body').append('<div class="project_container custom-items-component-container"></div>');
			let projectContainer = item.div.find('.component-body').find('.project_container');

			item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);

			removeLoadingBar();

			// Configures the instruction message for the component: "Click the edit button to get started adding tracks.", etc.
			const instructionMessage = self.createComponentMessage(response, item, projectContainer, self.title, self);
			if (!instructionMessage) return;

			if (item.settings.alignmentType === 'center') {
				projectContainer.addClass('space-out');
			}

			const displayOptions = {
				hovers: false,
				showing: true
			};
			
			if (item.type !== 'wide') {
				displayOptions.size = 'small';
			}

			// Sort the IDs so they maintain the order that the user specifies
			const playlistData = self.sortFeaturedItems(response, item.settings);

			playlistData.forEach(playlist => {
				projectContainer.append((new Project(playlist)).generateArtElement(displayOptions).addClass('featured'));
			});

			// Set number of items per row
			const itemCount = response.length - 1;
			projectContainer = self.configureItemsPerRow(projectContainer);

			if (lockdown) {
				sa.lockdownLinks(projectContainer.find('a'));
			}

			self.showHideItemDetails(projectContainer, item);
		});
	};
	
	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title} Settings`
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'featured-playlists' },
				{ type: 'displayCount', componentType: 'featured-playlists' },
				{ type: 'alignmentType', componentType: this.title },
				{ type: 'showComponentHeader', componentType: 'featured-playlists' },
				{ type: 'showItemDetails', componentType: 'featured-playlists' },
				{ type: 'mode', componentType: this.title },
				{ type: 'featuredPlaylistSelector', componentType: 'Playlists' },
				{ type: 'customSearch' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);
		
		// Update featured playlists
		this.loadFeaturedPlaylistData(settingsDiv, item);

		// Set some default values
		const {	title, displayCount, alignmentType, featuredItems } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: this.title },
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'alignmentType', fallbackValue: 'left' },
			{ name: 'showComponentHeader', fallbackValue: true },
			{ name: 'showItemDetails', fallbackValue: false },
			{ name: 'mode', fallbackValue: 'custom' },
			{ name: 'featuredItems', fallbackValue: [] },
			{ name: 'featuredPlaylistId', fallBackValue: -1 }
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Handle the component item "mode" - custom, featured, newest items, etc.
		this.handleItemModeDropdown(settingsDiv, item);
		this.handleItemModeDropdownEvent(settingsDiv, item);

		// Set the values into the inputs
		settingsDiv.find('#featured-playlists-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#featured-playlists-count').val(displayCount);

		// Handle Alignment 
		this.handleComponentAlignmentFields(settingsDiv, alignmentType);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle showing and hiding the item details
		this.handleShowItemDetails(settingsDiv, item);
		
		// Handle Custom Search Field Loading
		this.handleCustomSearchFields(settingsDiv, featuredItems, item);

		// Handle the custom search
		settingsDiv = this.handleCustomSearchEvents(settingsDiv, item, 'playlists');

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#featured-playlists-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#featured-playlists-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'text', fallbackValue: 4 },
			{ selector: '#center-align-items', propertyName: 'alignmentType', valueType: 'text', fieldType: 'checkbox', fallbackValue: 'left' },
			{ selector: '#toggleCustomItems', propertyName: 'customSearchToggle', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: true },
			{ selector: '#showItemDetails', propertyName: 'showItemDetails', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false },
			{ selector: '#featured-playlists', propertyName: 'featuredPlaylistId', valueType: 'number', fieldType: 'select', fallbackValue: -1 },
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#featplaylists-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerFeaturedPlaylists.prototype = new HomemakerComponent();
function HomemakerSocial() {
	const self = this;

	this.key = 'social';
	this.icon = 'fa-share-alt';
	this.title = 'Social<br/>Links';
	
	this.div = $j(`
		<div class="component social-component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3 class="social-title">Follow Us</h3>
			</div>
			<div class="component-body">
			</div>
		</div>
	`);

	this.settings = null;
	
	this.build = function (item) {
		item.div.find('.social-title').text(item.settings.title);

		if (!item.div.find('.social-text').length && user.userData.siteOwner) {
			item.div.find('.component-body').append('<div class="social-text"><span class="social-component-placeholder-text">Edit this component to start adding social links</span></div>');
		} else if (!item.div.find('.social-text').length) {
			item.div.find('.component-body').append('<div class="social-text"></div>');
		}

		// Hide / show header
		self.handleComponentHeaderDisplay(item);
		
		// Remove placeholder text if we have actual social links
		if (item.settings.twitter || item.settings.facebook || item.settings.instagram || item.settings.mastodon) {
			item.div.find('.component-body .social-component-placeholder-text').remove();
		} else {
			item.div.find('.component-body').append('<div class="social-text"><span class="social-component-placeholder-text">No social media links added.</span></div>');
		}
		
		if (item.settings.twitter && item.settings.twitter !== '@') {
			const referrerUrl = encodeURIComponent(siteBaseUrl());
			
			let username;
			if (item.settings.twitter.includes('twitter.com')) {
				username = item.settings.twitter.split('/').at(-1);
			} else if (item.settings.twitter.includes('@')) {
				username = item.settings.twitter.replace('@', '');
			} else {
				username = item.settings.twitter;
			}
			
			const linkUrl = `https://twitter.com/intent/follow?original_referer=${referrerUrl}%2F&amp;ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Efollow%7Ctwgr%5E${username}&amp;region=follow_link&amp;screen_name=${username}`;

			item.div.find('.social-text').append(`
				<a class="social-component-link social-link-twitter" target="_blank" href="${linkUrl}">
					<div>
						<i class="fa fa-twitter"></i>
					</div>
					<span class="social-username">@${username}</span>
				</a>
			`.trim());
		}

		if (item.settings.facebook) {
			let pageLink;
			try {
				pageLink = new URL(item.settings.facebook);
			} catch (e) {
				// Not a valid URL
				sa.alert({
					text: 'Facebook Social Link is not valid'
				});
			}

			let username;
			if (item.settings.facebook.includes('pages') || item.settings.facebook.includes('/')) {
				username = item.settings.facebook.split('/');
				username = username.filter(piece => !!piece);
				username = username.at(-1);
				
				// If it's a page id and not a username
				if (username.match(/^[0-9]+$/)) {
					username = 'Follow';
				}
			}
			
			item.div.find('.social-text').append(`
				<a class="social-component-link social-link-facebook" target="_blank" href="${pageLink.toString()}">
					<div>
						<i class="fa fa-facebook"></i>
					</div>
					<span class="social-username">${username}</span>
				</a>
			`.trim());
		}
		
		if (item.settings.instagram) {
			let username = item.settings.instagram;
			username = username.startsWith('@') ? username.substring(1, username.length) : username;
			item.div.find('.social-text').append(`
				<a class="social-component-link social-link-instagram" target="_blank" href="https://www.instagram.com/${username}">
					<div>
						<i class="fa fa-instagram"></i>
					</div>
					<span class="social-username">@${username}</span>
				</a>
			`.trim());
		}

		if (item.settings.mastodon) {
			const mastodonLink = item.settings.mastodon;
			const mastodonUser = item.settings.mastodon.split('@')[1];
			item.div.find('.social-text').append(`
				<a class="social-component-link social-link-mastodon" target="_blank" href="${mastodonLink}">
					<div>
						<i class="fab fa-mastodon"></i>
					</div>
					<span class="social-username">@${mastodonUser}</span>
				</a>
			`.trim());
		}
	};
	
	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: 'Social Link Settings'
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'social' },
				{ type: 'showComponentHeader', componentType: 'featured-writers' },
				{ type: 'social', componentType: 'social' }
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, facebook, twitter, instagram, mastodon } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: 'Follow Us' },
			{ name: 'facebook', fallbackValue: '' },
			{ name: 'twitter', fallbackValue: '' },
			{ name: 'instagram', fallbackValue: '' },
			{ name: 'mastodon', fallbackValue: '' },
			{ name: 'showComponentHeader', fallbackValue: true },
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Set the values into the inputs
		settingsDiv.find('#social-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#facebook-social-url').val(facebook);
		settingsDiv.find('#twitter-social-name').val(twitter);
		settingsDiv.find('#instagram-username').val(instagram);
		settingsDiv.find('#mastodon-link').val(mastodon);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#social-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: 'Follow Us' },
			{ selector: '#facebook-social-url', propertyName: 'facebook', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#twitter-social-name', propertyName: 'twitter', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#instagram-username', propertyName: 'instagram', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#mastodon-link', propertyName: 'mastodon', valueType: 'text', fieldType: 'text', fallbackValue: '' },
			{ selector: '#showComponentHeader', propertyName: 'showComponentHeader', valueType: 'boolean', fieldType: 'checkbox', fallbackValue: false }
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#social-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerSocial.prototype = new HomemakerComponent();

function HomemakerBlog() {
	const self = this;

	const templates = sa.templates.get('homemaker.blog');

	this.key = 'blog';
	this.icon = 'fa-bullhorn';
	this.title = 'Blog List';

	this.div = $j(`
		<div class="blog-component draggable-item component">
			<div class="component-edit-options">
				<span class="move-component-option">
					<i class="fas fa-arrows"></i>
				</span>
				<span class="edit-component-option">
					<i class="fas fa-edit"></i>
				</span>
				<span class="delete-component-option">
					<i class="fas fa-trash"></i>
				</span>
			</div>
			<div class="component-header">
				<h3>Latest News & Announcements</h3>
			 	<button class="home-editing-bar-btn add-blogs-btn">Manage Posts</button>
			</div>
			<div class="component-body">
				<div class="blog-list"></div>
			</div>
		</div>
	`);

	this.settings = {};
	this.settingsDiv = templates.get('settings_div');

	this.buildBlogPage = function (container, blog) {
		if (blog.body) {
			blog.body = blog.body.replace(/http:\/\/www\.youtube/g, 'https://www.youtube').replace(/http:\/\/player\.vimeo/, 'https://player.vimeo');
		}

		const baseUrl = siteBaseUrl();
		const blogLinks = this.buildBlogLinks(blog);
		
		const template = templates.get('blog_entry', {
			baseUrl: baseUrl,
			blog_title: blog.title,
			blog_body: cleanCkeditorOutput(blog.body, true),
			blog_thumbnail: blog.thumbnail,
			blog_date: formatDate(config.dateFormatString, blog.date),
			blog_links: blogLinks
		});
		
		if (blog.thumbnail) {
			template.find('.blog-thumbnail').append('<img src="' + blog.thumbnail + '" />');
		} else {
			template.find('.blog-thumbnail').remove();
		}
		
		container.html(template);
		
		setTitle(blog.title);
	};
	
	this.buildBlogLinks = function (blog, baseUrl = siteBaseUrl()) {
		let links = '';
		if (blog.previousBlog) {
			links += `<a href="${baseUrl}/blog/${blog.previousBlog}">&laquo; Previous Entry</a>`;
		}
		
		if (!blog.previousBlog && blog.nextBlog) {
			links += `<a href="${baseUrl}/home">&laquo; Home</a>`;
		}
		
		if (blog.nextBlog) {
			links += ` <a href="${baseUrl}/blog/${blog.nextBlog}" class="next">Next Entry &raquo;</a>`;
		}
		
		if (!blog.previousBlog && !blog.nextBlog) {
			links += `<a href="${baseUrl}/home">&laquo; Home</a>`;
		}
		
		return links;
	};

	this.build = function (item) {
		const baseUrl = siteBaseUrl();
		item.div.find('.add-blogs-btn').on('click', () => {
			sa.confirm({
				text: 'Are you sure you want to leave this page? All unsaved changes will be lost.',
				yesFunction: () => {
					sa.router.routeTo(`${baseUrl}/admin?p=custom_pages&tab=blog`)
				}
			});
		});
		
		if (!item.settings || !item.settings.blogs || !item.settings.blogs.length) {
			if (user.hasAdminPermission(AdminPermission.CustomPages)) {
				item.div.find('.component-header h3').html(StringSanitize.encodeIfNotEncoded(item.settings.title) || self.title);
				item.div.find('.component-body').append(`
					<div>
						Looks like you don't have any blogs. <a style="text-decoration: underline;" href="${baseUrl}/admin?p=custom_pages&tab=blog" target="_blank">Click here</a> to create some.
					</div>
				`);
			} else {
				item.div.remove();
			}
		} else {
			const blogList = $j('<div class="blog-list"></div>');
			
			item.div.find('.component-header h3').text(item.settings.title || 'Latest News & Announcements');

			const totalBlogsToShow = item.settings.displayCount;
			
			for (let i = 0; i < item.settings.blogs.length; i++) {
				if (i >= totalBlogsToShow) continue;
				const blog = item.settings.blogs[i];
				const blogItem = templates.get('blog_list_item', {
					link: `${baseUrl}/blog/${blog.blog_id}`,
					title: blog.title,
					date: formatDate(config.dateFormatString, blog.date),
					abstract: blog.abstract
				});
				
				if (blog.thumbnail) {
					blogItem.find('.blog-abstract-image').attr('src', blog.thumbnail);
				} else {
					blogItem.find('.thumbnail').remove();
				}

				blogList.append(blogItem);
			}
			blogList.find('.blog:last').addClass('last');
			
			item.div.find('.component-body').append(blogList);
		}

		// Hide / show header
		if (item.settings && item.settings.showComponentHeader) {
			item.div.find('.component-header').hide();
			item.div.addClass('component-no-header');
		} else {
			item.div.find('.component-header').show();
			item.div.removeClass('component-no-header');
		}
	};

	this.showSettings = function (item, home) {
		// Pull in the component settings base template
		const templates = sa.templates.get('pages.home.homemaker');
		const componentSettings = $j(templates.get('componentSettings', {
			componentType: item.key,
			componentSettingsTitle: `${this.title}`
		}));

		// Config
		const settingsFieldsConfig = {
			fields: [
				{ type: 'title', componentType: 'blog' },
				{ type: 'showComponentHeader', componentType: 'blog' },
				{ type: 'displayCount', componentType: 'blog' },
			]
		};

		// Build the fields out
		let settingsDiv = this.buildSettingsFields(componentSettings, settingsFieldsConfig);

		// Set some default values
		const {	title, displayGrid, displayCount } = this.setDefaultValues(item, [
			{ name: 'title', fallbackValue: 'Latest News & Announcements' },
			{ name: 'displayCount', fallbackValue: 4 },
			{ name: 'displayGrid', fallbackValue: false },
			{ name: 'showComponentHeader', fallbackValue: true },
		]);

		// Handle click events for alignment icons
		settingsDiv = this.handleAlignmentClickEvents(settingsDiv);

		// Set the values into the inputs
		settingsDiv.find('#blog-title').val(StringSanitize.ifEncodedDecode(title));
		settingsDiv.find('#blog-count').val(displayCount);
		settingsDiv.find('#display-grid-tiles').prop('checked', displayGrid);

		// Handle the component header toggle
		this.handleComponentHeaderToggle(settingsDiv, item);

		// Handle the component save event
		settingsDiv = this.handleComponentSave(settingsDiv, item, [
			{ selector: '#blog-title', propertyName: 'title', valueType: 'text', fieldType: 'text', fallbackValue: this.title },
			{ selector: '#blog-count', propertyName: 'displayCount', valueType: 'number', fieldType: 'text', fallbackValue: 4 },
			{ selector: '#display-grid-tiles', propertyName: 'displayGrid', valueType: 'text', fieldType: 'checkbox', fallbackValue: false }
		], home, self.build);

		$j('body').append(settingsDiv);

		settingsDiv.fadeIn();
	};

	this.hideSettings = function () {
		$j('#blog-component-settings').fadeOut(function () {
			$j(this).remove();
		});
	};
}

HomemakerBlog.prototype = new HomemakerComponent();
/**
 * Shows license now info for selected track
 */
function SubscriptionSignUpPage() {
	//private vars
	var page = this;

	//public vars
	this.container = null;
	this.section = null;
	this.vars = null;
	this.after_load = null;
	this.loaded = {};
	this.license_config = null;
	this.selected_plan = null;
	this.user_subscription = null;
	this.name = 'subscription_signup';
	this.title = "Subscription Signup";
	
	page.register = {
		hash: "#!subscription_signup",
		routes: [{
			pattern: '/subscription-signup',
			hash: '#!subscription_signup',
			name: "Subscription Signup"
		}]
	};

	this.preloadData = function() {
		page.loadUserSubscription();
	};

	this.isPreloaded = function() {
		var preloaded = true;
		$j.each(page.loaded, function(to_load, isLoaded) {
			//console.log('-- preload status:', to_load, isLoaded);
			if(!isLoaded) {
				//console.log('-- preload status: NOT LOADED.');
				preloaded = false;
				return false;
			}
		});

		return preloaded;
	};

	/**
	 * load user subscription
	 */

	this.loadUserSubscription = async function() {
		if(!user.logged) {
			page.user_subscription = {status:false};
			if(page.isPreloaded()) page.after_load();
			return;
		}
		page.loaded.user_subscription = false;

		const response = await sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'getUserSubscription'
		});
	
		console.log('response for user subscription was:', response[0]);

		if (response[0].error) {
			sa.notify({ text : response[0].error });
			return;
		}
		page.user_subscription = response[0];
		page.loaded.user_subscription = true;
		if(page.isPreloaded()) page.after_load();
	};

	this.showPlans = function() {

		if(!config.licensing.subscriptions) {
			page.container.html('This workspace is not configured for subscriptions.');
			return;
		}

		/*if(page.user_subscription.status && page.user_subscription.status == 'active') {
			//window.location.href = '/dashboard?p=subscription';
			//return;
		}*/

		page.container.html(
			'<div class="subscription_title">'+config.licensing.subscriptions_title+'</div>'
			+ '<div class="subscription_subtitle">'+config.licensing.subscriptions_header+'</div>'
			+ '<div class="subscription_plans">'
			+ '</div>'
			+ (config.id == 72 ?
				'<div id="fake_sub_plan" class="sub_plan">'
					+ '<div class="sub_plan_title" style="text-align: center;">'
						+ '<div class="sub_plan_title_main" style="font-size: 22px;">Multi-User</div>'
						+ '<div class="sub_plan_title_sub">Custom Pricing</div>'
					+ '</div>'
					+ '<div class="sub_plan_details">'
						+ '<div class="sub_plan_detail" style="margin-top: 11px; ">'
							+ '<li>priced based on number of users</li>'
							+ '<li>annual and buyout options</li>'
							+ '<li>upgrade, downgrade, cancel anytime</li>'
						+ '</div>'
					+ '</div>'
					+ '<a class="sub_plan_button" href="mailto:licensing@prosoundeffects.com?subject=Multi-User Licensing - Pro Sound Effects" target="_blank"><img class="faux_button" src="images/shoppingcart/get-a-quote.png"></a>'
					+ '<div class="clr"></div>'
				+ '</div>' : '')
			+ '<div class="subscription_bottom">'
			+	'<div class="sub_disclaimer">'+config.licensing.subscriptions_footer+'</div>'
			+	'<div class="sub_cart_box">'
			+		'<div class="sub_cart_top_text">Your selected plan:</div>'
			+		'<div class="sub_cart_selected_plan">Select Above</div>'
			+		'<div class="sub_cart_selected_price"></div>'
			+		'<div class="sub_cart_checkout"><img id="checkout_button" class="faux_button" src="images/shoppingcart/checkout.png"/></div>'
			+	'</div>'
			+ '</div>'
		);

		var plans = Object.keys(config.licensing.subscriptions).map(function (key) {return config.licensing.subscriptions[key]});
		plans.sort(function(sub1, sub2) { if (sub1.order > sub2.order) return 1; return -1; });

		$j.each(plans, function(key, sub) {
			$j('.subscription_plans').append(
				'<div id="sub_plan_'+sub.id+'" class="sub_plan">'
				+	'<div class="sub_plan_title">'
				+		'<div class="sub_plan_title_main">'+sub.title+'</div>'
				+		'<div class="sub_plan_title_sub">'+config.licensing.currency_marker + numberFormat(sub.price / 100)+'/month</div>'
				+	'</div>'
				+	'<div class="sub_plan_details">'
				+		'<div class="sub_plan_detail">'+page.cleanText(sub.details)+'</div>'
				+	'</div>'
				+	'<div class="sub_plan_button">'
				+		'<div class="sub_plan_addtocart"><img class="faux_button" src="images/shoppingcart/select-plan.png"/></div>'
				+	'</div>'
				+	'<div class="clr"></div>'
				+ '</div>'
			);

			//pad the details depending on it's height
			$j('#sub_plan_'+sub.id+' .sub_plan_detail').css('margin-top', 38 - $j('#sub_plan_'+sub.id+' .sub_plan_detail').height() * 8 / 15);

			if(page.user_subscription.status && page.user_subscription.status == 'active') {
				if(sub.id == page.user_subscription.plan) {
					page.selectPlan(sub.id);

					let baseUrl = siteBaseUrl();
					
					//we already have a plan, let's update the checkout box
					$j('.sub_cart_top_text').html('Your subscribed plan:');
					$j('.sub_cart_checkout').html('You are already subscribed to a plan. Click <a href="'+baseUrl+'/dashboard?p=subscription">here</a> to manage or upgrade it.');
				}
			} else {
				$j('#sub_plan_'+sub.id).on('click', function() {
					page.selectPlan(sub.id);
				});
			}
		});

		$j('#checkout_button').on('click', function() {
			console.log('checkout button!');
			if(!page.selected_plan) {
				sa.notify({ text : 'Please select a plan to continue.' });
				return;
			}

			if(sa.components.shoppingCart.count()) {
				//The theory here is that they probably got to this page from the shopping cart, and we don't want to clear it, just archive them
				sa.components.shoppingCart.overrideItems();
			}

			if(sa.components.shoppingCart.addItem({type:'subscription', id:page.selected_plan.id, price:page.selected_plan.price})) {
				document.location.href = '#shopping_cart';
			} else {
				window.location.href = getSecureLoginLink();
			}
		});
	};

	this.selectPlan = function(subid) {
		var sub = config.licensing.subscriptions[subid];
		page.selected_plan = sub;

		//clear selection of other plans
		$j('.sub_plan').removeClass('selected');
		$j('.sub_plan_addtocart img').attr('src', 'images/shoppingcart/select-plan.png');
		$j('#sub_plan_'+sub.id).addClass('selected');
		$j('#sub_plan_'+sub.id).find('.sub_plan_addtocart img').attr('src', 'images/shoppingcart/plan-selected.png');

		$j('.sub_cart_selected_plan').html(sub.title);
		$j('.sub_cart_selected_price').html(config.licensing.currency_marker + numberFormat(sub.price / 100)+'/month');
	};

	/**
	 * Generates the basic page frame
	 * @param {string} params the parameters for the page
	 */
	this.show = function(params) {
		//is this page outdated?
		if (config.licensingConfig && config.licensingConfig.show) {
			sa.currentPage = null;
			window.location.href = '/subscriptions';
			setTimeout(function() { sa.router.reloadPage(); }, 100);
			return;
		}

		var v = sa.router.paramsToVars(params),
			requestedSection = v.section,
			body = $j('#body').html('<div id="subscription_body"><div id="subscription_container" class="max_width"></div><div class="clr"></div></div>'),
			container = $j('#subscription_container');

		page.container = container;
		page.vars = v;

		//is this page outdated?
		if (config.licensingConfig && config.licensingConfig.show) {
			window.location.href = '/subscriptions';
			return;
		}

		//let's make sure licensing is turned on for them
		if (!config.licensing || !config.licensing.subscriptions) {
			container.html('This workspace does not have online licensing subscriptions activated.');
			return;
		}
		showLoader(container[0], 'Loading Subscription Sign Up');

		sa.router.routeTo('/subscription-signup?' + sa.router.queryParamsToString(params));
		sa.currentPage = this;

		console.log('requested section was:', requestedSection);

		switch(requestedSection) {

			default:
			this.section = 'show_plans';
			this.after_load = page.showPlans;
			break;
		}

		this.preloadData();
	};

	this.cleanText = function(str) {
		if (typeof str !== 'string') return '';

		return str.replace( /(<([^>]+)>)/ig, '');
	};
	
	return {
		title: page.title,
		name: page.name,
		register: page.register,
		show: page.show
	};
}

sa.pages.subscriptionSignUpPage = new SubscriptionSignUpPage();
function SubscriptionsPage() {
	//private vars
	var page = this;
	page.name = 'subscriptions';
	page.title = "Subscriptions";
	
	page.register = {
		hash: '#!subscriptions',
		routes: [{
			name: 'subscriptions',
			pattern: '/subscriptions',
			hash: '#!subscriptions'
		}]
	};

	//public vars
	this.container = null;
	this.section = null;
	this.vars = null;
	this.after_load = null;
	this.loaded = {};
	this.license_config = null;
	this.selected_plan = null;
	this.user_subscription = null;


	/**
	 * Generates the basic page frame
	 * @param {string} params the parameters for the page
	 */
	this.show = function (params) {
		page.vars = sa.router.paramsToVars(params);

		window.activePage = page;

		page.templates = sa.templates.get('subscriptions_page');
		page.pageTemplate = page.templates.get('page_frame').clone();
		container = $j('<div id="subscriptions-page"></div>');
		clearBody();
		$j('#body').append( container );

		showLoader(container, 'Loading Subscriptions');

		page.container = container;
		//page.vars = v;
		page.fakeTemplate = page.pageTemplate.find('.fake_sub_plan').detach();
		page.planTemplate = page.pageTemplate.find('.sub_plan').detach();

		// let's make sure licensing is turned on for them
		if (!config.licensingConfig.show) {
			container.html('This workspace does not have online licensing activated.');
			return;
		}

		if (config.licensingConfig.processor != 'braintree') {
			container.html('This workspace is not using a processor that can handle subscriptions.');
			return;
		}

		page.loadSubscription();

		sa.currentPage = page;
	};

	this.loadSubscription = async function () {
		const data = await sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'getSubscription'
		});

		console.log(data);
		if (data) {
			page.sub = data;
		}
		page.render();
			
	};

	this.render = function () {

		// page stuff
		page.container.html( page.pageTemplate );

		if (config.licensingConfig.coupons_active) {
			page.container.find('#sub_coupon_box').show();
			page.container.find('#sub_coupon_box .button').on('click',  page.couponClick );
			page.container.find('#sub_coupon_box input').on('keydown', function (e) {
				if (e.keyCode == 13) page.couponClick();
			});
		}

		var ops = config.licensingConfig.subscriptions_options || {};
		page.container.find('.subscription_title').html( ops.page_title || 'Choose a Subscription Plan' );
		page.container.find('.subscription_subtitle').html( ops.page_subtitle || '');
		page.container.find('.sub_disclaimer').html( ops.page_sideinfo || page.defaultSideInfo );

		// plans
		var showPlans = page.parseShowPlansQuery();
		_.each(config.licensingConfig.plans, plan => {
			var billingFrequency = plan.billing_frequency;
			if (billingFrequency > 12) return;
			var showPlanOverride = showPlans.indexOf(plan.id) > -1;
			var showHiddenPlan = false;
			if (plan.hidden && plan.braintree_id && page.sub && plan.id === page.sub.subscription.plan) showHiddenPlan = true;
			if (showPlanOverride || !plan.hidden || (plan.hidden && showHiddenPlan)) {
				var pdiv = page.planTemplate.clone();
				if (plan.id === page.sub.subscription.plan) {
					pdiv.addClass('active-sub');
				}
				pdiv.find('.sub_plan_title_main').html(htmlEncode(plan.title));
				pdiv.find('.sub_plan_title_sub').html(plan.subtitle || (plan.price / 100).currencyFormat() + ' / ' + page.parseBillingFrequency(billingFrequency));
				pdiv.find('.sub_plan_detail').html(page.cleanDetails(plan.description));
				if (plan.braintree_id) {
					pdiv.find('.sub_plan_addtocart').on('click', () => {
						page.planClick(plan);
					});
					if (page.sub && plan.id === page.sub.subscription.plan) {
						pdiv.find('.sub_plan_addtocart').remove();
						pdiv.find('.sub_plan_chosen').show();
					}
				} else {
					pdiv.find('.sub_plan_addtocart').html(htmlDecode(plan.action));
					pdiv.find('.sub_plan_addtocart').on('click', () => {
						window.location.href = plan.url;
					});
				}

				page.container.find('.subscription_plans').append(pdiv);
			}
		});
	};
	
	
	
	this.parseShowPlansQuery = function () {
		var showPlans = window.location.href.split(/show=(\d+)(,\d+)*/g);
		return showPlans.filter(function (plan) {
			return typeof plan === 'string';
		}).map(function (plan) {
			return parseInt(plan.replace(',', ''));
		}).filter(function (plan) {
			return plan > 0;
		});
	};
	
	this.parseBillingFrequency = function (frequency) {
		if (frequency === 1) {
			return 'month';
		} else if (frequency > 1 && frequency < 12) {
			return frequency + ' ' + 'months';
		} else if (frequency === 12) {
			return 'year';
		} else {
			return 'billing period';
		}
	};

	this.parseShowPlansQuery = function () {

		const qs = new URLSearchParams(window.location.search);
		const show = qs.get('show');
		if (show) {
			return show.split(',').map(plan => parseInt(plan));
		}

		return [];
	};

	this.couponClick = async function () {

		if (!user.logged) {

			sa.confirm({
				text: 'Log In or Sign Up to subscribe!',
				yesFunction() {
					document.location.href = 'login.php';
				},
				yesText: 'Log In',
				noFunction() {
					document.location.href = 'signup.php';
				},
				noText: 'Sign Up'
			});
			return;
		}

		var code = page.container.find('#sub_coupon_box input').val();
		if (!code) return sa.notify({ text: 'No code entered.' });

		console.log('- submitting code:', code);
		const data = await sa.api.request({
			handler: 'licensing/licensingCoupons',
			action: 'submitCoupon',
			postData: {
				code
			}
		});

		console.log('- coupon response:', data);

		if (data.error) return sa.notify({ text: data.error });
		if (data.success) {
			if (data.coupon) return sa.notify({ text: 'This is a percent off coupon and should be applied in your shopping cart.' });
			if (data.amount) return sa.notify({ text: data.amount + ' downloads were added to your account.' });
		}
		if (data.subscriptionCoupon) {
			purchaseModal.show('licensing_subscription', page.handlePurchase, code, data.plan, true);
		}
			
	};

	this.planClick = function (plan) {
		console.log('- showing purchaser for', plan.title);

		if (!user.logged) {

			sa.confirm({
				text: 'Log In or Sign Up to subscribe!',
				yesFunction() {
					document.location.href = 'login.php';
				},
				yesText: 'Log In',
				noFunction() {
					document.location.href = 'signup.php';
				},
				noText: 'Sign Up'
			});
			return;
		}

		if (page.sub && plan.price < page.sub.subscription.price) {
			var loseUnlimited = 'Do you want to downgrade your subscription? Your unlimited plan will be replaced with the downgraded plan and you will not be refunded for any portion of the remaining month.';
			var downgrade = 'Do you want to downgrade your subscription? You will not be refunded, but your next month\'s fee will be the new price. You will not lose any downloads you have already paid for.';
			sa.confirm({
				text: page.sub.subscription.downloads == 99999 ? loseUnlimited : downgrade,
				yesFunction() {
					page.downgradeToPlan( plan );
				},
				yesText: 'Yes'
			});
			return;
		}

		purchaseModal.show('licensing_subscription', page.handlePurchase, 1, plan, true);
	};

	this.downgradeToPlan = async function (plan) {
		const data = await sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'downgrade',
			postData: {
				plan: plan.id
			}
		});
		console.log('- downgrade response:', data);
		if (data.error) return sa.notify({ text: data.error });

		page.show();
	};

	this.handlePurchase = function (r) {
		console.log('- handle purchase:', r);
		if (r) {
			sa.router.routeTo('/dashboard?p=licensing-subscription');
		}
	};

	this.cleanDetails = function (text) {
		var a = htmlDecode(text).split('\n');
		a = _.map(a, function (l) {
			if (l.substr(0, 2) == '- ') {
				return '<li>' + l.substr(2) + '</li>';
			} else {
				return l + '<br>';
			}
		});

		return a.join('');
	};

	this.defaultSideInfo = '<b>Please read before you download:</b><br>Your payment grants you, as an individual, the right to download and use these sound effects in commercial productions, per our <span>End User License Agreement</span>.<BR><BR>Your downloads will be available immediately after your payment has been processed.';
	
	return page;
}

sa.pages.subscriptionsPage = new SubscriptionsPage();
/**
 * Allows coupon entry and credit stats
 */
function CouponEntryPage() {
	//private vars
	var page = this;
	
	page.register = {
		routes: [{
			pattern: '/coupon-entry',
			hash: '#!coupon_entry',
			name: 'coupon-entry'
		}]	
	};

	//public vars
	page.container = null;
	page.section = null;
	page.vars = null;
	page.after_load = null;
	page.loaded = {};
	page.saved_payment_data = null;
	page.license_config = null;
	page.user_subscription = null;
	page.user_coupon_credit = null;
	page.name = 'coupon_entry';

	page.preloadData = function() {
		page.loaded.preload_requests = false;
		page.loadUserCredit();
		page.loaded.preload_requests = true;
	};

	page.isPreloaded = function() {
		//return (page.tracks_loaded && config.licensing && page.saved_payment_data && !page.license_id) || (page.license && config.licensing && page.tracks_loaded);

		var preloaded = true;
		$j.each(page.loaded, function(to_load, isLoaded) {
			//console.log('-- preload status:', to_load, isLoaded);
			if(!isLoaded) {
				//console.log('-- preload status: NOT LOADED.');
				preloaded = false;
				return false;
			}
		});

		return preloaded;
	};

	/**
	 * load user subscription
	 */

	page.loadUserCredit = async function() {
		page.loaded.user_credit = false;
		const response = await sa.api.request({
			handler: 'licensing/licensingCoupons',
			action: 'loadUserCredit',
			getData: {
				cacheBreak: new Date().getTime(),
			}
		});
	
		console.log('response for user credit was:', response);

		if (response.error) {
			sa.notify({ text : response.error });
			return;
		}
		page.user_subscription = response.subscription;
		page.user_coupon_credit = response.coupon_credit;
		page.loaded.user_credit = true;
		if(page.isPreloaded()) page.after_load();
	};

	/**
	 * Show login and signup link
	 */

	page.showNonLogged = function() {
		//get the shopping cart items


		page.container.html(
			'<div id="coupon_header">'
			+		'<div class="coupon_header_title">' + 'Coupon Entry' + '</div>'
			+	'</div>'
			+	'<div id="coupon_body">'
			+		'<div class="coupon_box">'
			+			'<div class="coupon_box_title">' + 'Not Logged In' + '</div>'
			+			'<div class="coupon_box_desc" style="font-size: 18px;">' + 'If you have received a code and would like to redeem it, please' + '</div>'
			+			'<div id="coupon_login" class="coupon_box_submit button faux_button" style="margin-top: 10px; margin-bottom: 10px;">' + 'Log In' + '</div>'
			+			'<div class="coupon_box_desc">' + 'or' + '</div>'
			+			'<div id="coupon_signup" class="coupon_box_submit button faux_button" style="margin-top: 10px; margin-bottom: 10px;">' + 'Sign Up' + '</div>'
			+		'</div>'
		);

		$j('#coupon_login').on('click', function() {
			window.location.href = getLoginLink();
		});

		$j('#coupon_signup').on('click', function() {
			window.location.href = getSignupLink();
		});

	};
	/**
	 * Show balance and entry field
	 */

	page.showBalance = function() {
		//get the shopping cart items

		let baseUrl = siteBaseUrl();
		
		page.container.html(
			'<div id="coupon_header">'
			+		'<div class="coupon_header_title">' + 'Coupon Entry' + '</div>'
			+	'</div>'
			+	'<div id="coupon_body">'
			+		'<div class="coupon_added" style="display: none;">' + 'Code accepted and' + ' <span class="amt">X</span> ' + 'download credits have been added to your balance.' + '</div>'
			+		'<div class="coupon_balance" style="display:none;">' + 'Your current download balance' + ': <span class="coupon_balance_val">-</span></div>'
			+		'<div class="coupon_box">'
			+			'<div class="coupon_box_title">' + 'Enter your code' + '</div>'
			+			'<div class="coupon_box_desc">' + 'Enter it here to credit your account.' + '</div>'
			+			'<div class="coupon_box_input"><input type="text"/></div>'
			+			'<div class="coupon_box_submit button faux_button">' + 'Submit' + '</div>'
			+		'</div>'
			+		'<div class="coupon_disclaimer">' + 'Interested in learning more about our codes and offers?' + ' <a href="'+baseUrl+'/feedback">' + 'Contact us'
			+ '</a> ' + 'now and one of our team members will get back to you!' + '</div>'
		);

		//assign balance
		if(page.user_coupon_credit) {
			$j('.coupon_balance_val').html(page.user_coupon_credit.downloads);
		} else {
			$j('.coupon_balance_val').html('0');
		}

		//coupon entry triggers
		$j('.coupon_box_submit').on('click', function() {
			var code = $j('.coupon_box_input input').val();
			code = code.toUpperCase();
			$j('.coupon_box_input input').val(code);
			console.log('-- applying coupon code:', code);
			$j('.coupon_box_input input').prop('disabled', true);

			sa.api.request({
				handler: 'licensing/licensingCoupons',
				action: 'applySubscriptionCouponCode',
				postData: {
					code: code,
				}
			}).then(page.applyCodeHandler);
		});
		$j('.coupon_box_input input').on('keypress', function(e) {
			if(e.which == 13) $j('.coupon_box_submit').trigger('click');
		});
	};

	page.handlePurchase = function (r) {
		console.log('- handle purchase:', r);
		if (r) {
			sa.router.routeTo('/dashboard?p=licensing-subscription');
		}
	};

	page.applyCodeHandler = function(response) {
		console.log('apply code response:', response);

		if (response.subscriptionCoupon) {
			console.log('subscription coupon --show purchase modal.');
			return purchaseModal.show('licensing_subscription', page.handlePurchase, response.sub_coupon, response.plan, true);
		}

		if (response.success) {
			page.coupon_applied = true;
			$j('.coupon_added').show();
			$j('.coupon_added .amt').html(response.amount);
			$j('.coupon_balance_val').html((page.user_coupon_credit ? page.user_coupon_credit.downloads : 0) + response.amount);
			$j('.coupon_box_input input').prop('disabled', false);
		} else if(response.error) {
			$j('.coupon_box_input input').prop('disabled', false);
			sa.alert({ text : 'Error: ' + response.error });
		}
	};

	/**
	 * Generates the basic page frame
	 * @param {string} params the parameters for the page
	 */
	page.show = function(params) {
		var v = sa.router.paramsToVars(params),
			requestedSection = v.section,
			body = $j('#body').html('<div id="coupon_entry_body"><div id="coupon_entry_container" class="max_width"></div><div class="clr"></div></div>'),
			container = $j('#coupon_entry_container');

		page.container = container;
		page.vars = v;

		page.license_id = (v.license_id) ? v.license_id : null;
		page.subscription_id = (v.sub_id) ? v.sub_id : null;

		if(!user.logged) {
			page.showNonLogged();
			return;
		}

		showLoader(container[0], 'Loading Coupon Entry...');

		sa.router.routeTo('/coupon-entry?' + sa.router.queryParamsToString(params));
		sa.currentPage = this;

		console.log('requested section was:', requestedSection);

		switch(requestedSection) {

			case 'show_balance':
			page.section = 'show_balance';
			page.after_load = page.showBalance;
			break;

			default:
			page.section = 'show_balance';
			page.after_load = page.showBalance;
			break;
		}

		page.preloadData();
	};
	
	return {
		title: page.title,
		name: page.name,
		show: page.show,
		register: page.register
	}
}

sa.pages.couponEntryPage = new CouponEntryPage();

function CustomPage() {
	
	let pageId;
	
	var p = this;
	/** @var {{ id : int, body : string, title : string, hideLeftNav : int, removePadding : int }} pageData */
	var pageData = null;
	
	this.name = 'custom';
	
	this.show = function(params) {
		pageId = sa.router.paramsToVars(params).pageId;
		
		// set up the basic frame for the page
		var container = $j('<div id="custom_page" class="max_width"></div>');
		clearBody(true);
		var body = $j('#body').append(container);
		// see if we need to load
		if (pageData && pageId === pageData.id) {
			this.showPageData(pageData);
		} else {
			this.loadPageData();
		}
		
		sa.currentPage = this;
	};
	
	this.loadPageData = function() {
		ajax('p=custom_page&pageId=' + pageId, function(response) { p.showPageData(response); });
	};
	
	this.showPageData = function(newPageData) {
		let container = $j('#custom_page').empty();
		pageData = Array.isArray(newPageData) ? newPageData[0] : (newPageData || null);
		if (pageData.hideLeftNav) {
			sa.components.leftNav.hide();
			container.append('<div class="custom_page_container"></div><div class="clr"></div>');
			//sa.components.selector.hide();
		} else {
			sa.components.leftNav.show();
			sa.components.leftNav.disableAll();
			container.append('<div id="right_content" class="right_content custom_page_container padded_right_content"></div><div class="clr"></div>');
		}
		let contentContainer = container.find('.custom_page_container');
		if (pageData.removePadding) {
			contentContainer.addClass('without_padding');
		}
		contentContainer.append(cleanCkeditorOutput(pageData.body));
		setTitle(pageData.title);
	};
	
	p.register = {
		routes: [{
			pattern: '/custom-page/:int/:any?',
			hash: '#!custom_page',
			id: 'pageId',
			name: 'custom-page'
		}, {
			pattern: '/custom/:int/:any?',
			hash: '#!custom',
			id: 'projectId',
			name: 'custom',
			cb: (params) => {
				if (window['showCustomPage']) {
					showCustomPage(params);
					return false;
				} else {
					console.log('cannot show custom page because function showCustomPage does not exist');
					return true;
				}
			}
		}]
	};
	
	p.title = 'Custom Page';
	p.name = 'custom-page';
	
	return p;
}

sa.pages.customPage = new CustomPage();
function PlaylistManager() {
	let templates;
	var CONTEXT_MENU_EVENT_NAMESPACE = '.contextMenu',
		DEFAULT_DRAGGABLE_OPTIONS = {
			cursorAt: { top: 8, left: 8 },
			helper: createItemDraggableHelper,
			//helper: 'clone',
			start: dimDraggableSourceElement,
			stop: brightenDraggableSourceElement
		},
		DEFAULT_DROPPABLE_OPTIONS = {
			activeClass: "pm-valid-droppable-item",
			greedy: true,
			hoverClass: "pm-active-droppable-item"
		},
		PLAYLIST_ITEMS_PER_PAGE = 1000,
		MAGIC_CSS_TOP_HIDING_VALUE = "-9999px",
        page = this,
		SortMethod = function (icon, sortFunction) {
			this.icon = icon;
			this.sortFunction = sortFunction;
		}, PlaylistItemRequest = function (playlistId, loaderContainer, pageNumber) {
			if (undefined === pageNumber) {
				pageNumber = 0;
			}

			this.getPlaylistId = function () { return playlistId; };
			this.getLoaderContainer = function () { return loaderContainer; };
			this.getPageNumber = function () { return pageNumber; };
		};

	//<editor-fold desc="Folder Functions">
	function getFolderSortDirection()
	{
		return $j("#pm-folder-sort-icon").data("sort-direction");
	}

	function generateFolderSort()
	{
		var sortType = $j("#pm-folder-sort option:selected"),
			playlistCounts = {},
			sortFunction;

		function getPlaylistCount(playlist) {
			return playlistCounts.hasOwnProperty(playlist.id) ? playlistCounts[playlist.id] : 0;
		}

		switch (sortType.val()) {
			case "playlist_count":

				$j.each(user.getProjectArray(), function (index, playlist) {
					var folderId = playlist.folderId;

					if (!playlistCounts.hasOwnProperty(folderId)) {
						playlistCounts[folderId] = 1;
					} else {
						playlistCounts[folderId]++;
					}
				});

				if ("asc" === getFolderSortDirection()) {
					sortFunction = function (a, b) {
						return getPlaylistCount(a) - getPlaylistCount(b);
					};
				} else {
					sortFunction = function (a, b) {
						return getPlaylistCount(b) - getPlaylistCount(a);
					};
				}
				break;
			default:
				if ("asc" === getFolderSortDirection()) {
					sortFunction = function (a, b) {
						return a.name.localeCompare(b.name);
					};
				} else {
					sortFunction = function (a, b) {
						return b.name.localeCompare(a.name);
					};
				}
		}

		return new SortMethod(sortType.data("sort"), sortFunction);
	}

	function drawFolders(callback)
	{
		function draggableIsOnLeftEdgeOfContainer(ui)
		{
			return ui.position.left < 3;
		}

		user.reloadProjects(function () {
			var folderContainer = $j(templates.get("folder_container")),
				debouncedDeactivateEventSuccessInvoker = _.debounce(function (callback, args) {
					callback(args);
				}, 500, true),
				i, folderCopy, folderSort;


			if (user.projectFolders.length > 0) {
				folderCopy = user.projectFolders.slice();
				folderSort = generateFolderSort();

				folderCopy.sort(folderSort.sortFunction);
				for (i = 0; i < folderCopy.length; i++) {
					folderContainer.append(drawSingleFolder(folderCopy[i]));
				}

				$j("li:not([data-item-id=0])", folderContainer).draggable($j.extend({}, DEFAULT_DRAGGABLE_OPTIONS, {
					appendTo: ".pm-folders-container",
					drag: function (event, ui) {
						var topLevelNotice = $j(".pm-folder-top-level-notice");

						if (draggableIsOnLeftEdgeOfContainer(ui)) {
							$j(topLevelNotice).removeClass("pm-closed");
						} else if (!$j(topLevelNotice).hasClass("pm-closed")) {
							hideTopLevelFolderDropNotice();
						}
					},
					containment: ".pm-folders-container",
					scope: "pm-folder"
				}));

				$j("li", folderContainer).droppable($j.extend({}, DEFAULT_DROPPABLE_OPTIONS, {
					accept: function (draggable) {
						if ("folder" === draggable.data("type")) {
							return !$j(draggable).has(this).length;
						}
						return true;
					},
					deactivate: function (event, ui) {
						var onDropFunction;

						// If the draggable ended up on the left edge of the UI, fake a call to the
						// drop function with a parent item id of -1. This will put the folder on
						// the top level.
						if ("folder" === ui.draggable.data("type") && draggableIsOnLeftEdgeOfContainer(ui)) {
							onDropFunction = $j(this).droppable("option", "drop");

							if ("function" === typeof onDropFunction) {
								debouncedDeactivateEventSuccessInvoker(function (context) {
									onDropFunction.call($j('<li data-item-id="-1" data-type="folder"></li>'), context.event, context.ui);
								}, {event: event, ui: ui});
							}
						}
					},
					drop: function (event, ui) {
						switch (ui.draggable.data("type")) {
							case "folder":
								if (!draggableIsOnLeftEdgeOfContainer(ui)) {
									reparentFolder($j(ui.draggable).data("itemId"), $j(this).data("itemId"));
								}
								break;
							case "playlist":
								movePlaylistToFolder($j(ui.draggable).data("itemId"), $j(this).data("itemId"));
								break;
						}
					},
					over: function (event, ui) {
						var activeParents = $j(this).parents(".pm-active-droppable-item");

						if ($j(this).find(".pm-active-droppable-item").length) {
							$j(this).removeClass("pm-active-droppable-item");
						} else if (activeParents.length) {
							$j(activeParents).removeClass("pm-active-droppable-item");
						}
					},
					scope: "pm-folder"
				}));

				$j("#folders .pm-folders-container").find(".pm-folders-containment").remove();
				$j("#folders .pm-folders-container").append(folderContainer);
				$j("#pm-folder-sort-icon").attr("class", "fa " + folderSort.icon + "-" + getFolderSortDirection());
			}

			if ("function" === typeof callback) {
				callback();
			}
		});
	}

	function drawSingleFolder(folder)
	{
		if (!$j.isPlainObject(folder)) {
			throw "Argument passed to drawFolder must be a plain object.";
		}

		var folderElem = $j(templates.get("item", {
				itemId: folder.id,
				icon: "fa-folder-open-o",
				name: (folder.hasOwnProperty("name") ? folder.name : "Untitled Folder"),
				type: "folder"
			})),
			childContainer, i, childrenCopy, childrenSort;

		if (folder.hasOwnProperty("subfolders") && Array.isArray(folder.subfolders) && folder.subfolders.length > 0) {
			childContainer = $j(templates.get("folder_container"));
			childrenCopy = folder.subfolders.slice();
			childrenSort = generateFolderSort();

			childrenCopy.sort(childrenSort.sortFunction);
			for (i = 0; i < childrenCopy.length; i++) {
				childContainer.append(drawSingleFolder(childrenCopy[i]));
			}
			folderElem.append(childContainer);
		}

		return folderElem;
	}

    function getFolderById(folderId)
	{
		function checkFolderArray(folders)
		{
			var folderToReturn = null;

			$j.each(folders, function (index, folder) {
				if (folderId === folder.id) {
					folderToReturn = folder;
					return false;
				} else if (folder.hasOwnProperty("subfolders") && Array.isArray(folder.subfolders)) {
					folderToReturn = checkFolderArray(folder.subfolders);
					if (null !== folderToReturn) {
						return false;
					}
				}
			});

			return folderToReturn;
		}

		return checkFolderArray(user.projectFolders);
	}

	function reparentFolder(folderId, parentFolderId)
	{
		var folder = getFolderById(folderId),
			parentFolder = getFolderById(parentFolderId);

		hideTopLevelFolderDropNotice();

		if (null === folder) {
			sa.notify({ text : createText("There was a problem moving the folder: could not find the specified folder. Reloading...") });
			drawFolders();
		} else if (-1 !== parentFolderId && null === parentFolder) {
			// -1 is a magic folder id, meaning that the folder lives at the top level of the hierarchy
			sa.notify({ text : createText("There was a problem moving the folder: could not find the specified parent folder. Reloading...") });
			drawFolders();
		} else if (parentFolderId !== folder.parentFolderId) {
			ajax({
				u: user.userData.id,
				id: folderId,
				name: folder.name,
				description: folder.description,
				folderId: parentFolderId
			}, function (response) {
				processProjectsEndpointResponse(response);
				drawFolders();
			}, 'POST', "p=projects&action=edit_folder");
		}
	}

	function hideTopLevelFolderDropNotice()
	{
		$j(".pm-folder-top-level-notice").addClass("pm-closed");
	}

	//</editor-fold>

	//<editor-fold desc="Context Menu Functions">
	function hideContextMenu(menu)
	{
        $j(menu).css("top", MAGIC_CSS_TOP_HIDING_VALUE);
		$j(document).off(CONTEXT_MENU_EVENT_NAMESPACE);
		$j(".pm-force-visible").removeClass("pm-force-visible").children(".pm-options:not(.pm-hover)").removeClass("show-option");
	}

	function handleOptionsClick(clickedOption, menuDecorationCallback)
	{
		var paneContainer = $j(clickedOption).closest(".pm-pane-container"),
			itemContainer = $j(clickedOption).closest(".pm-pane-item-container"),
			menu = $j(".pm-menu", paneContainer),
			itemId = $j(clickedOption).closest("li").data("item-id");

		if (!$j(itemContainer).hasClass("pm-force-visible")) {
            menu.data("item-id", itemId);

			if ("function" === typeof menuDecorationCallback) {
				menuDecorationCallback(menu, itemId);
			}

			menu.position({
				my: "right top",
				at: "right bottom",
				of: clickedOption,
				within: paneContainer.closest(".pm-pane"),
				collision: "flipfit"
			});
			itemContainer.addClass("pm-force-visible");

			$j(document).on("click" + CONTEXT_MENU_EVENT_NAMESPACE, function (e) {
				var target = e.target;
                if (!$j(clickedOption).is(target)) {
					hideContextMenu(menu);

					if ($j(target).hasClass("pm-options")) {
						e.stopPropagation();
						handleOptionsClick(target);
						return false;
					}
				}

				return true;
			});

			$j(document).on("pm:escapeKey" + CONTEXT_MENU_EVENT_NAMESPACE, function () {
				hideContextMenu(menu);
			});
		} else {
			hideContextMenu(menu);
		}

		return false;
	}
	//</editor-fold>

	//<editor-fold desc="Playlist Functions">
	function getPlaylistsByFolderId(folderId)
	{
		var playlists = [];

		$j.each(user.getProjectArray(), function (index, playlist) {
			if (folderId == playlist.folderId) {
				playlists.push(playlist);
			}
		});

		return playlists;
	}

	function drawPlaylists(folderId)
	{
		var playlists = getPlaylistsByFolderId(folderId),
			folder = getFolderById(folderId),
			container = $j(".pm-playlists-container"),
			list, sortMethod;

		$j(container).find(".pm-playlists-containment").remove().end().find("h2").remove();
		if (0 === playlists.length) {
			$j(container).append(templates.get("zero_playlists", {
				folderName: null === folder ? "(Unknown)" : folder.name
			}));
		} else {
			$j(container).append($j(templates.get("playlists")));
			list = $j(container).find("ul");
			sortMethod = generatePlaylistSort();

			playlists.sort(sortMethod.sortFunction);
			$j.each(playlists, function (index, playlist) {
				var html = $j(templates.get("item", {
					itemId: playlist.id,
					icon: "fa-list",
					name: playlist.name,
					type: "playlist"
				}));

				$j(list).append(html);
			});

			$j("li", container).draggable($j.extend({}, DEFAULT_DRAGGABLE_OPTIONS, {
				appendTo: "body",
				scope: "pm-folder"
			}));
			$j("li", container).droppable($j.extend({}, DEFAULT_DROPPABLE_OPTIONS, {
				accept: function (draggable) {
					var parentId = getSelectedParentId(draggable),
						droppableId = $j(this).data("item-id");

					return parentId !== droppableId;
				},
				drop: function (event, ui) {
					attemptPlaylistAddition(ui.draggable, $j(this).data("item-id"));
				},
				scope: "pm-playlist"
			}));
			$j("#pm-playlist-sort-icon").attr("class", "fa " + sortMethod.icon + "-" + getPlaylistSortDirection());
		}

		removePlaylistItems();
	}

	function getPlaylistById(playlistId)
	{
		var returnedPlaylist = null;

		$j.each(user.getProjectArray(), function (index, playlist) {
			if (playlistId == playlist.id) {
				returnedPlaylist = playlist;
				return false;
			}
		});

		return returnedPlaylist;
	}

	function generatePlaylistSort()
	{
		var sortType = $j("#pm-playlist-sort option:selected"),
			sortParameter = $j(sortType).val(),
			sortDirection = getPlaylistSortDirection();

		return new SortMethod(sortType.data("sort"), function (a, b) {
			var aParameter, bParameter, typeofAParameter, typeofBParameter;

			if (a.hasOwnProperty(sortParameter) && b.hasOwnProperty(sortParameter)) {
				aParameter = a[sortParameter];
				bParameter = b[sortParameter];
                typeofAParameter = typeof aParameter;
                typeofBParameter = typeof bParameter;

				if (typeofAParameter === typeofBParameter) {
					switch (typeofAParameter) {
						case "number":
							if ("asc" === sortDirection) {
								return aParameter - bParameter;
							}
							return bParameter - aParameter;
						case "string":
							if ("asc" === sortDirection) {
								return aParameter.localeCompare(bParameter);
							}
							return bParameter.localeCompare(aParameter);
					}
				}
			}

			return 0;
		});
	}

	function getPlaylistSortDirection()
	{
		return $j("#pm-playlist-sort-icon").data("sort-direction");
	}

	function movePlaylistToFolder(playlistId, folderId)
	{
		var playlist = getPlaylistById(playlistId),
			folder = getFolderById(folderId);

		if (null === playlist) {
			sa.notify({ text : createText("Could not find specified playlist.") });
		} else if (-1 !== folderId && null === folder) {
			sa.notify({ text : createText("Could not find specified folder.") });
		} else if (playlist.folderId !== folderId) {
			ajax({
				u: user.userData.id,
				projectId: playlistId,
				name: playlist.name,
				description: playlist.description,
				folderId: folderId
			}, function (response) {
				processProjectsEndpointResponse(response);
				user.reloadProjects(function () {
					$j('[data-type="folder"][data-item-id="' + folderId + '"]').find(".pm-pane-item-container").trigger('click');
				});
			}, "POST", "p=projects&action=change_details");
		}
	}

	function attemptPlaylistAddition(playlistItemDraggable, destinationPlaylistId)
	{
		var sourcePlaylistId = $j(".pm-selected").closest("[data-type='playlist']").data("item-id"),
			playlistItemId = $j(playlistItemDraggable).data("item-id"),
			playlistItemType = $j(playlistItemDraggable).data("type"),
			sourcePlaylist = getPlaylistById(sourcePlaylistId),
			destinationPlaylist = getPlaylistById(destinationPlaylistId);

		function triggerPlaylistReload(playlistId)
		{
			$j('li[data-type="playlist"][data-item-id=' + playlistId + '] .pm-pane-item-container').trigger('click');
		}

		if (null === sourcePlaylist) {
			sa.notify({ text : createText("Could not find the playlist where the dragged item came from.") });
		} else if (null === destinationPlaylist) {
			sa.notify({ text : createText("Could not find the playlist the dragged item was supposed to go to.") });
		} else if (sourcePlaylistId !== destinationPlaylistId) {
			fetchPlaylistItems(
				new PlaylistItemRequest(destinationPlaylistId),
				function (destinationPlaylistItems) {
					var destinationHasPlaylistItem = _.some(destinationPlaylistItems, function (destinationPlaylistItem) {
						return destinationPlaylistItem.hasOwnProperty(playlistItemType) && destinationPlaylistItem[playlistItemType].id == playlistItemId;
					}), movedPlaylistItemRepresentation = playlistItemType + "-" + playlistItemId;

					removeItemFromPlaylist(playlistItemId, playlistItemType, sourcePlaylistId);

					// The destination playlist cannot contain the item that is being requested for addition.
					if (destinationHasPlaylistItem) {
						destinationPlaylistItems = _.without(_.map(destinationPlaylistItems, function (playlistItem) {
							if (playlistItem.hasOwnProperty("track")) {
								return "track-" + playlistItem.track.id;
							} else if (playlistItem.hasOwnProperty("album")) {
								return "album-" + playlistItem.track.id;
							}
						}), movedPlaylistItemRepresentation).unshift(movedPlaylistItemRepresentation);

						ajax({
							u: user.userData.id,
							newOrder: destinationPlaylistItems,
							page: $j(playlistItemDraggable).closest("ul").data("page"),
							perPage: PLAYLIST_ITEMS_PER_PAGE
						}, function (response) {
							processProjectsEndpointResponse(response);
							triggerPlaylistReload(sourcePlaylistId);
						}, "POST", "p=projects&action=reorder_page");
					} else {
						addItemToPlaylist(playlistItemId, playlistItemType, destinationPlaylistId, function () {
							triggerPlaylistReload(sourcePlaylistId);
						});
					}
				}
			);
		}
	}

	function addOrRemoveItemFromPlaylist(itemType, itemId, playlistId, endpoint, callback)
	{
		var requestVariables = {
			u: user.userData.id,
			projectId: playlistId
		};

		if ("track" === itemType) {
			requestVariables.trackIds = [itemId];
		} else if ("album" === itemType) {
			requestVariables.albumIds = [itemId];
		}

		ajax(requestVariables, function (response) {
			processProjectsEndpointResponse(response);
			if ("function" === typeof callback) {
				callback(response);
			}
		}, "POST", "p=projects&action=" + endpoint)
	}

	function removeItemFromPlaylist(itemId, itemType, playlistId)
	{
		addOrRemoveItemFromPlaylist(itemType, itemId, playlistId, "remove_items");
	}

	function addItemToPlaylist(itemId, itemType, playlistId, callback)
	{
		addOrRemoveItemFromPlaylist(itemType, itemId, playlistId, "add_items", callback);
	}

	function applyPlaylistsFilter(filterText)
	{
		var filterMatches = 0,
			filterContainer = $j(".pm-filter-container"),
			topLevelNotice = $j(".pm-playlists-top-level-notice"),
			totalPlaylists = $j("#playlists li").length;

		if (filterText.length > 0) {
			$j(".fa", filterContainer).removeClass("fa-search").addClass("fa-times-circle");
		} else {
			$j(".fa", filterContainer).addClass("fa-search").removeClass("fa-times-circle");
		}

		filterText = filterText.toLowerCase();
		$j("#playlists li").each(function (index, li) {
			if (-1 === $j(li).find(".pm-item-name").text().toLowerCase().indexOf(filterText)) {
				$j(li).hide();
			} else {
				filterMatches += 1;
				$j(li).show();
			}
		});

		if (0 === filterMatches) {
			$j(filterContainer).addClass("pm-invalid-filter");
			$j(topLevelNotice).addClass("pm-closed");
			$j("#playlists li").show();
		} else {
			$j(filterContainer).removeClass("pm-invalid-filter");
			$j(topLevelNotice)
				.find(".pm-filtered-count").text(filterMatches).end()
				.find(".pm-total-count").text(totalPlaylists + " playlist" + (1 === totalPlaylists ? "" : "s")).end()
				.find(".pm-hidden-count").text("(" + (totalPlaylists - filterMatches) + " filtered)").end();

			if (filterMatches === totalPlaylists) {
				$j(".pm-hidden-count", topLevelNotice).hide();
				$j(topLevelNotice).addClass("pm-closed");
			} else {
				$j(".pm-hidden-count", topLevelNotice).show();
				$j(topLevelNotice).removeClass("pm-closed");
			}

		}
	}
	//</editor-fold>

	//<editor-fold desc="Playlist Item Functions">
	function renderPlaylistItems(playlistId, items)
	{
		var container = $j(".pm-playlist-items-container"),
			itemList;

		$j(container).append(templates.get("playlist_items"));
		itemList = $j(container).find("ul");

		$j.each(items, function (index, item) {
			$j(itemList).append(renderSinglePlaylistItem(item));
		});

		$j(itemList).data("page", page);
		$j(itemList).sortable({
			axis: "y",
			placeholder: "pm-playlist-item-sortable-placeholder",
			receive: function (event, ui) {
				ui.item.addClass('removed').hide();
			},
			update: function (event, ui) {
				ui.item.draggable(getPlaylistItemsDraggableOptions(itemList));
				ajax({
					u: user.userData.id,
					projectId: playlistId,
					newOrder: _.map($j(itemList).children("li:not(.removed)"), function (li) {
						return $j(li).data("type") + "-" + $j(li).data("item-id");
					}),
					page: 0,
					perPage: PLAYLIST_ITEMS_PER_PAGE
				}, function (response) {
					processProjectsEndpointResponse(response);
					drawPlaylistItems(playlistId);
				}, "POST", "p=projects&action=reorder_page");
			}
		});

		$j("li", container).draggable(getPlaylistItemsDraggableOptions(itemList));

		// TODO: LOAD MORE link
		//if (responseMetadata.count >= 100) {
		//
		//}
	}

	function getPlaylistItemsDraggableOptions(passedItemList) {
		return {
			appendTo: "body",
			connectToSortable: passedItemList,
			cursorAt: {top: 8, left: 8},
			helper: createItemDraggableHelper,
			//helper : 'clone',
			scope: "pm-playlist"
		};
	}

	function drawPlaylistItems(playlistId, page)
	{
		var container = $j(".pm-playlist-items-container");

		if (undefined === page) {
			page = 0;
		}

		fetchPlaylistItems(new PlaylistItemRequest(playlistId, container), function (response) {
			var responseMetadata = response[0],
				playlist;

			$j(container).find(".pm-playlist-items-containment").remove().end().find("h2").remove();
            if (0 === responseMetadata.count) {
				playlist = getPlaylistById(playlistId);

				$j(container).append(templates.get("zero_playlist_items", {
					playlistName: null === playlist ? "(Unknown)" : playlist.name
				}));
			} else {
				renderPlaylistItems(playlistId, response.slice(1));
			}
		});
	}

	function fetchPlaylistItems(playlistItemRequest, callback)
	{
		var options = {
				p: "project_item_info",
				projectId: playlistItemRequest.getPlaylistId(),
				show: PLAYLIST_ITEMS_PER_PAGE
			},
			container = playlistItemRequest.getLoaderContainer();

		if (0 !== playlistItemRequest.getPageNumber()) {
			options.pg = playlistItemRequest.getPageNumber();
		}

        if (undefined !== container) {
			removePlaylistItems();
			$j(container).append(templates.get("playlist_items_loading"));
		}

        ajax(options, function (response) {
			if (undefined !== container) {
				$j(".pm-loading-animation", container).remove();
			}

			callback(response);
		});
	}

	function renderSinglePlaylistItem(item)
	{
		var options = {};

		if (item.hasOwnProperty("track")) {
			options = {
				name: item.track.title,
                icon: "fa-music",
                type: "track",
                itemId: item.track.id
            };
		} else if (item.hasOwnProperty("album")) {
			options = {
				name: item.album.name,
                icon: "fa-dot-circle-o",
                type: "album",
                itemId: item.album.id
			};
		}

		return templates.get("item", options);
	}

	//function renderLoadMorePlaylistItemsButton(responseMetadata)
	//{
	//
	//}

	function removePlaylistItems()
	{
		$j(".pm-playlist-items-containment").remove();
		$j("h2", ".pm-playlist-items-container").remove();
	}
	//</editor-fold>

	function toggleSortDirection(icon)
	{
		$j(icon).data("sort-direction", "asc" === $j(icon).data("sort-direction") ? "desc" : "asc");
	}

	function setSelectedParentId(container, parentId)
	{
		$j(container).closest(".pm-pane").data("parentId", parentId);
	}

	function getSelectedParentId(container)
	{
		return $j(container).closest(".pm-pane").data("parentId");
	}

	//<editor-fold desc="Drag/Drop/Sort UI Functions">
	function createItemDraggableHelper()
	{
		var ghostElement = $j(templates.get("draggable_helper_container"));

		$j(this).children(".pm-pane-item-container").children(".pm-item-icon").clone().appendTo(ghostElement).removeClass("fa-li");
        $j(this).children(".pm-pane-item-container").children(".pm-item-name").clone().appendTo(ghostElement);

		$j(ghostElement).data({
			itemId: $j(this).data("itemId"),
			type: $j(this).data("type")
		}).find("*").removeClass("pm-hover pm-force-visible pm-selected");

		return ghostElement;
	}

	function dimDraggableSourceElement()
	{
		$j(this).addClass("pm-dim-draggable-source");
	}

	function brightenDraggableSourceElement()
	{
		$j(this).removeClass("pm-dim-draggable-source");
	}
	//</editor-fold>

	function processProjectsEndpointResponse(response) {
		var message = 'Unknown error occurred. Please try again later.';
		if (response && response.length && response[0].result) {
			message = response[0].result;
			if (message == 'Success' || message == 'folders') {
				message = null; // Print nothing on success
			}
		}

		if (null !== message) {
			sa.notify({ text : createText(message) });
		}
	}

	this.generatePage = function (params) {
		templates = sa.templates.get("playlist_manager");
		var body = $j('#body');
		clearBody();
		body.append(templates.get("page"));
		drawFolders(function () {
			// The General folder is clicked by default. This will also load its playlists.
			$j('#folders li[data-item-id="0"]').find('.pm-pane-item-container').first().trigger('click');
		});
	};

	this.receiveConcurrencyNotification = function (playlist, response) {
		var container = $j(".pm-playlist-items-container"),
			selectedParentId = getSelectedParentId(container);

		//console.log("[PM] Received concurrency notification: passed playlist id: " + playlist.id + ", selected playlist: " + selectedParentId);
		let currentPath = sa.router.getCurrentPath();
        if (currentPath.includes('playlists') && playlist.id == selectedParentId) {
			//console.log("[PM] Redrawing playlist items: ", response);
			container.find("ul").remove();
			drawPlaylistItems(playlist.id, 0);
		}
	};

	this.getSelectedPlaylistId = function () {
		return $j(".pm-selected").closest("[data-type='playlist']").data("item-id")	|| null;
	};

	// I only want this code to run once ever
	(function () {
		var ITEM_SELECTOR = ".pm-pane li .pm-pane-item-container";

		$j(document)
			.on("mouseenter", ITEM_SELECTOR, function (e) {
				e.stopPropagation();
				if (0 === $j(".focused_container").length) {
					$j(this).children(".pm-options").addClass("show-option");
				}
				$j(this).children().addClass("pm-hover");
				return false;
			})

			.on("mouseleave", ITEM_SELECTOR, function (e) {
				e.stopPropagation();
				$j(this).children().removeClass("pm-hover");
				$j(this).children(".pm-pane-item-container:not(.pm-force-visible) .pm-options").removeClass("show-option");
				return false;
			})

			.on("click", ".pm-options", function (e) {
				var optionsIcon = this,
					menuDecorationCallback = null;

				function applyHrefTemplate(menu, itemId)
				{
					$j(".pm-playlist-items-menu-details", menu).each(function (index, button) {
						$j(button).attr("href", $j(button).data('href-template').replace("{id}", itemId));
					});
				}

				switch ($j(optionsIcon).parents("li").data("type")) {
					case "folder":
						menuDecorationCallback = function (menu, itemId) {
							menu.find(".pm-folder-menu-edit").empty().append(sa.components.buttons.generateEditButton({ type : 'folder', item : getFolderById(itemId), wide : true }));
						};
						break;

					case "playlist":
						menuDecorationCallback = function (menu, itemId) {
							var playlist = getPlaylistById(itemId),
								actionList = null === playlist ? [] : generateProjectActionsList(playlist),
								buttons;

							actionList.sort(function (a, b) {
								return a.getLocation() - b.getLocation();
							});

							buttons = $j.map(actionList, function (action) {
								return $j(action.getButton());
							});
							buttons.unshift($j(createButton('Playlist Details', '', 'pm-playlist-menu-details', '/playlist/' + itemId)));

                            $j(menu).empty().append(buttons);
							$j(".button:not(.faux_button)", menu).addClass("faux_button");
						};
						break;
					case "album":
						menuDecorationCallback = function (menu, itemId) {
							applyHrefTemplate(menu, itemId);
							$j(menu).find(".pm-track").hide();
							$j(menu).find(".pm-album").show();
						};
						break;
					case "track":
						menuDecorationCallback = function (menu, itemId) {
							applyHrefTemplate(menu, itemId);
							$j(menu).find(".pm-track").show();
							$j(menu).find(".pm-album").hide();
						};
						break;
				}

				e.stopPropagation();
				handleOptionsClick(optionsIcon, menuDecorationCallback);
				return false;
			})

			.on("change", "#pm-folder-sort", function () {
				drawFolders();
			})

			.on("click", "#pm-folder-sort-icon", function () {
				toggleSortDirection(this);
				drawFolders();
			})

			.on("change", "#pm-playlist-sort", function () {
				drawPlaylists(getSelectedParentId(this));
			})

			.on("click", "#pm-playlist-sort-icon", function () {
				toggleSortDirection(this);
				drawPlaylists(getSelectedParentId(this));
			})

			.on("click", ".pm-folder-menu-delete", function () {
				var folderId = $j(this).parents(".pm-menu").data("item-id");

				sa.confirm({
					text : 'Are you sure you want to delete this folder? All its playlists will move to General.',
					yesFunction : function() {
						ajax('folderId=' + folderId, function() {
							drawFolders();
						}, 'POST', 'p=projects&action=delete_folder');
					},
					yesText : 'Delete'
				});
			})

			.on("keyup", function (e) {
				// Only do stuff if we are actually on the playlist manager page
				function checkIfOnRightPage() {
					return $j(".playlist-container").length;
				}

				switch (e.which) {
					// Escape key
					case 27:
						if (checkIfOnRightPage()) {
							removeFocusBoxes();
						}
						$j(document).trigger("pm:escapeKey");
						break;
					// Enter key
					case 13:
						$j(e.target).trigger("pm:enterKey");
						break;
				}
			})

			.on("click", ITEM_SELECTOR, function () {
				if ($j(this).hasClass("pm-options")) {
					return;
				}

				var list = $j(this).parents("li"),
                	type = list.data("type"),
					itemId = list.data("itemId"),
					container = $j(this).parents(".pm-pane-container");

				$j(container).find(".pm-selected").removeClass("pm-selected");

				switch (type) {
					case "folder":
						$j(this).children().addClass("pm-selected");
						setSelectedParentId($j("#playlists"), itemId);
						drawPlaylists(itemId);
						break;
					case "playlist":
						$j(this).children().addClass("pm-selected");
						setSelectedParentId($j("#playlist-members"), itemId);
						drawPlaylistItems(itemId);
						sa.components.projector.checkConcurrency(getPlaylistById(itemId));
						break;
				}
			})

			.on("input", "#pm-filter-playlists", function () {
				applyPlaylistsFilter($j(this).val());
			})

			.on("click", ".pm-filter-container .fa-times-circle", function () {
				$j(this).closest(".pm-filter-container").find("input").val("");
				applyPlaylistsFilter("");
			})
		;
	})();
	
	page.show = function (params) {
		return page.generatePage(params);
	};
	
	page.title = "Playlist Manager";
	page.name = "playlist-manager";
	
	page.register = {
		routes: [{
			name: 'playlist-manager',
			hash: '#!playlist_manager',
			pattern: '/playlist-manager'
		}]
	}
	
	return page;
}

sa.pages.playlistManager = new PlaylistManager();
/**
 * The dashboard container that gives users access to the internal dashboard pages
 * @returns {Dashboard}
 */
function Dashboard() {
	var dashboardPage = this;
	var currentPage = null;
	var currentPageType = '';
	/**
	 * {Page} The object that's the current page being shown in the dashboard
	 */
	//this.currentPage = null;
	/**
	 * {string} the type of page we're showing
	 */
	//this.currentPageType = '';

	this.name = 'dashboard';

	var tabs = [];

	function getTabs() {
		if (!tabs.length) {
			const setPage = function (tabId, cont) {
				dashboardPage.setPage(tabId, cont);
			};

			let hrefBase = siteBaseUrl();

			const pages = [
				{
					id: 'home',
					href: hrefBase + '/dashboard?p=home',
					title: 'Home',
					icon: 'fa fa-home',
					isDisabled: false,
					hasPageFeature: true,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']
				},
				{
					id: 'inbox',
					href: hrefBase + '/dashboard?p=inbox',
					title: 'Briefs',
					icon: 'fa fa-inbox-full',
					isDisabled: false,
					hasPageFeature: true,
					enabledSiteTypes: ['buyer']
				},
				{
					id: 'received',
					href: hrefBase + '/dashboard?p=received',
					title: 'Received',
					icon: 'fa fa-sign-in',
					isDisabled: false,
					hasPageFeature: true,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']
				},
				{
					id: 'sent',
					href: hrefBase + '/dashboard?p=sent',
					title: 'Sent',
					icon: 'fa fa-sign-out',
					isDisabled: false,
					hasPageFeature: true,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']
				},
				{
					id: 'history',
					href: hrefBase + '/dashboard?p=history',
					title: 'History',
					icon: 'fa fa-clock-o',
					isDisabled: false,
					hasPageFeature: true,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				},
				{
					id: 'saved',
					href: hrefBase + '/dashboard?p=saved',
					title: 'Saved Searches',
					icon: 'fa fa-search',
					isDisabled: false,
					hasPageFeature: true,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']
				},
				{
					id: 'licenses',
					href: hrefBase + '/dashboard?p=licenses',
					title: (config.id == 90 ? 'Download' : 'License') + ' History',
					icon: 'fa fa-money',
					isDisabled: false,
					hasPageFeature: config.licensing.show,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				},
				{
					id: 'contentid',
					href: hrefBase + '/dashboard?p=contentid',
					title: 'YouTube Whitelist',
					icon: 'fab fa-youtube',
					isDisabled: false,
					hasPageFeature: (
						(config.licensingConfig.show ?? false)
						&& (config.contentid.approved ?? false)
						&& (config.licensingConfig.subscriptions_active ?? false)
						&& config.licensingConfig.plans.some((plan) => plan.whitelist)
					),
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				},
				{
					id: 'subscription',
					href: hrefBase + '/dashboard?p=subscription',
					title: 'My Subscription',
					icon: 'fa fa-refresh',
					isDisabled: false,
					hasPageFeature: config.licensing.subscriptions && config.licensing.show,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				},
				{
					id: 'licensing-history',
					href: hrefBase + '/dashboard?p=licensing-history',
					title: 'My Licenses',
					icon: 'fa fa-money',
					isDisabled: false,
					hasPageFeature: config.licensingConfig.show,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				},
				{
					id: 'licensing-subscription',
					href: hrefBase + '/dashboard?p=licensing-subscription',
					title: 'My Subscription',
					icon: 'fa fa-refresh',
					isDisabled: false,
					hasPageFeature: config.licensingConfig.show && config.licensingConfig.subscriptions_active,
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				},
				{
					id: 'mail',
					href: hrefBase + '/dashboard?p=mail',
					title: 'Email Settings',
					icon: 'fa fa-envelope',
					isDisabled: false,
					hasPageFeature: !user.userData['authorizedByIP'],
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				},
				{
					id: 'account',
					href: hrefBase + '/dashboard?p=account',
					title: 'Manage Account',
					icon: 'fa fa-user',
					isDisabled: false,
					hasPageFeature: !user.userData['authorizedByIP'] && (config.id != 87 || user.id != 34893),
					enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']
				}
			];
			for (var page of pages) {
				if (page.enabledSiteTypes.includes(config.siteType)) {
					if (page.section) {
						tabs.push(new LeftDivider(page.section));
					} else if (page.hasPageFeature) {
						tabs.push(new LeftTab(page.id, page.href, setPage, page.title, page.icon, '', page.isDisabled));
					}
				}
			}
		}
		return tabs;
	}

	/**
	 * Shows the dashboard
	 */
	this.show = function(params) {
		params = params.replace('%23', '#');
		
		if (!user.logged) {
			// dashboard is only accessible to logged in users
			setTimeout(function () {
				sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			}, 250);
			sa.notify({ text : $j('<span>The dashboard is only accessible to logged in users. Did you mean to <a href="' + getLoginLink() + '">Log In</a>?</span>') });
			return;
		}
		if (sa.getCurrentPageName() != this.name) {
			// reset vars
			currentPage = null;
			currentPageType = '';
			// call the left tabbed page initialization method
			//var dashboardPage = this,
				//setPage = function(tabId, cont) { dashboardPage.setPage(tabId, cont); },
				//tabs = [];

			// for (var p of pages) {
			// 	if (p.enabledSiteTypes.includes(config.siteType) && p.hasPageFeature) {
			// 		tabs.push(new LeftTab(p.id, p.href, setPage, p.title, p.icon, p.isDisabled));
			// 	}
			// }
			var pageOptions = [ { name : 'Dashboard', href : '/dashboard' } ];
			if (user.hasAdminPermission(AdminPermission.Any)) pageOptions.push({ name : 'Admin', href : '/admin' });

			LeftTabbedPage.prototype.show.call(this,
				'dashboard',
				getTabs(),
				pageOptions, []
			);
			sa.currentPage = this;
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.p) {
			// determine what tab to show
			for (let tab of getTabs()) {
				if (!(tab instanceof LeftDivider) && !tab.disabled) {
					vars.p = tab.id;
					if (window['history'] && history['replaceState']) {
						history.replaceState(undefined, '', siteBaseUrl() + '/dashboard?p=' + vars.p); // this lets us replace the url in place so /admin doesn't get stuck in the browser's back history
					}
					break;
				}
			}
		}
		if (currentPageType === vars.p) {
			dashboardPage.setPage(currentPageType, $j('#right_content .right_body'));
		} else {
			dashboardPage.setTab(vars.p);
		}
	};

	/**
	 * Changes what page the dashboard is showing
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (currentPageType == pageId) {
			currentPage.show(sa.router.getCurrentQueryParams(), container);
			return;
		}

		// Since Inbox is silo'd we need to undo some of the specific styling it does
		$j('.right_head').show();
		$j('#ltp_container').removeClass('dashboard-inbox');
		
		
		// they were on a different page so we need to find the correct page object
		var page = null;
		switch (pageId) {
			case 'home':
				page = new DashboardHome();
				break;
			case 'inbox':
				page = new DashboardInbox();
				break;
			case 'received':
				page = new DashboardReceived();
				break;
			case 'sent':
				page = new DashboardSent();
				break;
			case 'history':
				page = new DashboardHistory();
				break;
			case 'saved':
				page = new DashboardSaved();
				break;
			case 'licenses':
				page = new DashboardLicenseHistory();
				break;
			case 'contentid':
				page = new DashboardContentid();
				break;
			case 'subscription':
				page = new DashboardSubscription();
				break;
			case 'licensing-subscription':
				page = new DashboardLicensingSubscription();
				break;
			case 'licensing-history':
				page = new DashboardLicensingHistory();
				break;
			case 'mail':
				page = new DashboardMail();
				break;
			case 'account':
				page = new DashboardAccount();
				break;
		}
		// and then if we found it, have it load based on the current params
		if (page) {
			currentPage = page;
			currentPageType = pageId;
			let params = sa.router.getCurrentQueryParams();
			page.show(params, container);
		} else {
			console.warn('page not found:', pageId);
			container.html('Dashboard unable to determine page for ' + pageId);
		}
	};

	dashboardPage.register = {
		routes: [{
			pattern: '/dashboard',
			hash: '#!dashboard',
			name: 'dashboard'
		}]
	};
	
	dashboardPage.title = 'Dashboard';
	dashboardPage.name = 'dashboard';
	
	return dashboardPage;
}

Dashboard.prototype = new LeftTabbedPage();

sa.pages.dashboard = new Dashboard();
/**
 * The page in the dashboard that shows multiformat items
 * Meant to be overriden and not called directly
 */
function DashboardListPage() {
	
	/**
	 * What type of page is this? (used by subclasses to control what's passed into setData)
	 */
	this.type = '';
	/**
	 * {List} will show the received items
	 */
	this.list = null;
	
	/**
	 * Loads the information for the page
	 * @param {string} params the parameters from the url
	 */
	this.loadData = function(params) {
		this.list.loadPage(params.replace(/^p=/, 'type=') + '&u=' + user.userData.id);
	};
	
	/**
	 * Populates the page using the data from the server
	 * @param {json} newData data from server
	 */
	this.setData = function(newData) {
		var page = this,
			type = this.type;
		this.list.setData(newData, function(pageVars) { return getNewDashboardLink(type) + pageVars; }, function(params) { page.loadData(params); return false;});
	};
}

/**
 * Sets up the basic framework of the page and its objects 
 * @param {string} params the parameters from the url
 * @param {JQuery} container the object that should hold this list
 * @param {Array} columnList the column list that the config should use
 * @param {string} type the type of page this is (used for link generation in setData)
 * @param {object} filter if specified, will show a filter to filter down the results
 * 	{variable : variable name as it should be sent in to load, name : the name to show, values : [ { display : display value, value : send value }, ... ] } 
 */
DashboardListPage.prototype.show = function(params, container, columnList, type, filter) {
	this.type = type;
	// set up the config
	var db = this,
		listConfig = new ListConfig();
	listConfig.addColumnList(columnList);
	listConfig.callback = function(newData) { db.setData(newData); };
	listConfig.sortable = false;
	this.list = createMultiFormatList(listConfig);
	
	// add the filter
	if (filter) {
		var options = '<option value="">all</option>',
			filterDiv = $j('<div class="filters">' + filter.name + ':</div>'),
			currentVal = params.match(new RegExp(filter.variable + '=([^&]+)'));
		if (currentVal) currentVal = currentVal[1];
		for (var i = 0, len = filter.values.length; i < len; i++) {
			var filt = filter.values[i];
			options += '<option value="' + filt.value + '"' + (currentVal == filt.value ? ' selected="selected"' : '') + '>' + filt.display + '</option>';
		}
		filterDiv.append($j('<select>' + options + '</select>').on('change', function() { db.loadData(params.replace(/&pg=[0-9]+/, '&pg=0') + '&' + filter.variable + '=' + $j(this).val()); }));
		container.append(filterDiv);
	}
	
	// set up the container
	container.append('<div id="list_' + listConfig.bankKey + '" class="list"></div>');
	this.list.generatePage(container.find('.list'));

	// and load the data!
	this.loadData(params);
};
/**
 * The page of the dashboard that lets you update your account details
 */
function DashboardAccount() {
	
	var page = this;
	var templates;
	
	/**
	 * Shows the page form
	 */
	this.show = function(params, container) {

		if (!templates) {
			templates = sa.templates.get('dashboard.account');
		}
		
		if (config.hasJwt) {
			container.empty().append(templates.get('machinima_warning'));
			return;
		}
		
		var template = templates.get('page');
		
		// username/email/password editing
		template.find('.forgot_password_link').on('click', function() {
			sa.components.forgotPassword.show({ emailAddress : user.userData.email });
		});
		template.find('#username input').val(htmlDecode(user.userData.username));
		if (config.siteType != 'buyer') {
			template.find('#email input').val(user.userData.email);
		} else {
			template.find('#email').remove();
		}
		if (config.disableEmailLogins) {
			template.find('#password_section_container').hide();
		}
		
		// Adobe panel login auth code generator
		template.find('#adobe_login_button').on('click', function() {
			sa.api.request({
				handler : 'account',
				action : 'generateAdobeLoginCode'
			}).then(function(data) {
				template.find('.adobe_login_code_container').addClass('showing');
				template.find('#adobe_login_code').val(data.code);
			});
		});
		template.find('.adobe_copy_button').on('click', function() {
			let input = document.getElementById('adobe_login_code');
			input.disabled = false;
			input.focus();
			input.select();
			try {
				if (document.execCommand('copy')) {
					sa.notify({
						text : 'Login code copied! Paste this code into the "SSO Login" section of our Adobe extension\'s login page.',
						type : sa.notify.notificationTypes.success
					});
					window.getSelection().removeAllRanges(); // deselect text
					input.blur();
					input.disabled = true;
					return;
				}
			} catch (err) {
				console.error(err);
			}

			input.disabled = true;
			sa.notify({
				text : 'Unable to copy automatically. Please select code, copy, and paste this code into the "SSO Login" section of our Adobe extension\'s login page.'
			});
		})

		// settings
		if (config.siteType !== 'drop') {
			if (user.getOption('track_list_collapse') == '1') template.find('#group_alternates input').prop('checked', true);
		} else {
			template.find('#group_alternates').remove();
		}
		if (user.userData.allowApiAccess) {
			template.find('#allow_api_access input').prop('checked', true);
		}
		
		// privacy options
		template.find('.cooke_manager_button').on('click', function() {
			sa.components.cookieManager.show();
		});
		template.find('.export_button').on('click', function() {
			sa.components.privacyManager.exportData();
		});
		template.find('.delete_button').on('click', function() {
			sa.components.privacyManager.deleteAccount();
		});
		sa.components.documentViewer.enableButtons(template);
		
		// add the template before the we create the uploader object (might not work right otherwise?)
		container.empty().append(template);

		// avatar uploading
		if (user.userData.image.indexOf('default_editor') === -1) {
			template.find('.current_avatar').removeClass('fas fa-user-circle').append('<img src="' + user.userData.image + '" alt="user image"/>');
		}
		var uploader = new Uploader({ button : template.find('.browse_button'), browseCallback : function(uploader) { handleAvatarBrowseResponse(uploader); }, fileType : UploaderConstants.IMAGES });
		sa.components.edad.addGenericDropZone({
			allowedExtensions : Uploader.GetExtensions(UploaderConstants.IMAGES),
			anchorSelector : '.current_avatar',
			templateSelector : 'avatar_drop_zone',
			uniqueKey : 'avatar_uploader',
			dropCallback : function(files) {
				uploader.addFilesToUpload(files);
			}
		});

		// saving and any actions triggered by page load
		template.find('.save_changes').on('click', function() {
			saveChanges();
		});
		let vars = sa.router.paramsToVars(params);
		if (vars.confirmation && vars.conf) {
			ajax('p=account&confirmation=' + vars.confirmation + '&conf=' + vars.conf, function(response) { page.handleConfirmationResponse(response); });
		}
		this.updateConnectedAccounts();
		
		if (vars.section === 'adobe') {
			sa.scrollToElement(container.find('#adobe_login').addClass('focused'));
		}
	};
	
	/**
	 * Updates the connected accounts section so it matches the accounts on the user object
	 */
	this.updateConnectedAccounts = function() {
		var p = this,
			facebookContainer = $j('.facebook_connect').html('');
		if (user.userData.facebook) {
			// already connected. show disconnect
			facebookContainer.append('<div class="connect_button"><img src="images/buttons/facebook-connect.png"/></div>'
					+ '<div class="status connected">connected</div><img class="faux_button close_button" title="Unlink your account from facebook" src="images/shared/close.png"/><div class="clr"></div>');
			facebookContainer.find('img:last').on('click', function() {
				ajax('disconnect=1', function(response) {
					user.userData.facebook = 0;
					p.updateConnectedAccounts();
				}, 'POST', 'p=link_account&type=facebook');
			});
		} else {
			// not connected. show connect
			$j('#fb-root').remove();
			$j('#facebook-jssdk').remove();
			$j('body').append('<div id="fb-root"></div>');
			
			// facebook login code
			window.fbAsyncInit = function() {
				FB.init({
					appId      : config.facebookAppId, // App ID
					channelURL : 'https://' + config.domain + '/channel.php', // Channel File
					status     : true, // check login status
					cookie     : true, // enable cookies to allow the server to access the session
					oauth      : true, // enable OAuth 2.0
					xfbml      : true  // parse XFBML
				});
				function facebookLogin() {
					ajax('connect=1', function(response) {
						user.userData.facebook = 1;
						p.updateConnectedAccounts();
					}, 'POST', 'p=link_account&type=facebook');
				}
				// Additional initialization code here
				FB.Event.subscribe('auth.login', function(response) {
					console.log(response);
					facebookLogin();
				});
				FB.getLoginStatus(function(response) {
					// if you're already logged in to facebook and you've already authorized SA, subsequent calls to login don't do anything
					// we need to intercept that case here and make sure that clicking the login button does something
					if (response.status == 'connected') {
						console.log(response);
						$j('.fb-login-button').on('click', function() { facebookLogin(); });
					}
				});
				facebookContainer.append('<div class="connect_button"><img src="images/buttons/facebook-connect.png" class="faux_button"/></div><div class="status not_connected">not connected</div><div class="clr"></div>');
				facebookContainer.find('img').on('click', function() {
					FB.login(function(response) {
						if (response.status && response.status == 'connected') {
							facebookLogin();
						}
						console.log('login response: ', response);
					}, { scope : 'email' });
				});
			};
			
			// Load the SDK Asynchronously
			(function(d){
				var js, id = 'facebook-jssdk'; if (d.getElementById(id)) {return;}
				js = d.createElement('script'); js.id = id; js.async = true;
				js.src = "https://connect.facebook.net/en_US/all.js";
				d.getElementsByTagName('head')[0].appendChild(js);
			}(document));
		}
	};
	
	/**
	 * Handles the response from the server after you've submitted an email change confirmation request
	 * @param {json} response the server's response
	 */
	this.handleConfirmationResponse = function(response) {
		if (response[0].email_result) {
			sa.notify({ text : response[0].email_result });
		}
		if (response[0].new_email) {
			user.userData.email = response[0].new_email;
			$j('#email input').val(response[0].new_email);
		}
	};
	
	/**
	 * Checks to see if the user has entered any information on the dashboard account page
	 * Validates that data and saves it if no errors were detected
	 * @param {boolean} confirmedPasswordChangeNotice if the user changes their password, the form only works once they've confirmed
	 */
	function saveChanges(confirmedPasswordChangeNotice) {
		var username = $j('#account_details #username input').val().trim(),
			currentPass = $j('#account_details #current input').val().trim(),
			newPass = $j('#account_details #password input').val().trim(),
			confPass = $j('#account_details #conf input').val().trim(),
			save = false,
			error = false,
			email = '';
		if (config.siteType != 'buyer') {
			email = $j('#account_details #email input').val().trim();
			if (email && email != user.userData.email) {
				// user entered a new email
				if (!email.isEmail()) {
					$j('#account_details #email .information').addClass('error').removeClass('success').html('Please enter a valid email');
					error = true;
				} else {
					$j('#account_details #email .information').removeClass('error').removeClass('success')
						.html('Changing your email sends you a confirmation to the address you enter. The change will not be processed until you click on the verification link in that email.');
					save = true;
				}
			} else {
				email = '';
				$j('#account_details #email .information').removeClass('error').removeClass('success')
					.html('Changing your email sends you a confirmation to the address you enter. The change will not be processed until you click on the verification link in that email.');
			}
		}
		if (username && username != user.userData.username) {
			// user entered a new username
			if (username.length < 2 || username.length > 128) {
				$j('#account_details #username .information').addClass('error').removeClass('success')
					.html('Full name must be at least 2 characters and at most 128');
				error = true;
			} else {
				$j('#account_details #username .information').removeClass('error').removeClass('success')
					.html('Minimum of 2 characters, maximum of 128.');
				save = true;
			}
		} else {
			username = '';
			$j('#account_details #username .information').removeClass('error').removeClass('success')
				.html('Minimum of 2 characters, maximum of 128.');
		}
		if (newPass) {
			// user entered a new password
			$j('#account_details #current .information').removeClass('error').html('');
			$j('#account_details #password .information').removeClass('error').html('');
			$j('#account_details #conf .information').removeClass('error').html('');
			let errorMessage = '';
			if (!currentPass) {
				$j('#account_details #current .information').addClass('error').removeClass('success')
					.html(errorMessage = 'To change your password, please enter your old password');
				error = true;
			} else if (newPass.length < PasswordLength) {
				$j('#account_details #password .information').addClass('error').removeClass('success')
					.html(errorMessage = 'Password must be at least ' + PasswordLength + ' characters');
				error = true;
			} else if (newPass.match(/[0-9]/) == null || newPass.match(/[a-zA-Z]/) == null) {
				$j('#account_details #password .information').addClass('error').removeClass('success')
					.html(errorMessage = 'Password must contain at least 1 letter and 1 number');
				error = true;
			} else if (!confPass) {
				$j('#account_details #conf .information').addClass('error').removeClass('success')
					.html(errorMessage = 'Please reenter your new password to confirm');
				error = true;
			} else if (newPass != confPass) {
				$j('#account_details #conf .information').addClass('error').removeClass('success')
					.html(errorMessage = 'Confirmation does not match! Please reenter');
				error = true;
			} else if (!confirmedPasswordChangeNotice) {
				sa.api.request({
					handler : 'email-check',
					action : 'check-email-address',
					postData : {
						email : user.userData.email,
						excludeSite : config.id
					}
				}).then(function() {
					saveChanges(true);
				}).catch(function(e) {
					/** @var {string} errorMessage */
					let errorMessage = e.message;
					/** @var {{ email : string, loginLink : string, sites : string[], account : boolean, sitesString : string }} errorDetails */
					let errorDetails = e.details;
					if (errorDetails.sites.length) {
						sa.confirm({
							text : 'Your password is shared across SourceAudio workspaces so changing it here will change it on ' + errorDetails.sitesString + ' also.',
							yesText : 'Ok',
							yesFunction : function() { saveChanges(true); },
							noText : 'Cancel'
						});
					} else {
						saveChanges(true);
					}
				});
				return;
			} else {
				save = true;
			}
			if (errorMessage) {
				sa.alert({ text : errorMessage });
			}
		} else {
			newPass = '';
			$j('#account_details #current .information, #account_details #password .information, #account_details #conf .information')
				.addClass('error').removeClass('success').html('');
		}
		if (!error) {
			if (config.siteType !== 'drop') {
				user.setOption('track_list_collapse', $j('#group_alternates input:checked').length);
				saveSitePreference('allow_api_access', $j('#allow_api_access input:checked').length);
			}
			if (save) {
				ajax((username ? 'username=' + encodeURIComponent(username) : '') + (email ? '&email=' + encodeURIComponent(email) : '')
					+ (newPass ? '&password=' + encodeURIComponent(newPass) + '&oldPass=' + encodeURIComponent(currentPass) : ''),
					function(newData) { handleSaveAccountResponse(newData, { username : username, email : email }); }, 'POST', 'p=account&action=edit');
			} else {
				sa.notify({ text : 'Settings saved!', type : sa.notify.notificationTypes.success });
			}
			
		}
	}

	/**
	 * Saves a white-label specific user preference. Ex. Allowing API Access to user data
	 * 
	 * @param {String} preference		The name of the preference to set
	 * @param {String|Number} value			The value of the preference to set
	 */
	function saveSitePreference( preference, value) {
		ajax('action=setSitePreference&option=' + encodeURIComponent(preference) + '&value=' + encodeURIComponent(value), function(r) {
			console.log('- save workspace pref response:', r);
		}, 'POST', 'p=user_options');
	}
	
	/**
	 * Handles the server response after the user tries to change their account details
	 * @param {JSON} response the server's response
	 * @param {Object} newUserData
	 */
	function handleSaveAccountResponse(response, newUserData) {
		var result = response[0].result;
		if (typeof result !== 'string' || !result[0]) {
			let alertMessages = [];
			if (result.username) {
				if (result.username == 'success') {
					user.setUsername(StringSanitize.encodeIfNotEncoded(newUserData.username));
					$j('#account_details #username .information').addClass('success').removeClass('error')
						.html('Full name changed!');
					alertMessages.push('Full name changed!');
				} else {
					$j('#account_details #username .information').addClass('error').removeClass('success')
						.html(result.username);
					sa.alert(result.username);
				}
			}
			if (result.email) {
				if (result.email == 'success') {
					user.setEmail(newUserData.email);
					$j('#account_details #email .information').addClass('success').removeClass('error')
						.html('Confirmation email sent! Please check your email to complete the process.');
					alertMessages.push('Confirmation email sent! Please check your email to complete the process.');
				} else {
					$j('#account_details #email .information').addClass('error').removeClass('success')
						.html(result.email);
					sa.alert(result.email);
				}
			}
			if (result.password) {
				if (result.password == 'success') {
					$j('#account_details #password .information').addClass('success').removeClass('error')
						.html('Password changed!');
					$j('#account_details #password input, #account_details #conf input, #account_details #current input').val('');
					alertMessages.push('Password changed!');
				} else {
					/** @var {string} htmlMessage */
					let htmlMessage = htmlDecode(result.password);
					$j('#account_details #password .information').addClass('error').removeClass('success')
						.html(htmlMessage);
					sa.alert(htmlMessage);
					$j('.forgot_password_link').off('click').on('click', function() {
						sa.components.forgotPassword.show({ emailAddress : user.userData.email });
					});
				}
			}
			if (alertMessages.length) {
				sa.alert({ text : alertMessages.join('<br/>') });
			}
		} else {
			sa.alert({ text : result });
		}
	}
	
	/**
	 * Updates the display after you've browsed for an avatar
	 * @param {Uploader} uploader the object doing the uploading
	 */
	function handleAvatarBrowseResponse(uploader) {
		var f = uploader.getFiles();
		if (f && f.length) {
			uploader.upload({
				params : 'u=' + user.userData.id + '&t=avatar', 
				complete : function() { handleAvatarComplete(uploader); }, 
				error : function() { handleAvatarError(uploader); }
			}); 
		}
	}
	
	/**
	 * Handles response from flash after avatar upload completes, updating images and reseting form state
	 * @param {Uploader} uploader the object doing the uploading
	 */
	async function handleAvatarComplete(uploader) {
		const newData = await sa.api.request({
			handler: 'user',
			action: 'me',
			uncache: new Date().getTime()
		});
		
		if (newData) {
			const avatarPath = newData[1].image;
			user.setAvatar(avatarPath);
			$j('.current_avatar').removeClass('fas fa-user-circle').html('<img src="' + avatarPath + '" alt="user image" />');
		}
		uploader.removeAllFiles();
	}
	
	/**
	 * Alerts the user after avatar upload files (I'm not sure this actually gets called)
	 * @param {Uploader} uploader the object doing the uploading
	 */
	function handleAvatarError(uploader) {
		sa.alert('Error saving. Please try again');
		uploader.removeAllFiles();
	}
}
/**
 * These tab pages allow users to manage and view their whitelisted channels and claim activity.
 */
function DashboardContentid() {
	let page = this;
	let currentTab = '';
	let currentPage;

	this.show = function (params, container) {
		let vars = sa.router.paramsToVars(params);

		if (!$j('.right_body.contentid').length) {
			var callback = function (tabId, cont) { page.setPage(tabId, cont); }, tabs = [];
			let baseUrl = siteBaseUrl();
			const pages = [
				{ id: 'whitelist', href: baseUrl + '/dashboard?p=contentid&tab=whitelist', title: 'Manage Whitelist' },
				{ id: 'claims', href: baseUrl + '/dashboard?p=contentid&tab=claims', title: 'Claim History' }
			];

			for (var p of pages) {
				tabs.push(new RightTab(p.id, p.href, p.title, callback));
			}
			RightTabbedPage.prototype.show.call(page, 'contentid', container, tabs, '');
		}

		if (!vars.tab) vars.tab = 'whitelist';
		this.setTab(vars.tab);
	};

	this.setPage = function (pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			switch (pageId) {
				case 'claims':
					currentPage = new DashboardClaims();
					break;
				case 'whitelist':
				default:
					currentPage = new DashboardWhitelist();
			}
		}
		let params = sa.router.getCurrentQueryParams();
		currentPage.show(params, container);
	};
};
DashboardContentid.prototype = new RightTabbedPage();
/**
 * The page in the dashboard that enables users to view claim activity for their whitelisted channels.
 */
function DashboardClaims() {

	var page = this,
		templates = sa.templates.get('dashboard.contentid'),
		trackList = null,
		loader;

		this.show = function (params, container) {

			page.params = sa.router.paramsToVars(params);
			console.log('- showing claims');
			window.activePage = page;
			var pageTemplate = templates.get('claims');
			container.empty();
			container.html(pageTemplate);
			page.container = container;

			page.params = sa.router.getCurrentQueryParams();
			page.vars = sa.router.getCurrentParamsAsObject();
			console.log('- page vars:', page.vars);

			loadTracks();
		};

		//most of the following list functions originated from admin.contentid.claims
		function loadTracks(params) {
			loader = showLoader(page.container, 'Loading recent claim activity');
			var params = page.vars || {};
			params.siteId = config.id;
			sa.api.request({
				handler: 'content-id/UserWhitelist',
				action: 'getClaims',
				postData: params
			}).then(setTracks);
		}

		function setTracks(r) {
			console.log('- claims response:', r);
			var trackListConfig;

			delete page.vars.pg;
			delete page.vars.show;

			$j('#db-claims-tracks').html('');

			//trackbank
			trackBank.clear('dashboard_contentid_claims');
			if (r.tracks && r.tracks.length) {
				r.tracks = JSON.parse(r.tracks);
				console.log('- parsed:', r.tracks);
				var tracks = {};
				_.each(r.tracks, function (track) {
					if (!track.id) return;
					tracks[track.id] = track;
					trackBank.add(track, 'dashboard_contentid_claims');
				});
			}
			// insert data
			var listItems = [{
				count: parseInt(r.listInfo.count),
				trackCount: parseInt(r.listInfo.count),
				pageVars: 'show=' + r.listInfo.show + '&pg=',
				page: r.listInfo.pg || 0,
				perPage: r.listInfo.show || 15
			}];

			_.each(r.items, function (item) {
				var track = !r.tracks || !r.tracks.length ? '' : tracks[item.track_id];

				var actionText = '';
				if (parseInt(item.released) < 0) {
					actionText = 'Release Error<br/>Contact Support';
				} else
				if (parseInt(item.released)) {
					try {
						var rdata = JSON.parse(item.released_by);
						if (rdata.type == 'softlist') {
							actionText = 'Whitelisted release';
						} else
							if (rdata.type == 'manual') {
								actionText = 'Manual release by ' + rdata.username;
							} else
								if (rdata.type == 'auto-historical') {
									actionText = 'Historical auto release by ' + rdata.username;
								} else
									if (rdata.type == 'auto-historical-hardlist') {
										actionText = 'Historical hard whitelist auto release by ' + rdata.username;
									} else {
										actionText = 'Released: ' + item.released_by;
									}
					} catch (e) {
						console.log('- error parsing release json:', e, item.released_by);
						actionText = 'Released: ' + item.released_by;
					}
				}

				if (!track) track = {};

				listItems.push({
					id: item.track_id,
					title: track.title ? track.title : 'Deleted Track',
					date: item.date,
					file: track.file,
					length: track.length,
					actualLength: track.actualLength,
					yt_video: '<a target="_blank" href="https://www.youtube.com/watch?v=' + item.video_id + '">' + item.video_title + ' <i class="fa fa-external-link"></i></a>',
					yt_channel: '<a target="_blank" href="https://www.youtube.com/channel/' + item.channel_id + '">' + item.video_author + ' <i class="fa fa-external-link"></i></a>',
					actions: actionText
				});
			});

			trackListConfig = new TrackListConfig();
			trackListConfig.addColumnList([
				new ListColumn('play', ['play']),
				new ListColumn('title', ['title']),
				new ListColumn('date', ['date']),
				new ListColumn('Video', ['yt_video']),
				new ListColumn('Channel', ['yt_channel']),
				new ListColumn('Release Notes', ['actions'])
			]);
			trackListConfig.emptyMessage = 'There is no claim activity for any of your whitelisted channels yet.';
			trackListConfig.allowBlock = false;
			trackListConfig.allowMiniBlock = false;
			trackListConfig.bankKey = 'dashboard_contentid_claims';
			trackListConfig.getDefaultView = function () { return ListViewType.List; };
			trackListConfig.sortable = false;
			trackListConfig.selectable = false;
			trackListConfig.useCache = true;
			trackListConfig.useFilters = false;
			trackListConfig.headerBackground = false;
			trackListConfig.viewCookie = false;
			trackListConfig.resultCountChanging = false; // i turned this off cause I couldn't get it to transport the vars correctly

			trackList = createTrackList(trackListConfig);
			trackList.generatePage($j('#db-claims-tracks'));
			if (loader) loader.remove();
			trackList.setData(listItems, function (params) {
				return '/dashboard?' + sa.router.varsToParams(page.vars) + '&' + params;
			});

		}

}
/**
 * The page in the dashboard that enables users to view and manage their whitelisted youtube channels.
 */
function DashboardWhitelist() {
	var page = this;
	var templates = sa.templates.get('dashboard.contentid');
	
	this.show = async function (params, container) {
		page.params = sa.router.getCurrentParamsAsObject();
		console.log('- showing user whitelist');
		window.activePage = page;
		var pageTemplate = templates.get('whitelist');
		container.empty();
		container.html(pageTemplate);
		page.container = container;

		page.params = sa.router.getCurrentQueryParams();
		page.vars = sa.router.getCurrentParamsAsObject();
		console.log('- page vars:', page.vars);

		this.subscriptionNotice();
		page.getWhitelist();

		const r = await sa.api.request({
			handler: 'content-id/UserWhitelist',
			action: 'getUserSub'
		}).catch( e => {
			console.log('Error:', e);
			return sa.alert(e.message);
		});

	};

	this.subscriptionNotice = async function () {
    	const userSubscription = await sa.api.request({
			handler: "licensing/licensingSubscriptions",
			action: "getUserSubscription",
		})

		if (!(userSubscription.subscription.whitelist ?? false)) {
			page.container.find("#db-channel-list").before(`
				<p>
					Please sign up for a subscription plan with
					whitelisting to whitelist your channels.
				<p>
			`);
		}
  	};

	this.getWhitelist = function () {
		let trackListContainer = page.container.find('#db-channel-list');
		trackListContainer.html('');

		var conf = new ListConfig();
		conf.bankKey = 'user-whitelist-list';
		conf.sortable = false;
		conf.resultCountChanging = false;
		conf.pagination = true;
		conf.emptyMessage = 'You do not have any whitelisted channels yet.';
		conf.addColumnList([
			new ListColumn('channel', ['channel_name'], true),
			new ListColumn('whitelisted via', ['whitelist_type'], true),
			new ListColumn('actions', ['actions'])
		]);

		var list = createLicensingActivityList(conf);
		list.generatePage(trackListContainer);


		async function loadItems() {
			list.showCover('', 'Loading channels');
			const r = await sa.api.request({
				handler: 'content-id/UserWhitelist',
				action: 'getWhitelist'
			});

			var listInfo = r.listInfo;
			var listParams = {
				count: listInfo.count || 25,
				page: listInfo.pg || 0,
				perPage: listInfo.show || 25,
				pageVars: 'show=' + listInfo.show + '&pg='
			};

			var listItems = [];
			listItems.push(listParams);
			_.each(r.data, function (channel) {
				item = {
					id: 'u-' + channel.channel_id,
					channel_name: '<a target="_blank" href="https://www.youtube.com/channel/' + channel.channel_id + '">' + (channel.channel_name || channel.channel_id) + ' <i class="fa fa-external-link"></i></a>',
					whitelist_type: channel.whitelist_type == 0 ? 'Subscription' : 'License (whitelisting ' + channel.track_count + ' tracks)',
					actions: '<a data-remove="' + channel.channel_id + '" class="remove-channel">» Remove channel</a>'
				};
				listItems.push(item);
			});

			list.hideCover();
			list.setData(listItems, function (listParams) {
				let baseUrl = siteBaseUrl();
				return baseUrl + '/dashboard?p=contentid&tab=whitelist' + listParams;
			}, function (listParams) {
				sa.scrollToElement(trackListContainer);
				page.vars = sa.router.getCurrentParamsAsObject();
				loadItems();
				return false;
			});

			if (r.data.length < 3) {
				page.showAddChannel();
			} else
			if (config.id == 5520) {
				let tpl = templates.get('more_channels_cfm');
				page.container.find('.add-channel-cont').html(tpl);
			} else {
				let tpl = templates.get('more_channels');
				page.container.find('.add-channel-cont').html(tpl);
			}
				
		}
		
		loadItems();

		page.container.on('click', 'a.remove-channel', function () {
			let channel_id = $j(this).data('remove');
			sa.confirm({
				text: 'Are you sure you want to remove this channel from your whitelist?',
				yesFunction: function () {
					removeChannel(channel_id);
				},
				yesText: 'Remove'
			});
		});

		async function removeChannel(channel_id) {
			if (!channel_id) return sa.alert('Channel ID field was empty, please enter a YouTube channel ID.');			
			console.log(`Removing user whitelist channel: ${channel_id}`);
			await sa.api.request({
				handler: 'content-id/UserWhitelist',
				action: 'removeChannel',
				postData: {channel_id: channel_id}
			});


			page.getWhitelist();
			sa.notify({ text: 'Removed Channel from your whitelist!', type: sa.notify.notificationTypes.success });
		};

	};

	this.showAddChannel = function () {
		var tpl = templates.get('dc_add_channel');
		console.log('tpl', tpl);
		page.container.find('.add-channel-cont').addClass('cont').html(tpl);
		page.container.on('click', 'a.db-search-channel', function () {
			sa.components.yt_channel_search.show(saveChannel);
		});

		page.container.on('click', 'a.db-add-channel', function () {
			let channel_id = $j('#db-add-channelId').val();
			if (!channel_id) return sa.alert('Channel ID field was empty, please enter a YouTube channel ID.');
			
			
			sa.api.request({
				handler: 'content-id/UserWhitelist',
				action: 'CheckSubscriptionWhitelist',
				postData: { channel_id: channel_id }
			}).then(function (r) {
				console.log('- whitelist check:', r);
				if (r.error) return sa.error( r.error );
				if (!r.channel_name) return sa.error('We could not find a channel with that id. Please make sure you have it copied correctly. It should look something like "UC_B7kPmEgq9QbgkwNKjG1Cg"');
				sa.confirm({
					text: 'We found a channel named <b>' + r.channel_name + '</b>. Is that right?',
					yesFunction: function () {
						saveChannel(r.channel_id);
					},
					yesText: 'Yes'
				});
			}).catch(function (e) {
				console.log('Error:', e);
				return sa.alert(e.message);
			});
		});

		async function saveChannel(channelId) {
			if (!channelId) return sa.alert('Channel ID field was empty, please enter a YouTube channel ID.');
			await sa.api.request({
				handler: 'content-id/UserWhitelist',
				action: 'saveSubscriptionWhitelist',
				postData: { channel_id: channelId }
			});

			page.getWhitelist();
			return sa.notify({ text: 'Channel added to whitelist!', type: sa.notify.notificationTypes.success });
				
		}
	}

}
/**
 * The page in the dashboard that shows items the user has played or downloaded
 * Uses a basic List and lists projects, albums, and tracks
 */
function DashboardHistory() {
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		DashboardListPage.prototype.show.call(this, params, container, 
			[
				new ListColumn('date', ['date']),
				new ListColumn('type', ['type', 'history_type']), 
				new ListColumn('name', ['multi_name', 'expand']),
				new ListColumn('format', ['format']),
				new ListColumn('tracks', ['track count'])
			],
			'history', { variable : 'historyType', name : 'Type', values : [ { display : 'plays', value : 'play' }, { display : 'downloads', value : 'download' } ]});
	};
}
DashboardHistory.prototype = new DashboardListPage();
/**
 * The home page of the dashboard that lists recent site activity
 */
function DashboardHome() {
	/**
	 * The container this page should live in
	 */
	this.container = null;
	
	this.show = function(params, container) {
		this.container = container.html('Loading...');
		this.loadData();
	};
	
	/**
	 * Loads the information for the home page
	 */
	this.loadData = function() {
		var page = this;
		ajax('p=dashboard', function(newData) { page.setData(newData); });
	};
	
	/**
	 * Populates the page using the data from the server
	 * @param {json} newData data from server
	 */
	this.setData = function(newData) {
		if (!$j('.tab_home').length) return;
		var container = this.container.html(''),
			receivedConf = new ListConfig(),
			historyConf = new ListConfig();
		
		// received list conf
		receivedConf.addColumnList([
			new ListColumn('date', ['date']),
			new ListColumn('type', ['type']), 
			new ListColumn('name', ['multi_name', 'expand']),
			new ListColumn('sender', ['user avatar', 'username']),
			new ListColumn('download', ['multi_download']),
			new ListColumn('tracks', ['track count'])
		]);
		receivedConf.callback = function() {};
		receivedConf.sortable = false;
		receivedConf.pagination = false;
		receivedConf.resultCountChanging = false;
		receivedConf.bankKey = 'received';
		receivedConf.topBar = false;
		
		// history list
		historyConf.addColumnList([
			new ListColumn('date', ['date']),
			new ListColumn('type', ['type', 'history_type']), 
			new ListColumn('name', ['multi_name', 'expand']),
			new ListColumn('format', ['format']),
			new ListColumn('tracks', ['track count'])
		]);
		historyConf.callback = function() {};
		historyConf.sortable = false;
		historyConf.pagination = false;
		historyConf.resultCountChanging = false;
		historyConf.bankKey = 'history';
		historyConf.topBar = false;
		
		var elems = [
			{
				title:'Recently received tracks, albums, and playlists',
				shortName:'received',
				items:newData[0].received,
				conf:receivedConf
			},
			{
				title:'Recently played and downloaded tracks, albums, and playlists',
				shortName:'history',
				items:newData[0].history,
				conf:historyConf
			}
		];
		for (var i = 0, len = elems.length; i < len; i++) {
			var elem = elems[i],			
				div = $j('<div id="dashboard_favorites_' + elem.shortName + '" class="dashboard_favorites_section">'
					+ '<div class="dashboard_favorites_heading">' + elem.title + '</div>'
					+ '<div id="list_' + elem.shortName + '" class="list"></div></div>');
			container.append(div);
			
			if (elem.items.length) {
				div.append(createA('', 'profile_favorites_see_all', 
					getNewDashboardLink(elem.shortName), '', '', 'See More >>'));
				
				var list = createMultiFormatList(elem.conf);
				list.generatePage(div.find('.list'));
				list.setData(elem.items, getExplorerLink);
			} else {
				div.find('.list').html('Nothing to show here yet');
			}
		}
	};
}
/**
 * The page of the dashboard that lets you update your outgoing mail format
 */
function DashboardLicenseHistory() {
	/**
	 * The container this page should live in
	 */
	this.container = null;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var page = this;
		
		var vars = sa.router.paramsToVars(params);
		if(vars.tab) {
			this.setPage(vars.tab, container);
		} else { //default
			container.html( 
				'<div id="license_list">Loading ' + (config.id == 90 ? 'download' : 'license') + ' history...</div>');
			this.loadLicenseHistory(params);
		}
	};
	
	/**
	 * Loads the data from the server
	 */
	this.loadLicenseHistory = function(params) {
		var page = this;
		console.log('loading ' + (config.id == 90 ? 'download' : 'license') + ' history...', params);
		var vars = (params) ? sa.router.paramsToVars(params) : {};
		vars.p = 'license_profile';
		vars.action = 'getLicenseHistory';
		vars.section = 'dashboard';
		params = sa.router.queryParamsToString(vars).substr(1);
		
		$j('#license_list').html('Loading...');
		ajax(params, function(response) { 
			page.setLicenseList(response);
		 });
	};
	
	
	/**
	 * Populates the license list after it's loaded
	 * @param {json} newData the list of licenses
	 */
	this.setLicenseList = function(licenseData) {
		var page = this,
			container = $j('#license_list').html('');
		
		var licenses = licenseData[0][0];
		var tracksList = licenseData[0][1];
		var listInfo = licenseData[0][2];
		//override
		console.log('license data:', licenses);
		console.log('track data:', tracksList);
		console.log('list info:', listInfo);
		
		if(!tracksList) {
			container.append('You have no ' + (config.id == 90 ? 'download' : 'license') + ' history yet.');
			return;
		}
		
		//trackbank
		trackBank.clear('license_history_page');
		$j.each(tracksList, function(key, track) {
			//console.log('track to parse:', track);
			track = JSON.parse(track);
			tracksList[key] = track;
			trackBank.add(track, 'license_history_page');
		});
	
		var conf = new ListConfig();
		conf.bankKey = 'license_history_page';
		conf.sortable = true;
		conf.addColumnList([
			new ListColumn('track', ['play', 'title'], true),
			new ListColumn('date', ['date'], true),
			//new ListColumn('by', ['licensee'], true),
			new ListColumn('price', ['license_price'], true),
			new ListColumn('status', ['license_status'], true),
			new ListColumn('view', ['license_view']),
			new ListColumn('source files', ['source_download'])
		]);
		
		container.append('<div id="list_'+conf.bankKey + '" class="list"></div>');
		var list = createLicenseHistoryList(conf);
		list.generatePage($j('#list_'+conf.bankKey));
		
		var listParams = {
			count: listInfo.count,
			page: listInfo.pg,
			perPage: listInfo.rpp,
			pageVars: ((listInfo.o) ? 'o=' + listInfo.o + '&d=' + listInfo.d + '&' : '')+'show='+listInfo.rpp+'&pg='
		};
		
		//console.log('list params:', listParams);
		//format data
		var listItems = [];
		listItems.push(listParams);
		
		$j.each(licenses, function(key, l) {
			l.license = JSON.parse(l.license);
			var item = {
					id : l.track_licensed,
					title : (tracksList[l.track_licensed]) ? tracksList[l.track_licensed].title : 'No Track Found',
					date : l.time,
					licensee : l.first_name + ' ' + l.last_name,
					license_price : Number(l.price * 100).moneyFormat(2, true),
					license_status : l.status
				},
				track = tracksList[item.id];
			if (l.status == 'Complete') {
				item.license_view = '<a href="pdf.php?type=invoice&'+((l.transaction_id) ? 'transaction_id=' + l.transaction_id : 'license_id='+l.id)+'">Invoice</a><br/><a href="pdf.php?type=legal&'+((l.transaction_id) ? 'transaction_id=' + l.transaction_id : 'license_id='+l.id)+'">License</a>';

				if(track) {
					var formats = [];
					let baseUrl = siteBaseUrl();
					if (track.formats.mp3) {
						formats.push(`<a href="${baseUrl}/download.php?track_id=${l.track_licensed}&type=mp3&source=license_history"><img src="images/icons/mp3.png"/></a>`);
					}
					if (track.formats.wav) {
						formats.push(`<a href="${baseUrl}/download.php?track_id=${l.track_licensed}&type=wav&source=license_history"><img src="images/icons/wav.png"/></a>`);
					}
					if (track.formats.aiff) {
						formats.push(`<a href="${baseUrl}/download.php?track_id=${l.track_licensed}&type=aiff&source=license_history"><img src="images/icons/aiff.png"/></a>`);
					}
					if (track.formats.extras.length) {
						var extras = track.formats.extras;
						for (var i = 0, len = extras.length; i < len; i++) {
							var extra = extras[i],
								extension = extra.extension == 'aif' ? 'aiff' : extra.extension;
							formats.push(`<a href="download.php?&' + 'track_id=${l.track_licensed}&type=extra&extraType=${encodeURIComponent(extra.type)}&source=details"><img src="images/icons/${extra.extension}.png"/><br/>${extra.type}</a>`);
						}
					}
					item.source_download = formats.join(' &nbsp; ') + '<div class="clr"></div>';
				}
			} else {
				//offer
				let baseUrl = siteBaseUrl();
				item.license_view = '<a href="'+baseUrl+'/license-now?section=offer_respond&offer_id='+l.id+'">Offer</a>';
				item.source_download = 'N/A';
			}
			listItems.push(item);
		});
		
		list.setData(listItems, function(params) { return siteBaseUrl() + '/dashboard?p=licenses&'+params; }, function(params) { console.log('sort click'); return true;});
	};
	
}
/**
 * The page of the dashboard that lets you update your outgoing mail format
 */
function DashboardMail() {

	var templates;

	/**
	 * Shows the page form
	 */
	this.show = function(params, container) {

		if (!templates) {
			templates = sa.templates.get('dashboard.mail');
		}

		var template = templates.get('page', { siteName : config.name, username : user.userData.username });

		// Email Settings
		template.find('.left textarea').val(user.getOption('mail_template')).on('keyup', function () {
			updateExample();
		});

		// set up default visibility check box
		var useCustomCheck = template.find('#custom_template');
		if (user.getOption('use_custom_mail_template') == '1') {
			useCustomCheck.prop('checked', true);
			template.find('.template_changer').show();
		}
		useCustomCheck.on('click', function () {
			var useCustom = useCustomCheck.filter(':checked').length;
			user.setOption('use_custom_mail_template', useCustom ? 1 : 0);
			if (useCustom) {
				template.find('.template_changer').slideDown();
			} else {
				template.find('.template_changer').slideUp();
			}
		});

		// admin email preferences
		if (user.hasAdminPermission(AdminPermission.Licensees) || user.hasAdminPermission(AdminPermission.MusicSuppliers)) {
			if (user.userData.emailPreferences.syndication) {
				template.find('input[name=syndication_updates]').prop('checked', true);
			}
			template.find('.email_preferences .button').on('click', function() {
				saveEmailPreferences();
			});
		} else {
			template.find('.email_preferences').remove();
		}

		template.find('.left .save_changes').on('click', function() { saveChanges(); });

		container.empty().append(template);

		if (user.getOption('use_custom_mail_template') == '1') {
			template.find('.template_changer').show();
		}

		updateExample();
	};

	/**
	 * Updates the example text so it matches the currently entered format
	 */
	function updateExample() {
		let textarea = $j('#mail_template textarea');
		if (!textarea.length) return;

		let currentText = textarea.val();
		// replace any html
		currentText = currentText.replace(/</g, '&lt;').replace(/>/g, '&gt;');
		// replace bold
		currentText = currentText.replace(/\*\*(.+)\*\*/g, '<b>$1</b>');
		// replace urls
		currentText = currentText.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2">$1</a>');
		// replace images
		currentText = currentText.replace(/\{([^\}]+)\}/g, '<img src="$1"/>');
		// replace details
		currentText = currentText.replace(/%details%/g, '6 tracks in a playlist called <a class="example_link" href="#0">awesome music</a>');
		// replace link
		currentText = currentText.replace(/%link%/g, '<a class="example_link" href="#0">https://' + config.domain + '/example-link</a>');
		// replace message
		currentText = currentText.replace(/%message%/g, 'Your message will go here');
		// replace site_link
		currentText = currentText.replace(/%site_link%/g, 'https://' + config.domain);
		// replace site_name
		currentText = currentText.replace(/%site_name%/g, config.name);
		// replace username
		currentText = currentText.replace(/%username%/g, user.userData.username);
		// replace italic
		currentText = currentText.replace(/__(.+)__/g, '<i>$1</i>');
		// replace newlines
		currentText = currentText.replace(/\n/g, '<br/>');

		$j('#example').html(currentText).find('.example_link').on('click', function() {
			sa.alert('This will link to the sent track/playlist/album/etc.');
			return false;
		});
	}

	/**
	 * Checks to see if the user has entered any information on the dashboard account page
	 * Validates that data and saves it if no errors were detected
	 */
	function saveChanges() {
		var currentText = $j('#mail_template textarea').val();
		$j('#mail_template .error').remove();
		// you have to enter at least one link or one details. other than that, whatever
		if (currentText && currentText.indexOf('%link%') == -1 && currentText.indexOf('%details') == -1 && config.id != 215) {
			$j('#example').after(templates.get('link_error'));
		} else {
			user.setOption('mail_template', currentText, newData => {
				let result = newData.length ? newData[0].result : newData.result;
				let value = newData.length ? newData[0].value : newData.value;
				if (result === 'success') {
					$j('#mail_template textarea').val(value);
					updateExample();
					sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
				} else {
					sa.alert(createText(result));
				}
			});
		}
	}

	function saveEmailPreferences() {
		var preferences = $j('.email_preferences input');
		if (preferences.length) {
			var preferenceString = '';
			for (var i = 0, len = preferences.length; i < len; i++) {
				preferenceString += '&emailPreferences[' + preferences[i].name + ']=' + (preferences[i].checked ? 1 : 0);
			}
			ajax(preferenceString, function() {
				sa.notify({ text : 'Email preferences saved!', type : sa.notify.notificationTypes.success });
			}, 'POST', 'p=account&action=saveEmailPreferences');
		}
	}
}
/**
 * The page of the dashboard that shows you your inbox
 */
function DashboardInbox() {

	let templates;

	/**
	 * Shows the page form
	 */
	this.show = function(params, container) {

		if (!templates) {
			templates = sa.templates.get('dashboard.inbox');
		}

		const template = templates.get('page', { siteName : config.name, username : user.userData.username });
		container.empty().append(template);
		
		$j('#ltp_container').addClass('dashboard-inbox');

		$j('.right_head').hide();
		window.mountReactComponent(container.find('#inbox-root')[0], 'site-inbox', { siteType: config.siteType });
	};
}
/**
 * The page in the dashboard that shows items the user has received
 * Uses a basic List and s projects, albums, and tracks
 */
function DashboardReceived() {
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		DashboardListPage.prototype.show.call(this, params, container, 
			[
				new ListColumn('date', ['date']),
				new ListColumn('type', ['type']), 
				new ListColumn('name', ['multi_name', 'expand']),
				new ListColumn('sender', ['user avatar', 'username']),
				new ListColumn('download', ['multi_download']),
				new ListColumn('tracks', ['track count'])
			],
			'received');
	};
}
DashboardReceived.prototype = new DashboardListPage();
/**
 * The page in the dashboard that shows any searches they've saved
 */
function DashboardSaved() {
	var page = this;
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		container.html(
			'<div class="saved_searches">'
				+ '<div class="header">'
					+ '<div class="search">Search</div>'
					+ '<div class="date">Date Saved</div>'
					+ '<div class="options">Options</div>'
					+ '<div class="clr"></div>'
				+ '</div>'
				+ '<div class="search_list">'
				+ '</div>'
			+ '</div>'
		);
		var searchList = container.find('.search_list');
		ajax('p=saved_search&action=list', function(response) {
			if (!response.length) {
				searchList.append('<div class="empty">You haven\'t saved any searches yet. Use the button on the right after running a search.</div>');
				return;
			}
			
			let baseUrl = siteBaseUrl();
			for (var i = 0, len = response.length; i < len; i++) {
				var s = response[i];
				if (!s.search.startsWith('/')) {
					s.search = '/' + sa.router.pathConversionLookup(s.search);
				}
				s.search = sa.router.removeDevPathFragment(s.search);
				s.search = s.search.replace(/\/{2,}/, '/');
				searchList.append(
					'<div class="saved_search">'
						+ '<a class="search" href="' + baseUrl + s.search + '">' + s.name + '</a>'
						+ '<div class="date">' + formatDate(config.dateTimeFormatString, s.date) + '</div>'
						+ '<div class="options">'
							+ '<a class="icon fa fa-times faux_button" title="Unsave this search"></a>'
						+ '</div>'
						+ '<div class="clr"></div>'
					+ '</div>'
				);
				searchList.find('.fa-times:last').on('click', function(s) { return function () {
					ajax('id=' + s.id, function() {
						page.show(params, container);
					}, 'POST', 'p=saved_search&action=delete');
				}; }(s));
			}
		});
	};
}
/**
 * The page in the dashboard that shows items the user has received
 * Uses a basic List and s projects, albums, and tracks
 */
function DashboardSent() {
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		sa.pages.sent.show({
			type : sa.pages.sent.SentTypeUser,
			topMessage : '',
			emptyMessage : 'You haven\'t sent any playlists. You can send them using the "My Playlists" tool on the left'
		}, container);
	};
	
}
/**
 * The page of the dashboard that lets you update your outgoing mail format
 */
function DashboardLicensingSubscription() {
	const page = this;
	window.currentPage = page;

	// public vars
	this.vars = null;
	this.container = null;
	this.user_subscription = false;
	this.saved_payment_data = null;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		activePage = page;
		page.container = container;

		const vars = sa.router.paramsToVars(params);
		page.vars = vars;

		// Load data for the page
		page.preloadData();

		page.container.on('click', 'div.yt-search-link', () => {
			sa.components.yt_channel_search.show(setChannelId);
		});

		function setChannelId(selectedChannelId) {
			page.container.find('#whitelist-channel').val(selectedChannelId);
		}
	};

	/*
	* preload the data
	*/
	this.preloadData = function() {
		page.container.html('<div id="subscription_management">Loading subscription...</div>');
		page.loadUserSubscription();
	};

	/**
	 * load user subscription
	 */
	this.loadUserSubscription = function() {
		// Get the user license, payment, and subscription data
		sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'getUserSubscriptionHistory'
		}).then(page.loadUserSubscriptionHandler.bind(page));

	};

	this.loadUserSubscriptionHandler = function(response) {
		// Check errors
		if (response.error) {
			sa.notify({ text: response.error });
			return;
		}

		// Set payment variables
		page.saved_payment_data = response.paymentMethods || [];

		// Set user subscription variables
		page.user_subscription = response.userSub || [];

		// Set the user's current subscription paid through date
		page.user_subscription_paid_through_date = response.currentSubPaidThroughDate;

		// Set licensing activity variables
		page.user_licensing_activity = response.activityHistory || [];

		// Show the subscription data on the page)
		page.showSubscription();
	};

	// submit payment
	this.saveNewCard = function () {

		page.setProcessing(true);

		if (!page.nonce) return $j('#braintree-submit').trigger('click');

		var cardholder = $j('#infop_cardholder_name').val();

		sa.api.request({
			handler: 'licensing/licensingCheckout',
			action: 'saveCreditCardInfo',
			postData: {
				cardholder: cardholder
			}
		}).then(page.braintreeCardSaveHandler);
	};

	/**
	 * the handler for braintree card saving
	 */
	this.braintreeCardSaveHandler = function(response) {
		console.log('card save response:', response);
		let baseUrl = siteBaseUrl();
		window.location.href = baseUrl + '/dashboard?p=licensing-subscription&saved=1';
	};

	this.setProcessing = function(proc) {
		if(proc) {
			//deactivate the button and change the image
			$j('#submit_payment_button img').attr('src', 'images/licensing/processing.png');
			$j('#submit_payment_button').removeClass('faux_button');
			page.processing = true;
		} else {
			//activate it, and put stuff back as it was
			$j('#submit_payment_button img').attr('src', 'images/shoppingcart/save-card-blue.png');
			$j('#submit_payment_button').addClass('faux_button');
			page.processing = false;
		}
	};

	/**
	 * show the users subscriptions
	 */
	this.showSubscription = function() {
		if(!config.licensingConfig.plans) {
			page.container.html('This workspace is not configured for subscriptions.');
			return;
		}

		if(!page.user_subscription) {
			page.user_subscription = {status:'none'};
		}
		var channelIdFAQ = '<br/><a href="https://support.google.com/youtube/answer/3250431?hl=en" target="_blank">How do I find my channel id?</a>';
		channelIdFAQ = '';
		let baseUrl = siteBaseUrl();
		page.container.html(
			'<div class="dashboard_sub_section">'
			+	'<div class="dashboard_sub_title">View or change your current plan:</div>'
			+	((page.vars.change) ? '<div class="scart_shelved_items">Your plan was successfully changed.</div>' : '')
			+	((page.vars.saved) ? '<div class="scart_shelved_items">Your new card has been added.</div>' : '')
			+	'<div class="subscription_plans"></div>'
			+ '</div>'
			+ (page.user_subscription.whitelist == 1 && ['active', 'trial', 'init'].indexOf(page.user_subscription.status) != -1 ? '<div class="dashboard_sub_section">'
				+ '<div class="dashboard_sub_title">Whitelisting:'
				+ 	'<a class="dashboard_cc_button button db_sub-whitelist" href="'+baseUrl+'/dashboard?p=contentid">'
				+ 		'&nbsp;&nbsp;&nbsp;<i class="icon fa fa-youtube"></i>'
				+ 		'&nbsp; YouTube Whitelist&nbsp;&nbsp;&nbsp'
				+ 	'</a>'
				+ '</div>'
				+	'<div class="entry-description">'
				+ (config.id == 5520 ? // claims free
						'Currently only YouTube Channels need to be added to make sure you receive no claims on social media. If/when other platforms are needed, we will notify you! Visit your <a href="'+ baseUrl +'/dashboard?p=contentid">YouTube whitelist &raquo;</a> to add and manage channels whitelisted by your subscription for claim-free usage of the eligible tracks\' included with your subscription.'
						:
						'Visit your <a href="'+ baseUrl +'/dashboard?p=contentid">YouTube whitelist &raquo;</a> to add and manage channels whitelisted by your subscription for claim-free usage of the eligible tracks\' included with your subscription.'
				)
				+	'</div>'
				+ '</div>': '')
			+ ((['active', 'trial', 'init'].indexOf(page.user_subscription.status) != -1) ? '<div class="dashboard_sub_section">'
				+	'<div class="dashboard_sub_title">Your Current Balance and Billing Cycle:</div>'
				+	'<div class="dashboard_sub_billing">'
				+		'<div class="dashboard_sub_billing_item">My Subscription Status:</div>'
				+		'<div class="dashboard_sub_billing_value">Active</div><div class="clr"></div>'
				+		'<div class="dashboard_sub_billing_item">My Current Balance of Free Downloads:</div>'
				+		'<div class="dashboard_sub_billing_value">' + (page.user_subscription.userOptions.download_credit === 99999 ? 'Unlimited' : page.user_subscription.userOptions.download_credit) + '</div><div class="clr"></div>'
				+		'<div class="dashboard_sub_billing_item">Paid Through Date:</div>'
				+		'<div class="dashboard_sub_billing_value">'+formatDate('F j, Y', page.user_subscription_paid_through_date)+'</div><div class="clr"></div>'
				+	'</div>'
				+ '</div>' : '')
			+ '<div class="dashboard_sub_section">'
			+	'<div class="dashboard_sub_title">Your Credit Cards on File:</div>'
			+	'<div class="dashboard_stored_ccs"></div>'
			+ '</div>'
			+ '<div class="dashboard_sub_section">'
			+	'<div class="dashboard_sub_title">Previous Subscription Transactions:</div>'
			+	'<table class="dashboard_transactions">'
			+	'<tr><th>Date</th><th>Type</th><th></th><th>Amount</th><th>Card/Method</th><th></th></tr>'
			+	'</table>'
			+ '</div>'
		);

		if (page.user_subscription.whitelist) {

			$j('#whitelist-save').on('click', function() {
				var channel_id = $j('#whitelist-channel').val();
				if (!channel_id) return sa.error('You must enter a channel id to save!');

				console.log('- checking channel id', channel_id);

				sa.api.request({
					handler: 'licensing/licensingSubscriptions',
					action: 'checkSubscriptionWhitelist',
					getData: {
						channel_id: channel_id,
					}
				}).then(function (r) {
					console.log('- whitelist check:', r);
					if (r.error) return sa.error(r.error);
					if (!r.channel_name) return sa.error('We could not find a channel with that id. Please make sure you have it copied correctly. It should look something like "UC_B7kPmEgq9QbgkwNKjG1Cg"');

					sa.confirm({
						text: 'We found a channel named <b>' + r.channel_name + '</b>. Is that right?',
						yesFunction: function () {
							console.log('- saving whitelist');

							sa.api.request({
								handler: 'licensing/licensingSubscriptions',
								action: 'saveSubscriptionWhitelist',
								postData: {
									channel_id: channel_id,
								}
							}).then(function (r) {
								console.log('- save whitelist', r);
								if (r.error) return sa.error(r.error);

								sa.notify({ text: 'Channel whitelist saved!' });
								sa.router.reloadPage();
							});
						},
						yesText: 'Yes'
					});
				});
			});

		}

		if(!page.user_subscription || ['active', 'trial', 'init'].indexOf(page.user_subscription.status) == -1) {
			let baseUrl = siteBaseUrl();
			$j('.subscription_plans').html('<div class="dashboard_sub_signup">You have no active subscriptions. Click <a href="'+baseUrl+'/subscriptions">here</a> to sign up!</div>');
		} else
		if (page.user_subscription && page.user_subscription.braintreeId == 'import') {
			var sub = _.find(config.licensingConfig.plans, function(p) { return p.id == page.user_subscription.plan; });

			$j('.subscription_plans').html('<div id="update-sub" class="dashboard_sub_signup" style="cursor:pointer">You have a <b>' + sub.title + ' Plan</b> that was imported from a different billing system. Your credit card information is secure and unretrievable, so much so that we cannot retrieve it and add it to the new system. Please <span style="text-decoration: underline">click here</span> to update your info and continue your subscription.');

			$j('#update-sub').on('click', function() {
				purchaseModal.show('licensing_subscription', page.handlePurchase, 1, sub, true);
			});

		} else {
			var oldPlan = false;
			var userPlan = _.find(config.licensingConfig.plans, function(p) { return p.id == page.user_subscription.plan;});
			if (!userPlan) {
				oldPlan = true;
				userPlan = page.user_subscription;
			}

			$j.each(config.licensingConfig.plans, function(key, sub) {
				if (!sub.price) return true;
				var billingFrequency = parseInt(sub.billing_frequency);
				if (billingFrequency > 12) return;
				var billingFrequencyText = page.parseBillingFrequency(billingFrequency);
				var showHiddenPlan = false;
				if(sub.id == page.user_subscription.plan) {
					var selected = true;
					var select_image = 'plan-selected.png';
					if (sub.hidden) showHiddenPlan = true;
				} else {
					selected = false;

					//upgrade or downgrade?
					if(parseInt(sub.price) > parseInt(userPlan.price)) {
						//upgrade
						select_image = 'upgrade.png';
					} else {
						select_image = 'downgrade.png';
					}
				}

				if (!sub.hidden || (sub.hidden && showHiddenPlan)) {
					$j('.subscription_plans').append(
						'<div id="sub_plan_' + sub.id + '" class="sub_plan' + ((selected) ? ' selected' : '') + '">'
						+ '<div class="sub_plan_title">'
						+ '<div class="sub_plan_title_main">' + page.htmlEntities(sub.title) + '</div>'
						+ '<div class="sub_plan_title_sub">' + (sub.price / 100).currencyFormat() + billingFrequencyText.short + '</div>'
						+ '</div>'
						+ '<div class="sub_plan_details">'
						+ '<div class="sub_plan_detail">' + page.cleanDetails(sub.description) + '</div>'
						+ '</div>'
						+ '<div class="sub_plan_button">'
						+ '<div class="sub_plan_addtocart"><img class="faux_button" src="images/shoppingcart/' + select_image + '"/></div>'
						+ '</div>'
						+ '<div class="clr"></div>'
						+ '</div>'
					);

					if (sub.id != page.user_subscription.plan) {
						$j('#sub_plan_' + sub.id + ' .faux_button').on('click', function () {
							page.planClick(sub);
						});
					}
				}
			});

			$j('.subscription_plans').append(
				'<div class="dashboard_unsubscribe">'
				+ '<div id="update_payment_method_button" class="dashboard_cc_button faux_button">Change Payment Method</div>'
				+ '<div id="cancel_subscription_button" class="dashboard_cc_button dashboard_cc_delete faux_button">Cancel Subscription</div>'
				+ '</div><div class="clr"></div>'
			);

			$j('#cancel_subscription_button').on('click', function() {
				var b = $j(this);
				const removeCredits = config.licensingConfig.options.removeCredits || config.licensingConfig.options.noRollover || page.user_subscription.downloads === 99999;
				const cancelAndRemoveCreditsMessage = 'Cancelling your subscription will be effective immediately and you will lose any free downloads you have on credit. Proceed?';
				const cancelAndKeepCreditsMessage = 'Cancelling your subscription will be effective immediately, but your credit will remain. Proceed?';
				sa.confirm({
					text: removeCredits ? cancelAndRemoveCreditsMessage : cancelAndKeepCreditsMessage,
					yesFunction: function() {
						b.html('Cancelling...');
						b.off();
						page.cancelSubscription();
					},
					yesText: 'Yes'
				});
			});

			$j('#update_payment_method_button').on('click', function () {
				console.log('- showing purchse modal: update subscription payment method, user_sub: ' + page.user_subscription);
				purchaseModal.showSubscriptionChanger('update_sub_payment', page.updatePaymentMethod);
			});
		}
		//append credit cards

		/**
		 * GET SUBSCRIPTION TRANSACTIONS FROM LICENSING ACTIVITY
		 */
		let subscriptions = page.user_licensing_activity.filter(sub => sub.type.includes('user_subscription'));

		if(!page.saved_payment_data.length) {
			$j('.dashboard_stored_ccs').html('<div class="dashboard_stored_cc">No cards saved.</div>');
		} else {
			/**
			 * LIST ALL THE CREDIT CARDS ON FILE
			 */
			var transactions = [];
			$j.each(page.saved_payment_data, function (ii, card) {

				// pull out transactions before we continue
				_.each(card.subscriptions, function(sub) {
					transactions = transactions.concat( sub.transactions );
				});

				var active = (page.user_subscription.paymentMethod == card.token && ['active', 'trial', 'init'].indexOf(page.user_subscription.status) != -1);
				$j('.dashboard_stored_ccs').append(
					'<div id="card_'+card.token+'" class="dashboard_stored_cc'+((active) ? ' active' : '')+'">'
					+	'<div class="dashboard_cc_type"><b>'+card.cardType+'</b> ending in '+card.last4+'</div>'
					+	'<div class="dashboard_cc_name">'+ (card.cardholderName ? card.cardholderName : '--') + '</div>'
					+	'<div class="dashboard_cc_date">'+card.expirationDate+'</div>'
					+	'<div class="dashboard_cc_options">'
					+		((active) ? '' : '<div class="dashboard_cc_button faux_button make_active_button">Make Active</div>')
					+		'<div class="dashboard_cc_button dashboard_cc_delete faux_button delete_card_button">Delete</div>'
					+		'<div class="clr"></div>'
					+	'</div>'
					+	'<div class="clr"></div>'
					+ '</div>'
				);

				if(!active) {
					$j('#card_'+card.token).find('.make_active_button').on('click', function() {
						$j(this).html('Processing...');
						$j(this).off();
						page.makeCardActive(card);
					});
				}

				$j('#card_' + card.token).find('.delete_card_button').on('click', function() {
					if (active) {
						const removeCredits = config.licensingConfig.options.removeCredits || config.licensingConfig.options.noRollover;
						const cancelAndRemoveCreditsMessage = 'Deleting this card will cancel your subscription, effective immediately, and you will lose any free downloads you have on credit. Proceed?';
						const cancelAndKeepCreditsMessage = 'Deleting this card will cancel your subscription, effective immediately, but your credit will remain. Proceed?';

						sa.confirm({
							text: removeCredits ? cancelAndRemoveCreditsMessage : cancelAndKeepCreditsMessage,
							yesFunction() {
								$j(this).html('Deleting...');
								$j(this).off();
								page.deleteCard(card);
							},
							yesText: 'Yes'
						});
						return;
					}
					$j(this).html('Deleting...');
					$j(this).off();
					page.deleteCard(card);
				});
			});
		}

		/**
		 * GENERATE HTML FOR SUBSCRIPTION TRANSACTION HISTORY
		 */
		_.each(subscriptions, function(s) {
			let transaction = s.transaction || false;

			$j('.dashboard_transactions').append(page.formatTransactionEntry(s, transaction));
		});

		if (window.location.hash === '#cards-on-file') {
			const cardsOnFileSection = document.querySelector('.dashboard_sub_billing');
			if (cardsOnFileSection) {
				cardsOnFileSection.scrollIntoView();
			}
		}
	};

	this.parseBillingFrequency = function(frequency) {
		if (frequency === 1) {
			return {
				'per': 'per month',
				'short': ' / mo.',
				'name': 'month'
			}
		} if (frequency > 1 && frequency < 12) {
			return {
				'per': 'every '+ frequency +' months',
				'short': ' / '+ frequency +' mos.',
				'name': 'months'
			}
		} else if (frequency === 12) {
			return {
				'per': 'per year',
				'short': ' / yr.',
				'name': 'year'
			}
		} else if (frequency % 12 === 0 && frequency > 12) {
			var years = frequency / 12;
			return {
				'per': 'every ' + years + ' years',
				'short': ' / ' + years + ' yrs.',
				'name': 'years'
			}
		} else {
			return {
				'per': 'per billing period',
				'short': ' / billing period',
				'name': 'billing period'
			}
		}
	};

	this.parseSubscriptionIdFromActivity = function(activityRow) {
		var pattern = /subscription::([A-Za-z0-9]+)/;
		var matches = pattern.exec(activityRow.purchase_id);
		return matches[1] || false;
	}

	this.htmlEntities = function(str) {
		return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	this.findCardTransactionMatchingLicenseActivity = function(activityRow) {
		var activityTimestamp = activityRow.date * 1000;
		var matchingTransaction, matchingCard;

		/**
		 *  Match where the transactions are within 1 second and the White ID and User ID are the same
		 */

		// Iterate through all the cards
		matchingCard = _.find(page.saved_payment_data, function(card, key) {

			// Make sure we only use cards from the same user (it's a safety check)
			if (card.customerId != activityRow.user_id) {
				return false;
			}

			// Get all the transactions
			var transactions = _.flatten(card.subscriptions.map(function(s) { return s.transactions; }), true);

			// Get matching transaction, if any
			matchingTransaction = _.find(transactions, function(t) {
				var createdAtTimestamp = Date.parse(t.createdAt.date + (t.createdAt.timezone === 'UTC' ? 'Z' :''));

				return Math.abs(createdAtTimestamp - activityTimestamp) <= 1000;
			});

			return matchingTransaction;
		});

		// If we didn't find a matching transaction, return false
		if (matchingCard === undefined) {
			return false;
		}

		return {
			card: matchingCard,
			transaction: matchingTransaction
		};
	}

	/**
	 * Format the HTML for the subscription transactions table
	 */
	this.formatTransactionEntry = function(activity, transaction) {
		// Date formatting options
		var dateOptions = {
			weekday: 'short',
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric'
		};

		// Put together the different table fields
		// Label for the "Type" column
		var type = '';
		var date = '<td>' + new Date(activity.date * 1000).toLocaleString(undefined, dateOptions) + '</td>';
		var cost = '<td>' + (activity.amount_paid / 100).currencyFormat() + '</td>';
		var card = '';
		var invoice = '';

		let sandboxActivity = `<td><span class="sandbox-pill">Sandbox</span></td>`;

		switch (activity.type) {
			case 'user_subscription':
				type = 'Sign Up';
				break;
			case 'user_subscription_renew':
				type = 'Renewal';
				invoice = '<td><a target="_blank" href="pdf.php' + ((config.secureString) ? config.secureString : '?') + '&type=licensing_subscription_renewal_invoice&activity_id=' + activity.id + '">&raquo; Invoice</a></td>';
				break;
			case 'user_subscription_cancel':
				type = 'Cancellation';
				break;
			case "user_subscription_downgrade":
				type = 'Downgrade';
				break;
			case "user_subscription_upgrade":
				type = 'Upgrade';
				break;
		}
		type = '<td>' + type + '</td>';



		if (transaction) {
			// If we have the transaction, put the card and invoice info
			card = '<td>' + transaction.creditCard.cardType + ' ' + transaction.creditCard.last4 + '</td>';
			invoice = '<td><a target="_blank" href="pdf.php' + ((config.secureString) ? config.secureString : '?') + '&type=licensing_subscription_invoice&transaction_id=' + transaction.id + '">&raquo; Invoice</a></td>';
		} else {
			// If we don't have the transaction info, then put N/A
			card = '<td>N/A</td>';
		}

		return '<tr>' + date + type + (activity.is_test_activity ? sandboxActivity : '') + cost + card  + invoice + '</tr>';
	};

	this.cleanDetails = function(text) {
		var a = htmlDecode(text).split('\n');
		a = _.map(a, function(l) {
			if (l.substr(0, 2) === '- ') {
				return '<li>' + l.substr(2) + '</li>';
			} else {
				return l + '<br>';
			}
		});

		return a.join('');
	};

	this.planClick = function(plan) {
		console.log('- showing purchaser for', plan.title);

		if (plan.price < page.user_subscription.price) {
			var loseUnlimited = 'Do you want to downgrade your subscription? Your unlimited plan will be replaced with the downgraded plan and you will not be refunded for any portion of the remaining billing period.';
			var downgrade = 'Do you want to downgrade your subscription? You will not be refunded, but your new plan will start at the end of the current billing period. You will not lose any downloads you have already paid for.';

			sa.confirm({
				text: page.user_subscription.downloads === 99999 ? loseUnlimited : downgrade,
				yesFunction: function() {
					page.downgradeToPlan( plan );
				},
				yesText: 'Yes'
			});
			return;
		}

		purchaseModal.show('licensing_subscription', page.handlePurchase, 1, plan, true);
	};

	this.downgradeToPlan = function(plan) {
		page.container.html('');
		showLoader( page.container, 'Processing downgrade...' );

		sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'downgrade',
			postData: {
				plan: plan.id,
			}
		}).then(function (data) {
			if (data.error) sa.alert({ text: data.error });

			page.preloadData();
		});
	};

	this.handlePurchase = function(r) {
		console.log(r);
		if (r) page.preloadData();
	};

	this.updatePaymentMethod = function (r) {
		console.log('dashboard sub: updatePaymentMethod response:', r);
		if (r.error) sa.notify({ text: r.error });
		if (r.success) {
			sa.notify({ text: 'Subscription payment method updated.', type: 'success_notification' });
			page.preloadData();
		}
	};

	this.makeCardActive = function(card) {
		console.log('making card', card, 'active for subscription');

		sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'changeSubscriptionCard',
			getData: {
				card_token: card.token,
			}
		}).then( page.handleChangeSubscription);
	};

	this.deleteCard = function(card) {
		console.log('deleting card', card);
		sa.api.request({
			handler: 'licensing/licensingCheckout',
			action: 'deleteCard',
			postData: {
				card_token: card.token
			}
		})
			.then(page.handleChangeSubscription)
			.catch(err => {
				console.error('Could not delete card', card, err);
				sa.alert({ text: err.message });
			});
	};

	this.handleChangeSubscription = function(r) {
		console.log(r);
		page.preloadData();
	};

	this.cancelSubscription = function() {
		console.log('cancelling sub');
		var loggedInUserId = getCurrentUserId();
		sa.api.request({
			getData: {
				'from': 'Licensing Subscription Dashboard',
				'loggedInUserId': loggedInUserId
			},
			handler: 'licensing/licensingSubscriptions',
			action: 'cancelSubscription'
		}).then(function (r) {
			console.log('- cancel sub response:', r);
			if (r.error) sa.notify({ text: r.error });

			if (Number.isInteger(r.download_credits) && r.download_credits > -1) {
				$j('#header-credit-amount').text(r.download_credits);
			}

			page.preloadData();
		});
	};

	this.selectPlan = function (subid) {
		const sub = config.licensing.subscriptions[subid];
		page.selected_plan = sub;

		//clear selection of other plans
		$j('.sub_plan').removeClass('selected');
		$j('.sub_plan_addtocart img').attr('src', 'images/shoppingcart/select-plan.png');
		$j('#sub_plan_'+sub.id).addClass('selected');
		$j('#sub_plan_'+sub.id).find('.sub_plan_addtocart img').attr('src', 'images/shoppingcart/plan-selected.png');

	};
}
/**
 * The page of the dashboard that lets you update your outgoing mail format
 */
function DashboardLicensingHistory() {
	var page = this;

	//public vars
	this.vars = null;
	this.container = null;
	this.loaded = {}; //for preloading
	this.after_load = null;
	this.user_subscription = false;
	this.saved_payment_data = null;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		activePage = page;
		page.container = container;

		container.html( '<div id="licensing-history"></div>' );
		page.container = container;
		showLoader('#licensing-history', 'Loading Licenses');

		
		page.vars = sa.router.paramsToVars(params);

		page.loadHistory();
	};

	this.loadHistory = function() {
		page.loaded.user_subscription = false;
		sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'getHistory',
			getData: {
				pg: page.vars.pg || 0,
				show: page.vars.show || 25
			}
		}).then(page.renderHistory);
			
	};

	this.renderHistory = function(r) {
		console.log('- history', r);
		if (r.error) sa.notify({ text : r.error });

		//trackbank
		trackBank.clear('licensing_history_page');
		r.tracks = r.tracks.length ? JSON.parse(r.tracks) : [];
		console.log('- parsed:', r.tracks);
		var tracks = {};
		_.each(r.tracks, function(track) {
			if (!track.id) return;
			tracks[track.id] = track;
			trackBank.add(track, 'licensing_history_page');
		});

		var conf = new ListConfig();
		conf.bankKey = 'licensing_history_page';
		conf.sortable = true;

		// Check if the activity has test/sandbox data
		const hasSandboxActivity = r.items.find(item => item.is_test_activity === 1);
		
		let columnList = [
			new ListColumn('track', ['play', 'title'], true),
			(hasSandboxActivity ? new ListColumn(' ', ['sandbox_activity']) : null),
			new ListColumn('date', ['licensing_date'], true),
			new ListColumn('download', ['licensing_download'], true),
			new ListColumn('links', ['licensing_view'])
			//new ListColumn('source files', ['source_download'])
		];

		// Filter out null columns (e.g. - sandbox activity, if not present)
		conf.addColumnList(columnList.filter(column => column));

		var list = createLicensingActivityList(conf);
		list.generatePage($j('#licensing-history').html(''));

		var listInfo = r.listInfo;
		var listParams = {
			count: listInfo.total || 25,
			page: listInfo.pg || 0,
			perPage: listInfo.show || 25,
			pageVars: ((listInfo.o) ? 'o=' + listInfo.o + '&d=' + listInfo.d + '&' : '')+'&show='+listInfo.show+'&pg='
		};

		//console.log('list params:', listParams);
		//format data
		var listItems = [];
		var highlightItems = [];
		listItems.push(listParams);

		_.each(r.items, function(a) {

			var track = tracks[ a.track_id ];

			if (page.vars.transaction && page.vars.transaction == a.transaction_id) {
				highlightItems.push( a.track_id );
			}

			var extra = {};
			if (a.data) {
				try {
					extra = JSON.parse(a.data) || {};
				} catch(e) {
					console.log('- error parsing data from:', a.data);
				}
			}

			var item = {
				id: a.track_id,
				title: track ? track.title + (extra.alts ? ' [+' + extra.alts + ']' : '') : '[Deleted Track]',
				licensing_date: formatDate('Y-n-j', a.date),
				licensing_download: 'N/A',
				//licensing_price: (a.paid ? (a.paid / 100).currencyFormat() + (a.credit_used ? '<br>' : '') : (a.credit_used ? '' : 'No payment')) + (a.credit_used ? 'Credit: ' + a.credit_used : ''),
				licensing_view: '<a target="_blank" href="pdf.php?type=licensing_invoice&transaction_id=' + a.transaction_id + '">&raquo; Invoice</a> <a target="_blank" href="pdf.php?' + (a.project =='imported' ? '&type=legal&transaction_id=' + a.transaction_id.substr(2) : '&type=licensing_license&license_id=' + a.id) + '">&raquo; License</a>'
			};
			
			if (hasSandboxActivity) {
				item['sandbox_activity'] =  (a.is_test_activity ? '<span class="sandbox-pill">Sandbox</span>' : '<span class="sandbox-pill no-sandbox-active">Sandbox</span>');
			}

			if (track) {
				var formats = [];
				let baseUrl = siteBaseUrl();
				if (track.formats.wav && config.downloadFormats.wav) {
					formats.push(`<a href="${baseUrl}/download.php?track_id=${a.track_id}&type=wav&source=license_history">WAV</a>`);
				}
				if (track.formats.aiff && config.downloadFormats.aiff) {
					formats.push(`<a href="${baseUrl}/download.php?track_id=${a.track_id}&type=aiff&source=license_history">AIFF</a>`);
				}
				if (config.downloadFormats.mp3) {
					formats.push(`<a href="${baseUrl}/download.php?track_id=${a.track_id}&type=mp3&source=license_history">MP3</a>`);
				}
				item.licensing_download = formats.join(' &nbsp; ');
			}

			listItems.push(item);
		});

		list.setData(listItems, function(params) { 
			let link = '/dashboard?p=licensing-history&' + params;
			link = link.replace(/&{2,}/, '&');
			return siteBaseUrl() + link;
		}, function(params) { console.log('sort click'); return true;});

		if (highlightItems.length) {
			_.each(highlightItems, function(id) {
				console.log('- highlighting', id);
				page.container.find('#lr_' + id).addClass('highlighted');
			});
		}
	};
}
/**
 * The admin container that gives users access to the internal admin pages
 * @returns {Admin}
 */
function Admin() {
	var adminPage = this;
	/**
	 * {Page} The object that's the current page being shown in the admin
	 */
	var currentPage = null;
	/**
	 * {string} the type of page we're showing
	 */
	var currentPageType = '';

	this.name = 'admin';

	/**
	 * @var {Array.<LeftTab|LeftDivider>}
	 */
	var tabs = [];
	
	function getTabs() {
		if (!tabs.length) {
			const setPage = function (tabId, cont) {
				adminPage.setPage(tabId, cont);
			};
			
			/**
			 * Fox AR permissions (also in admin.foxar.js so change in both places)
			 */
			let allowedFoxAREmails = [
				'simon.kim@fox.com',
				'alekhya.kurra@fox.com',
				'soujanya.achyuta2@fox.com',
				'nabeel.ahmad@fox.com',
				'melissa.stern@foxcable.com',
			];
			let allowedWhites = [2068, 4925]
			let foxARShow = allowedWhites.includes(config.id) && (allowedFoxAREmails.includes(user.userData.email.toLowerCase()) || user.hasAdminPermission(AdminPermission.SuperAdmin));
			/** *** */

			let hrefBase = siteBaseUrl();
			
			const pages = [
				{section: 'Manage Your Workspace', enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
				{id: 'inbox', href: hrefBase + '/admin?p=inbox', title: 'Inbox', icon: 'fa fa-inbox', isDisabled: !user.hasAdminPermission(AdminPermission.Licensees) && !user.hasAdminPermission(AdminPermission.Pando), hasPageFeature: true, enabledSiteTypes: ['seller']},
				{id: 'users', href: hrefBase + '/admin?p=users', title: 'Manage Users', icon: 'fa fa-group', isDisabled: !user.hasAdminPermission(AdminPermission.Users) || (config.grayLabel && !user.hasAdminPermission(AdminPermission.SuperAdmin)), hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
				{id: 'stats', href: hrefBase + '/admin?p=stats', title: 'View Statistics', icon: 'fa fa-bar-chart-o', isDisabled: (!user.hasAdminPermission(AdminPermission.Statistics) && !user.hasAdminPermission(AdminPermission.Sharing)) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'custom_pages', href: hrefBase + '/admin?p=custom_pages', title: 'Home &amp; Custom Pages', icon: 'fa fa-home', isDisabled: !user.hasAdminPermission(AdminPermission.CustomPages) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'addons', href: hrefBase + '/admin?p=addons', title: 'Add-Ons', icon: 'fa fa-puzzle-piece', isDisabled: !user.hasAdminPermission(AdminPermission.Pando), hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'settings', href: hrefBase + '/admin?p=settings', title: 'Edit Workspace Settings', icon: 'fa fa-sliders-v-square', isDisabled: !user.hasAdminPermission(AdminPermission.Settings), hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
				//{id: 'seo', href: hrefBase + '/admin?p=seo', title: 'SEO Settings', icon: 'fa fa-code', isDisabled: !user.hasAdminPermission(AdminPermission.CustomPages) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'billing', href: hrefBase + '/admin?p=billing', title: 'Billing', icon: 'fa fa-usd', isDisabled: false, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
				{section: 'Manage Your Tracks', enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
				{id: 'upload', href: hrefBase + '/admin?p=upload', title: 'Upload/Import Audio', icon: 'fa fa-cloud-upload', isDisabled: !user.hasAdminPermission(AdminPermission.Metadata), hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				{id: 'metadata', href: hrefBase + '/admin?p=metadata', title: 'Manage Metadata', icon: 'fal fa-table', isDisabled: !user.hasAdminPermission(AdminPermission.Metadata), hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio', 'drop']},
				{id: 'music_suppliers', href: hrefBase + '/admin?p=music_suppliers', title: 'Music Suppliers', icon: 'fa fa-exchange', isDisabled: !user.hasAdminPermission(AdminPermission.MusicSuppliers), hasPageFeature: config.showSubscriptionOptions, enabledSiteTypes: ['buyer']},
				{id: 'featured', href: hrefBase + '/admin?p=featured', title: 'Featured Content', icon: 'fa fa-star', isDisabled: !user.hasAdminPermission(AdminPermission.Feature) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				{id: 'file_delivery', href: hrefBase + '/admin?p=file_delivery', title: 'File Delivery', icon: 'fa fa-truck', isDisabled: !user.hasAdminPermission(AdminPermission.FileDelivery) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				{id: 'aitools', href: hrefBase + '/admin?p=aitools', title: 'AI Tools', icon: 'fa fa-microchip-ai', isDisabled: !user.hasAdminPermission(AdminPermission.AutomatedMetadata), hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
				{ section: 'Monetize Your Content', enabledSiteTypes: ['seller', 'network', 'radio'] },
				{id: 'dataset_licensing', href: hrefBase + '/admin?p=dataset_licensing', title: 'AI Dataset Licensing', icon: 'fa-regular fa-handshake', isDisabled: !user.hasAdminPermission(AdminPermission.Pando), hasPageFeature: true, enabledSiteTypes: ['seller']},
				{id: 'contentid', href: hrefBase + '/admin?p=contentid', title: 'YouTube Content ID', icon: 'fa fa-copyright', isDisabled: !user.hasAdminPermission(AdminPermission.Pando) && !user.hasAdminPermission(AdminPermission.ContentIdClaims), hasPageFeature: true, enabledSiteTypes: ['seller', 'network']},
				{id: 'dsp', href: hrefBase + '/admin?p=dsp', title: 'DSP Distribution', icon: 'fa fa-solid fa-list-music', isDisabled: !user.hasAdminPermission(AdminPermission.Pando) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'network']},
				{id: 'collect', href: hrefBase + '/admin?p=collect', title: 'SourceAudio Collect', icon: 'fal fa-globe', isDisabled: !user.hasAdminPermission(AdminPermission.Pando) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				{id: 'detect', href: hrefBase + '/admin?p=detect', title: 'SourceAudio Detect', icon: 'far fa-tv-music', isDisabled: !user.hasAdminPermission(AdminPermission.Statistics) && !user.hasAdminPermission(AdminPermission.Sharing), hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				{id: 'foxar', href: hrefBase + '/admin?p=foxar', title: 'Fox AR', icon: 'fas fa-headphones', dontShow: !foxARShow, hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				{id: 'syndication', href: hrefBase + '/admin?p=syndication' + (config.grayLabel ? '&tab=requests' : ''), title: 'Sync Network', icon: 'fa fa-exchange', isDisabled: !user.hasAdminPermission(AdminPermission.Licensees), hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				{id: 'ecommerce', href: hrefBase + '/admin?p=ecommerce', title: 'E-Commerce', icon: 'fa fa-shopping-cart', isDisabled: !user.hasAdminPermission(AdminPermission.Licensing) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio']},
				//{id: 'licenses', href: hrefBase + '/admin?p=licenses', title: 'Manage Licenses', icon: 'fa fa-money', isDisabled: !user.hasAdminPermission(AdminPermission.Licensing), hasPageFeature: config.licensingConfig['show'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'coupons', href: hrefBase + '/admin?p=coupons', title: 'Manage Coupons', icon: 'fa fa-ticket', isDisabled: !user.hasAdminPermission(AdminPermission.Licensing), hasPageFeature: config.licensingConfig['coupons'], enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'alpha', href: hrefBase + '/admin?p=alpha', title: 'Alpha Libraries', icon: 'fa fa-microphone-alt', isDisabled: !user.hasAdminPermission(AdminPermission.Pando) || config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'network']},
				//{id: 'saone', href: hrefBase + '/admin?p=saone', title: 'SourceAudio ONE', logo: 'https://dm09pscvq9wc9.cloudfront.net/user_data/72/1614370859.3066-59135-72.png', icon: 'fa fa-money-bill-alt', isDisabled: !user.hasAdminPermission(AdminPermission.Pando), hasPageFeature: true, enabledSiteTypes: ['seller']},
				//{id: 'works_registration', href: hrefBase + '/admin?p=works_registration', title: 'Works Registration', icon: 'fa fa-copyright', isDisabled: !user.hasAdminPermission(AdminPermission.WorksRegistration), hasPageFeature: user.hasAdminPermission(AdminPermission.WorksRegistration), enabledSiteTypes: ['seller', 'network', 'radio']},
				//{id: 'premiere', href: hrefBase + '/admin?p=premiere', title: 'User Import', icon: 'fa fa-user', isDisabled: !user.hasAdminPermission(AdminPermission.Users), hasPageFeature: config.isPremiere, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
			];
			
			// if it's after 2024-10-18, remove the dsp tab (monthIndex is 0-based)
			if (new Date() > new Date(2024, 9, 19)) {
				pages.splice(pages.findIndex(p => p.id === 'dsp'), 1);
			}
			
			for (var page of pages) {
				if (page.dontShow) continue;
				if (page.enabledSiteTypes.includes(config.siteType)) {
					if (page.section) {
						tabs.push(new LeftDivider(page.section));
					} else if (page.hasPageFeature) {
						tabs.push(new LeftTab(page.id, page.href, setPage, page.title, page.icon, page.logo, page.isDisabled));
					}
				}
			}
		}
		return tabs;
	}

	/**
	 * Shows the admin
	 */
	this.show = function (params) {
		if (!user.logged) {
			// admin is only accessible to logged-in users
			setTimeout(function () {
				window.location.href = getLoginLink();
			}, 250);
			return;
		}
		
		if (!user.hasAdminPermission(AdminPermission.Any)) {
			// admin is only accessible to logged-in users
			setTimeout(function () {
				sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			}, 250);
			return;
		}
		
		let isNotCurrentPage = sa.getCurrentPageName() !== this.name;
		
		if (isNotCurrentPage) {
			// reset vars
			currentPage = null;
			currentPageType = '';
			
			const baseUrl = siteBaseUrl();
			
			// call the left tabbed page initialization method
			LeftTabbedPage.prototype.show.call(this,
				'admin',
				getTabs(),
				[{
					name: 'Admin',
					href: baseUrl + '/admin'
				}, {
					name: 'Dashboard',
					href: baseUrl + '/dashboard'
				}],
				[{
					icon: 'far fa-comment',
					href: baseUrl + '/feedback',
					title: 'Contact Support'
				}]
			);
			sa.currentPage = this;
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.p) {
			// determine what tab to show
			let billingTab;
			for (let tab of getTabs()) {
				if (!(tab instanceof LeftDivider) && !tab.disabled) {
					if (tab.id === 'billing') {
						billingTab = tab; // only go here if they can't access any other tabs
						continue;
					}
					vars.p = tab.id;
					sa.router.routeTo('/admin?p=' + vars.p, true);
					billingTab = null; // no need to go to the billing tab
					break;
				}
			}
			if (billingTab) { // if this is still set, go here
				vars.p = billingTab.id;
				sa.router.routeTo('/admin?p=' + vars.p, true);
			}
		}
		if (currentPageType === vars.p) {
			this.setPage(currentPageType, $j('#right_content .right_body'));
		} else {
			this.setTab(vars.p);
		}
	};

	/**
	 * Changes what page the admin is showing
	 */
	this.setPage = function (pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (currentPageType == pageId) {
			//console.log('admin reusing object for', pageId);
			let params = sa.router.getCurrentQueryParams();
			currentPage.show(params, container);
			return;
		}

		$j('.right_head').show();
		
		// they were on a different page so we need to find the correct page object
		var page = null;
		switch (pageId) {
			case 'addons':
				page = new AdminAddons();
				break;
			case 'aitools':
				page = new AdminAiTools();
				break;
			case 'alpha':
				page = new AdminAlpha();
				break;
			case 'billing':
				page = new AdminBilling();
				break;
			case 'catalogs': // legacy
			case 'music_providers': // legacy
			case 'music_suppliers':
				page = new AdminMusicSuppliers();
				break;
			case 'collect':
				page = new AdminCollect();
				break;
			case 'contentid':
				page = new AdminContentId();
				break;
			case 'custom_pages':
				page = new AdminCustomPages();
				break;
			case 'dataset_licensing':
				page = new AdminDatasetLicensing();
				break;
			case 'detect':
				page = new AdminSAD();
				break;
			case 'dsp':
				page = new AdminTooLost();
				break;
			case 'ecommerce':
				page = new AdminLicensing();
				break;
			case 'featured':
				page = new AdminFeatured();
				break;
			case 'file_delivery':
				page = new AdminFileDelivery();
				break;
			case 'foxar':
				page = new AdminFoxAR();
				break;
			case 'inbox':
				page = new AdminInbox();
				break;
			case 'licenses':
				page = new AdminLicenses();
				break;
			case 'metadata':
				page = new AdminMetadata();
				break;
			case 'premiere':
				page = new AdminPremiere();
				break;
			case 'saone':
				page = new AdminSAOne();
				break;
			case 'seo':
				page = new AdminSEO();
				break;
			case 'settings':
				page = new AdminSettings();
				break;
			case 'stats':
				page = new AdminStats();
				break;
			case 'syndication':
				page = new AdminSyndication();
				break;
			case 'upload':
				page = new AdminUpload();
				break;
			case 'users':
				page = new AdminUsers();
				break;
			case 'works_registration':
				page = new AdminWorksRegistration();
				break;
		}
		// and then if we found it, have it load based on the current params
		if (page) {
			//console.log('admin creating new object for', pageId);
			currentPage = page;
			currentPageType = pageId;
			let currentParams = sa.router.getCurrentQueryParams();
			page.show(currentParams, container);
		} else {
			console.warn('page not found:', pageId);
			container.html('Admin unable to determine page for ' + pageId);
		}
	};
	
	adminPage.register = {
		routes: [{
			name: 'admin',
			pattern: '/admin',
			hash: '#!admin'
		}]
	};
	
	adminPage.name = 'admin';
	adminPage.title = 'Admin';
	
	return adminPage;
}
Admin.prototype = new LeftTabbedPage();

sa.pages.admin = new Admin();

/**
 * Note to self: 2019-10-05
 * The Alpha tab seems ok. Make the Collect tab work the same way, using the same code. It almost does but it's missing all information. After that, other Pandos. Hide the old Alpha area. Testing?
 */
/**
 * A page in the admin panel
 */
function AdminAddons() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Pando)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Add-Ons and Programs' + '" permission.</h3>');
		}
		if (AdminAddons.reportsCache === null) {
			ajax('p=reports&action=list', function(reports) {
				AdminAddons.reportsCache = reports;
				showTabs();
			});
		} else {
			showTabs();
		}
		function showTabs() {

			// determine which tab should be active and set it as such
			let vars = sa.router.paramsToVars(params);
			let hrefBase = siteBaseUrl();
			if (!$j('.right_body .addons').length) {
				var callback = function(tabId, cont) { page.setPage(tabId, cont); },
					tabs = [];
				if (config.siteType != 'buyer') {
					tabs.push(new RightTab('isrc', hrefBase + '/admin/?p=addons&tab=isrc', 'ISRCs', callback));
				}
				tabs.push(new RightTab('chat', hrefBase + '/admin/?p=addons&tab=chat', 'Chat with Customers', callback, config.grayLabel));
				tabs.push(new RightTab('googleadwords', hrefBase + '/admin/?p=addons&tab=googleadwords', 'Google Ads', callback, config.grayLabel));
				tabs.push(new RightTab('analytics', hrefBase + '/admin/?p=addons&tab=analytics', 'Tracking/Analytics', callback, config.grayLabel));

				if (AdminAddons.reportsCache.length) {
					tabs.push(new RightTab('reports', hrefBase + '/admin/?p=addons&tab=reports', 'Reports', callback, config.grayLabel));
				}
				// direct link for adrev
				if (vars.tab == 'adrev') {
					tabs.push(new RightTab('adrev', hrefBase + '/admin/?p=addons&tab=adrev', 'Adrev', callback, config.grayLabel));
				}
				RightTabbedPage.prototype.show.call(page, 'addons', container, tabs, '');
			}
		
			if (!vars.tab) {
				if (config.grayLabel) {
					vars.tab = 'isrc';
				} else {
					vars.tab = 'chat';
				}
			}
			page.setTab(vars.tab);
		}
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			switch (pageId) {
				case 'analytics':
					currentPage = new AdminAddonsTrackingCodes();
					break;
				case 'googleadwords':
					currentPage = new AdminAddonsGoogleAdWords();
					break;
				case 'isrc':
					currentPage = new AdminAddonsISRC();
					break;
				case 'adrev':
					currentPage = new AdminAddonsContentID();
					break;
				case 'reports':
					currentPage = new AdminAddonsReports();
					break;
				case 'chat':
				default:
					currentPage = new AdminAddonsChat();
					break;
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminAddons.prototype = new RightTabbedPage();
AdminAddons.reportsCache = null;

function AdminAddonsContentID() {

	var page = this;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (config.grayLabel) {
			return container.html('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		container.addClass('adrev_container');
		ajax('p=adrev&action=signup_check', function(response) {
			if (response.haveData) {
				showLoader(container, 'Loading Your Data');
				loadData(container);
			} else if (parseInt(response.signedUp)) {
				container.addClass('noadrev').html(
					'<div class="container">'
						+ '<p>You <b>are</b> enrolled in SourceAudio &amp; AdRev\'s YouTube Content ID revenue program.</p>'
						+ '<p>However, we haven\'t received any data from AdRev yet so please be patient.</p>'
						+ '<p>It can take several months but we\'ll be sure to let you know!</p>'
					+ '</div>'
				);
			} else {
				container.addClass('noadrev').html(
					'<div class="container">'
						+ '<p>The AdRev program has been discontinued, but you can sign up now through our own <a href="'+siteBaseUrl()+'/admin?p=programs">Content ID Program</a>!</p>'
					+ '</div>'
				);
			}
		});
	};


	/**
	 * Load Data
	 *
	 * Loads the initial data for the page.
	 */
	function loadData(container){
		ajax('p=adrev&action=loadData', function(response) {
			container.html(''
				+ '<div class="admin_left_column"> '
					+ '<h2 class="adrev_heading">Overview</h2>'
					+ '<div class="inception_date">Inception Date: <span id="inception_date">Today</span> </div>'
					+ '<div class="stat"> '
						+ '<span class="title">Total Revenue</span> '
						+ '<div id="total_revenue" class="data">Loading...</div>'
					+ '</div>'
					+ '<div class="stat"> '
						+ '<span class="title">Total Copyrights</span> '
						+ '<div id="total_copyrights" class="data">Loading...</div>'
					+ '</div>'
					+ '<div class="adrev_monthly_reports"> '
						+ '<span class="title">Quarterly Reports</span>'
						+ '<div class="report_list"></div>'
					+ '</div> '
				+ '</div> '
				+ '<div class="admin_right_column" id="chart_column"> '
					+ '<div class="adrev_chart">'
						+ '<div class="chart"> '
							+ '<div class="views_axis">Views</div> '
							+ '<div class="month_axis"></div> '
							+ '<div class="graph"> '
								+ '<div class="ruler1"></div> '
								+ '<div class="ruler2"></div> '
								+ '<div class="ruler3"></div> '
								+ '<div class="ruler4"></div> '
								+ '<div class="ruler5"></div> '
								+ '<div class="previous">&lt;</div>'
								+ '<div class="next">&gt;</div> '
							+ '</div> '
						+ '</div> '
						+ '<div class="header">Quarterly Views & Payout</div>'
					+ '</div> '
					+ '<!--<div class="adrev_build_report"> '
					+ '<style> .ui-datepicker-calendar { display: none; } </style> '
						+ '<span class="title">Build Your Own Report</span>'
						+ '<div class="body"> '
							+ '<input type="text" value="start date" class="hasDatePicker startDate" /> '
							+ '<input type="text" value="end date" class="hasDatePicker endDate" /> '
							+ '<div class="exportButton"></div> '
						+ '</div>'
					+ '</div>--> '
				+ '</div><div class="clr"></div> '
				+ '<div class="top_active_videos"> '
					+ '<div class="header"> '
						+ 'Top Active Videos By Revenue '
					+ '</div> '
					+ '<div class="body"> '
						+ '<div class="no_records">No Records.</div> '
					+ '</div> '
					+ '<a class="button export_button" href="https://' + config.domain + '/export.php?type=exportAdRevVideos">Export Full Report</a> '
				+ '</div>'
			);

			jQuery('.hasDatePicker').datepicker({
				changeMonth: true,
				changeYear: true,
				showButtonPanel: true,
				showOtherMonths: false,
				dateFormat: 'mm/yy',
				onClose: function(dateText, inst) {
					var month = $j("#ui-datepicker-div .ui-datepicker-month :selected").val();
					var year = $j("#ui-datepicker-div .ui-datepicker-year :selected").val();
					$j(this).datepicker('setDate', new Date(year, month, 1));
				}
			});

			$j('div.exportButton').append(createButton('Download', '', '', getDefaultLink(), function() { page.exportButton(); }));

			//response = response[0];
			console.log('data:', response);

			$j('#inception_date').html(response.inceptionDate);
			$j('#total_revenue').html(response.totalRevenue);
			$j('#total_copyrights').html(response.totalCopyrights);

			// show the report list
			var reportList = $j('.report_list').empty(),
				maxViews = 0; // we use this for graph
			for (var i in response.quarterlyData) {
				var data = response.quarterlyData[i];
				if (!data.earned) continue;

				reportList.append('<a href="https://' + config.domain + '/export.php?type=adrevEarnings&fromDate=' + i + '">$' + Math.floor(data.payout).numberFormat() + ' - Q'
					+ data.quarter + ' ' + data.year + '</a>');
				maxViews = Math.max(data.views, maxViews);
			}

			console.log('max views:', maxViews);

			// show the graph
			var monthAxis = $j('.month_axis'),
				viewAxis = $j('.views_axis'),
				graph = $j('.graph'),
				graphHeight = graph.height();
			// round up max views
			var pow = Math.pow(10, (maxViews + '').length - 1);
			maxViews = Math.ceil(maxViews / pow) * pow;

			// add bars and x axis labels
			console.log(Object.keys(response.quarterlyData));
			var barLimit = 5;
			var added = 0;
			for (var i = Math.max(0, Object.keys(response.quarterlyData).length - barLimit); i < Object.keys(response.quarterlyData).length; i++) {
				var data = response.quarterlyData[Object.keys(response.quarterlyData)[i]];
				console.log('data:', i, data);
				graph.append('<div class="bar" style="height:' + Math.max(11, Math.floor(data.views / maxViews * graphHeight)) + 'px;margin-right:' + (40 + (4 - added) * 66) + 'px;">'
					+ '<span>$' + Math.floor(data.payout).numberFormat() + '</span>'
					+ '<div class="views">' + data.views.numberFormat() + '</div></div>');
				monthAxis.append('<span>Q' + data.quarter + ' \'' + data.year.toString().substr(-2)  + '</span>');
				added++;
				if (added >= barLimit) break;
			}

			// add y axis labels
			for (var i = 0, drop = Math.floor(maxViews / 5), halfStep = Math.floor(drop / 2); i < 5; i++) {
				viewAxis.append('<div>' + (maxViews - drop * i - halfStep).numberFormat() + '</div>');
			}

			// show top videos
			var topVideoContainer = $j('.top_active_videos .body'),
				topVideos = response.topVideos;
			if (topVideos.length) {
				topVideoContainer.html(
					'<table>'
						+ '<thead>'
							+ '<tr>'
								+ '<td class="url">URL</td>'
								+ '<td class="date_added">Date Added</td>'
								+ '<td class="revenue">Revenue</td>'
								+ '<td class="track">Track</td>'
							+ '</tr>'
						+ '</thead>'
						+ '<tbody></tbody>'
					+ '</table>'
				);
				var tbody = topVideoContainer.find('tbody');
				for (var i = 0, len = topVideos.length; i < len; i++) {
					var video = topVideos[i];
					tbody.append(
						'<tr>'
							+ '<td class="url"><a href="http://www.youtube.com/watch?v=' + video.video_id + '" target="_blank">http://www.youtube.com/watch?v=' + video.video_id + '</td>'
							+ '<td class="date_added">' + new Date((video.import_date + '').replace(/([0-9]{4})([0-9]{2})/, '$1-$2-15')).toString().replace(/[a-z]+ ([a-z]+) [0-9]{2} ([0-9]{4}) .*/i, '$1 $2') + '</td>'
							+ '<td class="revenue">$' + Math.floor(video.revenue).numberFormat() + '</td>'
							+ '<td class="track">' + (video.track_title ? '<a href="'+siteBaseUrl()+'/track/' + video.track_id + '">' + video.track_title + '</a>' : 'Track removed') + '</td>'
						+ '</tr>'
					);
				}
			}
			$j("#loader_element").remove();
		});
	}

	/**
	 * Export Button
	 */
	this.exportButton = function(){
		var startDateInput = jQuery('div.adrev_build_report div.body input.startDate');
		var endDateInput = jQuery('div.adrev_build_report div.body input.endDate');
		var startVal = startDateInput.val();
		var endVal = endDateInput.val();


		// Some testing
		if(startVal=='' || startVal=='start date'){
			alert('Please input valid start date.');
			return;
		}
		if(endVal=='' || endVal=='end date'){
			alert('Please input valid end date.');
			return;
		}
		if(startVal[2]!=='/' && endVal[2]!=='/'){
			alert('Please select valid dates.');
			return;
		}

		// Format Dates
		var startValSplit = startVal.split('/');
		var endValSplit = endVal.split('/');

		// Redirect
		var url = 'https://' + config.domain + '/export.php?type=exportAdRev&fromDate=' + startValSplit[1] + startValSplit[0] + '&toDate=' + endValSplit[1] + endValSplit[0];
		window.location.href = url;
	};

}
/**
 * The page in the admin panel that lets you manage really basic site settings
 */
function AdminAddonsTrackingCodes() {
	// Private class variables
	var templates, tab;

	// Variables accessible publicly
	this.$container = undefined;

	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		tab = this;
		this.$container = container;

		if (config.grayLabel) {
			return container.html('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}

		if (!templates) {
			templates = sa.templates.get('admin.addons.trackingcodes');
		}

		// Add class to container
		container.addClass('tab_trackingcodes');

		// Generate the accordion
		var accordion = new sa.collapsingAdminPage();

		this.load(function(codes) {

			var getCode = function (type) {
				var codesOfType = codes[type];
				if (typeof codesOfType !== "undefined" && codesOfType && codesOfType.length > 0) {
					return codesOfType[0]; // for now picking the first code until the UI supports multiple
				}

				return {};
			}

			// Add Google Analytics
			var googleAnalyticsCode = getCode('google_analytics');

			accordion.addSection({
				name:	'Google Analytics',
				contents: templates.get('google_analytics', {
					analytics_id : googleAnalyticsCode.analytics_id || '',
					id	: googleAnalyticsCode.id || '',
				})
			});

			// Add Google Tag Manager
			var gtmCode = getCode('google_tag_manager');

			accordion.addSection({
				name:	'Google Tag Manager',
				contents: templates.get('google_tag_manager', {
					analytics_id : gtmCode.analytics_id || '',
					id	:	gtmCode.id || '',
					gtm_explanation : gtmCode.use_explanation || 'We use Google Tag Manager to connect with other services to track how you\'re using the workspace.'
				})
			});

			// Add Facebook
			var fbPixelCode = getCode('facebook_pixel');

			accordion.addSection({
				name:	'Facebook Pixel',
				contents: templates.get('facebook_pixel', {
					analytics_id : fbPixelCode.analytics_id || '',
					facebook_track_event : fbPixelCode.data ? (fbPixelCode.data.facebook_track_event || 'PageView') : 'PageView',
					id : fbPixelCode.id || '',
					facebook_pixel_explanation : fbPixelCode.use_explanation || 'We use Facebook Pixel to measure, optimize, and build audiences for our ad campaigns.'
				})
			});


			// Add HubSpot
			var hubspotCode = getCode('hubspot');

			accordion.addSection({
				name:	'HubSpot',
				contents: templates.get('hubspot', {
					analytics_id : hubspotCode.analytics_id || '',
					id	: hubspotCode.id || '',
					hubspot_explanation : hubspotCode.use_explanation || 'We use HubSpot to track inbound marketing campaigns.'
				})
			});

			// Render the accordion
			accordion.addToContainer(container);

			// Init form handling
			sa.forms.init(container);

			// Other events
			tab.bindClickHandlers();

		});






	}

	this.load = function(callback) {
		sa.api.request({
			handler : 'settings',
			action : 'load-tracking-codes'
		}).then(callback);

	}

	/**
	 * Bind the click handlers for submit and code-parsing buttons
	 */
	this.bindClickHandlers = function() {
		
		// Code parsers

		// Code Parser for FB code
		var $fbClickEl = this.$container.find('form[name="facebook_pixel"] a.code-parser');
		var instructions = 'Paste your Facebook Pixel code here and we will extract the info we need.';
		var title = 'Facebook Pixel Code Parser';
		this.generateCodeParser($fbClickEl, instructions, title, [
			{
				regex				: /fbq\(['"]init['"],\s+['"](\d*)['"]\)/,
				extractInputSelector: 'input[name="analytics_id"]',
				matchIndex 			: 1,
			},
			{
				regex				: /fbq\(['"]track['"],\s+['"](\w*)['"]\)/,
				extractInputSelector: 'input[name="facebook_track_event"]',
				matchIndex			: 1,
			}
		] )

		// Code Parser for HubSpot code
		var $hsClickEl = this.$container.find('form[name="hubspot"] a.code-parser');
		var instructions = 'Paste your HubSpot tracking code here and we will extract the info we need.';
		var title = 'HubSpot Tracking Code Parser';
		this.generateCodeParser($hsClickEl, instructions, title, [
			{
				regex				: /js.hs-scripts.com\/(\d*).js/,
				extractInputSelector: 'input[name="analytics_id"]',
			}
		] )

		// Code Parser for GTM code
		var $gtmClickEl = this.$container.find('form[name="google_tag_manager"] a.code-parser');
		var instructions = 'Paste your Google Tag Manager tracking code here and we will extract the info we need.';
		var title = 'Google Tag Manager Code Parser';
		this.generateCodeParser($gtmClickEl, instructions, title, [
			{
				regex				: /(GTM-[A-Za-z0-9]{7,})/,
				extractInputSelector: 'input[name="analytics_id"]',
			}
		] )


		// Submit buttons for the forms
		this.$container.find(".submit-button").on('click', function(ev) {
			ev.preventDefault();

			// Get the form info
			var $form = $j(this).closest('form');
			var formData = $form.serializeArray();
			console.log("Submitted form data", formData);

			// Validate the form in the normal way
			var validationResults = sa.forms.validate($form);

			if (validationResults.error) {
				for (var e of validationResults.errors) {
					e.showError('Input is invalid, please ensure you have the correct info.');
				}
			}

			var validation = !validationResults.error;

			if (validation) {
				tab.saveSettings($form);
			}
		});
	}

	/**
	 * Generate a popup for parsing a code and extracting it to an input, given the jQuery object for the button that,
	 * when clicked, will trigger the popup.
	 *
	 * @param $clickEl jQuery
	 * @param instructions String which puts instructions in the parser.
	 * @param title Title of the parser
	 * @param regexArr Array of objects of form { regex, extractInputSelector, matchIndex } which matches a regex
	 * and fills the form element specified by the selector extractInputSelector
	 */
	this.generateCodeParser = function($clickEl, instructions, title, regexArr) {

		$clickEl.on('click', function(e){
			var $form = $j(this).closest('form');

			// Focus box content (code parser)
			var $codeParser = templates.get('code_parser', {
				instructions : 	instructions
			});

			// Create the FocusBox
			var fb = new FocusBox($codeParser, {
				title : title,
			});

			// Bind handlers for clicking Extract or Close

			// On click Extract
			$codeParser.find('.confirm_yes').on('click', function() {
				var val = $codeParser.find('textarea').val();
				if (val.trim() === '') {
					sa.alert({ text : 'Please enter your tag code or cancel.' });
					return;
				}

				var matched = true;
				var formChangeQueue = [];
				for (var obj of regexArr) {
					// set default match index to 1
					obj.matchIndex = obj.matchIndex !== undefined ? obj.matchIndex : 1;

					// check for match of regex
					var matches = val.match(obj.regex);
					var match = matches !== null ? matches[obj.matchIndex] : false

					if (match) {
						var $input = $form.find(obj.extractInputSelector);
						// Queue the form changes for after we have fully parsed the code
						// 	as opposed to changing the form before we know we can parse all we need from it
						formChangeQueue.push(function() {
							$input.val(match);
							$input[0].dispatchEvent(new Event('change', { 'bubbles': true }));
						});
					}

					matched = matched && !!match;
				}

				if (matched) {
					// Make the form changes
					formChangeQueue.forEach(function(f) { f(); });
					// Hide the box on successful matching
					fb.hide();
				} else {
					// If no match, error
					sa.alert({ text : 'Unable to parse your tracking code. Please try again or if the issue persists, contact SourceAudio for help.' });
				}
			});

			// Bind the hide button
			$codeParser.find('.confirm_no').on('click', function() {
				fb.hide();
			});

			// Show the FocusBox
			fb.show();
		});
	}



	/**
	 * Convert the output of $j.serializeArray to an Object with the names as the keys and the values as the values
	 * @param formArray
	 * @returns {{}}
	 */
	this.formArrayToObj = function(formArray) {
		var result = {};

		formArray.forEach(function(element) {
			var node = result[element.name];

			// If node with same name exists already, need to convert it to an array as it
			// is a multi-value field (i.e., checkboxes)

			if ('undefined' !== typeof node && node !== null) {
				if (Array.isArray(node)) {
					node.push(element.value);
				} else {
					result[element.name] = [node, element.value];
				}
			} else {
				result[element.name] = element.value;
			}
		});

		return result;
	}

	/**
	 * Pass the form, save the settings.
	 * Data gets sent to the server in the format
	 * { codes: {
	 *     facebook_pixel: {
	 *         facebook_pixel_id
	 *         facebook_track_event
	 *     },
	 *     hubspot: {
	 *         hubspot_id
	 *     }
	 *     ....
	 * }}
	 *
	 * @param $form
	 */
	this.saveSettings = async function($form) {
		var service = $form.attr('name');
		var formArr = $form.serializeArray();
		var code = tab.formArrayToObj(formArr);
		code.type = service;

		console.log("Saving settings for form: " + service);

		const response = await sa.api.request({
			handler : 'settings',
			action : 'save-tracking-code',
			postData : {
				code: code
			}
		}).catch(e => {
			sa.alert(e.message);
		});
		
		if (!response) return;

		// Remove IDs for deleted values
		for (var i of formArr) {
			if (i.name === 'analytics_id' && i.value === '') {
				$form.find('input[name="id"]').val("");
			}
		}

		// Fill ID value if we created a code
		if (response.id) {
			$form.find('input[name="id"]').val(response.id);
		}

		sa.notify({ text : 'Changes saved!  These codes will now run on the front pages of your workspace.', type : sa.notify.notificationTypes.success });

	}
}
/**
 * The page in the admin panel that lets you manage really basic site settings
 */
function AdminAddonsChat() {
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (config.grayLabel) {
			return container.html('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		container.html(`
			<div class="section manage_olark">
				<h2>SourceAudio partners with Olark Live Chat to make chatting with your customers simpler than ever. Get started here:</h2>
				<div class="section step_1">
					<h4>Step 1:</h4>
					<a href="http://www.olark.com/" target="_blank" class="img"><img src="https://static.olark.com/images/partner/125x125-live-chat-blue.png" alt="Olark Logo"/></a>
					<span>&laquo; Click this icon to sign up for a new account at <a href="http://www.olark.com/" target="_blank">olark.com</a></span>
					<div class="clr"></div>
				</div>
				<div class="section step_2">
					<h4>Step 2:</h4>
					<input type="text" value="${StringSanitize.encodeIfNotEncoded(config.olark)}" id="olark_id"/>
					<span>&laquo; Paste your Olark Site ID # into this field</span>
					<div class="clr"></div>
				</div>
				<div class="section step_3">
					<h4>Step 3:</h4>
					<a class="button">Save</a>
					<span>&laquo; Click here to finish and your chat widget will appear!</span>
					<div class="clr"></div>
				</div>
				<sub><em>Tip:</em> Your chat settings and options can be configured in your account at <a href="http://www.olark.com/" target="_blank">olark.com</a></sub>'
			</div>'
		`);
		
		// save button
		container.find('.button').on('click', function() {
			sa.api.request({
				handler : 'settings',
				action : 'save-olark',
				postData : {
					olark : $j('#olark_id').val()
				}
			}).then(function() {
				sa.notify({ text : 'Changes saved! Reload to see them in action.', type : sa.notify.notificationTypes.success });
			});
		});
	};
}
/**
 * The page in the admin panel that lets you manage really basic site settings
 */
function AdminAddonsGoogleAdWords() {

	var templates;
	var nextConversionId = 0;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (config.grayLabel) {
			return container.html('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		if (!templates) {
			templates = sa.templates.get('admin.addons.googleadwords');
		}

		var template = templates.get('admin', {
			adwords_explanation: StringSanitize.sanitize(config.googleAdWordsUseExplanation) || 'We use Google Ads to gauge the effectiveness of our marketing campaigns.'
		});
		sa.forms.init(template);

		template.find('#add_conversion').on('click', function() {
			addConversion(template);
		});

		config.googleAdWords.each(function(i, details) {
			details.label = StringSanitize.ifEncodedDecode(details.label);
			addConversion(template, details);
		});

		// save button
		template.find('#save_button').on('click', function() {
			var conversions = sa.forms.validate(template).values['conversions'];
			var conversionArray = [];
			for (var i in conversions) {
				if (!conversions.hasOwnProperty(i)) continue;
				var conversion = conversions[i];
				if (!conversion.id.match(/^[0-9]+$/)) {
					sa.alert({ text : 'Please make sure your Conversion ID(s) are all numbers.' });
					return;
				}
				if (!conversion.label) {
					sa.alert({ text : 'Please make sure you have a Conversion Label for each conversion.' });
					return;
				}
				if (!conversion.event) {
					sa.alert({ text : 'Please choose when you\'d like your conversion to trigger.' });
					return;
				}
				conversionArray.push(conversion);
				// The next thing to do is make sure there's a value for all the items in these conversions. maybe turn it into an array
				// then save it. you haven't written the saving part at all. or the piece that inserts saved values back into the form
			}
			sa.api.request({
				handler : 'settings',
				action : 'save-google-adwords',
				postData : {
					conversions : conversionArray,
					explanation : template.find('#adwords_explanation').val()
				}
			}).catch(function(e) {
				sa.alert(StringSanitize.encodeIfNotEncoded(e.message));
			}).then(function () {
				sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
				config.googleAdWords = conversionArray;
			});
		});

		container.empty().append(template);
	};

	function addConversion(container, details) {
		var conversionId = nextConversionId++;
		var conversionContainer = container.find('.conversions');
		var newConversion = templates.get('conversion', {
			conversionCount : conversionContainer.find('.conversion').length + 1,
			id : conversionId
		});
		var generatorSub = newConversion.find('.generator_container sub');
		var eventSelect = newConversion.find('.event_input');

		for (var value in sa.googleAdWordsEvents) {
			if (!sa.googleAdWordsEvents.hasOwnProperty(value)) continue;
			eventSelect.append('<option value="' + value + '">' + sa.googleAdWordsEvents[value] + '</option>');
		}

		if (details) {
			newConversion.find('.label_input').val(details['label']);
			newConversion.find('.id_input').val(details['id']);
			newConversion.find('.event_input').val(details['event']);
		}

		sa.forms.init(newConversion);

		newConversion.find('#code_parser_button').on('click', function() {
			var codeParser = templates.get('code_parser');
			var fb = new FocusBox(codeParser, { title : 'Google AdWords Code Parser' });

			codeParser.find('.confirm_yes').on('click', function() {
				var val = codeParser.find('textarea').val();
				if (val.trim() === '') {
					sa.alert({ text : 'Please enter your tag code or cancel.' });
					return;
				}
				var match = val.match(/google_conversion_id *= *([0-9]+);[\s\S]*google_conversion_label *= *"([^"]+)";/m);
				if (!match) {
					match = val.match(/www.googleadservices.com\/pagead\/conversion\/([0-9]+)\/\?label=([^&]+)&/m);
				}
				if (match) {
					newConversion.find('#conversion_id_' + conversionId).val(match[1]).trigger('change');
					newConversion.find('#conversion_label_' + conversionId).val(match[2]).trigger('change');
					fb.hide();
				} else {
					sa.alert({ text : 'Unable to parse your conversion code. Please contact SourceAudio for help.' });
				}
			});

			codeParser.find('.confirm_no').on('click', function() {
				fb.hide();
			});

			fb.show();
		});

		newConversion.find('#conversion_generator_' + conversionId).on('input', function() {
			var val = this.value;
			generatorSub.data('defaultValue', generatorSub.data('realDefaultValue'));
			if (val.trim() === '') return;
			var match = val.match(/google_conversion_id *= *([0-9]+);[\s\S]*google_conversion_label *= *"([^"]+)";/m);
			if (!match) {
				match = val.match(/www.googleadservices.com\/pagead\/conversion\/([0-9]+)\/\?label=([^&]+)&/m);
			}
			if (match) {
				newConversion.find('#conversion_id_' + conversionId).val(match[1]).trigger('change');
				newConversion.find('#conversion_label_' + conversionId).val(match[2]).trigger('change');
			} else {
				generatorSub.data('defaultValue', 'Unable to parse your conversion code. Please contact SourceAudio for help.');
			}
		});
		generatorSub.data('realDefaultValue', generatorSub.html());

		newConversion.find('#remove_button').on('click', function() {
			newConversion.remove();
			var conversionsLeft = conversionContainer.find('.conversion');
			if (!conversionsLeft.length) {
				conversionContainer.addClass('empty');
			} else {
				conversionsLeft.each(function(i) {
					$j(this).find('.conversion_count').html(i + 1);
				});
			}
		});

		conversionContainer.append(newConversion).removeClass('empty');
	}
}
/**
 * The page in the admin panel that lets you manage really basic site settings
 */
function AdminAddonsReports() {

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (config.grayLabel) {
			return container.html('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		var page = this;
		container.html(
			'<div class="section custom_reports">'
			+ '<h2>Available Reports:</h2>'
				+ '<div class="custom_reports_list"></div>'
			+ '</div>');

		ajax('p=reports&action=list', function(reports) {
			if (!reports.length) {
				return sa.router.routeTo('/');
			}

			var reportContainer = container.find('.custom_reports_list');
			for (var r = 0, rLen = reports.length; r < rLen; r++) {
				showReport(reports[r], reportContainer);
			}
		});
	};

	/**
	 * ReportData object type reference
	 * @typedef {Object} ReportData
	 * @property {string} name
	 * @property {string} button
	 * @property {string} baseLink
	 * @property {Array.<ReportDataVariable>} extraVariables
	 */

	/**
	 * ReportDataVariable object type reference
	 * @typedef {Object} ReportDataVariable
	 * @property {string} name
	 * @property {string} type
	 * @property {string} variable
	 */

	 /**
	 * @param {ReportData} reportData
	 * @param {JQuery} reportContainer
	 */
	function showReport(reportData, reportContainer) {
		var report = $j('<div class="report"></div>');

		if (reportData.name) {
			report.append('<h3>' + reportData.name + '</h3>');
		}

		 if (reportData.extraVariables) {
			 for (var ev = 0, evLen = reportData.extraVariables.length; ev < evLen; ev++) {
				 var variableData = reportData.extraVariables[ev];
				 var variable = $j('<div class="report_variable"></div>');

				 if (variableData.name) {
					 variable.append('<h4>' + variableData.name + '</h4>');
				 }

				 if (variableData.type == 'date') {
					 variable.append('<input type="text" name="' + variableData.variable + '"/>');
					 variable.find('input').datepicker({ dateFormat: config.datePickerDateFormatString });
				 } else if (variableData.type == 'text') {
					 variable.append('<input type="text" name="' + variableData.variable + '"/>');
				 }

				 variable.append('<div class="clr"></div>');

				 report.append(variable);
			 }
		 }

		if (reportData.button) {
			report.append('<a class="button report_button" href="#0">' + reportData.button + '</a>');
			report.find('.report_button').on('click', function() {
				createReport(report, reportData);
				return false;
			});
		}

		reportContainer.append(report);
	}

	/**
	 * @param {JQuery} report
	 * @param {ReportData} reportData
	 */
	function createReport(report, reportData) {
		var baseLink = reportData.baseLink;

		if (reportData.extraVariables && reportData.extraVariables.length) {
			for (var ev = 0, evLen = reportData.extraVariables.length; ev < evLen; ev++) {
				var variableData = reportData.extraVariables[ev];
				var value = report.find('input[name=' + variableData.variable + ']').val();

				if (value !== '') {
					baseLink += '&' + variableData.variable + '=' + encodeURIComponent(value);
				}
			}
		}

		console.log(baseLink);
		document.location.href = baseLink;
	}
}

function AdminAddonsISRC() {

	var page = this;

	this.status = null;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		container.addClass('isrc_container');
		container.html('<div class="loading">Loading...</div>');
		page.container = container;
		page.loadData();
	};


	/**
	 * Load Data
	 *
	 * Loads the initial data for the page.
	 */
	this.loadData = function() {

		ajax('p=isrc&action=getISRCData', function(response) {
			r = response[0];
			console.log('load data:', r);

			var total_tracks = r.total;
			var without_isrc = r.without_isrc;
			var with_isrc = total_tracks - without_isrc;
			var history = r.history;

			page.container.html(''
			+ '<div class="isrc-description"><b>SourceAudio</b> is no longer distributing ISRCs. Please check with <a href="https://isrc.ifpi.org/en/contact/national-agency-contacts" target="_blank" class="emphasized">your country\'s ISRC agency</a> for the best way to acquire them.</div>'
			+ '<div class="isrc-history">'
			+	'<h3>Purchase History</h3>'
			+	'<table>'
			+	'<tr><th>Date</th><th>User</th><th>Purchased</th><th></th></tr>'
			+	'</table>'
			+ '</div>'
			);

			if (history && history.length) {
				for (var ii = 0; ii < history.length; ii++) {
					var purchase = history[ii];
					$j('.isrc-history table').append('<tr><td>' + formatDate('Y-n-j', purchase.date) + '</td><td>' + purchase.username + '</td><td>' + numberFormat(purchase.count) + ' codes</td><td>' + ((purchase.pending) ? 'Pending' : '<a class="button export_button" href="https://' + config.domain + '/export.php?type=exportISRC&transactionId='+ purchase.transaction_id + '">Download</a>') + '</td></tr>');
				}

				$j('.isrc-history').append( '<div class="download-all"><a class="button export_button" href="https://' + config.domain + '/export.php?type=exportISRC&all=1">Download All</a></div>' );
			} else {
				$j('.isrc-history').remove();
			}
		});
	};


}
/**
 * The page in the admin panel that lets you manage Ai tools
 */
function AdminAiTools() {
	const page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		const defaultTab = 'metadata';
		if (!$j('.right_body.aitools').length) {
			const callback = function (tabId, cont) { page.setPage(tabId, cont); };
			const tabs = [];

			tabs.push(new RightTab('metadata', '/admin?p=aitools&tab=metadata', 'AI Tagging', callback));
			tabs.push(new RightTab('derivatives', '/admin?p=aitools&tab=derivatives', 'Derivative Works - Coming Soon!', callback));

			RightTabbedPage.prototype.show.call(this, 'aitools', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		const vars = sa.router.paramsToVars(params);
		if (!vars.tab) {
			vars.tab = defaultTab;
		}
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function (pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			switch (pageId) {
				case 'metadata':
					currentPage = new adminAiToolsTagging();
					break;
				case 'derivatives':
					currentPage = new AdminAiToolsDerivatives();
					break;
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminAiTools.prototype = new RightTabbedPage();
/**
 * A page in the admin panel
 */
function adminAiToolsTagging() {
	const page = this;
	const templates = sa.templates.get('admin.aitools');

	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		const page = this;
		window.activePage = page;
		const pageTemplate = templates.get('metadata');
		container.html(pageTemplate);
		page.container = container;

		mountReactComponent(page.container.find('#aitools-tagging')[0], 'admin-aitools-tagging', {});
	};
	
	this.save = async function () {
		console.log('saving');	
	};
}
/**
 * A page in the admin panel
 */
function AdminAiToolsDerivatives() {
	const page = this;
	const templates = sa.templates.get('admin.aitools');

	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		const page = this;
		window.activePage = page;
		const pageTemplate = templates.get('derivatives');
		container.html(pageTemplate);
		page.container = container;

		mountReactComponent(page.container.find('#aitools-derivatives')[0], 'admin-aitools-derivatives', {});
	};
	
	this.save = async function () {
		console.log('saving');	
	};
}

function AdminAlpha() {
	
	let page = this;
	let adminProgram;
	let templates;
	
	page.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Pando)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Add-Ons and Programs' + '" permission.</h3>');
		}
		if (!templates) {
			templates = sa.templates.get('admin.alpha');
		}
		if (config.grayLabel) {
			return container.empty().append(templates.get('contact_sales'));
		}
		sa.api.request({
			handler: 'Aml/Admin',
			action: 'signupCheck'
		}).then(function (response) {
			console.log('signup check', response);
			let r = response;
			if (!r.status) {
				sa.showAdminProgram(sa.AdminProgram.Alpha, container);
			} else if (r.status == 1) {
				container.addClass('noadrev').empty().append(templates.get('pending_approval'));
			} else if (r.status == 2) {
				container.addClass('noadrev').empty().append(templates.get('pending_payment', { added : r.added }));
			} else if (r.status == 3) {
				container.empty().append(templates.get('payment_history'));
				loadData(r);
			}
		});
		
	};
	
	/**
	 * Load Data
	 *
	 * Loads the initial data for the page.
	 */
	function loadData(signupCheckResponse, loadDataResponse) {
		if (!loadDataResponse) {
			sa.api.request({
				handler: 'Aml/Admin',
				action: 'getTrackingData'
			}).then(function (response) {
				loadData(signupCheckResponse, response);
			})
			return;
		}
		
		let r = loadDataResponse;
		console.log('load data:', r);

		$j('.admin_loader').hide();
		$j('#inception_date').html(formatDate('Y-n-j', signupCheckResponse.date));
		$j('#total_revenue').html((r.totals.payout * 100).moneyFormat(0));
		$j('#total_copyrights').html(signupCheckResponse.added.numberFormat());

		// show the report list
		let reportList = $j('.report_list').empty();
		let maxViews = 0; // we use this for graph
		for (let i = 0; i < r.quarters.length; i++) {
			let data = r.quarters[i];
			if (!data.total_payout) continue;

			reportList.append('<a href="export.php?type=amlearnings&quarter=' + data.date + '">$' + Math.floor(data.total_payout).numberFormat() + ' - ' + data.date + '</a>');
			maxViews = Math.max(data.points, maxViews);
		}

		// show the graph
		let monthAxis = $j('.month_axis');
		let viewAxis = $j('.views_axis');
		let graph = $j('.graph');
		let graphHeight = graph.height();
		// round up max views
		let pow = Math.pow(10, (maxViews + '').length - 1);
		maxViews = Math.ceil(maxViews / pow) * pow;
		// add bars and x axis labels
		for (let i = Math.min(r.quarters.length - 1, 4), added = 0; i >= 0 && added < 5; i--) {
			let data = r.quarters[i];
			graph.append('<div class="bar" style="height:' + Math.max(11, Math.floor(data.points / maxViews * graphHeight)) + 'px;margin-right:' + (40 + (4 - added) * 66) + 'px;">'
				+ '<span>$' + Math.floor(data.total_payout).numberFormat() + '</span>'
				+ '<div class="views">' + data.points.numberFormat() + '</div></div>');
			monthAxis.append('<span>' + data.date + '</span>');
			added++;
		}
		// add y axis labels
		for (let i = 0, drop = Math.floor(maxViews / 5), halfStep = Math.floor(drop / 2); i < 5; i++) {
			viewAxis.append('<div>' + (maxViews - drop * i - halfStep).numberFormat() + '</div>');
		}

		// show top videos
		if (r.top_tracks.length) {
			let topVideoContainer = $j('.top_active_videos .body');
			topVideoContainer.empty().append(templates.get('top_video_container'));
			let tbody = topVideoContainer.find('tbody');
			for (let i = 0, len = r.top_tracks.length; i < len; i++) {
				let track = r.top_tracks[i];
				tbody.append(templates.get('top_video_row', {
					title : (track.title ? '<a href="'+siteBaseUrl()+'/track/' + track.track_id + '">' + track.title + '</a>' : 'Track removed'),
					date : formatDate('Y-n-j', track.added),
					cnt : track.cnt,
					revenue : (100 * (track.track_payout + track.point_payout)).moneyFormat()
				}));
			}
		}
	}
	
}
/**
 * The page in the admin panel that lets you manage your billing information
 */
function AdminBilling() {

	var page = this;
	var templates;
	var currentlyProcessing = false;

	function disableInteraction() {
		currentlyProcessing = true;
		$j('body').append(templates.get('processing_cover'));
	}

	function enableInteraction() {
		$j('.billing_processing_cover').remove();
		currentlyProcessing = false;
	}

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.isSiteOwner() && !user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			ajax({ p : 'billing', action : 'getDetails' }, function(billingDetails) {
				var template = sa.templates.get('admin.billing').get('not_owner', {
					siteOwnerId : billingDetails.siteOwner ? billingDetails.siteOwner.id : '',
					siteOwnerName : billingDetails.siteOwner ? billingDetails.siteOwner.name : '',
					siteOwnerEmail : billingDetails.siteOwner ? billingDetails.siteOwner.email : ''
				});

				if (billingDetails.siteOwner) {
					template.find('.site_owner_information.no_owner').remove();
				} else {
					template.find('.site_owner_information.has_owner').remove();
				}

				container.empty().append(template);
			});
			return;
		}

		if (!templates) {
			templates = sa.templates.get('admin.billing');
		}

		container.append(templates.get('loading'));

		ajax({ p : 'billing', action : 'getDetails', liveProcessing : sa.router.paramsToVars(params)['liveProcessing'] ? 1 : 0 }, function(billingDetails) {

			/**
			 * @var {Object} billingDetails
			 *  @property {string} billingState
			 *  @property {string} creationDate
			 *  @property {int} userCount
			 *  @property {int} catalogCount
			 *  @property {int} trackCount
			 *  @property {string} nextPaymentAmount - already money formatted
			 *  @property {string} nextPaymentDate - already date formatted
			 *  @property {string} cardDigits
			 *  @property {string} cardType - from the Braintree card types
			 *  @property {Array} invoices
			 *  @property {string} shutdownDate - already date formatted
			 *  @property {string} deleteDate - already date formatted
			 *  @property {Object} siteOwner
			 *  @property {Array} details
			 */

			var template = templates.get('billing', {
				creationDate : billingDetails.creationDate,
				userCount : billingDetails.userCount.numberFormat(),
				catalogCount : billingDetails.catalogCount,
				trackCount : billingDetails.trackCount.numberFormat(),
				nextPaymentAmount : billingDetails.nextPaymentAmount,
				nextPaymentDate : billingDetails.nextPaymentDate,
				cardDigits : billingDetails.cardDigits,
				shutdownDate : billingDetails.shutdownDate,
				deleteDate : billingDetails.deleteDate,
				siteOwnerId : billingDetails.siteOwner ? billingDetails.siteOwner.id : '',
				siteOwnerName : billingDetails.siteOwner ? htmlEncode(billingDetails.siteOwner.name) : '',
				siteOwnerEmail : billingDetails.siteOwner ? billingDetails.siteOwner.email : ''
			});
			let isSuperAdmin = user.hasAdminPermission(AdminPermission.SuperAdmin);
			let isSiteOwner = user.isSiteOwner();

			if (billingDetails.siteOwner) {
				template.find('.site_owner_information.no_owner').remove();
			} else if (isSuperAdmin) {
				template.find('.site_owner_information.has_owner').remove();
			} else {
				template.find('.site_owner_information').remove();
			}

			if (!billingDetails.cardType || !billingDetails.cardDigits) {
				template.find('.has_card').remove();
				template.find('.non-payment-warning').show();
			} else {
				template.find('.no_card').remove();
				template.find('.non-payment-warning').hide();
				var ccIcon = 'fa-credit-card';
				if (billingDetails.cardType == 'American Express') {
					ccIcon = 'fa-cc-amex';
				} else if (billingDetails.cardType == 'Diners Club') {
					ccIcon = 'fa-cc-diners-club';
				} else if (billingDetails.cardType == 'Discover') {
					ccIcon = 'fa-cc-discover';
				} else if (billingDetails.cardType == 'JCB') {
					ccIcon = 'fa-cc-jcb';
				} else if (billingDetails.cardType == 'MasterCard') {
					ccIcon = 'fa-cc-mastercard';
				} else if (billingDetails.cardType == 'Visa') {
					ccIcon = 'fa-cc-visa';
				}
				template.find('.card_icon').addClass(ccIcon);
			}

			if (!isSiteOwner) {
				template.find('.owner_only').remove();
			}
			if (!isSuperAdmin) {
				template.find('.superadmin_only').remove();
			}
			if (!isSiteOwner && !isSuperAdmin) {
				template.find('.owner_or_superadmin_only').remove();
			} else {
				sa.api.request({
					handler : 'contact',
					action : 'get-invoice-address'
				}).then(function(invoiceAddress) {
					let invoiceAddressField = template.find('textarea[name=invoice_address]');
					invoiceAddressField.val(invoiceAddress.address.replace(/<br\/?>/gi, '\n'));
					template.find('#invoice_address_save').on('click', function() {
						sa.api.request({
							handler : 'settings',
							action : 'save-invoice-address',
							postData : {
								invoiceAddress : invoiceAddressField.val()
							}
						}).then(function() {
							sa.notify({ type : sa.notify.notificationTypes.success, text : 'Invoice address saved!' });
						}).catch(function() {
							sa.alert('Unable to save your invoice address. Please reload.');
						});
					});
					
				});
			}

			template.find('.billing_state_' + billingDetails.billingState).addClass('showing');

			// add bill details
			var billDetailsList = template.find('.current_bill_details');
			if (billingDetails.details.length) {
				for (var bdd = 0, bddLen = billingDetails.details.length; bdd < bddLen; bdd++) {
					billDetailsList.append(templates.get('current_bill_item', billingDetails.details[bdd]));
				}
				billDetailsList.find('tr:odd').addClass('stripe');
			} else {
				billDetailsList.remove();
				template.find('.billing_details').remove();
			}

			// add invoices
			var invoiceHistoryList = template.find('.invoice_history_list');
			var invLen = billingDetails.invoices.length;
			if (invLen) {
				for (var inv = 0; inv < invLen; inv++) {
					var invoice = billingDetails.invoices[inv];
					invoiceHistoryList.append(templates.get('invoice_history_item', {
						type : invoice.type,
						invoiceLink : invoice.link,
						datePaid : invoice.datePaid,
						amount : invoice.amount
					}));
				}
				invoiceHistoryList.find('tr:odd').addClass('stripe');
			} else {
				invoiceHistoryList.append(templates.get('no_invoices'));
			}

			// interactivity
			template.find('.update_card').on('click', function() {
				if (!user.isSiteOwner()) {
					alert('Only the workspace owner can change the card data for this workspace');
					return;
				}
				if (currentlyProcessing) {
					sa.notify({ text : 'Processing. Please be patient' });
					return;
				}
				purchaseModal.show('site_billing', function(paymentResult) {
					enableInteraction();
					if (paymentResult.success) {
						sa.notify({ text : paymentResult.success, type : sa.notify.notificationTypes.success });
						$j('.unpaid_notice').fadeOut(function() { $j(this).remove(); });
						if (AdminBilling.onCardUpdate) {
							if (AdminBilling.onCardUpdate()) {
								AdminBilling.onCardUpdate = null;
								return;
							}
							AdminBilling.onCardUpdate = null;
						}
					}
					if (paymentResult) {
						page.show(params, container);
					}
				});
			});

			template.find('.rerun_card').on('click', function() {
				if (!user.isSiteOwner() && !user.hasAdminPermission(AdminPermission.SuperAdmin)) {
					alert('Only the workspace owner can rerun the card for this workspace');
					return;
				}
				if (currentlyProcessing) {
					sa.notify({ text : 'Processing. Please be patient' });
					return;
				}
				disableInteraction();
				ajax({ p : 'billing', action : 'rerunCard' }, function(paymentResult) {
					enableInteraction();
					if (paymentResult.success) {
						sa.notify({ text : paymentResult.success, type : sa.notify.notificationTypes.success });
						$j('.unpaid_notice').fadeOut(function() { $j(this).remove(); });
						if (AdminBilling.onCardUpdate) {
							if (AdminBilling.onCardUpdate()) {
								AdminBilling.onCardUpdate = null;
								return;
							}
							AdminBilling.onCardUpdate = null;
						}
						page.show(params, container);
					} else if (paymentResult.error) {
						sa.notify({ text : paymentResult.error });
					}
				});
			});

			template.find('.billing_details').on('click', function() {
				template.find('.billing_details_section').toggleClass('showing');
			});

			template.find('.delete_site').on('click', function() {
				if (!user.isSiteOwner()) {
					alert('Please delete the workspace through the White Labeler');
					return;
				}
				template.find('.delete_site_container').remove();
				template.find('.delete_site').after(templates.get('delete_warning'));
				$j('html, body').animate({ scrollTop : template.find('.delete_site_container').offset().top });

				template.find('.delete_cancel_button').on('click', function() {
					template.find('.delete_site_container').remove();
					$j('html, body').animate({ scrollTop: 0 });
				});

				template.find('.delete_confirm_button').on('click', function() {
					var deleteValue = template.find('input[name=delete_box]').val();
					if (deleteValue != 'delete') {
						sa.alert({ text : 'Please enter "delete" in the box if you actually want to delete your workspace.' });
						return;
					}
					if (currentlyProcessing) {
						sa.notify({ text : 'Processing. Please be patient' });
						return;
					}

					sa.components.exitSurvey.show({ onClose : function() {

						ajax({ deleteBox : deleteValue }, function (response) {
							var deleteNonce = response.nonce;
							sa.confirm({
								text : 'Last chance. Are you sure you want to delete this workspace?',
								yesText : 'Delete',
								noText : 'Cancel',
								yesFunction : function () {
									if (currentlyProcessing) {
										sa.notify({ text : 'Processing. Please be patient' });
										return;
									}
									sa.showCover('Deleting your workspace...');
									ajax({ nonce : deleteNonce }, function (response) {
										sa.hideCover();
										if (response.error) {
											sa.notify({ text : response.error });
										} else {
											sa.alert({ text : 'Your workspace is being deleted and you will receive a confirmation in your email. You will now be forwarded to the Workspace Manager.' });
											setTimeout(function () {
												document.location.href = 'https://account.sourceaudio.com/site_manager.php';
											}, 5000);
										}
									}, 'POST', { p : 'billing', action : 'delete' });
								},
								noFunction : function () {
									template.find('.delete_site_container').remove();
									$j('html, body').animate({ scrollTop : 0 });
								}
							});
						}, 'POST', { p : 'billing', action : 'getDeleteNonce' });

					}});

				});
			});

			// add it!
			container.empty().append(template);

			$j('.right_head .title').html('Billing for ' + htmlEncode(config.name));

		});
	};
}

/**
 * If set to a function, that function will be called once the user has entered their billing information
 * Return true if the hash is going to change
 * @type {function}
 */
AdminBilling.onCardUpdate = null;
/**
 * The page in the admin panel that lets you manage your billing information
 */
function AdminBlogPage() {
	const page = this;
	let templates;
	page.blogs = [];
	page.editBlogData = {};

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.blog');
		}
		
		page.loadData(params, container);
	};
	
	this.buildPage = function (params, container) {
		// If editing, load edit template and such
		const newBlogUrl = `${siteBaseUrl()}/admin?p=custom_pages&tab=blog&create=true`;
		const urlParams = new URLSearchParams(params);
		const isEditView = urlParams.has('edit') && urlParams.get('edit');
		const isCreateView = urlParams.has('create') && urlParams.get('create') === 'true';
		const template = (isEditView || isCreateView) ? templates.get('edit') : templates.get('blog-list', { newBlogUrl });

		container.empty().append(template);

		page.container = container;

		if (isEditView || isCreateView) {
			const blogId = isCreateView ? 0 : parseInt(urlParams.get('edit'), 10);
			page.editBlog(blogId);
			return;
		}
		
		// Load Blog List
		page.buildBlogList();
	};
	
	this.buildBlogList = function () {
		const blogListTable = page.container.find('#admin-blog-list');
		const blogEditUrlBase = `${siteBaseUrl()}/admin?p=custom_pages&tab=blog`;
		
		// Add Header
		const blogTableHeader = `
			<thead>
				<tr>
					<th>Thumbnail</th>
					<th>Title</th>
					<th>Date</th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
				</tr>
			</thead>
		`;
		blogListTable.append(blogTableHeader);
		
		// Add Rows
		page.blogs.forEach(blog => {
			const blogRow = $j(`
				<tr>
					<td>
						<a href="${blogEditUrlBase}&edit=${blog.blog_id}">
							<img src="${StringSanitize.encodeIfNotEncoded(blog.thumbnail)}" class="blog-thumbnail" alt="${blog.title} blog thumbnail"/>
						</a>
					</td>
					<td><a href="${blogEditUrlBase}&edit=${blog.blog_id}">${blog.title}</a></td>
					<td>${formatDate(config.dateFormatString, blog.date)}</td>
					<td colspan=3"></td>
					<td>
						<a href="${blogEditUrlBase}&edit=${blog.blog_id}">Edit</a> | 
						<a href="#0" class="delete-blog" data-blog-id="${blog.blog_id}">Delete</a>
					</td>
				</tr>
			`);
			
			if (!blog.thumbnail) {
				blogRow.find('.blog-thumbnail').parent().append('<div class="blog-thumbnail-placeholder"><i class="fa fa-question-square"></i></div>');
				blogRow.find('.blog-thumbnail').remove();
			}
			
			blogListTable.append(blogRow);
		});
		
		// Set up delete click listeners
		blogListTable.find('.delete-blog').on('click', function () {
			const blogId = parseInt($j(this).data('blog-id'), 10);
			const blogTableRow = $j(this).closest('tr');
			page.deleteBlog(blogId, blogTableRow);
			return false;
		});
	};
	
	page.deleteBlog = function (blogId, blogTableRow) {
		const confirmDeletion = confirm('Are you sure you want to delete this blog?');
		if (confirmDeletion) {
			// ajax call
			const blog = {
				blog_id: blogId,
				remove: true
			};
			
			ajax({ blog: JSON.stringify(blog) }, (r) => {
				if (!r || !r[0].success) {
					sa.alert({ text: 'Unable to delete blog. Please contact SourceAudio and let them know about this issue.' });
					return;
				}

				blogTableRow.remove();
			}, 'POST', { p: 'homemaker', action: 'saveBlog' });
		}
	};

	/**
	 * Edit Blog View Loader
	 * @param {Number} blogId
	 */
	this.editBlog = function (blogId) {		
		const isCreateMode = blogId === 0;
		
		// Load data about blog
		let blogData = {};
		let blogIndex = null;
		if (!isCreateMode) {
			blogData = page.blogs.find(blog => blog.blog_id === blogId);
			blogIndex = page.blogs.findIndex(blog => blog.blog_id === blogId);
		} else {
			blogData = {
				blog_id: 0,
				title: 'Blog Title',
				abstract: 'Shorter version of the body',
				thumbnail: null,
				body: 'Type your blog here',
				date: Math.round((new Date()).getTime() / 1000),
				draft: true
			};
		}
		
		blogData.body = StringSanitize.ifEncodedDecode(blogData.body);
		
		page.editBlogData = blogData;
		
		// Build View
		const editElement = page.container.find('.edit-blog-section');
		
		// Set Href for "Back to Blogs" 
		const blogsUrl = `${siteBaseUrl()}/admin?p=custom_pages&tab=blog`;
		editElement.find('#back-to-blogs-btn').attr('href', blogsUrl);
		
		// Set title
		const createOrEditTitle = isCreateMode ? 'New Blog' : `Editing: ${blogData.title}`;
		editElement.find('#blog-editing-title').text(StringSanitize.forInputField(createOrEditTitle));
		editElement.find('#blog-title').val(StringSanitize.forInputField(blogData.title));
		
		// Set Abstract
		editElement.find('#blog-abstract').text(StringSanitize.forInputField(blogData.abstract));
		
		// Handle Thumbnail Preview
		if (blogData.thumbnail) {
			editElement.find('.blog-image-preview').append(`<img src="${StringSanitize.encodeIfNotEncoded(blogData.thumbnail)}"  alt="Blog Preview Thumbnail"/>`);
		}
		
		// Handle Upload
		const uploadBtn = editElement.find('#blog-thumbnail');
		page.setupUploader(uploadBtn);
		
		// Set Body
		editElement.find('#blog-body').text(blogData.body);
		showWysiwygEditor('#blog-body');
		
		// Set Publish Date
		const dateString = formatDate(config.dateFormatString, blogData.date);
		const dateInputField = editElement.find('#blog-publish-date');
		dateInputField.val(dateString);
		dateInputField.datepicker({
			dateFormat: config.datePickerDateFormatString 
		});
		
		// Set Draft Status
		if (blogData.draft) {
			editElement.find('#blog-is-draft').prop('checked', true);
		} else {
			editElement.find('#blog-is-draft').prop('checked', false);
		}
		
		// Update Post
		editElement.find('#save-blog-post').text(isCreateMode ? 'Save Blog' : 'Update Blog');
		editElement.find('#save-blog-post').on('click', (e) => {
			e.preventDefault();
			page.updatePost(editElement, blogIndex);
		});
	};
	
	this.updatePost = function (editElement, blogIndex) {
		const blogId = parseInt(page.editBlogData.blog_id, 10);
		const title = StringSanitize.encodeIfNotEncoded(editElement.find('#blog-title').val());
		const abstract = StringSanitize.encodeIfNotEncoded(editElement.find('#blog-abstract').val());
		const thumbnail = StringSanitize.encodeIfNotEncoded(editElement.find('.blog-image-preview img').attr('src'));
		const body = page.editBlogData.body = getWysiwygEditorContent('#blog-body');
		const publishDate = editElement.find('#blog-publish-date').val();
		const publishDateTimestamp = (new Date(publishDate)).getTime() / 1000;
		const isDraft = editElement.find('#blog-is-draft').prop('checked');
		
		const blog = {
			blog_id: blogId || 0,
			title,
			abstract,
			thumbnail,
			body,
			date: publishDateTimestamp,
			draft: isDraft
		};
		
		if (Number.isInteger(blogIndex) && blogIndex > -1) {
			page.blogs[blogIndex] = blog;
		}

		// Update the blog data
		page.editBlogData = blog;
		
		ajax({ blog: JSON.stringify(blog) }, (r) => {
			if (!r || !r[0].success) {
				sa.alert({ text: 'Unable to save blog. Please contact SourceAudio and let them know about this issue.' });
				return;
			}
			
			sa.router.routeTo(siteBaseUrl() + '/admin?p=custom_pages&tab=blog');
		}, 'POST', { p: 'homemaker', action: 'saveBlog' });	
	};
	
	this.setupUploader = function (uploadBtn) {
		const blogUploader = new Uploader({ 
			button: uploadBtn[0], 
			browseCallback(uploader) { // after selecting an image
				const fileList = uploader.getFiles();
				const key = new Date().getTime();
				if (fileList && fileList.length === 1) {
					// auto-upload
					uploadBtn.html('Uploading...');
					uploader.upload({
						params: `u=${user.userData.id}&t=homemaker&key=${key}&source=blog`,
						complete() { // success function
							const newPath = `https://sourceaudio-images.s3.amazonaws.com/user_data/${user.userData.id}/${user.userData.id}-${key}.jpg`;
							// set the value where we need it
							page.container.find('.blog-image-preview').html(`<img src="${newPath}" alt="Blog Preview Image"/>`);
							page.editBlogData.thumbnail = newPath;
							
							// let them upload again
							uploadBtn.html('Browse');
						},
						error() { // error function
							uploadBtn.html('Browse');
						}
					});
				}
			}, 
			fileType: UploaderConstants.IMAGES 
		});	
	};
	
	this.setData = function (blogData) {
		const baseUrl = siteBaseUrl();
		
		const table = $j('<table class="sa-table"></table>');
		blogData.forEach(blog => {
			table.append(`
				<tr>
					<td>${blog.title}</td>
					<td><a href="${baseUrl}/admin?p=custom_pages&tab=blog&edit=${blog.blog_id}">Edit</a></td>
					<td><a class="faux_button">Delete</a></td>
				</tr>
			`);
		});
		
		page.container.append(table);
	};

	this.loadData = function (params, container) {
		ajax('p=homemaker&action=blogs&backend=1&cacheBreak=' + (new Date().getTime()), (blogResults) => {
			if (blogResults) {
				page.blogs = blogResults[0];
			}
			
			page.buildPage(params, container);
		});
	};
}
/**
 * The page in the admin panel that lets you view and manage your licensing and e-commerce options
 */
function AdminCollect() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Pando)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Add-Ons and Programs' + '" permission.</h3>');
		}
		if (!$j('.right_body.sad').length) {
			var callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [
					new RightTab('home', '/admin?p=collect&tab=home', 'Home', callback)
				];
			RightTabbedPage.prototype.show.call(this, 'collect', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'home';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			//if (pageId == 'home') {
				currentPage = new AdminCollectHome();
			//}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminCollect.prototype = new RightTabbedPage();

function AdminCollectHome() {

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		// hide the tab bar
		$j('#rtp_nav').hide();

		// show the collect module
		sa.showAdminProgram(sa.AdminProgram.Collect, container, true);
	};

}
/**
 * The page in the admin panel that lets you view and manage your licensing and e-commerce options
 */
function AdminContentId() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function (params, container) {		
		if (!user.hasAdminPermission(AdminPermission.Pando) && !user.hasAdminPermission(AdminPermission.ContentIdClaims)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Add-Ons and Programs' + '" permission.</h3>');
		}
		
		if (!config.contentid) {
			// they haven't signed up yet (probably). show them the pando
			sa.api.request({
				handler: 'content-id/contentid-settings',
				action: 'getStatus'
			}).then((r) => {
				if (r && r.status) {
					config.contentid = r.status;
					page.show(params, container);
				} else {
					sa.showAdminProgram(sa.AdminProgram.ContentID, container);
				}
			}).catch((e) => {
				console.log('Error:', e);
				return sa.alert(e.message);
			});
			return;
		}

		let defaultTab = 'whitelist';
		if (!$j('.right_body.contentid').length) {
			let callback = function(tabId, cont) { page.setPage(tabId, cont); };
			let tabs = [];

			if (user.hasAdminPermission(AdminPermission.Pando) && config.contentid.whitelist_enabled != 2) {
				tabs.push(new RightTab('ingest', '/admin?p=contentid&tab=ingest', 'Settings', callback));
				tabs.push(new RightTab('earnings', '/admin?p=contentid&tab=earnings', 'Earnings', callback));
				defaultTab = 'ingest';
			}
			// pando and contentid_claims can access these pages
			tabs.push(new RightTab('claims', '/admin?p=contentid&tab=claims', 'Claims', callback));
			tabs.push(new RightTab('whitelist', '/admin?p=contentid&tab=whitelist', 'Whitelist', callback));

			RightTabbedPage.prototype.show.call(this, 'contentid', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) {
			vars.tab = defaultTab;
		}
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			switch (pageId) {
				case 'ingest':
					currentPage = new AdminContentIdIngest();
					break;
				case 'earnings':
					currentPage = new AdminContentIdEarnings();
					break;
				case 'claims':
					currentPage = new AdminContentIdClaims();
					break;
				case 'whitelist':
					currentPage = new AdminContentIdWhitelist();
					break;
				case 'home':
				default:
					currentPage = new AdminContentIdHome();
					break;
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};

	/**
	 * Check for ContentID agreement status
	 * @returns {Promise<*|boolean>}
	 */
	this.checkContentIdAgreement = async function () {
		try {
			const resp = await sa.api.request({
				handler: 'content-id/contentid-settings',
				action: 'getAgreementStatus'
			});

			return resp.agreementStatus;
		} catch (e) {
			console.error(e);
			sa.alert(e.message);
			return false;
		}
	};
	
	this.checkForTempBypass = function () {
		return sessionStorage.getItem('contentid_unsigned_agreement') !== null;
	};
}
AdminContentId.prototype = new RightTabbedPage();

function AdminContentIdHome() {
	var page = this;
	var templates = sa.templates.get('admin.contentid');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {

		container.html('');
		showLoader(container, 'Loading Content ID');


			showPaid(container);

		

	};

	function showInformation(container) {
		container.empty().append(templates.get('information_page'));
	}

	function showUnsubscribed(container) {
		var template = templates.get('home_unsubscribed');

		container.html('').append(template);

	}

	function showSiteOwner(template) {
		sa.getSiteOwner(function(ownerInformation) {
			if (ownerInformation) {
				template.find('.so_cont .name').html(ownerInformation.username);
				template.find('.so_cont .email').html(ownerInformation.email);
				template.find('.so_cont .no_owner').remove();
			} else {
				template.find('.so_cont .has_owner').remove();
			}
		});
	}

	function showPaid(container) {
		console.log('showing paid');

		var template = templates.get('home_paid');


		container.html('').append(template);

	}

}
/**
 * A page in the admin panel
 */
function AdminContentIdIngest() {
	var page = this;
	var templates = sa.templates.get('admin.contentid');

	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var page = this;
		console.log('- showing settings');
		window.activePage = page;
		var pageTemplate = templates.get('ingest');
		container.html( pageTemplate );
		page.container = container;

		ContentIdImporter.generateButton($j('#appending-ingest-button').get(0));
		ContentIdImporter.generateButton($j('#replacing-ingest-button').get(0), true);

		page.getStats();

		$j('#site-default-select').val( config.contentid.rules ? config.contentid.rules.default : 0 );
		$j('#site-default-publishing').val( config.contentid.rules ? config.contentid.rules.publishing : 0 );
		$j('#site-default-ownership').val( config.contentid.ownership );

		$j('#contentid-settings-save').on('click',  function(){ page.save(false, $j(this)); });
		$j('#contentid-settings-run').on('click',  function(){ page.save(true, $j(this)); });

		$j('.test-rule-button').on('click',  function() { page.testTrackPrompt(); });
		$j('.add-rule-button').on('click',  function() { page.addCustomRule(); });

		if (config.contentid.rules) {
			$j('#actual-rules').show();
			$j('#assert-box').hide();
		} else {
			$j('#contentid-settings-assert').on('click', function() {
				$j('#actual-rules').slideDown();
				$j('#assert-box').hide();
			});
		}

		/*if (config.contentid.rules && config.contentid.rules.rules) {
			$j('.rules').html('You have <b>custom rules</b> set up by SourceAudio staff for you, so you may not edit them yet. If you have questions, please contact <B><a href="mailto:contentid@sourceaudio.com" >contentid@sourceaudio.com</a></b>.<BR><pre style="padding: 5px; border-radius: 3px; background: #EEE; margin: 5px 20px; float: left; white-space:normal;">' + JSON.stringify( config.contentid.rules ) + '</pre><div class="clr"></div>' );

			return;
		}*/

		page.customRuleTemplate = $j('#rule-template').detach();

		if (config.contentid.rules && config.contentid.rules.rules) {
			_.each(config.contentid.rules.rules, function(r) {
				page.addCustomRule(r);
			});
		}

		page.addCustomRule();
		
	};

	function showDownloadAgreementButton() {
		sa.AdminProgram.getAgreementPath(sa.AdminProgram.ContentID, function(agreementPath) {
			if (agreementPath) {
				$j('#assert-box, #ingest-stats').append(templates.get('agreement_download_button').attr('href', agreementPath));
			}
		});
	}

	this.rulesTypeChange = function() {
		var ruleDiv = $j(this.$input[0]).parent().parent().parent();
		var val = $j(this.$input[0]).val();
		console.log('- change on', ruleDiv.attr('id'), 'to', val);

		if (val == 'na') {
			ruleDiv.find('input.c-value')[0].selectize.disable();
		} else {
			ruleDiv.find('input.c-value')[0].selectize.enable();
			ruleDiv.find('input.c-value')[0].selectize.clear();
			ruleDiv.find('input.c-value')[0].selectize.clearOptions();
		}
	};

	this.rulesSearchLoad = function(query, cb) {

		var ruleDiv = $j(this.$input[0]).parent().parent().parent();
		var type = ruleDiv.find('select.c-type').val();
		console.log('- searching for type:', type);

		if (!type) return cb([]);
		if (!query.length) return cb([]);
		ajax(
			{
				p: 'list',
				type: type.replace('_id', ''),
				ids: 1,
				part: query,
				excludeSyncs: config.contentid.synced_ingestion ? 0 : 1
			},
			function (response) {
				var items = [];
				if (response && response.length && response[0].items) {
					response[0].items.each(function () {
						items.push({ id: this.id, value: htmlDecode(this.value) });
					});
				}
				cb(items);
			}
		);
	};

	this.getStats = async function() {
		$j('#ingest-stats').html('Loading...');

		if (config.contentid.approved < 1) {
			showDownloadAgreementButton();
			return $j('#ingest-stats').html( 'New accounts must be reviewed and approved by a staff member before your tracks enter the system. Please be patient and you can contact <a href="mailto:contentid@sourceaudio.com">contentid@sourceaudio.com</a> if you have any questions about the approval process. You can still configure your ingestion settings so you\'re ready once you\'re approved.');
		}

		const r = await sa.api.request({
			handler: 'content-id/contentid-settings',
			action: 'getIngestionStats'
		});

		console.log(r);

		if (!r.total) {
			$j('#ingest-stats').html('You have no tracks in Content ID yet.');
		} else {
			$j('#actual-rules').show();
			$j('#assert-box').hide();

			if (r.total == r[99]) {
				$j('#ingest-stats').html('All <b>' + r.total + '</b> of your Content ID tracks are ingested properly.');
			} else {
				$j('#ingest-stats').html('<ul>'
					+ '<li> <b>Total</b>: ' + r.total + '</li>'
					+ (r[99] ? '<li> <b>Added</b>: ' + r[99] + '</li>' : '')
					+ (r[0] || r[1] ? '<li> <b>Queued</b>: ' + (r[1] || r[0] || 0) + '</li>' : '')
					+ (r[2] ? '<li> <b>Processing</b>: ' + r[2] + '</li>' : '')
					+ (r[-1] ? '<li> <b>Errors</b>: ' + r[-1] + ' (The most common error is that a track is too short.)</li>' : '')
					+ (r.rem ? '<li> <b>Removed</b>: ' + r.rem + '</li>' : '')
					+ '</ul>');
			}
		}
		showDownloadAgreementButton();
	};

	this.addCustomRule = function(rule) {
		var div = page.customRuleTemplate.clone();
		var count = $j('.custom-rules .rule-row').length;

		div.attr('id', 'rule-' + (count + 1));

		// bindings
		div.find('.condition .c-type').selectize({onChange: page.rulesTypeChange});
		div.find('.condition .c-value').selectize({
			maxItems: 1,
			labelField : 'value',
			searchField : 'value',
			sortField : 'value',
			valueField : 'id',
			load: page.rulesSearchLoad
		});

		// disable value if we don't have a key
		if (!rule) div.find('.condition .c-value')[0].selectize.disable();

		// add data if we have it
		if (rule) {
			div.find('select.c-type')[0].selectize.addItem( rule.key );
			div.find('input.c-value')[0].selectize.addOption({id: rule.value, value: rule.text || rule.value});
			div.find('input.c-value')[0].selectize.addItem( rule.value );
			if (rule.add) div.find('.ingest input').prop('checked', true);
			if (rule.publishing) div.find('.publishing input').prop('checked', true);
			div.find('.ownership input').val( rule.ownership );
		}

		div.find('.delete').on('click',  page.ruleDelete );
		div.find('.arrows .top').on('click',  page.ruleUp );
		div.find('.arrows .bottom').on('click',  page.ruleDown );

		// add to page
		$j('.custom-rules-list').append( div );
	};

	this.ruleUp = function() {
		var div = $j(this).parent().parent();
		var id = div.attr('id');

		console.log('- moving rule up', id);

		div.insertBefore( div.prev('.rule-row') );
		div.transition({background: '#EEE'}).transition({background: '#FFF'});
	};

	this.ruleDown = function() {
		var div = $j(this).parent().parent();
		var id = div.attr('id');

		console.log('- moving rule down', id);

		div.insertAfter( div.next('.rule-row') );
		div.transition({background: '#EEE'}).transition({background: '#FFF'});
	};

	this.ruleDelete = function() {
		var div = $j(this).parent();
		var id = div.attr('id');

		console.log('- deleting rule', id);

		div.remove();

		if (!$j('.custom-rules .rule-row').length) {
			page.addCustomRule();
		}
	};

	this.testTrackPrompt = function() {
		sa.prompt({
			text : 'Enter a Track Id to test against your Content ID settings:',
			yesFunction : page.testTrack,
			yesText : 'Test',
			noText : 'Cancel',
			placeholder : '/track/1234567 <- that number'
		});
	};

	this.testTrack = async function(id) {
		console.log('- testing track', id);

		var d = {
			default: $j('#site-default-select').val(),
			publishing: $j('#site-default-publishing').val(),
			ownership: $j('#site-default-ownership').val()
		};

		d.rules = page.parseCustomRules();
		console.log('- running with:', d);

		if (!id) return sa.notify({text: 'You must enter a track id to check with.'});

		const r = await sa.api.request({
			handler: 'content-id/contentid-settings',
			action: 'testTrack',
			postData: {
				track_id: id,
				rules: d
			}
		});

		console.log(r);

		if (r.error) return sa.alert(r.error);

		sa.alert('<b>Track: ' + r.track.title + '</b><BR>Ingest: <b>' + r.settings.add + '</b><br>Publishing: <b>' + r.settings.publishing + '</b><br>Ownership: <b>' + r.settings.ownership + '</b>');
	};

	function getOwnership(el) {
		const regex = /[^a-zA-Z-\|]/g;
		var val = el.val() || 'WW';
		if (regex.test(val)) {
			el.addClass('invalid');
			return false;
		}
		return val
	}

	this.parseCustomRules = function () {
		
		var needsFixing = false;
		var rules = [];
		//console.log('- parsing custom rules');	
		$j('.custom-rules .rule-row').each(function() {
			var div = $j(this);
			var ownership = getOwnership(div.find('.ownership input'))
			if (!ownership) needsFixing = true;
			var r = {
				key: div.find('select.c-type').val(),
				value: div.find('input.c-value').val(),
				text: div.find('input.c-value')[0].selectize.getOption( div.find('input.c-value').val() ).text(),
				add: div.find('.ingest input').is(':checked') ? 1 : 0,
				publishing: div.find('.publishing input').is(':checked') ? 1 : 0,
				ownership: ownership
			};
		
			if (r.key && r.key != 'na') rules.push(r);
		});

		//console.log(rules);
		if (needsFixing) return 'error';
		return rules;
	};

	this.save = async function(run, button) {
		console.log('- save settings - run: ' + (run ? 'yes' : 'no'));
		$j('.ownership input, #site-default-ownership').removeClass('invalid');

		var ownership = getOwnership($j('#site-default-ownership'));

		var d = {
			default: $j('#site-default-select').val(),
			publishing: $j('#site-default-publishing').val(),
			ownership: ownership ? ownership : 'WW'
		};

		d.rules = page.parseCustomRules();
		if (d.rules == 'error' | !ownership) return sa.notify({ text: 'Please correct the highlighted ownership fields for invalid values.' });

		if (button) {
			var old = button.html();
			button.html('<i class="fa fa-spin fa-refresh"></i>');
		}

		const r = await sa.api.request({
			handler: 'content-id/contentid-settings',
			action: 'saveSettings',
			postData: {
				run: run ? 1 : 0,
				data: d
			}
		});

		console.log(r);
		if (r.c) config.contentid = r.c; // update the config

		if (button && old) button.html(old);

		if (run) {
			var b = $j(this);

			var text = 'Your tracks have already been processed according to these rules, there will be no changes.';
			if (r.run.change) {
				var c = templates.get('ingest_confirm');
				_.each(Object.keys(r.run).sort(), function (k) {
					if (k == 'change') return;
					c.find('ul').append('<li style="text-align: left"> <b>' + k.replace('_', ' ') + '</b>: ' + r.run[k] + '</li>');
				});
				text = c.html();
			} else {
				return sa.alert(text);
			}

			sa.confirm({
				text: text,
				yesFunction: async function (div) {
					var addOnly = div.find('#ingest-addition-only').is(':checked');
					console.log('- addOnly:', addOnly);

					sa.notify({ text: '<i class="fa fa-refresh fa-spin"></i> &nbsp; &nbsp; Content ID workspace scan has started.', type: 'basic_notification' });

					const r = await sa.api.request({
						handler: 'content-id/contentid-settings',
						action: 'scanSite',
						postData: {
							white_id: config.id,
							addOnly: addOnly ? 1 : 0
						}
					});

					console.log('- scan complete:', r);
					sa.notify({ text: 'Content ID workspace scan has finished! We will now sync with Google.', type: 'success_notification' });
					
				},
				yesText: 'Process'
			});
		}

		page.getStats();

	};

}
/**
 * A page in the admin panel
 */
function AdminContentIdEarnings() {
	var page = this;
	var templates = sa.templates.get('admin.contentid');
	var trackList = null;

	this.currentTab = '';
	this.isGraphReady = false;
	this.isDataReady = false;


	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function(params, container) {
		console.log('- showing earnings');
		window.activePage = page;
		var pageTemplate = templates.get('earnings');
		container.html( pageTemplate );
		page.container = container;

		page.color = getCSSColor('waveform_dark_bar', true);

		$j.getScript('https://www.gstatic.com/charts/loader.js', function() {
			console.log('- chart script loaded');
			google.charts.load('current', {packages: ['corechart', 'bar']});
			google.charts.setOnLoadCallback( page.graphReady );
		});

		$j('#earnings-export select').on('change', page.export);

		const r = await sa.api.request({
			handler: 'content-id/content-id-settings',
			action: 'getEarnings',
			postData: {}
		});
		
		console.log('- data ready:', r);
		page.data = r;

		var total = 0;
		page.lastDate = null;
		_.each(_.toPairs(page.data).reverse(), function (r) {
			if (!page.lastDate) page.lastDate = r[0];
			var date = r[0];
			var earn = r[1] * 100;
			total += parseFloat(earn);

			var dobj = new Date(date.substr(0, 4) + '-' + date.substr(4, 2) + '-01T12:00');
			var month = formatDate('F', dobj.getTime() / 1000);
			var year = formatDate('y', dobj.getTime() / 1000);

			$j('#earnings-export select').append('<option value="' + date + '">' + month.substr(0, 3) + ' \'' + year + ' - ' + htmlDecode(earn.moneyFormat()) + '</option>');
		});
		$j('#earnings-total').html(total.moneyFormat());

		loadTracks();

		if (page.isGraphReady) return page.drawGraph();
		page.isDataReady = true;
		


	};

	this.graphReady = function() {
		console.log('- graph ready');

		if (page.isDataReady) return page.drawGraph();
		page.isGraphReady = true;

	};

	this.drawGraph = function() {

		// https://developers.google.com/chart/interactive/docs/gallery/columnchart
		console.log('- drawing graph');

		var dataRows = _.map(_.toPairs(page.data).slice(-6), function(r) {
			var date = r[0];
			var dobj = new Date( date.substr(0, 4) + '-' + date.substr(4,2) + '-01T12:00');
			var earn = r[1];
			var month = formatDate('F', dobj.getTime() / 1000);
			var year = formatDate('y', dobj.getTime() / 1000);
			return [month.substr(0, 3) + ' \'' + year, parseFloat(earn), htmlDecode( (earn * 100).moneyFormat() ), page.color];
		});

		dataRows.unshift(['Date', 'Earned', {role: 'tooltip'}, {role: 'style'}]);
		console.log('- datarows:', dataRows);

		let graphContainer = $j('#earnings-graph');
		if (!graphContainer.length) return; // might have paged away
		var data = new google.visualization.arrayToDataTable(dataRows);

		var options = {
			legend: {position: 'none'},
			width: 800,
			height: 350,
			vAxis: {
				format: '$#,###,###'
			}
		};

		var chart = new google.visualization.ColumnChart(graphContainer[0]);
		chart.draw(data, options);

	};

	this.export = function() {
		var date = $j(this).val();
		if (!parseInt(date)) return;
		console.log('- exporting for', date);

		window.location.href = 'export.php?type=contentIdEarnings&date=' + date;
	};

	function loadTracks(params) {
		var sort = $j('#filters #order').val() || 'earned';

		if (trackList) trackList.showCover();

		ajax('p=track_info&cide=1&' + (params ? params : 'o=' + sort) + '&siteId=' + config.id, function(response) { setTracks(response); });
	}

	/**
	 * Populates the track list, creating it if it doesn't already exist
	 */
	function setTracks(newData) {
		var trackListConfig;

		$j('#earnings-tracks').html('');

		// insert data
		trackListConfig = new TrackListConfig();
		trackListConfig.addColumnList([
			new ListColumn('play', ['play', 'download', 'email']),
			new ListColumn('title', ['title']),
			new ListColumn('catalog', ['avatar', 'catalog']),
			new ListColumn('album', ['album']),
			new ListColumn('length', ['length']),
			new ListColumn('earned', ['custom_1']),
		]);
		trackListConfig.allowBlock = false;
		trackListConfig.allowMiniBlock = false;
		trackListConfig.bankKey = 'contentid_earnings';
		trackListConfig.getDefaultView = function() { return ListViewType.List; };
		trackListConfig.sortable = false;
		trackListConfig.useCache = true;
		trackListConfig.useFilters = false;
		trackListConfig.headerBackground = false;
		trackListConfig.viewCookie = false;

		trackList = createTrackList(trackListConfig);
		trackList.generatePage($j('#earnings-tracks'));
		trackList.setData(newData, function(params) { return '/admin?p=contentid&tab=earnings'; }, function(params) { loadTracks(params); return false;});
	}


}
/**
 * A page in the admin panel
 */
function AdminContentIdClaims() {
	var page = this;
	var templates = sa.templates.get('admin.contentid');
	var trackList = null;

	this.currentTab = '';

	// date ranges
	const now = new Date();
	const midnight = new Date(now).setHours(23, 59, 59, 999);

	const dateRanges = {
		day: {
			label: 'Today',
			start: new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime(),
			end: midnight,
			count: null
		},
		week: {
			label: 'This Week',
			start: new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay()).getTime(),
			end: midnight,
			count: null
		},
		month: {
			label: 'This Month',
			start: new Date(now.getFullYear(), now.getMonth(), 1).getTime(),
			end: midnight,
			count: null
		},
		all: {
			label: 'All',
			start: 1000, // multiply by 1000 so when divided later we get 1
			end: midnight,
			count: null
		}
	};

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function(params, container) {
		var page = this;
		console.log('- showing claims');
		window.activePage = page;
		var pageTemplate = templates.get('claims');
		container.html( pageTemplate );
		page.container = container;

		page.params = sa.router.getCurrentQueryParams();
		page.vars = sa.router.paramsToVars(page.params);
		console.log('- page vars:', page.vars);

		const hasFilters = Boolean(page.vars.track_id || page.vars.video_id || page.vars.channel_id);

		// Only set default range if no filters and no range is set
		if (!hasFilters && !page.vars.range) {
			console.log('- no filters or range set - filters setting to day');
			page.vars.range = 'day';
			sa.router.routeTo(sa.router.getCurrentPath() + '?' + sa.router.varsToParams(page.vars));
			return; // Let the route reload handle everything
		}

		// Populate search fields on load
		if (page.vars.track_id) {
			$j('#search-trackid').val(page.vars.track_id);
		}
		if (page.vars.video_id) {
			$j('#search-videoid').val(page.vars.video_id);
		}
		if (page.vars.channel_id) {
			$j('#search-channelid').val(page.vars.channel_id);
		}

		const count = await loadTracks();

		// Handle range cycling only if we have a range and no filters
		if (!hasFilters && page.vars.range) {
			dateRanges[page.vars.range].count = count;

			if (count === 0) {
				// Try ranges in order: day -> week -> month -> all
				const orderedRanges = ['day', 'week', 'month', 'all'];
				const currentIndex = orderedRanges.indexOf(page.vars.range);

				for (let i = currentIndex + 1; i < orderedRanges.length; i++) {
					page.vars.range = orderedRanges[i];
					const rangeCount = await loadTracks();
					dateRanges[page.vars.range].count = rangeCount;

					if (rangeCount > 0) {
						sa.router.routeTo(sa.router.getCurrentPath() + '?' + sa.router.varsToParams(page.vars));
						break;
					}
				}
			}
		}

		generateDateRangeButtons();

		$j('#search-claims-button').on('click', function() {
			var filterVars = {};
			var trackId = $j('#search-trackid').val();
			var videoId = $j('#search-videoid').val();
			var channelId = $j('#search-channelid').val();

			if (trackId) filterVars.track_id = trackId;
			if (videoId) filterVars.video_id = videoId;
			if (channelId) filterVars.channel_id = channelId;

			console.log('- filtering for:', filterVars);

			// clean vars
			cleanVars();

			var joinedVars = {...page.vars, ...filterVars };

			console.log('- joined:', joinedVars);

			sa.router.routeTo(sa.router.getCurrentPath() + '?' + sa.router.varsToParams(joinedVars));

		});
		page.container.find('#export-claims').on('click', function (e) { page.showExport(); });

	};

	function cleanVars() {
		delete page.vars.track_id;
		delete page.vars.channel_id;
		delete page.vars.video_id;
		delete page.vars.pg;
		delete page.vars.range;
	}

	function generateDateRangeButtons() {
		// create buttons
		const $buttonContainer = $j('#date-range-buttons');
		// clear existing buttons
		$buttonContainer.html('');
		for (const range in dateRanges) {
			const isDisabled = dateRanges[range].count === 0;
			const button = $j(`<button class="date-range-button${page.vars.range === range ? ' active' : ''}${isDisabled ? ' disabled' : ''}">${dateRanges[range].label}</button>`);
			button.on('click', () => {
				if (isDisabled) return;
				cleanVars();
				page.vars.range = range;
				$buttonContainer.find('.date-range-button').removeClass('active');
				button.addClass('active');
				sa.router.routeTo(sa.router.getCurrentPath() + '?' + sa.router.varsToParams(page.vars));
			});
			$buttonContainer.append(button);
		}
	}

	async function loadTracks(params) {
		if (trackList) trackList.showCover();

		var params = page.vars ? { ...page.vars } : {};
		params.siteId = config.id;

		if (params.range) {
			const range = dateRanges[params.range];
			if (range) {
				// Convert milliseconds to seconds for PHP backend
				params.start_date = Math.floor(range.start / 1000);
				params.end_date = Math.floor(range.end / 1000);
			}
		}

		const response = await sa.api.request({
			handler: 'content-id/claims',
			action: 'get',
			postData: params
		});

		console.log('- claims response:', response);

		setTracks(response);

		// return the number of tracks
		return response.tracks?.length;

	}

	/**
	 * Populates the track list, creating it if it doesn't already exist
	 */
	function setTracks(r) {
		var trackListConfig;

		// get this out, the link function will put them back in
		delete page.vars.pg;
		delete page.vars.show;

		$j('#claims-tracks').html('');

		if (!r.tracks || !r.tracks.length) {
			$j('#claims-tracks').html('You do not have any claims yet.');
			return;
		}

		//trackbank
		trackBank.clear('contentid_claims_page');
		r.tracks = JSON.parse(r.tracks);
		console.log('- parsed:', r.tracks);
		var tracks = {};
		_.each(r.tracks, function(track) {
			if (!track.id) return;
			tracks[track.id] = track;
			trackBank.add(track, 'contentid_claims_page');
		});

		// insert data
		var listItems = [{
			count: parseInt( r.listInfo.count ),
			trackCount: parseInt( r.listInfo.count ),
			pageVars: 'show=' + r.listInfo.show + '&pg=',
			page: r.listInfo.pg || 0,
			perPage: r.listInfo.show || 15
		}];

		_.each(r.items, function(item) {
			var track = tracks[item.track_id];
			var actionText = '<div data-claims="' + item.claim_id + '" class="interaction_type release-claim">'
								+ '<span class="icon far fa-lock-open"></span>'
								+ '<span class="name" style="text-transform: uppercase; padding-left: 3px;"> Release</span>'
							+ '</div>';
			if (parseInt(item.released) < 0) {
				actionText = 'Release Error<br/><a href="mailto:support@sourceaudio.com">Contact Support</a>';
			} else
			if (!parseInt(item.activeTotal)) {
				try {
					var rdata = JSON.parse(item.released_by);
					if (rdata.type == 'softlist') {
						actionText = 'Whitelisted release';
					} else
					if (rdata.type == 'manual') {
							actionText = 'Manual release by ' + rdata.username;
					} else
					if (rdata.type == 'auto-historical') {
						actionText = 'Historical auto release by ' + rdata.username;
					} else
					if (rdata.type == 'auto-historical-hardlist') {
							actionText = 'Historical hard whitelist auto release by ' + rdata.username;
					} else {
						actionText = 'Released'
					}
				} catch(e) {
					console.log('- error parsing release json:', e, item.released_by);
					actionText = 'Released';
				}
			}

			if (!track) track = {};

			listItems.push({
				id: item.track_id,
				title: track.title ? track.title : 'Deleted Track',
				date: item.date,
				file: track.file,
				length: track.length,
				actualLength: track.actualLength,
				yt_video: '<a target="_blank" href="https://www.youtube.com/watch?v=' + item.video_id + '">' + item.video_title + ' <i class="fa fa-external-link"></i></a>',
				yt_channel: '<a target="_blank" href="https://www.youtube.com/channel/' + item.channel_id + '">' + item.video_author + ' <i class="fa fa-external-link"></i></a>',
				option: actionText
			});
		});

		trackListConfig = new TrackListConfig();
		trackListConfig.addColumnList([
			new ListColumn('play', ['play']),
			new ListColumn('title', ['title']),
			new ListColumn('date', ['date']),
			new ListColumn('Video', ['yt_video']),
			new ListColumn('Channel', ['yt_channel']),
			new ListColumn('', ['option'])
		]);
		trackListConfig.allowBlock = false;
		trackListConfig.allowMiniBlock = false;
		trackListConfig.bankKey = 'contentid_earnings';
		trackListConfig.getDefaultView = function() { return ListViewType.List; };
		trackListConfig.sortable = false;
		trackListConfig.selectable = false;
		trackListConfig.useCache = true;
		trackListConfig.useFilters = false;
		trackListConfig.headerBackground = false;
		trackListConfig.viewCookie = false;
		trackListConfig.resultCountChanging = false;

		trackList = createTrackList(trackListConfig);
		trackList.generatePage($j('#claims-tracks'));
		trackList.setData(listItems, function(params) { return '/admin?' + sa.router.varsToParams(page.vars) + '&' + params; });

		$j('div.interaction_type.release-claim').on('click', function() {
			var claimId = $j(this).data('claims');
			console.log('- release claims:', claimId);
			sa.confirm({
				text: 'Are you sure you want to release this claim?',
				yesFunction: function(div) {
					sa.api.request({
						handler: 'content-id/claims',
						action: 'release',
						getData: {claim_id: claimId}
					}).then(function (r) {
						console.log('- release complete:', r);
						if (r.error) {
							return sa.error( r.error );
						}
						sa.notify({ text: 'Claim released.', type: 'success_notification' });
						sa.router.reloadPage();
					});

				},
				yesText: 'Release'
			});
		});

		console.log('generated track list:', trackList);
	}

	this.showExport = function () {
		var box;
		var box_content = templates.get('claims-export');

		box = new FocusBox(box_content, { title: 'Claims History Export' });
		box.show();

		$j('#cidClaims_cancel').on('click', function () {
			box.hide();
		});

		$j('#cidClaims_download').on('click', function () {
			var start = $j('#cidClaims_export_start').val();
			var end = $j('#cidClaims_export_stop').val();
			var filter = $j('#cidClaims_export_filter').val();
			if (filter) filter = '&filter=' + encodeURIComponent(filter);
			box.showLoader('Exporting...');

			$j("#cidClaims_download").hide();
			$j(".focused_container").height($j(".focused_container").height() + 15);
			$j(".cidClaims_box").height($j(".cidClaims_box").height() + 15);

			window.location.href = 'export.php?type=ContentIdClaims&start=' + encodeURIComponent(start) + '&end=' + encodeURIComponent(end) + filter;
			box.hide();
		});

		$j('#cidClaims_export_start').datepicker({ dateFormat: config.datePickerDateFormatString });
		$j('#cidClaims_export_stop').datepicker({ dateFormat: config.datePickerDateFormatString });

		var month_ago = new Date();
		month_ago.setMonth(month_ago.getMonth - 1);

		$j('#cidClaims_export_start').datepicker('setDate', '-1m');
		$j('#cidClaims_export_stop').datepicker('setDate', new Date());
	};
}
/**
 * A page in the admin panel
 */
function AdminContentIdWhitelist() {
	var page = this;
	var templates = sa.templates.get('admin.contentid');
	var trackList = null;

	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		window.activePage = page;
		page.params = params;
		page.vars = sa.router.getCurrentParamsAsObject();
		page.container = container;

		if ($j('#admin-contentid-whitelist').length) {
			// this page is already being displayed. the user must have changed track list settings
			page.getWhitelist();
			if (config.contentid.whitelist_enabled || user.hasAdminPermission(AdminPermission.SuperAdmin)) page.getHardWhitelist();
		} else {
			container.empty().append(templates.get('whitelist'));
			page.getWhitelist();
			$j('#add-whitelist').on('click', page.addWhitelist);
			if (config.contentid.whitelist_enabled || user.hasAdminPermission(AdminPermission.SuperAdmin)) page.getHardWhitelist();
		}

		var channelInput = '';
		page.container.on('click', 'a.yt-search-link', function () {
			channelInput = $j(this).attr("data-input");
			sa.components.yt_channel_search.show(setSelectedChannel);
		});

		var setSelectedChannel = function(selectedChannelId) {
			page.container.find('#' + channelInput).val(selectedChannelId);
		}

	};

	this.addWhitelist = async function() {
		$j('#add-whitelist').text('Whitelisting Channel(s)...').prop('disabled', true);
		var channelIds = $j('#add-channel-id').val();
		var note = $j('#add-channel-note').val();

		if (!channelIds) {
			$j('#add-whitelist').text('Whitelist Channel(s)');
			return sa.error('Please include a channel.');
		}

		const r = await sa.api.request({
			handler: 'content-id/contentid-settings',
			action: 'addSoftlistChannel',
			postData: {
				channel_ids: channelIds,
				note: note
			}
		});

		$j('#add-whitelist').text('Whitelist Channel(s)');

		// Clear input fields
		$j('#add-channel-id').val('');
		$j('#add-channel-note').val('');

		console.log('- added:', r);

		// display alerts
		$whitelistAlerts = $j('#whitelist-alerts').empty();
		if (r.added.length) {
			$whitelistAlerts.append(`
			<p class="success">
			<i class="fas fa-check-circle fa-fw"></i><strong>Successfully Added:</strong> ${r.added.map(channel => channel.channel_name).join(', ')}.
			</p>
			`);
		}
		if (r.failed.length) {
			$whitelistAlerts.append(`
			<p class="error">
			<i class="fas fa-times-circle fa-fw"></i><strong>Failed to Add:</strong> ${r.failed.join(', ')}.
			</p>
			`);
		}

		// release claims
		let releaseClaims = $j('#release-claims').prop("checked") ? 1 : 0;
		if (!releaseClaims) return page.getWhitelist();

		for (channel of r.added){
			page.releaseHistoricalClaims(channel.channel_id);
		}

	};

	this.releaseHistoricalClaims = function (channel, hardlistRelease = 0) {

		console.log('- releasing channel claims:', channel);
		let rparams = {};
		rparams.channel_id = channel;
		rparams.hardlistRelease = hardlistRelease;

		sa.api.request({
			handler: 'content-id/claims',
			action: 'ReleaseHistoricalClaims',
			postData: rparams
		}).then(releaseResults).catch(function (e) {
			console.log('Error:', e);
			sa.alert(e.message);
			page.getWhitelist();
		});

		function releaseResults(r, hardlistRelease) {

			console.log('- claim release response:', r);

			if (!r.claims.length) {
				sa.notify({ text: 'Success! No existing claims to release.', type: 'success_notification' });
				if (!hardlistRelease) return page.getWhitelist();;
				return;
			}

			var claimTotal = r.claims.length,
				released = 0,
				release_errors = [],
				update_errors = [];
			for (i in r.claims) {
				if (r.claims[i].released && r.claims[i].updated) {
					++released;
					continue;
				}
				if (!r.claims[i].released) {
					release_errors.push(r.claims[i]);
					continue;
				}
				++released;
				update_errors.push(r.claims[i]);
			}

			if (r.claims.length == released && !update_errors.length) {
				sa.notify({ text: 'Success! Claims found: ' + r.claims.length + ' Claims released: ' + released, type: 'success_notification' });
				if (!hardlistRelease) return sa.router.reloadPage();
				return;
			}

			let cont = $j('#whitelist-FB');
			cont.empty();

			let content = 'Claim(s) found: ' + claimTotal + ', Claim(s) Released: ' + released + '<br/>';

			if (release_errors.length) {
				content += 'The following ' + release_errors.length + ' claim(s) were not released: <br/>';
				for (i in release_errors) {
					content += 'Claim ID: ' +  release_errors[i].claim_id + '<br/>';
				}
				content += 'The most common causes of an unsuccessful attempt to release a claim are that the video has since been deleted, the channel is no longer active, the claim has been closed, or the channel\'s monetization has been suspended. If you think this is incorrect, please contact support@sourceaudio.com <br/>';
			}

			if (update_errors.length) {
				content += 'The following ' + release_errors.length + ' claim(s) were successfully released but encountered an error while processing it\'s release: <br/>';
				for (i in update_errors) {
					content += 'Claim ID: ' + update_errors[i].claim_id + '<br/>';
				}
			}

			var fbCont = '<div id="text_container">' + content + '<div class="confirm_buttons"><a class="button confirm_yes" id="release-ok">Ok</a></div></div>';
			let fb = new FocusBox(cont.html(fbCont));
			fb.show();

			$j('#release-ok').on('click', function () {
				if (fb) fb.hide();
				if (!hardlistRelease) return sa.router.reloadPage();
				return;
			});
		}

	};

	this.getWhitelist = function () {
		const trackListContainer = $j('#whitelist-list');
		trackListContainer.html('');

		const conf = new ListConfig();
		conf.bankKey = 'whitelist-list';
		conf.sortable = false;
		conf.pagination = true;
		conf.selectable = false;
		conf.emptyMessage = 'You do not have any whitelisted channels yet.';
		conf.filterNoResultMessage = 'No whitelisted channels found.';
		conf.addColumnList([
			new ListColumn('channel', ['yt_channel'], true),
			new ListColumn('type', ['white_type'], true),
			new ListColumn('date', ['date'], true),
			new ListColumn('details', ['white_details'], true),
			new ListColumn('actions', ['actions'])
		]);

		const list = createLicensingActivityList(conf);
		list.generatePage(trackListContainer);

		const whiteListFilterInput = $j('.soft-whitelist-search');

		const getFilteredResults = () => {
			const searchTerm = whiteListFilterInput.val();
			if (!searchTerm) {
				QueryParams.RemoveParam('searchTerm');
				return;
			}
			
			// Reset page query param to reset the list
			page.vars.pg = 0;
			QueryParams.UpdateParam('pg', '0');
			
			// Add the query param to the URL
			QueryParams.AddQueryParam('searchTerm', searchTerm);

			loadItems(searchTerm);
		};

		whiteListFilterInput.on('keypress', (e) => {
			if (e.key === 'Enter' || e.keyCode === 13) {
				getFilteredResults();
			}
		});

		const resetFilterBtn = page.container.find('#reset-whitelist-filter');
		resetFilterBtn.on('click', () => {
			// Clear the filter input
			whiteListFilterInput.val('');
			
			// Remove the query param from the URL
			QueryParams.RemoveParam('searchTerm');

			// Reset page query param to reset the list
			page.vars.pg = 0;
			QueryParams.UpdateParam('pg', '0');
			
			loadItems();
		});

		const filterBtn = $j('#filter-whitelist');
		filterBtn.on('click', getFilteredResults);

		const exportWhiteListBtn = page.container.find('#export-whitelist-channels');
		exportWhiteListBtn.attr('href', 'export.php?type=contentIdWhitelist');

		$j('#whitelist-list').on('click', 'button.remove-channel', function () {
			var id = $j(this).attr('id');
			var idA = id.split('-');
			idA.shift();
			var channelId = idA.join('-');
			console.log('- remove channel:', channelId);
			sa.confirm({
				text: 'Are you sure you want to remove this channel?',
				yesFunction: async function (div) {

					const r = await sa.api.request({
						handler: 'content-id/contentid-settings',
						action: 'removeSoftlistChannel',
						postData: {
							channel_id: channelId,
						}
					});

					console.log('- removed:', r);
					sa.notify({ text: 'Channel removed.', type: 'success_notification' });
					sa.router.reloadPage();

				},
				yesText: 'Remove'
			});
		});

		async function loadItems(searchTerm = '') {
			list.showCover('', 'Loading channels');

			const queryParams = new URLSearchParams(window.location.search);
			if (!searchTerm && queryParams.has('searchTerm')) {
				searchTerm = queryParams.get('searchTerm');
			}
			
			const r = await sa.api.request({
				handler: 'content-id/contentid-settings',
				action: 'getSoftlists',
				postData: {
					pg: page.vars.pg || 0,
					show: page.vars.show || 25,
					search: searchTerm
				}
			});

			if (r.error) {
				sa.notify({ text: r.error });
				list.hideCover();
				return;
			}
			
			// Check if the hard whitelist is currently being filtered
			let hardlistFilterQueryParam = '';
			if (queryParams.has('hardListSearchTerm')) {
				hardlistFilterQueryParam = queryParams.get('hardListSearchTerm');
			}

			if (searchTerm) {
				list.conf.activeFilters.add('searchTerm');
			} else if (list.conf.activeFilters.has('searchTerm')) {
				list.conf.activeFilters.delete('searchTerm');
			}
			
			const { listInfo } = r;
			const listParams = {
				count: listInfo.count || 25,
				page: listInfo.pg || 0,
				perPage: listInfo.show || 25,
				pageVars: 'show=' + listInfo.show + (searchTerm ? '&searchTerm=' + searchTerm : '') + (hardlistFilterQueryParam ? '&hardListSearchTerm=' + hardlistFilterQueryParam : '') + '&pg='
			};
			
			// Fill in the filter box with query param if applicable
			$j('.soft-whitelist-search').val(searchTerm);

			// format data
			var listItems = [];
			listItems.push(listParams);
			_.each(r.items, function (item) {
				item = {
					yt_channel: '<a target="_blank" href="https://www.youtube.com/channel/' + item.channel_id + '">' + (item.channel_name || item.channel_id) + ' <i class="fa fa-external-link"></i></a>',
					white_type: item.data.manual ? 'Manual' : 'Purchase',
					date: item.date,
					white_details: item.data.manual ? item.data.note || 'No note' : item.track_ids.split(',').length + ' Licenses',
					actions: '<button id="channel-' + item.channel_id + '" class="remove-channel">Remove Channel</button>'
				};
				listItems.push(item);
			});

			list.hideCover();
			
			page.softlist = list;
			page.softlistItems = listItems;
			page.loadItemsFn = loadItems;
			
			page.setSoftlistData();

		}

		loadItems();
	};
	
	this.setSoftlistData = function (additionalParams = '', hardReset = false) {
		const listItems = page.softlistItems;
		
		if (!additionalParams && hardReset) {
			// Remove the filter for hard whitelisted items
			listItems[0].pageVars = listItems[0].pageVars.replace(/&hardListSearchTerm=[^&]+/, '');
		}
		
		this.softlist.setData(listItems, (listParams) => {
			return '/admin?p=contentid&tab=whitelist&' + listParams + (additionalParams ? '&' + additionalParams : '');
		}, (listParams) => {
			sa.router.routeTo('/admin?p=contentid&tab=whitelist&' + listParams + (additionalParams ? '&' + additionalParams : ''));
			page.vars = sa.router.getCurrentParamsAsObject();
			page.loadItemsFn();
			return false;
		});
	};

	/** hardwhitelisting */
	this.getHardWhitelist = function () {
		const hardwhitelistTemplate = templates.get('hard-whitelist');
		page.container.append(hardwhitelistTemplate);

		const hardListFilterInput = page.container.find('.hard-whitelist-search');
		const filterBtn = page.container.find('#filter-hard-whitelist');
		const resetFilterBtn = page.container.find('#reset-hard-whitelist-filter');

		const getFilteredResults = () => {
			let searchTerm = hardListFilterInput.val();

			const queryParams = new URLSearchParams(window.location.search);
			if (!searchTerm && queryParams.has('hardListSearchTerm')) {
				searchTerm = queryParams.get('hardListSearchTerm');
			} else {
				QueryParams.AddQueryParam('hardListSearchTerm', searchTerm);
			}
			
			page.setSoftlistData('hardListSearchTerm=' + searchTerm);

			sa.api.request({
				handler: 'content-id/whitelists',
				action: 'get',
				postData: { search: searchTerm }
			}).then((res) => displayHardwhitelist(res, searchTerm));
		};

		hardListFilterInput.on('keypress', (e) => {
			if (e.key === 'Enter' || e.keyCode === 13) {
				getFilteredResults();
			}
		});

		resetFilterBtn.on('click', () => {
			// Clear the filter input
			hardListFilterInput.val('');

			// Remove the query param from the URL
			QueryParams.RemoveParam('hardListSearchTerm');
			
			// Reset the page query param to reset the list
			page.vars.pg = 0;
			page.setSoftlistData('', true);
			
			sa.api.request({
				handler: 'content-id/whitelists',
				action: 'get'
			}).then(displayHardwhitelist);
		});

		filterBtn.on('click', getFilteredResults);

		// Check if there is an existing search query
		let hardListSearchTerm = '';
		const queryParams = new URLSearchParams(window.location.search);
		if (queryParams.has('hardListSearchTerm')) {
			hardListSearchTerm = queryParams.get('hardListSearchTerm');
			
			// Set the value in the input
			hardListFilterInput.val(hardListSearchTerm);
		}
		
		sa.api.request({
			handler: 'content-id/whitelists',
			action: 'get',
			postData: { search: hardListSearchTerm }
		}).then((res) => displayHardwhitelist(res, hardListSearchTerm));

		function displayHardwhitelist(r, searchTerm) {
			console.log('- hardwhitelist response:', r);

			$j('#add-hard-whitelist').on('click', addHardWhitelist);
			$j('#hard-whitelist-list').html('');

			// build list
			const hConf = new ListConfig();
			hConf.pagination = false;
			hConf.resultCountChanging = false;
			hConf.bankKey = 'contentid_hardwhitelist_page';
			hConf.sortable = false;
			hConf.selectable = false;
			hConf.emptyMessage = 'You do not have any hard whitelisted channels yet.';
			hConf.filterNoResultMessage = 'No whitelisted channels found.';
			if (searchTerm) {
				hConf.activeFilters.add('hardListSearchTerm');
			} else if (hConf.activeFilters.has('hardListSearchTerm')) {
				hConf.activeFilters.delete('hardListSearchTerm');
			}
			hConf.addColumnList([
				new ListColumn('date', ['date'], true),
				new ListColumn('user', ['user'], true),
				new ListColumn('event', ['event'], true),
				new ListColumn('channel', ['yt_channel'], true),
				new ListColumn('note', ['note']),
				new ListColumn('options', ['option'])
			]);

			const hList = createLicensingActivityList(hConf);
			hList.generatePage($j('#hard-whitelist-list'));

			const hListItems = [];
			const hListParams = { count: 1000, page: 0, perPage: 1000, pageVars: 'hlist=1' + (searchTerm ? '&hardListSearchTerm=' + searchTerm : '') };
			hListItems.push(hListParams);
			_.each(r.data, (channel) => {
				const channelAction = Number(channel.removed) !== 1 ? 'Remove' : 'Add';
				const updatedChannel = {
					id: 'h-' + channel.channel_id,
					date: channel.date,
					user: channel.note.user_name || channel.username,
					event: channel.note.action,
					yt_channel: '<a target="_blank" href="https://www.youtube.com/channel/' + channel.channel_id + '">' + (channel.channel_name || channel.channel_id) + ' <i class="fa fa-external-link"></i></a>',
					note: channel.note.message ? channel.note.message : '-',
					option: '<a data-history="' + channel.channel_id + '" class="view-history">» View History</a>'
						+ '<a data-' + channelAction.toLowerCase() + '="' + channel.channel_id + '" class="' + channelAction.toLowerCase() + '-hard-channel">» ' + channelAction + ' channel</a>'
				};

				hListItems.push(updatedChannel);
			});

			hList.setData(
				hListItems, 
				params => false, 
				params => false
			);

			// list interaction events
			$j('#hard-whitelist-list').on('click', 'a.view-history', function () {
				const channel = $j(this).data('history');
				console.log('- get channel history:', channel);
				sa.api.request({
					handler: 'content-id/whitelists',
					action: 'getHistory',
					postData: { channelId: channel }
				}).then(displayHistoryFB);
			});

			$j('#hard-whitelist-list').on('click', 'a.remove-hard-channel', function () {
				const channelId = $j(this).data('remove');
				return displayActionFB('remove', channelId);
			});

			$j('#hard-whitelist-list').on('click', 'a.add-hard-channel', function () {
				const channelId = $j(this).data('add');
				return displayActionFB('add', channelId);
			});

			// list interaction controllers

			/** creates a focus box containing a channel's history
			 * @param {json} r response data from Whitelisthandler::getHistory()
			 * @returns focusBox
			 */
			let historyContainer = $j('#hard-whitelist-history');
			function displayHistoryFB(r, cont= historyContainer) {
				cont.empty();
				var table;
				if (!r.data.length) {
					table = '<div class="">No further history found.</div>';
				} else {
					table = '<table class="sa_table"><caption>Channel History</caption>';
					table += '<tr class="header">' + '<th>Date</th>' + '<th>Action</th>' + '<th>User</th>' + '<th>Note</th>' + '</tr>';
					for (let row of r.data) {
						table += '<tr class="stripe"><td>' + formatDate(config.dateTimeFormatString, row.date) + '</td>';
						table += '<td>' + row.note.action + '</td>';
						table += '<td>' + row.note.user_name + '</td>';
						table += '<td>' + (row.note.message ? row.note.message : '-') + '</td></tr>';
					}
					table += '</table>';
				}
				let fb = new FocusBox(cont.html(table));
				return fb.show();
			}

			/** creates a focus box to handle channel list item add/remove actions
			 * @param {string} action requested action (add/remove)
			 * @param {string} channel the requested channel's youtube channel ID
			 * @returns focusBox
			 */
			let actionContainer = $j('#hard-whitelist-actionFB');
			function displayActionFB (action = 0, channel = 0, cont = actionContainer) {
				cont.empty();
				var content;
				if (!action || !channel) {
					content = '<div class="error">Error processing request. Please try again.</div>'
				} else {
					var rerelease = action != 'add' ? '' : '<br/><input id="rerelease-claims" type="checkbox" checked /><label for="rerelease-claims">Release existing channel claims.</label>';
					content =
						` <div id="text_container">
							Are you sure you want to ${action} this channel? <br/><br/>
							<textarea maxlength="180" type="text" id="channel-note" placeholder="note (optional)"></textarea>
							${rerelease}
						</div>
						<div class="confirm_buttons">
							<a class="button confirm_yes" id="confirm-h-whitelist" data-channel="${channel}" data-action="${action}">${action}</a>
							<a class="button deemphasized confirm_no" id="cancel-h-whitelist">Cancel</a>
						</div>`;
				}
				var fb = new FocusBox(cont.html(content));
				fb.show();

				$j('#cancel-h-whitelist').on('click', function () {if (fb) fb.hide();});
				$j('#confirm-h-whitelist').on('click', function () {
					if (fb) fb.hide();
					hList.showCover('', 'Processing...');
					var params 		 = page.vars || {};
					params.channelId = $j(this).data('channel');
					params.action 	 = $j(this).data('action');
					params.note 	 = $j('#channel-note').val().replace(/<(|\/|[^>\/bi]|\/[^>bi]|[^\/>][^>]+|\/[^>][^>]+)>/g, '');
					console.log(`- ${params.action} hard whitelist channel: ${params.channelId}`);
					var reReleaseClaims = params.action != 'add' ? 0 : $j('#rerelease-claims').prop("checked") ? 1 : 0;
					sa.api.request({
						handler: 'content-id/whitelists',
						action: params.action,
						postData: params
					}).then(function (r) {
						hList.hideCover();

						let actionDesc = r.removed != 1 ? 'Added' : 'Removed';
						sa.notify({ text: `${actionDesc} channel!`, type: sa.notify.notificationTypes.success });

						if (reReleaseClaims) {
							page.releaseHistoricalClaims(r.channel_id, 1);
						} else {
							return sa.router.reloadPage();
						}

					}).catch(function (e) {
						hList.hideCover();
						console.log('SA-API Error:', e);
						var alertMsg = e ? e.message : 'Processing error!';
						sa.alert(alertMsg);
					});
				});
			}

			function addHardWhitelist() {
				hList.showCover('', 'Processing...');
				var params = page.vars || {};
				var channel = $j('#add-hard-channel-id').val().replace(/<(|\/|[^>\/bi]|\/[^>bi]|[^\/>][^>]+|\/[^>][^>]+)>/g, '');
				var note = $j('#add-hard-channel-note').val().replace(/<(|\/|[^>\/bi]|\/[^>bi]|[^\/>][^>]+|\/[^>][^>]+)>/g, '');
				var releaseHardClaims = $j('#release-hard-claims').prop("checked") ? 1 : 0;
				params.note = note;
				params.channelId = channel;
				if (!params.channelId) return sa.error('Please include a channel.');
				sa.api.request({
					handler: 'content-id/whitelists',
					action: 'add',
					postData: params
				}).then(function (r) {
					hList.hideCover();

					let actionDesc = r.removed != 1 ? 'Added' : 'Removed';
					sa.notify({ text: `${actionDesc} channel!`, type: sa.notify.notificationTypes.success });

					if (releaseHardClaims) {
						page.releaseHistoricalClaims(r.channel_id, 1);
					} else {
						return sa.router.reloadPage();
					}
				}).catch(function (e) {
					hList.hideCover();
					var alertMsg = e ? e.message : 'Processing error!';
					sa.alert(alertMsg);
					console.log('SA-API Error:', e);
				});
			};
		};
	};

}
/**
 * The page in the admin panel that lets you view and manage your licensing and e-commerce options
 */
function AdminDatasetLicensing() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Pando)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Add-Ons and Programs' + '" permission.</h3>');
		}
		if (!$j('.right_body.sad').length) {
			var callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [
					new RightTab('home', '/admin?p=dataset_licensing&tab=home', 'Home', callback)
				];
			RightTabbedPage.prototype.show.call(this, 'dataset_licensing', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'home';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			//if (pageId == 'home') {
				currentPage = new AdminDatasetLicensingHome();
			//}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminDatasetLicensing.prototype = new RightTabbedPage();

function AdminDatasetLicensingHome() {

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		// hide the tab bar
		$j('#rtp_nav').hide();

		// show the collect module
		sa.showAdminProgram(sa.AdminProgram.DatasetLicensing, container);
	};

}
/**
 * The page in the admin panel that let you sign up for DSP distribution with TooLost
 */
function AdminTooLost() {
	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		container.html(`
			<div class="section" style="line-height: inherit">
				<p>
					At SourceAudio, our mission is to continually provide top-tier services that meet the evolving needs of our clients. 
					After a thorough review and careful consideration, we have made the difficult decision to discontinue support for the Free DSP Distribution service that was previously available here.
				</p>
				
				<p>
					If you used it previously, our support team will be in touch soon. Please check your email for details.
				</p>
				
				<p>
					We remain steadfast in our commitment to finding new ways to maximize revenue opportunities for your content, and you will continue to be the first to hear about new monetization opportunities as they develop. 
					We value your partnership and thank you for being a key member of the SourceAudio family.
				</p>
			</div>
		`.trim());
	};
}
/**
 * The page in the admin panel that lets you manipulate your site's settings
 */
function AdminCustomPages() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.CustomPages)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Edit Home Page/Custom Pages' + '" permission.</h3>');
		} else if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		if (!$j('.right_body .metadata').length) {
			const hrefBase = siteBaseUrl();
			const callback = (tabId, cont) => {
				page.setPage(tabId, cont);
			};
			
			const tabs = [
				new RightTab('homemaker', `${hrefBase}/admin?p=custom_pages&tab=homemaker`, 'Home Maker', callback),
				new RightTab('custom', `${hrefBase}/admin?p=custom_pages&tab=custom`, 'Custom Pages', callback),
				new RightTab('blog', `${hrefBase}/admin?p=custom_pages&tab=blog`, 'Blog', callback)
			];
			
			RightTabbedPage.prototype.show.call(this, 'custom_pages', container, tabs, '');
		}
		
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'homemaker';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			switch (pageId) {
				case 'custom':
					currentPage = new AdminCustomPagesCustomPages();
					break;
				case 'blog':
					currentPage = new AdminBlogPage();
					break;
				case 'homemaker':
				default:
					currentPage = new AdminCustomPagesHomeMaker();
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminCustomPages.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you manage custom pages
 */
function AdminCustomPagesCustomPages() {

	var page = this;
	var templates;
	var container;

	var customPages = [];

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} cont
	 */
	this.show = function(params, cont) {

		if (!templates) {
			templates = sa.templates.get('admin.custom_pages.custom_pages');
		}

		container = cont;
		container.empty().append(templates.get('page'));
		loadCustomPages();
	};

	/**
	 * Loads the current custom fields from the server
	 */
	function loadCustomPages() {
		ajax('p=custom_page&action=list', function(newCustomPages) {
			var customsList = $j('#custom_list').removeClass('empty');
			customsList.find('.item').remove();
			customPages = newCustomPages;
			if (!customPages.length) {
				customsList.addClass('empty').append(templates.get('empty_row'));
			} else {
				customPages.each(function(i, custom) {
					var tr = templates.get('row', {
						baseUrl: siteBaseUrl(),
						id : custom.id, 
						title : custom.title 
					});
					tr.find('#edit').on('click', function() {
						ajax('p=custom_page&pageId=' + custom.id, function(response) { displayEditInterface(response[0]); });
					});
					tr.find('#delete').on('click', function() {
						sa.confirm({
							text : 'Are you sure you want to delete the "' + custom.title + '" page? All its data will be permanently removed.',
							yesFunction : function() {
								ajax('pageId=' + custom.id, function() { loadCustomPages(); }, 'POST', 'p=custom_page&action=delete');
							},
							yesText : 'Delete'
						});
					});
					customsList.append(tr);
				});
			}
			customsList.find('.item:odd').addClass('stripe');

			container.find('#new_custom .button').off('click').on('click', function() {
				sa.prompt({
					text : 'Enter a title for your new custom page',
					yesText : 'Create',
					noText : 'Cancel',
					placeholder : 'Page title',
					yesFunction : function(newTitle, interactionOptions) {
						// make sure value is set and that it's not in the list
						if (newTitle == '') {
							interactionOptions.showError('Please enter a title');
							return true;
						} else {
							for (var i = 0, len = customPages.length; i < len; i++) {
								if (customPages[i].title == newTitle) {
									interactionOptions.showError('You already have a custom page with this title');
									return true;
								}
							}
						}
						// show the error if there is one
						var information = $j('#new_custom .content');
						information.removeClass('error').html('Creating...');
						ajax({ title : newTitle }, function(response) {
							if (response[0].error) {
								information.removeClass('success').addClass('error').html(response[0].error);
								sa.alert({ text : response[0].error });
							} else {
								loadCustomPages();
								information.removeClass('error').addClass('success').html('Created!');
							}
						}, 'POST', 'p=custom_page&action=new');
					}
				})
			});
		});
	}

	/**
	 * Lets the user edit a custom page
	 * @param {object} custom the custom page to edit. has id, title, and body
	 */
	function displayEditInterface(custom) {
		var editContainer = templates.get('edit_interface');
		editContainer.find('#page_title').val(custom.title);
		editContainer.find('#custom_body').val(cleanCkeditorOutput(custom.body));
		if (custom.hideLeftNav) {
			editContainer.find('#hide_left_nav').prop('checked', true);
		}
		if (custom.removePadding) {
			editContainer.find('#remove_padding').prop('checked', true);
		}
		window['a'] = custom.body;
		editContainer.find('#save_changes').on('click', function() {
			ajax({
				pageId : custom.id,
				title : editContainer.find('input').val(),
				body : getWysiwygEditorContent('#custom_body'),
				hideLeftNav : editContainer.find('#hide_left_nav:checked').length,
				removePadding : editContainer.find('#remove_padding:checked').length
			}, function(response) {
				if (response[0].result != 'success') {
					sa.alert({ text : response[0].result });
				} else {
					sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
					page.show('', container);
					sa.scrollToElement(container);
				}
			}, 'POST', 'p=custom_page&action=edit');
		});
		editContainer.find('#cancel_changes').on('click', function() {
			sa.confirm({
				text : 'Are you sure you want to discard your changes?',
				yesFunction : function() {
					page.show('', container);
					sa.scrollToElement(container);
				},
				yesText : 'Discard'
			});
		});
		container.html('').append(editContainer);
		
		showWysiwygEditor('#custom_body');
		
	}

}
function AdminCustomPagesHomeMaker() {
	const page = this;
	let container = null;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} cont
	 */
	this.show = function (params, cont) {
		container = cont;
		container.html('Loading...');
		page.displayPage();
	};

	this.displayPage = function () {
		const baseUrl = siteBaseUrl();
		container.html(`
			<div id="homemaker-content">
				<div class="homemaker-title">Build Your Home Page</div>
				<br>
				<div class="homemaker-subtitle">
					In order to see your home page, you have to add the home page to your tabs <a href="${baseUrl}/admin?p=settings&tab=tabs">here</a>.<br><br>
					<a class="edit-home-page-button" href="${baseUrl}/home?editMode=true">Click here to edit your home page</a>.
				</div>
			</div>
		`);
	};
}
/**
 * The page in the admin panel that lets you manipulate the featured on your site
 */
function AdminFeatured() {

	var page = this;
	var templates;

	/**
	 * {string} the name of the tab we're showing
	 */
	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {

		if (!templates) {
			templates = sa.templates.get('admin.featured');
		}

		if (!user.hasAdminPermission(AdminPermission.Feature)) {
			container.empty().append(templates.get('permission_denied', { permission : user.getAdminPermissionDescription(AdminPermission.Feature) }));
			return;
		} else if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}

		if (!$j('.right_body .featured').length) {
			let featuredPage = this;
			let callback = function(tabId, cont) { featuredPage.setPage(tabId, cont); };
			let hrefBase = siteBaseUrl();
			let tabs = [
				new RightTab('tracks', hrefBase + '/admin?p=featured&tab=tracks', 'Tracks', callback),
				new RightTab('albums', hrefBase + '/admin?p=featured&tab=albums', config.getDictionaryEntry('album', true), callback),
				new RightTab('artists', hrefBase + '/admin?p=featured&tab=artists', config.getDictionaryEntry('artist', true), callback),
				new RightTab('labels', hrefBase + '/admin?p=featured&tab=labels', config.getDictionaryEntry('label', true), callback),
				new RightTab('writers', hrefBase + '/admin?p=featured&tab=writers', config.getDictionaryEntry('writer', true), callback),
				new RightTab('publishers', hrefBase + '/admin?p=featured&tab=publishers', config.getDictionaryEntry('publisher', true), callback)
			];
			if (!config.singleCatalog) {
				tabs.push(new RightTab('catalogs', hrefBase + '/admin?p=featured&tab=catalogs', config.getDictionaryEntry('catalog', true), callback));
			}
			if (typeof extraAdminTabs != 'undefined' && extraAdminTabs.featured) {
				var tab = extraAdminTabs.featured;
				tabs.push(new RightTab(tab.hash, hrefBase + '/admin?p=featured&tab=' + tab.hash, tab.title, callback));
			}
			tabs.push(new RightTab('projects', hrefBase + '/admin?p=featured&tab=projects', 'Playlist Collections', callback));
			RightTabbedPage.prototype.show.call(this, 'featured', container, tabs, '');
		}

		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'tracks';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (this.currentTab == pageId) {
			//this.currentPage.show(sa.router.getCurrentQueryParams());
			return;
		}
		if (typeof extraAdminTabs != 'undefined' && extraAdminTabs.featured.hash == pageId) {
			extraAdminTabs.featured.callback(container);
			return;
		}
		if (pageId == 'projects') {
			(new AdminFeaturedProjects()).show('', container);
			return;
		}
		this.currentTab = pageId;
		// and then if we found it, have it load based on the current params
		this.loadList(pageId, container);
	};

	/**
	 * Loads a featured list from the server
	 * @param {string} itemType the type of item to load
	 * @param {JQuery} container where to put the list after load
	 */
	this.loadList = function(itemType, container) {
		sa.api.request({
			handler : 'features',
			action : 'list',
			postData : { type : itemType }
		}).then(response => {
			page.setList(response, container);
		});
	};

	/**
	 * Handles the response from the server after requesting a list
	 * @param {JSON} response the server's response
	 * @param {JQuery} container where to put the list after load
	 */
	this.setList = function(response, container) {
		if (response.result != 'success') {
			sa.notify({ text : response.message });
			return;
		}

		// create the frame
		var template = templates.get('page', {
			displayTitleType : (page.currentTab === 'tracks' ? 'Title' : 'Name'
		)});

		// add the list items
		var list = template.find('#featured_list');
		var items = response.items;
		var len = items.length;

		if (!len) {
			// there weren't any featured items yet so display a message
			list.append(templates.get('empty', { type : page.currentTab }));
		} else {
			for (var i = 0; i < len; i++) {
				list.append(createListRow(items[i]));
			}
		}

		// lookup
		template.find('input').on('keyup', _.debounce((e) => {
			updateSearch(e.target.value);
		}, 750));

		// unfeature all button
		template.find('#unfeature_all .button').on('click', function() {
			sa.confirm({
				text : 'This will remove <b>all</b> featured items of this type. Are you sure?',
				yesText : 'Yes',
				noText : 'Cancel',
				yesFunction : function() {
					sa.api.request({
						handler : 'features',
						action : 'unfeatureAll',
						postData : { type : page.currentTab }
					}).then(response => {
						page.loadList(page.currentTab, container);
					});
				}
			});
		});

		container.empty().append(template);

		if (len) {
			reorder();
		}
	};

	/**
	 * Creates a row to appear in the featured list
	 * @param {object} item the item - should have item.id and item.name
	 * @return {JQuery} the row
	 */
	function createListRow(item) {
		var row = templates.get('row', { id : item.id, link : getItemLink(item), name : item.name });
		// interactive buttons need to be added manually
		row.find('.up').on('click', function (item) { return function() { move(item, -1); }; }(item));
		row.find('.down').on('click', function (item) { return function() { move(item, 1); }; }(item));
		row.find('.top').on('click', function (item) { return function() { move(item, 0); }; }(item));
		row.find('.remove span').on('click', function (item) { return function() { unfeature(item); }; }(item));
		return row;
	}

	/**
	 * Gets a link to an item, determining what the item is based on teh currentTab
	 * @param {object} item the item to link to
	 * @return {string} the link
	 */
	function getItemLink(item) {
		var cap = ucfirst(page.currentTab),
			funcName = 'get' + cap.substring(0, cap.length - 1) + 'Link';
		return window[funcName](item.id);
	}

	/**
	 * Moves an item in the list in a direction
	 * To prevent lag, items are moved on the UI and then moved on the server separately. This function does both
	 * @param {object} item should have item.id
	 * @param {int} direction 0 means put first in list, 1 means move down, -1 means move up
	 */
	function move(item, direction) {
		var row = $j('#item_' + item.id);
		// move the item
		if (direction == 0) {
			$j('#featured_list .header').after(row);
		} else if (direction == 1) {
			row.next('.item').after(row);
		} else {
			row.prev('.item').before(row);
		}
		reorder();
		// now update the server

		sa.api.request({
			handler : 'features',
			action : 'move',
			postData : {
				type : page.currentTab,
				direction : direction,
				id : item.id
			}
		});
	}

	/**
	 * Removes an item from the feature list
	 * @param {object} item should have item.id
	 */
	function unfeature(item) {
		// remove the item
		$j('#featured_list #item_' + item.id).remove();
		reorder();
		
		// now update the server
		sa.api.request({
			handler : 'features',
			action : 'unfeature',
			postData : {
				type : page.currentTab,
				id : item.id
			}
		});

		// Reset Search
		let search = $j('#lookup input').val();
		if (search) {
			updateSearch(search);
		}
	}

	/**
	 * Reapplies order numbers to the items and restripes
	 * 	Called after the list has been rearranged
	 */
	function reorder() {
		// restripe
		$j('#featured_list .item').removeClass('stripe');
		$j('#featured_list .item:odd').addClass('stripe');
		// reapply numbers
		var items = $j('.item .order');
		if (!items.length) {
			// the last item was removed
			$j('#featured_list').append(templates.get('empty', { type : page.currentTab }));
		} else {
			$j('#featured_list .empty').remove();
			for (var i = 0, len = items.length; i < len; i++) {
				items[i].innerHTML = i + 1;
			}
		}
	}

	/**
	 * Sends a request to the server to update the lookup list
	 * @param {string} searchVal the search val
	 */
	function updateSearch(searchVal) {
		sa.api.request({
			handler : 'features',
			action : 'search',
			postData : {
				type : page.currentTab,
				search : searchVal
			}
		}).then(response => {
			var results = $j('.tabbed_body .results').empty().append(templates.get('search_header'));
			if (!response.items.length) {
				results.append(templates.get('search_empty'));
			} else {
				for (var i = 0, len = response.items.length; i < len; i++) {
					var item = response.items[i];
					var row = templates.get('search_row', { id : item.id, name : item.name, link : getItemLink(item) });
					// interactive buttons need to be added manually
					row.find('.icon').on('click', function(item) { return function() {
						feature(item);
					}; }(item));
					
					results.append(row);
				}
				results.find('.item:odd').addClass('stripe');
			}
			results.removeClass('hidden');
		});
	}

	/**
	 * Features an item
	 * 	Adds the items on the server and in the list
	 * @param {object} item the item to add
	 */
	function feature(item) {
		// make sure this isn't already in the featured list. if it is, move it to the top
		if ($j('#featured_list #item_' + item.id).length) {
			move(item, 0);
			return;
		}
		
		// add on the client end
		$j('#featured_list .header').after(createListRow(item));
		reorder();
		
		$j('#item_' + item.id).remove();
		
		// add on the server end
		sa.api.request({
			handler : 'features',
			action : 'feature',
			postData : {
				type : page.currentTab,
				id : item.id
			}
		});
	}
}
AdminFeatured.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you manage your catalogs
 */
function AdminFeaturedProjects() {

	var page = this;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.featured');
		}
		container.empty().append(templates.get('project_page'));
		page.loadTabs();
	};

	/**
	 * Loads the list of tabs and shows them on the page
	 */
	this.loadTabs = async function () {
		const response = await sa.api.request({
			handler: 'projectTabs',
			action: 'list'
		});
		console.log(response);
		const tabs = response.items ?? [];

		const $tabList = $j('#tab_list');
		$tabList.find('.item').remove();
		const baseUrl = siteBaseUrl();


		// create the rows
		for (const tab of tabs) {
			const row = templates.get('project_row', { id: tab.id, name: tab.name, baseUrl: baseUrl });

			// add the site tabs
			const linkText = tab.siteTabName ? `<b>${tab.siteTabName}</b>` : 'Add Tab &raquo;';
			row.find('.tab-assignment').append(`<a href='${baseUrl}/admin?p=settings&tab=tabs'>${linkText}</a>`);

			// add option icons
			if (tab.id == 1) {
				row.find('.option').empty();
			}else{
				row.find('#edit').on('click', () => {
					sa.components.projector.generateProjectTabForm({
						tab: tab,
						onSave() {
							page.loadTabs()
						}
					});
				});
				row.find('#delete').on('click', () => {
					page.deleteTab(tab);
				});
			}
			$tabList.append(row);
		}

		// add stripes
		$tabList.find('.item:odd').addClass('stripe');

		// set up the "create new" box. we don't do this in show() because we want the list to match against
		$j('#new_tab .button').off().on('click', function () {
			sa.components.projector.generateProjectTabForm({
				onSave(){
					page.loadTabs()
				}
			});
		});
	};

	/**
	 * Deletes a tab after showing a popup to make sure the user is sure
	 * @param {object} tab the tab to delete. has id, name
	 */
	this.deleteTab = function(tab) {
		sa.confirm({
			text : 'Are you sure you want to delete the "' + tab.name + '" Collection?<br/><br/>Any playlists in this collection will move to the general Playlists collection.',
			yesFunction: () => {
				sa.api.request({
					handler: 'projectTabs',
					action: 'delete',
					postData: tab
				}).then(() => {
					sa.notify({ text: 'Tab deleted!', type: sa.notify.notificationTypes.success });
					page.loadTabs();

					// remove the tab from the site tabs if it's associated
					$j('#nav_playliststab' + tab.id).remove();
				}).catch((e) => {
					sa.alert({ text: e.message });
				});
			},
			yesText : 'Delete'
		});
	};
	
}
/**
 * The page in the admin panel that lets you set up file deliveries
 */
function AdminFileDelivery() {
	let page = this;
	let currentTab = '';
	let currentPage;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.FileDelivery)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Use the File Delivery Tool' + '" permission.</h3>');
		}
		if (!$j('.right_body.file_delivery').length) {
			var callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [
			        new RightTab('recipients', '/admin?p=file_delivery&tab=recipients', 'Third Parties', callback, config.grayLabel),
			        new RightTab('copy', '/admin?p=file_delivery&tab=copy', 'Agents', callback),
			        new RightTab('history', '/admin?p=file_delivery&tab=history', 'History', callback),
			        new RightTab('purchases', '/admin?p=file_delivery&tab=purchases', 'Transfer Purchases', callback, config.grayLabel)
				];
			RightTabbedPage.prototype.show.call(this, 'file_delivery', container, tabs, '');
			$j('h2.title').append('<a class="read_about" href="https://docs.sourceaudio.com/administration/downloading.html#File-Transfer" target="_blank">Read about this feature</a>');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) {
			if (config.grayLabel) {
				vars.tab = 'copy';
			} else {
				vars.tab = 'recipients';
			}
		}
		this.setTab(vars.tab);
	};
	
	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			if (pageId == 'history') {
				currentPage = new AdminFileDeliveryHistory();
			} else if (pageId == 'purchases') {
				currentPage = new AdminFileDeliveryPurchases()
			} else if (pageId == 'copy') {
				currentPage = new AdminFileDeliveryCopy();
			} else {
				currentPage = new AdminFileDeliveryRecipients();
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminFileDelivery.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you set up copies to other sites
 */
function AdminFileDeliveryCopy() {

	var page = this,
		templates = sa.templates.get('admin.file_delivery.copy');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		createBaseContainer(container);

		listRecipients(container);
	};

	function createBaseContainer(container) {
		container.empty().append(templates.get('page')).addClass('file_delivery_copy');
	}


	//////////////////////////////////////////
	// Recipient List Functions
	//////////////////////////////////////////

	function listRecipients(baseContainer) {
		var container = baseContainer.find('#recipients');
		ajax({ p : 'copy', action : 'list_recipients' }, function(currentRecipients) {
			if (!currentRecipients.length) {
				container.empty().append(templates.get('no_recipients'));
			} else {
				var template = templates.get('recipient_list');

				// add the recipients
				var baseItem = template.find('.recipient');
				for (var i = 0, len = currentRecipients.length; i < len; i++) {
					var item = baseItem.clone(),
						recipient = currentRecipients[i];
					item.find('input').val(recipient.id);
					item.find('.name').html(htmlEncode(recipient.name)).attr('title', htmlEncode(recipient.name));
					item.on('mouseup', function() {
						updateSelectedRecipients();
					});
					baseItem.after(item);
				}
				baseItem.remove();

				// called when the user clicks a recipient. sets the selected state for the recipients and shows the track selector
				function updateSelectedRecipients() {
					console.log('update select');
					setTimeout(function() {
						$j('.recipient').removeClass('selected');
						$j('.recipient input:checked').parents('.recipient').addClass('selected');
						var formResults = sa.forms.validate(template).values;
						showTrackSelector(baseContainer, formResults.recipientIds);
					}, 10); // give the input box time to actually select
				}

				container.empty().append(template);
			}
			if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				// delete button for current recipients
				if (currentRecipients.length) {
					container.find('.recipients').append('<a class="button remove_button">Remove Selected</a>');
					container.find('.remove_button').on('click', function() {
						var removeRecipientIds = sa.forms.validate(container).values;
						ajax(removeRecipientIds, function(response) {
							listRecipients(baseContainer);
							showTrackSelector(baseContainer, []);
						}, 'POST', { p : 'copy', action : 'remove_recipients' });
						return false;
					});
				}
				// add new recipients
				ajax({ p : 'copy', action : 'list_new_recipients' }, function(potentialRecipients) {
					container.append(templates.get('new_recipient'));
					var select = container.find('.new_recipient select');
					for (var i = 0, len = potentialRecipients.length; i < len; i++) {
						var recipient = potentialRecipients[i];
						select.append('<option value="' + recipient.id + '">' + htmlEncode(recipient.name) + '</option>');
					}
					container.find('.new_recipient a').on('click', function() {
						ajax({ id : container.find('.new_recipient select').val() }, function(response) {
							listRecipients(baseContainer);
							showTrackSelector(baseContainer, []);
						}, 'POST', { p : 'copy', action : 'add_new_recipient' });
					});
				});
			}
		});
	}


	//////////////////////////////////////////
	// Track Selection functions
	//////////////////////////////////////////

	function resetPage(baseContainer) {
		selectionHierarchy = null;
		recentAlbums = null;
		currentSelectionState = { catalogs : {}, labels : {}, albums : {} };
		selectedCatalogId = 0;
		selectedLabelId = 0;
		page.show('', baseContainer);
	}

	var selectionHierarchy,
		recentAlbums,
		currentSelectionState = { catalogs : {}, labels : {}, albums : {} },
		selectedCatalogId = 0,
		selectedLabelId = 0;
	function showTrackSelector(baseContainer, recipientIds) {
		var container = baseContainer.find('#select_tracks');

		if (!recipientIds || !recipientIds.length) {
			showMessageInput(baseContainer, recipientIds, currentSelectionState, false);
			return container.html('');
		}

		container.empty().append(templates.get('track_selector'));

		// switching between selector types
		container.find('.select_type').on('click', function() {
			var t = $j(this),
				val = t.find('input').val();
			container.find('.select_type').removeClass('selected');
			t.addClass('selected');
			selectedCatalogId = 0;
			selectedLabelId = 0;
			container.find('.selector_type').hide();
			container.find('.selector_type#select_' + val).show();

			if (val == 'recent') {
				updateRecentState();
			}
		});

		if (config.watermarked) {
			container.find('.watermarking_disabled').remove();
		} else {
			container.find('.watermarking_enabled').remove();
		}

		// load the recent data
		function populateRecentAlbums() {
			var recentAlbumList = container.find('#recent_albums ul').empty();
			for (var i = 0, len = recentAlbums.length; i < len; i++) {
				var album = recentAlbums[i],
					item = templates.get('recent_album');
				item.find('.item_name').html(htmlEncode(album.name) + ' (' + formatDate(config.dateFormatString, album.releaseDate) + ')');
				item.attr('id', 'album_' + album.id);
				(function(album, item) {
					item.find('input').on('click', function() {
						selectedCatalogId = album.catalogId;
						selectedLabelId = album.labelId;
						updateSelectionState('album', album.id, this.checked);
					});
				})(album, item);
				if (currentSelectionState['albums'][album.id] == 1) {
					item.find('input').prop('checked', true);
				}

				recentAlbumList.append(item);
			}
		}
		if (!recentAlbums) {
			ajax({ p : 'copy', action : 'list_recent_albums' }, function(response) {
				recentAlbums = response;
				populateRecentAlbums();
			});
		} else {
			populateRecentAlbums();
		}


		// recent state auto syncs to hierarchy but not the other way around
		function updateRecentState() {
			window['currentSelectionState'] = currentSelectionState;
			window['recentAlbums'] = recentAlbums;
			container.find('#recent_albums input').prop('checked', false);
			for (var i = 0, len = recentAlbums.length; i < len; i++) {
				var albumId = parseInt(recentAlbums[i].id);
				console.log('checking', albumId, 'and found', currentSelectionState['albums'][albumId]);
				if (currentSelectionState['albums'][albumId] == 1) {
					container.find('#recent_albums #album_' + albumId + ' input').prop('checked', true);
				}
			}
		}

		// load the hierarchy data
		function populateCatalogHierarchy() {
			cleanSelectionState();
			// sort the catalogs
			var sortedCatalogs = [];
			for (var catalogId in selectionHierarchy) {
				if (!selectionHierarchy.hasOwnProperty(catalogId)) continue;
				selectionHierarchy[catalogId].id = catalogId;
				sortedCatalogs.push(selectionHierarchy[catalogId]);
			}
			sortedCatalogs.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			var catalogContainer = container.find('#catalogs ul');
			for (var c = 0, cLen = sortedCatalogs.length; c < cLen; c++) {
				var cat = sortedCatalogs[c];
				addSelectionItem(catalogContainer, 'catalog', cat.id, cat.name);
			}
		}
		if (!selectionHierarchy) {
			sa.api.request({
				handler : 'permission-profiles',
				action : 'getCatalogHierarchy',
			}).then(response => {
				selectionHierarchy = response;
				populateCatalogHierarchy();
			}).catch(err => {
				sa.alert(err.message);
			});
		} else {
			populateCatalogHierarchy();
		}

		// terminology
		container.find('#catalogs .title').html(gde('catalog', { plural : true }));
		container.find('#labels .title').html(gde('label', { plural : true }));
		container.find('#albums .title').html(gde('album', { plural : true }));

		// change detection is handled in updateSelectionState
		page.handleSelectionStateChange = function(currentSelectionState, allowNextStep) {
			if (!allowNextStep) { // just because you didn't click something on (allowNextStep's passed in state) doesn't mean there's nothing selected
				for (var i in currentSelectionState.albums) {
					if (currentSelectionState.albums.hasOwnProperty(i) && currentSelectionState.albums[i] === 1) {
						allowNextStep = true;
						break;
					}
				}
			}
			showMessageInput(baseContainer, recipientIds, currentSelectionState, allowNextStep);
		};
		page.handleSelectionStateChange({ albums : {} }, false);
	}

	/**
	 * Adds a single item to the profile option selection columns
	 * @param {JQuery} container the list to which the item should be added
	 * @param {string} itemType the type of item we're adding (catalog|label|album)
	 * @param {int} itemId the id of the item we're adding
	 * @param {string} itemName the name to display as the item's label
	 */
	function addSelectionItem(container, itemType, itemId, itemName) {
		var item = templates.get('selection_item');
		item.find('.item_name').html(htmlEncode(itemName));
		item.attr('id', itemType + '_' + itemId);
		if (itemType == 'album') {
			item.find('.expander').remove();
		}
		item.find('input').on('click', function() {
			updateSelectionState(itemType, itemId, this.checked);
		});
		item.find('.expander').on('click', function() {
			item.parent().find('.selected').removeClass('selected');
			item.addClass('selected');
			expandSelectionItem(itemType, itemId);
		});
		if (currentSelectionState[itemType + 's'][itemId] == 1) {
			item.find('input').prop('checked', true);
		}

		container.append(item);

		if (itemType == 'label') {
			determineSelectionLabelState(selectedCatalogId, itemId);
			determineSelectionCatalogState(selectedCatalogId);
		} else if (itemType == 'catalog') {
			determineSelectionCatalogState(itemId);
		}
	}

	/**
	 * Saves the state of the current item into the cache and updates any descendent items
	 * @param {string} itemType (catalog|label|album)
	 * @param {int} itemId the id of the item in question
	 * @param {boolean} allow are we allowing the user to do stateType with this item or not?
	 */
	function updateSelectionState(itemType, itemId, allow) {
		if (allow) {
			currentSelectionState[itemType + 's'][itemId] = 1;
		} else {
			currentSelectionState[itemType + 's'][itemId] = 0;
		}
		var albums, labelId, albumId;
		// need to propagate changes to subelements
		if (itemType == 'catalog') {
			var labels = selectionHierarchy[itemId].labels;
			for (labelId in labels) {
				if (!labels.hasOwnProperty(labelId)) continue;
				// hit the checkboxes if they're there
				$j('#label_' + labelId + ' input').prop('checked', allow);
				
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				currentSelectionState['labels'][labelId] = allow ? 1 : 0;
				// now we need to update the albums for this label
				albums = labels[labelId].albums;
				for (albumId in albums) {
					if (!albums.hasOwnProperty(albumId)) continue;
					// hit the checkboxes if they're there
					$j('#album_' + albumId + ' input').prop('checked', allow);
					// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
					currentSelectionState['albums'][albumId] = allow ? 1 : 0;
				}
			}
			determineSelectionCatalogState(itemId);
			// update label states if we're showing this catalog
			if (selectedCatalogId == itemId) {
				for (labelId in labels) {
					if (!labels.hasOwnProperty(labelId)) continue;
					determineSelectionLabelState(itemId, labelId);
				}
			}
		} else if (itemType == 'label') {
			// we have to find the label in question
			albums = selectionHierarchy[selectedCatalogId].labels[itemId].albums;
			for (albumId in albums) {
				if (!albums.hasOwnProperty(albumId)) continue;
				// hit the checkboxes if they're there
				$j('#album_' + albumId + ' input').prop('checked', allow);
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				currentSelectionState['albums'][albumId] = allow ? 1 : 0;
			}
			determineSelectionLabelState(selectedCatalogId, itemId);
			determineSelectionCatalogState(selectedCatalogId);
		} else if (itemType == 'album') {
			determineSelectionLabelState(selectedCatalogId, selectedLabelId);
			determineSelectionCatalogState(selectedCatalogId);
		}
		window['ps'] = currentSelectionState;

		// update next step in copy process
		page.handleSelectionStateChange(currentSelectionState, allow);
	}

	/**
	 * Updates a specific catalog's display so it shows the correct number of labels and albums
	 * @param {int} catalogId the id of the catalog
	 */
	function determineSelectionCatalogState(catalogId) {
		// now we need to update the label's catalog to partial status based on the state of the labels within it
		var labels = selectionHierarchy[catalogId].labels,
			labelTotal = 0,
			labelChecked = 0,
			albumTotal = 0,
			albumChecked = 0,
			albums;
		for (var labelId in labels) {
			if (!labels.hasOwnProperty(labelId)) continue;
			if (currentSelectionState.labels[labelId] == 1) labelChecked++;
			labelTotal++;
			albums = labels[labelId].albums;
			for (var albumId in albums) {
				if (!albums.hasOwnProperty(albumId)) continue;
				if (currentSelectionState.albums[albumId] == 1) albumChecked++;
				albumTotal++;
			}
		}
		$j('#catalog_' + catalogId + ' input').parent().find('span').html('(' + labelChecked + '/' + labelTotal + ') (' + albumChecked + '/' + albumTotal + ')');
		currentSelectionState.catalogs[catalogId] = (albumChecked + labelChecked == 0 ? 0 : (albumChecked < albumTotal || labelChecked < labelTotal) ? 2 : 1);
		if (labelChecked == labelTotal && labelTotal != 0) {
			$j('#catalog_' + catalogId + ' input').prop('checked', true);
		} else {
			$j('#catalog_' + catalogId + ' input').prop('checked', false);
		}
	}

	/**
	 * Updates a specific label's display so it shows the correct number of albums
	 * @param {int} catalogId the id of the label's catalog
	 * @param {int} labelId the id of the label itself
	 */
	function determineSelectionLabelState(catalogId, labelId) {
		// now we need to update the label to partial status based on the state of the albums within it
		var albums = selectionHierarchy[catalogId].labels[labelId].albums,
			total = 0,
			checked = 0;
		for (var albumId in albums) {
			if (!albums.hasOwnProperty(albumId)) continue;
			if (currentSelectionState.albums[albumId] == 1) checked++;
			total++;
		}
		$j('#label_' + labelId + ' input').parent().find('span').html('(' + checked + '/' + total + ')');
		currentSelectionState.labels[labelId] = (checked == 0 ? 0 : (checked < total) ? 2 : 1);
		if (checked == total && total != 0) {
			$j('#label_' + labelId + ' input').prop('checked', true);
		} else {
			$j('#label_' + labelId + ' input').prop('checked', false);
		}
	}

	/**
	 * Makes sure items are hierarchically excluded, meaning that if a catalog is excluded, all its labels and albums are
	 *  Saving will enforce this naturally but if an album is added through nefarious means, such as when adding a track, it won't get an exclusion row
	 *  if it's in an excluded label. That doesn't matter on most of the site but this interface requires those rows exist. We need to make sure that those albums are excluded here.
	 */
	function cleanSelectionState() {
		// go through each catalog in the hierarchy
		for (var catalogId in selectionHierarchy) {
			if (!selectionHierarchy.hasOwnProperty(catalogId)) continue;
			var catalog = selectionHierarchy[catalogId];
			// see if the entire catalog is excluded
			var labelId, lab, albumId;
			if (currentSelectionState.catalogs[catalogId] === 0) {
				// make sure all sub-items are excluded
				for (labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					lab = catalog.labels[labelId];
					currentSelectionState.labels[labelId] = 0;
					for (albumId in lab.albums) {
						if (!lab.albums.hasOwnProperty(albumId)) continue;
						currentSelectionState.albums[albumId] = 0;
					}
				}
			} else {
				// check the labels
				for (labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					if (currentSelectionState.labels[labelId] === 0) {
						// label is excluded. make sure albums are too
						lab = catalog.labels[labelId];
						for (albumId in lab.albums) {
							if (!lab.albums.hasOwnProperty(albumId)) continue;
							currentSelectionState.albums[albumId] = 0;
						}
					}
				}
			}
		}
	}

	/**
	 * Shows descendents of itemId, potentially loading them off the server
	 * @param {string} itemType (catalog|label). albums have no descendents we care about
	 * @param {int} itemId the id of the item whose descendents we're interested in
	 */
	function expandSelectionItem(itemType, itemId) {
		var newType = (itemType == 'catalog' ? 'label' : 'album'),
			cont = $j('.selector#' + newType + 's ul');
		var sorted, id, c, cLen;
		cont.find('li').remove();
		if (itemType == 'catalog') {
			selectedCatalogId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var labels = selectionHierarchy[itemId].labels;
			// sort
			sorted = [];
			for (id in labels) {
				if (!labels.hasOwnProperty(id)) continue;
				labels[id].id = id;
				sorted.push(labels[id]);
			}
			sorted.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			for (c = 0, cLen = sorted.length; c < cLen; c++) {
				var lab = sorted[c];
				addSelectionItem(cont, newType, lab.id, lab.name);
			}
			// we have to empty the albums if this changes
			$j('.selector#albums ul').find('li').remove().end().append('<li class="empty">Select a label to see albums</li>');
		} else {
			selectedLabelId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var albums = selectionHierarchy[selectedCatalogId].labels[itemId].albums;
			// sort
			sorted = [];
			for (id in albums) {
				if (!albums.hasOwnProperty(id)) continue;
				sorted.push({ name : albums[id], id : id });
			}
			sorted.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			for (c = 0, cLen = sorted.length; c < cLen; c++) {
				var alb = sorted[c];
				addSelectionItem(cont, newType, alb.id, alb.name);
			}
		}
	}


	///////////////////////////////////
	// Message Input Functions
	///////////////////////////////////

	function showMessageInput(baseContainer, recipientIds, currentSelectionState, allowNextStep) {
		var container = baseContainer.find('#message');

		if (!allowNextStep) {
			return container.html('');
		}

		container.empty().append(templates.get('message_input'));

		container.find('.send_button').on('click', function() {
			var details = {
				recipientIds : recipientIds,
				selectionState : currentSelectionState,
				watermarked : baseContainer.find('input[name=watermarked]:checked').length,
				message : container.find('textarea').val()
			};
			ajax(details, function(response) {
				if (response[0].success) {
					resetPage(baseContainer);
					sa.notify({ text : 'Sent ' + response[0].albumCount.numberFormat() + ' albums to ' + response[0].recipientCount + ' recipient(s).', type : sa.notify.notificationTypes.success });
				} else {
					sa.notify({ text : 'Error sending tracks: ' + response[0].message });
				}
			}, 'POST', { p : 'copy', action : 'send' });
		});
	}

}
/**
 * The page in the admin panel that lets you check the status of your previous deliveries
 */
function AdminFileDeliveryHistory() {
	
	var templates = sa.templates.get('admin.file_delivery.history');
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param container
	 */
	this.show = function(params, container) {
		container.html('');
		
		let vars = sa.router.paramsToVars(sa.router.getCurrentQueryParams());
		if (vars.type === 'copy') {
			listCopies(container);
		} else {
			listDeliveries(container);
		}
	};
	
	function listDeliveries(container) {
		var template = templates.get('file_delivery_page');
		let deliveryTemplate = template.find('.delivery:first').clone();
		
		// make the selects work
		function getFilters() {
			var filters = template.find('.filters select'),
				vars = {};
			for (var i = 0, len = filters.length; i < len; i++) {
				var filter = filters[i];
				vars[filter.name] = filter.value;
			}
			return vars;
		}
		template.find('select').on('change', function() {
			loadDeliveries(getFilters());
		});
		
		// load the recipients
		ajax('p=file_delivery&action=list_recipients', function(response) {
			var recipientSelect = template.find('select[name=recipient]');
			response.reverse();
			for (var i = 0, len = response.length; i < len; i++) {
				var recipient = response[i];
				recipientSelect.append('<option value="' + recipient.id + '">' + htmlEncode(recipient.name) + '</option>');
			}
		});
		
		// load the deliveries
		var progressVars,
			progressKey = 'file_delivery_history_progress_' + new Date().getTime();
		template.addClass(progressKey);
		function loadDeliveries(vars) {
			stopProgressCheck();
			if (!vars) vars = {};
			vars.p = 'file_delivery';
			vars.action = 'list_deliveries';
			progressVars = vars;
			showLoader(template.find('.deliveries'), 'Loading deliveries...');
			ajax(vars, function(response) {
				var deliveriesContainer = template.find('.deliveries');
				deliveriesContainer.empty();
				
				var paginationDetails = response.shift();
				for (var i = 0, len = response.length; i < len; i++) {
					var deliveryDetails = response[i],
						delivery = deliveryTemplate.clone();
					
					delivery.attr('id', 'delivery_' + deliveryDetails.delivery_id);
					delivery.find('.recipient_name').html(htmlEncode(deliveryDetails.name));
					delivery.find('.sender').html(htmlEncode(deliveryDetails.sender));
					delivery.find('.date').html(formatDate(config.dateTimeFormatString, deliveryDetails['date_sent']));
					if (deliveryDetails.metadata_only == '1') {
						delivery.find('.files, .art').hide();
					} else {
						var formats = [];
						if (deliveryDetails.formats.indexOf('m') != -1) formats.push('mp3');
						if (deliveryDetails.formats.indexOf('a') != -1) formats.push('aiff');
						if (deliveryDetails.formats.indexOf('w') != -1) formats.push('wav');
						delivery.find('.file_count').html(deliveryDetails['transfer_details']['fileCount'].numberFormat());
						delivery.find('.formats').html(formats.join(', '));
					}
					if (deliveryDetails.metadata_format == 'none') {
						delivery.find('.metadata').hide();
					}
					if (deliveryDetails.album_art == '0') {
						delivery.find('.art').hide();
					}
					if (deliveryDetails['transfer_billed'] != '0') {
						var amount = deliveryDetails['transfer_billed'];
						delivery.find('.transfer_billed').html(amount.numberFormat())
							.attr('title', amount.numberFormat() + ' B\n' + (amount / 1024).numberFormat(2) + ' KB\n' + (amount / 1024 / 1024).numberFormat(2) + ' MB\n' + (amount / 1024 / 1024 / 1024).numberFormat(2) + ' GB\n');
					} else {
						delivery.find('.transfer_billed_container').remove();
					}
					
					var downloadList = delivery.find('.download_list');
					var noDownloads = downloadList.find('.none').detach();
					var ipDownload = downloadList.find('.ip_download').detach();
					var userDownload = downloadList.find('.user_download').detach();
					if (!deliveryDetails.downloads.length) {
						downloadList.append(noDownloads);
					} else {
						deliveryDetails.downloads.each(function(i, download) {
							var downloadTemplate;
							if (download.user) {
								downloadTemplate = userDownload.clone();
								downloadTemplate.find('.username').html(htmlEncode(download.user.username));
								downloadTemplate.find('.useremail').html(htmlEncode(download.user.email));
								downloadTemplate.find('.user_link').attr('href', '/admin?p=users&tab=edit&user=' + download.user.id);
							} else {
								downloadTemplate = ipDownload.clone();
								downloadTemplate.find('.ip').html('A logged out user');
								downloadTemplate.find('.location').html(htmlEncode(download.location));
							}
							downloadTemplate.find('.count').html(download.downloads);
							downloadList.append(downloadTemplate);
						});
					}

					deliveriesContainer.append(delivery);
					
					if (deliveryDetails.status == 'f') {
						delivery.find('.ftp').show();
						delivery.find('.recipient').html(deliveryDetails.ftp_server);
						delivery.find('.type').html(deliveryDetails.ftp_type);
						delivery.find('.status_' + deliveryDetails.ftp_status).show();
						let resultsExportButton = delivery.find('.export_file_delivery_results');
						resultsExportButton.prop('href', resultsExportButton.prop('href') + deliveryDetails.delivery_id);
					} else if (deliveryDetails.status == 'e') {
						delivery.find('.email').show();
						delivery.find('.recipient').html(htmlEncode(deliveryDetails.recipient_email));
						delivery.find('.type').html('email');
					} else {
						delivery.find('.link').show();
						delivery.find('.type').html('link');
					}
				}

				sa.pagination.addPagination({
					container : deliveriesContainer,
					totalItems : paginationDetails.totalItems,
					perPage : paginationDetails.perPage,
					currentPage : paginationDetails.currentPage,
					callback : function(pageNumber) {
						var vars = getFilters();
						vars.page = pageNumber;
						loadDeliveries(vars);
						sa.scrollToElement(template);
					}
				});
				startProgressCheck();
			});
		}
		loadDeliveries();
		
		var deliveryStatuses = {};
		var progressInterval;
		function startProgressCheck() {
			if (progressInterval) return;
			progressInterval = setInterval(function () {
				if (!$j('.' + progressKey).length) {
					stopProgressCheck();
					return;
				}
				progressVars.action = 'get_history_progress';
				ajax(progressVars, function (response) {
					response.each(function (i, progress) {
						var deliveryId = progress.deliveryId;
						var delivery = template.find('#delivery_' + deliveryId);
						if (deliveryStatuses[deliveryId] && deliveryStatuses[deliveryId] == progress.status && progress.status != 'p') {
							// if the status hasn't changed and it's not a progress update, skip the update. nothing's changed
							return;
						}
						deliveryStatuses[deliveryId] = progress.status;

						delivery.find('.status').hide();
						delivery.find('.status_' + progress.status).show();

						if (progress.status == 'p') {
							if (progress.type == 'calculate') {
								delivery.find('.progress_text').html('Preparing delivery...');
								delivery.find('.progress_bar').css({ width : 0 });
							} else {
								delivery.find('.progress_text').html(progress.progress + '/' + progress.total + ' files transferred');
								delivery.find('.progress_bar').css({ width : (progress.progress / progress.total * 100) + '%' });
							}
						} else if (progress.status == 'e') {
							delivery.find('.message').html(progress.error);
							// retry button
							delivery.find('.retry').off().on('click', function () {
								$j(this).hide();
								sa.showCover('Retrying your delivery...');
								ajax({ p : 'file_delivery', action : 'retry_delivery', deliveryId : deliveryId }, function() {
									sa.hideCover();
								});
							});
						}

					});
				});
			}, 2000);
		}
		
		function stopProgressCheck() {
			clearInterval(progressInterval);
			progressInterval = null;
		}
		
		container.empty().append(template);
	}
	
	function listCopies(container) {
		var template = templates.get('copy_page'),
			baseDelivery = template.find('.delivery:first').clone();
		
		// make the selects work
		function getFilters() {
			var filters = template.find('.filters select'),
				vars = {};
			for (var i = 0, len = filters.length; i < len; i++) {
				var filter = filters[i];
				vars[filter.name] = filter.value;
			}
			return vars;
		}
		template.find('select').on('change', function() {
			loadCopies(getFilters());
		});
		
		// load the recipients
		ajax('p=copy&action=list_recipients', function(response) {
			var recipientSelect = template.find('select[name=recipient]');
			response.reverse();
			for (var i = 0, len = response.length; i < len; i++) {
				var recipient = response[i];
				recipientSelect.append('<option value="' + recipient.id + '">' + htmlEncode(recipient.name) + '</option>');
			}
		});
		
		// load the deliveries
		var progressVars,
			progressKey = 'file_delivery_history_progress_' + new Date().getTime();
		template.find('#file_delivery_history').addClass(progressKey);
		function loadCopies(vars) {
			if (!vars) vars = {};
			vars.p = 'copy';
			vars.action = 'list_send_copies';
			progressVars = vars;
			showLoader(template.find('.deliveries'), 'Loading deliveries...');
			ajax(vars, function(response) {
				var deliveriesContainer = template.find('.deliveries'),
					deliveryTemplate = baseDelivery.clone();
				deliveryTemplate.find('*').attr('style', '');
				deliveriesContainer.empty();
				
				var paginationDetails = response.shift();
				for (var i = 0, len = response.length; i < len; i++) {
					var deliveryDetails = response[i],
						delivery = deliveryTemplate.clone();
					
					delivery.attr('id', 'delivery_' + deliveryDetails.delivery_id);
					delivery.find('.recipient_name').html((function() {
						var r = [];
						for (var j = 0, jLen = deliveryDetails.recipients.length; j < jLen; j++) {
							r.push(deliveryDetails.recipients[j].name);
						}
						return htmlEncode(r.join(', '));
					})());
					delivery.find('.sender').html(htmlEncode(deliveryDetails.sender));
					delivery.find('.date').html(formatDate(config.dateTimeFormatString, deliveryDetails.dateSent));
					delivery.find('.album_count').html(deliveryDetails.albumCount);
					
					deliveriesContainer.append(delivery);
				}

				sa.pagination.addPagination({
					container : deliveriesContainer,
					totalItems : paginationDetails.totalItems,
					perPage : paginationDetails.perPage,
					currentPage : paginationDetails.currentPage,
					callback : function(pageNumber) {
						var vars = getFilters();
						vars.page = pageNumber;
						loadCopies(vars);
						sa.scrollToElement(template);
					}
				});
			});
		}
		loadCopies();
		
		container.empty().append(template);
	}
	
}
/**
 * The page in the admin panel that lets you view the history of your site's purchases
 */
function AdminFileDeliveryPurchases() {
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		container.html('');
		listPurchases(container);
	};
	
	function listPurchases(container) {
		var template = sa.templates.get('admin.file_delivery.purchases').get('page');
		
		loadPurchases(template);
		
		// make the purchase button work
		template.find('.purchase_more').on('click', function() {
			purchaseModal.show('file_delivery_1tb', function() {
				loadPurchases(container);
			});
		});
		
		// make the set amount button work
		if (!user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			template.find('.set_transfer_left').remove();
		}
		
		container.empty().append(template);
	}
	
	function loadPurchases(container) {
		ajax({ p : 'file_delivery', action : 'purchase_history' }, function(response) {
			response = response[0];
			
			var purchaseContainer = container.find('.purchases'),
				purchaseTemplate = purchaseContainer.find('.template').clone().removeClass('template');
			
			// clear out any old purchases
			purchaseContainer.find('.purchase:not(.template)').remove();
			
			// set up the header
			if (response.current != -1) {
				container.find('.transfer_amount').html(response.current.sizeFormat());
				container.find('.purchase_more').show();
			} else {
				container.find('.transfer_amount').html('Unlimited');
				container.find('.purchase_more').hide();
			}
			
			// add the purchases
			for (var i = 0, len = response.purchases.length; i < len; i++) {
				
				var purchaseData = response.purchases[i],
					purchase = purchaseTemplate.clone();
				
				let date = formatDate(config.dateFormatString, purchaseData.date);
				// let purchaser = stripHtmlFromString(purchaseData.purchaser);
				let purchaser = purchaseData.purchaser;
				let amountPurchased = purchaseData.transferPurchased.sizeFormat(2);
				let price = purchaseData.purchasePrice != '0' ? ('$' + purchaseData.purchasePrice / 100) : 'free';
				
				purchase.find('.date').text(date);
				purchase.find('.purchaser').text(purchaser);
				purchase.find('.amount_purchased').text(amountPurchased);
				purchase.find('.price').text(price);
				
				purchaseContainer.append(purchase);
			}
			
			// strip em!
			purchaseContainer.find('.purchase:not(.template):odd').addClass('stripe');

			// make the set amount button work
			container.find('.set_transfer_left').off().on('click', function() {
				sa.prompt({
					text : 'Set how much transfer this workspace should have.<br/>For example, 100gb, 50mb, or 2tb. Default is 10tb.',
					placeholder : 'Transfer amount',
					value : response.current + 'b',
					yesFunction : function(value) {
						var matches = value.toLowerCase().match(/([0-9]+(?:\.[0-9]+)?)(tb|gb|mb|kb|b)/);
						if (matches) {
							var realAmount = parseFloat(matches[1]);
							if (matches[2] == 'kb') realAmount *= 1024;
							else if (matches[2] == 'mb') realAmount *= 1024 * 1024;
							else if (matches[2] == 'gb') realAmount *= 1024 * 1024 * 1024;
							else if (matches[2] == 'tb') realAmount *= 1024 * 1024 * 1024 * 1024;
							realAmount = Math.floor(realAmount);
							console.log('setting to', realAmount);
							ajax({ p : 'file_delivery', action : 'set_transfer_left', amount : realAmount }, function(response) {
								loadPurchases(container);
								sa.notify({ text : 'Amount saved', type : sa.notify.notificationTypes.success });
							});
						} else {
							sa.notify({ text : 'No idea what you\'re going for there' });
							return true;
						}
					},
					yesText : 'Save'
				});
			});
			
		});
	}
	
}
/**
 * The page in the admin panel that lets you set up new deliveries
 */
function AdminFileDeliveryRecipients() {

	var templates = sa.templates.get('admin.file_delivery.recipients');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param container
	 */
	this.show = function(params, container) {
		if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}

		container.html('');
		
		let vars = sa.router.getCurrentQueryParams();
		vars = $j.deparam(vars);
		
		if (vars.action == 'newRecipient') {
			createNewRecipient(container);
		} else if (vars.action == 'editRecipient') {
			editRecipient(container, vars.id);
		} else if (vars.action == 'recipientDeliveryOrganization') {
			recipientDeliveryOrganization(container, vars.recipientId);
		} else if (vars.action == 'recipientDeliveryMapping') {
			recipientDeliveryMapping(container, vars.recipientId);
		} else if (vars.action == 'deliveryExtraFields') {
			deliveryExtraFields(container, vars.deliveryIds);
		} else if (vars.action == 'deliverySelection') {
			deliverySelection(container, vars.deliveryIds);
		} else if (vars.action == 'deliveryApproval') {
			deliveryApproval(container, vars.deliveryIds);
		} else if (vars.action == 'deliveryConfirmation') {
			deliveryConfirmation(container, vars.deliveryIds);
		} else {
			listRecipients(container);
		}
	};


	//////////////////////////////////////////
	// Recipient List Functions
	//////////////////////////////////////////

	function listRecipients(container) {
		ajax('p=file_delivery&action=list_recipients', function(response) {
			if (!response.length) {
				return sa.router.routeTo('/admin?p=file_delivery&action=newRecipient');
				//return createNewRecipient(container);
			} else {
				var template = templates.get('list_recipients'),
					baseItem = template.find('.item');
				for (var i = 0, len = response.length; i < len; i++) {
					var item = baseItem.clone(),
						recipient = response[i];
					item.attr('id', item.attr('id') + recipient.id);
					item.find('.name a').html(htmlEncode(recipient.name)).on('click', function(recipient) { return function() {
						startDelivery(recipient.id);
						return false;
					}; }(recipient));
					item.find('.location').html(htmlEncode(recipient.location));
					(function(item, recipient) {
						let baseUrl = siteBaseUrl();
						item.find('.edit_button').attr('href', baseUrl + '/admin?p=file_delivery&tab=recipients&action=editRecipient&id=' + recipient.id);
						item.find('.copy_button').on('click', function() {
							ajax({ p : 'file_delivery', action : 'copy_recipient', recipientId : recipient.id }, function() {
								listRecipients(container);
							});
						});
						item.find('.delete_button').on('click', function() {
							deleteRecipient(recipient, container);
						});
					})(item, recipient);
					baseItem.after(item);
				}
				baseItem.remove();
				template.find('.item:odd').addClass('stripe');

				// batch deliveries
				template.find('#start_batch').on('click', function() {
					template.find('tr').prepend('<td class="checkbox_container"><input type="checkbox" /></td>');

					template.find('.checkbox_container:first input').on('click', function() {
						if (this.checked) {
							template.find('.checkbox_container input').prop('checked', true);
						} else {
							template.find('.checkbox_container input').prop('checked', false);
						}
					});

					template.find('#start_batch_delivery').hide();
					template.find('#create_batch_delivery').show();

					template.find('#create_batch').on('click', function() {

						var deliveryIds = [];

						template.find('.checkbox_container input:checked').each(function() {
							var item = $j(this).parents('.item');
							if (!item) return;
							var itemId = item.attr('id');
							var matches;
							if (itemId && (matches = itemId.match(/^item_([0-9]+)$/))) {
								deliveryIds.push(parseInt(matches[1]));
							}
						});

						if (!deliveryIds.length) {
							sa.alert({ text : 'Choose some recipients to start a batch delivery.' });
						} else if (deliveryIds.length === 1) {
							startDelivery(deliveryIds[0]);
						} else {
							startBatchDelivery(deliveryIds);
						}

					});
				});

				container.empty().append(template);
			}
		});
	}

	function editRecipient(container, recipientId) {
		ajax('p=file_delivery&action=get_recipient_details&recipientId=' + recipientId, function(response) {
			response = response[0];
			if (response.error) {
				sa.notify({ text : response.error });
				return sa.router.routeTo('/admin?p=file_delivery&tab=recipients');
			}
			createNewRecipient(container, recipientId);
			var recipient = response.recipient;
			for (var varName in recipient) {
				if (!recipient.hasOwnProperty(varName)) continue;
				container.find('input[name=' + varName.replace(/(_[a-z])/g, function(val) { return val.toUpperCase().replace('_', ''); }) + ']').val(recipient[varName]);
			}
			if (recipient['ftp_type'] != 'none') {
				container.find('select[name=ftpType]').val(recipient['ftp_type']).trigger('change');
			}
			if (recipient['ftp_port'] == '0') {
				container.find('input[name=ftpPort]').val('');
			}
			container.find('h2').html('Edit a Recipient');
		});
	}

	function deleteRecipient(item, container) {
		sa.confirm({
			text : 'Are you sure you want to delete this recipient? This <b>will not stop</b> any transfers already being processed.',
			yesFunction : function() {
				ajax('recipientId=' + item.id, function() {
					sa.notify({ text : 'Recipient deleted!' });
					listRecipients(container);
				}, 'POST', 'p=file_delivery&action=delete_recipient');
			},
			yesText : 'Delete'
		});
	}

	function startDelivery(recipientId) {
		startBatchDelivery([ recipientId ]);
	}

	function startBatchDelivery(recipientIds) {
		ajax({ p : 'file_delivery', action : 'start_new_delivery', recipientIds : recipientIds }, function(response) {
			response = response[0];
			if (response.success) {
				if (response.extraFields) {
					return sa.router.routeTo('/admin?' + $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliveryExtraFields', deliveryIds : response.deliveryIds }));
				}

				return sa.router.routeTo('/admin?' + $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliverySelection', deliveryIds : response.deliveryIds }));
			} else {
				sa.notify({ text : response.error });
			}
		});
	}


	//////////////////////////////////////////
	// Creating Recipient Functions
	//////////////////////////////////////////

	function createNewRecipient(container, recipientId) {

		var template = templates.get('create_new_recipient');

		// enable and disable ftp
		template.find('select[name=ftpType]').on('change', function() {
			if (this.value == 'none') {
				template.find('.ftp_section').slideUp();
			} else {
				template.find('.ftp_section').slideDown();
			}
		});

		if (recipientId) {
			template.find('.preset_section').remove();
		} else {
			var presetSelect = template.find('select[name=preset]'),
				presets = { custom : { name : '', location : '', email : '' }};
			ajax('p=file_delivery&action=get_presets', function(response) {
				for (var i = 0, len = response.length; i < len; i++) {
					var preset = response[i];
					presets[preset.value] = preset;
					presetSelect.append('<option value="' + preset.value + '">' + htmlEncode(preset.name) + '</option>');
				}
			});
			presetSelect.on('change', function(){
				if (this.value == 'custom') {
					template.find('.button').html('Save and Configure Delivery');
				} else {
					template.find('.button').html('Save and Configure Fields');
				}
				var preset = presets[this.value];
				template.find('input[name=name]').val(preset.name);
				template.find('input[name=location]').val(preset.location);
				template.find('input[name=email]').val(preset.email);
			});
		}
		template.find('.button').on('click', function() {
			var validationResult = sa.forms.validate(template);
			template.find('.error').hide();
			if (!validationResult.error) {
				var vars = validationResult.values;
				var loader;
				// submit
				template.find('.general_error').hide();
				if (recipientId) vars.recipientId = recipientId;
				if (vars.ftpServer) {
					loader = showLoader($j('#file_delivery_new_recipient_form'), 'Testing FTP information...');
				}
				ajax(vars, function(response) {
					if (loader) loader.remove();
					response = response[0];
					if (response.success) {
						if (recipientId) {
							sa.notify({ text : 'Recipient updated!', type : sa.notify.notificationTypes.success });
						} else {
							sa.notify({ text : 'Recipient created!', type : sa.notify.notificationTypes.success });
							recipientId = response.recipientId;
						}
						if (response['skipConfiguration'] && response['skipMapping']) {
							return startDelivery(recipientId);
						} else if (response['skipConfiguration']) {
							return sa.router.routeTo('/admin?p=file_delivery&tab=recipients&action=recipientDeliveryMapping&recipientId=' + recipientId);
						} else {
							return sa.router.routeTo('/admin?p=file_delivery&tab=recipients&action=recipientDeliveryOrganization&recipientId=' + recipientId);
						}
					} else {
						template.find('.general_error').html(response.error).show();
						sa.scrollToElement(template.find('.general_error'));
						sa.notify({ text : 'Error ' + (recipientId ? 'updating' : 'creating') + ' recipient!' });
					}
				}, 'POST', 'p=file_delivery&action=' + (recipientId ? 'edit_recipient' : 'create_recipient'));
			} else {
				for (let fieldName in validationResult.errors) {
					if (!validationResult.errors.hasOwnProperty(fieldName)) continue;
					validationResult.errors[fieldName].inputContainer.find('.error').show();
				}
			}
		});

		container.empty().append(template);
	}

	//////////////////////////////////////////
	// Delivery Organization Functions
	//////////////////////////////////////////

	function recipientDeliveryOrganization(container, recipientId) {

		var template = templates.get('recipient_delivery_organization');

		template.find('.filename_button').on('click', function() {
			var t = $j(this),
				cont = t.parent(),
				editor = cont.find('.filename_editor');
			if (editor.length) {
				cont.find('input:first').off();
				t.html('Edit Filename Template');
				return editor.stop(true).slideUp(function() { editor.remove(); });
			}
			t.html('Hide Editor');
			showFilenameEditor(cont, $j(this).attr('step-type'));
		});

		if (config.watermarked) {
			template.find('.site_unwatermarked').remove();
		} else {
			template.find('.site_watermarked').remove();
		}

		ajax('p=file_delivery&action=get_recipient_delivery_organization&recipientId=' + recipientId, function(response) {
			if (!response.length || response[0].error) {
				sa.notify({ text : response[0].error });
				return sa.router.routeTo('/admin?p=file_delivery&tab=recipients');
			}
			var delivery = response[0];
			template.find('h2 .name').html(htmlEncode(delivery.name));
			for (var i in delivery) {
				if (!delivery.hasOwnProperty(i)) continue;
				if (i == 'albumArt') {
					if (delivery[i] == '1') {
						template.find('input[name=albumArt]').prop('checked', true);
						template.find('.album_art_setting').show();
					}
					continue;
				} else if (i == 'metadataFormat' && delivery[i] && delivery[i] != 'none') {
					template.find('.metadata_format_setting').show();
				} else if (i == 'metadataEmbedding') {
					(function(metadataEmbeddingValue) {
						ajax('p=metadata_downloading_profiles&action=listProfiles', function(profiles) {
							var select = template.find('select[name=metadataEmbedding]');
							var selectHtml = select.html();
							for (var p = 0, pLen = profiles.length; p < pLen; p++) {
								var profile = profiles[p];
								selectHtml += '<option value="' + profile.id + '">' + htmlEncode(profile.name) + '</option>';
							}
							select.html(selectHtml);
							select.val(metadataEmbeddingValue);
						});
					})(delivery[i]);
					continue;
				} else if (i == 'metadataOnly') {
					if (delivery[i] == '1') {
						template.find('input[name=metadataOnly]').prop('checked', true);
						template.find('.file_sending_section').hide();
					}
					continue;
				} else if (i == 'formats') {
					if (delivery[i].indexOf('m') != -1) {
						template.find('input[name=fileFormats\\[\\]][value=mp3]').prop('checked', true);
					}
					if (delivery[i].indexOf('a') != -1) {
						template.find('input[name=fileFormats\\[\\]][value=aiff]').prop('checked', true);
					}
					if (delivery[i].indexOf('w') != -1) {
						template.find('input[name=fileFormats\\[\\]][value=wav]').prop('checked', true);
					}
					continue;
				} else if (i == 'watermarked') {
					if (delivery[i] == '1') {
						template.find('input[name=watermarked]').prop('checked', true);
					}
					continue;
				}
				template.find('input[name=' + i + '], select[name=' + i + ']').val(delivery[i]);
			}
		});
		template.find('select[name=metadataFormat]').on('change', function() {
			if (this.value != 'none') {
				template.find('.metadata_format_setting').stop(true).slideDown();
			} else {
				template.find('.metadata_format_setting').stop(true).slideUp();
			}
		});
		template.find('input[name=albumArt]').on('change', function() {
			if (this.checked) {
				template.find('.album_art_setting').stop(true).slideDown();
			} else {
				template.find('.album_art_setting').stop(true).slideUp();
			}
		});
		template.find('input[name=metadataOnly]').on('change', function() {
			if (this.checked) {
				template.find('.file_sending_section').stop(true).slideUp();
			} else {
				template.find('.file_sending_section').stop(true).slideDown();
			}
		});
		template.find('.save').on('click', function() {
			var validationResult = sa.forms.validate(template);
			if (!validationResult.error) {
				var vars = validationResult.values;
				// submit
				template.find('.general_error').hide();
				vars.recipientId = recipientId;
				ajax(vars, function(response) {
					response = response[0];
					if (response.success) {
						if (response['mappingNeeded']) {
							sa.notify({ text : 'Details saved!', type : sa.notify.notificationTypes.success });
							return sa.router.routeTo('/admin?p=file_delivery&tab=recipients&action=recipientDeliveryMapping&recipientId=' + recipientId);
						} else {
							sa.notify({ text : 'Details saved! Recipient ready for deliveries.', type : sa.notify.notificationTypes.success });
							return sa.router.routeTo('/admin?p=file_delivery&tab=recipients&action=list');
						}
					} else {
						template.find('.general_error').html(response.error).show();
						sa.scrollToElement(template.find('.general_error'));
						sa.notify({ text : 'Error ' + (recipientId ? 'updating' : 'creating') + ' delivery!' });
					}
				}, 'POST', 'p=file_delivery&action=save_recipient_delivery_organization');
			} else {

				for (let error of validationResult.errors) {
					error.input.parent().find('.error').show();
				}

				sa.notify({ text: 'There is a problem with your configuration. Please check the fields above.' });
			}
		});

		container.empty().append(template);
	}


	//////////////////////////////////////////
	// Mapping Functions
	//////////////////////////////////////////

	var mappingFieldOptions;
	function recipientDeliveryMapping(container, recipientId) {
		// need our mapping options
		if (!mappingFieldOptions) {
			return ajax('p=file_delivery&action=get_mapping_options', function(response) {
				mappingFieldOptions = response;
				return recipientDeliveryMapping(container, recipientId);
			});
		}

		let template = templates.get('recipient_delivery_mapping');
		container.empty().append(template);

		// show a loader. this can take a few seconds
		let loader = showLoader(container, 'Loading mapping options');

		// load any previously saved data
		ajax('p=file_delivery&action=get_recipient_delivery_mapping&recipientId=' + recipientId, function(response) {
			if (response.length) {
				for (var i = 0, len = response.length; i < len; i++) {
					addMappingField(template, i, response[i].field, response[i].name, response[i].defaultValue, response[i].extraHeader,
						response[i].subHeader, response[i].manipulations);
				}
			} else {
				addMappingField(template, 0);
			}

			if (exampleTracks) {
				updateMappingSampleTracks(template);
				// console.log('updating sample tracks because we had examples');
			} else {
				ajax('p=track_info&show=5&customs=1', function(response) {
					exampleTracks = response;
					updateMappingSampleTracks(template);
					// console.log('updating sample tracks because examples loaded');
				});
			}

			let fieldList = container.find('.field_list');
			fieldList.sortable({
				axis : 'y',
				//containment : 'parent',
				helper : function(e, element) {
					return $j(element).addClass('file_delivery_mapping_field_sortable_handle');
				},
				placeholder : 'field sortable_placeholder',
				handle : '.move',
				start : function(event, ui) {
					let helperComputedStyles = window.getComputedStyle(ui.helper[0]);
					ui.placeholder.height(ui.helper.outerHeight() - parseInt(helperComputedStyles.paddingTop) - parseInt(helperComputedStyles.paddingBottom) - parseInt(helperComputedStyles.borderTopWidth) - parseInt(helperComputedStyles.borderBottomWidth));
				},
				stop : function() {
					// console.log('stop firing');
					stopSortable();
				},
				tolerance : 'pointer'
			});
			// this bit necessary to remove overflow: hidden; from some elements so the handle appears in the correct position when the browser is scrolled down
			// sortable has start and stop methods but start doesn't fire quickly enough - it's already badly positioned the handle by then
			let scroller = (function() {
				let scroller = {};
				let direction = 0;
				let scrollingElement = $j('html, body');
				let enabled = false;

				scroller.start = function() {
					enabled = true;
					doScroll();
				};

				scroller.stop = function() {
					enabled = false;
				};

				scroller.setDirection = function(newDirection) {
					direction = newDirection;
				};

				function doScroll() {
					//console.log('scroll with', direction);
					if (!enabled) {
						return;
					}
					if (direction === 0) {
						return setTimeout(doScroll, 100);
					}
					let rerun = false;
					scrollingElement.animate({ scrollTop : scrollingElement.scrollTop() + direction }, 100, 'linear', function () {
						if (rerun) return;
						rerun = true;
						setTimeout(doScroll, 0);
					});
				}

				return scroller;
			})();
			let $window = $j(window);
			function stopSortable(e) {
				sa.getDomBody().removeClass('sortable_active');
				$window.off('.sortablefix');
				if (e && e.delegateTarget) {
					$j(e.delegateTarget).off('.sortablefix');
					// console.log('removing .sortablefix from', e.delegateTarget);
				}
				scroller.stop();
				if (e && e.originalEvent && e.originalEvent['releaseCapture']) {
					e.originalEvent['releaseCapture']();
				}
				updateFieldPositioningElements(container);
			}
			container.find('.field_list').on('mousedown', function(e) {
				if (!$j(e.target).hasClass('move')) {
					// console.log('skipping mousedown');
					return;
				}
				sa.getDomBody().addClass('sortable_active');
				let maxY = $window.outerHeight() - $j('#bottom_bar').outerHeight();
				let minY = $j('#top_bar').outerHeight();
				$window.add($j(this)).on('mouseup.sortablefix dragend.sortablefix', function(e) {
					// console.log('mouseup firing');
					stopSortable(e);
				});
				$window.on('mousemove.sortablefix', function(e) {
					if (e.clientY < minY) {
						scroller.setDirection(-100);
					} else if (e.clientY > maxY) {
						scroller.setDirection(100);
					} else {
						scroller.setDirection(0);
					}
					e.preventDefault();
				});
				if (e.originalEvent['setCapture']) {
					e.originalEvent['setCapture']();
				}
				scroller.start();
				e.preventDefault();
			});

			loader.remove();
		});

		// save it!
		template.find('.save').on('click', function() {
			var vars = { fields : [] },
				fields = template.find('.field');
			if (!fields.length) {
				template.find('.general_error').html('Please select some fields for your metadata file or go back and indicate that you don\'t need one.').show();
				sa.scrollToElement(template.find('.general_error'));
				return;
			}
			for (var i = 0, len = fields.length; i < len; i++) {
				var field = $j(fields[i]),
					select = field.find('select[name=type]'),
					nameInput = field.find('input[name=name]'),
					defaultValue = field.find('input[name=default]'),
					extraHeader = field.find('textarea[name=extraHeader]'),
					subHeader = field.find('textarea[name=subHeader]'),
					manipulations = field.find('.manipulation'),
					fieldData;
				if (!select.val()) {
					template.find('.general_error').html('One of your fields is missing its required data. Sorry, please reload and try again.').show();
					sa.scrollToElement(select);
					return;
				}
				fieldData = { field : select.val(), name : nameInput.val(), defaultValue : defaultValue.val(), extraHeader : extraHeader.val(),
					subHeader : subHeader.val(), manipulations : [] };
				for (var m = 0, mLen = manipulations.length; m < mLen; m++) {
					var validationResult = sa.forms.validate($j(manipulations[m]));
					if (!validationResult.error) {
						var manipulationData = validationResult.values;
						if (manipulationData.type == 'concatenation' && manipulationData.separator) {
							manipulationData.separator = manipulationData.separator.replace(/ /g, '&nbsp;'); // sometimes separators are just spaces and they won't survive the trim on the php side
						}
						fieldData.manipulations.push(manipulationData);
					} // if it was false, the user didn't enter enough information. just ignore it, i guess
				}
				vars.fields.push(fieldData);
			}
			// submit
			template.find('.general_error').hide();
			vars.recipientId = recipientId;
			vars.fields = JSON.stringify(vars.fields);
			let loader = showLoader(container, 'Saving...');
			sa.scrollToElement(container);
			ajax(vars, function(response) {
				loader.remove();
				response = response[0];
				if (response.success) {
					sa.notify({ text : 'Metadata fields saved! Recipient ready for deliveries.', type : sa.notify.notificationTypes.success });
					return sa.router.routeTo('/admin?p=file_delivery&tab=recipients&action=list');
				} else {
					template.find('.general_error').html(response.error).show();
					sa.scrollToElement(template.find('.general_error'));
					sa.notify({ text : response.error });
				}
			}, 'POST', 'p=file_delivery&action=save_recipient_delivery_mapping');
		});
	}

	function addMappingField(container, location, fieldType, fieldTitle, fieldDefault, fieldExtraHeader, fieldSubHeader, fieldManipulations) {
		var field = templates.get('mapping_field');

		// add the types
		var typeList = field.find('select[name=type]');
		var columnNameInput = field.find('input[name=name]');
		for (var m = 0, mLen = mappingFieldOptions.length; m < mLen; m++) {
			var fieldData = mappingFieldOptions[m];
			typeList.append('<option value="' + fieldData.key + '">' + htmlEncode(fieldData.name) + '</option>');
		}
		typeList.val(fieldType);
		if (!fieldType || fieldType == 'preset') {
			field.addClass('unselected');
		}
		typeList.on('change', function() {
			var val = typeList.val();
			if (val && (!columnNameInput.val() || columnNameInput.attr('usingAuto'))) {
				columnNameInput.val(typeList.find('option:selected').html().replace(/ \(.*\)/, ''));
				columnNameInput.attr('usingAuto', '1');
			}
			if (!val) {
				field.addClass('unselected');
			} else {
				field.removeClass('unselected');
			}
			// console.log('type list has changed so updating sample tracks');
			updateMappingSampleTracks(container);
		});
		// add the field title if it was given
		if (fieldTitle) {
			columnNameInput.val(fieldTitle);
		} else {
			typeList.trigger('change');
		}
		columnNameInput.on('change', function() {
			columnNameInput.removeAttr('usingAuto');
		});
		// set up a default
		if (fieldDefault) {
			field.find('input[name=default]').val(fieldDefault);
		}
		// extra header
		var descriptions = [];
		if (fieldExtraHeader) {
			descriptions.push(fieldExtraHeader.replace(/\n/g, '<br/>'));
			field.find('textarea[name=extraHeader]').val(fieldExtraHeader);
		}
		// extra header
		if (fieldSubHeader) {
			descriptions.push(fieldSubHeader.replace(/\n/g, '<br/>'));
			field.find('textarea[name=subHeader]').val(fieldSubHeader);
		}
		field.find('.description').html(descriptions.join('<br/>'));

		// make the add step buttons work
		function animateNewField(newField) {
			let finalHeight = newField.outerHeight();
			let computedStyles = window.getComputedStyle(newField[0]);
			let finalPaddingTop = computedStyles.paddingTop;
			let finalPaddingBottom = computedStyles.paddingBottom;
			console.log('animating to', finalHeight);
			newField.css({ minHeight : 0, height : 0, overflow : 'hidden', paddingTop : 0, paddingBottom : 0 })
				.animate({ height : finalHeight, paddingTop : finalPaddingTop, paddingBottom : finalPaddingBottom }, function() {
					$j(this).css({ minHeight : '', height : '', overflow : '', paddingTop : '', paddingBottom : '' });
				});
		}
		field.find('.above').on('click', function() {
			animateNewField(addMappingField(container, field.index() - 1));
		});
		field.find('.below').on('click', function() {
			animateNewField(addMappingField(container, field.index()));
		});
		field.find('.remove').on('click', function() {
			field.css({ minHeight : 0 }).slideUp(function() {
				field.remove();
				updateFieldPositioningElements(container);
			});
		});
		field.find('.move_up').on('click', function() {
			let prev = field.prev();
			if (!prev.length || !prev.hasClass('field')) return;
			let done = 0;
			let finishFunction = function() {
				if (++done !== 2) return;
				prev.before(field);
				prev.add(field).css({ top : 0 });
				updateFieldPositioningElements(container);
			};
			field.animate({ top : (0 - prev.outerHeight()) + 'px' }, 400, finishFunction);
			prev.animate({ top : field.outerHeight() + 'px' }, 400, finishFunction);
		});
		field.find('.move_down').on('click', function() {
			let next = field.next();
			if (!next.length || !next.hasClass('field')) return;
			let done = 0;
			let finishFunction = function() {
				if (++done !== 2) return;
				next.after(field);
				next.add(field).css({ top : 0 });
				updateFieldPositioningElements(container);
			};
			field.animate({ top : next.outerHeight() + 'px' }, 400, finishFunction);
			next.animate({ top : (0 - field.outerHeight()) + 'px' }, 400, finishFunction);
		});

		// manipulation buttons
		field.find('.concatenate').on('click', function() {
			animateNewField(addConcatenationField(field));
		});
		if (fieldManipulations && fieldManipulations.length) {
			for (var i = 0, len = fieldManipulations.length; i < len; i++) {
				var data = fieldManipulations[i];
				if (data.type == 'concatenation') {
					var concat = addConcatenationField(field);
					concat.find('input[name=separator]').val(data.separator);
					concat.find('select[name=fieldType]').val(data.fieldType);
				}
			}
		}

		if (location == -1) {
			container.find('.field_list').prepend(field);
		} else {
			var afterField = container.find('.field:eq(' + location + ')');
			if (afterField.length) {
				afterField.after(field);
			} else {
				container.find('.field_list').append(field);
			}
		}
		updateFieldPositioningElements(container);
		return field;
	}

	function updateFieldPositioningElements(container) {
		// update column letters - only supports A - ZZ right now. if you went up to AAA, it would start to display gibberish for the first letter but that's over 600 cols
		var columnIndexes = container.find('.column_index');
		for (var i = 0, len = columnIndexes.length; i < len; i++) {
			var firstLetter = Math.floor(i / 26),
				secondLetter = i % 26;
			// 65 - A; 90 - Z
			columnIndexes[i].innerHTML = (firstLetter ? String.fromCharCode(64 + firstLetter) : '') + String.fromCharCode(65 + secondLetter); // first one is 64 because by the time it gets there, firstLetter is 1
		}
		// update the add/remove buttons
		if (container.find('.field').length == 1) {
			container.find('.field .remove').hide();
			container.find('.field .move').addClass('disabled');
		} else {
			container.find('.field .remove').show();
			container.find('.field .move').removeClass('disabled');
		}
		// update mapping arrows
		container.find('.field .move_up.disabled, .field .move_down.disabled').removeClass('disabled');
		container.find('.field:first .move_up, .field:last .move_down').addClass('disabled');
	}

	function addConcatenationField(container) {
		var concatenation = templates.get('concatenation_field');

		// add the types
		var typeList = concatenation.find('select[name=fieldType]');
		for (var i = 0, len = mappingFieldOptions.length; i < len; i++) {
			var fieldData = mappingFieldOptions[i];
			typeList.append('<option value="' + fieldData.key + '">' + htmlEncode(fieldData.name) + '</option>');
		}

		// add the interactions
		concatenation.find('.remove').on('click', function() {
			concatenation.animate({ height : 0, padding : 0 }, function() {
				concatenation.remove();
				updateMappingSampleTracks(container);
			});
		});
		concatenation.find('.concatenate').on('click', function() {
			addConcatenationField(container);
		});

		container.find('.options').append(concatenation);

		updateMappingSampleTracks(container);

		return concatenation;
	}

	function updateMappingSampleTracks(container) {
		if (!exampleTracks || exampleTracks.length < 2) {
			return container.find('.example').html('Add some tracks to see examples');
		}
		container.find('.example').html('Test examples');

		var fields,
			track = exampleTracks[1];

		if (container.hasClass('field')) {
			fields = [container];
		} else {
			fields = container.find('.field');
		}

		for (var i = 0, len = fields.length; i < len; i++) {
			var field = $j(fields[i]),
				fieldType = field.find('select[name=type]').val(),
				defaultValue = field.find('input[name=default]').val(),
				value,
				example = field.find('.example');

			value = getMappingTrackData(fieldType, track);

			field.find('input[name=default]').off().on('keyup', function() {
				updateMappingSampleTracks(container);
			});

			var manipulations = field.find('.manipulation');
			for (var m = 0, mLen = manipulations.length; m < mLen; m++) {
				var manipulation = $j(manipulations[m]),
					mType = manipulation.find('input[name=type]').val();
				if (mType == 'concatenation') {
					var sep = manipulation.find('input[name=separator]').val(),
						subType = manipulation.find('select[name=fieldType]').val(),
						secondValue;
					secondValue = getMappingTrackData(subType, track);
					if ((value != '' || fieldType == 'blank') && (secondValue != '' || subType == 'blank')) {
						value += sep + secondValue;
					} else if (secondValue) {
						value = secondValue;
					}
				}
				manipulation.find('input').off().on('change, keyup', function() {
					updateMappingSampleTracks(container);
				});
				manipulation.find('select').off().on('change', function() {
					updateMappingSampleTracks(container);
				});
			}

			if (!value) {
				value = defaultValue;
			}

			// console.log('value for', fieldType, 'is', value);
			if (!value && fieldType != 'blank') {
				value = 'Unable to provide example for this column';
			}

			example.text(value);
		}
	}

	function getMappingTrackData(fieldType, track) {
		var fieldData,
			value = '';

		for (var m = 0, mlen = mappingFieldOptions.length; m < mlen; m++) {
			if (mappingFieldOptions[m].key == fieldType) {
				fieldData = mappingFieldOptions[m];
			}
		}

		if (!fieldData) {
			return 'Select a type';
		}

		if (fieldData.custom) {
			if (fieldType == 'tempo' || fieldType == 'genre' || fieldType == 'cue type') {
				var arr = track[(fieldType == 'cue type' ? 'cueType' : fieldType) + 's'],
					arrVals = [];
				for (var a = 0, aLen = arr.length; a < aLen; a++) {
					arrVals.push(arr[a].name);
				}
				value = arrVals.join(', ');
			} else if (fieldType == 'moods' || fieldType == 'styles') {
				value = track[fieldType].join(', ');
			} else if (fieldType == 'blank') {
				value = '';
			}
		} else if (fieldData.value) {
			value = fieldData.value;
		} else if (fieldData['customField']) {
			if (track.custom_fields) {
				var customFieldId = parseInt(fieldData['customField']);
				track.custom_fields.each(function(f, cus) {
					if (cus.id == customFieldId) {
						value = cus.value;
					}
				});
			}
		} else if (fieldData.field == 'description 255') {
			value = track.description.substring(0, 255);
		} else {
			var val = track;
			for (var f = 0, fLen = fieldData.field.length; f < fLen; f++) {
				val = val[fieldData.field[f]];
				if (val == undefined) {
					val = '';
					break;
				}
			}
			if (val) {
				value = val;
			}
		}

		return value;
	}


	//////////////////////////////////////////
	// Delivery Extra Field Functions
	//////////////////////////////////////////

	function deliveryExtraFields(container, deliveryIds) {
		container.empty().append(templates.get('delivery_extra_fields'));

		var fieldTemplate = templates.get('delivery_extra_field_template');

		ajax({ p : 'file_delivery', action : 'get_delivery_extra_fields', deliveryIds : deliveryIds }, function(response) {
			if (!response.length) {
				return sa.router.routeTo('/admin?' + $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliverySelection', deliveryIds : deliveryIds }));
			}

			var fields = container.find('.fields');
			response.each(function(r, deliveryData) {
				deliveryData.fields.each(function(f, fieldData) {
					var field = fieldTemplate.clone();
					field.find('.recipient_name').html(htmlEncode(deliveryData.name));
					field.find('.field_name').html(fieldData.key);
					field.find('input').attr('name', 'extraFields[' + deliveryData.id + '][' + fieldData.key + ']').val(fieldData.value);
					fields.append(field);
				});
			});
		});
		container.find('.save').on('click', function() {
			var validationResult = sa.forms.validate(container);
			if (validationResult.error) return;
			var vars = validationResult.values;
			vars.deliveryIds = deliveryIds;
			ajax(vars, function(response) {
				if (response[0].success) {
					sa.notify({ text : 'Fields saved!', type : sa.notify.notificationTypes.success });
					return sa.router.routeTo('/admin?'+ $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliverySelection', deliveryIds : deliveryIds }));
				} else {
					sa.notify({ text : response[0].error });
				}
			}, 'POST', 'p=file_delivery&action=save_delivery_extra_fields');
		});
	}


	//////////////////////////////////////////
	// Delivery Selection Functions
	//////////////////////////////////////////

	var selectionHierarchy;
	var currentSelectionState;// = { catalogs : {}, labels : {}, albums : {} };
	var selectedCatalogId = 0;
	var selectedLabelId = 0;
	var recentAlbums = null;

	function deliverySelection(container, deliveryIds) {
		// get the currently selected data
		if (!currentSelectionState) {
			return ajax({ p : 'file_delivery', action : 'get_delivery_selection', deliveryIds : deliveryIds }, function(response) {
				currentSelectionState = response[0];
				deliverySelection(container, deliveryIds);
			});
		}

		var template = templates.get('delivery_selection');

		// load the hierarchy data
		sa.api.request({
			handler : 'permission-profiles',
			action : 'getCatalogHierarchy',
		}).then(response => {
			selectionHierarchy = response;
			cleanSelectionState();
			// sort the catalogs
			var sortedCatalogs = [];
			for (var catalogId in selectionHierarchy) {
				if (!selectionHierarchy.hasOwnProperty(catalogId)) continue;
				selectionHierarchy[catalogId].id = catalogId;
				sortedCatalogs.push(selectionHierarchy[catalogId]);
			}
			sortedCatalogs.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			var catalogContainer = template.find('#catalogs ul');
			for (var c = 0, cLen = sortedCatalogs.length; c < cLen; c++) {
				var cat = sortedCatalogs[c];
				addSelectionItem(catalogContainer, 'catalog', cat.id, cat.name);
			}
		}).catch(err => {
			sa.alert(err.message);
		});

        // load the most recent albums into the gui
		function populateRecentAlbums() {
			var recentAlbumList = container.find('#recent_albums ul').empty();
			for (var i = 0, len = recentAlbums.length; i < len; i++) {
				var album = recentAlbums[i],
					item = templates.get('recent_album');
				item.find('.item_name').html(htmlEncode(album.name) + ' (' + formatDate(config.dateFormatString, album.releaseDate) + ')');
				item.attr('id', 'album_' + album.id);
				(function(album, item) {
					item.find('input').on('click', function() {
						selectedCatalogId = album.catalogId;
						selectedLabelId = album.labelId;
						updateSelectionState('album', album.id, this.checked);
					});
				})(album, item);
				if (currentSelectionState['albums'][album.id] == 1) {
					item.find('input').prop('checked', true);
				}

				recentAlbumList.append(item);
			}
		}
		if (!recentAlbums) {
			ajax({ p : 'copy', action : 'list_recent_albums' }, function(response) {
				recentAlbums = response;
				populateRecentAlbums();
			});
		} else {
			populateRecentAlbums();
		}

		// terminology
		template.find('#catalogs .title').html(htmlEncode(gde('catalog', { plural : true })));
		template.find('#labels .title').html(htmlEncode(gde('label', { plural : true })));
		template.find('#albums .title').html(htmlEncode(gde('album', { plural : true })));

		// saving
		template.find('.save').on('click', function() {
			currentSelectionState.deliveryIds = deliveryIds;
			var loader = showLoader($j('#file_delivery_selection_form'), 'Saving your selections...');
			ajax({ selectData : JSON.stringify(currentSelectionState) }, function(response) {
				response = response[0];
				loader.remove();
				if (response.success) {
					sa.notify({ text : 'Saved your selections!', type : sa.notify.notificationTypes.success });
					return sa.router.routeTo('/admin?' + $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliveryApproval', deliveryIds : deliveryIds }));
				} else {
					template.find('.general_error').html(response.error).show();
					sa.scrollToElement(template.find('.general_error'));
					sa.notify({ text : response.error });
				}
			}, 'POST', 'p=file_delivery&action=save_delivery_selection');
		});

		container.empty().append(template);

		// switching between selector types
		container.find('.select_type').on('click', function() {
			var t = $j(this),
				val = t.find('input').val();
			container.find('.select_type').removeClass('selected');
			t.addClass('selected');
			selectedCatalogId = 0;
			selectedLabelId = 0;
			container.find('.selector_type').hide();
			container.find('.selector_type#select_' + val).show();

			//if (val == 'recent') {
			//	updateRecentState();
			//}
		});
	}

	/**
	 * Adds a single item to the profile option selection columns
	 * @param container the list to which the item should be added
	 * @param {string} itemType the type of item we're adding (catalog|label|album)
	 * @param {int} itemId the id of the item we're adding
	 * @param {string} itemName the name to display as the item's label
	 */
	function addSelectionItem(container, itemType, itemId, itemName) {
		var item = templates.get('selection_item');
		item.find('.item_name').html(htmlEncode(itemName));
		item.attr('id', itemType + '_' + itemId);
		if (itemType == 'album') {
			item.find('.expander').remove();
		}
		item.find('input').on('click', function() {
			updateSelectionState(itemType, itemId, this.checked);
		});
		item.find('.expander').on('click', function() {
			item.parent().find('.selected').removeClass('selected');
			item.addClass('selected');
			expandSelectionItem(itemType, itemId);
		});
		if (currentSelectionState[itemType + 's'][itemId] == 1) {
			item.find('input').prop('checked', true);
		}

		container.append(item);

		if (itemType == 'label') {
			determineSelectionLabelState(selectedCatalogId, itemId);
			determineSelectionCatalogState(selectedCatalogId);
		} else if (itemType == 'catalog') {
			determineSelectionCatalogState(itemId);
		}
	}

	/**
	 * Saves the state of the current item into the cache and updates any descendent items
	 * @param {string} itemType (catalog|label|album)
	 * @param {int} itemId the id of the item in question
	 * @param {boolean} allow are we allowing the user to do stateType with this item or not?
	 */
	function updateSelectionState(itemType, itemId, allow) {
		// console.log('update called with ' + itemType + ' ' + itemId + ' ' + (allow ? 'allow' : 'disallow'));
		if (allow) {
			currentSelectionState[itemType + 's'][itemId] = 1;
		} else {
			currentSelectionState[itemType + 's'][itemId] = 0;
		}
		// need to propagate changes to subelements
		var labelId, albums, albumId;
		if (itemType == 'catalog') {
			var labels = selectionHierarchy[itemId].labels;
			for (labelId in labels) {
				if (!labels.hasOwnProperty(labelId)) continue;
				// hit the checkboxes if they're there
				$j('#label_' + labelId + ' input').prop('checked', allow);
				
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				currentSelectionState['labels'][labelId] = allow ? 1 : 0;
				// now we need to update the albums for this label
				albums = labels[labelId].albums;
				for (albumId in albums) {
					if (!albums.hasOwnProperty(albumId)) continue;
					// hit the checkboxes if they're there
					$j('#album_' + albumId + ' input').prop('checked', allow);
					// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
					currentSelectionState['albums'][albumId] = allow ? 1 : 0;
				}
			}
			determineSelectionCatalogState(itemId);
			// update label states if we're showing this catalog
			if (selectedCatalogId == itemId) {
				for (labelId in selectionHierarchy[itemId].labels) {
					if (!selectionHierarchy[itemId].labels.hasOwnProperty(labelId)) continue;
					determineSelectionLabelState(itemId, labelId);
				}
			}
		} else if (itemType == 'label') {
			// we have to find the label in question
			albums = selectionHierarchy[selectedCatalogId].labels[itemId].albums;
			for (albumId in albums) {
				if (!albums.hasOwnProperty(albumId)) continue;
				// hit the checkboxes if they're there
				$j('#album_' + albumId + ' input').prop('checked', allow);
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				currentSelectionState['albums'][albumId] = allow ? 1 : 0;
			}
			determineSelectionLabelState(selectedCatalogId, itemId);
			determineSelectionCatalogState(selectedCatalogId);
		} else if (itemType == 'album') {
			determineSelectionLabelState(selectedCatalogId, selectedLabelId);
			determineSelectionCatalogState(selectedCatalogId);
		}
		window['ps'] = currentSelectionState;
	}

	/**
	 * Updates a specific catalog's display so it shows the correct number of labels and albums
	 * @param {int} catalogId the id of the catalog
	 */
	function determineSelectionCatalogState(catalogId) {
		// now we need to update the label's catalog to partial status based on the state of the labels within it
		var labels = selectionHierarchy[catalogId].labels,
			labelTotal = 0,
			labelChecked = 0,
			albumTotal = 0,
			albumChecked = 0;
		for (var labelId in labels) {
			if (!labels.hasOwnProperty(labelId)) continue;
			if (currentSelectionState.labels[labelId] == 1) labelChecked++;
			labelTotal++;
			for (var albumId in labels[labelId].albums) {
				if (!labels[labelId].albums.hasOwnProperty(albumId)) continue;
				if (currentSelectionState.albums[albumId] == 1) albumChecked++;
				albumTotal++;
			}
		}
		$j('#catalog_' + catalogId + ' input').parent().find('span').html('(' + labelChecked + '/' + labelTotal + ') (' + albumChecked + '/' + albumTotal + ')');
		currentSelectionState.catalogs[catalogId] = (albumChecked + labelChecked == 0 ? 0 : (albumChecked < albumTotal || labelChecked < labelTotal) ? 2 : 1);
		if (labelChecked == labelTotal && labelTotal != 0) {
			$j('#catalog_' + catalogId + ' input').prop('checked', true);
		} else {
			$j('#catalog_' + catalogId + ' input').prop('checked', false);
		}
	}

	/**
	 * Updates a specific label's display so it shows the correct number of albums
	 * @param {int} catalogId the id of the label's catalog
	 * @param {int} labelId the id of the label itself
	 */
	function determineSelectionLabelState(catalogId, labelId) {
		// now we need to update the label to partial status based on the state of the albums within it
		var albums = selectionHierarchy[catalogId].labels[labelId].albums,
			total = 0,
			checked = 0;
		for (var albumId in albums) {
			if (!albums.hasOwnProperty(albumId)) continue;
			if (currentSelectionState.albums[albumId] == 1) checked++;
			total++;
		}
		$j('#label_' + labelId + ' input').parent().find('span').html('(' + checked + '/' + total + ')');
		currentSelectionState.labels[labelId] = (checked == 0 ? 0 : (checked < total) ? 2 : 1);
		if (checked == total && total != 0) {
			$j('#label_' + labelId + ' input').prop('checked', true);
		} else {
			$j('#label_' + labelId + ' input').prop('checked', false);
		}
	}

	/**
	 * Makes sure items are hierarchically excluded, meaning that if a catalog is excluded, all its labels and albums are
	 *  Saving will enforce this naturally but if an album is added through nefarious means, such as when adding a track, it won't get an exclusion row
	 *  if it's in an excluded label. That doesn't matter on most of the site but this interface requires those rows exist. We need to make sure that those albums are excluded here.
	 */
	function cleanSelectionState() {
		// go through each catalog in the hierarchy
		for (var catalogId in selectionHierarchy) {
			if (!selectionHierarchy.hasOwnProperty(catalogId)) continue;
			var catalog = selectionHierarchy[catalogId];
			var labelId, lab, albumId;
			// see if the entire catalog is excluded
			if (currentSelectionState.catalogs[catalogId] === 0) {
				// make sure all sub-items are excluded
				for (labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					lab = catalog.labels[labelId];
					currentSelectionState.labels[labelId] = 0;
					for (albumId in lab.albums) {
						if (!lab.albums.hasOwnProperty(albumId)) continue;
						currentSelectionState.albums[albumId] = 0;
					}
				}
			} else {
				// check the labels
				for (labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					if (currentSelectionState.labels[labelId] === 0) {
						// label is excluded. make sure albums are too
						lab = catalog.labels[labelId];
						for (albumId in lab.albums) {
							if (!lab.albums.hasOwnProperty(albumId)) continue;
							currentSelectionState.albums[albumId] = 0;
						}
					}
				}
			}
		}
	}

	/**
	 * Shows descendents of itemId, potentially loading them off the server
	 * @param {string} itemType (catalog|label). albums have no descendents we care about
	 * @param {int} itemId the id of the item whose descendents we're interested in
	 */
	function expandSelectionItem(itemType, itemId) {
		var newType = (itemType == 'catalog' ? 'label' : 'album');
		var cont = $j('.selector#' + newType + 's ul');
		cont.find('li').remove();
		if (itemType == 'catalog') {
			selectedCatalogId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var labels = selectionHierarchy[itemId].labels;
			// sort
			var sortedLabels = [];
			for (var labelId in labels) {
				if (!labels.hasOwnProperty(labelId)) continue;
				labels[labelId].id = labelId;
				sortedLabels.push(labels[labelId]);
			}
			sortedLabels.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			sortedLabels.each(function(c, lab) {
				addSelectionItem(cont, newType, lab.id, lab.name);
			});
			// we have to empty the albums if this changes
			$j('.selector#albums ul').find('li').remove().end().append('<li class="empty">Select a label to see albums</li>');
		} else {
			selectedLabelId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var albums = selectionHierarchy[selectedCatalogId].labels[itemId].albums;
			// sort
			var sortedAlbums = [];
			for (var albumId in albums) {
				if (!albums.hasOwnProperty(albumId)) continue;
				sortedAlbums.push({ name : albums[albumId], id : albumId });
			}
			sortedAlbums.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			sortedAlbums.each(function(c, alb) {
				addSelectionItem(cont, newType, alb.id, alb.name);
			});
		}
	}


	//////////////////////////////////////////
	// Delivery Approval Functions
	//////////////////////////////////////////

	function deliveryApproval(container, deliveryIds) {
		var template = templates.get('delivery_approval');

		// get all the details
		ajax({ p : 'file_delivery', action : 'get_delivery_confirmation_details', deliveryIds : deliveryIds }, function(data) {
			if (!data || data.error) {
				sa.notify({ text : data.error });
				return sa.router.routeTo('/admin?p=file_delivery&tab=recipients');
			}

			var deliveries = data['deliveries'];
			var transferDetails = data['transferDetails'];
			var recipientContainer = template.find('.recipient_details_container');
			var recipientTemplateBase = template.find('.recipient_details').detach();
			var getDeliveryDetailsFunctions = [];

			template.find('.transfer_files .value').html(transferDetails.files.numberFormat() + ' files across ' + transferDetails.tracks.numberFormat() + ' tracks');
			template.find('.transfer_data .value').html(transferDetails.required.sizeFormat() + ' (' + transferDetails.required.numberFormat() + ' bytes)');
			template.find('.transfer_account .value').html(transferDetails.left == -1 ? 'Unlimited' : transferDetails.left.sizeFormat() + ' (' + transferDetails.left.numberFormat() + ' bytes)');
			template.find('.edit_files').attr('href', '/admin?' + $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliverySelection', deliveryIds : deliveryIds }));
			if (transferDetails.left != -1 && transferDetails.required > transferDetails.left) {
				template.find('.insufficient_transfer').show();
			}
			template.find('.purchase_more').on('click', function() {
				purchaseModal.show('file_delivery_1tb', function(success) {
					if (success) {
						sa.notify({ text : 'Additional transfer purchased!', type : sa.notify.notificationTypes.success });
						sa.router.reloadPage();
					}
				});
			});

			deliveries.each(function(number, delivery) {

				/** @var {{ delivery_id : string, metadata_only : string, name : string, metadata_format : string, metadata_location : string, metadata_filename_format : string, metadata_embedding : string, folder_structure : string, folder_filename_format : string, track_filename_format : string, album_art : string, album_art_filename_format : string, recipient_id : string, formats : string[], ftp_type : string, email : string }} details */
				var details = delivery.details;
				var fields = delivery.fields;
				var metadataOnly = details.metadata_only == '1';
				var formats = [];
				var recipientTemplate = recipientTemplateBase.clone();

				// add the recipient number
				if (deliveries.length > 1) {
					recipientTemplate.find('.recipient_number').html(number + 1);
				} else {
					recipientTemplate.find('.remove_recipient').remove();
				}

				// add some values!
				recipientTemplate.find('.recipient_name .value').html(htmlEncode(details.name));
				recipientTemplate.find('.metadata_format .value').html(details.metadata_format == 'none' ? 'None' : details.metadata_format.toUpperCase());
				recipientTemplate.find('.metadata_location .value').html(details.metadata_format == 'none' ? 'N/A' : (details.metadata_location == 'one' ? 'Put all file(s) in the main folder' : 'Put separate file(s) in each folder with tracks'));
				recipientTemplate.find('.metadata_filename_format .value').html(details.metadata_format == 'none' ? 'N/A' : details.metadata_filename_format);
				recipientTemplate.find('.metadata_only .value').html(details.metadata_only == '1' ? 'Yes' : 'No');
				if (metadataOnly) {
					recipientTemplate.find('.metadata_embedding, .folder_structure, .folder_names, .filenames, .formats, .album_art, .album_art_filename_format').hide();
				} else {
					recipientTemplate.find('.metadata_embedding .value').html(details.metadata_embedding == '-1' ? 'No' : 'Yes');
					recipientTemplate.find('.folder_structure .value').html(details.folder_structure == 'none' ? 'No folder' : (details.folder_structure == 'albums' ? 'A folder for each album' : 'A folder per nested track'));
					recipientTemplate.find('.folder_names .value').html(details.folder_structure == 'none' ? 'N/A' : details.folder_filename_format);
					recipientTemplate.find('.filenames .value').html(details.track_filename_format);
					if (details.formats.indexOf('m') != -1) formats.push('mp3');
					if (details.formats.indexOf('a') != -1) formats.push('aiff');
					if (details.formats.indexOf('w') != -1) formats.push('wav');
					recipientTemplate.find('.formats .value').html(formats.length == 1 ? formats[0] : (formats.length == 2 ? formats[0] + ' and ' + formats[1] : formats[0] + ', ' + formats[1] + ', and ' + formats[2]));
					recipientTemplate.find('.album_art .value').html(details.album_art == '1' ? 'Yes' : 'No');
					recipientTemplate.find('.album_art_filename_format .value').html(details.album_art == '1' ? details.album_art_filename_format : 'N/A');
					recipientTemplate.find('.edit_details').attr('href', '/admin?p=file_delivery&tab=recipients&action=recipientDeliveryOrganization&recipientId=' + details.recipient_id);
				}

				// fields
				if (details.metadata_format == 'none') {
					recipientTemplate.find('.fields').hide();
				} else {
					var fieldContainer = recipientTemplate.find('.fields table'),
						fieldBase = $j('<tr><td class="name"></td><td class="field"></td></tr>');
					for (var i = 0, len = fields.length; i < len; i++) {
						/** @var {{ name : string, internalName : string }} field */
						var field = fields[i];
						var fieldCont = fieldBase.clone();
						fieldCont.find('.field').html(htmlEncode(field.internalName));
						fieldCont.find('.name').html(htmlEncode(field.name));
						fieldContainer.append(fieldCont);
					}

					recipientTemplate.find('.edit_fields').attr('href', '/admin?p=file_delivery&tab=recipients&action=recipientDeliveryMapping&recipientId=' + details.recipient_id);
				}

				// transfer
				recipientTemplate.find('.transfer_files .value').html(transferDetails.files.numberFormat() + ' files in ' + transferDetails.tracks.numberFormat() + ' tracks');
				if (delivery.required > 0) {
					recipientTemplate.find('.transfer_data .value').html(delivery.required.sizeFormat() + ' (' + delivery.required.numberFormat() + ' bytes)');
				} else {
					recipientTemplate.find('.transfer_data .value').html('Metadata-only deliveries are free');
				}
				recipientTemplate.find('.remove_recipient').on('click', function() {
					var deliveryIndex = deliveryIds.indexOf(details.delivery_id);
					if (deliveryIndex !== -1) {
						deliveryIds.splice(deliveryIndex, 1);
						sa.router.routeTo('/admin?' + $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliveryApproval', deliveryIds : deliveryIds }));
					}
				});

				// recipient
				recipientTemplate.find('input[name=recipientEmail]').val(details.email);
				recipientTemplate.find('input[name=ftpEmail]').val(user.userData.email);
				if (details.ftp_type == 'none') {
					recipientTemplate.find('option[value=ftp]').remove();
				}
				recipientTemplate.find('select[name=sendType]').on('change', function() {
					if (this.value == 'email') {
						recipientTemplate.find('.email_options').stop(true).slideDown();
						recipientTemplate.find('.ftp_options').stop(true).slideUp();
					} else if (this.value == 'ftp') {
						recipientTemplate.find('.email_options').stop(true).slideUp();
						recipientTemplate.find('.ftp_options').stop(true).slideDown();
					} else {
						recipientTemplate.find('.email_options').stop(true).slideUp();
						recipientTemplate.find('.ftp_options').stop(true).slideUp();
					}
				});

				// make it easy to save
				getDeliveryDetailsFunctions.push(function() {
					return {
						id : details.delivery_id,
						sendType : recipientTemplate.find('select[name=sendType]').val(),
						recipientEmail : recipientTemplate.find('input[name=recipientEmail]').val(),
						emailMessage : recipientTemplate.find('textarea[name=emailMessage]').val(),
						ftpEmail : recipientTemplate.find('input[name=ftpEmail]').val()
					};
				});

				recipientContainer.append(recipientTemplate);
			});

			// sending
			template.find('.save').on('click', function() {
				var vars = {
					details : []
				};
				getDeliveryDetailsFunctions.each(function (i, func) {
					vars.details.push(func());
				});
				// console.log(vars);
				template.find('.general_error').hide();
				ajax(vars, function(response) {
					response = response[0];
					if (response.success) {
						sa.notify({ text : 'File Deliveries Processed!', type : sa.notify.notificationTypes.success });
						return sa.router.routeTo('/admin?' + $j.param({ p : 'file_delivery', tab : 'recipients', action : 'deliveryConfirmation', deliveryIds : deliveryIds }));
					} else {
						template.find('.general_error').html(response.error).show();
						sa.scrollToElement(template.find('.general_error'));
						sa.notify({ text : response.error });
					}
				}, 'POST', 'p=file_delivery&action=confirm_transfer');
			});

			template.find('select[name=sendType]').trigger('change');
		});

		container.empty().append(template);
	}


	//////////////////////////////////////////
	// Delivery Confirmation Functions
	//////////////////////////////////////////

	function deliveryConfirmation(container, deliveryIds) {
		var template = templates.get('delivery_confirmation');

		var recipientDetailsContainer = template.find('.recipient_details_container');
		var recipientDetailsTemplate = recipientDetailsContainer.find('.recipient_details').detach();

		// get all the details
		ajax({ p : 'file_delivery', action : 'get_delivery_results', deliveryIds : deliveryIds }, function(response) {
			if (!response.length || response[0].error) {
				sa.alert({ text : response[0].error });
				return;
			}

			response.each(function(i, deliveryResult) {

				var deliveryResultTemplate = recipientDetailsTemplate.clone();
				deliveryResultTemplate.find('.recipient_name').html(htmlEncode(deliveryResult.name));

				if (deliveryResult.sendType == 'email') {
					deliveryResultTemplate.find('.link, .ftp').hide();
					deliveryResultTemplate.find('.email').show();
					deliveryResultTemplate.find('.title').html('Files Delivered!');
					deliveryResultTemplate.find('.emails').html(htmlEncode(deliveryResult.email));
				} else if (deliveryResult.sendType == 'ftp') {
					deliveryResultTemplate.find('.link, .email').hide();
					deliveryResultTemplate.find('.ftp').show();
					deliveryResultTemplate.find('.title').html('Files Queued for Delivery!');
					deliveryResultTemplate.find('.emails').html(htmlEncode(deliveryResult.email));
				} else {
					deliveryResultTemplate.find('.email, .ftp').hide();
					deliveryResultTemplate.find('.link').show();
					deliveryResultTemplate.find('.title').html('Files Ready to Send!');
					deliveryResultTemplate.find('.delivery_link').val(deliveryResult.link).on('keydown', function() { return false; });

					loadScript(ExtraScripts.clipboard, function() {
						var cp = new Clipboard('.copy_button', {
							target : function() { return deliveryResultTemplate.find('.delivery_link')[0]; }
						});
						cp.on('success', function() {
							sa.notify({ text : 'Copied to clipboard!', type : sa.notify.notificationTypes.success });
						});
						cp.on('error', function() {
							sa.notify({ text : 'Press Cmd+C to copy' });
						});
					});
				}

				recipientDetailsContainer.append(deliveryResultTemplate);

			});
		});

		container.empty().append(template);
	}


	//////////////////////////////////////////
	// Filename Functions
	//////////////////////////////////////////

	/** @var {{ steps : Array, modifiers : Array }} */
	var filenameOptions;
	var exampleTracks;
	function showFilenameEditor(container, stepType) {
		if (!filenameOptions) {
			return ajax('p=file_delivery&action=get_filename_options', function(response) {
				filenameOptions = response[0];
				return showFilenameEditor(container, stepType);
			});
		}
		var editor = templates.get('filename_editor');
		container.append(editor);
		inputToSteps(editor, stepType);
		if (exampleTracks) {
			updateFilenameEditorSampleTracks(editor, stepType);
		} else {
			ajax('p=track_info&show=5&customs=1', function(response) {
				exampleTracks = response;
				updateFilenameEditorSampleTracks(editor, stepType);
			});
		}
		editor.slideDown();
		container.find('input:first').off().on('keyup', function() {
			inputToSteps(editor, stepType);
		});
	}

	function inputToSteps(container, stepType) {
		var input = container.parent().find('input:first'),
			val = input.val(),
			parts;

		if (val == '') {
			val = input.attr('default');
			input.val(val);
		}

		parts = val.match(/([^{]+)|({[^}]+})/g);

		container.find('.steps').empty();
		for (var i = 0, len = parts.length; i < len; i++) {
			var part = parts[i],
				step = addStep(container, stepType),
				partKey = 'text',
				partMatches,
				modifiers = [];

			if (partMatches = part.match(/^{([^}]+)}$/)) {
				var splits = partMatches[1].split(':');
				partKey = splits.splice(0, 1)[0];
				modifiers = splits;
			}
			// console.log('part key is', partKey, 'from', part);
			let customPartMatches;
			if (customPartMatches = partKey.match(/^"[a-z]+"=(.*)$/i)) {
				step.find('select[name=type]').append(new Option(customPartMatches[0], partKey, true, true));
			} else {
				step.find('select[name=type]').val(partKey);
			}
			changeStepType(container, stepType, step, true);
			if (partKey == 'text') {
				step.find('.text_input input').val(part);
			}
			if (modifiers.length) {
				for (var m = 0, mLen = modifiers.length; m < mLen; m++) {
					var modString = modifiers[m],
						modifier = addModifier(container, stepType, step),
						modSplit,
						modType;
					modSplit = modString.match(/^([a-z]+)\(([^)]+)\)/i);
					if (!modSplit) {
						// console.log('unable to parse modifier', modString);
						modifier.remove();
						continue;
					}
					modType = modSplit[1];
					modSplit = modSplit[2].split(',');
					modifier.find('select[name=type]').val(modType);
					changeModifierType(container, stepType, modifier, true);
					for (var s = 0, sLen = modSplit.length; s < sLen; s++) {
						var vars = modSplit[s].split('=');
						modifier.find('input[name=' + vars[0] + ']').val(vars[1]);
					}
				}
			}
		}
		updateFilenameEditorSampleTracks(container, stepType);
	}

	function addStep(container, stepType, location) {
		var step = templates.get('filename_editor_step');

		// add the types
		var typeList = step.find('select[name=type]');
		for (var i = 0, len = filenameOptions.steps[stepType].length; i < len; i++) {
			var stepData = filenameOptions.steps[stepType][i];
			typeList.append('<option value="' + stepData.key + '">' + htmlEncode(stepData.name) + '</option>');
		}
		typeList.on('change', function() {
			changeStepType(container, stepType, step);
		});
		// if location isn't passed in, the caller will probably set up the step data so we can skip pre-populating it
		if (location !== undefined) {
			typeList.trigger('change');
		}

		// make the modification button work
		step.find('.add_modifier').on('click', function() {
			addModifier(container, stepType, step);
		});

		// make the add step buttons work
		step.find('.above').on('click', function() {
			var newStep = addStep(container, stepType, step.index() - 1);
			changeStepType(container, stepType, newStep);
		});
		step.find('.below').on('click', function() {
			var newStep = addStep(container, stepType, step.index());
			changeStepType(container, stepType, newStep);
		});
		step.find('.remove').on('click', function() {
			step.remove();
			stepsToInput(container, stepType);
		});

		// add the step to the list
		function updateStepAfterThats() {
			container.find('.step .after_that').html('After that, put');
			container.find('.step:first .after_that').html('Start with');
		}
		function updateStepRemoveButtons() {
			if (container.find('.step').length == 1) {
				container.find('.step .remove').hide();
			} else {
				container.find('.step .remove').show();
			}
		}
		if (location !== undefined) {
			if (location == -1) {
				container.find('.steps').prepend(step);
				updateStepAfterThats();
				updateStepRemoveButtons();
				return step;
			}
			var afterStep = container.find('.step:eq(' + location + ')');
			if (afterStep.length) {
				afterStep.after(step);
				updateStepAfterThats();
				updateStepRemoveButtons();
				return step;
			}
		}
		container.find('.steps').append(step);
		updateStepAfterThats();
		updateStepRemoveButtons();
		return step;
	}

	function addModifier(container, stepType, step) {
		var modifier = templates.get('filename_editor_modifier');

		// make the type select work
		var typeList = modifier.find('select[name=type]');
		for (var i = 0, len = filenameOptions.modifiers.length; i < len; i++) {
			var modType = filenameOptions.modifiers[i];
			typeList.append('<option value="' + modType.key + '">' + htmlEncode(modType.name) + '</option>');
		}
		typeList.on('change', function() {
			changeModifierType(container, stepType, modifier);
		});

		// add the modification
		step.find('.modifiers').append(modifier);
		return modifier;
	}

	function changeModifierType(container, stepType, modifier, skipInputUpdate) {
		var modKey = modifier.find('select[name=type]').val(),
			modData = getModifierData(modKey),
			additionalFieldsContainer = modifier.find('.additional_fields');
		if (!modData) {
			modData = { description : '', additionalFields : [] };
		}
		modifier.find('.description').html(modData.description);

		// add all the additional fields for this modifier
		additionalFieldsContainer.empty();
		for (var i = 0, len = modData.additionalFields.length; i < len; i++) {
			var field = modData.additionalFields[i],
				fieldTemplate = modifier.find('.field_templates .field_' + field.type).clone();

			fieldTemplate.find('.name').html(htmlEncode(field.name) + ':');
			fieldTemplate.find('input').attr('name', field.key);

			fieldTemplate.find('input').on('keyup', function(field) { return function() {
				// do some validation
				if (field.type == 'int') {
					this.value = this.value.replace(/[^0-9]/g, '');
				}
				stepsToInput(container, stepType);
			}; }(field));

			additionalFieldsContainer.append(fieldTemplate);
		}

		// push the updates
		if (!skipInputUpdate) {
			stepsToInput(container, stepType);
		}
	}

	function changeStepType(container, stepType, step, skipInputUpdate) {
		var stepKey = step.find('select[name=type]').val(),
			stepData = getStepData(stepKey, stepType);
		step.find('.description').html(stepData.description);
		if (stepData.text) {
			step.find('.text_input').show();
			step.find('.text_input .title').html(htmlEncode(stepData.name));
			step.find('.text_input .text_description').html(stepData.description);
			step.find('.text_input input').val('').off().on('keyup', function() {
				stepsToInput(container, stepType);
			});
		} else {
			step.find('.text_input').hide();
		}
		if (stepData.allowModifiers === false) {
			step.find('.add_modifier, .modifiers').hide();
		} else {
			step.find('.add_modifier, .modifiers').show();
		}
		if (!skipInputUpdate) {
			stepsToInput(container, stepType);
		}
	}

	/**
	 * @param {string} key
	 * @param {string} stepType
	 * @return {{ description : string, name : string, allowModifiers : boolean }}
	 */
	function getStepData(key, stepType) {
		let customPartMatches;
		if (customPartMatches = key.match(/^"([a-z]+)"=(.*)$/i)) {
			return { description : '', name : customPartMatches[1], allowModifiers : false, value : customPartMatches[2] };
		}
		for (var i = 0, len = filenameOptions.steps[stepType].length; i < len; i++) {
			var step = filenameOptions.steps[stepType][i];
			if (step.key == key) return step;
		}
		return { description : '', name : '', allowModifiers : false };
	}

	function getModifierData(key) {
		for (var i = 0, len = filenameOptions.modifiers.length; i < len; i++) {
			var mod = filenameOptions.modifiers[i];
			if (mod.key == key) return mod;
		}
		return null;
	}

	function stepsToInput(container, stepType) {
		// console.log('generating input from steps');
		var input = container.parent().find('input:first'),
			string = '',
			steps = container.find('.step');
		for (var i = 0, len = steps.length; i < len; i++) {
			var step = $j(steps[i]),
				stepKey = step.find('select[name=type]').val(),
				modifiers = step.find('.modifier'),
				modifierString = '';

			// build the modifier string
			for (var m = 0, mLen = modifiers.length; m < mLen; m++) {
				var mod = $j(modifiers[m]),
					modType = mod.find('select[name=type]').val(),
					modData = getModifierData(modType),
					additionalFields = mod.find('.additional_fields input'),
					additionalFieldString = '';
				if (!modData) continue; // probably just selected none
				modifierString += ':' + modData.key;
				for (var a = 0, aLen = additionalFields.length; a < aLen; a++) {
					var additionalField = $j(additionalFields[a]);
					additionalFieldString += ',' + additionalField.attr('name') + '=' + additionalField.val();
				}
				if (additionalFieldString.length) {
					modifierString += '(' + additionalFieldString.substring(1) + ')';
				}
			}

			if (stepKey == 'text') {
				string += step.find('.text_input input').val();
			} else {
				string += '{' + stepKey + modifierString + '}';
			}
		}
		input.val(string);
		updateFilenameEditorSampleTracks(container, stepType);
	}

	function updateFilenameEditorSampleTracks(container, stepType) {
		if (!exampleTracks) {
			return container.find('.examples').append('<tr><td>Loading example tracks...</td></tr>');
		}
		if (exampleTracks.length < 2) {
			return container.find('.examples').append('<tr><td>Upload some tracks on your workspace to see examples</td></tr>');
		}
		var exampleTemplate = $j('<tr class="example"><td class="original"><a href="" class="filename" target="_blank"></a></td><td class="preview"></td></tr>'),
			exampleList = container.find('.examples').empty();
		for (var t = 1, tLen = exampleTracks.length; t < tLen; t++) {
			var track = exampleTracks[t],
				steps = container.find('.step'),
				exampleString = '',
				example = exampleTemplate.clone();
			for (var i = 0, len = steps.length; i < len; i++) {
				var step = $j(steps[i]),
					stepData = getStepData(step.find('select[name=type]:first').val(), stepType),
					stepString = '',
					modifiers = step.find('.modifier');

				// determine the base step value
				if (stepData.text) {
					stepString = step.find('.text_input input').val();
				} else if (stepData.value) {
					stepString = stepData.value;
				} else if (stepData.field) {
					var val = track;
					for (var f = 0, fLen = stepData.field.length; f < fLen; f++) {
						if (val[stepData.field[f]]) {
							val = val[stepData.field[f]];
						} else {
							val = '';
							break;
						}
					}
					if (val && stepData.regex) {
						val = val.replace(new RegExp(stepData.regex[0]), stepData.regex[1]);
					}
					stepString = val;
					// apply zip filename filters
					stepString = stepString.replace('/', '');
					stepString = stepString.replace('\\', '');
					stepString = stepString.replace(/^\.+/g, '');
				}

				// apply any modifiers
				for (var m = 0, mLen = modifiers.length; m < mLen; m++) {
					var mod = $j(modifiers[m]),
						modType = mod.find('select[name=type]').val(),
						modData = getModifierData(modType),
						additionalFields = mod.find('.additional_fields input'),
						additionalFieldValues = {};
					if (!modData) continue; // probably just selected none
					for (var a = 0, aLen = additionalFields.length; a < aLen; a++) {
						var additionalField = $j(additionalFields[a]);
						additionalFieldValues[additionalField.attr('name')] = additionalField.val();
					}
					if (modData.regex) {
						var regexString = modData.regex[0];
						for (var key in additionalFieldValues) {
							if (!additionalFieldValues.hasOwnProperty(key) || !additionalFieldValues[key]) continue;
							regexString = regexString.replace('$' + key, additionalFieldValues[key]);
						}
						stepString = stepString.replace(new RegExp(regexString), modData.regex[1]);
					} else if (modData.code == 'minLen') {
						while (additionalFieldValues.character && stepString.length < additionalFieldValues.length) {
							stepString = additionalFieldValues.character + stepString;
						}
					} else if (modData.code == 'lcase') {
						stepString = stepString.toLowerCase();
					} else if (modData.code == 'ucase') {
						stepString = stepString.toUpperCase();
					} else if (modData.code == 'remove') {
						stepString = stepString.replace(new RegExp('[' + additionalFieldValues['characters'].replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\/-]', 'g'), '\\$&') + ']', 'g'), '');
					}
				}

				// add it to the example
				exampleString += stepString;
			}
			example.find('.filename').attr('href', '/track/' + track.id).html(track.file.filename);
			example.find('.preview').text(exampleString);
			exampleList.append(example);
		}
	}

}
/**
 * The page in the admin panel that lets you set up file deliveries
 */
function AdminFoxAR() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, el) {
		/**
		 * Fox AR permissions (also used in admin/admin.js so change in both places)
		 */
		let allowedFoxAREmails = [
			'simon.kim@fox.com',
			'alekhya.kurra@fox.com',
			'soujanya.achyuta2@fox.com',
			'nabeel.ahmad@fox.com',
			'melissa.stern@foxcable.com',
		];
		let allowedWhites = [2068, 4925];
		let foxARShow = allowedWhites.includes(config.id) && (allowedFoxAREmails.includes(user.userData.email.toLowerCase()) || user.hasAdminPermission(AdminPermission.SuperAdmin));
		/** *** */
		if (!foxARShow) {
			return el.append('<h3 class="permission_denied">You don\'t have permission to access this page. You need to request special access from us.</h3>');
		}

		let vars = sa.router.paramsToVars(params);
		if (!$j('.right_body.foxar').length) {
			var callback = function(tabId, cont) { page.setPage(tabId, cont); };
			let baseUrl = siteBaseUrl();
			var tabs = [
				new RightTab('liveevents', baseUrl + '/admin?p=foxar&tab=liveevents', 'Live Events', callback),
				new RightTab('eschedule', baseUrl + '/admin?p=foxar&tab=eschedule', 'E-chain Schedule', callback),
				new RightTab('admin', baseUrl + '/admin?p=foxar&tab=admin', 'Admin Actions', callback),
				new RightTab('credentials', baseUrl + '/admin?p=foxar&tab=credentials', 'Credentials', callback),
			];

			RightTabbedPage.prototype.show.call(this, 'foxar', el, tabs, '');
		}

		if (!vars.tab) vars.tab = 'liveevents';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		console.log("setting page to", pageId);
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			if (pageId == 'eschedule') {
				currentPage = new AdminFoxARSchedule();
			} else if (pageId == 'admin') {
				currentPage = new AdminFoxARAdminActions();
			} else if (pageId == 'credentials') {
				currentPage = new AdminFoxARCredentials();
			} else {
				currentPage = new AdminFoxARLiveEvents();
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container, page);


		// Bind collapsers
		container.off('click.collapse').on('click.collapse', '.collapser', function(e) {
			let $el = $j(this);
			$el.toggleClass('open');
			let $target = $el.siblings('.collapse-target');
			if ($el.hasClass('open')) {
				$el.find('.fa').removeClass('fa-chevron-up').addClass('fa-chevron-down');
				$target.slideDown();
			} else {
				$el.find('.fa').addClass('fa-chevron-up').removeClass('fa-chevron-down');
				$target.slideUp();

			}

		});
		console.log("should be sliding up collapse targets");
		container.find('.collapse-target').slideUp();
	};
	this.parseFormData = function($form) {
		$form.find('input[type="checkbox"]').each(function() {
			if ($j(this).is(':checked')) {
				$j(this).attr('value', 'true');
			} else {
				$j(this).attr('value', 'false');
			}
		});
		console.log('checkbox inputs', $form.find($form.find('input[type="checkbox"]')));
		var formData = $form.serializeArray().reduce(function(obj, item) {
			obj[item.name] = item.value;
			return obj;
		}, {});

		return formData;
	};
	this.bindFormSubmits = function(container) {
		// Bind form submits
		container.on('submit', 'form', function(e) {
			e.preventDefault();
			var formData = page.parseFormData($j(this));

			let $form = $j(e.target);
			let $loader = $form.siblings(".loader");
			let $status = $form.siblings(".status");

			// Check form is not empty if applicable
			if ($form.attr('noempty') == 'true') {
				let isEmpty = Object.values(formData).filter(_.isEmpty).length > 0;
				console.log(formData);
				if (isEmpty) {
					console.log("was empty");
					$status.addClass('bg-no').text("Error: all fields must be filled out.");
					$form.addClass('show');
					return;
				}
			}
			$loader.addClass('show');
			$form.removeClass('show');
			$status.removeClass('bg-yes bg-no').text('').removeClass('show');
			const action = $form.attr('action');
			console.log("- form submitted, would be making request", action, $form.attr('confirm'));
			// if form has attr confirm, use that
			let confirm = $form.attr('confirm') == 'false' ? false : true;
			page.detectRequest(action, formData, confirm).then((resp) => {
				if (action == "detectResendDetections") {
					// handle errors from detectResendDetections
					const errors = [];
					for (const [envKey, obj] of Object.entries(resp)) {
						if (obj && obj.hasOwnProperty('success') && obj.success === false) {
							const e = _.get(obj, 'error.faultstring', '');

							if (e) {
								errors.push(`Error from ${envKey}: ${e}`);
							}

						}
					}

					if (errors.length) {
						throw new Error(errors.join("\n"));
					}

				}

				$status.addClass('bg-yes').text("Success!");
				// Hacky way of given the tabs a way to do things with the response
				if ($form.data('successCallback') && typeof $form.data('successCallback') == 'function') {
					$form.data('successCallback')(resp, $form);
				}
				if ($form.attr('resetOnFinish')) {
					$form[0].reset();
				}
			})
				.catch((e) => {
					$status.addClass('bg-no').text(e.toString());
					$form.addClass('show');
					// Hacky way of given the tabs a way to do things with the response
					if ($form.data('errorCallback') && typeof $form.data('errorCallback') == 'function') {
						console.error("error", e);
						$form.data('errorCallback')(e, $form);
					}
				})
				.finally(() => {
					$form.addClass('show');
					$loader.removeClass('show');
				});
		});
	};

	this.detectRequest = function(action, formData, confirmBeforeSend = true) {
		console.log("- detect request", 'action', action, 'formData', formData);

		var proceed = false;
		if (confirmBeforeSend && confirm('Are you sure you want to do this?')) {
			proceed = true;
		} else if (!confirmBeforeSend) {
			proceed = true;
		}
		return new Promise((resolve, reject) => {
			if (proceed) {
				return sa.api.request({
					handler: 'detect/fox',
					action: action,
					getData: formData,
				}).then(resp => {
					if (resp.error) {
						return reject(resp.error);
					}
					console.log("- request success", resp);
					return resolve(resp);
				}).catch(e => {
					console.error("- request error", e);
					sa.notify({ text: e.message });
					return reject(e);
				});
			} else {
				return reject('Error: Operation canceled');
			}
		});

	};
	this.formatTable = function(objs, options = {}) {
		options = Object.assign({
			hideHeadings: []
		}, options);

		let $table = $j('<div class="data-grid"></div>');
		var headings = objs.reduce((prev, cur) => _.uniq(prev.concat(Object.keys(cur))), []);
		// Render headings
		$table.append(headings.map(h => {
			if (options.hideHeadings.includes(h)) {
				return `<div class="heading"></div>`;
			} else {
				return `<div class="heading">${h}</div>`;

			}
		}).join(''));
		// Set number of columns
		$table.css({
			gridTemplateColumns: `repeat(${headings.length}, max-content)`
		});

		$table.append(objs.map(o => Object.values(o).map(v => `<div class="value">${v}</div>`).join('')).join(''));
		return $table;
	};
}

AdminFoxAR.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you set up file deliveries
 */
function AdminFoxARLiveEvents() {
	let page = this;
	var parent;
	let currentTab = '';
	let currentPage;
	var templates = sa.templates.get('admin.foxar');
	var container;
	var $grid;

	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, el, panel) {
		const seriesLoadScripts = (scriptNames, callback) => {
			if (scriptNames.length == 0) return callback();
			const script = scriptNames.shift();
			loadScript(script, () => {
				seriesLoadScripts(scriptNames, callback);
			}, true)
		}


		parent = panel;
		container = templates.get('foxar', { baseUrl: siteBaseUrl() });
		var grid = templates.get('program_grid')

		seriesLoadScripts([ExtraScripts.videoJs, ExtraScripts.flvJs, ExtraScripts.videoFlvJs], () => {
			container.append(grid);
			this.hideLoader()
			el.empty().append(container);

			parent.bindFormSubmits(container);
			this.bindEvents(container)
			$grid = container.find('.program-grid')
		})

	};

	this.renderGrid = function (response) {
		const programs = response.traffic_codes;
		const sfenvs = response.sf_environments;
		// Empty the container on slideup
		console.log("rendering grid")
		$grid = container.find('.program-grid');
		$grid.empty()
		var accordion = new sa.collapsingAdminPage();

		for (let [trafficCode, program] of Object.entries(programs)) {
			let $row = templates.get('program_row', { trafficCode: trafficCode });
			page.formatAiringHtml(program, $row)
			accordion.addSection({
				name: trafficCode + (program.timeframes && program.timeframes.length ? ' - ' + program.timeframes[0].channel : ''),
				contents: $row
			})
			// add the sf envs
			const $sfEnvContainer = $j($row).find(".admin-actions .sfenvs");
			for (const env of sfenvs) {
				$sfEnvContainer.append(`
				<div class="form-check">
					<input class="form-check-input" type="radio" name="sfenv" value="${env.id}" />
					<label class="form-check-label">${env.environment}</label>
				</div>`)
			}

		}
		// Render the accordion
		accordion.addToContainer($grid);
		$grid.slideDown();

		// Auto expand if 1 traffic code
		if (Object.keys(programs).length == 1) {
			$grid.find('.faux_button').trigger('click')
		}
	}
	this.formatAiringHtml = function (program, container) {
		console.log("formatting airing html", program)

		let $les = container.find('.les');
		let $eventInfo = container.find('.event-info');


		// Event info
		for (let timeframe of program.timeframes || []) {
			let $infoRow = $j(
				`<li>
					<div class="timeframe data-grid">
						<div class="datum">
							<div class="key">Event:</div>
							<div class="value">${timeframe.event_name}</div>
						</div>
						<div class="datum">
							<div class="key">Channel:</div>
							<div class="value">${timeframe.channel}</div>
						</div>

						<div class="datum">
							<div class="key">Timeframe from LES:</div>
							<div class="value ${timeframe.from_les ? 'bg-yes' : 'bg-no'}">${timeframe.from_les ? 'Yes' : 'No'}</div>
						</div>

						<div class="datum">
							<div class="key">Start:</div>
							<div class="value">${timeframe.start_pacific_pretty}</div>
						</div>

						<div class="datum">
							<div class="key">End:</div>
							<div class="value">${timeframe.end_pacific_pretty}</div>
						</div>
					</div>
				</li>`)
			$eventInfo.find('.timeframes ol').append($infoRow)
		}

		if (program.issues && program.issues.length > 0) {
			container.find('.possible-issues').show().append(program.issues.map(i => `<div class="issue">${i}</div>`).join(''))
		} else {
			container.find('.possible-issues').hide();
		}

		if (program.timeframes && program.timeframes.length == 1) {
			$eventInfo.find('.timeframes').remove();
		}

		// LES Reports
		for (let les of program.les || []) {
			let $report = $j('<li><div class="les-report data-grid"></div></li>')
			let wantedData = [
				'Program',
				'Log Date',
				'channel',
				'Traffic ID',
				'Start Pacific',
				'End Pacific',
				'General Event Summary',
				'Notes'
			]

			for (let key of wantedData) {
				const $lesDatum = $j(`<div class="datum ${key.toLowerCase().replace(/\s/g, '_')}"><div class="key">${capitalizeFirstLetter(key)}:</div><div class="value"><span>${les[key]}</span></div></div>`);
				$report.find('.les-report').append($lesDatum)

				let currentVal;
				switch (key) {
					case 'Start Pacific':
						// currentVal = les.event_start.split('.')[0]
						currentVal = les.start_pacific.slice(0, -6)
						break;
					case 'End Pacific':
						// currentVal = les.event_end.split('.')[0]
						currentVal = les.end_pacific.slice(0, -6);
						break;
					case 'channel':
						currentVal = les.station;
						break;
					case 'Traffic ID':
						currentVal = les['Traffic ID'];
						break;
				}
				let $editValue = $lesDatum.find('.value')
				// create fields that can be edited
				if (['Start Pacific', 'End Pacific', 'channel', 'Traffic ID'].includes(key)) {
					$editValue.append('<a class="fas fa-edit edit"></a><a class="fas fa-save save"></a>');
					$editValue.addClass('edit-field')

					$editValue.on('click', '.save', function (e) {
						// TODO: save and then set value to saved
						const saveKey = $editValue.find('input, select').attr('name');
						let saveText = $editValue.find('input,select option:selected').text();
						const saveVal = $editValue.find('input,select').val();
						if (!saveText) saveText = saveVal;
						const prevVal = $editValue.find('span').text();
						
						if (prevVal != saveText && confirm(`Are you sure you want to change LES report #${les.les_id} ${key} from ${prevVal} to ${saveText}?`)) {
							// save and set prev val
							$editValue.find('span').text(saveText)
							const editData = {les: les.les_id }
							editData[saveKey] = saveVal;
							parent.detectRequest('detectUpdateLES', editData, false).then(r => {
								console.log("got les response", r);
							}).catch(e => alert("Error saving LES report: " + e.toString()))
						}

						$editValue.removeClass('editing')
					});
					$editValue.on('click', '.edit', function (e) {
						$editValue.addClass('editing')
					});
				}

				// map the LES report names to the input names for form submission
				if (['Start Pacific', 'End Pacific', 'Traffic ID'].includes(key)) {
					let inputName = ''
					switch (key) {
						case 'Start Pacific':
							inputName = 'start'
							$editValue.prepend(`<input class="edit-input" type="datetime-local" name="${inputName}" step="1" value="${currentVal}" prevValue="${currentVal}"/>`)
							break;
						case 'End Pacific':
							inputName = 'end'
							$editValue.prepend(`<input class="edit-input" type="datetime-local" name="${inputName}" step="1" value="${currentVal}" prevValue="${currentVal}"/>`)
							break;
						case "Traffic ID":
							inputName = 'trafficCode'
							$editValue.prepend(`<input class="edit-input" type="text" name="${inputName}" value="${currentVal}" prevValue="${currentVal}"/>`)
							break;
					}
				}

				if (['channel'].includes(key)) {
					const $stationSelector = templates.get('station_select').addClass('edit-input');
					$stationSelector.find(`[value="${currentVal}"]`).attr('selected', true)
					$editValue.prepend($stationSelector)
				}
			}

			$les.find('ol').append($report);
		}

		// Have Asrun

		let $haveAsrun = $j('<div class="have_asrun datum"><div class="key">Have Asrun:</div><div class="value"></div></div>');
		if (program.have_asrun) {
			$haveAsrun.find('.value').addClass('bg-yes').text("Yes")
		} else {
			$haveAsrun.find('.value').addClass('bg-no').text("No")
		}


		// Have LES
		let $haveLes = $j('<div class="have_les datum"><div class="key">Have LES:</div><div class="value"></div></div>');
		if (program.have_les) {
			$haveLes.find('.value').addClass('bg-yes').text("Yes")
		} else {
			// If no LES report, remove
			$les.remove()
			$haveLes.find('.value').addClass('bg-no').text("No")
		}

		// Have Echain Override
		let $haveEchain = $j('<div class="have_echain_override datum"><div class="key">Echain Override:</div><div class="value"></div></div>');
		if (program.echainOverride && program.echainOverride.length > 0) {
			let echainOverrideText = program.echainOverride.map(a => a.airDatePacific + ' : ' + a.channel).join("<br>")
			$haveEchain.find('.value').text(echainOverrideText)
		} else {
			$haveEchain.find('.value').text("None")

			if (program.timeframes[0] && program.timeframes[0].channel && program.timeframes[0].channel[0] == 'E') {
				$haveEchain.find('.value').addClass('bg-no')
			}
		}



		// Manual Upload
		let $manualUpload = $j('<div class="manual_uploads datum"><div class="key">Video Is Manual Upload:</div><div class="value"></div></div>');
		let $manualUploadStartTime = $j('<div class="manual_upload_start_time datum"><div class="key">Manual Upload Start Time(s):</div><div class="value"></div></div>');
		if (program.manual_uploads && program.manual_uploads.length > 0) {
			$manualUpload.find('.value').addClass('bg-yes').text("Yes")
			$manualUploadStartTime.find('.value').text(program.manual_uploads.map(a => a["Start Time"]).join(','))
		} else {
			// If no LES report, remove
			$manualUpload.find('.value').addClass('bg-no').text("No")
		}

		/**
		 * Asrun / playlist files
		 */
		// Main Event files
		let $mainAsrunFiles = container.find('.main-asrun-files')
		if (program.main_event_airing_files && program.main_event_airing_files.length) {

			for (let file of program.main_event_airing_files) {
				let $file = $j(`<div class="file">${file.basename}</div>`)
				if (file.download_url) {
					$file.append(`<a class="download button" target="_blank" href="${file.download_url || ''}">Download</a>`);
				}
				$mainAsrunFiles.append($file)
			}
		} else {
			$mainAsrunFiles.append("<p>No asrun files for the main event.</p>");
		}
		// Timeframe Asrun files
		let $timeframeAsrunFiles = container.find('.timeframe-asrun-files')
		if (program.timeframe_airing_files && program.timeframe_airing_files.length) {

			for (let file of program.timeframe_airing_files) {
				let $file = $j(`<div class="file">${file.basename}</div>`)
				if (file.download_url) {
					$file.append(`<a class="download button" target="_blank" href="${file.download_url || ''}">Download</a>`);
				}
				$timeframeAsrunFiles.append($file)
			}
		} else {
			$timeframeAsrunFiles.remove()
		}

		// other matching Asrun files
		let $matchingAsrunFiles = container.find('.matching-asrun-files')
		if (program.matching_airing_files && program.matching_airing_files.length) {

			for (let file of program.matching_airing_files) {
				let $file = $j(`<div class="file">${file.basename}</div>`)
				if (file.download_url) {
					$file.append(`<a class="download button" target="_blank" href="${file.download_url || ''}">Download</a>`);
				}
				$matchingAsrunFiles.append($file)
			}
		} else {
			$matchingAsrunFiles.remove()
		}


		let $playlistFiles = container.find('.playlist-files');
		if (program.playlist_files && program.playlist_files.length) {

			for (let file of program.playlist_files) {
				let $file = $j(`<div class="file">${file.basename}</div>`)
				if (file.download_url) {
					$file.append(`<a class="download button" target="_blank" href="${file.download_url || ''}">Download</a>`);
				}
				$playlistFiles.append($file)
			}
		} else {
			$playlistFiles.append('<p>No playlist files found.</p>')
		}

		/**
		 * ASRUNS
		 */

		let $asrunTableContainer = container.find('.asrun-table');
		if (program && program.bareAsrunData.length) {
			let data = program.bareAsrunData.map(a => {
				return {
					"Traffic Code": a.before_dash_material_id || a.base_material_id,
					"Start": a.start_pacific_pretty,
					"End": a.end_pacific_pretty,
					"Channel": a.channel,
					"Title": a.EventName,
					"Billing Reference Code": a.BillingReferenceCode || 'N/A',
					"Filename": a.filename,
					"Playlist Filename": a.playlist_filename,
				}
			})
			let $asrunTable = parent.formatTable(data);
			$asrunTableContainer.append($asrunTable);
		} else {
			$asrunTableContainer.hide()
		}

		/**
		 * Manual uploads
		 */
		let $manualUploadContainer = container.find(".archive-info .manual_uploads");
		function renderManualUploads(program) {
			if (program.manual_uploads && program.manual_uploads.length > 0) {
				$manualUploadContainer.find('.data-grid').empty();
				// Add delete button
				let uploads = program.manual_uploads.map(a => {
					a.Delete = `<div class="delete-manual-upload" data-filename="${a.Filename}">
									<div class="status"></div>
									<div class="flex">
										<a class="button delete">Delete</a>
										<div class="loader hide"><div class="loading-spinner"><i class="fa fa-refresh fa-spin"></i></div></div>
									</div>
								</div>`
					// return everything but the Filename since we don't want to show the filename as a column
					const {Filename, ...output} = a; 
					return output
				})

				// format the table
				let $manualUploadTable = parent.formatTable(uploads);

				// Handle delete clicks
				$manualUploadTable.find('a.delete').on('click', function () {
					let $parent = $j(this).closest('.delete-manual-upload');
					$parent.find('.loader').addClass('show');
					$parent.find('.status').removeClass('show');
					let filename = $parent.data('filename')
					parent.detectRequest('detectRemoveVideo', { filename }, true).then(res => {
						$parent.find('.loader').removeClass('show');

						if (res.error) {
							throw res.error.toString()
						} else {
							let ind = program.manual_uploads.findIndex(a => a.Filename == filename);
							if (ind > -1) {
								program.manual_uploads.splice(ind, 1);
								renderManualUploads(program);
							}
						}
					}).catch(err => {
						$parent.find('.loader').removeClass('show');
						$parent.find('.status').addClass('bg-no show').text("Error deleting: " + err.toString());
					})
				})

				// Render the table
				$manualUploadContainer.find('.data-grid').append($manualUploadTable)
			} else {
				$manualUploadContainer.remove()
			}
		}
		renderManualUploads(program);

		/**
		 * Archives
		 */
		let $archives = container.find(".archive-info .archives .data-grid")
		let renderedArchiveHeader = false
		for (let archive of program.archives || []) {
			let aData = {
				Channel: archive.channel,
				"Start Time": archive.start_pacific_pretty,
				"Manual Upload": archive.is_manual ? 'Yes': 'No',
				Download: `<a class="download button" href="${archive.download_url}" target="_blank">Download</a>`,
			}
			if (!archive.download_url) {
				aData.Download = "Archive no longer exists."
			}

			if (!renderedArchiveHeader) {
				renderedArchiveHeader = true
				$archives.append($j(Object.keys(aData).map(h => `<div class="heading">${h}</div>`).join('')))
				$archives.css({
					gridTemplateColumns: `repeat(${Object.keys(aData).length}, max-content)`
				})
			}

			$archives.append($j(Object.values(aData).map(v => {
				return `<div class="value">${v}</div>`
			}).join('')))
		}


		container.find('.loadAllFeeds').on('click', function (e) {
			e.preventDefault()
			let $button = $j(this)
			let $checkFeeds = $j(this).closest('.check-the-feeds')
			$checkFeeds.append('<div class="message">Loading feed videos...<i class="fa fa-spinner fa-spin"></i></div>')

			let trafficCode = $button.data('traffic-code')
			parent.detectRequest('detectArchiveVideos', { trafficCode: trafficCode }, false).then(resp => {
				$checkFeeds.slideUp();
				console.log("archive vids", resp)
				const feedPlayer = new AdminFoxARFeedVideoPlayer(container.find('.feedVideos'), resp, trafficCode);
			}).catch(e => {
				$checkFeeds.find('.message').addClass('bg-no').text("Error: there was a problem getting the feed videos.")
			})
		})


		/**
		 * Detections
		 */
		let $detections = $j(
			`<div class="collapse-target">
				<p>Note that these are the raw detections.  When we actually send them, if two detections for the same track are within 10 seconds of each other we will merge them, and if a track is not affiliated with one of Fox's sites, we will not send that detection at all.  We will also send detections for deleted tracks, even if they say they are deleted here.</p>
				<p class="red">Detections in RED will not get sent because they are not from Fox Corp or Cleared Commercial Songs.</p>
				<div class="download-csv"><a class="button" href="${config.dev ? "/" + config.dev : ''}/sa/detect/fox/detectGenerateDetectionCsv?trafficCode=${program.traffic_code}" target="_blank">Download Detection CSV</a></div>
				<div class="data-grid"></div>
			</div>`
		)
		let $detectGrid = $detections.find('.data-grid')
		let renderedHeader = false;
		for (let detection of program.detections || []) {
			let $detection = $j('<div class="detection"></div>');
			let materialType = _.get(detection, 'foxAiring.EventMaterialType', '')
			let isLive = ['Live', 'Programme'].includes(materialType)
			let isNonsite = detection.hasOwnProperty('nonsite');
			let noTrackData = typeof detection.trackData == 'string' ? detection.trackData : '';
			let data = {
				"Midpoint": detection.midpoint_pacific_pretty,
				"Type": materialType,
				"Video Link": `<a target="_blank" href="${detection.video_link}">Detection Video</a>`,
				"Duration": detection.duration,
				"Matched Traffic Code": _.get(detection, 'foxAiring.base_material_id', ''),
				"BillingReferenceCode": _.get(detection, 'foxAiring.BillingReferenceCode', 'N/A'),
				"Track Title": _.get(detection, 'trackData.Title', noTrackData),
				"SourceAudio Track ID": _.get(detection, 'trackData.SaID', noTrackData),
				"Channel": detection.channel,
				"Airing Title": _.get(detection, 'foxAiring.EventName', ''),
				"Airing Filename": _.get(detection, 'foxAiring.filename', ''),
				// "Track Catalog": _.get(detection, 'trackData.Catalog', noTrackData),
				// "Track Label": _.get(detection, 'trackData.Label', noTrackData),
				"Fox Site (if Live)": _.get(detection, 'trackData.FoxSite', noTrackData),
			}
			if (!program.detection_track_info) {
				data = _.omit(data, ["Track Title", "Track Catalog", "Track Label", "SourceAudio Track ID"]);
			}
			if (!renderedHeader) {
				$detectGrid.append($j(Object.keys(data).map(h => `<div class="heading">${h}</div>`).join('')))
				$detectGrid.css({
					gridTemplateColumns: `repeat(${Object.keys(data).length}, max-content)`
				})
				renderedHeader = true
			}

			$detectGrid.append($j(Object.values(data).map(v => {
				if (isLive) {
					if (isNonsite) {
						return `<div class="value bolded nonsite">${v}</div>`
					}
					return `<div class="value bolded">${v}</div>`
				} else {
					return `<div class="value">${v}</div>`
				}
			}).join('')))
		}

		if (program.detections && program.detections.length == 0) {
			$detectGrid.append("<h3>There were no detections for this program.</h3>");
		}

		container.find('.detections').append($detections)

		// Format the final HTML
		let $start = ''
		let $end = ''
		let $program = ''
		let $channel = ''
		if (program.timeframes && program.timeframes[0]) {
			$channel = this.genDatum("Channel:", program.timeframes[0].channel)

			$program = this.genDatum("Program:", program.timeframes[0].event_name)
			$start = this.genDatum("Start:", program.timeframes[0].start_pacific_pretty)
			$end = this.genDatum("End:", program.timeframes[0].end_pacific_pretty);
		} else {
			container.find('.timeframes').remove()
		}
		let $numDetections = this.genDatum("Num Live Detections:", program.detections.filter(a => a.foxAiring && ['Live', 'Programme'].includes(a.foxAiring.EventMaterialType) && [a.foxAiring.before_dash_material_id, a.foxAiring.base_material_id].includes(program.traffic_code)).length);
		let $numDetectionsTotal = this.genDatum("Num Total Detections:", program.detections.length);
		let $eventGeneral = $eventInfo.find('.general');
		$eventGeneral.append($program)
			.append($channel)
			.append($haveEchain)
		if (program.manual_uploads && program.manual_uploads.length > 0) {
			$eventGeneral.append($manualUploadStartTime)
		}
		$eventGeneral
			.append($start)
			.append($end)
			.append($haveAsrun)
			.append($haveLes)
			.append($manualUpload)
			.append($numDetections)
			.append($numDetectionsTotal)

	}

	this.showLoader = function () {
		this._loader(true);
	}

	this.hideLoader = function () {
		this._loader(false);

	}

	this.genDatum = function (key, value) {
		let keyClass = key.toLowerCase().replace(/\s/g, '_');
		return $j(
			`<div class="datum">
				<div class="key ${keyClass}">${key}</div>
				<div class="value">${value}</div>
			</div>`
		)
	}
	this._loader = function (show) {
		console.log((show ? 'showing ' : 'hiding ') + ' loader')
		// TODO: show loading
		if (show) {
			container.find('.loader').addClass('show');
		} else {
			container.find('.loader').removeClass('show');
		}
	}

	this.bindEvents = function (container) {
		// Form submit
		// Override normal form submit
		container.find('form.admin-panel').off('submit').on('submit', function (e) {
			page.showLoader();
			var formData = parent.parseFormData($j(this))
			page.search(formData)
			return false;
		})
	}

	this.search = function (formData) {
		console.log("searching", formData)
		$grid.slideUp();
		parent.detectRequest('detectAdminPanel', formData, false).then(resp => {
			console.log("**** admin panel response", resp)
			page.hideLoader();
			page.renderGrid(resp);

		}).catch(e => {

			page.hideLoader();
			$grid.empty()
			$grid.append('<h2>' + e.toString() + '</h2>')
			$grid.slideDown()
		})
	}

	this.formatProgramDataForGrid = function (apiResp) {
		var output = [];
		for (let [code, data] of Object.entries(apiResp)) {
			var program = {
				"Traffic Code": code,
				"Title": data.title,
				"Stations": _.uniq(data.timeframes.map(a => a.station)).join(', '),
				"Airings": data.airings,
				"LES": data.les
			}
			output.push(program)
		}

		return output
	}
}
/**
 * The page in the admin panel that lets you set up file deliveries
 */
function AdminFoxARAdminActions() {
	let page = this;
	let parent;
	let currentTab = '';
	var templates = sa.templates.get('admin.foxar')


	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, el, panel) {
		let container = templates.get('admin_actions');
		el.append(container)
		parent = panel

		panel.bindFormSubmits(container);


		// Override default form handling
		/**
		 * CHECKING EMAILS
		 */
		let $form = container.find('form.check-emails');
		$form.data('successCallback', function (resp) {
			console.log("binding a function to the element!", resp)
			let $loader = $form.siblings(".loader")
			let $status = $form.siblings(".status")

			if (Array.isArray(resp) && resp.length == 0) {
				$status.text("Success!  No messages to parse.")
			}

			if (resp.trafficCodesToSend && resp.trafficCodesToSend.length) {
				$status.html("<div>Success!<br/>Sent traffic codes: " + resp.trafficCodesToSend.join(', ') + '</div>')
			}
		})
		$form.data('errorCallback', function (resp) {
			let $loader = $form.siblings(".loader")
			let $status = $form.siblings(".status")
			let wrongFormat = false;
			// Filter errors
			let errors = resp.filter((a, ind, arr) => {
				if (typeof a == 'string') {
					if (a.toLowerCase().includes('execution time')) {
						return false
					} else if (a.toLowerCase().includes('wrong format')) {
						wrongFormat = true
						return false
					}
				} else if (!Array.isArray(a)) { // remove objects
					return false
				}
				return true
			}).map(a => {
				if (typeof a != 'string') {
					a = a.toString()
				}
				return a
			})
			console.log('errors', errors)

			let badCsvs = errors.filter(a => {
				console.log('error', a)
				if (a.toLowerCase().includes("error processing attachment csv")) {
					return true
				}
				return false
			}).map(a => {
				a = a.replace("Error processing attachment CSV:", '').trim()
				return a;
			})
			if (badCsvs.length) {
				let badCsvList = badCsvs.map(a => `<li>${a}</li>`).join('')
				$status.html(`
				<div>Could not process attachments.  If there were other attachments, they were processed.
					<ul class="errors">${badCsvList}</ul>
				</div>`)
			}
		})


		$j('form.override-asrun').on('submit', function (e) {
			let $form = $j(this);
			let $loader = $form.siblings(".loader")
			let $status = $form.siblings(".status")
			$loader.addClass('show')
			$form.removeClass('show')
			$status.removeClass('bg-yes bg-no').text('').removeClass('show')


			let url = (config.dev ? '/' + config.dev : '') + '/sa/detect/fox/detectOverrideAsrun';
			let baseParams = ajax.getBaseParameters()
			url = url + '?' + baseParams;

			let f = new FormData();
			let xhr = new XMLHttpRequest();

			// add the files to the form data
			$j(this).find('input[type="file"]').each(function () {
				[...$j(this)[0].files].forEach(file => {
					f.append($j(this).attr('name'), file);
				})
			})

			// Display the key/value pairs
			for (var pair of f.entries()) {
				console.log(pair[0] + ', ' + pair[1]);
			}

			xhr.open('POST', url);


			var handleSuccess = function(successText = 'Success!') {
				$status.addClass('bg-yes').text(successText)
				console.log('upload complete');
			}
			var handleError = function(error) {
				$status.addClass('bg-no').text(error);
				$form.addClass('show')
			}

			xhr.addEventListener('load', function () {
				
				if (xhr.status == 200) {
					var response = JSON.parse(xhr.response);
					console.log("xhr response", response)
					if (response.content.error) {
						handleError(response.content.error.toString());
					} else {
						handleSuccess();
					}
				} else {
					console.log('uploader xhr load event error');
				}
			});

			xhr.addEventListener('loadend', function() {
				$form.addClass('show')
				$loader.removeClass('show')
			});

			xhr.addEventListener('abort', function (e) {
				handleError("Error: requested aborted")
				console.log('uploader xhr.abort detected', xhr);
			});

			xhr.addEventListener('error', function (e) {
				handleError("Error: " + e.toString())
				console.log('uploader xhr.error detected', xhr);
			});

			xhr.addEventListener('timeout', function () {
				handleError("Error: timeout.")
				console.log('uploader xhr.timeout detected', xhr);
			});

			xhr.send(f);
			return false;

		})
		// AUTOCOMPLETE remove asruns
		$j(".remove-asrun input.autocomplete-asrunfilename").autocomplete({
			source: (request, response) => {
				sa.api.request({
					handler: 'detect/fox',
					action: 'detectAutocompleteAsrunFilenames',
					getData: { filename: request.term },
				}).then(resp => {
					if (resp.error) {
						return response("Error: " + resp.error)
					}
					console.log("- request success", resp)
					response(resp)
				})
			}
		})

	}
}
/**
 * The page in the admin panel that lets you set up file deliveries
 */


class AdminFoxARFeedVideoPlayer {
	constructor($root, apiResp, trafficCode, options = {}) {
		var templates = sa.templates.get('admin.foxar');

		this.start_timestamp = parseInt(apiResp.start_timestamp)
		this.end_timestamp = parseInt(apiResp.end_timestamp)

		// Populate options with defaults
		options = Object.assign({
			title: "Feed Videos for Timeframe of " + trafficCode,
			subtitle: "This program ran from " + this.formatDate(this.start_timestamp) + " to " + this.formatDate(this.end_timestamp),
		}, options)


		this.$el = templates.get('feed_video_player', {
			title: options.title,
			subtitle: options.subtitle,
			start: this.formatTime(this.start_timestamp),
			end: this.formatTime(this.end_timestamp),
			start_timestamp: this.start_timestamp,
			end_timestamp: this.end_timestamp,
		});
		this.$range = this.$el.find('.video-time-slider');
		this.$currentTime = this.$el.find('.current-time');
		this.$videoRoot = this.$el.find('.feed-videos')
		this.$root = $root;
		this.videos = apiResp.archives.filter(a => a.stream_url != false);
		this.rows = {}
		this.timestamp = 0;

		if (this.videos.length == 0) {
			this.$root.append('<h2>No archival footage found for this period of time</h2>');
			return;
		}


		const feedPlayer = this
		this.$range.on('input', function (e) {
			feedPlayer.setCurrentTimeText(parseInt($j(this).val()))
		})
		this.$range.on('change', function (e) {
			// Get video in that timeframe
			feedPlayer.setCurrentTime(parseInt($j(this).val()));
		});

		// Render it
		this.$root.append(this.$el);
		feedPlayer.setCurrentTime(this.start_timestamp);

	}
	setCurrentTime(timestamp) {
		this.timestamp = timestamp
		this.$range.val(timestamp)
		this.setCurrentTimeText(timestamp)
		this.loadVideosForTime(timestamp)
	}
	setCurrentTimeText(timestamp) {
		this.$currentTime.text(this.formatDate(timestamp))
	}

	formatDate(millis) {
		return new Date(millis).toLocaleString('en-us', { timeZone: 'America/Los_Angeles', timeZoneName: 'short', hour12: false })
	}
	formatTime(millis) {
		return new Date(millis).toLocaleTimeString('en-us', { timeZone: 'America/Los_Angeles', timeZoneName: 'short', hour12: false })
	}
	setVideos(videos) {
		this.videos = videos
	}
	removeVideo(row) {
		if (row.player) {
			row.player.dispose()
		}
		row.$el.find('.video').empty()
		delete row.video
		delete row.player
		this.showNoVideos(row)
	}

	vidHasTime(video, timestamp) {
		return timestamp >= video.start_timestamp && timestamp <= video.end_timestamp;
	}
	renderVideo(video) {
		let station = video.station
		let channel = video.channel
		let row = this.rows[station] || false
		let vidId = "vid-" + video._id;
		if (!row) {
			// Render row for the first time
			let $el = $j(`<div class="station-row" id="station-${station}">
							<div class="titledl">
								<h3>${channel}</h3>
								<a title="Download current video" class="dl" href="" target="_blank"><i class="fas fa-download"></i></a>
							</div>
							<div class="no-videos">Feed was dark for this timeframe.</div>
							<div class="loader"><i class="fa fa-spinner fa-spin"></i></div>
							<div class="video"></div>
						</div>`)
			row = {
				$el: $el,
				station,
				channel,
				video,
			}
			this.$videoRoot.append($el)
		} else {
			if (video._id == row.video._id) {
				console.log("do nothing, video already rendered, setting current time to ", (this.timestamp - video.start_timestamp) / 1000)
				this.seekVideoTime(row, video);
				return
			} else {
				console.log("replacing video")
				this.removeVideo(row)
			}
		}

		let $vid = $j(`
			<video data-video-id="${video._id}" id="${vidId}" class="video-js" controls>
				<source src="${video.stream_url}" type="${video.stream_type}"></source>
			</video>
		`)
		row.$el.find('.video').append($vid);
		row.video = video
		row.player = videojs(vidId, {
			flvjs: {
				// mediaDataSource: {
				// 	type: 'flv',
				// 	isLive: false,
				// withCredentials: false,
				// },
				config: {
					// rangeLoadZeroStart: true,
					reuseRedirectedURL: true,
					// autoCleanupSourceBuffer: true,
					// enableWorker: true,
					// autoCleanupSourceBuffer: true,
				}
			}
		})

		row.player.one('loadedmetadata', () => {
			let ind = _.findIndex(this.videos, { _id: video._id })
			// get duration
			let dur = row.player.duration() // comes as seconds
			video.duration = dur
			video.end_timestamp = video.start_timestamp + (dur * 1000);
			this.videos[ind] = video;

			if (!this.vidHasTime(video, this.timestamp)) {
				this.removeVideo(row);
			} else {
				this.seekVideoTime(row, video);
			}
		})
		this.rows[station] = row
		// this.seekVideoTime(row, video);
		this.showNoVideos(row)
	}
	seekVideoTime(row, video) {
		row.player.currentTime((this.timestamp - video.start_timestamp) / 1000);

		row.player.one('loadeddata', () => {
			console.log("- loaded, seeking to time", video.channel)
			row.player.currentTime((this.timestamp - video.start_timestamp) / 1000);
		})
	}
	showNoVideos(row) {
		if (!row.video) {
			row.$el.find(".no-videos").show()
			row.$el.find('.dl').hide()
		} else {
			row.$el.find('.dl').show().attr('href', row.video.stream_url);
			row.$el.find(".no-videos").hide()
		}
	}

	loadVideosForTime(timestamp) {
		console.log("Loading videos for time", this.formatDate(timestamp))

		let videos = this.videos.filter(v => this.vidHasTime(v, timestamp))
		let stations = _.groupBy(videos, 'station');

		for (let [station, vids] of Object.entries(stations)) {
			if (!vids.length) {
				this.removeVideo(this.rows[station]);
				continue;
			}
			this.renderVideo(vids[0])
		}
	}
}/**
 * The page in the admin panel that lets you set up file deliveries
 */
function AdminFoxARSchedule() {
	let page = this;
	var parent = this;
	let currentTab = '';
	var templates = sa.templates.get('admin.foxar')

	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, el, panel) {
		parent = panel;
		console.log("Showing schedule");
		container = templates.get('echain_schedule');
		el.append(container);
		parent.bindFormSubmits(container);
		this.bindFormSubmits(container);
		this.renderSchedule();
		
	}

	this.renderSchedule = function() {
		parent.detectRequest('detectEchainSchedule', {}, false).then(resp => {
			let tableData = resp.map(e => {
				return {
					"Air Date" : e.airDatePacific,
					"Traffic Code" : e.trafficCode,
					"Station" : e.channel,
					"Remove" : `<a class="remove" data-id="${e._id}"><i class="fa fa-times"></i></a>`
				}
			})

			// Render the table of Echain Mappings
			let $table = parent.formatTable(tableData, {hideHeadings: ["Remove"]});

			// Bind removal links
			$table.find('a.remove').on('click', function(e) {
				e.preventDefault()
				parent.detectRequest("detectRemoveSchedule", {id: $j(this).data('id')}, false).catch(e => {
					alert("Could not delete that mapping. Error: " + e.toString());
				}).then(() => {
					page.renderSchedule();
				})
			})
			container.find(".upcoming .events").empty().append($table);
		})
	}

	this.bindFormSubmits = function(container) {
		container.find('form.save-schedule').data('successCallback', function(resp, $form) {
			$form.siblings('.status').removeClass('show bg-yes bg-no').text('');
			$form[0].reset();
			page.renderSchedule();
		})
	}
}
function AdminFoxARCredentials() {
	let page = this;
	var parent = this;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, el, panel) {
		parent = panel;
		console.log("Showing credentials", el);
		const $container = $j('<div class="admin-foxar-credentials"></div>');
		el.append($container);
		mountReactComponent($container[0], 'admin-foxar-credentials', {});
	}
}
/**
 * The page in the admin panel that lets you manage Ai tools
 */
class AdminInbox {
	constructor() {
		const page = this;

		/**
		 * Sets up the basic framework of the page and its objects
		 * @param {string} params the parameters from the url
		 * @param {JQuery} container
		 */
		this.show = function (params, container) {
			if (!user.hasAdminPermission(AdminPermission.Pando) && !user.hasAdminPermission(AdminPermission.Licensees)) {
				return container.append(`<h3 class="permission_denied">You don't have permission to access this page. You would need the "View Add-Ons and Programs" or the "Manage Music Suppliers &amp; Briefs" permission.</h3>`);
			}
			container.empty().append("<div id='inbox-root'></div>");
			page.container = container;
			$j('.right_head').hide();
			$j('#ltp_container').addClass('admin-inbox');
			window.mountReactComponent(page.container.find('#inbox-root')[0], 'site-inbox', { siteType: config.siteType });
		};

		// /**
		//  * Changes what page the admin is showing
		//  * @param {string} pageId the type of item to load
		//  * @param {JQuery} container where to put the information for the list
		//  */
		// this.setPage = function (pageId, container) {
		// 	currentPage.show(sa.router.getCurrentQueryParams(), container);
		// };
	}
}
AdminInbox.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you manage signup and download requests
 */
function AdminHome() {

	var templates;
	let lastPage = 0;
	let lastShow = 5;
	let lastStatus = 'pending';
	let lastSort = 'date';
	let lastSearch = '';
	let lastType = 'all';
	let lastDepartment = 'all'; // netflix #3777
	
	let permissionProfileSelectors = {};
	
	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.home');
		}
		container.empty();
		if (!user.hasAdminPermission(AdminPermission.Users)) {
			container.append(templates.get('permission_denied', { permission : user.getAdminPermissionDescription(AdminPermission.Users) }));
			return;
		}
		container.append(templates.get('page'));

		if (config.id == 2570) { // netflix #3777
			container.find('#request_search_container').after(templates.get('netflix_department_filter'));
		}		

		let vars = sa.router.getCurrentParamsAsObject();
		if (vars.pg) lastPage = parseInt(vars.pg);
		if (vars.show) lastShow = parseInt(vars.show);
		if (vars.status) {
			lastStatus = vars.status;
			container.find('select#status').val(lastStatus);
		}
		if (vars.sort) {
			lastSort = vars.sort;
			container.find('select#sort').val(lastSort);
		}
		if (vars.search) {
			lastSearch = vars.search;
			container.find('#request_search').val(lastSearch);
		}
		if (vars.type) {
			lastType = vars.type;
			container.find('select#type').val(lastType);
		}
		if (vars.department) { // netflix #3777
			lastDepartment = vars.department;
			container.find('select#department').val(lastDepartment);
		}
		container.find('select').on('change', function() {
			if (this.id === 'sort') {
				lastSort = this.value;
			} else if (this.id === 'request_search') {
				lastSearch = this.value;
			} else if (this.id === 'type') {
				lastType = this.value;
			} else if (this.id === 'department') {
				lastDepartment = this.value;
			} else {
				lastStatus = this.value;
			}
			lastPage = 0;
			loadRequests();
		});
		let keyTimeout = null;
		container.find('#request_search').on('keyup input change', function() {
			let newSearch = this.value;
			if (keyTimeout) clearTimeout(keyTimeout);
			keyTimeout = setTimeout(function() {
				keyTimeout = null;
				if (newSearch !== lastSearch) {
					lastSearch = newSearch;
					lastPage = 0;
					loadRequests();
				}
			}, 250);
		});
		loadRequests();
	};

	/**
	 * Loads the data from the server
	 */
	function loadRequests() {
		let paramPieces = sa.router.getCurrentParamsAsObject();
		if (lastPage !== 0 || paramPieces.pg !== undefined) { // only set if the pg is not 0
			paramPieces.pg = lastPage;
		}
		if (lastShow !== 5 || paramPieces.show !== undefined) {
			paramPieces.show = lastShow;
		}
		if (lastStatus !== 'pending' || paramPieces.status !== undefined) {
			paramPieces.status = lastStatus;
		}
		if (lastType !== 'all' || paramPieces.type !== undefined) {
			paramPieces.type = lastType;
		}
		if (lastDepartment !== 'all' || paramPieces.department !== undefined) { // netflix #3777
			paramPieces.department = lastDepartment;
		}
		if (lastSort !== 'date' || paramPieces.sort !== undefined) {
			paramPieces.sort = lastSort;
		}
		if (lastSearch !== '' || paramPieces.search !== undefined) {
			paramPieces.search = lastSearch;
		}
		if (paramPieces.pg !== undefined || paramPieces.show !== undefined || paramPieces.status !== undefined || paramPieces.sort !== undefined || paramPieces.type !== undefined || paramPieces.department !== undefined) {
			sa.router.routeTo(sa.router.getCurrentPath() + '?' + sa.router.varsToParams(paramPieces));
		}
		
		$j('#request_list').html('Loading...');
		sa.api.request({
			handler : 'user-management',
			action : 'getRequests',
			getData : {
				o : lastSort,
				status : lastStatus,
				type : lastType,
				search : lastSearch,
				pg : lastPage,
				department : lastDepartment,
				show : lastShow
			}
		}).then(setRequests);
	}

	/**
	 * Populates the user list after it's loaded
	 * @param {UserManagementRequestContainer} newData the list of users
	 */
	function setRequests(newData) {
		var container = $j('#request_list').html('');
		var lastDate = '';

		if (newData.result) {
			if (newData['showUserEditLink']) {
				let hrefBase = siteBaseUrl();
				newData.result += '<br/><b><a href="'+hrefBase+'/admin?p=users&tab=edit&user=' + newData['showUserEditLink'] + '">Click here to edit user</a></b>';
			}
			sa.notify({ text : newData.result });
		}

		if (newData['showGettingStarted']) {
			let template = templates.get('get_started_item').append(sa.templates.get('get_started').get('get_started_admin'));
			template.find('.hide_get_started').on('click', function() {
				sa.confirm({
					text : 'The Getting Started notice can be viewed again in the future by clicking on your user image in the upper right.',
					yesText : 'Ok, hide',
					yesFunction : function() {
						sa.api.request({
							handler : 'settings',
							action : 'hideGettingStarted'
						});
						template.remove();
					},
					noText : 'Cancel'
				});
			});
			container.append(template);
		}

		// finish structure
		if (newData.total) {
			permissionProfileSelectors = {};
			let mafExplanation = sa.templates.get('admin.users.create').get('maf_explanation').html();
			newData.requests.each(function(i, r) {
				var requestId = r.id;
				var element;
				if (r.registration) {
					r = r.registration;
					if (lastDate != r.date) {
						container.append(templates.get('date', { date : r.date }));
						lastDate = r.date;
					}
					element = templates.get('registration_request_item', {
						requestId : requestId,
						email : r.email,
						username : r.username,
						date : r.date,
						location : r.location
					});
					if (r.avatar && r.avatar.indexOf('default_editor') === -1) {
						element.find('.request_avatar').removeClass('fas fa-user-circle').html('<img src="' + r.avatar + '" alt="user image"/>');
					}
					
					let permissionProfileSelector = new sa.components.permissionProfileSelector();
					permissionProfileSelector.hideNewAndView();
					permissionProfileSelector.show(element.find('.permission_profile_selector_container'), 'permissionProfiles_' + requestId);
					permissionProfileSelectors[requestId] = permissionProfileSelector;
					sa.components.helpExplanation.show(element.find('.maf_title'), mafExplanation);
					
					var fieldGroup = element.find('.field_group.first');
					// add the extra fields. this is a bit nasty. you could shift some of this to the server but
					// it'd take another db query and i figured it's better to make the client do it
					for (var j = 0; j < r.extraFields.length; j++) {
						var value = r.extraFields[j].value;
						if (value == '') continue; // we don't display empties. this thing's tall enough
						var fieldId = r.extraFields[j].id;
						for (var k = 0, regLen = config.registrationFields.length; k < regLen; k++) {
							var field = config.registrationFields[k];
							if (field.id == fieldId) {
								fieldGroup.append(templates.get('registration_field', { name : field.name, value : value }));
								break;
							}
						}
					}
					// now we need to add the options
					if (r.status != 'n') {
						let status = (r.status == 'a' ? 'Approved' : 'Denied');
						if (r.approver.id) {
							element.find('.options').prepend(templates.get('download_request_item_options_with_approver', { status : status, date : r.responseDate, id : r.approver.id, name : r.approver.username }));
						} else {
							element.find('.options').prepend(templates.get('download_request_item_options', { status : status, date : r.responseDate }));
						}
					}
				} else {
					r = r.download_request;
					if (lastDate != r.date) {
						container.append(templates.get('date', { date : r.date }));
						lastDate = r.date;
					}
					element = templates.get('download_request_item', {
						requestId : requestId,
						requestorId : r.requestor.id,
						username : r.requestor.username,
						link : getTrackLink(r.track.id, 'details'),
						title : r.track.title,
						date : r.date,
						name : r.requestor.name,
						company : r.requestor.company,
						location : r.requestor.location,
						project : r.requestor.project,
						email : r.requestor.email,
						phone : r.requestor.phone
					});
					if (r.status != 'pending') {
						if (r.approver.id) {
							element.find('.options').prepend(templates.get('download_request_item_options_with_approver', { status : r.status.ucfirst(), date : r.response_date, id : r.approver.id, name : r.approver.username }));
						} else {
							element.find('.options').prepend(templates.get('download_request_item_options', { status : r.status.ucfirst(), date : r.response_date }));
						}
					}
				}
				// now we need to add the buttons to the options (if applicable)
				if (r.status == 'pending' || r.status == 'n') {
					element.find('.approve_button').on('click', function() {
						sendApproval(requestId, true, this);
					});
					element.find('.deny_button').on('click', function() {
						sendApproval(requestId, false, this);
					});
				} else {
					element.find('.options .pending_only').remove();
				}
				container.append(element);
			});

			let listControlBar = templates.get('control_bar');
			sa.pagination.addResultsPerPage({
				container : listControlBar,
				resultCounts : [ 5, 10, 25, 100 ],
				resultsPerPage : newData.perPage,
				callback : function(resultCount) {
					lastShow = resultCount;
					lastPage = 0;
					loadRequests();
				}
			});

			sa.pagination.addPagination({
				container : listControlBar,
				totalItems : newData.total,
				perPage : newData.perPage,
				currentPage : newData.page,
				callback : function(pageNumber) {
					lastPage = pageNumber;
					loadRequests();
				}
			});
			container.append(listControlBar);

			container.append('<div class="clr"></div>');

			container.find('.request_item:odd').addClass('stripe');

			if (newData.total > 0 && lastStatus === 'pending') {
				
				let groupControl = templates.get('group_approval_options');

				let groupPermissionProfileSelector = new sa.components.permissionProfileSelector();
				groupPermissionProfileSelector.hideNewAndView();
				groupPermissionProfileSelector.show(groupControl.find('.permission_profile_selector_container'), 'permissionProfiles_0');
				sa.components.helpExplanation.show(groupControl.find('.maf_title'), mafExplanation);

				groupControl.find('.approve_all, .deny_all').on('click', function() {

					var approve = $j(this).hasClass('approve_all');

					sa.confirm({
						text : 'Are you sure?',
						yesText : approve ? 'Approve' : 'Deny',
						yesFunction : function() {
							sa.api.request({
								handler : 'user-management',
								action : 'getRequests',
								getData : {
									o : $j('#filters #sort').val(),
									status : $j('#filters #status').val(),
									department : $j('#filters #department').val(),
									type : $j('#filters #type').val(),
									search : $j('#filters #request_search').val(),
									pg : 0
								},
								postData : {
									approve : approve ? 1 : 0,
									all : 1,
									permissionProfileIds: groupPermissionProfileSelector.getValues(),
									defaultPermissionProfileId : groupPermissionProfileSelector.getDefaultValue()
								}
							}).then(setRequests);
								
						}
					});

				});
				
				container.append(groupControl);
			}
		} else {
			let st = $j('#status').val();
			st = st ? st.toLowerCase() : '';
			container.append(templates.get('no_requests', { type : st }));
		}
	}

	/**
	 * Tells the server about an approval or denial
	 * @param {int} id the user to approve
	 * @param {boolean} approve or not
	 * @param {HTMLElement} button the button that was clicked
	 */
	function sendApproval(id, approve, button) {
		$j('#request_list').html('Loading...');
		sa.api.request({
			handler : 'user-management',
			action : 'getRequests',
			getData : {
				o : $j('#filters #sort').val(),
				status : $j('#filters #status').val(),
				pg : 0
			},
			postData : {
				approve : (approve ? '1' : '0'),
				id : id,
				sendEmail : $j(button).parent().find('input[type=checkbox]:checked').length ? 1 : 0,
				permissionProfileIds : permissionProfileSelectors[id] ? permissionProfileSelectors[id].getValues() : [],
				defaultPermissionProfileId : permissionProfileSelectors[id] ? permissionProfileSelectors[id].getDefaultValue() : -1
			}
		}).then(setRequests);
			
	}

}
/**
 * The page in the admin panel that lets you view and manage your licensing and e-commerce options
 */
function AdminLicensing() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Licensing)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Manage Licensing' + '" permission.</h3>');
		} else if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		let vars = sa.router.paramsToVars(params);
		if (!$j('.right_body.sad').length) {
			let hrefBase = siteBaseUrl();
			
			var callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [
					new RightTab('home', hrefBase + '/admin?p=ecommerce&tab=home', 'Home', callback)
				];

				if (config.licensingConfig.addon) {
					tabs.push( new RightTab('settings', hrefBase + '/admin?p=ecommerce&tab=settings', 'Settings', callback) );
					tabs.push( new RightTab('profiles', hrefBase + '/admin?p=ecommerce&tab=profiles', 'Profiles', callback) );

					if (config.licensingConfig.subscriptions_active) {
						tabs.push( new RightTab('subscriptions', hrefBase + '/admin?p=ecommerce&tab=subscriptions', 'Subscriptions', callback) );
						tabs.push( new RightTab('managesubscribers', hrefBase + '/admin?p=ecommerce&tab=managesubscribers', 'Manage Subscribers', callback) );
					}
					if (config.licensingConfig.coupons_active) {
						tabs.push( new RightTab('coupons', hrefBase + '/admin?p=ecommerce&tab=coupons', 'Coupons', callback) );
					}
					tabs.push( new RightTab('activity', hrefBase + '/admin?p=ecommerce&tab=activity', 'Activity', callback) );
				}

			RightTabbedPage.prototype.show.call(this, 'ecommerce', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		if (!vars.tab) vars.tab = config.licensingConfig.addon ? 'settings' : 'home';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			switch (pageId) {
				case 'profiles':
					currentPage = new AdminLicensingProfiles();
					break;
				case 'settings':
					currentPage = new AdminLicensingSettings();
					break;
				case 'subscriptions':
					currentPage = new AdminLicensingSubscriptions();
					break;
				case 'managesubscribers':
					currentPage = new AdminLicensingManageSubscribers();
					break;
				case 'coupons':
					currentPage = new AdminLicensingCoupons();
					break;
				case 'activity':
					currentPage = new AdminLicensingActivity();
					break;
				case 'home':
				default:
					currentPage = new AdminLicensingHome();
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminLicensing.prototype = new RightTabbedPage();

function AdminLicensingHome() {
	var page = this;
	var templates = sa.templates.get('admin.licensing');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {

		container.html('');
		showLoader(container, 'Loading SA E-commerce data');

		if (!config.licensingConfig || !config.licensingConfig.addon) {
			showUnsubscribed(container);
		} else {

			showPaid(container);

		}

	};

	function showInformation(container) {
		container.empty().append(templates.get('information_page'));
	}

	function showUnsubscribed(container) {
		var template = templates.get('home_unsubscribed');


		// enable signup
		if (user.siteOwner) {
			template.find('.not_site_owner').remove();
			template.find('.signup_button').on('click', function() {
				sa.components.billing.addAddon('licensing', function(agreed) {
					console.log('got response from billing addAddon', agreed);
					if (agreed) {
						window.location.reload();
					}
				});
			});
		} else {
			template.find('.site_owner').remove();
			showSiteOwner(template);
		}

		container.html('').append(template);

	}

	function showSiteOwner(template) {
		sa.getSiteOwner(function(ownerInformation) {
			if (ownerInformation) {
				template.find('.so_cont .name').html(ownerInformation.username);
				template.find('.so_cont .email').html(ownerInformation.email);
				template.find('.so_cont .no_owner').remove();
			} else {
				template.find('.so_cont .has_owner').remove();
			}
		});
	}

	async function showPaid(container) {
		console.log('showing paid');

		const data = await sa.api.request({
			handler: 'licensing/licensingUtility',
			action: 'loadBillingStatus'
		});

		console.log('showing paid data', data);

		var template = templates.get('home_paid');

		if (data['owned']) {
			template.find('#unsubscribe').on('click', function () {
				sa.components.billing.removeAddon('licensing', function (agreed) {
					if (agreed) {
						window.location.reload();
					}
				});
			});
		} else {
			template.find('.billing_details').remove();
		}

		container.html('').append(template);

	}

}
/**
 * A page in the admin panel
 */
function AdminLicensingSettings() {
	var page = this;
	var templates = sa.templates.get('admin.licensing');

	this.currentTab = '';


	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {jQuery} container
	 */
	this.show = function(params, container) {
		console.log('- showing settings');
		window.activePage = page;
		var pageTemplate = templates.get('settings');
		container.html(pageTemplate);
		page.container = container;
		
		page.container.find('#processor-select').on('change',  page.processorSelect );

		page.loadCurrencies();

		// input data
		if (!config.licensingConfig) config.licensingConfig = {};
		if (config.licensingConfig.active) page.container.find('#setting-active input').prop('checked', true);
		if (config.licensingConfig.admin_active) page.container.find('#setting-admin-active input').prop('checked', true);
		if (config.licensingConfig.subscriptions_active) page.container.find('#setting-subscriptions-active input').prop('checked', true);
		if (config.licensingConfig.coupons_active) page.container.find('#setting-coupons-active input').prop('checked', true);
		if (config.licensingConfig.options.albumPrices) page.container.find('#setting-album-prices input').prop('checked', true);
		if (config.licensingConfig.options.bypassSingles) page.container.find('#setting-bypass-singles input').prop('checked', true);
		if (config.licensingConfig.options.includeAlts) page.container.find('#setting-include-alts input').prop('checked', true);
		if (config.licensingConfig.options.projectDetails) page.container.find('#setting-project-details input').prop('checked', true);
		if (config.licensingConfig.options.emailNotify) page.container.find('#setting-email-notify input').prop('checked', true);
		if (config.licensingConfig.options.subNotify) page.container.find('#setting-sub-notify input').prop('checked', true);
		if (config.licensingConfig.options.noRollover) page.container.find('#setting-no-rollover input').prop('checked', true);
		if (config.licensingConfig.options.removeCredits) page.container.find('#setting-remove-credits input').prop('checked', true);
		if (config.licensingConfig.options.allowRequests) page.container.find('#setting-allow-requests input').prop('checked', true);
		if (config.licensingConfig.options.downloadAvailable) page.container.find('#setting-download-button-options input').prop('checked', true);
		if (config.licensingConfig.options.trackAssignment) page.container.find('#setting-track-assignment input').prop('checked', true);
		if (config.licensingConfig.options.signupCoupons) page.container.find('#setting-signup-coupons input').prop('checked', true);
		if (config.licensingConfig.options.autoReleaseClaims) page.container.find('#setting-autoRelease-claims input').prop('checked', true);
		if (config.licensingConfig.company_name) page.container.find('#setting-company-name input').val(config.licensingConfig.company_name);
		if (config.licensingConfig.company_address) page.container.find('#setting-company-address textarea').val(config.licensingConfig.company_address);
		
		if (config.licensingConfig.options.subscriptionRenewalEmailNotify || !config.licensingConfig.options.hasOwnProperty('subscriptionRenewalEmailNotify')) {
			page.container.find('#setting-subscription-email-renewal-notify input').prop('checked', true);
		} else if (config.licensingConfig.options.subscriptionRenewalEmailNotify === 0) {
			page.container.find('#setting-subscription-email-renewal-notify input').prop('checked', false);
		}

		if (config.licensingConfig.processor) page.container.find('#processor-select').val(config.licensingConfig.processor);
		
		const paypalCredentials = config.licensingConfig.paypal_credentials;
		const braintreeCredentials = config.licensingConfig.braintree_credentials;
		
		if (paypalCredentials && paypalCredentials.apiPassword) {
			page.container.find('#paypal-username input').val(paypalCredentials.apiUsername);
			page.container.find('#paypal-password input').val(paypalCredentials.apiPassword);
			page.container.find('#paypal-signature input').val(paypalCredentials.apiSignature);
			page.container.find('#paypal-sandbox input').prop('checked', paypalCredentials.sandbox);
		}
		
		if (braintreeCredentials && braintreeCredentials.publicKey) {
			page.container.find('#braintree-merchantId input').val(braintreeCredentials.merchantId);
			page.container.find('#braintree-publicKey input').val(braintreeCredentials.publicKey);
			page.container.find('#braintree-privateKey input').val(braintreeCredentials.privateKey);
			page.container.find('#braintree-sandbox input').prop('checked', braintreeCredentials.sandbox);
			page.container.find('#braintree-is-3dSecure input').prop('checked', braintreeCredentials.is3dSecure);
		}
		
		if (config.licensingConfig.currency) page.container.find('#paypal-currencies, #braintree-currencies').val(config.licensingConfig.currency);
		
		page.container.find('.three-d-secure-info').on('click', (e) => {
			e.preventDefault();
			sa.alert({
				text: '3D Secure benefits cardholders and merchants by providing an additional layer of authentication. '
					+ 'During the checkout process, if the cardholder is enrolled in 3D Secure, the issuing bank will decide whether the cardholder\'s '
					+ 'identity can be verified using data supplied regarding the cardholder and their device, or if an additional authentication process is necessary.'
			});
		});

		page.container.find('#licensing-settings-save').on('click', page.save);
		page.container.find('#processor-select').trigger('change');
		page.container.find('#paypal-validate, #braintree-validate').on('click', page.validateProcessor);
		
		// Setup Invoice Image Upload
		const uploadButton = pageTemplate.find('#thumb_upload_browse_invoice');
		new Uploader({
			button: uploadButton[0], browseCallback: function (uploader) { // after selecting an image
				var fileList = uploader.getFiles(),
					key = new Date().getTime();

				if (fileList && fileList.length == 1) {
					// auto-upload
					uploadButton.find('span').html('Uploading...');
					uploader.upload({
						params: 't=temp&key=' + key + '&source=invoice-logo',
						complete: function () { // success function
							var newPath = 'https://sourceaudio-images.s3.amazonaws.com/temp/' + user.userData.id + '-' + key + '.jpg';
							// set the value where we need it
							pageTemplate.find('.logo-area img').remove();
							pageTemplate.find('.logo-area').append('<img src="' + newPath + '"/>');
							// let them upload again
							uploadButton.find('span').html('Browse');
						},
						error: function () { // error function
							uploadButton.find('span').html('Browse');
						}
					});
				}
			}, fileType: UploaderConstants.IMAGES
		});
	};

	this.processorSelect = function() {
		var chosen = $j(this).val();

		page.container.find('.paypal, .braintree').hide();

		if (chosen) page.container.find('.' + chosen).show();
	};

	this.validating = false;
	this.validateProcessor = async function() {
		if (page.validating) return;
		page.validating = true;
		
		var data = {};
		
		data.processor = page.container.find('#processor-select').val();
		data.paypal_credentials = {
			apiUsername: page.container.find('#paypal-username input').val(),
			apiPassword: page.container.find('#paypal-password input').val(),
			apiSignature: page.container.find('#paypal-signature input').val(),
			sandbox: page.container.find('#paypal-sandbox input').is(':checked') ? 1 : 0
		};

		data.braintree_credentials = {
			merchantId: page.container.find('#braintree-merchantId input').val(),
			publicKey: page.container.find('#braintree-publicKey input').val(),
			privateKey: page.container.find('#braintree-privateKey input').val(),
			sandbox: page.container.find('#braintree-sandbox input').is(':checked') ? 1 : 0,
			is3dSecure: page.container.find('#braintree-is-3dSecure input').is(':checked') ? 1 : 0
		};

		var b = $j(this);
		var title = b.html();
		b.html( '<i class="fa fa-spin fa-refresh"></i>');

		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'testCredentials',
			getData: {
				processor: data.processor,
				c: data[data.processor + '_credentials']
			}
		});

		page.validating = false;
		b.html(title);
		console.log(r);
		if (r.error) return sa.notify({ text: 'Your credentials are not correct. Please make sure you\'ve copied them correctly.' });

		sa.notify({ text: 'Your credentials are good to go! Make sure you save them.' });
	};

	this.loadCurrencies = async function() {
		const data = await sa.api.request({
			handler: 'licensing/licensingCheckout',
			action: 'getCurrencies'
		});

		console.log('- loaded currencies:', data);

		// paypal
		page.container.find('#paypal-currencies').html('');
		_.each(data.paypal, function (curr) {
			var cA = curr.split('-');
			var id = cA[0].trim() || 0;
			var op = $j('<option value="' + id + '">' + cA.splice(0, 2).join(' - ') + '</option>');
			op.data('currency', curr);
			page.container.find('#paypal-currencies').append(op);
		});


		// braintree
		page.container.find('#braintree-currencies').html('');
		_.each(data.braintree, function (curr) {
			var cA = curr.split('-');
			var id = cA[0].trim() || 0;
			var op = $j('<option value="' + id + '">' + cA.splice(0, 2).join(' - ') + '</option>');
			op.data('currency', curr);
			page.container.find('#braintree-currencies').append(op);
		});

		if (config.licensingConfig.currency) {
			var code = config.licensingConfig.currency.split('-')[0].trim();
			console.log('- our currency is:', code);
			page.container.find('#braintree-currencies, #paypal-currencies').val(code);
		}

		page.container.find('#braintree-currencies, #paypal-currencies').on('change', page.currencySelect);
	};

	this.currencySelect = function() {
		console.log('- select:', $j(this).find('option:selected').data('currency'));
	};

	this.save = async function() {
		var data = {};
		data.active = page.container.find('#setting-active input').is(':checked') ? 1 : 0;
		data.admin_active = page.container.find('#setting-admin-active input').is(':checked') ? 1 : 0;
		data.subscriptions_active = page.container.find('#setting-subscriptions-active input').is(':checked') ? 1 : 0;
		data.coupons_active = page.container.find('#setting-coupons-active input').is(':checked') ? 1 : 0;
		data.company_name = page.container.find('#setting-company-name input').val();
		data.company_address = page.container.find('#setting-company-address textarea').val();
		data.invoice_logo = page.container.find('#setting-invoice-logo img').attr('src');

		data.options = {
			bypassSingles: page.container.find('#setting-bypass-singles input').is(':checked') ? 1 : 0,
			includeAlts: page.container.find('#setting-include-alts input').is(':checked') ? 1 : 0,
			projectDetails: page.container.find('#setting-project-details input').is(':checked') ? 1 : 0,
			emailNotify:	page.container.find('#setting-email-notify input').is(':checked') ? 1 : 0,
			subscriptionRenewalEmailNotify:	page.container.find('#setting-subscription-email-renewal-notify input').is(':checked') ? 1 : 0,
			subNotify:	page.container.find('#setting-sub-notify input').is(':checked') ? 1 : 0,
			noRollover:	page.container.find('#setting-no-rollover input').is(':checked') ? 1 : 0,
			removeCredits:	page.container.find('#setting-remove-credits input').is(':checked') ? 1 : 0,
			allowRequests:	page.container.find('#setting-allow-requests input').is(':checked') ? 1 : 0,
			downloadAvailable:	page.container.find('#setting-download-button-options input').is(':checked') ? 1 : 0,
			trackAssignment:	page.container.find('#setting-track-assignment input').is(':checked') ? 1 : 0,
			signupCoupons:	page.container.find('#setting-signup-coupons input').is(':checked') ? 1 : 0,
			albumPrices: page.container.find('#setting-album-prices input').is(':checked') ? 1 : 0,
			autoReleaseClaims: page.container.find('#setting-autoRelease-claims input').is(':checked') ? 1 : 0
		};

		data.processor = page.container.find('#processor-select').val();

		data.paypal_credentials = {
			apiUsername: page.container.find('#paypal-username input').val(),
			apiPassword: page.container.find('#paypal-password input').val(),
			apiSignature: page.container.find('#paypal-signature input').val(),
			sandbox: page.container.find('#paypal-sandbox input').is(':checked') ? 1 : 0
		};

		data.braintree_credentials = {
			merchantId: page.container.find('#braintree-merchantId input').val(),
			publicKey: page.container.find('#braintree-publicKey input').val(),
			privateKey: page.container.find('#braintree-privateKey input').val(),
			sandbox: page.container.find('#braintree-sandbox input').is(':checked') ? 1 : 0,
			is3dSecure: page.container.find('#braintree-is-3dSecure input').is(':checked') ? 1 : 0
		};

		if (data.processor) {
			data.currency = page.container.find('#' + data.processor + '-currencies option:selected').data('currency');
		}

		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'saveSettings',
			postData: data
		});

		if (r.error) return sa.notify({ text: r.error });

		config.licensingConfig = data;

		sa.notify({ text: 'Saved!', type: sa.notify.notificationTypes.success });
		window.location.reload(); // force reload so new tabs will show up
	};

}
/**
 * A page in the admin panel
 */
function AdminLicensingProfiles() {
	var page = this;
	var templates = sa.templates.get('admin.licensing');

	this.currentTab = '';


	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		console.log('- showing profiles');
		window.activePage = page;
		var pageTemplate = templates.get('profile');
		container.html( pageTemplate );
		page.container = container;

		// agreement editor
		page.agreementEditor = page.container.find('#agreement-editor').detach();

		// make new agreement button
		page.container.find('#new-agreement-button').on('click', page.newAgreement);

		// get tree template
		page.treeItemTemplate = page.container.find('#profile-tree .tree-item').detach();

		// make new profile button
		page.container.find('#new-profile-button').on('click', page.newProfile);

		// save profile button
		page.container.find('#profile-save').on('click', page.saveProfile);

		// preview
		page.container.find('#profile-preview').on('click', page.previewProfile);

		// load profiles
		page.loadProfiles();

		// add project field button
		page.container.find('#add-project-field').on('click',  page.addProjectField );

		// save project fields
		page.container.find('#save-project-fields').on('click',  page.saveProjectFields );

		// populate fields
		page.projectFieldTemplate = page.container.find('#profile-project-details .project-field').detach();
		page.renderProjectFields();

		// scroll
		page.scrollFixed = false;
		page.scrollMarker = page.container.find('#pre-load').offset().top;
		$j(window).on('scroll', page.windowScroll);

		// unload
		unloadFunctions.push(function() {
			console.log('- unload!');
			$j(window).off('scroll');
			unloadFunctions = [];
		});
	};

	this.windowScroll = function() {
		var scroll = $j(window).scrollTop();
		//console.log('- scroll:', scroll);


		if (page.scrollMarker - scroll < 55 && !page.scrollFixed) {
			page.scrollFixed = true;
			page.container.find('#item-details-fixed').addClass('fixed');
		}
		if (page.scrollMarker - scroll > 55 && page.scrollFixed) {
			page.scrollFixed = false;
			page.container.find('#item-details-fixed').removeClass('fixed');
		}
	};

	this.loadProfiles = async function() {
		const data = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'loadProfiles'
		});


		page.labels = Object.values(data.labels);
		// alphabetize labels
		page.labels.sort((a, b) => {
			if (a.name < b.name) return -1;
			if (a.name > b.name) return 1;
			return 0;
		})
		page.loadedAgreements = data.agreements;
		page.loadedAssignments = data.assignments;
		var profiles = data.profiles;
		console.log(data);
		profiles.forEach(function (p) {
			p.data = JSON.parse(p.data);
		});
		page.loadedProfiles = profiles;

		// profile assignment
		var assignTemplate = page.container.find('#profile-assignment .not-default').detach();
		page.container.find('#profile-assignment .default select').data('label', 'default');
		for (const label of page.labels) {
			var ldiv = assignTemplate.clone();
			ldiv.attr('id', 'label-assign-' + label.id);
			ldiv.find('.title').html(label.name);
			ldiv.find('select').data('label', label.id);
			page.container.find('#profile-assignment .assign-list').append(ldiv);
		};

		// profile editor
		page.container.find('#profile-select').html('');
		page.container.find('#profile-select').append('<option value=0>-- Choose --</option>');
		profiles.forEach(function (p) {
			page.container.find('#profile-select').append('<option value="' + p.id + '">' + htmlEncode(p.title) + '</option');
			if (p.id > 0) page.container.find('#profile-assignment select').append('<option value="' + p.id + '">' + htmlEncode(p.title) + '</option');
		});

		// profile edit select
		page.container.find('#profile-select').off().on('change', function () {
			let chose = parseInt($j(this).val());
			let p = page.loadedProfiles.find(p => p.id == chose);
			console.log('- chose', chose, p);
			if (p.white_id == -1) {
				const cp = JSON.parse(JSON.stringify(p));
				cp.title = cp.title.replace('Example ', '');
				cp.data.title = cp.title;
				p = cp;
			}
			page.showProfile(p);
		});

		// label assignment
		page.loadedAssignments.forEach(function (as) {
			page.container.find('#label-assign-' + as.label_id + ' select').val(as.profile);
		});
		page.container.find('#profile-assignment select').off().on('change', page.assignProfile);

		// track assignment
		page.container.find('#track-assignment-count').html(data.tracksassigned);
		ProfileImporter.generateButton($j('#license-import-button').get(0));

		if (data.tracksassigned) {
			page.container.find('#clear-track-assignments').on('click', page.clearTrackAssignments);
		} else {
			page.container.find('#clear-track-assignments').remove();
		}

		// agreement editor
		page.container.find('#agreement-select').html('');
		page.container.find('#agreement-select').append('<option value=0>-- Choose --</option>');
		page.container.find('#item-details-agreement').html('').append('<option value=0>-- Choose --</option>');
		page.loadedAgreements.forEach(function (p) {
			page.container.find('#agreement-select').append('<option value="' + p.id + '">' + htmlEncode(p.title) + '</option');
			if (p.white_id > 0) page.container.find('#item-details-agreement').append('<option value="' + p.id + '">' + htmlEncode(p.title) + '</option');
		});

		page.container.find('#agreement-select').off().on('change', function () {
			var chose = $j(this).val();
			var p = page.loadedAgreements.find(function (p) { return p.id == chose; });
			console.log('- chose', chose, p);
			if (p.white_id == -1) {
				var cp = JSON.parse(JSON.stringify(p));
				cp.title = 'My ' + cp.title;
				var p = cp;
			}
			page.editAgreement(p);
		});
			
	};

	this.clearTrackAssignments = function() {
		console.log('- clear assignments');

		sa.confirm({
			text: 'Do you want to clear all your track-level assignments?',
			yesFunction: function() {
				sa.api.request({
					handler: 'licensing/licensingAdmin',
					action: 'clearTrackProfiles'
				}).then(function (r) {
					if (r.error) return sa.notify({ text: r.error });

					sa.notify({ text: 'Cleared!', type: sa.notify.notificationTypes.success });
					window.location.reload();
				});
			},
			yesText: 'Yes'
		});

	};

	this.previewProfile = function() {
		licensingModal.cb = console.log;
		licensingModal.demo = true;
		licensingModal.show(page.currentProfile);
	};

	this.saveProfile = async function() {
		console.log('- save', page.currentProfile);

		// validate the data
		var validateItem = function (item) {
	        if (!item.title) return 'notitle';
	        if ((!item.children || !item.children.length) && !item.price) return 'nochildrennoprice||' + item.title;
			if (item.price && item.price != parseFloat(item.price)) return 'pricenotnumber||' + item.title;

	        if (item.children) {
				var e = null;
	            item.children.find(function(child) {
	                var cv = validateItem(child);
	                if (cv !== true) {
						e = cv;
						return true;
					}
	            });
				if (e) return e;

	        }

	        return true;
	    };
		var validation = validateItem( page.currentProfile.data );
		if (validation !== true) {
			var vA = validation.split('||');
			if (vA[0] == 'nochildrennoprice') {
				return alert('Your license "' + vA[1] + '" needs a price.');
			}
			if (vA[0] == 'pricenotnumber') {
				return alert('Your license "' + vA[1] + '" has a price that is not a number. Do not include currency marks.');
			}
			if (vA[0] == 'notitle') {
				return alert('One of your items does not have a title.');
			}
		}

		// save it
		let profileData = JSON.stringify(page.currentProfile);
		profileData = profileData.split(/\\n/).join('_lbc_');
		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'saveProfile',
			postData: {
				profile: profileData
			}
		});

		if (r.error) return sa.notify({ text: r.error });

		if (r.id) {
			page.currentProfile.id = r.id;

			window.location.reload();
		}
		sa.notify({ text: 'Saved!', type: sa.notify.notificationTypes.success });
			
	};

	this.newProfile = function() {

		page.showProfile({
			title: 'New Profile',
			data: {}
		});
	};


	this.showProfile = function(profile) {
		page.container.find('#pre-load').hide();
		page.container.find('#profile-editor').show();

		if (!profile.data.title) {
			profile.data = {
				title: profile.title,
				root: 1,
				children: [
					{title: 'Example License', price: 99}
				]
			};
		}
		page.currentProfile = profile;
		page.itemCount = 0;
		page.drawItem(profile.data, page.container.find('#profile-tree').html(''), 0);
		page.showItem( page.container.find('.item-root') );
	};

	this.drawItem = function(item, tree, id, inheritwhite) {
		id++;
		var whitelist = item.whitelist ? parseInt(item.whitelist) : 0;
		var whitelistinherit = inheritwhite || 0;
		page.itemCount = id;
		var idiv = page.treeItemTemplate.clone();
		idiv.data('item', item); // this is passed by reference
		idiv.attr('id', 'item-' + id);
		idiv.find('.item-title').html( item.title ? htmlEncode(item.title) + (item.price && (!item.children || !item.children.length) ? (item.price == -1 ? ' -- Contact' : (item.price == -2 ? ' -- Credit Only' : ' -- ' + item.price.currencyFormat())) : '') + (whitelistinherit && !whitelist ? ' <i class="fa fa-copyright inherit"></i>' : '') + (whitelist ? ' <i class="fa fa-copyright"></i>' : '') : '---' );
		if (item.price || !item.children || !item.children.length) {
			idiv.addClass('item-profile');
		} else {
			idiv.addClass('item-section');
		}
		if (item.root) {
			idiv.addClass('item-root');
			if (item.id < 1) idiv.find('.item-actions .delete').hide();
			idiv.find('.item-actions .duplicate').hide();
			idiv.removeClass('item-section');
		}
		idiv.appendTo( tree );

		idiv.on('click', page.itemClick);
		idiv.find('.item-icon').on('click',  page.itemIconClick );
		idiv.find('.item-actions .add').on('click',  page.itemAddClick );
		idiv.find('.item-actions .delete').on('click',  page.itemDeleteClick );
		idiv.find('.item-actions .duplicate').on('click',  page.itemDuplicateClick );

		if (item.children) {
			var children_container = $j('<div id="tree-children-' + id + '" class="tree-children"></div>');
			children_container.appendTo( tree );
			item.children.forEach(function(item) {
				id = page.drawItem(item, children_container, id, whitelist || whitelistinherit);
			});
		}

		return id;
	};



	this.itemClick = function(e) {
		var item = $j(this).data('item');
		console.log('- item click', item);

		page.showItem($j(this));
	};

	this.itemIconClick = function(e) {
		e.stopPropagation();
		console.log('- item dupe click');
		var idiv = $j(this).parent();
		var id = idiv.attr('id').split('-').pop();

		if (idiv.hasClass('closed')) { // open it

			idiv.removeClass('closed');
			page.container.find('#tree-children-' + id).show();

		} else { // close it

			idiv.addClass('closed');
			page.container.find('#tree-children-' + id).hide();

		}
	};

	this.itemDuplicateClick = function(e) {
		e.stopPropagation();
		console.log('- item dupe click');
		var idiv = $j(this).parent().parent();
		var id = idiv.attr('id').split('-').pop();
		var item = idiv.data('item');
		var pid = idiv.parent().attr('id').split('-').pop();
		var pdiv = page.container.find('#item-' + pid);
		var parent = pdiv.data('item');

		var cp = JSON.parse(JSON.stringify(item));
		cp.title = cp.title + ' Copy';
		parent.children.push(cp);

		page.itemCount++;
		page.drawItem(cp, page.container.find('#tree-children-' + pid), page.itemCount);
		page.showItem($j('#item-' + page.itemCount));
	};

	this.itemAddClick = function(e) {
		e.stopPropagation();
		console.log('- item add click');
		var idiv = $j(this).parent().parent();
		var item = idiv.data('item');
		if (item.price) {
			sa.confirm({
				text: 'This item has a price, are you sure you want to turn it into a section by adding something below it? You will lose the price data.',
				yesFunction: function() {
					page.addItemTo(idiv);
				},
				yesText: 'Yes'
			});
		} else {
			page.addItemTo(idiv);
		}
	};

	this.addItemTo = function(idiv) {
		var item = idiv.data('item');
		var id = idiv.attr('id').split('-')[1];

		console.log('- adding item to', item, id);
		item.price = null;
		if (!item.root) idiv.removeClass('item-profile').addClass('item-section');
		if (item.title == 'New License') {
			item.title = 'New Section';
		}
		idiv.find('.item-title').html( htmlEncode(item.title) );

		if (!item.children || !item.children.length) {
			item.children = [];
			var c = $j('<div id="tree-children-' + id + '" class="tree-children"></div>');
			idiv.after( c );
		} else {
			c = page.container.find('#tree-children-' + id);
		}
		var n = { title: 'New License' };
		item.children.push(n);
		page.itemCount++;
		page.drawItem(n, c, page.itemCount);
		page.showItem($j('#item-' + page.itemCount));

	};

	this.itemDeleteClick = function(e) {
		e.stopPropagation();
		console.log('- item delete click');
		var idiv = $j(this).parent().parent();
		var id = idiv.attr('id').split('-').pop();
		var item = idiv.data('item');
		var pid = idiv.parent().attr('id').split('-').pop();
		var pdiv = page.container.find('#item-' + pid);
		var parent = pdiv.data('item');

		if (item.root) {
			sa.confirm({
				text: 'Do you want to delete this profile?',
				yesFunction: function() {
					page.deleteProfile();
				},
				yesText: 'Yes'
			});
			return;
		}

		console.log('--', idiv.attr('id'), pid, item, parent);

		if (item.children && item.children.length) {
			sa.confirm({
				text: 'Are you sure you want to delete this section? Everything in this section will be deleted.',
				yesFunction: del,
				yesText: 'Yes'
			});
		} else {
			del();
		}

		function del() {
			var index = parent.children.indexOf( item );
			parent.children.splice(index, 1);
			if (!parent.children.length) {
				idiv.parent().remove();
				pdiv.removeClass('item-section').addClass('item-profile');
			}
			idiv.remove();
			page.container.find('#tree-children-' + id).remove();
		}

	};

	this.deleteProfile = async function(item) {
		console.log('- deleting profile', page.currentProfile.id);
		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'deleteProfile',
			postData: {
				id: page.currentProfile.id
			}
		});
		if (r.error) return sa.notify({ text: r.error });

		page.show('', page.container);

		sa.notify({ text: 'Deleted!', type: sa.notify.notificationTypes.success });
	};

	this.showItem = function(idiv) {
		page.container.find('.item-selected').removeClass('item-selected');
		idiv.addClass('item-selected');
		var item = idiv.data('item');
		page.shownItemDiv = idiv;
		page.shownItem = item;

		page.container.find('#item-no-details').hide();
		page.container.find('#item-details').show();
		if (item.root) {
			page.container.find('#item-details .description-section').hide();
			page.container.find('#item-details .agreement-section').show();
			page.container.find('#item-details .project-section').show();
			page.container.find('#item-details .whitelist-section').show();
			page.container.find('#item-details .overrideUrl-section').show();
		} else {
			page.container.find('#item-details .overrideUrl-section').hide();
			page.container.find('#item-details .description-section').show();
			page.container.find('#item-details .agreement-section').hide();
			page.container.find('#item-details .project-section').hide();
			page.container.find('#item-details .whitelist-section').show();
		}

		if (item.children && item.children.length) {
			page.container.find('#item-details .price-section').hide();
		} else {
			page.container.find('#item-details .price-section').show();
		}

		page.container.find('#item-details #item-details-title').val( item.title );
		page.container.find('#item-details #item-details-description').val( item.description );
		page.container.find('#item-details #item-details-albumPrice').val( item.albumPrice );
		page.container.find('#item-details #item-details-overrideUrl').val(item.overrideUrl);
		page.container.find('#item-details #item-details-price').val( item.price );
		if (item.root) page.container.find('#item-details-agreement').val( item.agreement || 0 );
		if (item.showproject && parseInt(item.showproject)) page.container.find('#item-details-showproject').prop('checked', true);
		if (item.whitelist && parseInt(item.whitelist)) {
			page.container.find('#item-details-whitelist').prop('checked', true);
		} else {
			page.container.find('#item-details-whitelist').prop('checked', false);
		}

		// catch detail edits
		page.container.find('#item-details input, #item-details textarea, #item-details-agreement').off().on('keyup change', page.detailChange);

		// focus on title input
		page.container.find('#item-details-title').trigger('focus');
	};

	this.detailChange = function() {
		let id = $j(this).attr('id');
		var prop = id.split('-').pop();
		var val = $j(this).val();
		if (prop == 'showproject') val = $j(this).is(':checked') ? 1 : 0;
		if (prop == 'whitelist') val = $j(this).is(':checked') ? 1 : 0;

		console.log(id, prop, val);
		var item = page.shownItemDiv.data('item');
		item[prop] = val;

		if (prop == 'price' && val.indexOf('$') != -1) sa.notify({ text : 'Do not put any currency in your prices, just numbers.' });
		if (prop == 'albumprice' && val.indexOf('$') != -1) sa.notify({ text : 'Do not put any currency in your prices, just numbers.' });
		if (prop == 'title' || prop == 'price') page.shownItemDiv.find('.item-title').html( item.title ? htmlEncode(item.title) + (item.price ? (item.price == -1 ? ' -- Contact' : (item.price == -2 ? ' -- Credit Only' : ' -- ' + (parseFloat(item.price) == item.price ? item.price.currencyFormat() : item.price))) : '') : '---' );

		if (prop == 'whitelist') {
			let id = page.shownItemDiv.attr('id');
			page.showProfile( page.currentProfile );
			page.showItem( page.container.find('#' + id) );
		}
	};

	this.assignProfile = async function() {
		var chose = $j(this).val();
		var label = $j(this).data('label');
		if (chose == -1) chose = 'none';
		if (chose == 0) chose = 'delete';
		var p = page.loadedProfiles.find(function(p) { return p.id == chose; });
		if (!p) p = {id: chose};
		console.log('- chose', chose, 'for', label, p);

		// check to see if there is an agreement attached
		if (p.id != 'delete' && p.id != 'none' && !p.data.agreement) {
			$j(this).val( label == 'default' ? -1 : 0 );
			sa.confirm({
				text: 'This is a valid profile, but it does not have an agreement attached to it. Would you like to edit it and do that now?',
				yesFunction: function() {
					page.showProfile( p );
				},
				yesText: 'Yes'
			});
			return;
		}

		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'assignProfile',
			getData: {
				id: p.id,
				label: label
			}
		});

		if (r.error) return sa.notify({ text: r.error });

		sa.notify({ text: 'Assigned!', type: sa.notify.notificationTypes.success });
	};

	this.newAgreement = function() {
		var agreement = {
			title: 'New Agreement',
			body: ''
		};

		page.editAgreement( agreement );
	};

	this.editAgreement = function(agreement) {
		page.currentAgreement = agreement;

		$j('body').append( page.agreementEditor );
		var h = page.agreementEditor.find('.frame').height() - 45;
		
		showWysiwygEditor('#agreement_body');

		page.agreementEditor.find('.header .title input').val( agreement.title );
		page.agreementEditor.find('textarea').val( cleanCkeditorOutput(agreement.body, true) );

		page.agreementEditor.find('.cancel').off().on('click', function() {
			page.agreementEditor.detach();
			page.container.find('#agreement-select').val(0); // Set to first item in list
		});

		page.agreementEditor.find('.save').off().on('click', page.saveAgreement);
	};

	this.saveAgreement = async function() {
		console.log('save');

		page.currentAgreement.title = page.agreementEditor.find('.header .title input').val();
		page.currentAgreement.body = getWysiwygEditorContent('#agreement_body');


		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'saveAgreement',
			postData: {
				agreement: page.currentAgreement
			}
		});

		if (r.error) return sa.notify({ text: r.error });

		if (r.id) {
			page.currentAgreement.id = r.id;

			window.location.reload();
		}
		page.agreementEditor.detach();
		sa.notify({ text: 'Saved!' });
	};

	this.addProjectField = function() {
		page.container.find('.project-fields').append( page.projectFieldTemplate.clone() );
	};

	this.saveProjectFields = async function() {
		var fields = [];
		page.container.find('.project-field').each(function() {
			var name = $j(this).find('input').val();
			var type = $j(this).find('select').val();
			if (!name) return;
			fields.push({
				name: name,
				type: type
			});
		});

		var buttonText = page.container.find('#save-project-fields').html();
		page.container.find('#save-project-fields').html( '<i class="fa fa-refresh fa-spin"></i>' );

		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'saveProjectFields',
			postData: {
				project_fields: fields
			}
		});

		page.container.find('#save-project-fields').html(buttonText);
		console.log(r);
		if (r.error) return sa.notify({ text: r.error });

		config.licensingConfig.project_fields = fields;

		sa.notify({ text: 'Saved!' });
	};

	this.renderProjectFields = function() {
		if (!config.licensingConfig.project_fields.length) {
			page.container.find('.project-fields').append( page.projectFieldTemplate.clone() );
			return;
		}

		config.licensingConfig.project_fields.forEach(function(f) {
			var fdiv = page.projectFieldTemplate.clone();
			fdiv.find('input').val( f.name );
			fdiv.find('select').val( f.type );
			page.container.find('.project-fields').append( fdiv );
		});
	};
}
/**
 * A page in the admin panel
 */
function AdminLicensingSubscriptions() {
	var page = this;
	var templates = sa.templates.get('admin.licensing');

	this.currentTab = '';


	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function(params, container) {
		console.log('- showing subscriptions');
		window.activePage = page;
		var pageTemplate = templates.get('subscriptions');
		container.html( pageTemplate );
		page.container = container;
		var nobrain = page.container.find('#no-braintree').detach();
		page.planEditor = page.container.find('#plan-editor').detach();

		if (!config.licensingConfig.braintree_credentials || !config.licensingConfig.braintree_credentials.merchantId) {
			nobrain.find('a').attr('href', '/admin?p=licensing&tab=settings');
			return page.container.find('#admin-licensing-subscriptions').html( nobrain );
		}

		var ops = config.licensingConfig.subscriptions_options;
		if (ops) {
			page.container.find('#subs-title input').val( ops.page_title );
			page.container.find('#subs-subtitle input').val( ops.page_subtitle );
			page.container.find('#subs-sideinfo textarea').val( ops.page_sideinfo );
		}

		page.container.find('#licensing-subscriptions-save').on('click',  page.save );
		page.container.find('#subs-add-plan').on('click',  function() { page.editPlanPopup(); } );

		page.planRowTemplate = page.container.find('table .row').detach();
		page.container.find('#plans-link').attr('href', 'https://' + (config.licensingConfig.braintree_credentials.sandbox ? 'sandbox' : 'www' ) + '.braintreegateway.com/merchants/' + config.licensingConfig.braintree_credentials.merchantId + '/plans');

		const r = await sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'getPlans',
			getData: {
				getBraintree: 1
			}
		});

		if (r.error) sa.notify({ text: r.error });

		page.container.find('.loading').hide();
		console.log(r);
		if (!r.plans || !_.keys(r.plans).length) {
			return page.container.find('.no-plans').show();
		}

		_.each(r.plans, function (plan) {
			var subscriptionPlanNotSupported = plan.billing_frequency > 12;
			var rdiv = page.planRowTemplate.clone();
			var planTitle = !plan.hidden ? plan.title : plan.title + ' [hidden]';
			rdiv.find('.plan-title').html(planTitle);
			rdiv.find('.plan-description').html(htmlDecode(plan.description).substr(0, 140));
			rdiv.find('.plan-dls').html(plan.downloads == 99999 ? '<span style="font-size: 22px;line-height:22px;">∞</span>' : plan.downloads);
			rdiv.find('.plan-price').html((plan.price / 100) + ' ' + plan.currency);
			if (plan.braintree_id) {
				var subRowlink = (config.licensingConfig.braintree_credentials.sandbox ? 'sandbox' : 'www') 
					+ '.braintreegateway.com/merchants/' 
					+ config.licensingConfig.braintree_credentials.merchantId 
					+ '/plans/' + plan.braintree_id;
				rdiv.find('.edit-link').attr('href', 'https://' + subRowlink);
				rdiv.find('.delete-link').remove();
			} else {
				rdiv.find('.edit-link').on('click', function () { page.editPlanPopup(plan); });
				rdiv.find('.delete-link').on('click', function () { page.deletePlan(plan); });
			}
			rdiv.find('.order-link').on('click', function () { page.orderPlan(plan); });
			
			if (subscriptionPlanNotSupported) {
				rdiv.html('<td colspan="5" style="color: red; font-weight: bold;"1>This plan ('+ planTitle +') is not supported. The billing period is too long ( >12 months )</td>');
			}
			
			page.container.find('table').append(rdiv);
		});
		page.container.find('table').show();
	};

	this.orderPlan = async function( plan ) {
		if (!plan || !plan.id) return;

		const r = await sa.api.request({
			handler: 'licensing/licensingSubscriptions',
			action: 'orderPlan',
			postData: {
				id: plan.id
			}
		});

		if (r.error) return sa.notify({ text: r.error });

		page.show('', page.container);
	};

	this.deletePlan = function( plan ) {
		if (!plan || !plan.id) return;

		sa.confirm({
			text: 'Do you want to delete this plan?',
			yesFunction: async function() {

				const r = await sa.api.request({
					handler: 'licensing/licensingSubscriptions',
					action: 'deletePlan',
					postData: {
						id: plan.id
					}
				});

				if (r.error) return sa.notify({ text : r.error });

				page.show( '', page.container );
			},
			yesText: 'Yes'
		});

	};

	this.save = async function() {
		var data = {};
		data.page_title = page.container.find('#subs-title input').val();
		data.page_subtitle = page.container.find('#subs-subtitle input').val();
		data.page_sideinfo = page.container.find('#subs-sideinfo textarea').val();

		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'saveSubscriptionSettings',
			postData: {
				subscriptions_options: data
			}
		});

		console.log(r);
		if (r.error) return sa.notify({ text: r.error });

		config.licensingConfig.subscriptions_options = data;

		sa.notify({ text: 'Saved!', type: sa.notify.notificationTypes.success });
		sa.router.reloadPage();
	};

	this.editPlanPopup = function(plan) {

		page.editingPlan = plan ? plan : null;

		if (plan) {
			page.planEditor.find('#sub-edit-title input').val( plan.title );
			page.planEditor.find('#sub-edit-subtitle input').val( plan.subtitle );
			page.planEditor.find('#sub-edit-description textarea').val( plan.description );
			page.planEditor.find('#sub-edit-action input').val( plan.action );
			page.planEditor.find('#sub-edit-url input').val( plan.url );
		}

		$j('body').append( page.planEditor );
		page.planEditor.show();

		page.planEditor.find('.cancel').on('click', function() {
			page.planEditor.detach();
		});

		page.planEditor.find('.save').on('click', async function() {

			var data = {
				title: page.planEditor.find('#sub-edit-title input').val(),
				subtitle: page.planEditor.find('#sub-edit-subtitle input').val(),
				description: page.planEditor.find('#sub-edit-description textarea').val(),
				action: page.planEditor.find('#sub-edit-action input').val(),
				url: page.planEditor.find('#sub-edit-url input').val()
			};

			console.log('- data:', data);


			const r = await sa.api.request({
				handler: 'licensing/licensingSubscriptions',
				action: 'editPlan',
				postData: {
					id: page.editingPlan ? page.editingPlan.id : 0,
					data: data
				}
			});

			if (r.error) return sa.notify({ text: r.error });

			page.planEditor.detach();
			page.show('', page.container);
			sa.notify({ text: 'Saved!', type: sa.notify.notificationTypes.success });
		});

	};

}
/**
 * A page in the admin panel
 */
function AdminLicensingManageSubscribers() {
	var page = this;
	var templates = sa.templates.get('admin.licensing');

	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var vars = sa.router.paramsToVars(params);
		if (vars.user) {
			console.log('found user ' + vars.user);
			// see if we're already on the user search page
			if ($j('#subscriber_search').length) return;
		}
		console.log('- showing subscriptions');
		window.activePage = page;
		var pageTemplate = templates.get('managesubscribers');
		container.html( pageTemplate );
		page.container = container;

		$j('#subscriber_search').on('keyup', page.debounce(function() {
			var val = this.value.trim();
			$j('#results').show();
			$j('#user_edit').hide();
			if (!val) {
				page.loadUsers('', true);
				return;
			}
			page.loadUsers(val);
		}, 250));

		function fin() {
			if (vars.user) {
				sa.api.request({
					handler : 'user-management',
					action : 'getUser',
					getData : {
						user : vars.user
					}
				}).then(page.setUser).catch(e => {
					sa.notify({ text: 'User not found. Please try searching' });
				});

			} else {
				$j('#subscriber_search').trigger('keyup');
			}
		}
		if (user.hasAdminPermission(AdminPermission.Admins)) {
			sa.api.request({
				handler : 'admin-roles',
				action : 'list'
			}).then(r => {
				adminRoles = r.roles;
			}).finally(() => {
				fin();
			});
		} else {
			fin();
		}
	};

	/**
	 * Loads a list of users based on what the user has entered
	 * @param {string} value the search term
	 * @param {boolean=} loadRecent if true, the script will load the 50 most recent users to join the site instead of the search results
	 */
	this.loadUsers = function(value, loadRecent) {
		sa.api.request({
			handler : 'user-management',
			action : 'subscriptionSearch',
			getData : {
				search : value,
				loadRecent : loadRecent ? 1 : 0
			}
		}).then(page.handleUserResults);

	};

	/**
	 * Handles the response from the server after searching for a user
	 * @param {{ result : string, users : Array, totalFound : int, message : string }} response the server's list of users
	 * @param {boolean} showingRecent
	 */
	this.handleUserResults = function(response) {
		var resultContainer = $j('#results .results').html('');
		if (response.result !== 'success') {
			sa.notify({ text : response.message });
		} else if (!response.users.length) {
			resultContainer.html('No users matched');
		} else {
			let resultContent = `
				<div class="clr"></div>
				<p style="background: #ececec; padding: 5px 12px;"><em>Note: </em>To set downloads to unlimited, type "99999"</p>
				<table class="plans-list" style="display: table;">
				<thead>
					<tr>
						<th>User</th>
						<th>Subscription Plan</th>
						<th>Subscription Status</th>
						<th>Price</th>
						<th>Paid Through</th>
						</th>
						<th>Cancel Subscription?</th>
						<th>Download <br>Credits</th>
						<th></th>
					</tr>
				</thead>
			`;

			for (let i = 0, users = response.users, len = users.length; i < len; i++) {
				let sub = users[i];
				let hasSub = !!sub.id;
				let subId = sub.id;
				let userId = sub.user_id;
				let username = sub.username;
				let userEmail = sub.email;
				let whiteId = sub.white_id;
				let title = sub.title ? sub.title : '&mdash;';
				let status = ['active', 'init'].indexOf(sub.status) > -1 ? 'Active' : '&mdash;';
				let price = sub.price;
				if (price) {
					let currency = getCurrencyInfo(config);
					price = (new Currency(currency.code, parseFloat(sub.price / 100), false)).getResult();
				} else {
					price = '&mdash;';
				}

				let paidThroughDate = hasSub ? new Date(sub.paid_through_date * 1000).toLocaleDateString() : '&mdash;';
				let downloads = sub.download_credit ? sub.download_credit : 0;
				downloads = parseInt(downloads) === 99999 ? 'Unlimited' : downloads;

				let cancelSubCheckbox = sub.status ? `<input type="checkbox" id="cancelSub_${subId}">` : '&mdash;';

				let baseUrl = siteBaseUrl();

				let row = `<tr data-userid="${userId}" data-subid="${subId}" data-whiteid="${whiteId}">
						<td>
							<a href="${baseUrl}/admin?p=users&tab=edit&user=${userId}">${username}</a>
							<br>
							<a href="${baseUrl}/admin?p=users&tab=edit&user=${userId}">${userEmail}</a>
						</td>
						<td style="text-align: center;">${title}</td>
						<td style="text-align: center;">${status}</td>
						<td style="text-align: center;">${price}</td>
						<td style="text-align: center;">${paidThroughDate}</td>
						<td style="text-align: center;">
							${cancelSubCheckbox}
						</td>
						<td style="width: 70px;">
							<input id="changeUserDownloadCredits_${userId}" value="${downloads}" style="width: 90px;" />
						</td>
						<td>
							<button class="button" id="saveUserSubCredits_${userId}" style="width: 90px;">Save</button>
						</td>
					</tr>`;

				resultContent += row;
			}
			resultContent += '</table>';
			var userContainer = $j(resultContent);
			// var	userContainer = $j('<a class="user faux_button" href="/admin?p=users&tab=edit&user=' + user.id + '">' + user.username + (user.company ? ' - ' + user.company : '') + '<span>' + user.email + '</span>'
			// 		+ (user.notes ? '<span>' + user.notes + '</span>' : '') + '</a>');
			resultContainer.append(userContainer);

			$j('[id^=changeUserDownloadCredits_]').each(function() {
				$j(this).on('keyup', function(e) {
					var val = e.target.value;
					if (isNaN(val) && !val.includes('Unlimit')) {
						alert('Please only use numbers in the download credits field(s).');
						return;
					}
					console.log(val);
					if (parseInt(val) === 99999 || parseInt(val) > 99999) {
						e.target.value = 'Unlimited';
					} else if (val === 'Unlimited' || val === 'Unlimite') {
						e.target.value = '9999';
					}
				});
			});

			$j('[id^=saveUserSubCredits_]').each(function() {
				$j(this).on('click', function() {
					var parentRow = $j(this).parent().parent();
					var userId = parentRow.data('userid');
					var subId = parentRow.data('subid');
					var whiteId = parentRow.data('whiteid');
					var cancelInput = parentRow.find('[id^="cancelSub_"]');
					var creditsInput = parentRow.find('[id^="changeUserDownloadCredits_"]');
					var cancelSub = cancelInput.is(":checked");
					var credits = creditsInput.val();
					credits = credits === 'Unlimited' ? 99999 : credits;
					if (credits !== 'Unlimited' && isNaN(credits)) {
						alert('Download credits must be a number or Unlimited');
						return;
					}

					var confirmText = 'Are you sure? This will update the user\'s download credits';
					confirmText += cancelSub ? ' and cancel the user\'s subscription.' : '.';

					var that = this;

					var loggedInUserId = getCurrentUserId();

					const oldBgColor = $j(that).css('background-color');
					const oldTextColor = $j(that).css('color');

					sa.confirm({
						text: confirmText,
						yesFunction: async function() {

							$j(that).html('<i class="fas fa-spinner fa-spin" style="margin-right: 10px;"></i>Saving');
							const response = await sa.api.request({
								handler: 'user-management',
								action: 'updateUserSubCredits',
								postData: {
									whiteId: whiteId,
									subId: subId,
									cancelSub: cancelSub,
									userId: userId,
									credits: credits,
									loggedInUserId: loggedInUserId
								}
							});

							if (response.success) {
								$j(that).css('background-color', '#3b775e');
								$j(that).html('Saved');

								if (parseInt(user.userData.id) === userId) {
									$j('#header-credit-amount').text(credits);
								}

								if (cancelSub) {
									parentRow.find('td').eq(1).html('&mdash;');
									parentRow.find('td').eq(2).html('&mdash;');
									parentRow.find('td').eq(3).html('&mdash;');
									parentRow.find('td').eq(4).html('&mdash;');
									parentRow.find('td').eq(5).html('&mdash;');
								}

								setTimeout(function() {
									$j(that).css({
										'background-color': oldBgColor,
										'color': oldTextColor
									});

									$j(that).html('Save');
								}, 3000);
							} else {
								$j(that).css('background-color', '#cf1e1e');
								$j(that).html('Failed');

								setTimeout(function() {
									$j(that).css({
										'background-color': oldBgColor,
										'color': oldTextColor
									});
									$j(that).html('Save');
								}, 3000);
							}

							return false;
						},
						noFunction: function() {
							$j(that).css({
								'background-color': oldBgColor,
								'color': oldTextColor
							});
							$j(that).html('Save');
						},
						yesText: 'CONFIRM'
					});
				});
			});
		}
	};

	this.debounce = function(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}
}
/**
 * The page in the admin panel that lets you manipulate your featured content
 */
function AdminLicensingCoupons() {
	var page = this;
	var campaigns = null;
	var box = null;

	/**
	 * {string} the name of the tab we're showing
	 */
	this.currentTab = '';

	/**
	 * {object} the page we're currently showing
	 */
	this.currentPage = null;

	this.hasDiscountTemplate = false;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Licensing)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Manage Licensing' + '" permission.</h3>');
		}

		if ( (!config.licensingConfig.braintree_credentials || !config.licensingConfig.braintree_credentials.merchantId) && !config.licensingConfig.paypal_credentials) {
			container.html(`
				<div class="admin-licensing">
					<div id="no-braintree">
						We're missing some of the information needed to process payments for your workspace. Please go to the payment processing <a href="${siteBaseUrl()}/admin?p=licensing&tab=settings">settings</a> to complete the payment setup for your workspace.
					</div>
				</div>
			`);
		} else {
			container.html('<div id="coupon_data">Loading Coupon Manager...</div>');
			this.loadCouponData();
		}
	};

	/**
	 * Loads the data from the server
	 */
	this.loadCouponData = function(params) {
		console.log('loading coupon data', params);
		// sa/licensing/licensingCoupons/loadUserCredit
		var vars = (params) ? sa.router.paramsToVars(params) : {};
		vars.section = 'admin';

		sa.api.request({
			handler: 'licensing/licensingCoupons',
			action: 'getCouponData',
			getData: vars
		}).then(page.setCouponData);
	
	};

	this.showBTdiscountInfo = function () {
		var container = $j('#coupon_data');
		var subSetupNotice = '<br/> <br/><div class="text"><i class="fa fa-info-circle" aria-hidden="true"></i> Subscription coupons are not setup yet. <a class="sub-setup">Click here to learn how to enable them.</a></div>';
		container.append(subSetupNotice);

		container.find('a.sub-setup').off('click').on('click', function () {
			console.log('- show sub setup');
			var subSetupInfo = '<div class="text" style="text-align: left;">'
				+ '<p><b>Overview</b><br/>Subscription coupons allow you to create and distribute special promotional discount codes for your subscription plans.'
				+ ' Customers redeem the code when they sign up for a plan at which time the plan\'s base price is discounted for the duration and amount specified by the coupon. <br/> <br/>Examples:'
				+ '<br/>- A "FIRSTMONTHFREE" code with a 100% discount for 1 billing cycle. The plan is free for the first month. Subsequent renewals are billed at the regular price.'
				+ '<br/>- A "3MO25%OFF" code with a 25% discount for 3 billing cycles. The plan price will be discounted by 25% for 3 months. Subsquent renewals are billed at the regular price.</p>'
				+ '<p><b>Setup</b><br/>'
				+ 'Subscription coupons are redeemed and applied to the customer\'s subscription at the time of purchase using a braintree discount template. The template is copied and has it\'s amount and duration set to the values specified by the coupon before being added as a discount line item to the subscription.'
				+ ' Please see the animated clip below for how to setup a discount template in braintee. Revisit this page after creating your discount template to start using subscription coupons. <br/><br/>'
				+ '<i class="fa fa-info-circle" aria-hidden="true"></i><i>  Only 1 template is required. This template will be used as the base template for all subscription coupons. The template amount and duration are placeholders—these values are set dynamically at the time of purchase as specified by the coupon.</i></p>'
				+ '<ul>'
				+ '	<li>Log into braintree and click on the "subscriptions" in the menu bar at the top of the page.</li>'
				+ '	<li>Next, click on "add-ons/discounts" on the sub menu bar.</li>'
				+ '	<li>Scroll to the discounts section and click the "+ new discount" button.</li>'
				+ '	<li>Enter a name. —<i>This will only appear in braintree.</i></li>'
				+ '	<li>Enter a description. —<i>This will only appear in braintree.</i><br/>'
				+ '  optional: add "<b>[discount]</b>" in the description to designate this discount as your template. This should be used if you have existing discounts or plan to create additional discounts in the future.'
				+ '	</li>'
				+ '	<li>Enter an amount ex: 0.01 —<i>This value is placeholder. At checkout we set the discount amount to the value specified by the coupon.</i></li>'
				+ '	<li>Select a duration. —<i>This is a placeholder. At checkout we set the discount duration to the value specified by the coupon.</i></li>'
				+ '</ul><br/>'
				+ '<img width="480" height="384" src="images/help/discount_setup.gif" alt="animated walkthrough"/></div>';
			var fb = new FocusBox(subSetupInfo);
			return fb.show();
		});
	};


	this.setCouponData = function(response) {
		console.log('coupon data response:', response);

		var container = $j('#coupon_data').html(
			'<div class="cpdata_buttons">'
			+	'<div id="cpdata_newcampaign" class="cpdata_action_button button faux_button">Create A New Campaign</div>'
			+	'<div class="clr"></div>'
			+ '</div>'
			+ '<div id="cpdata_list"></div>'
		);

		$j('#cpdata_newcampaign').on('click', function() {
			page.editCampaign();
		});

		if(response.error) {
			$j('#cpdata_list').html(response.error);
			return;
		}


		var cpdata_list = $j('#cpdata_list');

		campaigns = response;
		var ii = 1;
		var now = new Date();
		now = now.getTime() / 1000;

		/**
		* Functions for rendering the coupon rows
		*/
		var renderPrefixRow = function (selector, campaign, code) {
			var id 			= code.id,
				prefix 		= code.prefix,
				prefixObj 	= campaign.prefixes[prefix];

			var row = '<div data-type="prefix" id="cpdata_prefix_' + id + '" class="cpdata_code">'
				+ '<div class="cpdata_code_code">-- [' + prefix + ']' + ((prefixObj.count > 1) ? ' ' + prefixObj.count + ' codes</div>' : '</div>')
				+ '<div class="cpdata_code_stats ' + ((prefixObj.total_uses == prefixObj.total_used) ? 'used' : '') + ' ' + (prefixObj.total_used > 0 ? 'faux_button' : '') + '">' + (prefixObj.total_uses ? 'Used: ' + Math.round(100 * prefixObj.total_used / prefixObj.total_uses) + '% (' + prefixObj.total_used + '/' + prefixObj.total_uses + ')' : '&nbsp;') + '</div>'
				+ '<div class="cpdata_code_peruser">&nbsp;</div>'
				+ '<div class="cpdata_code_actions">'
				+ '<div id="cpdata_prefix_delete_multi_' + prefix + '" class="cpdata_action_button delete button faux_button">Delete</div>'
				+ '<div id="cpdata_prefix_edit_multi_' + prefix + '" class="cpdata_action_button button faux_button">Edit</div>'
				+ '<div id="cpdata_prefix_download_' + prefix + '" class="cpdata_action_button button faux_button">Download</div>'
				+ '</div>'
				+ '<div class="clr"></div>'
				+ '</div>';

			// Render it
			$j(selector).append(row);



			/**
		 	* BIND CLICK HANDLERS
			 */

			// Show redeemed on click stats
			$j('[id="cpdata_prefix_' + id + '"]').on('click', '.cpdata_code_stats.faux_button', function () {
				page.showRedeemed(campaign.id, 0, prefix);
			});

			// Clicking edit button
			$j('[id="cpdata_prefix_edit_multi_' + prefix + '"]').on('click', function () {
				console.log('editing prefix', prefix);
				page.editPrefix(campaign.id, prefix);
			});

			$j('[id="cpdata_prefix_delete_multi_' + prefix + '"]').on('click', function () {
				console.log('deleting prefix', prefix);

				sa.confirm({
					text: 'Are you sure? This will delete this prefix and all its codes permanently. Credit already given out will not be erased.',
					yesFunction: function () {
						sa.api.request({
							handler: 'licensing/licensingCoupons',
							action: 'deletePrefix',
							postData: {
								campaign_id: campaign.id,
								prefix: prefix,
							}
						}).then(page.deleteHandler);
							
					},
					yesText: 'DELETE'
				});

			});

			$j('[id="cpdata_prefix_download_' + prefix + '"]').on('click', function () {
				console.log('downloading prefix', prefix);
				document.location.href = 'export.php?type=couponData&prefix=' + prefix + '&campaign_id=' + campaign.id;
			});


			return row;
		};

		var renderSingleCodeRow = function(selector, code) {

			var row = '<div data-type="single_code" id="cpdata_code_' + code.id + '" class="cpdata_code">'
				+ '<div class="cpdata_code_code">-- ' + code.code + '</div>'
				+ '<div class="cpdata_code_stats ' + ((code.uses == code.used) ? 'used' : '') + '">Used: ' + Math.round(100 * code.used / code.uses) + '% (' + code.used + '/' + code.uses + ')</div>'
				+ '<div class="cpdata_code_peruser">Per User: ' + code.uses_per_user + '</div>'
				+ '<div class="cpdata_code_actions">'
				+ '<div id="cpdata_code_delete_' + code.id + '" class="cpdata_action_button delete faux_button">Delete</div>'
				+ '<div id="cpdata_code_edit_' + code.id + '" class="cpdata_action_button button faux_button">Edit</div>'
				+ '</div>'
				+ '<div class="clr"></div>'
				+ '</div>';

			// Render the row
			$j(selector).append(row);



			/**
			 * BIND CLICK HANDLERS
			 */
			$j('[id="cpdata_code_edit_' + code.id + '"]').on('click', function () {
				console.log('editing code', code);
				page.editCode(code);
			});

			$j('[id="cpdata_code_delete_' + code.id + '"]').on('click', function () {
				console.log('deleting code', code);

				sa.confirm({
					text: 'Are you sure? This will delete this code permanently. Credit already given out will not be erased.',
					yesFunction: function () {
						sa.api.request({
							handler: 'licensing/licensingCoupons',
							action: 'deleteCode',
							postData: {
								code: code.code
							}
						}).then(page.deleteHandler);
					},
					yesText: 'DELETE'
				});

			});
			if (code.used) {
				$j('[id="cpdata_code_' + code.id + '"] .cpdata_code_stats').addClass('faux_button').on('click', function () {
					page.showRedeemed(code.campaign_id, code.code);
				});
			}

			return row;
		};

		/**
		 * ITERATE THROUGH THE CAMPAIGNS AND RENDER THEM
		 */
		$j.each(campaigns, function(campaign_id, campaign) {
			cpdata_list.append(
				'<div id="cpdata_row_' + campaign_id + '" class="cpdata_campaign_row ' + ((ii % 2) ? 'dark' : '') + '">'
				+	'<div class="cpdata_title faux_button">'+ campaign.title + '</div>'
				+	'<div class="cpdata_stats ' + ((campaign.total_uses == campaign.total_used) ? 'used' : '') + '">' + (campaign.total_uses ? 'Used: ' + Math.round(100 * campaign.total_used / campaign.total_uses) + '% (' + campaign.total_used + '/' + campaign.total_uses + ')' : '&nbsp;') + '</div>'
				+	'<div class="cpdata_expires '+((campaign.expires && campaign.expires <= now) ? 'expired">Expired: ' : '">Expires: ') + (campaign.expires ? formatDate('F j, Y', campaign.expires) : 'Never') + '</div>'
				+	'<div class="cpdata_actions">'
				+		'<div id="cpdata_delete_'+campaign_id+'" class="cpdata_action_button delete button faux_button">Delete</div>'
				+		'<div id="cpdata_edit_'+campaign_id+'" class="cpdata_action_button button faux_button">Edit</div>'
				+		'<div id="cpdata_generate_'+campaign_id+'" class="cpdata_action_button button faux_button">Create Codes</div>'
				+	'</div>'
				+	'<div class="clr"></div>'
				+ '</div>'
				+ '<div id="cpdata_codes_'+campaign.id+'" class="cp_data_codes" style="display:none;"></div>'
			);

			$j('#cpdata_generate_'+campaign_id).on('click', function() {
				console.log('generating codes for campaign', campaign_id);
				page.generateCodesForCampaign(campaign_id);
			});

			$j('#cpdata_edit_'+campaign_id).on('click', function() {
				console.log('editing campaign', campaign_id);
				page.editCampaign(campaign_id);
			});

			$j('#cpdata_delete_'+campaign_id).on('click', function() {
				console.log('deleting campaign', campaign_id);
				sa.confirm({
					text: 'Are you sure? This will delete all associated codes. Credit already given out will not be erased.',
					yesFunction: function() {
						sa.api.request({
							handler: 'licensing/licensingCoupons',
							action: 'deleteCampaign',
							postData: {
								id: campaign_id,
							}
						}).then(page.deleteHandler);
							
					},
					yesText: 'DELETE'
				});
			});


			/**
			 * RENDER THE EXISTING CODES
			 */
			var handledPrefixes = [];
			$j.each(campaign.codes, function (ind, code) {
				var wrapper = '',
					prefix = code.prefix,
					id = code.id;

				// Only handle prefixes once
				if (handledPrefixes.indexOf(prefix) !== -1) return;

				if (prefix !== '') {
					// If we have a non-empty prefix, then render the row as a prefix row
					// Handle prefix
					renderPrefixRow('#cpdata_codes_' + campaign.id, campaign, code);
					handledPrefixes.push(prefix);

				} else {
					// If not, render a single code row
					renderSingleCodeRow('#cpdata_codes_' + campaign.id, code);
				}

			});


			/**
			 * BIND CLICK HANDLERS FOR THE CAMPAIGN ROWS
			 */
			$j('#cpdata_row_' + campaign_id + ' .cpdata_title').on('click', function () {
				if ($j('#cpdata_codes_' + campaign_id).is(':visible')) {
					$j('#cpdata_codes_' + campaign_id).slideUp();
				} else {
					$j('#cpdata_codes_' + campaign_id).slideDown();
				}
			});

			if (campaign.total_used) {
				$j('#cpdata_row_' + campaign_id + ' .cpdata_stats').addClass('faux_button').on('click', function () {
					page.showRedeemed(campaign_id);
				});
			}



			ii++;
		});

		if (config.licensingConfig.plans && config.licensingConfig.processor == 'braintree') {
			sa.api.request({
				handler: 'purchaser',
				action: 'hasBraintreeDiscount'
			}).then(function (r) {
				page.hasDiscountTemplate = r['hasDiscountTemplate'];
				if (!page.hasDiscountTemplate) page.showBTdiscountInfo();
			});
		}

	};

	this.showRedeemed = function(campaign_id, code, prefix) {
		if(!code) code = 0;
		if(!prefix) prefix = 0;
		var box_content = '<div class="cpedit_generate_box">'
		+	'<div class="cpedit_title">Code Redemptions</div>'
		+	'<div class="cpredeemed_data">Loading...</div>'
		+	'<div class="cpedit_buttons">'
		+		'<div id="cpedit_cancel" class="cpedit_button faux_button button">Return to Coupons</div>'
		+		'<div id="cpedit_download" class="cpedit_button faux_button button">Download CSV</div>'
		+		'<div class="clr"></div>'
		+	'</div>'
		+ '</div>';

		box = new FocusBox(box_content);
		box.show();

		$j('#cpedit_cancel').on('click', function() {
			box.hide();
		});

		$j('#cpedit_download').on('click', function() {
			console.log('downloading remdemptions');
			document.location.href = 'export.php?type=redemptionExport&prefix='+prefix+'&campaign_id='+campaign_id+'&code='+code;
		});


		sa.api.request({
			handler: 'licensing/licensingCoupons',
			action: 'getRedeemed',
			getData: {
				code: 			code,
				campaign_id: 	campaign_id,
				prefix:			prefix,
			}
		}).then(page.redeemedHandler);
			
	};

	this.redeemedHandler = function(response) {
		console.log('redeemed response:', response);
		dataDiv = $j('.cpredeemed_data').html('');
		if(response.length) {
				var kk = 1;
			$j.each(response, function(key, item) {
				dataDiv.append(
					'<div class="cpredeemed_row ' + ((kk % 2) ? 'dark' : '') + '">'
					+	'<div class="cpredeemed_date">'+formatDate('F j, Y', item.date)+'</div>'
					+	'<div class="cpredeemed_user">'+((item.username) ? item.username : 'Unclaimed New User')+'</div>'
					+	'<div class="cpredeemed_code">'+item.code+'</div>'
					+	'<div class="clr"></div>'
					+ '</div>'
				);
				kk++;
			});
		}
	};

	this.generateCodesForCampaign = function(cid) {
		var campaign = campaigns[cid];

		var box_content = '<div class="cpedit_generate_box">'
		+	'<div class="cpedit_title">Generate Codes</div>'
		+	'<span style="display: block; margin-bottom: 10px; background: #eee; padding: 5px 10px;"><strong>Note</strong>: A billing cycle refers to how often a subscription is renewed. 1 billing cycle for an annual plan is 12 months. 2 billing cycles for a 2 month plan equals 4 months.</span>'
		+	'<div class="cpedit_inputs">'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Coupon Type:</div>'
		+			'<div class="cpedit_input_input"><select id="coupon_type"><option value="dl_credits">Download credit</option><option value="perc_off">Percent off item</option><option value="perc_off_cart">Percent off cart</option></select></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">How Many Codes?:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpnum" value="1"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Code:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpcode"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row" style="display:none;">'
		+			'<div class="cpedit_input_title">Code Prefix:<Br><span style="color: #CCC;">("E32K-" for codes like E32K-ABI35R)</span></div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpprefix"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row" style="display:none;">'
		+			'<div class="cpedit_input_title">Random Characters:<Br><span style="color: #CCC;">(number of characters after your prefix)</span></div>'
		+			'<div class="cpedit_input_input"><select id="cprandomness"><option value="0">auto</option> <option>3</option> <option>4</option> <option>5</option> <option>6</option> <option>7</option> <option>8</option> <option>9</option> <option>10</option></select></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Expires:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpexpires"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Uses:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpuses" value="1"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Uses Per User:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpusesperuser" value="1"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div id="sub_discount" class="ctype_input_div hidden">'
		+			'<div class="cpedit_input_row">'
		+				'<div class="cpedit_input_title">Subscription Discount:</div>'
		+				'<div class="cpedit_input_input"><select id="cptrial"><option value="0">None</option></select><span>for <select id="cptriallength"><option value="0">perpetutity</option></select></div>'
		+				'<div class="clr"></div>'
		+			'</div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div id="dl_credits" class="ctype_input_div">'
		+				'<div class="cpedit_input_title">Download Credits:</div>'
		+				'<div class="cpedit_input_input"><input type="text" id="cpdownloads" value="0" /></div>'
		+			'</div>'
		+			'<div id="perc_off" class="ctype_input_div hidden">'
		+				'<div class="cpedit_input_title">Percent off:</div>'
		+				'<div class="cpedit_input_input"><input type="number" min="1" max="100" id="cppercent_off" value="0" /></div>'
		+			'</div>'
		+			'<div id="perc_off_cart" class="ctype_input_div hidden">'
		+				'<div class="cpedit_input_title">Percent off Cart:</div>'
		+				'<div class="cpedit_input_input"><input type="number" min="1" max="100" id="cppercent_off_cart" value="0" /></div>'
		+			'</div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+	'</div>'
		+	'<div class="cpedit_buttons">'
		+		'<div id="cpedit_submit" class="cpedit_button faux_button button">Submit</div>'
		+		'<div id="cpedit_cancel" class="cpedit_button faux_button button deemphasized">Cancel</div>'
		+		'<div class="clr"></div>'
		+	'</div>'
		+'</div>';

		box = new FocusBox(box_content);
		box.show();

		if (page.hasDiscountTemplate && config.licensingConfig.plans && config.licensingConfig.processor == 'braintree') {
			//add subscriptions to coupon type pulldown
			$j('#coupon_type').append('<option value="sub_discount">Subscription Discount</option>');
			$j.each(config.licensingConfig.plans, function (id, sub) {
				if (!sub.price || sub.hidden) return true;
				$j("#cptrial option[value=0]").remove();
				$j('#cptrial').append('<option value="' + sub.id + '">' + sub.title + '</option>');
				
				var optionCount = $j('#cptriallength option').length;
				if (optionCount < 12) {
					var options = '';
					for (var i = 1; i < 13; i++ ) {
						options += `<option value="${i}">${i + (i >= 2 ? ' Billing Cycles' : ' Billing Cycle')}</option>`;
					}
					$j('#cptriallength').append(options);
				}
			});
		}

		function toggleCouponType(cType = 'dl_credits', cTypeVal = 0) {
			$j('.ctype_input_div').each(function () {
				$j(this).find('input').val(0);
				$j(this).hide();
			});

			$j('#' + cType).show();
			if (cType != 'sub_discount') {
				$j('#' + cType).find('input').val(cTypeVal);
			} else {
				$j('#perc_off').show();
				$j('#perc_off').find('input').val(cTypeVal);
			}
		}

		$j('#coupon_type').on('change', function () {
			var cType = $j(this).val();
			toggleCouponType(cType);
		});

		$j('#cpexpires').datepicker({ dateFormat: config.datePickerDateFormatString });

		$j('#cpexpires').on('change', function() {
			if($j('#cpexpires').val() == '') {
				$j('#cpexpires').val('never');
				$j('#cpexpires').addClass('never');
			} else {
				$j('#cpexpires').removeClass('never');
			}
		});

		$j('#cpexpires').trigger('change');

		if(campaign.expires) $j('#cpexpires').datepicker('setDate', new Date(campaign.expires * 1000));

		$j('#cpnum').on('change', function() {
			var num = parseInt($j('#cpnum').val());
			$j('#cpnum').val(num);

			if(num > 1) {
				$j('#cpprefix').parent().parent().slideDown();
				$j('#cprandomness').parent().parent().slideDown();
				$j('#cpcode').parent().parent().slideUp();
			} else {
				$j('#cpprefix').parent().parent().slideUp();
				$j('#cprandomness').parent().parent().slideUp();
				$j('#cpcode').parent().parent().slideDown();
			}
		});

		$j('#cpedit_cancel').on('click', function() {
			box.hide();
		});

		$j('#cpedit_submit').on('click', function() {
			var vars = {};
			vars.coupon_type = $j('#coupon_type').val();
			vars.campaign_id = campaign.id;
			vars.code = $j('#cpcode').val().toUpperCase();
			vars.num = $j('#cpnum').val();
			vars.prefix = $j('#cpprefix').val();
			vars.randomness = $j('#cprandomness').val();
			vars.expires = $j('#cpexpires').val();
			vars.uses = $j('#cpuses').val();
			vars.uses_per_user = $j('#cpusesperuser').val();
			vars.downloads = $j('#cpdownloads').val();
			vars.percent_off = $j('#cppercent_off').val();
			vars.percent_off_cart = $j('#cppercent_off_cart').val();
			vars.sub_trial_plan = $j('#cptrial').val();
			vars.sub_trial_length = $j('#cptriallength').val();
			$j('#cpedit_submit').html('Saving...');
			console.log('submitting code with', vars);

			sa.api.request({
				handler: 'licensing/licensingCoupons',
				action: 'generateCodes',
				getData: {
					input: vars
				}
			}).then(page.saveHandler);
				
		});
	};

	this.editPrefix = function(campaign_id, prefix_id) {
		var prefix = campaigns[campaign_id].prefixes[prefix_id];
		var code = prefix.codes[0];
		// var code = prefix.sample;

		var box_content = '<div class="cpedit_code_box">'
		+	'<div class="cpedit_title">Edit Prefix</div>'
		+	'<span style="display: block; margin-bottom: 10px; background: #eee; padding: 5px 10px;"><strong>Note</strong>: A billing cycle refers to how often a subscription is renewed. 1 billing cycle for an annual plan is 12 months. 2 billing cycles for a 2 month plan equals 4 months.</span>'
		+	'<div class="cpedit_inputs">'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Coupon Type:</div>'
		+			'<div class="cpedit_input_input"><select id="coupon_type"><option value="dl_credits">Download credit</option><option value="perc_off">Percent off item</option><option value="perc_off_cart">Percent off cart</option></select></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Expires:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpexpires"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Uses:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpuses"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Uses Per User:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpusesperuser"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div id="sub_discount" class="ctype_input_div hidden">'
		+			'<div class="cpedit_input_row">'
		+				'<div class="cpedit_input_title">Subscription Discount:</div>'
		+				'<div class="cpedit_input_input"><select id="cptrial"><option value="0">None</option></select><span>for <select id="cptriallength"><option value="0">perpetutity</option></select></div>'
		+				'<div class="clr"></div>'
		+			'</div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div id="dl_credits" class="ctype_input_div">'
		+				'<div class="cpedit_input_title">Download Credits:</div>'
		+				'<div class="cpedit_input_input"><input type="text" id="cpdownloads"/></div>'
		+			'</div>'
		+			'<div id="perc_off" class="ctype_input_div hidden">'
		+				'<div class="cpedit_input_title">Percent off:</div>'
		+				'<div class="cpedit_input_input"><input type="number" min="1" max="100" id="cppercent_off"/></div>'
		+			'</div>'
		+			'<div id="perc_off_cart" class="ctype_input_div hidden">'
		+				'<div class="cpedit_input_title">Percent off Cart:</div>'
		+				'<div class="cpedit_input_input"><input type="number" min="1" max="100" id="cppercent_off_cart"/></div>'
		+			'</div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+	'</div>'
		+	'<div class="cpedit_buttons">'
		+		'<div id="cpedit_cancel" class="cpedit_button faux_button button">Cancel</div>'
		+		'<div id="cpedit_submit" class="cpedit_button faux_button button deemphazied">Submit</div>'
		+	'</div>'
		+ '</div>';

		box = new FocusBox(box_content);
		box.show();

		if (page.hasDiscountTemplate && config.licensingConfig.plans) {
			//add subscriptions to coupon type pulldown
			$j('#coupon_type').append('<option value="sub_discount">Subscription Discount</option>');
			$j.each(config.licensingConfig.plans, function (id, sub) {
				if (!sub.price) return true;
				if (!sub.hidden || (sub.hidden && code && code.sub_trial_plan == sub.id)) {
					$j("#cptrial option[value=0]").remove();
					$j('#cptrial').append('<option value="' + sub.id + '">' + sub.title + '</option>');
					if ($j('#cptriallength option').length != 13) {
						for (var i = 1; i < 13; i = i + 1) {
							$j('#cptriallength').append('<option value="' + i + '">' + i + ' ' + (i >= 2 ? 'Billing Cycles' : 'Billing Cycle') + '</option>');
						}
					}
				}
			});
		}

		function toggleCouponType(cType = 'dl_credits', cTypeVal = 0) {
			$j('.ctype_input_div').each(function () {
				$j(this).find('input').val(0);
				$j(this).hide();
			});

			$j('#' + cType).show();
			if (cType != 'sub_discount') {
				$j('#' + cType).find('input').val(cTypeVal);
			} else {
				$j('#perc_off').show();
				$j('#perc_off').find('input').val(cTypeVal);
			}
		}

		$j('#cpexpires').datepicker({ dateFormat: config.datePickerDateFormatString });

		$j('#cpexpires').on('change', function() {
			if($j('#cpexpires').val() == '') {
				$j('#cpexpires').val('never');
				$j('#cpexpires').addClass('never');
			} else {
				$j('#cpexpires').removeClass('never');
			}
		});

		$j('#cpexpires').trigger('change');

		$j('.cpedit_title').html('Editing Prefix: ' + prefix_id);
		if(code.expires) $j('#cpexpires').datepicker('setDate', new Date(code.expires * 1000));
		$j('#cpuses').val(code.uses);
		$j('#cpusesperuser').val(code.uses_per_user);
		$j('#cpdownloads').val(code.downloads);
		$j('#cppercent_off').val(code.percent_off);
		$j('#cppercent_off_cart').val(code.percent_off_cart);
		$j('#cptrial').val(code.sub_trial_plan);
		$j('#cptriallength').val(code.sub_trial_length);

		if (code) {
			var cType = code.downloads ? 'dl_credits' : code.percent_off_cart ? 'perc_off_cart' : code.sub_trial_plan ? 'sub_discount' : 'perc_off';
			var cTypeVal = code.downloads ? code.downloads : code.percent_off_cart ? code.percent_off_cart : code.percent_off;
			$j('#coupon_type').val(cType);
			toggleCouponType(cType, cTypeVal);
		}

		$j('#coupon_type').on('change', function () {
			cType = $j(this).val();
			toggleCouponType(cType);
		});

		$j('#cpedit_cancel').on('click', function() {
			box.hide();
		});

		$j('#cpedit_submit').on('click', function() {
			var vars = {};
			vars.coupon_type = $j('#coupon_type').val();
			vars.prefix = prefix_id;
			vars.campaign_id = code.campaign_id;
			vars.expires = $j('#cpexpires').val();
			vars.uses = $j('#cpuses').val();
			vars.uses_per_user = $j('#cpusesperuser').val();
			vars.downloads = $j('#cpdownloads').val();
			vars.percent_off = $j('#cppercent_off').val();
			vars.percent_off_cart = $j('#cppercent_off_cart').val();
			vars.sub_trial_plan = $j('#cptrial').val();
			vars.sub_trial_length = $j('#cptriallength').val();
			$j('#cpedit_submit').html('Saving...');
			console.log('submitting code with', vars);

			sa.api.request({
				handler: 'licensing/licensingCoupons',
				action: 'editPrefix',
				getData: {
					input: vars
				}
			}).then(page.saveHandler);
				
		});
	};

	this.editCode = function(code) {
		var box_content = '<div class="cpedit_code_box">'
		+	'<div class="cpedit_title">Generate Codes</div>'
		+	'<span style="display: block; margin-bottom: 10px; background: #eee; padding: 5px 10px;"><strong>Note</strong>: A billing cycle refers to how often a subscription is renewed. 1 billing cycle for an annual plan is 12 months. 2 billing cycles for a 2 month plan equals 4 months.</span>'
		+	'<div class="cpedit_inputs">'
		+		'<div class="cpedit_input">'
		+			'<div class="cpedit_input_title">Coupon Type:</div>'
		+			'<div class="cpedit_input_input"><select id="coupon_type"><option value="dl_credits">Download credit</option><option value="perc_off">Percent off item</option><option value="perc_off_cart">Percent off cart</option></select></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Code:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpcode"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Expires:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpexpires"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Uses:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpuses"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Uses Per User:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpusesperuser"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div id="sub_discount" class="ctype_input_div hidden">'
		+			'<div class="cpedit_input_row">'
		+				'<div class="cpedit_input_title">Subscription Discount:</div>'
		+				'<div class="cpedit_input_input"><select id="cptrial"><option value="0">None</option></select><span>for <select id="cptriallength"><option value="0">perpetutity</option></select></div>'
		+				'<div class="clr"></div>'
		+			'</div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div id="dl_credits" class="ctype_input_div">'
		+				'<div class="cpedit_input_title">Download Credits:</div>'
		+				'<div class="cpedit_input_input"><input type="text" id="cpdownloads"/></div>'
		+			'</div>'
		+			'<div id="perc_off" class="ctype_input_div hidden">'
		+				'<div class="cpedit_input_title">Percent off:</div>'
		+				'<div class="cpedit_input_input"><input type="number" min="1" max="100" id="cppercent_off"/></div>'
		+			'</div>'
		+			'<div id="perc_off_cart" class="ctype_input_div hidden">'
		+				'<div class="cpedit_input_title">Percent off Cart:</div>'
		+				'<div class="cpedit_input_input"><input type="number" min="1" max="100" id="cppercent_off_cart"/></div>'
		+			'</div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+	'</div>'
		+	'<div class="cpedit_buttons">'
		+		'<div id="cpedit_submit" class="cpedit_button faux_button button">Submit</div>'
		+		'<div id="cpedit_cancel" class="cpedit_button faux_button button deemphazid">Cancel</div>'
		+		'<div class="clr"></div>'
		+	'</div>'
		+ '</div>';

		box = new FocusBox(box_content);
		box.show();

		if (page.hasDiscountTemplate && config.licensingConfig.plans) {
			//add subscriptions to coupon type pulldown
			$j('#coupon_type').append('<option value="sub_discount">Subscription Discount</option>');
			$j.each(config.licensingConfig.plans, function (id, sub) {
				if (!sub.price) return true;
				if (!sub.hidden || (sub.hidden && code && code.sub_trial_plan == sub.id)) {
					$j("#cptrial option[value=0]").remove();
					$j('#cptrial').append('<option value="' + sub.id + '">' + sub.title + '</option>');
					if ($j('#cptriallength option').length != 13) {
						for (var i = 1; i < 13; i = i + 1) {
							$j('#cptriallength').append('<option value="' + i + '">' + i + ' ' + (i >= 2 ? 'Billing Cycles' : 'Billing Cycle') + '</option>');
						}
					}
				}
			});
		}

		function toggleCouponType(cType = 'dl_credits', cTypeVal = 0) {
			$j('.ctype_input_div').each(function () {
				$j(this).find('input').val(0);
				$j(this).hide();
			});

			$j('#' + cType).show();
			if (cType != 'sub_discount') {
				$j('#' + cType).find('input').val(cTypeVal);
			} else {
				$j('#perc_off').show();
				$j('#perc_off').find('input').val(cTypeVal);
			}
		}

		$j('#cpexpires').datepicker({ dateFormat: config.datePickerDateFormatString });

		$j('#cpexpires').on('change', function() {
			if($j('#cpexpires').val() == '') {
				$j('#cpexpires').val('never');
				$j('#cpexpires').addClass('never');
			} else {
				$j('#cpexpires').removeClass('never');
			}
		});

		$j('#cpexpires').trigger('change');

		if (code) {
			$j('.cpedit_title').html('Editing Code: ' + code.code);
			$j('#cpcode').val(code.code);
			if(code.expires) $j('#cpexpires').datepicker('setDate', new Date(code.expires * 1000));
			$j('#cpuses').val(code.uses);
			$j('#cpusesperuser').val(code.uses_per_user);
			$j('#cpdownloads').val(code.downloads);
			$j('#cppercent_off').val(code.percent_off);
			$j('#cppercent_off_cart').val(code.percent_off_cart);
			$j('#cptrial').val(code.sub_trial_plan);
			$j('#cptriallength').val(code.sub_trial_length);
			var cType = code.downloads ? 'dl_credits' : code.percent_off_cart ? 'perc_off_cart' : code.sub_trial_plan ? 'sub_discount' : 'perc_off';
			var cTypeVal = code.downloads ? code.downloads : code.percent_off_cart ? code.percent_off_cart : code.percent_off;
			$j('#coupon_type').val(cType);
			console.log(`ctype ${cType} cval ${cTypeVal}`);
			toggleCouponType(cType, cTypeVal);
		}

		$j('#coupon_type').on('change', function () {
			cType = $j(this).val();
			toggleCouponType(cType);
		});

		$j('#cpedit_cancel').on('click', function() {
			box.hide();
		});

		$j('#cpedit_submit').on('click', function() {
			var vars = {};
			vars.coupon_type = $j('#coupon_type').val();
			vars.ocode = code.code;
			vars.code = $j('#cpcode').val();
			vars.expires = $j('#cpexpires').val();
			vars.uses = $j('#cpuses').val();
			vars.uses_per_user = $j('#cpusesperuser').val();
			vars.downloads = $j('#cpdownloads').val();
			vars.percent_off = $j('#cppercent_off').val();
			vars.percent_off_cart = $j('#cppercent_off_cart').val();
			vars.sub_trial_plan = $j('#cptrial').val();
			vars.sub_trial_length = $j('#cptriallength').val();
			$j('#cpedit_submit').html('Saving...');
			console.log('submitting code with', vars);

			sa.api.request({
				handler: 'licensing/licensingCoupons',
				action: 'editCode',
				getData: {
					input: vars
				}
			}).then(page.saveHandler);
				
		});
	};

	this.editCampaign = function(cid) {
		var box_content = '<div class="cpedit_box">'
		+	'<div class="cpedit_title">New Campaign</div>'
		+	'<div class="cpedit_inputs">'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Title:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cptitle"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title">Expires:</div>'
		+			'<div class="cpedit_input_input"><input type="text" id="cpexpires"/></div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+		'<div class="cpedit_input_row">'
		+			'<div class="cpedit_input_title"><input id="cpapply" type="checkbox" checked="checked"/></div>'
		+			'<div class="cpedit_input_input">Apply expiration to campaign\'s codes</div>'
		+			'<div class="clr"></div>'
		+		'</div>'
		+	'</div>'
		+	'<div class="cpedit_buttons">'
		+		'<div id="cpedit_submit" class="cpedit_button faux_button button">Submit</div>'
		+		'<div id="cpedit_cancel" class="cpedit_button faux_button button deemphazied">Cancel</div>'
		+		'<div class="clr"></div>'
		+	'</div>'
		+ '</div>';

		box = new FocusBox(box_content);
		box.show();

		$j('#cpexpires').datepicker({ dateFormat: config.datePickerDateFormatString });

		$j('#cpexpires').on('change', function() {
			if($j('#cpexpires').val() == '') {
				$j('#cpexpires').val('never');
				$j('#cpexpires').addClass('never');
			} else {
				$j('#cpexpires').removeClass('never');
			}
		});

		$j('#cpexpires').trigger('change');

		if(cid) {
			var campaign = campaigns[cid];
			$j('.cpedit_title').html('Editing Campaign: ' + campaign.title);
			$j('#cptitle').val(campaign.title);
			if(campaign.expires) $j('#cpexpires').datepicker('setDate', new Date(campaign.expires * 1000));
		} else {
			$j('#cpapply').parent().parent().hide();
		}

		$j('#cpedit_cancel').on('click', function() {
			box.hide();
		});

		$j('#cpedit_submit').on('click', function() {
			var vars = {};
			if(cid) vars.campaign_id = cid;
			vars.title = $j('#cptitle').val();
			vars.expires = $j('#cpexpires').val();
			vars.applyToCodes = $j('#cpapply').filter(':checked').length;
			$j('#cpedit_submit').html('Saving...');
			console.log('submitting campaign with', vars);

			var endpointAction = !cid ? 'newCampaign' : 'editCampaign';
			sa.api.request({
				handler: 'licensing/licensingCoupons',
				action: endpointAction,
				getData: {
					input: vars
				}
			}).then(page.saveHandler);
				
		});
	};

	this.saveHandler = function(response) {
		console.log('save response:', response);
		if(response.error) {
			alert('Error: ' + response.error);
			return;
		}
		if(box) box.hide();
		page.loadCouponData();
	};

	this.deleteHandler = function(response) {
		console.log('delete response:', response);
		if(response.error) {
			alert('Error: ' + response.error);
			return;
		}
		if(box) box.hide();
		page.loadCouponData();
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (this.currentTab == pageId) {
			this.currentPage.show(sa.router.getCurrentQueryParams(), container);
			return;
		}
		this.currentTab = pageId;
		// and then if we found it, have it load based on the current params
		if (pageId == 'edit') {
			this.currentPage = new AdminEditLicense();
			this.currentPage.show(sa.router.getCurrentQueryParams(), container);
		} else if (pageId == 'preview') {
			this.currentPage = new AdminFindUser();
			this.currentPage.show(sa.router.getCurrentQueryParams(), container);
		} else {
			container.html('you\'re on the ' + pageId + ' page!');
		}
	};
}
/**
 * A page in the admin panel
 */
function AdminLicensingActivity() {
	var page = this;
	var templates = sa.templates.get('admin.licensing');

	this.activities = {};
	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		console.log('- showing activity');
		window.activePage = page;
		page.pageTemplate = templates.get('activity');
		container.html( '<div id="activity-loader"></div>' );
		page.container = container;
		showLoader('#activity-loader', 'Loading Activity');
		page.vars = sa.router.getCurrentParamsAsObject();
		console.log(page.vars);

		page.load();
	};

	this.load = async function() {
		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'getActivity',
			getData: {
				pg: page.vars.pg || 0,
				show: page.vars.show || 25,
				affiliate: page.vars.affiliate || ''
			}
		});
		
		let listIncludesSandboxActivities = r.items.find(item => item.is_test_activity === 1);

		console.log('- activity:', r);
		if (r.error) sa.notify({ text: r.error });

		page.container.html(page.pageTemplate);
		page.setupButtons();

		// are there affiliates?
		if (r.affiliates && r.affiliates.length) {
			page.affiliates = r.affiliates;
			var affdiv = $j('#activity-affiliate-filter');
			_.each(r.affiliates, function (a) {
				affdiv.find('select').append('<option ' + (page.vars.affiliate == a ? 'selected="selected"' : '') + '>' + a + '</option>');
			});
			affdiv.show();
			affdiv.find('select').off().on('change', function () {
				var aff = $j(this).val();
				console.log('- affiliate change:', aff);
				sa.router.routeTo('/admin?p=ecommerce&tab=activity&affiliate=' + aff);
			});
		}

		var conf = new ListConfig();
		conf.bankKey = 'licensing_activity_page';
		conf.sortable = true;
		
		let columnList = [
			new ListColumn('user', ['licensee'], true),
			new ListColumn('activity', ['licensing_status'], true),
			(listIncludesSandboxActivities ? new ListColumn(' ', ['is_sandbox_activity']) : null),
			new ListColumn('date', ['licensing_date'], true),
			new ListColumn('amount', ['licensing_price'], true),
			new ListColumn('links', ['licensing_view'])
		];
		
		// Filter out null columns (e.g. - sandbox activity, if not present)
		conf.addColumnList(columnList.filter(column => column));

		var list = createLicensingActivityList(conf);
		list.generatePage($j('#list_' + conf.bankKey));

		var listInfo = r.listInfo;
		var listParams = {
			count: listInfo.count || 25,
			page: listInfo.pg || 0,
			perPage: listInfo.show || 25,
			pageVars: ((listInfo.o) ? 'o=' + listInfo.o + '&d=' + listInfo.d + '&' : '') + '&show=' + listInfo.show + '&pg='
		};

		//console.log('list params:', listParams);
		//format data
		var listItems = [];
		listItems.push(listParams);

		_.each(r.items, function (a) {
			page.activities[a.id] = a;

			// generate descrtiption from activity type
			var description = '';
			if (a.type == 'license') {
				description = 'Licensed ' + a.num + ' tracks<br><span>&raquo; Show Tracks</span>';
			} else
				if (a.type == 'user_subscription') {
					description = 'Signed up for ' + a.plan.title + ' plan';
				} else
					if (a.type.indexOf('user_subscription') != -1) {
						var aa = a.type.split('_');
						var action = aa.pop();
						description = ucfirst(action) + (action.charAt(action.length - 1) == 'e' ? '' : 'e') + 'd ' + (action == 'cancel' ? '' : 'to') + ' ' + a.plan.title;
					} else {
						description = '[' + a.type + ']';
					}
			if (a.affiliate) description = '[<span class="aff">' + a.affiliate + '</span>] ' + description;

			var purchase = a.purchase_id.split('::');
			var purchaseLink = '';
			if (purchase[0] == 'braintree') {
				purchaseLink = 'https://' + (config.licensingConfig.braintree_credentials.sandbox ? 'sandbox' : 'www') + '.braintreegateway.com/merchants/' + config.licensingConfig.braintree_credentials.merchantId + '/transactions/' + purchase[1];
			} else
				if (purchase[0] == 'subscription') {
					purchaseLink = 'https://' + (config.licensingConfig.braintree_credentials.sandbox ? 'sandbox' : 'www') + '.braintreegateway.com/merchants/' + config.licensingConfig.braintree_credentials.merchantId + '/subscriptions/' + purchase[1];
				} else
					if (purchase[0] == 'paypal') {
						purchaseLink = 'https://www.' + (config.licensingConfig.paypal_credentials.sandbox ? 'sandbox.' : '') + 'paypal.com/cgi-bin/webscr?cmd=_view-a-trans&id=' + purchase[1];
					}
			var couponType = (a.coupon_type == 'subscription' ? a.coupon_type + ']' : a.coupon_type !== 'percent_off' ? 'cart]' : 'item]');
			var percentCoupon = (a.percent_off ? '<br/>[' + a.coupon_code + ', ' + a.percent_off + '% off ' + couponType : '');


			var item = {
				id: a.id,
				licensee: htmlEncode(a.user.username),
				licensing_status: description,
				licensing_date: formatDate('Y-n-j', a.date),
				licensing_price: (a.amount_paid ? (a.amount_paid / 100).currencyFormat() + (a.credit_used ? '<br>' : '') : (a.credit_used ? '' : 'No payment')) + (a.credit_used ? 'Credit: ' + a.credit_used : '') + percentCoupon,
				licensing_view: (a.type == 'license' ? '<a target="_blank" href="pdf.php?type=licensing_invoice&transaction_id=' + a.item_id + '">&raquo; Invoice</a>' : '') + (purchase[0] && purchase[0] != 'credit' && purchase[0] != 'subscription' ? '<a target="_blank" href="' + purchaseLink + '">&raquo; Transaction</a>' : '') + (purchase[0] && purchase[0] == 'subscription' ? '<a target="_blank" href="' + purchaseLink + '">&raquo; Subscription' : ' ')
			};
			
			if (listIncludesSandboxActivities) {
				item['is_sandbox_activity'] =  (a.is_test_activity ? '<span class="sandbox-pill">Sandbox</span>' : '<span class="sandbox-pill no-sandbox-active">Sandbox</span>');
			}

			listItems.push(item);
		});

		list.setData(listItems, function (params) { return '/admin?p=ecommerce&tab=activity&' + params; }, function (params) { return true; });

		page.mainList = list;
		page.container.find('.lc_licensing_status span').on('click', page.showLicenses);
			
	};

	this.showLicenses = async function() {
		var id = $j(this).parent().parent().parent().attr('id');
		console.log('- clicked:', id);

		id = id.split('_').pop();
		var activity = page.activities[id];
		console.log('- activity:', activity);

		var row = page.container.find('#lr_' + id);
		if (row.hasClass('showing')) {
			page.container.find('#row_sub_' + id).remove();
			row.removeClass('showing');
			return;
		}


		row.addClass('showing');
		var div = row.after( '<tr id="row_sub_' + id + '" class="sub_row alternates_container_row"><td colspan="5"><div id="lr_sub_' + id + '">Loading...</div></td></tr>' );

		const r = await sa.api.request({
			handler: 'licensing/licensingAdmin',
			action: 'getLicense',
			getData: {
				transaction_id: activity.item_id
			}
		});

		console.log(r);
		
		//trackbank
		trackBank.clear('licensing_history_page');
		r.tracks = JSON.parse(r.tracks);
		console.log('- parsed:', r.tracks);
		var tracks = {};
		_.each(r.tracks, function (track) {
			if (!track.id) return;
			tracks[track.id] = track;
			trackBank.add(track, 'licensing_history_page');
		});

		var conf = new ListConfig();
		conf.bankKey = 'licensing_history_page';
		conf.sortable = true;
		conf.resultCountChanging = false;
		conf.pagination = false;
		conf.addColumnList([
			new ListColumn('track', ['play', 'title'], true),
			new ListColumn('links', ['licensing_view'])
			//new ListColumn('source files', ['source_download'])
		]);

		var list = createLicensingActivityList(conf);
		list.generatePage($j('#lr_sub_' + id).html(''));

		var listParams = {
			count: 25,
			page: 1,
			perPage: 25,
			pageVars: '&pg='
		};

		//console.log('list params:', listParams);
		//format data
		var listItems = [];
		var highlightItems = [];
		listItems.push(listParams);

		_.each(r.items, function (a) {

			var track = tracks[a.track_id];

			var projects = [];
			try {
				projects = JSON.parse(a.project);
			} catch (e) { }

			var extra = {};
			if (a.data) {
				try {
					extra = JSON.parse(a.data) || {};
				} catch (e) {
					console.log('- error parsing data from:', a.data);
				}
			}

			var item = {
				id: a.track_id,
				title: track ? track.title + (extra.alts ? ' [+' + extra.alts + ']' : '') : '[Deleted Track]',
				licensing_view: '<a target="_blank" href="pdf.php?type=licensing_invoice&transaction_id=' + a.transaction_id + '">&raquo; Invoice</a>  <a target="_blank" href="pdf.php?type=licensing_license&license_id=' + a.id + '">&raquo; License</a>' + (projects && projects.length ? '  <a id="project-' + a.id + '" class="project-details-link">&raquo; Project Details</a>' : '')
			};

			listItems.push(item);
		});

		list.setData(listItems, function (params) { return '/dashboard?p=licensing-history&' + params; }, function (params) { console.log('sort click'); return true; });

		page.container.find('.project-details-link').on('click', function () {
			var id = $j(this).attr('id').split('-')[1];
			console.log('- details link', id);

			var previous = $j(this).parent().parent().parent().find('.project-details-row');
			console.log(previous);
			if (previous.length) {
				previous.remove();
				list.updateAlternatesHeight();
				return;
			}

			var p = _.find(r.items, function (a) { return a.id == id; });
			var projects = JSON.parse(p.project);
			console.log(p.id, projects);
			var pdiv = '<tr class="project-details-row"><td colspan="3">';
			_.each(projects, function (f) {
				pdiv += '<b>' + htmlDecode(f.name) + '</b><br>' + htmlDecode(f.value) + '<BR><BR>';
			});
			pdiv += '</td></tr>';

			$j(this).parent().parent().after(pdiv);

			list.updateAlternatesHeight();
		});

		page.mainList.updateAlternatesHeight();
			
	};

	this.setupButtons = function() {
		page.container.find('#export-licenses').on('click',  function(e) { page.showExport('licensing', 'License'); });
		page.container.find('#export-transactions').on('click',  function(e) { page.showExport('transaction', 'Transaction'); });
	};

	this.showExport = function(type, displayType) {
		var box;
		var box_content = templates.get('export');

		box = new FocusBox(box_content, { title : displayType + ' History Export' });
		box.show();

		$j('#ladmin_cancel').on('click', function() {
			box.hide();
		});

		$j('#ladmin_download').on('click', function() {
			var start = $j('#ladmin_export_start').val();
			var end = $j('#ladmin_export_stop').val();
			var affiliate = $j('#ladmin_export_affiliate').val();
			box.showLoader('Exporting...');

			$j("#ladmin_download").hide();
			$j(".focused_container").height($j(".focused_container").height() + 15);
			$j(".ladmin_box").height($j(".ladmin_box").height() + 15);

			var exportType = (type == 'transaction') ? 'LicensingActivity' : 'LicensingLicenses';

			window.location.href = 'export.php?type='+exportType+'&start='+encodeURIComponent(start)+'&end='+encodeURIComponent(end)+'&affiliate='+encodeURIComponent(affiliate);
			box.hide();
		});

		$j('#ladmin_export_start').datepicker({ dateFormat: config.datePickerDateFormatString });
		$j('#ladmin_export_stop').datepicker({ dateFormat: config.datePickerDateFormatString });

		if (page.affiliates) {
			var affdiv = $j('.ladmin_affiliate');
			_.each(page.affiliates, function(a) {
				affdiv.find('select').append('<option ' + (page.vars.affiliate == a ? 'selected="selected"' : '' ) + '>' + a + '</option>');
			});
			affdiv.show();
		}

		var month_ago = new Date();
		month_ago.setMonth(month_ago.getMonth - 1);

		$j('#ladmin_export_start').datepicker('setDate', '-1m');
		$j('#ladmin_export_stop').datepicker('setDate', new Date());
	};
}
/**
 * The page in the admin panel that lets you manipulate your featured content
 */
function AdminMetadata() {
	let page = this;
	let currentTab = '';
	let currentPage;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Metadata)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Edit Metadata and Add and Delete Tracks' + '" permission.</h3>');
		}
		if (!$j('.right_body.metadata').length) {
			const accessData = await sa.api.request({
				handler : 'settings',
				action : 'get-access'
			});

			var callback = function(tabId, cont) { page.setPage(tabId, cont); }, tabs = [];
      		let baseUrl = siteBaseUrl();
			const pages = [
				{ id: 'checkup', href: baseUrl + '/admin?p=metadata&tab=checkup', title: 'Checkup', hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio'] },
				{ id: 'import', href: baseUrl + '/admin?p=metadata&tab=import', title: 'Import Data', hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
				{ id: 'aitools-tagging', href: baseUrl + '/admin?p=aitools&tab=metadata', title: 'AI Tagging', hasPageFeature: true, enabledSiteTypes: ['seller']},
				{ id: 'export', href: baseUrl + '/admin?p=metadata&tab=export', title: 'Export Data', hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
				{ id: 'catalogs', href: baseUrl + '/admin?p=metadata&tab=catalogs', title: config.getDictionaryEntry('catalog', true), hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
				{ id: 'rules', href: baseUrl + '/admin?p=metadata&tab=rules', title: 'Rules', hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
				{ id: 'nesting', href: baseUrl + '/admin?p=metadata&tab=nesting', title: 'Nesting', hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
				{ id: 'downloading', href: baseUrl + '/admin?p=metadata&tab=downloading', title: 'Downloading', hasPageFeature: accessData['catalogs'].length, enabledSiteTypes: ['seller', 'network', 'radio', 'drop'] },
				{ id: 'fields', href: baseUrl + '/admin?p=metadata&tab=fields', title: 'Fields', hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] },
				{ id: 'people', href: baseUrl + '/admin?p=metadata&tab=people', title: 'Interested Parties', hasPageFeature: true, enabledSiteTypes: ['seller', 'network', 'radio', 'drop']},
			];
			for (var p of pages) {
				if (p.enabledSiteTypes.includes(config.siteType) && p.hasPageFeature) tabs.push(new RightTab(p.id, p.href, p.title, callback));
			}
			RightTabbedPage.prototype.show.call(page, 'metadata', container, tabs, '');
			// determine which tab should be active and set it as such
			var vars = sa.router.paramsToVars(params);
			if (!vars.tab) {
				vars.tab = config.siteType !== 'drop' ? 'checkup' : 'downloading';
			}
			page.setTab(vars.tab);
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) {
			vars.tab = config.siteType !== 'drop' ? 'checkup' : 'downloading';
		}
		this.setTab(vars.tab);
	};
	
	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			currentPage = null;
			switch (pageId) {
				case 'catalogs':
					currentPage = new AdminMetadataCatalogs();
					break;
				case 'checkup':
					currentPage = new AdminMetadataCheckup();
					break;
				case 'downloading':
					currentPage = new AdminMetadataDownloading();
					break;
				case 'export':
					currentPage = new AdminExport();
					break;
				case 'fields':
					currentPage = new AdminFields();
					break;
				case 'nesting':
					currentPage = new AdminMetadataNesting();
					break;
				case 'rules':
					currentPage = new AdminRules();
					break;
				case 'people':
					currentPage = new BusinessManagerPeople();
					break;
				case 'import':
				default:
					currentPage = new AdminImport();
					break;
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminMetadata.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you manage your catalogs
 */
function AdminMetadataCatalogs() {
	
	var page = this;
	var templates;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.metadata.catalogs');
		}
		// make sure they're secure
		container.empty().append(templates.get('page'));
		container.find('h2 a').on('click', function() { page.loadCatalogs(); });
		this.loadCatalogs();
	};
	
	/**
	 * Loads the current catalogs from the server
	 */
	this.loadCatalogs = function() {
		$j('#catalog_management_list').show();
		$j('#label_management_list').hide();
		ajax('p=list&type=catalog&ids=1', function(response) { page.setCatalogs(response); });
	};
	
	/**
	 * Populates the list
	 */
	this.setCatalogs = function(catalogs) {
		var catalogsList = $j('#catalog_list').empty().removeClass('empty'),
			items = catalogs[0].items;
		// while we're doing this, we update the site's catalog list
		config.catalogs = [];
		if (items.length) {
			catalogsList.append(templates.get('header_row'));
			for (var i = 0, len = items.length; i < len; i++) {
				var catalog = items[i],
					queuedForDelete = catalog.queuedForDelete === '0' ? ' - queued for delete' : (catalog.queuedForDelete ? ' - currently deleting' : ''),
					tr = templates.get('catalog_row', { name : catalog.value + queuedForDelete });
				config.catalogs.push(catalog.id);
				if (catalog['sync'] === 'm') {
					tr.find('#edit').on('click', function (catalog) {
						return function () {
							page.editCatalog(catalog);
						};
					}(catalog));
				} else {
					tr.find('#edit').addClass('disabled').on('click', function() { sa.alert('This catalog is synced to your workspace and cannot be edited.'); }).attr('title', 'This catalog is synced to your workspace and cannot be edited.');
				}
				tr.find('#delete').on('click', function(catalog) { return function() { page.deleteCatalog(catalog); }; }(catalog));
				tr.find('a').on('click', function(catalog) { return function() { page.loadLabelsForCatalog(catalog); }; }(catalog));
				catalogsList.append(tr);
			}
			catalogsList.find('.item:odd').addClass('stripe');
		} else {
			catalogsList.append(templates.get('empty_catalogs'));
		}
		// make sure the singleCatalog setting is right
		if (config.catalogs.length == 1) {
			config.singleCatalog = config.catalogs[0];
		} else {
			config.singleCatalog = 0;
		}
		// set up the "create new" box. we don't do this in show() because we want the list to match against
		$j('#create_catalog').off('click').on('click', function() {
			sa.prompt({
				text : 'Enter a name for your new ' + gde('catalog'),
				yesFunction : function(catalogName) {
					page.createCatalog(items, catalogName);
				},
				yesText : 'Create',
				noText : 'Cancel',
				placeholder : gde('catalog', { c : 'upper', p : false }) + ' name'
			});
		});
	};
	
	/**
	 * Creates a new field
	 * @param {Array} items the current item list so we can check for dupes
	 * @param {string} catalogName
	 */
	this.createCatalog = function(items, catalogName) {
		var information = $j('#new_catalog .content'),
			error = '';
		// make sure catalogName is set and that it's not in the list
		if (catalogName == '') {
			error = 'Please enter a name';
		} else {
			for (var i = 0, len = items.length; i < len; i++) {
				if (items[i].value == catalogName) {
					error = 'You already have a ' + config.getDictionaryEntry('catalog', false, true) + ' with this name';
				}
			}
		}
		// show the error if there is one
		if (error) {
			information.addClass('error').html(error).removeClass('hidden');
		} else {
			information.removeClass('error').html('Creating...').removeClass('hidden');
			// let them choose a label
			sa.prompt({
				text : 'Each ' + gde('catalog', { c : 'lower', p : false }) + ' must have at least one ' + gde('label', { c : 'lower', p : false }) + '. Please name it now',
				placeholder : gde('label', { c : 'upper', p : false }) + ' name',
				value : catalogName,
				yesFunction : function(labelName, interactionOptions) {
					if (!labelName) {
						interactionOptions.showError('Please enter a name');
						return true;
					}
					ajax({ name : catalogName, labelName : labelName }, function(response) {
						if (response[0].result == 'success') {
							information.removeClass('error').addClass('success').html('Created! You can edit its information using the icon next to its name.');
							page.loadCatalogs();
						} else {
							information.removeClass('success').addClass('error').html(response[0].result);
						}
					}, 'POST', 'p=catalog_details&action=new');
				},
				yesText : 'Create',
				noFunction : function() {
					information.html('Creation cancelled.');
				},
				closeFunction : function() {
					information.html('Creation cancelled.');
				}
			});
		}
	};
	
	/**
	 * Deletes a catalog after showing a popup to make sure the user is sure
	 * @param {object} catalog the catalog to delete. has id, value
	 */
	this.deleteCatalog = function(catalog) {
		sa.confirm({
			text : 'Are you sure you want to delete the "' + catalog.value + '" ' + gde('catalog', { p : false, c : 'lower' }) + '?<br/><br/>This will permanently delete all its tracks, '
				+ gde('label', { p : true, c : 'lower' }) + ', ' + gde('album', { p : true, c : 'lower' }) + ', and ' + gde('artist', { p : true, c : 'lower' })
				+ ' and is <b>NOT</b> undoable.',
			yesFunction : function() {
				ajax('id=' + catalog.id, function(response) {
					sa.notify({ text : config.getDictionaryEntry('catalog') + ' queued for deletion! Depending on the size of the ' + config.getDictionaryEntry('catalog', false, true)
						+ ' and the current backlog, it may take from five minutes to several hours for it and all its tracks to disappear.' });
					page.loadCatalogs();
				}, 'POST', 'p=catalog_details&action=delete');
			},
			yesText : 'Delete'
		});
	};
	
	/**
	 * Lets the user edit a catalog
	 * @param {object} catalog the catalog to edit. has id and name
	 */
	this.editCatalog = function(catalog) {
		// there's actually a function to handle editing catalogs but it needs more information about them than we have right now. need to load it
		ajax('p=catalog_info&id=' + catalog.id, function(response) {
			sa.components.itemEditInterface.show({ type : 'catalog', item : response[1] });
		});
	};
	
	var currentCatalog = null;
	
	/**
	 * Loads the current catalogs from the server
	 */
	this.loadLabelsForCatalog = function(catalog) {
		if (!catalog) {
			catalog = currentCatalog;
		} else {
			currentCatalog = catalog;
		}
		$j('#catalog_management_list').hide();
		$j('#label_management_list').show();
		$j('#label_management_list h2 span').html(catalog.value);
		ajax('p=list&type=label&ids=1&catalogId=' + catalog.id, function(response) { page.setLabels(response, catalog); });
	};
	
	/**
	 * Populates the list
	 */
	this.setLabels = function(labels, catalog) {
		var labelsList = $j('#label_list').empty().removeClass('empty'),
			items = labels[0].items;
		// while we're doing this, we update the site's catalog list
		if (items.length) {
			labelsList.append(templates.get('header_row'));
			for (var i = 0, len = items.length; i < len; i++) {
				var label = items[i],
					queuedForDelete = label.queuedForDelete === '0' ? ' - queued for delete' : (label.queuedForDelete ? ' - currently deleting' : ''),
					tr = templates.get('label_row', { name : label.value + queuedForDelete });
				if (catalog['sync'] === 'm') {
					tr.find('#edit').on('click', function (label) {
						return function () {
							page.editLabel(label);
						};
					}(label));
				} else {
					tr.find('#edit').addClass('disabled').on('click', function() { sa.alert('This label\'s catalog is synced to your workspace so it cannot be edited.'); }).attr('title', 'This label\'s catalog is synced to your workspace so it cannot be edited.');
				}
				tr.find('#delete').on('click', function(label) { return function() { page.deleteLabel(label); }; }(label));
				labelsList.append(tr);
			}
			labelsList.find('.item:odd').addClass('stripe');
		} else {
			labelsList.append(templates.get('empty_labels'));
		}
		// set up the "create new" box. we don't do this in show() because we want the list to match against
		if (catalog['sync'] === 'm') {
			$j('#new_label').show();
			$j('#create_label').off('click').on('click', function () {
				sa.prompt({
					text : 'Enter a name for your new ' + gde('label'),
					yesFunction : function (labelName) {
						page.createLabel(items, labelName);
					},
					yesText : 'Create',
					noText : 'Cancel',
					placeholder : gde('label', { c : 'upper', p : false }) + ' name'
				});
			});
		} else {
			$j('#new_label').hide();
		}
		sa.scrollToElement($j('#label_management_list'));
	};
	
	/**
	 * Creates a new field
	 * @param {Array} items the current item list so we can check for dupes
	 * @param {string} labelName
	 */
	this.createLabel = function(items, labelName) {
		var information = $j('#new_label .content'),
			error = '';
		// make sure catalogName is set and that it's not in the list
		if (labelName == '') {
			error = 'Please enter a name';
		} else {
			for (var i = 0, len = items.length; i < len; i++) {
				if (items[i].value == labelName) {
					error = 'You already have a ' + config.getDictionaryEntry('label', false, true) + ' with this name';
				}
			}
		}
		// show the error if there is one
		if (error) {
			information.addClass('error').html(error).removeClass('hidden');
		} else {
			information.removeClass('error').html('Creating...').removeClass('hidden');
			ajax({ name : labelName, catalogId : currentCatalog.id }, function(response) {
				if (response[0].result == 'Changes saved!') {
					information.removeClass('error').addClass('success').html('Created! You can edit its information using the icon next to its name.');
					page.loadLabelsForCatalog();
				} else {
					information.removeClass('success').addClass('error').html(response[0].result);
				}
			}, 'POST', 'p=label_details&action=new');
		}
	};
	
	/**
	 * Deletes a catalog after showing a popup to make sure the user is sure
	 * @param {object} label the label to delete. has id, value
	 */
	this.deleteLabel = function(label) {
		sa.confirm({
			text : 'Are you sure you want to delete the "' + label.value + '" ' + gde('label', { p : false, c : 'lower' }) + '?<br/><br/>This will permanently delete all its tracks, '
				+ gde('album', { p : false, c : 'lower' }) + ', and ' + gde('artist', { p : false, c : 'lower' })
				+ ' and is <b>NOT</b> undoable.',
			yesFunction : function() {
				ajax('id=' + label.id, function(response) {
					sa.notify({ text : config.getDictionaryEntry('label') + ' queued for deletion! Depending on the size of the ' + config.getDictionaryEntry('label', false, true)
						+ ' and the current backlog, it may take from five minutes to several hours for it and all its tracks to disappear.' });
					page.loadLabelsForCatalog();
				}, 'POST', 'p=label_details&action=delete');
			},
			yesText : 'Delete'
		});
	};
	
	/**
	 * Lets the user edit a label
	 * @param {object} label the label to edit. has id and name
	 */
	this.editLabel = function(label) {
		// there's actually a function to handle editing label but it needs more information about them than we have right now. need to load it
		ajax('p=label_info&id=' + label.id, function(response) {
			sa.components.itemEditInterface.show({ type : 'label', item : response[1] });
		});
	};
	
	/**
	 * Handles the response from the server after the user tries to edit or delete a field
	 */
	this.handleGenericResponse = function(response, type) {
		if (response[0].result == 'success') {
			sa.notify({ text : 'Changes saved', type : sa.notify.notificationTypes.success });
			this.loadFields(type);
		} else {
			sa.notify({ text : response[0].result });
		}
	};
}
/**
 * The page in the admin panel that lets you manage your catalogs
 */
function AdminMetadataCheckup() {

	var page = this;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	page.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.metadata.checkup');
		}
		let template = templates.get('page', { days : Math.max(0, Math.ceil((new Date('2023-05-01 00:00:00').getTime() - new Date().getTime()) / 86400000)) });
		container.empty().append(template);

		performCheckup(template);
	};

	/**
	 * Talks to the server to run the checkup and show the results
	 * @param container
	 */
	async function performCheckup(container) {
		let loader = showLoader(container, 'Checking your metadata for potential issues...');
		/**
		 * @var {{ tracksWithComposers : int, tracksWithPublishing : int }} checkupResults
		 */
		const checkupResults = await sa.api.request({
			handler : 'checkup',
			action : 'performCheckup'
		});

		loader.remove();

		// old composer values
		if (checkupResults.tracksWithComposers) {
			showInterestedPartyConversionResults(container, 'composers', checkupResults.tracksWithComposers);
		}

		// old publishing values
		if (checkupResults.tracksWithPublishing) {
			showInterestedPartyConversionResults(container, 'publishing', checkupResults.tracksWithPublishing);
		}

		// if we didn't find anything, show the user that everything is ok
		if (!container.find('.checkup_result.showing').length) {
			container.find('.checkup_result.no_problems').addClass('showing');
		}
	}

	function showInterestedPartyConversionResults(container, type, tracksWithField) {
		let cont = container.find('.checkup_result.old_' + type);
		//cont.find('.problem_description_container h3').html(getProblemWord() + ':');
		cont.find('.count').html(tracksWithField.numberFormat());

		cont.find('.convert').on('click', function() {
			performConversion(container, cont, type, true);
		});
		cont.find('.import').on('click', function() {
			let clickButton = function() {
				$j('#import_tracks').trigger('click');
				AdminImport.off('show', clickButton);
			};
			AdminImport.on('show', clickButton);
			sa.router.routeTo('/admin?p=metadata&tab=import');
		});
		cont.find('.clear').on('click', function() {
			clearData(container, cont, type);
		});
		cont.addClass('showing');
	}
	
	function clearData(pageContainer, sectionContainer, type) {
		sa.confirm({
			text : 'Are you sure you want to remove all ' + type + ' data? This cannot be undone.',
			yesText : 'Remove permanently',
			noText : 'Cancel',
			yesFunction : function() {
				let loader = showLoader(pageContainer, 'Removing all ' + type + ' data from your tracks.<br/>This could take anywhere from 30s to 30m depending on your track count.');
				sa.scrollToElement(loader);
				sa.api.request({
					handler : 'interestedPartyConversion',
					action : 'removeSite' + ucfirst(type)
				}).catch(function (e) {
					loader.remove();
					sa.alert({ text : e.message });
					sa.scrollToElement(sectionContainer);
				}).then(function (result) {
					loader.remove();
					sa.scrollToElement(sectionContainer);
					
					sa.notify({
						text : ucfirst(type) + ' data removed from ' + result.success.numberFormat() + ' tracks!',
						type : sa.notify.notificationTypes.success
					});
					page.show('', pageContainer.parent());
				});
			}
		})
	}

	function performConversion(pageContainer, sectionContainer, type, test) {
		let loader = showLoader(pageContainer, 'Performing conversion' + (test ? ' test' : '') + '.<br/>This could take anywhere from 30s to 30m depending on your track count and data.');
		sa.scrollToElement(loader);
		sa.api.request({
			handler : 'interestedPartyConversion',
			action : 'convertSite' + ucfirst(type),
			postData : {
				test : test ? 1 : 0
			}
		}).catch(function (e) {
			loader.remove();
			sa.alert({ text : e.message });
			sa.scrollToElement(sectionContainer);
		}).then(function (result) {
			/** @var {{ converted : { count : int, csv : string }, failed : { count : int, csv : string }, alreadyConverted : { count : int, csv : string } }} result */
			loader.remove();
			sa.scrollToElement(sectionContainer);

			if (test) {
				let resultContainer = sectionContainer.find('.result');
				function downloadCsv(hash) {
					let conversionForm = resultContainer.find('.get_conversion_results');
					conversionForm.find('input[name=csvHash]').val(hash);
					conversionForm.attr('action', 'sa/interestedPartyConversion/getConversionResults?' + ajax.getBaseParameters());
					conversionForm.trigger('submit');
				}
				if (result.converted.count) {
					resultContainer.find('.successful_count').html(result.converted.count.numberFormat());
					resultContainer.find('.successful_conversions').show().find('.download').off().on('click', function() { downloadCsv(result.converted.csv); });
				}
				if (result.failed.count) {
					resultContainer.find('.failed_count').html(result.failed.count.numberFormat());
					resultContainer.find('.failed_conversions').show().find('.download').off().on('click', function() { downloadCsv(result.failed.csv); });
				}
				if (result.alreadyConverted.count) {
					resultContainer.find('.already_count').html(result.alreadyConverted.count.numberFormat());
					resultContainer.find('.already_converted').show().find('.download').off().on('click', function() { downloadCsv(result.alreadyConverted.csv); });
				}
				resultContainer.find('.apply').on('click', function () {
					// verify? download option?
					sa.confirm({
						text : templates.get('conversion_verification_' + type).html(),
						noText : 'Cancel',
						yesText : 'Proceed',
						yesFunction : function () {
							performConversion(pageContainer, sectionContainer, type, false);
						}
					});
				});
				resultContainer.show();
				sectionContainer.find('.explanation').hide();
			} else {
				sa.notify({
					text : ucfirst(type) + ' converted successfully!',
					type : sa.notify.notificationTypes.success
				});
				page.show('', pageContainer.parent());
			}
		});
	}



}
/**
 * The page in the admin panel that lets you change your embedding
 */
function AdminMetadataDownloading() {

	var templates;
	var page = this;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		// templates
		if (!templates) {
			templates = sa.templates.get('admin.metadata.downloading');
		}

		// show everything
		var cap = new sa.collapsingAdminPage();
		cap.addSection({
			name : 'Metadata Injection',
			contents : getMetadataInjectionTemplate()
		});

		if (config.siteType !== 'drop') {
			cap.addSection({
				name: 'Metadata Embedding Profiles',
				contents: getMetadataEmbeddingProfilesTemplate()
			});
		}
		cap.addToContainer(container);

	};

	function getMetadataInjectionTemplate() {
		var metadataInjectionTemplate = templates.get('metadata_injection');
		sa.api.request({
			handler : 'settings',
			action : 'get-access'
		}).then(function(accessSettings) {

			var catalogs = accessSettings['catalogs'];
			if (config.siteType == 'buyer' || !catalogs.length) {
				metadataInjectionTemplate.find('.labels').html(templates.get('metadata_injection_no_catalogs'));
				return;
			}
			var catalogList = '';
			if (config.siteType !== 'drop') {
				for (var i = 0, len = catalogs.length; i < len; i++) {
					let injected = catalogs[i].injected != 0 ? 'checked="checked"' : '';
					catalogList += `<label><input type="checkbox" name="catalogInjection[${catalogs[i].id}]" value="1" ${injected} /> <span>${catalogs[i].name}</span></label>`;
				}
			} else {
				let injected = catalogs[0].injected != 0 ? 'checked="checked"' : '';
				catalogList += `
					<div class="input_container">
						<div class="instructions">
							Do you want your users to download files that are embedded with your current workspace metadata?
							<input type="checkbox" id="catalogInjection[${catalogs[0].id}]" value="1" name="catalogInjection[${catalogs[0].id}]" ${injected}/>
						</div>
					</div>
				`;
			}

			if (config.siteType !== 'drop'){
				metadataInjectionTemplate.find('.labels').html(catalogList);
			}else{
				metadataInjectionTemplate.find('span').empty();
				metadataInjectionTemplate.find('.section').html(catalogList);
			}
			metadataInjectionTemplate.find('.labels').html(catalogList);
			metadataInjectionTemplate.find('.button').on('click', function () {
				sa.api.request({
					handler : 'settings',
					action : 'save-injection',
					postData : sa.forms.validate(metadataInjectionTemplate).values
				}).catch(function (errorMessage) {
					sa.notify({ text: errorMessage });
				}).then(function() {
					sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
				});
			});
		});
		return metadataInjectionTemplate;
	}

	function getMetadataEmbeddingProfilesTemplate() {
		var metadataEmbeddingProfilesTemplate = templates.get('embedding_profiles');

		page.reloadMetadataEmbeddingProfiles = function() {
			ajax('p=metadata_downloading_profiles&action=listProfiles', function (profiles) {

				var profileList = metadataEmbeddingProfilesTemplate.find('.items').empty();
				var defaultProfile;

				// add the default template
				for (var p = 0, pLen = profiles.length; p < pLen; p++) {
					var profile = profiles[p];
					profileList.append(getProfileItemTemplate(profile));
					if (profile.id == 0) defaultProfile = profile;
				}

				metadataEmbeddingProfilesTemplate.find('#new_embedding_profile .button').off().on('click', function () {
					sa.prompt({
						text : 'Enter a name for your new profile',
						yesText : 'Create',
						noText : 'Cancel',
						placeholder : 'New profile name',
						yesFunction : function(newName) {
							if (newName) {
								defaultProfile.name = newName;
							} else {
								defaultProfile.name = 'New Profile';
							}
							showMetadataEmbeddingProfileEditor(defaultProfile);
						}
					});
				});

			});
		};

		page.reloadMetadataEmbeddingProfiles();

		return metadataEmbeddingProfilesTemplate;
	}

	/**
	 * @param {EmbeddingProfile} profile
	 * @returns {JQuery}
	 */
	function getProfileItemTemplate(profile) {
		var profileTemplate = templates.get('embedding_profile');

		profileTemplate.find('.name').html(profile.name);

		if (!profile.editable) {
			profileTemplate.find('.edit_profile_button, .delete_profile_button').remove();
			profileTemplate.find('.copy_profile_button').addClass('single');
		} else {
			profileTemplate.find('.edit_profile_button, .name').on('click', function() {
				showMetadataEmbeddingProfileEditor(profile);
			});
			profileTemplate.find('.delete_profile_button').on('click', function() {
				deleteMetadataEmbeddingProfile(profile);
			});
		}

		profileTemplate.find('.copy_profile_button').on('click', function() {
			/** @var {EmbeddingProfile} */
			var profileCopy = {};
			$j.extend(profileCopy, profile);
			profileCopy.name += ' copy';
			profileCopy.id = 0;
			showMetadataEmbeddingProfileEditor(profileCopy);
		});

		return profileTemplate;
	}

	/**
	 * @param {EmbeddingProfile} profile
	 */
	function showMetadataEmbeddingProfileEditor(profile) {
		var metadataEmbeddingProfileEditorTemplate = templates.get('embedding_profile_editor');

		metadataEmbeddingProfileEditorTemplate.find('input[name=name]').val(profile.name.entityDecode());

		if (profile.id) {
			metadataEmbeddingProfileEditorTemplate.find('.create').remove();
		} else {
			metadataEmbeddingProfileEditorTemplate.find('.edit').remove();
		}

		if (profile.embedArt) {
			metadataEmbeddingProfileEditorTemplate.find('input[name=embedArt]').prop('checked', true);
		}

		ajax('p=metadata_downloading_profiles&action=listFields', /** @param {EmbeddingFieldData} fieldData */ function(fieldData) {
			var sourceAudioOptions = '';
			for (var saFieldValue in fieldData.sourceAudioFields) {
				if (!fieldData.sourceAudioFields.hasOwnProperty(saFieldValue)) continue;
				var saFieldDisplay = fieldData.sourceAudioFields[saFieldValue];
				sourceAudioOptions += '<option value="' + saFieldValue + '">' + saFieldDisplay + '</option>';
			}

			var fieldList = metadataEmbeddingProfileEditorTemplate.find('#field_list');
			var fieldTemplate = templates.get('embedding_profile_editor_field');

			for (var id3FieldValue in fieldData.id3Fields) {
				if (!fieldData.id3Fields.hasOwnProperty(id3FieldValue)) continue;
				var id3Field = fieldData.id3Fields[id3FieldValue];
				var field = fieldTemplate.clone();
				var dropDown = field.find('.sourceaudio_field');

				field.find('.id3_field_name').html(id3Field);

				dropDown.attr('name', 'fields[' + id3FieldValue + ']');
				dropDown.append(sourceAudioOptions);

				if (profile.mappings[id3FieldValue]) {
					dropDown.val(profile.mappings[id3FieldValue]);
				}

				fieldList.append(field);
			}

			$j('html, body').animate({ scrollTop : metadataEmbeddingProfileEditorTemplate.position().top });

		});

		metadataEmbeddingProfileEditorTemplate.find('.button').on('click', function() {
			var fieldData = sa.forms.validate(metadataEmbeddingProfileEditorTemplate).values;
			if (fieldData.name.trim() == '') {
				sa.notify({ text : 'Please enter a name for the profile' });
			} else {
				fieldData.id = profile.id;
				ajax(fieldData, function(response) {
					if (response.success) {
						sa.notify({ text : 'Profile saved!', type : sa.notify.notificationTypes.success });
						page.reloadMetadataEmbeddingProfiles();
						$j('.metadata_profile_editor_container').empty();
						$j('html, body').animate({ scrollTop : 0 });
					} else {
						sa.notify({ text : response.error });
					}
				}, 'POST', 'p=metadata_downloading_profiles&action=save');
			}
		});

		$j('.metadata_profile_editor_container').empty().append(metadataEmbeddingProfileEditorTemplate);

		setTimeout(function() {
			sa.scrollToElement(metadataEmbeddingProfileEditorTemplate);
		}, 500);
	}

	/**
	 * @param {EmbeddingProfile} profile
	 */
	function deleteMetadataEmbeddingProfile(profile) {
		sa.confirm({
			text : 'Are you sure you want to delete the "' + profile.name + '" profile?',
			yesFunction : function() {
				ajax({ id : profile.id }, function(response) {
					if (response.success) {
						sa.notify({ text : 'Profile deleted!', type : sa.notify.notificationTypes.success });
						page.reloadMetadataEmbeddingProfiles();
						$j('html, body').animate({ scrollTop : 0 });
					} else {
						sa.notify({ text : response.error });
					}
				}, 'POST', 'p=metadata_downloading_profiles&action=delete');
			},
			yesText : 'Yes'
		});
	}

}

/**
 * @typedef {Object} EmbeddingProfile
 * @property {string} name
 * @property {int} id
 * @property {boolean} embedArt
 * @property {boolean} editable
 * @property {object} mappings
 */

/**
 * @typedef {Object} EmbeddingFieldData
 * @property {Object} id3Fields
 * @property {Object} sourceAudioFields
 */
/**
 * The page in the admin panel that lets you export your metadata
 */
function AdminExport() {

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		const exportTrackDataButton = $j('<div id="export_tracks_container" class="section"></div>');
		const exportUserDataButton = $j('<div id="export_userdata_container"></div>');

		function applyFilterToUrl(url) {
			const catalogFilter = container.find('input[name=catalog_filter]:checked').val();
			const dateFilter = container.find('input[name=date_filter]:checked').length;
			
			let extra = '&htmlEncode=' + container.find('input[name=html_encode]:checked').length
				+ '&combineIp=' + container.find('input[name=combine_ip]:checked').length
				+ '&includeIds=' + container.find('input[name=include_ids]:checked').length
				+ '&includeAmg=' + container.find('input[name=include_amg]:checked').length;
			
			if (catalogFilter === 'catalogs') {
				const catalogs = $j('.catalog_option select').val();
				if (catalogs && catalogs.length) {
					extra += '&catalogIds[]=' + catalogs.join('&catalogIds[]=');
				} else {
					sa.notify({ text: 'Please select some ' + gde('catalog', { case: 'lower', plural: true }) });
					return false;
				}
			} else if (catalogFilter === 'labels') {
				const labels = $j('.label_option select').val();
				if (labels && labels.length) {
					extra += '&labelIds[]=' + labels.join('&labelIds[]=');
				} else {
					sa.notify({ text: 'Please select some ' + gde('label', { case: 'lower', plural: true }) });
					return false;
				}
			}
			if (dateFilter) {
				extra += '&startDate=' + (container.find('input[name=start_date]').datepicker('getDate').getTime() / 1000)
					+ '&endDate=' + (container.find('input[name=end_date]').datepicker('getDate').getTime() / 1000);
			}
			
			return url + extra;
		}

		exportTrackDataButton.append(
			createButton(
				'Export Track Data to CSV', 
				'export_tracks', 
				'',
				'#0', 
				() => {
					const nonce = attachOnExportDownloadEventHandler(() => {
						$j('#loader_element').remove();
						$j('#export_tracks').show();
					});

					showLoader($j('#export_tracks_container'), 'Preparing your CSV...');
					$j('#export_tracks').hide();
					
					window.location.href = applyFilterToUrl('export.php?type=tracks&format=csv&nonce=' + nonce);
					return false;
				}
			)
		);

		if (config.id == 2068) {
			exportTrackDataButton.append(
				createButton(
					'Export Track Data to XML', 
					'export_tracks_xml', 
					'',
					'#0',
					() => {
						const nonce = attachOnExportDownloadEventHandler(() => {
							$j('#loader_element').remove();
							$j('#export_tracks_xml').show();
						});

						showLoader($j('#export_tracks_container'), 'Preparing your XML...');
						$j('#export_tracks_xml').hide();
						
						window.location.href = applyFilterToUrl('export.php?type=tracks&format=xml&nonce=' + nonce);
						return false;
					}
				)
			);

		}

		exportUserDataButton.append(createButton(
			'Export User Data to CSV', 
			'export_userdata', 
			'',
			'#0',
			() => {
				if (config.grayLabel) {
					sa.alert({ text: 'To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>' });
				} else {
					const nonce = attachOnExportDownloadEventHandler(() => {
						$j('#loader_element').remove();
						$j('#export_userdata').show();
					});
					
					showLoader($j('#export_userdata_container'), 'Preparing your CSV...');
					$j('#export_userdata').hide();
					
					window.location.href = applyFilterToUrl('export.php?type=users&format=csv&nonce=' + nonce);
				}
				return false;
			}
		));

		// track data
		container.html(
			'<div class="section export_tracks">'
			+ '<h2>Export Track Data</h2>'
			+ '<div class="information high_information">What do you want to export?</div>'
			+ '<div class="options">'
			+ '<div class="option"><input type="radio" name="catalog_filter" value="all" checked="checked"/><span>All ' + gde('catalog', { case: 'upper', plural: true }) + '</span>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="option catalog_option">'
			+ '<input type="radio" name="catalog_filter" value="catalogs"/><span>Only these ' + gde('catalog', { case: 'upper', plural: true }) + ':</span><select multiple="multiple"></select>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="option label_option">'
			+ '<input type="radio" name="catalog_filter" value="labels"/><span>Only these ' + gde('label', { case: 'upper', plural: true }) + ':</span><select multiple="multiple"></select>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="option">'
			+ '<label><input type="checkbox" name="date_filter" value="1"/><span>Only tracks published between</span></label>'
			+ '<input type="text" name="start_date"/><span>and</span><input type="text" name="end_date"/>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="option">'
			+ '<label><input type="checkbox" name="html_encode" value="1"/><span>Encode data for html (newlines as &lt;br/&gt;, etc.)</span></label>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="option">'
			+ '<label><input type="checkbox" name="combine_ip" value="1"/><span>Include field with combined ' + gde('writer', { case: 'lower', plural: false }) + '/' + gde('publisher', { case: 'lower', plural: false }) + ' data</span></label>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="option">'
			+ '<label><input type="checkbox" name="include_ids" value="1"/><span>Include internal ID\'s - (for reference only, ID\'s are subject to change)</span></label>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="option" ' + (!config.showAIMetadata ? 'style="display: none;"' : '') + '>'
			+ '<label><input type="checkbox"  name="include_amg" value="1" ' + (config.showAIMetadata ? 'checked="checked"' : '') + '/><span>Include AI metadata</span></label>'
			+ '<div class="clr"></div>'
			+ '</div>'
			+ '</div>'
			+ '<div class="clr"></div>'
			+ '</div>'
		)
			.append(exportTrackDataButton)
			.append('<div class="clr"></div>');
		
		container.find('input[name=start_date]').datepicker({
			changeMonth: true,
			changeYear: true,
			dateFormat: config.datePickerDateFormatString,
			yearRange: '2008:+0'
		}).datepicker('setDate', new Date('2008-01-02'));
		
		container.find('input[name=end_date]').datepicker({
			changeMonth: true,
			changeYear: true,
			dateFormat: config.datePickerDateFormatString,
			yearRange: '2008:+0'
		}).datepicker('setDate', new Date());
		
		container.find('.catalog_option select').on('click', () => {
			$j('.catalog_option input[type=radio]').trigger('click');
		});
		
		container.find('.label_option select').on('click', () => {
			$j('.label_option input[type=radio]').trigger('click');
		});
		
		container.find('input[name=start_date], input[name=end_date]').on('click', () => {
			$j('input[name=date_filter]').prop('checked', true);
		});
		
		// load the catalogs and labels so we can filter by them
		sa.api.request({
			handler: 'permission-profiles',
			action: 'getCatalogHierarchy',
		}).then(response => {
			const catalogs = [];
			const labels = [];
			let catalogString = '';
			let labelString = '';
			
			for (const catalogId in response) {
				if (!response.hasOwnProperty(catalogId)) continue;
				
				const catalog = response[catalogId];
				
				catalogs.push({ id: catalogId, name: catalog.name });
			
				for (const labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					labels.push({ id: labelId, name: catalog.labels[labelId].name });
				}
			}
			
			catalogs.sort((a, b) => { if (a.name < b.name) return -1; return 1; });
			for (let c = 0, cLen = catalogs.length; c < cLen; c++) {
				catalogString += '<option value="' + catalogs[c].id + '">' + catalogs[c].name + '</option>';
			}
			
			container.find('.catalog_option select').html(catalogString);
			labels.sort((a, b) => { if (a.name < b.name) return -1; return 1; });
			
			for (let i = 0, len = labels.length; i < len; i++) {
				labelString += '<option value="' + labels[i].id + '">' + labels[i].name + '</option>';
			}
			
			container.find('.label_option select').html(labelString);
		}).catch(err => {
			sa.alert(err.message);
		});
		// user data
		container.append('<div class="section"><h2>Export User Data</h2><div class="information">Click to export all of your user data to an excel sheet.</div><div class="clr"></div></div>')
			.find('.information:last')
			.before(exportUserDataButton);
	};
}
/**
 * The page in the admin panel that lets you manage relational fields
 */
function AdminFields() {

	var page = this;
	var templates;

	var fieldDataCache = {}; // used for presenting alternate options during delete

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.metadata.fields');
		}

		var cap = new sa.collapsingAdminPage();
		cap.addSection({
			name : gde('genre', { c : 'upper', p : true }),
			contents : getTypeTemplate('genre')
		});
		cap.addSection({
			name : gde('tempo', { c : 'upper', p : true }),
			contents : getTypeTemplate('tempo')
		});
		cap.addSection({
			name : gde('cue type', { c : 'upper', p : true }),
			contents : getTypeTemplate('cue_type')
		});
		cap.addSection({
			name : 'Custom Fields',
			contents : getCustomTemplate()
		});
		cap.addSection({
			name : 'Field Visibility',
			contents : getVisibilityTemplate()
		});
		cap.addSection({
			name : 'Synced ' + gde('catalog', { c : 'upper', p : false }) + ' Pages',
			contents : getSyncedCatalogDataTemplate()
		});
		cap.addSection({
			name : 'Mappings',
			contents : page.getMappingTemplate(templates)
		});
		cap.addToContainer(container);
	};

	function getSyncedCatalogDataTemplate() {
		var template = templates.get('synced_catalog_page');

		if (config.showExternalCatalogData) {
			template.find('#show-external-catalog-data input').prop('checked', true);
		}

		template.find('#show-external-catalog-data .button').on('click', function() {
			config.showExternalCatalogData = template.find('#show-external-catalog-data input:checked').length;
			sa.api.request({
				handler : 'settings',
				action : 'save-external-catalog-data-flag',
				postData : {
					showExternalCatalogData : config.showExternalCatalogData
				}
			}).then(function() {
				sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
			});
		});

		return template;
	}

	/**
	 * @param {string} type
	 * @returns {JQuery}
	 */
	function getTypeTemplate(type) {
		var template = templates.get(type + '_page');

		loadFieldData(type, template);

		return template;
	}

	function loadFieldData(type, template) {
		if (!template) {
			template = $j('#' + type + '_page');
		}

		ajax({ p : 'list', type : type, ids : 1 }, function(fields) {

			var fieldsList = template.find('#' + type + '_list');
			var items = fields[0].items;

			fieldDataCache[type] = items;

			fieldsList.find('.item').remove();

			items.each(function(i, field) {

				var tr = templates.get('type_row', { name : field.value, type : type });

				tr.find('#edit').on('click', function() { editField(field, type); });
				tr.find('#delete').on('click', function() { deleteField(field, type); });

				fieldsList.append(tr);

			});

			fieldsList.find('.item:odd').addClass('stripe');

			// delete unused button
			template.find('.delete_unused_button').off('click').on('click', function() {
				let displayType = gde(type.replace('_', ' '), { p : true, l : false });
				ajax({ p : 'relational_fields', action : 'unused', type : type }, function(unused) {
					if (!unused.length) {
						sa.alert({ text : 'No unused ' + displayType });
					} else {
						let unusedListTemplate = templates.get('unused_list', { type : displayType });
						let unusedList = unusedListTemplate.find('.list');

						unused.each(function(i, item) {
							unusedList.append('<li>' + item.name + '</li>');
						});

						unusedListTemplate.find('#delete_button').on('click', function() {

							fb.showLoader('Deleting. Please be patient.');

							ajax({ 'delete' : 1 }, function(response) {

								sa.notify({
									text : 'Deleted ' + response['deleted'].numberFormat() + ' ' + displayType,
									type : sa.notify.notificationTypes.success
								});
								sa.router.reloadPage();
								fb.hide();

							}, 'POST', { p : 'relational_fields', action : 'unused', type : type });

						});

						unusedListTemplate.find('#cancel_button').on('click', function() {
							fb.hide();
							return false;
						});

						let fb = new FocusBox(unusedListTemplate, { title : 'Unused ' + displayType + ' (' + unused.length.numberFormat() + ')' });
						fb.show();
					}
				});
			});

			// set up the "create new {type}" box
			template.find('.new_button').off('click').on('click', function() {
				var displayType = type.replace('_', ' ');
				sa.prompt({
					text : 'What do you want to name your new ' + gde(displayType, { c : 'lower', p : false}) + '?',
					placeholder : gde(displayType, { c : 'upper', p : false }) + ' name',
					yesText : 'Create',
					noText : 'Cancel',
					yesFunction : function(name, interactionOptions) {
						// make sure value is set and that it's not in the list
						if (name == '') {
							interactionOptions.showError('Please enter a name');
							return true;
						} else {
							for (var i = 0, len = items.length; i < len; i++) {
								if (items[i].value == name) {
									interactionOptions.showError('You already have a ' + gde(displayType, { c : 'lower', p : false }) + ' with that name');
									return true;
								}
							}
						}

						var information = template.find('.content').removeClass('success').removeClass('error');
						information.show().html('Creating...');
						ajax({ name : name }, function(response) {
							if (response[0].result == 'success') {
								information.addClass('success').html('Created!');
								loadFieldData(type, template);
							} else {
								sa.alert(response[0].result);
								information.addClass('error').html(response[0].result);
							}
						}, 'POST', 'p=relational_fields&action=new&type=' + type);
					}
				})
			});
		});
	}

	/**
	 * Deletes a custom field after showing a popup to make sure the user is sure
	 * @param {object} field the field to edit. has id, value
	 * @param {string} type the type we're saving (genre|tempo|cue_type)
	 * @param {int=} newFieldId what field should tracks that only have the deleted field get? (if not sent, will show a notice, letting the user choose)
	 * 		If it's the same as the field id, no tracks will be moved (not a valid option if there are tracks that should be)
	 */
	function deleteField(field, type, newFieldId) {
		if (!newFieldId) {
			var items = fieldDataCache[type];
			if (items.length == 1) {
				return sa.notify({ text : 'You may not delete the last ' + config.getDictionaryEntry(type.replace('_', ' '), false, true) });
			}
			ajax('p=relational_fields&action=countDistinctTracks&type=' + type + '&id=' + field.id, function(response) {
				var distinct = response[0].distinct,
					total = response[0].total,
					dict = config.getDictionaryEntry(type.replace('_', ' '), false, true);
				if (distinct) {
					$j('.focused_container').remove();
					sa.confirm({
						text : 'Are you sure you want to delete the "' + field.value + '" ' + dict + '?<br/><br/>' + total.numberFormat() + ' tracks will be affected '
							+ 'and for ' + distinct.numberFormat() + ' of those tracks, this is their only ' + dict + '. For those tracks, what new ' + dict + ' would you like them to have?<br/>'
							+ '<select id="replacement_field"></select>',
						yesFunction : function() {
							deleteField(field, type, $j('#replacement_field').val());
						},
						yesText : 'Delete'
					});
					var rep = $j('#replacement_field');
					for (var i = 0, len = items.length; i < len; i++) {
						var item = items[i];
						if (item.id == field.id) continue;
						rep.append('<option value="' + item.id + '">' + item.value + '</option>');
					}
				} else if (total) {
					$j('.focused_container').remove();
					sa.confirm({
						text : 'Are you sure you want to delete the "' + field.value + '" ' + config.getDictionaryEntry(type.replace('_', ' ')) + '?<br/><br/>' + total.numberFormat() + ' tracks will be affected.',
						yesFunction : function() {
							deleteField(field, type, field.id);
						},
						yesText : 'Delete'
					});
				} else {
					// if nothing's effected, just do it
					deleteField(field, type, field.id);
				}
			});
			return;
		}
		ajax({ id : field.id, type : type, replacement : newFieldId }, function(response) { handleGenericResponse(response, type, gde(type, { c : 'upper' }) + ' deleted'); }, 'POST', 'p=relational_fields&action=delete');
	}

	/**
	 * Lets the user edit a custom field
	 * @param {object} field the field to edit. has id and name
	 * @param {string} type the type we're saving (genre|tempo|cue_type)
	 * @param {string=} newName the name to change the name to. if not specified, asks the user for a name. defaults to unspecified
	 */
	function editField(field, type, newName) {
		var dict = config.getDictionaryEntry(type.replace('_', ' '), false, true);
		if (!newName) {
			$j('.focused_container').remove();
			sa.prompt({
				text : 'Enter the new name',
				placeholder : gde(type.replace('_', ' '), { c : 'upper', p : false }) + ' name',
				value : field.value,
				yesFunction : function(inputValue, interactionOptions) {
					// validate the new value
					if (!inputValue) {
						interactionOptions.showError('Please enter a name.');
					} else if (inputValue.length > 64 || inputValue.length < 2) {
						interactionOptions.showError('Name must be between 2 and 64 characters.');
					} else {
						// see if it's already in the list
						var items = fieldDataCache[type];
						for (var i = 0, len = items.length; i < len; i++) {
							if (items[i].value == inputValue && items[i].id != field.id) {
								interactionOptions.showError('You already have a ' + dict + ' with that name. Please choose another.');
								return true;
							}
						}
						editField(field, type, inputValue);
						return false;
					}
					return true;
				},
				yesText : 'Save'
			});
		} else {
			// submit!
			ajax('id=' + field.id + '&name=' + encodeURIComponent(newName) + '&type=' + type,
				function (response) {
					handleGenericResponse(response, type);
				}, 'POST', 'p=relational_fields&action=edit');
		}
	}

	/**
	 * Handles the response from the server after the user tries to edit or delete a field
	 */
	function handleGenericResponse(response, type, successMessage) {
		if (type == 'custom') {
			if (response[0].result == 'success') {
				sa.notify({ text : (successMessage ? successMessage : 'Created!') });
				loadCustoms();
			} else {
				sa.alert({ text : response[0].result });
			}
		} else {
			if (response[0].result == 'success') {
				sa.notify({ text : (successMessage ? successMessage : 'Changes saved') });
				loadFieldData(type);
			} else {
				sa.alert({ text : response[0].result });
			}
		}
	}

	function getCustomTemplate() {
		var template = templates.get('custom_field_page');

		loadCustoms(template);

		return template;
	}

	/**
	 * Loads the current custom fields from the server
	 */
	function loadCustoms(template) {
		if (!template) {
			template = $j('#custom_field_page');
		}

		ajax('p=custom_fields&action=list', function(customs) {

			var customsList = template.find('#custom_list');
			customsList.find('.item').remove();

			fieldDataCache['custom'] = customs;

			if (!customs.length) {
				customsList.append(templates.get('no_customs_row'));
			} else {
				customs.each(function(i, custom) {
					var tr = templates.get('custom_row', { name : custom.name });

					tr.find('#edit').on('click', function() { editCustom(custom); });
					tr.find('#delete').on('click', function() { deleteCustom(custom); });
					tr.find('#delimiter').on('click', function() { delimitCustom(custom); });

					if (custom.hidden) {
						tr.find('#hide_field').prop('checked', true);
					}

					tr.find('#hide_field').on('change', function() { updateHidden(custom, !!this.checked); });
					customsList.append(tr);
				});
				customsList.find('.item:odd').addClass('stripe');
			}

			template.find('.new_button').off('click').on('click', function() {
				sa.prompt({
					text : 'Enter a name for the new custom field',
					yesText : 'Create',
					placeholder : 'Custom field name',
					noText : 'Cancel',
					yesFunction : function(name, interactionOptions) {
						// make sure value is set and that it's not in the list
						if (name == '') {
							interactionOptions.showError('Please enter a name');
							return true;
						} else {
							for (var i = 0, len = customs.length; i < len; i++) {
								if (customs[i].name == name) {
									interactionOptions.showError('You already have a custom field with this name');
									return true;
								}
							}
						}

						var information = template.find('.content').removeClass('success').removeClass('error').show().html('Creating...');
						ajax({ name : name }, function(response) {
							if (response[0].result == 'success') {
								information.addClass('success').html('Created!');
								loadCustoms(template);
							} else {
								sa.alert(response[0].result);
								information.addClass('error').html(response[0].result);
							}
						}, 'POST', 'p=custom_fields&action=new');
					}
				})
			});

		});
	}

	var warned = false;
	/**
	 * Deletes a custom field after showing a popup to make sure the user is sure
	 * @param {object} custom the custom field to edit. has id, name
	 * @param {boolean=} skipWarning has the warning already been shown (default to false)
	 */
	function deleteCustom(custom, skipWarning) {
		if (warned) skipWarning = true;
		if (!warned && user.userData.id == 72 && skipWarning && custom.name.indexOf('DashGo') != -1) {
			warned = true;
		}
		if (!skipWarning) {
			sa.confirm({
				text : 'Are you sure you want to delete the "' + custom.name + '" field? All its data will be permanently removed.',
				yesFunction : function() {
					deleteCustom(custom, true);
				},
				yesText : 'Delete'
			});
			return;
		}
		ajax('id=' + custom.id, function(response) { handleGenericResponse(response, 'custom', 'Custom field deleted'); }, 'POST', 'p=custom_fields&action=delete');
	}

	/**
	 * Lets the user edit a custom field
	 * @param {object} custom the custom field to edit. has id and name
	 * @param {string=} newName the name to change the name to. if not specified, asks the user for a name. defaults to unspecified
	 */
	function editCustom(custom, newName) {
		if (!newName) {
			sa.prompt({
				text : 'Enter a new name for the field',
				placeholder : 'Custom field name',
				value : custom.name,
				yesFunction : function(inputValue, interactionOptions) {
					// validate the new value
					if (!inputValue) {
						interactionOptions.showError('Please enter a name');
					} else if (inputValue.length > 64) {
						interactionOptions.showError('Name must be shorter than 65 characters');
					} else {
						editCustom(custom, inputValue);
						return false;
					}
					return true;
				},
				yesText : 'Save'
			});
		} else {
			// submit!
			ajax('id=' + custom.id + '&name=' + encodeURIComponent(newName), function (response) {
				handleGenericResponse(response, 'custom', 'Changes saved!');
			}, 'POST', 'p=custom_fields&action=edit');
		}
	}

	/**
	 * Lets the user change a custom field's delimiter
	 * @param {object} custom the custom field to edit. has id and name
	 * @param {string=} newDelimiter the new delimiter
	 */
	function delimitCustom(custom, newDelimiter) {
		if (newDelimiter === undefined) {
			sa.prompt({
				text : 'What character separates values in your field?',
				placeholder : 'Enter a character',
				subtext : 'Note: If your tracks sync <b>to</b> other workspaces, this affects them as well. Conversely, if you sync tracks <b>from</b> other workspaces, this setting only affects tracks native to this one.',
				value : custom.delimiter,
				yesFunction : function(inputValue, interactionOptions) {
					// validate the new value
					if (!inputValue.length > 1) {
						interactionOptions.showError('You may only enter one character');
					} else if (inputValue.match(/^["\\]+$/i)) {
						interactionOptions.showError('This character cannot be used as a delimiter.');
					} else {
						delimitCustom(custom, inputValue);
						return false;
					}
					return true;
				},
				yesText : 'Save'
			});
		} else {
			// submit!
			ajax('id=' + custom.id + '&delimiter=' + encodeURIComponent(newDelimiter),
				function (response) {
					handleGenericResponse(response, 'custom', 'Changes saved! It may take <b>up to a day</b> before these changes are visible.');
				}, 'POST', 'p=custom_fields&action=delimiter');
		}
	}

	/**
	 * Updates the hidden status for a particular field
	 * @param {object} custom the custon field to set hidden for. has id
	 * @param {int|boolean} hidden should be 0 for hide or 1 for show
	 */
	function updateHidden(custom, hidden) {
		ajax('id=' + custom.id + '&hidden=' + (hidden ? 1 : 0), function(response) {
			handleGenericResponse(response, 'custom', 'Field ' + (hidden ? 'hidden' : 'unhidden'));
		}, 'POST', 'p=custom_fields&action=hidden');
	}

	/**
	 * Populates the list of visibility fields
	 */
	function getVisibilityTemplate() {
		var template = templates.get('field_visibility_page');
		var visibilityList = template.find('#visibility_list');
		const fieldListNames = ['album', 'artist', 'catalog', 'label', 'release date', 'genre', 'tempo', 'cue type', 'description', 'keywords', 'instruments', 'version', 'track number', 'style', 'mood', 'bpm', 'key',
			'has vocals', 'lyrics', 'isrc', 'iswc', 'writers', 'publishers', 'explicit', 'filename', 'sourceaudio id', 'ai genre', 'ai tempo', 'ai keywords', 'ai style', 'ai mood', 'ai bpm', 'ai key', 'ai has vocals'];

		var fieldList = [];
		// build a list of fields we can actually use
		for (let fieldName of fieldListNames) {
			let field = { value : fieldName, display : config.getDictionaryEntry(fieldName) };
			if (field.value == 'isrc') field.display = 'ISRC';
			else if (field.value == 'iswc') field.display = 'ISWC';
			else if (field.value == 'sourceaudio id') field.display = 'Track ID';
			else if (field.value == 'track number') field.display = 'Track Number (hiding will disable sorting album track lists by track number)';
			else if (field.value == 'ai bpm') field.display = 'zzzAI BPM'; // add "zzz" so it's at the bottom
			else if (field.value.indexOf('ai ') == 0) field.display = 'zzzAI ' + field.display.substring(3);
			fieldList.push(field);
		}
		fieldList.sort(function(field1, field2) { return field1.display > field2.display ? 1 : -1; });
		// remove the "zzz" from the display
		for (let field of fieldList) {
			if (field.display.indexOf('zzzAI') === 0) {
				field.display = field.display.substring(3);
			}
		}

		visibilityList.find('.item').remove();

		for (let field of fieldList) {
			var tr = templates.get('visibility_row', { name : field.display });
			if (config.hiddenFields.indexOf(field.value) != -1) {
				tr.find('input').prop('checked', true);
			}
			tr.find('input').on('change', function(field) { return function() {

				var hidden = this.checked;
				sa.api.request({
					handler : 'settings',
					action : 'saveFieldVisibility',
					postData : {
						field : field.value,
						show : hidden ? 0 : 1
					}
				}).then(function() {
					sa.notify({ text : 'Field ' + (hidden ? 'hidden for non-admins' : 'visible to non-admins') });
				});

				// add/remove it from the live config
				if (this.checked) {
					config.hiddenFields.push(field.value);
				} else {
					for (var i = 0, len = config.hiddenFields.length; i < len; i++) {
						if (config.hiddenFields[i] == field.value) {
							config.hiddenFields.splice(i, 1);
							break;
						}
					}
				}

			}; }(field));
			visibilityList.append(tr);
		}
		visibilityList.find('.item:odd').addClass('stripe');

		return template;
	}

}
/**
 * The page in the admin panel that lets you import your metadata
 */
function AdminImport() {

	var progressCheckId,
		stopAtFull = false,
		page = this,
		templates = sa.templates.get('admin.metadata.import');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var vars = sa.router.paramsToVars(params);
		container.html('<div class="data_importing"></div>');
		if (vars.importId && vars.action == 'fields') {
			loadFile(vars.importId);
		} else if (vars.importId && vars.action == 'test') {
			startApiTestRun(vars.importId, { p : 'track_data_import', handler : 'track-data-import', type : 'csv_import', removalSelector : '.pro_import' });
		} else if (vars.importId && vars.action == 'pro_settings') {
			showProSettings(vars.importId);
		} else if (vars.importId && vars.action == 'pro') {
			startTestRun(vars.importId, { p : 'pro_import', type : 'pro_import', removalSelector : '.csv_import' });
		} else {
			container.find('.data_importing').empty().append(templates.get('page'));
			// disable any keypresses in the browse box
			container.find('input').on('keydown', function() { return false; }).on('focus', function() { this.blur(); });

			// make a button for the user to click
			var button = container.find('#import_tracks');
			// set up the uploader object that will actually do the uploading
			new Uploader({ button : button, browseCallback : function(uploader) {
				handleBrowseResponse({ uploader : uploader, params : 't=track_data_import', path : 'admin?p=metadata&tab=import&action=fields&importId=' });
			}, fileType : UploaderConstants.CSV });

			// make a pro button for the user to click
			button = container.find('#pro_import_tracks');
			// set up the uploader object that will actually do the uploading
			var importId = new Date().getTime() + '' + config.id + '' + user.userData.id;
			new Uploader({ button : button, browseCallback : function(uploader) {
				handleBrowseResponse({ uploader : uploader, params : 't=pro_data_import&importId=' + importId, path : 'admin?p=metadata&tab=import&action=pro_settings&importId=' + importId + '&ignore=' });
			}, fileType : UploaderConstants.CSV });

			// show all the imports we've done previously
			loadList();
		}

		AdminImport.trigger('show');
	};

	function loadList() {
		sa.api.request({
			handler : 'track-data-import',
			action : 'get-list'
		}).then(showList);
	}

	/**
	 * Shows the list of previously imported files loaded from the server
	 */
	function showList(response) {
		var list = $j('.admin_left_list');
		list.find('.item').remove();
		if (!response.length) {
			list.append('<div class="item empty">No previous imports</div>');
			return;
		}
		for (var i = 0, len = response.length; i < len; i++) {
			var item = response[i];
			var template = templates.get('row', { id : item.id, filename : item.filename, date : formatDate(config.dateTimeFormatString, item.date) });
			template.find('.delete_icon').on('click', function(item) { return function() {
				sa.api.request({
					handler : 'track-data-import',
					action : 'delete',
					postData : {
						importId : item.id
					}
				}).then(function() {
					sa.notify({ text : 'Import deleted!', type : sa.notify.notificationTypes.success });
					loadList();
				});
			}; }(item));
			if (!item['stored']) {
				template.find('.run a, .download a').removeAttr('href');
				template.find('.run, .download').addClass('disabled').attr('title', 'This import is archived and can no longer be downloaded or run.');
			}
			list.append(template);
		}

		list.find('.item:odd').addClass('stripe');
	}

	/**
	 * Updates the display after you've browsed for an file
	 * @param {object} d the flash objecct doing the uploading
	 */
	function handleBrowseResponse(d) {
		var cont = $j('.import_container');
		var fileDetails = d.uploader.getFileDetails();
		cont.find('#file_save_message').remove();
		if (fileDetails  && fileDetails.length == 1) {
			if (fileDetails[0].size > 250 * 1024 * 1024) {
				sa.notify({ text : 'Max CSV size is 250MB. Please split this file or contact SourceAudio for assistance.' });
				sa.router.reloadPage();
				return;
			}
			cont.find('.button').hide();
			cont.append('<div id="file_save_message">Uploading...</div>');
			d.uploader.upload({
				params : d.params,
				parseComplete : true,
				complete : function(e, responseData) {
					if (responseData && responseData.length && responseData[0]['importDataId']) {
						sa.router.routeTo(d.path + responseData[0]['importDataId']);
					} else {
						sa.router.routeTo(d.path + '0');
					}
				},
				error : function() {
					cont.find('.button').show();
					$j('#file_save_message').html('Error uploading. Please try again').addClass('error');
				}
			});
		}
	}
	
	// this page is being initialized multiple times. i'm not sure why but only process once
	let loadKey = 0;

	/**
	 * Loads the details for the last file uploaded (presumably from this page)
	 */
	function loadFile(importId) {
		let myLoadKey = new Date().getTime();
		loadKey = myLoadKey;
		sa.api.request({
			handler : 'track-data-import',
			action : 'get-fields',
			getData : {
				importId : importId
			}
		}).then((data) => { showColumns(data, myLoadKey); });
	}

	function columnNumberToCode(number) {
		return (number > 25 ? String.fromCharCode(Math.floor(number / 26) + 64) : '') + String.fromCharCode(number % 26 + 65);
	}

	/**
	 * Shows the columns and lets the user determine if they're correct
	 * @param {Object} data the data from calling p=track_data_import&action=fields
	 * 	@property {Array} validFields
	 * 	@property {Array} fields
	 * 	@property {int} importId
	 * 	@property {string} filename
	 * @param {int} myLoadKey the key for this load, so we can ignore old loads
	 */
	function showColumns(data, myLoadKey) {
		
		if (loadKey != myLoadKey) {
			console.log('ignore showColumns call because load keys do not match');
			return;
		}
		ajax({ p : 'people', action : 'loadListFieldValues' }, function(listFields) {
			if (loadKey != myLoadKey) {
				console.log('ignore showColumns internal callback because load keys do not match');
				return;
			}
			let affiliationOptionString = '';
			for (var r = 0, rLen = listFields['affiliations'].length; r < rLen; r++) {
				var affiliation = listFields['affiliations'][r];
				affiliationOptionString += '<option value="' + affiliation.name.toLowerCase() + '">' + affiliation.name + '</option>';
			}

			const container = templates.get('column_editor_head', { filename : data.filename });
			$j('.data_importing').empty().append(container);
			const list = container.find('.column_list');
			
			let fieldList = '';
			for (const field of data.validFields) {
				let displayValue = field;
				if (displayValue.indexOf('Writer ') === 0) {
					displayValue = displayValue.replace('Writer', gde('writer', { c : 'upper', p : false }));
				} else if (displayValue.indexOf('Publisher ') === 0) {
					displayValue = displayValue.replace('Publisher', gde('publisher', { c : 'upper', p : false }));
				} else if (displayValue != 'SourceAudio ID' && displayValue != 'PRO Work Number' && displayValue != 'PRO Work Registration Date' && displayValue != 'ISRC' && displayValue != 'ISWC') {
					displayValue = config.getDictionaryEntry(displayValue.toLowerCase());
				}
				fieldList += '<option value="' + field.replace(/"/g, "&quot;") + '">' + displayValue + '</option>';
			}
			fieldList += '<option value="new_custom">New Custom Field</option>';
			
			let disableMaster = null; // used to track and make sure we're not selecting master id and master filename
			for (const field of data.fields) {
				const column = field.column;
				const wna = field['workNumberAffiliation'];
				let enabled = field.type != 'unknown';
				// don't let the defaults select both master filename and master id
				if (enabled && ((disableMaster === 'id' && field.name === 'Master ID') || (disableMaster === 'filename' && field.name === 'Master Filename'))) {
					enabled = false;
				} else if (enabled && !disableMaster) {
					if (field.name === 'Master ID') {
						disableMaster = 'filename';
					} else if (field.name === 'Master Filename') {
						disableMaster = 'id';
					}
				}
				if (field.type == 'custom') field.name = 'Custom: ' + field.name.toLowerCase().ucfirst();
				list.append(`
					<div class="column">
						<div class="code">${columnNumberToCode(column)}</div>
						<div class="original">${field['originalName'].replace('<', '&lt;').replace('>', '&gt;')}</div>
						<div class="example">${field.example.replace('<', '&lt;').replace('>', '&gt;')}</div>
						<div class="enabled"><input type="checkbox" title="Check to enable importing this field"${enabled ? ' checked="checked"' : ''}/></div>
						<div class="mapping">
							<select name="${column}"${(!enabled ? ' disabled="disabled"' : '')}>${fieldList.replace('"' + field.name + '"', '"' + field.name + '" selected="selected"')}</select>
						</div>
						<div class="work_number_affiliation_selection">PRO: <select name="pro_select" data-selected="${wna}"></select></div>
						<div class="writer_selection"">${gde('writer', { c : 'upper', p : false })} #: <input type="text" value="${field.writer ? field.writer : ''}"/></div>
						<div class="publisher_selection">${gde('publisher', { c : 'upper', p : false })} #: <input type="text" value="${field.publisher ? field.publisher : ''}"/></div>
						<div class="collection_share_selection">Collection Share #: <input type="text" value="${field.collectionShare ? field.collectionShare : ''}"/></div>
						<span class="clr"></span>
					</div>
				`);
			}
			list.find('.column:odd').addClass('stripe');
			list.append('<span class="clr"></span>');
			
			list.find('input[type=checkbox]').on('change', function() {
				if (this.checked) {
					let select = $j(this).parents('.column').find('select').prop('disabled', false);
					let selectValue = select.val();
					if (selectValue == 'Master Filename') {
						// uncheck any imports of "Master ID"
						let changed = $j('option[value="Master ID"]:selected').parents('.column').find('.enabled input:checked').prop('checked', false);
						if (changed.length) {
							changed.trigger('change');
							sa.notify({ text: 'Unchecked Master ID - cannot be selected with Master Filename' });
						}
					} else if (selectValue == 'Master ID') {
						// uncheck any imports of "Master ID"
						let changed = $j('option[value="Master Filename"]:selected').parents('.column').find('.enabled input:checked').prop('checked', false);
						if (changed.length) {
							changed.trigger('change');
							sa.notify({ text: 'Unchecked Master Filename - cannot be selected with Master ID' });
						}
					}
				} else {
					$j(this).parents('.column').find('select').prop('disabled', true);
				}
			});
			list.find('select[name!=pro_select]').on('change', function() {
				const t = $j(this);
				const currentValue = t.val();
				t.parents('.column').find('.writer_selection, .publisher_selection, .collection_share_selection, .work_number_affiliation_selection').hide();
				if (currentValue == 'new_custom') {
					sa.prompt({
						placeholder : 'Custom field name',
						yesFunction : function(value) {
							ajax('name=' + encodeURIComponent(value),
								function(response) {
									if (response[0].result == 'success') {
										list.find('option[value=new_custom]').before('<option>Custom: ' + value + '</option>');
										t.val('Custom: ' + value);
									} else {
										t.val('Album');
										sa.notify({ text : response[0].result });
									}
								}, 'POST', 'p=custom_fields&action=new');
						},
						yesText : 'Create',
						noFunction : function() { t.val('Album'); },
						closeFunction : function() { t.val('Album'); }
					});
				} else if (currentValue.indexOf('Writer ') === 0) {
					t.parents('.column').find('.writer_selection').show();
				} else if (currentValue.indexOf('Publisher ') === 0) {
					t.parents('.column').find('.publisher_selection').show();
					if (currentValue.indexOf('Collection Share') != -1) {
						t.parents('.column').find('.collection_share_selection').show();
					}
				} else if (currentValue == 'PRO Work Number' || currentValue == 'PRO Work Registration Date') {
					const workNumberContainer = t.parents('.column').find('.work_number_affiliation_selection');
					const proSelect = workNumberContainer.find('select[name=pro_select]');
					// we populate the proSelect only when necessary because Firefox takes a LONG time to add these if there are a lot of them
					if (proSelect.html() === '') {
						const proSelectValue = proSelect.data('selected');
						proSelect.html(proSelectValue ? affiliationOptionString.replace('value="' + proSelectValue + '"', 'value="' + proSelectValue + '" selected="selected"') : affiliationOptionString);
					}
					workNumberContainer.show();
				} else if (currentValue == 'Master Filename' && !t.prop('disabled')) {
					// uncheck any imports of "Master ID"
					let changed = $j('option[value="Master ID"]:selected').parents('.column').find('.enabled input:checked').prop('checked', false);
					if (changed.length) {
						changed.trigger('change');
						sa.notify({ text: 'Unchecked Master ID - cannot be selected with Master Filename' });
					}
				} else if (currentValue == 'Master ID' && !t.prop('disabled')) {
					// uncheck any imports of "Master ID"
					let changed = $j('option[value="Master Filename"]:selected').parents('.column').find('.enabled input:checked').prop('checked', false);
					if (changed.length) {
						changed.trigger('change');
						sa.notify({ text: 'Unchecked Master Filename - cannot be selected with Master ID' });
					}
				}
			}).trigger('change');
			container.append('<div class="error"></div>');
			container.append(createButton('Save and Do Test Run', 'save_button', '', getDefaultLink(), function() {
				// validate the info before we save
				const fieldVals = container.find('select[name!=pro_select]:enabled');
				const error = container.find('.error');
				let hasFilename = false;
				let hasTitle = false;
				let hasId = false;
				let usedFields = {};
				let fieldObject = {};
				function getCode(fieldVal) {
					return $j(fieldVal).parents('.column').find('.code').html();
				}
				function addFieldObjectValue(value, column, name) {
					if (!fieldObject[column]) {
						fieldObject[column] = {};
					}
					fieldObject[column][name] = value;
				}
				for (let i = 0, len = fieldVals.length; i < len; i++) {
					const fieldVal = fieldVals[i];
					const value = $j(fieldVal).val();
					const column = fieldVal.name;
					if (value == 'Filename') hasFilename = true;
					else if (value == 'Title') hasTitle = true;
					else if (value == 'SourceAudio ID') hasId = true;
					if (usedFields[value] !== undefined) {
						error.html('You may only select each field once but ' + getCode(fieldVals[usedFields[value]]) + ' and ' + getCode(fieldVal) + ' are both set to "' + value + '"');
						return;
					}
					if (value.indexOf('Writer ') === 0) {
						var writerNumber = $j(fieldVal).parents('.column').find('.writer_selection input').val();
						addFieldObjectValue(writerNumber, column, 'writer');
					} else if (value.indexOf('Publisher ') === 0) {
						var publisherNumber = $j(fieldVal).parents('.column').find('.publisher_selection input').val();
						addFieldObjectValue(publisherNumber, column, 'publisher');
						if (value.indexOf('Collection Share') != -1) {
							var collectionShare = $j(fieldVal).parents('.column').find('.collection_share_selection input').val();
							addFieldObjectValue(collectionShare, column, 'collectionShare');
						}
					} else if (value == 'PRO Work Number' || value == 'PRO Work Registration Date') {
						var proName = $j(fieldVal).parents('.column').find('select[name=pro_select]').val();
						addFieldObjectValue(proName, column, 'workNumberAffiliation');
					} else {
						usedFields[value] = i;
					}
					addFieldObjectValue(value, column, 'name');
				}
				if (!hasFilename && !hasTitle && !hasId) {
					error.html('You must have at least a Filename, Title, or SourceAudio ID column so we can match rows to tracks');
					return;
				}
				error.html('');
				sa.api.request({
					handler : 'track-data-import',
					action : 'saveFields',
					postData : {
						importId : data.importId,
						fields : fieldObject
					}
				}).then(function() {
					sa.router.routeTo('/admin?p=metadata&tab=import&importId=' + data.importId + '&action=test');
				}).catch(function(errorMessage) {
					error.html(errorMessage.message);
				});
			}));
			container.append('<a class="button deemphasized resizing" id="metadata_download_button" href="export.php?type=importData&importId=' + data.importId + '"><span class="fa fa-download"></span>Download CSV</a>');
		});
	}

	function showProSettings(importId) {
		var container = $j('.data_importing').html(''),
			template = templates.get('pro_settings');

		template.find('.test_run').on('click', function() {
			var pro = template.find('select[name=pro]').val(),
				iswcs = template.find('input[name=iswc]:checked').length,
				applyToNested = template.find('input[name=apply_to_nested]:checked').length,
				fuzzy = template.find('input[name=fuzzy_matching]').val();

			ajax({ pro : pro, iswcs : iswcs, fuzzy : fuzzy, applyToNested : applyToNested }, function(result) {

				if (result.success) {
					sa.router.routeTo('/admin?p=metadata&tab=import&action=pro&importId=' + importId);
				} else {
					sa.notify({ text : result.message });
				}

			}, 'POST', { p : 'pro_import', action : 'saveSettings', importId : importId });

		});

		container.append(template);
	}

	/**
	 * Initiates a test run of the given import
	 * @param {int} importId
	 * @param {object} d
	 */
	function startTestRun(importId, d) {
		var container = $j('.data_importing').html(''),
			startTime = new Date().getTime();
		progressCheckId = new Date().getTime().toString() + config.id + user.userData.id + Math.random();
		stopAtFull = false;
		showLoader(container[0], 'Performing test run...');
		ajax({ p : d.p, action : 'test', importId : importId, progressCheckId : progressCheckId }, function(results) {
			showRunResults(results, importId, true, d);
			stopProgressUpdate();
			console.log('Test run ran in ' + ((new Date().getTime() - startTime) / 1000));
		});
		startProgressUpdate(importId, d);
	}

	/**
	 * Initiates a test run of the given import
	 * @param {int} importId
	 * @param {object} d
	 */
	function startApiTestRun(importId, d) {
		var container = $j('.data_importing').html(''),
			startTime = new Date().getTime();
		progressCheckId = new Date().getTime().toString() + config.id + user.userData.id + Math.random();
		stopAtFull = false;
		showLoader(container[0], 'Performing test run...');
		sa.api.request({
			handler : d.handler,
			action : 'run-test',
			postData : {
				importId : importId,
				progressCheckId : progressCheckId
			}
		}).then(function(results) {
			showRunResults(results, importId, true, d);
			stopProgressUpdate();
			console.log('Test run ran in ' + ((new Date().getTime() - startTime) / 1000));
		});
		startProgressUpdate(importId, d);
	}

	/**
	 * Starts an interval that checks on progress of the current import job
	 * @param {int} importId
	 * @param {object} d
	 */
	function startProgressUpdate(importId, d) {
		var fillBar = $j('.data_importing').append('<div class="progress"><div class="fill_bar"></div><span class="progress_numbers"></div></div>').find('.fill_bar'),
			progressContainer =  $j('.data_importing .progress_numbers'),
			lastCurrent = 0,
			startTime = 0,
			checkSpeed = 5,
			getProgress = function() {
				let successCallback = function(response) {
					var current = response.current,
						total = response.total;
					if (lastCurrent && current == 0 && total == 1) {
						console.log('Spreadsheet importing stopped after ' + lastCurrent.numberFormat() + ' rows. Continuing');
						progressContainer.html('Current processed ' + lastCurrent.numberFormat() + ' rows. Processing and will continue...');
						startImport(importId, progressCheckId, lastCurrent, d);
					} else if (current == -1 || (current == 0 && total == 1)) {
						progressContainer.html('Preparing data...');
					} else if (current > 0 && current == total) {
						progressContainer.html('Performing post-processing. We\'re almost there...');
						fillBar.css({ width : '100%' });
						if (stopAtFull) {
							console.log('assuming we\'re done with import request');
							showRunResults({ stoppedAtFull : true }, importId, false, d);
							stopProgressUpdate();
						}
					} else {
						if (!startTime) {
							startTime = new Date().getTime();
							progressContainer.html(current + ' / ' + total + ' rows processed');
						} else {
							var elapsedTime = (new Date().getTime() - startTime) / 1000,
								tracksPerSecond = current / elapsedTime,
								secondsLeft = (total - current) / tracksPerSecond;
							progressContainer.html(current + ' / ' + total + ' rows processed' + (tracksPerSecond > 0 ? ' (' + (Math.round(tracksPerSecond * 100) / 100)
								+ ' per second - approximately ' + secondsToString(Math.floor(secondsLeft), false) + ' remaining)' : ''));
						}
						fillBar.css({ width : current / total * 100 + '%' });
						window['lastPerSecond'] = (current - lastCurrent) / checkSpeed;
						lastCurrent = current;
					}
				};
				if (d.handler) {
					sa.api.request({
						handler : d.handler,
						action : 'get-progress',
						getData : {
							progressCheckId : progressCheckId
						}
					})
						.then(successCallback)
						.catch(err => {
							sa.alert({ text : err.message });
							clearInterval(interval);
						});
						
				} else {
					ajax({ p : d.p, action : 'progress', importId : importId, progressCheckId : progressCheckId }, successCallback);
				}
			},
			interval = setInterval(function() {
				if (!progressCheckId) {
					clearInterval(interval);
					return;
				}
				getProgress();
			}, checkSpeed * 1000);
		// set up a progress bar
		setTimeout(function() { getProgress(); }, 1000);
	}

	/**
	 * Stops the interval started by startProgressUpdate
	 */
	function stopProgressUpdate() {
		progressCheckId = false;
	}

	/**
	 * Updates the progress check id if you ever need to change it
	 */
	function setProgressCheckId(id) {
		progressCheckId = id;
		stopAtFull = true;
	}

	/**
	 * @typedef {Object} ImportRunResults
	 * @property {int} matched
	 * @property {int} unmatched
	 * @property {int} doubled
	 * @property {string} result
	 * @property {boolean} stoppedAtFull
	 */


	/**
	 * @typedef {Object} ImportError
	 * @property {boolean} error
	 * @property {string} message
	 */

	/**
	 * Shows the results of a run, be a test or the real deal
	 * @param {ImportRunResults|ImportError|object} results the results from the run
	 * @param {int} importId the id of the import the run was on
	 * @param {boolean} testRun was this a test?
	 * @param {Object} d
	 */
	function showRunResults(results, importId, testRun, d) {
		if (results.result) {
			sa.notify({ text : results.result });
			sa.router.routeTo('/admin?p=metadata&tab=import&importId' + importId + '&action=fields');
			return;
		}
		var container = $j('.data_importing');
		if (results.stoppedAtFull) {
			container.empty().append(templates.get('stopped_at_full'));
		} else {
			var template = templates.get('run_results');
			if (testRun) {
				template.find('.run').remove();
			} else {
				template.find('.test').remove();
			}
			if (d.removalSelector) {
				template.find(d.removalSelector).remove();
			}
			var types = [ 'matched', 'unmatched', 'doubled', 'bad_columns', 'work_number_matched' ];
			for (var i = 0, len = types.length; i < len; i++) {
				var type = types[i];
				if (results[type]) {
					template.find('#' + type + '_rows .count').html(results[type].numberFormat());
					template.find('#' + type + '_rows .export_link').attr('href', 'export.php?type=import&id=' + importId + '&results=' + type + '&importType=' + d.type);
				} else {
					template.find('#' + type + '_rows').remove();
				}
			}
			if (results.matched) {
				if (testRun) {
					template.find('#no_matches, #data_imported').remove();
					if (!results.unmatched && !results.doubled) {
						template.find('#only_found').remove();
					}
					template.find('#begin_import').on('click', function (e) {
						e.preventDefault();
						var warningText = templates.get('import_warning');
						warningText.find('.count').html(results.matched.numberFormat());
						warningText.find('#export_tracks').attr('href', 'https://' + config.domain + '/export.php?type=tracks&format=csv&importType=' + d.type);
						sa.confirm({
							text : warningText.html(),
							yesFunction : function() {
								progressCheckId = new Date().getTime().toString() + config.id + user.userData.id + Math.random();
								var startRow = 0;
								if (window['globalStartRowOverride']) {
									startRow = window['globalStartRowOverride'];
								}
								startImport(importId, progressCheckId, startRow, d);
								container.html('');
								showLoader(container[0], 'Importing your CSV. Please be patient...');
								startProgressUpdate(importId, d);
							},
							yesText : 'Import'
						});
						return false;
					});
				} else {
					template.find('#begin_import, #no_matches, #only_found').remove();
				}
			} else if (results.error) {
				sa.notify({ text : results.message });
				sa.router.routeTo('/admin?p=metadata&tab=import');
				return;
			} else {
				template.find('#begin_import, #data_imported, #only_found').remove();
			}
			container.empty().append(template);
		}
	}

	function startImport(importId, progressCheckId, startRow, d) {
		if (!startRow) startRow = 0;
		var date = new Date().getTime();
		console.log('sending start import request for', date, 'import=1&startRow=' + startRow, progressCheckId);
		/**
		 * @param {Object} response
		 * 	@property {boolean} alreadyRunning
		 * 	@property {boolean} otherCopyRunning
		 * 	@property {int} processCheckId
		 */
		function handleImportResponse(response) {
			if (response && response.alreadyRunning) {
				return console.log('Server said', progressCheckId, 'was already running');
			}
			if (response && response.otherCopyRunning) {
				setProgressCheckId(response.processCheckId, true);
				sa.notify({ text : 'This import was already running and cannot be run again until that process has finished. You are now seeing its progress.' });
				return console.log('Server said this import was running elsewhere');
			}
			console.log('done with import request for', date);
			showRunResults(response, importId, false, d);
			stopProgressUpdate();
		}
		if (d.handler) {
			sa.api.request({
				handler : d.handler,
				action : 'run-import',
				postData : {
					progressCheckId : progressCheckId,
					startRow : startRow,
					importId : importId
				}
			}).then(handleImportResponse);
				
		} else {
			ajax({
				'import' : 1,
				'startRow' : startRow,
				'secureToken' : user.secureToken
			}, handleImportResponse, 'POST', {
				p : d.p,
				importId : importId,
				action : 'import',
				progressCheckId : progressCheckId
			});
		}
	}

}

sa.eventify(AdminImport);
/**
 * The page in the admin panel that lets you manage relational fields
 */
(function() {
	
	let page = {};

	/**
	 * @typedef {Object} ExternalSiteMappingData
	 * @property {Array} genres
	 * @property {Array} tempos
	 * @property {Array} cue_types
	 * @property {string} name
	 * @property {int} id
	 * @property {boolean} usingStandards
	 */

	/**
	 * @return {JQuery}
	 */
	AdminFields.prototype.getMappingTemplate = function(templates) {
		let template = templates.get('mapping_base');
		showLoader(template, 'Loading your mappings');
		
		ajax({ p : 'relational_fields', action : 'mapping' },
			/** @var {{ internal : { genres : Array, tempos : Array, cue_types : Array }, external : Array.<ExternalSiteMappingData>, mappings : object }} data */
			function(data) {
				var internal = data.internal,
					external = data.external,
					mappings = data.mappings,
					genreLength = 0,
					tempoLength = 0,
					cueTypeLength = 0;

				genreLength = internal.genres.length;
				tempoLength = internal.tempos.length;
				cueTypeLength = internal.cue_types.length;

				template.empty();

				if (!genreLength && !tempoLength && !cueTypeLength) {

					template.append(templates.get('no_mapping'));

				} else {

					template.append(templates.get('mapping_base'));

					if (!genreLength) {
						template.find('#genre_section').hide();
					}
					if (!tempoLength) {
						template.find('#tempo_section').hide();
					}
					if (!cueTypeLength) {
						template.find('#cue_type_section').hide();
					}

					// this function will handle choosing a site to show
					function showSiteMappings(data, mappings) {

						template.find('.site_name').html(data.name);

						if (data.usingStandards) {

							template.find('.mapping_section').hide();
							template.find('#using_standard').show();

						} else {

							template.find('.mapping_section').show();
							template.find('#using_standard').hide();

							if (genreLength) {
								showMappings(template.find('#genre_section'), 'genres', data.genres, internal.genres, mappings.genres);
							}

							if (tempoLength) {
								showMappings(template.find('#tempo_section'), 'tempos', data.tempos, internal.tempos, mappings.tempos);
							}

							if (cueTypeLength) {
								showMappings(template.find('#cue_type_section'), 'cue_types', data.cue_types, internal.cue_types, mappings.cue_types);
							}

						}

					}

					// set up the drop down
					var dd = template.find('select[name=mapping_site]');
					for (let e = 0, eLen = external.length; e < eLen; e++) {
						dd.append('<option value="' + external[e].id + '">' + external[e].name + (external[e].usingStandards ? ' (using SourceAudio standard)' : '') + '</option>');
					}
					dd.on('change', function() {
						let siteData,
							selectedSiteId = dd.val();
						for (let i = 0, len = external.length; i < len; i++) {
							if (external[i].id == selectedSiteId) {
								siteData = external[i];
								break;
							}
						}
						showSiteMappings(siteData, mappings);
					});

					showSiteMappings(external[0], mappings);

					// show the unmatched list
					page.determineUnmapped = function() {
						determineUnmapped(internal, external, mappings);
					}; // see documentation for determineUnmapped for closure excuse
					page.determineUnmapped();

					template.find('#save_mappings').on('click', function() {
						saveMappingChanges(mappings.genres, mappings.tempos, mappings.cue_types);
					});
					
					// let the mapping areas scroll
					let mappingHeight = Math.max(300, $j(window).height() - 200 - $j('#top_bar').height() - $j('#bottom_bar').height());
					template.find('.mapping_section ul').css({ maxHeight : mappingHeight + 'px', overflowY : 'auto' });
					
				}
			}
		);

		/**
		 * Shows the mappings for one section
		 * @param {*} section the container
		 * @param {string} type the type (genres|tempos|cue_types)
		 * @param {Array} external
		 * @param {Array} internal
		 * @param {Array} mappings
		 */
		function showMappings(section, type, external, internal, mappings) {
			let left = section.find('.mapping_left ul'),
				right = section.find('.mapping_right ul'),
				disableChecks = false,
				applyMappings,
				relevantMappings = {},
				externalIds = {}, // used to determine relevantMappings
				leftItemTemplate = templates.get('left_item'),
				rightItemTemplate = templates.get('right_item');

			if (!external.length) {
				left.html(templates.get('no_type_mappings'));
				right.empty();
				section.find('.hide_on_empty_element').hide();
				return;
			} else {
				left.empty();
				right.empty();
				section.find('.hide_on_empty_element').show();
			}

			for (let e = 0, eLen = external.length; e < eLen; e++) {
				externalIds[external[e].id] = 1;
			}
			for (let internalId in mappings) {
				if (!mappings.hasOwnProperty(internalId)) continue;
				for (let e = 0, eLen = mappings[internalId].length; e < eLen; e++) {
					let eVal = mappings[internalId][e];
					if (externalIds[eVal]) {
						if (!relevantMappings[internalId]) relevantMappings[internalId] = [];
						relevantMappings[internalId].push(eVal);
					}
				}
			}

			applyMappings = function(selected, id, add) {
				if (add) {
					if (!mappings[selected]) mappings[selected] = [];
					mappings[selected].push(id);
				} else {
					mappings[selected].splice(mappings[selected].indexOf(id), 1);
				}
			};

			leftItemTemplate.find('input').attr('name', 'external_' + type);

			for (let i = 0, len = internal.length; i < len; i++) {
				let name = internal[i].name,
					id = internal[i].id,
					item = leftItemTemplate.clone();

				(function(name, id, item) {

					item.attr('id', 'master_' + type + '_' + id);
					item.find('.name').html(name);

					left.append(item);

					item.find('input').on('click', function() {
						// show the mappings
						let maps = relevantMappings[id];
						disableChecks = true;
						right.find('input:checked').prop('checked', false);
						if (maps) {
							for (let i = 0, len = maps.length; i < len; i++) {
								template.find('#map_' + maps[i]).prop('checked', true);
							}
						}
						disableChecks = false;
					});

					if (relevantMappings[id] && relevantMappings[id].length) {
						item.addClass('has_map').data({ 'name' : name, 'id' : id });
					} else {
						item.addClass('no_map').data({ 'name' : name, 'id' : id });
					}

				})(name, id, item);
			}

			for (let i = 0, len = external.length; i < len; i++) {
				let name = external[i].name,
					id = external[i].id,
					item = rightItemTemplate.clone();

				(function(name, id, item) {

					item.find('input').attr('id', 'map_' + id);
					item.find('span').html(name);

					right.append(item);

					item.find('input').on('click', function() {
						// update mappings
						if (disableChecks) return;
						let selected = left.find('input:checked').parents('li').data('id');
						if (!relevantMappings[selected]) {
							relevantMappings[selected] = [];
						}
						if (this.checked) {
							relevantMappings[selected].push(id);
						} else {
							relevantMappings[selected].splice(relevantMappings[selected].indexOf(id), 1);
						}
						applyMappings(selected, id, this.checked);
						page.determineUnmapped();
						if (relevantMappings[selected] && relevantMappings[selected].length) {
							template.find('#master_' + type + '_' + selected).removeClass('no_map').addClass('has_map');
						} else {
							template.find('#master_' + type + '_' + selected).removeClass('has_map').addClass('no_map');
						}
					});

				})(name, id, item);

			}

			left.find('input:first').trigger('click');

			section.find('#autoassign').on('click', function() {
				let mapless = left.find('.no_map'),
					options = right.find('label');
				for (let i = 0, len = mapless.length; i < len; i++) {
					let map = template.find(mapless[i]),
						name = map.data('name').replace(/ - .*/, '').replace('&amp;', '&').replace(' ', '').toLowerCase(),
						id = map.data('id');
					for (let j = 0, jLen = options.length; j < jLen; j++) {
						let option = template.find(options[j]),
							optionName = option.find('span').html().replace('&amp;', '&').replace(' ', '').toLowerCase();
						if (name == optionName || name.indexOf(optionName) != -1 || optionName.indexOf(name) != -1) {
							if (!relevantMappings[id]) relevantMappings[id] = [];
							let selected = parseInt(option.find('input').attr('id').replace(/map_/, ''));
							relevantMappings[id].push(selected);
							applyMappings(id, selected, true);
							template.find('#master_' + type + '_' + id).removeClass('no_map').addClass('has_map');
						}
					}
				}
				left.find('input:checked').trigger('click');
				page.determineUnmapped();
			});
		}



		/**
		 * Figures out which sites still need mappings and shows a list on the page so the user can quickly figure out what they need to do
		 * Not called directly as determineUnmapped but rather uses page.determineUnmapped, a closure created in setData that always passes in the right data even when it's not accessible from where we're calling
		 */
		function determineUnmapped(internal, external, mappings) {
			var types = [ 'genres', 'tempos', 'cue_types' ];

			// each type will be checked individually
			var externalCount = external.length,
				unmapped = {};
			for (let t = 0; t < 2; t++) {
				let type = types[t],
					skippedExternals = {};

				// build a list of items so we can map them to sites
				let itemIds = {};
				for (let e = 0; e < externalCount; e++) {
					let externalId = external[e].id,
						externalItems = external[e][type],
						iLen = externalItems.length;
					for (let i = 0; i < iLen; i++) {
						itemIds[externalItems[i].id] = externalId;
					}
					if (!iLen) { // if there are no items, this one requires no mapping
						skippedExternals[externalId] = externalId;
					}
				}

				// make a full mappings list - the regular one doesn't include internal ids for which there's no mapping and this technique assumes a full list
				let fullMappings = {},
					typeMappings = mappings[type],
					typeInterals = internal[type];
				for (let i = 0, iLen = typeInterals.length; i < iLen; i++) {
					let internalId = typeInterals[i].id;
					if (typeMappings[internalId]) {
						fullMappings[internalId] = typeMappings[internalId];
					} else {
						fullMappings[internalId] = [];
					}
				}

				// go through the mappings and for each internal id, match it up to external ids and therefore to sites
				for (let internalId in fullMappings) {
					if (!fullMappings.hasOwnProperty(internalId)) continue;
					let externalIds = fullMappings[internalId],
						externalIdCount = externalIds.length,
						matchedSites = {};

					for (let e = 0; e < externalIdCount; e++) {
						let externalSiteId = itemIds[externalIds[e]];
						if (!externalSiteId) continue; // not all site will be represented in the external list. that's ok
						matchedSites[externalSiteId] = externalSiteId;
					}

					// if all sites aren't in the matchedSite, we found a site that still needs matching
					if (Object.keys(matchedSites).length != external.length) {
						for (let e = 0; e < externalCount; e++) {
							let externalId = external[e].id;
							if (!matchedSites[externalId] && !skippedExternals[externalId]) {
								unmapped[externalId] = external[e];
							}
						}
					}

					// if all sites are unmapped, we're done. they need everything
					if (Object.keys(unmapped).length >= externalCount) {
						return updateUnmappedList(unmapped, external);
					}
				}
			}

			// if we have any unmapped, we need to figure out the corresponding externals
			if (Object.keys(unmapped).length) {
				updateUnmappedList(unmapped, external);
			} else {
				updateUnmappedList({}, external);
			}

		}

		/**
		 * Helper function for determineUnmapped that actually updates the on-page list
		 * @param {object} unmappedSiteIds indexed by site id
		 * @param {Array.<ExternalSiteMappingData>} allSites of external sites
		 */
		function updateUnmappedList(unmappedSiteIds, allSites) {

			let list = template.find('.map_status_list').empty();
			let mappedTemplate = templates.get('map_status_list_mapped');
			let unmappedTemplate = templates.get('map_status_list_unmapped');
			let unmappedStandard = !!unmappedSiteIds[-1];

			allSites.each(function(s, site) {

				let template = (unmappedSiteIds[site.id] || (unmappedStandard && site.usingStandards) ? unmappedTemplate : mappedTemplate).clone();
				template.find('.name').html(site.name + (site.usingStandards ? ' (using SourceAudio standard)' : ''));
				list.append(template);

			});

		}

		/**
		 * Saves the current state of the maps
		 */
		function saveMappingChanges(genreMappings, tempoMappings, cueTypeMappings) {
			// it's tempting to try to convert this to using object syntax but don't - it needs to work the way it does because it can overflow the server limits with its var count
			let s = '&genreMappings=' + encodeURIComponent(JSON.stringify(genreMappings))
				+ '&tempoMappings=' + encodeURIComponent(JSON.stringify(tempoMappings))
				+ '&cue_typeMappings=' + encodeURIComponent(JSON.stringify(cueTypeMappings));
			ajax(s, function(response) {
				if (response[0].result == 'success') {
					sa.notify({ text : 'Changes saved', type : sa.notify.notificationTypes.success });
				} else {
					sa.alert({ text : response[0].result });
				}
				template.find('#loader_element').remove();
			}, 'POST', 'p=relational_fields&action=mappings_save');
			showLoader(template, 'Saving Mappings...');
			sa.scrollToElement(template);
		}

		return template;
	};
})();
/**
 * The page in the admin panel that lets you manage your catalogs
 */
function AdminMetadataNesting() {

	var page = this;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.metadata.nesting');
		}
		container.empty().append(templates.get('page'));
		container.find('#label_nesting_results h2 a').on('click', function() { showLabels(); });
		showLabels();
	};

	/**
	 * Loads the labels
	 */
	function showLabels() {
		$j('#label_management_list').show();
		$j('#nesting_options_list').hide();
		$j('#label_nesting_results').hide();
		ajax('p=list&type=label&ids=1&excludeSyncs=1', function(response) {
			var labelsList = $j('#label_list');
			var items = response[0].items;
			labelsList.find('.item').remove();
			if (items.length) {
				for (var i = 0, len = items.length; i < len; i++) {
					var label = items[i];
					if (label.queuedForDelete === '0' || label.queuedForDelete) {
						continue;
					}
					var tr = templates.get('row', { name : label.value });
					tr.find('.name a').on('click', function(label) { return function() {
						showNestingOptions(label);
					}; }(label));
					tr.find('#delete').on('click', function(label) { return function() {
						sa.confirm({
							text : 'Are you sure you want to remove all nesting from this ' + gde('label', { c : 'lower', p : false }) + '?<br/><b>All previous nesting will be undone.</b>',
							yesFunction : function() {
								removeNesting(label);
							},
							yesText : 'Remove'
						});
					}; }(label));
					labelsList.append(tr);
				}
				labelsList.find('.item:odd').addClass('stripe');
			} else {
				labelsList.append(templates.get('empty'));
			}
		});
	}

	function showNestingOptions(label) {
		var labelManagementList = $j('#label_management_list').hide();
		var nestingOptions = $j('#nesting_options_list').show();

		nestingOptions.find('.label_name').html(label.value);

		nestingOptions.find('#nest_button').off('click').on('click', function() {
			var options = $j('.nesting_options input:checked');
			let optionsArray = [];
			for (var i = 0, len = options.length; i < len; i++) {
				optionsArray.push(options[i].value);
			}
			console.log('sending', optionsArray, 'to the nester');
			startNesting(label, optionsArray);
		});

		nestingOptions.find('#cancel_button').off('click').on('click', function() {
			nestingOptions.hide();
			labelManagementList.show();
			sa.scrollToElement(labelManagementList);
		});

		sa.scrollToElement(nestingOptions);
	}

	function startNesting(label, optionsArray) {
		var updateKey = (new Date()).getTime();
		var formatSingle = function(track) {
			return '<a href="'+siteBaseUrl()+'/track/' + track.id + '" target="_blank">' + track.title + ' (' + track.id + ')</a> - ' + (Math.floor(track.length * 100) / 100) + 's<br/>';
		};
		var getStatus = async function() {
			const response = await sa.api.request({
				handler : 'nesting',
				action : 'status',
				getData : {
					updateKey : updateKey,
					labelId : label.id
				}
			});

			if (!response) return;
			var datumString = '';
			for (var i = 0, len = response.length; i < len; i++) {
				var datum = response[i],
					master = datum.master,
					children = datum.children;
				datumString += 'Master: ' + formatSingle(master);
				if (children.length) {
					datumString += '<ul class="child">';
				}
				for (var c = 0, cLen = children.length; c < cLen; c++) {
					datumString += '<li>' + formatSingle(children[c]) + '</li>';
				}
				if (children.length) {
					datumString += '</ul>';
				} else {
					datumString += '<br/>';
				}
			}
			resultsContainer.append('<div>' + datumString + '</div>');
		};
		var updateInterval;
		var container = $j('#label_nesting_results');
		var resultsContainer = container.find('.nesting_results').html('<h2>Results so far:</h2><div class="section"></div>').find('.section');

		// show the frame
		$j('#label_management_list').hide();
		$j('#nesting_options_list').hide();
		container.show();
		container.find('.back_button').on('click', function() {
			showLabels();
		});
		container.find('.progress').html('Nesting in progress for <span class="time">0:00</span>');
		sa.scrollToElement(container);
		resultsContainer.html('');

		// start the nesting!
		sa.api.request({
			handler : 'nesting',
			action : 'nest',
			getData : {
				updateKey : updateKey,
			},
			postData : {
				labelId : label.id,
				options : optionsArray
			}
		}).then(function () {
			container.find('.progress').html('<span class="success">Nesting complete! Total time: ' + secondsToClockTime((new Date().getTime() - updateKey) / 1000) + '</span>'
				+ '<h3>It could take a few minutes for your new nesting to appear on your workspace</h3>');
			clearInterval(updateInterval);
			getStatus(); // the last update
		}).catch(function(e) {
			container.find('.progress').html('<span class="error">' + e.message + '</span>');
			clearInterval(updateInterval);
			getStatus(); // the last update
		});

		// check for progress
		updateInterval = setInterval(function() {
			container.find('.time').html(secondsToClockTime((new Date().getTime() - updateKey) / 1000));
			getStatus();
		}, 1000);
	}

	async function removeNesting(label) {
		await sa.api.request({
			handler : 'nesting',
			action : 'unnest',
			postData : {
				labelId : label.id
			}
		});

		sa.notify({ text : 'All nesting removed from ' + label.value + '! It may take a few minutes for this to be visible on your workspace.' });
	}
}
/**
 * The page in the admin panel that lets you manage and run your rules
 *  NOTE: To whomever has to work on this, I'm sorry. It's a mess and it's really hard to figure out wtf is going on.
 *   Sorry, it's really old and despite being messy, it works, so it's hard to find time to go in and fix it.
 *   If you have to make any kind of large changes, I'd be really tempted to just rewrite this front-end completely.
 */
function AdminRules() {

	var page = this;
	var templates;

	/**
	 * {array} of options pertaining to what fields can affected and be affected by rules
	 */
	this.rulerOptions = [];

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.metadata.rules');
		}
		container.empty().append(templates.get('page'));
		this.loadRuleSettings();
		this.loadRules();
	};

	/**
	 * Loads the available conditions and results
	 */
	this.loadRuleSettings = function() {
		var page = this;
		ajax('p=rules&action=options', function(response) { page.handleRuleSettings(response); });
	};

	/**
	 * Sets up the ruler after it's been loaded
	 */
	this.handleRuleSettings = function(newData) {
		this.rulerOptions = newData[0];

		$j('#ruler .options').html(templates.get('options').html());
		$j('#ruler #add_condition').on('click', function() { page.addCondition(false); }).on('focus', function() { this.blur(); });
		$j('#ruler #add_result').on('click', function() { page.addResult(false); }).on('focus', function() { this.blur(); });

		this.addCondition(true);
		this.addResult(true);

		// add the buttons
		$j('#ruler #clear').off('click').on('click', function() { page.handleRuleSettings([page.rulerOptions]); });
		$j('#ruler #create').off('click').on('click', function() { page.createRule(); });
	};

	/**
	 * Adds a new condition to the rule
	 * @param {boolean} first is this the first condition?
	 */
	this.addCondition = function(first) {

		var condition = $j('<li class="condition"><span class="inner"></span></li>');

		// start off by generating the field type drop down
		var dropdown = $j('<select class="condition_field"><option value="0">--ignore--</option></select>')
			.on('change', function() {
				var option = $j(this.options[this.selectedIndex]), // the currently selected field <option>
					comps = condition.find('#condition_comparison option'), // the <option> elements in the comparison select
					list = option.data('list'), // is this field a list field?
					date = option.html() == 'release date',
					text = !list && !date;

				// set the input to whatever's in the field's data('input')
				condition.find('.input').html(option.data('input'));
				// do we need a date picker?
				if (date) {
					condition.find('.input input').datepicker({ dateFormat: config.datePickerDateFormatString });
				}
				// go through the comparison options and hide non-list ones if this is a list field
				for (var i = 0, len = comps.length; i < len; i++) {
					var opt = $j(comps.get(i));
					opt.show();
					if (list && !opt.data('list')) {
						opt.hide();
					}
					if (date && !opt.data('date')) {
						opt.hide();
					}
					if (text && !opt.data('text')) {
						opt.hide();
					}
				}
			});

		var rulerOptions = this.rulerOptions;
		var fields = rulerOptions.fields;
		var comparisons = rulerOptions['comparisons'];

		// now add the options
		for (var f = 0, fLen = fields.length; f < fLen; f++) {
			// each options has its own code for the input box/select box
			var inputCode = '',
				field = fields[f];
			if (field.list) {
				var list = field.list;
				inputCode = '<select class="condition_value">';
				for (var j = 0, jLen = list.length; j < jLen; j++) {
					inputCode += '<option value="' + list[j].id + '">' + list[j].name + '</option>';
				}
				inputCode += '</select>';
			} else {
				inputCode = '<input type="text" class="condition_value"/>';
			}
			// now add the option
			dropdown.append($j('<option value="' + field.id + '">' + field.name + '</option>')
				.data('input', inputCode).data('list', field.list ? 1 : 0));
		}

		// comparisons are much simpler and don't do much on their own
		var comp = $j('<select id="condition_comparison"></select>');
		for (var i = 0, len = comparisons.length; i < len; i++) {
			var comparison = comparisons[i];
			comp.append($j('<option value="' + comparison.id + '">' + comparison.name + '</option>')
				.data({ date : comparison.date, list : comparison.list, text : comparison.text }));
		}

		// make a condition div and add everything to it
		condition.find('.inner').append(dropdown.data('condition', condition))
			.append(comp)
			.append('<span class="input"><input type="text" class="condition_value"/></span>');

		// and that block and a title
		$j('#ruler #conditions').append((!first ? '<h4>and its</h4>' : '')).append(condition);
	};

	/**
	 * Adds a new result to the rule
	 * @param {boolean} first is this the first result?
	 */
	this.addResult = function(first) {
		// the field that should be selected if there is one
		var findField = (first && this.field) ? this.field.toLowerCase() : '',
			selectedFieldValue = 0,
			selectedInputValue = 0,
			fields = this.rulerOptions.fields;

		var result = $j('<li class="result"><span class="inner"></span></li>');

		// start off by generating the field type drop down
		var dropdown = $j('<select class="result_field"><option value="0">--ignore--</option></select>')
			.on('change', function() {
				var option = $j(this.options[this.selectedIndex]); // the currently selected field <option>

				// set the input to whatever's in the field's data('input')
				$j('.input', result).html(option.data('input'));
				// do we need a date picker?
				if (option.html() == 'release date') {
					$j('.input input', result).datepicker({ dateFormat: config.datePickerDateFormatString });
				}
			});

		// now add the options
		for (var i = 0, len = fields.length; i < len; i++) {
			var field = fields[i],
				inputCode = '',
				option;
			// each options has its own code for the input box/select box
			if (field.list) {
				var list = field.list;
				inputCode = '<select class="result_value">';
				for (var j = 0, jLen = list.length; j < jLen; j++) {
					inputCode += '<option value="' + list[j].id + '">' + list[j].name + '</option>';
					if (first && this.value == list[j].name) {
						selectedInputValue = list[j].id;
					}
				}
				inputCode += '</select>';
			} else {
				inputCode = '<input type="text" class="result_value"/>';
			}
			// now add the option
			option = $j('<option value="' + field.id + '">' + field.name + '</option>')
				.data('input', inputCode);
			if (findField && field.name.indexOf(findField) != -1) {
				//option.get(0).selected = true;
				selectedFieldValue = field.id;
			}
			dropdown.append(option);
		}

		// make a result div and add everything to it
		$j('.inner', result).append(dropdown.data('result', result))
			.append(' to ')
			.append('<span class="input"><input type="text" class="result_value"/></span>');

		// and that block and a title
		$j('#ruler #results').append((!first ? '<h4>and its</h4>' : '')).append(result);
		if (first && this.value && selectedFieldValue) {
			$j('.result .result_field').val(selectedFieldValue);
			$j('.result .result_field').trigger('change');
			$j('.result .input input').val(this.value);
			$j('.result .input select').val(selectedInputValue);
		}
	};

	/**
	 * Loads the current rules for this white label
	 */
	this.loadRules = function() {
		ajax('p=rules&action=list', function(response) { page.setRules(response); });
	};

	/**
	 * Populates the current rules once they've been loaded
	 * @param {Array} rules the rules
	 */
	this.setRules = function(rules) {

		var ruleList = $j('#rule_list_container');

		if (!rules.length) {

			ruleList.find('.empty').show();
			ruleList.find('.with_rules').hide();

		} else {

			ruleList.find('.empty').hide();
			ruleList.find('.with_rules').show();

			var list = ruleList.find('#rule_list');
			list.find('.item').remove();

			rules.each(function(i, rule) {

				var item = templates.get('rule_row', { ruleId : rule.id, order : rule.order, english : rule.english });

				item.find('#up').on('click', function() { page.moveRule(1, rule.id); });
				item.find('#down').on('click', function() { page.moveRule(-1, rule.id); });
				item.find('#delete').on('click', function() { page.deleteRule(rule.id); });

				list.append(item);

			});

			ruleList.find('.item:odd').addClass('stripe');

			ruleList.find('#run_rules').off('click').on('click', function() {
				page.runRules();
			});

		}

	};

	/**
	 * Starts the process to create rule based on the user entered values
	 */
	this.createRule = function() {
		var conditions = $j('.condition').removeClass('error'),
			results = $j('.result').removeClass('error'),
			queryString = '',
			page = this;
		for (var c = 0, cLen = conditions.length; c < cLen; c++) {
			var conditionField = $j('.condition_field', conditions[c]).val(),
				comparison = $j('#condition_comparison', conditions[c]).val();
			if (!conditionField || conditionField == '0') continue;
			queryString += '&conditions[' + c + '][field]=' + encodeURIComponent(conditionField)
				+ '&conditions[' + c + '][comparison]=' + encodeURIComponent(comparison)
				+ '&conditions[' + c + '][input]=' + encodeURIComponent($j('.condition_value', conditions[c]).val());
		}
		for (var i = 0; i < results.length; i++) {
			var resultField = $j('.result_field', results[i]).val();
			if (!resultField) continue;
			queryString += '&results[' + i + '][field]=' + encodeURIComponent(resultField)
				+ '&results[' + i + '][input]=' + encodeURIComponent($j('.result_value', results[i]).val());
		}
		ajax(queryString, function(response) { page.handleCreateRuleResponse(response[0]); }, 'POST', 'p=rules&action=new');
	};

	/**
	 * Handles the response from trying to create a rule
	 * @param {Object} newData will include "result", ("error" || "success"), "source":{"type","id"} (optional)
	 */
	this.handleCreateRuleResponse = function(newData) {
		$j('#ruler #response').html(newData.result).removeClass('error').addClass(newData.error ? 'error' : 'success');
		if (!newData.error) {
			sa.scrollToElement($j('#rule_list'));
		}
		if (newData.source) {
			$j($j('.' + newData.source.type)[newData.source.id]).addClass('error');
		}
		this.loadRules();
	};

	/**
	 * Moves the given rule up or down
	 * @param {int} direction 1, up. -1, down
	 * @param {int} ruleId the rule's id
	 */
	this.moveRule = function(direction, ruleId) {
		var rule = $j('#rule_' + ruleId);
		if (direction == -1) {
			rule.next('.item').after(rule);
		} else {
			rule.prev('.item').before(rule);
		}
		this.reorderRules();
		ajax('p=rules&action=move&ruleId=' + ruleId + '&direction=' + direction);
	};

	/**
	 * Deletes a rule
	 * @param {int} ruleId the rule's id
	 */
	this.deleteRule = function(ruleId) {
		$j('#rule_' + ruleId).remove();
		this.reorderRules();
		ajax('p=rules&action=delete&ruleId=' + ruleId);
	};

	/**
	 * Sets all the order numbers and stripes
	 * 	Used after moving or deleting rules
	 */
	this.reorderRules = function() {
		var orders = $j('#rule_list .item .order');
		for (var i = 0; i < orders.length; i++) {
			orders[i].innerHTML = i + 1;
		}
		$j('#rule_list .item').removeClass('stripe');
		$j('#rule_list .item:odd').addClass('stripe');
	};

	/**
	 * Runs the user's rules
	 * @param {boolean=} really if not true, will pop a binary box asking for confirmation
	 */
	this.runRules = function(really) {
		var page = this;
		if (!really) {
			sa.confirm({
				text : 'Are you sure you want to run your rules?<br/><b>This will override any manually entered information and is NOT undoable.</b>',
				yesFunction : function() {
					return page.runRules(true);
				},
				yesText : 'Run'
			});
			return;
		}
		// time to really run it
		var cover,
			progressCheckId = new Date().getTime(),
			stopProgressUpdate = function() {
				progressCheckId = false;
			},
			// function that will begin the progess updating process
			startProgressUpdate = function() {
				var progressContainer = cover.find('.message'),
					checkSpeed = 5,
					getProgress = function() {
						ajax('p=rules&action=progress&progressCheckId=' + progressCheckId, function(response) {
							var rule = response[0]['rule'],
								totalRules = response[0]['totalRules'],
								tracks = response[0].tracks;
							progressContainer.html('Running rule ' + rule + ' of ' + totalRules + '.<br/>Processed ' + tracks.numberFormat() + ' matches.');
						});
					},
					interval = setInterval(function() {
						if (!progressCheckId) {
							clearInterval(interval);
							return;
						}
						getProgress();
					}, checkSpeed * 1000);
				// set up a progress bar
				setTimeout(function() { getProgress(); }, 1000);
			};
		// ok, NOW it's time to really run it
		ajax('action=run', function(response) {
			response = response[0];
			cover.remove();
			stopProgressUpdate();
			if (response.result) {
				sa.notify({ text : createText(response.result) });
			} else {
				sa.notify({ text : createText('Run successful! Check rule listings for results'), type : sa.notify.notificationTypes.success });
				for (var i = 0, len = response.rules.length; i < len; i++) {
					var rule = response.rules[i];
					$j('#rule_' + rule.id + ' #results').html('Affected tracks: ' + rule['affected_tracks']);
				}
			}
		}, 'POST', 'p=rules&action=run&progressCheckId=' + progressCheckId);
		cover = $j('<div id="loader_element" class="stretched"><div class="img"></div><span class="message">Running rules...</span><div class="background stretched"></div></div>');
		$j('#rule_list').append(cover);
		startProgressUpdate();
	};
}
/**
 * The page in the admin panel that lets you manipulate your visible music suppliers if you're a licensee site
 */
function AdminMusicSuppliers() {

	var page = this;
	var templates;
	var container;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} cont
	 */
	this.show = function(params, cont) {
		container = cont;
		if (!user.hasAdminPermission(AdminPermission.MusicSuppliers)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "Manage Music Suppliers" permission.</h3>');
		} else if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		if (!templates) {
			templates = sa.templates.get('admin.music_suppliers');
		}
		container.empty().append(templates.get('page'));
		loadMusicSuppliers();
	};

	/**
	 * Loads a featured list from the server
	 */
	function loadMusicSuppliers() {
		sa.api.request({
			handler : 'licenseeSyndication',
			action : 'listMusicSuppliers'
		}).then(response => {
			setMusicSuppliers(response);
		});
	}

	/**
	 * Displays a list of all the music suppliers
	 * @param {json} response the server's list of music suppliers
	 */
	function setMusicSuppliers(response) {
		var list = container.find('.seller_list').empty(),
			types = [],
			musicSuppliers = response.musicSuppliers,
			visible = response.visible;
		for (var i = 0, len = musicSuppliers.length; i < len; i++) {
			var site = musicSuppliers[i],
				cont = $j(
					'<div class="seller buyer_seller">'
						+ (site.companyLogo ?
							'<div class="left">'
								+ '<img src="' + site.companyLogo + '"/>'
							+ '</div>' : '')
						+ '<div class="seller_expander button list_labels"><span class="icon"><span class="fa fa-chevron-down closed"></span><span class="fa fa-chevron-up open"></span></span>List Labels</div>'
						+ '<div class="seller_expander button show_sample"><span class="icon"><span class="fa fa-chevron-down closed"></span><span class="fa fa-chevron-up open"></span></span>Sample Tracks</div>'
						+ '<div class="right' + (site.companyLogo ? '' : ' no-logo') + '">'
							+ '<h2>' + site.name + '</h2>'
							+ '<div class="stats">' + site.trackCount.numberFormat() + ' tracks<span class="dot_span">&#8226;</span>Joined ' + formatDate('F d, Y', site.launchDate) + '</div>'
							+ (site.contactName || site.contactEmail || site.contactName ? '<div class="company_type"><b>Company Type:</b> ' + site.companyType + '<span class="dot_span">&#8226;</span><b>Main Contact:</b> '
								+ site.contactName + ' - <a href="mailto:' + site.contactEmail + '">' + site.contactEmail + '</a></div>' : '')
							+ '<p class="description">' + site.companyDescription + '</p>'
						+ '</div>'
						+ '<div class="clr"></div>'
						+ '<div class="status"></div>'
						+ '<div class="clr"></div>'
						+ '<div class="sample expanding empty">Loading Samples</div>'
						+ '<div class="labels expanding"></div>'
					+ '</div>'
				).data('musicSupplier', site),
				labelContainer = cont.find('.labels');
			if (site.companyType && types.indexOf(site.companyType) == -1) {
				types.push(site.companyType);
			}
			// status button
			addSyndicationButton(site.id, site.subscriptionStatus, cont);
			// add the labels
			for (var j = 0, jLen = site.labels.length; j < jLen; j++) {
				var lab = site.labels[j],
					labelLabel = $j('<label><input type="checkbox" value="' + lab.id + '"' + (lab.onsite ? ' checked="checked"' : '') + '/> ' + lab.name + ' (' + lab.trackCount.numberFormat() + ' tracks)</label>');
				labelContainer.append(labelLabel);
			}
			// add a save button
			updateSubscriptionStatus(site.id, site.subscriptionStatus, cont);
			// make the container expandable
			(function(site, cont, labelContainer) {
				var showingLabels = false,
					showingSample = false,
					sampleContainer = cont.find('.sample');
				cont.find('.list_labels').on('click', function() {
					if (!showingLabels) {
						labelContainer.stop(true).slideDown();
						sampleContainer.stop(true).slideUp();
						showingSample = false;
					} else {
						labelContainer.stop(true).slideUp();
					}
					$j(this).toggleClass('open');
					showingLabels = !showingLabels;
				});
				cont.find('.show_sample').on('click', function() {
					if (!showingSample) {
						if (sampleContainer.hasClass('empty')) {
							sampleContainer.removeClass('empty').empty();

							var conf = new TrackListConfig();
							conf.allowBlock = false;
							conf.allowList = true;
							conf.allowMiniBlock = false;
							conf.bankkey = 'sample_' + site.id;
							conf.callbackActual = conf.callback = function(response) { trackList.setData(response, getTrackLink); };
							conf.addColumnList([
								new ListColumn('title', ['play', 'title']),
								new ListColumn('music_supplier', ['music_supplier_avatar', 'music_supplier']),
								new ListColumn('album', ['album']),
								new ListColumn('length', ['length']),
								new ListColumn('description', ['description'])
							]);
							conf.defaultResultsPerPage = 5;
							conf.getDefaultView = function() { return ListViewType.List; };
							conf.headerBackground = false;
							conf.pagination = false;
							conf.resultCountChanging = false;
							conf.resultsPerPageCookie = false;
							conf.selectable = false;
							conf.sortable = false;
							conf.viewCookie = false;
							var trackList = createTrackList(conf);
							trackList.view = ListViewType.List;
							sampleContainer.append('<div id="track_list_' + conf.bankKey + '" class="track_list"></div>');
							trackList.generatePage(sampleContainer.find('.track_list'));
							trackList.loadPage('sample=' + site.id + '&show=5');
						}
						sampleContainer.stop(true).slideDown();
						labelContainer.stop(true).slideUp();
						showingLabels = false;
					} else {
						sampleContainer.stop(true).slideUp();
					}
					$j(this).toggleClass('open');
					showingSample = !showingSample;
				});
			})(site, cont, labelContainer);
			// done!
			list.append(cont);
		}
		// make the filters work
		types.sort();
		$j('.filter#type select').empty().html('<option>All</option><option>' + types.join('</option><option>') + '</option>');
		$j('.filter select, .filter input').on('change', function() { filterMusicSuppliers(); }).on('keyup', function() { filterMusicSuppliers(); });
		// visibility toggle
		if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			var visibleCheck = $j('.syndication_visibility input');
			// set up default visibility check box
			if (visible) {
				visibleCheck.prop('checked', true);
			} else {
				visibleCheck.prop('checked', false);
			}
			visibleCheck.on('click', function() {
				sa.api.request({
					handler : 'licenseeSyndication',
					action : 'setLicenseeVisibility',
					postData : {
						visible : visibleCheck.filter(':checked').length
					}
				});
			});
			$j('.syndication_visibility').show();
		} else {
			$j('.syndication_visibility').remove();
		}
	}

	function addSyndicationButton(siteId, subscriptionStatus, cont) {
		var status = cont.find('.status').empty(),
			action = '',
			clickMessage = '';
		if (subscriptionStatus.status == 'i') {
			status.append('<a class="button">+ Connect</a>');
			action = 'subscribe';
			clickMessage = 'Connecting...';
		} else if (subscriptionStatus.status == 'v' || subscriptionStatus.status == 'n') {
			status.append('<a class="button request_button">+ Request Access</a>');
			action = 'request';
			clickMessage = 'Requesting...';
		} else if (subscriptionStatus.status == 'r') {
			status.append('<span class="description"><span class="icon fa fa-clock-o"></span>'
				+ 'Requested on ' + formatDate('F d, Y', subscriptionStatus.date) + '</span><a class="unsubscribe faux_button"><span class="icon fa fa-times"></span>Cancel</a>');
			action = 'cancelMusicSupplierRequest';
			clickMessage = 'Cancelling request...';
		} else {
			status.append('<span class="description"><span class="icon fa fa-ok-sign"></span>'
				+ 'Connected on ' + formatDate('F d, Y', subscriptionStatus.date) + '</span><a class="unsubscribe faux_button"><span class="icon fa fa-times"></span>Cancel</a>');
			action = 'cancelMusicSupplierSubscription';
			clickMessage = 'Cancelling connection...';
		}
		status.find('a').on('click', function() {
			status.html(clickMessage);

			sa.api.request({
				handler : 'licenseeSyndication',
				action : action,
				postData : {
					siteId : siteId
				}
			}).then(response => {
				addSyndicationButton(siteId, response.syndication, cont);
				updateSubscriptionStatus(siteId, response.syndication, cont, true);
			}).catch(err => {
				sa.notify(({ text : err.message }));
			});
			return false;
		});
	}

	function updateSubscriptionStatus(siteId, subscriptionStatus, cont, resetChecks) {
		var inputs = cont.find('input'),
			labels = cont.find('.labels');
		labels.find('.notice, .button').remove();
		if (subscriptionStatus.status == 'i') {
			// can't save until you sub
			inputs.prop('disabled', true).prop('checked', false);
			if (resetChecks) {
				inputs.prop('checked', false);
			}
			labels.append('<div class="notice">Please connect before changing labels</div>');
		} else {
			inputs.prop('disabled', false);
			if (resetChecks) {
				inputs.prop('checked', true);
			}
			labels.append('<a class="button">Save Changes</a>');
			labels.find('a').on('click', function() {
				// build a list of the selected inputs
				var checked = inputs.filter(':checked'),
					labelIds = [];
				if (!checked.length) {
					// if they didn't check anything
					cont.find('.unsubscribe').trigger('click');
					return;
				}
				for (var i = 0, len = checked.length; i < len; i++) {
					labelIds.push(checked[i].value);
				}

				sa.api.request({
					handler : 'licenseeSyndication',
					action : 'saveLabels',
					postData : {
						siteId : siteId,
						labelIds : labelIds
					}
				}).then(response => {
					addSyndicationButton(siteId, response.syndication, cont);
					updateSubscriptionStatus(siteId, response.syndication, cont);
					sa.notify({ text : 'Saved!', type : sa.notify.notificationTypes.success });
				}).catch(err => {
					sa.notify(({ text : err.message }));
				});
				return false;
			});
		}
	}

	function filterMusicSuppliers() {
		var type = $j('.filter#type select').val(),
			status = $j('.filter#status select').val(),
			search = $j('.filter#search input').val().toLowerCase(),
			sortVal = $j('.filter#sort select').val(),
			sort = sortVal == 'Date Joined' ? 'launchDate' : (sortVal == 'Track Count' ? 'trackCount' : 'name'),
			order = sort == 'name' ? -1 : 1,
			musicSuppliers = $j('.seller').show(),
			musicSuppliersList = $j('.seller_list');
		// add back all the music suppliers
		musicSuppliers.show();
		musicSuppliersList.find('.empty').remove();
		// now hide stuff
		for (var i = 0, len = musicSuppliers.length; i < len; i++) {
			var musicSupplier = $j(musicSuppliers[i]),
				musicSupplierData = musicSupplier.data('musicSupplier');
			if (type != 'All' && type != musicSupplierData.companyType) {
				musicSupplier.hide();
			} else if (search && musicSupplierData.name.toLowerCase().indexOf(search) == -1) {
				musicSupplier.hide();
			} else if ((status == 'Invited' && musicSupplierData.subscriptionStatus.status != 'i') || (status == 'Connected' && musicSupplierData.subscriptionStatus.status != 's')
					|| (status == 'Not Connected' && musicSupplierData.subscriptionStatus.status != 'i' && musicSupplierData.subscriptionStatus.status != 'n' && musicSupplierData.subscriptionStatus.status != 'v')) {
				musicSupplier.hide();
			}
		}
		// sorting!
		musicSuppliers.sort(function(musicSupplier1, musicSupplier2) {
			musicSupplier1 = $j(musicSupplier1).data('musicSupplier');
			musicSupplier2 = $j(musicSupplier2).data('musicSupplier');
			return musicSupplier1[sort] < musicSupplier2[sort] ? order : (musicSupplier1[sort] == musicSupplier2[sort] ? 0 : order * -1);
		});
		for (var i = 0, len = musicSuppliers.length; i < len; i++) {
			musicSuppliersList.append(musicSuppliers[i]);
		}
		// did we hide everything?
		if (!$j('.seller:visible').length) {
			musicSuppliersList.append('<div class="empty">No music suppliers match your filters.</div>');
		}
	}

	/**
	 * Shows all the catalogs
	 * @param {array} list list of catalog objects
	 */
	this.setCatalogs = function(list) {
		var catalogList = $j('#catalog_list').html('<h3 class="totals"></h3><div class="column"></div><div class="column"></div><div class="clr"></div>'),
			lastWhite = 0,
			cols = catalogList.find('.column'),
			columns = [$j(cols[0]), $j(cols[1])],
			labelCount = 0,
			trackCount = 0,
			labelContainer,
			whiteCount = 0,
			currentWhite = 0;
		// do a prepass so we can figure out how many white labels are represented so we can put them in columns
		for (var i  = 0, len = list.length; i < len; i++) {
			var item = list[i];
			if (item.whiteId != lastWhite) {
				whiteCount++;
				lastWhite = item.whiteId;
			}
		}
		// now do the real pass
		for (var i  = 0, len = list.length; i < len; i++) {
			var item = list[i];
			if (item.whiteId != lastWhite) {
				if (labelCount) {
					labelContainer.closest('.white_container').find('.label_count').html((labelCount + '').numberFormat() + ' label' + (labelCount == 1 ? '' : 's'));
				}
				if (trackCount) {
					labelContainer.closest('.white_container').find('.track_count').html((trackCount + '').numberFormat() + ' track' + (trackCount == 1 ? '' : 's'));
				}
				var whiteContainer = $j(
					'<div class="white_container">'
						+ '<div class="white">'
							+ '<div class="checkbox faux_button"></div>'
							+ '<div class="name">' + item.whiteName + '</div>'
							+ '<div class="details"><span class="track_count">0 tracks</span><br/><span class="label_count">0 labels</span>'
								+ '<a class="expander faux_button"><img src="images/explorer/nesting-expand.png"/></a></div>'
							+ '<div class="clr"></div>'
						+ '</div>'
						+ '<div class="label_container"><hr/><h5>Add or remove labels from this catalog:</h5></div>'
					+ '</div>');
				columns[currentWhite < whiteCount / 2 ? 0 : 1].append(whiteContainer);
				labelCount = 0;
				trackCount = 0;
				lastWhite = item.whiteId;
				currentWhite++;
				labelContainer = whiteContainer.find('.label_container');
			}
			labelContainer.append($j('<label class="label"><input type="checkbox" value="' + item.labelId + '"' + (item.onsite ? ' checked="checked"' : '') + '/> ' + item.label + '</label>').data('tracks', item.trackCount));
			labelCount++;
			trackCount += item.trackCount;
		}
		$j('.label_container').hide();
		// make the expanders expand
		$j('.expander').toggleClick(function() {
			$j(this).html('<img src="images/explorer/nesting-collapse.png"/>').closest('.white_container').find('.label_container').show();
			return false;
		}, function() {
			$j(this).html('<img src="images/explorer/nesting-expand.png"/>').closest('.white_container').find('.label_container').hide();
			return false;
		});
		// if you check a parent, check the children
		$j('.white .checkbox').on('click', function() {
			var t = $j(this);
			if (t.hasClass('checked')) t.removeClass('checked'); else t.addClass('checked');
			if (t.hasClass('checked')) {
				t.closest('.white_container').find('.label_container input').prop('checked', true);
			} else {
				t.closest('.white_container').find('.label_container input').prop('checked', false);
			}
			updateTotals();
		});
		// if you uncheck all the children, uncheck the parent
		$j('.label input').on('click', function() {
			var checkedInputs = $j(this).parent().parent().find('input:checked');
			if (checkedInputs.length == 0) {
				$j(this).closest('.white_container').find('.white .checkbox').removeClass('checked');
			} else {
				$j(this).closest('.white_container').find('.white .checkbox').addClass('checked');
			}
			updateTotals();
		});
		// hide the expanders if there's only one child
		for (var whites = $j('.white_container'), i = 0, len = whites.length; i < len; i++) {
			var white = $j(whites[i]);
			if (white.find('.label').length == 1) {
				white.find('.expander').hide();
			}
		}
		// check all the labels that should be checked
		for (var checked = $j('.label input:checked'), i = 0, len = checked.length; i < len; i++) {
			$j(checked[i]).closest('.white_container').find('.white .checkbox').addClass('checked');
		}
		// need to be able to show totals
		function updateTotals() {
			var labelChecks = $j('.label input:checked'),
				trackCount = 0,
				catalogCount = $j('.white .checkbox.checked').length;
			for (var i = 0, len = labelChecks.length; i < len; i++) {
				trackCount += $j(labelChecks[i]).parent().data('tracks');
			}
			$j('.tab_catalogs .totals').html('Your workspace totals: ' + (catalogCount + '').numberFormat() + ' music supplier' + (catalogCount == 1 ? '' : 's') + ' / '
				+ (trackCount + '').numberFormat() + ' track' + (trackCount == 1 ? '' : 's'));
		}
		// save button
		catalogList.append('<h3 class="totals"></h3>').append(createButton('Save Suppliers', 'save_catalogs', '', '#0', function() {
			var checks = $j('.label input:checked'),
				labelIdString = 'labelIds[]=';
			for (var i = 0, len = checks.length; i < len; i++) {
				labelIdString += checks[i].value + '&labelIds[]=';
			}
			sa.scrollToPosition(0);
			catalogList.html('');
			showLoader(catalogList[0], 'Saving... This may take a minute. Please be patient.');
			ajax(labelIdString, function(response) {
				sa.notify({ text : (response[0].result == 'success') ? 'Changes saved! It may take a few minutes for all tracks to become available.' : response[0].message });
				page.loadCatalogs();
			}, 'POST', 'p=licensee_labels&action=save');
			return false;
		}));
		updateTotals();
	};
}
/**
 * The page in the admin panel that lets you manipulate your site's settings
 */
function AdminPremiere() {
	/**
	 * {string} the name of the tab we're showing
	 */
	this.currentTab = '';
	this.latestParams = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Users)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Manage Users' + '" permission.</h3>');
		}
		if (!config.isPremiere) return;
		if (!$j('.right_body .metadata').length) {
			var page = this,
				callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [
			        new RightTab('batch', '/admin?p=premiere&tab=batch', 'Batch Import', callback),
			        new RightTab('add', '/admin?p=premiere&tab=add', 'Add User', callback),
			        new RightTab('edit', '/admin?p=premiere&tab=edit', 'Edit User', callback),
			        new RightTab('codes', '/admin?p=premiere&tab=codes', 'Manage Show Codes', callback)
				];
			RightTabbedPage.prototype.show.call(this, 'premiere', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		this.latestParams = params;
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'batch';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (this.currentTab == pageId) {
			//this.currentPage.show(sa.router.getCurrentParams());
			return;
		}
		this.currentTab = pageId;
		// and then if we found it, have it load based on the current params
		if (pageId == 'batch') {
			(new AdminPremiereImport()).show(this.latestParams, container);
		} else if (pageId == 'add') {
			(new AdminPremiereAdd()).show(this.latestParams, container);
		} else if (pageId == 'edit') {
			(new AdminPremiereEdit()).show(this.latestParams, container);
		} else if (pageId == 'codes') {
			(new AdminPremiereShowCodes()).show(this.latestParams, container);
		}
	};
}
AdminPremiere.prototype = new RightTabbedPage();

/**
 * The page in the admin panel that lets premiere import their custom user spreadsheet
 */
function AdminPremiereImport() {

	var progressCheckId,
		page = this;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var vars = sa.router.paramsToVars(params);
		container.html('<div class="data_importing"></div>');
		if (vars.importId && vars.action == 'mapping') {
			this.loadMappings(vars.importId);
		//} else if (vars.importId && vars.action == 'columns') {
		//	this.loadColumns(vars.importId);
		} else if (vars.importId && vars.action == 'test') {
			this.startTestRun(vars.importId);
		} else {
			container.find('.data_importing').html(
				'<div class="admin_left_list">'
					+ '<h4>Previous Imports</h4>'
					+ '<div class="header">'
						+ '<div class="filename">Filename</div>'
						+ '<div class="date">Date Uploaded</div>'
						+ '<span class="clr"></span>'
					+ '</div>'
				+ '</div>'
				+ '<div class="admin_right import_container">'
					+ '<h4>Import New File</h4>'
					+ '<input type="text" id="file_upload_input" value="Browse to select a CSV file for import"/>'
					+ '<div class="clr" id="removeme"></div>'
				+ '</div>'
				+ '<div class="clr"></div>');

			// disable any keypresses in the browse box
			container.find('input').on('keydown', function() { return false; }).on('focus', function() { this.blur(); });
			// make a button for the user to click
			var button = createButton('Browse', 'import_tracks', '', getDefaultLink());
			container.find('#removeme').before(button);
			// set up the uploader object that will actually do the uploading
			new Uploader({ button : button, browseCallback : function(uploader) { page.handleBrowseResponse(uploader); }, fileType : UploaderConstants.CSV });
			ajax('p=premiere_import&action=list', function(response) {
				page.showList(response);
			});
		}
	};

	/**
	 * Shows the list of previously imported files loaded from the server
	 */
	this.showList = function(response) {
		let baseUrl = siteBaseUrl();
		var list = $j('.admin_left_list');
		list.find('.item').remove();
		if (!response.length) {
			list.append('<div class="item empty">No previous imports</div>');
			return;
		}
		for (var i = 0, len = response.length; i < len; i++) {
			var item = response[i];
			list.append(
				'<div class="item' + (i % 2 == 1 ? ' stripe' : '') + '">'
					+ '<div class="filename"><a href="https://' + config.domain + '/export.php?type=premiereImportData&importId=' + item.id + '">'
						+ item.filename + '</a></div>'
					+ '<div class="date">' + formatDate(config.dateTimeFormatString, item.date) + '</div>'
					+ '<div class="run"><a href="'+siteBaseUrl()+'/admin?p=premiere&tab=batch&importId=' + item.id + '&action=mapping"><img class="faux_button" src="' + baseUrl + '/images/buttons/refresh.png" title="Re-import this data"/></a></div>'
					+ '<div class="delete"><a class="faux_button"><img class="faux_button" src="' + baseUrl + '/images/shared/delete.png" title="Delete this data"/></a></div>'
					+ '<span class="clr"></span>'
				+ '</div>');
			list.find('a:last').on('click', function(item) { return function() {
				ajax('p=premiere_import&importId=' + item.id + '&action=delete', function() {
					sa.notify({ text : 'Import deleted!' });
					ajax('p=premiere_import&action=list', function(response) {
						page.showList(response);
					});
				});
				return false;
			}; }(item));
		}
	};

	/**
	 * Updates the display after you've browsed for an file
	 * @param {Uploader} uploader the flash objecct doing the uploading
	 */
	this.handleBrowseResponse = function(uploader) {
		var f = uploader.getFiles(),
			cont = $j('.import_container');
		$j('#file_upload_save, #file_save_message').remove();
		if (!f || !f.length || f.length != 1) {
			f = 'Browse to change your file';
		} else {
			f = f[0];
			cont.find('#removeme').remove();
			cont.append(createButton('Upload', 'file_upload_save', '', getDefaultLink(),
				function() {
					$j('#file_upload_save').hide();
					$j('#file_save_message').css('display', 'block').html('Saving...').removeClass('error');
					uploader.upload({
						params : 't=premiere_import',
						complete : function() {
							sa.router.routeTo('/admin?p=premiere&tab=batch&action=mapping&importId=0');
						},
						error : function() {
							$j('#file_upload_save').show();
							$j('#file_save_message').css('display', 'block').html('Error uploading. Please try again').addClass('error');
						}
					});
					return false;
				}))
				.append(createDiv('file_save_message'));
		}
		//console.log('f is ' + f);
		get('file_upload_input').value = f;
	};

	/*this.loadColumns = function(importId) {
		ajax('p=premiere_import&action=columns&importId=' + importId, function(data) {
			data = data[0];
			var container = $j('.data_importing').html(
				'<div class="section">'
					+ '<h2>Choose columns for your import</h2>'
					+ '<div class="column_list">'
						+ '<div class="header">'
							+ '<div class="code">Column</div>'
							+ '<div class="original">Column Title</div>'
							+ '<div class="example">Example</div>'
							+ '<div class="enabled">Import?</div>'
							+ '<div class="mapping">Corresponding Site Field</div>'
							+ '<span class="clr"></span>'
						+ '</div>'
					+ '</div>'
				+ '</div>'),
				list = container.find('.column_list'),
				fieldList = '';
			for (var i = 0, len = data.validFields.length; i < len; i++) {
				var field = data.validFields[i];
				fieldList += '<option value="' + field + '">' + field + '</option>';
			}
			for (var i = 0, len = data.fields.length; i < len; i++) {
				var field = data.fields[i],
					column = field.column,
					enabled = field.type != 'unknown';
				list.append(
					'<div class="column' + (i % 2 == 1 ? ' stripe' : '') + '">'
						+ '<div class="code">' + (column > 25 ? String.fromCharCode(Math.floor(column / 25) + 64) : '') + String.fromCharCode(column % 26 + 65) + '</div>'
						+ '<div class="original">' + field.originalName.replace('<', '&lt;').replace('>', '&gt;') + '</div>'
						+ '<div class="example">' + field.example.replace('<', '&lt;').replace('>', '&gt;') + '</div>'
						+ '<div class="enabled"><input type="checkbox" title="Check to enable importing this field"' + (enabled ? ' checked="checked"' : '') + '/></div>'
						+ '<div class="mapping"><select name="' + column + '"' + (!enabled ? ' disabled="disabled"' : '') + '>'
							+ fieldList.replace('"' + field.name + '"', '"' + field.name + '" selected="selected"') + '</select></div>'
						+ '<span class="clr"></span>'
					+ '</div>'
				);
			}
			list.append('<span class="clr"></span>');
			list.find('input').on('change', function() {
				if (this.checked) {
					$j(this).parent().parent().find('select').prop('disabled', false);
				} else {
					$j(this).parent().parent().find('select').prop('disabled', true);
				}
			});
			container.append('<div class="error"></div>');
			container.append(createButton('Save and Map Show Codes', 'save_button', '', getDefaultLink(), function() {
				// validate the info before we save
				var fieldVals = container.find('select:enabled'),
					error = container.find('.error'),
					usedFields = [],
					fieldString = '';
				for (var i = 0, len = fieldVals.length; i < len; i++) {
					var fieldVal = fieldVals[i],
						value = $j(fieldVal).val(),
						column = fieldVal.name;
					if (usedFields.indexOf(value) != -1) {
						error.html('You may only select each field once and you have two of "' + value + '"');
						return;
					}
					usedFields.push(value);
					fieldString += '&fields[' + column + ']=' + encodeURIComponent(value);
				}
				error.html('');
				ajax(fieldString, function(response) {
					if (response[0].result != 'success') {
						error.html(response[0].result);
					} else {
						sa.router.routeTo('/admin?p=premiere&tab=mapping&importId=' + data.importId);
					}
				}, 'POST', 'p=premiere_import&action=saveFields&importId=' + data.importId);
			}));
		});
	};*/

	/**
	 * Loads the details for the last file uploaded (presumably from this page)
	 */
	this.loadMappings = function(importId) {
		ajax('p=premiere_import&action=mapping&importId=' + importId, function(newData) {
			showShowCodeMapper(newData[0], { container : $j('.data_importing'), saveText : 'Save and Do Test Run', saveFunction : function(mapString) {
				ajax(mapString, function(response) {
					if (response[0].result != 'success') {
						$j('.data_importing').find('.error').html(response[0].result);
					} else {
						sa.router.routeTo('/admin?p=premiere&tab=batch&importId=' + newData[0].importId + '&action=test');
					}
				}, 'POST', 'p=premiere_import&action=saveMapping&importId=' + newData[0].importId);
			} } );
		});
	};

	/**
	 * Initiates a test run of the given import
	 * @param {int} importId the
	 */
	this.startTestRun = function(importId) {
		var container = $j('.data_importing').html(''),
			startTime = new Date().getTime();
		progressCheckId = new Date().getTime();
		showLoader(container[0], 'Performing test run...');
		ajax('p=premiere_import&action=test&importId=' + importId + '&progressCheckId=' + progressCheckId, function(results) {
			page.showRunResults(results, importId, true);
			page.stopProgressUpdate();
			console.log('Test run ran in ' + ((new Date().getTime() - startTime) / 1000));
		});
		this.startProgressUpdate();
	};

	/**
	 * Starts an interval that checks on progress of the current import job
	 */
	this.startProgressUpdate = function() {
		var fillBar = $j('.data_importing').append('<div class="progress"><div class="fill_bar"></div><span class="progress_numbers"></div></div>').find('.fill_bar'),
			progressContainer =  $j('.data_importing .progress_numbers'),
			lastCurrent = 0,
			checkSpeed = 5,
			getProgress = function() {
				ajax('p=premiere_import&action=progress&progressCheckId=' + progressCheckId, function(response) {
					var current = response[0].current,
						total = response[0].total;
					if (current == -1) {
						progressContainer.html('Preparing data...');
					} else {
						progressContainer.html(current + ' / ' + total);
						fillBar.css({ width : current / total * 100 + '%' });
						window['lastPerSecond'] = (current - lastCurrent) / checkSpeed;
						lastCurrent = current;
					}
				});
			},
			interval = setInterval(function() {
				if (!progressCheckId) {
					clearInterval(interval);
					return;
				}
				getProgress();
			}, checkSpeed * 1000);
		// set up a progress bar
		setTimeout(function() { getProgress(); }, 1000);
	};

	/**
	 * Stops the interval started by startProgressUpdate
	 */
	this.stopProgressUpdate = function() {
		progressCheckId = false;
	};

	/**
	 * Shows the results of a run, be a test or the real deal
	 * @param {json} results the results from the run
	 * @param {int} importId the id of the import the run was on
	 * @param {boolean} testRun was this a test?
	 */
	this.showRunResults = function(results, importId, testRun) {
		let baseUrl = siteBaseUrl();
		if (results[0].result) {
			sa.notify({ text : results[0].result });
			sa.router.routeTo('/admin?p=premiere&tab=batch&importId' + importId + '&action=mapping');
			return;
		}
		var container = $j('.data_importing');
		container.html(
			'<div class="section">'
				+ '<h2>Results from your ' + (testRun ? 'test ' : '') + 'import:</h2>'
				+ (results[0].matched.length ? '<div class="section test_results_container" id="matched_rows">'
					+ '<h3>Found existing users for <b>' + results[0].matched.length + '</b> rows <a href="' + getDefaultLink() + '">show/hide list</a></h3>'
					+ (testRun ? '<sub>This is a good thing! All the users listed here are already on the system.</sub>'
							: '<sub>These users were all updated!</sub>')
					+ '<div class="hiding column_list"><div class="header"><div class="row">Row #</div><div class="track">Username</div><span class="clr"></span></div></div>'
				+ '</div>' : '')
				+ (results[0].unmatched.length ? '<div class="section test_results_container" id="unmatched_rows">'
					+ '<h3>Will create <b>' + results[0].unmatched.length + '</b> new users <a href="' + getDefaultLink() + '">show/hide list</a></h3>'
					+ (testRun ? '<sub>They just weren\'t in the system yet but we can create them.</sub>'
							: '<sub>These users were all created!</sub>')
					+ '<div class="hiding column_list"><div class="header"><div class="row">Row #</div><div class="track">Username</div><span class="clr"></span></div></div>'
				+ '</div>' : '')
			+ '</div>'
		);
		for (var section in results[0]) {
			if (!results[0].hasOwnProperty(section)) continue;
			var res = results[0][section],
				cont = container.find('#' + section + '_rows .column_list');
			for (var i = 0, len = res.length; i < len; i++) {
				var match = res[i];
				cont.append(
					'<div class="match' + (i % 2 == 1 ? ' stripe' : '') + '">'
						+ '<div class="row">' + match.row + '</div>'
						+ '<div class="track">' + match.username + '</div>'
						+ '<span class="clr"></span>'
					+ '</div>');
			}
			cont.append('<span class="clr"></span>');
		}
		container.find('.section h3 > a').on('click', function() {
			var cont = $j(this).parent().parent().find('div');
			if (cont.hasClass('hiding')) {
				cont.removeClass('hiding');
				cont.stop().slideDown(500, 'linear');
			} else {
				cont.addClass('hiding');
				cont.stop().slideUp(500, 'linear');
			}
		});
		if (testRun) {
			container.append(createButton('Begin Import', 'begin_import', '', getDefaultLink(), function(e) {
				sa.confirm({
					text : 'This will permanently update the data for your users.<br/><br/>'
						+ 'Once you\'re confident everything looks right, press the "Import" button below. The process may take some time but please don\'t leave the page.',
					yesFunction : function() {
						progressCheckId = new Date().getTime();
						ajax('import=1&secureToken=' + user.secureToken,
							function(response) {
								page.showRunResults(response, importId, false);
								page.stopProgressUpdate();
							}, 'POST', 'p=premiere_import&importId=' + importId + '&action=import&progressCheckId=' + progressCheckId);
						container.html('');
						showLoader(container[0], 'Importing your CSV. Please be patient...');
						page.startProgressUpdate();
					},
					yesText : 'Import'
				});
				e.preventDefault();
				return false;
			}));
		} else {
			container.append('<div id="notice"><img src="' + baseUrl + '/images/licensing/thank-you-check.png"/>Data imported! It may take a few minutes before your updated music access filters are done processing.</div>');
		}
	};

}

/**
 * Shows the mappings and lets the user determine their accuracy
 * @param {object} data the data from calling p=premiere_import&action=mapping
 * @param {object} params
 * 	{JQuery} container the container
 *  {string} saveText what the save button should say
 *  {string} saveFunction what to pass the urlencoded map string to when the user saves
 */
function showShowCodeMapper(data, params) {
	var showCodes = data.showCodes,
		hierarchy = data.hierarchy,
		mappings = data.mappings,
		playMappings = data.playMappings,
		container = params.container.html(
				'<div class="section">'
				+ '<h2>Show code mappings' + (data.filename ? ' for ' + data.filename : '') + '</h2>'
				+ '<div class="new_codes"></div>'
				+ 'Select a show code to change its permissions: <select class="show_codes"></select>'
				+ '<div class="show_code_selector"></div>'
			+ '</div>'),
		select = container.find('select'),
		newCodeContainer = container.find('.new_codes'),
		showCodeSelector = container.find('.show_code_selector');
	// figure out what codes are new (aren't in the mappings)
	var newCodes = [];
	for (var i = 0, len = showCodes.length; i < len; i++) {
		var code = showCodes[i];
		if (!mappings[code] && !playMappings[code]) {
			newCodes.push(code);
		}
	}
	if (newCodes.length) {
		newCodes.sort();
		newCodeContainer.html('<hr/><b>New show codes:</b> ' + newCodes.join(', ') + '<hr/>');
	} else {
		newCodeContainer.hide();
	}

	// add all the codes to the select
	select.html('<option>---</option><option>' + showCodes.join('</option><option>') + '</option>');

	// make changing the select show the mapper
	select.on('change', function() {
		var currentShowCode = select.val(),
			addLabel = function(labelId, type) {
				labelId = parseInt(labelId);
				var map = type == 'play' ? playMappings : mappings;
				if (map[currentShowCode].indexOf(labelId) == -1) {
					map[currentShowCode].push(labelId);
				}
				labels.find('input[value=' + labelId + '][name=' + type + ']').prop('checked', true);
				if (type == 'download') {
					var index = playMappings[currentShowCode].indexOf(labelId);
					if (index == -1) {
						playMappings[currentShowCode].push(labelId);
					}
					labels.find('input[value=' + labelId + '][name=play]').prop('checked', true);
				}
			},
			removeLabel = function(labelId, type) {
				labelId = parseInt(labelId);
				var map = type == 'play' ? playMappings : mappings,
					index = map[currentShowCode].indexOf(labelId);
				if (index != -1) {
					map[currentShowCode].splice(index, 1);
				}
				labels.find('input[value=' + labelId + '][name=' + type + ']').prop('checked', false);
				if (type == 'play') {
					index = mappings[currentShowCode].indexOf(labelId);
					if (index != -1) {
						mappings[currentShowCode].splice(index, 1);
					}
					labels.find('input[value=' + labelId + '][name=download]').prop('checked', false);
				}
			},
			addCatalog = function(catalog, type) {
				for (var i = 0, len = catalog.labels.length; i < len; i++) {
					addLabel(catalog.labels[i].id, type);
				}
				catalogs.find('input[value=' + catalog.id + '][name=' + type + ']').prop('checked', true);
			},
			removeCatalog = function(catalog, type) {
				for (var i = 0, len = catalog.labels.length; i < len; i++) {
					removeLabel(catalog.labels[i].id, type);
				}
				catalogs.find('input[value=' + catalog.id + '][name=' + type + ']').prop('checked', false);
			},
			addWhite = function(white, type) {
				for (var i = 0, len = white.catalogs.length; i < len; i++) {
					addCatalog(white.catalogs[i], type);
				}
				whites.find('input[value=' + white.id + '][name=' + type + ']').prop('checked', true);
			},
			removeWhite = function(white, type) {
				for (var i = 0, len = white.catalogs.length; i < len; i++) {
					removeCatalog(white.catalogs[i], type);
				}
				whites.find('input[value=' + white.id + '][name=' + type + ']').prop('checked', false);
			},
			recheck = function() {
				// updates check status for everything that's visible
				for (var w = 0, wLen = hierarchy.length; w < wLen; w++) {
					var white = hierarchy[w],
						totalWhiteCatalogs = 0,
						totalWhiteLabels = 0,
						checkedWhiteCatalogsDownload = 0,
						checkedWhiteLabelsDownload = 0,
						checkedWhiteCatalogsPlay = 0,
						checkedWhiteLabelsPlay = 0;
					for (var c = 0, cLen = white.catalogs.length; c < cLen; c++) {
						var catalog = white.catalogs[c],
							totalCatalogLabels = 0,
							checkedCatalogLabelsDownload = 0,
							checkedCatalogLabelsPlay = 0,
							isCatalogCheckedDownload = false,
							isCatalogCheckedPlay = false;
						totalWhiteCatalogs++;
						for (var l = 0, lLen = catalog.labels.length; l < lLen; l++) {
							var lab = catalog.labels[l];
							totalWhiteLabels++;
							totalCatalogLabels++;
							if (mappings[currentShowCode].indexOf(lab.id) != -1) {
								isCatalogCheckedDownload = true;
								checkedWhiteLabelsDownload++;
								checkedCatalogLabelsDownload++;
							}
							if (playMappings[currentShowCode].indexOf(lab.id) != -1) {
								isCatalogCheckedPlay = true;
								checkedWhiteLabelsPlay++;
								checkedCatalogLabelsPlay++;
							}
						}
						if (isCatalogCheckedDownload) {
							checkedWhiteCatalogsDownload++;
						}
						if (isCatalogCheckedPlay) {
							checkedWhiteCatalogsPlay++;
						}
						// now we know the stats for the catalog
						var cat = $j('.catalogs input[value=' + catalog.id + '][name=download]');
						cat.parent().find('span').html('(' + checkedCatalogLabelsDownload + '/' + totalCatalogLabels + ')');
						if (checkedCatalogLabelsDownload) {
							cat.prop('checked', true);
						} else {
							cat.prop('checked', false);
						}
						cat = $j('.catalogs input[value=' + catalog.id + '][name=play]');
						cat.parent().find('span').html('(' + checkedCatalogLabelsPlay + '/' + totalCatalogLabels + ')');
						if (checkedCatalogLabelsPlay) {
							cat.prop('checked', true);
						} else {
							cat.prop('checked', false);
						}
					}
					// now we know the stats for the white
					var wit = $j('.whites input[value=' + white.id + '][name=download]');
					wit.parent().find('span').html('(' + checkedWhiteCatalogsDownload + '/' + totalWhiteCatalogs + ') (' + checkedWhiteLabelsDownload + '/' + totalWhiteLabels + ')');
					if (checkedWhiteCatalogsDownload) {
						wit.prop('checked', true);
					} else {
						wit.prop('checked', false);
					}
					wit = $j('.whites input[value=' + white.id + '][name=play]');
					wit.parent().find('span').html('(' + checkedWhiteCatalogsPlay + '/' + totalWhiteCatalogs + ') (' + checkedWhiteLabelsPlay + '/' + totalWhiteLabels + ')');
					if (checkedWhiteCatalogsPlay) {
						wit.prop('checked', true);
					} else {
						wit.prop('checked', false);
					}
				}
			};
		if (currentShowCode == '---') {
			showCodeSelector.html('');
			return;
		}
		if (!mappings[currentShowCode]) {
			mappings[currentShowCode] = [];
		}
		if (!playMappings[currentShowCode]) {
			playMappings[currentShowCode] = [];
		}
		showCodeSelector.html(
			'<div class="column_editor clr">'
			+ '<div>Check the labels <b>' + currentShowCode + '</b> should have access to:</div>'
			+ '<div class="selector whites">'
				+ '<h3>Sites</h3>'
				+ '<ul></ul>'
			+ '</div>'
			+ '<div class="selector catalogs">'
				+ '<h3>Catalogs</h3>'
				+ '<ul></ul>'
			+ '</div>'
			+ '<div class="selector labels">'
				+ '<h3>Labels</h3>'
				+ '<ul></ul>'
			+ '</div>'
			+ '<div class="clr"></div>'
		);
		var whites = showCodeSelector.find('.whites ul'),
			catalogs = showCodeSelector.find('.catalogs ul'),
			labels = showCodeSelector.find('.labels ul');
		// add all the white labels
		for (var i = 0, len = hierarchy.length; i < len; i++) {
			var white = hierarchy[i],
				checkedSubCatalogsDownload = 0,
				checkedSubCatalogsPlay = 0;
			// see if this catalog should be checked
			for (var c = 0, cLen = white.catalogs.length; c < cLen; c++) {
				var catalog = white.catalogs[c];
				for (var l = 0, lLen = catalog.labels.length; l < lLen; l++) {
					if (mappings[currentShowCode].indexOf(catalog.labels[l].id) != -1) {
						checkedSubCatalogsDownload++;
					}
					if (playMappings[currentShowCode].indexOf(catalog.labels[l].id) != -1) {
						checkedSubCatalogsPlay++;
					}
				}
			}
			whites.append($j(
				'<li class="item">'
					+ '<h4>' + white.name + '</h4>'
					+ '<label><input type="checkbox" value="' + white.id + '"' + (checkedSubCatalogsPlay ? ' checked="checked"' : '') + ' name="play"/> Can View/Play <span></span></label>'
					+ '<label><input type="checkbox" value="' + white.id + '"' + (checkedSubCatalogsDownload ? ' checked="checked"' : '') + ' name="download"/> Can Download <span></span></label>'
					+ '<span class="fa fa-chevron-right expander"></span>'
				+ '</li>').data('white', white));
		}
		// make checking a white add it to the mappings
		whites.find('input').on('click', function() {
			var white = $j(this).parents('li').data('white'),
				type = this.name;
			if (this.checked) {
				addWhite(white, type);
			} else {
				removeWhite(white, type);
			}
			recheck();
		});
		// make checking a white show catalogs
		showCodeSelector.find('.whites .expander').on('click', function() {
			whites.find('.selected').removeClass('selected');
			var white = $j(this).parent().addClass('selected').data('white');
			catalogs.empty();
			for (var i = 0, len = white.catalogs.length; i < len; i++) {
				var catalog = white.catalogs[i],
					checkedSubLabelsDownload = 0,
					checkedSubLabelsPlay = 0;
				// see if this catalog should be checked
				for (var l = 0, lLen = catalog.labels.length; l < lLen; l++) {
					if (mappings[currentShowCode].indexOf(catalog.labels[l].id) != -1) {
						checkedSubLabelsDownload++;
					}
					if (playMappings[currentShowCode].indexOf(catalog.labels[l].id) != -1) {
						checkedSubLabelsPlay++;
					}
				}
				// add it
				catalogs.append($j(
					'<li class="item">'
						+ '<h4>' + catalog.name + '</h4>'
						+ '<label><input type="checkbox" value="' + catalog.id + '"' + (checkedSubLabelsPlay ? ' checked="checked"' : '') + ' name="play"/> Can View/Play <span></span></label>'
						+ '<label><input type="checkbox" value="' + catalog.id + '"' + (checkedSubLabelsDownload ? ' checked="checked"' : '') + ' name="download"/> Can Download <span></span></label>'
						+ '<span class="fa fa-chevron-right expander"></span>'
					+ '</li>').data('catalog', catalog));
			}
			// make checking a catalog add it to the mappings
			catalogs.find('input').on('click', function() {
				var catalog = $j(this).parents('li').data('catalog'),
					type = this.name;
				if (this.checked) {
					addCatalog(catalog, type);
				} else {
					removeCatalog(catalog, type);
				}
				recheck();
			});
			recheck();
			labels.empty();
			// make checking a catalog show labels
			catalogs.find('.expander').on('click', function() {
				catalogs.find('.selected').removeClass('selected');
				var catalog = $j(this).parent().addClass('selected').data('catalog');
				labels.empty();
				for (var i = 0, len = catalog.labels.length; i < len; i++) {
					var lab = catalog.labels[i];
					labels.append(
						'<li class="item">'
							+ '<h4>' + lab.name + '</h4>'
							+ '<label><input type="checkbox" value="' + lab.id + '"' + (playMappings[currentShowCode].indexOf(lab.id) != -1 ? ' checked="checked"' : '') + ' name="play"/> Can View/Play</label>'
							+ '<label><input type="checkbox" value="' + lab.id + '"' + (mappings[currentShowCode].indexOf(lab.id) != -1 ? ' checked="checked"' : '') + ' name="download"/> Can Download</label>'
						+ '</li>');
				}
				// make clicking a label add it to the mappings
				labels.find('input').on('click', function() {
					var type = this.name;
					if (this.checked) {
						addLabel(this.value, type);
					} else {
						removeLabel(this.value, type);
					}
					recheck();
				});
			});
		});
		recheck();
	});

	container.append('<div class="error"></div>');
	container.append(createButton(params.saveText, 'save_button', '', getDefaultLink(), function() {
		// validate the info before we save
		var mapString = '';
		for (var codeName in mappings) {
			if (!mappings.hasOwnProperty(codeName)) continue;
			for (var i = 0, len = mappings[codeName].length; i < len; i++) {
				mapString += '&mappings[' + encodeURIComponent(codeName) + '][]=' + mappings[codeName][i];
			}
		}
		for (var playCodeName in playMappings) {
			if (!playMappings.hasOwnProperty(playCodeName)) continue;
			for (var j = 0, jLen = playMappings[playCodeName].length; j < jLen; j++) {
				mapString += '&playMappings[' + encodeURIComponent(playCodeName) + '][]=' + playMappings[playCodeName][j];
			}
		}
		params.saveFunction(mapString.substring(1));
	}));
}

/**
 * The page in the admin panel that lets you create users
 */
function AdminPremiereAdd() {

	var page = this,
		cont;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		cont = container;
		container.html(
			'<div class="section" id="basics">'
				+ '<h2>Add a New User:</h2>'
				+ '<div class="section" id="station"><h4>Station:</h4> <input type="text" value=""/><div class="clr"></div></div>'
				+ '<div class="section" id="username"><h4>Username:</h4> <input type="text" value=""/><div class="clr"></div></div>'
				+ '<div class="section" id="password"><h4>Password:</h4> <input type="text" value=""/><div class="clr"></div></div>'
				+ '<div class="section" id="name"><h4>Name:</h4> <input type="text" value=""/><div class="clr"></div></div>'
				+ '<div class="section" id="showcodes"><h4>Showcodes:</h4> <select multiple="multiple"></select><div class="clr"></div></div>'
			+ '</div>'
			+ '<div class="information" id="errors"></div><div class="clr"></div>'
			+ '<a class="button">Create Account</a>');
		container.find('.button').on('click', function() {
			var station = $j('#station input').val().trim(),
				username = $j('#username input').val().trim(),
				password = $j('#password input').val().trim(),
				name = $j('#name input').val().trim(),
				showcodes = $j('#showcodes select').val(),
				errors = [];
			if (!station) {
				errors.push('Please enter a station.');
			}
			if (!username) {
				errors.push('Please enter a username.');
			}
			if (!password) {
				errors.push('Please enter a password.');
			}
			if (!name) {
				errors.push('Please enter a name.');
			}
			if (!showcodes.length) {
				errors.push('Please enter some showcodes.');
			}
			if (errors.length) {
				container.find('.information').html('Please correct the following issues before proceeding:<ul><li>' + errors.join('</li><li>') + '</li></ul>');
			} else {
				ajax('station=' + encodeURIComponent(station) + '&username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password)
						+ '&name=' + encodeURIComponent(name) + '&showcodes=' + encodeURIComponent(showcodes.join(',')), function(response) {
					if (response[0].result != 'success') {
						$j('.tabbed_body').find('.error').html(response[0].result);
					} else {
						sa.notify({ text : 'User created!', type : sa.notify.notificationTypes.success });
						page.show('', cont);
						container.find('.button').show();
						container.find('.information').html('');
					}
				}, 'POST', 'p=premiere_import&action=createUser');
				container.find('.button').hide();
				container.find('.information').html('Processing...');
			}
			return false;
		});
		ajax('p=premiere_import&action=listShowCodes', function(response) {
			var select = container.find('select');
			select.html('<option>' + response.join('</option><option>') + '</option>');
		});
	};
}

/**
 * The page in the admin panel that lets you create users
 */
function AdminPremiereEdit() {

	var page = this,
		cont;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		cont = container;
		var vars = sa.router.paramsToVars(params);
		if (vars.id) {
			showUser(vars.id, container);
		} else {
			showSearch(container);
		}
	};

	function showSearch(container) {
		container.html(
			'<div class="section" id="search">'
				+ '<h2>Find a User:</h2>'
				+ '<div class="section">'
					+ '<h4>user lookup:</h4><input type="text" value="" id="user_search"/><div class="clr"></div>'
				+ '</div>'
				+ '<div class="section" id="results">'
					+ '<h4>results:</h4>'
					+ '<div class="results">Enter some terms above to find results</div>'
					+ '<div class="clr"></div>'
				+ '</div>'
			+ '</div>');
		container.find('#user_search').on('keyup', function() {
			var val = this.value.trim();
			if (!val) {
				showMatchedUsers('');
			} else {
				showMatchedUsers(val);
			}
		}).trigger('keyup');
	}

	function showMatchedUsers(value) {
		ajax('p=premiere_import&action=findUser&fragment=' + encodeURIComponent(value), function(response) {
			var resultContainer = $j('#results .results').html('');
			if (!response.length) {
				resultContainer.html('No users matched');
			} else {
				for (var i = 0, users = response, len = users.length; i < len; i++) {
					var user = users[i],
						userContainer = $j('<a class="user faux_button" href="'+siteBaseUrl()+'/admin?p=premiere&tab=edit&id=' + user.id + '">' + user.name + (user.username ? ' - ' + user.username : '')
							+ '<span>' + user.email + '</span></a>');
					//userContainer.on('click', function(user) { return function() { page.setUser(user); }; }(user));
					resultContainer.append(userContainer);
				}
				resultContainer.append('<div>Showing ' + Math.min(users.length, 50) + ' users</div>');
			}
		});
	}

	function showUser(userId, container) {
		ajax('p=premiere_import&action=loadUserDetails&id=' + userId, function(response) {
			if (!response.length) {
				sa.router.routeTo('/admin?p=premiere&tab=edit');
				return sa.notify({ text : 'User not found' });
			}
			var premiereUser = response[0];
			container.html(
				'<div class="section" id="basics">'
					+ '<h2>Edit a User:</h2>'
					+ '<div class="section" id="station"><h4>Station:</h4> <input type="text" value="' + premiereUser.station.replace('"', '&quot;') + '"/><div class="clr"></div></div>'
					+ '<div class="section" id="username"><h4>Username:</h4> <input type="text" value="' + premiereUser.username.replace('"', '&quot;') + '"/><div class="clr"></div></div>'
					+ '<div class="section" id="password"><h4>Password:</h4> <input type="text" value=""/><div class="clr"></div></div>'
					+ '<div class="section" id="name"><h4>Name:</h4> <input type="text" value="' + premiereUser.name.replace('"', '&quot;') + '"/><div class="clr"></div></div>'
					+ '<div class="section" id="showcodes"><h4>Showcodes:</h4> <select multiple="multiple"></select><div class="clr"></div></div>'
				+ '</div>'
				+ '<div class="information" id="errors"></div><div class="clr"></div>'
				+ '<a class="button">Save Changes</a>');
			container.find('.button').on('click', function() {
				var station = $j('#station input').val().trim(),
					username = $j('#username input').val().trim(),
					password = $j('#password input').val().trim(),
					name = $j('#name input').val().trim(),
					showcodes = $j('#showcodes select').val(),
					errors = [];
				if (!station) {
					errors.push('Please enter a station.');
				}
				if (!username) {
					errors.push('Please enter a username.');
				}
				if (!name) {
					errors.push('Please enter a name.');
				}
				if (!showcodes.length) {
					errors.push('Please enter some showcodes.');
				}
				if (errors.length) {
					container.find('.information').html('Please correct the following issues before proceeding:<ul><li>' + errors.join('</li><li>') + '</li></ul>');
				} else {
					ajax('station=' + encodeURIComponent(station) + '&username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password)
							+ '&name=' + encodeURIComponent(name) + '&showcodes=' + encodeURIComponent(showcodes.join(',')) + '&id=' + userId, function(response) {
						if (response[0].result != 'success') {
							$j('.tabbed_body').find('.error').html(response[0].result);
						} else {
							sa.notify({ text : 'User updated!', type : sa.notify.notificationTypes.success });
							container.find('.button').show();
							container.find('.information').html('');
						}
					}, 'POST', 'p=premiere_import&action=editUser');
					container.find('.button').hide();
					container.find('.information').html('Processing...');
				}
				return false;
			});
			ajax('p=premiere_import&action=listShowCodes', function(response) {
				var select = container.find('select');
				for (var i = 0, len = response.length; i < len; i++) {
					var code = response[i];
					select.append('<option' + (premiereUser.showCodes.indexOf(code) != -1 ? ' selected="selected"' : '') + '>' + code + '</option>');
				}
			});
		});
	}
}

/**
 * Lets you update the show code mappings
 */
function AdminPremiereShowCodes() {

	var page = this,
		cont;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		container.html('<div class="data_importing"></div>');
		ajax('p=premiere_import&action=mapping&showAll=1', function(newData) {
			showShowCodeMapper(newData[0], { container : $j('.data_importing'), saveText : 'Save', saveFunction : function(mapString) {
				ajax(mapString, function(response) {
					if (response[0].result != 'success') {
						$j('.data_importing').find('.error').html(response[0].result);
					} else {
						sa.confirm({
							text : 'Changes saved! Use show codes to generate new music access filters for all users?',
							yesFunction : function() {
								ajax('p=premiere_import&action=applyShowCodes', function() {
									sa.notify({ text : 'Done', type : sa.notify.notificationTypes.success });
								});
							},
							yesText : 'Generate'
						});
					}
				}, 'POST', 'p=premiere_import&action=saveMapping');
			} } );
			// add a new code field
			container.find('h2:first').after('<div class="section new_show_code"><span>Add a new show code:</span><input type="text"/><a class="button">Create</a><div class="clr"></div></div>');
			var input = container.find('.new_show_code input'),
				createShowCode = function() {
					var newCode = input.val().trim(),
						select = container.find('select');
					if (!newCode) return;
					select.append('<option>' + newCode + '</option>');
					select.val(newCode).trigger('change');
				};
			container.find('.new_show_code .button').on('click', createShowCode);
			checkForEnter(input, createShowCode);
		});
	};
}


/**
 * Shows the Pando signup block in the provided container.
 *
 * @param {Enum} programType			The type of program, enum found at end of this file.
 * @param {jQuery} container			The jQuery container to add the module to
 * @param {boolean} infoOnly			Display the module in info only mode.
 */


sa.showAdminProgram = async function(programType, container, infoOnly) {
	if (config.grayLabel && programType !== sa.AdminProgram.ContentID && programType !== sa.AdminProgram.DatasetLicensing) {
		container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		return;
	}

	if (!user.hasAdminPermission(AdminPermission.Pando)) {
		container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Add-Ons and Programs' + '" permission.</h3>');
		return;
	}

	let info;
	let templates = sa.templates.get('admin.programs');

	function setInfoNotice() {
		//hide both, just in case they were already out and it changed
		$j('.pando_info_check, .pando_info_none').hide();

		//set the notice info with our loaded info
		if (info && info != 'none') {
			$j('.pando_info_check #pando_notice_name').html(htmlEncode(info.username));
			$j('.pando_info_check #pando_notice_title').html(htmlEncode(info.title));
			$j('.pando_info_check #pando_notice_company').html(htmlEncode(info.company));
			$j('.pando_info_check #pando_notice_address').html(htmlEncode((info.address + '').replace('\n', ' - ')));
			$j('.pando_info_check').show();
		} else {
			$j('.pando_info_none').show();
		}
		$j('.pando_open_info_span').off('click').on('click', function() {
			showInfoFixer();
		});
	}

	function showInfoFixer(callback) {
		if (!info) {
			info = {
				username: user.userData.username,
				company: config.name
			};
		}

		let template = templates.get('info_fixer');

		//fill in data we have
		if (info.username) template.find('#pando_info_username').val(info.username);
		if (info.title) template.find('#pando_info_title').val(info.title);
		if (info.company) template.find('#pando_info_company').val(info.company);
		if (info.address) template.find('#pando_info_address').val(info.address);
		if (info.payable) template.find('#pando_info_payable').val(info.payable);

		sa.forms.init(template);

		let infoFocusBox = new FocusBox(template, {
			title : 'Confirm Your Information'
		});

		template.find('.confirm_no').on('click', function() {
			infoFocusBox.hide();
		});
		template.find('.confirm_yes').on('click', function() {
			let vars = {
				username : $j('#pando_info_username').val(),
				title : $j('#pando_info_title').val(),
				company : $j('#pando_info_company').val(),
				address : $j('#pando_info_address').val(),
				payable : $j('#pando_info_payable').val()
			};

			if (!vars.username || !vars.title || !vars.company || !vars.address || !vars.payable) {
				infoFocusBox.showErrorMessage('Please fill out all fields');
				return;
			}

			//it's legit, let's save it
			infoFocusBox.showLoader('Saving');

			sa.api.request({
				handler : 'pando',
				action : 'saveUserInfo',
				postData : vars
			}).then(function() {
				// update the info notice
				info = vars;
				setInfoNotice();

				infoFocusBox.hide();

				// run callback in necessary
				if (callback) {
					callback();
				}
			});
		});

		infoFocusBox.show();
	}

	function showAmendment(am_id, amended) {

		let application = templates.get('application', { username : htmlEncode(info.username) });
		application.find('iframe').attr('src', 'pdf.php?type=pando_amendment&id=' + am_id);

		// buttons
		application.find('.pando_app_close').on('click', function() {
			closeAgreement();
		});

		application.find('.pando_app_download').on('click', function() {
			window.location.href = 'pdf.php?dl=1&type=pando_amendment&id=' + am_id;
		});

		application.find('.pando_app_accept').on('click', function() {
			acceptAmendment(am_id);
		});

		if (!amended || amended >= 0) {
			application.find('.pando_app_optout').show().on('click', function() {
				if (confirm('Are you sure you want to opt out and no longer receive payments from this program?')) {
					acceptAmendment(am_id, true);
				}
			});
		}

		//show the overlay
		$j('body').append(application);
		application.fadeIn();
	}

	function closeAgreement() {
		let application = $j('#pando_app');
		if (application.length) {
			application.fadeOut(function() {
				application.remove();
			});
		}
	}

	async function acceptAmendment(am_id, optout) {
		$j('#pando_app .pando_app_accept').off();

		await sa.api.request({
			handler : 'pando',
			action : 'agreeToAmendment',
			postVars : {
				id : am_id,
				optout : optout ? 1 : 0
			}
		});

		closeAgreement();
		sa.router.reloadPage();
	}

	async function acceptOpp(opp, isAmendment = false) {
		$j('#pando_app .pando_app_accept').off();

		await sa.api.request({
			handler: 'pando',
			action: 'agreeToPando',
			postData: {
				id: opp.id,
				isAmendment: isAmendment ? 1 : 0
			}
		});

		closeAgreement();
		sa.router.reloadPage();
	}

	function showAgreement(opp, isAmendment = false) {

		if (opp.sign_url) {
			var win = window.open(opp.sign_url, '_blank');

			sa.confirm({
				text : 'If you signed the agreement, please click here so we can begin adding you to the system.',
				yesText : 'Yes, I signed',
				noText : 'Cancel',
				yesFunction : function() {
					acceptOpp(opp, isAmendment);
				}
			});
			return;
		}

		let application = templates.get('application', { username : htmlEncode(info.username) });
		application.find('iframe').attr('src', 'pdf.php?type=pando&id=' + opp.id);

		// buttons
		application.find('.pando_app_close').on('click', function() {
			closeAgreement();
		});

		application.find('.pando_app_download').on('click', function() {
			window.location.href = 'pdf.php?dl=1&type=pando&id=' + opp.id;
		});

		application.find('.pando_app_accept').on('click', function() {
			acceptOpp(opp, isAmendment);
		});

		application.find('.pando_app_optout').hide();

		//show the overlay
		$j('body').append(application);
		application.fadeIn();
	}
	
	function checkNeedsUpdatedContentIdAgreement(opp, agreement) {
		if (!agreement) return true;
		
		// Make sure it's a ContentID agreement
		if (Number(opp.id) !== 15) return false;
		
		// Check if the agreement date is before 02/28/2025
		const newDocumentDate = new Date('2025-02-28');
		
		// Get date of agreement or latest amendment
		const amendedDate = Number(agreement.amended) > 0 ? Number(agreement.amended) : null;
		const latestAgreementDate = amendedDate && amendedDate > Number(agreement.date) ? amendedDate : Number(agreement.date);
		const agreementDate = new Date(latestAgreementDate);
		
		return agreementDate < newDocumentDate;
	}
	
	function checkCanSkipAgreement() {
		return sessionStorage.getItem('contentid_unsigned_agreement') !== null;
	}
	
	container.empty();

	/** @var {{ opp : Object, agreed : Object|boolean, amendments : Object[] }} response */
	const response = await sa.api.request({
		handler : 'pando',
		action : 'getPando',
		getData : { id : programType }
	}).catch(function(e) {
		container.append('<h3 class="permission_denied">' + e.message + '</h3>');
	});

	/** @var {{ id : int, title : string, image : string, rules : string, bullets : string, text : string, pdf : string, sign_url : string, visible : boolean, order : int }} */
	const { opp } = response;
	/** @var {{ id : int, date : int, white_id : int, user_id : int, info : { id : int, user_id : int, white_id : int, username : string, title : string, company : string, address : string, payable : string }, opp_id : int, agreement : string, amended : int, amend_info : string }} */
	const agreement = response.agreed;
	/** @var {{ id : int, opp_id : int, effective_date : int, pdf : string, visible : boolean }[]} */
	const { amendments } = response;
	info = response.info;
	
	// Check if the user needs to sign an updated agreement and launch the agreement signing modal if so
	// Currently turned off for ContentID
	const needsUpdatedAgreement = false;
	
	// Check if they temporarily are skipping the new sign-up
	const skipAgreement = checkCanSkipAgreement();
	if (needsUpdatedAgreement && !skipAgreement) {
		const template = templates.get('contentid_unsigned_agreement');
		
		// Sign Agreement Button -> Trigger Agreement Modal
		template.find('#new-agreement-btn').on('click', function () {
			if (!info) {
				showInfoFixer(() => {
					showAgreement(opp, true);
				});
				return;
			}

			showAgreement(opp, true);
		});
		
		// Sign Later Button
		template.find('#new-agreement-sign-later-btn').on('click', function () {
			sessionStorage.setItem('contentid_unsigned_agreement', 'true');
			window.location.reload();
		});
		
		container.append(template);
		
		return;
	}
	
	const template = templates.get(opp.id == sa.AdminProgram.DatasetLicensing ? 'pando_dataset_licensing' : 'pando', {
		id : opp.id,
		rules : opp.rules.replace(/&lt;/g, '<').replace(/&gt;/g, '>'),
		title : opp.title,
		bullets : opp.bullets.replace(/&lt;/g, '<').replace(/&gt;/g, '>'),
		details : opp.text.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
	});
	template.find('img').attr('src', 'images/pando/' + opp.image);
	container.append(template);

	if (!infoOnly) setInfoNotice();

	if (agreement && !infoOnly) {
		//we are enrolled
		const sep = opp.id == sa.AdminProgram.DatasetLicensing ? ' ' : '<br/>';
		$j('#pando_opp_' + opp.id + ' .pando_opp_apply').hide();
		$j('#pando_opp_' + opp.id + ' .pando_opp_enrolled span').html(`${formatDate(config.dateFormatString, agreement.date)}${sep}- ${agreement.info.username}${sep}<b>${(opp.sign_url && agreement.agreement == '' ? '' : '<a href="pdf.php?type=pando_archive&id=' + agreement.id + '">download agreement &raquo;</a></b>')}`);

		// amendments
		if (amendments && amendments.length) {
			let amendment = amendments.pop();
			if (agreement.date < amendment.effective_date) {
				$j('#pando_opp_' + opp.id + ' .pando_opp_amendment').find('span').html(formatDate(config.dateFormatString, amendment.effective_date));
				$j('#pando_opp_' + opp.id + ' .pando_opp_amendment .button').off('click').on('click', function () {
					showInfoFixer(function () {
						showAmendment(amendment.id, agreement.amended);
					});
				});

				if (agreement.amended > 0) {
					$j('#pando_opp_' + opp.id + ' .pando_opp_amendment i').removeClass('fa-exclamation').addClass('fa-check');
					$j('#pando_opp_' + opp.id + ' .pando_opp_amendment .button').before('<b><a href="pdf.php?dl=1&type=pando_amendment&id=' + amendment.id + '">download amendment &raquo;</a></b>');
					$j('#pando_opp_' + opp.id + ' .pando_opp_amendment .button').remove();
				} else if (agreement.amended < 0) {
					$j('#pando_opp_' + opp.id + ' .pando_opp_amendment i').removeClass('fa-exclamation').addClass('fa-times');
				}
			} else {
				$j('#pando_opp_' + opp.id + ' .pando_opp_amendment').hide();
			}
		} else {
			$j('#pando_opp_' + opp.id + ' .pando_opp_amendment').hide();
			$j('.pando_info_check, .pando_info_none').hide();
		}
	} else {
		// we are not enrolled
		$j('#pando_opp_' + opp.id + ' .pando_opp_enrolled').hide();
		$j('#pando_opp_' + opp.id + ' .pando_opp_amendment').hide();

		$j('.pando_opp_apply .button').off('click').on('click', function() {
			if (!info) {
				showInfoFixer(function() {
					showAgreement(opp);
				});
				return;
			}

			showAgreement(opp);
		});
	}

	if (infoOnly) {
		$j('#pando_opp_' + opp.id + ' .pando_opp_r').hide();
		$j('.pando_opp_seemore').hide();
		$j('#pando_opp_' + opp.id + ' .pando_opp_desc').show();
	}

	$j('.pando_opp_seemore').on('click', function() {
		$j(this).hide();
		$j('#pando_opp_' + opp.id + ' .pando_opp_desc').slideDown();
	});
};

sa.AdminProgram = {
	Alpha : 6,
	ContentID : 15,
	Collect : 16,
	DatasetLicensing: 17,
	/**
	 *
	 * @param programType
	 * @param callback
	 */
	getAgreementPath : async function(programType, callback) {
		/** @var {{ opp : Object, agreed : Object|boolean, amendments : Object[] }} response */
		const response = await sa.api.request({
			handler : 'pando',
			action : 'getPando',
			getData : { id : programType }
		}).catch(e => {
			callback(null);
		});
			
		if (response && response['agreed'] && response['agreed']['id'] && (user.hasAdminPermission(AdminPermission.SuperAdmin) || response['agreed']['user_id'] == user.userData.id)) {
			callback('pdf.php?type=pando_archive&id=' + response['agreed']['id']);
		} else {
			callback(null);
		}

	}
};
/**
 * The page in the admin panel that lets you view and manage your licensing and e-commerce options
 */
function AdminSAOne() {
	let page = this;
	
	let templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Pando)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Add-Ons and Programs' + '" permission.</h3>');
		}
		if (!templates) {
			templates = sa.templates.get('admin.saone');
		}
		var vars = sa.router.paramsToVars(params);
		if (vars['briefId']) {
			showBrief(container, vars['briefId'], vars['optInKey'], vars['notice']);
		} else {
			showBriefList(container);
		} 
	};

	/**
	 * Show a single brief
	 * @param {JQuery} container
	 * @param {int} briefId
	 * @param {string=} optInKey if set, will be sent to the server in an attempt to automatically opt-in. it's a code generated by the brief email
	 * @param {int=} reminderId if set, will be sent to the server with the optInKey
	 */
	async function showBrief(container, briefId, optInKey, reminderId) {

		/** @var {{ title : string, body : string, emailBody : string, response : { id : int, time : int, userId : int, formattedResponse : string } }} brief */
		const brief = await sa.api.request({
			handler : 'saone',
			action : 'getBrief',
			postData : {
				briefId : briefId,
				optInKey : optInKey ? optInKey : '',
				reminderId : reminderId ? reminderId : 0
			}
		}).catch(function (e) {
			sa.alert({ text: e.message });
			showBriefList(container);
		});

		/** @var {JQuery} template */
		let template = templates.get('single_brief', { baseUrl: siteBaseUrl() });
		let briefBody = $j(htmlDecode(brief.emailBody));
		
		briefBody.find('.header_logo, .footer_social, .footer_short').remove();
		
		template.find('.title').html(brief.title);
		template.find('.body').append(briefBody); // not htmlEncoded on purpose because it will contain HTML
		
		// button stuff
		let optInButton = template.find('.opt_in');
		if (brief.response.time) {
			optInButton.after(templates.get('brief_response', { formattedResponse : htmlEncode(brief.response.formattedResponse) }));
			optInButton.remove();
		} else {
			optInButton.on('click', function () {
				sa.api.request({
					handler : 'saone',
					action : 'respondToBrief',
					postData : {
						briefId : briefId
					}
				}).then(function () {
					showBrief(container, briefId, '');
				});
				return false;
			});
		}
		
		container.empty().append(template);
	}

	/**
	 * Show a list of all the briefs currently available to this site
	 * @param container
	 */
	async function showBriefList(container) {
		
		let template = templates.get('brief_list');
		container.empty().append(template);
		let loader = showLoader(template, 'Loading briefs', true);
		
		const briefs = await sa.api.request({
			handler : 'saone',
			action : 'listBriefs'
		});


		loader.remove();
		let listContainer = template.find('.list_container .sa_table');
		
		if (!briefs.length) {
			listContainer.append(templates.get('no_briefs'));
			return;
		}
		
		for (let brief of briefs) {
			let briefTemplate = templates.get('brief', {
				briefId : brief.id,
				title : brief.title,
				baseUrl: siteBaseUrl()
			});
			if (brief.response.time) {
				briefTemplate.find('.status').html(brief.response.formattedResponse);
			} else {
				briefTemplate.find('.status').html('Not yet applied');
			}

			listContainer.append(briefTemplate);
		}
	}

}
/**
 * The page in the admin panel that lets you manipulate your site's settings
 */
function AdminSettings() {
	let page = this;
	let currentTab = '';
	let currentPage;
	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Settings)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Change Settings' + '" permission.</h3>');
		}
		if (!$j('.right_body .metadata').length) {
			var callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [];
			let baseUrl = siteBaseUrl();
			const pages = [
				{id: 'general', href: baseUrl + '/admin?p=settings&tab=general', title: 'General', isDisabled: false, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
				{id: 'access', href: baseUrl + '/admin?p=settings&tab=access', title: 'Access', isDisabled: config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{ id: 'api', href: baseUrl + '/admin?p=settings&tab=api', title: 'API', isDisabled: (!config.apiEnabled ? config.grayLabel : (config.apiEnabled == 1 ? false : true)), hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'seo', href: baseUrl + '/admin?p=settings&tab=seo', title: 'SEO', isDisabled: config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network']},
				{id: 'search', href: baseUrl + '/admin?p=settings&tab=search', title: 'Search', isDisabled: config.grayLabel, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'lists', href: baseUrl + '/admin?p=settings&tab=lists', title: 'Lists', isDisabled: false, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'filters', href: baseUrl + '/admin?p=settings&tab=filters', title: 'Filters', isDisabled: false, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'tabs', href: baseUrl + '/admin?p=settings&tab=tabs', title: 'Tabs', isDisabled: false, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
				{id: 'cue-sheets', href: baseUrl + '/admin?p=settings&tab=cue-sheets', title: 'Cue Sheets', isDisabled: config.grayLabel, hasPageFeature: config.showCueSheets, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio',  'drop']},
				{id: 'appearance', href: baseUrl + '/admin?p=settings&tab=appearance', title: 'Appearance', isDisabled: false, hasPageFeature: true, enabledSiteTypes: ['seller', 'buyer', 'network', 'radio',  'drop']}
			];
			for (var p of pages) {
				if (p.enabledSiteTypes.includes(config.siteType) && p.hasPageFeature) tabs.push(new RightTab(p.id, p.href, p.title, callback, p.isDisabled));
			}			
			RightTabbedPage.prototype.show.call(this, 'settings', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'general';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			if (pageId == 'general') {
				currentPage = new AdminSettingsGeneral();
			} else if (pageId == 'access') {
				currentPage = new AdminSettingsAccess();
			} else if (pageId == 'api') {
				currentPage = new AdminSettingsApi();
			} else if (pageId == 'seo') {
				currentPage = new AdminSEO();
			} else if (pageId == 'search') {
				currentPage = new AdminSettingsSearch();
			} else if (pageId == 'lists') {
				currentPage = new AdminSettingsLists();
			} else if (pageId == 'filters') {
				currentPage = new AdminSettingsFilters();
			} else if (pageId == 'tabs') {
				currentPage = new AdminSettingsTabs();
			} else if (pageId == 'cue-sheets' && config.showCueSheets) {
				currentPage = new AdminSettingsCueSheets();
			} else if (pageId == 'appearance') {
				currentPage = new AdminSettingsAppearance();
			} else {
				currentPage = new AdminSettingsGeneral();
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminSettings.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you manage user registration and download options
 */
function AdminSettingsAccess() {

	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function(params, container) {

		if (!templates) {
			templates = sa.templates.get('admin.settings.access');
		}

		const accessSettings = await sa.api.request({
			handler : 'settings',
			action : 'get-access'
		});

		var cap = new sa.collapsingAdminPage();
		cap.addSection({
			name : 'Registration Options',
			contents : getRegistrationOptionsTemplate(accessSettings['registrationOptions'])
		});
		if (config.siteType != 'buyer') {
			cap.addSection({
				name : 'Registration Fields',
				contents : getRegistrationFieldsTemplate()
			});
		}
		cap.addSection({
			name : 'Download Options',
			contents : getDownloadOptionsTemplate()
		});
		if (config.siteType != 'buyer' && accessSettings['catalogs'].length) {
			cap.addSection({
				name : 'Metadata Embedding',
				contents : getMetadataEmbeddingTemplate()
			});
		}
		cap.addSection({
			name : 'User Permissions',
			contents : getUserPermissionTemplate()
		});
		cap.addSection({
			name : 'Embedding Options',
			contents : getEmbeddingOptionsTemplate()
		});
		cap.addToContainer(container);

		container.append(getButtonsTemplate());
	};

	/**
	 * @param {Object} registrationOptions
	 * 	@property {boolean} admin_verification
	 * 	@property {boolean} admin_notification
	 * 	@property {boolean} registration_required
	 * 	@property {string} admin_contact
	 * 	@property {string} approved_domains
	 * 	@property {string} message
	 * @return {JQuery} the template
	 */
	function getRegistrationOptionsTemplate(registrationOptions) {

		var template = templates.get('registration_options');

		if (config.siteType === 'buyer') {
			template.find('.section:not(.buyer_site)').remove();
		}

		if (registrationOptions.admin_verification) {
			template.find('#admin_verification input').prop('checked', true);
		} else {
			template.find('#approved_domains').hide();
		}
		if (registrationOptions.admin_notification) {
			template.find('#admin_notification input').prop('checked', true);
		}
		if (registrationOptions.registration_required) {
			template.find('#registration_required input').prop('checked', true);
		}
		if (config.showUnloggedHome) {
			template.find('#show_unlogged_home input').prop('checked', true);
		}
		if (registrationOptions.admin_contact) {
			template.find('#admin_email textarea').val(registrationOptions.admin_contact);
		}
		if (registrationOptions.approved_domains) {
			template.find('#approved_domains textarea').val(registrationOptions.approved_domains.split(',').join(', '));
		}
		if (registrationOptions.message) {
			template.find('#signup_message textarea').val(registrationOptions.message);
		}
		template.find('#admin_verification input').on('click', function() {
			if (this.checked) {
				template.find('#approved_domains').show();
			} else {
				template.find('#approved_domains').hide();
			}
		});
		
		if (config.grayLabel) {
			template.find('#admin_verification input').prop('disabled', true);
			template.find('#admin_notification input').prop('disabled', true);
			template.find('#registration_required input').prop('disabled', true);
			template.find('#show_unlogged_home input').prop('disabled', true);
			
			template.find('#approved_domains').hide();
			template.find('#signup_message').hide();
		}

		return template;
	}

	/**
	 * @return {JQuery}
	 */
	function getRegistrationFieldsTemplate() {

		var template = templates.get('registration_fields');

		template.find('#add_field').on('click', function() {
			addRegistrationField();
			restripe();
		});

		// add the site's custom fields
		var regFields = template.find('#custom_registration_fields');
		sa.api.request({
			handler : 'settings',
			action : 'getRegistrationFields'
		}).then(function(fields) {
			for (var i = 0, len = fields.length; i < len; i++) {
				let field = fields[i];
				if (field.type === 'contact selector') {
					field.contactSelectorOptions = JSON.stringify(field.contactSelectorOptions);
				} else if (field.type === 'option selector') {
					field.optionSelectorOptions = JSON.stringify(field.optionSelectorOptions);
				}
				addRegistrationField(field, regFields);
			}
		})
		restripe();

		return template;

	}

	/**
	 * @returns {JQuery}
	 */
	function getDownloadOptionsTemplate() {

		var template = templates.get('download_options');

		if (config.downloadFormats.mp3) {
			template.find('#mp3').prop('checked', true);
		}
		if (config.downloadFormats.wav) {
			template.find('#wav').prop('checked', true);
		}
		if (config.downloadFormats.aiff) {
			template.find('#aiff').prop('checked', true);
		}
		if (config.showAltDownloads) {
			template.find('#nested_zips input').prop('checked', true);
		}

		template.find('a.download_agreement').on('click', function() {
			sa.components.documentViewer.show('download_agreement');
		});

		return template;

	}

	/**
	 * @returns {JQuery}
	 */
	function getMetadataEmbeddingTemplate() {

		return templates.get('metadata_embedding');

	}

	/**
	 * @returns {JQuery}
	 */
	function getUserPermissionTemplate() {

		return templates.get('user_permissions');

	}

	/**
	 * @returns {JQuery}
	 */
	function getEmbeddingOptionsTemplate() {

		var template = templates.get('embedding_options');

		if (config.showEmbeds) {
			template.find('input').prop('checked', true);
		}

		return template;

	}

	/**
	 * @returns {JQuery}
	 */
	function getButtonsTemplate() {

		var template = templates.get('buttons');

		template.find('.button').on('click', function() {
			saveChanges();
		});

		return template;

	}

	/**
	 * Stripes the registration fields
	 */
	function restripe() {
		$j('.field').removeClass('stripe');
		$j('.field:odd').addClass('stripe');
	}

	/**
	 * Adds a registration field at the end of the list
	 * @param {object=} regField the details of the registration field out of the config (optional - if specified, this is an existing field. if not, a new)
	 * @param {JQuery=} regFieldContainer the container to put the fields in (optional - on initial load, saves jquery calls to pass this in rather than load it every time)
	 */
	function addRegistrationField(regField, regFieldContainer) {
		if (!regField) {
			regField = {
				id : 0,
				name : '',
				type : 'text',
				defaultValue : '',
				required : 0,
				contactSelectorOptions : '',
				optionSelectorOptions : ''
			};
		}
		if (!regFieldContainer) regFieldContainer = $j('#custom_registration_fields');
		var field = templates.get('registration_field', { id : regField.id });
		field.find('.type select').val(regField.type);
		field.find('.name input').val(regField.name);
		field.find('.default input').val(regField.defaultValue);
		if (regField.required) {
			field.find('.required input').prop('checked', true);
		} else {
			field.find('.required input').prop('checked', false);
		}
		field.find('.up').on('click', function() { moveField(field, -1); });
		field.find('.down').on('click', function() { moveField(field, 1); });
		field.find('.delete').on('click', function() {
			field.remove();
			restripe(); $j('.delete_notice').slideDown();
		});
		field.find('.type select').on('change', function() {
			let forceRequired = false;
			if (this.value === 'contact selector') {
				if (regFieldContainer.find('.item .type option[value="contact selector"]:selected').length > 1) {
					$j(this).find('option[value="text"]').prop('selected', true);
					$j(this).trigger('change');
					sa.alert({ text : 'You may only have one contact selector.' });
					return;
				}
				field.addClass('contact_selector_field');
				forceRequired = true;
			} else {
				field.removeClass('contact_selector_field');
			}
			if (this.value === 'option selector') {
				field.addClass('option_selector_field');
				forceRequired = true;
			} else {
				field.removeClass('option_selector_field');
			}
			if (forceRequired) {
				field.find('.required input').prop('checked', true).prop('disabled', true);
			} else {
				field.find('.required input').prop('disabled', false);
			}
		}).trigger('change');
		field.find('input[name=contact_selector_options]').val(regField.contactSelectorOptions);
		field.find('input[name=option_selector_options]').val(regField.optionSelectorOptions);
		field.find('.contact_selector_button').on('click', function() {
			showContactSelector(field.find('input[name=contact_selector_options]'));
		});
		field.find('.option_selector_button').on('click', function() {
			showOptionSelector(field.find('input[name=option_selector_options]'));
		});
		regFieldContainer.append(field);
	}

	/**
	 * Moves a field up or down in the list
	 * @param {JQuery} field the field to move
	 * @param {int} direction -1 means up, 1 means down
	 */
	function moveField(field, direction) {
		if (direction == 1) {
			field.next().after(field);
		} else {
			field.prev().before(field);
		}
		restripe();
	}

	/**
	 * Shows the contact selector that lets you choose which contact should be emailed depending on which select option the user picks
	 * @param {JQuery} input
	 */
	function showContactSelector(input) {

		let template = templates.get('contact_selector');
		let rowTemplate = template.find('.item').clone();
		template.find('.item').remove();
		let rowContainer = template.find('.row_container');

		let getNewRow = function() {
			let row = rowTemplate.clone();
			row.find('.up').on('click', function() { moveField(row, -1); });
			row.find('.down').on('click', function() { moveField(row, 1); });
			row.find('.delete').on('click', function() {
				row.remove();
			});
			return row;
		};

		let currentValueString = input.val();
		if (currentValueString) {
			let currentValues = JSON.parse(currentValueString);
			if (currentValues.isArray) {
				currentValues.each(function(i, value) {
					let row = getNewRow();
					row.find('input[name=value]').val(htmlDecode(value.value));
					row.find('input[name=email]').val(htmlDecode(value.email));
					rowContainer.append(row);
				});
			}
		}

		template.find('.add_option_button').on('click', function() {
			rowContainer.append(getNewRow());
		});

		// add some starter rows
		rowContainer.append(getNewRow());
		rowContainer.append(getNewRow());
		rowContainer.append(getNewRow());

		let fb = sa.showFocusBox(template, {
			title : 'Registration Contact Selector'
		});

		template.find('.confirm_yes').on('click', function() {
			let values = [];
			for (let rows = rowContainer.find('.item'), len = rows.length, i = 0; i < len; i++) {
				let row = $j(rows[i]);
				let value = row.find('input[name=value]').val().trim();
				let email = row.find('input[name=email]').val().trim();
				// if they don't enter anything, discard it
				if (value === '' && email === '') continue;
				// if they only enter one, throw an error
				if (value === '' || email === '') {
					sa.alert({ text : 'Please enter a value and an email for each option.' });
					return;
				}
				// perform email address validation. email addresses can be multivalued so split first
				let emails = email.split(',');
				for (let e = 0, eLen = emails.length; e < eLen; e++) {
					let email = emails[e].trim();
					if (email === '') {
						continue;
					}
					if (!email.isEmail()) {
						sa.alert({ text : 'Please only enter valid email address. Multiple emails can be entered with commas.' });
						return;
					}
				}
				// make sure there's no value duplication
				for (let v = 0, vLen = values.length; v < vLen; v++) {
					if (values[v].value === value) {
						sa.alert({ text : 'Please only enter each value once.' });
						return;
					}
				}
				// everything looks ok
				values.push({ value : value, email : email });
			}
			// everything went ok. add the data back to the parent
			input.val(JSON.stringify(values));
			fb.hide();
			sa.notify({ text : 'Options updated! Make sure to Save Changes on this page to make those updates permanent.' });
		});

		template.find('.confirm_no').on('click', function() {
			fb.hide();
		})

	}

	/**
	 * Shows the option selector that lets you choose values for a select box
	 * @param {JQuery} input
	 */
	function showOptionSelector(input) {

		let template = templates.get('option_selector');
		let rowTemplate = template.find('.item').clone();
		template.find('.item').remove();
		let rowContainer = template.find('.row_container');

		let getNewRow = function() {
			let row = rowTemplate.clone();
			row.find('.up').on('click', function() { moveField(row, -1); });
			row.find('.down').on('click', function() { moveField(row, 1); });
			row.find('.delete').on('click', function() {
				row.remove();
			});
			return row;
		};

		let currentValueString = input.val();
		if (currentValueString) {
			let currentValues = JSON.parse(currentValueString);
			if (currentValues.isArray) {
				currentValues.each(function(i, value) {
					let row = getNewRow();
					row.find('input[name=value]').val(htmlDecode(value.value));
					rowContainer.append(row);
				});
			}
		}

		template.find('.add_option_button').on('click', function() {
			rowContainer.append(getNewRow());
		});

		// add some starter rows
		rowContainer.append(getNewRow());
		rowContainer.append(getNewRow());
		rowContainer.append(getNewRow());

		let fb = sa.showFocusBox(template, {
			title : 'Registration Option Selector'
		});

		template.find('.confirm_yes').on('click', function() {
			let values = [];
			for (let rows = rowContainer.find('.item'), len = rows.length, i = 0; i < len; i++) {
				let row = $j(rows[i]);
				let value = row.find('input[name=value]').val().trim();
				// if they don't enter anything, discard it
				if (value === '') continue;
				// make sure there's no value duplication
				for (let v = 0, vLen = values.length; v < vLen; v++) {
					if (values[v].value === value) {
						sa.alert({ text : 'Please only enter each value once.' });
						return;
					}
				}
				// everything looks ok
				values.push({ value : value });
			}
			// everything went ok. add the data back to the parent
			input.val(JSON.stringify(values));
			fb.hide();
			sa.notify({ text : 'Options updated! Make sure to Save Changes on this page to make those updates permanent.' });
		});

		template.find('.confirm_no').on('click', function() {
			fb.hide();
		})

	}

	/**
	 * Saves changes to a white label's basic information after performing form validation
	 */
	function saveChanges() {

		let postData = {
			adminNotification : $j('#admin_notification input:checked').val() ? 1 : 0,
			adminVerification : $j('#admin_verification input:checked').val() ? 1 : 0,
			showUnloggedHome : $j('#show_unlogged_home input:checked').val() ? 1 : 0,
			registrationRequired : $j('#registration_required input:checked').val() ? 1 : 0,
			adminEmail : $j('#admin_email textarea').val().trim(),
			approvedDomains : $j('#approved_domains textarea').val(),
			showEmbeds : $j('.embedding_options input:checked').val() ? 1 : 0,
			showAltDownloads : $j('#nested_zips input:checked').val() ? 1 : 0,
			message : $j('#signup_message textarea').val(),
			additionalFields : [],
			formats : {
				aiff : $j('#formats #aiff:checked').length ? 1 : 0,
				wav : $j('#formats #wav:checked').length ? 1 : 0,
				mp3 : $j('#formats #mp3:checked').length ? 1 : 0
			}
		};

		let errorContainer = $j('#access_error').empty().removeClass('error').removeClass('success');

		// email
		// need to verify the email address is valid
		let emails = postData.adminEmail.split(',');
		postData.adminEmail = '';
		for (let i = 0, len = emails.length; i < len; i++) {
			var email = emails[i].trim();
			if (!email.isEmail()) {
				errorContainer.addClass('error').html('Please enter a valid email address in the Registration Options. Separate multiple addresses with commas.');
				return;
			} else {
				postData.adminEmail += ', ' + email;
			}
		}
		postData.adminEmail = postData.adminEmail.substr(2);
		$j('#admin_email textarea').val(postData.adminEmail);
		$j('#admin_email .information').removeClass('error').html('Who should receive email notifications related to registration and download requests? Multiple emails may be entered, separated by commas.');

		// Makes sure the domains are valid
		let domains = postData.approvedDomains.split('\n').join(',').replace(/,{2,}/, ',');
		domains = DomainUtils.validateDomains(domains);
		
		if (domains.invalid.length) {
			errorContainer.addClass('error').html('The following domains are invalid: ' + domains.invalid.join(', '));
			return;
		}
		
		postData.approvedDomains = domains.valid.filter(d => d.length).join(',');
		
		// registration fields
		let fieldNames = [];
		for (let fields = $j('#custom_registration_fields .item'), i = 0, len = fields.length; i < len; i++) {
			let field = $j(fields[i]),
				name = field.find('.name input').val().trim(),
				type = field.find('.type select').val(),
				errorMessage = '';
			if (!name) {
				errorMessage = 'Please enter a name for all fields';
			} else if (type !== 'text' && type !== 'textarea' && type !== 'phone' && type !== 'forced' && type !== 'contact selector' && type !== 'option selector') {
				errorMessage = 'Please choose from the type list for every field';
			} else if (fieldNames.indexOf(name) != -1) {
				errorMessage = 'Please choose a unique name for each field';
			}
			fieldNames.push(name);
			if (errorMessage) {
				errorContainer.addClass('error').html(errorMessage);
				return;
			}
			postData.additionalFields.push({
				name : name,
				type : type,
				default_value : field.find('.default input').val().trim(),
				id : field.attr('id').substr(6),
				contactSelectorOptions : field.find('input[name=contact_selector_options]').val(),
				optionSelectorOptions : field.find('input[name=option_selector_options]').val(),
				required : field.find('.required input:checked').val() ? 1 : 0
			});
		}

		$j('.tabbed_body #general').removeClass('error').removeClass('success').html('Submitting...');
		sa.api.request({
			handler : 'settings',
			action : 'save-access',
			postData : postData
		}).then(function() {
			sa.notify({ text : 'Changes saved! You might need to reload to see all your changes', type : sa.notify.notificationTypes.success });
		}).catch(e => {
			sa.alert(e.message);
			errorContainer.addClass('error').html(e.message);
		});
		config.showEmbeds = postData.showEmbeds;
	}
}
/**
 * The page in the admin panel that lets you manage user registration and download options
 */
function AdminSettingsApi() {

	var page = this;
	var templates = sa.templates.get('admin.settings.api');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		let isDisabled = (!config.apiEnabled ? config.grayLabel : (config.apiEnabled == 1 ? false : true));

		console.log('- showing api settings');
		window.activePage = page;
		container.empty();

		var pageTemplate = !isDisabled ? 'page' : 'disabled';
		container.html(templates.get(pageTemplate));
		page.div = container;

		if (!isDisabled) {
			page.addPermOptions(page.div.find('#new-token-perms'));
			page.tokenTemplate = page.div.find('.token').detach();
			page.getTokens();
			page.div.find('#new-token-button').on('click', page.addToken);
		}
	};

	this.getTokens = function () {
		sa.api.request({
			handler: 'apiSettings',
			action: 'getTokens'
		}).then((r) => {
			console.log(r);

			if (!r.length) return page.div.find('.tokens').html('<div class="no-tokens">No tokens yet. Create one above.</div>');

			_.each(r, (token) => {
				const tdiv = page.tokenTemplate.clone();
				tdiv.data('token', token);
				tdiv.find('.token-name').html(token.name);
				tdiv.find('.token-code-section code').html(token.token);
				tdiv.find('.token-name span').html(token.name);
				tdiv.find('.token-name code').html(token.token);
				tdiv.find('.token-perms input').val(token.permissions_list.join(',').toLowerCase());
				page.div.find('.tokens').append(tdiv);

				tdiv.find('.token-copy').on('click', function () {
					const tokenText = $j(this).parent().find('code').text();
					navigator.clipboard.writeText(tokenText).then(() => {
						sa.notify({ text: 'Token Copied!', type: 'success_notification' });
					});
				});

				page.addPermOptions(tdiv.find('.token-perms input'));

				tdiv.find('.token-perms input').on('change', () => {
					// var token = $j(this).parent().parent().data('token');
					// var perms = $j(this).val();
					// console.log('- new perms:', perms, token);
					tdiv.find('.token-save').show();
				});
			});

			page.div.find('.token-save').on('click', page.saveToken);
			page.div.find('.token-delete').on('click', page.deleteToken);
		}).catch((e) => {
			sa.error(e.message);
		});
	};

	this.addToken = function() {
		var name = page.div.find('#new-token-name').val();
		var perms = page.div.find('#new-token-perms').val();

		if (!name) return sa.error('You must have a name for your new token.');
		if (name.length > 32) return sa.error('Please use less than 32 chars for your name.');
		if (!perms) return sa.error('You must assign at least one permission to your new token.');

		sa.api.request({
			handler : 'apiSettings',
			action : 'createNewToken',
			postData : {
				name : name,
				perms : perms
			}
		})
		.then(function(r) {
			sa.notify({ text : 'Saved!', type : 'success_notification' });
			sa.router.reloadPage();
		})
		.catch(function(e) {
			sa.error(e.message)
		});

	};

	this.saveToken = function () {
		const token = $j(this).parent().parent().data('token');
		const newPerms = $j(this).parent().parent().find('.token-perms input').val();
		
		if (!newPerms) {
			return sa.error('You must assign at least one permission to your token.');
		}
		
		console.log('- save:', token);
		$j(this).hide();

		sa.api.request({
			handler: 'apiSettings',
			action: 'editToken',
			postData: {
				id: token.id,
				perms: newPerms
			}
		})
			.then(() => {
				sa.notify({text: 'Saved!', type: 'success_notification'});
			})
			.catch((e) => {
				sa.error(e.message);
			});
	};

	this.deleteToken = function() {
		var token = $j(this).parent().parent().data('token');
		var tdiv = $j(this).parent().parent();
		var delbutton = $j(this);
		console.log('- delete:', token);

		sa.confirm({
			text: 'Do you want to delete the "' + token.name + '" token? This is not undoable and will disrupt any integrations using this token.',
			yesFunction: function() {

				delbutton.hide();

				sa.api.request({
					handler: 'apiSettings',
					action: 'deleteToken',
					postData: {
						id: token.id,
					}
				})
					.then(() => {
						sa.notify({
							text: 'Deleted!', 
							type: 'success_notification'
						});
						
						tdiv.slideUp();
						tdiv.remove();
						
						if ($j('.tokens .token').length === 0) {
							page.div.find('.tokens').html('<div class="no-tokens">No tokens yet. Create one above.</div>');
						}
					})
					.catch((e) => {
						sa.error(e.message);
					});
			},
			yesText: 'Delete'
		});
	};

	this.addPermOptions = function(div) {
		/*
		define('API_ALL', 1);
		define('API_IMPORT', 2);
		define('API_TRACKS_VIEW', 4);
		define('API_TRACKS_UPDATE', 8);
		define('API_TRACKS_DOWNLOAD', 16);
		define('API_TRACKS_DELETE', 32);
		define('API_LICENSING_RATES', 64);
		define('API_LICENSING_USERSTATUS', 128);
		define('API_CONTENTID', 256);
		define('API_CONTENTID_EDIT', 512);
		const PERM_PLAYLISTS = 1024;
		const PERM_USERDATA = 2048;
		*/
		div.selectize({
			plugins: ['remove_button'],
			options: [
				{
					name: 'all',
					pretty: 'All',
					description: 'Grants all permissions.'
				},
				{
					name: 'import',
					pretty: 'Import',
					description: 'Can import tracks into the workspace.'
				},
				{
					name: 'tracks_view',
					pretty: 'View Tracks',
					description: 'Can view metadata for any track.'
				},
				{
					name: 'tracks_update',
					pretty: 'Update Tracks',
					description: 'Can edit metadata for any track.'
				},
				{
					name: 'tracks_download',
					pretty: 'Download Tracks',
					description: 'Can download any track.'
				},
				{
					name: 'tracks_delete',
					pretty: 'Delete Tracks',
					description: 'Can delete any track.'
				},
				{
					name: 'licensing_rates',
					pretty: 'Licensing Rates',
					description: 'Can pull rate card info for any track.'
				},
				{
					name: 'licensing_userstatus',
					pretty: 'User Licensing Status',
					description: 'Can get subscription/credit info about any user.'
				},
				{
					name: 'contentid',
					pretty: 'ContentId',
					description: 'Can access contentid.'
				},
				{
					name: 'contentid_edit',
					pretty: 'ContentId edit',
					description: 'Can manage contentId claims and whitelisting.'
				},
				{
					name: 'playlists',
					pretty: 'Playlists',
					description: 'Can create/edit playlists that are workspace published or owned by users that grant access.'
				},
				{
					name: 'userdata',
					pretty: 'Handle User Data',
					description: 'Can access user data of users that have granted access to do so.'
				},
			],
			labelField: 'name',
			valueField: 'name',
			create: false,
			onInitialize: function () {
				this.$control_input.attr('readonly', true);
			},
			render: {
				option: function (item, escape) {
					return '<div>'
					+ '<div class="title"><b>' + escape(item.pretty) + '</b>: ' + escape(item.description) + '</div>'
					+ '</div>';
				}
			},
		});
	};
}
/**
 * The page in the admin panel that lets you change your site's styles
 */
function AdminSettingsAppearance() {
	const self = this;
	self.allThemes = null;
	let templates;
	let themeBase;
	let currentTheme;
	let themeId;
	const images = {
		topBarLogo: '',
		loginLogo: '',
		loginBackground: '',
		homeBackground: '',
		homeBackgroundRepeat: 'repeat',
		brandingHeaderLogo: '',
		brandingHeaderLogoPosition: 'left',
		brandingHeaderBackground: '',
		brandingHeaderBackgroundRepeat: false,
		brandingHeaderFullWidth: false,
		emailLogo: '',
		favicons: []
	};
	let $bannerOptions;
	let $emailOptions;
	const layoutTheme = {};

	const availableColorThemeIds = [
		'sourceaudio',
		'noir',
		'sage',
		'midnightforest',
		'deepocean',
		'harvestmoon',
		'hotdog'
	];

	const themePaletteMap = [
		'color_buttonBackgroundColor',
		'color_siteBackgroundColor',
		'color_navBarBackgroundColor',
		'color_leftNavBackgroundColor',
		'color_leftNavFolderTextColor',
		'color_waveformPlayingColor',
		'color_topBarBackgroundColor',
		'color_buttonTextColor',
		'color_bottomBarBackgroundColor',
		'color_listBackgroundColor',
		'color_listPaginationBackgroundColor',
		'color_bottomBarProgressColor'
	];

	const themeThumbnailMap = [
		{ type: 'backgroundColor', selector: '.button', colorPickerId: 'color_buttonBackgroundColor' },
		{ type: 'backgroundColor', selector: '.button', colorPickerId: 'color_buttonBackgroundColor' },
		{ type: 'textColor', selector: '.button', colorPickerId: 'color_buttonTextColor' },
		{ type: 'backgroundColor', selector: '.header', colorPickerId: 'color_topBarBackgroundColor' },
		{ type: 'backgroundColor', selector: '.logo', colorPickerId: 'color_buttonBackgroundColor' },
		{ type: 'backgroundColor', selector: '.icon', colorPickerId: 'color_textOnTopBarColor' },
		{ type: 'backgroundColor', selector: '.search-bar', colorPickerId: 'color_searchBoxBackgroundColor' },
		{ type: 'backgroundColor', selector: '.menu', colorPickerId: 'color_navBarBackgroundColor' },
		{ type: 'backgroundColor', selector: '.left-nav', colorPickerId: 'color_leftNavBackgroundColor' },
		{ type: 'textColor', selector: '.left-nav-item', colorPickerId: 'color_leftNavHeadingColor' },
		{ type: 'backgroundColor', selector: '.content', colorPickerId: 'color_siteBackgroundColor' },
		{ type: 'backgroundColor', selector: '.album', colorPickerId: 'color_waveformPlayingColor' },
		{ type: 'backgroundColor', selector: 'hr', colorPickerId: 'color_waveformPlayingColor' },
		{ type: 'backgroundColor', selector: '.bottom-bar', colorPickerId: 'color_bottomBarBackgroundColor' },
		{ type: 'backgroundColor', selector: '.play-line', colorPickerId: 'color_bottomBarProgressColor' }
	];

	this.loadThemes = async function () {
		self.allThemes = AdminSettingsAppearance.allThemes ?? (AdminSettingsAppearance.allThemes = await $j.getJSON(siteBaseUrl() + '/js/color-themes.json'));
	};

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function (params, container) {
		templates = sa.templates.get('admin.settings.appearance');
		container.addClass('appearance_editor');

		// Get the themes JSON
		await this.loadThemes();

		const cap = new sa.collapsingAdminPage();

		cap.addSection({
			name: 'Images',
			contents: getImagesTemplate()
		});
		cap.addSection({
			name: 'Colors',
			contents: getColorsTemplate()
		});
		cap.addSection({
			name: 'Page Banners',
			contents: getBannersTemplate()
		});
		cap.addSection({
			name: 'Emails',
			contents: getEmailsTemplate()
		});
		if (config.siteType !== 'drop') {
			cap.addSection({
				name: 'Layout',
				contents: getLayoutTemplate()
			});
			cap.addSection({
				name: 'Terminology',
				contents: getTerminologyEditingTemplate()
			});
		}

		cap.addToContainer(container);

		const buttons = templates.get('buttons');
		buttons.find('#reset_button').on('click', () => {
			reset();
		});
		buttons.find('#save_button').on('click', () => {
			saveChanges();
		});

		// Save theme as file button		
		buttons.find('.save_theme_as_json').on('click', () => {
			saveThemeAsJSON();
		});

		container.append(buttons);

		unloadFunctions.push(() => {
			$j('.jPicker').remove();
		});
	};

	function getImagesTemplate() {
		const template = templates.get('image_editor');

		Object.keys(images).forEach((logoName) => {
			if (logoName === 'favicons') {
				config.theme.favicons.each((i, favicon) => {
					images.favicons.push(favicon.path);
				});
			} else if (config.theme[logoName]) {
				images[logoName] = config.theme[logoName].path;
			}
		});

		if (config.siteType !== 'drop') {
			if (config.theme.brandingHeaderBackground.options && config.theme.brandingHeaderBackground.options.repeat) {
				images.brandingHeaderBackgroundRepeat = true;
			}
			if (config.theme.brandingHeaderFullWidth) {
				images.brandingHeaderFullWidth = true;
			}
			if (config.theme.homeBackground.options && config.theme.homeBackground.options.repeat) {
				images.homeBackgroundRepeat = config.theme.homeBackground.options.repeat;
			}
			if (config.theme.brandingHeaderLogo.options && config.theme.brandingHeaderLogo.options.position) {
				images.brandingHeaderLogoPosition = config.theme.brandingHeaderLogo.options.position;
			}

			images.bannersDynamicBackground = !!config.theme.bannersDynamicBackground;
		}

		if (images.topBarLogo) template.find('#top_bar_logo').data({ value: images.topBarLogo });
		if (images.loginLogo) template.find('#login_logo').data({ value: images.loginLogo });
		if (images.loginBackground) template.find('#login_background').data({ value: images.loginBackground });

		if (config.siteType !== 'drop') {
			if (images.brandingHeaderLogo) template.find('#branding_header_logo').data({ value: images.brandingHeaderLogo });
			if (images.brandingHeaderLogoPosition) template.find('#branding_header_logo_position').val(images.brandingHeaderLogoPosition);
			if (images.bannersDynamicBackground) template.find('#banners_dynamic_background').prop('checked', true);
			if (images.homeBackground) template.find('#home_background').data({ value: images.homeBackground });
			if (images.homeBackgroundRepeat) template.find('#home_background_repeat').val(images.homeBackgroundRepeat);
			if (images.brandingHeaderBackground) template.find('#branding_header_background').data({ value: images.brandingHeaderBackground });
			if (images.brandingHeaderBackgroundRepeat) template.find('#branding_header_background_repeat').prop('checked', true);
			if (images.brandingHeaderFullWidth) template.find('#branding_header_full_width').prop('checked', true);
			if (images.favicons.length) template.find('#favicon').data({ value: images.favicons[0] });
		} else {
			template.find('#branding_images_container').remove();
			template.find('#home_images_container').remove();
			template.find('#favicon_image_container').remove();
		}

		sa.forms.init(template, {
			realTimeValidation: true,
			realTimeValidationCallback: function (validationResult) {
				if (validationResult.uploader) {
					const uploader = validationResult.uploader;
					const files = uploader.getFileDetails();
					if (files.length) {
						const key = new Date().getTime();
						sa.showCover('Uploading image...');
						uploader.upload({
							params: 't=temp&key=' + key + '&source=' + validationResult.name,
							complete: function (e, response) { // success function
								sa.hideCover();
								uploader.removeAllFiles();
								let newPath;
								if (response && response[0] && response[0].file) {
									newPath = response[0].file;
								} else {
									newPath = user.userData.id + '-' + key + '.jpg';
								}
								newPath = 'https://sourceaudio-images.s3.amazonaws.com/temp/' + newPath;
								if (validationResult.name === 'top_bar_logo') {
									sa.components.topBar.setLogo({ path: newPath });
									images.topBarLogo = newPath;
								} else if (validationResult.name === 'branding_header_logo') {
									sa.components.brandingHeader.setLogo({ path: newPath });
									images.brandingHeaderLogo = newPath;
								} else if (validationResult.name === 'branding_header_background') {
									images.brandingHeaderBackground = newPath;
									updateBrandingHeaderBackground();
								} else if (validationResult.name === 'login_logo') {
									images.loginLogo = newPath;
								} else if (validationResult.name === 'login_background') {
									images.loginBackground = newPath;
								} else if (validationResult.name === 'home_background') {
									images.homeBackground = newPath;
								} else if (validationResult.name === 'favicon') {
									images.favicons = [];
									if (response && response[0] && response[0]['extraFiles']) {
										response[0]['extraFiles'].each(function(i, extraFile) {
											images.favicons.push('https://sourceaudio-images.s3.amazonaws.com/temp/' + extraFile);
										});
									} else {
										images.favicons.push(newPath);
									}
									$j('link[rel=icon]').remove();
									if (images.favicons.length) {
										const path = images.favicons[images.favicons.length - 1];
										const mime = 'image/' + (path.indexOf('.ico') !== -1 ? 'x-icon' : 'png');
										$j('head').append('<link rel="icon" type="' + mime + '" href="' + path + '"/>');
									}
								}
							},
							error: function () { // error function
								sa.hideCover();
								console.log('error');
							},
							parseComplete: true
						});
					} else {
						// remove image
						if (validationResult.name === 'top_bar_logo') {
							sa.components.topBar.setLogo({ path : '' });
							images.topBarLogo = '';
						} else if (validationResult.name === 'branding_header_logo') {
							sa.components.brandingHeader.setLogo({ path : '' });
							images.brandingHeaderLogo = '';
						} else if (validationResult.name === 'branding_header_background') {
							sa.components.brandingHeader.setBackground({ path : '' });
							images.brandingHeaderBackground = '';
						} else if (validationResult.name === 'login_logo') {
							images.loginLogo = '';
						} else if (validationResult.name === 'login_background') {
							images.loginBackground = '';
						} else if (validationResult.name === 'home_background') {
							images.homeBackground = '';
						} else if (validationResult.name === 'email_logo') {
							images.emailLogo = '';
						} else if (validationResult.name === 'favicon') {
							$j('link[rel=icon]').remove();
							$j('head').append('<link rel="icon" type="image/png" sizes="64x64" href="https://dm09pscvq9wc9.cloudfront.net/user_data/72/1507837737-72-r-64.png"/>');
							images.favicons = [];
						}
					}
				} else if (validationResult.name === 'branding_header_background_repeat') {
					images.brandingHeaderBackgroundRepeat = !!validationResult.value;
					if (images.brandingHeaderBackground) {
						updateBrandingHeaderBackground();
					}
				} else if (validationResult.name === 'home_background_repeat') {
					images.homeBackgroundRepeat = validationResult.value;
				} else if (validationResult.name === 'branding_header_full_width') {
					images.brandingHeaderFullWidth = !!validationResult.value;
					updateBrandingHeaderWidth();
				} else if (validationResult.name === 'branding_header_logo_position') {
					images.brandingHeaderLogoPosition = validationResult.value;
					sa.components.brandingHeader.setLogoPosition(validationResult.value);
				} else if (validationResult.name === 'banners_dynamic_background') {
					config.theme.bannersDynamicBackground = !!validationResult.value;
					images.bannersDynamicBackground = !!validationResult.value;
				} else {
					console.warn('unknown validation', validationResult);
				}
			}
		});

		return template;
	}

	function updateBrandingHeaderBackground() {
		sa.components.brandingHeader.setBackground({
			path: images.brandingHeaderBackground,
			options: {
				repeat: images.brandingHeaderBackgroundRepeat
			}
		});
	}

	function updateBrandingHeaderWidth() {
		sa.components.brandingHeader.setFullWidth(images.brandingHeaderFullWidth);
	}

	function renderBannerOptions($root) {
		for (let type of config.typesWithBanner) {
			if (type === 'project_item_list') type = 'playlist';

			const $options = templates.get('banner_type_options', {
				type,
				heading: gde(type, { case: 'upper', plural: true })
			});

			if (config.theme.bannerTypes[type]) {
				$options.find('input').data('value', config.theme.bannerTypes[type]);
			}

			$root.append($options);
		}
	}

	function getBannersTemplate() {
		// Add banner color options
		$bannerOptions = templates.get('page_banner_options');
		renderBannerOptions($bannerOptions.find('.options'));
		sa.forms.init($bannerOptions);
		// colorGroupContainer.before($bannerOptions)
		return $bannerOptions;
	}
	
	function getEmailsTemplate() {
		$emailOptions = templates.get('email_options');

		if (images.emailLogo) $emailOptions.find('#email_logo').data({ value: images.emailLogo });

		sa.forms.init($emailOptions, {
			realTimeValidation: true,
			realTimeValidationCallback: function (validationResult) {
				if (validationResult.uploader) {
					const uploader = validationResult.uploader;
					const files = uploader.getFileDetails();
					if (files.length) {
						const key = new Date().getTime();
						sa.showCover('Uploading image...');
						uploader.upload({
							params: 't=temp&key=' + key + '&source=' + validationResult.name,
							complete: function (e, response) { // success function
								sa.hideCover();
								uploader.removeAllFiles();
								let newPath;
								if (response && response[0] && response[0].file) {
									newPath = response[0].file;
								} else {
									newPath = user.userData.id + '-' + key + '.jpg';
								}
								newPath = 'https://sourceaudio-images.s3.amazonaws.com/temp/' + newPath;
								if (validationResult.name === 'email_logo') {
									images.emailLogo = newPath;
								}
							},
							error: function () { // error function
								sa.hideCover();
								console.log('error');
							},
							parseComplete: true
						});
					} else {
						// remove image
						if (validationResult.name === 'email_logo') {
							images.emailLogo = '';
						}
					}
				} else {
					console.warn('unknown validation', validationResult);
				}
			}
		});
		
		$emailOptions = setEmailColorOptions(config, $emailOptions);
		
		return $emailOptions;
	}
	
	function setEmailColorOptions(config, emailOptions) {
		if (config.theme.shareEmailBgColor) {
			emailOptions.find('#share_email_bg_color').data({ value: config.theme.shareEmailBgColor }).val(config.theme.shareEmailBgColor);
			emailOptions.find('#share_email_bg_color').closest('div').find('.color-picker-text-helper').val(config.theme.shareEmailBgColor);
		}
		if (config.theme.shareEmailHeaderBgColor) {
			emailOptions.find('#share_email_header_bg_color').data({ value: config.theme.shareEmailHeaderBgColor }).val(config.theme.shareEmailHeaderBgColor);
			emailOptions.find('#share_email_header_bg_color').closest('div').find('.color-picker-text-helper').val(config.theme.shareEmailHeaderBgColor);
		}
		if (config.theme.shareEmailTextColor) {
			emailOptions.find('#share_email_text_color').data({ value: config.theme.shareEmailTextColor }).val(config.theme.shareEmailTextColor);
			emailOptions.find('#share_email_text_color').closest('div').find('.color-picker-text-helper').val(config.theme.shareEmailTextColor);
		}

		// Change Input when colors change
		emailOptions.find('#share_email_bg_color, #share_email_header_bg_color, #share_email_text_color').on('change input', function () {
			$j(this).closest('div').find('.color-picker-text-helper').val($j(this).val());
		});

		// Change colors when input changes
		emailOptions.find('.color-picker-text-helper').on('change', function () {
			const color = $j(this).val() || '#FFFFFF';
			$j(this).closest('div').find('input[type="color"]').val(color);
		});

		emailOptions.find('.color-picker-text-helper').on('keyup', function () {
			const color = $j(this).val() || '#FFFFFF';
			if (color.length < 7) return;

			$j(this).closest('div').find('input[type="color"]').val(color);
		});
		
		return emailOptions;
	}

	function getColorsTemplate() {
		let appearanceData;
		const template = templates.get('colors_editor');
		const colorGroupContainer = template.find('.color_groups');
		let currentThemeId;

		sa.api.request({
			handler: 'settings',
			action: 'get-appearance'
		}).then(function (data) {
			appearanceData = data;
			const defaultTheme = parseTheme(appearanceData.defaultTheme);
			const siteTheme = parseTheme(appearanceData.siteTheme);
			const colorDetails = appearanceData.colorDetails;

			// Get the current themes ID
			currentThemeId = appearanceData.hasOwnProperty('themeId') ? appearanceData['themeId'] : 'custom';
			themeId = currentThemeId;

			buildThemeSelector(template, currentThemeId, siteTheme);

			themeBase = appearanceData.themeBase;
			currentTheme = $j.extend(defaultTheme, siteTheme);

			// modern browsers support <input type="color" /> but IE doesn't. since I don't want to write and support
			// two versions of this, we're just going to use colorPicker until we can ditch IE
			loadScript(ExtraScripts.colorPicker, function () {

				// assign colors into groups
				const colorGroups = {};
				for (const colorName in colorDetails) {
					if (!colorDetails.hasOwnProperty(colorName)) continue;
					/** @var {{ nonEditable : boolean, grouping : string, hideOn : <Array.string>, alpha : boolean }} */
					const colorDetail = colorDetails[colorName];
					if (colorDetail.nonEditable || (colorDetail.hideOn && colorDetail.hideOn.indexOf(config.siteType) !== -1)) continue;
					if (!colorGroups[colorDetail.grouping]) {
						colorGroups[colorDetail.grouping] = { colors : [] };
					}
					let currentColor = currentTheme[colorName];
					if (colorDetail.alpha && currentColor.indexOf('#') === 0) {
						currentColor = convertHexaToRGBA(currentColor);
					}
					colorGroups[colorDetail.grouping].colors.push({ name : colorName, color : currentColor, detail : colorDetail });
				}

				for (const key in colorGroups) {
					if (!colorGroups.hasOwnProperty(key)) continue;
					addColorGroup(key, colorGroups[key].colors, colorGroupContainer);
				}

				sa.forms.init(colorGroupContainer);

				const examples = templates.get('color_examples');
				showLoader(examples, 'Loading bar example');
				colorGroupContainer.append(examples);
			});
		});

		// let them reset in case they mess everything up
		template.find('#reset_colors').on('click', () => {
			resetColors(appearanceData);
		});

		template.find('.color-buttons .save_button').on('click', function () {
			if ($j(this).css('opacity') !== 0) {
				saveChanges();
			}
		});

		template.find('.color-buttons .reset-colors').on('click', () => {
			resetColors(appearanceData);
		});

		template.find('.color-buttons .reset_button').on('click', function () {
			if ($j(this).css('opacity') !== 0) {
				reset();
			}
		});

		template.find('.color-buttons .save_theme_as_json').on('click', () => {
			saveThemeAsJSON();
		});

		function loadJSONColorTheme(themeJSON) {
			loadThemeColors(themeJSON);

			// Clear the file input
			const file = document.getElementById('colorJSONFile');
			file.value = '';
		}

		// Allows for uploading a custom theme file
		template.find('#uploadColorThemeJSON').on('click', () => {
			const file = document.getElementById('colorJSONFile');
			if (!file.files[0]) {
				alert('No File added');
				return;
			}

			const reader = new FileReader();
			reader.addEventListener('load', function (e) {
				const json = JSON.parse(e.target.result);
				loadJSONColorTheme(json);
			});

			reader.readAsText(file.files[0]);
		});

		return template;
	}

	/**
	 * Create a themes thumbnail HTML/Styling from theme palette
	 *
	 * @param palette
	 * @returns {*}
	 */
	function buildThemeThumbnail(palette) {
		// Convert the theme name into a usable ID
		const paletteId = palette.name
			.split(' ')
			.join('_')
			.replace(/[^a-zA-Z\d]/g, '')
			.toLowerCase();

		// Get the theme thumbnail template
		const themeThumbnail = templates.get('themeThumbnail', { 'theme-name': paletteId });

		// Map the correct colors from the theme to the thumbnail elements
		themeThumbnailMap.forEach(thumbnailInfo => {
			let color = palette.colors.find(color => color.colorInputId === thumbnailInfo.colorPickerId);
			if (!color) return;
			color = `#${color.color}`;

			const isTextColor = thumbnailInfo.type === 'textColor';
			const colorPropToChange = isTextColor ? 'color' : 'background-color';

			themeThumbnail.find(thumbnailInfo.selector).css(colorPropToChange, color);
		});

		const paletteWrap = $j('<div class="palette-wrap" data-palette-id="' + paletteId + '"></div>');

		const colors = $j('<div class="palette-colors-wrap"></div>');

		// Get the primary colors from the theme (most used colors)
		const primaryColors = getPrimaryColorsFromTheme(palette.colors);

		// Loop through the primary colors to build palette swatches
		primaryColors.forEach(color => {
			color = `#${color}`;
			const colorEl = $j('<div class="palette-color"></div>');
			colorEl.css('background-color', color);
			colors.append(colorEl);
		});

		// Build up the HTML structure
		const paletteNameWrap = $j('<div class="palette-name-wrap"></div>');
		paletteNameWrap.append('<input type="radio" name="palette-options" id="'+ paletteId +'" />');
		paletteNameWrap.append('<span class="palette-name">'+ palette.name  +'</span>');
		paletteWrap.append(paletteNameWrap);
		paletteWrap.append(themeThumbnail);
		paletteWrap.append(colors);

		// Set up click handler to change the theme
		paletteWrap.on('click', function () {
			const id = $j(this).data('palette-id');
			themeId = id;

			setActiveTheme(id);

			sa.showCover('Changing Theme...');

			// Load theme colors
			// The setTimeout is to allow the modal to load. Without it, it lags and freezes.
			setTimeout(() => {
				loadThemeColors(palette.colors);
				sa.hideCover();
			}, 400);
		});

		return paletteWrap;
	}

	/**
	 * Generate a custom theme object to build theme selector from
	 *
	 * @param themeObj
	 * @returns {array}
	 */
	function buildCustomThemeObj(themeObj) {
		const customTheme = {
			Custom: []
		};

		for (const colorVar in themeObj) {
			const color = themeObj[colorVar];
			const colorVarName = colorVar.replace('@', '');
			const colorId = 'color_' + colorVarName;

			const name = colorVarName[0].toUpperCase() + colorVarName.slice(1, colorVarName.length);

			customTheme.Custom.push({
				color: color.replace('#', ''),
				colorInputId: colorId,
				name: name
			});
		}

		return customTheme;
	}

	/**
	 * Build out the HTML for the theme selector section
	 *
	 * @param template
	 * @param currentThemeId
	 * @param siteTheme
	 */
	function buildThemeSelector(template, currentThemeId, siteTheme) {
		// Check if currentThemeId is valid
		const themeNameValid = availableColorThemeIds.includes(currentThemeId);
		if (!themeNameValid) currentThemeId = 'custom';

		let themes = self.allThemes;
		const customTheme = buildCustomThemeObj(siteTheme);

		themes = Object.assign(themes, customTheme);

		const colorPalettes = [];

		Object.keys(themes).forEach(theme => {
			colorPalettes.push({
				name: theme,
				colors: themes[theme]
			});
		});

		const palettes = $j('<div class="palettes"></div>');

		colorPalettes.forEach(palette => {
			const paletteWrap = buildThemeThumbnail(palette);
			palettes.append(paletteWrap);
		});

		const themeSelectorEl = template.find('.theme-selector');
		themeSelectorEl.append(palettes);

		setActiveTheme(currentThemeId);
	}

	/**
	 * Pulls the top used colors from a color palette
	 *
	 * @param {array} themeColors
	 * @returns {array} The top 4-5 colors in an array
	 */
	function getPrimaryColorsFromTheme(themeColors) {
		let paletteColors = [];

		themeColors.forEach(color => {
			if (themePaletteMap.includes(color.colorInputId)) {
				paletteColors.push(color.color.toLowerCase());
			}
		});

		paletteColors = [...new Set(paletteColors)];

		return paletteColors.slice(0, Math.min(5, paletteColors.length));
	}

	/**
	 * Loops through each color picker and sets the new color from the theme
	 *
	 * @param colorThemeObj
	 */
	function loadThemeColors(colorThemeObj) {
		delayThemeApplication();
		colorThemeObj.forEach(color => {
			const el = document.getElementById(color.colorInputId);
			if (!el) return;

			// This has to be done to correctly change the jPicker colors
			const colorHex = color.color;
			const colorType = colorHex.length === 6 ? 'hex' : 'ahex';
			el.color.active.val(colorType, colorHex, 'test');
		});
		applyDelayedTheme();
	}

	/**
	 * Handles setting (and unsetting) the active theme
	 *
	 * @param themeSelector
	 */
	function setActiveTheme(themeSelector = null) {
		themeId = themeSelector || (themeId || 'custom');

		$j('[name="palette-options"]').prop('checked', false);

		themeSelector = themeId.includes('#') ? themeId : `#${themeId}`;

		$j(themeSelector).prop('checked', true);

		$j('.palette-wrap').removeClass('active');
		$j(themeSelector).closest('.palette-wrap').addClass('active');
	}

	/**
	 * Compares to theme strings against one another to check if the theme has been changed
	 * If the active theme and the current combination of colors don't match, it sets the
	 * current theme as "Custom"
	 */
	function checkColorMatch() {
		// Get all the colors currently set in the theme editor
		let currentInputColors = [...document.querySelectorAll('.color input')];
		currentInputColors = currentInputColors.map(colorInput => colorInput.value.toLowerCase());
		const currentInputColorList = [...currentInputColors];
		currentInputColors = currentInputColors.toString();

		let themeName;

		// Loop through other themes and check against the currently configured colors
		for (const theme in self.allThemes) {
			if (theme.toLowerCase() === 'custom') continue;

			let themeColors = self.allThemes[theme];

			themeColors = themeColors.map(color => {
				return color.color.toLowerCase();
			});

			const themeColorList = [...themeColors];

			themeColors = themeColors.toString();

			if (currentInputColors === themeColors) {
				themeName = theme;
			} else {
				// Check if the colors are the same but in a different order
				let newThemeColorList = themeColorList.map(color => {
					if (color.length > 6) return color.slice(0, -2);
					return color;
				});
				let newCurrentInputColorList = currentInputColorList.map(color => {
					if (color.length > 6) return color.slice(0, -2);
					return color;
				});
				newThemeColorList.sort();
				newCurrentInputColorList.sort();
				newThemeColorList = newThemeColorList.toString();
				newCurrentInputColorList = newCurrentInputColorList.toString();

				if (newCurrentInputColorList === newThemeColorList) {
					themeName = theme;
				}
			}
		}

		themeName = themeName || 'custom';
		themeName = themeName.split(' ')
			.join('_')
			.replace(/[^a-zA-Z\d]/g, '')
			.toLowerCase();

		if (themeName === 'custom') {
			setActiveTheme('custom');
		} else {
			setActiveTheme(themeName);
		}
	}

	/**
	 * Saves a JSON file of all the theme information
	 */
	function saveThemeAsJSON() {
		// Get all the current colors from the color inputs
		const colors = [...document.querySelectorAll('.colors input')];

		// Build the theme object for export
		const colorData = [];
		colors.forEach(color => {
			let name = color.id.replace('color_', '');
			name = name.split('Color');
			name = name[0].charAt(0).toUpperCase() + name[0].slice(1);

			colorData.push({
				name: name,
				colorInputId: color.id,
				color: color.value
			});
		});

		// Create the download blob and download it
		const url = window.URL.createObjectURL(new Blob([JSON.stringify(colorData, undefined, 2)], { type: 'application/json' }));
		const downloadLink = document.createElement('a');
		downloadLink.style.display = 'none';
		downloadLink.href = url;
		downloadLink.download = 'color-theme.json';
		document.body.appendChild(downloadLink);
		downloadLink.click();
		window.URL.revokeObjectURL(url);
	}

	function resetColors(appearanceData) {
		const realDefaultTheme = parseTheme(appearanceData.defaultTheme);
		for (const colorSelector in realDefaultTheme) {
			if (!realDefaultTheme.hasOwnProperty(colorSelector)) continue;
			const input = $j('#color_' + colorSelector.substring(1));
			if (input.length) {
				const colorHex = convertRGBAToHex(realDefaultTheme[colorSelector]).replace('#', '');
				const colorType = colorHex.length === 6 ? 'hex' : 'ahex';
				input[0].color.active.val(colorType, colorHex);
			}
		}

		// Select default theme on reset
		setActiveTheme('sourceaudio');
	}

	function addColorGroup(name, colorGroup, container) {
		const template = templates.get('color_group', { name: name });
		const colorContainer = template.find('.colors');

		colorGroup.each((i, colorData) => {
			addColor(colorData.name, colorData.color, colorContainer);
		});

		colorContainer.append('<div class="clr"></div>');
		container.append(template);
	}

	function convertHexaToRGBA(hexa) {
		const components = $j.jPicker.ColorMethods.hexToRgba(hexa);
		return 'rgba(' + components.r + ',' + components.g + ',' + components.b + ',' + (components.a / 255) + ')';
	}

	function convertRGBAToHex(rgba) {
		const match = rgba.match(/rgba\(([0-9]+), *([0-9]+), *([0-9]+), *([.0-9]+)\)/);
		if (match) {
			const components = {
				r: parseInt(match[1]),
				g: parseInt(match[2]),
				b: parseInt(match[3]),
				a: parseFloat(match[4]) * 255
			};
			return '#' + $j.jPicker.ColorMethods.rgbaToHex(components);
		}
		return rgba;
	}

	function addColor(name, color, container) {
		const id = name.substring(1);
		const displayName = name.replace('Color', '').substring(1).replace(/([A-Z])/g, ' $1').ucfirst();
		const template = templates.get('color', { id: id, name: displayName });

		const input = template.find('input');
		const colorHex = convertRGBAToHex(color).replace('#', '');
		const colorType = 'ahex';
		input.val(colorHex).jPicker(
			{
				window: {
					title: `${displayName} Color`,
					effects: {
						type: 'fade',
						speed: {
							show: 'slow',
							hide: 'fast'
						}
					},
					position: {
						x: 'screenCenter',
						y: 'center'
					},
					positionFunctions: {
						top: function () {
							return input.offset().top - 150;
						},
						left: function () {
							return input.offset().left + 275;
						}
					},
					alphaSupport : true
				},
				images: {
					clientPath: 'images/jpicker/'
				},
				color: {
					active: new $j.jPicker.Color((function () {
						const args = {};
						args[colorType] = colorHex;
						return args;
					})())
				}
			},
			function(newColor) {
				checkColorMatch();
				// checkForNewColor(newColor, input, colorType);
			},
			function (newColor) {
				if (!delayedThemeApplication) {
					checkColorMatch();
				}
				// checkForNewColor(newColor, input, colorType);

				let hexColor = newColor.val(colorType);
				if (hexColor === '') {
					const defaultValue = colorType === 'ahex' ? 'FFFFFFFF' : 'FFFFFF';
					input.val(defaultValue);
					hexColor = defaultValue;
				}

				currentTheme[name] = '#' + hexColor;

				applyTheme(currentTheme);
			}
		);
		// if (colorType === 'ahex') {
		// 	input.val(colorHex.substring(0, 6));
		// }

		const checkColor = new $j.jPicker.Color();
		checkColor.val(colorType, colorHex);

		container.append(template);
	}

	function getLayoutTemplate() {
		const template = templates.get('layout_editor');

		layoutTheme.navAlignment = config.theme.navAlignment;
		if (layoutTheme.navAlignment) {
			template.find(`#${layoutTheme.navAlignment}-align-nav`).prop('checked', true);
		}

		sa.forms.init(template, {
			realTimeValidation: true,
			realTimeValidationCallback: function (validationResult) {
				if (validationResult.name === 'align-nav') {
					const checkedInput = validationResult.input.filter(function () {
						return $j(this).prop('checked');
					});

					const alignment = checkedInput.val();
					sa.components.nav.alignNav(alignment);
					layoutTheme.navAlignment = alignment;
				}
			}
		});

		return template;
	}

	function parseTheme(themeData) {
		const themeColors = {};
		themeData.split('!').each((i, colorString) => {
			const atIndex = colorString.lastIndexOf('@');
			if (atIndex !== -1) {
				themeColors[colorString.substring(atIndex)] = colorString.substring(0, atIndex);
			}
		});
		return themeColors;
	}

	let delayedThemeApplication = false;
	let lastTheme = null;
	function delayThemeApplication() {
		console.log('delaying theme application');
		delayedThemeApplication = true;
	}

	function applyDelayedTheme() {
		console.log('applying delayed theme');
		delayedThemeApplication = false;
		applyTheme(lastTheme);
		checkColorMatch();
	}

	function applyTheme(theme) {

		if (delayedThemeApplication) {
			lastTheme = theme;
			return;
		}

		let themeString = themeBase;
		for (const key in theme) {
			if (!theme.hasOwnProperty(key)) continue;
			let color = theme[key];
			if (color.length === 9) {
				const components = $j.jPicker.ColorMethods.hexToRgba(color);
				color = 'rgba(' + components.r + ',' + components.g + ',' + components.b + ',' + (components.a / 255) + ')';
			} else if (color.indexOf('@') !== -1) {
				continue;
			}
			themeString = themeString.replace(new RegExp(key, 'g'), color);
		}

		if (delayedThemeApplication) {
			lastThemeString = themeString;
			return;
		}

		console.log('applying theme');
		$j('#temp_theme').remove();
		$j('head').append('<style id="temp_theme">' + themeString + '</style>');
		sa.updateFooterColor();
	}

	async function saveChanges() {

		const validationResult = sa.forms.validate($j('.terminology_editor'));
		if (validationResult.error) return;

		themeId = themeId || '';

		const validateBanners = sa.forms.validate($bannerOptions);
		const validateEmails = sa.forms.validate($emailOptions);

		let values = $j.extend(validationResult.values, { colors: currentTheme, images: images });
		values = $j.extend(values, layoutTheme);
		values = $j.extend(values, { themeId: themeId });

		console.log(validateEmails);
		if (validateEmails && validateEmails.errors.length === 0) {
			values = $j.extend(values, validateEmails.values);
			
			config.theme.shareEmailBgColor = validateEmails.values.share_email_bg_color;
			config.theme.shareEmailHeaderBgColor = validateEmails.values.share_email_header_bg_color;
			config.theme.shareEmailTextColor = validateEmails.values.share_email_text_color;
		}
		
		if (validateBanners && validateBanners.errors.length === 0) {
			values = $j.extend(values, validateBanners.values);

			for (let type of config.typesWithBanner) {
				if (type === 'project_item_list') {
					type = 'playlist';
				}
				// update theme
				config.theme.bannerTypes[type] = validateBanners.values[`${type}_banner_type`];
			}
		}

		sa.showCover('Saving...');

		await sa.api.request({
			handler: 'settings',
			action: 'save-appearance',
			postData: values
		});

		sa.hideCover();
		sa.notify({ text : 'Changes saved! You might need to reload to see all your changes', type : sa.notify.notificationTypes.success });
		for (const logoName in images) {
			if (!images.hasOwnProperty(logoName)) continue;
			if (logoName === 'favicons') {
				config.theme.favicons = [];
				images.favicons.each((i, faviconPath) => {
					config.theme.favicons.push({
						path: faviconPath,
						options: {}
					});
				});
			} else {
				const dontAddPath = ['bannersDynamicBackground'];
				if (dontAddPath.includes(logoName)) {
					config.theme[logoName] = images[logoName];
				} else {
					config.theme[logoName] = {
						path: images[logoName],
						options: {}
					};
				}
			}
		}

		config.theme.homeBackground.options.repeat = images.homeBackgroundRepeat;
		config.theme.brandingHeaderBackground.options.repeat = images.brandingHeaderBackgroundRepeat;
	}

	/**
	 * Resets the stylesheet
	 */
	function reset() {
		window.location.reload();
	}

	function getTerminologyEditingTemplate() {
		const template = templates.get('terminology_editing');

		let i = 0;
		for (const term in config.dictionary) {
			if (!config.dictionary.hasOwnProperty(term)) continue;
			const termTemplate = templates.get('term', { term : term, termName : term.ucfirst(), num : i });
			termTemplate.find('.singular').val(config.dictionary[term]['singular']);
			termTemplate.find('.plural').val(config.dictionary[term]['plural']);
			template.append(termTemplate);
			i++;
		}

		template.append('<div class="clr"></div>');

		sa.forms.init(template);

		return template;
	}
}
/**
 * The page in the admin panel that lets you change the fields for your cue sheets
 */
function AdminSettingsCueSheets() {
	
	let page = this;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		container.html(
			'<div class="section">'
				+ '<h2>Cue Sheet Fields</h2>'
				+ '<div id="cue_sheet_fields" class="section">Loading...</div>'
				+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="section">'
				+ '<h2>Cue Sheet Track Fields</h2>'
				+ '<div id="cue_sheet_track_fields" class="section">Loading...</div>'
				+ '<div class="clr"></div>'
			+ '</div>'
			+ '<div class="section"><div class="clr"></div></div>')
			.find('.clr:last').before($j(createButton('Save Changes', '', '', '#0', function() { page.save(); return false; })));
		this.loadCueSheetOptions();
	};

	/**
	 * Loads the current cue sheet options from the server
	 */
	this.loadCueSheetOptions = function() {
		sa.api.request({
			handler : 'settings',
			action : 'get-cuesheets'
		}).then(page.setCueSheetOptions);
			
	};

	/**
	 * Populates the cue sheet options using the list from the server
	 * @param {{ cueSheetFields : Array, trackFields : Array, columns: Array }} data the information about the cue sheet options
	 */
	this.setCueSheetOptions = function(data) {
		console.log('cue sheet options:', data);
		var cueSheetFields = data.cueSheetFields,
			trackFields = data.trackFields,
			trackColumns = data.columns,
			trackColumnString = '',
			cueSheetFieldsContainer = $j('#cue_sheet_fields'),
			cueSheetTrackFieldsContainer = $j('#cue_sheet_track_fields'),
			fieldContainer = null,
			trackFieldContainer = null;

		// set up the section and interactions for the fields that will be cue-sheet specific
		cueSheetFieldsContainer.html(
			'<div class="information top">Set what fields each cue sheet should list at the top.</div>'
			+ '<div class="field_container"><div class="header field"><div class="name">Name</div><div class="options">Options</div><div class="clr"></div></div></div>'
		);
		fieldContainer = cueSheetFieldsContainer.find('.field_container');
		for (let i = 0, len = cueSheetFields.length; i < len; i++) {
			let field = cueSheetFields[i];
			fieldContainer.append(
				'<div class="field cue_sheet_field field_' + field.id + '">'
					+ '<div class="name subsection"><input type="text" value="' + field.name + '"/></div>'
					+ '<div class="options subsection">'
						+ '<span class="icon fa fa-arrow-up faux_button up"></span>'
						+ '<span class="icon fa fa-arrow-down faux_button down"></span>'
						+ '<span class="icon fa fa-times faux_button delete"></span>'
					+ '</div>'
				+ '<div class="clr"></div></div>'
			);
		}
		if (!cueSheetFields.length) {
			fieldContainer.append(
					'<div class="field empty">'
						+ '<div class="name subsection">Use the "New Field" button to add some fields.</div>'
					+ '<div class="clr"></div></div>'
				);
		}
		page.restripe(fieldContainer);
		fieldContainer.find('.up').on('click', function() { page.moveField($j(this).parent().parent(), -1); });
		fieldContainer.find('.down').on('click', function() { page.moveField($j(this).parent().parent(), 1); });
		fieldContainer.find('.delete').on('click', function() { page.deleteField($j(this).parent().parent()); });
		cueSheetFieldsContainer.append(createButton('New Field', 'new_field', '', getDefaultLink(), function() {
			var newField = $j('<div class="field cue_sheet_field field_0">'
					+ '<div class="name subsection"><input type="text" value=""/></div>'
					+ '<div class="options subsection">'
						+ '<span class="icon fa fa-arrow-up faux_button up"></span>'
						+ '<span class="icon fa fa-arrow-down faux_button down"></span>'
						+ '<span class="icon fa fa-times faux_button delete"></span>'
					+ '</div>'
				+ '<div class="clr"></div></div>');
			newField.find('.up').on('click', function() { page.moveField($j(this).parent().parent(), -1); });
			newField.find('.down').on('click', function() { page.moveField($j(this).parent().parent(), 1); });
			newField.find('.delete').on('click', function() { page.deleteField($j(this).parent().parent()); });
			fieldContainer.find('.field:last').after(newField);
			fieldContainer.find('.empty').remove();
			newField.find('input').trigger('focus');
			page.restripe(fieldContainer);
		}));

		// set up the track specific fields
		for (let i = 0, len = trackColumns.length; i < len; i++) {
			trackColumnString += '<option value="' + trackColumns[i].id + '">' + trackColumns[i].name + '</option>';
		}
		cueSheetTrackFieldsContainer.html(
			'<div class="information top">Set what fields each track in the cue sheet should show.<br/><b>Name</b> and <b>Values</b> are only applicable to "User Entered" type fields</div>'
			+ '<div class="field_container"><div class="header field"><div class="type">Type</div><div class="name">Name</div><div class="values">Values</div>'
				+ '<div class="options">Options</div><div class="clr"></div></div></div>'
		);
		trackFieldContainer = cueSheetTrackFieldsContainer.find('.field_container');
		for (var i = 0, len = trackFields.length; i < len; i++) {
			var field = trackFields[i];
			trackFieldContainer.append(
				'<div class="field cue_sheet_track_field field_' + field.id + '">'
					+ '<div class="type subsection"><select>' + trackColumnString.replace('value="' + field.type + '"', 'value="' + field.type + '" selected="selected"') + '</select></div>'
					+ '<div class="name subsection"><input type="text" value="' + field.name + '"' + (field.type != 'user_entered' ? ' disabled="disabled"' : '') + '/></div>'
					+ '<div class="values subsection"><input type="text" value="' + field.values + '"' + (field.type != 'user_entered' ? ' disabled="disabled"' : '') + '/></div>'
					+ '<div class="options subsection">'
						+ '<span class="icon fa fa-arrow-up faux_button up"></span>'
						+ '<span class="icon fa fa-arrow-down faux_button down"></span>'
						+ '<span class="icon fa fa-times faux_button delete"></span>'
					+ '</div>'
					+ '<div class="notes"' + (field.type == 'user_entered' ? '' : ' style="display: none"') + '><b>Name</b> is the name you want the field to have when the user enters it.<br/>'
						+ '<b>Values</b> is all the values you want people to be able to enter for this field. They will also be able to enter an arbitrary value so you don\'t have to put anything here.<br/>'
							+ '<b>Values should be separated with ;</b></div>'
				+ '<div class="clr"></div></div>'
			);
		}
		if (!trackFields.length) {
			trackFieldContainer.append(
					'<div class="field empty">'
						+ '<div class="name subsection">Use the "New Field" button to add some fields.</div>'
					+ '<div class="clr"></div></div>'
				);
		}
		page.restripe(trackFieldContainer);
		trackFieldContainer.find('.up').on('click', function() { page.moveField($j(this).parent().parent(), -1); });
		trackFieldContainer.find('.down').on('click', function() { page.moveField($j(this).parent().parent(), 1); });
		trackFieldContainer.find('.delete').on('click', function() { page.deleteField($j(this).parent().parent()); });
		trackFieldContainer.find('select').on('change', function() {
			if (this.value == 'user_entered') {
				$j(this).parent().parent().find('input').prop('disabled', false).end().find('.notes').show();
			} else {
				$j(this).parent().parent().find('input').prop('disabled', true).end().find('.notes').hide();
			}
		});
		cueSheetTrackFieldsContainer.append(createButton('New Field', 'new_field', '', getDefaultLink(), function() {
			var newField = $j('<div class="field cue_sheet_track_field field_0">'
					+ '<div class="type subsection"><select>' + trackColumnString + '</select></div>'
					+ '<div class="name subsection"><input type="text" value="" disabled="disabled"/></div>'
					+ '<div class="values subsection"><input type="text" value="" disabled="disabled"/></div>'
					+ '<div class="options subsection">'
						+ '<span class="icon fa fa-arrow-up faux_button up"></span>'
						+ '<span class="icon fa fa-arrow-down faux_button down"></span>'
						+ '<span class="icon fa fa-times faux_button delete"></span>'
					+ '</div>'
					+ '<div class="notes" style="display: none"><b>Name</b> is the name you want the field to have when the user enters it.<br/>'
						+ '<b>Values</b> is all the values you want people to be able to enter for this field. They will also be able to enter an arbitrary value so you don\'t have to put anything here.<br/>'
							+ '<b>Values should be separated with ;</b></div>'
				+ '<div class="clr"></div></div>');
			newField.find('.up').on('click', function() { page.moveField($j(this).parent().parent(), -1); });
			newField.find('.down').on('click', function() { page.moveField($j(this).parent().parent(), 1); });
			newField.find('.delete').on('click', function() { page.deleteField($j(this).parent().parent()); });
			newField.find('select').on('change', function() {
				if (this.value == 'user_entered') {
					$j(this).parent().parent().find('input').prop('disabled', false).end().find('.notes').show();
				} else {
					$j(this).parent().parent().find('input').prop('disabled', true).end().find('.notes').hide();
				}
			});
			trackFieldContainer.find('.field:last').after(newField);
			trackFieldContainer.find('.empty').remove();
			page.restripe(trackFieldContainer);
		}));
	};

	/**
	 * Removes a row from the displayed list
	 * @param {JQuery} row the row to delete
	 */
	this.deleteField = function(row) {
		var cont = row.parent();
		row.remove();
		if (cont.find('.field').length < 2) {
			cont.append(
					'<div class="field empty">'
						+ '<div class="name subsection">Use the "New Field" button to add some fields.</div>'
					+ '<div class="clr"></div></div>'
				);
		}
		this.restripe(cont);
	};

	/**
	 * Moves a row up or down
	 * @param {JQuery} row the row to move
	 * @param {int} direction -1 is up, 1 is down
	 */
	this.moveField = function(row, direction) {
		if (direction == -1) {
			var prev = row.prev('.field:not(.header)');
			if (prev) {
				prev.before(row);
			}
		} else {
			var next = row.next('.field');
			if (next) {
				next.after(row);
			}
		}
		this.restripe(row.parent());
	};

	/**
	 * Stripes the fields in the passed in element
	 * @param {JQuery} container
	 */
	this.restripe = function(container) {
		container.find('.field').removeClass('stripe');
		container.find('.field:odd').addClass('stripe');
	};

	/**
	 * Saves changes to a white label's basic information after performing form validation
	 */
	this.save = function() {
		let cueSheetFields = $j('.cue_sheet_field');
		let cueSheetTrackFields = $j('.cue_sheet_track_field');
		let postData = { cueSheetFields : [], trackFields : [] };
		for (let i = 0, len = cueSheetFields.length; i < len; i++) {
			let field = $j(cueSheetFields[i]),
				fieldId = field.attr('class').match(/field_([0-9]+)/),
				name = String(field.find('input').val());
			if (!name) continue;
			postData.cueSheetFields.push({ field_id : fieldId[1], name : name });
		}
		for (let i = 0, len = cueSheetTrackFields.length; i < len; i++) {
			let field = $j(cueSheetTrackFields[i]),
				type = String(field.find('select').val()),
				fieldId = field.attr('class').match(/field_([0-9]+)/);
			let fieldData = {
				field_id: fieldId[1],
				type : type
			};
			if (type === 'user_entered') {
				fieldData.name = String(field.find('input:first').val());
				fieldData.values = String(field.find('input:last').val());
			}
			postData.trackFields.push(fieldData);
		}
		sa.api.request({
			handler : 'settings',
			action : 'save-cuesheets',
			postData : postData
		}).catch(e => {
			sa.alert(e.message);
		}).then(() => {
			sa.notify({ text : 'Changes saved! You might need to reload to see all your changes', type : sa.notify.notificationTypes.success });
		});
	};

}
/**
 * The page in the admin panel that lets you change the items that appear in your left nav
 */
function AdminSettingsFilters() {
	
	let filterType = 'track';
	let templates;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		let vars = sa.router.getCurrentParamsAsObject();
		if (!templates) {
			templates = sa.templates.get('admin.settings.filters');
		}
		container.empty();
		if (vars.type == 'album') {
			filterType = 'album';
		} else {
			filterType = 'track';
		}
		container.append(templates.get(filterType + '_page'));
		loadFilters();
	};

	/**
	 * @typedef {Object} CurrentFilter
	 * @property {string} type
	 * @property {int} customFieldId
	 * @property {string} parentType
	 * @property {int} parentCustomFieldId
	 */

	/**
	 * @typedef {Object} AvailableFilter
	 * @property {string} name
	 * @property {int} customFieldId
	 * @property {string} type
	 */
	
	/**
	 * Loads the current filters options from the server
	 */
	async function loadFilters() {
		const filters = await sa.api.request({
			handler : 'settings',
			action : 'get-filters',
			getData : { type : filterType }
		});


		let availableContainer = $j('#available_filters ol');
		let currentContainer = $j('#current_filters ol');
		let availableList = filters['all'];
		let currentList = filters['current'];

		for (let i = 0, len = currentList.length; i < len; i++) {
			/** @var {CurrentFilter} filter */
			let filter = currentList[i];

			// the server sends in vars as child > parent but we really need parent > child so these new five vars flip that around
			let hasChild = !!filter.parentType;
			let type = hasChild ? filter.parentType : filter.type;
			let customFieldId = hasChild ? filter.parentCustomFieldId : filter.customFieldId;
			let childType = hasChild ? filter.type : '';
			let childCustomFieldId = hasChild ? filter.customFieldId : 0;

			let matchType = type == 'custom' ? 'custom_' + customFieldId : type;
			/** @var {AvailableFilter|null} realFilter */
			let realFilter = null;
			let noNest = type == 'length' || type == 'release_date';
			// find it in the available list
			for (let a = 0, aLen = availableList.length; a < aLen; a++) {
				if (availableList[a].type == matchType && availableList[a].customFieldId == customFieldId) {
					realFilter = availableList[a];
					availableList.splice(a, 1);
					break;
				}
			}
			if (!realFilter) {
				console.log('unable to find real filter for ', filter);
				continue;
			}
			let filterTemplate = templates.get('filter', {
				title : realFilter.name,
				name : realFilter.name.replace('Custom: ', '')
			});
			filterTemplate.data('type', realFilter.type);
			if (noNest) {
				filterTemplate.addClass('no-nest');
			}
			currentContainer.append(filterTemplate);
			// see if there's a child element
			if (childType) {
				let matchType = childType == 'custom' ? 'custom_' + childCustomFieldId : childType;
				/** @var {AvailableFilter|null} realFilter */
				let realFilter = null;
				// find it in the available list
				for (let a = 0, aLen = availableList.length; a < aLen; a++) {
					if (availableList[a].type == matchType) {
						realFilter = availableList[a];
						availableList.splice(a, 1);
						break;
					}
				}
				if (!realFilter) {
					console.log('unable to find real child filter for ', filter);
					continue;
				}
				currentContainer.find('li:last').append($j('<ol>').append(templates.get('filter', {
					title : realFilter.name,
					name : realFilter.name.replace('Custom: ', '')
				}).data('type', realFilter.type)));
			}
		}
		availableList.each(
			/**
			 * @param {int} i
			 * @param {AvailableFilter} filter
			 */
			function (i, filter) {
			
			let noNest = filter.type == 'length' || filter.type == 'release_date' || filter.type == 'moods' || filter.type == 'styles' || filter.type == 'key';
			let filterTemplate = templates.get('filter', {
				title : filter.name,
				name : filter.name.replace('Custom: ', '')
			});
			filterTemplate.data('type', filter.type);
			if (noNest) {
				filterTemplate.addClass('no-nest');
			}
			availableContainer.append(filterTemplate);
		});
		$j('#filter_container').append(templates.get('save_button').on('click', function () {
			save();
		}));
		// make them draggable
		loadScript(ExtraScripts.nestedSortable, function () {
			$j('.filter_column ol').nestedSortable({
				connectWith : '.filter_column ol',
				placeholder : 'filter_placeholder',
				maxLevels : 2,
				errorClass : 'filter_placeholder_error',
				disableNesting : 'no-nest',
				isAllowed : function (placeholder, placeholderParent) {
					if (!placeholderParent) return true;
					return !(placeholderParent.hasClass('no-nest') || placeholderParent.find('.left_nav_component:not(.ui-sortable-helper)').length || placeholderParent.parents('.ui-sortable').length > 1);
				}
			}).disableSelection();
		});
	}
	
	/**
	 * Saves changes to a white label's basic information after performing form validation
	 */
	function save() {
		let postData = { type : filterType, filters : [] };
		$j('#current_filters ol:first').children().each(function(i, filter) {
			let filterData = {};
			let jFilter = $j(filter);
			let subFilter = jFilter.find('li');
			if (subFilter.length) {
				filterData.parent = jFilter.data('type');
				jFilter = subFilter;
			}
			filterData.type = jFilter.data('type');
			postData.filters[i] = filterData;
		});
		sa.api.request({
			handler : 'settings',
			action : 'save-filters',
			postData : postData
		}).then(function() {
			sa.notify({ text : 'Changes saved! You might need to reload to see all your changes', type : sa.notify.notificationTypes.success });
		}).catch(e => {
			sa.alert(e.message);
		});
	}
	
}
/**
 * The page in the admin panel that lets you manage really basic site settings
 */
function AdminSettingsGeneral() {
	var localizationDateFormatHelp = 'This option affects how dates are read and displayed when importing and exporting ' + gde('track', {c: "lower"}) + ' metadata, viewing ' + gde('track', {p: true, c: "lower"}) + ', and viewing or editing ' + gde('album', {p: true, c: "lower"}) + '.';
	var templates;
	var page = this;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.settings.general');
		}
		var template = templates.get('settings', { domain : config.domain });
		var notSelector = ':not(.' + config.siteType + '_option)';

		// hide elements irrelevant to the current context
		if (!user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			template.find('.super_admin_option').remove();
		} else {
			notSelector += ':not(.' + config.siteType + '_super_admin_option)';
			template.find('#gray input').prop('checked', !!config.grayLabel).on('click', function() {
				return !this.checked || confirm('If you make this a gray label, all users but the workspace owner will be removed. Are you sure?');
			});
			if (!config.visible) {
				template.find('#hideSite input').prop('checked', true);
			}
			if (config.hideStats) {
				template.find('#hideStats input').prop('checked', true);
			}
		}
		template.find('.buyer_option' + notSelector + ', .network_option' + notSelector + ', .seller_option' + notSelector + ', .radio_option' + notSelector).remove();

		// set the values for all the inputs
		template.find('#name input').val(config.name);

		// company info fields loaded from server
		sa.api.request({
			handler : 'contact',
			action : 'get-company-info'
		}).then(
		/**
		 * @param {{
		 *    contactName : string,
		 *    contactEmail : string,
		 *    contactPhone : string,
		 *    contactAddress: string,
		 *    description : string,
		 *    logo : string,
		 *    type : string
		 * }} companyInfo
		 */
		function(companyInfo) {
			
			if (config.siteType !== 'drop') {
				template.find('#company-contact-name input').val(htmlDecode(companyInfo.contactName));
			} else {
				template.find('#company-contact-name').remove();
			}
			template.find('#company-contact-email input').val(htmlDecode(companyInfo.contactEmail));
			template.find('#company-contact-phone input').val(htmlDecode(companyInfo.contactPhone));
			template.find('#company-contact-address textarea').val(htmlDecode(companyInfo.contactAddress.replace(/<br\/>/g, "\n")));
			template.find('#company-description textarea').val(htmlDecode(companyInfo.description.replace(/<br\/>/g, "\n")));
			if (config.siteType === 'drop') {
				template.find('#company-logo').remove();
			} else if (companyInfo.logo) {
				template.find('#company-logo img').attr('src', companyInfo.logo);
			} else {
				template.find('#company-logo img').remove();
			}

			if (config.siteType !== 'drop') {
				let companyType = template.find('#company-type select');
				companyType.val(companyInfo.type);
				if (companyType.val() != companyInfo.type) companyType.val('Other');
				companyType.on('change', function () {
					if (companyType == 'Other') {
						template.find('.other_description').show();
					} else {
						template.find('.other_description').hide();
					}
				});
				companyType.trigger('change');
			} else {
				template.find('#company-type').remove();
			}
		});

		if (config.siteType !== 'drop') {
			let seoTags = decodeURIComponent(config.seo.tags);
			seoTags = seoTags.replace(/\+/g, ' ');
			template.find('#seo-header-tags input').val(seoTags);
		} else {
			template.find('#seo-header-tags').remove();
		}

		// license contact fields loaded from server
		sa.api.request({
			handler : 'contact',
			action : 'get-license-contact'
		}).then(function(licenseContact) {
			template.find('#license-name input').val(htmlDecode(licenseContact.name));
			template.find('#license-phone input').val(htmlDecode(licenseContact.phone));
			template.find('#license-email input').val(htmlDecode(licenseContact.email));
		});
		
		template.find('#license-url input').val(decodeURIComponent(config.licenseUrl));
		if (config.showLicensing) {
			template.find('#show-licensing input').prop('checked', true);
		}
		if (config.showMCPS) {
			template.find('#mcps input').prop('checked', true);
		}
		if (config.showCueSheets) {
			template.find('#show-cue-sheets input').prop('checked', true);
		}
		var splits = config.defaultViews.split('|');
		for (var i = 0, len = splits.length; i < len; i++) {
			template.find('#' + splits[i][0] + '-lists option[value=' + splits[i][1] + ']').prop('selected', true);
		}
		
		if (config.showDownloadStudio) {
			template.find('#enable-download-studio select option[value="' + config.showDownloadStudio + '"]').prop('selected', true);
		}

		if (config.showRequestEmailOptions) {
			template.find('#show-requests-email-options input').prop('checked', true);
		}
		template.find('#localization-date-format select option:selected').prop('selected', false);
		template.find('#localization-date-format select option[value="' + config.dateFormat + '"]').prop('selected', true);

		sa.getSiteOwner(function(ownerInformation) {
			if (ownerInformation) {
				template.find('#site_owner .name').html(ownerInformation.username);
				template.find('#site_owner .email').html(ownerInformation.email);
				template.find('#site_owner .no_owner').remove();
			} else {
				template.find('#site_owner .has_owner').remove();
			}
		});

		// add interactions
		template.find('#save_changes').on('click', function() {
			saveChanges(template);
		});

		container.empty().append(template);

		// company logo
		if (config.siteType !== 'drop') {
			var uploadButton = template.find('#thumb_upload_browse');
			new Uploader({
				button: uploadButton[0], browseCallback: function (uploader) { // after selecting an image
					var fileList = uploader.getFiles(),
						key = new Date().getTime();
					if (fileList && fileList.length == 1) {
						// auto-upload
						uploadButton.find('span').html('Uploading...');
						uploader.upload({
							params: 't=temp&key=' + key + '&source=logo',
							complete: function () { // success function
								var newPath = 'https://sourceaudio-images.s3.amazonaws.com/temp/' + user.userData.id + '-' + key + '.jpg';
								// set the value where we need it
								template.find('.logo-area img').remove();
								template.find('.logo-area').append('<img src="' + newPath + '"/>');
								// let them upload again
								uploadButton.find('span').html('Browse');
							},
							error: function () { // error function
								uploadButton.find('span').html('Browse');
							}
						});
					}
				}, fileType: UploaderConstants.IMAGES
			});
		}
	};

	/**
	 * Saves changes to a white label's basic information after performing form validation
	 * @param template
	 */
	function saveChanges(template) {
		template.find('.success').removeClass('success');
		template.find('.error').removeClass('error');
		var values = sa.forms.validate(template).values;
		var error = false;

		values.companyLogo = template.find('#company-logo img').attr('src');

		// name
		if (!values.name) {
			template.find('#name .information').addClass('error').removeClass('success')
				.html('Please enter a name. Your workspace has to be called something.');
			error = true;
		} else if (values.name.length < 2 || values.name.length > 64) {
			template.find('#name .information').addClass('error').removeClass('success')
				.html('Name must be at least 2 characters and at most 64.');
			error = true;
		} else if (!values.name.match(/^[0-9a-zA-Z ,._\-'":&/]+$/)) {
			template.find('#name .information').addClass('error').removeClass('success')
				.html('Name may only contain alphanumeric characters, spaces, and ,._-/:&\' or "');
			error = true;
		} else {
			template.find('#name .information').removeClass('error').removeClass('success')
				.html('Appears in the browser title bar, in emails, and all over the place');
		}
		// licenseName
		if (template.find('#licensing_options_section').length) {
			if (!values.licenseName) {
				template.find('#license-name .information').addClass('error').removeClass('success')
					.html('Please enter a name. It can be your company name if you don\'t want to list an individual');
				error = true;
			} else if (values.licenseName.length < 2 || values.licenseName.length > 64) {
				template.find('#license-name .information').addClass('error').removeClass('success')
					.html('Name must be at least 2 characters and at most 64.');
				error = true;
			} else {
				template.find('#license-name .information').removeClass('error').removeClass('success').html('');
			}
			// licenseEmail
			if (!values.licenseEmail) {
				template.find('#license-email .information').addClass('error').removeClass('success').html('Please enter an email');
				error = true;
			} else {
				var emails = values.licenseEmail.split(',');
				var valid = true;
				for (var i = 0, len = emails.length; i < len; i++) {
					if (!emails[i].trim().isEmail()) {
						valid = false;
						break;
					}
				}
				if (!valid) {
					template.find('#license-email .information').addClass('error').removeClass('success').html('Please enter a valid email');
					error = true;
				} else {
					template.find('#license-email .information').removeClass('error').removeClass('success').html('');
				}
			}
			// licenseUrl
			if (values.licenseUrl && values.licenseUrl.indexOf('http://') != 0 && values.licenseUrl.indexOf('https://') != 0) {
				template.find('#license-url .information').addClass('error').removeClass('success').html('Url must be a valid url, starting with http:// or https://');
				error = true;
			} else {
				template.find('#license-url .information').removeClass('error').removeClass('success')
					.html('Providing a url in this box overrides the default SourceAudio page when a user clicks a track\'s "License Now"'
						+ 'button. The user will be redirected to this page instead.');
			}
		}

		// dateFormat
		if (values.dateFormat && !isNumeric(values.dateFormat)) {
			error = true;
			template.find('#localization-date-format .information').addClass('error').html('Please select an option from the drop-down to the left.');
		} else {
			template.find('#localization-date-format .information').removeClass('error').html(localizationDateFormatHelp);
		}

		if (!error) {
			sa.api.request({
				handler : 'settings',
				action : 'save-general',
				postData : values
			}).then(function() {
				sa.notify({ text : 'Changes saved! You might need to reload to see all your changes', type : sa.notify.notificationTypes.success });
			}).catch(e => {
				if (e.details && e.details['field']) {
					template.find('#' + e.details['field'] + ' .information').addClass('error').removeClass('success').html(e.message);
				} else {
					sa.alert(e.message);
				}
			});
			if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				config.grayLabel = values.gray;
				config.visible = !values.hideSite;
				config.hideStats = values.hideStats;
			}
		}
	}

}
/**
 * The page in the admin panel that lets you change the columns of your track lists
 */
function AdminSettingsLists() {

	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {

		if (!templates) {
			templates = sa.templates.get('admin.settings.lists');
		}

		var cap = new sa.collapsingAdminPage();
		cap.addSection({
			name : 'Track List Columns',
			contents : getTrackListColumnsTemplate()
		});
		cap.addSection({
			name : 'Track List Options',
			contents : getTrackListOptionsTemplate()
		});
		cap.addSection({
			name : 'Default View Settings',
			contents : getDefaultViewSettingsTemplate()
		});
		cap.addSection({
			name : 'Sorting',
			contents : getSortingTemplate()
		});
		cap.addToContainer(container);

		container.append(getButtonsTemplate());

	};

	function getTrackListColumnsTemplate() {

		var template = templates.get('track_list_columns');

		sa.api.request({
			handler : 'settings',
			action : 'get-lists'
		}).then(setColumns);

		return template;

	}

	function getTrackListOptionsTemplate() {

		var template = templates.get('track_list_options');

		template.find('#rpp input').val(config.defaultResultsPerPage);
		if (config.defaultNesting) {
			template.find('#nesting input').prop('checked', true);
		}
		if (config.showNestedCounts) {
			template.find('#nested_counts input').prop('checked', true);
		}

		return template;

	}

	function getDefaultViewSettingsTemplate() {

		var template = templates.get('default_view_settings');

		var splits = config.defaultViews.split('|');
		for (var i = 0, len = splits.length; i < len; i++) {
			template.find('#' + splits[i][0] + '_lists select').val(splits[i][1]);
		}

		return template;
	}

	function getSortingTemplate() {

		var template = templates.get('sorting');

		template.find('#t_sort_lists select').val(config.defaultTrackSort);
		template.find('#b_sort_lists select').val(config.defaultAlbumSort);

		return template;

	}

	function getButtonsTemplate() {

		var template = templates.get('buttons');

		template.find('#save_changes').on('click', function() {

			let postData = {
				rpp : $j('#rpp input').val(),
				nesting : $j('#nesting input:checked').val() ? 1 : 0,
				showNestedCounts : $j('#nested_counts input:checked').val(),
				listViews : 't' + $j('#t_lists select').val()
					+ '|c' + $j('#c_lists select').val() + '|l' + $j('#l_lists select').val()
					+ '|a' + $j('#a_lists select').val() + '|b' + $j('#b_lists select').val()
					+ '|w' + $j('#w_lists select').val() 
					+ '|u' + $j('#u_lists select').val() 
					+ '|r' + $j('#r_lists select').val(),
				listSorts : {
					album : $j('#b_sort_lists select').val(),
					track : config.id == 25 ? 'release_date' : $j('#t_sort_lists select').val()
				}
			};

			let verificationColumns = {
				"wave_normal" : $j('#wave_normal_columns'),
				"wave_alternate" : $j('#wave_alternate_columns'),
				"simple_normal" : $j('#simple_normal_columns'),
				"simple_alternate" : $j('#simple_alternate_columns')
			};
			for (let listKey in verificationColumns) {
				if (!verificationColumns.hasOwnProperty(listKey)) continue;
				let context = verificationColumns[listKey];

				postData[listKey] = [];
				let columns = $j('.tl-column', context);
				let usedColumns = [];

				// validate the columns
				for (let i = 0, len = columns.length; i < len; i++) {
					let column = $j(columns[i]);
					let val = column.find('select').val();

					if (val) {
						let cId = column.attr('id');
						cId = cId.substring(cId.lastIndexOf('_') + 1);
						let cb = column.find('input[type=checkbox]');

						if (cb.length) {
							cb = cb.filter(':checked').length ? '1' : '0';
						} else {
							cb = '0';
						}
						postData[listKey].push({
							type : val,
							icon : cb
						});
						if (usedColumns.indexOf(val) != -1) {
							$j('#general.information').addClass('error').html('You may only have one of each column type');
							return;
						} else {
							usedColumns.push(val);
						}
					} else if (i === 0 && listKey.indexOf('wave') === 0 && column.find('#large_album_art_check:checked').length) {
						postData[listKey].push({
							type : 'large_album_art',
							icon : 0
						});
					}
				}
			}

			if (!isInt(postData.rpp) || postData.rpp < 5 || postData.rpp > 50) {

				$j('#general.information').addClass('error').html('Must be between 5 and 50');

			} else if (postData['wave_normal'].length < 4 || postData['simple_normal'].length < 4) {

				$j('#general.information').addClass('error').html('You must choose at least four columns');

			} else {

				$j('#general.information').removeClass('error').html('');

				sa.api.request({
					handler : 'settings',
					action : 'save-lists',
					postData : postData
				}).then(() => {
					sa.notify({ text : 'Changes saved! You might need to reload to see all your changes', type : sa.notify.notificationTypes.success });

				}).catch(err => {
					sa.alert(err.message);
				});

			}
		});

		return template;

	}

	/**
	 * Populates the column list using the list from the server
	 * @param {Array} columns the full column list
	 */
	function setColumns(columns) {
		let waveNormalContainer = $j('#wave_normal_columns');
		let waveAlternateContainer = $j('#wave_alternate_columns');
		let simpleNormalContainer = $j('#simple_normal_columns');
		let simpleAlternateContainer = $j('#simple_alternate_columns');
		let shouldShowLicenseNow = false;

		if (!config.showLicensing || config.licensing['show_cart']) {
			shouldShowLicenseNow = false;
		} else if (config.licensing['full_licensing']) {
			shouldShowLicenseNow = true;
		} else if (config.id == 162) {
			shouldShowLicenseNow = false;
		} else if (config.siteType != 'radio' && !(config.licensingConfig.show || config.licensing.show || (config.id == 49 || config.id == 118 || config.id == 225 || config.id == 104))) {
			shouldShowLicenseNow = true;
		}

		function renderTrackColumnList(container, trackColumnList, prefix, hasLargeArt) {
			var usedColumns = {};
			var columnList;
			var columnString;
			var extraAlts = $j('#extra_alternates_column select');

			if (undefined === prefix) {
				prefix = "";
			}

			// build a list of used columns for the right side
			trackColumnList.each(function(i, column) {
				let title = column.name.toLowerCase();
				if (title == '#' || title == '&num;') title = 'track_number';
				else if (title == 'release date') title = 'added';
				else if (title == 'add to cart') title = 'add_to_cart_col';

				// need to look for customs differently because their "title" contains "Custom: " so we can differentiate between something like "Custom: Genre" and "Genre"
				// the title that's in the config doesn't have that "Custom: " on it though because we don't want the user to see it
				if (column.displayColumns[0].indexOf('custom_') == 0) {
					title = column.displayColumns[0];
				}
				usedColumns[title] = title;
			});

			// build a basic select box we're going to replace into and simultaneously build the full list of columns for the right
			columnList = '<ul id="' + prefix + 'column_list" class="column_list">';
			let baseColumnSelect = '<select><option value="">Empty</option>';
			columns.each(function(i, c) {
				if ('license_now' === c.id && !shouldShowLicenseNow || c.id == 'icon' || c.id == 'play' || (c.id === 'length' && prefix.indexOf('wave') === 0)) {
					return;
				}

				columnList += '<li id="' + prefix + c.id + '" class="' + c.id + '">' + c.name + ' (' + c.weight + ')</li>';
				baseColumnSelect += '<option value="' + c.id + '">' + c.name + ' (' + c.weight + ')</option>';
				if (c.id != 'play' && c.id != 'title' && c.id != 'plays' && c.id != 'length')
					extraAlts.append('<option value="' + prefix + c.id + (!c.id ? '" selected="selected' : '') + '">' + c.name + '</option>');
			});
			columnList += '</ul>';
			baseColumnSelect += '</select>';

			let columnIndex = 1;
			let displayColumn = 2;
			if (hasLargeArt) {
				// for views that support large art, the first column is a checkbox and the second is title
				let showingLargeAlbumArt = trackColumnList[0].displayColumns[0].indexOf('large_') === 0 ? 'checked="checked" ' : '';
				columnString = `
					<div id="${prefix}column_1" class="section tl-column">
						<h4>Column 1:</h4>
						<label>Large album art: <input type="checkbox" id="large_album_art_check" value="large_album_art" ${showingLargeAlbumArt}/></label>
						<span class="weight">+ 5</span><div class="icon"></div>
						<div class="information"></div>
					</div>
					<div id="${prefix}column_2" class="section tl-column">
						<h4>Column 2:</h4>
						<select disabled="disabled"><option selected="selected" value="title">Track Title</option></select>
						<span class="weight"></span><div class="icon"></div>
						<div class="information"></div>
					</div>
				`;
				if (showingLargeAlbumArt) {
					columnIndex = 2;
				}
				displayColumn = 3;
			} else {
				// for views that don't, the first column is title
				columnString = `
					<div id="${prefix}column_1" class="section tl-column">
						<h4>Column 1:</h4>
						<select disabled="disabled"><option selected="selected" value="title">Track Title</option></select>
						<span class="weight"></span><div class="icon"></div>
						<div class="information"></div>
					</div>
				`;
			}
			// the other columns are variable
			while (columnIndex < 13) {
				let selected = '';
				let showIcon = false;
				if (columnIndex < trackColumnList.length) {
					let trackColumn = trackColumnList[columnIndex];
					showIcon = trackColumn.displayColumns[0].indexOf('avatar') != -1;
					selected = config.getReverseDictionaryEntry(trackColumn.name.toLowerCase());
					if (selected == '#' || selected == '&num;') selected = 'track_number';
					else if (selected == 'cue type') selected = 'cue-type';
					else if (selected == 'release date') selected = 'added';
					else if (selected == 'add to cart') selected = 'add_to_cart_col';
					if (trackColumn.displayColumns[0].indexOf('custom_') == 0) {
						selected = trackColumn.displayColumns[0];
					}
				}
				let columnSelect = baseColumnSelect.replace('"' + selected + '"', '"' + selected + '" selected="selected"').replace(/<option value="(play|title)">[^<]+<\/option>/g, '');
				columnString += `
					<div id="${prefix}column_${columnIndex}" class="section tl-column"><h4>Column ${displayColumn}:</h4>
						${columnSelect}
						<span class="weight"></span>
						<div class="icon">${showIcon ? 'Show an icon? <input type="checkbox" value="1" checked="checked"/><div class="weight"></div>' : ''}</div>
						<div class="information"></div>
					</div>
				`;
				columnIndex++;
				displayColumn++;
			}

			container.append(`
				<div class="column">
					${columnString}
					<div id="${prefix}total_weight" class="total_weight section">Total:<div class="weight"></div><div class="clr"></div></div>
				</div>
				<div class="column">
					<h3>Available Columns:</h3>
					${columnList}
				</div>
				<div class="clr"></div>
			`);
		}

		waveNormalContainer.html(templates.get('track_list_columns_description').html());
		waveAlternateContainer.html("");
		simpleNormalContainer.html("");
		simpleAlternateContainer.html("");

		renderTrackColumnList(waveNormalContainer, config.trackColumnLists.wave.normal, 'wave_normal_', true);
		renderTrackColumnList(waveAlternateContainer, config.trackColumnLists.wave.alternate, 'wave_alternate_', true);
		renderTrackColumnList(simpleNormalContainer, config.trackColumnLists.simple.normal, 'simple_normal_');
		renderTrackColumnList(simpleAlternateContainer, config.trackColumnLists.simple.alternate, 'simple_alternate_');

		$j('.tl-column select, .tl-column .icon input[type=checkbox], .tl-column #large_album_art_check').on('change', function() {
			refreshWhiteTrackListWeights($j(this).closest(".track_columns"), columns);
		});
		$j('.track_list_columns #how').on('click', function () {$j('#track_list_explanation').slideToggle(250);});
		refreshWhiteTrackListWeights(waveNormalContainer, columns);
		refreshWhiteTrackListWeights(waveAlternateContainer, columns);
		refreshWhiteTrackListWeights(simpleNormalContainer, columns);
		refreshWhiteTrackListWeights(simpleAlternateContainer, columns);
	}

	/**
	 * Updates the weights for all the columns
	 * Updates which columns are greyed out in the Available Columns column
	 * Updates whether we're showing icon options
	 */
	function refreshWhiteTrackListWeights(context, fullColumnList) {
		if (undefined === context) {
			context = $j("body");
		}

		let iconWeight = 0;
		let columns = $j('.tl-column', context);
		let hasLargeAlbumArt = context.find('#large_album_art_check:checked').length;
		let totalWeight = hasLargeAlbumArt ? 5 : 0;
		let waveColumns = context.attr('id').indexOf('wave') === 0;

		// we need to figure out how much an icon weighs
		for (var f = 0, fLen = fullColumnList.length; f < fLen; f++) {
			if (fullColumnList[f].id == 'icon') {
				iconWeight = fullColumnList[f].weight;
				break;
			}
		}
		// ok, got it
		$j('ul.column_list li', context).removeClass('used');
		for (var i = 0, len = columns.length; i < len; i++) {
			var col = $j(columns[i]);
			var weight = 0;
			var val = col.find('select').val();
			if (val) {
				// if this column has a value, we need to find the columnlist column that it represents
				for (var j = 0; j < fullColumnList.length; j++) {
					if (fullColumnList[j].id == val) {
						var co = fullColumnList[j]; // column object
						// update the total weight
						totalWeight += (weight = co.weight);
						// grey out of the Available Column
						$j('.' + co.id, context).addClass('used');
						// icon options
						var iconContainer = col.find('.icon');
						if (co.icon && (!waveColumns || co.id !== 'album' || !hasLargeAlbumArt)) {
							if (iconContainer.html()) {
								// the option was added previously. see if it's checked
								if (iconContainer.find('input[type=checkbox]:checked').length) {
									iconContainer.find('.weight').html('+ ' + iconWeight);
									totalWeight += iconWeight;
								} else {
									iconContainer.find('.weight').html('');
								}
							} else {
								// this column was freshly selected. add the icon option text
								iconContainer.html('Show an icon? <input type="checkbox" value="1"/><div class="weight"></div>');
								iconContainer.find('input[type=checkbox]').on('change', function() {
									refreshWhiteTrackListWeights($j(this).closest(".track_columns"), fullColumnList);
								});
							}
						} else {
							iconContainer.html('');
						}
						break;
					}
				}
			} else {
				col.find('.icon').html('');
				if (i === 0 && hasLargeAlbumArt) {
					weight = 5;
				}
			}
			col.find('.weight:first').html(weight ? '+ ' + weight : '');
		}
		$j('.total_weight', context).removeClass('error').addClass(totalWeight > 100 ? 'error' : '').find('.weight').html(totalWeight + '/100');
	}

}
/**
 * The page in the admin panel that lets you manage options releated to search
 */
function AdminSettingsSearch() {

	let templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {

		if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}

		if (!templates) {
			templates = sa.templates.get('admin.settings.search');
		}

		const cap = new sa.collapsingAdminPage();
		cap.addSection({
			name: 'Search Options',
			contents: getSearchOptionsTemplate()
		});
		cap.addSection({
			name: 'Embedded Search',
			contents: getEmbeddedSearchTemplate()
		});
		cap.addSection({
			name: gde('label', { c: 'upper', p: false }) + ' Weighting',
			contents: getLabelWeightingTemplate()
		});
		cap.addToContainer(container);

		container.append(getButtonsTemplate());

	};

	function getSearchOptionsTemplate() {

		const template = templates.get('search_options');

		if (config.showBrowse) {
			template.find('#show_browse input').prop('checked', true);
		}
		if (config.showTrackCount) {
			template.find('#show_track_count input').prop('checked', true);
		}

		if (config.showAISearch) {
			template.find('#show_ai_mode input').prop('checked', true);
		}

		if (config.showAIPlaylists) {
			template.find('#show_ai_playlists input').prop('checked', true);
		}

		if (config.showSonicSearch) {
			template.find('#show_sonic_search input').prop('checked', true);
		}

		if (config.grayLabel) {
			template.find('#show_ai_mode').remove();
		}

		return template;

	}

	function getEmbeddedSearchTemplate() {

		const template = templates.get('embedded_search', { name: config.name, domain: config.domain });

		template.find('input[name=new-window]').on('click', function () {
			const ta = $j('#code textarea');
			if (this.id.indexOf('yes') != -1) {
				ta.val(ta.val().replace(' target="_blank"', '').replace('"get"', '"get" target="_blank"'));
			} else {
				ta.val(ta.val().replace(' target="_blank"', ''));
			}
		});
		template.find('form').on('submit', function () {
			const form = $j(this);
			window.open(form.attr('action') + '?s=' + encodeURIComponent(form.find('input[name=s]').val()));
			return false;
		});

		return template;

	}

	function getLabelWeightingTemplate() {

		const template = templates.get('label_weighting');

		// load the label list
		sa.api.request({
			handler: 'settings',
			action: 'get-weighting'
		}).then((labelWeights) => {
			const list = template.find('#catalog_list').empty();
			for (let i = 0, len = labelWeights.length; i < len; i++) {
				const lab = labelWeights[i];
				const labelWeight = lab.weight / 10;
				const row = $j('<div class="catalog"><select name="weight[' + lab.id + ']"></select><div class="name">' + lab.name + '</div><div class="clr"></div></div>');
				const sel = row.find('select');
				for (let weight = 0; weight <= 10; weight++) {
					sel.append('<option' + (weight == labelWeight ? ' selected="selected"' : '') + '>' + weight + '</option>');
				}
				list.append(row);
			}
		});

		return template;

	}

	function getButtonsTemplate() {

		const template = templates.get('buttons');

		template.find('.button').on('click', () => {

			const postData = {
				showBrowse: $j('#show_browse input:checked').val() ? 1 : 0,
				showTrackCount: $j('#show_track_count input:checked').val() ? 1 : 0,
				showSonicSearch: $j('#show_sonic_search input:checked').val() ? 1 : 0,
				showAISearch: $j('#show_ai_mode input:checked').val() ? 1 : 0,
				showAIPlaylists: $j('#show_ai_playlists input:checked').val() ? 1 : 0,
			};
			for (let weights = $j('#catalog_list select'), i = 0, len = weights.length; i < len; i++) {
				postData[weights[i].name] = weights[i].value * 10;
			}
			// no validation required
			sa.api.request({
				handler: 'settings',
				action: 'save-search',
				postData
			}).then(() => {
				sa.notify({ text: 'Changes saved! You might need to reload to see all your changes', type: sa.notify.notificationTypes.success });
			}).catch((e) => {
				sa.alert(e.message);
			});

		});

		return template;

	}

}
/**
 * The page in the admin panel that lets you change the columns of your track lists
 */
function AdminSettingsTabs() {

	var page = this;
	var cont;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function(params, container) {
		var tabs = config.tabs;
		var tabList;
		var tabOptionString;
		cont = container;

		if (!templates) {
			templates = sa.templates.get('admin.settings.tabs');
		}
		var template = templates.get('page');
		if (config.singleCatalog) {
			template.find('.multiple_catalogs').remove();
		} else {
			template.find('.single_catalog').remove();
		}

		// default values
		template.find('*[name=catalog_tab]').val(config.defaultCatalogTab);
		template.find('*[name=label_tab]').val(config.defaultLabelTab);
		
		// for the catalog/label tabs, we have to do the same stuff for both types
		for (var types = [ 'catalog', 'label' ], i = 0; i < 2; i++) {
			var type = types[i];

			// set the values for the catalog and label tabs
			template.find('.' + type + '_tabs input').each(function() {
				if (this.disabled) return
				var select = template.find('select[name=' + type + '_tab]');
				const value = config[type + 'Tabs'].indexOf(this.value) != -1;
				template.find('.' + type + '_tabs input[value=' + this.value + ']').prop('checked', value);

				if (!value) {
					select.find('option[value="' + this.value + '"]').hide();
				} else {
					select.find('option[value="' + this.value + '"]').show();
				}
			});

			// changing which tabs are available needs to update which default tabs are available
			template.find('.' + type + '_tabs input').on('change', function(type) { return function() {
				var select = template.find('select[name=' + type + '_tab]');
				var available = this.checked,
					val = this.value;
				if (!available && select.val() == val) {
					select.val('t'); // since you can't turn that one off
				}
				if (!available) {
					select.find('option[value="' + val + '"]').hide();
				} else {
					select.find('option[value="' + val + '"]').show();
				}
			}; }(type));
		}

		container.empty().append(template);

		const tabOptions = await sa.api.request({
			handler : 'settings',
			action : 'get-available-tabs'
		});

		tabList = container.find('.field_container');
		tabOptionString =
			'<option value="albums">' + config.getDictionaryEntry('album', true) + '</option>'
			+ '<option value="artists">' + config.getDictionaryEntry('artist', true) + '</option>'
			+ (config.singleCatalog ? '' : '<option value="catalogs">' + config.getDictionaryEntry('catalog', true) + '</option>')
			+ '<option value="home">Home</option>'
			+ '<option value="genres">' + gde('genre', { p : true, c : 'upper' }) + '</option>'
			+ '<option value="labels">' + config.getDictionaryEntry('label', true) + '</option>'
			+ '<option value="publishers">' + config.getDictionaryEntry('publisher', true) + '</option>'
			+ '<option value="tracks">Tracks</option>'
			+ '<option value="writers">' + config.getDictionaryEntry('writer', true) + '</option>';
		
		if (config.licensingConfig.addon) {
			tabOptionString += '<option value="subscriptions">Subscriptions</option>';
			if (config.licensingConfig.coupons_active) {
				tabOptionString += '<option value="coupon_entry">Coupon Entry</option>';
			}
		}
		
		for (let i = 0, len = tabOptions.length; i < len; i++) {
			tabOptionString += '<option value="' + tabOptions[i].url + '">' + tabOptions[i].type + '</option>';
		}
		
		tabOptionString +=
			(config.siteType != 'seller' ? '<option value="requests">Requests</option><option value="music-suppliers">Music Suppliers</option>' : '')
			+ '<option value="custom">Custom</option>';
		
		for (let i = 0, len = tabs.length; i < len; i++) {
			let tab = tabs[i],
				tabUrl = tab.hash.replace(/^\//, ''),
				custom = false,
				customTabOptionString = tabOptionString.replace('value="' + tabUrl + '"', 'value="' + tabUrl + '" selected="selected"');
			
			if (customTabOptionString === tabOptionString) {
				// we made no change doing the replace, meaning the tabUrl wasn't found, meaning it's a custom
				customTabOptionString = tabOptionString.replace('value="custom"', 'value="custom" selected="selected"');
				custom = true;
			}
			
			const tabTemplate = templates.get('new_tab');
			tabTemplate.addClass('field_' + i);
			
			if (tabUrl === decodeURIComponent(config.home)) {
				tabTemplate.find('.home input').prop('checked', true);
			}
			
			tabTemplate.find('.type select').html(customTabOptionString);
			tabUrl = this.encodeUrl(tabUrl);
			tabTemplate.find('.url input').val(tabUrl);
			
			if (!custom) {
				tabTemplate.find('.url input').prop('disabled', true);
				tabTemplate.find('.notes').hide();
			}
			
			tabTemplate.find('.name input').val(htmlDecode(tab.text));
			tabList.append(tabTemplate);
		}
		
		if (!tabs.length) {
			tabList.append(templates.get('empty_tab'));
		}
		
		page.restripe(tabList);
		tabList.find('.up').on('click', function() { page.moveField($j(this).parent().parent(), -1); });
		tabList.find('.down').on('click', function() { page.moveField($j(this).parent().parent(), 1); });
		tabList.find('.delete').on('click', function() { page.deleteField($j(this).parent().parent()); });
		tabList.find('select').on('change', function() {
			var t = $j(this),
				tab = t.parent().parent();
			if (this.value == 'custom') {
				tab.find('.url input').prop('disabled', false).val('');
				tab.find('.notes').show();
				tab.find('.name input').val('');
			} else {
				tab.find('.url input').prop('disabled', true).val(this.value);
				tab.find('.notes').hide();
				tab.find('.name input').val(t.find('option[value="' + t.val().replace(/\?/g, '\\?').replace(/=/g, '\\=') + '"]').html().replace(/[a-z ]+: /i, ''));
			}
		});
		tabList.append(createButton('New Tab', 'new_tab', '', getDefaultLink(), function() {
			var newField = templates.get('new_tab');
			newField.addClass('field_0');
			newField.find('.type select').html(tabOptionString);
			newField.find('.url input').val('albums').prop('disabled', true);
			newField.find('.notes').hide();
			newField.find('.name input').val('Albums');
			newField.find('.up').on('click', function() { page.moveField($j(this).parent().parent(), -1); });
			newField.find('.down').on('click', function() { page.moveField($j(this).parent().parent(), 1); });
			newField.find('.delete').on('click', function() { page.deleteField($j(this).parent().parent()); });
			newField.find('select').on('change', function() {
				var t = $j(this),
					tab = t.parent().parent();
				if (this.value === 'custom') {
					tab.find('.url input').prop('disabled', false).val('');
					tab.find('.notes').show();
					tab.find('.name input').val('');
				} else {
					tab.find('.url input').prop('disabled', true).val(this.value);
					tab.find('.notes').hide();
					let optionValue = 'option[value="' + t.val().replace(/\?/g, '\\?').replace(/=/g, '\\=').replace(/\//g, '\\/') + '"]';
					tab.find('.name input').val(t.find(optionValue).html().replace(/[a-z ]+: /i, ''));
				}
			});
			tabList.find('.field:last').after(newField);
			tabList.find('.empty').remove();
			page.restripe(tabList);
		}));
		container.find('.section:last').append($j(createButton('Save Changes', '', '', '#0',
			function() { page.save(); return false; }))).append('<div class="clr"></div>');
	};

	/**
	 * Removes a row from the displayed list
	 * @param {JQuery} row the row to delete
	 */
	this.deleteField = function(row) {
		var cont = row.parent();
		row.remove();
		if (cont.find('.field').length < 2) {
			cont.append(templates.get('empty_tab'));
		}
		this.restripe(cont);
	};

	/**
	 * Moves a row up or down
	 * @param {JQuery} row the row to move
	 * @param {int} direction -1 is up, 1 is down
	 */
	this.moveField = function(row, direction) {
		if (direction == -1) {
			var prev = row.prev('.field:not(.header)');
			if (prev) {
				prev.before(row);
			}
		} else {
			var next = row.next('.field');
			if (next) {
				next.after(row);
			}
		}
		this.restripe(row.parent());
	};

	/**
	 * Stripes the fields in the passed in element
	 * @param {JQuery} container
	 */
	this.restripe = function(container) {
		container.find('.field').removeClass('stripe');
		container.find('.field:odd').addClass('stripe');
	};
	
	this.encodeUrl = function (url) {
		if (url.includes('?')) {
			const [preQuery, query] = url.split('?');
			url = preQuery + '?' + (new URLSearchParams(query)).toString();
		}
		
		return url;
	};

	/**
	 * Saves changes to a white label's basic information after performing form validation
	 */
	this.save = function() {
		let home = $j('input[name=home]:checked').parent().parent().find('.url input').val();
		let postData = {
			home : (home === undefined ? '' : home),
			defaultCatalogTab : $j('*[name=catalog_tab]').val(),
			defaultLabelTab : $j('*[name=label_tab]').val(),
			catalogTabs : '',
			labelTabs : '',
			tabs : []
		};

		config.defaultCatalogTab = postData.defaultCatalogTab;
		config.defaultLabelTab = postData.defaultLabelTab;

		$j('.catalog_tabs input:checked').each(function() {
			postData.catalogTabs += this.value;
		});
		$j('.label_tabs input:checked').each(function() {
			postData.labelTabs += this.value;
		});
		config.catalogTabs = postData.catalogTabs;
		config.labelTabs = postData.labelTabs;

		// Regex to check if the chars ARE NOT included in this list/regex pattern
		const nonApprovedCharsRegex = /[^a-zA-Z0-9-_.~:/?#[\]@!&+,=% ]/;
		
		// Check for errors in the urls
		const inputsWithErrors = [];
		for (let urls = $j('.tab_field .url input'), i = 0, len = urls.length; i < len; i++) {
			let url = urls[i].value;
			
			url = this.encodeUrl(url);
			
			const invalidCharsInUrl = url.match(nonApprovedCharsRegex);
			
			if (invalidCharsInUrl) {
				inputsWithErrors.push(urls[i]);
			}
		}
		
		if (inputsWithErrors.length) {
			inputsWithErrors.forEach(input => {
				let el = $j(input);
				el.addClass('tab-input-error');
				setTimeout(() => {
					el.removeClass('tab-input-error');
				}, 5000);
			});
			
			sa.notify({ text: 'Invalid characters in url(s).' });
			return;
		}

		
		for (let names = $j('.tab_field .name input'), urls = $j('.tab_field .url input'), i = 0, len = urls.length; i < len; i++) {
			let url = urls[i].value;
			let tabName = names[i].value;
			
			if (!url || !tabName) {
				sa.notify({ text : 'All tabs must have urls and names. Please delete any tabs you don\'t want.' });
				return;
			}

			if (tabName.length > 32) {
				sa.notify({ text : 'Tab names must be 32 characters or less.' });
				return;
			}
			
			if (url.indexOf('http') !== 0 && url.indexOf('login.php') !== 0 && url.indexOf('#') === 0) {
				sa.notify({ text : url + ' is not a properly formatted url for a tab.' });
				return;
			}
			
			// Strip non-approved characters, just in case they weren't caught above
			url = url.replace(nonApprovedCharsRegex, '');
			
			postData.tabs.push({
				url : url,
				name : tabName
			});
		}

		sa.api.request({
			handler : 'settings',
			action : 'save-tabs',
			postData : postData
		}).then(function(responseData) {
			sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
			
			// update home
			config.home = postData.home.replace(/^\//, '').replace(/\/$/, '');
			$j('#logo').attr('href', '/' + sa.router.pathConversionLookup(config.home));
			
			// update tabs
			config.tabs = responseData['tabs'];
			sa.components.nav.build();
			sa.components.nav.attach();
			sa.components.nav.resize();
			page.show('', cont);
		}).catch(function(e) {
			sa.alert(e.message);
		});
	};

}
/**
 * The page in the admin panel that lets you manipulate your featured content
 */
function AdminStats() {
	let page = this;
	let currentTab = '';
	let currentPage;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Statistics) && !user.hasAdminPermission(AdminPermission.Sharing)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Statistics' + '" permission.</h3>');
		} else if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		if (!$j('.right_body .stats').length) {
			let hrefBase = siteBaseUrl();
			var callback = function(tabId, cont) { 
					page.setPage(tabId, cont); 
				},
				tabs = [
					new RightTab('music', hrefBase + '/admin?p=stats&tab=music', 'Music Stats', callback),
					new RightTab('users', hrefBase + '/admin?p=stats&tab=users', 'User Stats', callback),
					new RightTab('search', hrefBase + '/admin?p=stats&tab=search', 'Search Trends', callback),
					new RightTab('sent', hrefBase + '/admin?p=stats&tab=sent', 'Company Sent', callback)
				];
			RightTabbedPage.prototype.show.call(this, 'stats', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'music';
		this.setTab(vars.tab);
	};
	
	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			if (pageId == 'music') {
				currentPage = new AdminStatsMusic();
			} else if (pageId == 'users') {
				currentPage = new AdminStatsUsers();
			} else if (pageId == 'search') {
				currentPage = new AdminStatsSearch();
			} else if (pageId == 'sent') {
				currentPage = new AdminStatsSent();
			} else {
				currentPage = new AdminStatsMusic();
			}
		}
		let params = sa.router.getCurrentQueryParams();
		currentPage.show(params, container);
	};
}
AdminStats.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you view and manage your SA Detections
 */
function AdminSAD() {
	let page = this;
	let currentTab = '';
	let currentPage;
	let paidStatus = null;
	let hideHomeTab = false;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = async function (params, container) {
		// Check if the site has paid for detect and has it enabled
		await sa.api.request({
			handler: 'sad',
			action: 'loadPaid'
		}).then((response) => {
			paidStatus = response.paid;
		});
		hideHomeTab = config.watermarked && paidStatus && !user.isSiteOwner();
		
		//if (config.id == 1037) {
		//	return container.append('<h3 class="permission_denied">You don\'t have permission to access this page.</h3>');
		//}
		if (!user.hasAdminPermission(AdminPermission.Statistics)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Statistics' + '" permission.</h3>');
		}
		if (!$j('.right_body.sad').length) {
			const callback = (tabId, cont) => page.setPage(tabId, cont);
			const tabs = [
				new RightTab('detections', '/admin?p=detect&tab=detections', 'TV Detections', callback),
				new RightTab('radio', '/admin?p=detect&tab=radio', 'Radio Detections', callback),
				new RightTab('test', '/admin?p=detect&tab=test', 'Test a File', callback),
			];

			if (!hideHomeTab) {
				tabs.splice(0, 0, new RightTab('home', '/admin?p=detect&tab=home', 'Home', callback));
			}

			RightTabbedPage.prototype.show.call(this, 'sad', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = hideHomeTab ? 'detections' : 'home';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function (pageId, container) {		
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			if (pageId === 'detections' || pageId === 'programs') {
				currentPage = new AdminSADDetections();
				// Add a query param to the current URL
				sa.router.addQueryParamToURL('tab', pageId);
			} else if (pageId === 'radio') {
				currentPage = new AdminSADRadioDetections();
			} else if (pageId === 'test') {
				currentPage = new AdminSADTest();
			} else {
				currentPage = new AdminSADHome();
			}
		}
		
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminSAD.prototype = new RightTabbedPage();

// Detect paid status checking functions. Inside function call to create internal scope for caching
(function() {
	
	let paidStatus = null;

	/**
	 * Checks if the site has currently paid for Detect
	 * @param {function} callback - passed one boolean state value
	 */
	AdminSAD.getPaidStatus = function (callback) {
		if (paidStatus !== null) {
			callback(paidStatus);
		} else {
			sa.api.request({
				handler : 'sad',
				action : 'loadPaid'
			}).then(function (response) {
				paidStatus = response['paid'];
				callback(paidStatus);
			});
		}
	};

	/**
	 * Flags that the paid status for Detect needs to be reloaded from the server
	 */
	AdminSAD.resetPaidStatus = function () {
		paidStatus = null;
	};
})();
/**
 * A page in the admin panel
 */
function AdminSADDetections() {
	const page = this;
	const templates = sa.templates.get('admin.sad');

	let networkList = [];

	this.currentTab = '';

	this.eventTypes = {
		1: 'Program',
		63: 'Program',
		55: 'Program',
		4: 'Promo',
		16: 'Promo',
		5: 'Commercial',
		29: 'Commercial' // brought to you by
	};

	this.eps = {};

	this.detections = [];

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		const pageId = sa.router.paramsToVars(params).tab;

		AdminSAD.getPaidStatus(paid => {
			if (paid) {
				showPaid(pageId, container);
			} else if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				showPaid(pageId, container);
				sa.notify({ text : 'This workspace is currently unpaid so this page is only accessible to SourceAudio employees.' });
			} else {
				sa.router.routeTo('/admin?p=detect&tab=home');
				sa.notify({ text : 'Please sign up before accessing your detections!' });
			}
		});
	};

	function showPaid(pageId, container) {
		page.vars = sa.router.getCurrentParamsAsObject();
		page.currentTab = pageId;
		switch (pageId) {
			case 'detections':
				page.showDetections('', container);
				break;
		}
		// and then if we found it, have it load based on the current params

	}

	this.extractExportData = function(item, includeDetections = true) {
		let type = ucfirst(item.type);
		const isAdItem = item.data.competitrackOccurrence && item.data.competitrackOccurrence.advertiser;
		const isViacomEvent = page.groupBy === 'viacomkey' && item.data.viacomEvent;

		let exportsString = '';

		if (isViacomEvent) {
			type = page.eventTypes[item.data.viacomEvent.type] || 'Type ' + item.data.viacomEvent.type;
		} else if (isAdItem) {
			exportsString = '<a id="bmi-' + item.id + '" class="export-button" target="_blank" href="pdf.php?type=bmiSubmission&sub=' + config.sub + '&id=' + item.groupingKey + '">bmi</a>'
				+ '<a id="ascap-' + item.id + '" class="export-button" target="_blank" href="pdf.php?type=ascapSubmission&sub=' + config.sub + '&id=' + item.groupingKey + '">ascap</a>';
		}

		let typeParam = type === 'Program' ? 'detectCueSheet' : 'detectLog';
		let typeText = type === 'Program' ? 'Cue Sheet' : 'Log';

		let startDate = page.vars.startDate ? new Date(page.vars.startDate).getTime() / 1000 : '';
		let endDate = page.vars.endDate ? new Date(page.vars.endDate).getTime() / 1000 : '';

		let detectionsLink = `<a id="detections-${item.id}" class="export-button" target="_blank" href="excel.php?sub=${config.sub}&type=detectDetections&startDate=${startDate}&endDate=${endDate}&groupingKey=${item.groupingKey}">Detections</a>`;
		let programFinal = `<a id="export-${item.id}" class="export-button" target="_blank" href="excel.php?sub=${config.sub}&type=${typeParam}&groupingKey=${item.groupingKey}">${typeText}</a>`;

		let exportsHtml = '';
		if (includeDetections) {
			exportsHtml = programFinal + exportsString + detectionsLink;
		} else {
			exportsHtml = programFinal + exportsString;
		}


		return exportsHtml;
	};

	/**
	 * @param {List} list
	 */
	this.showTracks = function(list) {
		//e.preventDefault();

		var parentRow = $j(this).parent();
		var ida = parentRow.find('.show-tracks').attr('id').split('_');
		var id = ida[1];
		var groupingKey = ida[2];
		var program = page.data.items[id];
		console.log('clicked', id, groupingKey, program);

		var conf = new ListConfig();
		conf.bankKey = 'sad_detections_page';
		conf.sortable = true;
		conf.suppressFeature = true;
		conf.pagination = false;
		conf.resultCountChanging = false;
		let columnList = [
			new ListColumn('track', ['play', 'title'], true),
			new ListColumn('publishers', ['publisher'], false),
			new ListColumn('writers', ['writer'], false),
			//new ListColumn('usage', ['runtime'], false),
			new ListColumn('clip', ['clip'], false),
			new ListColumn('detections', ['detections'], false)
		];

		if (page.groupBy == 'viacomkey' && page.eventTypes[ program.data.viacomEvent.type] == 'Program') {
			columnList.splice(3, 0, new ListColumn('usage', ['runtime'], false) );
		}

		conf.addColumnList(columnList);

		var listParams = {
			count: 1, //listInfo.count,
			page: 1, //listInfo.pg,
			perPage: 25, //listInfo.rpp,
			pageVars: '' //((listInfo.o) ? 'o=' + listInfo.o + '&d=' + listInfo.d + '&' : '')+'show='+listInfo.rpp+'&pg='
		};

		var listItems = [];
		listItems.push(listParams);

		var tracks = program.tracks.toString().split(',');

		_.each(tracks, function(id) {
			var track = page.data.track_info[ id ];
			var mark = page.data.marks[ id + '-' + groupingKey ];
			console.log('-', id, track);
			if (track) trackBank.add(track, 'sad_detections_page');

			if (track) {
				let trackDetections = 0;
				page.data.items.forEach(item => {
					if (!item.hasOwnProperty('detections')) return;
					for (let detection in item.detections) {
						if (parseInt(detection) === track.id && groupingKey === item.groupingKey) {
							trackDetections += item.detections[detection].length;
						}
					}
				});

				var listItem = {
					id: track ? track.id : id,
					title: track ? track.title : 'No track found.',
					publishers: track.publishers,
					writers: track.writers,
					runtime: (mark.duration + 3) + 's',
					detections: '<div class="track-detection-count" data-track-id="'+ track.id  +'" data-track-name="'+ track.title  +'">'+ trackDetections +' <i class="fa fa-external-link" style="font-size: 12px;"></i></div>',
					clip: '<div id="detection_detail_' + track.id + '_' + mark.groupingKey + '" class="details"><i class="fa fa-video-camera"></i></div>'
				};
			} else {
				listItem = {
					id: 0,
					title: '<span>[Deleted]</span> ' + mark.track_title,
					publishers: [],
					writers: [],
					detections: null,
					runtime: (mark.duration + 3) + 's',
					clip: '<div id="detection_detail_' + id + '_' + mark.groupingKey + '" class="details"><i class="fa fa-video-camera"></i></div>'
				};
			}
			listItems.push(listItem);
		});

		list.showSubTrackList(createSADetectionList, parentRow.parent(), id, conf, function(setData, subTrackList) {
			setData(listItems, function (params) {
				return '/admin?p=detect&' + params;
			}, function () {
				console.log('sort click');
				return true;
			});
			subTrackList.table.find('.details').on('click', function() { page.detailsClick.call(this); });
		});

		parentRow.find('.show-tracks').removeClass('fa-plus-square-o').addClass('fa-minus-square-o');
		parentRow.find('td').off().on('click', function(e) {
			e.preventDefault();

			var ida = parentRow.find('.show-tracks').attr('id').split('_');
			var id = ida[1];
			console.log('clicked', id);

			list.hideSubTrackList(id, function() {
				parentRow.find('.show-tracks').removeClass('fa-minus-square-o').addClass('fa-plus-square-o');
				parentRow.find('td').off().on('click', function() { page.showTracks.call(this, list); });
			});
		});

		$j(document).on('click', '#track_table_sad_detections_page .lc_detections', function() {
			// If it isn't a specific track...
			if (!$j(this).find('.track-detection-count').length) {
				let groupingKey = $j(this).closest('tr').find('.groupingKeyInfo').data('groupingkey');
				let groupingKeyModified = encodeURI(groupingKey);
				let newPath = `/admin?p=detect&tab=programs&mode=detected-tracks&groupingKey=${groupingKeyModified}`;
				sa.router.routeTo(newPath);
			} else {
				// It is a specific track
				let trackId = $j(this).find('.track-detection-count').data('track-id');
				let groupingKey = $j(this).closest('tbody.alternates_container_row').prev().find('.groupingKeyInfo').data('groupingkey');
				let groupingKeyModified = encodeURI(groupingKey);
				let newPath = `/admin?p=detect&tab=programs&mode=detected-tracks&groupingKey=${groupingKeyModified}&trackId=${trackId}`;
				sa.router.routeTo(newPath);
			}
		});

	};

	this.showDetections = function(params, container) {
		console.log('sad detections');
		container.addClass('sad_container');
		loadScript(ExtraScripts.mediaElement, function() {
			var template = templates.get('demo_table');

			container.html(template);
			$j('#sad-real-export').show();
			$j('#sad-filter-network').show();
			$j('#sad-filter-market').show();
			if (page.vars.startDate) $j('.sad-startdate').val(page.vars.startDate);
			if (page.vars.endDate) $j('.sad-enddate').val(page.vars.endDate);
			if (page.vars.market) {
				$j('#sad-filter-market').val(page.vars.market);
				$j('#sad-filter-market option[value="0"]').html('All Markets');
			}
			page.container = container;

			$j('#sad-filter-apply').on('click', () => {
				let station = $j('#sad-filter-network').val() || '';
				if (station === 'Network') station = '';
				const start = $j('.sad-startdate').val() || '';
				const end = $j('.sad-enddate').val() || '';
				const rpp = page.vars.show || 25;

				sa.router.routeTo('/admin?p=detect&tab=detections' + '&startDate=' + start + '&endDate=' + end + '&station=' + station + '&show=' + rpp);
			});

			$j('#sad-real-export a').attr('href', 'excel.php?sub=' + config.sub + '&type=detectDetections&startDate=' + (page.vars.startDate ? new Date(page.vars.startDate).getTime() / 1000 : '') + '&endDate=' + (page.vars.endDate ? new Date(page.vars.endDate).getTime() / 1000 : '') + '&stationId=' + (page.vars.station || ''));

			// Show station list (if hidden)
			$j('.detect-info').show();
			
			page.loadDetections();
		});
	};

	this.loadDetections = async function() {

		// load the full network list
		getNetworkList(function(networkList) {
			console.log(networkList);
			$j('#sad-filter-network').empty().append('<option value="0">All Networks</option>');
			
			const stations = Object.entries(networkList)
				.sort(([, a], [, b]) => a.localeCompare(b))
				.map(([value, label]) => ({ value, label }));

			stations.forEach(({ value, label }) => {
				$j('#sad-filter-network').append(`<option value="${value}">${label}</option>`);
			});

			if (page.vars.station) $j('#sad-filter-network').val( page.vars.station );

			const stationMap = {
				0: "All Networks",
				10035: "A&E",
				21251: "ABC",
				59337: "AMC",
				57394: "Animal Planet",
				64492: "BBC America",
				63236: "BET",
				21883: "Boomerang",
				58625: "Bravo",
				60048: "Cartoon Network",
				19628: "CBS",
				59250: "CBS Sports Network",
				59440: "CMT",
				58780: "CNBC",
				58646: "CNN",
				62420: "Comedy Channel",
				68065: "Cooking Channel",
				21657: "CW",
				60468: "Destination",
				56905: "Discovery Channel",
				19247: "Discovery Espanol",
				92204: "Discovery Life Channel",
				59684: "Disney",
				74885: "Disney Junior",
				60006: "Disney XD",
				61812: "E!",
				50747: "Food Network",
				21252: "FOX",
				59615: "Freeform",
				58574: "FX",
				70253: "FX Movies",
				66379: "FXX",
				66268: "Hallmark",
				46710: "Hallmark Mystery",
				49788: "HGTV",
				57708: "History Channel",
				64549: "HLN",
				59444: "IFC",
				65342: "Investigation Discovery",
				55887: "Lifetime Movie Network",
				46762: "LOGO TV",
				67375: "Magnolia",
				31046: "MotorTrend",
				10986: "MTV",
				22561: "MTV Classic",
				16361: "MTV2",
				51307: "MyNetworkTV",
				66804: "Nat Geo Wild",
				24959: "Nattional Geographic Channel",
				32281: "NBA TV",
				21250: "NBC",
				19211: "NicJr",
				11006: "Nickelodeon",
				70387: "OWN TV",
				21484: "OXYGEN",
				11163: "Paramount",
				16715: "POP TV",
				16616: "Science Channel",
				53121: "Smithsonian",
				11097: "SYFY",
				11867: "TBS",
				59036: "Teen Nick",
				11158: "TLC",
				11164: "TNT",
				11180: "Travel Channel",
				10153: "TruTV",
				16123: "TV Land",
				58452: "USA",
				60046: "VH1",
				65732: "VICE",
				59296: "WE"
			};

			$j('#sad-filter-network').selectize({
				render: {
					item: function (item, escape) {
						const stationId = Number(item.value);
						const stationPill = `<span class="station-pill">Active</span>`;
						const stationPillInactive = `<span class="station-pill inactive">Inactive</span>`;
						let monitoredIcon = !!stationMap[stationId] ? stationPill : stationPillInactive;
						monitoredIcon =  stationId > 0 ? monitoredIcon : '';
						return (
							"<div class='select-item-row'>" + (item.text ? '<span class="name">' + monitoredIcon + escape(item.text) + "</span>" : "") + "</div>"
						);
					},
					option: function (item, escape) {
						const label = item.text;
						const stationId = Number(item.value);
						const stationPill = `<span class="station-pill">Active</span>`;
						const stationPillInactive = `<span class="station-pill inactive">Inactive</span>`;
						let monitoredIcon = !!stationMap[stationId] ? stationPill : stationPillInactive;
						monitoredIcon =  stationId > 0 ? monitoredIcon : '';
						return (
							"<div class='select-item-row'>" + '<span class="label">' + monitoredIcon + escape(label) + "</span>" + "</div>"
						);
					},
				},
			});
		});

		/**
		 * @var {{
		 *     items : Array,
		 *     trackIds : int[],
		 *     tracks : Array,
		 *     labels : int[],
		 *     total : int,
		 *     rpp : int,
		 *     pg : int,
		 *     maxdate : int,
		 *     sf : int[],
		 *     station : string,
		 *     market : string,
		 *     startDate : string,
		 *     endDate : string
		 * }} data
		 */
		const data = await sa.api.request({
			handler : 'sad',
			action : 'getDetections',
			postData : {
				program: page.vars.program || '',
				pg: page.vars.pg || 0,
				rpp: page.vars.show || 25,
				station: page.vars.station || '',
				market: page.vars.market || '',
				startDate: page.vars.startDate || '',
				endDate: page.vars.endDate || ''
			}
		});

		// might already have been done by the network list load but doesn't hurt to do it again
		if (page.vars.station) $j('#sad-filter-network').val( page.vars.station );
		
		if (!data.items || !data.items.length) {
			return page.container.find('#admin-sad-table').html( data.watermark_count ?
				'<div class="no-data-yet">No data available for this view. Make sure your music is watermarked and that your clients have the watermarked versions.<br/>For more information, <a href="'+siteBaseUrl()+'/admin?p=detect&tab=home&sub=information">click here</a>.</div>' :
				'<div class="no-data-yet">The SA Detect program is currently in beta. For more information, please contact your SourceAudio rep.<br/>For more information, <a href="'+siteBaseUrl()+'/admin?p=detect&tab=home&sub=information">click here</a>.</div>' );
		}

		page.maxdate = data.maxdate;
		page.groupBy = data.groupBy;

		let track_objs = JSON.parse(data.tracks).slice(1);

		// index by track id
		data.track_info = {};
		for (var t in track_objs) {
			if (!track_objs.hasOwnProperty(t)) continue;
			data.track_info[ track_objs[t].id ] = track_objs[t];
		}
		page.data = data;

		console.log('- tracks', data.track_info);

		if (page.vars.program) {
			var bread = '<a href="'+siteBaseUrl()+'/admin?p=detect&tab=programs">Programs</a> &raquo; <a href="'+siteBaseUrl()+'/admin?p=detect&tab=detections&program=' + page.vars.program + '">' + page.vars.program + '</a>';
			if (page.vars.ep) {
				var epa = page.vars.ep.split('-');
				bread += ' &raquo; <a href="'+siteBaseUrl()+'/admin?p=detect&tab=detections&program=' + page.vars.program + '&ep=' + page.vars.ep + '">S' + epa[0] + 'E' + epa[1] + '</a>';
			}
			if (page.vars.track) {
				var trackname = data.track_info[ page.vars.track ].title;
				bread += ' &raquo; ' + trackname;
			}
			page.container.find('#breadcrumb').html( bread ).show();
		}

		$j('#admin-sad-table').html('');

		var conf = new ListConfig();
		conf.bankKey = 'sad_detections_page';
		conf.sortable = true;
		conf.suppressFeature = true;
		conf.addColumnList([
			new ListColumn('track', ['play', 'title'], true),
			new ListColumn('detected During', ['detected'], false),
			//new ListColumn('program or Ad Name', ['progname'], true),
			new ListColumn('date', ['date_string'], true),
			new ListColumn('clip', ['clip'], false)
		]);

		var list = createSADetectionList(conf);
		list.generatePage($j('#admin-sad-table'));

		var listParams = {
			count: data.total, //listInfo.count,
			page: parseInt(data.pg),
			perPage: data.rpp,
			pageVars: '&tab=detections&station=' + data.station + '&market=' + data.market + '&startDate=' + data.startDate + '&endDate=' + data.endDate + '&show=' + data.rpp + '&pg='
		};

		var listItems = [];
		listItems.push(listParams);

		for (var i in data.items) {
			if (!data.items.hasOwnProperty(i)) continue;
			var item = data.items[i];

			if (!item.track_id) continue;
			if (!item.data) continue;
			if (item.data.station.iheartId) continue; // don't handle radio stuff yet
			if (item.data.station.radiocomId) continue; // don't handle radio stuff yet
			if (item.data.station.radioFrequency) continue; // don't handle radio stuff yet

			let track = data.track_info[item.track_id];
			if (!track || !track.id) {
				track = null;
			} else {
				trackBank.add(track, 'sad_detections_page');
			}

			// Set the channel info
			let channel = item.data.station.call;
			if (item.data.station.affiliate) {
				channel = item.data.station.affiliate.replace(' Affiliate', '') + ' - ' + item.data.station.call;
			} else if (item.data.station.affiliate === 'Satellite' || item.data.station.affiliate === 'Network') { // cable channel
				channel = item.data.station.call + ' - Cable';

			}

			let name = 'Waiting on third-party data for confirmation';
			if (page.groupBy === 'viacomkey' && item.data.viacomEvent) {
				name = item.data.viacomEvent.title + '<br><span>' + (page.eventTypes[ item.data.viacomEvent.type ] || 'Type ' + item.data.viacomEvent.type) + '</span>';
			} else if (item.data.occurrence && item.data.occurrence.braneOne) {
				name = item.data.occurrence.brandOne.variant + '<br><span>' + (item.data.occurrence.brandOne.advId._id == 1 ? 'Broadcast Promo' : 'Commercial') + '</span>';
			} else if (item.data.probableBrand) {
				name = item.data.probableBrand.variant + '<br><span>Unconfirmed ' + (item.data.probableBrand.advId == 1 ? 'Broadcast Promo' : 'Commercial') + '</span>';
			} else if (item.data.probableAdv) {
				name = item.data.probableAdv.description + '<br><span>Unconfirmed ' + (item.data.probableAdv._id == 1 ? 'Broadcast Promo' : 'Commercial') + '</span>';
			} else if (!item.ad && item.groupingKey) {
				name = item.data.airing.episode.program + (item.data.airing.episode.episode ? ' - ' + item.data.airing.episode.episode : '') + '<br><span>Program</span>';
			} else if (item.data.bmat) {
				name = item.data.bmat.program + ' - ' + item.data.bmat.episode_name;
			} else if (item.data.date / 1000 < data.maxdate) {
				name = 'Unknown';
			}

			const customs = {
				100001: 'CBS Sports Live',
				100002: 'SBT Curitiba',
			};

			// Broke the old nasty one-liner into functions for readability
			function formatAiringEpisode(airing, channel) {
				const { program, episode, mpaa } = airing.episode;
				let result = program;

				if (episode) {
					result += ` - ${episode}`;
				}

				if (mpaa) {
					result += ` <span>[${mpaa}]</span>`;
				}

				return `${result}<br>${channel}`;
			}

			function formatBmatContent(item) {
				const { program, episode_name, channel_name, country_name } = item.data.bmat;
				let result = program;

				if (episode_name) {
					result += ` - ${episode_name}`;
				}

				return `${result}<br>${channel_name} - ${country_name}`;
			}

			function getCustomFeedName(stationName) {
				return `Custom Feed - ${stationName}`;
			}

			function detectProgram(item, channel, customs) {
				const stationId = parseInt(item.station);
				channel = customs[stationId] || channel;

				// Case 1: Airing data is available
				if (item.data.airing) {
					return formatAiringEpisode(item.data.airing, channel);
				}

				// Case 2: Station ID handling
				// Fox Stations & Big10
				const allowedDirectFeeds = [100003, 100005, 1000022, 1000023];
				if (stationId >= 100001 && !allowedDirectFeeds.includes(stationId)) {
					// BMAT content (station IDs 110001-199999)
					if (stationId >= 110001 && stationId < 200000) {
						return formatBmatContent(item);
					}
					// Other custom feed
					return getCustomFeedName(item.station_name);
				}

				// Case 3: Default fallback
				return customs[item.station] || channel || getCustomFeedName(item.station_name);
			}
			// Get the detected program
			const detected = detectProgram(item, channel, customs);
			
			var listItem = {
				id: item.track_id,
				title: track ? track.title : 'No track found.',
				date: item.date,
				date_string: item.date_string,
				progname: name,
				detected: detected,
				clip: item.data.video || item.data.audio ? '<div id="detection_detail_' + item.id + '_' + item.groupingKey + '" class="details"><i class="fa fa-video-camera"></i></div><div class="clr"></div>' : ' '
			};
			listItems.push(listItem);
		}
		console.log('- sending items', listItems);

		list.setData(listItems, function(params) { return '/admin?p=detect' + params; }, function(params) { console.log('sort click'); return true;});

		$j('#track_table_sad_detections_page td .details').on('click',  page.detailsClick );

		$j('#track_table_sad_detections_page td span.proids').on('hover',  function() {
			$j(this).find('div').show();
		}, function() {
			$j(this).find('div').hide();
		});

		$j('#export').on('click', function() { alert('If this were real data, this would export it!'); });

		$j('#sad-filters .sad-startdate').datepicker();
		$j('#sad-filters .sad-enddate').datepicker();
	};

	this.setDetectionClickHandler = function() {
		$j('#track_table_sad_detections_page tr.lr_sad').each(function() {
			let placeholder = $j(this).find('.video-detection-placeholder').length > 0;
			let videoEl = $j(this).find('video').length > 0;
			let detectionId;
			if (placeholder) {
				detectionId = $j(this).find('.video-detection-placeholder').prop('id');
			} else if (videoEl) {
				detectionId = $j(this).find('video').prop('id');
				detectionId = detectionId.replace('video-', '');
			} else {
				detectionId = null;
			}
			let detectionData = page.detections.find(d => d.id === parseInt(detectionId));
			let title = $j(this).find('.lc_detection-track-title').text();
			let occurrence = $j(this).find('.lc_detection-occurrence').text();
			let duration = $j(this).find('.lc_duration').text();
			$j(this).off('click');
			$j(this).on('click', function(e) {
				e.preventDefault();
				console.group('Detection Id: ', detectionId);
				console.info({
					id: detectionId,
					title: title,
					occurrence: occurrence,
					duration: duration
				});
				console.info(detectionData);
				console.groupEnd();
			});
		});
	}

	/**
	 * Gets the network list and sends it to a callback function
	 * @param {function} callback receives an array network list
	 */
	function getNetworkList(callback) {
		if (networkList.length) {
			callback(networkList);
		} else {
			sa.api.request({
				handler : 'sad',
				action : 'getNetworks'
			}).then(function (networks) {
				networkList = networks;
				callback(networkList);
			});
		}
	}

	this.detailsClick = function (e) {
		var id = $j(this).attr('id');
		var ida = id.split('_');
		var key = ida.pop();
		var did = ida.pop();
		console.log('- clicked:', did, id, key);

		// find the item
		var item = null;
		for (var i in page.data.items) {
			if (page.data.items[i].id === did) {
				item = page.data.items[i];
				break;
			}
		}
		if (!item) {
			item = page.data.marks[ did + '-' + key ];
		}
		console.log('item:', item);

		let name = 'Waiting on third-party data for confirmation';
		let type = name;
		if (page.groupBy === 'viacomkey' && item.data.viacomEvent) {
			name = item.data.viacomEvent.title;
			type = item.data.viacomEvent.type === 1 || item.data.viacomEvent.type === 63 ? 'Program' : item.data.viacomEvent.type === 4 ? 'Broadcast Promo' : 'Commercial';
		} else if (item.data.occurrence && item.data.occurrence.brandOne) {
			name = item.data.occurrence.brandOne.variant;
			type = item.data.occurrence.brandOne.advId._id === 1 ? 'Broadcast Promo' : 'Commercial';
		} else if (item.data.probableBrand) {
			name = item.data.probableBrand.variant;
			type = 'Unconfirmed ' + (item.data.probableBrand.advId === 1 ? 'Broadcast Promo' : 'Commercial');
		} else if (item.data.probableAdv) {
			name = item.data.probableAdv.description;
			type = 'Unconfirmed ' + (item.data.probableAdv._id === 1 ? 'Broadcast Promo' : 'Commercial');
		} else if (!item.ad && item.groupingKey) {
			name = item.data.airing.episode.program;
			type = 'Program';
		} else if (!item.ad && item.data.airing) {
			name = item.data.airing.episode.program ?? 'Unknown Airing';
			type = 'Program';
		} else if (item.data.date / 1000 < page.maxdate || !item.data.airing) {
			name = 'Unknown';
			type = name;
		}

		const popup = templates.get('details_popup');
		popup.find('.title span').html(item.track_title || 'Track ID: ' + item.track_id);
		// https://sourceaudio-sad.s3.amazonaws.com/2015-9-28/571198-1443448793548.mp4
		var video = item.data.video;
		if (video.split('/').length < 2) {
			var date = new Date(item.data.date);
			video = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + '/' + video;

		}
		var channel = item.data.station.call + ' (' + item.data.station.affiliate.replace(' Affiliate', '') + ') ' + item.data.station.city;
		if (item.data.station.affiliate == 'Satellite' || item.data.station.affiliate == 'Network') { // cable channel
			channel = item.data.station.call + ' (Cable) ';
		}
		if (item.data.station.custom) { // internet stream
			channel = item.data.station.call + ' (Stream) ';
		}

		popup.find('.text .video').html('<video src="https://sourceaudio-sad.s3.amazonaws.com/' + video + '" controls playsinline style="min-width: 318px; height: 100%;"></video>');
		popup.find('#download-link .info-val a').attr('href', 'https://sourceaudio-sad.s3.amazonaws.com/' + video);

		popup.find('#info-type .info-val').html(type);
		popup.find('#info-name .info-val').html(name);
		if (type && type.toLowerCase() === 'program') {
			if (item.data.airing.episode.episode) {
				popup.find('#info-episode-title .info-val').text(item.data.airing.episode.episode);
			} else {
				popup.find('#info-episode-title').hide();
			}
			
			if (item.data.airing.episode.epnum) {
				popup.find('#info-episode-number .info-val').text(item.data.airing.episode.epnum);
			} else {
				popup.find('#info-episode-number').hide();
			}
			
			// channel = StringSanitize.encodeIfNotEncoded(channel);
			
			if (channel) {
				popup.find('#info-airing .info-val').text(channel);
				const startDatetime = Math.round(Number(item.data.airing.start) / 1000);
				
				popup.find('#info-airing .info-val').append('<br>' + formatDate(config.dateFormatString + ' @ g:ia', startDatetime) + ' (' + item.data.airing.duration + 'min)');
			} else {
				popup.find('#info-airing .info-val').hide();
			}
			
		} else {
			popup.find('.prog-info').hide();
			popup.find('#info-airing .info-val').text(channel);
			const airDate = Number(item.date);
			popup.find('#info-airing .info-val').append('<br>' + formatDate(config.dateFormatString + ' @ g:ia', airDate));
		}
		
		// if (hideAiring) popup.find('#info-airing').hide();

		popup.on('click', function() { popup.remove(); });
		popup.find('.content').on('click', function(e) { e.stopPropagation(); });
		popup.find('#popup-cancel').on('click', function() { popup.remove(); });

		$j('body').append(popup);
	};

}
/**
 * A page in the admin panel
 */
function AdminSADRadioDetections() {
	const page = this;
	const templates = sa.templates.get('admin.sad');

	let networkList = [];

	this.currentTab = '';

	this.detections = [];

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		const pageId = sa.router.paramsToVars(params).tab;

		AdminSAD.getPaidStatus(paid => {
			if (paid) {
				showPaid(pageId, container);
			} else if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				showPaid(pageId, container);
				sa.notify({ text: 'This workspace is currently unpaid so this page is only accessible to SourceAudio employees.' });
			} else {
				sa.router.routeTo('/admin?p=detect&tab=home', true);
				sa.notify({ text: 'Please sign up before accessing your detections!' });
			}
		});
	};

	function showPaid(pageId, container) {
		page.vars = sa.router.getCurrentParamsAsObject();
		page.currentTab = pageId;
		if (pageId === 'radio') {
			page.showRadioDetections('', container);
		}
	}

	/**
	 * @param {List} list
	 */
	this.showTracks = function (list) {
		const parentRow = $j(this).parent();
		const ida = parentRow.find('.show-tracks').attr('id').split('_');
		const id = ida[1];
		const groupingKey = ida[2];
		const program = page.data.items[id];
		console.log('clicked', id, groupingKey, program);

		const conf = new ListConfig();
		conf.bankKey = 'sad_radiodetections_page';
		conf.sortable = true;
		conf.suppressFeature = true;
		conf.allowBlock = true;
		conf.pagination = false;
		conf.resultCountChanging = false;
		const columnList = [
			new ListColumn('track', ['play', 'title'], true),
			new ListColumn('publishers', ['publisher'], false),
			new ListColumn('writers', ['writer'], false),
			// new ListColumn('usage', ['runtime'], false),
			new ListColumn('clip', ['clip'], false),
			new ListColumn('detections', ['detections'], false)
		];

		conf.addColumnList(columnList);

		const listParams = {
			count: 1, // listInfo.count,
			page: 1, // listInfo.pg,
			perPage: 25, // listInfo.rpp,
			pageVars: '' // ((listInfo.o) ? 'o=' + listInfo.o + '&d=' + listInfo.d + '&' : '')+'show='+listInfo.rpp+'&pg='
		};

		const listItems = [];
		listItems.push(listParams);

		const tracks = program.tracks.toString().split(',');

		_.each(tracks, (id) => {
			const track = page.data.track_info[id];
			const mark = page.data.marks[`${id}-${groupingKey}`];
			console.log('-', id, track);
			if (track) trackBank.add(track, 'sad_radiodetections_page');
			
			let listItem;
			
			if (track) {
				let trackDetections = 0;
				page.data.items.forEach(item => {
					if (!item.hasOwnProperty('detections')) return;
					
					Object.keys(item.detections).forEach(detection => {
						if (parseInt(detection) === track.id && groupingKey === item.groupingKey) {
							trackDetections += item.detections[detection].length;
						}
					});
				});

				listItem = {
					id: track ? track.id : id,
					title: track ? track.title : 'No track found.',
					publishers: track.publishers,
					writers: track.writers,
					runtime: `${mark.duration + 3}s`,
					detections: `<div class="track-detection-count" data-track-id="${track.id}" data-track-name="${StringSanitize.encodeIfNotEncoded(track.title)}">${trackDetections} <i class="fa fa-external-link" style="font-size: 12px;"></i></div>`,
					clip: `<div id="detection_detail_${track.id}_${mark.groupingKey}" class="details"><i style="font-size: 20px; padding-right: 40px;" class="fa-solid fa-tower-broadcast"></i></div>`
				};
			} else {
				listItem = {
					id: 0,
					title: `<span>[Deleted]</span> ${StringSanitize.encodeIfNotEncoded(mark.track_title)}`,
					publishers: [],
					writers: [],
					detections: null,
					runtime: `${mark.duration + 3}s`,
					clip: `<div id="detection_detail_${id}_${mark.groupingKey}" class="details"><i style="font-size: 20px; padding-right: 40px;" class="fa-solid fa-tower-broadcast"></i></div>`
				};
			}
			listItems.push(listItem);
		});

		list.showSubTrackList(createSADetectionList, parentRow.parent(), id, conf, (setData, subTrackList) => {
			setData(listItems, (params) => {
				return `/admin?p=detect&${params}`;
			}, () => {
				console.log('sort click');
				return true;
			});
			subTrackList.table.find('.details').on('click', function () { page.detailsClick.call(this); });
		});

		parentRow.find('.show-tracks').removeClass('fa-plus-square-o').addClass('fa-minus-square-o');
		parentRow.find('td').off().on('click', (e) => {
			e.preventDefault();

			const ida = parentRow.find('.show-tracks').attr('id').split('_');
			const id = ida[1];
			console.log('clicked', id);

			list.hideSubTrackList(id, () => {
				parentRow.find('.show-tracks').removeClass('fa-minus-square-o').addClass('fa-plus-square-o');
				parentRow.find('td').off().on('click', function () { page.showTracks.call(this, list); });
			});
		});

		$j(document).on('click', '#track_table_sad_radiodetections_page .lc_detections', function () {
			// If it isn't a specific track...
			if (!$j(this).find('.track-detection-count').length) {
				const groupingKey = $j(this).closest('tr').find('.groupingKeyInfo').data('groupingkey');
				const groupingKeyModified = encodeURI(groupingKey);
				const newPath = `/admin?p=detect&tab=programs&mode=detected-tracks&groupingKey=${groupingKeyModified}`;
				sa.router.routeTo(newPath, true);
			} else {
				// It is a specific track
				const trackId = $j(this).find('.track-detection-count').data('track-id');
				const groupingKey = $j(this).closest('tbody.alternates_container_row').prev().find('.groupingKeyInfo')
					.data('groupingkey');
				const groupingKeyModified = encodeURI(groupingKey);
				const newPath = `/admin?p=detect&tab=programs&mode=detected-tracks&groupingKey=${groupingKeyModified}&trackId=${trackId}`;
				sa.router.routeTo(newPath, true);
			}
		});
	};

	this.showRadioDetections = function (params, container) {
		console.log('sad radio detections');
		container.addClass('sad_container');
		loadScript(ExtraScripts.mediaElement, () => {
			const template = templates.get('demo_table');

			container.html(template);
			$j('#sad-real-export').show();
			$j('#sad-filter-network').show();
			$j('#sad-filter-market').show();
			
			// Set the input fields with values if they're available
			if (page.vars.startDate) $j('.sad-startdate').val(page.vars.startDate);
			if (page.vars.endDate) $j('.sad-enddate').val(page.vars.endDate);
			if (page.vars.market) {
				$j('#sad-filter-market').val(page.vars.market);
				$j('#sad-filter-market option[value="0"]').html('All Markets');
			}
			page.container = container;

			$j('#sad-filter-apply').on('click', () => {
				let station = $j('#sad-filter-network').val() || '';
				// To look up the stations, we need to bring the underscore back
				station = station.split(' ').join('_');
				const market = $j('#sad-filter-market').val() || '';
				const start = $j('.sad-startdate').val() || '';
				const end = $j('.sad-enddate').val() || '';
				const rpp = page.vars.show || 25;

				sa.router.routeTo(`/admin?p=detect&tab=radio&market=${market}&startDate=${start}&endDate=${end}&station=${station}&show=${rpp}`);
			});

			$j('#sad-real-export a').attr('href', `excel.php?sub=${config.sub}&type=detectRadioDetections&startDate=${page.vars.startDate ? new Date(page.vars.startDate).getTime() / 1000 : ''}&endDate=${page.vars.endDate ? new Date(page.vars.endDate).getTime() / 1000 : ''}&station=${page.vars.station || ''}`);

			// Hide station list link
			$j('.detect-info').hide();
			
			page.loadDetections();
		});
	};

	this.loadDetections = async function () {
		// load the full network list
		getNetworkList((networkList) => {
			$j('#sad-filter-network').empty().append('<option value="0">All Stations</option>');
			const cleaned = [];
			_.each(networkList, (station) => {
				if (station.indexOf('(') !== -1 && station.charAt(0) === 'W') {
					station = station.split(' (')[1].replace(')', '');
				} else if (station.indexOf('(') !== -1) station = station.split(' (')[0];
				cleaned.push(station);
			});

			const sorted = _.sortBy(cleaned);
			_.each(sorted, (station) => {
				const stationFormatted = station.split('_').join(' ').replace(/(D)(AM|FM)/g, '$2');
				$j('#sad-filter-network').append(`<option value="${station}">${stationFormatted}</option>`);
			});

			if (page.vars.station) $j('#sad-filter-network').val(page.vars.station);
		});

		/**
		 * @var {{
		 *     items : Array,
		 *     trackIds : int[],
		 *     tracks : Array,
		 *     labels : int[],
		 *     total : int,
		 *     rpp : int,
		 *     pg : int,
		 *     maxdate : int,
		 *     sf : int[],
		 *     station : string,
		 *     market : string,
		 *     startDate : string,
		 *     endDate : string
		 * }} data
		 */
		const data = await sa.api.request({
			handler: 'sad',
			action: 'getRadioDetections',
			postData: {
				program: page.vars.program || '',
				pg: page.vars.pg || 0,
				rpp: page.vars.show || 25,
				station: page.vars.station || '',
				market: page.vars.market || '',
				startDate: page.vars.startDate || '',
				endDate: page.vars.endDate || ''
			}
		});

		// might already have been done by the network list load but doesn't hurt to do it again
		if (page.vars.station) $j('#sad-filter-network').val(page.vars.station);

		if (!data.items || !data.items.length) {
			return page.container.find('#admin-sad-table').html(data.watermark_count
				? `<div class="no-data-yet">No data available for this view. Make sure your music is watermarked and that your clients have the watermarked versions.<br/>For more information, <a href="${siteBaseUrl()}/admin?p=detect&tab=home&sub=information">click here</a>.</div>`
				: `<div class="no-data-yet">The SA Detect program is currently in beta. For more information, please contact your SourceAudio rep.<br/>For more information, <a href="${siteBaseUrl()}/admin?p=detect&tab=home&sub=information">click here</a>.</div>`);
		}

		page.maxdate = data.maxdate;
		page.groupBy = data.groupBy;

		const trackObjs = JSON.parse(data.tracks).slice(1);

		// index by track id
		data.track_info = {};
		
		for (const t in trackObjs) {
			if (!trackObjs.hasOwnProperty(t)) continue;
			data.track_info[trackObjs[t].id] = trackObjs[t];
		}
		page.data = data;

		console.log('- tracks', data.track_info);

		if (page.vars.program) {
			let bread = `<a href="${siteBaseUrl()}/admin?p=detect&tab=programs">Programs</a> &raquo; <a href="${siteBaseUrl()}/admin?p=detect&tab=radio&program=${page.vars.program}">${page.vars.program}</a>`;
			if (page.vars.ep) {
				const epa = page.vars.ep.split('-');
				bread += ` &raquo; <a href="${siteBaseUrl()}/admin?p=detect&tab=radio&program=${page.vars.program}&ep=${page.vars.ep}">S${epa[0]}E${epa[1]}</a>`;
			}
			if (page.vars.track) {
				const trackname = data.track_info[page.vars.track].title;
				bread += ` &raquo; ${trackname}`;
			}
			page.container.find('#breadcrumb').html(bread).show();
		}

		$j('#admin-sad-table').html('');

		const conf = new ListConfig();
		conf.bankKey = 'sad_radiodetections_page';
		conf.sortable = true;
		conf.suppressFeature = true;
		conf.allowMobileView = false;
		conf.allowMiniBlock = false;
		conf.addColumnList([
			new ListColumn('track', ['play', 'title'], true),
			new ListColumn('detected On', ['detected'], false),
			new ListColumn('date', ['date_string'], true),
			new ListColumn('clip', ['clip'], false)
		]);

		const list = createSADetectionList(conf);
		list.generatePage($j('#admin-sad-table'));

		const listParams = {
			count: data.total, // listInfo.count,
			page: parseInt(data.pg),
			perPage: data.rpp,
			pageVars: `&tab=radio&station=${data.station}&market=${data.market}&startDate=${data.startDate}&endDate=${data.endDate}&show=${data.rpp}&pg=`
		};

		const listItems = [];
		listItems.push(listParams);

		for (const i in data.items) {
			if (!data.items.hasOwnProperty(i)) continue;
			const item = data.items[i];

			if (!item.track_id) continue;
			if (!item.data) continue;

			let track = data.track_info[item.track_id];
			if (!track || !track.id) {
				track = null;
			} else {
				trackBank.add(track, 'sad_radiodetections_page');
			}

			const name = item.track_name;

			const detected = `${item.data.station.name}<br>${item.data.station.radioCity}` || 'Custom Stream';
			
			const listItem = {
				id: item.track_id,
				title: track ? track.title : 'No track found.',
				date: item.date,
				date_string: item.date_string,
				progname: name,
				detected,
				clip: item.data.video || item.data.audio ? `<div id="detection_detail_${item.id}_${item.groupingKey}" class="details"><i style="font-size: 20px; padding-right: 40px;" class="fa-solid fa-tower-broadcast"></i></div><div class="clr"></div>` : ' '
			};
			listItems.push(listItem);
		}
		console.log('- sending items', listItems);

		list.setData(listItems, (params) => { return `/admin?p=detect${params}`; }, (params) => { console.log('sort click'); return true; });

		$j('#track_table_sad_radiodetections_page td .details').on('click', page.detailsClick);

		$j('#track_table_sad_radiodetections_page td span.proids').on('hover', function () {
			$j(this).find('div').show();
		}, function () {
			$j(this).find('div').hide();
		});

		$j('#export').on('click', () => sa.alert('If this were real data, this would export it!'));

		$j('#sad-filters .sad-startdate').datepicker();
		$j('#sad-filters .sad-enddate').datepicker();
	};

	/**
	 * Gets the network list and sends it to a callback function
	 * @param {function} callback receives an array network list
	 */
	function getNetworkList(callback) {
		if (networkList.length) {
			callback(networkList);
		} else {
			sa.api.request({
				handler: 'sad',
				action: 'getRadioStations'
			}).then((networks) => {
				networkList = networks;
				callback(networkList);
			});
		}
	}

	this.detailsClick = function (hideAiring) {
		const id = $j(this).attr('id');
		const ida = id.split('_');
		const key = ida.pop();
		const did = ida.pop();
		console.log('- clicked:', did, id, key);

		// find the item		
		let item = page.data.items.find(it => it.id === did);
		
		if (!item) {
			item = page.data.marks[`${did}-${key}`];
		}

		let station = item.data?.station.name;

		const popup = templates.get('radio_details_popup');
		popup.find('.title span').html(item.track_title);
		
		let { audio } = item.data;
		if (audio.split('/').length < 2) {
			const date = new Date(item.data.date);
			audio = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}/${audio}`;
		}
		
		if (item.data?.station?.custom) { // internet stream
			station = `${item.data.station.call} (Stream) `;
		}

		popup.find('.text .audio').html(`<audio src="https://sourceaudio-sad.s3.amazonaws.com/${audio}" controls></audio>`);
		popup.find('#radio-download-link .info-val a').attr('href', `https://sourceaudio-sad.s3.amazonaws.com/${audio}`);

		popup.find('#radio-info-name .info-val').html(station);
		
		if (hideAiring) popup.find('#radio-info-airing').hide();

		popup.on('click', () => { popup.remove(); });
		popup.find('.content').on('click', (e) => { e.stopPropagation(); });
		popup.find('#radio-popup-cancel').on('click', () => { popup.remove(); });

		$j('body').append(popup);
	};
}

function AdminSADHome() {
	var page = this;
	var templates = sa.templates.get('admin.sad');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (config.watermarked < 0) {
			sa.notify({ text : 'SourceAudio Detect disabled for this workspace. Please contact SourceAudio if you have any questions.' });
			sa.router.routeTo('/');
			return;
		}
		container.html('');
		showLoader(container, 'Loading SA Detect data');

		if (!config.watermarked) {
			showUnsubscribed(container);
		} else {
			AdminSAD.getPaidStatus((paid) => {
				if (paid) {
					if (
						(typeof params === 'string' && params.indexOf('information') !== -1)
						|| (typeof params === 'object' && params.hasOwnProperty('information'))
					) {
						showInformation(container);
					} else {
						showPaid(container);
					}
				} else {
					showUnsubscribed(container);
				}
			});
		}

	};

	function showInformation(container) {
		container.empty().append(templates.get('information_page'));
	}

	async function showUnsubscribed(container) {
		var template = templates.get('home_unsubscribed');

		/**
		 * @var {{ trackTiers : Array, ramps : Array, rampDiscount : int, trackCount : int, price : int, rampPercentage : float }} data
		 */
		const data = await sa.api.request({
			handler : 'sad',
			action : 'loadBillingTiers'
		});

		// add track price data
		/** @var {JQuery} rowContainer */
		var rowContainer = template.find('#price_per_track .price_rows');
		var rowTemplate = template.find('#price_per_track .price_row').clone();
		rowContainer.empty();
		for (let i = 0, len = data.trackTiers.length; i < len; i++) {
			let tier = data.trackTiers[i];
			let row = rowTemplate.clone();
			row.find('.count').html(tier.trackMinimum.numberFormat() + (tier.trackMaximum > 0 ? ' - ' + tier.trackMaximum.numberFormat() : '+'));
			row.find('.price').html(tier.price.moneyFormat(0, true));
			rowContainer.append(row);
		}

		// add discount data
		rowContainer = template.find('#ramps .price_rows');
		rowTemplate = template.find('#ramps .price_row').clone();
		rowContainer.empty();
		for (let i = 0, len = data.ramps.length; i < len; i++) {
			let tier = data.ramps[i];
			let row = rowTemplate.clone();
			row.find('.month').html(addOrdinal(i + 1) + ' month' + (tier.rampId == 0 ? ' onwards' : ''));
			row.find('.price').html(tier.percentage + '%');
			rowContainer.append(row);
		}

		// enable signup
		if (user.siteOwner) {
			template.find('.not_site_owner').remove();
			template.find('.track_count').html(data.trackCount.numberFormat());
			if (!data.rampDiscount) {
				template.find('.ramp_up_text').remove();
			}
			template.find('.initial_payment_amount').html(data.price.moneyFormat(2, true));
			template.find('.signup_button').on('click', function() {
				//sa.alert({ text: 'SourceAudio Detect is not accepting signups at this time. Please contact <a href="mailto:support@sourceaudio.com">support@sourceaudio.com</a> for more information and check back soon!' });
				sa.components.billing.addAddon('detect', function(agreed) {
					console.log('got response from billing addAddon', agreed);
					if (agreed) {
						config.watermarked = 1;
						sa.router.reloadPage();
					}
				});
			});
		} else {
			template.find('.site_owner').remove();
			showSiteOwner(template);
		}

		container.html('').append(template);
	}

	function showSiteOwner(template) {
		sa.getSiteOwner(function(ownerInformation) {
			if (ownerInformation) {
				template.find('.so_cont .name').html(ownerInformation.username);
				template.find('.so_cont .email').html(ownerInformation.email);
				template.find('.so_cont .no_owner').remove();
			} else {
				template.find('.so_cont .has_owner').remove();
			}
		});
	}

	async function showPaid(container) {
		console.log('showing paid');

		const data = await sa.api.request({
			handler : 'sad',
			action : 'loadBillingStatus'
		});


		console.log('showing paid data', data);

		var template = templates.get('home_paid');

		if (data['owned']) {
			template.find('#unsubscribe').on('click', function() {
				sa.components.billing.removeAddon('detect', function(agreed) {
					if (agreed) {
						AdminSAD.resetPaidStatus();
						sa.router.reloadPage();
					}
				});
			});
		} else {
			template.find('.billing_details').remove();
		}

		if (data['watermarkQueue'] && data['watermarkQueue'] != 0) {
			template.find('.watermarked').remove();
		} else {
			template.find('.watermarking').remove();
		}

		container.html('').append(template);
	}

}

function AdminSADTest() {
	var page = this;
	var templates = sa.templates.get('admin.sad');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {

		AdminSAD.getPaidStatus(function (paid) {
			if (paid) {
				showPaid(container);
			} else if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				showPaid(container);
				sa.notify({ text : 'This workspace is currently unpaid so this page is only accessible to SourceAudio employees.' });
			} else {
				sa.router.routeTo('/admin?p=detect&tab=home');
				sa.notify({ text : 'Please sign up before accessing your detections!' });
			}
		});

	};

	function showPaid(container) {

		var template = templates.get('test');
		template.find('input[name=whiteId]').val(config.id);
		template.find('input[name=userId]').val(user.userData.id);

		function submitForm(formData) {
			if (!formData) {
				formData = new FormData(window['file_form']);
			}
			template.find('.cover').show();
			$j.ajax({
				url : 'https://' + ImportDomain + '/sadetect/ajax.php',
				type : 'POST',
				data : formData,
				processData : false,
				contentType : false,
				dataType : 'json',
				success : function(result) {
					template.find('.cover').hide();
					showResult(template, result);
					template.find('input[type=file]').val('');
					template.find('input[type=text]').val('');
				}
			});
		}

		sa.components.edad.addGenericDropZone({
			allowedExtensions : [ 'mp3', 'aif', 'aiff', 'wav', 'mp4', 'avi', 'wmv', 'flv' ],
			anchorSelector : '#sad_test .drop_target',
			templateSelector : 'detect_test_drop_zone',
			uniqueKey : 'detect_test_drop_zone',
			dropCallback : function(files) {

				if (files.length < 1) return;

				var formData = new FormData();

				formData.append('file', files[0]);

				submitForm(formData);
			}
		});

		var dropTarget = template.find('.drop_target');

		template.find('.search_button').on('click', function() {
			submitForm();
		});

		template.find('form').on('submit', function() {
			submitForm();
			return false;
		});

		dropTarget.on('click', function() {
			template.find('input[type=file]').trigger('click');
		});

		template.find('input[type=file]').on('change', function() {
			submitForm();
		});

		container.empty().append(template);

	}

	// result handling
	function showResult(template, watermarks) {
		template.find('.results').show();

		if (watermarks.error) {
			template.find('.detected').hide();
			template.find('.error').show().html(watermarks.error);
			return console.log(watermarks.error);
		}

		template.find('.error').hide();
		template.find('.detected').show();
		template.find('.detect_number .number').html(watermarks.length);

		if (!watermarks.length) {
			template.find('.detection_list').hide();
		} else {

			var baseDetection = template.find('.detection:first').clone(),
				detectionList = template.find('.detection_list');

			detectionList.empty().show();

			for (var w = 0, wLen = watermarks.length; w < wLen; w++) {

				var detection = baseDetection.clone(),
					watermark = watermarks[w];

				detection.find('.number').html(w + 1);

				detection.find('.title .datum').html(watermark.title);

				if (watermark.site) {
					detection.find('.site .datum').html(watermark.site);
					detection.find('.site').show();
				} else {
					detection.find('.site').hide();
				}

				detectionList.append(detection);

			}

			if (watermarks.length > 1) {
				$j('.plural').show();
			} else {
				$j('.plural').hide();
			}

		}

		$j('html, body').animate({ scrollTop : template.find('.results').position().top });
	}

}
/**
 * The page in the admin panel that lets you view and manage your licensing and e-commerce options
 */
function AdminSEO() {

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Settings)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Change Settings' + '" permission.</h3>');
		} else if (config.grayLabel) {
			return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}

		var cap = new sa.collapsingAdminPage();
		cap.addSection({
			name : 'Tag Manager',
			contents : getTagManagerTemplate()
		});
		cap.addSection({
			name : 'Page Aliases',
			contents : getPageAliasesTemplate()
		});
		cap.addToContainer(container);
	};
	
	function getTagManagerTemplate() {
		let container = $j('<div></div>');
		let page = new AdminSEOTags();
		page.show(container);
		return container;
	}
	
	function getPageAliasesTemplate() {
		let container = $j('<div></div>');
		let page = new AdminSEOAlias();
		page.show(container);
		return container;
	}
	
}

function AdminSEOAlias() {
	var page = this;
	var templates = sa.templates.get('admin.seo');

	let pageContainer;
	let customRuleTemplate;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {JQuery} container
	 */
	this.show = function (container) {
		container.html('');
		const template = templates.get('alias_page');
		pageContainer = container;

		container.append(template);

		// buttons
		pageContainer.find('#seo-settings-save').on('click', () => { page.save(); });
		pageContainer.find('#seo-settings-addrule').on('click', () => { page.addCustomRule(); });
		pageContainer.find('.show_advanced_matching').on('click', () => { pageContainer.find('#advmatching').toggle(); });

		// rules setup
		customRuleTemplate = pageContainer.find('#alias-rule-template').detach();

		if (config.seo.settings.alias) {
			_.each(config.seo.settings.alias, (r) => {
				page.addCustomRule(r);
			});
		}

		page.addCustomRule();

	};

	this.addCustomRule = function (r) {

		const newCustomRule = customRuleTemplate.clone();
		const count = pageContainer.find('#alias-rules .alias-rule').length;

		newCustomRule.attr('id', 'rule-' + (count + 1));

		if (r) {
			newCustomRule.find('.rule-pattern').val(r.pattern);
			newCustomRule.find('.rule-result').val(r.result);
		}
		
		newCustomRule.find('.remove-alias i').on('click', () => {
			newCustomRule.remove();
		});

		pageContainer.find('#alias-rules').append(newCustomRule);
	};

	this.save = function() {

		var rules = [];
		var error = null;
		pageContainer.find('.alias-rule').each(function() {
			var r = $j(this);
			var rule = {
				pattern: r.find('.rule-pattern').val(),
				result: r.find('.rule-result').val()
			};

			if (!rule.pattern) return true;

			// double check the pattern
			if (rule.pattern.charAt(0) == '/' && rule.pattern.charAt( rule.pattern.length ) == '/') {
				try {
					new RegExp( rule.pattern.substr(1, rule.pattern.length - 2) );
				} catch(e) {
					console.log(e);
					error = '<code>' + rule.pattern + '</code> is not a valid pattern.';
					return false;
				}
			}

			rules.push( rule );
		});
		if (error) return sa.alert( error );

		console.log( rules );

		sa.api.request({
			handler : 'seo',
			action : 'saveAliasSettings',
			postData : {
				data : rules
			}
		}).then(() => {
			sa.notify({text: 'Settings Saved!', type: 'success_notification'});
		});
	};


}

function AdminSEOTags() {
	var page = this;
	var templates = sa.templates.get('admin.seo');
	
	let pageContainer;
	let customRuleTemplate;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {JQuery} container
	 */
	this.show = function(container) {
		container.html('');
		var template = templates.get('tags_page');
		pageContainer = container;

		container.append( template );

		// fill in saved
		if (!config.seo.settings.meta) config.seo.settings.meta = {};
		if (config.seo.settings.meta.title) pageContainer.find('#seo-title').val( config.seo.settings.meta.title );
		if (config.seo.settings.meta.description) pageContainer.find('#seo-description').val( config.seo.settings.meta.description );
		if (config.seo.settings.meta.keywords) pageContainer.find('#seo-keywords').val( config.seo.settings.meta.keywords );


		// buttons
		pageContainer.find('#seo-settings-save').on('click',  function() { page.save(); } );
		pageContainer.find('#seo-settings-addrule').on('click',  function() { page.addCustomRule(); } );
		pageContainer.find('.show_advanced_matching').on('click', function() { pageContainer.find('#advmatching').toggle(); });

		customRuleTemplate = pageContainer.find('#tag-rule-template').detach();

		if (config.seo.settings.meta.rules) {
			_.each(config.seo.settings.meta.rules, function(r) {
				page.addCustomRule(r);
			});
		}

		page.addCustomRule();

	};

	this.addCustomRule = function(r) {

		var div = customRuleTemplate.clone();
		var count = pageContainer.find('#tag-rules .tag-rule').length;

		div.attr('id', 'rule-' + (count + 1));

		if (r) {
			div.find('.rule-pattern').val( r.pattern.replace(/\\{2,}/g, "\\"));
			div.find('.rule-title').val( r.title );
			div.find('.rule-description').val( r.description );
			div.find('.rule-keywords').val( r.keywords );
		}
		
		div.find('.page-tag-remove').on('click', function() {
			div.remove();
		});


		pageContainer.find('#tag-rules').append( div );
	};

	this.save = function() {

		var settings = {
			title: pageContainer.find('#seo-title').val(),
			description: pageContainer.find('#seo-description').val(),
			keywords: pageContainer.find('#seo-keywords').val(),
			set: 1
		};

		var rules = [];
		var error = null;
		pageContainer.find('.tag-rule').each(function() {
			var r = $j(this);
			var rule = {
				pattern: r.find('.rule-pattern').val(),
				title: r.find('.rule-title').val(),
				description: r.find('.rule-description').val(),
				keywords: r.find('.rule-keywords').val()
			};

			if (!rule.pattern) return true;

			// double check the pattern
			if (rule.pattern.charAt(0) == '/' && rule.pattern.charAt( rule.pattern.length ) == '/') {
				try {
					new RegExp( rule.pattern.substr(1, rule.pattern.length - 2) );
				} catch(e) {
					console.log(e);
					error = '<code>' + rule.pattern + '</code> is not a valid pattern.';
					return false;
				}
			}

			rules.push( rule );
		});
		if (error) return sa.alert( error );

		settings.rules = rules;

		console.log( settings );

		sa.api.request({
			handler : 'seo',
			action : 'saveTagSettings',
			postData : {
				data : settings
			}
		}).then(() => {
			sa.notify({text: 'Settings Saved!', type: 'success_notification'});
		});
	};


}
/**
 * The page in the admin panel that lets you see what users have been search for
 */
function AdminStatsMusic() {

	var page = this;
	var siteId = config.id;
	var templates = sa.templates.get('admin.stats.music');

	let list; // the list object for the current tab
	let lastRequest; // last request string

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Statistics)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Statistics' + '" permission.</h3>');
		}

		container.empty().append(templates.get('page'));
		loadMonthly();
		loadTracks();
		loadExternalSites(container.find('#monthly'));

		// set up the tabs
		if (config.singleCatalog) {
			$j('#history_tabs #catalogs').remove();
		}
		$j('#history_tabs .tab').on('click', function(e) {
			var t = $j(this),
				id = t.attr('id');
			t.parent().find('a').removeClass('selected');
			t.addClass('selected');
			loadCurrentType();
			e.preventDefault();
			return false;
		});

		// set up the filters
		$j('#filters select').on('change', function() {
			loadCurrentType();
		});
		$j('#filters #time').on('change', function() {
			var timeSelectorContainer = $j('#filters #time_selector_container');
			if (this.value === '-1') {
				timeSelectorContainer.slideDown();
			} else {
				timeSelectorContainer.slideUp();
			}
		});
		var fromDate = $j('#filters #stats_from_date');
		var toDate = $j('#filters #stats_to_date');
		var startTimestamp = new Date().getTime() / 1000;
		fromDate.val(formatDate(config.dateFormatString, startTimestamp - 86400 * 7));
		fromDate.datepicker({
			changeMonth : true,
			dateFormat : config.datePickerDateFormatString,
			maxDate : '-1d'
		});
		fromDate.on('change', function() {
			toDate.datepicker('option', 'minDate', $j.datepicker.parseDate(config.datePickerDateFormatString, this.value));
		});
		toDate.val(formatDate(config.dateFormatString, startTimestamp));
		toDate.datepicker({
			changeMonth : true,
			dateFormat : config.datePickerDateFormatString,
			maxDate : '-1d'
		});
		toDate.on('change', function() {
			fromDate.datepicker('option', 'maxDate', $j.datepicker.parseDate(config.datePickerDateFormatString, this.value));
		});
		fromDate.trigger('change');
		toDate.trigger('change');
		$j('#filters input').on('change', function() {
			loadCurrentType();
		});
	};

	async function loadExternalSites(container) {
		const sites = await sa.api.request({
			handler : 'stats',
			action : 'get-accessible-sites'
		});

		if (!sites.length) return;

		var div = templates.get('site_selector'),
			select = div.find('select');

		sites.sort(function (a, b) {
			return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
		});
		for (var i = 0, len = sites.length; i < len; i++) {
			var site = sites[i];
			select.append('<option value="' + site.id + '">' + site.name + '</option>');
		}

		select.val(config.id);

		select.on('change', function () {
			siteId = $j(this).val();
			loadMonthly();
			loadCurrentType();
		});

		container.append(div);
	}

	/**
	 * Figures out what type of item we're showing in the list and calls a reload on it
	 */
	function loadCurrentType() {
		var id = $j('#history_tabs .tab.selected').attr('id');
		if (id == 'tracks') {
			loadTracks();
		} else if (id == 'albums') {
			loadAlbums();
		} else if (id == 'catalogs') {
			loadCatalogs();
		} else {
			loadArtists();
		}
	}

	/**
	 * Loads the monthly data
	 */
	async function loadMonthly() {
		var cont = $j('.stats #images');
		cont.find('#loader_element').remove();
		showLoader(cont.find('.music_stats_graph'), 'Loading data');
		const response = await sa.api.request({
			handler : 'stats',
			action : 'get-monthly-stats',
			getData : {
				siteId : siteId
			}
		});

		var color = getCSSColor('waveform_dark_bar', true);
		// add # to color
		if (color.indexOf('#') !== 0) {
			color = '#' + color;
		}

		var options = {
			chart : {
				title: 'Tracks Played'
			},
			legend : {
				position : 'none'
			},
			series : [
				{
					color : color
				}
			],
			titleTextStyle : {
				color : '#52514d',
				fontName : 'Open Sans',
				fontSize : 14,
				bold : true
			},
			hAxis : {
				title : '',
				slantedText : true,
				minTextSpacing : 0
			},
			vAxis : {
				title : '',
				slantedText : true,
				minTextSpacing : 0
			},
			chartArea : {
				left : 0,
				bottom : 0,
				width: '100%',
				height : 180
			}
		};
		console.log(options);

		function drawCharts() {

			loadScript(ExtraScripts.charts, function() {

				google.charts.load('current', { packages : ['bar'] });
				google.charts.setOnLoadCallback(drawPlayed);
				google.charts.setOnLoadCallback(drawDownloaded);

				function drawPlayed() {
					var played = response.played;
					var rawData = [['Month', 'Plays']];
					for (var i = 0, len = played.length; i < len; i++) {
						rawData.push([played[i].month, played[i].stat]);
					}

					var chart = new google.charts.Bar(cont.find('#tracks_played_graph')[0]);
					options.chart.title = 'Tracks Played';
					chart.draw(google.visualization.arrayToDataTable(rawData), google.charts.Bar.convertOptions(options));
				}

				function drawDownloaded() {
					var downloaded = response.downloaded;
					var rawData = [['Month', 'Downloads']];
					for (var i = 0, len = downloaded.length; i < len; i++) {
						rawData.push([downloaded[i].month, downloaded[i].stat]);
					}

					var chart = new google.charts.Bar(cont.find('#tracks_downloaded_graph')[0]);
					options.chart.title = 'Tracks Downloaded';
					chart.draw(google.visualization.arrayToDataTable(rawData), google.charts.Bar.convertOptions(options));
				}

			});

		}

		drawCharts();

		$j(window).off('.admin-stats-music').on('resize.admin-stats-music', function() {
			drawCharts();
		});
	}

	/**
	 * Takes in a number and returns a string version of that number. If the number is below 1000, the number is returned unchanged.
	 * 	If it's above 1000, it is returned as num / 1000 + 'k' only a little prettier
	 * @param {int} num the number to format
	 * @return {string} formatted number
	 */
	function formatScale(num) {
		if (num > 10000) {
			return Math.floor(num / 1000) + 'k';
		} else if (num > 1000) {
			return (Math.floor(num / 100) / 10) + 'k';
		} else {
			return num;
		}
	}

	function getTimeParams() {
		var time = $j('#filters #time').val();
		if (time === '-1') {
			var fromDate = formatDate('Y-m-d', $j('#filters #stats_from_date').datepicker('getDate').getTime() / 1000);
			var toDate = formatDate('Y-m-d', $j('#filters #stats_to_date').datepicker('getDate').getTime() / 1000);
			return '&fromDate=' + fromDate + '&toDate=' + toDate;
		}
		return '&time=' + time;
	}

	/**
	 *
	 * @param {string} listClass the class of the list to show
	 */
	function showLoading(listClass) {
		topList = $j('#top_list');

		// if the list is already the right type, show the cover
		if (topList.hasClass(listClass)) {
			list.showCover();
		} else {
			topList.html('Loading...');
		}
	}

	/**
	 * Loads the top tracks for the site
	 * @param {string=} params and parameters to send in. Will override anything in the drop downs
	 */
	function loadTracks(params) {
		showLoading('tracks');

		const orderBy = $j('#filters #order').val();
		const request = 'p=track_info&' + (params ?? `o=${orderBy}` + getTimeParams()) + '&siteId=' + siteId;
		lastRequest = request;

		// make the request
		ajax(request, (response) => {
			// only update if this matches the most recent request
			if (request != lastRequest) return;

			setTracks(response);
		});

	}

	/**
	 * Populates the track list, creating it if it doesn't already exist
	 */
	function setTracks(newData) {
		var listConfig,
			topList = $j('#top_list');
		if (!topList.hasClass('tracks')) {
			topList.addClass('tracks').removeClass('catalogs').removeClass('albums').removeClass('artists').html('');
			// insert data
			listConfig = new TrackListConfig();
			listConfig.addColumnList([
				new ListColumn('play', ['play', 'download', 'email']),
				new ListColumn('title', ['title']),
				new ListColumn('catalog', ['avatar', 'catalog']),
				new ListColumn('album', ['album']),
				new ListColumn('length', ['length']),
				new ListColumn('plays', ['plays']),
				new ListColumn('downloads', ['downloads'])
			]);
			listConfig.allowBlock = false;
			listConfig.allowMiniBlock = false;
			listConfig.bankKey = 'top_list';
			listConfig.getDefaultView = function() { return ListViewType.List; };
			listConfig.sortable = false;
			listConfig.useCache = true;
			listConfig.useFilters = false;
			listConfig.headerBackground = false;
			listConfig.viewCookie = false;

			list = createTrackList(listConfig);
			list.generatePage(topList[0]);
			console.log("top list", topList[0])
		}
		list.setData(newData, function(params) { return '/admin?p=stats&tab=music'; }, function(params) { loadTracks(params); return false;});
	}

	/**
	 * Loads the top tracks for the site
	 * @param {string} params and parameters to send in. Will override anything in the drop downs
	 */
	function loadAlbums(params) {
		showLoading('albums');

		const orderBy = $j('#filters #order').val();
		const request = 'p=album_info&' + (params ?? `o=${orderBy}` + getTimeParams()) + '&siteId=' + siteId;
		lastRequest = request;

		// make the request
		ajax(request, (response) => {
			// only update if this matches the most recent request
			if (request != lastRequest) return;

			setAlbums(response);
		});
	}

	/**
	 * Populates the track list, creating it if it doesn't already exist
	 */
	function setAlbums(newData) {
		var listConfig,
			topList = $j('#top_list');
		if (!topList.hasClass('albums')) {
			topList.addClass('albums').removeClass('catalogs').removeClass('tracks').removeClass('artists').html('');
			// insert data
			listConfig = new ListConfig();
			listConfig.allowBlock = false;
			listConfig.allowMiniBlock = false;
			listConfig.bankKey = 'top_list';
			listConfig.getDefaultView = function() { return ListViewType.List; };
			listConfig.sortable = false;
			listConfig.headerBackground = false;
			listConfig.viewCookie = false;

			let columnList = getStandardAlbumColumnList();
			columnList.push(new ListColumn('plays', ['plays']));
			columnList.push(new ListColumn('downloads', ['downloads']));
			listConfig.addColumnList(columnList);

			list = createAlbumList(listConfig);
			list.generatePage(topList[0]);
		}
		list.setData(newData, function(params) { return '/admin?p=stats&tab=music'; }, function(params) { loadAlbums(params); return false;});
	}

	/**
	 * Loads the top artists for the site
	 * @param {string} params and parameters to send in. Will override anything in the drop downs
	 */
	function loadArtists(params) {
		showLoading('artists');

		const orderBy = $j('#filters #order').val();
		const request = 'p=artist_info&' + (params ?? `o=${orderBy}` + getTimeParams()) + '&siteId=' + siteId;
		lastRequest = request;

		// make the request
		ajax(request, (response) => {
			// only update if this matches the most recent request
			if (request != lastRequest) return;

			setArtists(response);
		});
	}

	/**
	 * Populates the artist list, creating it if it doesn't already exist
	 */
	function setArtists(newData) {
		var listConfig,
			topList = $j('#top_list');
		if (!topList.hasClass('artists')) {
			topList.addClass('artists').removeClass('catalogs').removeClass('albums').removeClass('tracks').html('');
			// insert data
			listConfig = new ListConfig();
			listConfig.allowBlock = false;
			listConfig.bankKey = 'top_list';
			listConfig.getDefaultView = function() { return ListViewType.List; };
			listConfig.sortable = false;
			listConfig.headerBackground = false;
			listConfig.viewCookie = false;

			let columnList = getStandardArtistColumnList();
			columnList.push(new ListColumn('plays', ['plays']));
			columnList.push(new ListColumn('downloads', ['downloads']));
			listConfig.addColumnList(columnList);

			list = createArtistList(listConfig);
			list.view = listConfig.defaultView = ListViewType.List;
			list.generatePage(topList[0]);
		}
		list.setData(newData, function(params) { return '/admin?p=stats&tab=music'; }, function(params) { loadArtists(params); return false;});
	}

	/**
	 * Loads the top catalogs for the site
	 * @param {string} params and parameters to send in. Will override anything in the drop downs
	 */
	function loadCatalogs(params) {
		showLoading('catalogs');

		const orderBy = $j('#filters #order').val();
		const request = 'p=catalog_info&' + (params ?? `o=${orderBy}` + getTimeParams()) + '&siteId=' + siteId;
		lastRequest = request;

		// make the request
		ajax(request, (response) => {
			// only update if this matches the most recent request
			if (request != lastRequest) return;

			setCatalogs(response)
		});
	}

	/**
	 * Populates the catalog list, creating it if it doesn't already exist
	 */
	function setCatalogs(newData) {
		var listConfig,
			topList = $j('#top_list');
		if (!topList.hasClass('catalogs')) {
			topList.addClass('catalogs').removeClass('artists').removeClass('albums').removeClass('tracks').html('');
			// insert data
			listConfig = new ListConfig();
			listConfig.allowBlock = false;
			listConfig.bankKey = 'top_list';
			listConfig.getDefaultView = function() { return ListViewType.List; };
			listConfig.sortable = false;
			listConfig.headerBackground = false;
			listConfig.viewCookie = false;

			let columnList = getStandardCatalogColumnList();
			columnList.push(new ListColumn('plays', ['plays']));
			columnList.push(new ListColumn('downloads', ['downloads']));
			listConfig.addColumnList(columnList);

			list = createCatalogList(listConfig);
			list.view = listConfig.defaultView = ListViewType.List;
			list.generatePage(topList[0]);
		}
		list.setData(newData, function(params) { return '/admin?p=stats&tab=music'; }, function(params) { loadCatalogs(params); return false;});
	}
}
/**
 * The page in the admin panel that lets you see what users have been search for
 */
function AdminStatsSearch() {

	var page = this;
	var siteId = config.id,
		templates = sa.templates.get('admin.stats.search');

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Statistics)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Statistics' + '" permission.</h3>');
		}

		container.empty().append(templates.get('page'));

		$j('.filters select').on('change', function() {
			$j('#trends_container').html('Loading...');
			loadTrends();
		});
		loadTrends();
	};

	function loadExternalSites(container) {
		ajax({ p : 'stats', action : 'list_sites' }, function(sites) {
			if (!sites.length) return;

			var div = templates.get('site_selector'),
				select = div.find('select');

			sites.sort(function(a, b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; });
			for (var i = 0, len = sites.length; i < len; i++) {
				var site = sites[i];
				select.append('<option value="' + site.id + '">' + site.name + '</option>');
			}

			select.val(config.id);

			select.on('change', function() {
				siteId = $j(this).val();
				loadTrends();
			});

			container.append(div);

		});
	}

	/**
	 * Loads the trends list
	 */
	async function loadTrends() {
		const response = await sa.api.request({
			handler : 'stats',
			action : 'get-trends',
			getData : {
				siteId : siteId,
				time : $j('.filters select').val()
			}
		});

		var cont = $j('#trends_container'),
			termStrings = ['', '', '', ''];
		if (!response.length) {
			cont.html('No one has searched for anything yet!');
			return;
		}
		
		let baseUrl = siteBaseUrl();
		
		for (var i = 0, len = response.length, perColumn = len / 4; i < len; i++) {
			var term = response[i];
			termStrings[Math.floor(i / perColumn)] += '<a class="term" href="'+ baseUrl  +'/tracks?s=' + encodeURIComponent(term) + '">' + (i + 1) + '. ' + term + '</a>';
		}
		cont.empty().append(templates.get('columns', { first : termStrings[0], second : termStrings[1], third : termStrings[2], fourth : termStrings[3] }));
	}

}
/**
 * The page in the admin panel that lets you see what users have been search for
 */
function AdminStatsSent() {
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Sharing)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Send and Embed Tracks &amp; Manage Comments' + '" permission.</h3>');
		}
		sa.pages.sent.show({
			type : sa.pages.sent.SentTypeAdmin,
			topMessage : 'See what playlists, albums, and tracks admins have sent.',
			emptyMessage : 'The selected admins have sent any playlists, albums, or tracks. You can send them using the "My Playlists" tool on the left'
		}, container);
	};
	
}
/**
 * The page in the admin panel that lets you see a stats for a particular user
 */
function AdminStatsUser() {
	
	let page = this;
	
	/**
	 * The id of the user this page is showing details for
	 */
	this.userId = 0;
	
	/**
	 * The play history list
	 */
	this.trackList = null;
	
	/**
	 * The downloads list
	 */
	this.downloadList = null;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!window.user.hasAdminPermission(AdminPermission.Statistics)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'View Statistics' + '" permission.</h3>');
		}
		var vars = sa.router.paramsToVars(params),
			user = vars.user;
		let baseUrl = siteBaseUrl();
		let adminUserSectionHtml = `
			<div class="admin_user section">
				<a href="${baseUrl}/admin?p=stats&tab=users" class="back">&laquo; View All Users</a>
				<div id="basic">
					Loading...
				</div>
				<div id="history_tabs"></div>
				<div id="history">Loading...</div>
		`;
		container.html(adminUserSectionHtml);
		this.userId = user;
		this.loadUser(user);
	};
	
	/**
	 * Loads info about a particular user
	 */
	this.loadUser = function(userId) {
		let cont = $j('.admin_user #basic');
		sa.api.request({
			handler : 'stats',
			action : 'get-user-stats',
			getData : {
				id : userId
			}
		}).then(function (statsUser) {
			let baseUrl = siteBaseUrl();
			let link = baseUrl + '/admin?p=users&tab=edit&user=' + statsUser.id;

			cont.html(
				'<table><tr><th></th>' + (statsUser.company ? '<th>' + statsUser.company.fieldName + '</th>' : '') + '<th>Plays</th><th>Playlists</th><th>Downloads</th><th>Last Logged In</th><th>Member Since</th></tr>'
				+ '<tr><td><span class="lr fake_row">' + sa.generateUserAvatarHtml(statsUser, link) + '</span>'
				+ '<a href="' + link + '" class="username">' + statsUser.username + '</a></td>'
				+ (statsUser.company ? '<td>' + statsUser.company.value + '</td>' : '')
				+ '<td>' + numberFormat(statsUser.plays) + '</td><td>' + numberFormat(statsUser.projects) + '</td><td>' + numberFormat(statsUser.downloads) + '</td>'
				+ '<td>' + statsUser.lastLoggedIn + '</td><td>' + statsUser.joinDate + '</td></tr><tr><td colspan="6"><sub><a href="' + link + '">(edit user)</a></sub></td></tr></table>'
				+ '<div class="stats_note">Stats up to date - these numbers include today\'s stats.</div>');
			page.loadPlayHistory();
			// set up the tabs
			$j('#history_tabs').html('<a class="faux_button selected tab" id="plays" href="' + getDefaultLink() + '">Play History</a>'
				+ '<a class="faux_button tab" id="downloads" href="' + getDefaultLink() + '">Download History</a><div class="clr"></div>')
				.find('.tab').on('click', function() {
				$j(this).parent().find('a').removeClass('selected').end().end().addClass('selected');
				if ($j(this).attr('id') == 'plays') {
					page.loadPlayHistory();
				} else {
					page.loadDownloadHistory();
				}
			});
		}).catch(function(e) {
			cont.html('<div class="error">' + htmlEncode(e.message) + '</div>');
		});
	};
	
	/**
	 * Loads the user list
	 * @param {string} params any additional parameters to send into the user list
	 */
	this.loadPlayHistory = function(params) {
		var page = this,
			userId = this.userId;
		ajax('p=track_info&' + (params ? params : 'u=' + userId + '&type=history'), function(response) { 
			page.setPlayHistory(response);
		});
	};
	
	/**
	 * Populates the play history, creating it if it doesn't already exist
	 */
	this.setPlayHistory = function(newData) {
		var page = this,
			trackList = this.trackList,
			trackListConfig,
			history = $j('#history');
		if (!history.hasClass('plays') || !trackList) {
			history.addClass('plays').removeClass('downloads').html('');
			// insert data
			trackListConfig = new TrackListConfig();
			trackListConfig.useStandardColumnList();
			trackListConfig.allowMiniBlock = true;
			trackListConfig.bankKey = 'users';
			trackListConfig.sortable = false;
			trackListConfig.useCache = true;
			trackListConfig.useFilters = false;
			trackListConfig.headerBackground = false;
			
			trackList = this.trackList = createTrackList(trackListConfig);
			trackList.generatePage(history[0]);
		}
		trackList.setData(newData, function(params) { return '/admin?p=stats&tab=users'; }, function(params) { 
			page.loadPlayHistory(params);
			return false;
		});
	};
	
	/**
	 * Loads the user list
	 * @param {string} params any additional parameters to send into the user list
	 */
	this.loadDownloadHistory = function(params) {
		var page = this,
			userId = this.userId;
		ajax('p=multiformat_info&' + (params ? params : 'u=' + userId + '&type=history&historyType=download'), function(response) { 
			page.setDownloadHistory(response);
		});
	};
	
	/**
	 * Populates the play history, creating it if it doesn't already exist
	 */
	this.setDownloadHistory = function(newData) {
		var page = this,
			downloadList = this.downloadList,
			downloadListConfig,
			history = $j('#history');
		if (!history.hasClass('downloads') || !downloadList) {
			history.addClass('downloads').removeClass('plays').html('');
			// insert data
			downloadListConfig = new ListConfig();
			downloadListConfig.addColumnList([
				new ListColumn('date', ['date']),
				new ListColumn('type', ['type', 'history_type']), 
				new ListColumn('name', ['multi_name', 'expand']),
				new ListColumn('format', ['format']),
				new ListColumn('tracks', ['track count'])
			]);
			downloadListConfig.bankKey = 'users';
			downloadListConfig.sortable = false;
			
			downloadList = this.downloadList = createMultiFormatList(downloadListConfig);
			downloadList.generatePage(history[0]);
		}
		downloadList.setData(newData, function(params) { return '/admin?p=stats&tab=users'; }, function(params) { 
			page.loadDownloadHistory(params);
			return false;
		});
	};
}
/**
 * The page in the admin panel that lets you see a list of all your users
 */
function AdminStatsUsers() {
	
	var page = this;
	var templates;
	
	var salespersonId = 0;
	
	this.userList = null;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		
		if (!templates) {
			templates = sa.templates.get('admin.stats.users');
		}
		
		if (!user.hasAdminPermission(AdminPermission.Statistics)) {
			return container.append(templates.get('permission_denied', { permission : user.getAdminPermissionDescription(AdminPermission.Statistics) }));
		}
		
		var vars = sa.router.paramsToVars(params);
		// if they've requested a user, 
		if (vars.user) {
			(new AdminStatsUser()).show(params, container);
			return;
		}
		if (vars.salespersonId) {
			salespersonId = vars.salespersonId;
		}
		// if we're already on this page, we don't want to reload everything
		if (!$j('#user_list_container').length) {
			container.empty().append(templates.get('page'));
			this.userList = null;
			this.loadOverview();
			this.loadUserList('');
			if (config.id == 691) { // westar
				showSalespersonFilter(container);
			}
		} else {
			this.loadUserList(params);
		}
	};
	
	function showSalespersonFilter(container) {
		container.prepend(templates.get('salesperson_filter'));
		sa.api.request({
			handler : 'user-management',
			action : 'getUser',
			getData : {
				user : user.userData.id,
				cacheBreak : (new Date().getTime())
			}
		}).then((response) => {
			var salesperson = container.find('select[name=salesperson]'),
				salesOptions = '';
			for (var i = 0, len = response['adminUsers'].length; i < len; i++) {
				var ad = response['adminUsers'][i];
				salesOptions += '<option value="' + ad.id + '"' + (ad.id == salespersonId ? ' selected="selected"' : '') + '>' + ad.username + '</option>';
			}
			salesperson.html('<option value="0">All</option>' + salesOptions);
		});
		
		container.find('select').on('change', function() {
			sa.router.routeTo('/admin?p=stats&tab=users&salespersonId=' + $j(this).val());
		});
	}
	
	/**
	 * Loads the overview information displayed on the right
	 */
	this.loadOverview = async function() {
		const data = await sa.api.request({
			handler : 'stats',
			action : 'get-user-overview',
			getData : {
				salespersonId : parseInt(salespersonId)
			}
		});

		let registered = data.registered;
		let active = data.active;
		let cont = $j('.admin_right .content');
		cont.html(templates.get('overview_section', { registered : numberFormat(registered), active : numberFormat(active) }).html());
		// chart.googleapis.com has been shut down. we need a replacement if we want to keep showing a graph
		//cont.find('#overview_graph').attr('src', 'https://chart.googleapis.com/chart?cht=p3&chs=230x100&chd=t:' + (registered - active) + ',' + active + '&chl=Inactive|Active');
		$j('.admin_right').after(templates.get('right_sections', {
			startDate : formatDate(config.dateFormatString, new Date().getTime() / 1000 - 86400 * 30),
			endDate : formatDate(config.dateFormatString),
			startDateTracks : formatDate(config.dateFormatString, new Date().getTime() / 1000 - 86400 * 30),
			endDateTracks : formatDate(config.dateFormatString)
		}));
		$j('.admin_right input[type=text]').datepicker({ dateFormat: config.datePickerDateFormatString });
		$j('#user_export .button').on('click', function() {
			window.location = 'export.php?type=user-stats&format=csv&startDate='
				+ encodeURIComponent($j('#user_export #start-date').val()) + '&endDate=' + encodeURIComponent($j('#user_export #end-date').val()) + (salespersonId ? '&salespersonId=' + salespersonId : '');
		});
		$j('#user_tracks_export .button').on('click', function() {
			let exportParameters = {
				type : 'user-tracks-stats',
				format : 'csv',
				startDate : $j('#user_tracks_export #start-date-t').val(),
				endDate : $j('#user_tracks_export #end-date-t').val(),
				includeDownloads : $j('#user_tracks_export input[name=includeDownloads]:checked').length,
				includePlays : $j('#user_tracks_export input[name=includePlays]:checked').length,
				fullTrackData : $j('#user_tracks_export input[name=fullTrackData]:checked').length
			};
			if (salespersonId) {
				exportParameters.salespersonId = salespersonId;
			}
			window.location = 'export.php?' + createVarStringFromObject(exportParameters);
		});
		$j('#user_full_export .button').on('click', function() {
			window.location = 'export.php?type=users';
		});
	};
	
	/**
	 * Loads the user list
	 * @param {string} params any additional parameters to send into the user list
	 */
	this.loadUserList = function(params) {
		var page = this;
		ajax('p=user_info&' + params + (salespersonId ? '&salespersonId=' + salespersonId : ''), function(response) { 
			page.setUserData(response); 
		});
	};
	
	/**
	 * Populates the user list, creating it if it doesn't already exist
	 */
	this.setUserData = function(newData) {
		var page = this,
			userList = this.userList,
			userListConfig;
		if (this.userList == null) {
			// insert data
			userListConfig = new ListConfig();
			userListConfig.addColumnList([
				new ListColumn('username', ['user avatar', 'username']),
				new ListColumn('plays', ['plays']),
				new ListColumn('downloads', ['downloads'])
			]);
			userListConfig.bankKey = 'users';
			
			userList = this.userList = createUserList(userListConfig);
			userList.generatePage($j('#list_users')[0]);
			
			// set up the filters
			var filters = $j('#filters'),
				order = newData[0].pageVars.match(/o=([a-z]+)/),
				time = newData[0].pageVars.match(/time=([0-9]+)/),
				search = newData[0].pageVars.match(/search=([^&]+)/),
				searchTimer = null;
			order = order ? order[1] : 'username';
			time = time ? time[1] : '0';
			search = search ? search[1] : '';
			filters.html(templates.get('filters').html());
			filters.find('#order').val(order);
			filters.find('#time').val(time);
			filters.find('#usearch').val(search);
			filters.find('select').on('change', function() {
				var order = $j('#filters #order').val(),
					time = $j('#filters #time').val(),
					search = $j('#filters #usearch').val(),
					rpp = $j('#user_list_container #result_count_selection').val();
				page.loadUserList('show=' + rpp + '&o=' + order + '&time=' + time + '&search=' + search);
			});
			filters.find('input').on('keyup', function() {
				// we don't want to ajax on every keypress in case the user is typing quickly. Only ajax if 500ms passes between presses
				if (searchTimer) {
					clearTimeout(searchTimer);
				}
				searchTimer = setTimeout(function() {
					var order = $j('#filters #order').val(),
						time = $j('#filters #time').val(),
						search = $j('#filters #usearch').val(),
						rpp = $j('#user_list_container #result_count_selection').val();
					ajax('p=user_info&show=' + rpp + '&o=' + order + '&time=' + time + '&search=' + search, function(response) {
						userList.setData(response, function(params) { return '/admin?p=stats&tab=users'; }, function(params) { 
							page.loadUserList(params); 
							return false;
						});
					});
				}, 500);
			});
		}
		userList.setData(newData, function(params) { return '/admin?p=stats&tab=users'; }, function(params) { 
			page.loadUserList(params); 
			return false;
		});
	};
}
/**
 * The page in the admin panel that lets you manipulate your site's syndication stuff
 */
function AdminSyndication() {
	let page = this;
	let currentTab = '';
	let currentPage;
	
	var currentParams;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Licensees)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "Manage Music Suppliers &amp; Briefs" permission.</h3>');
		}
		if (!$j('.right_body .metadata').length) {
			let hrefBase = siteBaseUrl();
			var callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [
			        new RightTab('licensees', hrefBase + '/admin?p=syndication&tab=licensees', 'Licensees', callback, config.grayLabel),
			        new RightTab('syndication', hrefBase + '/admin?p=syndication&tab=syndication', 'Settings', callback, config.grayLabel),
					new RightTab('syncing', hrefBase + '/admin?p=syndication&tab=syncing', 'Connections', callback)
				];
			RightTabbedPage.prototype.show.call(this, 'syndication', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		currentParams = params;
		var vars = sa.router.paramsToVars(params);
		
		// Redirect from old requests tab to new inbox
		if (vars.tab === 'requests') {
			sa.router.routeTo('/admin?p=inbox');
			return;
		}
		
		if (!vars.tab) vars.tab = 'licensees';
		this.setTab(vars.tab);
	};
	
	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			if (pageId == 'licensees') {
				currentPage = new AdminSyndicationLicensees();
			} else if (pageId == 'syndication') {
				currentPage = new AdminSyndicationSyndication();
			} else if (pageId == 'syncing') {
				currentPage = new AdminSyndicationSyncing();
			} else {
				currentPage = new AdminSyndicationLicensees();
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminSyndication.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you select to whom you're connected
 */
function AdminSyndicationLicensees() {

	var page = this;
	var container;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} cont
	 */
	this.show = function(params, cont) {
		if (config.grayLabel) {
			return cont.html('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		if (!templates) {
			templates = sa.templates.get('admin.syndication.licensees');
		}
		container = cont;
		container.empty().append(templates.get('page'));
		loadLicensees();
	};

	/**
	 * Loads a featured list from the server
	 */
	function loadLicensees() {
		sa.api.request({
			handler : 'musicSupplierSyndication',
			action : 'listLicensees'
		}).then(response => {
			setLicensees(response);
		});
	}

	/**
	 * Displays a list of all the licensee
	 * @param {Object} response the server's list of licensee
	 * 	@property {Array} licensees
	 * 	@property {boolean} visible
	 */
	function setLicensees(response) {
		var list = container.find('.buyer_list').empty();
		var types = [];
		var visibleCheck = container.find('#visibility');
		var licensees = response.licensees;

		// set up default visibility check box
		if (response.visible) {
			visibleCheck.prop('checked', true);
		} else {
			visibleCheck.prop('checked', false);
		}
		visibleCheck.on('click', function() {
			var visible = visibleCheck.filter(':checked').length ? 1 : 0;
			sa.api.request({
				handler : 'musicSupplierSyndication',
				action : 'setVisibility',
				postData : {
					visible : visible
				}
			});
			sa.notify({ text : 'Your workspace is now ' + (visible ? 'visible' : 'invisible') + ' to licensees', type : sa.notify.notificationTypes.success });
		});

		// show a warning if you haven't syndicated anything
		sa.api.request({
			handler : 'musicSupplierSyndication',
			action : 'loadSyndication',
		}).then(syndicationResponse => {
			// do they have anything syndicated? if they do, skip out of here
			for (var c = 0, cLen = syndicationResponse.length; c < cLen; c++) {
				for (var l = 0, lLen = syndicationResponse[c].labels.length; l < lLen; l++) {
					if (syndicationResponse[c].labels[l].syndicated) return;
				}
			}
			// guess not. show a warning
			$j('.syndication_visibility .warning').removeClass('hidden');
		});
		// add licensees
		for (var i = 0, len = licensees.length; i < len; i++) {
			var site = licensees[i],
				cont = $j(
					'<div class="buyer buyer_seller">'
						+ (site.companyLogo ?
							'<div class="left">'
								+ '<img src="' + site.companyLogo + '" alt="company logo"/>'
							+ '</div>' : '')
						+ '<div class="right' + (site.companyLogo ? '' : ' no-logo') + '">'
							+ '<h2>' + htmlEncode(site.name) + '</h2>'
							+ '<div class="join_date">Joined ' + formatDate('F d, Y', site.date) + '</div>'
							+ (site.contactName || site.contactEmail || site.contactName ? '<div class="company_type"><b>Company Type:</b> ' + htmlEncode(site.companyType) + '<span class="dot_span">&#8226;</span><b>Main Contact:</b> '
								+ htmlEncode(site.contactName) + ' - <a href="mailto:' + htmlEncode(site.contactEmail) + '">' + htmlEncode(site.contactEmail) + '</div>' : '')
							+ '<p class="description">' + htmlEncode(site.companyDescription) + '</p>'
						+ '</div>'
						+ '<div class="clr"></div>'
						+ '<div class="status"></div>'
						+ '<div class="clr"></div>'
					+ '</div>'
				).data('licensee', site);
			if (site.companyType && types.indexOf(site.companyType) == -1) {
				types.push(site.companyType);
			}
			// status button
			addSyndicationButton(site.id, site.syndication, cont);
			list.append(cont);
		}
		// make the filters work
		types.sort();
		$j('.filter#type select').empty().html('<option>All</option><option>' + types.join('</option><option>') + '</option>');
		$j('.filter select, .filter input').on('change', function() { filterLicensees(); }).on('keyup', function() { filterLicensees(); });
	}

	function addSyndicationButton(siteId, syndication, cont) {
		var status = cont.find('.status').empty(),
			action = '',
			clickMessage = '',
			clickFunc = function(action, clickMessage) {
				status.html(clickMessage);

				sa.api.request({
					handler : 'musicSupplierSyndication',
					action : action,
					postData : {
						siteId : siteId
					}
				}).then(response => {
					addSyndicationButton(siteId, response.syndication, cont);
				}).catch(err => {
					sa.notify({ text : err.message });
				});
			};
		if (syndication.status == 'n' || syndication.status == 'v') { // we get 'v' if we're visible and you reject someone's invite
			status.append('<a class="button">+ Connect</a>');
			action = 'inviteLicensee';
			clickMessage = 'Inviting...';
		} else if (syndication.status == 'i') {
			status.append('<span class="description"><span class="icon fa fa-clock-o"></span>'
				+ 'Invitation sent on ' + formatDate('F d, Y', syndication.date) + '</span><a class="faux_button"><span class="icon fa fa-times"></span>Cancel</a>');
			action = 'cancelLicenseeInvitation';
			clickMessage = 'Cancelling invite...';
		} else if (syndication.status == 'r') {
			status.append('<a class="button">+ Grant Access</a><span class="description request">Licensee has requested access</span><a class="faux_button"><span class="icon fa fa-times"></span>Cancel</a>');
			action = 'cancelLicenseeRequest';
			clickMessage = 'Cancelling request...';
			status.find('a:first').on('click', function(action, clickMessage) { return function() { clickFunc(action, clickMessage); return false; }; }('acceptLicenseeRequest', 'Accepting request...'));
		} else if (syndication.status == 's') {
			status.append('<span class="description"><span class="icon fa fa-ok-sign"></span>'
				+ 'Connected on ' + formatDate('F d, Y', syndication.date) + '</span><a class="faux_button"><span class="icon fa fa-times"></span>Cancel</a>');
			action = 'cancelLicenseeSubscription';
			clickMessage = 'Cancelling connection...';
		}
		status.find('a:last').on('click', function() { clickFunc(action, clickMessage); return false; });
	}

	function filterLicensees() {
		var type = $j('.filter#type select').val(),
			status = $j('.filter#status select').val(),
			search = $j('.filter#search input').val().toLowerCase(),
			sort = $j('.filter#sort select').val() == 'Date Joined' ? 'launchDate' : 'name',
			order = sort == 'name' ? -1 : 1,
			licensees = $j('.buyer').show(),
			licenseesList = $j('.buyer_list');
		// add back all the licensees
		licensees.show();
		licenseesList.find('.empty').remove();
		// now hide stuff
		for (let i = 0, len = licensees.length; i < len; i++) {
			var licensee = $j(licensees[i]),
				licenseeData = licensee.data('licensee');
			if (type != 'All' && type != licenseeData.companyType) {
				licensee.hide();
			} else if (search && licenseeData.name.toLowerCase().indexOf(search) == -1) {
				licensee.hide();
			} else if ((status == 'Unconnected' && licenseeData.syndication.status != 'n') || (status == 'Invited' && licenseeData.syndication.status != 'i') || (status == 'Connected' && licenseeData.syndication.status != 's')) {
				licensee.hide();
			}
		}
		// sorting!
		licensees.sort(function(licensee1, licensee2) {
			licensee1 = $j(licensee1).data('licensee');
			licensee2 = $j(licensee2).data('licensee');
			return licensee1[sort] < licensee2[sort] ? order : (licensee1[sort] == licensee2[sort] ? 0 : order * -1);
		});
		for (let i = 0, len = licensees.length; i < len; i++) {
			licenseesList.append(licensees[i]);
		}
		// did we hide everything?
		if (!$j('.buyer:visible').length) {
			licenseesList.append('<div class="empty">No licensees match your filters.</div>');
		}
	}

}
AdminSyndicationLicensees.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you manage requests
 */
function AdminSyndicationRequests() {
	
	var page = this,
		container,
		requestList,
		requestDetails;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} cont
	 */
	this.show = function(params, cont) {
		cont.addClass('request_container');
		
		console.log('request params', params);
		var vars = sa.router.paramsToVars(params);
		if (vars.subtab == 'details') {
			if (!requestDetails) {
				requestDetails = new RequestsDetails();
			}
			requestDetails.show(params, cont, true);
		} else {
			if (!requestList) {
				requestList = new RequestsList();
			}
			requestList.show(params, cont, '/admin?p=syndication&tab=requests&subtab=details&requestId=', true);
		}
	};
}

AdminSyndicationRequests.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you select what catalogs you're syndicating
 */
function AdminSyndicationSyncing() {

	var page = this;
	var container;

	var unsyncs = {};

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} cont
	 */
	this.show = function(params, cont) {
		container = cont;
		container.html(
			'<div class="section loader_positioner">'
				+ '<h2>Connections</h2>'
				+ '<div class="information high_information">Select the ' + config.getDictionaryEntry('catalog', true) + ' and '
					+ config.getDictionaryEntry('label', true) + ' you want to manage.<br/><br/>'
					+ 'To add, edit, or delete them go to '
					+ '<a href="'+siteBaseUrl()+'/admin?p=metadata&tab=catalogs">Manage Metadata <span class="fa fa-arrow-right"></span> Catalogs</a></div>'
				+ '<div class="section">'
					+ '<div class="column_editor"></div>'
				+ '</div>'
			+ '</div>'
			+ '<div class="clr"></div>');
		loadCatalogs();
	};

	/**
	 * Loads stuff from the server
	 */
	function loadCatalogs() {
		unsyncs = {};
		ajax('p=list&type=catalog&ids=1&excludeSyncs=1', function(response) {
			var catalogs = response[0].items;
			var selectorContainer = container.find('.column_editor');
			if (!catalogs.length) {
				selectorContainer.html('You don\'t have any ' + config.getDictionaryEntry('catalog', true, true) + ' on your workspace '
					+ 'whose syncing you can manage.<br/><br/>'
					+ 'You can create some using the <a href="'+siteBaseUrl()+'/admin?p=metadata&tab=catalogs">' + config.getDictionaryEntry('catalog') + ' Manager</a>');
				return;
			}
			selectorContainer.html(
				'<div class="selector">'
					+ '<h3>' + config.getDictionaryEntry('catalog', true) + '</h3>'
					+ '<ul id="catalog_list"></ul>'
				+ '</div>'
				+ '<div class="selector">'
					+ '<h3>' + config.getDictionaryEntry('label', true) + '</h3>'
					+ '<ul id="label_list"></ul>'
				+ '</div>'
				+ '<div class="selector">'
					+ '<h3>Connections</h3>'
					+ '<ul id="sync_list"></ul>'
				+ '</div>');
			var catalogList = selectorContainer.find('#catalog_list').empty();
			catalogs.each(function(i, catalogData) {
				var catalogItem = $j(
					'<li class="item short" id="catalog_' + catalogData.id + '">'
						+ '<h4>' + catalogData.value + '</h4>'
						+ '<span class="fa fa-chevron-right expander"></span>'
					+ '</li>'
				);

				catalogItem.find('.expander').on('click', function() {
					showLabels(selectorContainer, catalogData);
					catalogList.find('.selected').removeClass('selected');
					catalogItem.addClass('selected');
				});

				catalogList.append(catalogItem);
			});
			// save button
			container.find('.changes_button').remove();
			selectorContainer.after('<a class="button changes_button faux_button">Save Changes</a><div class="clr"></div>');
			container.find('.button').on('click', function() {
				var progressKey = user.userData.id + '-' + config.id + '-' + new Date().getTime() + '-' + Math.random();
				var loader = showLoader(container.find('.loader_positioner'), 'Processing changes...');
				var interval;
				ajax({ unsyncs : unsyncs }, function(response) {
					loader.remove();
					clearInterval(interval);
					if (response.error) {
						sa.notify({ text : response.error });
					} else {
						sa.notify({ text : 'Saved!', type : sa.notify.notificationTypes.success });
						loadCatalogs();
					}
				}, 'POST', 'p=syncing&action=save&progressKey=' + progressKey);
				interval = setInterval(function() {
					/** @var {{ labelsProcessed : int, labelsTotal : int, whitesProcessed : int, whitesTotal : int }} response */
					ajax('p=syncing&action=progress&progressKey=' + progressKey, function(response) {
						loader.find('.message').html('Processed ' + response.labelsProcessed + '/' + response.labelsTotal
							+ ' labels on ' + response.whitesProcessed + '/' + response.whitesTotal + ' workspaces');
					});
				}, 1000);
			});
		});
	}

	function showLabels(selectorContainer, catalogData) {
		ajax('p=list&type=label&ids=1&catalogId=' + catalogData.id + '&excludeSyncs=1', function(response) {
			var labels = response[0].items;
			var labelList = selectorContainer.find('#label_list').empty();
			labels.each(function(i, labelData) {
				var labelItem = $j(
					'<li class="item short" id="label_' + labelData.id + '">'
						+ '<h4>' + labelData.value + '</h4>'
						+ '<span class="fa fa-chevron-right expander"></span>'
					+ '</li>'
				);

				labelItem.find('.expander').on('click', function() {
					showSyncs(selectorContainer, labelData);
					labelList.find('.selected').removeClass('selected');
					labelItem.addClass('selected');
				});

				labelList.append(labelItem);
			});
		});
	}

	function showSyncs(selectorContainer, labelData) {
		ajax('p=list&type=sync&ids=1&labelId=' + labelData.id + '&masters=1', function(response) {
			var syncs = response[0].items;
			var syncList = selectorContainer.find('#sync_list').empty();
			var addedSyncs = 0;
			syncs.each(function(i, syncData) {
				if (syncData.id == config.id || syncData.id == 0) return;
				addedSyncs++;
				var syncItem = $j(
					'<li class="item" id="sync_' + syncData.id + '">'
						+ '<h4>' + syncData.value + '</h4>'
						+ '<label title="Uncheck to remove the connection for this workspace">'
							+ '<input type="checkbox" name="sync" checked="checked"/>'
							+ 'Connected'
						+ '</label>'
					+ '</li>'
				);

				if (unsyncs[labelData.id] && unsyncs[labelData.id][syncData.id]) {
					syncItem.find('input').prop('checked', false);
				}

				syncItem.find('input').on('click', function() {
					if (this.checked) {
						delete unsyncs[labelData.id][syncData.id];
					} else {
						if (!unsyncs[labelData.id]) {
							unsyncs[labelData.id] = {};
						}
						unsyncs[labelData.id][syncData.id] = syncData.id;
					}
				});

				syncList.append(syncItem);
			});
			if (!addedSyncs) {
				syncList.append('<li class="item">Not connected anywhere</li>');
			}
		});
	}
}

AdminSyndicationSyncing.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you select what catalogs you're syndicating
 */
function AdminSyndicationSyndication() {

	var page = this,
		container;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} cont
	 */
	this.show = function(params, cont) {
		if (config.grayLabel) {
			return cont.html('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
		}
		container = cont;
		container.html(`
			<div class="loader_positioner">
				<div class="section">
					<h2>Settings</h2>
					<div class="section_explanation">Select the ${config.getDictionaryEntry('catalog', true)} and ${config.getDictionaryEntry('label', true)} you want available to licensees.</div>
					<div class="section" style="margin-top: -15px">
						<div class="column_editor"></div>
						<div class="clr"></div>
					</div>
				</div>
				<div class="section">
					<h2>Pitch Request Contact</h2>
					<div class="section_explanation">Briefs are sent to your licensing contact, entered in the License Options section of the <a class="emphasized" href="/admin?p=settings">Workspace Settings</a> page.</div>
				</div>
			</div>
			<div class="clr"></div>
		`);
		loadCatalogs();
	};

	/**
	 * Loads stuff from the server
	 */
	function loadCatalogs() {
		sa.api.request({
			handler : 'musicSupplierSyndication',
			action : 'loadSyndication'
		}).then(response => {
			setSyndication(response);
		});
	}

	/**
	 * Displays a list of all your catalogs
	 * @param {array} response the server's list of catalogs
	 */
	function setSyndication(response) {
		var selectorContainer = container.find('.column_editor'),
			updateChecks = function() {
				// if all labels are checked, check the catalog
				for (var i = 0, len = response.length; i < len; i++) {
					var catalog = response[i],
						checkedLabels = 0,
						catalogLabel = $j('#catalog_' + catalog.id + ' > label');
					for (var j = 0, jLen = catalog.labels.length; j < jLen; j++) {
						var lab = catalog.labels[j],
							syndicated = lab.syndicated,
							labelCheck = $j('#label_' + lab.id + ' input');
						if (syndicated) {
							checkedLabels++;
							labelCheck.prop('checked', true);
						} else {
							labelCheck.prop('checked', false);
						}
					}
					if (checkedLabels) {
						catalogLabel.find('input').prop('checked', true);
					} else {
						catalogLabel.find('input').prop('checked', false);
					}
					catalogLabel.find('.totals').html('(' + checkedLabels + '/' + jLen + ')');
				}
			};
		if (!response.length) {
			selectorContainer.html(`Your current workspace does't have any ${config.getDictionaryEntry('catalog', true, true)} or you don't have the rights to share any of the ones you do have.<br/><br/>
				You can create some using the <a href="${siteBaseUrl()}/admin?p=metadata&tab=catalogs">${config.getDictionaryEntry('catalog')} Manager</a>`);
			return;
		}
		selectorContainer.html(`
			<div class="selector">
				<h3 class="title">${config.getDictionaryEntry('catalog', true)}</h3>
				<ul></ul>
			</div>
			<div class="selector">
				<h3 class="title">${config.getDictionaryEntry('label', true)}</h3>
				<ul></ul>
			</div>
		`);
		var catalogList = selectorContainer.find('ul:first');
		for (var i = 0, len = response.length; i < len; i++) {
			var catalogData = response[i],
				catalog = $j(`
					<li class="item" id="catalog_${catalogData.id}">
						<h4>${catalogData.name}</h4>
						<label title="Should this ${config.getDictionaryEntry('catalog', false, true)} be available?">
							<input type="checkbox" name="syndicate"/> Make available <span class="totals"></span>
						</label>
						<span class="fa fa-chevron-right expander"></span>
					</li>
				`);
			catalog.find('input').on('click', function(catalogData) { return function() {
				for (var i = 0, len = catalogData.labels.length; i < len; i++) {
					catalogData.labels[i].syndicated = this.checked;
				}
				updateChecks();
			}; }(catalogData));
			catalog.find('.expander').on('click', function(catalogData, catalog) { return function() {
				var labelList = selectorContainer.find('ul:last').empty();
				for (var i = 0, len = catalogData.labels.length; i < len; i++) {
					var labelData = catalogData.labels[i],
						lab = $j(`
							<li class="item" id=label_${labelData.id}">
								<h4>${labelData.name}</h4>
								<label title="Should this ${config.getDictionaryEntry('label', false, true)} be available?">
									<input type="checkbox" name="syndicate"${(labelData.syndicated ? ' checked="checked"' : '')}/> Make available
								</label>
							</li>
						`);
					lab.find('input').on('click', function(labelData) { return function() {
						labelData.syndicated = this.checked;
						updateChecks();
					}; }(labelData));
					labelList.append(lab);
				}
				catalog.siblings('.expanded').removeClass('expanded');
				catalog.addClass('expanded');
			}; }(catalogData, catalog));
			catalogList.append(catalog);
		}
		updateChecks();
		// save button
		container.find('.loader_positioner').append('<a class="button changes_button faux_button">Save Changes</a><div class="clr"></div>');
		container.find('.button').on('click', function() {
			var selectedLabels = [];
			for (var i = 0, len = response.length; i < len; i++) {
				var catalog = response[i];
				for (var j = 0, jLen = catalog.labels.length; j < jLen; j++) {
					var lab = catalog.labels[j];
					if (lab.syndicated) {
						selectedLabels.push(lab.id);
					}
				}
			}
			var loader = showLoader(container.find('.loader_positioner'), 'Saving Changes...');

			sa.api.request({
				handler : 'musicSupplierSyndication',
				action : 'saveSyndication',
				postData : {
					labelIds : selectedLabels
				}
			}).then(response => {
				sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
			}).finally(() => {
				loader.remove();
			});
		});
	}
}

AdminSyndicationSyndication.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you add new tracks
 */
function AdminUpload() {
	let page = this;
	let currentTab = '';
	let currentPage;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Metadata)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Edit Metadata and Add and Delete Tracks' + '" permission.</h3>');
		}
		if (!$j('.right_body .metadata').length) {
			var callback = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [
					new RightTab('upload', '/admin?p=upload&tab=upload', 'Upload Files', callback),
					new RightTab('metadata', '/admin?p=upload&tab=metadata', 'Publish to Workspace', callback),
					new RightTab('status', '/admin?p=upload&tab=status', 'Publishing Status', callback),
					new RightTab('copy', '/admin?p=upload&tab=copy', 'Agent Music Delivery', callback),
					new RightTab('transcode', '/admin?p=upload&tab=transcode', 'Transcoding', callback)
				];
			RightTabbedPage.prototype.show.call(this, 'upload', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'upload';
		this.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			if (pageId == 'upload') {
				currentPage = new AdminUploadUpload();
			} else if (pageId == 'copy') {
				currentPage = new AdminUploadCopy();
			} else if (pageId == 'metadata') {
				currentPage = new AdminUploadMetadata();
			} else if (pageId == 'transcode') {
				currentPage = new AdminUploadTranscoding();
			} else {
				currentPage = new AdminUploadStatus();
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminUpload.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you receive copies from other sites
 */
function AdminUploadCopy() {

	var page = this,
		templateSet = sa.templates.get('admin.upload.copy'),
		status = 'n';
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		
		createBaseContainer(container);
		
		listIncomingCopies(container);
	};
	
	function createBaseContainer(container) {
		container.empty().append(templateSet.get('page').addClass('file_delivery_copy tab_file_delivery'));
	}

	
	//////////////////////////////////////////
	// Incoming Copies List Functions
	//////////////////////////////////////////
	
	function listIncomingCopies(baseContainer) {
		var container = baseContainer.find('#incoming_copies');
		ajax({ p : 'copy', action : 'list_incoming_copies', status : status }, function(copies) {
			let template;
			if (!copies.length) {
				template = templateSet.get('no_copies');
				template.find('.status').html(status == 'n' ? 'new' : 'imported');
				container.empty().append(template);
			} else {
				template = templateSet.get('select_copy');
				
				// add the copies
				var baseItem = template.find('.copy');
				for (var i = 0, len = copies.length; i < len; i++) {
					var item = baseItem.clone(),
						copy = copies[i];
					item.find('input').val(copy.id);
					item.find('.name').html(copy.name).attr('title', copy.name);
					item.find('.albums').html(copy.albumCount);
					item.find('.message div').html(copy.message).attr('title', copy.message);
					item.find('.date').html(formatDate(config.dateFormatString, copy.date));
					item.on('mouseup', function() {
						$j(this).find('input').prop('checked', true);
						selectCopy();
					});
					baseItem.before(item);
				}
				baseItem.remove();
				
				// called when the user clicks a copy. sets the selected state for the copies and shows the album tool
				function selectCopy() {
					setTimeout(function() {
						$j('.copy').removeClass('selected');
						var selectedInput = $j('.copy input:checked');
						selectedInput.parents('.copy').addClass('selected');
						showAlbumSelector(baseContainer, selectedInput.val());
						container.find('.mark_done_container').show();
					}, 10); // give the input box time to actually select
				}
				
				// mark done button
				template.find('.mark_done').on('click', function() {
					markDone(baseContainer, $j('.copy input:checked').val());
				});
				
				template.find('.mark_done_container').hide();
				
				container.empty().append(template);
			}
			
			// status switcher
			template.find('select[name=status]').val(status).on('change', function() {
				var newStatus = $j(this).val();
				if (status != newStatus) {
					status = newStatus;
					listIncomingCopies(baseContainer);
					showAlbumSelector(baseContainer, 0);
				}
			});
		});
	}
	
	function markDone(baseContainer, copyId) {
		ajax({ p : 'copy', action : 'mark_done', copyId : copyId }, function(response) {
			sa.notify({ text : 'Removed the copy from your incoming list.' });
			showAlbumSelector(baseContainer, 0);
			listIncomingCopies(baseContainer);
		});
	}
	
	
	//////////////////////////////////////////
	// Album Selection Functions
	//////////////////////////////////////////
	
	function showAlbumSelector(baseContainer, copyId) {
		var container = baseContainer.find('#select_albums');
		
		if (!copyId) {
			hideImport(baseContainer);
			return container.html('');
		}
		
		var template = templateSet.get('album_selector');
		template.find('.list').attr('id', 'list_copy_albums_' + copyId);
		container.empty().append(template);
		
		var selectedAlbums = [],
			allAlbumIds;
		function updateSelectedAlbums(albums) {
			selectedAlbums = albums;
			template.find('.selected_count').html(albums.length);
			if (selectedAlbums.length) {
				showImport(baseContainer, copyId, selectedAlbums);
			} else {
				hideImport(baseContainer);
			}
		}

		// show the album list
		var albumListConfig = new ListConfig({
			allowBlock : false,
			allowEditing : false,
			allowMiniBlock : false,
			bankKey : 'copy_albums_' + copyId,
			callback : function(response) { albumListCallback(response); },
			callbackActual : function(response) { albumListCallback(response); },
			disableLinks : true,
			extraLoadVars : 'copyId=' + copyId,
			resultCountChanging : false,
			resultsPerPageCookie : false,
			selectable : true,
			selectorConfig : {
				change : function(selected) {
					updateSelectedAlbums(selected.albums);
				},
				dragging : false,
				key : 'copy_' + copyId,
				selectAlbums : true,
				selectProjectItems : false,
				selectTracks : false,
				buttonSection : ''
			},
			sortable : false,
			topBar : false,
			useFilters : false,
			viewCookie : false
		});
		let columnList = getStandardAlbumColumnList();
		columnList[0] = new ListColumn(columnList[0].name, [ 'name', 'expand-album' ], columnList[0].sortable);
		albumListConfig.addColumnList(columnList);
		albumListConfig.getDefaultView = function() { return ListViewType.List; };
		function albumListCallback(response) {
			albumList.setData(response, function() { return '#0'; }, function(newPage) {
				albumList.loadPage('copyId=' + copyId + '&pg=' + newPage);
				return false;
			});
		}
		
		var albumList = createAlbumList(albumListConfig);
		albumList.generatePage(container.find('.list'));
		albumList.loadPage('copyId=' + copyId);
		
		// make the buttons work
		template.find('.select_all').on('click', function() {
			if (allAlbumIds) {
				sa.components.selector.setSelected({tracks: [], albums: allAlbumIds});
			} else {
				ajax({ p : 'album_info', copyId : copyId, onlyIds : 1 }, function(response) {
					allAlbumIds = response;
					sa.components.selector.setSelected({tracks: [], albums: allAlbumIds});
				});
			}
		});
		template.find('.select_none').on('click', function() {
			sa.components.selector.setSelected({ tracks : [], albums : [] });
		});
	}
	
	/////////////////////////
	// Import Functions
	/////////////////////////
	

	function showImport(baseContainer, copyId, selectedAlbums) {
		var container = baseContainer.find('#import_selected').empty(),
			template = templateSet.get('import');
		
		template.find('.completed').hide();
		
		template.find('input[name=email]').val(user.userData.email);
		
		template.find('.import_selected').on('click', function() {
			//var loader = showLoader(baseContainer, 'Copying your albums...');
			ajax({
					copyId : copyId,
					albums : selectedAlbums,
					email : container.find('input[name=email]').val(),
					'private' : container.find('input[name=private]:checked').length
				}, function(response) {
					
					//loader.remove();
					
					if (response[0].error) {
						return sa.notify({ text : response[0].message });
					}
					
					template.find('.completed').show();
					template.find('.incomplete').hide();
					template.find('.mark_done').on('click', function() {
						markDone(baseContainer, copyId);
					});
					
				}, 'POST', {
					p : 'copy',
					action : 'import'
				});
		});
		
		container.append(template);
	}
	
	function hideImport(baseContainer) {
		baseContainer.find('#import_selected').empty();
	}
	
}
/**
 * The page in the admin panel that lets you manage edit metadata on new uploaded tracks before taking them live
 */
function AdminUploadMetadata() {
	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {

		(new PublishComponent()).show(container);
	}
}
/**
 * The page in the admin panel that lets you check what's happening with your uploads
 */
function AdminUploadStatus() {
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var page = this;
		container.html(
			'<div class="section">'
				+ '<h2>Transcode Job Status</h2>'
				+ '<div id="transcode_status" class="section">Loading...</div>'
				+ '<h2>Upload Status</h2>'
				+ '<div class="information status_information">See what\'s happening with tracks you\'ve published or copied this month.</div>'
				+ '<div class="section" id="statuses">'
				+ '</div>'
				+ '<div class="clr"></div>'
			+ '</div>');
		page.loadStatus();
	};
	
	/**
	 * Loads and displays the status of the current imports
	 */
	this.loadStatus = function() {
		var page = this,
			statuses = $j('#statuses'),
			progressWidth = 0; // the width of a progress bar. cache this so we only have to check it once
		var statusesReturned = 0;
		var unfinished = false;
		function reloadStatus() {
			statusesReturned++;
			if (statusesReturned == 2) {
				setTimeout(function() { page.loadStatus(); }, unfinished ? 5000 : 20000);
			}
		}
		ajax('p=import_tracks&action=status&cacheBreak=' + new Date().getTime(), function(response) {
			if (!$j('#statuses').length) return;
			statuses.empty();
			// for every status, we add a row
			for (var i = 0, len = response.length; i < len; i++) {
				var job = response[i],
					status = $j(
						'<div class="status">'
							+ '<h3>' + (job.type == 'copy' ? 'Copy' : 'Upload') + ' initiated ' + formatDate(config.dateTimeFormatString, job.date) + ' by ' + job.notification + '</h3>'
							+ '<div class="progress"><div class="error"></div><div class="done"></div><div class="importing"></div><div class="processing"></div><div class="queued"></div>'
								+ '<div class="progress_status"></div></div>'
							+ '<div class="progress_text"></div>'
						+ '</div>'
					),
					texts = [],
					progressDone = 0, // the number of tracks in this job that have been finished (successfully or not)
					progressUnfinished = 0; // the number that haven't finished
				statuses.append(status);
				// cache the width of a bar so we don't have to figure it out repeatedly
				if (!progressWidth) {
					progressWidth = status.find('.progress').width();
				}
				// for each status in the job, we're going to set a bar with an appropriate width
				for (var statusType in job.statuses) {
					if (job.statuses.hasOwnProperty(statusType)) {
						var num = job.statuses[statusType],
							name = '',
							index = 0;
						if (statusType == 'd') {
							name = 'done';
							index = 1;
							progressDone += num;
						} else if (statusType == 'i') {
							name = 'importing';
							index = 2;
							unfinished = true;
							progressUnfinished += num;
						} else if (statusType == 'q') {
							name = 'queued';
							index = 4;
							unfinished = true;
							progressUnfinished += num;
						} else if (statusType == 'n') {
							name = 'unpublished';
							index = 5;
							unfinished = true;
							progressUnfinished += num;
						} else if (statusType == 'e') {
							name = 'error';
							index = 0;
							progressDone += num;
						} else if (statusType == 'p') {
							name = 'preimporting';
							index = 3;
							progressUnfinished += num;
						} else {
							continue;
						}
						texts[index] = '<span><span class="' + name + ' legend"></span>' + name.ucfirst() + ': ' + num.numberFormat() + '</span>';
						status.find('.' + name).width(num / job.total * 100 + '%');
					}
				}
				status.find('.progress_status').html(Math.floor(progressDone / job.total * 1000) / 10 + '% finished');
				// copies can't be exported, so we don't show the link
				if (job.type === 'copy') {
					status.find('.progress_text').html(`Total ${config.getDictionaryEntry('album', true, true)}: ${job.total.numberFormat()} | ${texts.filter(function(item) { return item != undefined; }).join(' | ')}`);
				} else {
					status.find('.progress_text').html(`Total tracks: ${job.total.numberFormat()} | <a href="export.php?type=ImportResults&id=${job.id}" class="emphasized">Export Results</a> | ${texts.filter(function(item) { return item != undefined; }).join(' | ')}`);
				}
			}
			// load again. sooner if there's something interesting happening
			reloadStatus();
		});

		ajax("p=transcode_status", function (response) {
			var container = $j("#transcode_status");
			if (response[0].jobs.length) {
				$j(container).html(
					'<div class="sub">NOTE: Only jobs started in the last 30 days are shown.</div>' +
                    '<table><thead><tr><th>Job Status</th><th>Count</th></tr></thead><tbody></tbody></table>'
				);
				$j.each(response[0].jobs, function (index, row) {
					$j(container).find("tbody").append('<tr><td>' + row.status + '</td><td>' + row.cnt + '</td></tr>');
				});
			} else {
				$j(container).html('<div class="sub">No transcode jobs have been started in the last 30 days.</div>')
			}
			reloadStatus();
		});
	};
}
/**
 * The page in the admin panel that lets you actually upload new tracks
 */
function AdminUploadUpload() {
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		(new UploadComponent()).show(container, AdminUploadUpload.files);
		AdminUploadUpload.files = [];
	};

}

AdminUploadUpload.files = [];
/**
 * The page in the admin panel that lets users kick off batch transcoding requests
 */
function AdminUploadTranscoding() {
	var page = this,
		templates = sa.templates.get('admin.file_delivery.transcoding'),
		selectionHierarchy,
		recentAlbums,
		currentSelectionState = { catalogs : {}, labels : {}, albums : {} },
		selectedCatalogId = 0,
		selectedLabelId = 0;

	this.selectedFormats = [];

	this.show = function (params, container) {

		container.append(templates.get("page"));

		showTrackSelector(container);

		$j(".transcode_format", container).on('click', function (e) {
			var self = this,
				wasSelected = $j(self).data("selected");

			if (wasSelected) {
				$j(self).data("selected", 0).removeClass("selected");
			} else {
				$j(self).data("selected", 1).addClass("selected");
			}

			page.selectedFormats = [];
			$j(".transcode_format[data-selected]").each(function (index, value) {
				if (1 === $j(value).data("selected")) {
					page.selectedFormats.push($j(value).data("format"));
				}
			});

			e.stopPropagation();
			return false;
		});

		$j("#transcode_submit").on('click', function () {
			var selectionCount = 0,
				reducedSelection = { catalogs: [], labels: [], albums: []},
				button = this;

			$j(".error", container).empty();

			$j.each([ "catalogs", "labels", "albums" ], function (index, type) {
				$j.each(currentSelectionState[type], function (id, state) {
					selectionCount += (state === 1) ? 1 : 0;

					if (0 !== id && state === 1) {
						reducedSelection[type].push(id);
					}
				});
			});

			// Verification step 1: Ensure there are catalog/label/albums selected
			if (0 === selectionCount) {
				$j(".error", container).html("You must select some " + gde("album", { p: true }) + ", " + gde("label", { p: true }) + ", or " + gde("catalog", { p: true }) + " to transcode in Step 1.");
			}
			// Verification step 2: Ensure there is at least one transcode format selected
			else if (0 === page.selectedFormats.length) {
				$j(".error", container).html("You must select at least one format for transcoding in Step 2.");
			} else {
				$j(button).html("Processing request...").prop("disabled", true);
				ajax(
					{
						formats: page.selectedFormats.join(","),
						albumIds: reducedSelection.albums.join(","),
						labelIds: reducedSelection.labels.join(","),
						catalogIds: reducedSelection.catalogs.join(",")
					},
					function (response) {
						$j(button).prop("disabled", false);
						sa.notify({ text : response[0].result });
						if (response[0].hasOwnProperty('success') && response[0].success) {
							$j(button).html("Submit");
						}
					},
					'POST',
					'p=transcode_bulk'
				);
			}
		});
		
		let baseUrl = siteBaseUrl();
		
		container.find('image').each(function() {
			let imageSrc = $j(this).attr('src');
			imageSrc = imageSrc.split('images/');
			$j(this).attr('src', baseUrl + '/images/' + imageSrc);
		});
	};

	//////////////////////////////////////////
	// Track Selection functions
	//////////////////////////////////////////

	function showTrackSelector(baseContainer) {
		var container = baseContainer.find('#transcode_selector');

		container.empty().append(templates.get('track_selector'));

		// switching between selector types
		container.find('.select_type').on('click', function() {
			var t = $j(this),
				val = t.find('input').val();
			container.find('.select_type').removeClass('selected');
			t.addClass('selected');
			selectedCatalogId = 0;
			selectedLabelId = 0;
			container.find('.selector_type').hide();
			container.find('.selector_type#select_' + val).show();

			if (val == 'recent') {
				updateRecentState();
			}
		});

		// load the recent data
		function populateRecentAlbums() {
			var recentAlbumList = container.find('#recent_albums ul').empty();
			for (var i = 0, len = recentAlbums.length; i < len; i++) {
				var album = recentAlbums[i],
					item = templates.get('recent_album');
				item.find('.item_name').html(htmlEncode(album.name) + (album.releaseDate != '0' ? ' (' + formatDate(config.dateFormatString, album.releaseDate) + ')' : ''));
				item.attr('id', 'album_' + album.id);
				(function(album, item) {
					item.find('input').on('click', function() {
						selectedCatalogId = album.catalogId;
						selectedLabelId = album.labelId;
						updateSelectionState('album', album.id, this.checked);
					});
				})(album, item);
				if (currentSelectionState['albums'][album.id] == 1) {
					item.find('input').prop('checked', true);
				}

				recentAlbumList.append(item);
			}
		}
		if (!recentAlbums) {
			ajax({ p : 'copy', action : 'list_recent_albums', sync: 1 }, function(response) {
				recentAlbums = response;
				populateRecentAlbums();
			});
		} else {
			populateRecentAlbums();
		}


		// recent state auto syncs to hierarchy but not the other way around
		function updateRecentState() {
			window['currentSelectionState'] = currentSelectionState;
			window['recentAlbums'] = recentAlbums;
			container.find('#recent_albums input').prop('checked', false);
			for (var i = 0, len = recentAlbums.length; i < len; i++) {
				var albumId = parseInt(recentAlbums[i].id);
				console.log('checking', albumId, 'and found', currentSelectionState['albums'][albumId]);
				if (currentSelectionState['albums'][albumId] == 1) {
					container.find('#recent_albums #album_' + albumId + ' input').prop('checked', true);
				}
			}
		}

		// load the hierarchy data
		function populateCatalogHierarchy() {
			cleanSelectionState();
			// sort the catalogs
			var sortedCatalogs = [];
			// Getting the length of an object is kinda difficult without resorting
			// to chicanery like this
			if ($j.map(selectionHierarchy, function () { return 1; }).length) {
				for (var catalogId in selectionHierarchy) {
					if (!selectionHierarchy.hasOwnProperty(catalogId)) continue;
					selectionHierarchy[catalogId].id = catalogId;
					sortedCatalogs.push(selectionHierarchy[catalogId]);
				}
				sortedCatalogs.sort(function(a, b) {
					if (a.name.toLowerCase() < b.name.toLowerCase()) {
						return -1;
					}
					return 1;
				});
				// add all the catalogs to the list
				var catalogContainer = container.find('#catalogs ul');
				for (var c = 0, cLen = sortedCatalogs.length; c < cLen; c++) {
					var cat = sortedCatalogs[c];
					addSelectionItem(catalogContainer, 'catalog', cat.id, cat.name);
				}
			} else {
				$j("#transcode_container").html('<div class="error">The transcoding feature is only available for catalogs you own.</div>');
			}
		}
		if (!selectionHierarchy) {
			sa.api.request({
				handler : 'permission-profiles',
				action : 'getCatalogHierarchy',
				getData : { sync : 1 }
			}).then(response => {
				selectionHierarchy = response;
				populateCatalogHierarchy();
			}).catch(err => {
				sa.alert(err.message);
			});
		} else {
			populateCatalogHierarchy();
		}

		// terminology
		container.find('#catalogs .title').html(gde('catalog', { plural : true }));
		container.find('#labels .title').html(gde('label', { plural : true }));
		container.find('#albums .title').html(gde('album', { plural : true }));

}

	/**
	 * Adds a single item to the profile option selection columns
	 * @param {JQuery} container the list to which the item should be added
	 * @param {string} itemType the type of item we're adding (catalog|label|album)
	 * @param {int} itemId the id of the item we're adding
	 * @param {string} itemName the name to display as the item's label
	 */
	function addSelectionItem(container, itemType, itemId, itemName) {
		var item = templates.get('selection_item');
		item.find('.item_name').html(htmlEncode(itemName));
		item.attr('id', itemType + '_' + itemId);
		if (itemType == 'album') {
			item.find('.expander').remove();
		}
		item.find('input').on('click', function() {
			updateSelectionState(itemType, itemId, this.checked);
		});
		item.find('.expander').on('click', function() {
			item.parent().find('.selected').removeClass('selected');
			item.addClass('selected');
			expandSelectionItem(itemType, itemId);
		});
		if (currentSelectionState[itemType + 's'][itemId] == 1) {
			item.find('input').prop('checked', true);
		}

		container.append(item);

		if (itemType == 'label') {
			determineSelectionLabelState(selectedCatalogId, itemId);
			determineSelectionCatalogState(selectedCatalogId);
		} else if (itemType == 'catalog') {
			determineSelectionCatalogState(itemId);
		}
	}

	/**
	 * Saves the state of the current item into the cache and updates any descendent items
	 * @param {string} itemType (catalog|label|album)
	 * @param {int} itemId the id of the item in question
	 * @param {boolean} allow are we allowing the user to do stateType with this item or not?
	 */
	function updateSelectionState(itemType, itemId, allow) {
		if (allow) {
			currentSelectionState[itemType + 's'][itemId] = 1;
		} else {
			currentSelectionState[itemType + 's'][itemId] = 0;
		}
		// need to propagate changes to subelements
		if (itemType == 'catalog') {
			var labels = selectionHierarchy[itemId].labels;
			for (var labelId in labels) {
				// hit the checkboxes if they're there
				$j('#label_' + labelId + ' input').prop('checked', allow);
				
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				currentSelectionState['labels'][labelId] = allow ? 1 : 0;
				// now we need to update the albums for this label
				var albums = labels[labelId].albums;
				for (var albumId in albums) {
					// hit the checkboxes if they're there
					$j('#album_' + albumId + ' input').prop('checked', allow);
					// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
					currentSelectionState['albums'][albumId] = allow ? 1 : 0;
				}
			}
			determineSelectionCatalogState(itemId);
			// update label states if we're showing this catalog
			if (selectedCatalogId == itemId) {
				for (var labelId in selectionHierarchy[itemId].labels) {
					determineSelectionLabelState(itemId, labelId);
				}
			}
		} else if (itemType == 'label') {
			// we have to find the label in question
			var albums = selectionHierarchy[selectedCatalogId].labels[itemId].albums;
			for (var albumId in albums) {
				// hit the checkboxes if they're there
				$j('#album_' + albumId + ' input').prop('checked', allow);
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				currentSelectionState['albums'][albumId] = allow ? 1 : 0;
			}
			determineSelectionLabelState(selectedCatalogId, itemId);
			determineSelectionCatalogState(selectedCatalogId);
		} else if (itemType == 'album') {
			determineSelectionLabelState(selectedCatalogId, selectedLabelId);
			determineSelectionCatalogState(selectedCatalogId);
		}
		window['ps'] = currentSelectionState;
	};

	/**
	 * Updates a specific catalog's display so it shows the correct number of labels and albums
	 * @param {int} catalogId the id of the catalog
	 */
	function determineSelectionCatalogState(catalogId) {
		// now we need to update the label's catalog to partial status based on the state of the labels within it
		var labels = selectionHierarchy[catalogId].labels,
			labelTotal = 0,
			labelChecked = 0,
			albumTotal = 0,
			albumChecked = 0;
		for (var labelId in labels) {
			if (currentSelectionState.labels[labelId] == 1) labelChecked++;
			labelTotal++;
			for (var albumId in labels[labelId].albums) {
				if (currentSelectionState.albums[albumId] == 1) albumChecked++;
				albumTotal++;
			}
		}
		$j('#catalog_' + catalogId + ' input').parent().find('span').html('(' + labelChecked + '/' + labelTotal + ') (' + albumChecked + '/' + albumTotal + ')');
		currentSelectionState.catalogs[catalogId] = (albumChecked + labelChecked == 0 ? 0 : (albumChecked < albumTotal || labelChecked < labelTotal) ? 2 : 1);
		if (labelChecked == labelTotal && labelTotal != 0) {
			$j('#catalog_' + catalogId + ' input').prop('checked', true);
		} else {
			$j('#catalog_' + catalogId + ' input').prop('checked', false);
		}
	};

	/**
	 * Updates a specific label's display so it shows the correct number of albums
	 * @param {int} catalogId the id of the label's catalog
	 * @param {int} labelId the id of the label itself
	 */
	function determineSelectionLabelState(catalogId, labelId) {
		// now we need to update the label to partial status based on the state of the albums within it
		var albums = selectionHierarchy[catalogId].labels[labelId].albums,
			total = 0,
			checked = 0;
		for (var albumId in albums) {
			if (currentSelectionState.albums[albumId] == 1) checked++;
			total++;
		}
		$j('#label_' + labelId + ' input').parent().find('span').html('(' + checked + '/' + total + ')');
		var labelChecked = (checked == 0 ? 0 : (checked < total) ? 2 : 1);
		//if (!labelChecked && !total) {
			//labelChecked = $j('#label_' + labelId + ' input:checked').length;
		//}
		currentSelectionState.labels[labelId] = labelChecked;
		if (checked == total && total != 0) {
			$j('#label_' + labelId + ' input').prop('checked', true);
		} else {
			$j('#label_' + labelId + ' input').prop('checked', false);
		}
	};

	/**
	 * Makes sure items are hierarchically excluded, meaning that if a catalog is excluded, all its labels and albums are
	 *  Saving will enforce this naturally but if an album is added through nefarious means, such as when adding a track, it won't get an exclusion row
	 *  if it's in an excluded label. That doesn't matter on most of the site but this interface requires those rows exist. We need to make sure that those albums are excluded here.
	 */
	function cleanSelectionState() {
		// go through each catalog in the hierarchy
		for (var catalogId in selectionHierarchy) {
			if (!selectionHierarchy.hasOwnProperty(catalogId)) continue;
			var catalog = selectionHierarchy[catalogId];
			// see if the entire catalog is excluded
			if (currentSelectionState.catalogs[catalogId] === 0) {
				// make sure all sub-items are excluded
				for (var labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					var lab = catalog.labels[labelId];
					currentSelectionState.labels[labelId] = 0;
					for (var albumId in lab.albums) {
						if (!lab.albums.hasOwnProperty(albumId)) continue;
						currentSelectionState.albums[albumId] = 0;
					}
				}
			} else {
				// check the labels
				for (var labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					if (currentSelectionState.labels[labelId] === 0) {
						// label is excluded. make sure albums are too
						var lab = catalog.labels[labelId];
						for (var albumId in lab.albums) {
							if (!lab.albums.hasOwnProperty(albumId)) continue;
							currentSelectionState.albums[albumId] = 0;
						}
					}
				}
			}
		}
	};

	/**
	 * Shows descendents of itemId, potentially loading them off the server
	 * @param {string} itemType (catalog|label). albums have no descendents we care about
	 * @param {int} itemId the id of the item whose descendents we're interested in
	 */
	function expandSelectionItem(itemType, itemId) {
		var newType = (itemType == 'catalog' ? 'label' : 'album'),
			cont = $j('.selector#' + newType + 's ul');
		cont.find('li').remove();
		if (itemType == 'catalog') {
			selectedCatalogId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var labels = selectionHierarchy[itemId].labels;
			// sort
			var sorted = [];
			for (var id in labels) {
				if (!labels.hasOwnProperty(id)) continue;
				labels[id].id = id;
				sorted.push(labels[id]);
			}
			sorted.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			for (var c = 0, cLen = sorted.length; c < cLen; c++) {
				var lab = sorted[c];
				addSelectionItem(cont, newType, lab.id, lab.name);
			}
			// we have to empty the albums if this changes
			$j('.selector#albums ul').find('li').remove().end().append('<li class="empty">Select a label to see albums</li>');
		} else {
			selectedLabelId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var albums = selectionHierarchy[selectedCatalogId].labels[itemId].albums;
			// sort
			var sorted = [];
			for (var id in albums) {
				if (!albums.hasOwnProperty(id)) continue;
				sorted.push({ name : albums[id], id : id });
			}
			sorted.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			// add all the catalogs to the list
			for (var c = 0, cLen = sorted.length; c < cLen; c++) {
				var alb = sorted[c];
				addSelectionItem(cont, newType, alb.id, alb.name);
			}
		}
	};
}
/**
 * The page in the admin panel that lets you manipulate your featured content
 */
function AdminUsers() {
	let page = this;
	let currentTab = '';
	let currentPage;

	let tabs = [];
	function getTabs() {
		if (tabs.length) return tabs;
		let callback = function (tabId, cont) {
			page.setPage(tabId, cont);
		};
		const pages = [
			{ id: 'notifications', href: '/admin?p=users&tab=notifications', title: 'Notifications', enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
			{ id: 'create', href: '/admin?p=users&tab=create', title: 'Create a new user', enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
			{ id: 'edit', href: '/admin?p=users&tab=edit', title: 'Edit or remove a user', enabledSiteTypes: ['seller', 'buyer', 'network', 'radio', 'drop']},
			{ id: 'profiles', href: '/admin?p=users&tab=profiles', title: 'Music Access Filters', enabledSiteTypes: ['seller', 'buyer', 'network', 'radio']},
			{ id: 'roles', href: '/admin?p=users&tab=roles', title: 'Admin Roles', enabledSiteTypes: ['seller', 'buyer', 'network', 'radio'] }
		];
		for (var p of pages) {
			if (p.enabledSiteTypes.includes(config.siteType)) tabs.push(new RightTab(p.id, p.href, p.title, callback));
		}
		return tabs;
	}
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.Users)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Manage Users' + '" permission.</h3>');
		}
		if (config.grayLabel) {
			if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
				sa.notify({ text: 'This workspace is a gray label so this page is only accessible to SourceAudio employees.' });
			} else {
				return container.append('<h3 class="permission_denied">To add this feature to your workspace, please contact SourceAudio at <a href="mailto:sales@sourceaudio.com" class="emphasized">sales@sourceaudio.com</a>.</h3>');
			}
		}
		if (!$j('.right_body.users').length) {
			RightTabbedPage.prototype.show.call(this, 'users', container, getTabs(), '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = getTabs()[0].id;
		this.setTab(vars.tab);
	};
	
	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (!currentPage || currentTab !== pageId) {
			currentTab = pageId;
			// and then if we found it, have it load based on the current params
			switch (pageId) {
				case 'create':
					currentPage = new AdminCreateUser();
					break;
				case 'edit':
					currentPage = new AdminFindUser();
					break;
				case 'profiles':
					currentPage = new AdminPermissionProfiles();
					break;
				case 'roles':
					currentPage = new AdminRoles();
					break;
				case 'notifications':
				default:
					currentPage = new AdminHome();
					break;
			}
		}
		currentPage.show(sa.router.getCurrentQueryParams(), container);
	};
}
AdminUsers.prototype = new RightTabbedPage();
/**
 * The page in the admin panel that lets you create users
 */
function AdminCreateUser() {

	var page = this;
	var templates;

	/** @var {sa.components.permissionProfileSelector} */
	let permissionProfileSelector;
	/** @var {sa.components.permissionProfileSelector} */
	let expirationProfileSelector;

	this.loadAdminRoles = function() {
		var container = $j('#admin_roles');
		if (!user.hasAdminPermission(AdminPermission.Admins)) return container.remove();


		sa.api.request({
			handler : 'admin-roles',
			action : 'list'
		}).catch(() => {
			container.remove(); // this might legit fail if the user doesn't have perm to load
		}).then(response => {
			let html = '<h4>Admin Permissions:</h4> <select name="admin_role" class="aligned">'
				+ '<option value="-1">No permissions</option>'
				+ '<option value="0">Full Access</option>';
			for (let role of response.roles) {
				html += '<option value="' + role.id + '">' + role.name + '</option>';
			}
			html += '</select>'
				+ '<div class="clr"></div><a class="perm_view" href="'+siteBaseUrl()+'/admin?p=users&tab=roles">manage admin roles</a></div>';
			container.html(html);

			container.find('select').on('change', function() {
				if (this.value != -1) { // admin
					$j('#new_profile_container, #permission_profile, #expire_profile, .download_permissions').hide();
					$j('#expiration_date, #expiration_profile, #expire_profile').hide();
				} else {
					$j('#new_profile_container, #permission_profile, #expire_profile, .download_permissions').show();
					if ($j('#expire_profile').show().find('input:checked').length) {
						$j('#expiration_date, #expiration_profile').show();
					}
				}
			});
		});
	};

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		templates = sa.templates.get('admin.users.create');

		container.empty().append(templates.get('basics'));
		container.append(templates.get(config.siteType === 'drop' ? 'perms_drop' : 'perms'));
		container.append(templates.get('sending'));

		// when you update the download limit, update the current left
		container.find('#recurring_total').on('change', function() { container.find('#recurring_current').val($j(this).val()); });
		// add a submit button
		container.find('#create_account').on('click', function() { page.createAccount(); });
		// clicking send email button shows/hides the message container
		$j('#send input').on('click', function() {
			if (this.id == 'send_email_1') {
				$j('#message').show();
			} else {
				$j('#message').hide();
			}
		});
		// permission profile selectors
		let mafExplanation = templates.get('maf_explanation').html();
		permissionProfileSelector = new sa.components.permissionProfileSelector();
		permissionProfileSelector.show(container.find('#create_permission_profile_selector_container'), 'permissionProfiles');
		sa.components.helpExplanation.show(container.find('#permission_profile h4'), mafExplanation);

		if (config.siteType !== 'drop') {
			expirationProfileSelector = new sa.components.permissionProfileSelector();
			expirationProfileSelector.show(container.find('#create_expiration_permission_profile_selector_container'), 'expirationProfiles');
			sa.components.helpExplanation.show(container.find('#expiration_profile h4'), mafExplanation);
		}

		// random password generator
		container.find('input[name=passwordType]').on('click', function() {
			if (this.value === 'generate' || this.value === 'none') {
				container.find('.password_entry').removeClass('showing');
				container.find('#send_email_1').click();
				container.find('input[name=send_email]').attr('disabled', 'disabled');
			} else {
				container.find('.password_entry').addClass('showing');
				container.find('.password_entry input[name=password]').focus();
				container.find('input[name=send_email]').removeAttr('disabled');
			}
		});
		if (config.disableEmailLogins) {
			container.find('#password').hide();
		}

		this.loadAdminRoles();
		sa.api.request({
			handler : 'user-management',
			action : 'getUser',
			getData : {
				user : user.userData.id,
				cacheBreak : (new Date().getTime())
			}
		}).then(function(response) {
			let salesperson = $j('select[name=salesperson]');
			let salesOptions = '';

			let hasAdminUsers = response.hasOwnProperty('adminUsers') && response['adminUsers'].length;

			if (hasAdminUsers) {
				for (let i = 0, len = response['adminUsers'].length; i < len; i++) {
					let ad = response['adminUsers'][i];
					salesOptions += '<option value="' + ad.id + '">' + ad.username + ' (' + ad.email + ')</option>';
				}
				salesperson.html('<option value="0"></option>' + salesOptions);
			}
		});

		// expiration profile
		container.find('#expire_profile input').on('click', function() {
			if (this.checked) {
				container.find('#expiration_date, #expiration_profile').show();
			} else {
				container.find('#expiration_date, #expiration_profile').hide();
			}
		});
		if (!user.expirationDate) {
			container.find('#expiration_date, #expiration_profile').hide();
		}
		container.find('#expiration_date input').datepicker({ dateFormat: config.datePickerDateFormatString });
	};

	/**
	 * Performs form validation before submitting a create user request
	 */
	this.createAccount = function() {
		let post = {
			username : $j('#username input').val().trim(),
			email : $j('#email input').val().trim(),
			passwordType : $j('input[name=passwordType]:checked').val(),
			password : $j('#password input[name=password]').val().trim(),
			permissionProfiles : permissionProfileSelector.getValues(),
			defaultPermissionProfileId : permissionProfileSelector.getDefaultValue(),
			send_email : $j('#send_email_0:checked').length ? 0 : 1,
			total : (config.siteType !== 'drop') ? $j('#recurring_total').val().trim() : 0,
			interval : (config.siteType !== 'drop') ? $j('#recurring_interval').val() : 'd',
			current : (config.siteType !== 'drop') ? $j('#recurring_current').val() : 0,
			adminRoleId : (config.siteType !== 'drop') ? $j('select[name=admin_role]').val() : 0,
			salespersonId : (config.siteType !== 'drop') ? $j('select[name=salesperson]').val() : 0,
			company : $j('#company input').val(),
			notes : $j('#notes input').val(),
			expirationDate : '',
			expirationProfiles : [],
			defaultExpirationProfileId : -1
		};
		let message = $j('#message textarea').val().trim();
		if (message) {
			post.message = message;
		}
		let expireProfile = config.siteType !== 'drop' ? $j('#expire_profile input:checked').length : false;
		if (expireProfile) {
			post.expirationDate = $j('#expiration_date input').val().trim();
			post.expirationProfiles = expirationProfileSelector.getValues();
			post.defaultExpirationProfileId = expirationProfileSelector.getDefaultValue();
		}
		let error = false;
		$j('#general').removeClass('error').html('');
		// username
		if (!post.username) {
			$j('#username .information').addClass('error').removeClass('success')
				.html('Please enter a name');
			error = true;
		} else if (post.username.length < 2 || post.username.length > 128) {
			$j('#username .information').addClass('error').removeClass('success')
				.html('Full name must be at least 2 characters and at most 128');
			error = true;
		} else {
			$j('#username .information').removeClass('error').removeClass('success')
				.html('Minimum of 2 characters, maximum of 128.');
		}
		// email
		if (!post.email) {
			$j('#email .information').addClass('error').removeClass('success').html('Please enter an email');
			error = true;
		} else if (!post.email.isEmail()) {
			$j('#email .information').addClass('error').removeClass('success').html('Please enter a valid email');
			error = true;
		} else {
			$j('#email .information').removeClass('error').removeClass('success')
				.html('The user will receive a confirmation email at this address. They will need to confirm before '
					+ 'the account will be activated.');
		}
		// password
		if (post.passwordType !== 'generate') {
			if (!post.password) {
				$j('#password .information').addClass('error').removeClass('success')
					.html('Please enter a password');
				error = true;
			} else if (post.password.length < PasswordLength) {
				$j('#password .information').addClass('error').removeClass('success')
					.html('Password must be at least ' + PasswordLength + ' characters');
				error = true;
			} else if (post.password.match(/[0-9]/) == null || post.password.match(/[a-zA-Z]/) == null) {
				$j('#password .information').addClass('error').removeClass('success')
					.html('Password must contain at least 1 letter and 1 number');
				error = true;
			} else {
				$j('#password .information').removeClass('error').removeClass('success')
					.html('Minimum of ' + PasswordLength + ' characters. Must contain at least 1 letter and 1 number.');
			}
		} else {
			post.password = '';
			$j('#password .information').removeClass('error').removeClass('success')
				.html('Minimum of ' + PasswordLength + ' characters. Must contain at least 1 letter and 1 number.');
		}
		// expiration profile
		if (expireProfile && (!post.expirationDate || isNaN(dateStringToTimestamp(post.expirationDate)) || dateStringToTimestamp(post.expirationDate) <= (new Date().getTime()) / 1000)) {
			$j('#expire_profile .information').addClass('error')
				.html('Expiration date must be in the future.');
			error = true;
		} else {
			$j('#expire_profile .information').removeClass('error')
				.html('convert this user to a different filter on a specific date?');
		}

		if (!error) {
			let loader = showLoader($j('.tabbed_body'), 'Creating user...', true);
			sa.scrollToElement(loader);
			sa.api.request({
				handler : 'user-management',
				action : 'createUser',
				postData : post
			}).then((result) => {
				loader.remove();
				/** @var {{ email_sent : boolean, new_user : boolean, full_creation : boolean, new_user : boolean }} result */
				$j('#username input, #email input, #password input[name=password], #company input, #notes input').val('');
				let message;
				if (result.email_sent) {
					message = 'The user <b>was emailed</b> their account details. If they have trouble getting the email, they can use the Forgot Password option on the login page.';
				} else if (result.full_creation) {
					message = 'The user <b>was not emailed</b> their account details and their account was automatically activated. You\'ll need to send them their email and password before they\'ll be able to access their account.';
				} else {
					message = 'The user <b>was not emailed</b> their account details but <span class="error">there was an error while activating their account</span>. You\'ll need to send them their username and password before they\'ll be able to access their account.';
				}
				$j('#general').html('<h2>Result: Account Created!</h2><div class="section">' + message + '</div><div class="section">Remember that they\'ll log in with their email, not their username</div>');
				sa.scrollToElement($j('#general'));
				sa.notify({ text : createText('Account created' + (result.email_sent ? ' and email sent!' : '!')), type : sa.notify.notificationTypes.success });
			}).catch(e => {
				loader.remove();
				$j('#general').addClass('error').html(e.message);
				sa.notify({ text : e.details && e.details['containsHtml'] ? e.message : createText(e.message) });
			});
		} else {
			sa.scrollToElement($j('.tab_users .error:first'));
		}
	};
}
/**
 * The page in the admin panel that lets you find/edit/remove users
 */
function AdminFindUser() {

	var page = this;

	/**
	 * The list of permission profiles on this white label
	 */
	let adminRoles = [];

	/** @var {sa.components.permissionProfileSelector} */
	let permissionProfileSelector;
	/** @var {sa.components.permissionProfileSelector} */
	let expirationProfileSelector;

	let templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var content,
			vars = sa.router.paramsToVars(params);
		if (vars.user) {
			console.log('found user ' + vars.user);
			// see if we're already on the user search page
			if ($j('#user_search').length) return;
		}
		if (!templates) {
			templates = sa.templates.get('admin.users.find');
		}
		container.empty().append(templates.get('user_lookup'));
		// clicking send email button shows/hides the message container
		container.find('#user_search').on('keyup', function() {
			var val = this.value.trim();
			$j('#results').show();
			$j('#user_edit').hide();
			if (!val) {
				page.loadUsers('', true);
				return;
			}
			page.loadUsers(val);
		});

		function fin() {
			vars = sa.router.getCurrentParamsAsObject();
			if (vars.user) {
				sa.api.request({
					handler : 'user-management',
					action : 'getUser',
					getData : {
						user : vars.user
					}
				}).then(page.setUser).catch(() => { sa.notify({ text: 'User not found. Please try searching' }); });

			} else {
				$j('#user_search').trigger('keyup');
			}
		}
		if (user.hasAdminPermission(AdminPermission.Admins)) {
			sa.api.request({
				handler : 'admin-roles',
				action : 'list'
			}).then(r => {
				adminRoles = r.roles;
			}).finally(() => {
				fin();
			});
		} else {
			fin();
		}
	};

	/**
	 * Loads a list of users based on what the user has entered
	 * @param {string} value the search term
	 * @param {boolean=} loadRecent if true, the script will load the 50 most recent users to join the site instead of the search results
	 */
	this.loadUsers = function(value, loadRecent) {
		sa.api.request({
			handler : 'user-management',
			action : 'search',
			getData : {
				search : value,
				loadRecent : loadRecent ? 1 : 0
			}
		}).then(response => {
			page.handleUserResults(response, loadRecent);
		});
	};

	/**
	 * Handles the response from the server after searching for a user
	 * @param {{ result : string, users : Array, totalFound : int, message : string }} response the server's list of users
	 * @param {boolean} showingRecent
	 */
	this.handleUserResults = function(response, showingRecent) {
		var resultContainer = $j('#results .results').html('');
		if (response.result != 'success') {
			sa.notify({ text : response.message });
		} else if (!response.users.length) {
			resultContainer.html('No users matched');
		} else {
			let baseUrl = siteBaseUrl();
			for (var i = 0, users = response.users, len = users.length; i < len; i++) {
				var user = users[i],
					userContainer = $j('<a class="user faux_button" href="'+ baseUrl + '/admin?p=users&tab=edit&user=' + user.id + '">' + user.username + (user.company ? ' - ' + user.company : '') + '<span>' + user.email + '</span>'
						+ (user.notes ? '<span>' + user.notes + '</span>' : '') + '</a>');
				//userContainer.on('click', function(user) { return function() { page.setUser(user); }; }(user));
				resultContainer.append(userContainer);
			}
			if (showingRecent) {
				resultContainer.append('<div>Showing the ' + Math.min(users.length, 50) + ' most recently joined users</div>');
			} else {
				resultContainer.append('<div>Showing ' + Math.min(users.length, 50) + ' out of ' + response.totalFound + ' matched users</div>');
			}
		}
	};

	/**
	 * Sets up the user display so you can edit a user
	 * @param {{
	 * 		id : int,
	 * 		username : string,
	 * 		email : string,
	 * 		admin : int,
	 * 		permissionProfileIds : int[],
	 * 		defaultPermissionProfileId : int,
	 * 		download_limit : object,
	 * 		extra_fields : object,
	 * 		expirationDate : int,
	 * 		expirationProfileIds : int[],
	 * 		defaultExpirationProfileId : int,
	 * 		salesperson : { id : int, username : string },
	 * 		company : string,
	 * 		notes : string,
	 * 		owner : int,
	 * 		lastIp : string,
	 * 		ipLocation : string,
	 * 		ip_banned : int,
	 * 		hard_ip_banned : int,
	 * 		user_id_banned : int,
	 * 		adminRoleId : int,
	 * 		adminUsers : Array.<{ id : int, username : string, email : string }>,
	 * 		userIpRanges : Array
	 * 	}} editUser the user you're going to edit
	 */
	this.setUser = function(editUser) {
		let baseUrl = siteBaseUrl();
		$j('#results').hide();
		if (window.user.userData.id == editUser.id) {
			var href = baseUrl + '/dashboard?p=account';
			sa.confirm({
				text: 'Please edit your account from the dashboard.',
				yesText: 'Ok',
				yesFunction: function () {
					sa.router.routeTo(href);
				}
			});
		}
		var container = $j('#user_edit').show();
		var lim = editUser.download_limit;
		var superAdmin = window.user.hasAdminPermission(AdminPermission.SuperAdmin);
		var mapQuotes = { "\"": "&quot;", "'": "&#39;" };
		var userPerms = '<div class="section with_checks" id="permission_profile"><h4>Music Access Filters:</h4> <div id="edit_permission_profile_selector_container"></div>'
			+ '<div class="information"></div><div class="clr"></div></div>'
			+ (window.user.hasAdminPermission(AdminPermission.Admins) ?
				'<div class="section with_checks" id="admin_permission"><h4>Admin Permissions:</h4> <select name="admin_role" class="aligned">'
				+ (function () {
					var ret = '<option value="-1"' + (editUser.adminRoleId == -1 ? ' selected="selected"' : '') + '>No permissions</option>'
						+ '<option value="0"' + (editUser.adminRoleId == 0 ? ' selected="selected"' : '') + '>Full Access</option>';
					for (var i = 0, len = adminRoles.length; i < len; i++) {
						var role = adminRoles[i];
						ret += '<option value="' + role.id + '"' + (editUser.adminRoleId == role.id ? ' selected="selected"' : '') + '>' + role.name + '</option>';
					}
					if (superAdmin) {
						ret += '<option value="-2">Make Workspace Owner</option>';
					}
					return ret;
				})()
				+ '</select>'
				+ '<div class="clr"></div><a class="perm_view" href="'+siteBaseUrl()+'/admin?p=users&tab=roles">manage admin roles</a></div>'
				: '')
			+ '<div class="section with_checks" id="expire_profile"><h4>Expire Filters:</h4> <input type="checkbox" value="1"' + (editUser.admin ? ' disabled="disabled"' : '')
			+ (editUser.expirationDate ? ' checked="checked"' : '') + '/>'
			+ '<div class="information short">convert this user to different filters on a specific date?</div><div class="clr"></div></div>'
			+ '<div class="section" id="expiration_date"><h4>Expiration Date:</h4> <input type="text" value="' + (editUser.expirationDate ? formatDate(config.dateFormatString, editUser.expirationDate) : '') + '"/>'
			+ '<div class="clr"></div></div>'
			+ '<div class="section" id="expiration_profile"><h4>New Filters:</h4> <div class="information short">The filters to change to on the expiration date</div><div id="edit_expiration_permission_profile_selector_container"></div>'
			+ '<div class="clr"></div></div>';
		var salesOptions = '';
		if (editUser.adminUsers && editUser.adminUsers.isArray) {
			for (var i = 0, len = editUser.adminUsers.length; i < len; i++) {
				var ad = editUser.adminUsers[i];
				salesOptions += '<option value="' + ad.id + '"' + (editUser.salesperson.id == ad.id ? ' selected="selected"' : '') + '>' + htmlEncode(ad.username + ' (' + ad.email + ')') + '</option>';
			}
		}
		var dlLimit = '<div class="download_limit_container">'
				+ '<h2>Download limit:</h2>'
				+ '<div class="information top">You can set a recurring download limit for this user.<br/><br/><b>Please Note:</b> If this user\'s music access filter has downloads disabled, they '
					+ 'will not be able to download at all, no matter what number is entered below. They must be associated to a filter that allows downloads and when the number '
					+ 'of downloads entered below is reached, they are no longer allowed to download without your permission.<br/><br/></div><div class="clr"></div>'
				+ '<div class="section"><h4>Limit:</h4><input type="text" id="recurring_total" value="' + (lim.total ? lim.total : 0) + '"/>'
					+ '<div class="information">The max number of downloads the user will be able to make. 0 is unlimited.</div><div class="clr"></div></div>'
				+ '<div class="section"><h4>Resets:</h4><select id="recurring_interval" class="aligned">'
					+ '<option value="d"' + (lim.interval == 'd' ? ' selected="selected"' : '') + '>Daily</option>'
					+ '<option value="w"' + (lim.interval == 'w' ? ' selected="selected"' : '') + '>Weekly</option>'
					+ '<option value="m"' + (lim.interval == 'm' ? ' selected="selected"' : '') + '>Monthly</option>'
					+ '<option value="q"' + (lim.interval == 'q' ? ' selected="selected"' : '') + '>Quarterly</option>'
					+ '<option value="y"' + (lim.interval == 'y' ? ' selected="selected"' : '') + '>Yearly</option>'
					+ '<option value="n"' + (lim.interval == 'n' ? ' selected="selected"' : '') + '>Never Reset</option>'
					+ '</select>'
					+ '<div class="information">Every time this time period elapses, the user will be able to download {limit} tracks again.</div><div class="clr"></div></div>'
				+ '<div class="section"><h4>Currently left:</h4><input type="text" id="recurring_current" value="' + (lim.current ? lim.current : 0) + '"/>'
					+ '<div class="information">How many downloads does the user have left?</div><div class="clr"></div></div>'
			+ '</div>';
		var basics = '<div class="section" id="basics">'
				+ '<h2>Name and email:</h2>'
				+ '<div class="section text_data_section" id="username"><h4>Full Name:</h4> <div class="text_data"></div>'
					+ '<div class="text_data_information">' + (config.siteType !== 'drop' ? '<a href="'+siteBaseUrl()+'/admin?p=stats&tab=users&user=' + editUser.id + '">(user stats)</a>' : '') + '</div>'
					+ '<div class="clr"></div></div>'
				+ '<div class="section text_data_section" id="email"><h4>Email:</h4> <div class="text_data"></div>'
					+ '<div class="text_data_information">Contact support@sourceaudio.com if you need to change a user\'s email</div><div class="clr"></div></div>'
				+ '<div class="section" id="email"><h4>Salesperson:</h4> <select name="salesperson" class="aligned"><option value="0"></option>' + salesOptions + '</select>'
					+ '<div class="information short">Only displayed internally</div><div class="clr"></div></div>'
				+ '<div class="section" id="company"><h4>Company:</h4> <input type="text" value=""/><div class="information short">Only displayed internally</div><div class="clr"></div></div>'
				+ '<div class="section" id="notes"><h4>Notes:</h4> <input type="text" value=""/>'
					+ '<div class="information short">Only displayed internally</div><div class="clr"></div></div>'
					// premiere radio has some extra fields http://bugs.sourceaudio.com/show_bug.cgi?id=856
				+ (function() {
					let ret = '';
					const forcedFields = {};
					for (const fieldData of config.registrationFields) {
						if (fieldData.type === 'forced') {
							forcedFields[fieldData.name] = 'disabled';
							editUser.extra_fields[fieldData.name] = fieldData.defaultValue;
						} else {
							forcedFields[fieldData.name] = '';
						}
					}
					for (const key in editUser.extra_fields) {
						const value = editUser.extra_fields[key].replace(/["']/gi, function (matched) { return mapQuotes[matched]; });
						ret += `<div class="section"><h4>${key}:</h4> <input type="text" ${forcedFields[key]} class="extra_field_value" name="extra[${key}]" value="${value}"/><div class="clr"></div></div>`;
					}
					return ret;
				})()
				+ '<div class="clr"></div>'
			+ '</div>';
		var html = '<div class="section label_options" id="user_permissions">'
						+ '<h2>User permissions:</h2>'
							+ userPerms
							+ dlLimit
					+ '</div>';
		if (config.siteType === 'drop') html = '';
		container.html(basics);
		container.append(templates.get('password_section'));
		container.append(html);
		container.append(templates.get('delete_section'));
		if (superAdmin) {
			container.append(templates.get('superadmin_section'));
		}
		container.append(templates.get('admin_notice_section'));
		// add values safely
		container.find('#username .text_data').text(editUser.username);
		container.find('#email .text_data').text(editUser.email);
		container.find('#company input').val(editUser.company);
		container.find('#notes input').val(editUser.notes);
		// permission profile selection
		if (config.siteType !== 'drop') {
			permissionProfileSelector = new sa.components.permissionProfileSelector();
			permissionProfileSelector.show(container.find('#edit_permission_profile_selector_container'), 'permissionProfiles');
			permissionProfileSelector.setSelectedPermissionProfileIds(editUser.permissionProfileIds, editUser.defaultPermissionProfileId);

			expirationProfileSelector = new sa.components.permissionProfileSelector();
			expirationProfileSelector.show(container.find('#edit_expiration_permission_profile_selector_container'), 'expirationProfiles');
			expirationProfileSelector.setSelectedPermissionProfileIds(editUser.expirationProfileIds, editUser.defaultExpirationProfileId);

			let mafExplanation = sa.templates.get('admin.users.create').get('maf_explanation').html();
			sa.components.helpExplanation.show(container.find('#permission_profile h4'), mafExplanation);
			sa.components.helpExplanation.show(container.find('#expiration_profile h4'), mafExplanation);
		}
		// ip, if we have it
		if (editUser['lastIp']) {
			container.find('#basics').append('<div class="section"><h4>Last Used IP:</h4> <div class="text_data">' + editUser['lastIp'] + ' (probably ' + editUser['ipLocation'] + ')</div><div class="clr"></div></div>');
			if (editUser['ipBanned']) {
				container.find('#basics').append('<div class="notice">This user\'s IP is banned from downloading</div>');
			}
			if (editUser['hardIpBanned']) {
				container.find('#basics').append('<div class="notice">This user\'s IP is banned from access the workspace in any way</div>');
			}
			if (editUser['userIdBanned']) {
				container.find('#basics').append('<div class="notice">This user is banned</div>');
			}
		}
		// user ip ranges
		if (window['user'].hasAdminPermission(AdminPermission.SuperAdmin)) {
			let autoLoginIpTemplate = container.find('.auto_login_ip').clone();
			let autoLoginIpTable = container.find('.auto_login_ips');
			let autoLoginIpSection = container.find('.auto_login_ips_section');
			let addAutoLoginIp = function(userIpRange) {
				let template = autoLoginIpTemplate.clone();
				if (userIpRange) {
					template.find('.start').val(userIpRange['start']);
					template.find('.end').val(userIpRange['end']);
				}
				template.find('.remove').on('click', function() {
					template.remove();
					if (!autoLoginIpTable.find('.auto_login_ip').length) {
						autoLoginIpSection.removeClass('has_ips');
					}
				});
				autoLoginIpTable.append(template);
				autoLoginIpSection.addClass('has_ips');
			};
			container.find('.auto_login_ip').remove();
			if (editUser['userIpRanges'] && editUser['userIpRanges']['ipRanges'] && editUser['userIpRanges']['ipRanges'].length) {
				for (let i = 0, len = editUser['userIpRanges']['ipRanges'].length; i < len; i++) {
					addAutoLoginIp(editUser['userIpRanges']['ipRanges'][i]);
				}
			} else {
				autoLoginIpSection.removeClass('has_ips');
			}
			container.find('.add_auto_login_ip').on('click', function() { addAutoLoginIp(); });
		}
		// when you update the download limit, update the current left
		container.find('#recurring_total').on('change', function() { container.find('#recurring_current').val($j(this).val()); });
		container.find('.label:odd').addClass('stripe');
		if (editUser.admin) { // admins don't have permission profiles
			$j('#new_profile_container, #permission_profile').hide();
			container.find('#expiration_date, #expiration_profile, #expire_profile').hide();
			$j('.download_limit_container').hide();
		} else {
			// expiration profile
			container.find('#expire_profile input').on('click', function() {
				if (this.checked) {
					container.find('#expiration_date, #expiration_profile').show();
				} else {
					container.find('#expiration_date, #expiration_profile').hide();
				}
			});
			if (!editUser.expirationDate) {
				container.find('#expiration_date, #expiration_profile').hide();
			}
			container.find('#expiration_date input').datepicker({ dateFormat: config.datePickerDateFormatString });
		}
		if (config.siteType === 'drop' && (window.user.isSiteOwner() || superAdmin)) {
			var addToDom = '<div class="section with_checks" id="admin_permission">'
				+ '<h4> Admin Permissions:</h4>'
				+ '<select name = "admin_role" class="aligned">'
				+ '<option value="0"' + (editUser.adminRoleId == 0 ? ' selected="selected"' : '') + '>Full Access</option>'
				+ '<option value="-2">Make Workspace Owner</option></select></div>';
			container.find('#basics').append(addToDom);
		}

		// random password generator
		container.find('input[name=passwordType]').on('click', function() {
			if (this.value !== 'enter') {
				container.find('.password_entry').removeClass('showing');
			} else {
				container.find('.password_entry').addClass('showing');
				container.find('.password_entry input[name=password]').focus();
			}
		});
		if (config.disableEmailLogins) {
			container.find('#password').hide();
		}

		// add a submit button
		container.append($j(createButton('Save Changes', 'save_changes', '', '', function() { page.saveChanges(editUser); return false; })))
			.append('<div class="information" id="general"></div>');
		if (editUser.owner || editUser.superAdmin) { // site owners can't be edited
			$j('#admin_permission select').html('<option value="0">' + (editUser.superAdmin ? 'SourceAudio Employee' : 'Workspace Owner') + '</option>').prop('disabled', true);
			$j('#new_profile_container, #permission_profile, #expire_profile, #delete_user, .download_limit_container').hide();
			if (editUser.superAdmin || !superAdmin) {
				$j('#user_edit input, #user_edit select').prop('disabled', true);
				$j('#admin_info').show().find('.information').html('You may not edit ' + (editUser.superAdmin ? 'a SourceAudio employee\'s' : 'the workspace owner\'s')
						+ ' account. Please log in as this user or contact SourceAudio if you need to make changes.').addClass('error');
				$j('#save_changes').hide();
			}
		} else if (editUser.admin && !window.user.hasAdminPermission(AdminPermission.Admins)) {
			$j('#user_edit input, #user_edit select').prop('disabled', true);
			$j('#admin_info').show().find('.information').html('You may not edit admins\' accounts. Please log in as this user or contact the workspace owner to make changes.').addClass('error');
			$j('#save_changes').hide();
		}
		// we set a window var here to tell the permission profile manager to make a new profile when it loads. not elegant. very effective
		container.find('#permission_profile .perm_view').on('click', function() {
			let val = $j('#permission_profile select').val();
			if (val.length < 1) {
				sa.notify({ text : 'Please select a profile to view.' });
				return false;
			} else if (val.length > 1) {
				sa.notify({ text : 'Please select only one profile to view it.' });
				return false;
			} else {
				AdminPermissionProfiles.LoadProfileOnLoad = val[0];
				return true;
			}
		});
		container.find('select[name=admin_role]').on('change', function() {
			var admin = this.value != -1;
			if (admin) {
				$j('#new_profile_container, #permission_profile, #expire_profile, #delete_user, .download_limit_container').hide();
				$j('#expiration_date, #expiration_profile, #expire_profile').hide();
			} else {
				$j('#new_profile_container, #permission_profile, #expire_profile, #delete_user, .download_limit_container').show();
				if ($j('#expire_profile').show().find('input').filter(':checked').length) {
					$j('#expiration_date, #expiration_profile').show();
				}
			}
		});
		if (superAdmin) {
			container.find('#masquerade').on('click', function() {
				ajax({ userId : editUser.id, action : 'masquerade' }, function() {
					sa.router.routeTo('/tracks');
					window.location.reload();
				}, 'POST', { p : 'user_options' });
			});
		}
	};

	/**
	 * Saves changes to the current user
	 * @param {object} editUser the user as passed into setUser
	 * @param {boolean} proceed ignore the admin warning?
	 */
	this.saveChanges = function(editUser, proceed) {
		if (editUser.siteOwner && !window.user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			sa.notify({ text : 'You cannot make changes to the workspace owner.' });
			return;
		} else if (editUser.admin && !window.user.hasAdminPermission(AdminPermission.Admins)) {
			sa.notify({ text : 'You cannot make changes to an admin account.' });
			return;
		}
		var password = $j('#password input[name=password]').val().trim();
		var passwordType = $j('#password input[name=passwordType]:checked').val();
		var deleteUser = $j('#delete_user input').val().trim();
		var extraFields = $j('.extra_field_value');
		var error = false;
		var page = this;

		var permProfiles = editUser.permissionProfileIds;
		var defaultPermissionProfileId = -1;
		var adminRoleId = (config.siteType !== 'drop' || (window.user.isSiteOwner() || window.user.hasAdminPermission(AdminPermission.SuperAdmin))) ? $j('select[name=admin_role]').val() : 0;
		var total = 0;
		var interval = 'd';
		var current = 0;
		var expireProfile = false;
		var expirationDate = '';
		var expirationProfiles = [];
		var defaultExpirationProfileId = -1;
		if (config.siteType !== 'drop') {
			permProfiles = permissionProfileSelector.getValues();
			defaultPermissionProfileId = permissionProfileSelector.getDefaultValue();
			total = $j('#recurring_total').val().trim();
			interval = $j('#recurring_interval').val();
			current = $j('#recurring_current').val();
			expireProfile = $j('#expire_profile input:checked').length;
			expirationDate = $j('#expiration_date input').val().trim();
			expirationProfiles = expirationProfileSelector.getValues();
			defaultExpirationProfileId = expirationProfileSelector.getDefaultValue();
		}
		var downloadPermissionString = '&permissionProfiles[]=' + permProfiles.join('&permissionProfiles[]=') + '&defaultPermissionProfileId=' + defaultPermissionProfileId;
		var expirationString = expireProfile ? '&expirationDate=' + encodeURIComponent(expirationDate) + '&expirationProfiles[]=' + expirationProfiles.join('&expirationProfiles[]=') + '&defaultExpirationProfileId=' + defaultExpirationProfileId : '&expirationDate=&expirationProfiles=';

		$j('#general').removeClass('error').html('');
		// password
		if (passwordType === 'none' || passwordType === 'generate') {
			$j('#password .information').removeClass('error').removeClass('success')
				.html('Minimum of ' + PasswordLength + ' characters. Must contain at least 1 letter and 1 number.');
		} else {
			if (password.length < PasswordLength) {
				$j('#password .information').addClass('error').removeClass('success')
					.html('Password must be at least ' + PasswordLength + ' characters');
				error = true;
			} else if (password.match(/\d/) == null || password.match(/[a-zA-Z]/) == null) {
				$j('#password .information').addClass('error').removeClass('success')
					.html('Password must contain at least 1 letter and 1 number');
				error = true;
			} else {
				$j('#password .information').removeClass('error').removeClass('success')
					.html('Minimum of ' + PasswordLength + ' characters. Must contain at least 1 letter and 1 number.');
			}
		}
		// permission profiles
		if (!permProfiles.length) {
			$j('#permission_profile .information').addClass('error').html('Please select at least one profile.');
		} else {
			$j('#permission_profile .information').removeClass('error').html('');
		}
		// expiration profile
		if (expireProfile && (!expirationDate || isNaN(dateStringToTimestamp(expirationDate)) || dateStringToTimestamp(expirationDate) <= (new Date().getTime()) / 1000)) {
			$j('#expire_profile .information').addClass('error')
				.html('Expiration date must be in the future.');
			error = true;
		} else {
			$j('#expire_profile .information').removeClass('error')
				.html('convert this user to a different filter on a specific date?');
		}

		if (!error) {
			if (deleteUser === 'DELETE' && !proceed) {
				sa.confirm({
					text : 'Are you absolutely sure you want to delete this user?',
					yesFunction : function () {
						page.saveChanges(editUser, true);
					},
					yesText : 'Delete'
				});
			} else if (deleteUser !== '' && deleteUser !== 'DELETE') {
				sa.alert({
					text : 'To delete a user, enter "DELETE" in all caps. Otherwise, remove any text from the Delete User field.'
				});
			} else {
				// extra fields
				var extraString = '&salespersonId=' + $j('select[name=salesperson]').val();
				extraString += '&company=' + encodeURIComponent($j('#company input').val()) + '&notes=' + encodeURIComponent($j('#notes input').val());
				for (var i = 0, len = extraFields.length; i < len; i++) {
					extraString += '&' + extraFields[i].name + '=' + encodeURIComponent(extraFields[i].value);
				}
				// add the user ip ranges
				if (window['user'].hasAdminPermission(AdminPermission.SuperAdmin)) {
					let startIps = $j('input[name=startIps\\[\\]]');
					let endIps = $j('input[name=endIps\\[\\]]');
					for (let i = 0, len = startIps.length; i < len; i++) {
						let startIp = startIps[i].value.trim();
						let endIp = endIps[i].value.trim();
						if (startIp === '' && endIp === '') continue;
						if (!isIpAddress(startIp)) {
							sa.alert({ text : 'Start IP ' + (i + 1) + ' is invalid' });
							return;
						}
						if (!isIpAddress(endIp)) {
							sa.alert({ text : 'End IP ' + (i + 1) + ' is invalid' });
							return;
						}
						extraString += '&userIpRangeStartIp[' + i + ']=' + startIp + '&userIpRangeEndIp[' + i + ']=' + endIp;
					}
				}
				sendUserEditPost('userId=' + editUser.id + '&password=' + encodeURIComponent(password) + '&passwordType=' + encodeURIComponent(passwordType)
					+ '&total=' + total + '&interval=' + interval + '&current=' + current + '&adminRoleId=' + adminRoleId
					+ '&delete=' + encodeURIComponent(deleteUser) + downloadPermissionString + expirationString + extraString, false);
			}
		}
	};

	function sendUserEditPost(postString, ignoreWarnings) {
		var currentUserId = getCurrentUserId();
		sa.api.request({
			handler : 'user-management',
			action : 'editUser',
			postData : postString,
			getData: {
				currentUserId: currentUserId
			}
		}).catch(e => {
			$j('#general').addClass('error').html(e.message);
			sa.notify({ text : e.message });
		}).then(response => {
			if (!ignoreWarnings && response['warning']) {
				sa.confirm({ text : response['warning'], yesFunction : function() {
						sendUserEditPost(postString + '&ignoreWarning=1', true);
					}});
			} else if (response.ownerChanged) {
				sa.scrollToElement($j('.ltp_header'));
				sa.notify({ text : 'This user is now the workspace owner. Changing the owner has removed the workspace\'s billing information. The new owner will need to log in and add their card.', type : sa.notify.notificationTypes.success });
			} else if (response.changed) {
				sa.scrollToElement($j('.ltp_header'));
				sa.notify({ text : 'Account updated and user notified via email!', type : sa.notify.notificationTypes.success });
			} else if (response.isAdminUser) {
				sa.notify({ text : 'Unable to change this user\'s name, email, or password because they have an admin account on at least one workspace in the SourceAudio network. Please contact SourceAudio support if you need help.' });
			} else if (response.quietlyChanged) {
				sa.scrollToElement($j('.ltp_header'));
				sa.notify({ text : 'Account updated!', type : sa.notify.notificationTypes.success });
			} else if (response.deleted) {
				sa.router.routeTo('/admin?p=users&tab=edit');
				sa.notify({ text : 'User deleted!', type : sa.notify.notificationTypes.success });
			} else {
				sa.scrollToElement($j('.ltp_header'));
				sa.notify({ text : 'You must change at least one field to save' });
			}
		});
	}
}
/**
 * The page in the admin panel that lets you create/edit permission profiles
 */
function AdminPermissionProfiles() {

	var templates = sa.templates.get('admin.users.permission_profiles');
	var page = this;

	this.currentProfileState = {};
	this.selectedCatalogId = 0;
	this.selectedLabelId = 0;

	this.hierarchy = null;
	this.onHierarchy = [];

	this.userList = null;
	
	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		var vars = sa.router.paramsToVars(params);
		if (vars.profile) {
			console.log('found profile ' + vars.profile);
			// see if we're already on the user search page
			if ($j('#permission_profile_editor').length) {
				console.log('returning');
				return;
			}
			this.loadProfile = vars.profile;
		}
		container.html(templates.get('base'));
		
		// add superadmin options
		if (user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			container.find('.header .last').prop('colspan', 6);
		}

		// Set up event listener here so it doesn't get re-added each time `loadProfiles` is called
		container.find('#new_profile').on('click', function () {
			page.newProfile();
		});
		
		this.loadProfiles();

		if (!this.hierarchy) {
			sa.api.request({
				handler : 'permission-profiles',
				action : 'getCatalogHierarchy',
			}).then(hierarchy => {
				page.hierarchy = hierarchy;
				if (this.onHierarchy.length) {
					for (let callback of this.onHierarchy) {
						callback(hierarchy);
					}
				}
			});
		}
	};

	/**
	 * Loads the list of profiles from the server
	 *  Displays the list after load
	 */
	this.loadProfiles = function() {
		sa.api.request({
			handler : 'permission-profiles',
			action : 'getList',
			getData : { cache : new Date().getTime() }
		}).then(profiles => {
			var list = $j('#permission_profile_list');
			var profileContainer = list.find('#profile_list');
			profileContainer.find('.permission_profile').remove();
			for (let i = 0, len = profiles.length; i < len; i++) {
				profileContainer.append(page.addProfile(profiles[i]));
			}
			list.find('.permission_profile:odd').addClass('stripe');
			
			function showBackButton() {
				list.after(templates.get('back_button').on('click', () => { window.history.go(-1); }));
			}
			if (AdminPermissionProfiles.CreateNewProfileOnLoad) {
				AdminPermissionProfiles.CreateNewProfileOnLoad = false;
				showBackButton();
				page.newProfile();
			} else if (AdminPermissionProfiles.LoadProfileOnLoad) {
				var profileId = AdminPermissionProfiles.LoadProfileOnLoad;
				AdminPermissionProfiles.LoadProfileOnLoad = false;
				showBackButton();
				for (let i = 0, len = profiles.length; i < len; i++) {
					if (profiles[i].id == profileId) {
						page.editProfile(profiles[i]);
						break;
					}
				}
			}
		});
	};

	/**
	 * Creates a profile to add to the list
	 * @param {object} profileData should have .id and .name
	 * @return {JQuery} the profile to add
	 */
	this.addProfile = function(profileData) {
		var profile = templates.get('listed_profile', {
			'profileId' : profileData.id,
			'profileName' : profileData.name
		});

		if (!profileData['deletable']) {
			profile.find('.delete').remove();
		}
		if (profileData.name == 'Default Logged Out') {
			profile.find('.list').remove();
			profile.find('.edit').addClass('indented');
		}

		profile.find('.edit, a:first').on('click', function() {
			page.editProfile(profileData);
			return false;
		});
		profile.find('.list').on('click', function() {
			page.listUsers(profileData);
			return false;
		});
		profile.find('.copy').on('click', function () {
			page.copyProfile(profileData);
			return false;
		});
		profile.find('.delete').on('click', function() {
			page.deleteProfile(profileData);
			return false;
		});
		if (!user.hasAdminPermission(AdminPermission.SuperAdmin)) {
			profile.find('.superadmin').remove();
		} else {
			profile.find('.copyToSite').on('click', function() {
				page.copyToSite(profileData);
				return false;
			});
		}

		return profile;
	};

	/**
	 * Lists the users who have a particular profile
	 * @param {object} profileData the data for the profile
	 */
	this.listUsers = function(profileData) {
		this.userList = null;
		$j('#permission_profile_editor, #permission_profile_user_list').remove();
		$j('#permission_profile_list').after(templates.get('user_list', { profileName : profileData.name }));
		// highlight the row
		$j('.permission_profile').removeClass('selected');
		$j('#profile_row_' + profileData.id).addClass('selected');

		this.loadUserList('&permissionProfile=' + profileData.id);
	};

	/**
	 * Loads the user list
	 * @param {string} params any additional parameters to send into the user list
	 */
	this.loadUserList = function(params) {
		var page = this;
		ajax('p=user_info' + params, function(response) {
			var userList = page.userList,
				userListConfig;
			if (!userList) {
				// insert data
				userListConfig = new ListConfig();
				userListConfig.addColumnList([
					new ListColumn('username', ['user avatar', 'username']),
					new ListColumn('plays', ['plays']),
					new ListColumn('downloads', ['downloads'])
				]);
				userListConfig.bankKey = 'users';
				userListConfig.emptyMessage = 'No authorized users found with this filter.<br/>There might be potential users who have yet to be authorized.';

				userList = page.userList = createUserList(userListConfig);
				userList.generatePage($j('#list_users')[0]);
			}
			userList.setData(response, function(params) {
				return '/admin?p=users&tab=profiles';
			}, function(params) {
				page.loadUserList(params);
				return false;
			});
			sa.scrollToElement($j('#permission_profile_user_list'));
		});
	};

	/**
	 * Starts the editing process
	 *    In order to edit, we need the main hierarchy loaded and the details for this specific profile
	 *  Since those are loaded separately, we make two ajax calls and neither of them does anything in callback unless the other has already completed
	 * @param {object} profileData the data for the profile
	 */
	this.editProfile = function(profileData) {
		let loadedState = false;
		$j('#permission_profile_editor, #permission_profile_user_list').remove();
		sa.api.request({
			handler : 'permission-profiles',
			action : 'getPermissionsForProfile',
			getData : {
				profileId : profileData.id,
				cache : new Date().getTime()
			}
		}).then(currentProfileState => {
			loadedState = true;
			page.currentProfileState = currentProfileState;
			if (page.hierarchy) {
				page.showEditor(profileData);
			} else {
				page.onHierarchy.push(function() { page.showEditor(profileData); });
			}
		});
		$j('#list_users').remove();
		this.userList = null;
		$j('.permission_profile').removeClass('selected');
		$j('#profile_row_' + profileData.id).addClass('selected');
		this.profileId = profileData.id;
	};

	/**
	 * Creates a new profile from an existing profile, adds it to the list, and throws it up in the editor
	 * @param {object} profileData the data of the profile to copy
	 */
	this.copyProfile = function (profileData) {
		const page = this;
		const waiter = new Waiter('Copying Filter. Please be patient.');
		sa.api.request({
			handler: 'permission-profiles',
			action: 'copy',
			postData: {
				profileId: profileData.id
			}
		}).then(copyProfile => {
			page.loadProfiles();
			page.editProfile(copyProfile);
			sa.components.permissionProfileSelectorController.resetPermissionProfileList();
		}).catch(err => {
			sa.alert(err.message);
		}).finally(() => {
			waiter.hide();
		});
	};

	/**
	 * Creates a new profile, adds it to the list, and throws it up in the editor
	 */
	this.newProfile = function() {
		var page = this,
			waiter = new Waiter('Creating new filter. Please be patient.');
		sa.api.request({
			handler : 'permission-profiles',
			action : 'createNew',
			postData : { create : 1 }
		}).then(newProfile => {
			page.loadProfiles();
			page.editProfile(newProfile);
			sa.components.permissionProfileSelectorController.resetPermissionProfileList();
		}).catch(err => {
			sa.alert(err.message)
		}).finally(() => {
			waiter.hide();
		});
	};

	/**
	 * Shows the editing interface and loads the hierarchy from the server
	 * @param {Object} profileData
	 */
	this.showEditor = function(profileData) {
		if ($j('#permission_profile_editor').length) return;
		var template = templates.get('editor');
		var catalogs = $j('#permission_profile_list').after(template).parent().find('#catalogs ul');
		
		// load the full hierarchy
		var f = function(hierarchy) {
			page.hierarchy = hierarchy;
			page.cleanState();
			// sort the catalogs
			var sortedCatalogs = [];
			for (var catalogId in hierarchy) {
				if (!hierarchy.hasOwnProperty(catalogId)) continue;
				hierarchy[catalogId].id = catalogId;
				sortedCatalogs.push(hierarchy[catalogId]);
			}
			sortedCatalogs.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			page.addBulkItem(catalogs, 'catalog');
			// add all the catalogs to the list
			for (var c = 0, cLen = sortedCatalogs.length; c < cLen; c++) {
				var cat = sortedCatalogs[c];
				page.addItem(catalogs, 'catalog', cat.id, cat.name);
			}
		};
		if (page.hierarchy) {
			f(page.hierarchy);
		} else {
			page.onHierarchy.push(function() { f(page.hierarchy); });
		}
		
		// metadata embedding profile selects
		ajax('p=metadata_downloading_profiles&action=listProfiles', function(profiles) {
			var select = template.find('select#metadata_profile');
			var selectHtml = select.html();
			for (var p = 0, pLen = profiles.length; p < pLen; p++) {
				var profile = profiles[p];
				selectHtml += '<option value="' + profile.id + '">' + profile.name + '</option>';
			}
			select.html(selectHtml);
			select.val(profileData['metadataProfileId']);
		});
		
		// save button
		template.find('.buttons .button').on('click', function() {
			page.saveChanges();
		});
		
		// populate name
		let profileNameElement = template.find('#profile_name');
		profileNameElement.val(profileData.name);
		profileNameElement.prop('disabled', !profileData['deletable']);

		// set up sync flags
		if (config.syncFlags.length) {
			let list = template.find('.sync_flag_list');
			for (let syncFlagName of config.syncFlags) {
				let syncFlagCheck = templates.get('sync_flag_selector', { name : syncFlagName });
				if (profileData.syncFlags.includes(syncFlagName)) {
					syncFlagCheck.find('input').prop('checked', true);
				}
				list.append(syncFlagCheck);
			}
		} else {
			template.find('.sync_flag_section').remove();
		}
		
		// set up additional options
		if (profileData.disableDownloadRequests) {
			template.find('input[name=disable_download_requests]').prop('checked', true);
		} else {
			template.find('input[name=disable_download_requests]').prop('checked', false);
		}

		// add optional pitch requests for licensee and network sites
		if (['buyer', 'network'].includes(config.siteType)) {
			template.find('input[name=allow_pitch_requests]').prop('checked', profileData.allowPitchRequests);
		} else {
			template.find('#allow_pitch_requests').remove()
		}
		
		sa.scrollToElement(template);
	};

	/**
	 * Adds a single item to the profile option selection columns
	 * @param {JQuery} container the list to which the item should be added
	 * @param {string} itemType the type of bulk item we're adding (catalog|label|album)
	 */
	this.addBulkItem = function (container, itemType) {
		var page = this,
			bulkType = {bulkType: itemType},
			item = templates.get('profile_editor_bulk', bulkType);
		
		item.find('a').on('click', function () {
			var itemType = $j(this).data('type'),
				stateType = $j(this).data('perm'),
				allow = $j(this).data('allow');
			page.bulkUpdateItemStates(itemType, stateType, allow);
		});
		
		container.append(item);
	}

	/**
	 * Adds a single item to the profile option selection columns
	 * @param {JQuery} container the list to which the item should be added
	 * @param {string} itemType the type of item we're adding (catalog|label|album)
	 * @param {int} itemId the id of the item we're adding
	 * @param {string} itemName the name to display as the item's label
	 */
	this.addItem = function(container, itemType, itemId, itemName) {
		var page = this,
			canView = this.currentProfileState['view'][itemType + 's'][itemId] != 0, // not set should be true
			canDownload = this.currentProfileState['download'][itemType + 's'][itemId] != 0, // not set should be true
			item = templates.get('profile_editor_option', {
				itemId : itemId,
				itemType : itemType,
				itemName : itemName
			});
		if (itemType == 'album') {
			item.find('.expander').remove();
		}
		if (canView) {
			setCheck(item.find('input[name=view]'), true);
		}
		if (canDownload) {
			setCheck(item.find('input[name=download]'), true);
		}
		item.find('input').on('click', function() {
			page.updateState(itemType, itemId, this.name, this.checked);
			//$j(this).parent().find('.span').empty();
		});
		item.find('.expander').on('click', function() {
			item.parent().find('.selected').removeClass('selected');
			item.addClass('selected');
			page.expandItem(itemType, itemId);
		});
		container.append(item);
		if (canView) {
			this.currentProfileState['view'][itemType + 's'][itemId] = 1;
		} else {
			this.currentProfileState['view'][itemType + 's'][itemId] = 0;
		}
		if (canDownload) {
			this.currentProfileState['download'][itemType + 's'][itemId] = 1;
		} else {
			this.currentProfileState['download'][itemType + 's'][itemId] = 0;
		}
		if (itemType == 'label') {
			this.determineLabelState('view', this.selectedCatalogId, itemId);
			this.determineCatalogState('view', this.selectedCatalogId);
			this.determineLabelState('download', this.selectedCatalogId, itemId);
			this.determineCatalogState('download', this.selectedCatalogId);
		} else if (itemType == 'catalog') {
			this.determineCatalogState('view', itemId);
			this.determineCatalogState('download', itemId);
		}
		//this.updateState(itemType, itemId, 'view', canView);
		//this.updateState(itemType, itemId, 'download', canDownload);
	};
	
	function setCheck(elem, checked) {
		return elem.prop('checked', !!checked);
	}

	/**
	* Bulk updates the stateType of each item of the clicked item type
	* @param {string} itemType (catalog|label|album)
	* @param {string} stateType (download|view)
	* @param {boolean} allow are we allowing the user to do stateType with this item or not?
	*/
	this.bulkUpdateItemStates = function (itemType, stateType, allow) {
		console.log('bulk update called with ' + itemType + ' ' + stateType + ' ' + allow);
		$j('.selector#' + itemType + 's ul li[id]').map(function () {	
			setCheck($j('#' + this.id + ' input[name=' + stateType + ']'), allow);
			return page.updateState(itemType, this.id.replace(itemType + '_', ''), stateType, allow);
		});
	};

	/**
	 * Saves the state of the current item into the cache and updates any descendent items
	 * @param {string} itemType (catalog|label|album)
	 * @param {int} itemId the id of the item in question
	 * @param {string} stateType (download|view)
	 * @param {boolean} allow are we allowing the user to do stateType with this item or not?
	 */
	this.updateState = function(itemType, itemId, stateType, allow) {
		console.log('update called with ' + itemType + ' ' + itemId + ' ' + stateType + ' ' + (allow ? 'allow' : 'disallow'));
		if (allow) {
			this.currentProfileState[stateType][itemType + 's'][itemId] = 1;
		} else {
			this.currentProfileState[stateType][itemType + 's'][itemId] = 0;
		}
		var labelId, albums, albumId;
		// need to propagate changes to subelements
		if (itemType == 'catalog') {
			var labels = this.hierarchy[itemId].labels;
			for (labelId in labels) {
				if (!labels.hasOwnProperty(labelId)) continue;
				// hit the checkboxes if they're there
				setCheck($j('#label_' + labelId + ' input[name=' + stateType + ']'), allow);
				
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				this.currentProfileState[stateType]['labels'][labelId] = allow ? 1 : 0;
				// now we need to update the albums for this label
				albums = labels[labelId].albums;
				for (albumId in albums) {
					if (!albums.hasOwnProperty(albumId)) continue;
					// hit the checkboxes if they're there
					setCheck($j('#album_' + albumId + ' input[name=' + stateType + ']'), allow);
					// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
					this.currentProfileState[stateType]['albums'][albumId] = allow ? 1 : 0;
				}
			}
			this.determineCatalogState(stateType, itemId);
			// update label states if we're showing this catalog
			if (this.selectedCatalogId == itemId) {
				for (labelId in this.hierarchy[itemId].labels) {
					if (!this.hierarchy[itemId].labels.hasOwnProperty(labelId)) continue;
					this.determineLabelState(stateType, itemId, labelId);
				}
			}
		} else if (itemType == 'label') {
			// we have to find the label in question
			albums = this.hierarchy[this.selectedCatalogId].labels[itemId].albums;
			for (albumId in albums) {
				if (!albums.hasOwnProperty(albumId)) continue;
				// hit the checkboxes if they're there
				setCheck($j('#album_' + albumId + ' input[name=' + stateType + ']'), allow);
				// update the stored states. if the checkboxes existed, this is redundant but we'll do it anyway. couldn't hurt
				this.currentProfileState[stateType]['albums'][albumId] = allow ? 1 : 0;
			}
			this.determineLabelState(stateType, this.selectedCatalogId, itemId);
			this.determineCatalogState(stateType, this.selectedCatalogId);
		} else if (itemType == 'album') {
			this.determineLabelState(stateType, this.selectedCatalogId, this.selectedLabelId);
			this.determineCatalogState(stateType, this.selectedCatalogId);
		}
		// if you uncheck view, you have to uncheck download
		if (stateType == 'view' && !allow) {
			if (setCheck($j('#' + itemType + '_' + itemId + ' input[name=download]:checked'), false).length) {
				this.updateState(itemType, itemId, 'download', false);
			}
		} else if (stateType == 'download' && allow) {
			// conversely, if you check download, it will automatically check view
			if (setCheck($j('#' + itemType + '_' + itemId + ' input[name=view]:not(:checked)'), true).length) {
				this.updateState(itemType, itemId, 'view', true);
			}
		}
		window['ps'] = this.currentProfileState;
	};

	/**
	 * Updates a specific catalog's display so it shows the correct number of labels and albums
	 * @param {string} stateType is this the view or download we're updating?
	 * @param {int} catalogId the id of the catalog
	 */
	this.determineCatalogState = function(stateType, catalogId) {
		// now we need to update the label's catalog to partial status based on the state of the labels within it
		var labels = this.hierarchy[catalogId].labels,
			labelTotal = 0,
			labelChecked = 0,
			albumTotal = 0,
			albumChecked = 0;
		for (var labelId in labels) {
			if (!labels.hasOwnProperty(labelId)) continue;
			if (this.currentProfileState[stateType].labels[labelId] != 0) labelChecked++;
			labelTotal++;
			for (var albumId in labels[labelId].albums) {
				if (!labels[labelId].albums.hasOwnProperty(albumId)) continue;
				if (this.currentProfileState[stateType].albums[albumId] != 0) albumChecked++;
				albumTotal++;
			}
		}
		$j('#catalog_' + catalogId + ' input[name=' + stateType + ']').parent().find('span').html('(' + labelChecked + '/' + labelTotal + ') (' + albumChecked + '/' + albumTotal + ')');
		this.currentProfileState[stateType].catalogs[catalogId] = (albumChecked + labelChecked == 0 ? 0 : (albumChecked < albumTotal || labelChecked < labelTotal) ? 2 : 1);
	};

	/**
	 * Updates a specific label's display so it shows the correct number of albums
	 * @param {string} stateType is this the view or download we're updating?
	 * @param {int} catalogId the id of the label's catalog
	 * @param {int} labelId the id of the label itself
	 */
	this.determineLabelState = function(stateType, catalogId, labelId) {
		// now we need to update the label to partial status based on the state of the albums within it
		var albums = this.hierarchy[catalogId].labels[labelId].albums,
			total = 0,
			checked = 0;
		for (var albumId in albums) {
			if (!albums.hasOwnProperty(albumId)) continue;
			if (this.currentProfileState[stateType].albums[albumId] != 0) checked++;
			total++;
		}
		$j('#label_' + labelId + ' input[name=' + stateType + ']').parent().find('span').html('(' + checked + '/' + total + ')');
		var labelChecked = (checked == 0 ? 0 : (checked < total) ? 2 : 1);
		if (!labelChecked && !total) {
			labelChecked = $j('#label_' + labelId + ' input[name=' + stateType + ']:checked').length;
		}
		this.currentProfileState[stateType].labels[labelId] = labelChecked;
	};

	/**
	 * Makes sure items are hierarchically excluded, meaning that if a catalog is excluded, all its labels and albums are
	 *  Saving will enforce this naturally but if an album is added through nefarious means, such as when adding a track, it won't get an exclusion row
	 *  if it's in an excluded label. That doesn't matter on most of the site but this interface requires those rows exist. We need to make sure that those albums are excluded here.
	 * @param {string} stateType (view|download) don't specify and it'll do both
	 */
	this.cleanState = function(stateType) {
		if (!stateType) {
			this.cleanState('view');
			stateType = 'download';
		}
		// go through each catalog in the hierarchy
		for (var catalogId in this.hierarchy) {
			if (!this.hierarchy.hasOwnProperty(catalogId)) continue;
			var catalog = this.hierarchy[catalogId];
			var labelId, lab, albumId;
			// see if the entire catalog is excluded
			if (this.currentProfileState[stateType].catalogs[catalogId] === 0) {
				// make sure all sub-items are excluded
				for (labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					lab = catalog.labels[labelId];
					this.currentProfileState[stateType].labels[labelId] = 0;
					for (albumId in lab.albums) {
						if (!lab.albums.hasOwnProperty(albumId)) continue;
						this.currentProfileState[stateType].albums[albumId] = 0;
					}
				}
			} else {
				// check the labels
				for (labelId in catalog.labels) {
					if (!catalog.labels.hasOwnProperty(labelId)) continue;
					if (this.currentProfileState[stateType].labels[labelId] === 0) {
						// label is excluded. make sure albums are too
						lab = catalog.labels[labelId];
						for (albumId in lab.albums) {
							if (!lab.albums.hasOwnProperty(albumId)) continue;
							this.currentProfileState[stateType].albums[albumId] = 0;
						}
					}
				}
			}
		}
	};

	/**
	 * Shows descendents of itemId, potentially loading them off the server
	 * @param {string} itemType (catalog|label). albums have no descendents we care about
	 * @param {int} itemId the id of the item whose descendents we're interested in
	 */
	this.expandItem = function(itemType, itemId) {
		var page = this,
			newType = (itemType == 'catalog' ? 'label' : 'album'),
			cont = $j('.selector#' + newType + 's ul');
		cont.find('li').remove();
		if (itemType == 'catalog') {
			this.selectedCatalogId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var labels = this.hierarchy[itemId].labels;
			// sort
			var sortedLabels = [];
			for (var labelId in labels) {
				if (!labels.hasOwnProperty(labelId)) continue;
				labels[labelId].id = labelId;
				sortedLabels.push(labels[labelId]);
			}
			sortedLabels.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			page.addBulkItem(cont, newType);
			// add all the catalogs to the list
			for (var labelIndex = 0, sortLabelsLen = sortedLabels.length; labelIndex < sortLabelsLen; labelIndex++) {
				var lab = sortedLabels[labelIndex];
				page.addItem(cont, newType, lab.id, lab.name);
			}
			// we have to empty the albums if this changes
			$j('.selector#albums ul').find('li').remove().end().append('<li class="empty">Select a label to see albums</li>');
		} else {
			this.selectedLabelId = itemId;
			// we already have all the labels. we just need to go through the hierarchy to find the correct ones
			var albums = this.hierarchy[this.selectedCatalogId].labels[itemId].albums;
			// sort
			var sortedAlbums = [];
			for (var albumId in albums) {
				if (!albums.hasOwnProperty(albumId)) continue;
				sortedAlbums.push({ name : albums[albumId], id : albumId });
			}
			sortedAlbums.sort(function(a, b) {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}
				return 1;
			});
			page.addBulkItem(cont, newType);
			// add all the catalogs to the list
			for (var albumIndex = 0, sortAlbumsLen = sortedAlbums.length; albumIndex < sortAlbumsLen; albumIndex++) {
				var alb = sortedAlbums[albumIndex];
				page.addItem(cont, newType, alb.id, alb.name);
			}
		}
	};

	/**
	 * Saves the changes to the currently opened profile
	 */
	this.saveChanges = function() {
		var profileJson = { catalogs : {}, labels : {}, albums : {} },
			profileName = $j('#profile_name').val(),
			metadataProfile = $j('#metadata_profile').val(),
			disableDownloadRequests = $j('input[name=disable_download_requests]:checked').length ? 1 : 0,
			allowPitchRequests = $j('input[name=allow_pitch_requests]:checked').length ? 1 : 0,
			syncFlags = $j('.sync_flag input:checked').map(function(index, input) { return input.value; }).toArray(),
			profileState = this.currentProfileState,
			waiter = new Waiter('Saving... Please be patient. This can take a lot of crunching.');
		// the server expects an array of data like $catalogs[catalogId]='d'; where the entries sent are the ones to deny permission for
		for (var stateType in profileState) {
			if (!profileState.hasOwnProperty(stateType)) continue;
			for (var itemType in profileState[stateType]) {
				if (!profileState[stateType].hasOwnProperty(itemType)) continue;
				for (var itemId in profileState[stateType][itemType]) {
					if (!profileState[stateType][itemType].hasOwnProperty(itemId)) continue;
					if (profileState[stateType][itemType][itemId] == 0) {
						if (!profileJson[itemType][itemId]) {
							profileJson[itemType][itemId] = [stateType.substring(0, 1)];
						} else {
							profileJson[itemType][itemId].push(stateType.substring(0, 1));
						}
					}
				}
			}
		}
		sa.api.request({
			handler : 'permission-profiles',
			action : 'saveChanges',
			postData : {
				profileId : this.profileId,
				name : profileName,
				metadataProfile : metadataProfile,
				state : JSON.stringify(profileJson),
				syncFlags : syncFlags,
				disableDownloadRequests: disableDownloadRequests,
				allowPitchRequests: allowPitchRequests
			}
		}).then(newProfile => {
			sa.notify({ text : 'Changes saved!' });
			$j('#permission_profile_editor').remove();
			page.loadProfiles();
			sa.components.permissionProfileSelectorController.resetPermissionProfileList();
		}).catch(err => {
			sa.alert(err.message);
			$j('.buttons').show();
			$j('.saving_notice').remove();
		}).finally(() => {
			waiter.hide();
		});
		$j('.buttons').hide();//.after('<div class="section saving_notice">Saving... Please be patient. This can take a lot of crunching.</div>');
	};

	/**
	 * Deletes a profile after making sure the user knows what they're doing
	 * @param {object} profileData the info for the profile to delete
	 */
	this.deleteProfile = function(profileData) {
		var page = this;
		sa.confirm({
			text : 'Are you sure you want to delete "' + profileData.name + '"? Any users previously assigned this profile will lose access to it. If this was their only profile, they will revert to Default Logged In.',
			yesFunction : function() {
				var waiter = new Waiter('Deleting filter. This may take a minute. Please be patient.');
				sa.api.request({
					handler : 'permission-profiles',
					action : 'delete',
					postData : {
						profileId : profileData.id
					}
				}).then(() => {
					sa.notify({ text : 'Music access filter deleted!' });
					$j('#permission_profile_editor').remove();
					page.loadProfiles();
					sa.components.permissionProfileSelectorController.resetPermissionProfileList();
				}).catch(e => {
					sa.alert(e.message);
				}).finally(() => {
					waiter.hide();
				});
			},
			yesText : 'Delete'
		});

	};
	
	/**
	 * Copies the profile to a different site (superadmin only)
	 * @param {object} profileData the info for the profile to delete
	 */
	this.copyToSite = function(profileData) {
		if (!user.hasAdminPermission(AdminPermission.SuperAdmin)) { // should really happen anyway. we've already hid the button. real security will happen in PHP
			sa.alert('You do not have permission to copy profiles to other workspaces.');
			return;
		}
		var page = this;
		sa.api.request({
			handler: 'permission-profiles',
			action: 'getSiteList'
		}).then(sites => {
			const $profileSiteCopier = templates.get('profile_site_copier', { profileId: profileData.id});
			$profileSiteCopier.find('#profile_site_copier_name').val(profileData.name);
			let siteOptions = '<option selected></option>';
			/** @var {{id:int, name:string}} site */
			for (let site of sites) {
				siteOptions += `<option value="${site.id}">${site.name} (${site.id})</option>`;
			}
			$profileSiteCopier.find('select').html(siteOptions);
			sa.forms.init($profileSiteCopier);
			const fb = sa.showFocusBox($profileSiteCopier, {
				title: 'Copy MAF to Another Workspace',
				showClose: true
			});
			$profileSiteCopier.find('.confirm_no').on('click', () => fb.hide());
			$profileSiteCopier.find('.confirm_yes').on('click', () => {
				const postData = sa.forms.validate($profileSiteCopier).values;
				if (!postData.site.id) {
					fb.showErrorMessage('Select a destination workspace');
					return;
				}
				postData.site = postData.site.id;
				fb.showLoader('Copying');
				sa.api.request({
					handler: 'permission-profiles',
					action: 'copyToSite',
					postData: postData
				}).then(() => {
					sa.notify({ text: 'MAF copied!' });
					fb.hide();
				}).catch(e => {
					sa.alert(e.message);
					fb.hideLoader();
				});
			});
		}).catch(e => {
			sa.alert(e.message);
		});
	};
}

AdminPermissionProfiles.CreateNewProfileOnLoad = false;
AdminPermissionProfiles.LoadProfileOnLoad = false;
/**
 * The page in the admin panel that lets you create/edit admin roles
 */
function AdminRoles() {

	var page = this;
	var permissions;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.users.roles');
		}
		if (!user.hasAdminPermission(AdminPermission.Admins)) {
			container.empty().append(templates.get('permission_denied', { description : user.getAdminPermissionDescription(AdminPermission.Admins) }));
			return;
		}
		var vars = sa.router.paramsToVars(params);
		if (vars.profile) {
			console.log('found profile ' + vars.profile);
			// see if we're already on the user search page
			if ($j('#permission_profile_editor').length) { console.log('returning'); return; }
			this.loadProfile = vars.profile;
		}
		container.empty().append(templates.get('base'));
		container.find('#new_role').on('click', function() {
			newRole();
		});
		loadRoles();
	};

	function loadRoles() {
		sa.api.request({
			handler : 'admin-roles',
			action : 'list'
		}).then(response => {
			let list = $j('.admin_roles');

			list.find('.admin_role').remove();
			list.append(templates.get('admin_role', { roleId : 0, name : 'Full Admins' }));
			list.find('.edit').remove();
			list.find('.delete').remove();
			list.find('.list').on('click', function() { listUsers({ id : 0, name : 'Full Admins' }); });

			const permissionMap = {
				'settings': 'Change Settings',
				'contentid_claims': 'Manage Content ID Claims/Whitelist',
				'custom_pages': 'Edit Home Page/Custom Pages',
				'feature': 'Feature Content/Publish Playlists',
				'file_delivery': 'Use the File Delivery Tool',
				'users': 'Manage Users',
				'admins': 'Manage Admins',
				'statistics': 'View Statistics',
				'buyers': 'Manage Music Suppliers &amp; Briefs',
				'metadata': 'Edit Metadata and Add and Delete Tracks',
				'licensing': 'Manage Licensing',
				'pando': 'View Add-Ons and Programs',
				'automated_metadata': 'Manage AI Tagging',
				'sharing': 'Send and Embed Tracks &amp; Manage Comments'
			}
			
			permissions = [];
			for (const permissionKey of response.permissions) {
				const permissionDisplay = permissionMap[permissionKey];
				if (permissionDisplay) { // exclude permissions that don't have a translation (usually still in dev)
					permissions.push({ key : permissionKey, display : permissionDisplay });
				}
			}
			permissions.sort(function(a, b) { return a.display < b.display ? -1 : 1; });

			for (let role of response.roles) {
				let roleTemplate = templates.get('admin_role', { roleId : role.id, name : role.name });

				roleTemplate.find('.edit, .name').on('click', function() { editRole(role); });
				roleTemplate.find('.list').on('click', function() { listUsers(role); });
				roleTemplate.find('.delete').on('click', function() { deleteRole(role); });

				list.append(roleTemplate);
			}

			list.find('.admin_role:odd').addClass('stripe');
		});
	}

	/**
	 * Lists the users who have a particular profile
	 * @param {object} roleData the data for the profile
	 */
	function listUsers(roleData) {
		var list = templates.get('user_list', { name : roleData.name });
		page.userList = null;
		$j('#role_editor, #role_user_list').remove();
		$j('#role_list').append(list);
		// highlight the row
		$j('.admin_role.selected').removeClass('selected');
		$j('#role_' + roleData.id).addClass('selected');

		loadUserList('&roleId=' + roleData.id);

		sa.scrollToElement(list);
	}

	/**
	 * Loads the user list
	 * @param {string} params any additional parameters to send into the user list
	 */
	function loadUserList(params) {
		ajax('p=user_info' + params, function(response) {
			var userList = page.userList,
				userListConfig;
			if (!userList) {
				// insert data
				userListConfig = new ListConfig();
				userListConfig.addColumnList([
					new ListColumn('username', ['user avatar', 'edit_user']),
					new ListColumn('plays', ['plays']),
					new ListColumn('downloads', ['downloads'])
				]);
				userListConfig.bankKey = 'users';
				userListConfig.emptyMessage = 'No users found with this role.';

				userList = page.userList = createUserList(userListConfig);
				userList.generatePage($j('#list_users')[0]);
			}
			userList.setData(response, function() { return '/admin?p=users&tab=roles'; }, function(params) { loadUserList(params); return false;});
		});
	}

	/**
	 * Starts the editing process
	 * 	In order to edit, we need the main hierarchy loaded and the details for this specific profile
	 *  Since those are loaded separately, we make two ajax calls and neither of them does anything in callback unless the other has already completed
	 * @param {object} roleData the data for the profile
	 * 	@property {int} id
	 * 	@property {string} name
	 * 	@property {Array.<string>} permissions
	 */
	function editRole(roleData) {
		$j('#role_editor, #role_user_list').remove();
		$j('.admin_role').removeClass('selected');
		$j('#role_' + roleData.id).addClass('selected');

		let editor = templates.get('role_editor');
		let roleNameInput = editor.find('#role_name').val(roleData.name);

		// add permissions
		var permissionsContainer = editor.find('.permissions');
		for (var i = 0, len = permissions.length; i < len; i++) {
			var perm = permissions[i];
			var permTemplate = templates.get('role_permission', { key : perm.key, display : perm.display });
			if (roleData.permissions.indexOf(perm.key) != -1) {
				permTemplate.find('input').prop('checked', true);
			}
			permissionsContainer.append(permTemplate);
		}

		// save button
		editor.find('.button').on('click', function() {
			sa.api.request({
				handler : 'admin-roles',
				action : 'updateRole',
				postData : {
					id : roleData.id,
					name : roleNameInput.val(),
					permissions : $j('input[type=checkbox][name=permission]:checked').map((i, perm) => perm.value).get()
				}
			}).catch(err => {
				sa.notify({ text : err.message });
			}).then(r => {
				sa.notify({ text : 'Changes saved!', type : sa.notify.notificationTypes.success });
				loadRoles();
				$j('#role_editor, #role_user_list').remove();
				sa.scrollToElement($j('.admin_roles'));
			});
		});

		$j('#role_list').after(editor);

		sa.scrollToElement(editor);
	}

	/**
	 * Creates a new profile, adds it to the list, and throws it up in the editor
	 */
	function newRole() {

		sa.api.request({
			handler : 'admin-roles',
			action : 'createRole'
		}).catch(err => {
			sa.notify({ text : err.message });
		}).then(newRole => {
			editRole(newRole);
		});
	}

	/**
	 * Deletes a profile after making sure the user knows what they're doing
	 * @param {Object} roleData the info for the profile to delete
	 */
	function deleteRole(roleData) {
		sa.confirm({
			text : 'Are you sure you want to delete "' + roleData.name + '"? Any users previously assigned this role will revert to full permissions.',
			yesFunction : function() {
				sa.api.request({
					handler : 'admin-roles',
					action : 'deleteRole',
					postData : {
						id : roleData.id,
					}
				}).catch(err => {
					sa.notify({ text : err.message });
				}).then(r => {
					sa.notify({ text : 'Role deleted!', type : sa.notify.notificationTypes.success });
					$j('#role_editor, #role_user_list').remove();
					loadRoles();
				});
			},
			yesText : 'Delete'
		});

	}
}
/**
 * A page in the admin panel
 */
function AdminWorksRegistration() {
	/**
	 * {string} the name of the tab we're showing
	 */
	this.currentTab = '';

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		if (!user.hasAdminPermission(AdminPermission.WorksRegistration)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Edit Metadata and Add and Delete Tracks' + '" permission.</h3>');
		}
		var page = this;
		if (!$j('.right_body .addons').length) {
			var callback = function(tabId, cont) { page.setPage(tabId, cont); };
			var tabs = [
				new RightTab('status', '/admin?p=works_registration&tab=status', 'Status', callback),
				new RightTab('register', '/admin?p=works_registration&tab=register', 'Register Works', callback),
				new RightTab('people', '/admin?p=metadata&tab=people', 'Interested Parties', callback),
				new RightTab('help', '/admin?p=works_registration&tab=help', 'Help &amp; Glossary', callback)
			];
			RightTabbedPage.prototype.show.call(page, 'works_registration', container, tabs, '');
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.tab) vars.tab = 'status';
		page.setTab(vars.tab);
	};

	/**
	 * Changes what page the admin is showing
	 * @param {string} pageId the type of item to load
	 * @param {JQuery} container where to put the information for the list
	 */
	this.setPage = function(pageId, container) {
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (this.currentTab == pageId) {
			this.currentPage.show(sa.router.getCurrentQueryParams());
			return;
		}
		this.currentTab = pageId;
		// and then if we found it, have it load based on the current params
		switch (pageId) {
			case 'status':
				(new AdminWorksRegistrationStatus()).show('', container);
				break;
			case 'register':
				(new AdminWorksRegistrationRegister()).show('', container);
				break;
			case 'help':
				(new AdminWorksRegistrationHelp()).show('', container);
				break;
			case 'people':
				(new BusinessManagerPeople()).show('', container);
			break;
		}
	};
}
AdminWorksRegistration.prototype = new RightTabbedPage();

AdminWorksRegistration.getSubscriptionStatus = function(callback) {
	ajax({
		p : 'works_registration',
		action : 'getSubscriptionStatus'
	}, function(response) {
		callback(response.subscribed, response);
	});
};

function AdminWorksRegistrationHelp() {
	
	var page = this;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.works_registration.help');
		}
		container.empty().append(templates.get('page'));
	};
}

function AdminWorksRegistrationRegister() {

	var templates;

	/**
	 * Sets up the basic framework of the page and its objectsg
	 * @param {string} params the parameters from the url
	 * @param container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.works_registration.register');
		}

		AdminWorksRegistration.getSubscriptionStatus(function(subscribed) {

			if (!subscribed) {

				sa.router.routeTo('/admin?p=works_registration&tab=status');

			} else {

				let vars = sa.router.getCurrentParamsAsObject();

				if (vars['action'] == 'showSelections') {

					AdminWorksRegistrationRegister.showSelections(container, templates);

				} else if (vars['action'] == 'showAffiliations') {

					AdminWorksRegistrationRegister.showAffiliations(container, templates, vars['key']);

				} else if (vars['action'] == 'showValidation') {

					AdminWorksRegistrationRegister.showValidation(container, templates, vars['key'], vars['pg']);

				} else {

					showSubscribed(container);

				}

			}
		});
	};

	/**
	 * Shows basic information about how this works and invites the user to begin selecting
	 * @param container
	 */
	function showSubscribed(container) {

		var template = templates.get('subscribed_page');

		template.find('#get_started').on('click', function() {

			AdminWorksRegistrationRegister.startSelecting(true);

		});

		// video popup
		template.find('video').on('click', function() {
			var content = templates.get('select_example_popup');
			var fb;

			content.find('.button').on('click', function() {
				fb.hide();
			});

			fb = new FocusBox(content, { title : 'Works Registration Selection Example' });
			fb.show();
		});

		container.empty().append(template);

	}

}

AdminWorksRegistrationRegister.showErrors = function(template, response) {

	template.find('#loading').remove();

	// show the user any errors
	if (response.errors.length) {

		var errorContainer = template.find('#errors');
		var errorList = errorContainer.find('.error_list');
		var errorTemplate = errorList.find('.error').detach();

		response.errors.each(function(i, error) {
			errorList.append(errorTemplate.clone().html(error));
		});

		errorContainer.show();

	}

	// some errors disallow continuing
	if (response['fatalError']) {

		template.find('#continue').remove();

	}

};

(function() {

	/**
	 * Lets the user choose to which PROs they want to submit
	 * @param container
	 * @param templates
	 * @param {string} key
	 */
	AdminWorksRegistrationRegister.showAffiliations = function(container, templates, key) {

		var template = templates.get('affiliations_page');
		var selectedAffiliationSection = template.find('#selected_affiliations');
		var selectedAffiliationList = selectedAffiliationSection.find('.list');
		var selectedAffiliationTemplate = selectedAffiliationList.find('.affiliation').detach();

		var selectedAffiliations = [];

		// it's important to have a loader because all this loading and checking might take a minute
		showLoader(template.find('#loading'), 'Loading supported societies list...');

		/** @var {{ affiliations : array, selectedAffiliations : array }} response **/
		ajax({ key : key }, function(response) {

			AdminWorksRegistrationRegister.showErrors(template, response);

			if (response.errors.length) return;

			// populate the affiliation selector and country filter
			var affiliationSelect = template.find('#affiliations');
			var countrySelect = template.find('#countries');
			var affiliations = {};
			var countries = {};
			response.affiliations.each(function(i, affiliation) {
				affiliations[affiliation.name] = '<option value="' + i + '">' + affiliation.name + ' - ' + affiliation.country + '</option>';
				if (!countries[affiliation.country]) {
					countries[affiliation.country] = [ i ];
				} else {
					countries[affiliation.country].push(i);
				}
			});

			var affiliationString = '';
			Object.keys(affiliations).sort().each(function(i, affiliationName) {
				affiliationString += affiliations[affiliationName];
			});
			affiliationSelect.html(affiliationString);

			var countryString = '<option value="-1">All countries</option>';
			Object.keys(countries).sort().each(function(i, countryName) {
				countryString += '<option value="' + countries[countryName].join(',') + '">' + countryName + '</option>';
			});
			countrySelect.html(countryString);

			// let the user add new affiliations
			template.find('#add_affiliation').on('click', function() {
				var affiliationId = affiliationSelect.val();
				if (affiliationId == '-1') {
					sa.alert('Choose a society before clicking the Add button');
					return;
				}
				selectAffiliation(template, response.affiliations[affiliationId]);
			});

			// add the current selections
			response.selectedAffiliations.each(function(i, affiliation) {
				selectAffiliation(template, affiliation);
			});

			// make the country filter work
			countrySelect.on('change', function() {
				var affiliationValues = countrySelect.val();
				affiliationSelect.html(affiliationString);
				if (affiliationValues != '-1') {
					affiliationSelect.find('option:not([value=' + affiliationValues.split(',').join(']):not([value=') + '])').remove();
				}
			});

			sa.forms.init(template);

			template.find('#affiliation_selector').show();

			// buttons
			template.find('#options').show();
			template.find('#continue').on('click', function() {
				ajax({ key : key, affiliations : selectedAffiliations }, function(response) {
					if (response.errors.length) {
						sa.alert(response.errors[0]);
					} else {
						sa.router.routeTo('/admin?p=works_registration&tab=register&action=showValidation&key=' + key);
					}
				}, 'POST', { p : 'works_registration', action : 'saveAffiliations' });
			});

		}, 'POST', { p : 'works_registration', action : 'loadSupportedAffiliations' });

		container.empty().append(template);

		/**
		 * Adds a new affiliation to the selected
		 * @param container
		 * @param affiliation
		 */
		function selectAffiliation(container, affiliation) {

			if (selectedAffiliations.indexOf(affiliation.id) !== -1) return;
			selectedAffiliations.push(affiliation.id);

			selectedAffiliationSection.show();
			container.find('#continue').removeClass('hidden');

			var sat = selectedAffiliationTemplate.clone();
			sat.find('.name').html(affiliation.name + ' - ' + affiliation.country);
			sat.find('.remove').on('click', function() {
				sat.remove();
				selectedAffiliations.splice(selectedAffiliations.indexOf(affiliation.id), 1);

				if (!selectedAffiliationList[0].childNodes.length) {
					selectedAffiliationSection.hide();
					container.find('#continue').addClass('hidden');
				}
			});

			selectedAffiliationList.append(sat);
		}

	};
	
})();

(function() {
	
	var selections = {};

	function getSelections() {
		return selections;
	}

	function setSelections(newSelections) {
		selections = newSelections;
	}

	function resetSelections() {
		selections = {};
	}

	/**
	 * Tells the selector to start allowing selections
	 * @param {boolean=} reset 
	 */
	AdminWorksRegistrationRegister.startSelecting = function(reset) {
		
		if (reset) {
			resetSelections();
		}

		sa.components.selector.initializeItems($j(), {
			action : function(finalSelected) {
				console.log('final selected', finalSelected);
				setSelections(finalSelected);
				sa.router.routeTo('/admin?p=works_registration&tab=register&action=showSelections');
			},
			buttonSection : 'works_registration_buttons',
			change : function(newSelected) {
				console.log('new selected', newSelected);
			},
			dragging: false,
			key : 'works_registration',
			persistent : true,
			selectAlbums : true,
			selectArtists : true,
			selectCatalogs : true,
			selectLabels : true,
			selectTracks : true,
			showContainerWhenEmpty : true
		});

		sa.components.selector.setSelected(getSelections());

		sa.router.routeTo('/');

	};
	
	AdminWorksRegistrationRegister.showSelections = function(container, templates) {

		// TODO: should check here if the selector is still active and end it in case the user hits back to get here

		var template = templates.get('selection_page');

		// it's important to have a loader because all this loading and checking might take a minute
		showLoader(template.find('#loading'), 'Looking for tracks in your selections...');

		ajax(getSelections(), function(response) {

			AdminWorksRegistrationRegister.showErrors(template, response);

			template.find('#continue').attr('href', '/admin?p=works_registration&tab=register&action=showAffiliations&key=' + response.key);

			// show the user information about what they selected
			if (response.trackCount) {

				template.find('#track_count').html(response.trackCount.numberFormat());

				template.find('#tracks').show();

			}

			// the other buttons just restart the selection process
			template.find('#select_more').on('click', function() {
				AdminWorksRegistrationRegister.startSelecting();
			});
			template.find('#select_start_over').on('click', function() {
				AdminWorksRegistrationRegister.startSelecting(true);
			});

			template.find('#options').show();

		}, 'POST', { p : 'works_registration', action : 'convertSelections' });

		container.empty().append(template);
		
	};
	
})();

(function() {

	/**
	 * This step ensures the tracks the user selected have all the data required to be registered
	 * @param container
	 * @param templates
	 * @param {string} key
	 * @param {int} currentPage
	 */
	AdminWorksRegistrationRegister.showValidation = function(container, templates, key, currentPage) {

		var template = templates.get('validation_page', { key : key });

		// it's important to have a loader because all this loading and checking might take a minute
		showLoader(template.find('#loading'), 'Validating your track information...');

		/** @var {{ errors : string[], trackErrors : Array, page : int, totalTrackErrors : int, totalPages : int, perPage : int }} response */
		ajax({ key : key, currentPage : currentPage }, function(response) {

			AdminWorksRegistrationRegister.showErrors(template, response);

			if (!response.errors.length && response.trackErrors.length) {

				var trackErrorListContainer = template.find('#track_error_list');
				var trackErrorRowTemplate = trackErrorListContainer.find('.track_error').detach();

				template.find('#track_errors .track_count').html(response.totalTrackErrors.numberFormat());

				// when the user fixes a track error, it calls this function to actually save the data and update the page
				function saveTrackChange(trackId, field, value) {
					sa.showCover('Saving changes...');
					ajax({ field : field, value : value }, function(trackChangeResponse) {
						sa.hideCover();
						if (!trackChangeResponse.length) {
							sa.alert({ text : 'Unable to save. Please reload and try again' });
						} else if (trackChangeResponse[0].result != 'success') {
							sa.alert({ text : trackChangeResponse[0].result });
						} else {
							AdminWorksRegistrationRegister.showValidation(container, templates, key, currentPage);
						}
					}, 'POST', { p : 'track_details', t : trackId });
				}

				// enumerate all the track errors
				/** @var {{ errors : string[], track : Track }} trackError */
				response.trackErrors.each(function(i, trackError) {

					// go through all the tracks and organize their errors
					var formattedErrors = [];
					Object.keys(trackError.errors).each(function(j, errorField) {
						formattedErrors.push(trackError.errors[errorField]);
					});

					// build the error row template
					var trackErrorRow = trackErrorRowTemplate.clone();
					trackErrorRow.find('.track_id').html(trackError.track.id);
					trackErrorRow.find('.track_title').html(trackError.track.title).attr('href', '/track/' + trackError.track.id);
					trackErrorRow.find('.track_problem').html(formattedErrors.join('<br/>'));

					// the options for each track depend on fields that need fixing
					var trackOptionsContainer = trackErrorRow.find('.track_options');
					Object.keys(trackError.errors).each(function(i, field) {
						var buttonText = '';
						var buttonCallback = function() {};
						if (field == 'publishers') {
							buttonText = 'Fix Publishers';
							buttonCallback = function() {
								sa.pages.details.showInterestedPartyEditor(trackError.track.publishers, 'publisher', function(newPublishers) {
									saveTrackChange(trackError.track.id, 'publishers', newPublishers);
								});
							};
						} else if (field == 'writers') {
							buttonText = 'Fix Writers';
							buttonCallback = function() {
								sa.pages.details.showInterestedPartyEditor(trackError.track.writers, 'writer', function(newWriters) {
									saveTrackChange(trackError.track.id, 'writers', newWriters);
								}, trackError.track.publishers);
							};
						}
						if (buttonText) {
							trackOptionsContainer.append($j('<a class="button">' + buttonText + '</a>').on('click', buttonCallback));
						}
					});

					// or, if they don't want to fix it, let them just cancel the registration for this track
					trackOptionsContainer.append($j('<a class="button deemphasized">Remove Track</a>').on('click', function() {
						ajax({ key : key, trackId : trackError.track.id }, function() {
							AdminWorksRegistrationRegister.showValidation(container, templates, key, currentPage);
							sa.notify({ type : sa.notify.notificationTypes.success, text : 'Removed track from registration' });
						}, 'POST', { p : 'works_registration', action : 'removeSelection' });
					}));

					trackErrorListContainer.append(trackErrorRow);
				});

				template.find('#track_errors').show();

				sa.pagination.addPagination({ container : template.find('.pagination_container'), currentPage : response.currentPage, totalPages : response.totalPages, callback : function(newPage) {
					AdminWorksRegistrationRegister.showValidation(container, templates, key, newPage);
				}});

			} else {
				
				// show all the tracks that are going to be new registrations
				showNewRegistrations(key, template, 0);
				
				// show all the tracks that will be revisions to registrations
				showRevisedRegistrations(key, template, 0);
				
				// show the affiliations for confirmation
				var affiliationNames = [];
				response.affiliations.each(function(i, affiliation) {
					affiliationNames.push(affiliation.name);
				});
				affiliationNames.push('and ' + affiliationNames.pop());
				template.find('.final_notice .societies').html(affiliationNames.join(affiliationNames > 2 ? ', ' : ' '));
				template.find('.final_notice').removeClass('hidden');
				
				// let the users continue
				template.find('#continue').removeClass('hidden').on('click', function() {
					ajax({ key : key }, function(submitResponse) {
						
					}, 'POST', { p : 'works_registration', action : 'submit' });
					return false;
				});

			}

			// buttons
			template.find('#options').show();

		}, 'POST', { p : 'works_registration', action : 'validateTrackData' });

		container.empty().append(template);
		
	};

	/**
	 * Shows the tracks that will be new registrations
	 * @param {string} key
	 * @param template
	 * @param {int} currentPage
	 */
	function showNewRegistrations(key, template, currentPage) {

		// show all the tracks that are going to be new registrations
		/** @var {{ tracks : Array, totalTracks : Number, currentPage : Number, totalPages : Number }} tracksResponse */
		ajax({ key : key, currentPage : currentPage }, function(tracksResponse) {

			var registrationsContainer = template.find('#new_registrations');
			
			if (!tracksResponse.tracks.length) {
				registrationsContainer.hide();
				return;
			}

			var trackListContainer = registrationsContainer.find('#track_data_list');
			var trackRowTemplate = trackListContainer.find('.track_datum').detach();

			registrationsContainer.find('.track_count').html(tracksResponse.totalTracks.numberFormat());

			// enumerate all the tracks
			tracksResponse.tracks.each(function(i, track) {

				// build the error row template
				var trackRow = trackRowTemplate.clone();
				trackRow.find('.track_id').html(track.id);
				trackRow.find('.track_title').html(track.title).attr('href', '/track/' + track.id);

				// let them add an iswc
				var trackOptionsContainer = trackRow.find('.track_options');

				// or, if they don't want to fix it, let them just cancel the registration for this track
				trackOptionsContainer.append($j('<a class="button deemphasized">Remove Track</a>').on('click', function() {
					ajax({ key : key, trackId : track.id }, function() {
						showNewRegistrations(key, template, currentPage);
						sa.notify({ type : sa.notify.notificationTypes.success, text : 'Removed track from registration' });
					}, 'POST', { p : 'works_registration', action : 'removeSelection' });
				}));

				trackListContainer.append(trackRow);
			});

			registrationsContainer.show();

			sa.pagination.addPagination({ container : registrationsContainer.find('.pagination_container'), currentPage : tracksResponse.currentPage, totalPages : tracksResponse.totalPages, callback : function(newPage) {
				showNewRegistrations(key, template, newPage);
			}});

		}, 'POST', { p : 'works_registration', action : 'getNewRegistrationTrackData'});
		
	}

	/**
	 * Shows the tracks that will be new registrations
	 * @param {string} key
	 * @param template
	 * @param {int} currentPage
	 */
	function showRevisedRegistrations(key, template, currentPage) {

		// show all the tracks that are going to be new registrations
		/** @var {{ tracks : Array, totalTracks : Number, currentPage : Number, totalPages : Number }} tracksResponse */
		ajax({ key : key, currentPage : currentPage }, function(tracksResponse) {

			var registrationsContainer = template.find('#registration_updates');

			if (!tracksResponse.tracks.length) {
				registrationsContainer.hide();
				return;
			}

			var trackListContainer = registrationsContainer.find('#track_data_list');
			var trackRowTemplate = trackListContainer.find('.track_datum').detach();

			registrationsContainer.find('.track_count').html(tracksResponse.totalTracks.numberFormat());

			// enumerate all the tracks
			tracksResponse.tracks.each(function(i, track) {

				// build the error row template
				var trackRow = trackRowTemplate.clone();
				trackRow.find('.track_id').html(track.id);
				trackRow.find('.track_title').html(track.title).attr('href', '/track/' + track.id);
				trackRow.find('.track_iswc').html(track.iswc);
				
				// let them just cancel the registration for this track
				var trackOptionsContainer = trackRow.find('.track_options');
				trackOptionsContainer.append($j('<a class="button deemphasized">Remove Track</a>').on('click', function() {
					ajax({ key : key, trackId : track.id }, function() {
						showNewRegistrations(key, template, currentPage);
						sa.notify({ type : sa.notify.notificationTypes.success, text : 'Removed track from registration' });
					}, 'POST', { p : 'works_registration', action : 'removeSelection' });
				}));

				trackListContainer.append(trackRow);
			});

			registrationsContainer.show();

			sa.pagination.addPagination({ container : registrationsContainer.find('.pagination_container'), currentPage : tracksResponse.currentPage, totalPages : tracksResponse.totalPages, callback : function(newPage) {
				showNewRegistrations(key, template, newPage);
			}});

		}, 'POST', { p : 'works_registration', action : 'getRevisedRegistrationTrackData'});

	}
	
})();

function AdminWorksRegistrationStatus() {
	
	var page = this;
	var templates;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param container
	 */
	this.show = function(params, container) {
		if (!templates) {
			templates = sa.templates.get('admin.works_registration.status');
		}

		AdminWorksRegistration.getSubscriptionStatus(function(subscribed, subscriptionDetails) {
			
			if (!subscribed) {

				showUnsubscribed(container, subscriptionDetails);
				
			} else {
				
				showSubscribed(container);
				
			}
		});
	};
	
	function showUnsubscribed(container, subscriptionDetails) {
		
		var template = templates.get('unsubscribed_page', {
			percentage : Math.floor(subscriptionDetails['percentage'] * 100) + '%',
			trackCount : subscriptionDetails['trackCount'].numberFormat(),
			monthlyHosting : subscriptionDetails['monthlyHosting'].moneyFormat(),
			monthlyRate : subscriptionDetails['monthlyRate'].moneyFormat(),
			signupPrice : subscriptionDetails['signupPrice'].moneyFormat()
		});
		
		if (user.isSiteOwner()) {
			
			template.find('.not_site_owner').remove();

			template.find('#subscribe').on('click', function() {
				sa.components.billing.addAddon('worksRegistration', function(agreed) {
					if (agreed) {
						sa.router.reloadPage();
					}
				});
			});
			
		} else {
			
			template.find('.site_owner').remove();

			sa.getSiteOwner(function(ownerInformation) {
				if (ownerInformation) {
					template.find('.so_cont .name').html(ownerInformation.username);
					template.find('.so_cont .email').html(ownerInformation.email);
					template.find('.so_cont .no_owner').remove();
				} else {
					template.find('.so_cont .has_owner').remove();
				}
			});
			
		}
		
		container.empty().append(template);
		
	}
	
	function showSubscribed(container) {
		
		var template = templates.get('subscribed_page');

		if (user.isSiteOwner()) {
			
			template.find('#unsubscribe').on('click', function() {
				sa.components.billing.removeAddon('worksRegistration', function(agreed) {
					if (agreed) {
						sa.router.reloadPage();
					}
				});
			});
			
		} else {
			
			template.find('.site_owner').remove();
			
		}
		
		/** @var {{ registrations : array }} response **/
		ajax({ p : 'works_registration', action : 'getRegistrations', page : 0, limit : 10 }, function(response) {

			template.find('.loading_registrations').hide();
			
			if (!response.registrations.length) {
				
				template.find('.no_registrations').show();
				
			} else {
				
				template.find('.registrations').show();
				
			}
			
		});
		
		container.empty().append(template);
		
	}
}
/**
 * The business manager container that gives users access to all the pages of the business manager
 * @returns {BusinessManager}
 */
function BusinessManager() {
	/**
	 * {Page} The object that's the current page being shown in the admin
	 */
	this.currentPage = null;
	/**
	 * {string} the type of page we're showing
	 */
	this.currentPageType = '';
	
	this.name = 'business_manager';

	/**
	 * Shows the admin
	 */
	this.show = function(params) {
		if (!user.logged || !user.hasAdminPermission(AdminPermission.Any)) {
			// business manager is only accessible to logged in users
			setTimeout(function() { 
				sa.router.routeTo(sa.router.pathConversionLookup(config.home));
			}, 250);
			sa.notify({ text : $j('<span>The business manager is only accessible to ' + (user.logged ? 'admin users.' : 'logged in users. Did you mean to <a href="' + getLoginLink() + '">Log In</a>?') + '</span>') });
			return;
		}
		if (sa.getCurrentPageName() != this.name) {
			// reset vars
			this.currentPage = null;
			this.currentPageType = '';
			// call the left tabbed page initialization method
			var page = this,
				setPage = function(tabId, cont) { page.setPage(tabId, cont); },
				tabs = [];
			tabs.push(new LeftTab('overview', '/business?p=overview', setPage, 'Overview', 'fa-sitemap', '', false));
			tabs.push(new LeftTab('people', '/business?p=people', setPage, 'People &amp; Companies', 'fa-user', '', false));
			tabs.push(new LeftTab('tasks', '/business?p=tasks', setPage, 'Tasks', 'fa-check-square-o', '', false));
			
			LeftTabbedPage.prototype.show.call(this,
				'business_manager',
				tabs,
				[{
					name: 'Business Manager', 
					href: '/business' 
				}, { 
					name: 'Admin', 
					href: '/admin' 
				}, { 
					name: 'Dashboard', 
					href: '/dashboard' 
			}],
				[ ]
			);
			sa.currentPage = this;
		}
		// determine which tab should be active and set it as such
		var vars = sa.router.paramsToVars(params);
		if (!vars.p) {
			// determine what tab to show
			for (var i = 0, len = tabs.length; i < len; i++) {
				if (!tabs[i].disabled) {
					vars.p = tabs[i].id;
					break;
				}
			}
		}
		this.setTab(vars.p);
	};

	/**
	 * Changes what page the admin is showing
	 */
	this.setPage = function(pageId, container) {
		console.log('business manager set page:', pageId);
		// if they're on the current page already, we don't want to create a new object. just give its show the new params
		if (this.currentPageType == pageId) {
			this.currentPage.show(sa.router.getCurrentQueryParams(), container);
			return;
		}
		// they were on a different page so we need to find the correct page object
		var page = null;
		switch (pageId) {
			case 'overview':
				page = new BusinessManagerOverview();
				break;
			case 'people':
				page = new BusinessManagerPeople();
				break;
			case 'tasks':
				page = new BusinessManagerTasks();
				break;
		}
		// and then if we found it, have it load based on the current params
		if (page) {
			page.show(sa.router.getCurrentQueryParams(), container);
		} else {
			console.log('page not found:', pageId);
			container.html('Daskboard says ' + pageId);
		}
	};
}
BusinessManager.prototype = new LeftTabbedPage();
/**
 * The page in the business manager that gives you a hint of what all's going on
 */
function BusinessManagerOverview() {

	var page = this;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		// make sure they're secure
		if (!user.hasAdminPermission(AdminPermission.Any)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Edit Metadata and Add and Delete Tracks' + '" permission.</h3>');
		}
		container.html('').addClass('bm_overview');
		
		var vars = sa.router.getCurrentParamsAsObject();
		if (vars.action == 'new') {
			showPersonForm(container);
		} else if (vars.action == 'edit') {
			showPersonForm(container, vars.personId);
		} else if (vars.action == 'import') {
			showImportForm(container, vars.importId, vars.stage);
		} else {
			showOverview(container);
		}
	};
	
	function showOverview(container) {
		container.html('this is the overview');
	}
	
}
BusinessManagerOverview.prototype = new RightTabbedPage();
/**
 * The page in the business manager that lets you manage your interested parties
 */
function BusinessManagerPeople() {

	var page = this,
		templates = sa.templates.get('business_manager.people'),
		personTemplate,
		noteUploader,
		listFields = null;

	/**
	 * Sets up the basic framework of the page and its objects
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function (params, container) {
		let vars = sa.router.getCurrentParamsAsObject();
		container.html('').addClass('admin_people');
		if (vars.action == 'new') {
			showPersonForm(container, 0, vars.company == '1');
		} else if (vars.action == 'details') {
			showPersonDetails(container, vars.personId);
		} else if (vars.action == 'edit') {
			// redirect edit page to the main admin interested parties page
			sa.router.routeTo('/admin?p=metadata&tab=people');
		} else if (vars.action == 'import') {
			showImportForm(container, vars.importId, vars.stage, vars.type);
		} else if (vars.action == 'manage_custom_fields') {
			showCustomFieldManager(container, vars.source);
		} else {
			createListLayout(container, vars);
			listPeople(container, vars);
		}
	};

	////////////////////////
	// List
	////////////////////////

	function createListLayout(container, vars) {
		var template = templates.get('list');

		// batch importing with the Add Multiple button
		new Uploader({ button : template.find('.import'), browseCallback : function(uploader) {

			var addSection = template.find('.add_section');

			addSection.find('.import').hide();
			addSection.find('.importing').show();
			addSection.find('.importing_error').hide();

			// make an upload id for this upload
			var importId = new Date().getTime() + '' + config.id + '' + user.userData.id;

			uploader.upload({
				params : 't=people_import&importId=' + importId,
				complete : function() {
					sa.router.routeTo('/admin?p=metadata&tab=people&action=import&importId=' + importId + '&stage=columns&type=add');
				},
				error : function() {
					addSection.find('.import').show();
					addSection.find('.importing').hide();
					addSection.find('.importing_error').show();
				}
			});

		}, fileType : UploaderConstants.CSV });

		// affiliation visibility management
		if (config.siteType === 'network' || config.siteType === 'buyer') {
			template.find('.select_affiliations').on('click', function () {
				let manager = templates.get('affiliation_visibility_manager');
				let listContainer = manager.find('.affiliation_list');
				let fb = new FocusBox(manager, { title : 'Manage PRO Visibility' });

				sa.api.request({
					handler : 'affiliationExclusions',
					action : 'getAffiliationExclusions'
				}).then(affiliations => {
					listContainer.empty();
					for (let affiliation of affiliations) {
						let affiliationElement = templates.get('affiliation', {
							affiliationId : affiliation.id,
							affiliationName : affiliation.name
						})
						if (affiliation.excluded) {
							affiliationElement.find('input').prop('checked', true);
						}
						listContainer.append(affiliationElement);
					}
				});

				manager.find('.confirm_yes').on('click', function () {
					fb.showLoader('Saving changes...');
					let postData = { exclusions: [] };
					for (let input of listContainer.find('input:checked')) {
						postData.exclusions.push(input.value);
					}
					sa.api.request({
						handler : 'affiliationExclusions',
						action : 'saveAffiliationExclusions',
						postData : postData
					}).then(() => {
						fb.hide();
						sa.alert('Changes saved! It may take some time to process your exclusions.');
					}).catch(err => {
						fb.hideLoader();
						sa.alert(err.message);
					});
				});

				manager.find('.confirm_no').on('click', function () {
					fb.hide();
				});

				manager.find('#affiliation_search').on('input', function() {
					let val = this.value.trim().toLowerCase();
					listContainer.find('.affiliation.hidden').removeClass('hidden');
					if (val) {
						listContainer.find('.affiliation').each(function () {
							if (this.dataset.name.toLowerCase().indexOf(val) === -1) {
								this.className = 'affiliation hidden';
							}
						});
					}
				});

				fb.show();

			});
		} else {
			template.find('.affiliation_visibility_section').remove();
		}

		// batch updating with the Update Multiple button
		new Uploader({ button : template.find('.update'), browseCallback : function(uploader) {

			var editSection = template.find('.edit_section');

			editSection.find('.update').hide();
			editSection.find('.importing').show();
			editSection.find('.importing_error').hide();

			// make an upload id for this upload
			var importId = new Date().getTime() + '' + config.id + '' + user.userData.id;

			uploader.upload({
				params : 't=people_import&importId=' + importId,
				complete : function() {
					sa.router.routeTo('/admin?p=metadata&tab=people&action=import&importId=' + importId + '&stage=columns&type=update');
				},
				error : function() {
					editSection.find('.update').show();
					editSection.find('.importing').hide();
					editSection.find('.importing_error').show();
				}
			});

		}, fileType : UploaderConstants.CSV });

		// exporting (uses the current list)
		template.find('.export').on('click', function() {
			document.location.href = 'export.php?type=people' + getFilterParamString(container);
		});

		// add writer/publisher
		template.find('.new_writer').on('click', function(e) {
			e.preventDefault();
			sa.components.itemEditInterface.show({ type:'writer', title: 'Add New ' + gde('writer')});
			return false;
		})
		template.find('.new_publisher').on('click', function(e) {
			e.preventDefault();
			sa.components.itemEditInterface.show({ type:'publisher', title: 'Add New ' + gde('publisher') });
			return false;
		})

		// filters
		template.find('.search input[name=people_search]').on('keyup', function(e) {
			if (e.keyCode == 13) {
				filterPeople(container, 0);
			}
		});

		// filter on press enter in search box
		template.find('.search input.person_search').on('keypress', function(e) {
			if(e.which == 13) {
				filterPeople(container, 0);
			}
		})
		template.find('.filter').on('click', function() {
			filterPeople(container, 0);
		});
		// set up checkbox interactions
		template.find('.search input[type=radio]').on('click', function() {
			$j(this).parents('.search_group').find('input[type=checkbox]').prop('checked', false);
		});
		template.find('.search input[type=checkbox]').on('click', function() {
			var group = $j(this).parents('.search_group');
			if (group.find('input[type=checkbox]:checked').length) {
				group.find('input[type=radio]').prop('checked', false);
			} else {
				group.find('input[type=radio]').prop('checked', true);
			}
		});
		// add current filter values
		if (vars.search) {
			template.find('.search input[name=search]').val(vars.search);
		}
		if (vars['role[]']) {
			var roles = vars['role[]'];
			for (let i = 0, len = roles.length; i < len; i++) {
				template.find('.search .roles input[type=checkbox][value=' + roles[i] + ']').trigger('click');
			}
		}
		if (vars['partyType[]']) {
			var types = vars['partyType[]'];
			for (let i = 0, len = types.length; i < len; i++) {
				template.find('.search .types input[type=checkbox][value=' + types[i] + ']').trigger('click');
			}
		}

		container.empty().append(template);
	}

	function getFilterParamString(container) {
		var params = sa.forms.validate(container.find('.search')).values;

		return (params.search ? '&search=' + encodeURIComponent(params.search) : '')
			+ (params.role && params.role.length && params.role[0] != 'all' ? '&role[]=' + params.role.join('&role[]=') : '')
			+ (params.partyType && params.partyType.length && params.partyType[0] != 'all' ? '&partyType[]=' + params.partyType.join('&partyType[]=') : '');
	}

	function filterPeople(container, page) {
		sa.router.routeTo('/admin?p=metadata&tab=people' + getFilterParamString(container) + (page ? '&pg=' + page : ''), null, true);
	}

	function listPeople(container, vars) {
		// set up the list
		var personList = container.find('.person_list');
		if (!personTemplate) {
			personTemplate = personList.find('.person').clone();
		}
		personList.find('.person').remove();
		personList.find('.hidden').hide();

		// get some data!
		vars.action = 'list';
		vars.p = 'people';

		ajax(vars, function(response) {
			var metadata = response.metadata,
				people = response.people;

			if (!people.length) {
				return personList.find('.hidden').show();
			}

			for (var i = 0, len = people.length; i < len; i++) {
				var personData = people[i],
					person = personTemplate.clone();

				person.find('.name').html(personData.name);

				if (personData.isCompany) {
					person.find('.person_field').remove();
				} else {
					person.find('.company_field').remove();
				}
				if (personData.groups.length) {
					var groups = [];
					for (var g = 0, gLen = personData.groups.length; g < gLen; g++) {
						groups.push(personData.groups[g].name);
					}
					person.find('.groups').html(groups.join(', '));
				} else {
					person.find('.groups').remove();
				}
				if (personData.image) {
					person.find('.type_icon .art').html('<img src="' + personData.image + '" alt=""/>');
				}

				person.find('.link').attr('href', 'admin?p=metadata&tab=people&action=details&personId=' + personData.id);

				person.find('.delete').on('click', function(personData) { return function() {
					sa.confirm({
						text : 'Are you sure you want to delete ' + personData.name + '?<br/>This is <b>not undoable</b> and will remove them from <b>all tracks</b>.',
						yesFunction : function() {
							ajax({ personId : personData.id }, function(response) {
								listPeople(container, vars);
								sa.notify({ text : 'Interested Party removed.' });
							}, 'POST', 'p=people&action=delete');
						},
						yesText : 'Delete'
					});
				}; }(personData));

				personList.append(person);
			}

			personList.find('.person:odd').addClass('stripe');

			if (metadata.totalPages > 1) {
				sa.pagination.addPagination({
					container : personList,
					currentPage : metadata.currentPage,
					totalPages : metadata.totalPages,
					callback : function(pageNumber) {
						sa.scrollToElement($j('.admin_people'));
						filterPeople(container, pageNumber);
					}
				});
			}

			// deleting (uses the current list)
			container.find('.delete').off('click').on('click', function() {
				sa.confirm({
					text : 'This will <b>permanently delete</b> these interested parties and remove them from all tracks. Are you sure?',
					yesText : 'Delete',
					noText : 'Cancel',
					yesFunction : function() {
						showLoader(container.find('.bm_left'), 'Deleting...', true);
						ajax({ nonce : metadata['deleteNonce'] }, function() {
							sa.notify({ text : 'Interested parties deleted', type : sa.notify.notificationTypes.success });
							let currentPath = sa.router.getCurrentPath(true);
							if (currentPath.includes('admin?p=metadata&tab=people')) {
								sa.router.reloadPage();
							} else {
								sa.router.routeTo('/admin?p=metadata&tab=people');
							}
						}, 'POST', 'p=people&action=deleteMultiple' + getFilterParamString(container));
					}
				})
			});

		});
	}



	////////////////////////////
	// Person Details
	///////////////////////////

	function showPersonDetails(container, personId) {

		personId = parseInt(personId);
		if (isNaN(personId)) personId = 0;

		if (!personId) {
			//console.log('cannot show person details without a person id');
			return sa.router.routeTo('/admin?p=metadata&tab=people');
		}

		ajax({ p : 'people', personId : personId, action : 'details' }, function(response) {

			let person = response[0];
			if (person.error) {
				sa.router.routeTo('/admin?p=metadata&tab=people');
				return sa.notify({ text : person.message });
			}

			var template = templates.get('person_details', { id : personId }),
				company = person.isCompany,
				name = company ? person.company : [ person.firstName, person.lastName ].join(' ');

			// set up the notes (we do this first so the field removes don't break notes)
			var noteTemplateMaster = template.find('.note').clone();
			template.find('.note').remove();

			// add all the fields
			template.find('.name').html(name);

			if (company) {
				template.find('.person_field').remove();
			} else {
				template.find('.company_field').remove();
				if (person.company) {
					template.find('.company').html(person.company);
				} else {
					template.find('.company').remove();
					template.find('.title_and_company').remove();
				}
				if (person.title) {
					template.find('.company_title').html(person.title);
				} else {
					template.find('.company_title').remove();
					template.find('.title_and_company').remove();
				}
			}

			// art
			if (person.image) {
				template.find('.type_icon .art').html('<img src="' + person.image + '"/>');
			}

			if (person.groups.length) {
				var groupOnPage = template.find('.group').parents('.field'),
				groupMasterTemplate = groupOnPage.clone(),
				groupContainer = template.find('.group_list');
				groupOnPage.remove();
				for (let e = 0, eLen = person.groups.length; e < eLen; e++) {
					let group = person.groups[e];
					let groupTemplate = groupMasterTemplate.clone();
					groupTemplate.find('.group').html(group.name).attr('href', 'admin?p=metadata&tab=people&group=' + group.id);
					if (e > 0) {
						groupTemplate.find('.title').empty();
					}
					groupContainer.append(groupTemplate);
				}
			} else {
				template.find('.group_list').remove();
			}

			if (person.emails.length) {
				var emailOnPage = template.find('.email').parents('.field'),
					emailMasterTemplate = emailOnPage.clone(),
					emailContainer = template.find('.email_list');
				emailOnPage.remove();
				for (let e = 0, eLen = person.emails.length; e < eLen; e++) {
					let email = person.emails[e];
					let emailTemplate = emailMasterTemplate.clone();
					emailTemplate.find('.email').attr('href', 'mailto:' + email.email).html(email.email);
					emailTemplate.find('.email_type').html(email.type);
					if (e > 0) {
						emailTemplate.find('.title').empty();
					}
					emailContainer.append(emailTemplate);
				}
			} else {
				template.find('.email_list').remove();
			}

			if (person.phones.length) {
				var phoneOnPage = template.find('.phone').parents('.field'),
					phoneMasterTemplate = phoneOnPage.clone(),
					phoneContainer = template.find('.phone_list');
				phoneOnPage.remove();
				for (let e = 0, eLen = person.phones.length; e < eLen; e++) {
					let phone = person.phones[e];
					let phoneTemplate = phoneMasterTemplate.clone();
					phoneTemplate.find('.phone').html(phone.number);
					phoneTemplate.find('.phone_type').html(phone.type);
					if (e > 0) {
						phoneTemplate.find('.title').empty();
					}
					phoneContainer.append(phoneTemplate);
				}
			} else {
				template.find('.phone_list').remove();
			}

			if (person.addresses.length) {
				var addressOnPage = template.find('.address').parents('.field'),
					addressMasterTemplate = addressOnPage.clone(),
					addressContainer = template.find('.address_list');
				addressOnPage.remove();
				for (let e = 0, eLen = person.addresses.length; e < eLen; e++) {
					let address = person.addresses[e];
					let addressTemplate = addressMasterTemplate.clone();
					let addressString = '';
					if (address.address) {
						addressString += address.address + '<br/>';
					}
					if (address.city) {
						addressString += address.city;
						if (address.state) {
							addressString += ', ';
						}
					}
					if (address.state) {
						addressString += address.state;
					}
					if (address.zip) {
						addressString += ' ' + address.zip;
					}
					if (address.country) {
						if (addressString.length) {
							addressString += '<br/>';
						}
						addressString += address.country;
					}
					addressTemplate.find('.address').attr('href', 'https://www.google.com/maps/place/' + encodeURIComponent(addressString.replace(/,|<br\/>/g, ' ').replace(/ +/g, ' '))).html(addressString);
					addressTemplate.find('.address_type').html(address.type);
					if (e > 0) {
						addressTemplate.find('.title').empty();
					}
					addressContainer.append(addressTemplate);
				}
			} else {
				template.find('.address_list').remove();
			}

			if (person.affiliation.id != 0) {
				template.find('.affiliation').html(person.affiliation.name);
				if (person.affiliationNumber && person.affiliationNumber != '0') {
					template.find('.affiliationNumber').html(' (' + person.affiliationNumber + ')');
				}
			} else {
				template.find('.affiliation').parents('.field').remove();
			}

			if (person.ipi && person.ipi != '') {
				template.find('.ipi').html(person.ipi);
			} else {
				template.find('.ipi').parents('.field').remove();
			}

			if (person.ssn && person.ssn != '0') {
				template.find('.ssn').html(person.ssn);
			} else {
				template.find('.ssn').parents('.field').remove();
			}

			if (person.twitter) {
				template.find('.twitter').attr('href', 'https://twitter.com/' + person.twitter).html('@' + person.twitter).attr('title', '@' + person.twitter);
			} else {
				template.find('.twitter').parents('.field').remove();
			}

			if (person.facebook) {
				template.find('.facebook').attr('href', person.facebook).html(person.facebook).attr('title', person.facebook);
			} else {
				template.find('.facebook').parents('.field').remove();
			}

			if (person.linkedin) {
				template.find('.linkedin').attr('href', person.linkedin).html(person.linkedin).attr('title', person.linkedin);
			} else {
				template.find('.linkedin').parents('.field').remove();
			}

			if (person.customFields.length) {
				var customOnPage = template.find('.custom_field'),
					customMasterTemplate = customOnPage.clone(),
					customContainer = template.find('.custom_field_list');
				customOnPage.remove();
				for (var e = 0, eLen = person.customFields.length; e < eLen; e++) {
					var custom = person.customFields[e],
						customTemplate = customMasterTemplate.clone();
					customTemplate.find('.name').html(custom.name);
					customTemplate.find('.value').html(custom.value);
					customContainer.append(customTemplate);
				}
			} else {
				template.find('.custom_field_list').remove();
			}

			if (person.description) {
				template.find('.description').html(person.description.replace(/\n/g, '<br/>'));
			} else {
				template.find('.description').parents('.field').remove();
			}

			// add notes
			if (person.notes && person.notes.length) {

				let noteContainer = template.find('.note_list');
				let fileContainerTemplateMaster = templates.get('note_attachments');
				let fileTemplateMaster = fileContainerTemplateMaster.find('.attached_file').clone();
				fileContainerTemplateMaster.find('.attached_file').remove();
				for (let n = 0, nLen = person.notes.length; n < nLen; n++) {

					var note = person.notes[n],
						noteTemplate = noteTemplateMaster.clone();

					noteTemplate.find('.avatar img').attr('src', note.avatar);
					noteTemplate.find('.name').html(note.userId == user.userData.id ? 'You' : note.username);
					noteTemplate.find('.person_link').html(name).attr('href', sa.router.getCurrentPath(true));
					noteTemplate.find('.note_text').html(note.content);
					noteTemplate.find('.date_added').html(formatDate(config.dateTimeFormatString, note.date));

					noteTemplate.find('.delete').click(function(note, person) { return function() {
						sa.confirm({
							text : 'Are you sure you want to delete this note and all its files?',
							yesFunction : function() {
								ajax({ personId : person.id, noteId : note.id }, function(response) {
									showPersonDetails(container, personId);
								}, 'POST', { p : 'people', action : 'delete_note' });
							},
							yesText : 'Delete'
						});
					}; }(note, person));

					if (note.files.length) {

						var fileContainerTemplate = fileContainerTemplateMaster.clone();

						for (var f = 0, fLen = note.files.length; f < fLen; f++) {
							var file = note.files[f],
								fileTemplate = fileTemplateMaster.clone();

							fileTemplate.find('.filename').text(StringSanitize.decodeString(file.filename, true));
							fileTemplate.find('.filesize').html('(' + file.size.sizeFormat() + ')');
							fileTemplate.find('.filetype').addClass(getIconClass(file.filename));
							fileTemplate.find('.remove').remove();
							fileTemplate.find('.file_link').attr('href', 'https://' + config.domain + '/download.php?peopleNoteFileId='
								+ file.id + '&personId=' + person.id + '&noteId=' + note.id);

							fileContainerTemplate.append(fileTemplate);
						}

						noteTemplate.find('.files').append(fileContainerTemplate);

					}

					noteContainer.append(noteTemplate);

				}
			} else {
				template.find('.note_history').remove();
			}

			// add interactivity
			template.find('.show_info').on('click', function() {
				$j(this).hide();
				template.find('.hide_info').show();
				template.find('.info').slideDown();
			});

			template.find('.hide_info').on('click', function() {
				$j(this).hide();
				template.find('.show_info').show();
				template.find('.info').slideUp();
			});
			template.find('.options_icon').on('click', function() {
				var options = $j(this).parents('.note').find('.options');
				if (options.filter(':visible').length) {
					options.stop(true).slideUp();
				} else {
					options.stop(true).slideDown();
				}
			});
			enablePersonManagement(template, person, company);

			template.find('.add_note').on('click', function() {
				saveNote(container, personId);
			});

			container.empty().append(template);

			noteUploader = new Uploader({
				button: template.find('.browse'),
				allowMultiple: true,
				browseCallback: function (uploader) {
					refreshFileList();
				},
				fileType: UploaderConstants.NOTES
			});

			sa.components.edad.addGenericDropZone({
				allowedExtensions: ['mp3', 'aif', 'aiff', 'wav', 'xls', 'xlsx', 'doc', 'docx', 'txt', 'pdf', 'zip', 'csv'],
				anchorSelector: '.person_details .new_note',
				templateSelector: 'people_add_note_drop_zone',
				uniqueKey: 'people_add_note_drop_zone',
				dropCallback(files) {
					noteUploader.addFiles(files);
				}
			});

		});
	}

	/**
	 * Updates the attached file list for a new note
	 */
	function refreshFileList() {
		if (!noteUploader) return;

		var fileContainer = $j('.new_note .files'),
			files = noteUploader.getFileDetails(),
			template = templates.get('note_attachments'),
			fileTemplateMaster = template.find('.attached_file').clone();

		fileContainer.empty();

		if (!files.length) {
			return;
		}

		template.empty();

		for (let f = 0, fLen = files.length; f < fLen; f++) {

			var file = files[f],
				fileTemplate = fileTemplateMaster.clone();

			if (file.size > 300 * 1024 * 1024) {
				sa.notify({ text : 'Files must be 300MB or smaller. Please use a smaller file and try again.' });
				noteUploader.removeFile(file.id);
				return refreshFileList();
			}

			fileTemplate.find('.filename').text(StringSanitize.decodeString(file.name, true));
			fileTemplate.find('.filesize').html('(' + file.size.sizeFormat() + ')');
			fileTemplate.find('.filetype').addClass(getIconClass(file.name));
			fileTemplate.find('.remove').on('click', function (file) {
				return function () {
					noteUploader.removeFile(file.id);
					refreshFileList();
				};
			}(file));

			template.append(fileTemplate);

		}

		fileContainer.append(template);

	}

	/**
	 * Returns an appropriate font awesome icon class for the given file based on its extension
	 * @param {string} filename
	 * @return {string} class name
	 */
	function getIconClass(filename) {
		var extension = filename.split('.').pop().toLowerCase();
		if (extension == 'doc' || extension == 'docx' || extension == 'txt') {
			return 'fa-file-word-o';
		}
		if (extension == 'xls' || extension == 'xlsx' || extension == 'csv') {
			return 'fa-file-excel-o';
		}
		if (extension == 'pdf') {
			return 'fa-file-pdf-o';
		}
		if (extension == 'mp3' || extension == 'aif' || extension == 'aiff' || extension == 'wav') {
			return 'fa-file-audio-o';
		}
		if (extension == 'zip') {
			return 'fa-file-archive-o';
		}
		console.warn('unable to determine file type for', filename);
		return 'fa-file-code-o';
	}

	/**
	 * Saves the new note, recursively uploading all the files
	 */
	function saveNote(container, personId) {
		// make sure they said something
		var noteText = $j('.new_note textarea[name=new_note]').val().trim();
		if (!noteText.length) {
			$j('.new_note .error').show();
			return;
		} else {
			$j('.new_note .error').hide();
		}

		// disable all input so they can't add anything else while we're saving
		$j('.new_note .save_cover').show();

		// save the note text so we can get a note id to which to attach the files (if any)
		ajax({ personId : personId, noteText : noteText }, function(response) {
			response = response[0];
			if (response.error) {
				sa.notify({ text : response.message });
				$j('.new_note .save_cover').hide();
				return;
			}
			// recursively save the files
			uploadNoteFiles(response.noteId, 0, container, personId);
		}, 'POST', { p : 'people', action : 'add_note' });
	}

	function uploadNoteFiles(noteId, fileIndex, container, personId) {
		var files = noteUploader.getFileDetails();

		if (fileIndex >= files.length) {
			// we're done!
			setUploading(false);
			// throw a confirmation
			showPersonDetails(container, personId);
			// reload the notes and create a new new form
			return sa.notify({ text : 'Note saved!' });
		}
		setUploading(true);
		// find the progress bar
		var progressBarContainer = $j(container.find('.new_note .attached_file').get(fileIndex)),
			progressBar = progressBarContainer.find('.progress_bar');
		// upload the given file
		noteUploader.upload({
			params : 't=person_note_attachment&noteId=' + noteId,
			complete : function() {
				progressBar.css({ right : 0 });
				uploadNoteFiles(noteId, fileIndex + 1, container, personId);
			},
			progress : function(e, bytesLoaded, bytesTotal) {
				var fullWidth = progressBarContainer.width(); // you could cache this but it won't handle window resizing
				progressBar.css({ right : fullWidth - fullWidth * bytesLoaded / bytesTotal });
			},
			error : function() {
				sa.notify({ text : 'There was an error uploading ' + files[fileIndex].name });
				progressBar.css({ right : '100%' });
				uploadNoteFiles(noteId, fileIndex + 1, container, personId);
			},
			fileId : files[fileIndex].id,
			forceSourceAudioServer : true
		});
	}

	function setUploading(isUploading) {
		if (isUploading) {
			unloadFunctions = [function() {
				if (confirm('Leaving this page will abort any in-progress uploads. Are you sure you want to leave?')) {
					unloadFunctions = [];
					return false;
				}
				return true;
			}];
			window.onbeforeunload = function() {
				return 'Leaving the page will abort any in-progress uploads.';
			};
		} else {
			window.onbeforeunload = null;
			unloadFunctions = [];
		}
	}

	function enablePersonManagement(template, person, isCompany) {
		var personId = person.id;
		template.find('.edit_link').on('click', function(e) {
			e.preventDefault();
			sa.components.itemEditInterface.show({type: person.isCompany ? 'publisher' : 'writer', item: person });
			return false;
		})
		template.find('.delete_link').on('click', function() {

			sa.confirm({
				text: 'Are you sure you want to delete this person/company? This will remove all their information, all notes, attached files, and tasks associated with them, and will remove them from all tracks.',
				yesFunction: function () {
					showLoader(template[0], 'Deleting...', true)
					ajax({personId: personId}, function (response) {
						sa.notify({ text : (isCompany ? 'Company' : 'Person') + ' deleted' });
						sa.router.routeTo('/admin?p=metadata&tab=people');
					}, 'POST', {p: 'people', action: 'delete'});
				},
				yesText: 'Delete'
			});
		});
		template.find('.merge_link').on('click', function() {
			var mergeTool = templates.get('person_merger');
			mergeTool.find(isCompany ? '.writers_fields' : '.publishers_fields').remove();

			sa.forms.init(mergeTool);

			mergeTool.find('.confirm_no').on('click', function() {
				fb.hide();
			});
			mergeTool.find('.confirm_yes').on('click', function() {
				var validationResult = sa.forms.validate(mergeTool);
				if (!validationResult.error) {
					fb.showLoader('Processing request');
					var newPersonId = validationResult.values.recipientInterestedParty.id;
					ajax({ oldPersonId : person.id, newPersonId : newPersonId }, function(response) {
						if (response[0].error) {
							fb.hideLoader();
							fb.showErrorMessage(response[0].message);
						} else {
							fb.hide();
							sa.notify({ text : 'Interested parties merged successfully! It might take a few minutes for your changes to appear.', type : sa.notify.notificationTypes.success });
							sa.router.routeTo('/admin?p=metadata&tab=people&action=details&personId=' + newPersonId);
						}
					}, 'POST', { p : 'people', action : 'merge' });
				}
			});

			var fb = new FocusBox(mergeTool, {
				title : 'Merge Interested Parties'
			});
			fb.show();
		});
		template.find('.details_link').attr('href', 'admin?p=metadata&tab=people&action=details&personId=' + personId);
		template.find('.' + (isCompany ? 'person' : 'company') + '_field_right').remove();
		template.find('.list_people').attr('href', 'admin?p=metadata&tab=people&action=list&company=' + personId);
		template.find('.add_task').on('click', function() {
			BusinessManagerTasks.NewTask(person);
		});
		template.find('.add_note_shortcut').on('click', function() {
			sa.scrollToElement($j('.new_note'));
			$j('textarea[name=new_note]').trigger('focus');
		});
	}



	////////////////////////////
	// Person Editing
	////////////////////////////

	function showPersonForm(container, personId, newIsCompany) {
		personId = parseInt(personId);
		if (isNaN(personId)) personId = 0;

		let template = templates.get('person_form', { id : personId });
		let skipGroupSelectize = false;

		showLoader(template, 'Loading details');

		if (!listFields) {
			return loadListFields(function() { showPersonForm(container, personId, newIsCompany); });
		}

		function populateListFields(template) {
			var select = template.find('select[name=affiliation]');
			var optionString = select.html();
			for (var a = 0, aLen = listFields.affiliations.length; a < aLen; a++) {
				var affiliation = listFields.affiliations[a];
				optionString += '<option value="' + affiliation.id + '">' + affiliation.name + '</option>';
			}
			select.html(optionString);
		}

		// load the person, if there is one. if not, hide the right column because it's all edit-related
		if (!personId) {
			// remove the fields unrelated to this entity type and populate the required fields
			if (newIsCompany) {
				template.find('.person_field').remove();
			} else {
				template.find('.company_field').remove();
				selectizeCompany();
			}
			selectizeGroup(template);
			populateListFields(template);
			template.filter('.bm_right').hide();
		}

		// art
		var uploader = new Uploader({
			button : template.find('.upload_text'),
			allowMultiple : false,
			allowFolder : false,
			browseCallback : function() {
				var key = new Date().getTime();
				uploader.upload({
					params : 't=temp&source=people&key=' + key,
					complete : function() {
						var imagePage = 'https://sourceaudio-images.s3.amazonaws.com/temp/' + user.userData.id + '-' + key + '.jpg';
						template.find('.type_icon .art').html('<img src="' + imagePage + '"/>');
						template.find('input[name=art]').val(imagePage);
					}
				});
			},
			fileType : UploaderConstants.IMAGES
		});

		function loadListFields(callback) {
			if (BusinessManagerPeople.cachedListFields) {
				listFields = BusinessManagerPeople.cachedListFields;
				return callback();
			}
			ajax({ p : 'people', action : 'loadListFieldValues' }, function(response) {
				BusinessManagerPeople.cachedListFields = listFields = response;
				callback();
			});
		}

		// set up company smart drop down
		function selectizeCompany() {

			template.find('select[name=company]').selectize({
				create : true,
				createOnBlur : true,
				labelField : 'display',
				persist : false,
				searchField : 'display',
				sortField : 'display',
				valueField : 'display',
				load : function(query, callback) {
					if (!query.length) return callback();
					ajax({ p : 'people', action : 'search', s : query, type : 'publishers' }, function(response) {
						callback(response);
					});
				}
			});

		}

		// set up group smart drop down
		function selectizeGroup(container) {

			if (skipGroupSelectize) {
				skipGroupSelectize = false;
				return;
			}

			container.find('select[name=group\\[\\]]').selectize({
				create : true,
				createOnBlur : true,
				labelField : 'display',
				persist : false,
				searchField : 'display',
				sortField : 'display',
				valueField : 'display',
				load : function(query, callback) {
					if (!query.length) return callback();
					ajax({ p : 'people', action : 'search', s : query, type : 'groups' }, function(response) {
						callback(response);
					});
				}
			});

		}

		// custom fields
		var customFieldContainer = template.find('.custom_fields'),
			customFieldMasterTemplate = customFieldContainer.find('.field').clone(),
			customFieldButton = customFieldContainer.find('.manage_customs');

		customFieldContainer.find('.field').remove();

		ajax({ p : 'people', action : 'list_custom_fields' }, function(response) {

			for (var c = 0, cLen = response.length; c < cLen; c++) {

				var field = response[c],
					customFieldTemplate = customFieldMasterTemplate.clone();

				customFieldTemplate.find('.field_name').html(field.name);
				customFieldTemplate.find('input').attr('name', 'customField[' + field.id + ']');

				customFieldButton.before(customFieldTemplate);

			}

			allowPromptedInput();

			if (personId) {
				ajax({ p : 'people', personId : personId, action : 'details' }, function(response) {
					response = response[0];
					if (response.error) {
						return sa.notify({ text : response.message });
					}

					// set up the prompted input fields
					function setPromptedInputValue(fieldName) {
						var value = response[fieldName];
						if (!value) return;
						var input = template.find('input[name=' + fieldName + '], textarea[name=' + fieldName + ']');
						input.parents('.prompted_input').find('.prompt').trigger('click');
						input.val(value);
						input.trigger('blur');
					}

					// remove the fields unrelated to this entity type and populate the required fields
					if (response.isCompany) {
						template.find('.person_field').remove();
						template.find('input[name=company]').val(response.company);
					} else {
						template.find('.company_field').remove();
						template.find('input[name=firstName]').val(response.firstName);
						template.find('input[name=lastName]').val(response.lastName);
						setPromptedInputValue('title');

						if (response.company) {
							var companyInput = template.find('select[name=company]');
							companyInput.html('<option></option>').find('option').html(response.company);
							selectizeCompany();
							companyInput.parents('.prompted_input').attr('skip-select', '1').find('.prompt').trigger('click');
						} else {
							selectizeCompany();
						}
						//setPromptedInputValue('company');
					}

					populateListFields(template);

					if (response.affiliation.id != 0) {
						var affiliationSelect = template.find('select[name=affiliation]');
						affiliationSelect.parents('.prompted_input').find('.prompt').trigger('click');
						affiliationSelect.val(response.affiliation.id);
						affiliationSelect.trigger('blur');
						if (response.affiliationNumber && response.affiliationNumber != '0') {
							template.find('input[name=affiliationNumber]').val(response.affiliationNumber);
						}
					} else if (response.affiliationNumber && response.affiliationNumber != '0') {
						setPromptedInputValue('affiliationNumber');
					}
					setPromptedInputValue('ipi');
					setPromptedInputValue('ssn');
					setPromptedInputValue('description');
					setPromptedInputValue('twitter');
					setPromptedInputValue('linkedin');
					setPromptedInputValue('facebook');

					// custom fields
					if (response.customFields.length) {
						response.customFields.each(function(c, fieldData) {
							if (!fieldData.value) return;
							var input = template.find('input[name=customField\\[' + fieldData.id + '\\]]');
							if (!input.length) return; // field must not exist on site anymore
							input.parents('.prompted_input').find('.prompt').trigger('click');
							input.val(fieldData.value);
							input.trigger('blur');
						});
					}

					// repeating fields
					if (response.groups.length) {
						let groups = response.groups;
						let input = template.find('select[name=group\\[\\]]');
						let promptedInputContainer = input.parents('.prompted_input');
						let groupData = groups[0];
						promptedInputContainer.find('.prompt').trigger('click');
						input.html('<option></option>').find('option').html(groupData.name);
						selectizeGroup(template);
						//input.parents('.prompted_input').attr('skip-select', '1').find('.prompt').trigger('click');
						for (let i = 1, len = response.groups.length; i < len; i++) {
							groupData = groups[i];
							skipGroupSelectize = true; // ordinarily, clicking the repeater would selectize the group tool. we can't have that happen yet
							promptedInputContainer.find('.repeater').trigger('click');
							var newContainer = promptedInputContainer.find('.repeatable:last');
							newContainer.find('select').html('<option></option>').find('option').html(groupData.name);
							selectizeGroup(newContainer);
						}
					} else {
						selectizeGroup(template);
					}
					if (response.emails.length) {
						let emails = response.emails;
						let input = template.find('input[name=email\\[\\]]');
						let promptedInputContainer = input.parents('.prompted_input');
						let emailData = emails[0];
						let foundPreferred = false;
						promptedInputContainer.find('.prompt').trigger('click');
						input.val(emailData.email).trigger('blur');
						input.parent().find('select').val(emailData.type);
						for (let i = 1, len = response.emails.length; i < len; i++) {
							emailData = emails[i];
							promptedInputContainer.find('.repeater').trigger('click');
							promptedInputContainer.find('input[type=text]:last').val(emailData.email).trigger('blur');
							promptedInputContainer.find('select:last').val(emailData.type);
							if (emailData.preferred) {
								promptedInputContainer.find('.not_preferred:last').trigger('click');
								foundPreferred = true;
							}
						}
						if (!foundPreferred) {
							input.parents('.field').find('.not_preferred:first').trigger('click');
						}
					}
					if (response.phones.length) {
						let phones = response.phones;
						let input = template.find('input[name=phone\\[\\]]');
						let promptedInputContainer = input.parents('.prompted_input');
						let phoneData = phones[0];
						promptedInputContainer.find('.prompt').trigger('click');
						input.val(phoneData.number).trigger('blur');
						input.parent().find('select').val(phoneData.type);
						for (let i = 1, len = response.phones.length; i < len; i++) {
							phoneData = phones[i];
							promptedInputContainer.find('.repeater').trigger('click');
							promptedInputContainer.find('input:last').val(phoneData.number).trigger('blur');
							promptedInputContainer.find('select:last').val(phoneData.type);
						}
					}
					if (response.addresses.length) {
						let addresses = response.addresses;
						let input = template.find('textarea[name=address\\[\\]]');
						let promptedInputContainer = input.parents('.prompted_input');
						let addressData = addresses[0];
						promptedInputContainer.find('.prompt').trigger('click');
						input.val(addressData.address).trigger('blur');
						promptedInputContainer.find('input[name=city\\[\\]]').val(addressData.city);
						promptedInputContainer.find('input[name=state\\[\\]]').val(addressData.state);
						promptedInputContainer.find('input[name=zip\\[\\]]').val(addressData.zip);
						promptedInputContainer.find('input[name=country\\[\\]]').val(addressData.country);
						promptedInputContainer.find('select').val(addressData.type);
						for (let i = 1, len = response.addresses.length; i < len; i++) {
							addressData = addresses[i];
							promptedInputContainer.find('.repeater').trigger('click');
							promptedInputContainer.find('textarea[name=address\\[\\]]:last').val(addressData.address).trigger('blur');
							promptedInputContainer.find('input[name=city\\[\\]]:last').val(addressData.city);
							promptedInputContainer.find('input[name=state\\[\\]]:last').val(addressData.state);
							promptedInputContainer.find('input[name=zip\\[\\]]:last').val(addressData.zip);
							promptedInputContainer.find('input[name=country\\[\\]]:last').val(addressData.country);
							promptedInputContainer.find('select:last').val(addressData.type);
						}
					}

					// art
					if (response.art) {
						template.find('.type_icon .art').html('<img src="' + response.image + '"/>');
						template.find('input[name=art]').val(response.image);
					}

					// right column interactivity
					enablePersonManagement(template, response, response['isCompany']);

					sa.scrollToPosition(0);

					// hide the loader
					template.find('#loader_element').remove();
				});
			} else {
				// select the first email
				container.find('.preferred').trigger('click');
				// hide the loader
				template.find('#loader_element').remove();
			}

		});

		customFieldButton.on('click', function() {
			sa.confirm({
				text: 'You will lose any unsaved changes. Are you sure?',
				yesFunction: function () {
					// you have to double encode the source because parseHash decodes it
					let currentPath = sa.router.getCurrentPath(true);
					sa.router.routeTo('/admin?p=metadata&tab=people&action=manage_custom_fields&source=' + encodeURIComponent(currentPath));
				},
				yesText: 'Manage Custom Fields'
			});
		});

		function allowPromptedInput() {
			// allow setting of preferred email
			function addPreferredClick(container) {
				if (!container.find('.preferred').length) return;

				var parent = container.parents('.field'),
					myPreferred = container.find('.preferred'),
					myNotPreferred = container.find('.not_preferred'),
					myInput = container.find('input[name=emailPreferred\\[\\]]');

				container.find('.not_preferred').on('click', function() {
					parent.find('input[name=emailPreferred\\[\\]]').val('0');
					parent.find('.preferred').hide();
					parent.find('.not_preferred').show();
					myPreferred.show();
					myNotPreferred.hide();
					myInput.val('1');
				});
				container.find('.preferred').on('click', function() {
					if (myInput.val() != '1') return;
					parent.find('.preferred:first').trigger('click');
				});
			}
			addPreferredClick(template.find('input[name=email\\[\\]]').parents('.field').find('.repeatable'));

			// make the prompted inputs work
			template.find('.prompted_input .prompt').on('click', function() {

				var promptContainer = $j(this).parents('.prompted_input'),
					inputs = promptContainer.find('.input input, .input textarea'),
					selectize = false,
					disableOutClick = false; // click on the "add another"

				promptContainer.find('.prompt').hide();
				promptContainer.find('.input, .repeater').show();

				if (promptContainer.find('.selectize-control').length) {
					if (!promptContainer.attr('skip-select')) {
						inputs.filter(':first').trigger('focus');
						var selectizeInput = promptContainer.find('.selectize-input').trigger('click');
						setTimeout(function() {
							selectizeInput.find('input').trigger('click');
						}, 50);
					} else {
						// we can't have the initial faux click that shows the company trigger the full focusing because it's hard to get rid of
						promptContainer.removeAttr('skip-select');
					}
					selectize = true;
				} else {
					inputs.filter(':first').trigger('focus');
				}

				promptContainer.find('.repeater').on('mousedown', function() { disableOutClick = true; });

				// hide the inputs if the user clicks away
				promptContainer.find('.input input, .input select, .input textarea').on('blur', function() {
					// use a setTimeout because if they click away into another field, we need to make sure it's focused before we check
					setTimeout(function() {
						var shouldHide = true;
						if (disableOutClick) {
							// don't hide if they clicked on the repeater
							shouldHide = false;
							disableOutClick = false;
						} else if (promptContainer.find('input:focus, select:focus, textarea:focus').length) {
							// if the user has selected something else in the input, don't hide
							shouldHide = false;
						} else if (promptContainer.find('.repeatable').length > 1) {
							// don't hide if there are multiple repeatees
							shouldHide = false;
						} else if (selectize) {
							// don't hide if the select has a value for a selectize
							shouldHide = promptContainer.find('select:first').val().trim() == '';
						} else if (promptContainer.find('.prompted_select').val() != '0') {
							// don't hide if they've used a select box to choose something
							shouldHide = false;
						} else {
							// if the user has entered a value in an input or a textarea, don't hide
							promptContainer.find('.input input, .input textarea').each(function() { // don't use var inputs bc repeatables may change
								if (this.value.trim() != '') {
									shouldHide = false;
								}
							});
						}
						if (shouldHide) {
							promptContainer.find('.prompt').show();
							promptContainer.find('.input, .repeater').hide();
						}
					}, 50);
				});

			});

			// make the repeatable inputs work
			template.find('.repeater').on('click', function() {
				var repeat = $j(this).parents('.field').find('.repeatable:first').clone();
				if (repeat.hasClass('group_selectize_container')) {
					repeat.find('.selectize-control').remove();
					repeat.find('select.selectized').removeClass('selectized').html('<option value selected="selected"></option>');
					selectizeGroup(repeat);
				}
				repeat.find('input, textarea').val('');
				repeat.find('.remove_repeat').show().on('click', function() {
					repeat.remove();
				});
				$j(this).before(repeat);
				addPreferredClick(repeat);
				repeat.find('input, textarea').filter(':first').trigger('focus');
			});
		}

		// save button
		template.find('.save').on('click', function() {
			template.find('.general.error').hide();
			var validationResult = sa.forms.validate(template);
			if (!validationResult.error) {
				var vars = validationResult.values;
				if (vars.isCompany == '0' && !vars.firstName && !vars.lastName) {
					return template.find('.general.error').show();
				} else if (vars.isCompany == '1' && !vars.company) {
					return template.find('.general.error').show();
				}
				if (personId) {
					vars.id = personId;
				}
				ajax(vars, function(response) {
					if (response[0].success) {
						sa.notify({ text : (vars.isCompany == '0' ? 'Person' : 'Company') + (vars.id ? ' updated!' : ' created!') });
						sa.router.routeTo('/admin?p=metadata&tab=people&action=details&personId=' + response[0].personId);
					} else {
						template.find('.error.general').show().html(response[0].message);
					}
				}, 'POST', 'p=people&action=save');
			}
		});

		container.empty().append(template);
	}



	/////////////////////////
	// Custom Fields
	////////////////////////

	function showCustomFieldManager(container, source) {
		var template = templates.get('custom_field_manager');

		// set up return link
		if (source) {
			template.find('.back_link').attr('href', source);
		} else {
			template.find('.back_link').remove();
		}

		// load the custom fields
		var customFieldList = template.find('.custom_field_list'),
			customFieldMasterTemplate = template.find('.custom_field').clone();

		template.find('.custom_field').remove();

		ajax({ p : 'people', action : 'list_custom_fields' }, function(response) {

			for (var c = 0, cLen = response.length; c < cLen; c++) {

				var field = response[c],
					customFieldTemplate = customFieldMasterTemplate.clone();

				customFieldTemplate.find('.field_name').html(field.name);

				// set up interactivity - we do this in a new function so it holds scope
				(function(field, customFieldTemplate) {

					customFieldTemplate.find('.edit_field').on('click', function() {
						sa.prompt({
							placeholder : 'Field name',
							value : field.name,
							yesFunction : function(newValue) {
								ajax({ fieldId : field.id, name : newValue }, function(response) {
									if (response[0].success) {
										showCustomFieldManager(container, source);
									} else {
										sa.notify({ text : response[0].message });
									}
								}, 'POST', { p : 'people', action : 'edit_custom_field' });
							},
							yesText : 'Save'
						});
					});

					customFieldTemplate.find('.remove_field').on('click', function() {
						sa.confirm({
							text: 'Are you sure? This will remove the field, "' + field.name + '", from all people and companies.',
							yesFunction: function () {
								ajax({fieldId: field.id}, function (response) {
									if (response[0].success) {
										showCustomFieldManager(container, source);
									} else {
										sa.notify({ text : response[0].message });
									}
								}, 'POST', {p: 'people', action: 'delete_custom_field'});
							},
							yesText: 'Delete'
						});
					});

				})(field, customFieldTemplate);

				customFieldList.append(customFieldTemplate);

			}

		});

		// make the new field button work
		var createCustomFieldButton = template.find('.new_custom_field .button'),
			createCustomFieldInput = template.find('.new_custom_field input[name=custom_field]');

		createCustomFieldButton.on('click', function() {

			var newField = createCustomFieldInput.val().trim();
			if (!newField) return;

			ajax({ name : newField }, function(response) {

				if (response[0].success) {
					showCustomFieldManager(container, source);
				} else {
					sa.notify({ text : response[0].message });
				}

			}, 'POST', { p : 'people', action : 'add_custom_field' });

		});

		checkForEnter(createCustomFieldInput, function() { createCustomFieldButton.trigger('click'); });

		container.empty().append(template);

		createCustomFieldInput.trigger('focus');
	}



	///////////////////////
	// Importing People
	///////////////////////

	function showImportForm(container, importId, stage, type) {
		if (!stage) {
			stage = 'columns';
		}
		switch (stage) {
			case 'run':
				showImportRun(container, importId, type);
				break;
			case 'test':
				showImportTest(container, importId, type);
				break;
			case 'columns':
			default:
				showImportColumnsForm(container, importId, type);
		}
	}

	function showImportColumnsForm(container, importId, type) {
		var template = templates.get('import_columns_form'),
			columnList = template.find('.column_list'),
			columnTemplate = template.find('.column').clone();
		template.find('.column').remove();

		container.empty().append(template);

		// the server knows all the columns of the csv
		ajax({ p : 'people', action : 'import', importId : importId, stage : 'columns', type : type }, function(response) {

			// set up a base select box with all the available columns
			var availableColumnHtml = '';
			for (var i = 0, len = response.availableColumns.length; i < len; i++) {
				availableColumnHtml += '<option>' + response.availableColumns[i] + '</option>';
			}
			columnTemplate.find('.mapping select').html(availableColumnHtml);

			// add all the columns that were in the csv
			for (var i = 0, len = response.columns.length; i < len; i++) {
				var columnData = response.columns[i],
					column = columnTemplate.clone();

				// put all this column's data in the fields
				column.find('.code').html((i > 25 ? String.fromCharCode(Math.floor(i / 26) + 64) : '') + String.fromCharCode(i % 26 + 65));
				column.find('.original').html(columnData.originalName.replace('<', '&lt;').replace('>', '&gt;'));
				column.find('.example').html(columnData.example.replace('<', '&lt;').replace('>', '&gt;'));
				if (columnData.disabled) {
					column.find('.enabled input').prop('checked', false);
					column.find('.mapping select').prop('disabled', true);
				}
				column.find('.mapping select').val(columnData.name).attr('columnId', i).on('change', function(column) { return function() {
					column.find('.number_field').hide();
					var t = $j(this);
					var val = t.val();
					t.removeAttr('selection');
					if (val == 'Address' || val == 'City' || val == 'State' || val == 'Zip' || val == 'Country' || val == 'Address Type') {
						column.find('.address_selection').show();
						t.attr('selection', 'address_selection');
					} else if (val == 'Email' || val == 'Email Type') {
						column.find('.email_selection').show();
						t.attr('selection', 'email_selection');
					} else if (val == 'Phone' || val == 'Phone Type') {
						column.find('.phone_selection').show();
						t.attr('selection', 'phone_selection');
					}
				}; }(column));


				// add it to the displayed list!
				columnList.append(column);

				// set the selection
				if (columnData.address) {
					column.find('.address_selection').show().find('input').val(columnData.address);
					column.find('.mapping select').attr('selection', 'address_selection');
				} else if (columnData.email) {
					column.find('.email_selection').show().find('input').val(columnData.email);
					column.find('.mapping select').attr('selection', 'email_selection');
				} else if (columnData.phone) {
					column.find('.phone_selection').show().find('input').val(columnData.phone);
					column.find('.mapping select').attr('selection', 'phone_selection');
				}
			}
			columnList.append('<span class="clr"></span>');

			// stripe it
			columnList.find('.column:odd').addClass('stripe');

			// make the disabled checkbox work
			columnList.find('.enabled input').on('click', function() {
				var select = $j(this).parents('.column').find('.mapping select');
				if (this.checked) {
					select.prop('disabled', false);
				} else {
					select.prop('disabled', true);
				}
			});

			if (type == 'add') {
				template.find('.update_text').remove();
			} else {
				template.find('.add_text').remove();
			}

			container.find('#save_button').on('click', function() {
				// make sure they don't have two of any field
				var cols = container.find('select:enabled'),
					colData = createSafeObject(),
					usedCols = createSafeObject();
				for (var i = 0, len = cols.length; i < len; i++) {
					var col = $j(cols[i]),
						stringVal = col.val(),
						val = { value : stringVal, number : 0 },
						columnId = col.attr('columnId'),
						selection = col.attr('selection');
					if (selection) {
						var numberField = parseInt(col.parents('.column').find('.number_field:visible input').val());
						if (isNaN(numberField)) {
							return sa.notify({ text : 'Please make sure you have a number for each ' + stringVal + ' field' });
						}
						stringVal += ' - ' + numberField;
						val.number = numberField;

						if (usedCols[stringVal]) {
							return sa.notify({ text : 'Please make sure each ' + val.value + ' field has a unique number. You currently have more than one with ' + numberField });
						}
					} else if (usedCols[stringVal]) {
						return sa.notify({ text : 'You may only have one of each field type selected and you have two or more of <b>' + val.value + '</b>.' });
					}
					usedCols[stringVal] = 1;
					colData[columnId] = val;
				}

				// adding is easier than editing
				if (type == 'add') {

					// we show a confirmation box since this looks a lot like metadata importing, which has several more steps before it runs. this doesn't need that extra info and just goes immediately
					sa.confirm({
						text: '<b>Add new Interested Parties</b> with these settings?<br/>Import will begin immediately.',
						yesFunction: function () {
							ajax({columns: colData}, function (response) {
								response = response[0];
								if (response.error) {
									sa.notify({ text : response.message });
								} else {
									sa.router.routeTo('/admin?p=metadata&tab=people&action=import&importId=' + importId + '&stage=run&type=' + type);
								}
							}, 'POST', {p: 'people', action: 'import', importId: importId, stage: 'saveColumns'});
						},
						yesText: 'Import'
					});

				} else {

					// make sure they specified an id column
					if (!usedCols['ID']) {
						return sa.notify({ text : 'You must specify one ID column so we can match your data to the parties.' });
					}

					ajax({columns: colData}, function (response) {
						response = response[0];
						if (response.error) {
							sa.notify({ text : response.message });
						} else {
							sa.router.routeTo('/admin?p=metadata&tab=people&action=import&importId=' + importId + '&stage=test&type=update');
						}
					}, 'POST', {p: 'people', action: 'import', importId: importId, stage: 'saveColumns'});

				}
			});
		});
	}

	function showImportTest(container, importId, type) {
		container.empty().append(templates.get('import_test'));
		showLoader(container.find('.loading_container'), 'Testing your CSV. Please be patient. These don\'t take long.');

		ajax({ p : 'people', action : 'import', importId : importId, stage : 'test', type : type }, function(response) {

			// full script errors are sent back as an array
			if (response[0] && response[0].error) {
				showImportColumnsForm(container, importId);
				return sa.notify({ text : response[0].message });
			}

			// show that we've switched to done and tell the user some stats
			container.find('.running').hide();
			container.find('.finished').show();
			container.find('.total_rows').html(response.total.numberFormat());
			container.find('.matched_rows').html(response.matched.numberFormat());

			// if there are row errors, we need to list them out. hopefully there aren't so many this causes problems
			if (Object.keys(response.errors).length) {
				container.find('.errors').show();
				var errorTemplate = container.find('.error'),
					errorList = container.find('.error_list');
				container.find('.error').remove();

				// errors are sent back as an object with messages indexed by row number
				for (var i in response.errors) {
					if (!response.errors.hasOwnProperty(i)) continue;
					var error = errorTemplate.clone();
					error.find('.row_number').html(i);
					error.find('.explanation').html(response.errors[i]);
					errorList.append(error);
				}
			}

			// set up the run option
			if (response.matched > 0) {
				container.find('.run').attr('href', 'admin?p=metadata&tab=people&action=import&importId=' + importId + '&stage=run&type=' + type);
			} else {
				container.find('.run').remove();
			}
		});
	}

	function showImportRun(container, importId, type) {
		container.empty().append(templates.get('import_run'));
		showLoader(container.find('.loading_container'), 'Your CSV is being processed. Please be patient. These don\'t take long.');

		ajax({ p : 'people', action : 'import', importId : importId, stage : 'run', type : type }, function(response) {

			// full script errors are sent back as an array
			if (response[0] && response[0].error) {
				showImportColumnsForm(container, importId);
				return sa.notify({ text : response[0].message });
			}

			if (type == 'add') {
				container.find('.update_text').remove();
			} else {
				container.find('.add_text').remove();
			}

			// show that we've switched to done and tell the user some stats
			container.find('.running').hide();
			container.find('.finished').show();
			container.find('.total_rows').html(response.processed.numberFormat());
			container.find('.total_added').html(response.added.numberFormat());

			// if there are row errors, we need to list them out. hopefully there aren't so many this causes problems
			if (Object.keys(response.errors).length) {
				container.find('.errors').show();
				var errorTemplate = container.find('.error'),
					errorList = container.find('.error_list');
				container.find('.error').remove();

				// errors are sent back as an object with messages indexed by row number
				for (var i in response.errors) {
					if (!response.errors.hasOwnProperty(i)) continue;
					var error = errorTemplate.clone();
					error.find('.row_number').html(i);
					error.find('.explanation').html(response.errors[i]);
					errorList.append(error);
				}
			}
		});
	}

}
//BusinessManagerPeople.prototype = new RightTabbedPage();
/**
 * The page in the business manager that lets you see all your active tasks
 */
function BusinessManagerTasks() {

	var page = this;
	
	/**
	 * Sets up the basic framework of the page and its objects 
	 * @param {string} params the parameters from the url
	 * @param {JQuery} container
	 */
	this.show = function(params, container) {
		// make sure they're secure
		if (!user.hasAdminPermission(AdminPermission.Any)) {
			return container.append('<h3 class="permission_denied">You don\'t have permission to access this page. You would need the "' + 'Edit Metadata and Add and Delete Tracks' + '" permission.</h3>');
		}
		container.html('').addClass('bm_overview');
		
		/*let vars = sa.router.getCurrentParamsAsObject();
		if (vars.action == 'new') {
			showPersonForm(container);
		} else if (vars.action == 'edit') {
			showPersonForm(container, vars.personId);
		} else if (vars.action == 'import') {
			showImportForm(container, vars.importId, vars.stage);
		} else {
			showTasks(container);
		}*/
	};
	
	function showTasks(container) {
		container.html('this is the tasks');
	}
	
}
BusinessManagerTasks.prototype = new RightTabbedPage();

BusinessManagerTasks.NewTask = function(person) {
	var template,
		fb,
		personName;

	template = sa.templates.get('business_manager.tasks').get('new');
	fb = new FocusBox(template);

	// date stuff
	template.find('input[name=date]').datepicker({ dateFormat: config.datePickerDateFormatString });
	loadScript(ExtraScripts.timePicker, function() {
		template.find('input[name=time]').timepicker();
	});

	// related to
	personName = person.isCompany ? person.company : [ person.firstName, person.lastName ].join(' ');
	template.find('.person option').val(person.id).html(personName);
	template.find('.person').selectize({
		create : false,
		labelField : 'display',
		searchField : 'display',
		sortField : 'display',
		valueField : 'id',
		load : function(query, callback) {
			if (!query.length) return callback();
			ajax({ p : 'people', action : 'search', s : query }, function(response) {
				callback(response);
			});
		}
	});

	// give them a way to close it
	template.find('#close, .cancel').on('click', function() {
		fb.hide();
	});

	fb.show();
};
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
			(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.chroma = factory());
})(this, (function () { 'use strict';

	var limit$2 = function (x, min, max) {
		if ( min === void 0 ) min=0;
		if ( max === void 0 ) max=1;

		return x < min ? min : x > max ? max : x;
	};

	var limit$1 = limit$2;

	var clip_rgb$3 = function (rgb) {
		rgb._clipped = false;
		rgb._unclipped = rgb.slice(0);
		for (var i=0; i<=3; i++) {
			if (i < 3) {
				if (rgb[i] < 0 || rgb[i] > 255) { rgb._clipped = true; }
				rgb[i] = limit$1(rgb[i], 0, 255);
			} else if (i === 3) {
				rgb[i] = limit$1(rgb[i], 0, 1);
			}
		}
		return rgb;
	};

	// ported from jQuery's $.type
	var classToType = {};
	for (var i$1 = 0, list$1 = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Undefined', 'Null']; i$1 < list$1.length; i$1 += 1) {
		var name = list$1[i$1];

		classToType[("[object " + name + "]")] = name.toLowerCase();
	}
	var type$p = function(obj) {
		return classToType[Object.prototype.toString.call(obj)] || "object";
	};

	var type$o = type$p;

	var unpack$B = function (args, keyOrder) {
		if ( keyOrder === void 0 ) keyOrder=null;

		// if called with more than 3 arguments, we return the arguments
		if (args.length >= 3) { return Array.prototype.slice.call(args); }
		// with less than 3 args we check if first arg is object
		// and use the keyOrder string to extract and sort properties
		if (type$o(args[0]) == 'object' && keyOrder) {
			return keyOrder.split('')
				.filter(function (k) { return args[0][k] !== undefined; })
				.map(function (k) { return args[0][k]; });
		}
		// otherwise we just return the first argument
		// (which we suppose is an array of args)
		return args[0];
	};

	var type$n = type$p;

	var last$4 = function (args) {
		if (args.length < 2) { return null; }
		var l = args.length-1;
		if (type$n(args[l]) == 'string') { return args[l].toLowerCase(); }
		return null;
	};

	var PI$2 = Math.PI;

	var utils = {
		clip_rgb: clip_rgb$3,
		limit: limit$2,
		type: type$p,
		unpack: unpack$B,
		last: last$4,
		PI: PI$2,
		TWOPI: PI$2*2,
		PITHIRD: PI$2/3,
		DEG2RAD: PI$2 / 180,
		RAD2DEG: 180 / PI$2
	};

	var input$h = {
		format: {},
		autodetect: []
	};

	var last$3 = utils.last;
	var clip_rgb$2 = utils.clip_rgb;
	var type$m = utils.type;
	var _input = input$h;

	var Color$D = function Color() {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var me = this;
		if (type$m(args[0]) === 'object' &&
			args[0].constructor &&
			args[0].constructor === this.constructor) {
			// the argument is already a Color instance
			return args[0];
		}

		// last argument could be the mode
		var mode = last$3(args);
		var autodetect = false;

		if (!mode) {
			autodetect = true;
			if (!_input.sorted) {
				_input.autodetect = _input.autodetect.sort(function (a,b) { return b.p - a.p; });
				_input.sorted = true;
			}
			// auto-detect format
			for (var i = 0, list = _input.autodetect; i < list.length; i += 1) {
				var chk = list[i];

				mode = chk.test.apply(chk, args);
				if (mode) { break; }
			}
		}

		if (_input.format[mode]) {
			var rgb = _input.format[mode].apply(null, autodetect ? args : args.slice(0,-1));
			me._rgb = clip_rgb$2(rgb);
		} else {
			throw new Error('unknown format: '+args);
		}

		// add alpha channel
		if (me._rgb.length === 3) { me._rgb.push(1); }
	};

	Color$D.prototype.toString = function toString () {
		if (type$m(this.hex) == 'function') { return this.hex(); }
		return ("[" + (this._rgb.join(',')) + "]");
	};

	var Color_1 = Color$D;

	var chroma$k = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( chroma$k.Color, [ null ].concat( args) ));
	};

	chroma$k.Color = Color_1;
	chroma$k.version = '2.4.2';

	var chroma_1 = chroma$k;

	var unpack$A = utils.unpack;
	var max$2 = Math.max;

	var rgb2cmyk$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$A(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		r = r / 255;
		g = g / 255;
		b = b / 255;
		var k = 1 - max$2(r,max$2(g,b));
		var f = k < 1 ? 1 / (1-k) : 0;
		var c = (1-r-k) * f;
		var m = (1-g-k) * f;
		var y = (1-b-k) * f;
		return [c,m,y,k];
	};

	var rgb2cmyk_1 = rgb2cmyk$1;

	var unpack$z = utils.unpack;

	var cmyk2rgb = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		args = unpack$z(args, 'cmyk');
		var c = args[0];
		var m = args[1];
		var y = args[2];
		var k = args[3];
		var alpha = args.length > 4 ? args[4] : 1;
		if (k === 1) { return [0,0,0,alpha]; }
		return [
			c >= 1 ? 0 : 255 * (1-c) * (1-k), // r
			m >= 1 ? 0 : 255 * (1-m) * (1-k), // g
			y >= 1 ? 0 : 255 * (1-y) * (1-k), // b
			alpha
		];
	};

	var cmyk2rgb_1 = cmyk2rgb;

	var chroma$j = chroma_1;
	var Color$C = Color_1;
	var input$g = input$h;
	var unpack$y = utils.unpack;
	var type$l = utils.type;

	var rgb2cmyk = rgb2cmyk_1;

	Color$C.prototype.cmyk = function() {
		return rgb2cmyk(this._rgb);
	};

	chroma$j.cmyk = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$C, [ null ].concat( args, ['cmyk']) ));
	};

	input$g.format.cmyk = cmyk2rgb_1;

	input$g.autodetect.push({
		p: 2,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$y(args, 'cmyk');
			if (type$l(args) === 'array' && args.length === 4) {
				return 'cmyk';
			}
		}
	});

	var unpack$x = utils.unpack;
	var last$2 = utils.last;
	var rnd = function (a) { return Math.round(a*100)/100; };

	/*
	 * supported arguments:
	 * - hsl2css(h,s,l)
	 * - hsl2css(h,s,l,a)
	 * - hsl2css([h,s,l], mode)
	 * - hsl2css([h,s,l,a], mode)
	 * - hsl2css({h,s,l,a}, mode)
	 */
	var hsl2css$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var hsla = unpack$x(args, 'hsla');
		var mode = last$2(args) || 'lsa';
		hsla[0] = rnd(hsla[0] || 0);
		hsla[1] = rnd(hsla[1]*100) + '%';
		hsla[2] = rnd(hsla[2]*100) + '%';
		if (mode === 'hsla' || (hsla.length > 3 && hsla[3]<1)) {
			hsla[3] = hsla.length > 3 ? hsla[3] : 1;
			mode = 'hsla';
		} else {
			hsla.length = 3;
		}
		return (mode + "(" + (hsla.join(',')) + ")");
	};

	var hsl2css_1 = hsl2css$1;

	var unpack$w = utils.unpack;

	/*
	 * supported arguments:
	 * - rgb2hsl(r,g,b)
	 * - rgb2hsl(r,g,b,a)
	 * - rgb2hsl([r,g,b])
	 * - rgb2hsl([r,g,b,a])
	 * - rgb2hsl({r,g,b,a})
	 */
	var rgb2hsl$3 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		args = unpack$w(args, 'rgba');
		var r = args[0];
		var g = args[1];
		var b = args[2];

		r /= 255;
		g /= 255;
		b /= 255;

		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);

		var l = (max + min) / 2;
		var s, h;

		if (max === min){
			s = 0;
			h = Number.NaN;
		} else {
			s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
		}

		if (r == max) { h = (g - b) / (max - min); }
		else if (g == max) { h = 2 + (b - r) / (max - min); }
		else if (b == max) { h = 4 + (r - g) / (max - min); }

		h *= 60;
		if (h < 0) { h += 360; }
		if (args.length>3 && args[3]!==undefined) { return [h,s,l,args[3]]; }
		return [h,s,l];
	};

	var rgb2hsl_1 = rgb2hsl$3;

	var unpack$v = utils.unpack;
	var last$1 = utils.last;
	var hsl2css = hsl2css_1;
	var rgb2hsl$2 = rgb2hsl_1;
	var round$6 = Math.round;

	/*
	 * supported arguments:
	 * - rgb2css(r,g,b)
	 * - rgb2css(r,g,b,a)
	 * - rgb2css([r,g,b], mode)
	 * - rgb2css([r,g,b,a], mode)
	 * - rgb2css({r,g,b,a}, mode)
	 */
	var rgb2css$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var rgba = unpack$v(args, 'rgba');
		var mode = last$1(args) || 'rgb';
		if (mode.substr(0,3) == 'hsl') {
			return hsl2css(rgb2hsl$2(rgba), mode);
		}
		rgba[0] = round$6(rgba[0]);
		rgba[1] = round$6(rgba[1]);
		rgba[2] = round$6(rgba[2]);
		if (mode === 'rgba' || (rgba.length > 3 && rgba[3]<1)) {
			rgba[3] = rgba.length > 3 ? rgba[3] : 1;
			mode = 'rgba';
		}
		return (mode + "(" + (rgba.slice(0,mode==='rgb'?3:4).join(',')) + ")");
	};

	var rgb2css_1 = rgb2css$1;

	var unpack$u = utils.unpack;
	var round$5 = Math.round;

	var hsl2rgb$1 = function () {
		var assign;

		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
		args = unpack$u(args, 'hsl');
		var h = args[0];
		var s = args[1];
		var l = args[2];
		var r,g,b;
		if (s === 0) {
			r = g = b = l*255;
		} else {
			var t3 = [0,0,0];
			var c = [0,0,0];
			var t2 = l < 0.5 ? l * (1+s) : l+s-l*s;
			var t1 = 2 * l - t2;
			var h_ = h / 360;
			t3[0] = h_ + 1/3;
			t3[1] = h_;
			t3[2] = h_ - 1/3;
			for (var i=0; i<3; i++) {
				if (t3[i] < 0) { t3[i] += 1; }
				if (t3[i] > 1) { t3[i] -= 1; }
				if (6 * t3[i] < 1)
				{ c[i] = t1 + (t2 - t1) * 6 * t3[i]; }
				else if (2 * t3[i] < 1)
				{ c[i] = t2; }
				else if (3 * t3[i] < 2)
				{ c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6; }
				else
				{ c[i] = t1; }
			}
			(assign = [round$5(c[0]*255),round$5(c[1]*255),round$5(c[2]*255)], r = assign[0], g = assign[1], b = assign[2]);
		}
		if (args.length > 3) {
			// keep alpha channel
			return [r,g,b,args[3]];
		}
		return [r,g,b,1];
	};

	var hsl2rgb_1 = hsl2rgb$1;

	var hsl2rgb = hsl2rgb_1;
	var input$f = input$h;

	var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
	var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
	var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
	var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
	var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
	var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;

	var round$4 = Math.round;

	var css2rgb$1 = function (css) {
		css = css.toLowerCase().trim();
		var m;

		if (input$f.format.named) {
			try {
				return input$f.format.named(css);
			} catch (e) {
				// eslint-disable-next-line
			}
		}

		// rgb(250,20,0)
		if ((m = css.match(RE_RGB))) {
			var rgb = m.slice(1,4);
			for (var i=0; i<3; i++) {
				rgb[i] = +rgb[i];
			}
			rgb[3] = 1;  // default alpha
			return rgb;
		}

		// rgba(250,20,0,0.4)
		if ((m = css.match(RE_RGBA))) {
			var rgb$1 = m.slice(1,5);
			for (var i$1=0; i$1<4; i$1++) {
				rgb$1[i$1] = +rgb$1[i$1];
			}
			return rgb$1;
		}

		// rgb(100%,0%,0%)
		if ((m = css.match(RE_RGB_PCT))) {
			var rgb$2 = m.slice(1,4);
			for (var i$2=0; i$2<3; i$2++) {
				rgb$2[i$2] = round$4(rgb$2[i$2] * 2.55);
			}
			rgb$2[3] = 1;  // default alpha
			return rgb$2;
		}

		// rgba(100%,0%,0%,0.4)
		if ((m = css.match(RE_RGBA_PCT))) {
			var rgb$3 = m.slice(1,5);
			for (var i$3=0; i$3<3; i$3++) {
				rgb$3[i$3] = round$4(rgb$3[i$3] * 2.55);
			}
			rgb$3[3] = +rgb$3[3];
			return rgb$3;
		}

		// hsl(0,100%,50%)
		if ((m = css.match(RE_HSL))) {
			var hsl = m.slice(1,4);
			hsl[1] *= 0.01;
			hsl[2] *= 0.01;
			var rgb$4 = hsl2rgb(hsl);
			rgb$4[3] = 1;
			return rgb$4;
		}

		// hsla(0,100%,50%,0.5)
		if ((m = css.match(RE_HSLA))) {
			var hsl$1 = m.slice(1,4);
			hsl$1[1] *= 0.01;
			hsl$1[2] *= 0.01;
			var rgb$5 = hsl2rgb(hsl$1);
			rgb$5[3] = +m[4];  // default alpha = 1
			return rgb$5;
		}
	};

	css2rgb$1.test = function (s) {
		return RE_RGB.test(s) ||
			RE_RGBA.test(s) ||
			RE_RGB_PCT.test(s) ||
			RE_RGBA_PCT.test(s) ||
			RE_HSL.test(s) ||
			RE_HSLA.test(s);
	};

	var css2rgb_1 = css2rgb$1;

	var chroma$i = chroma_1;
	var Color$B = Color_1;
	var input$e = input$h;
	var type$k = utils.type;

	var rgb2css = rgb2css_1;
	var css2rgb = css2rgb_1;

	Color$B.prototype.css = function(mode) {
		return rgb2css(this._rgb, mode);
	};

	chroma$i.css = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$B, [ null ].concat( args, ['css']) ));
	};

	input$e.format.css = css2rgb;

	input$e.autodetect.push({
		p: 5,
		test: function (h) {
			var rest = [], len = arguments.length - 1;
			while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

			if (!rest.length && type$k(h) === 'string' && css2rgb.test(h)) {
				return 'css';
			}
		}
	});

	var Color$A = Color_1;
	var chroma$h = chroma_1;
	var input$d = input$h;
	var unpack$t = utils.unpack;

	input$d.format.gl = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var rgb = unpack$t(args, 'rgba');
		rgb[0] *= 255;
		rgb[1] *= 255;
		rgb[2] *= 255;
		return rgb;
	};

	chroma$h.gl = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$A, [ null ].concat( args, ['gl']) ));
	};

	Color$A.prototype.gl = function() {
		var rgb = this._rgb;
		return [rgb[0]/255, rgb[1]/255, rgb[2]/255, rgb[3]];
	};

	var unpack$s = utils.unpack;

	var rgb2hcg$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$s(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var c = delta * 100 / 255;
		var _g = min / (255 - delta) * 100;
		var h;
		if (delta === 0) {
			h = Number.NaN;
		} else {
			if (r === max) { h = (g - b) / delta; }
			if (g === max) { h = 2+(b - r) / delta; }
			if (b === max) { h = 4+(r - g) / delta; }
			h *= 60;
			if (h < 0) { h += 360; }
		}
		return [h, c, _g];
	};

	var rgb2hcg_1 = rgb2hcg$1;

	var unpack$r = utils.unpack;
	var floor$3 = Math.floor;

	/*
	 * this is basically just HSV with some minor tweaks
	 *
	 * hue.. [0..360]
	 * chroma .. [0..1]
	 * grayness .. [0..1]
	 */

	var hcg2rgb = function () {
		var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
		args = unpack$r(args, 'hcg');
		var h = args[0];
		var c = args[1];
		var _g = args[2];
		var r,g,b;
		_g = _g * 255;
		var _c = c * 255;
		if (c === 0) {
			r = g = b = _g;
		} else {
			if (h === 360) { h = 0; }
			if (h > 360) { h -= 360; }
			if (h < 0) { h += 360; }
			h /= 60;
			var i = floor$3(h);
			var f = h - i;
			var p = _g * (1 - c);
			var q = p + _c * (1 - f);
			var t = p + _c * f;
			var v = p + _c;
			switch (i) {
				case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
				case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
				case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
				case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
				case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
				case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
			}
		}
		return [r, g, b, args.length > 3 ? args[3] : 1];
	};

	var hcg2rgb_1 = hcg2rgb;

	var unpack$q = utils.unpack;
	var type$j = utils.type;
	var chroma$g = chroma_1;
	var Color$z = Color_1;
	var input$c = input$h;

	var rgb2hcg = rgb2hcg_1;

	Color$z.prototype.hcg = function() {
		return rgb2hcg(this._rgb);
	};

	chroma$g.hcg = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$z, [ null ].concat( args, ['hcg']) ));
	};

	input$c.format.hcg = hcg2rgb_1;

	input$c.autodetect.push({
		p: 1,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$q(args, 'hcg');
			if (type$j(args) === 'array' && args.length === 3) {
				return 'hcg';
			}
		}
	});

	var unpack$p = utils.unpack;
	var last = utils.last;
	var round$3 = Math.round;

	var rgb2hex$2 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$p(args, 'rgba');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		var a = ref[3];
		var mode = last(args) || 'auto';
		if (a === undefined) { a = 1; }
		if (mode === 'auto') {
			mode = a < 1 ? 'rgba' : 'rgb';
		}
		r = round$3(r);
		g = round$3(g);
		b = round$3(b);
		var u = r << 16 | g << 8 | b;
		var str = "000000" + u.toString(16); //#.toUpperCase();
		str = str.substr(str.length - 6);
		var hxa = '0' + round$3(a * 255).toString(16);
		hxa = hxa.substr(hxa.length - 2);
		switch (mode.toLowerCase()) {
			case 'rgba': return ("#" + str + hxa);
			case 'argb': return ("#" + hxa + str);
			default: return ("#" + str);
		}
	};

	var rgb2hex_1 = rgb2hex$2;

	var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
	var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;

	var hex2rgb$1 = function (hex) {
		if (hex.match(RE_HEX)) {
			// remove optional leading #
			if (hex.length === 4 || hex.length === 7) {
				hex = hex.substr(1);
			}
			// expand short-notation to full six-digit
			if (hex.length === 3) {
				hex = hex.split('');
				hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
			}
			var u = parseInt(hex, 16);
			var r = u >> 16;
			var g = u >> 8 & 0xFF;
			var b = u & 0xFF;
			return [r,g,b,1];
		}

		// match rgba hex format, eg #FF000077
		if (hex.match(RE_HEXA)) {
			if (hex.length === 5 || hex.length === 9) {
				// remove optional leading #
				hex = hex.substr(1);
			}
			// expand short-notation to full eight-digit
			if (hex.length === 4) {
				hex = hex.split('');
				hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2]+hex[3]+hex[3];
			}
			var u$1 = parseInt(hex, 16);
			var r$1 = u$1 >> 24 & 0xFF;
			var g$1 = u$1 >> 16 & 0xFF;
			var b$1 = u$1 >> 8 & 0xFF;
			var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
			return [r$1,g$1,b$1,a];
		}

		// we used to check for css colors here
		// if _input.css? and rgb = _input.css hex
		//     return rgb

		throw new Error(("unknown hex color: " + hex));
	};

	var hex2rgb_1 = hex2rgb$1;

	var chroma$f = chroma_1;
	var Color$y = Color_1;
	var type$i = utils.type;
	var input$b = input$h;

	var rgb2hex$1 = rgb2hex_1;

	Color$y.prototype.hex = function(mode) {
		return rgb2hex$1(this._rgb, mode);
	};

	chroma$f.hex = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$y, [ null ].concat( args, ['hex']) ));
	};

	input$b.format.hex = hex2rgb_1;
	input$b.autodetect.push({
		p: 4,
		test: function (h) {
			var rest = [], len = arguments.length - 1;
			while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

			if (!rest.length && type$i(h) === 'string' && [3,4,5,6,7,8,9].indexOf(h.length) >= 0) {
				return 'hex';
			}
		}
	});

	var unpack$o = utils.unpack;
	var TWOPI$2 = utils.TWOPI;
	var min$2 = Math.min;
	var sqrt$4 = Math.sqrt;
	var acos = Math.acos;

	var rgb2hsi$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		/*
		borrowed from here:
		http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
		*/
		var ref = unpack$o(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		r /= 255;
		g /= 255;
		b /= 255;
		var h;
		var min_ = min$2(r,g,b);
		var i = (r+g+b) / 3;
		var s = i > 0 ? 1 - min_/i : 0;
		if (s === 0) {
			h = NaN;
		} else {
			h = ((r-g)+(r-b)) / 2;
			h /= sqrt$4((r-g)*(r-g) + (r-b)*(g-b));
			h = acos(h);
			if (b > g) {
				h = TWOPI$2 - h;
			}
			h /= TWOPI$2;
		}
		return [h*360,s,i];
	};

	var rgb2hsi_1 = rgb2hsi$1;

	var unpack$n = utils.unpack;
	var limit = utils.limit;
	var TWOPI$1 = utils.TWOPI;
	var PITHIRD = utils.PITHIRD;
	var cos$4 = Math.cos;

	/*
	 * hue [0..360]
	 * saturation [0..1]
	 * intensity [0..1]
	 */
	var hsi2rgb = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		/*
		borrowed from here:
		http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
		*/
		args = unpack$n(args, 'hsi');
		var h = args[0];
		var s = args[1];
		var i = args[2];
		var r,g,b;

		if (isNaN(h)) { h = 0; }
		if (isNaN(s)) { s = 0; }
		// normalize hue
		if (h > 360) { h -= 360; }
		if (h < 0) { h += 360; }
		h /= 360;
		if (h < 1/3) {
			b = (1-s)/3;
			r = (1+s*cos$4(TWOPI$1*h)/cos$4(PITHIRD-TWOPI$1*h))/3;
			g = 1 - (b+r);
		} else if (h < 2/3) {
			h -= 1/3;
			r = (1-s)/3;
			g = (1+s*cos$4(TWOPI$1*h)/cos$4(PITHIRD-TWOPI$1*h))/3;
			b = 1 - (r+g);
		} else {
			h -= 2/3;
			g = (1-s)/3;
			b = (1+s*cos$4(TWOPI$1*h)/cos$4(PITHIRD-TWOPI$1*h))/3;
			r = 1 - (g+b);
		}
		r = limit(i*r*3);
		g = limit(i*g*3);
		b = limit(i*b*3);
		return [r*255, g*255, b*255, args.length > 3 ? args[3] : 1];
	};

	var hsi2rgb_1 = hsi2rgb;

	var unpack$m = utils.unpack;
	var type$h = utils.type;
	var chroma$e = chroma_1;
	var Color$x = Color_1;
	var input$a = input$h;

	var rgb2hsi = rgb2hsi_1;

	Color$x.prototype.hsi = function() {
		return rgb2hsi(this._rgb);
	};

	chroma$e.hsi = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$x, [ null ].concat( args, ['hsi']) ));
	};

	input$a.format.hsi = hsi2rgb_1;

	input$a.autodetect.push({
		p: 2,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$m(args, 'hsi');
			if (type$h(args) === 'array' && args.length === 3) {
				return 'hsi';
			}
		}
	});

	var unpack$l = utils.unpack;
	var type$g = utils.type;
	var chroma$d = chroma_1;
	var Color$w = Color_1;
	var input$9 = input$h;

	var rgb2hsl$1 = rgb2hsl_1;

	Color$w.prototype.hsl = function() {
		return rgb2hsl$1(this._rgb);
	};

	chroma$d.hsl = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$w, [ null ].concat( args, ['hsl']) ));
	};

	input$9.format.hsl = hsl2rgb_1;

	input$9.autodetect.push({
		p: 2,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$l(args, 'hsl');
			if (type$g(args) === 'array' && args.length === 3) {
				return 'hsl';
			}
		}
	});

	var unpack$k = utils.unpack;
	var min$1 = Math.min;
	var max$1 = Math.max;

	/*
	 * supported arguments:
	 * - rgb2hsv(r,g,b)
	 * - rgb2hsv([r,g,b])
	 * - rgb2hsv({r,g,b})
	 */
	var rgb2hsl = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		args = unpack$k(args, 'rgb');
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var min_ = min$1(r, g, b);
		var max_ = max$1(r, g, b);
		var delta = max_ - min_;
		var h,s,v;
		v = max_ / 255.0;
		if (max_ === 0) {
			h = Number.NaN;
			s = 0;
		} else {
			s = delta / max_;
			if (r === max_) { h = (g - b) / delta; }
			if (g === max_) { h = 2+(b - r) / delta; }
			if (b === max_) { h = 4+(r - g) / delta; }
			h *= 60;
			if (h < 0) { h += 360; }
		}
		return [h, s, v]
	};

	var rgb2hsv$1 = rgb2hsl;

	var unpack$j = utils.unpack;
	var floor$2 = Math.floor;

	var hsv2rgb = function () {
		var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
		args = unpack$j(args, 'hsv');
		var h = args[0];
		var s = args[1];
		var v = args[2];
		var r,g,b;
		v *= 255;
		if (s === 0) {
			r = g = b = v;
		} else {
			if (h === 360) { h = 0; }
			if (h > 360) { h -= 360; }
			if (h < 0) { h += 360; }
			h /= 60;

			var i = floor$2(h);
			var f = h - i;
			var p = v * (1 - s);
			var q = v * (1 - s * f);
			var t = v * (1 - s * (1 - f));

			switch (i) {
				case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
				case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
				case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
				case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
				case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
				case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
			}
		}
		return [r,g,b,args.length > 3?args[3]:1];
	};

	var hsv2rgb_1 = hsv2rgb;

	var unpack$i = utils.unpack;
	var type$f = utils.type;
	var chroma$c = chroma_1;
	var Color$v = Color_1;
	var input$8 = input$h;

	var rgb2hsv = rgb2hsv$1;

	Color$v.prototype.hsv = function() {
		return rgb2hsv(this._rgb);
	};

	chroma$c.hsv = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$v, [ null ].concat( args, ['hsv']) ));
	};

	input$8.format.hsv = hsv2rgb_1;

	input$8.autodetect.push({
		p: 2,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$i(args, 'hsv');
			if (type$f(args) === 'array' && args.length === 3) {
				return 'hsv';
			}
		}
	});

	var labConstants = {
		// Corresponds roughly to RGB brighter/darker
		Kn: 18,

		// D65 standard referent
		Xn: 0.950470,
		Yn: 1,
		Zn: 1.088830,

		t0: 0.137931034,  // 4 / 29
		t1: 0.206896552,  // 6 / 29
		t2: 0.12841855,   // 3 * t1 * t1
		t3: 0.008856452,  // t1 * t1 * t1
	};

	var LAB_CONSTANTS$3 = labConstants;
	var unpack$h = utils.unpack;
	var pow$a = Math.pow;

	var rgb2lab$2 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$h(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		var ref$1 = rgb2xyz(r,g,b);
		var x = ref$1[0];
		var y = ref$1[1];
		var z = ref$1[2];
		var l = 116 * y - 16;
		return [l < 0 ? 0 : l, 500 * (x - y), 200 * (y - z)];
	};

	var rgb_xyz = function (r) {
		if ((r /= 255) <= 0.04045) { return r / 12.92; }
		return pow$a((r + 0.055) / 1.055, 2.4);
	};

	var xyz_lab = function (t) {
		if (t > LAB_CONSTANTS$3.t3) { return pow$a(t, 1 / 3); }
		return t / LAB_CONSTANTS$3.t2 + LAB_CONSTANTS$3.t0;
	};

	var rgb2xyz = function (r,g,b) {
		r = rgb_xyz(r);
		g = rgb_xyz(g);
		b = rgb_xyz(b);
		var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS$3.Xn);
		var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS$3.Yn);
		var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS$3.Zn);
		return [x,y,z];
	};

	var rgb2lab_1 = rgb2lab$2;

	var LAB_CONSTANTS$2 = labConstants;
	var unpack$g = utils.unpack;
	var pow$9 = Math.pow;

	/*
	 * L* [0..100]
	 * a [-100..100]
	 * b [-100..100]
	 */
	var lab2rgb$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		args = unpack$g(args, 'lab');
		var l = args[0];
		var a = args[1];
		var b = args[2];
		var x,y,z, r,g,b_;

		y = (l + 16) / 116;
		x = isNaN(a) ? y : y + a / 500;
		z = isNaN(b) ? y : y - b / 200;

		y = LAB_CONSTANTS$2.Yn * lab_xyz(y);
		x = LAB_CONSTANTS$2.Xn * lab_xyz(x);
		z = LAB_CONSTANTS$2.Zn * lab_xyz(z);

		r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);  // D65 -> sRGB
		g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
		b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);

		return [r,g,b_,args.length > 3 ? args[3] : 1];
	};

	var xyz_rgb = function (r) {
		return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$9(r, 1 / 2.4) - 0.055)
	};

	var lab_xyz = function (t) {
		return t > LAB_CONSTANTS$2.t1 ? t * t * t : LAB_CONSTANTS$2.t2 * (t - LAB_CONSTANTS$2.t0)
	};

	var lab2rgb_1 = lab2rgb$1;

	var unpack$f = utils.unpack;
	var type$e = utils.type;
	var chroma$b = chroma_1;
	var Color$u = Color_1;
	var input$7 = input$h;

	var rgb2lab$1 = rgb2lab_1;

	Color$u.prototype.lab = function() {
		return rgb2lab$1(this._rgb);
	};

	chroma$b.lab = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$u, [ null ].concat( args, ['lab']) ));
	};

	input$7.format.lab = lab2rgb_1;

	input$7.autodetect.push({
		p: 2,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$f(args, 'lab');
			if (type$e(args) === 'array' && args.length === 3) {
				return 'lab';
			}
		}
	});

	var unpack$e = utils.unpack;
	var RAD2DEG = utils.RAD2DEG;
	var sqrt$3 = Math.sqrt;
	var atan2$2 = Math.atan2;
	var round$2 = Math.round;

	var lab2lch$2 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$e(args, 'lab');
		var l = ref[0];
		var a = ref[1];
		var b = ref[2];
		var c = sqrt$3(a * a + b * b);
		var h = (atan2$2(b, a) * RAD2DEG + 360) % 360;
		if (round$2(c*10000) === 0) { h = Number.NaN; }
		return [l, c, h];
	};

	var lab2lch_1 = lab2lch$2;

	var unpack$d = utils.unpack;
	var rgb2lab = rgb2lab_1;
	var lab2lch$1 = lab2lch_1;

	var rgb2lch$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$d(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		var ref$1 = rgb2lab(r,g,b);
		var l = ref$1[0];
		var a = ref$1[1];
		var b_ = ref$1[2];
		return lab2lch$1(l,a,b_);
	};

	var rgb2lch_1 = rgb2lch$1;

	var unpack$c = utils.unpack;
	var DEG2RAD = utils.DEG2RAD;
	var sin$3 = Math.sin;
	var cos$3 = Math.cos;

	var lch2lab$2 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		/*
		Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
		These formulas were invented by David Dalrymple to obtain maximum contrast without going
		out of gamut if the parameters are in the range 0-1.

		A saturation multiplier was added by Gregor Aisch
		*/
		var ref = unpack$c(args, 'lch');
		var l = ref[0];
		var c = ref[1];
		var h = ref[2];
		if (isNaN(h)) { h = 0; }
		h = h * DEG2RAD;
		return [l, cos$3(h) * c, sin$3(h) * c]
	};

	var lch2lab_1 = lch2lab$2;

	var unpack$b = utils.unpack;
	var lch2lab$1 = lch2lab_1;
	var lab2rgb = lab2rgb_1;

	var lch2rgb$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		args = unpack$b(args, 'lch');
		var l = args[0];
		var c = args[1];
		var h = args[2];
		var ref = lch2lab$1 (l,c,h);
		var L = ref[0];
		var a = ref[1];
		var b_ = ref[2];
		var ref$1 = lab2rgb (L,a,b_);
		var r = ref$1[0];
		var g = ref$1[1];
		var b = ref$1[2];
		return [r, g, b, args.length > 3 ? args[3] : 1];
	};

	var lch2rgb_1 = lch2rgb$1;

	var unpack$a = utils.unpack;
	var lch2rgb = lch2rgb_1;

	var hcl2rgb = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var hcl = unpack$a(args, 'hcl').reverse();
		return lch2rgb.apply(void 0, hcl);
	};

	var hcl2rgb_1 = hcl2rgb;

	var unpack$9 = utils.unpack;
	var type$d = utils.type;
	var chroma$a = chroma_1;
	var Color$t = Color_1;
	var input$6 = input$h;

	var rgb2lch = rgb2lch_1;

	Color$t.prototype.lch = function() { return rgb2lch(this._rgb); };
	Color$t.prototype.hcl = function() { return rgb2lch(this._rgb).reverse(); };

	chroma$a.lch = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$t, [ null ].concat( args, ['lch']) ));
	};
	chroma$a.hcl = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$t, [ null ].concat( args, ['hcl']) ));
	};

	input$6.format.lch = lch2rgb_1;
	input$6.format.hcl = hcl2rgb_1;

	['lch','hcl'].forEach(function (m) { return input$6.autodetect.push({
		p: 2,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$9(args, m);
			if (type$d(args) === 'array' && args.length === 3) {
				return m;
			}
		}
	}); });

	/**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
	 */

	var w3cx11$1 = {
		aliceblue: '#f0f8ff',
		antiquewhite: '#faebd7',
		aqua: '#00ffff',
		aquamarine: '#7fffd4',
		azure: '#f0ffff',
		beige: '#f5f5dc',
		bisque: '#ffe4c4',
		black: '#000000',
		blanchedalmond: '#ffebcd',
		blue: '#0000ff',
		blueviolet: '#8a2be2',
		brown: '#a52a2a',
		burlywood: '#deb887',
		cadetblue: '#5f9ea0',
		chartreuse: '#7fff00',
		chocolate: '#d2691e',
		coral: '#ff7f50',
		cornflower: '#6495ed',
		cornflowerblue: '#6495ed',
		cornsilk: '#fff8dc',
		crimson: '#dc143c',
		cyan: '#00ffff',
		darkblue: '#00008b',
		darkcyan: '#008b8b',
		darkgoldenrod: '#b8860b',
		darkgray: '#a9a9a9',
		darkgreen: '#006400',
		darkgrey: '#a9a9a9',
		darkkhaki: '#bdb76b',
		darkmagenta: '#8b008b',
		darkolivegreen: '#556b2f',
		darkorange: '#ff8c00',
		darkorchid: '#9932cc',
		darkred: '#8b0000',
		darksalmon: '#e9967a',
		darkseagreen: '#8fbc8f',
		darkslateblue: '#483d8b',
		darkslategray: '#2f4f4f',
		darkslategrey: '#2f4f4f',
		darkturquoise: '#00ced1',
		darkviolet: '#9400d3',
		deeppink: '#ff1493',
		deepskyblue: '#00bfff',
		dimgray: '#696969',
		dimgrey: '#696969',
		dodgerblue: '#1e90ff',
		firebrick: '#b22222',
		floralwhite: '#fffaf0',
		forestgreen: '#228b22',
		fuchsia: '#ff00ff',
		gainsboro: '#dcdcdc',
		ghostwhite: '#f8f8ff',
		gold: '#ffd700',
		goldenrod: '#daa520',
		gray: '#808080',
		green: '#008000',
		greenyellow: '#adff2f',
		grey: '#808080',
		honeydew: '#f0fff0',
		hotpink: '#ff69b4',
		indianred: '#cd5c5c',
		indigo: '#4b0082',
		ivory: '#fffff0',
		khaki: '#f0e68c',
		laserlemon: '#ffff54',
		lavender: '#e6e6fa',
		lavenderblush: '#fff0f5',
		lawngreen: '#7cfc00',
		lemonchiffon: '#fffacd',
		lightblue: '#add8e6',
		lightcoral: '#f08080',
		lightcyan: '#e0ffff',
		lightgoldenrod: '#fafad2',
		lightgoldenrodyellow: '#fafad2',
		lightgray: '#d3d3d3',
		lightgreen: '#90ee90',
		lightgrey: '#d3d3d3',
		lightpink: '#ffb6c1',
		lightsalmon: '#ffa07a',
		lightseagreen: '#20b2aa',
		lightskyblue: '#87cefa',
		lightslategray: '#778899',
		lightslategrey: '#778899',
		lightsteelblue: '#b0c4de',
		lightyellow: '#ffffe0',
		lime: '#00ff00',
		limegreen: '#32cd32',
		linen: '#faf0e6',
		magenta: '#ff00ff',
		maroon: '#800000',
		maroon2: '#7f0000',
		maroon3: '#b03060',
		mediumaquamarine: '#66cdaa',
		mediumblue: '#0000cd',
		mediumorchid: '#ba55d3',
		mediumpurple: '#9370db',
		mediumseagreen: '#3cb371',
		mediumslateblue: '#7b68ee',
		mediumspringgreen: '#00fa9a',
		mediumturquoise: '#48d1cc',
		mediumvioletred: '#c71585',
		midnightblue: '#191970',
		mintcream: '#f5fffa',
		mistyrose: '#ffe4e1',
		moccasin: '#ffe4b5',
		navajowhite: '#ffdead',
		navy: '#000080',
		oldlace: '#fdf5e6',
		olive: '#808000',
		olivedrab: '#6b8e23',
		orange: '#ffa500',
		orangered: '#ff4500',
		orchid: '#da70d6',
		palegoldenrod: '#eee8aa',
		palegreen: '#98fb98',
		paleturquoise: '#afeeee',
		palevioletred: '#db7093',
		papayawhip: '#ffefd5',
		peachpuff: '#ffdab9',
		peru: '#cd853f',
		pink: '#ffc0cb',
		plum: '#dda0dd',
		powderblue: '#b0e0e6',
		purple: '#800080',
		purple2: '#7f007f',
		purple3: '#a020f0',
		rebeccapurple: '#663399',
		red: '#ff0000',
		rosybrown: '#bc8f8f',
		royalblue: '#4169e1',
		saddlebrown: '#8b4513',
		salmon: '#fa8072',
		sandybrown: '#f4a460',
		seagreen: '#2e8b57',
		seashell: '#fff5ee',
		sienna: '#a0522d',
		silver: '#c0c0c0',
		skyblue: '#87ceeb',
		slateblue: '#6a5acd',
		slategray: '#708090',
		slategrey: '#708090',
		snow: '#fffafa',
		springgreen: '#00ff7f',
		steelblue: '#4682b4',
		tan: '#d2b48c',
		teal: '#008080',
		thistle: '#d8bfd8',
		tomato: '#ff6347',
		turquoise: '#40e0d0',
		violet: '#ee82ee',
		wheat: '#f5deb3',
		white: '#ffffff',
		whitesmoke: '#f5f5f5',
		yellow: '#ffff00',
		yellowgreen: '#9acd32'
	};

	var w3cx11_1 = w3cx11$1;

	var Color$s = Color_1;
	var input$5 = input$h;
	var type$c = utils.type;

	var w3cx11 = w3cx11_1;
	var hex2rgb = hex2rgb_1;
	var rgb2hex = rgb2hex_1;

	Color$s.prototype.name = function() {
		var hex = rgb2hex(this._rgb, 'rgb');
		for (var i = 0, list = Object.keys(w3cx11); i < list.length; i += 1) {
			var n = list[i];

			if (w3cx11[n] === hex) { return n.toLowerCase(); }
		}
		return hex;
	};

	input$5.format.named = function (name) {
		name = name.toLowerCase();
		if (w3cx11[name]) { return hex2rgb(w3cx11[name]); }
		throw new Error('unknown color name: '+name);
	};

	input$5.autodetect.push({
		p: 5,
		test: function (h) {
			var rest = [], len = arguments.length - 1;
			while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

			if (!rest.length && type$c(h) === 'string' && w3cx11[h.toLowerCase()]) {
				return 'named';
			}
		}
	});

	var unpack$8 = utils.unpack;

	var rgb2num$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$8(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		return (r << 16) + (g << 8) + b;
	};

	var rgb2num_1 = rgb2num$1;

	var type$b = utils.type;

	var num2rgb = function (num) {
		if (type$b(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
			var r = num >> 16;
			var g = (num >> 8) & 0xFF;
			var b = num & 0xFF;
			return [r,g,b,1];
		}
		throw new Error("unknown num color: "+num);
	};

	var num2rgb_1 = num2rgb;

	var chroma$9 = chroma_1;
	var Color$r = Color_1;
	var input$4 = input$h;
	var type$a = utils.type;

	var rgb2num = rgb2num_1;

	Color$r.prototype.num = function() {
		return rgb2num(this._rgb);
	};

	chroma$9.num = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$r, [ null ].concat( args, ['num']) ));
	};

	input$4.format.num = num2rgb_1;

	input$4.autodetect.push({
		p: 5,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			if (args.length === 1 && type$a(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) {
				return 'num';
			}
		}
	});

	var chroma$8 = chroma_1;
	var Color$q = Color_1;
	var input$3 = input$h;
	var unpack$7 = utils.unpack;
	var type$9 = utils.type;
	var round$1 = Math.round;

	Color$q.prototype.rgb = function(rnd) {
		if ( rnd === void 0 ) rnd=true;

		if (rnd === false) { return this._rgb.slice(0,3); }
		return this._rgb.slice(0,3).map(round$1);
	};

	Color$q.prototype.rgba = function(rnd) {
		if ( rnd === void 0 ) rnd=true;

		return this._rgb.slice(0,4).map(function (v,i) {
			return i<3 ? (rnd === false ? v : round$1(v)) : v;
		});
	};

	chroma$8.rgb = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$q, [ null ].concat( args, ['rgb']) ));
	};

	input$3.format.rgb = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var rgba = unpack$7(args, 'rgba');
		if (rgba[3] === undefined) { rgba[3] = 1; }
		return rgba;
	};

	input$3.autodetect.push({
		p: 3,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$7(args, 'rgba');
			if (type$9(args) === 'array' && (args.length === 3 ||
				args.length === 4 && type$9(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) {
				return 'rgb';
			}
		}
	});

	/*
	 * Based on implementation by Neil Bartlett
	 * https://github.com/neilbartlett/color-temperature
	 */

	var log$1 = Math.log;

	var temperature2rgb$1 = function (kelvin) {
		var temp = kelvin / 100;
		var r,g,b;
		if (temp < 66) {
			r = 255;
			g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp-2) + 104.49216199393888 * log$1(g);
			b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp-10) + 115.67994401066147 * log$1(b);
		} else {
			r = 351.97690566805693 + 0.114206453784165 * (r = temp-55) - 40.25366309332127 * log$1(r);
			g = 325.4494125711974 + 0.07943456536662342 * (g = temp-50) - 28.0852963507957 * log$1(g);
			b = 255;
		}
		return [r,g,b,1];
	};

	var temperature2rgb_1 = temperature2rgb$1;

	/*
	 * Based on implementation by Neil Bartlett
	 * https://github.com/neilbartlett/color-temperature
	 **/

	var temperature2rgb = temperature2rgb_1;
	var unpack$6 = utils.unpack;
	var round = Math.round;

	var rgb2temperature$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var rgb = unpack$6(args, 'rgb');
		var r = rgb[0], b = rgb[2];
		var minTemp = 1000;
		var maxTemp = 40000;
		var eps = 0.4;
		var temp;
		while (maxTemp - minTemp > eps) {
			temp = (maxTemp + minTemp) * 0.5;
			var rgb$1 = temperature2rgb(temp);
			if ((rgb$1[2] / rgb$1[0]) >= (b / r)) {
				maxTemp = temp;
			} else {
				minTemp = temp;
			}
		}
		return round(temp);
	};

	var rgb2temperature_1 = rgb2temperature$1;

	var chroma$7 = chroma_1;
	var Color$p = Color_1;
	var input$2 = input$h;

	var rgb2temperature = rgb2temperature_1;

	Color$p.prototype.temp =
		Color$p.prototype.kelvin =
			Color$p.prototype.temperature = function() {
				return rgb2temperature(this._rgb);
			};

	chroma$7.temp =
		chroma$7.kelvin =
			chroma$7.temperature = function () {
				var args = [], len = arguments.length;
				while ( len-- ) args[ len ] = arguments[ len ];

				return new (Function.prototype.bind.apply( Color$p, [ null ].concat( args, ['temp']) ));
			};

	input$2.format.temp =
		input$2.format.kelvin =
			input$2.format.temperature = temperature2rgb_1;

	var unpack$5 = utils.unpack;
	var cbrt = Math.cbrt;
	var pow$8 = Math.pow;
	var sign$1 = Math.sign;

	var rgb2oklab$2 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		// OKLab color space implementation taken from
		// https://bottosson.github.io/posts/oklab/
		var ref = unpack$5(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		var ref$1 = [rgb2lrgb(r / 255), rgb2lrgb(g / 255), rgb2lrgb(b / 255)];
		var lr = ref$1[0];
		var lg = ref$1[1];
		var lb = ref$1[2];
		var l = cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
		var m = cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
		var s = cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);

		return [
			0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
			1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
			0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s
		];
	};

	var rgb2oklab_1 = rgb2oklab$2;

	function rgb2lrgb(c) {
		var abs = Math.abs(c);
		if (abs < 0.04045) {
			return c / 12.92;
		}
		return (sign$1(c) || 1) * pow$8((abs + 0.055) / 1.055, 2.4);
	}

	var unpack$4 = utils.unpack;
	var pow$7 = Math.pow;
	var sign = Math.sign;

	/*
	 * L* [0..100]
	 * a [-100..100]
	 * b [-100..100]
	 */
	var oklab2rgb$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		args = unpack$4(args, 'lab');
		var L = args[0];
		var a = args[1];
		var b = args[2];

		var l = pow$7(L + 0.3963377774 * a + 0.2158037573 * b, 3);
		var m = pow$7(L - 0.1055613458 * a - 0.0638541728 * b, 3);
		var s = pow$7(L - 0.0894841775 * a - 1.291485548 * b, 3);

		return [
			255 * lrgb2rgb(+4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
			255 * lrgb2rgb(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
			255 * lrgb2rgb(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s),
			args.length > 3 ? args[3] : 1
		];
	};

	var oklab2rgb_1 = oklab2rgb$1;

	function lrgb2rgb(c) {
		var abs = Math.abs(c);
		if (abs > 0.0031308) {
			return (sign(c) || 1) * (1.055 * pow$7(abs, 1 / 2.4) - 0.055);
		}
		return c * 12.92;
	}

	var unpack$3 = utils.unpack;
	var type$8 = utils.type;
	var chroma$6 = chroma_1;
	var Color$o = Color_1;
	var input$1 = input$h;

	var rgb2oklab$1 = rgb2oklab_1;

	Color$o.prototype.oklab = function () {
		return rgb2oklab$1(this._rgb);
	};

	chroma$6.oklab = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$o, [ null ].concat( args, ['oklab']) ));
	};

	input$1.format.oklab = oklab2rgb_1;

	input$1.autodetect.push({
		p: 3,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack$3(args, 'oklab');
			if (type$8(args) === 'array' && args.length === 3) {
				return 'oklab';
			}
		}
	});

	var unpack$2 = utils.unpack;
	var rgb2oklab = rgb2oklab_1;
	var lab2lch = lab2lch_1;

	var rgb2oklch$1 = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var ref = unpack$2(args, 'rgb');
		var r = ref[0];
		var g = ref[1];
		var b = ref[2];
		var ref$1 = rgb2oklab(r, g, b);
		var l = ref$1[0];
		var a = ref$1[1];
		var b_ = ref$1[2];
		return lab2lch(l, a, b_);
	};

	var rgb2oklch_1 = rgb2oklch$1;

	var unpack$1 = utils.unpack;
	var lch2lab = lch2lab_1;
	var oklab2rgb = oklab2rgb_1;

	var oklch2rgb = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		args = unpack$1(args, 'lch');
		var l = args[0];
		var c = args[1];
		var h = args[2];
		var ref = lch2lab(l, c, h);
		var L = ref[0];
		var a = ref[1];
		var b_ = ref[2];
		var ref$1 = oklab2rgb(L, a, b_);
		var r = ref$1[0];
		var g = ref$1[1];
		var b = ref$1[2];
		return [r, g, b, args.length > 3 ? args[3] : 1];
	};

	var oklch2rgb_1 = oklch2rgb;

	var unpack = utils.unpack;
	var type$7 = utils.type;
	var chroma$5 = chroma_1;
	var Color$n = Color_1;
	var input = input$h;

	var rgb2oklch = rgb2oklch_1;

	Color$n.prototype.oklch = function () {
		return rgb2oklch(this._rgb);
	};

	chroma$5.oklch = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		return new (Function.prototype.bind.apply( Color$n, [ null ].concat( args, ['oklch']) ));
	};

	input.format.oklch = oklch2rgb_1;

	input.autodetect.push({
		p: 3,
		test: function () {
			var args = [], len = arguments.length;
			while ( len-- ) args[ len ] = arguments[ len ];

			args = unpack(args, 'oklch');
			if (type$7(args) === 'array' && args.length === 3) {
				return 'oklch';
			}
		}
	});

	var Color$m = Color_1;
	var type$6 = utils.type;

	Color$m.prototype.alpha = function(a, mutate) {
		if ( mutate === void 0 ) mutate=false;

		if (a !== undefined && type$6(a) === 'number') {
			if (mutate) {
				this._rgb[3] = a;
				return this;
			}
			return new Color$m([this._rgb[0], this._rgb[1], this._rgb[2], a], 'rgb');
		}
		return this._rgb[3];
	};

	var Color$l = Color_1;

	Color$l.prototype.clipped = function() {
		return this._rgb._clipped || false;
	};

	var Color$k = Color_1;
	var LAB_CONSTANTS$1 = labConstants;

	Color$k.prototype.darken = function(amount) {
		if ( amount === void 0 ) amount=1;

		var me = this;
		var lab = me.lab();
		lab[0] -= LAB_CONSTANTS$1.Kn * amount;
		return new Color$k(lab, 'lab').alpha(me.alpha(), true);
	};

	Color$k.prototype.brighten = function(amount) {
		if ( amount === void 0 ) amount=1;

		return this.darken(-amount);
	};

	Color$k.prototype.darker = Color$k.prototype.darken;
	Color$k.prototype.brighter = Color$k.prototype.brighten;

	var Color$j = Color_1;

	Color$j.prototype.get = function (mc) {
		var ref = mc.split('.');
		var mode = ref[0];
		var channel = ref[1];
		var src = this[mode]();
		if (channel) {
			var i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
			if (i > -1) { return src[i]; }
			throw new Error(("unknown channel " + channel + " in mode " + mode));
		} else {
			return src;
		}
	};

	var Color$i = Color_1;
	var type$5 = utils.type;
	var pow$6 = Math.pow;

	var EPS = 1e-7;
	var MAX_ITER = 20;

	Color$i.prototype.luminance = function(lum) {
		if (lum !== undefined && type$5(lum) === 'number') {
			if (lum === 0) {
				// return pure black
				return new Color$i([0,0,0,this._rgb[3]], 'rgb');
			}
			if (lum === 1) {
				// return pure white
				return new Color$i([255,255,255,this._rgb[3]], 'rgb');
			}
			// compute new color using...
			var cur_lum = this.luminance();
			var mode = 'rgb';
			var max_iter = MAX_ITER;

			var test = function (low, high) {
				var mid = low.interpolate(high, 0.5, mode);
				var lm = mid.luminance();
				if (Math.abs(lum - lm) < EPS || !max_iter--) {
					// close enough
					return mid;
				}
				return lm > lum ? test(low, mid) : test(mid, high);
			};

			var rgb = (cur_lum > lum ? test(new Color$i([0,0,0]), this) : test(this, new Color$i([255,255,255]))).rgb();
			return new Color$i(rgb.concat( [this._rgb[3]]));
		}
		return rgb2luminance.apply(void 0, (this._rgb).slice(0,3));
	};


	var rgb2luminance = function (r,g,b) {
		// relative luminance
		// see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
		r = luminance_x(r);
		g = luminance_x(g);
		b = luminance_x(b);
		return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	};

	var luminance_x = function (x) {
		x /= 255;
		return x <= 0.03928 ? x/12.92 : pow$6((x+0.055)/1.055, 2.4);
	};

	var interpolator$1 = {};

	var Color$h = Color_1;
	var type$4 = utils.type;
	var interpolator = interpolator$1;

	var mix$1 = function (col1, col2, f) {
		if ( f === void 0 ) f=0.5;
		var rest = [], len = arguments.length - 3;
		while ( len-- > 0 ) rest[ len ] = arguments[ len + 3 ];

		var mode = rest[0] || 'lrgb';
		if (!interpolator[mode] && !rest.length) {
			// fall back to the first supported mode
			mode = Object.keys(interpolator)[0];
		}
		if (!interpolator[mode]) {
			throw new Error(("interpolation mode " + mode + " is not defined"));
		}
		if (type$4(col1) !== 'object') { col1 = new Color$h(col1); }
		if (type$4(col2) !== 'object') { col2 = new Color$h(col2); }
		return interpolator[mode](col1, col2, f)
			.alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
	};

	var Color$g = Color_1;
	var mix = mix$1;

	Color$g.prototype.mix =
		Color$g.prototype.interpolate = function(col2, f) {
			if ( f === void 0 ) f=0.5;
			var rest = [], len = arguments.length - 2;
			while ( len-- > 0 ) rest[ len ] = arguments[ len + 2 ];

			return mix.apply(void 0, [ this, col2, f ].concat( rest ));
		};

	var Color$f = Color_1;

	Color$f.prototype.premultiply = function(mutate) {
		if ( mutate === void 0 ) mutate=false;

		var rgb = this._rgb;
		var a = rgb[3];
		if (mutate) {
			this._rgb = [rgb[0]*a, rgb[1]*a, rgb[2]*a, a];
			return this;
		} else {
			return new Color$f([rgb[0]*a, rgb[1]*a, rgb[2]*a, a], 'rgb');
		}
	};

	var Color$e = Color_1;
	var LAB_CONSTANTS = labConstants;

	Color$e.prototype.saturate = function(amount) {
		if ( amount === void 0 ) amount=1;

		var me = this;
		var lch = me.lch();
		lch[1] += LAB_CONSTANTS.Kn * amount;
		if (lch[1] < 0) { lch[1] = 0; }
		return new Color$e(lch, 'lch').alpha(me.alpha(), true);
	};

	Color$e.prototype.desaturate = function(amount) {
		if ( amount === void 0 ) amount=1;

		return this.saturate(-amount);
	};

	var Color$d = Color_1;
	var type$3 = utils.type;

	Color$d.prototype.set = function (mc, value, mutate) {
		if ( mutate === void 0 ) mutate = false;

		var ref = mc.split('.');
		var mode = ref[0];
		var channel = ref[1];
		var src = this[mode]();
		if (channel) {
			var i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
			if (i > -1) {
				if (type$3(value) == 'string') {
					switch (value.charAt(0)) {
						case '+':
							src[i] += +value;
							break;
						case '-':
							src[i] += +value;
							break;
						case '*':
							src[i] *= +value.substr(1);
							break;
						case '/':
							src[i] /= +value.substr(1);
							break;
						default:
							src[i] = +value;
					}
				} else if (type$3(value) === 'number') {
					src[i] = value;
				} else {
					throw new Error("unsupported value for Color.set");
				}
				var out = new Color$d(src, mode);
				if (mutate) {
					this._rgb = out._rgb;
					return this;
				}
				return out;
			}
			throw new Error(("unknown channel " + channel + " in mode " + mode));
		} else {
			return src;
		}
	};

	var Color$c = Color_1;

	var rgb = function (col1, col2, f) {
		var xyz0 = col1._rgb;
		var xyz1 = col2._rgb;
		return new Color$c(
			xyz0[0] + f * (xyz1[0]-xyz0[0]),
			xyz0[1] + f * (xyz1[1]-xyz0[1]),
			xyz0[2] + f * (xyz1[2]-xyz0[2]),
			'rgb'
		)
	};

	// register interpolator
	interpolator$1.rgb = rgb;

	var Color$b = Color_1;
	var sqrt$2 = Math.sqrt;
	var pow$5 = Math.pow;

	var lrgb = function (col1, col2, f) {
		var ref = col1._rgb;
		var x1 = ref[0];
		var y1 = ref[1];
		var z1 = ref[2];
		var ref$1 = col2._rgb;
		var x2 = ref$1[0];
		var y2 = ref$1[1];
		var z2 = ref$1[2];
		return new Color$b(
			sqrt$2(pow$5(x1,2) * (1-f) + pow$5(x2,2) * f),
			sqrt$2(pow$5(y1,2) * (1-f) + pow$5(y2,2) * f),
			sqrt$2(pow$5(z1,2) * (1-f) + pow$5(z2,2) * f),
			'rgb'
		)
	};

	// register interpolator
	interpolator$1.lrgb = lrgb;

	var Color$a = Color_1;

	var lab = function (col1, col2, f) {
		var xyz0 = col1.lab();
		var xyz1 = col2.lab();
		return new Color$a(
			xyz0[0] + f * (xyz1[0]-xyz0[0]),
			xyz0[1] + f * (xyz1[1]-xyz0[1]),
			xyz0[2] + f * (xyz1[2]-xyz0[2]),
			'lab'
		)
	};

	// register interpolator
	interpolator$1.lab = lab;

	var Color$9 = Color_1;

	var _hsx = function (col1, col2, f, m) {
		var assign, assign$1;

		var xyz0, xyz1;
		if (m === 'hsl') {
			xyz0 = col1.hsl();
			xyz1 = col2.hsl();
		} else if (m === 'hsv') {
			xyz0 = col1.hsv();
			xyz1 = col2.hsv();
		} else if (m === 'hcg') {
			xyz0 = col1.hcg();
			xyz1 = col2.hcg();
		} else if (m === 'hsi') {
			xyz0 = col1.hsi();
			xyz1 = col2.hsi();
		} else if (m === 'lch' || m === 'hcl') {
			m = 'hcl';
			xyz0 = col1.hcl();
			xyz1 = col2.hcl();
		} else if (m === 'oklch') {
			xyz0 = col1.oklch().reverse();
			xyz1 = col2.oklch().reverse();
		}

		var hue0, hue1, sat0, sat1, lbv0, lbv1;
		if (m.substr(0, 1) === 'h' || m === 'oklch') {
			(assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2]);
			(assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2]);
		}

		var sat, hue, lbv, dh;

		if (!isNaN(hue0) && !isNaN(hue1)) {
			// both colors have hue
			if (hue1 > hue0 && hue1 - hue0 > 180) {
				dh = hue1 - (hue0 + 360);
			} else if (hue1 < hue0 && hue0 - hue1 > 180) {
				dh = hue1 + 360 - hue0;
			} else {
				dh = hue1 - hue0;
			}
			hue = hue0 + f * dh;
		} else if (!isNaN(hue0)) {
			hue = hue0;
			if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') { sat = sat0; }
		} else if (!isNaN(hue1)) {
			hue = hue1;
			if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') { sat = sat1; }
		} else {
			hue = Number.NaN;
		}

		if (sat === undefined) { sat = sat0 + f * (sat1 - sat0); }
		lbv = lbv0 + f * (lbv1 - lbv0);
		return m === 'oklch' ? new Color$9([lbv, sat, hue], m) : new Color$9([hue, sat, lbv], m);
	};

	var interpolate_hsx$5 = _hsx;

	var lch = function (col1, col2, f) {
		return interpolate_hsx$5(col1, col2, f, 'lch');
	};

	// register interpolator
	interpolator$1.lch = lch;
	interpolator$1.hcl = lch;

	var Color$8 = Color_1;

	var num = function (col1, col2, f) {
		var c1 = col1.num();
		var c2 = col2.num();
		return new Color$8(c1 + f * (c2-c1), 'num')
	};

	// register interpolator
	interpolator$1.num = num;

	var interpolate_hsx$4 = _hsx;

	var hcg = function (col1, col2, f) {
		return interpolate_hsx$4(col1, col2, f, 'hcg');
	};

	// register interpolator
	interpolator$1.hcg = hcg;

	var interpolate_hsx$3 = _hsx;

	var hsi = function (col1, col2, f) {
		return interpolate_hsx$3(col1, col2, f, 'hsi');
	};

	// register interpolator
	interpolator$1.hsi = hsi;

	var interpolate_hsx$2 = _hsx;

	var hsl = function (col1, col2, f) {
		return interpolate_hsx$2(col1, col2, f, 'hsl');
	};

	// register interpolator
	interpolator$1.hsl = hsl;

	var interpolate_hsx$1 = _hsx;

	var hsv = function (col1, col2, f) {
		return interpolate_hsx$1(col1, col2, f, 'hsv');
	};

	// register interpolator
	interpolator$1.hsv = hsv;

	var Color$7 = Color_1;

	var oklab = function (col1, col2, f) {
		var xyz0 = col1.oklab();
		var xyz1 = col2.oklab();
		return new Color$7(
			xyz0[0] + f * (xyz1[0] - xyz0[0]),
			xyz0[1] + f * (xyz1[1] - xyz0[1]),
			xyz0[2] + f * (xyz1[2] - xyz0[2]),
			'oklab'
		);
	};

	// register interpolator
	interpolator$1.oklab = oklab;

	var interpolate_hsx = _hsx;

	var oklch = function (col1, col2, f) {
		return interpolate_hsx(col1, col2, f, 'oklch');
	};

	// register interpolator
	interpolator$1.oklch = oklch;

	var Color$6 = Color_1;
	var clip_rgb$1 = utils.clip_rgb;
	var pow$4 = Math.pow;
	var sqrt$1 = Math.sqrt;
	var PI$1 = Math.PI;
	var cos$2 = Math.cos;
	var sin$2 = Math.sin;
	var atan2$1 = Math.atan2;

	var average = function (colors, mode, weights) {
		if ( mode === void 0 ) mode='lrgb';
		if ( weights === void 0 ) weights=null;

		var l = colors.length;
		if (!weights) { weights = Array.from(new Array(l)).map(function () { return 1; }); }
		// normalize weights
		var k = l / weights.reduce(function(a, b) { return a + b; });
		weights.forEach(function (w,i) { weights[i] *= k; });
		// convert colors to Color objects
		colors = colors.map(function (c) { return new Color$6(c); });
		if (mode === 'lrgb') {
			return _average_lrgb(colors, weights)
		}
		var first = colors.shift();
		var xyz = first.get(mode);
		var cnt = [];
		var dx = 0;
		var dy = 0;
		// initial color
		for (var i=0; i<xyz.length; i++) {
			xyz[i] = (xyz[i] || 0) * weights[0];
			cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
			if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
				var A = xyz[i] / 180 * PI$1;
				dx += cos$2(A) * weights[0];
				dy += sin$2(A) * weights[0];
			}
		}

		var alpha = first.alpha() * weights[0];
		colors.forEach(function (c,ci) {
			var xyz2 = c.get(mode);
			alpha += c.alpha() * weights[ci+1];
			for (var i=0; i<xyz.length; i++) {
				if (!isNaN(xyz2[i])) {
					cnt[i] += weights[ci+1];
					if (mode.charAt(i) === 'h') {
						var A = xyz2[i] / 180 * PI$1;
						dx += cos$2(A) * weights[ci+1];
						dy += sin$2(A) * weights[ci+1];
					} else {
						xyz[i] += xyz2[i] * weights[ci+1];
					}
				}
			}
		});

		for (var i$1=0; i$1<xyz.length; i$1++) {
			if (mode.charAt(i$1) === 'h') {
				var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
				while (A$1 < 0) { A$1 += 360; }
				while (A$1 >= 360) { A$1 -= 360; }
				xyz[i$1] = A$1;
			} else {
				xyz[i$1] = xyz[i$1]/cnt[i$1];
			}
		}
		alpha /= l;
		return (new Color$6(xyz, mode)).alpha(alpha > 0.99999 ? 1 : alpha, true);
	};


	var _average_lrgb = function (colors, weights) {
		var l = colors.length;
		var xyz = [0,0,0,0];
		for (var i=0; i < colors.length; i++) {
			var col = colors[i];
			var f = weights[i] / l;
			var rgb = col._rgb;
			xyz[0] += pow$4(rgb[0],2) * f;
			xyz[1] += pow$4(rgb[1],2) * f;
			xyz[2] += pow$4(rgb[2],2) * f;
			xyz[3] += rgb[3] * f;
		}
		xyz[0] = sqrt$1(xyz[0]);
		xyz[1] = sqrt$1(xyz[1]);
		xyz[2] = sqrt$1(xyz[2]);
		if (xyz[3] > 0.9999999) { xyz[3] = 1; }
		return new Color$6(clip_rgb$1(xyz));
	};

	// minimal multi-purpose interface

	// @requires utils color analyze

	var chroma$4 = chroma_1;
	var type$2 = utils.type;

	var pow$3 = Math.pow;

	var scale$2 = function(colors) {

		// constructor
		var _mode = 'rgb';
		var _nacol = chroma$4('#ccc');
		var _spread = 0;
		// const _fixed = false;
		var _domain = [0, 1];
		var _pos = [];
		var _padding = [0,0];
		var _classes = false;
		var _colors = [];
		var _out = false;
		var _min = 0;
		var _max = 1;
		var _correctLightness = false;
		var _colorCache = {};
		var _useCache = true;
		var _gamma = 1;

		// private methods

		var setColors = function(colors) {
			colors = colors || ['#fff', '#000'];
			if (colors && type$2(colors) === 'string' && chroma$4.brewer &&
				chroma$4.brewer[colors.toLowerCase()]) {
				colors = chroma$4.brewer[colors.toLowerCase()];
			}
			if (type$2(colors) === 'array') {
				// handle single color
				if (colors.length === 1) {
					colors = [colors[0], colors[0]];
				}
				// make a copy of the colors
				colors = colors.slice(0);
				// convert to chroma classes
				for (var c=0; c<colors.length; c++) {
					colors[c] = chroma$4(colors[c]);
				}
				// auto-fill color position
				_pos.length = 0;
				for (var c$1=0; c$1<colors.length; c$1++) {
					_pos.push(c$1/(colors.length-1));
				}
			}
			resetCache();
			return _colors = colors;
		};

		var getClass = function(value) {
			if (_classes != null) {
				var n = _classes.length-1;
				var i = 0;
				while (i < n && value >= _classes[i]) {
					i++;
				}
				return i-1;
			}
			return 0;
		};

		var tMapLightness = function (t) { return t; };
		var tMapDomain = function (t) { return t; };

		// const classifyValue = function(value) {
		//     let val = value;
		//     if (_classes.length > 2) {
		//         const n = _classes.length-1;
		//         const i = getClass(value);
		//         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
		//         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
		//         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
		//     }
		//     return val;
		// };

		var getColor = function(val, bypassMap) {
			var col, t;
			if (bypassMap == null) { bypassMap = false; }
			if (isNaN(val) || (val === null)) { return _nacol; }
			if (!bypassMap) {
				if (_classes && (_classes.length > 2)) {
					// find the class
					var c = getClass(val);
					t = c / (_classes.length-2);
				} else if (_max !== _min) {
					// just interpolate between min/max
					t = (val - _min) / (_max - _min);
				} else {
					t = 1;
				}
			} else {
				t = val;
			}

			// domain map
			t = tMapDomain(t);

			if (!bypassMap) {
				t = tMapLightness(t);  // lightness correction
			}

			if (_gamma !== 1) { t = pow$3(t, _gamma); }

			t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));

			t = Math.min(1, Math.max(0, t));

			var k = Math.floor(t * 10000);

			if (_useCache && _colorCache[k]) {
				col = _colorCache[k];
			} else {
				if (type$2(_colors) === 'array') {
					//for i in [0.._pos.length-1]
					for (var i=0; i<_pos.length; i++) {
						var p = _pos[i];
						if (t <= p) {
							col = _colors[i];
							break;
						}
						if ((t >= p) && (i === (_pos.length-1))) {
							col = _colors[i];
							break;
						}
						if (t > p && t < _pos[i+1]) {
							t = (t-p)/(_pos[i+1]-p);
							col = chroma$4.interpolate(_colors[i], _colors[i+1], t, _mode);
							break;
						}
					}
				} else if (type$2(_colors) === 'function') {
					col = _colors(t);
				}
				if (_useCache) { _colorCache[k] = col; }
			}
			return col;
		};

		var resetCache = function () { return _colorCache = {}; };

		setColors(colors);

		// public interface

		var f = function(v) {
			var c = chroma$4(getColor(v));
			if (_out && c[_out]) { return c[_out](); } else { return c; }
		};

		f.classes = function(classes) {
			if (classes != null) {
				if (type$2(classes) === 'array') {
					_classes = classes;
					_domain = [classes[0], classes[classes.length-1]];
				} else {
					var d = chroma$4.analyze(_domain);
					if (classes === 0) {
						_classes = [d.min, d.max];
					} else {
						_classes = chroma$4.limits(d, 'e', classes);
					}
				}
				return f;
			}
			return _classes;
		};


		f.domain = function(domain) {
			if (!arguments.length) {
				return _domain;
			}
			_min = domain[0];
			_max = domain[domain.length-1];
			_pos = [];
			var k = _colors.length;
			if ((domain.length === k) && (_min !== _max)) {
				// update positions
				for (var i = 0, list = Array.from(domain); i < list.length; i += 1) {
					var d = list[i];

					_pos.push((d-_min) / (_max-_min));
				}
			} else {
				for (var c=0; c<k; c++) {
					_pos.push(c/(k-1));
				}
				if (domain.length > 2) {
					// set domain map
					var tOut = domain.map(function (d,i) { return i/(domain.length-1); });
					var tBreaks = domain.map(function (d) { return (d - _min) / (_max - _min); });
					if (!tBreaks.every(function (val, i) { return tOut[i] === val; })) {
						tMapDomain = function (t) {
							if (t <= 0 || t >= 1) { return t; }
							var i = 0;
							while (t >= tBreaks[i+1]) { i++; }
							var f = (t - tBreaks[i]) / (tBreaks[i+1] - tBreaks[i]);
							var out = tOut[i] + f * (tOut[i+1] - tOut[i]);
							return out;
						};
					}

				}
			}
			_domain = [_min, _max];
			return f;
		};

		f.mode = function(_m) {
			if (!arguments.length) {
				return _mode;
			}
			_mode = _m;
			resetCache();
			return f;
		};

		f.range = function(colors, _pos) {
			setColors(colors);
			return f;
		};

		f.out = function(_o) {
			_out = _o;
			return f;
		};

		f.spread = function(val) {
			if (!arguments.length) {
				return _spread;
			}
			_spread = val;
			return f;
		};

		f.correctLightness = function(v) {
			if (v == null) { v = true; }
			_correctLightness = v;
			resetCache();
			if (_correctLightness) {
				tMapLightness = function(t) {
					var L0 = getColor(0, true).lab()[0];
					var L1 = getColor(1, true).lab()[0];
					var pol = L0 > L1;
					var L_actual = getColor(t, true).lab()[0];
					var L_ideal = L0 + ((L1 - L0) * t);
					var L_diff = L_actual - L_ideal;
					var t0 = 0;
					var t1 = 1;
					var max_iter = 20;
					while ((Math.abs(L_diff) > 1e-2) && (max_iter-- > 0)) {
						(function() {
							if (pol) { L_diff *= -1; }
							if (L_diff < 0) {
								t0 = t;
								t += (t1 - t) * 0.5;
							} else {
								t1 = t;
								t += (t0 - t) * 0.5;
							}
							L_actual = getColor(t, true).lab()[0];
							return L_diff = L_actual - L_ideal;
						})();
					}
					return t;
				};
			} else {
				tMapLightness = function (t) { return t; };
			}
			return f;
		};

		f.padding = function(p) {
			if (p != null) {
				if (type$2(p) === 'number') {
					p = [p,p];
				}
				_padding = p;
				return f;
			} else {
				return _padding;
			}
		};

		f.colors = function(numColors, out) {
			// If no arguments are given, return the original colors that were provided
			if (arguments.length < 2) { out = 'hex'; }
			var result = [];

			if (arguments.length === 0) {
				result = _colors.slice(0);

			} else if (numColors === 1) {
				result = [f(0.5)];

			} else if (numColors > 1) {
				var dm = _domain[0];
				var dd = _domain[1] - dm;
				result = __range__(0, numColors, false).map(function (i) { return f( dm + ((i/(numColors-1)) * dd) ); });

			} else { // returns all colors based on the defined classes
				colors = [];
				var samples = [];
				if (_classes && (_classes.length > 2)) {
					for (var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
						samples.push((_classes[i-1]+_classes[i])*0.5);
					}
				} else {
					samples = _domain;
				}
				result = samples.map(function (v) { return f(v); });
			}

			if (chroma$4[out]) {
				result = result.map(function (c) { return c[out](); });
			}
			return result;
		};

		f.cache = function(c) {
			if (c != null) {
				_useCache = c;
				return f;
			} else {
				return _useCache;
			}
		};

		f.gamma = function(g) {
			if (g != null) {
				_gamma = g;
				return f;
			} else {
				return _gamma;
			}
		};

		f.nodata = function(d) {
			if (d != null) {
				_nacol = chroma$4(d);
				return f;
			} else {
				return _nacol;
			}
		};

		return f;
	};

	function __range__(left, right, inclusive) {
		var range = [];
		var ascending = left < right;
		var end = !inclusive ? right : ascending ? right + 1 : right - 1;
		for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
			range.push(i);
		}
		return range;
	}

	//
	// interpolates between a set of colors uzing a bezier spline
	//

	// @requires utils lab
	var Color$5 = Color_1;

	var scale$1 = scale$2;

	// nth row of the pascal triangle
	var binom_row = function(n) {
		var row = [1, 1];
		for (var i = 1; i < n; i++) {
			var newrow = [1];
			for (var j = 1; j <= row.length; j++) {
				newrow[j] = (row[j] || 0) + row[j - 1];
			}
			row = newrow;
		}
		return row;
	};

	var bezier = function(colors) {
		var assign, assign$1, assign$2;

		var I, lab0, lab1, lab2;
		colors = colors.map(function (c) { return new Color$5(c); });
		if (colors.length === 2) {
			// linear interpolation
			(assign = colors.map(function (c) { return c.lab(); }), lab0 = assign[0], lab1 = assign[1]);
			I = function(t) {
				var lab = ([0, 1, 2].map(function (i) { return lab0[i] + (t * (lab1[i] - lab0[i])); }));
				return new Color$5(lab, 'lab');
			};
		} else if (colors.length === 3) {
			// quadratic bezier interpolation
			(assign$1 = colors.map(function (c) { return c.lab(); }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2]);
			I = function(t) {
				var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t) * lab0[i]) + (2 * (1-t) * t * lab1[i]) + (t * t * lab2[i]); }));
				return new Color$5(lab, 'lab');
			};
		} else if (colors.length === 4) {
			// cubic bezier interpolation
			var lab3;
			(assign$2 = colors.map(function (c) { return c.lab(); }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3]);
			I = function(t) {
				var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t)*(1-t) * lab0[i]) + (3 * (1-t) * (1-t) * t * lab1[i]) + (3 * (1-t) * t * t * lab2[i]) + (t*t*t * lab3[i]); }));
				return new Color$5(lab, 'lab');
			};
		} else if (colors.length >= 5) {
			// general case (degree n bezier)
			var labs, row, n;
			labs = colors.map(function (c) { return c.lab(); });
			n = colors.length - 1;
			row = binom_row(n);
			I = function (t) {
				var u = 1 - t;
				var lab = ([0, 1, 2].map(function (i) { return labs.reduce(function (sum, el, j) { return (sum + row[j] * Math.pow( u, (n - j) ) * Math.pow( t, j ) * el[i]); }, 0); }));
				return new Color$5(lab, 'lab');
			};
		} else {
			throw new RangeError("No point in running bezier with only one color.")
		}
		return I;
	};

	var bezier_1 = function (colors) {
		var f = bezier(colors);
		f.scale = function () { return scale$1(f); };
		return f;
	};

	/*
	 * interpolates between a set of colors uzing a bezier spline
	 * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
	 */

	var chroma$3 = chroma_1;

	var blend = function (bottom, top, mode) {
		if (!blend[mode]) {
			throw new Error('unknown blend mode ' + mode);
		}
		return blend[mode](bottom, top);
	};

	var blend_f = function (f) { return function (bottom,top) {
		var c0 = chroma$3(top).rgb();
		var c1 = chroma$3(bottom).rgb();
		return chroma$3.rgb(f(c0, c1));
	}; };

	var each = function (f) { return function (c0, c1) {
		var out = [];
		out[0] = f(c0[0], c1[0]);
		out[1] = f(c0[1], c1[1]);
		out[2] = f(c0[2], c1[2]);
		return out;
	}; };

	var normal = function (a) { return a; };
	var multiply = function (a,b) { return a * b / 255; };
	var darken = function (a,b) { return a > b ? b : a; };
	var lighten = function (a,b) { return a > b ? a : b; };
	var screen = function (a,b) { return 255 * (1 - (1-a/255) * (1-b/255)); };
	var overlay = function (a,b) { return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255 ) * ( 1 - b / 255 )); };
	var burn = function (a,b) { return 255 * (1 - (1 - b / 255) / (a/255)); };
	var dodge = function (a,b) {
		if (a === 255) { return 255; }
		a = 255 * (b / 255) / (1 - a / 255);
		return a > 255 ? 255 : a
	};

	// # add = (a,b) ->
	// #     if (a + b > 255) then 255 else a + b

	blend.normal = blend_f(each(normal));
	blend.multiply = blend_f(each(multiply));
	blend.screen = blend_f(each(screen));
	blend.overlay = blend_f(each(overlay));
	blend.darken = blend_f(each(darken));
	blend.lighten = blend_f(each(lighten));
	blend.dodge = blend_f(each(dodge));
	blend.burn = blend_f(each(burn));
	// blend.add = blend_f(each(add));

	var blend_1 = blend;

	// cubehelix interpolation
	// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
	// http://astron-soc.in/bulletin/11June/289392011.pdf

	var type$1 = utils.type;
	var clip_rgb = utils.clip_rgb;
	var TWOPI = utils.TWOPI;
	var pow$2 = Math.pow;
	var sin$1 = Math.sin;
	var cos$1 = Math.cos;
	var chroma$2 = chroma_1;

	var cubehelix = function(start, rotations, hue, gamma, lightness) {
		if ( start === void 0 ) start=300;
		if ( rotations === void 0 ) rotations=-1.5;
		if ( hue === void 0 ) hue=1;
		if ( gamma === void 0 ) gamma=1;
		if ( lightness === void 0 ) lightness=[0,1];

		var dh = 0, dl;
		if (type$1(lightness) === 'array') {
			dl = lightness[1] - lightness[0];
		} else {
			dl = 0;
			lightness = [lightness, lightness];
		}

		var f = function(fract) {
			var a = TWOPI * (((start+120)/360) + (rotations * fract));
			var l = pow$2(lightness[0] + (dl * fract), gamma);
			var h = dh !== 0 ? hue[0] + (fract * dh) : hue;
			var amp = (h * l * (1-l)) / 2;
			var cos_a = cos$1(a);
			var sin_a = sin$1(a);
			var r = l + (amp * ((-0.14861 * cos_a) + (1.78277* sin_a)));
			var g = l + (amp * ((-0.29227 * cos_a) - (0.90649* sin_a)));
			var b = l + (amp * (+1.97294 * cos_a));
			return chroma$2(clip_rgb([r*255,g*255,b*255,1]));
		};

		f.start = function(s) {
			if ((s == null)) { return start; }
			start = s;
			return f;
		};

		f.rotations = function(r) {
			if ((r == null)) { return rotations; }
			rotations = r;
			return f;
		};

		f.gamma = function(g) {
			if ((g == null)) { return gamma; }
			gamma = g;
			return f;
		};

		f.hue = function(h) {
			if ((h == null)) { return hue; }
			hue = h;
			if (type$1(hue) === 'array') {
				dh = hue[1] - hue[0];
				if (dh === 0) { hue = hue[1]; }
			} else {
				dh = 0;
			}
			return f;
		};

		f.lightness = function(h) {
			if ((h == null)) { return lightness; }
			if (type$1(h) === 'array') {
				lightness = h;
				dl = h[1] - h[0];
			} else {
				lightness = [h,h];
				dl = 0;
			}
			return f;
		};

		f.scale = function () { return chroma$2.scale(f); };

		f.hue(hue);

		return f;
	};

	var Color$4 = Color_1;
	var digits = '0123456789abcdef';

	var floor$1 = Math.floor;
	var random = Math.random;

	var random_1 = function () {
		var code = '#';
		for (var i=0; i<6; i++) {
			code += digits.charAt(floor$1(random() * 16));
		}
		return new Color$4(code, 'hex');
	};

	var type = type$p;
	var log = Math.log;
	var pow$1 = Math.pow;
	var floor = Math.floor;
	var abs$1 = Math.abs;


	var analyze = function (data, key) {
		if ( key === void 0 ) key=null;

		var r = {
			min: Number.MAX_VALUE,
			max: Number.MAX_VALUE*-1,
			sum: 0,
			values: [],
			count: 0
		};
		if (type(data) === 'object') {
			data = Object.values(data);
		}
		data.forEach(function (val) {
			if (key && type(val) === 'object') { val = val[key]; }
			if (val !== undefined && val !== null && !isNaN(val)) {
				r.values.push(val);
				r.sum += val;
				if (val < r.min) { r.min = val; }
				if (val > r.max) { r.max = val; }
				r.count += 1;
			}
		});

		r.domain = [r.min, r.max];

		r.limits = function (mode, num) { return limits(r, mode, num); };

		return r;
	};


	var limits = function (data, mode, num) {
		if ( mode === void 0 ) mode='equal';
		if ( num === void 0 ) num=7;

		if (type(data) == 'array') {
			data = analyze(data);
		}
		var min = data.min;
		var max = data.max;
		var values = data.values.sort(function (a,b) { return a-b; });

		if (num === 1) { return [min,max]; }

		var limits = [];

		if (mode.substr(0,1) === 'c') { // continuous
			limits.push(min);
			limits.push(max);
		}

		if (mode.substr(0,1) === 'e') { // equal interval
			limits.push(min);
			for (var i=1; i<num; i++) {
				limits.push(min+((i/num)*(max-min)));
			}
			limits.push(max);
		}

		else if (mode.substr(0,1) === 'l') { // log scale
			if (min <= 0) {
				throw new Error('Logarithmic scales are only possible for values > 0');
			}
			var min_log = Math.LOG10E * log(min);
			var max_log = Math.LOG10E * log(max);
			limits.push(min);
			for (var i$1=1; i$1<num; i$1++) {
				limits.push(pow$1(10, min_log + ((i$1/num) * (max_log - min_log))));
			}
			limits.push(max);
		}

		else if (mode.substr(0,1) === 'q') { // quantile scale
			limits.push(min);
			for (var i$2=1; i$2<num; i$2++) {
				var p = ((values.length-1) * i$2)/num;
				var pb = floor(p);
				if (pb === p) {
					limits.push(values[pb]);
				} else { // p > pb
					var pr = p - pb;
					limits.push((values[pb]*(1-pr)) + (values[pb+1]*pr));
				}
			}
			limits.push(max);

		}

		else if (mode.substr(0,1) === 'k') { // k-means clustering
			/*
			implementation based on
			http://code.google.com/p/figue/source/browse/trunk/figue.js#336
			simplified for 1-d input values
			*/
			var cluster;
			var n = values.length;
			var assignments = new Array(n);
			var clusterSizes = new Array(num);
			var repeat = true;
			var nb_iters = 0;
			var centroids = null;

			// get seed values
			centroids = [];
			centroids.push(min);
			for (var i$3=1; i$3<num; i$3++) {
				centroids.push(min + ((i$3/num) * (max-min)));
			}
			centroids.push(max);

			while (repeat) {
				// assignment step
				for (var j=0; j<num; j++) {
					clusterSizes[j] = 0;
				}
				for (var i$4=0; i$4<n; i$4++) {
					var value = values[i$4];
					var mindist = Number.MAX_VALUE;
					var best = (void 0);
					for (var j$1=0; j$1<num; j$1++) {
						var dist = abs$1(centroids[j$1]-value);
						if (dist < mindist) {
							mindist = dist;
							best = j$1;
						}
						clusterSizes[best]++;
						assignments[i$4] = best;
					}
				}

				// update centroids step
				var newCentroids = new Array(num);
				for (var j$2=0; j$2<num; j$2++) {
					newCentroids[j$2] = null;
				}
				for (var i$5=0; i$5<n; i$5++) {
					cluster = assignments[i$5];
					if (newCentroids[cluster] === null) {
						newCentroids[cluster] = values[i$5];
					} else {
						newCentroids[cluster] += values[i$5];
					}
				}
				for (var j$3=0; j$3<num; j$3++) {
					newCentroids[j$3] *= 1/clusterSizes[j$3];
				}

				// check convergence
				repeat = false;
				for (var j$4=0; j$4<num; j$4++) {
					if (newCentroids[j$4] !== centroids[j$4]) {
						repeat = true;
						break;
					}
				}

				centroids = newCentroids;
				nb_iters++;

				if (nb_iters > 200) {
					repeat = false;
				}
			}

			// finished k-means clustering
			// the next part is borrowed from gabrielflor.it
			var kClusters = {};
			for (var j$5=0; j$5<num; j$5++) {
				kClusters[j$5] = [];
			}
			for (var i$6=0; i$6<n; i$6++) {
				cluster = assignments[i$6];
				kClusters[cluster].push(values[i$6]);
			}
			var tmpKMeansBreaks = [];
			for (var j$6=0; j$6<num; j$6++) {
				tmpKMeansBreaks.push(kClusters[j$6][0]);
				tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length-1]);
			}
			tmpKMeansBreaks = tmpKMeansBreaks.sort(function (a,b){ return a-b; });
			limits.push(tmpKMeansBreaks[0]);
			for (var i$7=1; i$7 < tmpKMeansBreaks.length; i$7+= 2) {
				var v = tmpKMeansBreaks[i$7];
				if (!isNaN(v) && (limits.indexOf(v) === -1)) {
					limits.push(v);
				}
			}
		}
		return limits;
	};

	var analyze_1 = {analyze: analyze, limits: limits};

	var Color$3 = Color_1;


	var contrast = function (a, b) {
		// WCAG contrast ratio
		// see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
		a = new Color$3(a);
		b = new Color$3(b);
		var l1 = a.luminance();
		var l2 = b.luminance();
		return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
	};

	var Color$2 = Color_1;
	var sqrt = Math.sqrt;
	var pow = Math.pow;
	var min = Math.min;
	var max = Math.max;
	var atan2 = Math.atan2;
	var abs = Math.abs;
	var cos = Math.cos;
	var sin = Math.sin;
	var exp = Math.exp;
	var PI = Math.PI;

	var deltaE = function(a, b, Kl, Kc, Kh) {
		if ( Kl === void 0 ) Kl=1;
		if ( Kc === void 0 ) Kc=1;
		if ( Kh === void 0 ) Kh=1;

		// Delta E (CIE 2000)
		// see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
		var rad2deg = function(rad) {
			return 360 * rad / (2 * PI);
		};
		var deg2rad = function(deg) {
			return (2 * PI * deg) / 360;
		};
		a = new Color$2(a);
		b = new Color$2(b);
		var ref = Array.from(a.lab());
		var L1 = ref[0];
		var a1 = ref[1];
		var b1 = ref[2];
		var ref$1 = Array.from(b.lab());
		var L2 = ref$1[0];
		var a2 = ref$1[1];
		var b2 = ref$1[2];
		var avgL = (L1 + L2)/2;
		var C1 = sqrt(pow(a1, 2) + pow(b1, 2));
		var C2 = sqrt(pow(a2, 2) + pow(b2, 2));
		var avgC = (C1 + C2)/2;
		var G = 0.5*(1-sqrt(pow(avgC, 7)/(pow(avgC, 7) + pow(25, 7))));
		var a1p = a1*(1+G);
		var a2p = a2*(1+G);
		var C1p = sqrt(pow(a1p, 2) + pow(b1, 2));
		var C2p = sqrt(pow(a2p, 2) + pow(b2, 2));
		var avgCp = (C1p + C2p)/2;
		var arctan1 = rad2deg(atan2(b1, a1p));
		var arctan2 = rad2deg(atan2(b2, a2p));
		var h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
		var h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
		var avgHp = abs(h1p - h2p) > 180 ? (h1p + h2p + 360)/2 : (h1p + h2p)/2;
		var T = 1 - 0.17*cos(deg2rad(avgHp - 30)) + 0.24*cos(deg2rad(2*avgHp)) + 0.32*cos(deg2rad(3*avgHp + 6)) - 0.2*cos(deg2rad(4*avgHp - 63));
		var deltaHp = h2p - h1p;
		deltaHp = abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
		deltaHp = 2*sqrt(C1p*C2p)*sin(deg2rad(deltaHp)/2);
		var deltaL = L2 - L1;
		var deltaCp = C2p - C1p;
		var sl = 1 + (0.015*pow(avgL - 50, 2))/sqrt(20 + pow(avgL - 50, 2));
		var sc = 1 + 0.045*avgCp;
		var sh = 1 + 0.015*avgCp*T;
		var deltaTheta = 30*exp(-pow((avgHp - 275)/25, 2));
		var Rc = 2*sqrt(pow(avgCp, 7)/(pow(avgCp, 7) + pow(25, 7)));
		var Rt = -Rc*sin(2*deg2rad(deltaTheta));
		var result = sqrt(pow(deltaL/(Kl*sl), 2) + pow(deltaCp/(Kc*sc), 2) + pow(deltaHp/(Kh*sh), 2) + Rt*(deltaCp/(Kc*sc))*(deltaHp/(Kh*sh)));
		return max(0, min(100, result));
	};

	var Color$1 = Color_1;

	// simple Euclidean distance
	var distance = function(a, b, mode) {
		if ( mode === void 0 ) mode='lab';

		// Delta E (CIE 1976)
		// see http://www.brucelindbloom.com/index.html?Equations.html
		a = new Color$1(a);
		b = new Color$1(b);
		var l1 = a.get(mode);
		var l2 = b.get(mode);
		var sum_sq = 0;
		for (var i in l1) {
			var d = (l1[i] || 0) - (l2[i] || 0);
			sum_sq += d*d;
		}
		return Math.sqrt(sum_sq);
	};

	var Color = Color_1;

	var valid = function () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		try {
			new (Function.prototype.bind.apply( Color, [ null ].concat( args) ));
			return true;
		} catch (e) {
			return false;
		}
	};

	// some pre-defined color scales:
	var chroma$1 = chroma_1;

	var scale = scale$2;

	var scales = {
		cool: function cool() { return scale([chroma$1.hsl(180,1,.9), chroma$1.hsl(250,.7,.4)]) },
		hot: function hot() { return scale(['#000','#f00','#ff0','#fff']).mode('rgb') }
	};

	/**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
	 */

	var colorbrewer = {
		// sequential
		OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
		PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
		BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
		Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
		BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
		YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
		YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
		Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
		RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
		Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
		YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
		Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
		GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
		Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
		YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
		PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
		Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
		PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
		Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],

		// diverging

		Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
		RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
		RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
		PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
		PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
		RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
		BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
		RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
		PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],

		// qualitative

		Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
		Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
		Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
		Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
		Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
		Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
		Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
		Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2'],
	};

	// add lowercase aliases for case-insensitive matches
	for (var i = 0, list = Object.keys(colorbrewer); i < list.length; i += 1) {
		var key = list[i];

		colorbrewer[key.toLowerCase()] = colorbrewer[key];
	}

	var colorbrewer_1 = colorbrewer;

	var chroma = chroma_1;

	// feel free to comment out anything to rollup
	// a smaller chroma.js built

	// io --> convert colors

















	// operators --> modify existing Colors










	// interpolators












	// generators -- > create new colors
	chroma.average = average;
	chroma.bezier = bezier_1;
	chroma.blend = blend_1;
	chroma.cubehelix = cubehelix;
	chroma.mix = chroma.interpolate = mix$1;
	chroma.random = random_1;
	chroma.scale = scale$2;

	// other utility methods
	chroma.analyze = analyze_1.analyze;
	chroma.contrast = contrast;
	chroma.deltaE = deltaE;
	chroma.distance = distance;
	chroma.limits = analyze_1.limits;
	chroma.valid = valid;

	// scale
	chroma.scales = scales;

	// colors
	chroma.colors = w3cx11_1;
	chroma.brewer = colorbrewer_1;

	var chroma_js = chroma;

	return chroma_js;

}));
const ColorUtils = {
	addAlpha: function (color, alphaAmount) {
		return chroma(color).alpha(alphaAmount);	
	},
	
	lighten: function (color, amount, method) {
		let [h, s, l, a] = chroma(color).hsl();
		
		if (method && method === 'relative') {
			l += l * amount / 100;
		} else {
			l += amount / 100;
		}
		
		return chroma(h, s, l, 'hsl').hex();
	},
	
	darken: function (color, amount, method) {
		let [h, s, l, a] = chroma(color).hsl();
		
		if (method && method === 'relative') {
			l -= l * amount / 100;
		} else {
			l -= amount / 100;
		}

		return chroma(h, s, l, 'hsl').hex();
	},
	
	spin: function (color, amount) {
		let [h, s, l, a] = chroma(color).hsl();
		
		let hue = (h + amount) % 360;
		h = hue < 0 ? 360 + hue : hue;
		
		return chroma(h, s, l, 'hsl').hex();
	},
	
	luma: function (color) {
		let rgb = chroma(color).rgb();
		let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
		r = (r <= 0.03928) ? r / 12.92 : Math.pow(((r + 0.055) / 1.055), 2.4);
		g = (g <= 0.03928) ? g / 12.92 : Math.pow(((g + 0.055) / 1.055), 2.4);
		b = (b <= 0.03928) ? b / 12.92 : Math.pow(((b + 0.055) / 1.055), 2.4);
		return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	},

	contrast: function (color, dark, light, threshold) {		
		if (typeof light === 'undefined') {
			light = chroma([255, 255, 255, 1.0]);
		}
		
		if (typeof dark === 'undefined') {
			dark = chroma([0, 0, 0, 1.0]);
		}
		
		// Figure out which is actually light and dark:
		if (ColorUtils.luma(dark.hex()) > ColorUtils.luma(light.hex())) {
			let t = light;
			light = dark;
			dark = t;
		}

		threshold = 0.43;
		
		if (ColorUtils.luma(color) < threshold) {
			return light;
		} else {
			return dark;
		}
	},
	
	HexToHSL: function (color) {
		return chroma(color).hsl();
	}
};

const getBWContrastingColor = (r, g, b) => {
	const rgbTotal = r * 0.299 + g * 0.587 + b * 0.114;
	if (rgbTotal > 186) {
		return '#000000';
	}
	
	return '#FFFFFF';
};

const hex2rgba = (hex, alpha = 1, asFormattedString = false) => {
	const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
	
	if (!asFormattedString) {
		return {r, g, b, alpha};
	}
	
	return `rgba(${r},${g},${b},${alpha})`;
};
/**
 * Main control object that initializes the basic html framework of the site
 * 	and provides access functions
 * @returns {SourceAudio}
 */
/* eslint-disable */
(function () {
	/** @var {JQuery} sa.body */
	sa.body = null;
	/** @var {JQuery} sa.footer */
	sa.footer = null;

	if (!config.downloadFormats || (!config.downloadFormats.mp3 && !config.downloadFormats.aiff && !config.downloadFormats.wav)) {
		sa.disableDownloading = true;
	}

	var templates;
	/** @var {FocusBox} cover */
	var cover;
	/** @var {JQuery} */
	var domBody;

	/**
	 * @returns {JQuery}
	 */
	sa.getDomBody = function () {
		if (!domBody) domBody = $j('body');
		return domBody;
	};

	/**
	 * Used to dynamically load page objects so we don't have to have them all initialized to begin with
	 * @param {string} pageName the name of the page to load. if it hasn't been loaded, a class is called to load it, named ucfirst(pageName)
	 * @returns {object} the page object
	 */
	sa.getPage = function (pageName) {
		if (!this[pageName]) {
			this[pageName] = new window[ucfirst(pageName)]();
		}
		return this[pageName];
	};

	/**
	 * Checks if the current page is the page passed in
	 * @param page should be from sa.pages
	 * @returns {boolean}
	 */
	sa.isCurrentPage = function (page) {
		return sa.currentPage && page.name && sa.currentPage.name === page.name;
	};

	/**
	 * Locks down any links passed in so they can't be clicked when the site is in lockdown mode
	 * @param {JQuery} $links
	 */
	sa.lockdownLinks = function($links) {
		$links.off().attr('href', '').on('click', (e) => { if (e) e.preventDefault(); return sa.showLockdownMessage(); });
	};

	/**
	 * Shows a message to the user that the site is in lockdown state
	 * Needs to be able to elegantly handle being called when it's already open
	 */
	sa.showLockdownMessage = function () {
		if (!lockdown) return;
		sa.templates.init(); // sometimes this function can be called without sa.init being called
		$j('.focused_container').remove();
		if (user && !user.isFullyAuthorized()) {

			sa.alert({
				text: 'You have access to this page because you were sent a link.<br/><br/>To access additional features, you must be properly authorized.',
				buttonText: 'Ok',
				onClose: function () {
					sa.showAuthForm();
				}
			});

		} else {

			sa.alert({
				text: 'This feature requires you to be logged in. Please log in or sign up to continue.',
				buttonText: 'Ok',
				onClose: function () {
					document.location.href = 'https://' + config.domain + '/login.php?forward=' + encodeURIComponent(document.location.href);
				}
			});

		}
		return false;
	};

	/**
	 * Shows a notice to the user that they need to contact SourceAudio to enable all the site's features
	 */
	sa.showGrayLabelNotice = function () {
		sa.alert({ text: 'This feature is unavailable on your workspace.<br/>Please contact SourceAudio to upgrade!', buttonText: 'Close' });
	};

	/**
	 * Locks certain page elements so they can't be clicked when the site is in lockdown mode (used when bypassing registration required)
	 */
	sa.lockdown = function () {
		var showLockdownMessage = sa.showLockdownMessage;
		sa.lockdownLinks($j('#header a'));
		sa.lockdownLinks($j('#footer a[href*="#"]'));
	};

	/**
	 * Goes to the login page
	 */
	sa.login = function () {
		var err = new Error();
		console.warn('something called sa.login', err.stack);
		//return;
		//if (!forward) forward = encodeURIComponent(document.location.href);
		//document.location.href = 'https://' + config.domain + '/login.php?forward=' + forward + (vars ? '&' + vars : '');
	};

	/**
	 * Creates the basic page elements and calls the functions to get this party started
	 */
	sa.init = function () {
		// don't double init
		if (sa.initialized) return;
		sa.initialized = true;

		// need to actually load
		sa.templates.init();
		templates = sa.templates.get('sourceaudio');
		sa.registerPages(sa.pages);

		// build all the components
		buildComponents(sa.components);

		// get the body in case anything needs it
		domBody = $j('body');

		// this flag prevents the sa object from trying to control the page content
		if (sa.objectOnly) {
			sa.triggerContinuously('start');
			return;
		}

		// at this point, we can clear everything EXCEPT Google Tag Managers's noscript tag and get started on rebuilding
		domBody.find('*').not('.keep_in_body').remove();

		sa.start(domBody, templates);

		// bad browser check
		if (BrowserDetect.isIE8down && !sa.cookies.get('ignore_browser_notice')) {
			domBody.append('<div class="browser_notice">' 
				+ `We noticed you're using an old version of Internet Explorer. SourceAudio doesn't officially support this browser and we recommend you <a href="https://www.microsoft.com/IE" target="_blank">upgrade to a newer version</a> or try a different browser, like <a href="https://google.com/chrome" target="_blank">Chrome</a> or <a href="https://www.firefox.com" target="_blank">Firefox</a>, to get the best experience.` 
				+ ' <a id="close" class="fa fa-times"></a></div>');
			$j('.browser_notice #close').on('click', function () {
				$j('.browser_notice').remove();
				sa.cookies.setIfAllowed(sa.cookieTypes.necessary, 'ignore_browser_notice', '1', 86400, true);
			});
		}
		// mac check
		if (BrowserDetect.OS == 'Mac') {
			domBody.addClass('mac');
		}

		// touch device check
		if (BrowserDetect.isTouchDevice) {
			domBody.addClass('touch');
		}

		if (!ios && BrowserDetect.isIpad) {
			loadScript(ExtraScripts.ios)
		}

		// check for resizing and move anything that needs it
		sa.on('start', function () {
			sa.handleMobileSizing(true);
			disableDraggablesOnMobile()
		});
		
		$j(window).on('resize', function () {
			sa.resize();
		});


		sa.on('routeChange', function() {
			sa.resize();
			
			// Check if we're on the homepage
			const onHomepage = $j('#body').hasClass('.homemaker_body');
			if (onHomepage) {
				$j('body').addClass('is-home-page');
			} else {
				$j('body').removeClass('is-home-page');
			}
		});

		// catch any uncaught errors
		window.addEventListener('unhandledrejection', function (event) {
			console.error('Uncaught error from window.addEventListener(unhandledrejection):', event);
			sa.onUncaughtError(event.reason); // event.reason is the Error thrown by the promise
			event.preventDefault();
		});

		setTimeout(function() {
			if (window['SpiderController'] && new Date().toDateString().indexOf('Oct 31') !== -1) new SpiderController({ minBugs: 0, maxBugs: 2, imageSprite: 'js/lib/bug/spider-sprite.png', mouseOver: 'die' });
		}, 2000);
	};

	/**
	 * Sends unhandler errors from promises to september and notifies the user.
	 * @param {Error} error
	 */
	sa.onUncaughtError = function (error) {

		// record this in september
		if (!window['user']) {
			// site manager doesn't have a user object
			window['user'] = { logged: false, userData: { id: -1, username: 'Site Manager' }, hasAdminPermission: function () { return false; } };
			window['jsRelease'] = 0;
		}
		var sepError = {
			message: error.message,
			type: error.name,
			stack: error.stack,
			url: window.location.href,
			whiteId: config.id,
			whiteName: config.name,
			userId: user.logged ? user.userData.id : 'temp-' + user.userData.id,
			userName: user.userData.username,
			userEmail: user.logged ? user.userData.email : '',
			request: 'uncaught',
			response: '',
			jsRelease: jsRelease,
			browser: BrowserDetect.OS + ' ' + BrowserDetect.browser + ' ' + BrowserDetect.version
		};
		if (config.dev) {
			console.error(error.stack);
		}
		window.lastError = sepError;
		if (sepError.message.indexOf('play() failed because') !== -1 || sepError.message === 'The operation was aborted.') {
			console.log('not sending error to september caused by autoplay not working without user interaction', sepError);
		} else if (sepError.message.indexOf('play method is not allowed by the user agent') !== -1) {
			console.log('not sending error to september caused by Firefox commit notice', sepError);
		} else if (sepError.message.indexOf('unsafe-eval') !== -1) {
			console.log('not sending error to september caused by unsafe eval (possibly a browser extension?)', sepError);
		} else if (sepError.message.indexOf('NetworkError when attempting to fetch resource') !== -1) {
			console.log('not sending error to september caused by possible browser extension in Firefox', sepError);
		} else if (typeof sepError.stack === 'string' && (sepError.stack.indexOf('@webkit-masked-url://hidden') !== -1 || sepError.stack.indexOf('@moz-extension') !== -1 || sepError.stack.indexOf('@user-script') !== -1 || sepError.stack.indexOf('chrome-extension://') !== -1)) {
			console.log('not sending error to september caused by plugin', sepError);
		} else if (sepError.message.indexOf('Connection to Indexed Database server lost. Refresh the page to try again') !== -1) {
			console.log('not sending error to september', sepError);
		} else {
			console.log('sending error (also stored in window.lastError with response in window.lastResponse):', sepError);
			$j.post('https://september.sourceaudio.com/api/monitor/error', sepError, function (r) {
				console.log('september error response:', r);
				if (window['user'] && user.hasAdminPermission(AdminPermission.SuperAdmin)) {
					r.id = '<a target="_blank" href="https://september.sourceaudio.com/errors?id=' + r.id + '">' + r.id + '</a>';
				}
				sa.notify({ text: $j(`<div>The client had a problem processing your request.<br/>If you report this issue, reference error <b>${r.id}</b></div>`) });
			}, 'json');
		}
	};
	
	function isTouchDevice() {
		return 'ontouchstart' in document.documentElement;
	}
	
	/**
	 * Fix bug on iPad where you can't scroll because of jQuery UI draggables
	 */
	function disableDraggablesOnMobile() {
		const isMobileDevice = BrowserDetect.isMobile() || BrowserDetect.isIpad;
		if (!isMobileDevice || !MutationObserver) {
			return
		}

		// Wait for all the changes to happen, then unbind jQuery UI
		var observer = new MutationObserver(_.debounce((mutationsList) => {
			$j('.ui-draggable').each(function () {
				const $target = $j(this)
				if ($target.data('ui-draggable')) {
					// must be destroyed, disabling didn't do it
					$target.draggable('destroy')
				}
			})

		}, 100));
		// Start observing the target node for configured mutations
		observer.observe(document.getElementById('body'), { childList: true, subtree: true });
	}

	sa.isMobile = function () {
		var sizes = sa.handleMobileSizing();
		return sizes.mobile;
	}
	sa.isTablet = function () {
		var sizes = sa.handleMobileSizing();
		return sizes.tablet;
	}
	sa.isDesktop = function () {
		var sizes = sa.handleMobileSizing();
		return sizes.desktop;
	}
	sa.handleMobileSizing = function (trigger = false) {
		// Disable mobile view on IE 
		if (BrowserDetect.isIE) {
			return {
				mobile: false,
				tablet: false,
				desktop: true
			}
		}
		var domBody = sa.getDomBody();

		const mobileBreakpoint = 768
		const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
		const tabletBreakpoint = BrowserDetect.isIpad ? windowWidth : 1080

		// If tablet, this will be 2, if mobile, it will be 1, if desktop it will be 0, so if we transition 
		// from one state to another, the number will change, and we can trigger view_mobile, view_desktop, view_tablet
		// correctly
		var prevSum = sa.isMobileSize + (sa.isTabletSize * 2);

		if (window.innerWidth <= tabletBreakpoint && window.innerWidth >= mobileBreakpoint) {
			// tablet
			sa.isMobileSize = false
			sa.isTabletSize = true
		} else if (window.innerWidth < mobileBreakpoint) {
			// mobile
			sa.isMobileSize = true
			sa.isTabletSize = false
		} else {
			// desktop
			sa.isMobileSize = false
			sa.isTabletSize = false
		}

		var newSum = sa.isMobileSize + (sa.isTabletSize * 2);
		var sizeChanged = (prevSum != newSum || isNaN(prevSum));

		if (domBody && sizeChanged) {
			domBody.removeClass('mobile tablet')
			if (sa.isMobileSize) domBody.addClass('mobile')
			if (sa.isTabletSize) domBody.addClass('tablet')
		}
		// If prevSum is NaN it means we are loading for the first time
		if (trigger && sizeChanged) {
			if (sa.isMobileSize){
				sa.trigger('view_mobile');
			} else if (sa.isTabletSize) {
				sa.trigger('view_tablet');
			} else {
				sa.trigger('view_desktop');
			}
		}

		return {
			mobile: sa.isMobileSize,
			tablet: sa.isTabletSize,
			desktop: !(sa.isMobileSize || sa.isTabletSize)
		}
	}

	// separated out to be overwritten by other page types
	sa.start = function (domBody, templates) {

		// attach base objects
		sa.attachComponents(sa.components, 'attachOnLoad');
		if (sa.components.nav) {
			sa.components.nav.resize();
		}

		// body
		sa.body = templates.get('body');
		domBody.append(sa.body);
		// create footer
		sa.footer = templates.get('footer' + (config.siteType === 'drop' ? '_drop' : '') + (config.id == 347 ? '_nbcuniversal' : '') + (config.id == 2846 ? '_machiavelli' : ''));
		sa.components.documentViewer.enableButtons(sa.footer);
		sa.footer.find('.cooke_manager_button').on('click', () => {
			sa.components.cookieManager.show();
		});
		domBody.append(sa.footer);
		sa.updateFooterColor();

		if (config.footerAdditional) {
			domBody.append(config.footerAdditional);
		}


		// react modal root
		const $modalRoot = $j('<div id="modal-root"></div>');
		domBody.append($modalRoot);
		window.mountReactComponent($modalRoot[0], 'global-modal-root', {});

		// set up pages
		sa.registerPages(sa.pages);

		// unescape config data
		config.seo.settings = htmlDecode(config.seo.settings);
		config.home = decodeURIComponent(config.home);

		if (!sa.router.started() && !window.noLoad) {
			firstCheck = true;
			sa.triggerContinuously('start');
			sa.router.start();
			if (lockdown) {
				sa.lockdown();
			}
		}

	};

	sa.updateFooterColor = function () {
		const [r, g, b] = domBody.css('background-color').match(/([0-9]+)/g);
		const newColor = getBWContrastingColor(r, g, b);
		
		sa.footer.css({ color: newColor });
	};

	/**
	 * Recursively builds all components and their children, maintaining and creating child/parent relationships
	 * @param components
	 */
	function buildComponents(components) {
		var component;
		var parentComponent;
		var componentName;
		for (componentName in components) {
			if (!components.hasOwnProperty(componentName)) continue;
			component = components[componentName];
			if (component['parent']) {
				parentComponent = components[component['parent']];
				if (!parentComponent) {
					console.error('Unable to find parent component for', component, 'in', Object.keys(components));
					continue;
				}
				if (!parentComponent['childComponents']) {
					parentComponent['childComponents'] = {};
				}
				parentComponent['childComponents'][componentName] = component;
				delete component['parent'];
				if (!parentComponent['built']) continue;
			}
			if (component['build']) {
				component.build();
			}
			component['built'] = true;
			if (component['childComponents']) {
				buildComponents(component['childComponents']);
			}
		}
	}

	/**
	 * Attaches all components that are set to attachOnLoad, making sure parents are attached before their children
	 * @param components
	 * @param {string} attachOnLoadType
	 */
	sa.attachComponents = function (components, attachOnLoadType) {
		var component;
		var componentName;
		for (componentName in components) {
			if (!components.hasOwnProperty(componentName)) continue;
			component = components[componentName];
			if (component['parent']) continue; // let the parent attach first. it'll handle its children
			if (component[attachOnLoadType]) {
				component.attach();
			}
			if (component['childComponents']) {
				sa.attachComponents(component['childComponents'], attachOnLoadType);
			}
		}
	};

	/**
	 * Registers all the pages with register details so they're accessible via hash
	 * @param pages
	 */
	sa.registerPages = function (pages) {
		for (let pageId in pages) {
			if (!pages.hasOwnProperty(pageId)) continue;
			let page = pages[pageId];
			
			if (page.register && (page.show || page.register.show)) {
				page.register.routes.forEach(route => {
					
					// Default Callback that is overrideable
					if (!route.hasOwnProperty('cb') && typeof route.cb !== 'function') {
						route['cb'] = params => {
							page.show(params);

							// this gives one to override the title that would be set by the router AFTER we have loaded data
							if (!route.dontSetTitle) {
								setTitle(page.title);
							}
						};
					}
					
					sa.router.addRoute(route.name, {
						pattern: route.pattern,
						hash: route.hash,
						id: route.id || null,
						redirect: route.redirect || null,
						appendParams: route.appendParams || false,
						cb: route.cb,
						navigable: route.navigable || true
					});
				});
			}
		}
	};

	var lastWidth = 0;
	sa.resize = function () {
		sa.handleMobileSizing(true);

		if (loginConfig) return;
		var newWidth = domBody.width();
		if (!lastWidth || lastWidth != newWidth) {
			lastWidth = newWidth;
			sa.trigger('resize');
		}

		// fire scroll. it does some movement stuff
		sa.scroll();
	};

	sa.scroll = function () {
		if (ios || android) return;
		$j('.dragging_tracks').trigger('mousemove');
	};

	/**
	 * Smoothly scrolls down to the specified element, taking into account static elements
	 * @param {JQuery} element
	 */
	sa.scrollToElement = function (element) {
		var elementOffset = $j(element).offset();
		if (elementOffset) {
			sa.scrollToPosition(elementOffset.top - $j('#top_bar').outerHeight());
		}

	};

	/**
	 * Smoothly scrolls down to the specified vertical position
	 * @param {number} position
	 */
	sa.scrollToPosition = function (position) {
		$j('html, body').animate({ scrollTop: position }, 500);
	};

	/**
	 * Gets the body we're going to attach everything to
	 * @return {HTMLElement} the body
	 */
	sa.getBody = function () {
		return document.body;
	};

	/**
	 * Shows a lightbox processing message on top of the whole site that the user cannot dismiss
	 * @param {string} message
	 */
	sa.showCover = function (message) {
		cover = new FocusBox(templates.get('cover', { message: message }), {
			preventClose: true, onClose: function () {
				cover = null;
			}
		});
		cover.show();
	};

	/**
	 * Hides the lightbox shown by this.showCover()
	 */
	sa.hideCover = function () {
		if (cover) {
			cover.hide();
		}
	};

})();

$j(function () {
	// don't let sourceaudio run in a frame
	if (window.top.location != window.location) {
		window.top.location.replace(window.location);
		return;
	}
	if (BrowserDetect.isIE || (BrowserDetect.isChrome && BrowserDetect.version < 49)) {
		sa.templates.init();
		sa.showCover = function () { };
		$j('body').empty();
		(new FocusBox(sa.templates.get('sourceaudio').get('browser_support_notice'), { title: 'Browser Unsupported', preventClose: true, preventRemoval: true })).show();
		return;
	}

	if (!sa.initialized) {
		if (loginConfig && ($j('body').hasClass('login_style_page') || $j('body').hasClass('site_manager'))) {
			sa.init();
		} else {
			user.loadInitialUser(function () {
				sa.init();
			});
		}
	}
});
function UploadComponent() {

	/** @var {Uploader} uploader the uploader object that will actually do the uploading */
    var uploader = null;

	var fileErrors = {};

    this.show = function (container, files) {
		var page = this;
		container.html('');

		ajax('p=import_tracks&action=perm', function(response) {
			var allowUploads = response[0]['allowUploads'];
			if (allowUploads == 'no_labels') {
				// they have no labels
				container.html('<div class="section information no_upload"><div class="guide_no_tracks">You need to add a ' + gde('label', { 'case' : 'lower', 'plural' : false })
					+ ' before you can upload tracks. Click "Manage Metadata" on the left, go to the ' + gde('catalog', { 'case' : 'lower', 'plural' : true }) + ' tab, and hit "show '
					+ gde('label', { 'case' : 'lower', 'plural' : true }) + '" to set some up!</div></div>');
			} else if (allowUploads == 'syncing') {
				// they have catalogs but they're all syncing
				container.html('<div class="section information no_upload">At this time, all your ' + gde('catalog', { 'case' : 'lower', 'plural' : true })
						+ ' are set to sync with remotely managed versions and you cannot add or edit files.<br/><br/>'
					+ 'If you have any questions please <a href="mailto:support@sourceaudio.com">contact SourceAudio</a>.</div>');
			} else if (allowUploads == 'no_catalogs') {
				// they have no catalogs at all
				container.html('<div class="section information no_upload"><div class="guide_no_tracks">You need to add a ' + gde('catalog', { 'case' : 'lower', 'plural' : false })
						+ ' before you can upload tracks. Click "Manage Metadata" on the left and go to the ' + gde('catalog', { 'case' : 'lower', 'plural' : true }) + ' tab to '
					+ 'set some up!</div></div>');
			} else {
				container.html(
					'<div class="section">'
						+ '<h2>Files to upload</h2>'
						+ '<sub class="upload_protip information multiline">Metadata will be automatically imported from mp3s.<br/>'
							+ 'Different formats of the same track will be automatically grouped if they have the same filename.<br/>'
							+ 'For example, epic_drums.mp3, epic_drums.aiff, and epic_drums.wav will be automatically grouped and metadata will be read from epic_drums.mp3</sub>'
						+ '<div class="file_list">'
							+ '<div class="file_row header"><span class="file">File</span><span class="size">Size</span><span class="remove">Remove</span><div class="clr"></div></div>'
							+ '<div class="file_row empty">No files pending upload yet. Click below to add some.</div>'
							+ '<div class="file_row footer">'
								+ '<span class="file">0 Files</span>'
								+ '<span class="size">Total: 0MB</span>'
								+ '<div class="clr"></div>'
							+ '</div>'
						+ '</div>'
						+ '<div class="section" id="upload_buttons"></div>'
					+ '</div>');

				// make an upload button
				var button = createButton('Choose Files', 'choose_files', '', getDefaultLink());
				// add it
				container.find('#upload_buttons').append(button);
				// set up the uploader object that will actually do the uploading
				uploader = new Uploader({
					button : button,
					allowMultiple : true,
					browseCallback : function(uploader) { page.handleBrowseResponse(uploader); },
					fileType : UploaderConstants.AUDIO
				});

				if (files && files.isArray && files.length) {
					uploader.addFilesToUpload(files);
				}

				sa.components.edad.addGenericDropZone({
					allowedExtensions : Uploader.GetExtensions(UploaderConstants.AUDIO),
					anchorSelector : '.tab_upload',
					templateSelector : 'upload_component_drop_zone',
					uniqueKey : 'uploader_component',
					dropCallback : function(files) {
						uploader.addFilesToUpload(files);
					}

				});
			}

			fileErrors = {};
		});
    };

	/**
	 * Updates the display after the user selects files
	 * @param {Uploader} uploader the uploader used to select
	 */
	this.handleBrowseResponse = function(uploader) {
		this.showFileList(uploader.getFileDetails());
	};

	/**
	 * Shows a list of files the user has selected for upload
	 * @param {Array} fileList all the files' information, as the uploader flash returns them
	 */
	this.showFileList = function(fileList) {
		$j('.file_row.empty, .file_row.row').remove();
		$j('#upload_button').remove();
		var totalSize = 0,
			page = this;
		if (!fileList.length) {
			$j('.file_row.footer').before($j('<div class="file_row empty">No files pending upload yet. Click below to add some.</div>'));
		} else {
			for (var i = 0, len = fileList.length; i < len; i++) {
				var file = fileList[i];
				$j('.file_row.footer').before($j(
					'<div class="file_row row" id="row_' + i + '">'
						+ '<span class="file">' + StringSanitize.encodeIfNotEncoded(file.name) + '</span>'
						+ '<span class="size">' + sizeFormat(file.size) + '</span>'
						+ '<span class="remove"><img src="images/shared/delete.png" class="faux_button"/></span>'
						+ '<div class="background"></div>'
						+ '<div class="clr"></div>'
					+ '</div>').find('img').on('click', function(id) { return function() { page.removeFile(id); }; }(file.id)).end());
				totalSize += file.size;
			}
			$j('#folder_button').after(createButton('Start Upload', 'upload_button', '', getDefaultLink(), function() {
				page.startUploads();
			}));

		}
		$j('.file_row.footer .file').html(fileList.length + ' files');
		$j('.file_row.footer .size').html('Total: ' + sizeFormat(totalSize));
	};

	/**
	 * Removes a file from the list and the uploader
	 * @param {int} fileId the id of the file to remove (comes from the file details)
	 */
	this.removeFile = function(fileId) {
		this.showFileList(uploader.removeFile(fileId));
	};

	/**
	 * Begins the recursive uploading, setting up and removing ui elements so users can't change things they shouldn't be
	 */
	this.startUploads = function() {
		var details = uploader.getFileDetails(),
			totalSize = 0;
		if (!details.length) return;
		// hide some of the file selection elements
		$j('#upload_buttons').remove();
		$j('#choose_files div').remove();
		$j('.file_row.row .remove').remove();

		// set up the overall upload progress bar
		$j('.file_list').after('<div class="section" id="overall_progress"><em>Overall Progress:</em><div class="background"></div></div>');

		// figure out the total size so we know how to calculate progress
		for (var i = 0, len = details.length; i < len; i++) {
			totalSize += details[i].size;
		}
		this.totalSize = totalSize;

		// start the upload!
		this.upload(0);
	};
	
	const retries = {};
	const baseTimeout = 120000; // 2 minutes
	let uploadTimer = null; // a setTimeout so we can show a message if the upload is taking too long
	let slowConfirm = null; // if uploadTimer triggers, we show this confirm but track it so we can hide it if the upload finishes

	/**
	 * Uploads a single file and sets up handlers to display its progress
	 * @param {int} fileIndex the index of the file to upload
	 */
	this.upload = function(fileIndex) {
		const page = this;
		const files = uploader.getFileDetails();
		
		clearTimeout(uploadTimer);
		this.setUploading(false);

		if (slowConfirm) {
			// if we were showing a "your upload is going slowly" message, hide it
			slowConfirm.hide();
			slowConfirm = null;
		}
		
		if (fileIndex < files.length) {
			this.setUploading(true);
			// find the file so when we're done, we can appropriate fill it in
			const file = files[fileIndex];
			const fileId = file.id;
			/**
			 * Handles the case where there's an error during the upload, showing a message and retrying a couple times
			 * @param {string} message
			 * @param {boolean} retry whether to retry the upload or not. Defaults to true
			 * @param {boolean} promptRetry if true, show the user a prompt before retrying. Defaults to false
			 */
			const handleError = function(message, retry = true, promptRetry = false) {
				console.log(message);
				clearTimeout(uploadTimer);
				if (slowConfirm) {
					// if we were showing a "your upload is going slowly" message, hide it
					slowConfirm.hide();
					slowConfirm = null;
				}
				if (promptRetry) {
					sa.confirm({
						text: `${message}. Would you like to try again?`,
						yesText: 'Retry File',
						noText: 'Skip File',
						yesFunction: function() {
							handleError(message);
						},
						noFunction: function() {
							handleError(message, false);
						}
					});
					return;
				}
				// retry the current fileIndex but only a couple times
				if (!retries[fileIndex]) {
					retries[fileIndex] = 1;
				} else {
					retries[fileIndex]++;
				}
				if (!retry || retries[fileIndex] > 2) {
					// since we've had to retry a couple times, just mark it as an error and move on
					$j('#row_' + fileIndex + ' .clr').before(`<div class="result">${message}</div>`);
					fileErrors[file.name] = message;
					page.updateProgress(fileIndex, file.size, file.size); // set the bar to full. it looks weird forever otherwise
					fileIndex++;
				}
				page.upload(fileIndex);
			};
			// if it takes too long to upload (or it gets stuck), show a message that lets them restart
			uploadTimer = setTimeout(function() {
				// if we're still uploading after 2 minutes, show a message that lets them restart
				slowConfirm = sa.confirm({
					text: 'The upload is taking longer than expected. Would you like to try again?',
					yesText: 'Retry File',
					noText: 'Skip File',
					yesFunction: function() {
						page.upload(fileIndex);
					},
					noFunction: function() {
						uploader.abort(); // stop the upload if it was still going
						handleError('Skipping file due to timeout', false);
					}
				});
			}, baseTimeout + (Math.floor(file.size / 104857600) * 60000)); // timeout is 2 minutes + 1 minute per 100MB
			// actually start uploading
			console.log('uploading file ' + fileId);
			
			uploader.abort(); // if an upload is already in progress, make sure it stops before we start another. otherwise, their events will overlap
			uploader.upload({
				params : 't=track',
				forceSourceAudioServer : true,
				useImportIndex : true,
				complete : function(e, serverResponse) {
					if (slowConfirm) {
						// if we were showing a "your upload is going slowly" message but the upload finished, hide the notice
						slowConfirm.hide();
						slowConfirm = null;
					}
					clearTimeout(uploadTimer);
					console.log('received upload response', serverResponse);
					if (serverResponse.length && serverResponse[0] == '{') {
						try {
							var parsedResponse = JSON.parse(serverResponse);
							if (parsedResponse && parsedResponse.error && parsedResponse.message) {
								handleError(parsedResponse.message, parsedResponse.retry !== 0);
								return;
							}
						} catch (e) {}
					} else {
						handleError('Server did not recieve file properly. Please try again.');
						return;
					}
					page.updateProgress(fileIndex, file.size, file.size);
					page.upload(fileIndex + 1);
				},
				progress : function(e, bytesLoaded, bytesTotal) {
					page.updateProgress(fileIndex, bytesLoaded, bytesTotal);
				},
				error : function(e, status) {
					console.log('upload component error', status, e);
					if (status === 0) {
						// if the network was interrupted, prompt them before retying
						handleError('Network interrupted', false, true);
					} else {
						handleError('Error during upload');
					}
				},
				fileId : fileId
			});
		} else {
			let baseUrl = siteBaseUrl();
			$j('#overall_progress .background').html('Upload Complete!');
			$j('#overall_progress').after($j('<div id="upload_finish"></div>')
				.append(createButton('Upload More', 'upload_more', '', getDefaultLink(), function() { sa.router.reloadPage(); }))
				.append(createButton('Next &raquo;', 'upload_next', '', baseUrl + '/admin?p=upload&tab=metadata')));
			
			if (Object.keys(fileErrors).length) {
				var errorString = '<div class="file_errors"><p><span class="fa fa-warning"></span>The following files could not be added:</p><ul>';
				for (var filename in fileErrors) {
					if (!fileErrors.hasOwnProperty(filename)) continue;
					errorString += '<li class="file_error"><em class="filename">' + filename + '</em><div>' + fileErrors[filename].replace('The file you uploaded', 'This file') + '</div></li>';
				}
				errorString += '</ul></div>';
				$j('#upload_finish').prepend(errorString);
			}
		}
	};

	/**
	 * Update the progress of the current bar plus the big one
	 */
	this.updateProgress = function(fileIndex, bytesLoaded, bytesTotal) {
		$j('#row_' + fileIndex + ' .background').width(($j('.file_row:first').width() + 1) * (bytesLoaded / bytesTotal));
		// update the big bar
		var files = uploader.getFileDetails(),
			size = 0;
		for (var i = 0; i < fileIndex; i++) {
			size += files[i].size;
		}
		size += files[fileIndex].size * (bytesLoaded / bytesTotal);
		$j('#overall_progress .background').width(($j('#overall_progress').width() - 155) * (size / this.totalSize));
	};

	this.setUploading = function(isUploading) {
		if (window['bufunc']) {
			window.removeEventListener('beforeunload', window['bufunc']);
			delete window['bufunc'];
		}
		if (isUploading) {
			unloadFunctions = [function() {
				if (confirm('Leaving this page will abort any in-progress uploads. Are you sure you want to leave?')) {
					unloadFunctions = [];
					return false;
				}
				return true;
			}];
			window.addEventListener('beforeunload', window['bufunc'] = function() {
				return 'Leaving the page will abort any in-progress uploads.';
			});
		} else {
			unloadFunctions = [];
		}
	};
}
function PublishComponent() {

	var templates = sa.templates.get('publish_component'),
		page = this,
		BANK_KEY = "publish_component",
		container,
		currentTracks = {};

	/**
	 * Fields used for editing
	 */
	this.selectData = {};
	this.selects = [];
	this.lastPage = 0;

	this.show = function (newContainer) {
		var button = createButton('Import Metadata', 'import_metadata_button', 'action_button', getDefaultLink());

		if (undefined !== newContainer) {
			container = newContainer;
		}

		container.html(templates.get("page", {
			bankKey: BANK_KEY
		}));
		this.loadTracks(0);

		// add a publish button
		container.find('#publish_button').on('click', function(e) {
			page.publish(false);
			e.preventDefault();
			return false;
		});
		// add a batch apply button
		container.find('#apply_button').on('click', function(e) {
			page.applyBatch();
			e.preventDefault();
			return false;
		});
		container.find('#batch_create img').on('click', function(e) {
			// this.src == 'https://secure.sourceaudio.com/dev/images/icons/mp3.png' && $j(this).attr('src') == 'images/icons/mp3.png' && wtf
			page.batchCreate(this.src.replace(/^.*images\/icons\/([a-z3]+)\.png/, '$1'));
			e.preventDefault();
			return false;
		});

		$j("#import_metadata").append(button);
		$j("#delete_all_button", container).on('click', handleDeleteAll);
		$j("#export_metadata_button", container).on('click', handleExportMetadata);
		new Uploader({ button : button, browseCallback: handleImportMetadata, fileType : UploaderConstants.CSV });
	};

	/**
	 * Loads the data from the server
	 */
	this.loadTracks = function(pg) {
		if (!pg) pg = 0;
		$j("#list_" + BANK_KEY).empty();
		$j('#it_list').html('Loading...');
		ajax('p=import_tracks&action=list&pg=' + pg, function(response) {
			page.setTracks(response[0]);
			page.setBatchFields();
			page.selectData['catalog'] = [{ type : 'catalog', items : response[0].catalogs }];
			page.lastPage = response[0].pg;
		});
	};

	/**
	 * Sets the list of fields you can update by batch
	 */
	this.setBatchFields = function() {
		var batch = $j('#batch');
		if (batch.hasClass('loaded')) return;

		var fields = [
			this.genField(config.getDictionaryEntry('album'), 'album'),
			this.genField(config.getDictionaryEntry('artist'), 'artist'),
			this.genField('BPM'),
			this.genField('Key'),
			this.genField(config.getDictionaryEntry('genre'), 'genre'),
			this.genField(config.getDictionaryEntry('tempo'), 'tempo'),
			this.genField(config.getDictionaryEntry('cue type'), 'cue_type'),
			this.genField(config.getDictionaryEntry('label'), 'label'),
			this.genField('Has Vocals', 'has_vocal'),
			this.genField('Explicit', 'explicit'),
			this.genField('Release Date', 'release_date'),
			this.genField('Keywords', 'keywords'),
			this.genField('Instruments', 'instruments'),
			this.genField('Version', 'version'),
			this.genField(config.getDictionaryEntry('writer'), 'writers'),
			this.genField(config.getDictionaryEntry('publisher'), 'publishers')
		];
		if (config.syncFlags.length) {
			fields.push(this.genField(config.getDictionaryEntry('syncflag', true), 'sync_flags'));
		}
		var html = '';
		var persistentValues = {
			writers : [],
			publishers : []
		};

		// only want catalog if there's more than one option
		if (config.catalogs.length > 1) {
			fields.push(this.genField(config.getDictionaryEntry('catalog'), 'catalog'));
		}
		// need to override default sorting because the array is full of custom objects
		fields = fields.sort(function(a, b) { return a.display > b.display ? 1 : -1; });
		// now generate the html for the select and pop it in there!
		for (var i = 0, len = fields.length; i < len; i++) {
			var field = fields[i];
			html += `<option value="${field.value}" ${(field.disabled ? 'disabled' : '')}>${field.display}</option>`;
		}
		batch.addClass('loaded').find('select').html(html).on('change', function() {
			const val = $j('#batch select:first').val();
			let input;
			$j('#batch .suggestion_box, #batch .ip_button, #batch .selectize-control').remove();
			$j('#batch .input, #apply_button').show();
			if (val == 'genre' || val == 'tempo' || val == 'cue_type' || val == 'key' || val == 'catalog' || val == 'has_vocal' || val == 'explicit') {
				// these fieldNames get a drop down box. values are loaded dynamically
				$j('#batch .input').after(input = $j('<select class="input"><option>Loading...</option></select>')).remove();
				page.loadSelect(val, input);
			} else if (val == 'sync_flags') {
				// uses a multiselect with fixed values
				$j('#batch .input').after(input = $j('<select class="input" multiple><option>Loading...</option></select>')).remove();
				input.selectize({
					delimiter : '\n',
					placeholder : 'Click to add a value to this field',
					labelField : 'value',
					searchField : 'value',
					sortField : 'value',
					valueField : 'id',
					options : config.syncFlags.map(val => { return { id : val, value : val }; })
				});
			} else if (val == 'artist' || val == 'album' || val == 'publisher' || val == 'label' || val == 'composer') {
				// these fieldNames get a smart suggestion box, dynamically showing options as the user types
				$j('#batch .input').after($j(new SuggestionBox(val)).addClass('input').trigger('focus')).remove();
			} else if (val == 'writers' || val == 'publishers') {
				$j('#batch .input').after('<a class="button ip_button">Set ' + val + '</a>');
				$j('#batch .input, #apply_button').hide();
				$j('#batch .ip_button').on('click', function(e) {
					sa.pages.details.showInterestedPartyEditor(persistentValues[val], val.substring(0, val.length - 1), function(newValue) {
						ajax({ field : val, value : newValue }, function(response) {
							if (response[0].result == 'success') {
								sa.notify({ text : 'Fields updated!' });
								page.loadTracks(page.lastPage);
								persistentValues[val] = response[0].value;
							} else {
								sa.alert({ text : response[0].result });
							}
						}, 'POST', { p : 'import_tracks', action : 'batch' });
					}, persistentValues.publishers);
					e.preventDefault();
					return false;
				});
			} else {
				$j('#batch .input').after('<input type="text" class="input"/>').remove();
				if (val == 'release_date') {
					$j('#batch .input').datepicker({ dateFormat: config.datePickerDateFormatString });
				}
			}
		}).trigger('change');
	};

	/**
	 * Utility function for setBatchFields that creates objects designed to store key information about options in the batch field select
	 * @param {string} display the display name to put in the option
	 * @param {string=} value the value to send to the server when that option is selected (optional - defaults to lowercase display)
	 * @param {boolean=} disabled whether or not the option should be disabled (optional - defaults to false)
	 * @return {object} storage object for those members
	 */
	this.genField = function(display, value, disabled) {
		if (!value) value = display.toLowerCase();
		return { display: display, value : value, disabled : disabled };
	};

	/**
	 * Applies changes to all import tracks at once using a field and value selection from the boxes at the top of the page
	 */
	this.applyBatch = function() {
		var field = $j('#batch select:first').val(),
			value = $j('#batch .input').val();
		ajax('field=' + encodeURIComponent(field) + '&value=' + encodeURIComponent(value), function(response) {
			if (response[0].result == 'success') {
				sa.notify({ text : 'Fields updated!' });
				page.loadTracks(page.lastPage);
			} else {
				sa.alert({ text : response[0].result });
			}
		}, 'POST', 'p=import_tracks&action=batch');
	};

	/**
	 * Creates files for each import track in the given type
	 * 	Basically just a shortcut for going down and hitting all the create buttons. Apparently that's not very user-friendly when you have a thousand tracks for some reason
	 * @param {string} type (aiff|mp3|wav)
	 */
	this.batchCreate = function(type) {
		ajax('type=' + encodeURIComponent(type), function(response) {
			if (response[0].result == 'success') {
				sa.notify({ text : $j('<div id="batch_create">Creating <img src="images/icons/' + type + '.png"/> files!</div>') });
				page.loadTracks(page.lastPage);
			} else {
				sa.notify({ text : response[0].result });
			}
		}, 'POST', 'p=import_tracks&action=batch_create');
	};

	/**
	 * Shows all the tracks in the queue
	 * @param {object} newData the server's response to a list request
	 * 	@property {Array.<Track>} tracks
	 * 	@property {Array} customFields
	 * 	@property {int} totalFiles
	 * 	@property {int} newCount
	 * 	@property {int} updateCount
	 */
	this.setTracks = function(newData) {
		var tracks = newData.tracks;
		var customFields = newData.customFields;
		var cont = $j('#it_list').empty();
		var tracksForTrackList = [{
			pageVars: ""
		}];
		var trackListConfig;
		var trackList;

		trackListConfig = new TrackListConfig({
			bankKey: BANK_KEY,
			pagination: false,
			resultCountChanging: false,
			defaultResultsPerPage: tracks.length,
			useFilters: false,
			affectFilters: false,
			skipWaveforms: true,
			suppressFeature: true,
			addDetailsRows: true,
			selectable: false,
			disableEmptyMessage : true
		});
		trackListConfig.addColumnList(getCustomColumnList([
			{ displayColumns : [ "play for publish", "title" ], sortable : 1, name : "Title" },
			{ displayColumns : [ "filename" ], sortable : 1, name : "Filename" },
			{ displayColumns : [ "available formats" ], sortable : 0, name : "Available Formats" },
			{ displayColumns : [ "delete" ], sortable : 0, name : "" }
		]));

		trackList = createTrackList(trackListConfig);
		// if they have no tracks, just show them what's up and get out of here
		if (!tracks.length) {
			cont.parent().html(templates.get("no_tracks_found"));
			return;
		}
		// add a summary
		$j('.publish_summary .total_files').html(newData.totalFiles.numberFormat());
		$j('.publish_summary .new_tracks').html(newData.newCount.numberFormat());
		$j('.publish_summary .track_updates').html(newData.updateCount.numberFormat());

		trackList.generatePage($j("#list_" + BANK_KEY));
		for (var t = 0, tLen = tracks.length; t < tLen; t++) {
			if (tracks[t].type == 'new') {
				tracksForTrackList.push(tracks[t]);
			}
		}
		trackList.setData(tracksForTrackList, function (vars) {
			return '/admin?' + sa.router.queryParamsToString(vars);
		});

		// kill the link on mobile
		$j(`#list_${BANK_KEY} .lr a`).removeAttr('href');
		// make clicking the tracks open metadata
		$j(`#list_${BANK_KEY} .lr td:not(:first)`).addClass('faux_button').on('click', function (e) {
			var itemId = $j(this).closest(".lr").data("trackId");
			var detailRow = $j('.lr_detail_row[data-item-id="' + itemId + '"]');

			detailRow.toggle(0);
			if (!detailRow.is(":hidden")) {
				sa.scrollToElement(detailRow);
			}
			e.preventDefault();
			return false;
		});

		$j("#list_" + BANK_KEY + " .lr").each(function () {
			var deleteButtonCell = templates.get("delete_button_cell");
			var trackId = $j(this).data("trackId");
			var track = _.find(tracks, function (track) {
				return trackId == track.id;
			});

			deleteButtonCell.on('click', function(e) {
				if (undefined !== track) {
					page.deleteTrack(track);
				} else {
					sa.alert({ text : 'Unable to delete track at this time. Please contact SourceAudio if this problem persists' });
				}
				e.preventDefault();
				return false;
			});

			$j(this).append($j('<td></td>').append(deleteButtonCell));
		});

		$j('.lr_detail_row td').attr('colspan', 5);

		$j(".list_item_title").each(function () {
			$j(this).closest("div").addClass("list_title_contents");
			$j(this).replaceWith($j(this).contents());
		});

		$j(".lc_filename").each(function () {
			var contents = $j(this).text(),
				searchResults = contents.match(/^(.+)\.(?:mp3|aiff|wav)$/i);

			if (null !== searchResults) {
				$j(this).text(searchResults[1]);
			}
		});

		currentTracks = {};

		let baseUrl = siteBaseUrl();

		for (var i = 0, len = tracks.length; i < len; i++) {
			var track = tracks[i],
				trackContainer,
				genreString = '',
				tempoString = '',
				cueTypeString = '';

			currentTracks[track.id] = track;

			if (track.type == 'new') {
				var j, jLen;
				// genre
				for (j = 0, jLen = track.genres.length; j < jLen; j++) {
					var genre = track.genres[j];
					genreString += (j ? ', ' : '') + genre.name;
				}
				// tempo
				for (j = 0, jLen = track.tempos.length; j < jLen; j++) {
					var tempo = track.tempos[j];
					tempoString += (j ? ', ' : '') + tempo.name;
				}
				// cue type
				for (j = 0, jLen = track.cueTypes.length; j < jLen; j++) {
					var cueType = track.cueTypes[j];
					cueTypeString += (j ? ', ' : '') + cueType.name;
				}
				// writers
				var writersStrings = [];
				for (var w = 0, wLen = track.writers.length; w < wLen; w++) {
					var writer = track.writers[w];
					writersStrings.push('<a class="person" href="'+baseUrl+'/writer/' + writer.id + '">' + htmlEncode(writer.name)
						+ (writer.affiliation.id ? ' (' + writer.affiliation.name + ')' : '')
						+ (parseFloat(writer.ownershipShare) > 0 ? ' - ' + writer.ownershipShare + '%' : '') + '</a>');
				}
				var publishersStrings = [];
				for (var pub = 0, pubLen = track.publishers.length; pub < pubLen; pub++) {
					var publisher = track.publishers[pub];
					publishersStrings.push('<a class="person" href="'+baseUrl+'/publisher/' + publisher.id + '">' + htmlEncode(publisher.name)
						+ (publisher.affiliation.id ? ' (' + publisher.affiliation.name + ')' : '')
						+ (parseFloat(publisher.ownershipShare) > 0 ? ' - ' + publisher.ownershipShare + '%' : '') + '</a>');
				}
				var workNumberContainer = $j('<div/>');
				if (track.workNumbers.length > 1) workNumberContainer.append('<br/>');
				for (w = 0, wLen = track.workNumbers.length; w < wLen; w++) {
					var workNumberTemplate = templates.get('details_work_number'),
						workNumber = track.workNumbers[w];
					workNumberTemplate.find('.affiliation').html(workNumber.affiliation.name);
					workNumberTemplate.find('.number').html(htmlEncode(workNumber.workNumber));
					workNumberContainer.append(workNumberTemplate);
				}
				workNumberContainer.find('br:last').remove();
				trackContainer = $j(templates.get("track_container", {
					trackId : track.id,
					trackLength : '' + (track.length < 1 ? (Math.round(track.length * 100) / 100) + 's' : secondsToClockTime(track.length)),
					trackTitle : track.title,
					catalogName : track.catalog.name,
					trackLabel : track.label,
					filename : track.filename.replace('.mp3', ''),
					releaseDate : track.date,
					album : track.album,
					genre : genreString,
					tempo : tempoString,
					cueType : cueTypeString,
					description : track.description,
					keywords : track.keywords,
					instruments : track.instruments,
					version : track.version,
					trackNumber : track.trackNumber,
					artist : track.artist,
					writers : writersStrings.join('<br/>'),
					publishers : publishersStrings.join('<br/>'),
					isrc : track.isrc,
					iswc : track.iswc,
					syncFlags : track.syncFlags.join(', '),
					workNumbers : workNumberContainer.html(),
					style : track.style,
					mood : track.mood,
					bpm : (track.bpm ? track.bpm : '0 (not set)'),
					styleOf : track.styleOf,
					key : track.key.name,
					hasVocals : (track.has_vocal == 2 ? 'Unspecified' : (track.has_vocal ? 'Yes' : 'No')),
					explicit : (track.explicit == 2 ? 'Unspecified' : (track.explicit ? 'Yes' : 'No')),
					lyrics : track.lyrics
				}));
				//cont.append(trackContainer);
				$j('.lr_detail_row[data-item-id="' + track.id + '"] td').append($j(trackContainer));

				trackContainer.find('#play_container').append(sa.components.player.generatePlayButton(track.id, { location : 'upload', importTrack : track }));
				this.makeEditable(track.id, trackContainer.find('h3 span'), trackContainer.find('h3'), 'title', track.title);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_artist span'), trackContainer.find('#details_subsection_artist'), 'artist', track.artist);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_album span'), trackContainer.find('#details_subsection_album'), 'album', track.album);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_track_number span'), trackContainer.find('#details_subsection_track_number'), 'track_number', track.trackNumber && track.trackNumber != '0' ? track.trackNumber : '');
				this.makeEditable(track.id, trackContainer.find('#details_subsection_label span'), trackContainer.find('#details_subsection_label'), 'label', track['label']);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_writers:first span'), trackContainer.find('#details_subsection_writers:first'), 'writers', track.writers);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_publishers:first span'), trackContainer.find('#details_subsection_publishers:first'), 'publishers', track.publishers);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_isrc span'), trackContainer.find('#details_subsection_isrc'), 'isrc', track.isrc);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_iswc span'), trackContainer.find('#details_subsection_iswc'), 'iswc', track.iswc);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_work_numbers span'), trackContainer.find('#details_subsection_work_numbers'), 'work_numbers', track.workNumbers);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_genre span'), trackContainer.find('#details_subsection_genre'), 'genre', track.genres);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_tempo span'), trackContainer.find('#details_subsection_tempo'), 'tempo', track.tempos);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_cue_type span'), trackContainer.find('#details_subsection_cue_type'), 'cue_type', track.cueTypes);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_bpm span'), trackContainer.find('#details_subsection_bpm'), 'bpm', track.bpm);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_description span'), trackContainer.find('#details_subsection_description'), 'description', track.description, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_keywords span'), trackContainer.find('#details_subsection_keywords'), 'keywords', track.keywords, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_instruments span'), trackContainer.find('#details_subsection_instruments'), 'instruments', track.instruments, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_version span'), trackContainer.find('#details_subsection_version'), 'version', track.version, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_style_of span'), trackContainer.find('#details_subsection_style_of'), 'style_of', track.styleOf, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_lyrics div'), trackContainer.find('#details_subsection_lyrics b'), 'lyrics', track.lyrics, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_mood span'), trackContainer.find('#details_subsection_mood'), 'mood', track.mood, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_style span'), trackContainer.find('#details_subsection_style'), 'style', track.style, true);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_key span'), trackContainer.find('#details_subsection_key'), 'key', track.key.name);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_has_vocal span'), trackContainer.find('#details_subsection_has_vocal'), 'has_vocal', track.has_vocal);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_explicit span'), trackContainer.find('#details_subsection_explicit'), 'explicit', track.explicit);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_release_date span'), trackContainer.find('#details_subsection_release_date'), 'release_date', track.date);
				this.makeEditable(track.id, trackContainer.find('#details_subsection_filename span'), trackContainer.find('#details_subsection_filename'), 'filename', track.filename.replace('.mp3', ''));
				if (config.catalogs.length > 1) {
					this.makeEditable(track.id, trackContainer.find('#details_subsection_catalog span'), trackContainer.find('#details_subsection_catalog'), 'catalog', track.catalog.name);
				}
				if (config.syncFlags?.length) {
					this.makeEditable(track.id, trackContainer.find('#details_subsection_sync_flags span'), trackContainer.find('#details_subsection_sync_flags'), 'sync_flags', track.syncFlags);
				} else {
					trackContainer.find('#details_subsection_sync_flags').remove();
				}

				var customs = trackContainer.find('#details_subsection_customs');
				if (0 === customFields.length) {
					$j(customs).closest(".custom_fields").hide();
				} else {
					// custom fields
					for (j = 0, jLen = customFields.length; j < jLen; j++) {
						var customFieldData = customFields[j],
							nameSearch = customFieldData.name.toLowerCase(),
							value = '',
							custom = null;
						// search through the set custom fields to see if this one has a value already
						if (track.customFields[nameSearch]) {
							value = track.customFields[nameSearch];
						}
						custom = $j('<div id="details_subsection_' + customFieldData.name.replace(' ', '_').toLowerCase() + '" class="custom_field_' + customFieldData.id + '"><b>' + customFieldData.name
						+ ':</b> <span>' + value + '</span></div>');
						customs.append(custom);
						this.makeEditable(track.id, custom.find('span'), custom, 'custom_field_' + customFieldData.id, value, false, customFieldData.name, customFieldData.is_list);
					}
				}

				// delete button
				trackContainer.find('#details_edit_title').after($j('<a href="' + getDefaultLink() + '" class="edit_button"><span class="icon fa fa-times"></span></a>')
						.on('click', function(track) { return function(e) { page.deleteTrack(track); e.preventDefault(); return false; }; }(track))
						.attr('title', 'Click to delete track'));
				// format buttons
				for (var format in track.formats) {
					if (!track.formats.hasOwnProperty(format)) continue;
					var val = track.formats[format],
						formatContainer = trackContainer.find('#' + format);
					if (val == 'g' || val == 'i') {
						formatContainer.find('img').attr('src', 'images/icons/' + format + '-faded.png').attr('title', 'Not yet uploaded');
						formatContainer.find('.options').append(
							'<div></div>'
							+ '<div><label><input type="radio" name="format_' + format + '_' + track.id + '" value="g"' + (val == 'g' ? ' checked="checked"' : '') + '/> Have SourceAudio create</label></div>'
							+ '<div><label><input type="radio" name="format_' + format + '_' + track.id + '" value="i"' + (val == 'i' ? ' checked="checked"' : '') + '/> Don\'t add</label></div>'
						).find('div:first').append(createButton('Browse to add', '', '', getDefaultLink(), function(track, format) { return function() {
							page.changeFormat(track, format, 'a');
						}; }(track, format)));
						formatContainer.find('.options input').on('click', function(track, format) { return function() {
							page.changeFormat(track, format, this.value);
							//e.preventDefault();
							//return false;
						};}(track, format));
					} else {
						formatContainer.find('.left').append('<span class="size">' + sizeFormat(val) + '</span>');
						formatContainer.find('.options')
							.append($j('<a href="' + getDefaultLink() + '" class="remove" title="Delete this format"><span class="icon fa fa-times"></span> Delete this format</a>')
								.on('click', function(track, format) { return function(e) {
									page.deleteFormat(track, format);
									e.preventDefault();
									return false;
								};}(track, format)));
					}
				}
			} else {
				cont.append(trackContainer = $j(`
					<div class="import_track track_details track_update" id="update_track_${track.id}">
						<h3><span id="title">${track.filename}</span></h3>'
						<div class="target">Will add as ${track.format == 'wav' ? 'a' : 'an'} ${track.format === 'wav' || track.format === 'mp3' || track.format === 'aiff' ? `<img alt="${track.format}" src="images/icons/${track.format}.png">` : 'extra file'} to track "<a href="${getTrackLink(track.track.id)}">${track.track.title}</a>"
						<div id="options">
							<div class="instructions">If this file was supposed to be a new track, please delete it, give it a unique filename, and upload it again.</div>
							<div class="instructions">If this file was supposed to attach to a different track, please delete it, give it a filename that matches that track, and upload it again.</div>
						</div>
						<div class="clr"></div>
					</div>
				`));
				// delete button
				trackContainer.find('#title').after($j('<a href="' + getDefaultLink() + '" class="edit_button"><span class="fa fa-times"></span></a>')
						.on('click', function(track) { return function(e) { page.deleteTrack(track); e.preventDefault(); return false; }; }(track))
						.attr('title', 'Click to delete file'));
			}
		}

		// set up pages
		sa.pagination.addPagination({
			currentPage : newData.pg,
			totalItems : newData.resultCount,
			perPage : newData.resultsPerPage,
			callback : function(newPage) {
				page.loadTracks(newPage);
			},
			container : cont
		});
	};

	/**
	 * Removes a specific format from the track, giving the user the option to delete the file or make it a separate track
	 * @param {Track} track the track to remove the format from
	 * @param {string} format the format you want to remove
	 */
	this.deleteFormat = function(track, format) {
		var formatCount = 0;
		for (var formatType in track.formats) {
			if (!track.formats.hasOwnProperty(formatType)) continue;
			if (!isNaN(track.formats[formatType])) {
				formatCount++;
			}
		}
		if (formatCount > 1) {
			sa.confirm({
				text : 'Do you want to delete this ' + format + ' file or make it a separate track?<br/><br/>To cancel, click outside the box.',
				yesFunction : function () {
					ajax('trackId=' + track.id + '&format=' + format + '&secureToken=' + user.secureToken,
						function (response) {
							if (response[0].result == 'success') {
								sa.notify({ text : 'Format deleted!' });
								page.show();
							} else {
								sa.notify({ text : response[0].result });
							}
						}, 'POST', 'p=import_tracks&action=deleteFormat');
				},
				noFunction : function () {
					ajax('trackId=' + track.id + '&format=' + format + '&secureToken=' + user.secureToken,
						function (response) {
							if (response[0].result == 'success') {
								sa.notify({ text : 'Format separated!' });
								page.show();
							} else {
								sa.notify({ text : response[0].result });
							}
						}, 'POST', 'p=import_tracks&action=separateFormat');
				},
				yesText : 'Delete',
				noText : 'Separate'
			});
		} else {
			page.deleteTrack(track);
		}
	};

	/**
	 * Updates the setting for one of a track's file formats
	 * @param {Track} track the track to change
	 * @param {string} format format we're changing setting for (mp3|aiff|wav)
	 * @param {string} newSetting the new setting for the format (g|i|a)
	 */
	this.changeFormat = function(track, format, newSetting) {
		if (newSetting == 'g' || newSetting == 'i') {
			ajax('trackId=' + track.id + '&format=' + encodeURIComponent(format) + '&setting=' + newSetting, function(response) {
				if (response[0].result == 'success') {
					sa.notify({ text : 'Setting saved!' });
				} else {
					sa.notify({ text : response[0].result });
				}
			}, 'POST', 'p=import_tracks&action=changeFormatSetting');
			return
		}
		// they want to choose. time to get nuts
		var letter = format == 'wav' ? '' : 'n';
		var content = templates.get('format_selector', { letter : letter, format : format });
		var fb = new FocusBox(content);
		content.find('#cancel_button').on('click', function(e) {
			fb.hide();
			e.preventDefault();
			return false;
		});
		fb.show();

		// make an upload button
		new Uploader({ button : content.find('#choose_files'), browseCallback : function(uploader) {
			page.startUploads(uploader, track, format, fb);
		}, fileType : (format == 'mp3' ? UploaderConstants.MP3 : (format == 'aiff' ? UploaderConstants.AIFF : UploaderConstants.WAV)) });

		ajax('p=import_tracks&action=listFormats&format=' + encodeURIComponent(format), function(response) {
			var list = content.find('.format_list').empty(),
				tracks = response[0].tracks;
			if (!tracks.length) {
				list.addClass('empty').html('You don\'t have any unassigned ' + format + ' files. To add some, use the upload tab above or separate a' + letter + ' ' + format + ' from another track.');
				return;
			}
			for (var i = 0, len = tracks.length; i < len; i++) {
				var chooseTrack = tracks[i];
				var trackContainer = templates.get('format_selector_track_container', {
					trackId : chooseTrack.id,
					length : (chooseTrack.length < 1 ? (Math.round(chooseTrack.length * 100) / 100) + 's' : secondsToClockTime(chooseTrack.length)),
					title : chooseTrack.title
				});
				trackContainer.find('.select_button').on('click', function(selectedTrack) { return function(e) {
					$j('.select_button, .format_selector #choose_files, .format_selector #cancel_button').remove();
					ajax('trackId=' + track.id + '&format=' + format + '&chooseTrackId=' + selectedTrack.id,
						function(response) {
							fb.hide();
							if (response[0].result == 'success') {
								sa.notify({ text : 'File associated!' });
								page.loadTracks(page.lastPage);
							} else {
								sa.alert({ text : response[0].result });
							}
						}, 'POST', 'p=import_tracks&action=mergeTracks');
					e.preventDefault();
					return false;
				};}(chooseTrack));
				trackContainer.find('#play_container').append(sa.components.player.generatePlayButton(chooseTrack.id, { location : 'upload', importTrack : chooseTrack }));
				list.append(trackContainer);
			}
			$j('.format_list .import_track:last').addClass('last');
		});
	};

	/**
	 * Actually starts the upload
	 * @param {Uploader} uploader the uploader
	 * @param {Track} track the track being uploaded to
	 * @param {string} format the format of the file to upload (wav|aiff|mp3)
	 * @param {FocusBox} fb the focus box containing the upload
	 */
	this.startUploads = function(uploader, track, format, fb) {
		var files = uploader.getFileDetails();
		if (!files.length) return;

		// hide some of the file selection elements
		$j('.format_selector #choose_files, .format_selector #cancel_button, .format_selector h2, .format_selector .format_list').remove();
		$j('.file_row').addClass('uploading');

		var file = files[0];
		var fillRow = $j('.format_selector .file_row .fill');
		fillRow.css({ width : 0 });
		$j('.format_selector .file_row .text').html(file.name + ' - ' + sizeFormat(file.size));

		// start the upload!
		var previousLoaded = 0;
		uploader.upload({
			params : 't=track&attachTo=' + track.id,
			complete : function(e, serverResponse) {
				console.log('received upload response', serverResponse);
				if (serverResponse.length && serverResponse[0] == '{') {
					try {
						var parsedResponse = JSON.parse(serverResponse);
						if (parsedResponse && parsedResponse.error && parsedResponse.message) {
							sa.notify({ text : parsedResponse.message });
							page.show();
							fb.hide();
							return;
						}
					} catch (e) {

					}
				}
				sa.notify({ text : 'Format uploaded!' });
				page.show();
				fb.hide();
			},
			progress : function(e, bytesLoaded, bytesTotal) {
				var loaded = (bytesLoaded / bytesTotal);
				if (loaded != previousLoaded) {
					fillRow.css({ width : loaded * 100 + '%' });
					if (loaded == 1) {
						$j('.format_selector .file_row .text').html('Processing...');
					}
					previousLoaded = loaded;
				}
			},
			error : function() { console.log('error during upload'); },
			fileId : file.id
		});
	};

	/**
	 * Appends an edit button within the given container, allowing a text field to be edited
	 * @param {int} trackId the id the track being edited
	 * @param {JQuery} e the element containg the text to be edited
	 * @param {JQuery} cont the container holding the element
	 * @param {string} fieldName the name of the field. Used to generated a form field name
	 * @param {string} value the current value of the field
	 * @param {boolean=} large should the text field be an input or a textarea? Defaults to false
	 * @param {string=} displayName the name to display in the 'click to add' text. defaults to fieldName
	 * @param {boolean=} smartBox should this use a smart selection box? defaults to determined by fieldName
	 */
	this.makeEditable = function(trackId, e, cont, fieldName, value, large, displayName, smartBox) {
		var plus = false;
		displayName = displayName ? displayName : fieldName.replace('_', ' ');
		if (value == undefined || value === '' || (fieldName == 'key' && value == 'Unspecified') || ((fieldName == 'genre' || fieldName == 'tempo' || fieldName == 'cue_type') && !value.length)) {
			e.html('click button to add ' + displayName.toLowerCase()).addClass('artist_profile_editable');
			plus = true;
		} else {
			e.removeClass('artist_profile_editable');
		}
		if (!large) large = false;
		if (!value) value = '';
		cont.css('display', 'block')
			.append($j('<a href="' + getDefaultLink() + '" id="details_edit_' + fieldName.replace(' ', '_') + '" class="edit_button fa fa-' + (plus ? 'plus' : 'edit') + '"></a>')
				.on('click', function(e) { page.allowInput($j(this)); e.preventDefault(); return false; })
				.data({
					large : large,
					cont : cont,
					value : value,
					fieldName : fieldName,
					displayName : displayName,
					smartBox : !!smartBox,
					trackId : trackId
				})
				.attr('title', 'Click to ' + (plus ? 'add' : 'edit') + ' field'));
	};

	/**
	 * Populates a select box after data's loaded from the server
	 * @param {JSON} newData the info from the server (probably from lists.php)
	 */
	this.populateSelect = function(newData) {
		var type = newData[0].type,
			t = this,
			selects = this.selects[type],
			items = newData[0].items,
			extraOptions = type == 'genre' || type == 'tempo' || type == 'cue_type';
		this.selectData[type] = newData;
		for (var j = 0, jLen = selects.length; j < jLen; j++) {
			var select = $j(selects[j]),
				selectedValue = select.val(),
				html = '';
			if (extraOptions) {
				html = '<option value="0">-----</option>';
			}
			for (var i = 0, len = items.length; i < len; i++) {
				var item = items[i],
					itemId = item.id,
					itemValue = item.value;
				if (type == 'catalog' && itemValue === undefined) {
					html += '<option value="' + item.replace('"', '&quot;') + '">' + item + '</option>';
				} else if (type == 'key') {
					html += '<option value="' + itemValue + '"' + (itemValue == selectedValue ? ' selected="selected"' : '') + '>' + itemValue + '</option>';
				} else {
					html += '<option value="' + itemId + '"' + (itemId == selectedValue ? ' selected="selected"' : '') + '>' + itemValue + '</option>';
				}
			}
			if (extraOptions) {
				html += '<option value="-1">add new</option>';
				select.off('change').on('change', function(select) { return function() {
					if ($j(this).val() != -1) return;
					sa.prompt({
						placeholder : 'New ' + gde(type.replace('_', ' '), { c : 'lower', p : false }) + ' name',
						yesFunction : function(inputValue, interactionOptions) {
							// validate the new value
							if (!inputValue) {
								interactionOptions.showError('Please enter a name.');
							} else if (inputValue.length > 64 || inputValue.length < 2) {
								interactionOptions.showError('Name must be between 2 and 64 characters.');
							} else if (!inputValue.match(/^[0-9a-z\-_ ()+\/&:]+$/i)) {
								interactionOptions.showError('Names may only contain letters, numbers, spaces, hyphens, and slashes.');
							} else {
								ajax({ name : inputValue },
									function(response) {
										if (response[0].result == 'success') {
											var newValue = response[0].newValue;
											selects.find('option[value=-1]').before('<option value="' + newValue.id + '">' + newValue.value + '</option>');
											select.val(newValue.id);
											t.selectData[type] = null;
										} else {
											select.val('0');
											sa.notify({ text : response[0].result });
										}
									}, 'POST', 'p=relational_fields&action=new&type=' + type);
								return false;
							}
							return true;
						},
						yesText : 'Create'
					});
				}; }(select));
			}
			select.html(html);
		}
	};

	/**
	 * Loads the values for a select box
	 * @param {string} type the name of the field we're going to load
	 * @param {JQuery} select the drop down box(es) on the page
	 */
	this.loadSelect = function(type, select) {
		this.selects[type] = select;
		if (type == 'has_vocal') {
			this.populateSelect(
				[{
					type : "has_vocal",
					items : [
						{
							id : 2,
							value : 'Unspecified'
						}, {
							id : 1,
							value : 'Yes'
						}, {
							id : 0,
							value : 'No'
						}
					]
				}]);
		} else if (type == 'explicit') {
			this.populateSelect(
				[{
					type : "explicit",
					items : [
						{
							id : 2,
							value : 'Unspecified'
						}, {
							id : 1,
							value : 'Yes'
						}, {
							id : 0,
							value : 'No'
						}
					]
				}]);
		} else if (type == 'sync_flags') {
			this.populateSelect(
				[{
					type : "sync_flags",
					items : config.syncFlags.map(value => { return { id : value, value : value }})
				}]);
		} else	if (this.selectData[type] != undefined && this.selectData[type] != null) {
			this.populateSelect(this.selectData[type]);
		} else {
			ajax('p=list&type=' + type + '&ids=1', function(response) { page.populateSelect(response); });
		}
	};

	// you can make several calls to this function before it has time to load anything. only the first call will initiate an ajax request and the other callbacks are added to a list, to be fired when we get the data
	var personListFields = null,
		personListFieldCallbacks = [],
		loadingPersonListFields = false;
	function loadPersonListFields(callback) {
		if (personListFields) {
			return callback(personListFields);
		}
		personListFieldCallbacks.push(callback);
		if (loadingPersonListFields) return;
		loadingPersonListFields = true;
		ajax({ p : 'people', action : 'loadListFieldValues' }, function(response) {
			personListFields = response;
			for (var i = 0, len = personListFieldCallbacks.length; i < len; i++) {
				personListFieldCallbacks[i](personListFields);
			}
		});
	}

	/**
	 * Lets a user input a new value for a field
	 * @param e jQuery the edit button clicked. This element will have a .data object indicating whether
	 * 		the new edit field should be large (.large), its container (.cont), its previous value (.value),
	 * 		and the name of the field (.fieldName)
	 */
	this.allowInput = function(e) {
		var data = e.data(),
			large = data.large,
			cont = data.cont,
			value = data.value,
			smartBox = data.smartBox,
			fieldName = data.fieldName.replace(' ', '_'),
			trackId = data.trackId,
			div = $j('<div class="details_input_container"></div>'),
			i = null;

		if (fieldName == 'work_numbers') {
			sa.pages.details.showWorkNumberEditor(value, function (newValue) {
				ajax({ field : fieldName, value : newValue, secureToken : user.secureToken, trackId : trackId },
					function(response) { page.setField(response); }, 'POST', { p : 'import_tracks', action : 'setField' });
			});
			return;
		}
		if (fieldName == 'writers' || fieldName == 'publishers') {
			sa.pages.details.showInterestedPartyEditor(value, fieldName.substring(0, fieldName.length - 1), function(newValue) {
				ajax({ field : fieldName, value : newValue, secureToken : user.secureToken, trackId : trackId },
					function(response) { page.setField(response); }, 'POST', { p : 'import_tracks', action : 'setField' });
			}, currentTracks[trackId].publishers);
			return;
		}

		e.off('click').on('click', function (e) { page.disallowInput($j(this)); e.preventDefault(); return false; });
		cont.append(div);

		// create the input element. Different fieldNames are input with different types of elements
		if (fieldName == 'genre' || fieldName == 'tempo' || fieldName == 'cue_type') {
			// these fieldNames get a series of drop down boxes. values are loaded dynamically
			for (var j = 0, jLen = value.length; j < jLen; j++) {
				div.append('<select class="details_' + fieldName + '_select"><option value="' + value[j].id + '">' + value[j].name + '</option></select>');
			}
			this.loadSelect(fieldName, $j('.details_' + fieldName + '_select'));
			div.append('<a class="another faux_button">add another</a>');
			div.find('a.another').on('click', function(e) {
				$j(this).before('<select class="details_' + fieldName + '_select"></select>');
				page.loadSelect(fieldName, $j('.details_' + fieldName + '_select'));
				e.preventDefault();
				return false;
			});
		} else if (fieldName == 'key' || fieldName == 'catalog') {
			// these fieldNames get a drop down box. values are loaded dynamically
			value += '';
			div.append(i = $j('<select id="details_' + fieldName + '_select"><option>' + value + '</option></select>'));
			this.loadSelect(fieldName, [i]);
		} else if (fieldName == 'has_vocal' || fieldName == 'explicit') {
			// has vocal also has a drop down but it's not loaded from the server
			value += '';
			div.append(i = $j('<select id="details_' + fieldName + '_select"><option value="0">No</option><option value="1">Yes</option><option value="2">Unspecified</option></select>'));
			if (value !== '') {
				i.find('option[value=' + value + ']').prop('selected', true);
			}
		} else if (fieldName == 'sync_flags') {
			// sync flags also has a drop down but it's not loaded from the server
			value += '';
			div.append(i = $j('<select multiple="multiple" id="details_' + fieldName + '_select"><option>' + config.syncFlags.join('</option><option>') + '</option></select>'));
			if (value !== '') {
				i.find('option[value="' + value + '"]').prop('selected', true);
			}
			i.selectize({
				delimiter : '\n',
				placeholder : 'Click to add a value to this field',
				labelField : 'value',
				searchField : 'value',
				sortField : 'value',
				valueField : 'id',
				options : config.syncFlags.map(val => { return { id : val, value : val }; })
			});
		} else {
			value += '';
			if (fieldName == 'artist' || fieldName == 'album' || fieldName == 'publisher' || fieldName == 'label' || fieldName == 'composer' || smartBox) {
				// these fieldNames get a smart suggestion box, dynamically showing options as the user types
				div.append(i = $j(new SuggestionBox(fieldName)).attr('id', 'profile_field_' + fieldName).trigger('focus'));
			} else {
				if (!large) {
					// regular boring input text field
					div.append(
						i = $j('<input type="text" id="profile_field_' + fieldName + '"/>'));
					if (fieldName == 'release_date') {
						i.datepicker({ dateFormat: config.datePickerDateFormatString });
					}
				} else {
					// regular boring textarea
					div.append(
						i = $j('<textarea class="artist_profile_edit_text" id="profile_field_' + fieldName + '"></textarea>'));
				}
			}
			// check to see if we're editing an existing value or adding a new one
			if (!e.hasClass('artist_profile_editable')) {
				// need to unescape to make it look right in the text box
				i.val(value.replace(/<br\/?>/ig, '\n').entityDecode());
			}
		}
		div.find('input, textarea, select').trigger('focus');
		e.data('inputDiv', div);
		// save button
		div.append($j('<a class="save_button faux_button icon fa fa-save" title="Click to save your change to this track"></a>')
			.on('click', function (e) { page.saveChange($j(this)); e.preventDefault(); return false; })
			.data({
				fieldName : fieldName,
				input : i,
				all : false,
				trackId : trackId
			}));
		div.append('<div class="clr_left"></div>');
	};

	/**
	 * Hides the input elements when the user clicks on the edit button while the elements are already shown
	 * @param e jQuery the edit button clicked
	 */
	this.disallowInput = function(e) {
		e.off('click').on('click', function(e) { page.allowInput($j(this)); e.preventDefault(); return false; });
		(e.data('inputDiv')).remove();
	};


	/**
	 * Saves any edits made to a field
	 * @param {JQuery} e the save button that was clicked. Should have .data('fieldName'), .data('input'), .data('all')
	 */
	this.saveChange = function(e) {
		var data = e.data(),
			fieldName = data.fieldName,
			trackId = data.trackId,
			value,
			selects,
			people,
			container,
			ownershipShares,
			roleIds,
			i,
			len;
		if (fieldName == 'genre' || fieldName == 'tempo' || fieldName == 'cue_type') {
			var values = [];
			selects = $j('.details_' + fieldName + '_select');
			for (i = 0, len = selects.length; i < len; i++) {
				value = selects[i].value;
				if (value == 0 || value == -1) continue;
				values.push(value);
			}
			if (!values.length) {
				sa.notify({ text : 'You must choose at least one ' + fieldName.replace('_', ' ') });
				return;
			}
			ajax('field=' + fieldName + '&values[]=' + values.join('&values[]=') + '&secureToken=' + user.secureToken + '&trackId=' + trackId,
				function (response) {
					page.setField(response);
				}, 'POST', 'p=import_tracks&action=setField');
		} else if (fieldName == 'sync_flags') {
			let newValue = [];
			let value = $j('#details_' + fieldName + '_select').val();
			if (value && value.isArray) {
				value.each(function () {
					var singleVal = this;
					if (singleVal < 0) {
						newValue.push(newValues[singleVal]);
					} else {
						newValue.push(singleVal);
					}
				});
			}
			ajax({
					field : fieldName,
					value : newValue, 
					secureToken : user.secureToken,
					trackId : trackId
				},
				function (response) {
					page.setField(response);
				}, 'POST', 'p=import_tracks&action=setField');
		} else if (fieldName == 'work_numbers') {
			var workNumbers = [],
				workNumberValues,
				affiliationIds,
				registrationDates,
				usedAffiliationIds = {};
			container = e.data('input');
			workNumberValues = container.find('input[name=work_number]');
			affiliationIds = container.find('select[name=affiliation]');
			registrationDates = container.find('input[name=registration_date]');
			workNumberValues.removeClass('error');
			container.find('.error').remove();
			for (var wn = 0, wnLen = workNumberValues.length; wn < wnLen; wn++) {
				var workNumberValue = workNumberValues[wn].value,
					affiliationId = $j(affiliationIds[wn]).val(),
					registrationDate = $j(registrationDates[wn]).val();
				if (usedAffiliationIds[affiliationId]) {
					container.append('<div class="error">Please make sure you select each PRO only once</div>');
					return;
				}
				usedAffiliationIds[affiliationId] = 1;
				if (workNumberValue != '') {
					workNumbers.push({ value : workNumberValue, affiliationId : affiliationId, registrationDate : registrationDate });
				}
			}
			ajax({ field : fieldName, value : workNumbers, secureToken : user.secureToken, trackId : trackId },
				function(response) { page.setField(response); }, 'POST', { p : 'import_tracks', action : 'setField' });
		} else if (fieldName == 'writers') {
			people = [];
			container = e.data('input');
			ownershipShares = container.find('input.percentage');
			selects = container.find('select.person');
			roleIds = container.find('select[name=role]');
			var publisherIds = container.find('select[name=writerPublisherId]');
			ownershipShares.removeClass('error');
			container.find('.error').remove();
			for (var w = 0, wLen = selects.length; w < wLen; w++) {
				var personId = $j(selects[w]).val(),
					writerPercentage = ownershipShares[w].value,
					writerRoleId = $j(roleIds[w]).val(),
					publisherId = $j(publisherIds[w]).val();
				if (writerPercentage != '' && !writerPercentage.match(/^[0-9]+(\.[0-9]+)?%?$/)) {
					container.find('input.percentage:eq(' + w + ')').addClass('error');
					container.append('<div class="error">Please enter a number for all share percentages</div>');
					return;
				}
				if (personId != '') {
					people.push({ id : personId, ownershipShare : writerPercentage, publisherId : publisherId, roleId : writerRoleId });
				}
			}
			ajax({ field : fieldName, value : people, secureToken : user.secureToken, trackId : trackId },
				function(response) { page.setField(response); }, 'POST', { p : 'import_tracks', action : 'setField' });
		} else if (fieldName == 'publishers') {
			people = [];
			container = e.data('input');
			ownershipShares = container.find('input[name=ownershipShare]');
			selects = container.find('select.person');
			roleIds = container.find('select[name=role]');
			container.find('div.error').remove();
			container.find('.error').removeClass('error');
			for (var p = 0, pLen = selects.length; p < pLen; p++) {
				var person = $j(selects[p]).val(),
					publisherRoleId = $j(roleIds[p]).val(),
					ownershipShare = ownershipShares[p].value,
					personContainer = $j(selects[p]).parents('.publisher'),
					collectionShares = personContainer.find('input[name=collectionShare]'),
					collectionTerritories = personContainer.find('select[name=territory]'),
					organizedCollectionShares = [];
				if (ownershipShare != '' && !ownershipShare.match(/^[0-9]+(\.[0-9]+)?%?$/)) {
					container.find('input.percentage:eq(' + p + ')').addClass('error');
					container.append('<div class="error">Please enter a number for all share percentages</div>');
					return;
				}
				for (var c = 0, cLen = collectionShares.length; c < cLen; c++) {
					var share = $j(collectionShares[c]).val(),
						territory = $j(collectionTerritories[c]).val();
					if (share != '') {
						if (!share.match(/^[0-9]+(\.[0-9]+)?%?$/)) {
							$j(collectionShares[c]).addClass('error');
							$j(collectionShares[c]).parents('.sub_field').append('<div class="error">Please enter a number for all share percentages</div>');
							return;
						}
						organizedCollectionShares.push({ share : share, territory : territory });
					}

				}
				if (person != '') {
					people.push({ id : $j(selects[p]).val(), ownershipShare : ownershipShare, roleId : publisherRoleId, collectionShares : organizedCollectionShares });
				}
			}
			ajax({ field : fieldName, value : people, secureToken : user.secureToken, trackId : trackId },
				function(response) { page.setField(response); }, 'POST', { p : 'import_tracks', action : 'setField' });
		} else {
			ajax('field=' + fieldName + '&value=' + encodeURIComponent(data.input.val()) + '&secureToken=' + user.secureToken + '&trackId=' + trackId,
					function(response) { page.setField(response); }, 'POST', 'p=import_tracks&action=setField');
		}
	};

	/**
	 * Handles the response after trying to save changes to a field
	 * @param newData json the response from the server
	 */
	this.setField = function(newData) {
		if (newData[0].result == 'success') {
			var field = newData[0].field,
				value = newData[0].value,
				displayValue = value,
				trackContainer = $j('.upload #track_' + newData[0].trackId),
				e;
			sa.notify({ text : createText('Changes saved!') });
			switch (field) {
				case 'title':
					e = trackContainer.find('span#title');
					break;
				case 'artist':
				case 'label':
				case 'catalog':
				case 'album':
				case 'release_date':
				case 'style_of':
				case 'description':
				case 'keywords':
				case 'instruments':
				case 'version':
				case 'style':
				case 'mood':
				case 'tags':
				case 'isrc':
				case 'iswc':
					e = trackContainer.find('#details_subsection_' + field + ' span');
					break;
				case 'bpm':
					e = trackContainer.find('#details_subsection_' + field + ' span:first');
					if (value == '0') displayValue = '0 (not set)';
					break;
				case 'track_number':
					e = trackContainer.find('#details_subsection_' + field + ' span');
					if (!value || value == '0') displayValue = value = '';
					break;
				case 'filename':
					e = trackContainer.find('#details_subsection_' + field + ' span');
					displayValue = value = value.replace('.mp3', '');
					break;
				case 'key':
					value = displayValue = value.replace(/%u([0-9A-F]+)/, '&#X$1;');
					e = trackContainer.find('#details_subsection_' + field + ' span');
					break;
				case 'has_vocal':
				case 'explicit':
					e = trackContainer.find('#details_subsection_' + field + ' span');
					displayValue = (value == 1 ? 'Yes' : (value == 2 ? 'Unspecified' : 'No'));
					break;
				case 'sync_flags':
					e = trackContainer.find('#details_subsection_' + field + ' div');
					displayValue = value.join(', ');
					break;
				case 'lyrics':
					e = trackContainer.find('#details_subsection_' + field + ' div');
					break;
				case 'work_numbers':
					e = trackContainer.find('#details_subsection_' + field).html('<b>Work Numbers:</b>' + (value.length > 1 ? '<br/>' : ''));
					for (var w = 0, wLen = value.length; w < wLen; w++) {
						var workNumberTemplate = templates.get('details_work_number'),
							workNumber = value[w];
						workNumberTemplate.find('.affiliation').html(workNumber.affiliation.name);
						workNumberTemplate.find('.number').html(htmlEncode(workNumber.workNumber));
						e.append(workNumberTemplate);
					}
					e.find('br:last').remove();
					page.makeEditable(newData[0].trackId, trackContainer.find('#details_subsection_' + field + ':first span'), trackContainer.find('#details_subsection_' + field + ':first'), field, value);
					currentTracks[newData[0].trackId]['workNumbers'] = value;
					return;
				case 'writers':
				case 'publishers':
					e = trackContainer.find('#details_subsection_' + field);
					e.html('<b>' + gde(field, { c : 'upper', p : true }) + ':</b>');
					let baseUrl = siteBaseUrl();
					for (var p = 0, pLen = value.length; p < pLen; p++) {
						var person = value[p];
						e.append((p ? '<br/>' : '') + '<a class="person" href="'+baseUrl+'/' + field.substring(0, field.length - 1) + '?id=' + person.id + '">' + htmlEncode(person.name)
							+ (person.affiliation.id ? ' (' + person.affiliation.name + ')' : '')
							+ (parseFloat(person.ownershipShare) > 0 ? ' - ' + person.ownershipShare + '%' : '') + '</a>');
					}
					page.makeEditable(newData[0].trackId, trackContainer.find('#details_subsection_' + field + ':first span'), trackContainer.find('#details_subsection_' + field + ':first'), field, value);
					currentTracks[newData[0].trackId][field] = value;
					return;
				case 'tempo':
				case 'cue_type':
				case 'genre':
					trackContainer.find('#details_subsection_' + field + ' a:not(.edit_button)').hide();
					e = trackContainer.find('#details_subsection_' + field + ' span');
					displayValue = '';
					for (var i = 0, len = value.length; i < len; i++) {
						var v = value[i];
						displayValue += (i == 0 ? '' : ', ') + v.name;
					}
					break;
				default:
					e = trackContainer.find('.' + field + ' span');
					if (!e.length) return;
			}
			e.html(displayValue).removeClass('artist_profile_editable');
			if (value == '') {
				e.addClass('artist_profile_editable').html('click button to add');
				e.parent().find('.edit_button:first').addClass('fa-plus').removeClass('fa-edit');
			} else {
				e.parent().find('.edit_button:first').removeClass('fa-plus').addClass('fa-edit');
			}
			a = trackContainer.find('#details_edit_' + field);
			if (a.length) {
				this.disallowInput(a);
				a.data('value', value);
			}

			if ('title' === field) {
				$j("#lr_" + newData[0].trackId + " .list_title_contents").html(value);
			}

			if ('filename' === field) {
				$j("#lr_" + newData[0].trackId + " td.lc_filename").html(value);
			}
		} else {
			sa.notify({ text : createText(newData[0].result) });
		}
	};

	/**
	 * Starts the track deletion process, prompting the user to make sure they're sure
	 */
	this.deleteTrack = function(track) {
		sa.confirm({
			text: 'Are you sure you want to delete this track, "' + track.title + '"?<br/><br/>To restore the track, you\'ll have to reupload it.',
			yesFunction: function () {
				ajax('trackId=' + track.id + '&type=' + track.type + '&secureToken=' + user.secureToken,
					function (response) {
						if (response[0].result == 'success') {
							sa.notify({ text : 'Track deleted!' });
							page.show();
						} else {
							sa.notify({ text : response[0].result });
						}
					}, 'POST', 'p=import_tracks&action=delete');
			},
			yesText: 'Delete'
		});
	};

	/**
	 * Starts the publishing process, prompting the user to make sure they're sure
	 */
	this.publish = function() {
		sa.confirm({
			text: 'This will publish all uploaded tracks to the workspace. The process may take some time depending on how many tracks you have and the current load.<br/><br/>'
				+ 'Email address to receive notification when all tracks are up: <input type="text" value="' + user.userData.email + '" id="publish_email"/><br/>'
				+ '<small>Note that tracks will appear gradually as they are processed.</small><br/><br/><b>Are you sure all tracks are ready?</b>',
			yesFunction: function () {
				var publishEmail = $j('#publish_email').val();
				ajax('publish=1&publishEmail=' + encodeURIComponent(publishEmail) + '&secureToken=' + user.secureToken,
					function (response) {
						if (response[0].result == 'success') {
							sa.notify({ text : 'Tracks added to publish queue!' });
							sa.router.routeTo('/admin?p=upload&tab=status');
						} else {
							sa.notify({ text : response[0].result });
						}
					}, 'POST', 'p=import_tracks&action=publish');
			},
			yesText: 'Publish'
		});
	};

	function handleDeleteAll(e) {
		sa.confirm({
			text: "This will delete all tracks to be published, with all work lost!<br /><br />Are you sure?",
			yesFunction: function () {
				ajax({}, function (response) {
					if (response[0].result == 'success') {
						sa.notify({ text : "Tracks deleted." });
						sa.router.routeTo('/admin?p=upload');
					}
				}, 'POST', 'p=import_tracks&action=deleteAll');
			},
			yesText: 'Delete All'
		});
		e.preventDefault();
		return false;
	}

	function handleExportMetadata(e){
		window.location.href = "https://" + config.domain + "/export.php?type=import_job_metadata";
		e.preventDefault();
		return false;
	}

	function handleImportMetadata(uploader)
	{
		var f = uploader.getFiles();

		if (f && f.length && f.length == 1) {
			$j('#import_metadata_button').html('Uploading...');
			uploader.upload({
				p: "import_tracks",
				params: 'action=uploadMetadata',
				complete: function (e, response) {
					$j('#import_metadata_button').html('Import Metadata');
					renderMetadataMapUI(response[0].fields, response[0].validFields, response[0].filename);
				},
				error: function() {
					$j('#import_metadata_button').html('Import Metadata');
				},
				parseComplete: true
			});
		}
	}

	function renderMetadataMapUI(fields, validFields, filename) {
		container.html(templates.get("map_ui"));

		var list = container.find('.column_list');
		var fieldList = '';

		for (var v = 0, vLen = validFields.length; v < vLen; v++) {
			let displayValue = validFields[v];
			let realValue = displayValue;
			if (displayValue.indexOf('Writer ') === 0) {
				displayValue = displayValue.replace('Writer', gde('writer', { c : 'upper', p : false }));
			} else if (displayValue.indexOf('Publisher ') === 0) {
				displayValue = displayValue.replace('Publisher', gde('publisher', {c: 'upper', p: false}));
			} else if (displayValue != 'SourceAudio ID' && displayValue != 'PRO Work Number' && displayValue != 'PRO Work Registration Date' && displayValue != 'ISRC' && displayValue != 'ISWC') {
				displayValue = config.getDictionaryEntry(displayValue.toLowerCase());
			}
			let disabled = realValue.indexOf('field is deprecated') !== -1 ? 'disabled' : ''
			fieldList += `<option value="${realValue.replace(/"/g, "&quot;")}" ${disabled}>${displayValue}</option>`;
		}
		fieldList += '<option value="new_custom">New Custom Field</option>';
		for (var f = 0, fLen = fields.length; f < fLen; f++) {
			var field = fields[f],
				column = field.column,
				enabled = field.type != 'unknown',
				columnTemplate = templates.get('map_ui_column');
			if (f % 2 == 1) {
				columnTemplate.addClass('stripe');
			}
			columnTemplate.find('.code').html((column > 25 ? String.fromCharCode(Math.floor(column / 26) + 64) : '') + String.fromCharCode(column % 26 + 65));
			columnTemplate.find('.original').html(field.originalName.replace('<', '&lt;').replace('>', '&gt;'));
			columnTemplate.find('.example').html(field.example.replace('<', '&lt;').replace('>', '&gt;'));
			if (!enabled) {
				columnTemplate.find('.enabled input').prop('checked', false);
				columnTemplate.find('.mapping select').prop('disabled', true);
			}
			if (field.type == 'custom') field.name = 'Custom: ' + field.name.toLowerCase().ucfirst();
			columnTemplate.find('.mapping select').attr('name', column).html(fieldList.replace('"' + field.name + '"', '"' + field.name + '" selected="selected"'));
			if (field.writer) {
				columnTemplate.find('.writer_selection').show();
				columnTemplate.find('.writer_selection input').val(field.writer);
			} else if (field.publisher) {
				columnTemplate.find('.publisher_selection').show();
				columnTemplate.find('.publisher_selection input').val(field.publisher);
				if (field.collectionShare) {
					columnTemplate.find('.collection_share_selection').show();
					columnTemplate.find('.collection_share_selection input').val(field.collectionShare);
				}
			} else if (field.workNumberAffiliation) {
				columnTemplate.find('.work_number_affiliation_selection').show();
				columnTemplate.find('.work_number_affiliation_selection select').html('<option selected="selected" value="' + field.workNumberAffiliation + '"></option>');
			}
			list.append(columnTemplate);
		}
		list.append('<span class="clr"></span>');
		list.find('input[type=checkbox]').on('change', function() {
			if (this.checked) {
				$j(this).parent().parent().find('select').prop('disabled', false);
			} else {
				$j(this).parent().parent().find('select').prop('disabled', true);
			}
		});
		ajax({ p : 'people', action : 'loadListFieldValues' }, function(listFields) {
			var affiliationSelects = list.find('.work_number_affiliation_selection select'),
				optionString = '';
			for (var r = 0, rLen = listFields.affiliations.length; r < rLen; r++) {
				var affiliation = listFields.affiliations[r];
				optionString += '<option value="' + affiliation.name.toLowerCase() + '">' + affiliation.name + '</option>';
			}
			for (var s = 0, sLen = affiliationSelects.length; s < sLen; s++) {
				var affiliationSelect = $j(affiliationSelects[s]),
					currentValue = affiliationSelect.val();
				affiliationSelect.html(optionString);
				if (currentValue) {
					affiliationSelect.val(currentValue);
				}
			}
		});
		list.find('select').on('change', function() {
			var t = $j(this),
				currentValue = t.val();
			t.parents('.column').find('.writer_selection, .publisher_selection, .collection_share_selection, .work_number_affiliation_selection').hide();
			if (currentValue == 'new_custom') {
				sa.prompt({
					placeholder : 'Custom field name',
					yesFunction : function(value) {
						ajax('name=' + encodeURIComponent(value),
							function(response) {
								if (response[0].result == 'success') {
									list.find('option[value=new_custom]').before('<option>Custom: ' + value + '</option>');
									t.val('Custom: ' + value);
								} else {
									t.val('Album');
									sa.notify({ text : response[0].result });
								}
							}, 'POST', 'p=custom_fields&action=new');
					},
					yesText : 'Create',
					noFunction : function() { t.val('Album'); },
					closeFunction : function() { t.val('Album'); }
				});
			} else if (currentValue.indexOf('Writer ') === 0) {
				t.parents('.column').find('.writer_selection').show();
			} else if (currentValue.indexOf('Publisher ') === 0) {
				t.parents('.column').find('.publisher_selection').show();
				if (currentValue.indexOf('Collection Share') != -1) {
					t.parents('.column').find('.collection_share_selection').show();
				}
			} else if (currentValue == 'PRO Work Number' || currentValue == 'PRO Work Registration Date') {
				t.parents('.column').find('.work_number_affiliation_selection').show();
			}
		});
		container.find('#save_button').on('click', function(e) {
			// validate the info before we save
			var fieldVals = container.find('select[name!=pro_select]:enabled'),
				error = container.find('.error'),
				hasFilename = false,
				hasTitle = false,
				hasId = false,
				usedFields = [],
				fieldString = 'filename=' + encodeURIComponent(filename);
			for (var i = 0, len = fieldVals.length; i < len; i++) {
				var fieldVal = fieldVals[i],
					value = $j(fieldVal).val(),
					column = fieldVal.name;
				if (value == 'Filename') hasFilename = true;
				else if (value == 'Title') hasTitle = true;
				else if (value == 'SourceAudio ID') hasId = true;
				if (usedFields.indexOf(value) != -1) {
					error.html('You may only select each field once and you have two of "' + value + '"');
					return;
				}
				if (value.indexOf('Writer ') === 0) {
					var writerNumber = $j(fieldVal).parents('.column').find('.writer_selection input').val();
					fieldString += '&fields[' + column + '][writer]=' + encodeURIComponent(writerNumber);
				} else if (value.indexOf('Publisher ') === 0) {
					var publisherNumber = $j(fieldVal).parents('.column').find('.publisher_selection input').val();
					fieldString += '&fields[' + column + '][publisher]=' + encodeURIComponent(publisherNumber);
					if (value.indexOf('Collection Share') != -1) {
						var collectionShare = $j(fieldVal).parents('.column').find('.collection_share_selection input').val();
						fieldString += '&fields[' + column + '][collectionShare]=' + encodeURIComponent(collectionShare);
					}
				} else if (value == 'PRO Work Number' || value == 'PRO Work Registration Date') {
					var proName = $j(fieldVal).parents('.column').find('select[name=pro_select]').val();
					fieldString += '&fields[' + column + '][workNumberAffiliation]=' + encodeURIComponent(proName);
				} else {
					usedFields.push(value);
				}
				fieldString += '&fields[' + column + '][name]=' + encodeURIComponent(value);
			}
			if (!hasFilename && !hasTitle && !hasId) {
				error.html('You must have at least a Filename or SourceAudio ID column so we can match rows to tracks');
				return;
			}
			error.html('');
			let loader = showLoader(container.find('.data_importing'), 'Processing your data. This may take a little while.');
			sa.scrollToElement(loader);
			ajax(fieldString, function(response) {
				loader.remove();
				if (response[0].result != 'success') {
					error.html(response[0].result);
				} else {
					showImportResults(response[0]);
				}
			}, 'POST', 'p=import_tracks&action=bulkMetadataUpdate');
			e.preventDefault();
			return false;
		});

		container.find("#map_ui_abort").on('click', function (e) {
			page.show();
			e.preventDefault();
			return false;
		});
	}

	/**
	 * Shows the results of a run, be a test or the real deal
	 * @param {json} results the results from the run
	 */
	function showImportResults(results) {
		var container = $j('.data_importing');
		container.empty().append(templates.get('map_ui_results'));

		['matched', 'unmatched', 'doubled'].map(function(type) {
			if (results[type]) {
				container.find('.' + type + '_track_count').html(results[type].numberFormat());
				container.find('.' + type + '_export_link').attr('href', 'export.php?&type=import&filename=' + results.filename + '&results=' + type);
			} else {
				container.find('#' + type + '_rows').remove();
			}
		});

		if (results.matched) {
			container.find('.no_matched_notice').remove();
		} else {
			container.find('.matched_notice').remove();
		}

		container.find('#back_button').on('click', function(e) {
			page.show();
			e.preventDefault();
			return false;
		});
	}
}
